package com.arena_web.generated

import com.arena_web.data.dto.ClubDto
import com.arena_web.ui.sections.cities.CitySeo

val GENERATED_CITIES: List<CitySeo> = listOf(
  CitySeo(slug="barcelona", name="Barcelona", country="ES", clubCount=48, sports=listOf(Pair("Padel", 6), Pair("Football", 6), Pair("Volleyball", 5), Pair("Tennis", 5), Pair("Karting", 5), Pair("Basketball", 3), Pair("Paintball", 3), Pair("Climbing", 3), Pair("Golf", 3), Pair("Billiards", 3), Pair("Laser Tag", 3), Pair("Bowling", 2), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="d1822a55-bad1-4518-8c12-d738e5d2848a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Virtua", address="Carrer de Viladomat, 95, Eixample, 08015 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3790003, longitude=2.1580461,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bf1d02e5-52c4-43d2-8d2d-a160a43c3947_ChIJGay6pFqj_0.jpg",
      averageRating=4.9, totalRatingsCount=2213,
      createdAt="2026-08-30T15:56:29.162355Z", updatedAt="2026-08-30T20:52:25.050962Z",
    ),
    ClubDto(
      id="1f0e9585-4cda-4c64-8524-09a7a6776fcb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MONKEY PAINTBALL", address="Carrer de Granollers, 1, 08319 Dosrius, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.6213818, longitude=2.4212899,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/af8813a7-5f10-4811-b6ae-ee25f7e8ccea_ChIJeVJLlQbL_0.jpg",
      averageRating=4.8, totalRatingsCount=722,
      createdAt="2026-08-30T15:56:58.600356Z", updatedAt="2026-08-30T20:52:18.052807Z",
    ),
    ClubDto(
      id="c4b3ad23-abc2-4ff1-9b6f-3d8bea0a97a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bloc District Barcelona Marina", address="Carrer de Zamora, 96-106, Sant Martí, 08018 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3969576, longitude=2.1887115,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77351cf9-ec90-4348-bab2-f34447394244_ChIJT4QPeVyj_0.jpg",
      averageRating=4.6, totalRatingsCount=885,
      createdAt="2026-08-30T15:55:55.558639Z", updatedAt="2026-08-30T20:52:08.786753Z",
    ),
    ClubDto(
      id="88f7c2ec-1232-471a-9318-cf6d028cab60", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ilusiona", address="Centro Comercial, Gran Via, 2, 08908 L'Hospitalet de Llobregat, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3583, longitude=2.129066,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5c6970ba-acb9-4ac4-b36b-9316f42484a8_photo.jpg",
      averageRating=4.6, totalRatingsCount=6123,
      createdAt="2026-08-31T14:52:35.114824Z", updatedAt="2026-08-31T14:52:35.114824Z",
    ),
    ClubDto(
      id="274f5317-fc22-4c50-a285-bcc01c13774e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nick Club Padel Barcelona", address="Carrer de Campoamor, 66, Horta-Guinardó, 08031 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4355528, longitude=2.1543931,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fa2921af-a716-411e-826a-2f4b26679d6b_ChIJo3MYQ1u9_0.jpg",
      averageRating=4.6, totalRatingsCount=1237,
      createdAt="2026-08-30T11:46:33.960661Z", updatedAt="2026-09-01T14:31:45.005154Z",
    ),
    ClubDto(
      id="77e9250d-2a0a-46b4-b129-1c802f10d64d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CSS.CAT - Sarrià", address="Carrer de Ràfols, 17, Sarrià-Sant Gervasi, 08034 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4015648, longitude=2.1161742,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fe70fdfd-4dbe-458e-8eb0-987d0294c83b_photo.jpg",
      averageRating=4.5, totalRatingsCount=75,
      createdAt="2026-08-31T14:52:03.422362Z", updatedAt="2026-08-31T14:52:03.422362Z",
    ),
    ClubDto(
      id="909d634d-f831-45fb-8f7c-c2b9e5569d07", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Parcmotor Castellolí", address="Carretera Nacional IIa, Km 560, 08719 Castellolí, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.5881569, longitude=1.6910604,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4c241df-46c4-4161-a4b2-b09519e96c77_ChIJXaGi_PVn_0.jpg",
      averageRating=4.5, totalRatingsCount=2467,
      createdAt="2026-08-30T11:45:10.089684Z", updatedAt="2026-08-30T20:52:15.943436Z",
    ),
    ClubDto(
      id="e928a592-ce13-4bb7-a520-c1bc1c1ed5e5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aurial Padel Cornellà", address="Passatge dels Alps, S-N, 08940 Cornellà de Llobregat, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3559006, longitude=2.0812236,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/58549027-e8aa-4f1b-a5fb-35b714f5ab48_ChIJe5Ma1ESZ_0.jpg",
      averageRating=4.4, totalRatingsCount=660,
      createdAt="2026-08-30T11:45:57.626566Z", updatedAt="2026-08-30T20:52:08.313942Z",
    ),
    ClubDto(
      id="12e114a4-8e9e-4a24-80d8-8a793cf4a492", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climbat La Foixarda (Barcelona)", address="Carrer de la Foixarda, 14, 18, Sants-Montjuïc, 08038 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3665636, longitude=2.1481214,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0cf63237-d265-43c9-ac5f-b84e34d73f41_ChIJ4Wl02XWi_0.jpg",
      averageRating=4.4, totalRatingsCount=1733,
      createdAt="2026-08-30T15:55:41.425280Z", updatedAt="2026-08-30T20:52:10.811809Z",
    ),
    ClubDto(
      id="b9b93180-41e7-4f74-b170-2c6b96415a9e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Tennis de La Salut - 1902", address="Carrer de la Mare de Déu de la Salut, 75, Gràcia, 08024 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4130073, longitude=2.1576369,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/665437f2-0efe-4ace-8ecd-438de1ee2ae8_ChIJ7URnk7Ci_0.jpg",
      averageRating=4.4, totalRatingsCount=705,
      createdAt="2026-08-30T11:46:47.693923Z", updatedAt="2026-08-30T20:52:11.397872Z",
    ),
    ClubDto(
      id="b2d40646-e989-46a4-98f7-98a7c815392f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="David Lloyd Barcelona", address="Av. Diagonal, 673-685, Les Corts, 08028 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3829056, longitude=2.1078451,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84458e3a-9d1e-4ad3-ac64-400878b9d0ce_ChIJ4-BrdVWY_0.jpg",
      averageRating=4.4, totalRatingsCount=1373,
      createdAt="2026-08-30T11:46:26.168171Z", updatedAt="2026-08-30T20:52:12.250276Z",
    ),
    ClubDto(
      id="96dd4946-61c5-48ca-9f58-e8c8bbeb7e02", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fairplay Padel Club", address="Carrer del Foc, 2, Sants-Montjuïc, 08038 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3532258, longitude=2.1348395,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2638e428-157d-4922-bc54-8340e7a74a34_ChIJrb_BxLqY_0.jpg",
      averageRating=4.4, totalRatingsCount=1143,
      createdAt="2026-08-30T11:45:44.442479Z", updatedAt="2026-08-30T20:52:13.005103Z",
    ),
    ClubDto(
      id="d9d2087f-7d5b-48a3-87c5-b9565fe86da9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Sallent", address="C-16, km 58,5, 08650 Sallent, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.784832, longitude=1.8884792,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ce8974c-43b3-408e-91a5-3b844b4bfd8e_ChIJd1J5ajb-_0.jpg",
      averageRating=4.4, totalRatingsCount=1007,
      createdAt="2026-08-30T11:45:30.551188Z", updatedAt="2026-08-30T20:52:16.179295Z",
    ),
    ClubDto(
      id="ead01160-f05f-468e-93e1-679a97b2d772", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MEGA GAME CORNELLÀ", address="Pg. dels Ferrocarrils Catalans, 138, 08940 Cornellà de Llobregat, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3521885, longitude=2.0805835,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b35983b5-894f-468c-9281-eca2fac661f5_ChIJwfQvR7KZ_0.jpg",
      averageRating=4.4, totalRatingsCount=1922,
      createdAt="2026-08-30T15:56:37.669709Z", updatedAt="2026-08-30T20:52:17.555819Z",
    ),
    ClubDto(
      id="091fa85d-cbc6-4ef4-886a-bdd17053998e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball en Barcelona", address="Calle de Cartagena, 329, 331, Horta-Guinardó, 08025 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4117639, longitude=2.1733583,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11a93c87-0aa6-4fde-8b2a-148fb3d62269_ChIJbf3_TFCj_0.jpg",
      averageRating=4.4, totalRatingsCount=1060,
      createdAt="2026-08-30T15:56:44.404941Z", updatedAt="2026-08-30T20:52:20.032993Z",
    ),
    ClubDto(
      id="af7da05c-d715-4cdf-b2d0-168fd268f88f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poliesportiu Carrer Tenerife", address="C. de Tenerife, Horta-Guinardó, 08024 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4167065, longitude=2.164701,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1bfa986a-0fcf-4ce6-87ab-437d87fd1fcb_photo.jpg",
      averageRating=4.4, totalRatingsCount=90,
      createdAt="2026-08-31T14:51:34.178600Z", updatedAt="2026-08-31T14:51:34.178600Z",
    ),
    ClubDto(
      id="85233ca8-b0a7-4cfd-b3ea-e2bb32739a9a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Real Club de Golf El Prat", address="Plans de Bonvilar, 17, 08227 Terrassa, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.5721266, longitude=2.0558428,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/44212325-bcc9-4e20-8842-b7bdb2cd37c4_ChIJ_-IbJkWT_0.jpg",
      averageRating=4.4, totalRatingsCount=1355,
      createdAt="2026-08-30T15:56:02.112524Z", updatedAt="2026-08-30T20:52:21.632704Z",
    ),
    ClubDto(
      id="03861231-fb28-4969-b9ed-e63a7d86f52a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SINGULAR Copas y Billares", address="Carrer de Sant Antoni Maria Claret, 514, Sant Andreu, 08027 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4216566, longitude=2.1888406,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d6bc08b-8f02-458d-a659-cb3f637fc774_ChIJBWWaXKy9_0.jpg",
      averageRating=4.4, totalRatingsCount=747,
      createdAt="2026-08-30T15:55:13.794063Z", updatedAt="2026-08-30T20:52:22.574800Z",
    ),
    ClubDto(
      id="31fbe1f9-cedf-4325-8f02-11f394f406e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sapakara Fun Parcs", address="Carrer del Silici, 9, 08940 Cornellà de Llobregat, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3563551, longitude=2.0915598,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/678353d3-abb3-4342-ba6e-578fb5f861ad_ChIJdbvJStqZ_0.jpg",
      averageRating=4.4, totalRatingsCount=2609,
      createdAt="2026-08-30T15:56:22.736866Z", updatedAt="2026-08-30T20:52:22.962038Z",
    ),
    ClubDto(
      id="f888c891-894c-430b-8ca1-eea92ac8e3b8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vall Parc: Club de tenis y de pádel en Barcelona", address="Carretera de l' Arrabassada, 107, 127, Horta-Guinardó, 08035 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4241138, longitude=2.1348779,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6fa077bd-453e-4869-a9a1-b46a4f327cae_ChIJnYOHvQOY_0.jpg",
      averageRating=4.4, totalRatingsCount=1453,
      createdAt="2026-08-30T11:46:19.412953Z", updatedAt="2026-09-01T14:31:57.429278Z",
    ),
    ClubDto(
      id="001b8acc-11a9-45f6-91e4-731d5e896135", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CEM Bogatell", address="Carrer de Carmen Amaya, 4, 6, Sant Martí, 08005 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3943248, longitude=2.2035623,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/60f09cb0-cb18-4385-b604-f44566a54293_ChIJ7zBVWhOj_0.jpg",
      averageRating=4.3, totalRatingsCount=688,
      createdAt="2026-08-30T11:44:50.676346Z", updatedAt="2026-08-30T20:52:09.036297Z",
    ),
    ClubDto(
      id="193d89b3-9f32-4686-b964-116f94136da3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Claror Can Caralleu - Centro Deportivo", address="Carrer dels Esports, 2, 8, Sarrià-Sant Gervasi, 08017 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4016081, longitude=2.1109972,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3700ae54-f44c-4f14-962d-f4b22edf4bb5_ChIJxRNx_EmY_0.jpg",
      averageRating=4.3, totalRatingsCount=1413,
      createdAt="2026-08-30T11:44:28.783290Z", updatedAt="2026-08-30T20:52:10.561367Z",
    ),
    ClubDto(
      id="3caf8acc-6eb9-45d0-8ee5-888a0561f186", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Pecera del Pool", address="Carrer de Calàbria, 171, Eixample, 08015 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3826167, longitude=2.1508634,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bf96e288-028b-4eb9-adf7-ae01449f42cf_ChIJE-DVsemj_0.jpg",
      averageRating=4.3, totalRatingsCount=1844,
      createdAt="2026-08-30T15:54:58.951460Z", updatedAt="2026-08-30T20:52:16.690988Z",
    ),
    ClubDto(
      id="7a09df9b-52c5-494d-90e3-c7084dc14fc7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pàdel Barcelona - El Prat", address="B-250 , Parc del Riu 3-4, Ronda de Llevant, s / n, 08820 El Prat de Llobregat, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.328261, longitude=2.1087664,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ae9b06f0-1928-4ceb-a10b-58782b4fc0f2_ChIJIYEXk9ee_0.jpg",
      averageRating=4.3, totalRatingsCount=1371,
      createdAt="2026-08-30T11:45:37.460165Z", updatedAt="2026-08-30T20:52:20.810137Z",
    ),
    ClubDto(
      id="9dccd07d-cd1a-4088-b3b2-3f3a4b11d0f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pádel Indoor Hospitalet", address="Carrer del Cobalt, 85, 08907 L'Hospitalet de Llobregat, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3582366, longitude=2.1087557,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/076d856a-6d32-4836-8d9c-de81eaaf5350_ChIJOxKW596Y_0.jpg",
      averageRating=4.3, totalRatingsCount=1104,
      createdAt="2026-08-30T11:45:50.970435Z", updatedAt="2026-08-30T20:52:20.936148Z",
    ),
    ClubDto(
      id="574b6ab5-3dff-4b3f-b562-f52f5da6b740", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sharma BCN", address="Carrer del Marroc, 204, Sant Martí, 08019 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4156562, longitude=2.2104632,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b08dee21-05a3-43e0-98d1-1494fe3bd0e9_ChIJq6QzO0yj_0.jpg",
      averageRating=4.3, totalRatingsCount=1518,
      createdAt="2026-08-30T15:55:48.949937Z", updatedAt="2026-08-30T20:52:23.085032Z",
    ),
    ClubDto(
      id="806150eb-d655-46c8-9ab6-bb17286ab753", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Pedralbes", address="Av. Dr. Marañón, 11, bajos, Les Corts, 08028 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.380753, longitude=2.116595,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0601cd3a-d405-4e5a-93fc-f5b58728e875_photo.jpg",
      averageRating=4.2, totalRatingsCount=4992,
      createdAt="2026-08-31T14:52:26.968124Z", updatedAt="2026-08-31T14:52:26.968124Z",
    ),
    ClubDto(
      id="b84d90fc-3dfb-4f0a-8ad1-22c87bf339c4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Can Cuyas Golf P&P i Padel", address="Carrer Granollers, 55, 08980 Sant Feliu de Llobregat, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3950413, longitude=2.0435415,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ee7d842a-12d6-45fa-85d1-f0c8570e9063_ChIJE0a4XEea_0.jpg",
      averageRating=4.2, totalRatingsCount=773,
      createdAt="2026-08-30T15:56:15.942406Z", updatedAt="2026-08-30T20:52:09.299851Z",
    ),
    ClubDto(
      id="f84a0fe3-fd7a-4a4b-b21d-5da26c29f2ef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Esportiu Hispano Francès", address="Carrer de Jorge Manrique, 15-19, Horta-Guinardó, 08035 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.430666, longitude=2.149743,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/90c0f825-8966-4d91-96a2-829ee82aab8a_photo.jpg",
      averageRating=4.2, totalRatingsCount=754,
      createdAt="2026-08-31T14:52:09.984952Z", updatedAt="2026-08-31T14:52:09.984952Z",
    ),
    ClubDto(
      id="09f225a6-1b4d-4712-9cdc-9baf6ee245ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club de Golf Barcelona", address="Av. Golf Masia Bach, 1, 08635 Sant Esteve Sesrovires, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4935224, longitude=1.8484145,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e168ab94-7573-46b8-83be-535b886f0225_ChIJlX2r7vKJ_0.jpg",
      averageRating=4.2, totalRatingsCount=805,
      createdAt="2026-08-30T15:56:08.790287Z", updatedAt="2026-08-30T20:52:11.512472Z",
    ),
    ClubDto(
      id="61be88ca-8943-487a-9df8-659a4eb5b655", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Complejo Deportivo Municipal La Mar Bella", address="Av. del Litoral, 86-96, Sant Martí, 08005 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4000329, longitude=2.2119394,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/af4bdffe-4bdd-404a-8662-da52e487d9c2_ChIJHUSEeEKj_0.jpg",
      averageRating=4.2, totalRatingsCount=2525,
      createdAt="2026-08-30T11:44:21.366310Z", updatedAt="2026-08-30T20:52:11.880289Z",
    ),
    ClubDto(
      id="f64d137f-18e3-4da9-a056-15cb435bb91c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fútbol Sala Promosportive", address="Camí Pau Redó, s/n, 08908 L'Hospitalet de Llobregat, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.344949, longitude=2.1129891,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cfe15389-bedf-4359-a565-1f6e0fc23c75_ChIJ21JZsNOY_0.jpg",
      averageRating=4.2, totalRatingsCount=726,
      createdAt="2026-08-30T11:44:43.669979Z", updatedAt="2026-08-30T20:52:13.890061Z",
    ),
    ClubDto(
      id="d0316a1a-b79b-4237-a310-238606aa336d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoor Karting Barcelona", address="Pol. Ind. El Pla, Carrer de Laureà Miró, 434, 08980 Sant Feliu de Llobregat, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3948646, longitude=2.0342269,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/acac6b28-7a4e-4656-9b4f-afd5c52a09e0_ChIJFUzyWVqa_0.jpg",
      averageRating=4.2, totalRatingsCount=7192,
      createdAt="2026-08-30T11:45:03.317075Z", updatedAt="2026-08-30T20:52:15.058824Z",
    ),
    ClubDto(
      id="5e39176f-6248-4f0c-a528-57638f466074", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Cardedeu", address="Carretera Granollers a Sant Celoni (C-251, Km 5.300, 08440 Cardedeu, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.6340172, longitude=2.3368237,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/82f207a4-bac7-4267-b55e-831bacba907e_ChIJN12G0ubI_0.jpg",
      averageRating=4.2, totalRatingsCount=2334,
      createdAt="2026-08-30T11:45:17.236499Z", updatedAt="2026-08-30T20:52:15.565467Z",
    ),
    ClubDto(
      id="eb4190ed-5ab8-4628-bbd9-9f526fe5580f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo Municipal de Fútbol de la Satalia", address="Carrer de Margarit, 23, Sants-Montjuïc, 08004 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3703383, longitude=2.1625445,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1921aba-9236-4e7c-8eaa-4f0eb8b9a140_ChIJ0wZHj2ii_0.jpg",
      averageRating=4.1, totalRatingsCount=757,
      createdAt="2026-08-30T11:44:36.134388Z", updatedAt="2026-08-30T20:52:09.171940Z",
    ),
    ClubDto(
      id="50ffcb58-a099-402d-ad2a-03600235933a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club de Tenis y Pádel Olímpia | CEM Olímpia", address="Carrer del Perú, 215, Sant Martí, 08020 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4135845, longitude=2.2024563,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7df9fc9a-d0f6-409f-be25-1e63f849657b_ChIJ5Zzjqjej_0.jpg",
      averageRating=4.1, totalRatingsCount=836,
      createdAt="2026-08-30T11:46:40.753762Z", updatedAt="2026-09-01T14:31:54.438631Z",
    ),
    ClubDto(
      id="aa6270c0-960a-4c46-93d7-0d68372efa4b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Futbol Club Martinenc", address="Carrer del Telègraf, 31, Horta-Guinardó, 08041 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4167819, longitude=2.1731872,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4d4c40cb-eb44-4ea3-bde3-2e023d1b1de3_ChIJyeG0IoKj_0.jpg",
      averageRating=4.1, totalRatingsCount=450,
      createdAt="2026-08-30T11:44:57.002778Z", updatedAt="2026-08-30T20:52:13.649420Z",
    ),
    ClubDto(
      id="a8a68495-75db-44ed-8f95-1a19a7a554db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoor Pádel Barcelona", address="Carrer de Veneçuela, 78, Sant Martí, 08019 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.411283, longitude=2.2091456,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0044c0c5-6ee3-4b70-accf-4f98502977bc_ChIJwe6ItEij_0.jpg",
      averageRating=4.1, totalRatingsCount=659,
      createdAt="2026-08-30T11:46:05.493748Z", updatedAt="2026-08-30T20:52:15.184769Z",
    ),
    ClubDto(
      id="bd15712b-fb5f-40c1-9c40-e115937b69ad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Minilandia, Parc Recreatiu.", address="Autovia de Castelldefels, km 12, 600, 08840 Viladecans, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.2756564, longitude=2.0476574,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b9176b7c-73a6-457e-9b28-b5dd6775813d_ChIJXbkv3Oyd_0.jpg",
      averageRating=4.1, totalRatingsCount=1948,
      createdAt="2026-08-30T11:45:23.691276Z", updatedAt="2026-08-30T20:52:15.811310Z",
    ),
    ClubDto(
      id="169c3d07-df38-4de3-ab72-9615efc52fdc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pàdel 7 Sant Martí (Indoor)", address="C de Puigcerdà, 113, Sant Martí, 08019 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.4139199, longitude=2.2111519,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96937e56-c35d-4ad5-89e3-8778565eb9ee_ChIJ4b4Ti06j_0.jpg",
      averageRating=4.1, totalRatingsCount=635,
      createdAt="2026-08-30T11:46:11.971568Z", updatedAt="2026-08-30T20:52:20.682296Z",
    ),
    ClubDto(
      id="65e357dd-83c1-421c-8224-a8aa79a4cdf7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Retruc", address="Gran Via de les Corts Catalanes, 399, Eixample, 08015 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.376934, longitude=2.151079,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/265e5c01-7be7-44fa-a7e5-e6d0f63e2cec_ChIJQaOzEnyi_0.jpg",
      averageRating=4.1, totalRatingsCount=1737,
      createdAt="2026-08-30T15:55:06.801326Z", updatedAt="2026-08-30T20:52:22.017851Z",
    ),
    ClubDto(
      id="ffb8e0ce-59c4-40ff-ae5b-27fa76487e16", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aiguajoc", address="Carrer del Comte Borrell, 21, 33, Eixample, 08015 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3764248, longitude=2.1637278,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2ad87276-92e7-4e15-bf49-b1d586da3aa3_photo.jpg",
      averageRating=4.0, totalRatingsCount=865,
      createdAt="2026-08-31T14:51:27.935362Z", updatedAt="2026-08-31T22:11:13.081954Z",
    ),
    ClubDto(
      id="ec5a1190-cad8-4994-9890-acf6fc2bbb43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Barcelona Radical", address="C-1415a, Km 10, 08211 Castellar del Vallès, Barcelona",
      city="Barcelona", country="ES",
      latitude=41.6147537, longitude=2.0762912,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49d2aa48-736b-4f11-9fe5-2accb005dcfd_ChIJdyAxi3rr_1.jpg",
      averageRating=4.0, totalRatingsCount=746,
      createdAt="2026-08-30T15:56:51.305981Z", updatedAt="2026-08-31T22:11:14.236868Z",
    ),
    ClubDto(
      id="44fe1f24-890e-44ae-979d-6d9775d4fcd1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="OKEYMAS CEM Parc de la Ciutadella", address="Passeig Circumval lacio, 1, Ciutat Vella, 08003 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3856, longitude=2.1866,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e1d8afb7-ab57-4b2a-93ad-143e03a7aa46_photo.jpg",
      averageRating=4.0, totalRatingsCount=1301,
      createdAt="2026-08-31T14:51:46.369469Z", updatedAt="2026-08-31T14:51:46.369469Z",
    ),
    ClubDto(
      id="56bf9137-a03a-48c7-a492-87d0fac3d986", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Phoenix Beach Volleyball Club - Bogatell", address="Platja del Bogatell, S/N, Sant Martí, 08038 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.395852, longitude=2.2086618,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/93749a61-d091-4f3e-99e2-0868b71e40e1_ChIJ4dS02tuj_0.jpg",
      averageRating=5.0, totalRatingsCount=39,
      createdAt="2026-08-30T15:57:13.122456Z", updatedAt="2026-08-30T20:52:20.293965Z",
    ),
    ClubDto(
      id="4c4c33d9-8a85-48a6-9312-af01bc89c67e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Volley Addicts Barcelona", address="Carrer Sant Miquel Platja, 10, Ciutat Vella, 08003 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3770499, longitude=2.19132,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/362bc107-43dd-46fd-aee8-d72444d8c4db_photo.jpg",
      averageRating=4.7, totalRatingsCount=32,
      createdAt="2026-08-31T14:51:54.769121Z", updatedAt="2026-08-31T14:51:54.769121Z",
    ),
    ClubDto(
      id="927aafb8-b24e-4790-ba12-bc77aba9a9d4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Taules de Ping Pong", address="Parc de la Ciutadella, Ciutat Vella, 08003 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3906076, longitude=2.1865142,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d8485706-47f4-47cd-982e-f971cfa8e722_ChIJ33JB_m6j_0.jpg",
      averageRating=4.4, totalRatingsCount=27,
      createdAt="2026-08-30T15:57:06.701819Z", updatedAt="2026-08-30T20:52:24.212332Z",
    ),
    ClubDto(
      id="42d8a152-f00c-41b4-b306-0637e89cabd0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Acadèmia de Voleibol Platja de Barcelona", address="Av. de l'Estadi, 12, INEFC, Sants-Montjuïc, 08038 Barcelona",
      city="Barcelona", country="ES",
      latitude=41.3639342, longitude=2.1467154,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f16b747b-22e4-4906-a56f-f0118acca60e_photo.jpg",
      averageRating=4.8, totalRatingsCount=9,
      createdAt="2026-08-31T14:52:18.641292Z", updatedAt="2026-08-31T14:52:18.641292Z",
    ),
  )),
  CitySeo(slug="madrid", name="Madrid", country="ES", clubCount=45, sports=listOf(Pair("Football", 6), Pair("Padel", 6), Pair("Tennis", 5), Pair("Karting", 5), Pair("Climbing", 3), Pair("Volleyball", 3), Pair("Laser Tag", 3), Pair("Table Tennis", 3), Pair("Billiards", 3), Pair("Paintball", 3), Pair("Basketball", 2), Pair("Golf", 2), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="9859bcfa-7b6f-4773-b31b-a14bfbe9b983", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="⭐ Humor Amarillo Madrid【El auténtico】- Action Live", address="Calle Mayor, 6, 1ºplanta, Centro, 28013 Madrid",
      city="Madrid", country="ES",
      latitude=40.4166846, longitude=-3.7054415,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c918e8f0-f7ad-40c0-9d3e-7e70745b32ae_ChIJuW2RcEEp_2.jpg",
      averageRating=5.0, totalRatingsCount=5841,
      createdAt="2026-08-30T15:54:16.214952Z", updatedAt="2026-08-31T22:11:28.559215Z",
    ),
    ClubDto(
      id="dc68a7ee-25a6-4323-b785-f1ec300e5e9c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Madrid CTM / Madrid Ciudad Tenis de Mesa", address="C. de Moreja, 11, Usera, 28041 Madrid",
      city="Madrid", country="ES",
      latitude=40.3681278, longitude=-3.6981317,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/253b76a3-4b15-4ddf-9793-31ecf7222859_ChIJ6YJIJAMn_0.jpg",
      averageRating=4.9, totalRatingsCount=67,
      createdAt="2026-08-30T15:54:36.930716Z", updatedAt="2026-08-30T20:52:18.296535Z",
    ),
    ClubDto(
      id="60955dfd-5775-496a-b867-bf55e5085d9c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Omotopark", address="28922 Alcorcón, Madrid",
      city="Madrid", country="ES",
      latitude=40.3389748, longitude=-3.8489887,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0436623f-5456-41d9-884c-0636fbf00e22_ChIJ06TCy0GP_0.jpg",
      averageRating=4.9, totalRatingsCount=591,
      createdAt="2026-08-30T11:41:16.771892Z", updatedAt="2026-08-30T20:52:19.119125Z",
    ),
    ClubDto(
      id="f035e6b7-50e4-44ec-8d5f-65cd73a721f8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PadelSpirit Club - Madrid", address="Vicálvaro, C. Pirotecnia, 59, Vicálvaro, 28052 Madrid",
      city="Madrid", country="ES",
      latitude=40.3962649, longitude=-3.5910913,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e17409b9-f369-459c-9f3d-a720cbb073ba_ChIJJ3YtNT4l_0.jpg",
      averageRating=4.9, totalRatingsCount=2797,
      createdAt="2026-08-30T11:41:29.698369Z", updatedAt="2026-08-30T20:52:19.706415Z",
    ),
    ClubDto(
      id="d7fddc19-283c-422f-a46b-eed28a22aea6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Madrid【Nº1 En mapas de juego】 - Action Live", address="Av del Cardenal Herrera Oria, 173, Loc 1, Fuencarral-El Pardo, 28034 Madrid",
      city="Madrid", country="ES",
      latitude=40.4836372, longitude=-3.7113391,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a7f84bc8-7271-499b-93b1-08183d54bf49_ChIJZ-l9zJop_0.jpg",
      averageRating=4.9, totalRatingsCount=12256,
      createdAt="2026-08-30T15:53:59.753988Z", updatedAt="2026-08-30T20:52:19.916418Z",
    ),
    ClubDto(
      id="b1e86047-3f0d-4085-bf7b-fb7253cf9914", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="✅ Gran Paintball Madrid Oficina (con Cita Previa) ⭐【Nº 1 Paintball Madrid】", address="Av. del Pdte. Carmona, 8, 2º izquierda, Tetuán, 28020 Madrid",
      city="Madrid", country="ES",
      latitude=40.453741, longitude=-3.696835,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99795d02-eb47-488d-92c3-9992d214a034_ChIJe5pIqUeD_0.jpg",
      averageRating=4.9, totalRatingsCount=14433,
      createdAt="2026-08-30T15:53:52.025348Z", updatedAt="2026-08-30T20:52:55.559499Z",
    ),
    ClubDto(
      id="073833e6-c42a-46bd-8d72-7265a34a6361", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="✅ Gran Paintball Madrid ⭐【Nº 1 Paintball Madrid ✚ Humor Amarillo】", address="en el kilómetro 5 de la M-600, C. Barrasqui, s/n, 28200 San Lorenzo de El Escorial, Madrid",
      city="Madrid", country="ES",
      latitude=40.6161283, longitude=-4.1141051,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/43630bd6-90e4-4cc3-bc8a-c4b757cc8463_ChIJFap76qYL_0.jpg",
      averageRating=4.9, totalRatingsCount=11547,
      createdAt="2026-08-30T15:54:07.528372Z", updatedAt="2026-08-30T20:52:55.689089Z",
    ),
    ClubDto(
      id="37e864d3-682e-4af7-852f-5d6c37c11d7c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Virtual Zone Madrid", address="Pl. de Carlos Trías Bertrán, 3, Planta 1, Tetuán, 28020 Madrid",
      city="Madrid", country="ES",
      latitude=40.4514914, longitude=-3.6943452,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/649a5266-569a-4320-9ec8-8144d8d03121_ChIJk445V4Ap_0.jpg",
      averageRating=4.8, totalRatingsCount=3083,
      createdAt="2026-08-30T15:54:22.864565Z", updatedAt="2026-08-30T20:52:25.175483Z",
    ),
    ClubDto(
      id="9524c500-db97-4556-8382-05aadff00759", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Ilusiona Islazul", address="Centro Comercial Islazul, Carabanchel, 28054 Carabanchel, Madrid",
      city="Madrid", country="ES",
      latitude=40.36304, longitude=-3.738807,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7f5becc6-d6c0-4d73-8d3c-1aec36ac5cec_photo.jpg",
      averageRating=4.6, totalRatingsCount=10673,
      createdAt="2026-08-31T14:53:28.562432Z", updatedAt="2026-08-31T14:53:28.562432Z",
    ),
    ClubDto(
      id="957e6cca-e5d1-4f16-807a-336b44718e2c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Combat Arena", address="C. Areneros, 12, 28521 Rivas-Vaciamadrid, Madrid",
      city="Madrid", country="ES",
      latitude=40.3284928, longitude=-3.5219765,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/12b27432-935f-4bed-86eb-32d76a291be3_ChIJt9UR8nI8_0.jpg",
      averageRating=4.6, totalRatingsCount=720,
      createdAt="2026-08-30T15:54:29.639332Z", updatedAt="2026-08-30T20:52:11.761027Z",
    ),
    ClubDto(
      id="09b010c1-3c68-41e2-ac83-3cf5488f2989", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indie Padel Club", address="Av. de la Democracia, 11, Puente de Vallecas, 28031 Madrid",
      city="Madrid", country="ES",
      latitude=40.3863911, longitude=-3.6252379,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1fb896e8-5ad7-45dc-ae17-f5769efbf167_ChIJ-2uzrhQl_0.jpg",
      averageRating=4.6, totalRatingsCount=1974,
      createdAt="2026-08-30T11:41:35.931120Z", updatedAt="2026-08-30T20:52:14.938930Z",
    ),
    ClubDto(
      id="0d3bbc1a-c07f-496e-87db-71530333de1c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Madrid Ángel Burgueño", address="Vía de Servicio A-1, salida 47, 28723 Pedrezuela, Madrid",
      city="Madrid", country="ES",
      latitude=40.7561648, longitude=-3.5999868,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b360f729-f7ba-4c63-a8bd-22ba39fef11b_ChIJca3fyfLb_0.jpg",
      averageRating=4.6, totalRatingsCount=2603,
      createdAt="2026-08-30T11:41:02.641727Z", updatedAt="2026-08-30T20:52:15.682638Z",
    ),
    ClubDto(
      id="8747c26f-4640-4150-8045-7e59682475be", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Rivas | Circuito de Karts", address="C. de la Fundición, 89, 28522 Rivas-Vaciamadrid, Madrid",
      city="Madrid", country="ES",
      latitude=40.3471656, longitude=-3.5353533,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e107aefb-7c88-4db4-a76c-0dbe39dbf189_ChIJESuVUZs7_0.jpg",
      averageRating=4.6, totalRatingsCount=2987,
      createdAt="2026-08-30T11:40:55.658585Z", updatedAt="2026-08-30T20:52:16.061612Z",
    ),
    ClubDto(
      id="87e69a7d-f417-4415-8741-5a25a6351ad8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Movistar Arena Madrid", address="Av. de Felipe II, s/n, Salamanca, 28009 Madrid",
      city="Madrid", country="ES",
      latitude=40.4238786, longitude=-3.6717512,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ad357cb5-1aa4-493f-a39d-4b562c1f3c08_photo.jpg",
      averageRating=4.6, totalRatingsCount=69423,
      createdAt="2026-08-31T14:52:43.394523Z", updatedAt="2026-08-31T14:52:43.394523Z",
    ),
    ClubDto(
      id="50d4d339-1053-407f-b8cc-e86f25b79b9c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Real Club de Golf La Herrería", address="de Chavela, Carr. de Robledo, s/n, 28200 San Lorenzo de El Escorial, Madrid",
      city="Madrid", country="ES",
      latitude=40.5846775, longitude=-4.15467,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9adf4edb-b608-47b7-95df-7695d11af1cb_ChIJx0kMcpMJ_0.jpg",
      averageRating=4.6, totalRatingsCount=2016,
      createdAt="2026-08-30T15:53:38.983700Z", updatedAt="2026-08-30T20:52:21.758424Z",
    ),
    ClubDto(
      id="2752417e-adfb-49fc-882a-0f81a56d7df2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sputnik Climbing Las Rozas - Centro de escalada", address="C. París, 2, 28232 Las Rozas de Madrid, Madrid",
      city="Madrid", country="ES",
      latitude=40.4984304, longitude=-3.8907835,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/672a9436-911b-45e4-836a-531e63e4176f_ChIJ_ZkzRPOD_0.jpg",
      averageRating=4.6, totalRatingsCount=1086,
      createdAt="2026-08-30T15:53:32.628134Z", updatedAt="2026-08-30T20:52:23.700443Z",
    ),
    ClubDto(
      id="508ef0d4-e485-4d50-9541-494ebd7fa957", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fútbol Factory Madrid Centro", address="Calle Mayor, 21, Centro, 28013 Madrid",
      city="Madrid", country="ES",
      latitude=40.416228, longitude=-3.706615,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dae3ffaf-8345-4f32-9fcb-3160ea618b4c_ChIJo4eN6X4o_0.jpg",
      averageRating=4.5, totalRatingsCount=846,
      createdAt="2026-08-30T11:40:15.069432Z", updatedAt="2026-08-30T20:52:13.767856Z",
    ),
    ClubDto(
      id="e98b5044-1ae0-4136-ac77-a18f021bb20e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Madrid Central Padel", address="Calle Boyer, 28, C. de Boyer, 20, Vicálvaro, 28052 Madrid",
      city="Madrid", country="ES",
      latitude=40.4044706, longitude=-3.5869918,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/47000d7f-02c9-4f34-9ec6-6122e0153fc9_ChIJ-Vr5b04l_0.jpg",
      averageRating=4.5, totalRatingsCount=977,
      createdAt="2026-08-30T11:41:42.059948Z", updatedAt="2026-08-30T20:52:18.415581Z",
    ),
    ClubDto(
      id="0181e024-ffd2-4d96-849d-b55385f691b5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Río Arena Pádel", address="C. de la Verdad, 20, Carabanchel, 28019 Madrid",
      city="Madrid", country="ES",
      latitude=40.3925363, longitude=-3.7190357,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1f097550-52b2-4106-94e8-85c6240c2b49_ChIJp9e7W8cn_0.jpg",
      averageRating=4.5, totalRatingsCount=600,
      createdAt="2026-08-30T11:41:55.744949Z", updatedAt="2026-08-30T20:52:22.322769Z",
    ),
    ClubDto(
      id="d5792352-4ac5-403d-98c6-f010682777c2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fuencarral El Pardo Tenis de Mesa", address="CEIP Felipe II, Av. de Asturias, n°70, Tetuán, 28029 Madrid",
      city="Madrid", country="ES",
      latitude=40.4726735, longitude=-3.6981359,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/70f67e13-8626-45e7-a3dc-6f2c9b2d952b_ChIJgYiDsN8p_0.jpg",
      averageRating=4.9, totalRatingsCount=45,
      createdAt="2026-08-30T15:54:42.897082Z", updatedAt="2026-08-30T20:52:13.516122Z",
    ),
    ClubDto(
      id="605ff1d5-ec14-4422-8cde-9ef61a8cb80a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo Municipal Antiguo Canódromo", address="C. Vía Carpetana, 57, Carabanchel, 28047 Madrid",
      city="Madrid", country="ES",
      latitude=40.397452, longitude=-3.7357944,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/274fad10-94a7-478e-9ab0-b96e8dcdded2_ChIJQ3MZnPEn_0.jpg",
      averageRating=4.4, totalRatingsCount=523,
      createdAt="2026-08-30T11:40:35.709527Z", updatedAt="2026-08-30T20:52:09.814091Z",
    ),
    ClubDto(
      id="8ae814b0-f322-4242-9b10-0fc337c6c2c0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="El Chico Feo", address="Calle de Covarrubias, 21, Chamberí, 28010 Madrid",
      city="Madrid", country="ES",
      latitude=40.4304386, longitude=-3.6979475,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/16202fb7-808f-4f3a-a063-0150632beb81_ChIJaZcWh4so_1.jpg",
      averageRating=4.4, totalRatingsCount=893,
      createdAt="2026-08-30T15:52:51.464341Z", updatedAt="2026-08-31T22:11:16.066220Z",
    ),
    ClubDto(
      id="14acb1ff-2634-4307-b8df-a6fc069368cf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Real Club de la Puerta de Hierro", address="Av. de Miraflores, s/n, Moncloa - Aravaca, 28035 Madrid",
      city="Madrid", country="ES",
      latitude=40.4599189, longitude=-3.7407336,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/80e137ae-0148-4810-984c-bb76ea894751_ChIJj0v98cQp_0.jpg",
      averageRating=4.4, totalRatingsCount=1248,
      createdAt="2026-08-30T15:53:45.554308Z", updatedAt="2026-08-30T20:52:21.889680Z",
    ),
    ClubDto(
      id="6adf82bf-44b4-49b6-bda8-9fe60da4f83c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sharma Climbing Madrid - Rocódromo de escalada en Madrid", address="C. de Julián Camarillo, 55, San Blas-Canillejas, 28037 Madrid",
      city="Madrid", country="ES",
      latitude=40.4377516, longitude=-3.620209,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/751643a5-68a7-4e7e-8d23-d8775a921749_ChIJhdV3R_4v_0.jpg",
      averageRating=4.4, totalRatingsCount=2290,
      createdAt="2026-08-30T15:53:18.931766Z", updatedAt="2026-08-30T20:52:23.205312Z",
    ),
    ClubDto(
      id="5be00573-46a4-4553-b81f-735b52adb96a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stars Volleyball Club", address="Av. de Pío XII, 2, Chamartín, 28016 Madrid",
      city="Madrid", country="ES",
      latitude=40.4613101, longitude=-3.6760405,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f2ddf9f8-2658-4fce-9987-2e0a89f59192_photo.jpg",
      averageRating=4.4, totalRatingsCount=72,
      createdAt="2026-08-31T14:53:17.908261Z", updatedAt="2026-08-31T14:53:17.908261Z",
    ),
    ClubDto(
      id="d82845ad-478a-4592-a87c-c019b6d78d96", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vim Padel Indoor", address="C. de Agosto, 3, San Blas-Canillejas, 28022 Madrid",
      city="Madrid", country="ES",
      latitude=40.4420651, longitude=-3.5719142,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/051d89e9-2f7c-413b-8c53-462d7b05a260_ChIJGZ3IMFUx_0.jpg",
      averageRating=4.4, totalRatingsCount=664,
      createdAt="2026-08-30T11:41:49.125008Z", updatedAt="2026-08-30T20:52:24.920310Z",
    ),
    ClubDto(
      id="ad8d2cd9-6750-4e0c-940f-d6a47e5ff49a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zentro Basket", address="C. de Joaquín Dicenta, 1, Tetuán, 28029 Madrid",
      city="Madrid", country="ES",
      latitude=40.4713898, longitude=-3.6955245,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a68b4472-7971-4f9b-874f-81208c7cc5c2_photo.jpg",
      averageRating=4.4, totalRatingsCount=99,
      createdAt="2026-08-31T14:52:49.791122Z", updatedAt="2026-08-31T22:11:23.996400Z",
    ),
    ClubDto(
      id="82c3ed89-1c1e-427f-a9b5-8fefc9cb70f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cubes Norte TT tenis de mesa", address="C. de Puente la Reina, Fuencarral-El Pardo, 28050 Madrid",
      city="Madrid", country="ES",
      latitude=40.5016551, longitude=-3.6745783,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d4247d98-9538-42e0-a365-9a6fb982e926_ChIJj-F7W48r_0.jpg",
      averageRating=4.9, totalRatingsCount=44,
      createdAt="2026-08-30T15:54:50.643587Z", updatedAt="2026-08-30T20:52:12.003521Z",
    ),
    ClubDto(
      id="1dbcda69-a596-4a17-9452-7d9910d57b10", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo Goya", address="Av. de los Caprichos, 16, Latina, 28011 Madrid",
      city="Madrid", country="ES",
      latitude=40.4051399, longitude=-3.7309036,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/69dbb706-26ce-4581-ad2e-b4b8b17dffd1_ChIJXxlG1486_0.jpg",
      averageRating=4.3, totalRatingsCount=203,
      createdAt="2026-08-30T11:40:43.016205Z", updatedAt="2026-08-30T20:52:10.928030Z",
    ),
    ClubDto(
      id="c368bc18-0074-4d1f-b4cf-37e7e91f7856", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo Somontes", address="Carr Madrid-El Pardo, Km. 3, 400, Fuencarral-El Pardo, 28048 Madrid",
      city="Madrid", country="ES",
      latitude=40.4919199, longitude=-3.7565449,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e6ff4902-3b2f-4e99-b1c7-c4c25a400613_ChIJdaFeBCMo_0.jpg",
      averageRating=4.3, totalRatingsCount=2957,
      createdAt="2026-08-30T11:41:23.424659Z", updatedAt="2026-08-30T20:52:11.049412Z",
    ),
    ClubDto(
      id="b6454dff-aeb5-45f4-b046-33d67ef232b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club El Estudiante", address="C. del Alto, s/n, 28108 Alcobendas, Madrid",
      city="Madrid", country="ES",
      latitude=40.5208958, longitude=-3.5940122,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/686a66c8-23b4-4097-8414-eb2e0b6b0ded_ChIJi2vYH6st_0.jpg",
      averageRating=4.3, totalRatingsCount=2008,
      createdAt="2026-08-30T11:42:08.210347Z", updatedAt="2026-09-01T14:31:48.396408Z",
    ),
    ClubDto(
      id="1925d0ed-cf5e-4e89-b65b-e86efeb00010", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BamVolea Ciudad de la Raqueta", address="C. del Monasterio de El Paular, 2, Fuencarral-El Pardo, 28049 Madrid",
      city="Madrid", country="ES",
      latitude=40.4998915, longitude=-3.7117448,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ab38e885-3803-4d6d-ac98-fa86f984d790_ChIJB3lW8Lhh_0.jpg",
      averageRating=4.2, totalRatingsCount=3519,
      createdAt="2026-08-30T11:42:01.696648Z", updatedAt="2026-08-30T20:52:08.438100Z",
    ),
    ClubDto(
      id="5d466799-fef3-4098-8b20-00d89748bda7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Carlos Sainz Karting Las Rozas", address="Parque Empresarial Európolis, C. Bruselas, 3, 28232 Las Rozas de Madrid, Madrid",
      city="Madrid", country="ES",
      latitude=40.5007582, longitude=-3.8940375,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd20fb04-3897-4459-93cb-8382af8c84c1_ChIJPTR3AEWD_0.jpg",
      averageRating=4.2, totalRatingsCount=3565,
      createdAt="2026-08-30T11:40:49.144979Z", updatedAt="2026-08-30T20:52:09.427445Z",
    ),
    ClubDto(
      id="bdde4f5f-05b4-4e29-8f4f-fcde1b77141b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo Municipal La Chopera", address="P.º de Fernán Núñez, 3, Retiro, 28009 Madrid",
      city="Madrid", country="ES",
      latitude=40.4123505, longitude=-3.6861743,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4c9a166f-52ab-4cc1-b034-0d7fadfa47c5_ChIJO-wFlyAm_0.jpg",
      averageRating=4.2, totalRatingsCount=623,
      createdAt="2026-08-30T11:40:21.990463Z", updatedAt="2026-09-01T14:31:57.898900Z",
    ),
    ClubDto(
      id="53f82e0f-51ea-4f16-841d-f51ce62bb5f9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo SMP", address="C. del Dr. Esquerdo, 64, 66, Retiro, 28007 Madrid",
      city="Madrid", country="ES",
      latitude=40.414328, longitude=-3.6709454,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e1a1ae84-86b6-4c1d-817e-13ec0fea2c92_ChIJeYHlJ6go_0.jpg",
      averageRating=4.2, totalRatingsCount=563,
      createdAt="2026-08-30T11:40:28.736435Z", updatedAt="2026-09-01T14:31:58.015062Z",
    ),
    ClubDto(
      id="4929f21b-1f77-44b3-80c8-8988c6837bf3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climbat", address="C. Oslo, 54, Loc 27, 28922 Alcorcón, Madrid",
      city="Madrid", country="ES",
      latitude=40.3393516, longitude=-3.8485639,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a5330c0c-4543-4b97-aa73-49348029fb6f_ChIJ57jy8bCP_0.jpg",
      averageRating=4.2, totalRatingsCount=1153,
      createdAt="2026-08-30T15:53:25.966256Z", updatedAt="2026-08-30T20:52:10.687497Z",
    ),
    ClubDto(
      id="5964f2cf-aaea-450d-9113-9e3b0faa9405", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gran Match Billar", address="Calle de Brescia, 19, Salamanca, 28028 Madrid",
      city="Madrid", country="ES",
      latitude=40.4366836, longitude=-3.6623286,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5acf68b6-0236-4d3f-9f9a-11ad13f0b4ee_ChIJw47U0soo_0.jpg",
      averageRating=4.2, totalRatingsCount=2847,
      createdAt="2026-08-30T15:52:44.675320Z", updatedAt="2026-08-30T20:52:14.273263Z",
    ),
    ClubDto(
      id="a23e35f5-9a9b-4ea4-abf7-73bacc5b4f9f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Vía Láctea", address="C. de Velarde, 18, Centro, 28004 Madrid",
      city="Madrid", country="ES",
      latitude=40.4269012, longitude=-3.7029216,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/574181bb-c07c-4e8f-a4e1-7c980e502e2b_ChIJK0L434ko_0.jpg",
      averageRating=4.2, totalRatingsCount=4235,
      createdAt="2026-08-30T15:52:37.321435Z", updatedAt="2026-08-30T20:52:16.814751Z",
    ),
    ClubDto(
      id="691a562a-7554-4d9c-9a53-c182dd518c1e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Las Tablas Sports Club", address="Av. del Camino de Santiago, 25, Fuencarral-El Pardo, 28050 Madrid",
      city="Madrid", country="ES",
      latitude=40.5024107, longitude=-3.6744309,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c5b0b9b8-f67b-4974-8f6f-1ff79ade245c_ChIJV2i4AeUr_0.jpg",
      averageRating=4.2, totalRatingsCount=1651,
      createdAt="2026-08-30T11:42:23.309180Z", updatedAt="2026-09-01T14:31:45.633289Z",
    ),
    ClubDto(
      id="f79665ec-054c-41ca-ac40-3be5203e0a0e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Internacional de Tenis", address="Carretera de El Plantío, 3, 28221 Majadahonda, Madrid",
      city="Madrid", country="ES",
      latitude=40.475624, longitude=-3.8419336,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/188a075c-ff1b-4156-9205-3444bedda684_ChIJKxyhVWuE_0.jpg",
      averageRating=4.1, totalRatingsCount=426,
      createdAt="2026-08-30T11:42:30.485631Z", updatedAt="2026-08-30T20:52:11.291935Z",
    ),
    ClubDto(
      id="179a977e-63ab-45aa-8039-9cd9c4312e99", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Masó Sports Club", address="C. de La Masó, 34, Fuencarral-El Pardo, 28035 Madrid",
      city="Madrid", country="ES",
      latitude=40.4893966, longitude=-3.7144793,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0ec0bd56-3aad-43c0-94cf-768015c6b29f_ChIJEeRrwIgp_0.jpg",
      averageRating=4.1, totalRatingsCount=1855,
      createdAt="2026-08-30T11:42:15.597215Z", updatedAt="2026-09-01T14:31:45.264333Z",
    ),
    ClubDto(
      id="66261a2a-a456-47ca-90b4-bc29d7c4d320", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo Municipal Marqués de Samaranch", address="P.º Imperial, 20, Arganzuela, 28005 Madrid",
      city="Madrid", country="ES",
      latitude=40.4075805, longitude=-3.71739,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3fb7c3a0-e4f4-4256-b4f7-637c6c831a0e_ChIJ4f53Rtkn_0.jpg",
      averageRating=4.0, totalRatingsCount=1894,
      createdAt="2026-08-30T11:40:07.103613Z", updatedAt="2026-08-30T20:52:10.053756Z",
    ),
    ClubDto(
      id="20c8110e-4d2c-424f-af99-6ed9947717e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Formula Cero Outdoor Karting", address="C. Verano, 4A, 28914 Leganés, Madrid",
      city="Madrid", country="ES",
      latitude=40.3000642, longitude=-3.7735931,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f011c2fd-05a2-498d-b01b-326f4dd92a79_ChIJXUTuZkWK_0.jpg",
      averageRating=4.0, totalRatingsCount=2073,
      createdAt="2026-08-30T11:41:09.522639Z", updatedAt="2026-08-30T20:52:13.253261Z",
    ),
    ClubDto(
      id="e431848e-54e4-4167-81bc-697d9168a335", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pistas Voleyplaya FMVB", address="Av. Padre Huidobro, 2, Moncloa - Aravaca, 28040 Madrid",
      city="Madrid", country="ES",
      latitude=40.4659824, longitude=-3.749963,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7120d1c4-dcec-49a6-9709-f378e282a05d_photo.jpg",
      averageRating=4.5, totalRatingsCount=32,
      createdAt="2026-08-31T14:52:55.858002Z", updatedAt="2026-08-31T14:52:55.858002Z",
    ),
    ClubDto(
      id="b44f2bc1-ce76-4c56-ac6f-4071df87a50f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Volleyball Madrid", address="Av. de Filipinas, 7, Chamberí, 28003 Madrid",
      city="Madrid", country="ES",
      latitude=40.4409759, longitude=-3.7092316,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/238421c3-a77c-4b8b-ac3f-77d56e39ed53_photo.jpg",
      averageRating=4.1, totalRatingsCount=25,
      createdAt="2026-08-31T14:53:08.864125Z", updatedAt="2026-08-31T14:53:08.864125Z",
    ),
  )),
  CitySeo(slug="odesa", name="Odesa", country="UA", clubCount=39, sports=listOf(Pair("Tennis", 8), Pair("Football", 5), Pair("Billiards", 3), Pair("Golf", 3), Pair("Karting", 3), Pair("Climbing", 3), Pair("Paintball", 3), Pair("Padel", 2), Pair("Basketball", 2), Pair("Table Tennis", 2), Pair("Laser Tag", 2), Pair("Volleyball", 2), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="b62b42af-13cf-44a4-b63c-3add936c1774", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг Одеса \"Kart Center Odesa\"", address="вулиця Базова, 17, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4445092, longitude=30.6498636,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9267765f-424e-4752-9111-e22eee58d4b2_ChIJO9kUbQAz_0.jpg",
      averageRating=5.0, totalRatingsCount=393,
      createdAt="2026-08-30T15:34:52.790881Z", updatedAt="2026-08-30T20:52:32.829794Z",
    ),
    ClubDto(
      id="4a40b64c-f3f3-449c-821c-971a26b6d2aa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Golf - Міні Гольф, що світиться", address="ТЦ Чудо-Город, вулиця Середньофонтанська, 19А, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4582557, longitude=30.7407354,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a4470a2b-a919-489f-adf4-f35b02c0c432_ChIJqd3weVQz_0.jpg",
      averageRating=4.9, totalRatingsCount=454,
      createdAt="2026-08-30T15:51:21.551356Z", updatedAt="2026-08-30T20:52:10.444292Z",
    ),
    ClubDto(
      id="a14cf499-b54d-4c1f-8e91-90f3f3af5090", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Point Odesa", address="Люстдорфська дорога, 96, 65029 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4175866, longitude=30.7219148,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/17472234-35a4-4138-a58f-5b1ed4a031d5_ChIJ7RvpMZMd_0.jpg",
      averageRating=4.8, totalRatingsCount=51,
      createdAt="2026-08-30T15:35:09.281394Z", updatedAt="2026-08-30T20:52:19.367830Z",
    ),
    ClubDto(
      id="56979ac8-8824-4483-b984-501265160f9d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Настольный теннис EVOLUTION", address="вулиця Тараса Кузьміна, 4, 65029 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4813642, longitude=30.7193181,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d6febb4a-ece4-4bf2-98b1-d1a5a72ac57d_ChIJJ6DbvpIx_0.jpg",
      averageRating=4.8, totalRatingsCount=63,
      createdAt="2026-08-30T15:52:22.577726Z", updatedAt="2026-08-30T20:52:40.325027Z",
    ),
    ClubDto(
      id="95785842-e56c-46d5-9de6-7f4181753f96", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазер клуб \"ШТАБ\"", address="Торгова вулиця, 26, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4877006, longitude=30.7257828,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/387de083-2459-476b-abe6-bb2c32afd3c4_ChIJ9ay_SZUx_0.jpg",
      averageRating=4.7, totalRatingsCount=210,
      createdAt="2026-08-30T15:52:10.089060Z", updatedAt="2026-08-30T20:52:36.627322Z",
    ),
    ClubDto(
      id="619eb383-be0c-4e8d-bc3a-f2178720266f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбольный клуб Headshot", address="вулиця Сергія Ядова, 6, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4890248, longitude=30.6895982,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c9f330d4-d260-4850-a1e6-c4994929f778_ChIJWdwTzQIu_0.jpg",
      averageRating=4.7, totalRatingsCount=434,
      createdAt="2026-08-30T15:51:29.958998Z", updatedAt="2026-08-30T20:52:43.765583Z",
    ),
    ClubDto(
      id="3bae560c-acb8-41e5-a6f0-5afb962d4bdb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скеледром \"Shelrocks\"", address="вулиця Академіка Філатова, 13б, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4328015, longitude=30.7224137,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04d6174d-3c4f-47c3-a211-a44e7b2eb7c8_ChIJqwroGCoz_0.jpg",
      averageRating=4.7, totalRatingsCount=61,
      createdAt="2026-08-30T15:51:13.442330Z", updatedAt="2026-08-30T20:52:46.379823Z",
    ),
    ClubDto(
      id="eced0a94-33f2-40c1-85d6-f0b144588bef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Теннисный комплекс Престиж-Матчболл", address="вулиця Давида Ойстраха, 30, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.5834901, longitude=30.7917877,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3db1ee07-293d-4be4-a822-e8a29418bb3a_ChIJD2zhoNEk_2.jpg",
      averageRating=4.7, totalRatingsCount=72,
      createdAt="2026-08-30T15:35:30.883984Z", updatedAt="2026-09-01T14:31:50.825520Z",
    ),
    ClubDto(
      id="7cf0ead3-5dbb-48e6-a104-b54de9f21f97", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KartFreedom", address="ТРЦ Рив‘єра Південна дорога 101. С. Фонтанка, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.5623332, longitude=30.8376793,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3b16c9b0-3a74-48b5-87fc-e903ecb6a653_ChIJHY-ZegI7_0.jpg",
      averageRating=4.6, totalRatingsCount=675,
      createdAt="2026-08-30T15:34:43.824176Z", updatedAt="2026-08-30T20:52:15.444814Z",
    ),
    ClubDto(
      id="b3c9eddf-8117-4085-8d89-d29d586bda98", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Арена", address="Генуезька вулиця, 2, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4330219, longitude=30.759988,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/179d18ab-a5c9-44c7-8064-294c29e3aa65_ChIJRzkfkosz_0.jpg",
      averageRating=4.6, totalRatingsCount=259,
      createdAt="2026-08-30T15:50:18.635995Z", updatedAt="2026-08-30T20:52:26.637081Z",
    ),
    ClubDto(
      id="860f7256-da9e-450e-9856-56bea34cfdcd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Більярдний клуб \"Колізей\"", address="вулиця Сергія Шелухина, 57, 65088 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.41193, longitude=30.7290267,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4b94a578-2033-4160-9577-c005bfd2cc1e_ChIJ_eiY-2Qz_0.jpg",
      averageRating=4.6, totalRatingsCount=186,
      createdAt="2026-08-30T15:50:25.617128Z", updatedAt="2026-08-30T20:52:28.483214Z",
    ),
    ClubDto(
      id="5e147db9-20a7-4868-9394-4615511d7e2b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ДЮСШ 11, Футбольне поле", address="вулиця Євгенія Танцюри, 11, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4290113, longitude=30.7151657,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/16642413-8133-43bb-accd-a4a5c9662600_ChIJpV2JZqcz_0.jpg",
      averageRating=4.6, totalRatingsCount=270,
      createdAt="2026-08-30T15:34:29.403451Z", updatedAt="2026-08-30T20:52:30.506279Z",
    ),
    ClubDto(
      id="bb21e66a-b57e-45c7-b6ea-2c7b4c05b348", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Куяльніцька стінка", address="Лиманна вулиця, 170, 65013 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.5595466, longitude=30.7250667,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/303656c7-fb10-4ca3-8f5a-1e5dacdae2dc_ChIJX-nf8WQl_0.jpg",
      averageRating=4.6, totalRatingsCount=93,
      createdAt="2026-08-30T15:51:05.747484Z", updatedAt="2026-08-30T20:52:35.891051Z",
    ),
    ClubDto(
      id="541d3c07-5211-4005-b8db-cb3cb3d96c1d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбол Дракон", address="Косівська вулиця, 4/11, 65074 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4553186, longitude=30.7192484,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/97361eb4-815e-4ec6-bfd7-fb271900af16_ChIJ-xYjwTIy_0.jpg",
      averageRating=4.6, totalRatingsCount=314,
      createdAt="2026-08-30T15:51:38.209005Z", updatedAt="2026-08-30T20:52:42.016397Z",
    ),
    ClubDto(
      id="d7c03d27-83d1-4340-86a6-41b95f7f5087", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="\"Стиль\" Більярдний клуб", address="Тираспольська вулиця, 16, 65020 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4780692, longitude=30.7278397,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e9e6404e-f1b7-4f74-bf25-8ad917946c9b_ChIJYXegLpAx_0.jpg",
      averageRating=4.5, totalRatingsCount=589,
      createdAt="2026-08-30T15:50:11.789524Z", updatedAt="2026-08-30T20:52:08.185385Z",
    ),
    ClubDto(
      id="530415ce-2655-4393-8efe-31c3be23ab18", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Академія Спорту", address="Дальницьке шосе, 2, 65085 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4731907, longitude=30.6590584,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/24e20cb4-0d1c-4454-b6f6-8c482a2ed5ab_ChIJQ7zKC_Et_0.jpg",
      averageRating=4.5, totalRatingsCount=1404,
      createdAt="2026-08-30T15:34:00.227880Z", updatedAt="2026-08-30T20:52:26.513467Z",
    ),
    ClubDto(
      id="efeafb3a-5367-4c6d-b802-f184c7d3afb2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Клуб настільного тенісу T-Stream", address="вулиця Успенська, 66, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4762427, longitude=30.7323553,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6b1ac660-11f0-4a1f-b2ba-9fa86c860a8e_ChIJ8XDwMoUx_0.jpg",
      averageRating=4.5, totalRatingsCount=184,
      createdAt="2026-08-30T15:52:17.353995Z", updatedAt="2026-08-30T20:52:34.487822Z",
    ),
    ClubDto(
      id="4d6f0876-9ee6-49f8-8b9d-35c2dc8df747", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лаун-теніс Клуб", address="Французький бульвар, 85, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4457646, longitude=30.7663569,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eaa34a95-77bb-424c-a1ee-968296377c79_ChIJda8NZvAz_2.jpg",
      averageRating=4.5, totalRatingsCount=62,
      createdAt="2026-08-30T15:35:38.453210Z", updatedAt="2026-08-31T22:11:25.750951Z",
    ),
    ClubDto(
      id="e4afd085-ba41-4a84-9ba5-e37e8189233b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скалодром", address="Трасса Здоровья Чкаловский, пляж, 7, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4424532, longitude=30.771539,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/948f8ac6-3220-44e4-a837-5c2c4248b392_ChIJMzYzQfcz_0.jpg",
      averageRating=4.5, totalRatingsCount=1198,
      createdAt="2026-08-30T15:50:57.075821Z", updatedAt="2026-08-30T20:52:45.756570Z",
    ),
    ClubDto(
      id="16eb4b53-8d9b-4e91-b570-8bb6daf7e1f7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ТЕХАС", address="Радісна вулиця, 15, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4420588, longitude=30.6990742,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/62a8f90c-469e-46a2-8ce2-8d0bea69181c_ChIJTfxSOlIy_0.jpg",
      averageRating=4.4, totalRatingsCount=277,
      createdAt="2026-08-30T15:51:54.751658Z", updatedAt="2026-08-30T20:52:50.317207Z",
    ),
    ClubDto(
      id="c8b480ab-ad28-4936-8fa1-04624bbd1974", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Чорноморець", address="вул. Андрія Гулого-Гуленка, 1, Одеса, Одеська область, 65000",
      city="Odesa", country="UA",
      latitude=46.4638756, longitude=30.7597009,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d977f95-ec87-4bc7-9116-4dc2b2e79a1f_photo.jpg",
      averageRating=4.4, totalRatingsCount=153,
      createdAt="2026-08-31T21:55:01.495622Z", updatedAt="2026-09-01T14:31:42.390056Z",
    ),
    ClubDto(
      id="33639d82-91b4-470f-8c33-5a9eef13df7d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="тенісний комплекс Престиж", address="вулиця Академіка Корольова, 90, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.3947465, longitude=30.7201902,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/af2cdc51-d73d-4e2a-a100-8c41f762ed37_ChIJ4-q32Vcz_0.jpg",
      averageRating=4.4, totalRatingsCount=208,
      createdAt="2026-08-30T15:35:23.631032Z", updatedAt="2026-09-01T14:31:42.517225Z",
    ),
    ClubDto(
      id="8f04bf9f-5a85-4ff9-a019-9d83a484adc6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Кузин Теннис Одесса", address="вулиця Балтиморська, 2, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4322071, longitude=30.7598185,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1fd0186-60e5-4ebf-bbd2-39ac08141b45_ChIJe3jOlT0z_0.jpg",
      averageRating=4.9, totalRatingsCount=44,
      createdAt="2026-08-30T15:35:46.490890Z", updatedAt="2026-08-30T20:52:35.773400Z",
    ),
    ClubDto(
      id="dd7cc817-b63a-4d07-971e-ad11bf4e9480", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спорт-комплекс Ф.Л.А.Г.", address="Спорт-комплекс Ф.Л.А.Г., вулиця Середньофонтанська, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4509979, longitude=30.7404668,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8054893c-6959-4f78-bdf3-f65a6e40336c_ChIJAQCw5cQz_0.jpg",
      averageRating=4.3, totalRatingsCount=288,
      createdAt="2026-08-30T15:34:21.811727Z", updatedAt="2026-08-30T20:52:47.824966Z",
    ),
    ClubDto(
      id="6b9154f5-18db-4107-bce3-5226fd153011", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Park Residence", address="Французький бульвар, 85, 65058 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4454862, longitude=30.7664734,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4cdcaa19-44cc-44ed-890e-f4d949f0ff11_ChIJjZ-zo_oz_0.jpg",
      averageRating=4.2, totalRatingsCount=934,
      createdAt="2026-08-30T15:34:13.956445Z", updatedAt="2026-08-30T20:52:20.160772Z",
    ),
    ClubDto(
      id="1c27c972-bc22-499f-851c-7aba1021286b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="П'ятий Елемент", address="вул. Артура Савельєва, 4, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4384823, longitude=30.7473077,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e72f6d7a-65f8-434f-bf82-17ffd3dbed28_ChIJ47KcYpMz_0.jpg",
      averageRating=4.1, totalRatingsCount=1982,
      createdAt="2026-08-30T15:50:48.780556Z", updatedAt="2026-08-30T20:52:41.421278Z",
    ),
    ClubDto(
      id="41df73da-b3a5-45a0-92f6-eed35f974deb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стадіон \"Спартак\"", address="79, вулиця Канатна, 77, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4683564, longitude=30.7483079,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ba6ef89f-4afd-4388-938d-5a30fb3d1db6_ChIJbyT_nHkx_0.jpg",
      averageRating=4.0, totalRatingsCount=1021,
      createdAt="2026-08-30T15:34:06.851029Z", updatedAt="2026-08-30T20:52:49.001702Z",
    ),
    ClubDto(
      id="200c7fc2-da96-4387-ae34-7c6a6939c774", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ураган", address="проспект Небесної Сотні, 32Б, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.408235, longitude=30.705655,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d16f3129-69d1-42fe-b9e2-d667a4ce4096_ChIJgWLs7P4t_1.jpg",
      averageRating=4.0, totalRatingsCount=49,
      createdAt="2026-08-30T15:51:46.663771Z", updatedAt="2026-08-31T22:11:27.810747Z",
    ),
    ClubDto(
      id="36fdbfb7-b44d-42ee-98c9-0b963c996931", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Panorama Tennis Club", address="Одеса, Одеська область, 65000",
      city="Odesa", country="UA",
      latitude=46.4691066, longitude=30.7602774,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4868ffe1-00a3-4e0f-a9d6-30b2806859db_photo.jpg",
      averageRating=4.5, totalRatingsCount=40,
      createdAt="2026-08-31T21:55:07.880075Z", updatedAt="2026-08-31T21:55:07.880075Z",
    ),
    ClubDto(
      id="c44dfa8c-4fcc-43df-a297-28964aa49583", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Yellow Padel Club", address="вулиця Панченко, 6, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.5705545, longitude=30.8162934,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5cc58c70-d751-467d-8b7a-08f4e38c57e3_ChIJLYMyJAA7_0.jpg",
      averageRating=5.0, totalRatingsCount=34,
      createdAt="2026-08-30T15:35:16.424206Z", updatedAt="2026-08-30T20:52:25.676349Z",
    ),
    ClubDto(
      id="c44ce5d6-7766-4594-b86f-62324baaa738", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг Ривьера", address="Південна дорога, 101а, 67571 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.5622959, longitude=30.8376098,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9673a698-1fb8-4816-a024-50d0449c4028_ChIJhSaqKgA7_0.jpg",
      averageRating=4.5, totalRatingsCount=35,
      createdAt="2026-08-30T15:35:01.135253Z", updatedAt="2026-08-30T20:52:32.963025Z",
    ),
    ClubDto(
      id="8872bd7f-41f2-46bd-b727-af429475e370", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Дюківський", address="Поштова вулиця, 1, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.4833878, longitude=30.7025911,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c0227beb-8cf7-4be0-b8f4-48f0c3167fad_ChIJdU3UdvAx_0.jpg",
      averageRating=4.2, totalRatingsCount=34,
      createdAt="2026-08-30T15:35:55.223823Z", updatedAt="2026-08-30T20:52:31.607161Z",
    ),
    ClubDto(
      id="0c906af2-4e15-4b01-813e-3fd33ef317da", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пляжний волейбол", address="Пляж 14 станция Большого Фонтана, Фонтанська дорога, 153, 65000 Odesa, Ukraine",
      city="Odesa", country="UA",
      latitude=46.3986013, longitude=30.7538547,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3a40cb3d-302a-4025-8eb5-9d5d32ee42f9_ChIJ5YfALJQ0_3.jpg",
      averageRating=4.7, totalRatingsCount=20,
      createdAt="2026-08-30T15:52:29.637186Z", updatedAt="2026-08-31T22:11:26.505750Z",
    ),
    ClubDto(
      id="92e9b7b8-a642-4f8a-90ca-85c2152c18d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спорткомплекс Динамика", address="вулиця Бугаївська, 35/1, Одеса, Одеська область, 65005",
      city="Odesa", country="UA",
      latitude=46.4720613, longitude=30.7024668,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/46a5f088-e0d9-4b4a-85b6-76db13f151f1_photo.jpg",
      averageRating=4.4, totalRatingsCount=21,
      createdAt="2026-08-31T14:53:51.470002Z", updatedAt="2026-08-31T14:53:51.470002Z",
    ),
    ClubDto(
      id="c0ba6e6a-eb1a-486f-bee0-8c634b506440", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Odesa Golf Club", address="Чорноморська вулиця, 19, Одеса, Одеська область, 65000",
      city="Odesa", country="UA",
      latitude=46.4719295, longitude=30.7616762,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7949ca1-c4c3-4580-a8d2-326eec9162c7_photo.jpg",
      averageRating=5.0, totalRatingsCount=15,
      createdAt="2026-08-31T14:54:15.288558Z", updatedAt="2026-08-31T14:54:15.288558Z",
    ),
    ClubDto(
      id="b921f4ad-1a2d-4819-a481-0a265b791f2c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Краян", address="Одеса, Одеська область, 65000",
      city="Odesa", country="UA",
      latitude=46.4633926, longitude=30.7310729,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f230f2df-89f3-4be9-b7e5-e36f367eb5e7_photo.jpg",
      averageRating=4.4, totalRatingsCount=17,
      createdAt="2026-08-31T21:54:55.527897Z", updatedAt="2026-08-31T21:54:55.527897Z",
    ),
    ClubDto(
      id="da0fd961-921d-4b88-a195-75931fce8525", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Баскетбольний клуб Ініма Жирафи", address="вулиця Гоголя, 18, Одеса, Одеська область, 65000",
      city="Odesa", country="UA",
      latitude=46.4873955, longitude=30.7353012,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ef384811-b2b0-4ec3-b695-41dac804045a_photo.jpg",
      averageRating=5.0, totalRatingsCount=7,
      createdAt="2026-08-31T14:53:36.916986Z", updatedAt="2026-08-31T14:53:36.916986Z",
    ),
    ClubDto(
      id="4c0d81e9-8113-4711-8385-d5d92341c390", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Гольф Клуб Одеса", address="вулиця Вапняна, 32, Одеса, Одеська область, 65000",
      city="Odesa", country="UA",
      latitude=46.4964991, longitude=30.7102901,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/12facd72-4220-47d1-8295-2a13381ec5b1_photo.jpg",
      averageRating=5.0, totalRatingsCount=6,
      createdAt="2026-08-31T14:54:24.145105Z", updatedAt="2026-08-31T14:54:24.145105Z",
    ),
    ClubDto(
      id="372c8834-6630-4179-b5f6-d7bbe81be28e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Центр пляжних видів спорту", address="Одеса, Одеська область, 65000",
      city="Odesa", country="UA",
      latitude=46.3964285, longitude=30.7539358,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c41a25bf-a503-43a7-8334-bbeea38ee5c5_photo.jpg",
      averageRating=5.0, totalRatingsCount=5,
      createdAt="2026-08-31T14:54:08.846945Z", updatedAt="2026-08-31T22:11:28.452268Z",
    ),
  )),
  CitySeo(slug="stockholm", name="Stockholm", country="SE", clubCount=33, sports=listOf(Pair("Football", 4), Pair("Volleyball", 4), Pair("Padel", 3), Pair("Tennis", 3), Pair("Basketball", 3), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Table Tennis", 2), Pair("Laser Tag", 2), Pair("Karting", 2), Pair("Paintball", 2), Pair("Golf", 2)), clubs=listOf(
    ClubDto(
      id="64fc1053-8897-4626-9b15-02404b8cc48c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cave Padel", address="Sjöviksvägen 136, 117 57 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3053904, longitude=18.0361592,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/00f679ef-cddd-4f02-9248-b7f6f507803d_ChIJYSqlY593_0.jpg",
      averageRating=4.6, totalRatingsCount=52,
      createdAt="2026-08-30T23:26:32.822472Z", updatedAt="2026-08-31T08:26:46.429953Z",
    ),
    ClubDto(
      id="94475e85-a664-4a47-906d-c2b34f7f7e20", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klätterverket Gasverket", address="Gasverksvägen 15, 115 42 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3574759, longitude=18.0907382,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/13ad85bf-31d3-4159-a0dd-84d7490f732f_ChIJfWQg0dmd_0.jpg",
      averageRating=4.6, totalRatingsCount=431,
      createdAt="2026-08-30T23:25:57.193875Z", updatedAt="2026-08-30T23:25:57.193875Z",
    ),
    ClubDto(
      id="416f6a6a-2a53-487d-a740-b12c2647dacb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="O'Learys Kista Stockholm Gokart", address="Hanstavägen 55, Under Filmstaden, Plan 2, 164 91 Kista",
      city="Stockholm", country="SE",
      latitude=59.4038956, longitude=17.9431897,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6ba40e3f-1c7f-45ec-9c30-f0d835b2bfb9_photo.png",
      averageRating=4.6, totalRatingsCount=341,
      createdAt="2026-08-31T15:30:31.458234Z", updatedAt="2026-08-31T15:30:31.458234Z",
    ),
    ClubDto(
      id="d30b1299-6914-4276-a18f-2750c4d80cc8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Beach", address="Novavägen 35, 141 44 Huddinge",
      city="Stockholm", country="SE",
      latitude=59.2309115, longitude=17.9574838,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/87c76454-cba5-4abc-a007-182612779be0_photo.png",
      averageRating=4.6, totalRatingsCount=348,
      createdAt="2026-08-31T15:29:30.375751Z", updatedAt="2026-08-31T15:29:30.375751Z",
    ),
    ClubDto(
      id="6df80a0d-dbf2-4dfe-99dd-2af5a5a85964", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Alewalds Outdoor & Sports", address="Kungsgatan 32, 111 35 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.336054, longitude=18.0650801,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/721d16c2-6168-4386-8a88-3d985bbcdfcf_ChIJX2bzd12d_0.jpg",
      averageRating=4.5, totalRatingsCount=725,
      createdAt="2026-08-30T23:25:50.092534Z", updatedAt="2026-08-31T08:24:50.494747Z",
    ),
    ClubDto(
      id="29b469ce-17e1-4e2c-b904-ded90867fcb7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Birka Bowling och Dart", address="Birkagatan 16, 113 39 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.340372, longitude=18.035117,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd2843d3-7e4a-4e0e-bacc-3572cb54db32_ChIJjeRWgnmd_0.jpg",
      averageRating=4.5, totalRatingsCount=1236,
      createdAt="2026-08-30T23:25:35.636135Z", updatedAt="2026-08-30T23:25:35.636135Z",
    ),
    ClubDto(
      id="68bdac32-8748-4925-8c4f-9a6ece241bc7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Spelapaintball Stockholm", address="Skärsvik, 136 50 Jordbro",
      city="Stockholm", country="SE",
      latitude=59.1460506, longitude=18.1022206,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e21d8555-a5d3-481c-ba47-6b943653d284_photo.jpg",
      averageRating=4.5, totalRatingsCount=484,
      createdAt="2026-08-31T15:30:38.758817Z", updatedAt="2026-08-31T15:30:38.758817Z",
    ),
    ClubDto(
      id="d3dce884-1bd5-4c74-bfd5-369f6f6712e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Spårvägens Bordtennisklubb", address="Tellusborgsvägen 22, 126 33 Hägersten",
      city="Stockholm", country="SE",
      latitude=59.3046785, longitude=18.0139109,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/469e116c-c438-404a-8319-693f99fcafca_photo.jpg",
      averageRating=4.5, totalRatingsCount=57,
      createdAt="2026-08-31T15:30:06.514024Z", updatedAt="2026-08-31T15:30:06.514024Z",
    ),
    ClubDto(
      id="65fb2aeb-377b-4d74-9b43-3fb60fe96ee7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sthlm Beach Club", address="Norra Malmvägen 80, 191 62 Sollentuna",
      city="Stockholm", country="SE",
      latitude=59.4397417, longitude=17.9352744,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e20a022-3f39-4f02-9e37-a2c24b90bf2c_photo.jpg",
      averageRating=4.5, totalRatingsCount=229,
      createdAt="2026-08-31T15:29:37.723877Z", updatedAt="2026-08-31T15:29:37.723877Z",
    ),
    ClubDto(
      id="a8d1d160-0ff4-4ac9-9068-53198ae84e6d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stockholms Tennishall", address="Elersvägen 37, 112 51 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3375305, longitude=18.0026077,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b0c729fa-ae9b-4a51-8a71-5043c8642be7_ChIJTQQfd4id_0.jpg",
      averageRating=4.5, totalRatingsCount=121,
      createdAt="2026-08-30T23:26:46.421697Z", updatedAt="2026-08-31T08:37:01.232954Z",
    ),
    ClubDto(
      id="a8acf88f-51dc-458b-8585-40cc65aecda9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vinterviken padelbanor", address="Vinterviksvägen 10, 117 65 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.311422, longitude=18.0041486,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/37523716-79d5-4560-893b-e33e0918ce09_ChIJ8d_iq0p2_0.jpg",
      averageRating=4.5, totalRatingsCount=128,
      createdAt="2026-08-30T23:26:16.597237Z", updatedAt="2026-08-31T08:38:37.856097Z",
    ),
    ClubDto(
      id="d25be9b7-dcec-486e-8653-a860f7b33770", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fusion Table Tennis Club", address="2 Stockholm Rd, London SE16 3LP, UK",
      city="Stockholm", country="SE",
      latitude=51.4849414, longitude=-0.0508567,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d1166b9c-e507-47c4-8469-9e88c1e823d1_photo.jpg",
      averageRating=4.4, totalRatingsCount=114,
      createdAt="2026-08-31T15:30:14.011865Z", updatedAt="2026-08-31T15:30:14.011865Z",
    ),
    ClubDto(
      id="18aa885e-5f7b-4a05-a81a-f6f46551deab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Huddinge Tennisklubb", address="Gamla Stockholmsvägen 87, 141 32 Huddinge",
      city="Stockholm", country="SE",
      latitude=59.2501291, longitude=17.9513804,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aec56be0-e235-43c4-94c3-633cdc4f4c97_ChIJiT8nktR2_0.jpg",
      averageRating=4.4, totalRatingsCount=94,
      createdAt="2026-08-30T23:26:53.654833Z", updatedAt="2026-08-31T08:29:05.572676Z",
    ),
    ClubDto(
      id="37857c3c-5379-4b93-9a5d-3415608b5713", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kungliga tennishallen", address="Lidingövägen 75, 115 41 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3502508, longitude=18.095738,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f9cd8ab9-62e2-4b9a-afef-c685fab22159_ChIJ_f5ZZDed_0.jpg",
      averageRating=4.4, totalRatingsCount=450,
      createdAt="2026-08-30T23:26:39.760187Z", updatedAt="2026-08-30T23:26:39.760187Z",
    ),
    ClubDto(
      id="dd853b5b-54be-4d47-b43e-a32ff3d3b2cc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="NK Padel & Social by ASCARO", address="Regeringsgatan 47 Ingång NK Parkaden, 111 56 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3332254, longitude=18.067488,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/38186868-3712-4a2e-8c99-949444106f3f_ChIJxXIfj16d_0.jpg",
      averageRating=4.4, totalRatingsCount=64,
      createdAt="2026-08-30T23:26:23.879248Z", updatedAt="2026-08-31T08:33:12.400837Z",
    ),
    ClubDto(
      id="6be0b894-0b60-481d-9904-9233ce229761", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Racehall Stockholm AB", address="Skälbyvägen 5, 147 91 Grödinge",
      city="Stockholm", country="SE",
      latitude=59.1628027, longitude=17.7399467,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67d41fb5-d84d-4fa8-b530-291c23a8daa7_photo.jpg",
      averageRating=4.4, totalRatingsCount=184,
      createdAt="2026-08-31T15:30:21.146012Z", updatedAt="2026-08-31T15:30:21.146012Z",
    ),
    ClubDto(
      id="e53ed594-5607-4ec5-beee-a6da7615ca0f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Årsta Golf", address="Östbergavägen 10, 125 74 Älvsjö",
      city="Stockholm", country="SE",
      latitude=59.2881097, longitude=18.0416959,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d2100dad-53cf-480d-af73-dca944d4badf_photo.jpg",
      averageRating=4.4, totalRatingsCount=151,
      createdAt="2026-08-31T15:29:59.629029Z", updatedAt="2026-08-31T15:29:59.629029Z",
    ),
    ClubDto(
      id="9f4bba60-8e6c-4eb9-8adc-ec4836906e1a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Östermalms IP", address="Södra Fiskartorpsvägen 2, 114 33 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3475194, longitude=18.0835005,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/94080568-3b27-43f1-a65c-f8fdc12df2ec_ChIJ9WLPT0ed_0.jpg",
      averageRating=4.3, totalRatingsCount=1113,
      createdAt="2026-08-30T23:25:08.108538Z", updatedAt="2026-08-30T23:25:08.108538Z",
    ),
    ClubDto(
      id="5c5557e5-b6b6-428e-ab9e-5052236fc09b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Frescati Sports Center", address="Svante Arrhenius väg 4, 114 18 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.366504, longitude=18.0576528,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f59d0c98-767b-42c6-bd02-d1a06825cae8_ChIJK6BlywWd_0.jpg",
      averageRating=4.2, totalRatingsCount=1272,
      createdAt="2026-08-30T23:25:01.785894Z", updatedAt="2026-08-31T08:28:03.770600Z",
    ),
    ClubDto(
      id="3a0093f3-81a6-423b-b112-71081ec6d988", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laserdome Stockholm", address="Surbrunnsgatan 42, 113 48 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3450953, longitude=18.0559224,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/206926eb-8f14-4f29-840c-51b1b6555278_ChIJkylgjm6d_0.jpg",
      averageRating=4.2, totalRatingsCount=466,
      createdAt="2026-08-30T23:26:03.586254Z", updatedAt="2026-08-31T08:32:19.326574Z",
    ),
    ClubDto(
      id="7d34e476-a878-4bf3-9ba4-d9a41584052f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stockholm Paintball & Adventure Center", address="Torslundavägen 42, 194 92 Upplands Väsby",
      city="Stockholm", country="SE",
      latitude=59.4944245, longitude=17.9792853,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/57dea839-5a99-4c23-94aa-4b593349c57a_photo.jpg",
      averageRating=4.2, totalRatingsCount=139,
      createdAt="2026-08-31T15:30:46.078385Z", updatedAt="2026-08-31T15:30:46.078385Z",
    ),
    ClubDto(
      id="3e7fd704-7f01-4fe1-b5c0-91870369ea5c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ballbreaker Kungsholmen", address="Lindhagensgatan 114, 112 51 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3364196, longitude=18.0113376,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d0210453-2288-4d0e-b3b3-37f62d04ae8a_ChIJ-bGbG7WC_0.jpg",
      averageRating=4.1, totalRatingsCount=2266,
      createdAt="2026-08-30T23:24:54.785143Z", updatedAt="2026-08-30T23:24:54.785143Z",
    ),
    ClubDto(
      id="b0626034-203a-47c0-a3a1-8ede8f134902", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Biljardpalatset i Stockholm", address="Sankt Eriksgatan 52, 112 34 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3358117, longitude=18.0338072,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dd12c11d-c751-4501-b6ef-934258ef9e85_ChIJ6VqxInyd_0.jpg",
      averageRating=4.1, totalRatingsCount=2562,
      createdAt="2026-08-30T23:25:21.913490Z", updatedAt="2026-08-31T08:26:09.124667Z",
    ),
    ClubDto(
      id="40a0741d-42f7-40d5-b700-39f7fb561793", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stockholms Golfklubb", address="Kevinge strand 22, 182 57 Danderyd",
      city="Stockholm", country="SE",
      latitude=59.3941734, longitude=18.0300286,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c35b2aad-b290-4a79-bf83-6b95f5a81942_photo.jpg",
      averageRating=4.1, totalRatingsCount=252,
      createdAt="2026-08-31T15:29:52.396234Z", updatedAt="2026-08-31T15:29:52.396234Z",
    ),
    ClubDto(
      id="7397df7d-9261-4811-9ef4-c80953b8e245", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LASERFORTET", address="Saltmätargatan 19A, 113 59 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3407628, longitude=18.0569895,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/94521acc-5092-4cc6-ba8c-d4fd94ed1ce1_ChIJBZfxrWid_0.jpg",
      averageRating=4.0, totalRatingsCount=309,
      createdAt="2026-08-30T23:26:09.757206Z", updatedAt="2026-08-30T23:26:09.757206Z",
    ),
    ClubDto(
      id="8f670a9a-8a38-4b01-87bf-cce0ac662e8e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lucky Bowl Kungsholmen", address="S:t Göransgatan 64, 112 38 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3332646, longitude=18.0326541,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/46fb7d78-8fdf-4d45-9191-a319bdc0c18e_ChIJQ6P9wH2d_0.jpg",
      averageRating=4.0, totalRatingsCount=506,
      createdAt="2026-08-30T23:25:42.725458Z", updatedAt="2026-08-31T08:32:35.266744Z",
    ),
    ClubDto(
      id="ae057d41-a05e-4aad-9681-371f630baeba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PDL Center Frihamnen", address="Palermogatan 34, 115 56 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3404941, longitude=18.1250247,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d6f5951a-0581-40b9-b374-916e407ae1dd_ChIJwcu3vbeC_0.jpg",
      averageRating=4.0, totalRatingsCount=519,
      createdAt="2026-08-30T23:25:14.950948Z", updatedAt="2026-09-01T14:31:53.182212Z",
    ),
    ClubDto(
      id="9d36daf0-0470-4364-8cfc-83e06bdd7560", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Ship - Sportbar & Restaurang i Stockholm", address="Sankt Eriksgatan 36, 112 34 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3338178, longitude=18.0324114,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0737bf1f-e5c7-4a39-8b53-dd64e097df5b_ChIJZUAh0H2d_3.jpg",
      averageRating=4.0, totalRatingsCount=1777,
      createdAt="2026-08-30T23:25:29.197664Z", updatedAt="2026-08-31T22:11:23.129467Z",
    ),
    ClubDto(
      id="f58e9985-f1d4-49a7-9cbb-15bd3d30338e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Liljeholmshallarna", address="Mejerivägen 4, 117 61 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3132434, longitude=18.0245826,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/22ab1caf-e4d9-4f94-802f-440cec841775_photo.jpg",
      averageRating=3.9, totalRatingsCount=436,
      createdAt="2026-08-31T15:29:07.823350Z", updatedAt="2026-08-31T15:29:07.823350Z",
    ),
    ClubDto(
      id="65b7ca95-a388-4c11-bebe-b9347e0c2750", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="S:t Erikshallen", address="Polhemsgatan 35, 112 30 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3351101, longitude=18.0378719,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/696e5e1a-190d-454c-9525-d5c1749b9a32_photo.jpg",
      averageRating=4.2, totalRatingsCount=44,
      createdAt="2026-08-31T15:29:16.171635Z", updatedAt="2026-08-31T15:29:16.171635Z",
    ),
    ClubDto(
      id="47d23809-b10f-419e-9909-222edd4fa9de", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KFUM Central", address="Rosengatan 1, 111 40 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3395871, longitude=18.0622719,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2ab6506c-ace1-4b1e-934c-50ec4a8b815b_photo.jpg",
      averageRating=4.2, totalRatingsCount=31,
      createdAt="2026-08-31T15:29:00.009619Z", updatedAt="2026-08-31T15:29:00.009619Z",
    ),
    ClubDto(
      id="89e57e9b-11da-482d-8779-5bdc26a23d53", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gärdet beach volleyball court", address="Unnamed Road, 115 28 Stockholm",
      city="Stockholm", country="SE",
      latitude=59.3416063, longitude=18.1098677,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d3dde88c-0913-42cc-a9e2-b62d27a41466_photo.jpg",
      averageRating=4.4, totalRatingsCount=27,
      createdAt="2026-08-31T15:29:22.624469Z", updatedAt="2026-08-31T15:29:22.624469Z",
    ),
    ClubDto(
      id="9765557f-1a93-4860-99b3-58fd77ad815a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hästhagen Beach Arena", address="Östervägen, 131 33 Nacka",
      city="Stockholm", country="SE",
      latitude=59.2995528, longitude=18.1662207,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b6143953-f4b7-46c8-a6e2-dc3ffaf3a9a8_photo.jpg",
      averageRating=4.6, totalRatingsCount=25,
      createdAt="2026-08-31T15:29:45.716393Z", updatedAt="2026-08-31T15:29:45.716393Z",
    ),
  )),
  CitySeo(slug="new-york", name="New York", country="US", clubCount=33, sports=listOf(Pair("Volleyball", 5), Pair("Football", 4), Pair("Tennis", 3), Pair("Padel", 3), Pair("Billiards", 2), Pair("Laser Tag", 2), Pair("Paintball", 2), Pair("Climbing", 2), Pair("Bowling", 2), Pair("Table Tennis", 2), Pair("Golf", 2), Pair("Karting", 2), Pair("Basketball", 2)), clubs=listOf(
    ClubDto(
      id="fa80f6df-481a-447a-b04f-cdf49200cf67", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="QBK Sports", address="41-20 39th St, Long Island City, NY 11104",
      city="New York", country="US",
      latitude=40.7468683, longitude=-73.9259383,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/07c5f7fe-5b81-43fc-acc0-59ef20148822_photo.jpg",
      averageRating=5.0, totalRatingsCount=1098,
      createdAt="2026-09-20T19:09:28.749658Z", updatedAt="2026-09-20T19:09:28.749658Z",
    ),
    ClubDto(
      id="58787a53-ed57-438c-bbaa-fd6caa797be0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Downtown Tennis Club", address="John J. Carty Park Tennis Court #1, Brooklyn, NY 11209",
      city="New York", country="US",
      latitude=40.6127187, longitude=-74.0307185,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9554cd69-f1d1-4480-837d-316b820157e8_photo.jpg",
      averageRating=4.9, totalRatingsCount=304,
      createdAt="2026-09-20T19:09:08.130285Z", updatedAt="2026-09-20T19:09:08.130285Z",
    ),
    ClubDto(
      id="e79a6584-f1d2-4b35-ab91-0fe092e48262", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Five Iron Golf", address="883 6th Ave 3rd floor, New York, NY 10001",
      city="New York", country="US",
      latitude=40.7484018, longitude=-73.9892996,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d5c66c3-0b8f-4c2d-a56c-cb5da34f4cc5_photo.jpg",
      averageRating=4.9, totalRatingsCount=569,
      createdAt="2026-09-20T19:09:44.115560Z", updatedAt="2026-09-20T19:09:44.115560Z",
    ),
    ClubDto(
      id="b917d76a-0357-4142-8637-ba141f411578", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LaFayette Motorsports Park", address="4930 US-20, Lafayette, NY 13084",
      city="New York", country="US",
      latitude=42.9014227, longitude=-76.1745428,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9c058649-f0ee-4b5c-9454-3d2ed2f82e3e_photo.jpg",
      averageRating=4.9, totalRatingsCount=64,
      createdAt="2026-09-20T19:10:00.450931Z", updatedAt="2026-09-20T19:10:00.450931Z",
    ),
    ClubDto(
      id="84b821ac-3d86-4aba-9cb5-79b05fa31532", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mink Padel", address="439 W 127th St, New York, NY 10027",
      city="New York", country="US",
      latitude=40.8134804, longitude=-73.9547533,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e3613c70-8e21-4ee2-9c36-dca8a7c2e55f_photo.jpg",
      averageRating=5.0, totalRatingsCount=48,
      createdAt="2026-09-20T19:09:16.900049Z", updatedAt="2026-09-20T19:09:16.900049Z",
    ),
    ClubDto(
      id="a78ff138-bb39-424f-acf6-2a2823eee617", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sofive Soccer Centers Meadowlands", address="2 Palmer Terrace, Carlstadt, NJ 07072",
      city="New York", country="US",
      latitude=40.824795, longitude=-74.0682588,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c641f7ba-c2fe-444c-ac87-e9a2e9575031_photo.jpg",
      averageRating=4.8, totalRatingsCount=1952,
      createdAt="2026-09-20T19:08:51.407519Z", updatedAt="2026-09-20T19:08:51.407519Z",
    ),
    ClubDto(
      id="4c020318-0b9e-45fd-8e3c-0690517408d2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tac Ops - Tactical Laser Tag - Fairfield", address="373 US-46 d110, Fairfield, NJ 07004",
      city="New York", country="US",
      latitude=40.8822984, longitude=-74.2943857,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2c438f1f-f031-4a49-9c71-346c87603a47_photo.jpg",
      averageRating=4.8, totalRatingsCount=1408,
      createdAt="2026-09-20T19:10:32.252856Z", updatedAt="2026-09-20T19:10:32.252856Z",
    ),
    ClubDto(
      id="8760716c-628b-4bcd-8c50-15848cad5320", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Area 53 - Indoor Paintball", address="616 Scholes St, Brooklyn, NY 11237",
      city="New York", country="US",
      latitude=40.7126383, longitude=-73.922691,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5bce988e-e18c-40f6-aa6e-77910b1dfdd6_photo.jpg",
      averageRating=4.7, totalRatingsCount=2169,
      createdAt="2026-09-20T19:10:28.945112Z", updatedAt="2026-09-20T19:10:28.945112Z",
    ),
    ClubDto(
      id="8e596bf4-2f43-41f1-b1e5-b6b9df3baa09", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brooklyn Bridge Park - Pier 6 - Beach Volleyball Courts", address="Brooklyn Bridge Park Greenway, Brooklyn, NY 11201",
      city="New York", country="US",
      latitude=40.6932222, longitude=-74.0016887,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ee0067ce-9c69-4db8-b060-faeeaee00324_photo.jpg",
      averageRating=4.7, totalRatingsCount=714,
      createdAt="2026-09-20T19:09:37.104156Z", updatedAt="2026-09-20T19:09:37.104156Z",
    ),
    ClubDto(
      id="24773ad1-5e01-4247-abc9-2d9d232ad9ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="High Velocity Paintball", address="426 Mill Rd, Coram, NY 11727",
      city="New York", country="US",
      latitude=40.854903, longitude=-72.98121,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/314cda13-f1a9-4f0b-bfbf-901ca83b91fe_photo.jpg",
      averageRating=4.7, totalRatingsCount=569,
      createdAt="2026-09-20T19:10:41.437840Z", updatedAt="2026-09-20T19:10:41.437840Z",
    ),
    ClubDto(
      id="b8c509cc-c163-4288-ac45-763006cba172", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Movement LIC", address="11-11 44th Dr, Long Island City, NY 11101",
      city="New York", country="US",
      latitude=40.7485996, longitude=-73.9487406,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aeb2fb17-0af3-43a6-8d8c-0f3136c65b4e_photo.jpg",
      averageRating=4.7, totalRatingsCount=1655,
      createdAt="2026-09-20T19:10:11.449222Z", updatedAt="2026-09-20T19:10:11.449222Z",
    ),
    ClubDto(
      id="8b03d5f9-db70-449e-8943-e823a8ed17f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="USTA Billie Jean King National Tennis Center", address="Flushing Meadows Corona Park, Flushing, NY 11368",
      city="New York", country="US",
      latitude=40.7499978, longitude=-73.8469958,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/20fe16e2-ba00-44ef-bb28-9fbf658eaf33_photo.jpg",
      averageRating=4.7, totalRatingsCount=5694,
      createdAt="2026-09-20T19:09:01.232382Z", updatedAt="2026-09-20T19:09:01.232382Z",
    ),
    ClubDto(
      id="09b5511b-236b-4964-abf7-9708afa56adb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brooklyn Boulders Queensbridge", address="23-10 41st Ave, Long Island City, NY 11101",
      city="New York", country="US",
      latitude=40.7526405, longitude=-73.9400914,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/27ed12bd-6f45-42b5-aa8f-71c830eb30e2_photo.jpg",
      averageRating=4.6, totalRatingsCount=885,
      createdAt="2026-09-20T19:10:14.581751Z", updatedAt="2026-09-20T19:10:14.581751Z",
    ),
    ClubDto(
      id="3f4aa895-c680-4b40-a1ce-de6e6c5b5d61", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brooklyn Table Tennis Club", address="1100 Coney Island Ave #8, Brooklyn, NY 11230",
      city="New York", country="US",
      latitude=40.6306627, longitude=-73.9665767,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ad7969c7-3a86-4fbb-875d-9519a11c23e1_photo.jpg",
      averageRating=4.6, totalRatingsCount=91,
      createdAt="2026-09-20T19:09:51.385706Z", updatedAt="2026-09-20T19:09:51.385706Z",
    ),
    ClubDto(
      id="780b46f5-0d59-4781-9c13-43b3e1051618", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="HQ Racing", address="7 John Walsh Blvd, Peekskill, NY 10566",
      city="New York", country="US",
      latitude=41.2741312, longitude=-73.9409865,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5593120d-8d50-4e88-bb41-5a5cc12b7c49_photo.jpg",
      averageRating=4.6, totalRatingsCount=135,
      createdAt="2026-09-20T19:09:57.290553Z", updatedAt="2026-09-20T19:09:57.290553Z",
    ),
    ClubDto(
      id="7c5e0137-bd96-4dcc-bebf-95bc374f0f17", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Haus Dumbo", address="257 Water St, Brooklyn, NY 11201",
      city="New York", country="US",
      latitude=40.7031702, longitude=-73.9837946,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/08e3c0c6-847c-47e2-bb29-617574a10f3d_photo.jpg",
      averageRating=4.6, totalRatingsCount=52,
      createdAt="2026-09-20T19:09:14.313232Z", updatedAt="2026-09-20T19:09:14.313232Z",
    ),
    ClubDto(
      id="fd22f73e-eb5b-42a5-aecd-c054144d1b80", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Socceroof - Sunset Park", address="3rd Floor, 14b 53rd St, Brooklyn, NY 11232",
      city="New York", country="US",
      latitude=40.6501414, longitude=-74.023608,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7c285767-1589-4c0d-b6d1-bcb2524878f2_photo.jpg",
      averageRating=4.6, totalRatingsCount=1083,
      createdAt="2026-09-20T19:08:54.360256Z", updatedAt="2026-09-20T19:08:54.360256Z",
    ),
    ClubDto(
      id="2f8db2c6-0109-4e6f-9185-af81ee382415", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sofive Soccer Centers Brooklyn", address="2015 Pitkin Ave, Brooklyn, NY 11207",
      city="New York", country="US",
      latitude=40.6719131, longitude=-73.8984085,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a4e6d443-1bec-40b1-aa6b-ed1fb14d12d9_photo.jpg",
      averageRating=4.6, totalRatingsCount=1065,
      createdAt="2026-09-20T19:08:57.920991Z", updatedAt="2026-09-20T19:08:57.920991Z",
    ),
    ClubDto(
      id="b61c608c-acf7-4814-82ce-d05771f01fc6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Battle Creek Paintball", address="625 Macopin Rd, West Milford, NJ 07480",
      city="New York", country="US",
      latitude=41.0378685, longitude=-74.3838496,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/88bdc0bc-7733-49a0-a78e-f14a71bd3388_photo.jpg",
      averageRating=4.5, totalRatingsCount=937,
      createdAt="2026-09-20T19:10:37.283874Z", updatedAt="2026-09-20T19:10:37.283874Z",
    ),
    ClubDto(
      id="a4cc5e9b-93ea-4e7a-8fe8-acfe378ce263", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="East Volleyball Courts", address="Perimeter Rd, Flushing, NY 11355",
      city="New York", country="US",
      latitude=40.7470495, longitude=-73.8360331,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8c512b93-cc42-4131-935e-9c5297b3975d_photo.jpg",
      averageRating=4.5, totalRatingsCount=187,
      createdAt="2026-09-20T19:09:39.801130Z", updatedAt="2026-09-20T19:09:39.801130Z",
    ),
    ClubDto(
      id="38364d58-c30b-46db-b117-4de29db7c5e7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vibe Fitness BQE", address="26-50 Brooklyn Queens Expy W, Woodside, NY 11377",
      city="New York", country="US",
      latitude=40.761397, longitude=-73.9021965,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5f9e8c5-c2fa-466f-a5fe-c6b6c491e005_photo.jpg",
      averageRating=4.5, totalRatingsCount=791,
      createdAt="2026-09-20T19:09:20.764340Z", updatedAt="2026-09-20T19:09:20.764340Z",
    ),
    ClubDto(
      id="d3e32007-2d6d-4294-ae29-873b3da69e28", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brooklyn Bowl", address="61 Wythe Ave, Brooklyn, NY 11249",
      city="New York", country="US",
      latitude=40.7218874, longitude=-73.9573813,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/195a21cf-9a6c-4081-8cb7-191338fdc76e_photo.jpg",
      averageRating=4.4, totalRatingsCount=3985,
      createdAt="2026-09-20T19:10:03.343228Z", updatedAt="2026-09-20T19:10:03.343228Z",
    ),
    ClubDto(
      id="68f492bc-a4a8-4d52-be3f-ca67f7a2407e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="House of Sports", address="1 Elm St, Ardsley, NY 10502",
      city="New York", country="US",
      latitude=41.0103563, longitude=-73.8510887,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6ed183e8-d349-45c4-99b9-b2eb661a270d_photo.jpg",
      averageRating=4.4, totalRatingsCount=523,
      createdAt="2026-09-20T19:09:31.913646Z", updatedAt="2026-09-20T19:09:31.913646Z",
    ),
    ClubDto(
      id="2e2f80ca-c095-46cf-b04c-4b51d463c008", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Amsterdam Billiards", address="110 E 11th St, New York, NY 10003",
      city="New York", country="US",
      latitude=40.7317088, longitude=-73.9899424,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ef9cec76-df6d-45e4-808c-c2825315f0b2_photo.jpg",
      averageRating=4.3, totalRatingsCount=1554,
      createdAt="2026-09-20T19:10:22.406315Z", updatedAt="2026-09-20T19:10:22.406315Z",
    ),
    ClubDto(
      id="4fa465bc-6d46-4e10-ae09-65afd8930e0c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Central Park Tennis Center", address="1 West 96th Street &, Central Prk W, New York, NY 10025",
      city="New York", country="US",
      latitude=40.7898866, longitude=-73.9620658,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/117df29a-bbbf-420f-ae56-b3856d09db86_photo.jpg",
      averageRating=4.3, totalRatingsCount=435,
      createdAt="2026-09-20T19:09:04.540966Z", updatedAt="2026-09-20T19:09:04.540966Z",
    ),
    ClubDto(
      id="fa96e3b3-f9c9-4240-b3ac-9c7c1881866a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Frames Bowling Lounge", address="550 9th Ave, New York, NY 10018",
      city="New York", country="US",
      latitude=40.757116, longitude=-73.99315,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/631c641a-2bae-4dd6-a3b8-9fbc5e2cb29d_photo.jpg",
      averageRating=4.2, totalRatingsCount=3184,
      createdAt="2026-09-20T19:10:07.162056Z", updatedAt="2026-09-20T19:10:07.162056Z",
    ),
    ClubDto(
      id="21d77604-7bec-4a56-a04d-f4b1e2bccc1c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ocean's 8 Billiards", address="308 Flatbush Ave, Brooklyn, NY 11238",
      city="New York", country="US",
      latitude=40.6773994, longitude=-73.9728592,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eadbeb01-24ac-438d-bf1c-c892a2237038_photo.jpg",
      averageRating=4.2, totalRatingsCount=1553,
      createdAt="2026-09-20T19:10:25.735959Z", updatedAt="2026-09-20T19:10:25.735959Z",
    ),
    ClubDto(
      id="6116a614-114c-45e1-9119-ebe88371ddf1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SportsPlex at Metuchen", address="215 Durham Ave, Metuchen, NJ 08840",
      city="New York", country="US",
      latitude=40.5410576, longitude=-74.3710556,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d995d215-511a-4992-954a-1a1df18b9902_photo.jpg",
      averageRating=4.2, totalRatingsCount=759,
      createdAt="2026-09-20T19:09:23.950227Z", updatedAt="2026-09-20T19:09:23.950227Z",
    ),
    ClubDto(
      id="b8402cc2-8776-4745-a096-0b364e56165e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Wang Chen Table Tennis Club", address="250 W 100th St, New York, NY 10025",
      city="New York", country="US",
      latitude=40.7974208, longitude=-73.970798,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3fb4bd29-1af2-450a-8b0c-0f3cb27dc295_photo.jpg",
      averageRating=4.2, totalRatingsCount=82,
      createdAt="2026-09-20T19:09:54.277757Z", updatedAt="2026-09-20T19:09:54.277757Z",
    ),
    ClubDto(
      id="5f3b4e20-4838-41f6-a640-f36206aa9ed0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Haus Williamsburg", address="307 Kent Ave, Brooklyn, NY 11249",
      city="New York", country="US",
      latitude=40.7141104, longitude=-73.9667559,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ea3b5f99-ab02-49c6-aa09-b18e81fba36a_photo.jpg",
      averageRating=4.1, totalRatingsCount=211,
      createdAt="2026-09-20T19:09:11.502096Z", updatedAt="2026-09-20T19:09:11.502096Z",
    ),
    ClubDto(
      id="ba5d04b2-a411-4e7a-91d2-ce1d011ed225", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ZogSports", address="500 7th Ave, New York, NY 10018",
      city="New York", country="US",
      latitude=40.7531386, longitude=-73.9894616,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a5f17de0-9eee-4e92-ab9c-6467f0f747ca_photo.jpg",
      averageRating=4.1, totalRatingsCount=282,
      createdAt="2026-09-20T19:09:34.541107Z", updatedAt="2026-09-20T19:09:34.541107Z",
    ),
    ClubDto(
      id="2259b706-aeb6-4025-be57-d6e5f9ac6d68", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Forest Park Golf Course", address="1-01 Forest Park Dr, Woodhaven, NY 11421",
      city="New York", country="US",
      latitude=40.6971274, longitude=-73.8666398,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1bd9172c-a6a6-4f73-8171-0d9c71dc9685_photo.jpg",
      averageRating=4.0, totalRatingsCount=471,
      createdAt="2026-09-20T19:09:48.112455Z", updatedAt="2026-09-20T19:09:48.112455Z",
    ),
    ClubDto(
      id="187cb8ac-fd36-491a-bd6f-341539296157", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Detective Russel Timoshenko Soccer Field", address="Slater Ave. &, Father Capodanno Blvd, Staten Island, NY 10305",
      city="New York", country="US",
      latitude=40.5755731, longitude=-74.0819625,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/32d29548-c906-4316-9ced-16be4c93e590_photo.jpg",
      averageRating=4.4, totalRatingsCount=43,
      createdAt="2026-09-20T19:10:44.373551Z", updatedAt="2026-09-20T19:10:44.373551Z",
    ),
  )),
  CitySeo(slug="poznan", name="Poznan", country="PL", clubCount=33, sports=listOf(Pair("Football", 5), Pair("Volleyball", 4), Pair("Tennis", 4), Pair("Padel", 3), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Golf", 2), Pair("Karting", 2), Pair("Bowling", 2), Pair("Paintball", 2), Pair("Basketball", 2), Pair("Laser Tag", 2), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="97ba6936-52c5-401f-a0ff-5d25258936bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Spot", address="Termalna 7, 61-028 Poznań",
      city="Poznan", country="PL",
      latitude=52.4087631, longitude=16.9743054,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2242e747-c876-452e-9ab7-05d816986e10_photo.jpg",
      averageRating=4.9, totalRatingsCount=119,
      createdAt="2026-08-31T23:35:15.734260Z", updatedAt="2026-08-31T23:35:15.734260Z",
    ),
    ClubDto(
      id="3366d3a1-5613-4a05-b317-7b670c8d0deb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball laserowy Poznań - Laser Tag Wielka Spluwa", address="Podgórze 28, 60-101 Poznań",
      city="Poznan", country="PL",
      latitude=52.4121869, longitude=16.9335771,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/564740f5-210d-415e-b564-d16ec4caa895_photo.jpg",
      averageRating=4.9, totalRatingsCount=1748,
      createdAt="2026-08-31T23:37:05.387169Z", updatedAt="2026-08-31T23:37:05.387169Z",
    ),
    ClubDto(
      id="8e4303ed-e263-4414-b474-96cbd537e34d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Black Water Links Golf Club", address="Szkolna 21, 62-080 Rumianek",
      city="Poznan", country="PL",
      latitude=52.4687536, longitude=16.6244986,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/78bf444a-3cb4-462c-9b6c-f86ba10b7863_photo.jpg",
      averageRating=4.8, totalRatingsCount=200,
      createdAt="2026-08-31T23:36:04.130632Z", updatedAt="2026-08-31T23:36:04.130632Z",
    ),
    ClubDto(
      id="0a5251e2-9c7c-438a-9e29-b4bb568575dd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Arena Poznań - Paintball laserowy", address="Ul. Obodrzycka - Fort II \"Stülpnagel, 61-249 Poznań",
      city="Poznan", country="PL",
      latitude=52.3725459, longitude=16.9657568,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5315044f-bf87-49d5-87fa-173597aa1d99_photo.jpg",
      averageRating=4.8, totalRatingsCount=146,
      createdAt="2026-08-31T23:37:10.470648Z", updatedAt="2026-08-31T23:37:10.470648Z",
    ),
    ClubDto(
      id="47bddba1-ec47-4ec3-aa56-8024e49442b7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BLOK LINE | Ścianka wspinaczkowa | Zajęcia sportowe dla dzieci i dorosłych | Poznań", address="Bolesława Krzywoustego 72, 61-144 Poznań",
      city="Poznan", country="PL",
      latitude=52.3732793, longitude=16.982334,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f92237e3-a345-4879-b09a-0854c9d1902f_photo.jpg",
      averageRating=4.7, totalRatingsCount=558,
      createdAt="2026-08-31T23:36:51.395740Z", updatedAt="2026-08-31T23:36:51.395740Z",
    ),
    ClubDto(
      id="f7ad272e-bfc1-4f00-8c17-719e6851f9ad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="E1GOKART Poznań - Gokarty Skórzewo", address="Cisowa 6, 60-185 Skórzewo",
      city="Poznan", country="PL",
      latitude=52.3922907, longitude=16.8052951,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/95b59df3-6b46-41a4-9ec7-cb5beba4905f_photo.jpg",
      averageRating=4.7, totalRatingsCount=2752,
      createdAt="2026-08-31T23:36:23.694320Z", updatedAt="2026-08-31T23:36:23.694320Z",
    ),
    ClubDto(
      id="94b97d4d-a615-41e8-82dd-49571503b95d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hala Dydaktyczno-Sportowa AWF", address="61-001 Poznań",
      city="Poznan", country="PL",
      latitude=52.3971005, longitude=16.9320619,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/807fe055-a04b-4290-8199-e8a662dc7657_photo.jpg",
      averageRating=4.7, totalRatingsCount=173,
      createdAt="2026-08-31T23:35:26.096948Z", updatedAt="2026-08-31T23:35:26.096948Z",
    ),
    ClubDto(
      id="6a1e54f8-6e49-4932-9413-47f7ad1ec1ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Interpadel Poznań", address="Wołczyńska 18, 60-003 Poznań",
      city="Poznan", country="PL",
      latitude=52.3720265, longitude=16.8386402,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff17f740-984f-40e3-b89c-4c0d0918d33f_photo.jpg",
      averageRating=4.7, totalRatingsCount=116,
      createdAt="2026-08-31T23:35:21.505589Z", updatedAt="2026-08-31T23:35:21.505589Z",
    ),
    ClubDto(
      id="925ce971-28c7-4125-8490-e1ee7d579d1b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KKS Lech Poznan SA", address="Bułgarska 17, 60-320 Poznań",
      city="Poznan", country="PL",
      latitude=52.3977932, longitude=16.8584766,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06bdae4e-43ca-4853-9d2d-2693233a7ca4_photo.jpg",
      averageRating=4.7, totalRatingsCount=1918,
      createdAt="2026-08-31T23:34:12.987080Z", updatedAt="2026-08-31T23:34:12.987080Z",
    ),
    ClubDto(
      id="b57bee2b-3ded-4c0e-ba13-12887b858349", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klub bilardowy Zakręcona Bila", address="Ratajczaka 20, 61-815 Poznań",
      city="Poznan", country="PL",
      latitude=52.405046, longitude=16.9255341,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9c5a53ce-cd42-44f5-806e-5f4b93b1d405_photo.jpg",
      averageRating=4.7, totalRatingsCount=1498,
      createdAt="2026-08-31T23:36:57.432108Z", updatedAt="2026-08-31T23:36:57.432108Z",
    ),
    ClubDto(
      id="5456c4fc-8cca-4901-b07e-b70c5f43d066", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Korty Rataje POSiR", address="Osiedle Piastowskie 106A, 61-139 Poznań",
      city="Poznan", country="PL",
      latitude=52.382772, longitude=16.937648,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db0fe437-2cb4-4b4c-bc38-939df43cac32_photo.jpg",
      averageRating=4.7, totalRatingsCount=88,
      createdAt="2026-08-31T23:34:55.577741Z", updatedAt="2026-09-01T14:31:43.449976Z",
    ),
    ClubDto(
      id="39c1f1b2-e6dd-48f6-97a4-eb9c4eaa93d5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Korty tenisowe KW04", address="Piastowska 40, 61-556 Poznań",
      city="Poznan", country="PL",
      latitude=52.3960172, longitude=16.937971,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06202836-e664-41a8-b839-40e945f4cbdd_photo.jpg",
      averageRating=4.7, totalRatingsCount=138,
      createdAt="2026-08-31T23:34:50.905310Z", updatedAt="2026-08-31T23:34:50.905310Z",
    ),
    ClubDto(
      id="a5740f02-b325-4c67-9ec7-36b660dce9bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tor Poznań", address="Wyścigowa 3, 62-081 Przeźmierowo",
      city="Poznan", country="PL",
      latitude=52.4200301, longitude=16.8077647,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fa282b96-a6d3-4fdc-9253-d1ce3b4a21ac_photo.jpg",
      averageRating=4.7, totalRatingsCount=5115,
      createdAt="2026-08-31T23:36:18.527502Z", updatedAt="2026-08-31T23:36:18.527502Z",
    ),
    ClubDto(
      id="76b25357-8259-4741-b9c4-b2c344fcd989", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CTS Sobota", address="Poznańska 43/k, 62-090 Sobota",
      city="Poznan", country="PL",
      latitude=52.5205216, longitude=16.8183749,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/81c1b39f-4a0a-49ed-911c-f74e0b0d99fe_photo.jpg",
      averageRating=4.6, totalRatingsCount=85,
      createdAt="2026-08-31T23:34:59.859183Z", updatedAt="2026-08-31T23:34:59.859183Z",
    ),
    ClubDto(
      id="90e06299-14d0-4c09-88f4-44674383f983", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climbing Spot", address="Kazimierza Pułaskiego 30, 61-001 Poznań",
      city="Poznan", country="PL",
      latitude=52.4181162, longitude=16.9244613,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f7c0c860-ec19-407b-bbf7-3934ef78bd9c_photo.jpg",
      averageRating=4.6, totalRatingsCount=588,
      createdAt="2026-08-31T23:36:41.412748Z", updatedAt="2026-08-31T23:36:41.412748Z",
    ),
    ClubDto(
      id="f5547ce9-a4b8-4968-8d81-14b5b8cdf602", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Parks Poland", address="Zygmunta Vogla 19, 02-990 Warszawa",
      city="Poznan", country="PL",
      latitude=52.161649, longitude=21.102008,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7e8563ec-5f60-4b22-8b5f-68a839fa0fa1_photo.jpg",
      averageRating=4.6, totalRatingsCount=182,
      createdAt="2026-08-31T23:36:09.030401Z", updatedAt="2026-08-31T23:36:09.030401Z",
    ),
    ClubDto(
      id="82f77860-c35e-42a0-8c05-aa62524cff85", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Green Paintball Range", address="Krańcowa 91, 61-048 Poznań",
      city="Poznan", country="PL",
      latitude=52.404103, longitude=16.9864252,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd7c72bb-e683-466a-9462-4f19a8c6f846_photo.jpg",
      averageRating=4.6, totalRatingsCount=438,
      createdAt="2026-08-31T23:37:21.703458Z", updatedAt="2026-08-31T23:37:21.703458Z",
    ),
    ClubDto(
      id="fe674e46-7fc4-470a-9947-69415c6d1c69", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sekcja tenisowa AZS Poznań", address="Zygmunta Noskowskiego 25, 61-705 Poznań",
      city="Poznan", country="PL",
      latitude=52.4136068, longitude=16.9170428,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ba41f37-4f7d-4db2-90cf-0780ea9e85de_photo.jpg",
      averageRating=4.6, totalRatingsCount=77,
      createdAt="2026-08-31T23:35:45.392721Z", updatedAt="2026-08-31T23:35:45.392721Z",
    ),
    ClubDto(
      id="6da29f82-65da-4f6b-83c3-398f6a195607", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportowy Reyon", address="Margonińska, 60-425 Poznań",
      city="Poznan", country="PL",
      latitude=52.430198, longitude=16.8385667,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/27e28ea2-b970-4bf7-a72a-b52c9ed689fb_photo.jpg",
      averageRating=4.6, totalRatingsCount=545,
      createdAt="2026-08-31T23:35:07.181807Z", updatedAt="2026-08-31T23:35:07.181807Z",
    ),
    ClubDto(
      id="6dfc1505-ca21-4695-b761-0e9eb6adb627", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="United Paintball", address="Starołęcka 60, 61-361 Poznań",
      city="Poznan", country="PL",
      latitude=52.3668112, longitude=16.9296965,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c29d969c-049c-407e-bcd5-f164d83baf38_photo.jpg",
      averageRating=4.6, totalRatingsCount=877,
      createdAt="2026-08-31T23:37:16.453443Z", updatedAt="2026-08-31T23:37:16.453443Z",
    ),
    ClubDto(
      id="4ab70060-fd47-4042-9aaf-0c8eeaab46df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Youth Sports Centre", address="Gdańska 1, 61-123 Poznań",
      city="Poznan", country="PL",
      latitude=52.4127264, longitude=16.9546594,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/205d5d5e-e548-4e14-95ef-8fa6fbad9ab9_photo.jpg",
      averageRating=4.6, totalRatingsCount=618,
      createdAt="2026-08-31T23:34:22.148401Z", updatedAt="2026-09-01T14:31:54.555374Z",
    ),
    ClubDto(
      id="1964fad2-65e4-4f6a-b41e-93520d55e45e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poznańskie Ośrodki Sportu i Rekreacji - Hala C", address="Jana Spychalskiego 38, 61-553 Poznań",
      city="Poznan", country="PL",
      latitude=52.3936755, longitude=16.9293563,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/87bf5ece-00ae-4e99-94c7-8b0796c6a260_photo.jpg",
      averageRating=4.5, totalRatingsCount=156,
      createdAt="2026-08-31T23:35:36.343943Z", updatedAt="2026-08-31T23:35:36.343943Z",
    ),
    ClubDto(
      id="755edec3-f136-4f41-8ee0-bb0c88d75d4c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Reiss Football Academy", address="Źródlana 19/1, 60-642 Poznań",
      city="Poznan", country="PL",
      latitude=52.4258683, longitude=16.9113693,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e29bee9f-c67c-4ecf-a39f-ddf2a8644624_photo.jpg",
      averageRating=4.5, totalRatingsCount=308,
      createdAt="2026-08-31T23:34:32.536477Z", updatedAt="2026-08-31T23:34:32.536477Z",
    ),
    ClubDto(
      id="624d5040-a572-4e8c-bfae-3e38be4a11cb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportwin Arena Dębiec", address="Łozowa 77, 61-448 Poznań",
      city="Poznan", country="PL",
      latitude=52.3664211, longitude=16.9107597,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/691f9f87-84c8-42a9-8a5d-ca60fa1e7193_photo.jpg",
      averageRating=4.5, totalRatingsCount=399,
      createdAt="2026-08-31T23:34:26.922960Z", updatedAt="2026-08-31T23:34:26.922960Z",
    ),
    ClubDto(
      id="7368447d-bc94-4825-ba1a-c316e920ce9e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stadion Lekkoatletyczny POSiR Golęcin", address="Warmińska 1, 60-622 Poznań",
      city="Poznan", country="PL",
      latitude=52.4254001, longitude=16.8903021,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cccd126a-d503-46f2-98bd-8b75ea3fde51_photo.jpg",
      averageRating=4.5, totalRatingsCount=1386,
      createdAt="2026-08-31T23:34:17.400246Z", updatedAt="2026-08-31T23:34:17.400246Z",
    ),
    ClubDto(
      id="d9ed2b57-7f50-49e3-9098-87440c4051ce", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Strefa Sportu Tenis & Fitness", address="Osiedle Edwarda Raczyńskiego 3/50, 62-020 Swarzędz",
      city="Poznan", country="PL",
      latitude=52.3984329, longitude=17.0591107,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/468c4148-8acc-47fa-aec1-b6002d0b4370_photo.jpg",
      averageRating=4.5, totalRatingsCount=336,
      createdAt="2026-08-31T23:34:40.990452Z", updatedAt="2026-08-31T23:34:40.990452Z",
    ),
    ClubDto(
      id="466c4816-7d41-47e9-b2d9-cef992aad94d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Black Ball Pool Club", address="Wielka 21, 61-775 Poznań",
      city="Poznan", country="PL",
      latitude=52.408529, longitude=16.9367255,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0ba350de-12dd-409e-8fc3-7ebfdee00c6f_photo.jpg",
      averageRating=4.3, totalRatingsCount=1176,
      createdAt="2026-08-31T23:37:01.201596Z", updatedAt="2026-08-31T23:37:01.201596Z",
    ),
    ClubDto(
      id="4caeb588-9ef2-4966-aa1c-63a9fd4444a0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gravitacja", address="Bukowska 156, 60-198 Poznań",
      city="Poznan", country="PL",
      latitude=52.410802, longitude=16.8635322,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/050ea8b3-c7df-47d8-bbe2-a4178a5670b5_photo.jpg",
      averageRating=4.3, totalRatingsCount=2279,
      createdAt="2026-08-31T23:36:33.048990Z", updatedAt="2026-08-31T23:36:33.048990Z",
    ),
    ClubDto(
      id="8b51fc83-4e99-451c-9a91-f5be1387eadc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MK Bowling Poznań", address="Święty Marcin 24, 61-805 Poznań",
      city="Poznan", country="PL",
      latitude=52.4066153, longitude=16.9279736,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/093e54e4-8f44-489d-a811-f68507feac63_photo.jpg",
      averageRating=4.2, totalRatingsCount=4114,
      createdAt="2026-08-31T23:36:28.210461Z", updatedAt="2026-08-31T23:36:28.210461Z",
    ),
    ClubDto(
      id="af9fc254-32ca-45eb-b64f-d43ef066dfdd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poznańska Akademia Siatkówki Teszner", address="Juliusza Słowackiego 54, 60-538 Poznań",
      city="Poznan", country="PL",
      latitude=52.4117365, longitude=16.9026618,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5eaae4f1-c24f-4bad-88b7-7ed185efbee9_photo.jpg",
      averageRating=4.2, totalRatingsCount=47,
      createdAt="2026-08-31T23:35:51.021604Z", updatedAt="2026-08-31T23:35:51.021604Z",
    ),
    ClubDto(
      id="3d6a39a4-f4e8-457d-ba9e-ac36e37ca0c0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TKKF Poznań Ściana tenisowa", address="Księcia Mieszka I 664, 61-001 Poznań",
      city="Poznan", country="PL",
      latitude=52.4249311, longitude=16.9205453,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0659f27b-64af-471b-b3aa-88562449575f_photo.jpg",
      averageRating=3.9, totalRatingsCount=61,
      createdAt="2026-08-31T23:35:31.244992Z", updatedAt="2026-08-31T23:35:31.244992Z",
    ),
    ClubDto(
      id="9093efe1-b095-4d25-a97a-91b9e0c8d1ea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ping-Pong, Tenis Stołowy PingPong24.pl", address="Słowiańska 55A, 61-655 Poznań",
      city="Poznan", country="PL",
      latitude=52.4311892, longitude=16.9348972,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f5cbec90-a75b-45f4-b226-7d506a762a83_photo.jpg",
      averageRating=4.6, totalRatingsCount=33,
      createdAt="2026-08-31T23:36:13.467283Z", updatedAt="2026-08-31T23:36:13.467283Z",
    ),
    ClubDto(
      id="2d5cabcb-e852-42e1-9320-a64ab74a7b23", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Arena", address="Stanisława Wyspiańskiego 27, 60-751 Poznań",
      city="Poznan", country="PL",
      latitude=52.3987328, longitude=16.8935323,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1f1f28f7-016e-41af-bf84-e790a76b3af1_photo.jpg",
      averageRating=4.7, totalRatingsCount=23,
      createdAt="2026-08-31T23:35:57.794203Z", updatedAt="2026-08-31T23:35:57.794203Z",
    ),
  )),
  CitySeo(slug="prague", name="Prague", country="CZ", clubCount=32, sports=listOf(Pair("Football", 4), Pair("Volleyball", 4), Pair("Basketball", 3), Pair("Tennis", 3), Pair("Padel", 3), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Karting", 2), Pair("Golf", 2), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Paintball", 2), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="678cea78-15b4-4376-bd8b-d384f835252c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="RANGER PRAGUE Shooting Range", address="Lublaňská 1729/23, Nové Město, 120 00 Praha-Praha 2",
      city="Prague", country="CZ",
      latitude=50.0714782, longitude=14.4319076,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/87c24048-d1d4-4376-a001-f1221aefa449_ChIJz3Dn616T_1.jpg",
      averageRating=4.9, totalRatingsCount=5263,
      createdAt="2026-08-30T23:19:41.336404Z", updatedAt="2026-08-31T22:11:21.018549Z",
    ),
    ClubDto(
      id="6af57bcb-9c5d-45ff-a6ca-1ba31e81a572", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Praha (Paintball Prague ®)", address="Výpadová 157, 159 00 Praha-Praha 16",
      city="Prague", country="CZ",
      latitude=49.9951577, longitude=14.3939638,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/57cd24e4-9b9c-47cf-8e08-a0ec993497ba_ChIJr4Aj4FyX_0.jpg",
      averageRating=4.8, totalRatingsCount=959,
      createdAt="2026-08-30T23:19:48.439543Z", updatedAt="2026-08-31T08:34:24.817371Z",
    ),
    ClubDto(
      id="a5346a42-f5d6-49ee-b0fc-dc09531aaf96", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SK Slavia Praha PADEL", address="Pod Altánem 18, 100 00 Praha 10-Vršovice",
      city="Prague", country="CZ",
      latitude=50.0667584, longitude=14.4810284,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8eea289a-2050-4eab-aa4e-31db9cb73698_ChIJm_-J7u-T_0.jpg",
      averageRating=4.8, totalRatingsCount=50,
      createdAt="2026-08-30T23:20:03.810045Z", updatedAt="2026-08-31T08:35:34.955642Z",
    ),
    ClubDto(
      id="d7d34a84-fa9a-4c97-a1fd-a7dd0c4479d3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Action Park", address="Výpadová 157, Lahovice, 159 00 Praha-Zbraslav",
      city="Prague", country="CZ",
      latitude=49.9945524, longitude=14.3956349,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2538cde0-4e0c-4837-bbb0-4e0c199d812c_ChIJWSIH-9mW_1.jpg",
      averageRating=4.7, totalRatingsCount=945,
      createdAt="2026-08-30T23:18:14.245233Z", updatedAt="2026-08-31T22:11:12.972293Z",
    ),
    ClubDto(
      id="a4549b61-e56a-4a06-8b38-b131f5106f3e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lezecké centrum smíchOFF", address="Křížová 6, 150 00 Praha 5-Smíchov",
      city="Prague", country="CZ",
      latitude=50.0550508, longitude=14.4066703,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7ecb2f3-6e78-400d-9294-e6ec6e637b6b_ChIJDXiq1ECU_0.jpg",
      averageRating=4.7, totalRatingsCount=4394,
      createdAt="2026-08-30T23:19:00.705031Z", updatedAt="2026-08-31T08:32:31.719175Z",
    ),
    ClubDto(
      id="3a2edff0-a268-4820-b422-9206db1d470f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mercuria Laser Game Holešovice", address="2c, Jankovcova 1569, 170 00 Praha 7-Holešovice",
      city="Prague", country="CZ",
      latitude=50.1023198, longitude=14.4565476,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f7456bdc-043a-4f06-bfc4-94d4a2575490_ChIJizr6MbWU_0.jpg",
      averageRating=4.7, totalRatingsCount=1610,
      createdAt="2026-08-30T23:19:34.247809Z", updatedAt="2026-08-31T08:32:51.309828Z",
    ),
    ClubDto(
      id="43850e94-6824-45f8-8c86-61d09c4c7e50", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Powers Smíchov", address="Křížová 6, 150 00 Praha 5-Smíchov",
      city="Prague", country="CZ",
      latitude=50.0542613, longitude=14.4062312,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/14b2c0fe-f5c4-4a7d-8334-1f8ed00a46d6_ChIJ0XuYW2SV_0.jpg",
      averageRating=4.7, totalRatingsCount=155,
      createdAt="2026-08-30T23:19:55.939153Z", updatedAt="2026-08-31T08:33:58.236482Z",
    ),
    ClubDto(
      id="7879d47a-dad0-48a3-9210-a6bb7a55b0a1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Prague Beach Team", address="Sibeliova 368/51, 162 00 Praha 6-Střešovice",
      city="Prague", country="CZ",
      latitude=50.0907673, longitude=14.3749462,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3564de37-56ad-46eb-bf47-82ea98ec51fb_photo.jpg",
      averageRating=4.7, totalRatingsCount=138,
      createdAt="2026-08-31T14:56:32.803170Z", updatedAt="2026-08-31T14:56:32.803170Z",
    ),
    ClubDto(
      id="6fc01387-89ac-4fd9-a884-d02a0b07e0fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachklub Pankrác", address="Bartákova, 140 00 Praha 4",
      city="Prague", country="CZ",
      latitude=50.0469416, longitude=14.4377798,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/58ff5952-c2cf-47c1-bda8-f70504e72f38_photo.jpg",
      averageRating=4.6, totalRatingsCount=346,
      createdAt="2026-08-31T14:56:26.114903Z", updatedAt="2026-08-31T14:56:26.114903Z",
    ),
    ClubDto(
      id="6c3e02b5-94d5-4f8a-845d-836ef841e3ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dopravní hřiště Glowackého", address="Glowackého 555/6, 181 00 Praha 8",
      city="Prague", country="CZ",
      latitude=50.1279022, longitude=14.4303933,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/253de679-9ea2-4f06-82eb-e9e4bda9e3e3_ChIJzZRf7yPr_2.jpg",
      averageRating=4.6, totalRatingsCount=485,
      createdAt="2026-08-30T23:18:28.397842Z", updatedAt="2026-08-31T22:11:15.511534Z",
    ),
    ClubDto(
      id="4cc9ae6e-9645-4d8b-ad53-39a0f0907426", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CMKarting", address="Ringhofferova 115/1, Třebonice, 155 21 Praha-Zličín",
      city="Prague", country="CZ",
      latitude=50.0589319, longitude=14.2947223,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a9e36f59-8bc4-4ad2-b4e6-4d1133d9e682_ChIJ0QKSgnK-_0.jpg",
      averageRating=4.5, totalRatingsCount=3758,
      createdAt="2026-08-30T23:19:13.924371Z", updatedAt="2026-08-30T23:19:13.924371Z",
    ),
    ClubDto(
      id="7c250706-9d3d-4976-b3af-d52286f0cd00", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="I. ČLTK Praha", address="ostrov Štvanice 38, 170 00 Praha 7-Holešovice",
      city="Prague", country="CZ",
      latitude=50.0958366, longitude=14.4402542,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/171d54a4-fba0-4f6d-b8fe-543bb3a5a93e_ChIJRVQT27iU_0.jpg",
      averageRating=4.5, totalRatingsCount=277,
      createdAt="2026-08-30T23:20:22.965453Z", updatedAt="2026-08-31T08:31:00.469128Z",
    ),
    ClubDto(
      id="8d08bebe-41e5-47c7-afcb-dc4e1de79d65", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Jeremi Sport - Beach volejbal", address="64A, Ovčí hájek 2174, 158 00 Praha 13-Stodůlky",
      city="Prague", country="CZ",
      latitude=50.047615, longitude=14.3487977,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7c5d33a8-ce1b-465b-8bcb-df458b2dec81_photo.jpg",
      averageRating=4.5, totalRatingsCount=110,
      createdAt="2026-08-31T14:56:16.383479Z", updatedAt="2026-08-31T14:56:16.383479Z",
    ),
    ClubDto(
      id="581ee28b-de8c-4056-b951-2c93b579d0ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Prague Golf & Games", address="Michalská 432/12, 110 00 Praha 1-Staré Město",
      city="Prague", country="CZ",
      latitude=50.0850663, longitude=14.4200703,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/364e859c-7826-425f-8aae-444a27c5b336_ChIJFQWDjvGU_0.jpg",
      averageRating=4.5, totalRatingsCount=3782,
      createdAt="2026-08-30T23:19:27.599345Z", updatedAt="2026-08-30T23:19:27.599345Z",
    ),
    ClubDto(
      id="103e0a68-5c44-4977-9f54-918d72599baa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportcentrum Step", address="6, Malletova 2350, 190 00 Praha-Praha 9",
      city="Prague", country="CZ",
      latitude=50.1012649, longitude=14.4835316,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f29a12b-caae-4d52-80ee-0ed94c8016c6_photo.jpg",
      averageRating=4.5, totalRatingsCount=912,
      createdAt="2026-08-31T14:56:02.535676Z", updatedAt="2026-08-31T14:56:02.535676Z",
    ),
    ClubDto(
      id="0aa77f87-0d03-4b5b-abab-f209a2a75a34", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportovní areál HAMR - Braník", address="Vltavanů 1542, 147 00 Praha 4-Hodkovičky",
      city="Prague", country="CZ",
      latitude=50.0277861, longitude=14.4023839,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b5630328-9089-4d1a-9eec-1b0d16c4ea3f_ChIJsYXWrqGW_0.jpg",
      averageRating=4.5, totalRatingsCount=896,
      createdAt="2026-08-30T23:18:21.426910Z", updatedAt="2026-09-01T14:32:01.085564Z",
    ),
    ClubDto(
      id="75415673-5316-4246-9a26-3be85a7800c0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportovní areál HAMR-Záběhlice", address="K vodě 3200/6, 106 00 Praha 10-Záběhlice",
      city="Prague", country="CZ",
      latitude=50.0531517, longitude=14.4861082,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3cc55f7d-6db7-474c-b851-2b9d0dbf5ccf_ChIJa8zYUa6T_0.jpg",
      averageRating=4.5, totalRatingsCount=1312,
      createdAt="2026-08-30T23:18:07.610707Z", updatedAt="2026-09-01T14:32:01.207427Z",
    ),
    ClubDto(
      id="45a310a2-ab16-4b9c-a7d7-a7e806cea408", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="USK Praha Basketball", address="2, Na Folimance 2490, Vinohrady, 120 00 Praha-Praha 2",
      city="Prague", country="CZ",
      latitude=50.0668651, longitude=14.4320234,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bf0cd206-4d71-4211-b852-71696b568118_photo.jpg",
      averageRating=4.5, totalRatingsCount=193,
      createdAt="2026-08-31T14:56:08.634054Z", updatedAt="2026-08-31T14:56:08.634054Z",
    ),
    ClubDto(
      id="d50675f4-8a4e-4751-b6e6-998fc58b28fe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Driving range Rohan Island", address="U Libeňského mostu 1, 180 00 Praha 8-Rohanský ostrov",
      city="Prague", country="CZ",
      latitude=50.1016504, longitude=14.4620965,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5f2b1312-c051-4d12-b228-328d8af116ee_photo.jpg",
      averageRating=4.4, totalRatingsCount=300,
      createdAt="2026-08-31T14:57:12.204106Z", updatedAt="2026-08-31T22:11:15.613372Z",
    ),
    ClubDto(
      id="793cfa00-bcc6-4962-9097-e84db8fba421", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Prague City Golf - Zbraslav", address="Oddechová 886, 155 00 Praha-Lipence",
      city="Prague", country="CZ",
      latitude=49.9602814, longitude=14.3499936,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/64cfe6a4-5baf-4d37-a668-d8d7371f41a4_photo.jpg",
      averageRating=4.4, totalRatingsCount=454,
      createdAt="2026-08-31T14:57:17.635452Z", updatedAt="2026-08-31T14:57:17.635452Z",
    ),
    ClubDto(
      id="7c07358b-d67d-4182-8758-7797f2c847b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportovní areál Beachklub Ládví", address="Žernosecká 1895/2, 182 00 Praha 8",
      city="Prague", country="CZ",
      latitude=50.1333151, longitude=14.4725722,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/773662cb-cd9a-4871-a370-cd25ee00c5ea_photo.jpg",
      averageRating=4.4, totalRatingsCount=813,
      createdAt="2026-08-31T14:57:05.268184Z", updatedAt="2026-08-31T14:57:05.268184Z",
    ),
    ClubDto(
      id="abcab903-5873-4d7a-8561-28ac5abe234f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TK Sparta Praha", address="Za Císařským mlýnem 1115/2, 170 00 Praha 7-Bubeneč",
      city="Prague", country="CZ",
      latitude=50.1103663, longitude=14.4092463,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dadecb35-8288-4eaa-9e7b-a65420d8f109_ChIJ_yy3NSqV_0.jpg",
      averageRating=4.4, totalRatingsCount=474,
      createdAt="2026-08-30T23:20:16.685970Z", updatedAt="2026-08-31T08:37:16.449620Z",
    ),
    ClubDto(
      id="02f789da-e681-4fe0-bac5-7c580536618d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billiard club - Řipská", address="Řipská 547/24, Vinohrady, 130 00 Praha-Praha 3",
      city="Prague", country="CZ",
      latitude=50.0767113, longitude=14.4525816,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84c517fa-1b34-483c-a438-2cb8f7b30b5b_ChIJAa2Is4KU_0.jpg",
      averageRating=4.3, totalRatingsCount=1142,
      createdAt="2026-08-30T23:18:41.491380Z", updatedAt="2026-08-30T23:18:41.491380Z",
    ),
    ClubDto(
      id="2d8386dd-b59d-4d51-8fd5-e7bddc6ca8ba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Celnice", address="Millennium Plaza, V Celnici 10, 110 00 Praha 1-Nové Město",
      city="Prague", country="CZ",
      latitude=50.088284, longitude=14.4321946,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ba6455c-0d7b-4fb9-9a7d-1fbfaa9be90b_ChIJ18FrPJWU_0.jpg",
      averageRating=4.3, totalRatingsCount=1504,
      createdAt="2026-08-30T23:18:47.588511Z", updatedAt="2026-08-30T23:18:47.588511Z",
    ),
    ClubDto(
      id="d01486b4-22d6-40a5-80fb-58678425e7ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Harlequin Praha", address="101 00 Praha-Praha 10, Česko",
      city="Prague", country="CZ",
      latitude=50.0656476, longitude=14.457537,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1a928e67-d912-42d8-b6b7-fc63643db87b_ChIJ7xEfC4KT_0.jpg",
      averageRating=4.3, totalRatingsCount=1720,
      createdAt="2026-08-30T23:18:35.729900Z", updatedAt="2026-08-30T23:18:35.729900Z",
    ),
    ClubDto(
      id="e4b5f338-f120-43d1-8798-0301cb6140d8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kart-Centrum Radotín", address="Výpadová 1335, 150 00 Praha 16",
      city="Prague", country="CZ",
      latitude=49.9892106, longitude=14.3758384,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8d1af49b-d14c-42ea-b7bc-959183475730_ChIJ94cGvwCV_0.jpg",
      averageRating=4.3, totalRatingsCount=3073,
      createdAt="2026-08-30T23:19:20.886279Z", updatedAt="2026-08-31T08:31:09.767666Z",
    ),
    ClubDto(
      id="91343453-d970-4a0f-a97d-173849c56e3d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LOKAL BLOK", address="nám. 14. října 2173/10, 150 00 Praha 5-Smíchov",
      city="Prague", country="CZ",
      latitude=50.0730379, longitude=14.4049752,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d71c33e-9915-45e0-a70c-c282dbde162c_ChIJCbAOe_iU_0.jpg",
      averageRating=4.3, totalRatingsCount=2308,
      createdAt="2026-08-30T23:19:08.070675Z", updatedAt="2026-08-31T08:31:51.932215Z",
    ),
    ClubDto(
      id="5a0149f1-bcf0-481b-81b9-1a66e5a27132", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Garage Billiard & Bowling Smíchov - Praha 5", address="407, Na Bělidle 25, Smíchov, 150 00 Praha-Praha 5",
      city="Prague", country="CZ",
      latitude=50.0715693, longitude=14.4059504,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4901d8b6-5206-4a0d-a4fb-526de8b5eeb5_ChIJQa4iAPOV_0.jpg",
      averageRating=4.2, totalRatingsCount=1386,
      createdAt="2026-08-30T23:18:54.029669Z", updatedAt="2026-08-30T23:18:54.029669Z",
    ),
    ClubDto(
      id="671508dd-2e31-4ba8-bc29-b64a59e8150d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportcentrum Radlice", address="Kutvirtova 1, 150 00 Praha 5",
      city="Prague", country="CZ",
      latitude=50.0573546, longitude=14.3934363,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1c9beb0b-fb7c-4e4b-afa4-a7aa8566e58d_ChIJDSvCWUmU_0.jpg",
      averageRating=4.2, totalRatingsCount=204,
      createdAt="2026-08-30T23:20:30.238875Z", updatedAt="2026-08-31T08:36:27.338617Z",
    ),
    ClubDto(
      id="a8843f8f-954b-48f7-9d78-097373154192", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AC Sparta Praha - table tennis", address="27, Kovanecká 2405, 190 00 Praha 9-Libeň",
      city="Prague", country="CZ",
      latitude=50.1085673, longitude=14.4872746,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/63009e35-cfef-4667-bc09-c7b81e661eee_photo.jpg",
      averageRating=4.3, totalRatingsCount=45,
      createdAt="2026-08-31T14:57:24.800131Z", updatedAt="2026-08-31T14:57:24.800131Z",
    ),
    ClubDto(
      id="e08d72ba-4016-4768-97f0-c0c07ac487ba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketball court", address="16, Rybalkova 59, Vinohrady, 120 00 Praha-Praha 2",
      city="Prague", country="CZ",
      latitude=50.0706245, longitude=14.4441549,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/48037bf5-b28a-4458-ab00-cf79b5e04614_photo.jpg",
      averageRating=4.4, totalRatingsCount=29,
      createdAt="2026-08-31T14:55:46.887651Z", updatedAt="2026-08-31T14:55:46.887651Z",
    ),
    ClubDto(
      id="b9d77347-4c27-49df-be34-3442a8c52879", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Džus", address="U Továren 999/31, 102 00 Praha 15-Hostivař",
      city="Prague", country="CZ",
      latitude=50.0575942, longitude=14.5457621,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/15bb53a8-0e6e-4a47-803e-0af966d095ca_ChIJR3-OUgCT_0.jpg",
      averageRating=4.8, totalRatingsCount=25,
      createdAt="2026-08-30T23:20:10.361101Z", updatedAt="2026-09-01T14:31:55.370937Z",
    ),
  )),
  CitySeo(slug="miami", name="Miami", country="US", clubCount=32, sports=listOf(Pair("Football", 7), Pair("Volleyball", 5), Pair("Tennis", 3), Pair("Padel", 3), Pair("Basketball", 2), Pair("Bowling", 2), Pair("Table Tennis", 2), Pair("Climbing", 2), Pair("Karting", 2), Pair("Golf", 2), Pair("Paintball", 1), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="280981cc-30ec-4a6a-b632-8c71f95e312b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Volleyball Academy Miami", address="801 Ocean Dr, Miami Beach, FL 33139",
      city="Miami", country="US",
      latitude=25.7778815, longitude=-80.1308468,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cf7cec84-fda7-44ac-b80e-3de1d530189b_photo.jpg",
      averageRating=5.0, totalRatingsCount=139,
      createdAt="2026-09-20T19:14:32.962080Z", updatedAt="2026-09-20T19:14:32.962080Z",
    ),
    ClubDto(
      id="d8314f5e-216a-44a7-846e-3e46b25377d3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ADAPT", address="14901 NE 20th Ave, North Miami, FL 33181",
      city="Miami", country="US",
      latitude=25.9134889, longitude=-80.1589014,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/419827bd-4a0f-4298-81bf-69990341ef64_photo.jpg",
      averageRating=4.9, totalRatingsCount=478,
      createdAt="2026-09-20T19:14:23.891574Z", updatedAt="2026-09-20T19:14:23.891574Z",
    ),
    ClubDto(
      id="5c475055-460f-4824-97f1-620c74b1ab4d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Broward Table Tennis Club", address="2850 Greene St., Hollywood, FL 33020",
      city="Miami", country="US",
      latitude=26.0390701, longitude=-80.1646575,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d84bf6ab-b863-4316-92bf-bacdaf760771_photo.jpg",
      averageRating=4.9, totalRatingsCount=231,
      createdAt="2026-09-20T19:14:53.297936Z", updatedAt="2026-09-20T19:14:53.297936Z",
    ),
    ClubDto(
      id="1ab9b639-a65a-4982-ad14-2d0000c049b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Game Point Miami", address="8081 W 28th Ave, Hialeah, FL 33016",
      city="Miami", country="US",
      latitude=25.8954245, longitude=-80.3389786,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/790b7bbd-2e3a-4751-818f-dfcff4fc831e_photo.jpg",
      averageRating=4.9, totalRatingsCount=172,
      createdAt="2026-09-20T19:14:26.799353Z", updatedAt="2026-09-20T19:14:26.799353Z",
    ),
    ClubDto(
      id="4a78303c-312d-4397-8479-fb4de6d58dac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rent A Field - Indoor Soccer", address="16601 NE 15th Ave, North Miami Beach, FL 33162",
      city="Miami", country="US",
      latitude=25.928734, longitude=-80.169015,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/baf33119-6f59-489a-b729-667004e4b3fe_photo.jpg",
      averageRating=4.9, totalRatingsCount=224,
      createdAt="2026-09-20T19:27:17.072432Z", updatedAt="2026-09-20T19:27:17.072432Z",
    ),
    ClubDto(
      id="feb45bd4-a8fb-4eaf-abce-5319be8b565a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Soccer 5 Miami – Tropical Park", address="7900 SW 40th St, Miami, FL 33155",
      city="Miami", country="US",
      latitude=25.729872, longitude=-80.324274,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2db10191-4727-4435-b05a-4bf6c3e57bb6_photo.jpg",
      averageRating=4.9, totalRatingsCount=320,
      createdAt="2026-09-20T19:27:13.769951Z", updatedAt="2026-09-20T19:27:13.769951Z",
    ),
    ClubDto(
      id="0efc29e1-48dd-4bd1-be6c-8450ec4e7698", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ultra Padel Club", address="400 NE 67th St, Miami, FL 33138",
      city="Miami", country="US",
      latitude=25.8356988, longitude=-80.1884721,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ce494538-953d-4f46-b972-3bcc99e87335_photo.jpg",
      averageRating=4.9, totalRatingsCount=876,
      createdAt="2026-09-20T19:14:12.380513Z", updatedAt="2026-09-20T19:14:12.380513Z",
    ),
    ClubDto(
      id="09779454-40ef-45ac-a718-6e78af67c1f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Velocity Climbing", address="2280 NW 41st St, Miami, FL 33142",
      city="Miami", country="US",
      latitude=25.8125366, longitude=-80.2335518,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/651ff013-cb4c-4788-beb1-d856dda7b492_photo.jpg",
      averageRating=4.9, totalRatingsCount=1079,
      createdAt="2026-09-20T19:27:04.931462Z", updatedAt="2026-09-20T19:27:04.931462Z",
    ),
    ClubDto(
      id="ed2a1725-0781-442c-9049-dc84993b46fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gymage Miami", address="1651 Washington Ave 2nd Floor, Miami Beach, FL 33139",
      city="Miami", country="US",
      latitude=25.7910303, longitude=-80.1316842,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b70f5158-a21e-4fa1-9aba-5659fb2f8683_photo.jpg",
      averageRating=4.8, totalRatingsCount=1221,
      createdAt="2026-09-20T19:27:01.964894Z", updatedAt="2026-09-20T19:27:01.964894Z",
    ),
    ClubDto(
      id="287de264-4942-45c9-9b24-62cbd1f1eb06", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Salvadore Park Tennis Center", address="1120 Andalusia Ave, Coral Gables, FL 33134",
      city="Miami", country="US",
      latitude=25.7472207, longitude=-80.277952,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dbd765af-0579-4cb0-a418-610a1a01e9b3_photo.jpg",
      averageRating=4.8, totalRatingsCount=900,
      createdAt="2026-09-20T19:14:03.362546Z", updatedAt="2026-09-20T19:14:03.362546Z",
    ),
    ClubDto(
      id="4b9edf16-f6fd-4d96-acc5-2796ae177b1c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Flamingo Park Tennis Center", address="11th St &, Jefferson Ave, Miami Beach, FL 33139",
      city="Miami", country="US",
      latitude=25.782605, longitude=-80.137285,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9a9eb45c-1d4a-4211-99e3-9045c0778231_photo.jpg",
      averageRating=4.7, totalRatingsCount=216,
      createdAt="2026-09-20T19:14:06.044837Z", updatedAt="2026-09-20T19:14:06.044837Z",
    ),
    ClubDto(
      id="80731a40-13e1-4cd4-bf27-d94fcd52c0ce", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Homestead-Miami Speedway", address="One Ralph Sanchez, Speedway Blvd, Homestead, FL 33035",
      city="Miami", country="US",
      latitude=25.4532846, longitude=-80.4093054,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/41da6fe1-befb-4ce8-adb4-e24e0c34ed48_photo.jpg",
      averageRating=4.7, totalRatingsCount=3493,
      createdAt="2026-09-20T19:15:01.710583Z", updatedAt="2026-09-20T19:15:01.710583Z",
    ),
    ClubDto(
      id="1c467588-6d21-4e0a-8888-d5ad1a8b0906", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kaseya Center", address="601 Biscayne Blvd, Miami, FL 33132",
      city="Miami", country="US",
      latitude=25.7814014, longitude=-80.186969,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4748eb84-63c4-4889-ac75-222c59bd703c_photo.jpg",
      averageRating=4.7, totalRatingsCount=23548,
      createdAt="2026-09-20T19:27:07.587498Z", updatedAt="2026-09-20T19:27:07.587498Z",
    ),
    ClubDto(
      id="8835ccd4-042d-4a4f-ab4d-7e5371299466", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Crandon Park Tennis Center", address="7300 Crandon Blvd, Key Biscayne, FL 33149",
      city="Miami", country="US",
      latitude=25.7083248, longitude=-80.1591495,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5bd7d0bf-bb6c-48a5-8c96-1fd4afb2162d_photo.jpg",
      averageRating=4.6, totalRatingsCount=211,
      createdAt="2026-09-20T19:14:09.790459Z", updatedAt="2026-09-20T19:14:09.790459Z",
    ),
    ClubDto(
      id="2c420e99-efe2-47f3-968f-c9c4102ca202", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Doral Soccerland Park", address="8111 NW 54th St, Doral, FL 33166",
      city="Miami", country="US",
      latitude=25.8229026, longitude=-80.3286056,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc021072-98e5-4889-862d-00eaac056e1a_photo.jpg",
      averageRating=4.6, totalRatingsCount=450,
      createdAt="2026-09-20T19:14:00.083247Z", updatedAt="2026-09-20T19:14:00.083247Z",
    ),
    ClubDto(
      id="7ba27327-5969-478e-ae6f-1bdda426d38a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Family Paintball Center", address="220 NW 137th Ave, Miami, FL 33182",
      city="Miami", country="US",
      latitude=25.7701149, longitude=-80.4175777,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/03107589-0788-483f-93c3-4e0ad3ef8560_photo.jpg",
      averageRating=4.6, totalRatingsCount=1030,
      createdAt="2026-09-20T19:27:10.649172Z", updatedAt="2026-09-20T19:27:10.649172Z",
    ),
    ClubDto(
      id="f7c56478-9367-41fa-bb8e-906fea98f172", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kendall Soccer Park", address="8011 SW 127th Ave, Miami, FL 33183",
      city="Miami", country="US",
      latitude=25.6925433, longitude=-80.3999609,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/17353389-8fb4-44fc-ac1e-c345160c6be8_photo.jpg",
      averageRating=4.6, totalRatingsCount=1346,
      createdAt="2026-09-20T19:13:42.762957Z", updatedAt="2026-09-20T19:13:42.762957Z",
    ),
    ClubDto(
      id="6c8ca22f-0ec2-4033-ad6a-3d1965210797", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Miami Sports Box/ Miami United", address="3508 NW 114th Ave, Doral, FL 33178",
      city="Miami", country="US",
      latitude=25.8063149, longitude=-80.3821322,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e6e28d6c-9c6e-4703-853e-7322ce44b1c0_photo.jpg",
      averageRating=4.6, totalRatingsCount=164,
      createdAt="2026-09-20T19:14:29.881023Z", updatedAt="2026-09-20T19:14:29.881023Z",
    ),
    ClubDto(
      id="20f27846-7b82-415d-a6ec-5546b19079e5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADEL LIFE & SOCCER", address="1000 W Pembroke Rd, Hallandale Beach, FL 33009",
      city="Miami", country="US",
      latitude=25.995919, longitude=-80.1638748,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/72774afa-9d3e-4499-a7cc-79c55749faae_photo.jpg",
      averageRating=4.6, totalRatingsCount=185,
      createdAt="2026-09-20T19:14:16.485732Z", updatedAt="2026-09-20T19:14:16.485732Z",
    ),
    ClubDto(
      id="dc1a1eca-f191-4283-b6a0-0755f0e57cb1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stadio Soccer", address="571 NW 73rd St, Miami, FL 33150",
      city="Miami", country="US",
      latitude=25.8423011, longitude=-80.206612,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2d23f3f1-850b-44ee-9f24-5b805c302d6c_photo.jpg",
      averageRating=4.6, totalRatingsCount=780,
      createdAt="2026-09-20T19:13:45.976264Z", updatedAt="2026-09-20T19:13:45.976264Z",
    ),
    ClubDto(
      id="fc810a44-36cf-4832-90ec-af9afca40904", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Revo Soccer", address="10395 NW 41st St #101, Doral, FL 33178",
      city="Miami", country="US",
      latitude=25.8131155, longitude=-80.365739,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/071cfed9-397b-49db-9f77-90be65d0498c_photo.jpg",
      averageRating=4.5, totalRatingsCount=608,
      createdAt="2026-09-20T19:13:48.972288Z", updatedAt="2026-09-20T19:13:48.972288Z",
    ),
    ClubDto(
      id="f99cfabe-6f82-4458-851c-3ea8565b768e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Soccer City Miami", address="2400 NW 110th Ave, Miami, FL 33172",
      city="Miami", country="US",
      latitude=25.7959847, longitude=-80.3748453,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1953ee9d-5194-4f35-b73f-bc483be30ad8_photo.jpg",
      averageRating=4.5, totalRatingsCount=463,
      createdAt="2026-09-20T19:13:55.372739Z", updatedAt="2026-09-20T19:13:55.372739Z",
    ),
    ClubDto(
      id="80b0cbde-e934-42d9-a89b-f4c6a5468c01", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bird Bowl Bowling Center", address="9275 SW 40th St, Miami, FL 33165",
      city="Miami", country="US",
      latitude=25.7333521, longitude=-80.3457662,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eee9385e-ea3c-4284-a912-1efcbf46faa9_photo.jpg",
      averageRating=4.4, totalRatingsCount=3984,
      createdAt="2026-09-20T19:15:07.612028Z", updatedAt="2026-09-20T19:15:07.612028Z",
    ),
    ClubDto(
      id="c8e42e56-400f-4b81-b6e3-5aac19623e8f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Miami Shores Country Club", address="10000 Biscayne Blvd, Miami Shores, FL 33138",
      city="Miami", country="US",
      latitude=25.8681778, longitude=-80.1761989,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fce40a96-2ee5-4f85-aa55-66352247f661_photo.jpg",
      averageRating=4.4, totalRatingsCount=1429,
      createdAt="2026-09-20T19:14:49.950398Z", updatedAt="2026-09-20T19:14:49.950398Z",
    ),
    ClubDto(
      id="0847b62a-bc23-4b30-954f-35a5dac758fc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel X Miami", address="141 NE 13th Terrace, Miami, FL 33132",
      city="Miami", country="US",
      latitude=25.7877104, longitude=-80.1918834,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/de2cde91-f6ab-4ecd-b8aa-b4b961077140_photo.jpg",
      averageRating=4.4, totalRatingsCount=176,
      createdAt="2026-09-20T19:14:20.335960Z", updatedAt="2026-09-20T19:14:20.335960Z",
    ),
    ClubDto(
      id="d4c00f4d-c48d-4c07-8a34-82fad3234455", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pinto's Farm", address="14890 SW 216th St, Miami, FL 33170",
      city="Miami", country="US",
      latitude=25.564828, longitude=-80.432968,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7d77778d-2dbb-4e03-922a-14d0bcec403c_photo.jpg",
      averageRating=4.4, totalRatingsCount=2071,
      createdAt="2026-09-20T19:15:04.998941Z", updatedAt="2026-09-20T19:15:04.998941Z",
    ),
    ClubDto(
      id="baa4b56d-0759-4230-89c6-d1490fa39904", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lucky Strike Miami", address="199 NE 7th St, Miami, FL 33132",
      city="Miami", country="US",
      latitude=25.7812815, longitude=-80.1911163,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b9a3a95-60d5-441d-b8c1-9edfe8c3f3f1_photo.jpg",
      averageRating=4.3, totalRatingsCount=407,
      createdAt="2026-09-20T19:15:11.482959Z", updatedAt="2026-09-20T19:15:11.482959Z",
    ),
    ClubDto(
      id="2d267e28-c626-49e9-accd-e4935cfa9924", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Topgolf Miami Gardens", address="17321 NW 7th Ave, Miami Gardens, FL 33169",
      city="Miami", country="US",
      latitude=25.9331094, longitude=-80.2092404,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2e523645-0faa-42df-b861-02bbf600cbd7_photo.jpg",
      averageRating=4.3, totalRatingsCount=4403,
      createdAt="2026-09-20T19:14:47.002362Z", updatedAt="2026-09-20T19:14:47.002362Z",
    ),
    ClubDto(
      id="8de6998b-ed76-4a08-9069-1d3a2d66a146", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Miami Volleyball Academy (West Location)", address="1500 NW 108th Ave, Miami, FL 33172",
      city="Miami", country="US",
      latitude=25.7873554, longitude=-80.3712151,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5b454cd2-57a9-4a6b-9bb0-01c032724797_photo.jpg",
      averageRating=4.2, totalRatingsCount=117,
      createdAt="2026-09-20T19:14:37.542208Z", updatedAt="2026-09-20T19:14:37.542208Z",
    ),
    ClubDto(
      id="5b1f41aa-2441-4316-bc3a-9c75614e26e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Virginia Key Beach Volleyball Court", address="Miami, FL 33149",
      city="Miami", country="US",
      latitude=25.7455169, longitude=-80.1436832,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/93fff1ff-0e76-490a-978c-4f646cb0b17a_photo.jpg",
      averageRating=4.4, totalRatingsCount=42,
      createdAt="2026-09-20T19:14:40.289808Z", updatedAt="2026-09-20T19:14:40.289808Z",
    ),
    ClubDto(
      id="a568a4eb-66b7-4eb2-8d2c-70b7384436d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Haulover Beach Volleyball Courts", address="14379 Collins Ave, Miami Beach, FL 33154",
      city="Miami", country="US",
      latitude=25.9135239, longitude=-80.1219311,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a6d750df-3312-4981-ba25-fe55ab2a3155_photo.jpg",
      averageRating=4.8, totalRatingsCount=27,
      createdAt="2026-09-20T19:14:43.391007Z", updatedAt="2026-09-20T19:14:43.391007Z",
    ),
    ClubDto(
      id="c6728627-7cc7-4294-8c2d-361851270753", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Miami Table Tennis Club", address="Legacy Place Community Center, 11400 NW 82nd St, Doral, FL 33178",
      city="Miami", country="US",
      latitude=25.8472493, longitude=-80.3813951,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/20b10288-6398-4452-b618-42cb1738a3c5_photo.jpg",
      averageRating=4.9, totalRatingsCount=24,
      createdAt="2026-09-20T19:14:58.963002Z", updatedAt="2026-09-20T19:14:58.963002Z",
    ),
  )),
  CitySeo(slug="edinburgh", name="Edinburgh", country="GB", clubCount=32, sports=listOf(Pair("Football", 7), Pair("Tennis", 4), Pair("Basketball", 3), Pair("Padel", 3), Pair("Paintball", 2), Pair("Billiards", 2), Pair("Golf", 2), Pair("Climbing", 2), Pair("Volleyball", 2), Pair("Bowling", 2), Pair("Table Tennis", 2), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="44bd8680-d517-414b-a382-b09432333407", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Edinburgh Combat Challenge", address="Lugton Bogs, Gilmerton Road, Edinburgh EH18 1AR",
      city="Edinburgh", country="GB",
      latitude=55.8970682, longitude=-3.0988313,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5e40478-b8d6-4dc9-a82d-318729c50ebb_photo.jpg",
      averageRating=4.9, totalRatingsCount=125,
      createdAt="2026-08-31T23:11:14.484351Z", updatedAt="2026-08-31T23:11:14.484351Z",
    ),
    ClubDto(
      id="d6e1b928-fe49-4d4d-9236-05de2c23a28c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boom Battle Bar Edinburgh", address="Omni Centre, Edinburgh EH1 3AU",
      city="Edinburgh", country="GB",
      latitude=55.9561351, longitude=-3.1854016,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b3952f82-792d-4e7d-90af-f75df713742f_photo.jpg",
      averageRating=4.8, totalRatingsCount=1602,
      createdAt="2026-08-31T23:11:01.323492Z", updatedAt="2026-08-31T23:11:01.323492Z",
    ),
    ClubDto(
      id="53c5f2df-c521-4e93-8229-6eea51e9969a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Roxy Lanes Edinburgh Rose Street", address="26 Rose St, Edinburgh EH2 2QA",
      city="Edinburgh", country="GB",
      latitude=55.952964, longitude=-3.1956581,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4d46dafd-231e-43bd-a9e8-5455968699fb_photo.jpg",
      averageRating=4.8, totalRatingsCount=1723,
      createdAt="2026-08-31T23:10:44.585820Z", updatedAt="2026-08-31T23:10:44.585820Z",
    ),
    ClubDto(
      id="11ff5faf-6263-4af4-bf8f-bc991aefab23", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="alien bloc", address="23 Dunedin St, Edinburgh EH7 4JG",
      city="Edinburgh", country="GB",
      latitude=55.9648102, longitude=-3.1929407,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0f562d5c-d1ca-4db7-b6db-7aca323062e2_photo.jpg",
      averageRating=4.8, totalRatingsCount=746,
      createdAt="2026-08-31T23:10:55.838065Z", updatedAt="2026-08-31T23:10:55.838065Z",
    ),
    ClubDto(
      id="7fd0afc0-3cee-4b55-8f72-e35e3e74c569", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Battlezone Paintball Edinburgh", address="Battlezone Edinburgh, Dolphinton Burn Woodlands Dundas Castle Est, Edinburgh EH29 9EN",
      city="Edinburgh", country="GB",
      latitude=55.9728155, longitude=-3.3876856,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fee5215f-5a91-4be8-bea7-a8e825080beb_photo.jpg",
      averageRating=4.7, totalRatingsCount=267,
      createdAt="2026-08-31T23:11:20.131565Z", updatedAt="2026-08-31T23:11:20.131565Z",
    ),
    ClubDto(
      id="137c0ee0-8b3f-4341-a24d-6ed5cbe3db55", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Edinburgh International Climbing Arena: Ratho", address="South Platt Hill, Ratho, Newbridge EH28 8AA",
      city="Edinburgh", country="GB",
      latitude=55.923409, longitude=-3.397706,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2b1f1574-7941-4245-9872-80492d74ca6f_photo.jpg",
      averageRating=4.7, totalRatingsCount=2065,
      createdAt="2026-08-31T23:10:49.918555Z", updatedAt="2026-08-31T23:10:49.918555Z",
    ),
    ClubDto(
      id="020c0346-ec66-4969-8dfb-1b306430f5b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Oriam", address="Heriot-Watt Univ Edinburgh Campus, Currie, Edinburgh EH14 4AS",
      city="Edinburgh", country="GB",
      latitude=55.9092328, longitude=-3.3157983,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bdeac6b2-07bf-4955-b81e-20ca5cf33999_photo.jpg",
      averageRating=4.7, totalRatingsCount=709,
      createdAt="2026-08-31T23:07:59.757960Z", updatedAt="2026-08-31T23:07:59.757960Z",
    ),
    ClubDto(
      id="e7f2cc05-130c-4408-826c-6008c3613bcc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bedlam Paintball Edinburgh", address="Craigton House, Craigton Farm, Winchburgh, Broxburn EH52 6PY",
      city="Edinburgh", country="GB",
      latitude=55.9730253, longitude=-3.4891347,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04be1669-3c1c-46a7-9bf7-0921250ed1d3_photo.jpg",
      averageRating=4.6, totalRatingsCount=218,
      createdAt="2026-08-31T23:11:25.925119Z", updatedAt="2026-08-31T23:11:25.925119Z",
    ),
    ClubDto(
      id="68c76b98-a6e9-4e69-8592-b6c67c16a873", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Meadows City Tennis Club", address="Melville Drive, Edinburgh EH8 9NL",
      city="Edinburgh", country="GB",
      latitude=55.9411, longitude=-3.18544,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/569a956c-3101-4beb-93c7-d476bf4f8d0a_photo.jpg",
      averageRating=4.6, totalRatingsCount=129,
      createdAt="2026-08-31T23:09:07.496211Z", updatedAt="2026-08-31T23:09:07.496211Z",
    ),
    ClubDto(
      id="512425c1-5df6-483f-beda-8e70bb723f66", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Craiglockhart Leisure & Tennis Centre", address="Craiglockhart Tennis Centre, 177 Colinton Rd, Edinburgh EH14 1BZ",
      city="Edinburgh", country="GB",
      latitude=55.9221332, longitude=-3.2351356,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/def29852-eec0-4900-8a61-a612016b5864_photo.jpg",
      averageRating=4.5, totalRatingsCount=560,
      createdAt="2026-08-31T23:08:47.283631Z", updatedAt="2026-08-31T23:08:47.283631Z",
    ),
    ClubDto(
      id="f098a274-08c0-4451-8c14-4cc781c97b23", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Edinburgh Sports Club", address="7 Belford Pl, Edinburgh EH4 3DH",
      city="Edinburgh", country="GB",
      latitude=55.9493944, longitude=-3.2251667,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd05a38c-1e3b-4f35-92bc-a6cf13a388d3_photo.jpg",
      averageRating=4.5, totalRatingsCount=112,
      createdAt="2026-08-31T23:09:11.309350Z", updatedAt="2026-08-31T23:09:11.309350Z",
    ),
    ClubDto(
      id="e817f322-f9f0-45b7-b09e-a0bff0e0ab1a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lane7 Edinburgh", address="Saint James Square, Edinburgh EH1 3AD",
      city="Edinburgh", country="GB",
      latitude=55.9555545, longitude=-3.1888057,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6c1b737a-c7a5-4b87-b9a9-705380d1df12_photo.jpg",
      averageRating=4.5, totalRatingsCount=2172,
      createdAt="2026-08-31T23:10:40.131761Z", updatedAt="2026-08-31T23:10:40.131761Z",
    ),
    ClubDto(
      id="10ea6423-4542-4191-91dc-813e93bea1b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pleasance Sports Complex & Gym", address="Centre for Sport and Exercise, 46 Pleasance, Edinburgh EH8 9TJ",
      city="Edinburgh", country="GB",
      latitude=55.948146, longitude=-3.181068,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6f563f09-d511-46d2-9ba4-bf8a2a376ccf_photo.jpg",
      averageRating=4.5, totalRatingsCount=349,
      createdAt="2026-08-31T23:09:56.497508Z", updatedAt="2026-08-31T23:09:56.497508Z",
    ),
    ClubDto(
      id="fe2e5144-0b87-4a44-8bc7-169fcf943492", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Braid Hills Golf Course", address="27 Braid Hills Approach, Edinburgh EH10 6JY",
      city="Edinburgh", country="GB",
      latitude=55.916057, longitude=-3.204679,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a7baf446-2329-4866-bb51-d1e7d997d9f6_photo.jpg",
      averageRating=4.4, totalRatingsCount=505,
      createdAt="2026-08-31T23:10:15.139733Z", updatedAt="2026-08-31T23:10:15.139733Z",
    ),
    ClubDto(
      id="1266c37e-f50b-43cc-b82d-15a162ea93fb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Drumbrae Leisure Centre", address="30 Drum Brae Terrace, Edinburgh EH4 7SF",
      city="Edinburgh", country="GB",
      latitude=55.9560253, longitude=-3.2940489,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/76a2a700-7710-4ddf-ac54-260845bd9bd9_photo.jpg",
      averageRating=4.4, totalRatingsCount=545,
      createdAt="2026-08-31T23:09:51.316666Z", updatedAt="2026-08-31T23:09:51.316666Z",
    ),
    ClubDto(
      id="1380e688-6d30-4d06-98c0-d1fbc1ee45b8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gracemount Leisure Centre", address="22 Gracemount Dr, Edinburgh EH16 6RN",
      city="Edinburgh", country="GB",
      latitude=55.903017, longitude=-3.1546058,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d7517cdc-2f7e-495c-aa12-1e749924b412_photo.jpg",
      averageRating=4.4, totalRatingsCount=383,
      createdAt="2026-08-31T23:10:01.445597Z", updatedAt="2026-08-31T23:10:01.445597Z",
    ),
    ClubDto(
      id="9f9a764b-28a3-4c73-ae5c-991372e0d80e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Marcos", address="79 Grove St, Edinburgh EH3 8FG",
      city="Edinburgh", country="GB",
      latitude=55.9443072, longitude=-3.2117434,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d4615a2e-f35d-462d-b4af-2d7dec962181_photo.jpg",
      averageRating=4.4, totalRatingsCount=819,
      createdAt="2026-08-31T23:11:09.098753Z", updatedAt="2026-08-31T23:11:09.098753Z",
    ),
    ClubDto(
      id="342bf861-b636-4209-99a8-1a52440ca70e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Silverknowes Golf Course", address="118 Silverknowes Rd, Edinburgh EH4 5ET",
      city="Edinburgh", country="GB",
      latitude=55.9729755, longitude=-3.2725414,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c565f633-b2d6-4ba7-b683-1990c7526220_photo.jpg",
      averageRating=4.4, totalRatingsCount=436,
      createdAt="2026-08-31T23:10:21.429897Z", updatedAt="2026-08-31T23:10:21.429897Z",
    ),
    ClubDto(
      id="1ceac9a1-b8ac-4b08-b707-c92f88fea48d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ainslie Park Leisure Centre", address="92 Pilton Dr, Edinburgh EH5 2HF",
      city="Edinburgh", country="GB",
      latitude=55.9718528, longitude=-3.2305649,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4d452335-af49-4181-8862-64d1d111358a_photo.jpg",
      averageRating=4.3, totalRatingsCount=711,
      createdAt="2026-08-31T23:09:46.747126Z", updatedAt="2026-08-31T23:09:46.747126Z",
    ),
    ClubDto(
      id="c8f31c56-986c-4fcb-b4d6-a8c10cb77b4c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Meggetland Sports Complex", address="Meggetland Sports Complex, 4 Meggetland Wynd, Edinburgh EH14 1XN",
      city="Edinburgh", country="GB",
      latitude=55.9279646, longitude=-3.2349332,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4b1a5ab5-2cee-42eb-9658-6cde1e10a4a2_photo.jpg",
      averageRating=4.3, totalRatingsCount=455,
      createdAt="2026-08-31T23:08:15.643932Z", updatedAt="2026-08-31T23:08:15.643932Z",
    ),
    ClubDto(
      id="8c658664-732d-4ad0-9b0c-c8c000e11ab3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Powerleague Edinburgh Portobello", address="10 Westbank St, Edinburgh EH15 1DR",
      city="Edinburgh", country="GB",
      latitude=55.9566232, longitude=-3.1178799,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed4bb2a7-6799-434e-93c4-bd5f08275f2f_photo.jpg",
      averageRating=4.3, totalRatingsCount=300,
      createdAt="2026-08-31T23:08:22.265395Z", updatedAt="2026-08-31T23:08:22.265395Z",
    ),
    ClubDto(
      id="57d47c26-68ae-4be3-866e-384cc339b4ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Powerleague Edinburgh Sighthill", address="66 Bankhead Dr, Sighthill, Edinburgh EH11 4EQ",
      city="Edinburgh", country="GB",
      latitude=55.9278317, longitude=-3.2879132,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ffd06380-4989-42d2-8058-3d26a6ea6bae_photo.jpg",
      averageRating=4.3, totalRatingsCount=251,
      createdAt="2026-08-31T23:08:26.992501Z", updatedAt="2026-08-31T23:08:26.992501Z",
    ),
    ClubDto(
      id="d399f60e-0d1e-4aee-884e-598df80752c5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Grange Club", address="Portgower Pl, Edinburgh EH4 1HQ",
      city="Edinburgh", country="GB",
      latitude=55.9599209, longitude=-3.2133478,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2d157a7b-1eb3-4c7c-a5eb-b5bc660653d6_photo.jpg",
      averageRating=4.3, totalRatingsCount=173,
      createdAt="2026-08-31T23:08:52.498396Z", updatedAt="2026-08-31T23:08:52.498396Z",
    ),
    ClubDto(
      id="551db4fc-942a-4b3e-888b-d49dab2171d0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Meadowbank Sports Centre", address="London Rd, Edinburgh EH7 6AE",
      city="Edinburgh", country="GB",
      latitude=55.9563423, longitude=-3.1569952,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9e2241d1-3c6d-4909-9f85-040af6b5c373_photo.jpg",
      averageRating=4.2, totalRatingsCount=636,
      createdAt="2026-08-31T23:08:09.672700Z", updatedAt="2026-08-31T23:08:09.672700Z",
    ),
    ClubDto(
      id="14824721-8570-4f7d-a2f8-df5bdb7d8827", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Saughton Sports Complex", address="Stevenson Dr, Edinburgh EH11 3BQ",
      city="Edinburgh", country="GB",
      latitude=55.9347874, longitude=-3.2546399,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c77e24c3-d455-4f4c-823d-6889ab80c74b_photo.jpg",
      averageRating=4.2, totalRatingsCount=192,
      createdAt="2026-08-31T23:11:31.941367Z", updatedAt="2026-09-01T14:31:44.489353Z",
    ),
    ClubDto(
      id="c1e981b4-4727-4e6b-923f-a2b5f06f8314", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Craigmillar Park Tennis & Padel Club, Edinburgh", address="Cameron Toll Shopping Centre, Lady Rd, Edinburgh EH16 5TZ",
      city="Edinburgh", country="GB",
      latitude=55.924946, longitude=-3.164234,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff9f3a11-1f28-4373-b658-c1379487f9bb_photo.jpg",
      averageRating=4.6, totalRatingsCount=39,
      createdAt="2026-08-31T23:09:18.204493Z", updatedAt="2026-09-01T14:31:56.413279Z",
    ),
    ClubDto(
      id="1b2fd022-1b7c-412e-a818-c72de5e6e62f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="NUVOC Volleyball Club", address="James Gillespie's High School, 57 Lauderdale Street, 57 Lauderdale St, Edinburgh EH9 1DD",
      city="Edinburgh", country="GB",
      latitude=55.9358058, longitude=-3.2010696,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d86e17e5-ff11-466a-ac48-5baad90fc638_photo.jpg",
      averageRating=4.8, totalRatingsCount=34,
      createdAt="2026-08-31T23:10:08.332519Z", updatedAt="2026-08-31T23:10:08.332519Z",
    ),
    ClubDto(
      id="3f315885-4d75-4cfd-88d6-29be293482b0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Wardie Recreation Ground", address="Granton Rd, Edinburgh EH5 3QJ",
      city="Edinburgh", country="GB",
      latitude=55.9760185, longitude=-3.2143425,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f153b7cf-112d-4774-941f-3e62d2bfe609_photo.jpg",
      averageRating=3.8, totalRatingsCount=39,
      createdAt="2026-08-31T23:11:36.861034Z", updatedAt="2026-08-31T23:11:36.861034Z",
    ),
    ClubDto(
      id="63cc8180-47a7-4dab-a2d7-721a6dc58e11", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Thistle Tennis Club", address="Katesmill Rd, Edinburgh EH14 1EF",
      city="Edinburgh", country="GB",
      latitude=55.9143753, longitude=-3.2513213,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c36d68f6-358b-4244-99b8-61490fd073e1_photo.jpg",
      averageRating=4.7, totalRatingsCount=26,
      createdAt="2026-08-31T23:09:23.632408Z", updatedAt="2026-09-01T14:31:52.051580Z",
    ),
    ClubDto(
      id="5f6af5ee-ae44-4d4a-9b38-bf7718712e5b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Barnton Park Lawn Tennis Club", address="12 Barnton Park, Edinburgh EH4 6JF",
      city="Edinburgh", country="GB",
      latitude=55.9680931, longitude=-3.2793164,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7512737d-a30c-459d-8659-68b6398919e2_photo.jpg",
      averageRating=4.7, totalRatingsCount=19,
      createdAt="2026-08-31T23:09:42.014856Z", updatedAt="2026-09-01T14:31:46.886910Z",
    ),
    ClubDto(
      id="8cc71314-4f03-4e4d-b7c3-995344a7ae95", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pop in and Play Table Tennis - Gyle", address="Unit 5 Foodcourt, Gyle Shopping Centre, Gyle Ave, Edinburgh EH12 9JY",
      city="Edinburgh", country="GB",
      latitude=55.9384669, longitude=-3.3146724,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d2917cc2-c714-45ff-bca8-f9bff2688eeb_photo.jpg",
      averageRating=4.3, totalRatingsCount=20,
      createdAt="2026-08-31T23:10:26.635948Z", updatedAt="2026-08-31T23:10:26.635948Z",
    ),
    ClubDto(
      id="416b80bf-3400-4b9f-a891-df0543bba1f1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Murrayfield Memorial Table Tennis Club", address="13 Murrayfield Ave, Edinburgh EH12 6AY",
      city="Edinburgh", country="GB",
      latitude=55.9472717, longitude=-3.2369138,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bec23dc3-5082-4709-a937-e3b2696f79ab_photo.jpg",
      averageRating=4.4, totalRatingsCount=14,
      createdAt="2026-08-31T23:10:31.920325Z", updatedAt="2026-08-31T23:10:31.920325Z",
    ),
  )),
  CitySeo(slug="eindhoven", name="Eindhoven", country="NL", clubCount=32, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Padel", 3), Pair("Basketball", 3), Pair("Volleyball", 3), Pair("Paintball", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Karting", 2), Pair("Laser Tag", 2), Pair("Billiards", 2), Pair("Table Tennis", 2)), clubs=listOf(
    ClubDto(
      id="8052a2b4-4802-4b15-8fa0-cab8365ace90", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Urban Sportpark Eindhoven", address="Halvemaanstraat 130, 5651 BR Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4461514, longitude=5.4390942,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e2db045f-9206-43f5-bae7-d702f764311e_photo.jpg",
      averageRating=4.8, totalRatingsCount=221,
      createdAt="2026-08-31T23:48:28.500995Z", updatedAt="2026-08-31T23:48:28.500995Z",
    ),
    ClubDto(
      id="d9943673-2ed8-4a54-ae41-e71836eb6664", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Liever Buiten", address="Bruggenseweg 12, 5752 SC Deurne",
      city="Eindhoven", country="NL",
      latitude=51.4785524, longitude=5.7620178,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac2fdbfc-1ea7-4b0c-8a32-cbc5303cd357_photo.jpg",
      averageRating=4.7, totalRatingsCount=176,
      createdAt="2026-08-31T23:50:13.843056Z", updatedAt="2026-08-31T23:50:13.843056Z",
    ),
    ClubDto(
      id="81584656-a421-4cc0-9aeb-ab553a631693", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PSV", address="Frederiklaan 10A, 5616 LX Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4416289, longitude=5.4676566,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8d78565f-d45f-4ee9-ad3f-9ee166437f7c_photo.jpg",
      averageRating=4.7, totalRatingsCount=990,
      createdAt="2026-08-31T23:47:41.905370Z", updatedAt="2026-09-01T14:31:53.307278Z",
    ),
    ClubDto(
      id="93756be7-940a-4d43-8569-9d29381503a5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Padellers Valkenswaard Valkencourt - Padelclub🥎", address="Pastoor Heerkensdreef 15, 5552 BG Valkenswaard",
      city="Eindhoven", country="NL",
      latitude=51.3645512, longitude=5.4539889,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2842bc2c-0736-4013-851e-577292997718_photo.jpg",
      averageRating=4.7, totalRatingsCount=81,
      createdAt="2026-08-31T23:48:23.708153Z", updatedAt="2026-08-31T23:48:23.708153Z",
    ),
    ClubDto(
      id="bcbb08c9-48c1-411e-872b-0317a9943893", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kombikart Circuit \"The Landsard\"", address="Landsardseweg 47, 5657 AB Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.462189, longitude=5.3762923,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1018bdab-0cf3-480d-8303-36a425e6d265_photo.jpg",
      averageRating=4.6, totalRatingsCount=935,
      createdAt="2026-08-31T23:49:30.292717Z", updatedAt="2026-08-31T23:49:30.292717Z",
    ),
    ClubDto(
      id="f308db9d-d280-4413-a1ca-1d4eb5a84ece", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Peakz Padel Eindhoven High Tech Campus | Padelclub", address="High Tech Campus 8, 5656 AE Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4091124, longitude=5.4503701,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc9adde5-f57d-44e9-afc1-40efba4c2292_photo.jpg",
      averageRating=4.6, totalRatingsCount=81,
      createdAt="2026-08-31T23:48:18.647559Z", updatedAt="2026-08-31T23:48:18.647559Z",
    ),
    ClubDto(
      id="014a8bce-170f-47b7-b99a-8b7f554b21a8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Airsoft Training Center", address="Turfweg 9, 5504 RL Veldhoven",
      city="Eindhoven", country="NL",
      latitude=51.3848452, longitude=5.3822819,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cbc170c8-3cd9-4c89-8e20-1d227922b845_photo.jpg",
      averageRating=4.5, totalRatingsCount=232,
      createdAt="2026-08-31T23:50:08.904170Z", updatedAt="2026-08-31T23:50:08.904170Z",
    ),
    ClubDto(
      id="a6e530c9-d930-4109-b33a-00cd16a5710b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="David Lloyd Eindhoven", address="Peter Zuidlaan 30, 5502 NH Veldhoven",
      city="Eindhoven", country="NL",
      latitude=51.4228642, longitude=5.4260439,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a6b11a4e-5b4a-4b46-a6c4-b8a7a14656bc_photo.jpg",
      averageRating=4.5, totalRatingsCount=1104,
      createdAt="2026-08-31T23:47:51.913927Z", updatedAt="2026-08-31T23:47:51.913927Z",
    ),
    ClubDto(
      id="bdce0e44-eed5-46d9-9671-862f7269734f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golfcentrum Eindhoven", address="De Hondsheuvels, J C Dirkxpad, 5631 BZ Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4562332, longitude=5.4909755,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/62bc415a-9358-4868-9629-0082b0035650_photo.jpg",
      averageRating=4.5, totalRatingsCount=54,
      createdAt="2026-08-31T23:49:05.552246Z", updatedAt="2026-08-31T23:49:05.552246Z",
    ),
    ClubDto(
      id="67dfb788-9d73-44b4-92b3-607a7f4c68be", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Snooker & Poolcentrum Woensel 🎱", address="Winkelcentrum Woensel 84D, 5625 AE Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.470787, longitude=5.4735972,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/619df4c0-a27e-4ab9-9a82-c48fec6c60f4_photo.jpg",
      averageRating=4.5, totalRatingsCount=325,
      createdAt="2026-08-31T23:49:47.058008Z", updatedAt="2026-08-31T23:49:47.058008Z",
    ),
    ClubDto(
      id="491d532f-772f-44d9-ba74-3960fc471b1a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tafeltennisvereniging Flash - TTV Flash", address="Bekerakker 11A, 5625 VX Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4708333, longitude=5.4833333,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac909f71-1af5-4529-9048-4c77368d7be8_photo.jpg",
      averageRating=4.5, totalRatingsCount=59,
      createdAt="2026-08-31T23:49:12.002184Z", updatedAt="2026-08-31T23:49:12.002184Z",
    ),
    ClubDto(
      id="7839aa4c-1a6f-407d-a815-6a17dbe57a31", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tafeltennisvereniging Veldhoven", address="Burgemeester van Hoofflaan 147, 5503 BL Veldhoven",
      city="Eindhoven", country="NL",
      latitude=51.4141123, longitude=5.4070308,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c576f3ad-4bec-4159-85e4-8d08029d1ed4_photo.jpg",
      averageRating=4.5, totalRatingsCount=57,
      createdAt="2026-08-31T23:49:18.897732Z", updatedAt="2026-08-31T23:49:18.897732Z",
    ),
    ClubDto(
      id="37180137-a8fa-403b-9435-57c38f3e06f1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennisvereniging E.S.T. Fellenoord", address="Onze Lieve Vrouwestraat 1, 5612 AW Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.451232, longitude=5.484763,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/705cbbc8-9bcd-4237-a266-9cf0dfb8ca80_photo.jpg",
      averageRating=4.5, totalRatingsCount=79,
      createdAt="2026-08-31T23:48:03.246394Z", updatedAt="2026-09-01T14:31:42.248635Z",
    ),
    ClubDto(
      id="1da2a9cc-e698-4eaa-b7e4-b93a8d5ebf03", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="the Herdgang", address="Oirschotsedijk 12, 5651 GC Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.458911, longitude=5.439284,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fdcbde6a-411b-471a-9edb-857d20f238ae_photo.jpg",
      averageRating=4.5, totalRatingsCount=661,
      createdAt="2026-08-31T23:47:46.865677Z", updatedAt="2026-08-31T23:47:46.865677Z",
    ),
    ClubDto(
      id="b06c1090-7b53-4725-a797-af071380f798", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoor Sportcentrum Eindhoven", address="Theo Koomenlaan 1, 5644 HZ Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.412674, longitude=5.4812188,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cd86a053-e5b7-4c1a-9022-8b297ab01280_photo.jpg",
      averageRating=4.4, totalRatingsCount=1171,
      createdAt="2026-08-31T23:47:37.032388Z", updatedAt="2026-09-01T14:32:02.525092Z",
    ),
    ClubDto(
      id="bd9ffecc-3a24-42ce-9140-1f5776bab819", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Students Sport Centre Eindhoven", address="Onze Lieve Vrouwestraat 1, 5612 AW Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4521839, longitude=5.4893775,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8e9584d3-4333-4309-a41c-2737fc0a1d5f_photo.jpg",
      averageRating=4.4, totalRatingsCount=1428,
      createdAt="2026-08-31T23:47:32.308366Z", updatedAt="2026-08-31T23:47:32.308366Z",
    ),
    ClubDto(
      id="66e877d0-b15c-4a4e-91bf-d0e02648911e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Padellers Veldhoven - Padelclub", address="Heerseweg 49, 5504 KP Veldhoven",
      city="Eindhoven", country="NL",
      latitude=51.3991005, longitude=5.4001529,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5bf78d07-be0f-4058-a07a-970e588da140_photo.jpg",
      averageRating=4.4, totalRatingsCount=98,
      createdAt="2026-08-31T23:48:13.022025Z", updatedAt="2026-08-31T23:48:13.022025Z",
    ),
    ClubDto(
      id="b852690b-be1a-4915-9843-60809866e049", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Flying Bowling Partycentrum", address="Oortlaan 152, 5505 RH Veldhoven",
      city="Eindhoven", country="NL",
      latitude=51.4131065, longitude=5.3968015,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f7118552-9445-42a4-b638-223d3ce5182d_photo.jpg",
      averageRating=4.3, totalRatingsCount=493,
      createdAt="2026-08-31T23:49:40.698536Z", updatedAt="2026-08-31T23:49:40.698536Z",
    ),
    ClubDto(
      id="7d495db1-c333-4341-ab9a-ef9f40abd1d6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf & Country Club De Tongelreep", address="Charles Roelslaan 15, 5644 HX Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4083769, longitude=5.4738681,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8647de8a-da4c-4968-b72b-5bb8e6be6563_photo.jpg",
      averageRating=4.3, totalRatingsCount=121,
      createdAt="2026-08-31T23:49:00.976715Z", updatedAt="2026-08-31T23:49:00.976715Z",
    ),
    ClubDto(
      id="455eed1f-b111-44ba-b544-335164fbd6d7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hezemans Indoor Karting Axe Bar", address="Vijfkamplaan 18, 5624 EB Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4755321, longitude=5.4583253,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1d8eaa86-ec81-4ce0-b9db-56a214e02822_photo.jpg",
      averageRating=4.3, totalRatingsCount=1224,
      createdAt="2026-08-31T23:49:24.340156Z", updatedAt="2026-08-31T23:49:24.340156Z",
    ),
    ClubDto(
      id="3b9984b6-35a8-47a9-b5c7-b90f77ffaf4d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Quest Eindhoven", address="Oude Stadsgracht 15, 5611 DD Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4358446, longitude=5.4825196,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/479bb957-6595-417d-a0c9-3c5884a221bd_photo.jpg",
      averageRating=4.3, totalRatingsCount=425,
      createdAt="2026-08-31T23:49:59.718118Z", updatedAt="2026-08-31T23:49:59.718118Z",
    ),
    ClubDto(
      id="4f319d91-5666-4e27-b47f-d0c906f5c5af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="National Swimming Center the Tongelreep", address="Antoon Coolenlaan 1, 5644 RX Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4166045, longitude=5.4782531,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fb44b333-88e0-49ff-b5b3-4c1046711adf_photo.jpg",
      averageRating=4.3, totalRatingsCount=2039,
      createdAt="2026-08-31T23:47:27.465107Z", updatedAt="2026-08-31T23:47:27.465107Z",
    ),
    ClubDto(
      id="6e44414f-ab38-4c6c-aa02-6e58b95d2ae0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="HUP", address="Arkweg 3, 5731 PD Mierlo",
      city="Eindhoven", country="NL",
      latitude=51.4509576, longitude=5.6292318,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1327882a-635c-459d-993c-862d3c9385eb_photo.jpg",
      averageRating=4.2, totalRatingsCount=2101,
      createdAt="2026-08-31T23:49:34.782299Z", updatedAt="2026-08-31T23:49:34.782299Z",
    ),
    ClubDto(
      id="7792eff1-b9b4-4a19-97bc-065fd4501b8d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporthal Strijp", address="Rijstenweg 7, 5652 CG Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4368424, longitude=5.4468242,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3583d44d-cad1-46b9-9e6e-3d4cb3e21ef5_photo.jpg",
      averageRating=4.2, totalRatingsCount=113,
      createdAt="2026-08-31T23:48:39.799766Z", updatedAt="2026-08-31T23:48:39.799766Z",
    ),
    ClubDto(
      id="b3d4b648-87ce-4e8e-b1a4-fa6e018c3a20", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporthal de Vijfkamp", address="Vijfkamplaan 5, 5624 EB Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4768929, longitude=5.4546439,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/234f8f56-99b5-4966-9ce5-1975dceed299_photo.jpg",
      averageRating=4.2, totalRatingsCount=176,
      createdAt="2026-08-31T23:47:57.712745Z", updatedAt="2026-08-31T23:47:57.712745Z",
    ),
    ClubDto(
      id="26e9b9e6-30ec-49ed-8b21-602bce114ef2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Bokt | Tennis & Padel", address="Anconalaan 1, 5633 BJ Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4871839, longitude=5.4984931,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5dd44997-27c5-4d16-8c41-0f8f3d01a284_photo.jpg",
      averageRating=4.2, totalRatingsCount=73,
      createdAt="2026-08-31T23:48:08.284038Z", updatedAt="2026-09-01T14:31:59.692203Z",
    ),
    ClubDto(
      id="22ba5e1d-431b-4289-b1a7-91092117054c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporthal Achtse Barrier", address="Savoiepad 14, 5627 DX Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4878011, longitude=5.4428582,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a149a608-8e61-47a4-a191-ba7d56dcc5db_photo.jpg",
      averageRating=4.1, totalRatingsCount=136,
      createdAt="2026-08-31T23:48:34.057499Z", updatedAt="2026-08-31T23:48:34.057499Z",
    ),
    ClubDto(
      id="a55575e3-7b84-44ff-a228-1dfcd675b061", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportinghall Genderbeemd", address="Sterkenburg 616, 5653 NP Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4203094, longitude=5.4385808,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/be7faf42-6f06-4152-9769-18f621066c10_photo.jpg",
      averageRating=4.1, totalRatingsCount=350,
      createdAt="2026-08-31T23:48:44.200340Z", updatedAt="2026-08-31T23:48:44.200340Z",
    ),
    ClubDto(
      id="6eb86755-e31f-4350-9ca0-42329b29a1ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportpark - South Dommeldal", address="Locatellistraat 3, 5654 JB Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4158275, longitude=5.4517782,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/112ce832-9728-4b44-870f-a34d5406e7f7_photo.jpg",
      averageRating=4.1, totalRatingsCount=109,
      createdAt="2026-08-31T23:48:49.292304Z", updatedAt="2026-08-31T23:48:49.292304Z",
    ),
    ClubDto(
      id="94aee3b6-f2ef-4328-9521-9057f554c35c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="mvc De Hangar", address="Meerbos 4, 5658 LA Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4427778, longitude=5.4108333,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0628ee2e-14a5-4062-9576-9acdd22311ea_photo.jpg",
      averageRating=4.1, totalRatingsCount=76,
      createdAt="2026-08-31T23:48:55.624448Z", updatedAt="2026-08-31T23:48:55.624448Z",
    ),
    ClubDto(
      id="841a2f21-4bd7-4634-9d57-0b5676eeb81f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Rex Snooker & Pool Club", address="Stationsplein 2-A, 5611 AB Eindhoven",
      city="Eindhoven", country="NL",
      latitude=51.4411807, longitude=5.4802736,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/27a60c6b-0227-4b5a-8c82-6dedb3ab03c3_photo.jpg",
      averageRating=3.6, totalRatingsCount=287,
      createdAt="2026-08-31T23:49:52.634998Z", updatedAt="2026-08-31T23:49:52.634998Z",
    ),
    ClubDto(
      id="5a39d2b7-9fcf-4422-a8aa-89b55cd70901", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasergame Veldhoven", address="Blaarthemseweg 90, 5502 JW Veldhoven",
      city="Eindhoven", country="NL",
      latitude=51.4247244, longitude=5.4256893,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dbba359a-5773-4ed4-995b-d09104a7cddc_photo.jpg",
      averageRating=4.8, totalRatingsCount=12,
      createdAt="2026-08-31T23:50:04.336243Z", updatedAt="2026-08-31T23:50:04.336243Z",
    ),
  )),
  CitySeo(slug="valencia", name="Valencia", country="ES", clubCount=32, sports=listOf(Pair("Football", 6), Pair("Volleyball", 5), Pair("Basketball", 3), Pair("Paintball", 2), Pair("Tennis", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Climbing", 2), Pair("Karting", 2), Pair("Billiards", 2), Pair("Laser Tag", 2), Pair("Padel", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="014525ad-8840-4e5d-82ff-52f597d50692", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Arena Sports", address="Pol.Ind. III, Carrer dels Llanterners, 7, 46120 Alboraia, Valencia",
      city="Valencia", country="ES",
      latitude=39.50217, longitude=-0.3436,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8bce4a25-0e9f-43d1-b4bb-f00aba4b0966_photo.jpg",
      averageRating=4.9, totalRatingsCount=63,
      createdAt="2026-08-31T22:37:08.824742Z", updatedAt="2026-08-31T22:37:08.824742Z",
    ),
    ClubDto(
      id="ca30df49-58da-4857-80c3-929877c91715", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PIRAMIDA", address="C. del Palleter, 59, Extramurs, 46008 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4720835, longitude=-0.3885683,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/62c3591f-1e73-4a93-95f0-77f6a4c8008e_photo.jpg",
      averageRating=4.9, totalRatingsCount=66,
      createdAt="2026-08-31T22:38:14.515028Z", updatedAt="2026-08-31T22:38:14.515028Z",
    ),
    ClubDto(
      id="2f0d0fd9-45f0-4316-9ae8-f2b84fd15ac8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball La Vall LaserTag", address="Pla de Llobet S/N, Camí de la l'Escoladora, 12600 Vall de Uxó, Castellón",
      city="Valencia", country="ES",
      latitude=39.7895117, longitude=-0.2707972,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9c2ee14c-e3ed-41f3-b349-aa011e866eee_photo.jpg",
      averageRating=4.9, totalRatingsCount=190,
      createdAt="2026-08-31T22:38:26.263731Z", updatedAt="2026-08-31T22:38:26.263731Z",
    ),
    ClubDto(
      id="5d38ce30-3408-43cd-8a9b-073726f47a2e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aventura València", address="Camí del Pla, s/n, 46590 Estivella, Valencia",
      city="Valencia", country="ES",
      latitude=39.721215, longitude=-0.375496,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49206448-3e05-4418-b4e3-bd878bc464e3_photo.jpg",
      averageRating=4.8, totalRatingsCount=1384,
      createdAt="2026-08-31T22:38:31.235809Z", updatedAt="2026-08-31T22:38:31.235809Z",
    ),
    ClubDto(
      id="2a6f4a53-669f-4dc1-9366-14fb400d0010", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Valencia Basket", address="Roig Arena, Carrer d'Ángel Villena, SN, puerta L1, Quatre Carreres, 46013 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4491961, longitude=-0.3643239,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/80f61aba-50a7-4e7e-aecb-76524fbe516e_photo.jpg",
      averageRating=4.7, totalRatingsCount=1335,
      createdAt="2026-08-31T22:36:47.088310Z", updatedAt="2026-08-31T22:36:47.088310Z",
    ),
    ClubDto(
      id="3bb281ea-e754-44f7-a64f-79230259304a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Las Colinas", address="Av. de las Colinas, 2, 03189 Dehesa de Campoamor, Alicante",
      city="Valencia", country="ES",
      latitude=37.9279868, longitude=-0.8090538,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a404a14a-41d6-41f0-af31-b4f80c0573c3_photo.jpg",
      averageRating=4.6, totalRatingsCount=2013,
      createdAt="2026-08-31T22:37:29.662209Z", updatedAt="2026-08-31T22:37:29.662209Z",
    ),
    ClubDto(
      id="8ec01980-290f-4470-a4a8-b47da21a6c20", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Estadio Ciudad de Valencia", address="Carrer de Sant Vicent de Paül, 44, Rascanya, 46019 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4946891, longitude=-0.3638225,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/206b6336-6c3a-4582-aa61-f9b989940305_photo.jpg",
      averageRating=4.5, totalRatingsCount=9032,
      createdAt="2026-08-31T22:35:50.447711Z", updatedAt="2026-08-31T22:35:50.447711Z",
    ),
    ClubDto(
      id="e8f958e5-1722-4ce4-b662-6e1b576a327f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoorwall", address="Av. Mare Nostrum, 8, 03007 Alacant, Alicante",
      city="Valencia", country="ES",
      latitude=38.3420919, longitude=-0.525132,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9ed67796-3c15-47fc-bd35-dc24d3cc390c_photo.jpg",
      averageRating=4.5, totalRatingsCount=515,
      createdAt="2026-08-31T22:38:05.768026Z", updatedAt="2026-08-31T22:38:05.768026Z",
    ),
    ClubDto(
      id="96d57fba-439e-4dae-842a-3e2ec34002b5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ON AIR FITNESS VALENCIA - RUZAFA", address="Gran Vía de las Germanías, 20 Bajo, Ensanche, 46006 Valencia",
      city="Valencia", country="ES",
      latitude=39.4642843, longitude=-0.375886,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/44717594-5d27-4942-b28d-f1cb53faba0d_photo.jpg",
      averageRating=4.5, totalRatingsCount=1887,
      createdAt="2026-08-31T22:36:42.483437Z", updatedAt="2026-08-31T22:36:42.483437Z",
    ),
    ClubDto(
      id="3bfd34af-c586-4c12-aaee-50a5bb1d77dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pabellón Fuente de San Luis", address="Pavelló Font de Sant Lluis, Av. dels Germans Maristes, 16, Quatre Carreres, 46013 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4516754, longitude=-0.3660431,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/73f93c86-f156-4644-b77f-ca404246aaaf_photo.jpg",
      averageRating=4.5, totalRatingsCount=3630,
      createdAt="2026-08-31T22:36:36.461091Z", updatedAt="2026-08-31T22:36:36.461091Z",
    ),
    ClubDto(
      id="8ce7b988-4455-492d-843c-f7317b012b52", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club de Tenis de Valencia", address="C/ de Cavanilles, 7, La Saïdia, 46010 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4841616, longitude=-0.3644563,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0a459831-b832-48ad-9d3d-e0e65f205332_photo.jpg",
      averageRating=4.4, totalRatingsCount=716,
      createdAt="2026-08-31T22:36:22.813525Z", updatedAt="2026-09-01T14:31:54.323861Z",
    ),
    ClubDto(
      id="8eef12a5-7e4d-4c40-8232-b57517cf767c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Estadio de Atletismo del Turia", address="Cauce del rio Turia, Tramo III, P.º de la Pechina, 36, Extramurs, 46008 Valencia",
      city="Valencia", country="ES",
      latitude=39.47721, longitude=-0.39313,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/883df053-58da-4ba8-b642-97c2a1150ad8_photo.jpg",
      averageRating=4.4, totalRatingsCount=1570,
      createdAt="2026-08-31T22:35:55.478003Z", updatedAt="2026-08-31T22:35:55.478003Z",
    ),
    ClubDto(
      id="d9c92df4-c0a0-48c1-942a-6037a9cd5bc7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting La Pobla Valencia", address="Mas de Tous, Pol. Ind, C. Viena, 9, 46185 La Pobla de Vallbona, Valencia",
      city="Valencia", country="ES",
      latitude=39.5884443, longitude=-0.533538,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96e8079b-34e9-4f2c-b29a-e22852c93d26_photo.jpg",
      averageRating=4.4, totalRatingsCount=1650,
      createdAt="2026-08-31T22:37:44.999712Z", updatedAt="2026-08-31T22:37:44.999712Z",
    ),
    ClubDto(
      id="723f2053-9dfa-4c29-aed7-994184f2187b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Catrina Cocktails & Rock", address="C/ de Cadis, 54, L'Eixample, 46006 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.461416, longitude=-0.373352,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7852a374-4d53-4eb3-a604-467a686b1983_photo.jpg",
      averageRating=4.4, totalRatingsCount=987,
      createdAt="2026-08-31T22:38:09.587272Z", updatedAt="2026-08-31T22:38:09.587272Z",
    ),
    ClubDto(
      id="f4ed41bc-20a2-42d8-856e-005eeb2ef1dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Natural Climb VLC", address="C/ dels Campaners, 6, Patraix, 46014 Valencia",
      city="Valencia", country="ES",
      latitude=39.4559151, longitude=-0.3976793,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/482d43a3-5117-48b7-ac47-e11ef4bb18dd_photo.jpg",
      averageRating=4.4, totalRatingsCount=749,
      createdAt="2026-08-31T22:38:01.091860Z", updatedAt="2026-08-31T22:38:01.091860Z",
    ),
    ClubDto(
      id="2a39c306-cd8f-4729-97c6-f67134f040b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pádel Club Valencia", address="Unidad De Ejecución J, 1, 46185 La Pobla de Vallbona, Valencia",
      city="Valencia", country="ES",
      latitude=39.6017168, longitude=-0.5626708,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/62251994-7290-4827-9680-3695efb3add7_photo.jpg",
      averageRating=4.4, totalRatingsCount=305,
      createdAt="2026-08-31T22:36:30.922649Z", updatedAt="2026-08-31T22:36:30.922649Z",
    ),
    ClubDto(
      id="82740835-51dc-4b5f-a5a9-bf55b5fa0672", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Urban Paintball Valencia", address="Camino Brocheros, s/n, 46184 San Antonio de Benagéber, Valencia",
      city="Valencia", country="ES",
      latitude=39.5616937, longitude=-0.4851609,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a264f151-83dc-4827-9ca2-772333409da0_photo.jpg",
      averageRating=4.4, totalRatingsCount=660,
      createdAt="2026-08-31T22:38:35.758541Z", updatedAt="2026-08-31T22:38:35.758541Z",
    ),
    ClubDto(
      id="3434dc32-be16-409b-b7c2-32459dff68b3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BamVolea Sportcity Valencia - Club de Pádel", address="C/ Del Polideportivo, 2, 46470 Massanassa, Valencia",
      city="Valencia", country="ES",
      latitude=39.4132734, longitude=-0.3901176,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c6c3bb03-710b-485e-ada1-eeb69b6a7780_photo.jpg",
      averageRating=4.3, totalRatingsCount=1156,
      createdAt="2026-08-31T22:36:17.905178Z", updatedAt="2026-09-01T14:31:46.755035Z",
    ),
    ClubDto(
      id="d6dae435-cfb0-4087-ad07-c85a777e43ab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachbol", address="C/ d'Isabel de Villena, 10, Poblats Marítims, 46011 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4734765, longitude=-0.3240481,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c6f1624-80e7-4903-8f76-7e4a4e61512a_photo.jpg",
      averageRating=4.3, totalRatingsCount=949,
      createdAt="2026-08-31T22:36:57.616163Z", updatedAt="2026-08-31T22:36:57.616163Z",
    ),
    ClubDto(
      id="1d3876ac-3a98-45c3-9d42-9db30f8970f2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Parador de El Saler", address="Avinguda dels Pinars, 151, Pobles del Sud, 46012 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.3207526, longitude=-0.3019142,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67a58696-979e-4a09-9daf-163f8766aa53_photo.jpg",
      averageRating=4.3, totalRatingsCount=3363,
      createdAt="2026-08-31T22:37:20.188360Z", updatedAt="2026-08-31T22:37:20.188360Z",
    ),
    ClubDto(
      id="3cb35c00-2a5f-48d1-85e9-3ec077225ada", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo de fútbol Marchalenes", address="C/ de Sant Pancraç, 29, La Saïdia, 46009 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.488332, longitude=-0.3819446,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a305d60-4dab-4ece-b992-88e597a8059c_photo.jpg",
      averageRating=4.2, totalRatingsCount=513,
      createdAt="2026-08-31T22:36:06.147506Z", updatedAt="2026-08-31T22:36:06.147506Z",
    ),
    ClubDto(
      id="d1955480-91d6-460f-84f2-4881fe78490a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasergame 2.0", address="Carrer Accés Pista d'Ademús, 46980 Paterna, Valencia",
      city="Valencia", country="ES",
      latitude=39.5293747, longitude=-0.4402652,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9952d18e-aebe-432f-aba6-b50eed358d1d_photo.jpg",
      averageRating=4.2, totalRatingsCount=341,
      createdAt="2026-08-31T22:38:19.103204Z", updatedAt="2026-08-31T22:38:19.103204Z",
    ),
    ClubDto(
      id="82ceefc8-c1ef-4860-9490-9fb06355497d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pabellón Municipal Benicalap", address="Carrer de Castellonet de la Conquesta, 19, Benicalap, 46025 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4927366, longitude=-0.3855519,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c012ee37-b8a0-4a57-b2a4-c17aa232b9c4_photo.jpg",
      averageRating=4.2, totalRatingsCount=564,
      createdAt="2026-08-31T22:37:03.318727Z", updatedAt="2026-08-31T22:37:03.318727Z",
    ),
    ClubDto(
      id="bc331234-e3d9-4c40-9f06-8cf0b0b46230", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bolera Big Fun", address="Carretera A-3 Salida, 345, 46960 Aldaia, Valencia",
      city="Valencia", country="ES",
      latitude=39.4719113, longitude=-0.4892457,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77df5c48-84ee-4a69-8b7e-10bb5445d9b6_photo.jpg",
      averageRating=4.1, totalRatingsCount=1097,
      createdAt="2026-08-31T22:37:55.577226Z", updatedAt="2026-08-31T22:37:55.577226Z",
    ),
    ClubDto(
      id="644e8ffa-7537-4e06-8aab-a2f93f82e709", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Camp de futbol Apolo", address="Travessia de Pinedo al Mar, 65, Pobles del Sud, 46012 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.421714, longitude=-0.3360412,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1184b09d-75c0-41e5-9367-870893efec38_photo.jpg",
      averageRating=4.1, totalRatingsCount=163,
      createdAt="2026-08-31T22:38:40.568487Z", updatedAt="2026-08-31T22:38:40.568487Z",
    ),
    ClubDto(
      id="be98f32b-9758-481e-8e3b-749c3cc19ad6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Doctor Lluch Football Pitch", address="Carrer del Bloc dels Portuaris, 25, Poblats Marítims, 46011 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4701164, longitude=-0.3271999,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a81f5038-8c0a-4ce7-b4e2-320df53ae45c_photo.jpg",
      averageRating=4.1, totalRatingsCount=483,
      createdAt="2026-08-31T22:36:11.724655Z", updatedAt="2026-08-31T22:36:11.724655Z",
    ),
    ClubDto(
      id="a93480c4-73df-4ce6-8c7a-28ef87ef7eb5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poliesportiu de Benimaclet", address="Carrer de Daniel Balaciart, s/n, Benimaclet, 46020 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4810535, longitude=-0.3544959,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a51b8d9c-9fee-4bf7-92ed-ece131ca3ac2_photo.jpg",
      averageRating=4.1, totalRatingsCount=1301,
      createdAt="2026-08-31T22:36:51.614924Z", updatedAt="2026-08-31T22:36:51.614924Z",
    ),
    ClubDto(
      id="1e69ec4d-6ed2-4517-b43a-0e521d6b5d96", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beniferri Soccer Field", address="Carrer de Favanella, 18, Pobles de l'Oest, 46035 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4930943, longitude=-0.4078678,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cfe42d52-0330-40ae-b632-abdb591505ab_photo.jpg",
      averageRating=4.0, totalRatingsCount=519,
      createdAt="2026-08-31T22:36:00.470100Z", updatedAt="2026-08-31T22:36:00.470100Z",
    ),
    ClubDto(
      id="e65513df-0ff9-4448-9805-1ce982706258", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Racing Dakart Valencia CC Ademuz", address="Av. de la Ilustración, 6, Poblados del Oeste, 46100 Burjasot, Valencia",
      city="Valencia", country="ES",
      latitude=39.5002158, longitude=-0.4086124,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/47ea49d6-8fd1-4769-bbf2-ceec5caf0fbf_photo.jpg",
      averageRating=3.9, totalRatingsCount=2011,
      createdAt="2026-08-31T22:37:40.559470Z", updatedAt="2026-08-31T22:37:40.559470Z",
    ),
    ClubDto(
      id="794eece7-7d0b-42d0-871e-8c7fd4178b6f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bolera Cosmic Bowling", address="Carrer de Josep Maestre, 22, L'Olivereta, 46018 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.465594, longitude=-0.4041749,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a7396421-81b5-4e19-b37b-e4d153c731be_photo.jpg",
      averageRating=3.8, totalRatingsCount=1125,
      createdAt="2026-08-31T22:37:49.610234Z", updatedAt="2026-08-31T22:37:49.610234Z",
    ),
    ClubDto(
      id="3797fb54-0703-4574-8485-688cf94b4fc5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tovar Beach Volley Club", address="C/ d'Isabel de Villena, 16, Poblats Marítims, 46011 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4774698, longitude=-0.3241927,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/791e1f2b-d2b7-4350-92ea-8a39383a2a0c_photo.jpg",
      averageRating=4.8, totalRatingsCount=38,
      createdAt="2026-08-31T22:37:12.968462Z", updatedAt="2026-08-31T22:37:12.968462Z",
    ),
    ClubDto(
      id="bada19b7-9bea-4887-b768-d9d451fb9825", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Valencia Tenis de Mesa City", address="Carrer de Lladró i Mallí, 12, Patraix, 46007 València, Valencia",
      city="Valencia", country="ES",
      latitude=39.4618748, longitude=-0.3889121,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/52f73bd4-715b-4a51-8d69-9a79f8b83c9f_photo.jpg",
      averageRating=4.5, totalRatingsCount=28,
      createdAt="2026-08-31T22:37:34.985549Z", updatedAt="2026-08-31T22:37:34.985549Z",
    ),
  )),
  CitySeo(slug="hamburg", name="Hamburg", country="DE", clubCount=32, sports=listOf(Pair("Volleyball", 5), Pair("Football", 4), Pair("Tennis", 3), Pair("Padel", 3), Pair("Basketball", 2), Pair("Table Tennis", 2), Pair("Karting", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Billiards", 2), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="9f5f5ec4-b62a-4342-8ea9-11649515bcdc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Derbe Flott", address="Paul-Dessau-Straße 3, 22761 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.5629993, longitude=9.9164735,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e704747e-5727-48cb-98f7-1b88adc79406_ChIJzUMrDBeF_0.jpg",
      averageRating=5.0, totalRatingsCount=836,
      createdAt="2026-08-30T21:12:11.526297Z", updatedAt="2026-08-30T21:12:11.526297Z",
    ),
    ClubDto(
      id="182ba575-877b-4ae4-896a-237eb46d8062", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach me Beachvolleyballcamps", address="Bogenstraße 17, 20144 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.5724785, longitude=9.975525,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0190a9c9-9846-4de7-a9fc-6b26d8451e32_photo.jpg",
      averageRating=4.9, totalRatingsCount=98,
      createdAt="2026-08-31T15:10:59.992185Z", updatedAt="2026-08-31T15:10:59.992185Z",
    ),
    ClubDto(
      id="bd933857-0322-42ad-9114-90a9c6ae1e23", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TILTA Lasertag", address="Wittekopsweg 41a, 22415 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.6417322, longitude=10.0108449,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6c58913d-8c61-4433-9f83-7bc9c2051cb1_ChIJk7ZZvkCI_0.jpg",
      averageRating=4.9, totalRatingsCount=586,
      createdAt="2026-08-30T21:12:32.576517Z", updatedAt="2026-08-30T22:01:18.904950Z",
    ),
    ClubDto(
      id="298bf651-8fb3-49ec-95a2-8db699b0a45c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="mitte — dolce vita | Boutique Padel Club", address="Beerenweg 3, 22761 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.5664433, longitude=9.9207232,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/115549f5-8640-4ca1-aa40-d79c5bb8a6e1_ChIJB59PTQCF_0.jpg",
      averageRating=4.9, totalRatingsCount=720,
      createdAt="2026-08-30T21:13:09.988053Z", updatedAt="2026-09-01T14:31:54.792154Z",
    ),
    ClubDto(
      id="d084081c-5fd2-41f6-ac74-b0468d4da3c8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="mitte — the cabrio | Boutique Padel Club", address="Wandsbeker Zollstraße 25-29, 22041 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.575325, longitude=10.0746053,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/216fc3ba-afa6-4d7c-b274-f349224c98b0_ChIJdbd-x8WL_0.jpg",
      averageRating=4.9, totalRatingsCount=506,
      createdAt="2026-08-30T21:13:17.549135Z", updatedAt="2026-09-01T14:31:54.904385Z",
    ),
    ClubDto(
      id="884737ae-8599-40ee-9a18-fc4d4b74c2f1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Lounge Resort", address="Vorlandring 16, 22113 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.5056682, longitude=10.0720618,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/737dcc61-688a-46e4-a946-aad3fd74ecf0_photo.jpg",
      averageRating=4.8, totalRatingsCount=2323,
      createdAt="2026-08-31T15:11:29.277734Z", updatedAt="2026-08-31T15:11:29.277734Z",
    ),
    ClubDto(
      id="072cab36-d960-4196-8578-fbc312a93127", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasertag Hamburg | LaserZone", address="Baurstraße 2, 22605 Hamburg-Altona",
      city="Hamburg", country="DE",
      latitude=53.5577836, longitude=9.9005404,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/402242a3-87af-45dd-83cb-8b456d32ec11_ChIJid4P2GOF_0.jpg",
      averageRating=4.8, totalRatingsCount=4231,
      createdAt="2026-08-30T21:12:25.551371Z", updatedAt="2026-08-30T21:58:22.451447Z",
    ),
    ClubDto(
      id="29fd56c3-e902-4720-866f-726273f013fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nordwandhalle", address="Am Inselpark 20, 21109 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.4943514, longitude=10.0030403,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d8324642-bac6-4b65-9e73-673741475282_ChIJf1aHUCGO_0.jpg",
      averageRating=4.8, totalRatingsCount=1047,
      createdAt="2026-08-30T21:12:04.287153Z", updatedAt="2026-08-30T21:12:04.287153Z",
    ),
    ClubDto(
      id="96001a59-a327-45a9-84c2-62f76d0a7126", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kletterwald Hamburg", address="Meiendorfer Weg 122-128, 22359 Hamburg-Wandsbek",
      city="Hamburg", country="DE",
      latitude=53.6391868, longitude=10.1598901,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/55796e24-5334-4a90-b905-ea1c910712bf_ChIJeYEUpY6K_0.jpg",
      averageRating=4.7, totalRatingsCount=1350,
      createdAt="2026-08-30T21:11:57.338418Z", updatedAt="2026-08-30T21:57:34.804477Z",
    ),
    ClubDto(
      id="02a53760-aa8a-4040-b725-30c655a8e4a3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Soccer in Hamburg GmbH", address="Kieler Str. 565, 22525 Hamburg-Eimsbüttel",
      city="Hamburg", country="DE",
      latitude=53.5990886, longitude=9.916762,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ddad6081-0539-499d-9609-836bbd80dc91_ChIJfxuuT26G_0.jpg",
      averageRating=4.7, totalRatingsCount=812,
      createdAt="2026-08-30T21:11:04.919931Z", updatedAt="2026-08-30T21:11:04.919931Z",
    ),
    ClubDto(
      id="7ad4745e-9b50-4384-86c4-905972778c21", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Paintball Hamburg", address="Bramfelder Ch 84, 22179 Hamburg-Wandsbek",
      city="Hamburg", country="DE",
      latitude=53.5982652, longitude=10.0681078,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fff1ee5e-0ea3-4205-a7a3-da21854463ad_ChIJIyBs_WaJ_0.jpg",
      averageRating=4.6, totalRatingsCount=2824,
      createdAt="2026-08-30T21:12:39.141342Z", updatedAt="2026-08-30T21:12:39.141342Z",
    ),
    ClubDto(
      id="6d9be452-8a03-4f5f-bc34-2ee8bedfc972", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Futuresport Vertriebs GmbH", address="Hinterm Stern 22, 22041 Hamburg-Wandsbek",
      city="Hamburg", country="DE",
      latitude=53.5739584, longitude=10.0680038,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c39bead5-cbd3-468a-a3ee-67eebc894ea5_ChIJXcDDtWaP_0.jpg",
      averageRating=4.6, totalRatingsCount=178,
      createdAt="2026-08-30T21:11:18.923722Z", updatedAt="2026-08-30T21:56:48.472659Z",
    ),
    ClubDto(
      id="663728ec-c4fc-404b-b9a0-70eb8c35c3b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hamburg Pioneers", address="Jahnring 26, 22297 Hamburg-Nord",
      city="Hamburg", country="DE",
      latitude=53.5995849, longitude=10.0174972,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/98c9ceaa-bb1a-4c6a-9dcd-524037f85714_ChIJjyor_9-I_0.jpg",
      averageRating=4.6, totalRatingsCount=166,
      createdAt="2026-08-30T21:11:25.694735Z", updatedAt="2026-08-30T21:57:12.360082Z",
    ),
    ClubDto(
      id="966593d1-0b04-42cf-abe2-9b07395df31f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hanse Padel Hamburg", address="Curslacker Heerweg 265, 21039 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.474624, longitude=10.238149,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/76f1d318-067b-45ec-a54c-142e29aa722a_ChIJ6ye2XHDz_0.jpg",
      averageRating=4.6, totalRatingsCount=180,
      createdAt="2026-08-30T21:13:02.572738Z", updatedAt="2026-08-30T21:57:12.873978Z",
    ),
    ClubDto(
      id="e6337e78-189b-4ee4-a943-984496d262e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolleyballfelder Bülaustraße", address="Bülaustraße 8, 20099 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.5595762, longitude=10.0152761,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6b60ae6f-0a57-4584-a2da-ae93b99cf3c5_photo.jpg",
      averageRating=4.5, totalRatingsCount=71,
      createdAt="2026-08-31T15:10:49.351211Z", updatedAt="2026-08-31T15:10:49.351211Z",
    ),
    ClubDto(
      id="e8400131-55ea-40ac-aad9-c87658ebe39c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Der Club an der Alster e.V. | Tennis, Padel & Hockey", address="Hallerstraße 91, 20149 Hamburg-Eimsbüttel",
      city="Hamburg", country="DE",
      latitude=53.573265, longitude=9.9922428,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/749fa6f8-cc08-4270-8d93-5a892750967e_ChIJFxyt6jGP_0.jpg",
      averageRating=4.5, totalRatingsCount=348,
      createdAt="2026-08-30T21:13:24.653317Z", updatedAt="2026-09-01T14:31:56.749544Z",
    ),
    ClubDto(
      id="c2efc58f-1245-4c16-b7ac-3dab9af31a98", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf club Hamburg Wendlohe", address="Oldesloer Str. 251, 22457 Hamburg-Eimsbüttel",
      city="Hamburg", country="DE",
      latitude=53.657199, longitude=9.9388402,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0943b08d-f599-49cc-8e5c-56b0d7401559_photo.png",
      averageRating=4.5, totalRatingsCount=72,
      createdAt="2026-08-31T15:11:37.410682Z", updatedAt="2026-08-31T15:11:37.410682Z",
    ),
    ClubDto(
      id="a0b714bc-f2d9-4ee5-80a2-86ffedaa95a4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Hamburg", address="Alter Teichweg 220, 22049 Hamburg-Nord",
      city="Hamburg", country="DE",
      latitude=53.5883942, longitude=10.0744683,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4238fecb-a142-41ca-9228-fb26f83a5329_photo.jpg",
      averageRating=4.4, totalRatingsCount=1431,
      createdAt="2026-08-31T15:10:39.987362Z", updatedAt="2026-08-31T15:10:39.987362Z",
    ),
    ClubDto(
      id="2f4d9d82-be9b-4ac4-be8c-0400921de85f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SUNSET BILLARD WANDSBEK", address="Walddörferstraße 110, 22041 Hamburg-Wandsbek",
      city="Hamburg", country="DE",
      latitude=53.5795876, longitude=10.0768447,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cfa20e4b-f227-4553-802a-ab67e356d604_ChIJd1hZEfyL_0.jpg",
      averageRating=4.4, totalRatingsCount=864,
      createdAt="2026-08-30T21:11:37.497143Z", updatedAt="2026-08-30T21:11:37.497143Z",
    ),
    ClubDto(
      id="0d3b9642-97fe-4548-aa60-8c1dc0181acc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sunset Billard Hoheluft", address="Hoheluftchaussee 97, 20253 Hamburg-Eimsbüttel",
      city="Hamburg", country="DE",
      latitude=53.5823787, longitude=9.970963,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6a7b4a17-f2db-47d2-a802-ae9276001deb_ChIJpY6-LbOI_0.jpg",
      averageRating=4.4, totalRatingsCount=1056,
      createdAt="2026-08-30T21:11:31.633613Z", updatedAt="2026-08-30T21:11:31.633613Z",
    ),
    ClubDto(
      id="407f793b-e66c-4cf1-b325-a8f82c30140a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="jumicar Hamburg - Fahrspaß mit Lerneffekt", address="Heestweg 1, 22143 Hamburg-Wandsbek",
      city="Hamburg", country="DE",
      latitude=53.601021, longitude=10.149651,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8f6aa8bf-f6c5-4ed5-b80e-6223cbce63d7_ChIJ0SColwWL_0.jpg",
      averageRating=4.4, totalRatingsCount=439,
      createdAt="2026-08-30T21:12:18.535702Z", updatedAt="2026-08-30T22:02:37.394457Z",
    ),
    ClubDto(
      id="69adabc8-6662-4637-a3c3-c32d2e42bc3a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padelon Hamburg-Rahlstedt", address="Eichberg 59, 22143 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.6155425, longitude=10.1750415,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/015698fc-d20b-4988-94fa-983fa2e7df10_ChIJ2ftvVnaL_0.jpg",
      averageRating=4.3, totalRatingsCount=204,
      createdAt="2026-08-30T21:12:55.872648Z", updatedAt="2026-08-30T21:59:16.483489Z",
    ),
    ClubDto(
      id="3984382d-9e49-4724-8346-79b0b31c72ab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padelon Hamburg-Hummelsbüttel", address="Glashütter Landstraße 43, 22339 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.6525864, longitude=10.0432153,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/72f733e8-118d-450d-bf71-cdde0d31842b_ChIJ-Ucg-8yJ_0.jpg",
      averageRating=4.2, totalRatingsCount=222,
      createdAt="2026-08-30T21:12:47.413652Z", updatedAt="2026-08-30T21:59:16.177145Z",
    ),
    ClubDto(
      id="d581c5ed-cda3-4e60-8d09-8d3995f3e7f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportpark Hamburg Öjendorf", address="Koolbargenredder 31-33, 22117 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.5472773, longitude=10.1412743,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/44353868-92b1-4dad-bd54-b32da35bc7de_ChIJb-SaEtiN_0.jpg",
      averageRating=4.2, totalRatingsCount=674,
      createdAt="2026-08-30T21:11:11.742399Z", updatedAt="2026-09-01T14:32:01.442808Z",
    ),
    ClubDto(
      id="f84e8a8a-1d74-4c08-9b53-161761cdd25f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gilde Bowling Hamburg-Wandsbek", address="Wandsbeker Zollstraße 25-29, 22041 Hamburg-Wandsbek",
      city="Hamburg", country="DE",
      latitude=53.5756874, longitude=10.0742015,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0283c7d9-926e-41dc-92cf-df0334b6da8b_ChIJNxhSF_-L_0.jpg",
      averageRating=4.1, totalRatingsCount=1493,
      createdAt="2026-08-30T21:11:50.494544Z", updatedAt="2026-08-30T21:57:05.356435Z",
    ),
    ClubDto(
      id="d0cf4aeb-c121-48cc-a908-f2ccf37c80ea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="U.S. FUN BOWLING", address="Wagnerstraße 2, 22081 Hamburg-Nord",
      city="Hamburg", country="DE",
      latitude=53.5744786, longitude=10.0357983,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1de4df65-beb3-4919-bb6e-05a3921a6b78_ChIJRfoe-8qO_0.jpg",
      averageRating=4.0, totalRatingsCount=3070,
      createdAt="2026-08-30T21:11:44.110986Z", updatedAt="2026-08-30T22:01:47.360486Z",
    ),
    ClubDto(
      id="51c66773-7c98-4893-bff4-ab4ce1d67019", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Südstrand Hamburg", address="Südring 5C, 22303 Hamburg-Nord",
      city="Hamburg", country="DE",
      latitude=53.59226, longitude=10.01845,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39c8af1c-28da-427a-84ca-bba10898164f_photo.jpg",
      averageRating=4.9, totalRatingsCount=18,
      createdAt="2026-08-31T15:11:21.827097Z", updatedAt="2026-08-31T15:11:21.827097Z",
    ),
    ClubDto(
      id="1b7f3c4a-1822-400d-bcb0-3e1bbd3349b9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolleyballfelder Niendorfer TSV", address="Sootbörn 18P, 22453 Hamburg-Eimsbüttel",
      city="Hamburg", country="DE",
      latitude=53.6150165, longitude=9.9540519,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6be6cc8a-2617-4598-a673-0f443493c790_photo.jpg",
      averageRating=4.7, totalRatingsCount=17,
      createdAt="2026-08-31T15:11:14.172852Z", updatedAt="2026-08-31T15:11:14.172852Z",
    ),
    ClubDto(
      id="9e3d871e-b7cd-4ec7-9a4d-170040243236", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolleyballfeld Eimsbüttler TV", address="Bundesstraße 103, 20144 Hamburg-Eimsbüttel",
      city="Hamburg", country="DE",
      latitude=53.5716765, longitude=9.9651725,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5260c66d-6313-4a67-86d4-2bcb7da3831a_photo.jpg",
      averageRating=4.7, totalRatingsCount=13,
      createdAt="2026-08-31T15:11:06.922923Z", updatedAt="2026-08-31T15:11:06.922923Z",
    ),
    ClubDto(
      id="db4ad8cd-c3fd-4d10-8476-ebb08701b3af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketball court", address="Pinnasberg 81, 20359 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.5463816, longitude=9.9570425,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3efda898-53a9-486b-b261-8c1e10db1a92_photo.jpg",
      averageRating=4.9, totalRatingsCount=11,
      createdAt="2026-08-31T15:10:33.641880Z", updatedAt="2026-08-31T15:10:33.641880Z",
    ),
    ClubDto(
      id="3fc4e034-2a58-4afb-acba-b970028aedd2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TTG Hamburg-Nord Tischtennis (Sporthalle Ohlstedt)", address="Kupferredder 12, 22397 Hamburg-Wandsbek",
      city="Hamburg", country="DE",
      latitude=53.6975087, longitude=10.13608,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e49ccd33-b054-4773-8d48-61e043987c75_photo.png",
      averageRating=4.9, totalRatingsCount=9,
      createdAt="2026-08-31T15:11:41.910612Z", updatedAt="2026-08-31T15:11:41.910612Z",
    ),
    ClubDto(
      id="37daf8de-cb49-42dd-8ecb-72f2fc711e24", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bramfelder Tischtennisvereinigung von 1929 e.V.", address="Edwin-Scharff-Ring 56, 22309 Hamburg",
      city="Hamburg", country="DE",
      latitude=53.6155653, longitude=10.0480833,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7ebf076d-0e75-4f85-aabc-0880c18bf36b_photo.jpg",
      averageRating=4.8, totalRatingsCount=9,
      createdAt="2026-08-31T15:11:49.747378Z", updatedAt="2026-08-31T15:11:49.747378Z",
    ),
  )),
  CitySeo(slug="vienna", name="Vienna", country="AT", clubCount=32, sports=listOf(Pair("Volleyball", 5), Pair("Football", 4), Pair("Padel", 3), Pair("Basketball", 3), Pair("Karting", 2), Pair("Laser Tag", 2), Pair("Climbing", 2), Pair("Table Tennis", 2), Pair("Golf", 2), Pair("Paintball", 2), Pair("Bowling", 2), Pair("Tennis", 2), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="7019b610-691f-43e2-b25d-4538bb6cb95d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="DViennaZ Tischtennis Center - Halle -Wien", address="Längenfeldgasse 68/3/2, 1120 Wien",
      city="Vienna", country="AT",
      latitude=48.1776589, longitude=16.3406773,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a35659e-b324-4653-9f5d-1c6f2affe9b5_photo.jpg",
      averageRating=5.0, totalRatingsCount=127,
      createdAt="2026-08-31T15:00:40.378925Z", updatedAt="2026-08-31T15:00:40.378925Z",
    ),
    ClubDto(
      id="97442d70-498d-44fe-89b1-95c4a8b4a577", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padeldome Alte Donau", address="Arbeiterstrandbadstraße 87A, 1210 Wien",
      city="Vienna", country="AT",
      latitude=48.2450924, longitude=16.4119406,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fb33cadd-9a47-4624-a287-57bb8b375078_ChIJZyZ-ldIH_0.jpg",
      averageRating=4.9, totalRatingsCount=561,
      createdAt="2026-08-30T23:32:52.915118Z", updatedAt="2026-08-31T08:34:09.700599Z",
    ),
    ClubDto(
      id="b2320e80-4f90-43af-a38a-ac7e385445b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Virtual Lasertag / Paintball Wien 1040", address="Waaggasse 2a, 1040 Wien",
      city="Vienna", country="AT",
      latitude=48.1951441, longitude=16.3660717,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6ef9e6d4-a1e8-456b-b93c-86e62ffed538_ChIJYY3ix-QH_0.jpg",
      averageRating=4.8, totalRatingsCount=120,
      createdAt="2026-08-30T23:32:39.450259Z", updatedAt="2026-08-30T23:32:39.450259Z",
    ),
    ClubDto(
      id="73e2cccd-965d-45b3-8f28-bdd7027a910c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BattleKart Wien", address="in der Messe Wien/Parkhaus D/Halle C/Eingang C6, Trabrennstraße 5, 1020 Wien",
      city="Vienna", country="AT",
      latitude=48.2130303, longitude=16.411958,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c779b05-9253-4bce-b3ca-a072f6850708_ChIJHUSlYogH_0.jpg",
      averageRating=4.7, totalRatingsCount=709,
      createdAt="2026-08-30T23:32:20.165020Z", updatedAt="2026-08-31T08:25:56.902625Z",
    ),
    ClubDto(
      id="08abac22-13c9-411d-8fa6-e1be5be81628", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Blockfabrik", address="Schlossgasse 10-12, 1050 Wien",
      city="Vienna", country="AT",
      latitude=48.1905843, longitude=16.3604755,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5efda17-ff0d-42cd-9888-3aae4c70f4e4_ChIJ44qVjCmo_0.jpg",
      averageRating=4.7, totalRatingsCount=1554,
      createdAt="2026-08-30T23:32:07.661586Z", updatedAt="2026-08-31T08:26:19.599314Z",
    ),
    ClubDto(
      id="313c59bd-1e54-4c66-b07c-bdb5d0a4712d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Waldseilpark Kahlenberg", address="Josefsdorf 47, 1190 Wien",
      city="Vienna", country="AT",
      latitude=48.2806175, longitude=16.3340629,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a170008-7d6e-4eaf-b3cd-01d447e54dfe_ChIJ9e_dhTUP_0.jpg",
      averageRating=4.7, totalRatingsCount=2571,
      createdAt="2026-08-30T23:32:01.043511Z", updatedAt="2026-08-31T08:38:59.983306Z",
    ),
    ClubDto(
      id="66bc9635-82aa-4a8e-b86e-59baa76b5e81", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SPEZI SPORTINSEL", address="Sportinsel, 1210 Wien",
      city="Vienna", country="AT",
      latitude=48.2438283, longitude=16.3912336,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/617b1a51-563e-4c72-a78d-2fe5f848d99a_photo.jpg",
      averageRating=4.6, totalRatingsCount=408,
      createdAt="2026-08-31T14:59:32.468445Z", updatedAt="2026-08-31T14:59:32.468445Z",
    ),
    ClubDto(
      id="5798a6c1-251e-42fd-9bca-4baa87b13fee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportcenter Donaucity", address="Arbeiterstrandbadstraße 128, 1220 Wien",
      city="Vienna", country="AT",
      latitude=48.2386558, longitude=16.4220768,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/89618a9e-0ccf-43fd-af70-08655456366c_ChIJpWmQi-kG_0.jpg",
      averageRating=4.6, totalRatingsCount=1434,
      createdAt="2026-08-30T23:31:08.763751Z", updatedAt="2026-09-01T14:31:44.755163Z",
    ),
    ClubDto(
      id="036c3b5d-6d97-4967-b200-722d6ad18e45", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Table Tennis Center Langegasse", address="Lange G. 69, 1080 Wien",
      city="Vienna", country="AT",
      latitude=48.2147025, longitude=16.3508063,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/95705033-b261-47d6-ab8e-abefccf291a2_photo.jpg",
      averageRating=4.6, totalRatingsCount=251,
      createdAt="2026-08-31T15:00:32.619549Z", updatedAt="2026-08-31T15:00:32.619549Z",
    ),
    ClubDto(
      id="6664bce7-5c1e-474b-a582-b0652bf004e3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Club Wien", address="Freudenau 65A, 1020 Wien",
      city="Vienna", country="AT",
      latitude=48.19098, longitude=16.4404285,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db6d38b2-4000-4a67-b007-266af0a99936_photo.jpg",
      averageRating=4.5, totalRatingsCount=155,
      createdAt="2026-08-31T15:00:24.211899Z", updatedAt="2026-08-31T15:00:24.211899Z",
    ),
    ClubDto(
      id="9e20fcec-520d-4d5f-b2a5-f366de836214", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasermaxx", address="Anny Wödl Gasse 3, Anny Wodl Gasse 3, 2700 Wiener Neustadt",
      city="Vienna", country="AT",
      latitude=47.805461, longitude=16.265151,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9b545553-6474-4726-945c-c30c27aee688_ChIJYc_PtnvL_2.jpg",
      averageRating=4.5, totalRatingsCount=346,
      createdAt="2026-08-30T23:32:32.750147Z", updatedAt="2026-08-31T22:11:18.399309Z",
    ),
    ClubDto(
      id="83fbdf82-5cf1-44de-b49b-743133aa5681", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Maxs Paintball Wien", address="Castellezgasse 14, 1020 Wien",
      city="Vienna", country="AT",
      latitude=48.220775, longitude=16.3807782,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/035b0223-6ee8-4b1a-9845-6cf8c73d82cb_ChIJJ8zP66gH_0.jpg",
      averageRating=4.5, totalRatingsCount=91,
      createdAt="2026-08-30T23:32:46.105442Z", updatedAt="2026-08-30T23:32:46.105442Z",
    ),
    ClubDto(
      id="64022f61-2814-4744-ad0d-9930c9603350", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolley Wien", address="Auf der Schmelz, 1150 Wien",
      city="Vienna", country="AT",
      latitude=48.202961, longitude=16.3211914,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d872c9e-bfd2-4ace-af8d-9a16fea6f700_photo.jpg",
      averageRating=4.4, totalRatingsCount=91,
      createdAt="2026-08-31T15:00:03.383348Z", updatedAt="2026-08-31T22:11:14.344566Z",
    ),
    ClubDto(
      id="7414c33c-16ee-4a98-97d7-d9ce3b0fc45f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Blacklite Arena", address="Rautenweg 2, 1220 Wien",
      city="Vienna", country="AT",
      latitude=48.263809, longitude=16.455661,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6a57bbc1-93ae-4a9a-995a-1ce0045481f5_ChIJDXPODu8F_0.jpg",
      averageRating=4.4, totalRatingsCount=1900,
      createdAt="2026-08-30T23:32:26.407067Z", updatedAt="2026-08-30T23:32:26.407067Z",
    ),
    ClubDto(
      id="c3a71322-b3db-4f19-8457-365bb4d61047", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golfclub Marco Polo Vienna", address="Ruthnergasse 170, 1210 Wien",
      city="Vienna", country="AT",
      latitude=48.2825197, longitude=16.4276673,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/944c9d87-21a6-4c76-ac0e-c1e739259915_photo.jpg",
      averageRating=4.4, totalRatingsCount=289,
      createdAt="2026-08-31T15:00:17.019033Z", updatedAt="2026-08-31T15:00:17.019033Z",
    ),
    ClubDto(
      id="afb51608-0ed7-42b9-b9fb-5122e86e4bc6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padeldome Erdberg", address="Franzosengraben 2, 1030 Wien",
      city="Vienna", country="AT",
      latitude=48.1897969, longitude=16.4139065,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4a1225fa-6445-4310-a8a7-821f77a6d9b1_ChIJv5tjTlcH_0.jpg",
      averageRating=4.4, totalRatingsCount=295,
      createdAt="2026-08-30T23:33:06.447492Z", updatedAt="2026-08-31T08:34:11.022079Z",
    ),
    ClubDto(
      id="65600fb2-596a-46c5-a771-05f79e18026d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pointers Vienna", address="Resselgasse 5, 1040 Wien",
      city="Vienna", country="AT",
      latitude=48.1989549, longitude=16.3685097,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4af4328d-2498-495d-bdc4-bca619e8b3fe_ChIJWTanEIMH_0.jpg",
      averageRating=4.4, totalRatingsCount=1072,
      createdAt="2026-08-30T23:31:15.167667Z", updatedAt="2026-08-31T08:34:49.370500Z",
    ),
    ClubDto(
      id="436bbc04-c06e-4b25-8e6a-24990635be01", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportzentrum Marswiese", address="Neuwaldegger Str. 57A, 1170 Wien",
      city="Vienna", country="AT",
      latitude=48.239531, longitude=16.276894,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d136ef60-284b-4a51-ac4e-6bd6d6bba882_ChIJraFsR6sJ_0.jpg",
      averageRating=4.4, totalRatingsCount=842,
      createdAt="2026-08-30T23:31:21.403776Z", updatedAt="2026-08-31T08:36:48.871926Z",
    ),
    ClubDto(
      id="195963a8-aa6c-4508-88fd-b384f1b10425", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Point Vienna", address="Baumgasse 87, 1030 Wien",
      city="Vienna", country="AT",
      latitude=48.1906983, longitude=16.410178,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ab507830-3c74-4b1e-aae0-1da2486c1328_ChIJtTizF1oH_1.jpg",
      averageRating=4.4, totalRatingsCount=524,
      createdAt="2026-08-30T23:33:20.349403Z", updatedAt="2026-08-31T22:11:22.594308Z",
    ),
    ClubDto(
      id="3dfb5b54-d10f-40c5-ba56-60225dc16c21", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vienna D.C. Timberwolves - Wolves Dome", address="Bernoullistraße 9, 1220 Wien",
      city="Vienna", country="AT",
      latitude=48.2405621, longitude=16.4439432,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1435ccec-d191-45fd-9cdc-be8a663c930d_photo.jpg",
      averageRating=4.4, totalRatingsCount=194,
      createdAt="2026-08-31T14:59:18.545929Z", updatedAt="2026-08-31T14:59:18.545929Z",
    ),
    ClubDto(
      id="c57f2c1a-ddd4-4abf-b759-6dbf5215a956", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Millennium City", address="Handelskai 94-96, 1200 Wien",
      city="Vienna", country="AT",
      latitude=48.240616, longitude=16.3857577,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3aae7558-ef4a-4f65-a4b9-e25eeab701fb_ChIJ5UxO7FoG_0.jpg",
      averageRating=4.3, totalRatingsCount=10810,
      createdAt="2026-08-30T23:31:46.726553Z", updatedAt="2026-08-31T08:32:55.418570Z",
    ),
    ClubDto(
      id="24cd3d57-71f6-47fb-8553-0e89112d5793", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Monza", address="Hochwassergasse 12, 1230 Wien",
      city="Vienna", country="AT",
      latitude=48.1481437, longitude=16.3583522,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ba01ef7-9870-44bc-8fc7-f69219fabf11_ChIJ1b7Vjgip_0.jpg",
      averageRating=4.3, totalRatingsCount=1026,
      createdAt="2026-08-30T23:32:13.891339Z", updatedAt="2026-08-30T23:32:13.891339Z",
    ),
    ClubDto(
      id="d9b67a77-afd5-4b52-bf5b-509d3ca2e9aa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Racketworld", address="Park & Ride 3.OG, Kendlerstraße 47, 1160 Wien",
      city="Vienna", country="AT",
      latitude=48.2060596, longitude=16.3093151,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/258b7e4b-4922-4291-86ef-e67411dbcad2_ChIJsYSGIUYJ_0.jpg",
      averageRating=4.3, totalRatingsCount=302,
      createdAt="2026-08-30T23:32:59.673109Z", updatedAt="2026-08-30T23:32:59.673109Z",
    ),
    ClubDto(
      id="82892e51-8931-4c38-960b-9907190caceb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Spielmanngasse Beachvolleyball-Halle", address="Spielmanngasse 8, 1200 Wien",
      city="Vienna", country="AT",
      latitude=48.2426115, longitude=16.3709207,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1b7655ae-53d4-48d1-a50e-53454034d3d9_photo.jpg",
      averageRating=4.3, totalRatingsCount=111,
      createdAt="2026-08-31T14:59:48.438806Z", updatedAt="2026-08-31T14:59:48.438806Z",
    ),
    ClubDto(
      id="d4952dc9-d6df-4a83-ac9e-48451784ca50", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport & Fun Donaustadt", address="Erzherzog-Karl-Straße 108, 1220 Wien",
      city="Vienna", country="AT",
      latitude=48.2294989, longitude=16.4507157,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/23dd1f7c-bd5c-4e2a-a591-5eccd7359847_photo.jpg",
      averageRating=4.3, totalRatingsCount=431,
      createdAt="2026-08-31T14:59:56.124952Z", updatedAt="2026-08-31T14:59:56.124952Z",
    ),
    ClubDto(
      id="0e3100e4-b4ae-4d2c-8a68-b4162137eb9d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Westside Soccer Arena", address="Bahnhofstraße 1D, 1140 Wien",
      city="Vienna", country="AT",
      latitude=48.1999599, longitude=16.2641838,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0e60ff93-8e20-4b6d-bdc2-e6073e8af24a_ChIJ5XIJxwOn_0.jpg",
      averageRating=4.3, totalRatingsCount=612,
      createdAt="2026-08-30T23:31:28.482973Z", updatedAt="2026-08-30T23:31:28.482973Z",
    ),
    ClubDto(
      id="6d8bb7ea-739a-479e-94c7-46ebcfaf833d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Postsportverein Wien", address="Roggendorfgasse 2, 1170 Wien",
      city="Vienna", country="AT",
      latitude=48.22332, longitude=16.3246707,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cbb1ebae-4a35-4bc9-a0f2-d8debbc59137_ChIJdR-Jv3YI_2.jpg",
      averageRating=4.2, totalRatingsCount=314,
      createdAt="2026-08-30T23:33:27.643984Z", updatedAt="2026-08-31T22:11:20.801856Z",
    ),
    ClubDto(
      id="9411c15c-835c-4fe5-8f2b-700d56ce954a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport & Fun Halle Favoriten", address="Windtenstraße 2, 1100 Wien",
      city="Vienna", country="AT",
      latitude=48.1689296, longitude=16.3553773,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d04b0e1f-ce4b-41bf-a25d-eeb3c429e56b_photo.jpg",
      averageRating=4.1, totalRatingsCount=150,
      createdAt="2026-08-31T14:59:25.269283Z", updatedAt="2026-08-31T14:59:25.269283Z",
    ),
    ClubDto(
      id="2c094db1-002d-4629-b046-d5ab1c498fb0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="die Allee", address="Hauptallee 124, 1020 Wien",
      city="Vienna", country="AT",
      latitude=48.2108771, longitude=16.4048696,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/587da8e3-e0b5-42f7-b936-1e657a97645f_ChIJOb5QgRYH_0.jpg",
      averageRating=4.1, totalRatingsCount=2743,
      createdAt="2026-08-30T23:31:54.232603Z", updatedAt="2026-08-31T08:39:29.178075Z",
    ),
    ClubDto(
      id="8df57799-693b-4cff-a176-279b0b80e981", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hit & Hope", address="Seyringer Str. 6-8/Top 4, 1210 Wien",
      city="Vienna", country="AT",
      latitude=48.26557, longitude=16.4556782,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d4cc9077-e9e7-40a0-b048-8f7791e69d74_ChIJGalBA7UF_0.jpg",
      averageRating=4.0, totalRatingsCount=568,
      createdAt="2026-08-30T23:31:40.520930Z", updatedAt="2026-08-31T08:29:01.521609Z",
    ),
    ClubDto(
      id="9522b4c2-a59b-43bd-8249-2671ae3cdc77", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach and Racket Sport Eden", address="An der Schanze 7, 1210 Wien",
      city="Vienna", country="AT",
      latitude=48.2490382, longitude=16.4159503,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db3dcfec-c984-4f9c-8e19-53b92625ed3f_photo.png",
      averageRating=4.5, totalRatingsCount=42,
      createdAt="2026-08-31T14:59:41.984702Z", updatedAt="2026-08-31T14:59:41.984702Z",
    ),
    ClubDto(
      id="a377c78e-5a5d-4ee8-b93f-2439f865c597", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolleyballfeld am Handelskai", address="Handelskai 385, 1020 Wien",
      city="Vienna", country="AT",
      latitude=48.2126946, longitude=16.4234099,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0fa1d571-18b0-4555-a6e7-af14e52ac609_photo.jpg",
      averageRating=4.5, totalRatingsCount=6,
      createdAt="2026-08-31T15:00:09.124211Z", updatedAt="2026-08-31T15:00:09.124211Z",
    ),
  )),
  CitySeo(slug="birmingham", name="Birmingham", country="GB", clubCount=32, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Volleyball", 3), Pair("Padel", 3), Pair("Basketball", 3), Pair("Table Tennis", 2), Pair("Golf", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Laser Tag", 2), Pair("Karting", 2), Pair("Paintball", 1), Pair("Climbing", 1)), clubs=listOf(
    ClubDto(
      id="f0201a50-1ba5-45a7-aba8-50c8b4b50968", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Conflict", address="Brickyard Ln, Studley B80 7EE",
      city="Birmingham", country="GB",
      latitude=52.2728843, longitude=-1.9114105,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1339b0b-f4f4-4322-a4bd-6d6138d0e198_photo.jpg",
      averageRating=5.0, totalRatingsCount=308,
      createdAt="2026-08-31T23:03:16.204569Z", updatedAt="2026-08-31T23:03:16.204569Z",
    ),
    ClubDto(
      id="0f52fe8c-e7d7-41e3-8092-f822de75fd57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Padel Loft Aston", address="The Padel Loft, Aston, Car Park, 5 Holt St, Birmingham B7 4BH",
      city="Birmingham", country="GB",
      latitude=52.4880329, longitude=-1.8891754,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5958a28e-93de-48a9-b45d-88eb1f155de2_photo.jpg",
      averageRating=5.0, totalRatingsCount=180,
      createdAt="2026-08-31T23:01:30.719597Z", updatedAt="2026-08-31T23:01:30.719597Z",
    ),
    ClubDto(
      id="a2fcd4b0-f3c2-4d59-9111-02d82812ebfd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pure Padel Solihull", address="Pure Padel, Streetsbrook Rd, Shirley, Solihull B90 3PE",
      city="Birmingham", country="GB",
      latitude=52.4227367, longitude=-1.8239203,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b5e7877c-f50f-4997-96c3-dfab1fd613d7_photo.jpg",
      averageRating=4.9, totalRatingsCount=73,
      createdAt="2026-08-31T23:01:38.114846Z", updatedAt="2026-08-31T23:01:38.114846Z",
    ),
    ClubDto(
      id="68692be6-c569-4057-bb2a-2b6deb84dedf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Birmingham Table Tennis Academy", address="20 Great King St N, Birmingham B19 2LF",
      city="Birmingham", country="GB",
      latitude=52.4952405, longitude=-1.9064893,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/79331e6b-ac8a-459e-964a-c7e1dc67496a_photo.jpg",
      averageRating=4.8, totalRatingsCount=57,
      createdAt="2026-08-31T23:02:27.558019Z", updatedAt="2026-08-31T23:02:27.558019Z",
    ),
    ClubDto(
      id="46971ecb-7776-4e7f-ab9f-32f8b75dc2da", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Yardley Tennis Club", address="Queens Rd, Yardley, Birmingham B26 2AH",
      city="Birmingham", country="GB",
      latitude=52.4724831, longitude=-1.802225,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fca369f1-dc82-40b6-a345-fe025abdc916_photo.jpg",
      averageRating=4.8, totalRatingsCount=82,
      createdAt="2026-08-31T23:01:25.247720Z", updatedAt="2026-08-31T23:01:25.247720Z",
    ),
    ClubDto(
      id="6405dc56-e38b-48a0-ad11-a6e289b590ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Goals Birmingham Star City", address="31 Watson Rd, Nechells, Birmingham B7 5SA",
      city="Birmingham", country="GB",
      latitude=52.5050659, longitude=-1.8545056,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c4bb576a-56a4-4fd2-bb87-0de06db69049_photo.jpg",
      averageRating=4.7, totalRatingsCount=766,
      createdAt="2026-08-31T23:01:02.367065Z", updatedAt="2026-08-31T23:01:02.367065Z",
    ),
    ClubDto(
      id="c3b9b2ca-2d04-42ae-a9fb-09eb90234d17", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rock Up – Climbing centre & soft play – Birmingham", address="Broadway Plaza, 220 Ladywood Middleway, Birmingham B16 8LP",
      city="Birmingham", country="GB",
      latitude=52.4736328, longitude=-1.922138,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0e5349d2-7c0d-4bed-8c47-36fffcbf0ee0_photo.jpg",
      averageRating=4.7, totalRatingsCount=1148,
      createdAt="2026-08-31T23:02:56.004104Z", updatedAt="2026-08-31T23:02:56.004104Z",
    ),
    ClubDto(
      id="8adef712-0f1d-40d7-b46e-459402727060", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Delta Force Paintball Birmingham", address="Cut Throat Ln, Birmingham B94 6SE",
      city="Birmingham", country="GB",
      latitude=52.3543591, longitude=-1.8067173,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0666b0ad-611c-41d5-b805-defa04f18ba8_photo.jpg",
      averageRating=4.6, totalRatingsCount=2174,
      createdAt="2026-08-31T23:03:22.666632Z", updatedAt="2026-08-31T23:03:22.666632Z",
    ),
    ClubDto(
      id="f1625e2c-a51a-400d-bd8a-c8e082ecbbd2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Goals Birmingham Perry Barr", address="tameside park, Aldridge Rd, Birmingham B42 2UB",
      city="Birmingham", country="GB",
      latitude=52.5266652, longitude=-1.8936539,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7e854b44-cbd2-4774-8c08-969f0bc85686_photo.jpg",
      averageRating=4.6, totalRatingsCount=923,
      createdAt="2026-08-31T23:00:58.050897Z", updatedAt="2026-08-31T23:00:58.050897Z",
    ),
    ClubDto(
      id="783bfdd3-f06b-49c0-890b-4b9c1c97f77d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bromsgrove Golf Centre", address="Old Stratford Rd, Bromsgrove B60 1LD",
      city="Birmingham", country="GB",
      latitude=52.3368898, longitude=-2.0452066,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e9172d9c-3111-42c6-bcf0-f911f9548653_photo.jpg",
      averageRating=4.5, totalRatingsCount=924,
      createdAt="2026-08-31T23:02:17.965722Z", updatedAt="2026-08-31T23:02:17.965722Z",
    ),
    ClubDto(
      id="94e95aec-2e6c-403a-a05b-7e4859188d38", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Felsons - Birmingham", address="266 Broad St, Birmingham B1 2DS",
      city="Birmingham", country="GB",
      latitude=52.4777968, longitude=-1.9107187,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2d459a0f-b306-4d4e-ad4b-afcf49e01435_photo.jpg",
      averageRating=4.5, totalRatingsCount=459,
      createdAt="2026-08-31T23:03:00.597754Z", updatedAt="2026-08-31T23:03:00.597754Z",
    ),
    ClubDto(
      id="65229fa0-a1d6-4ec2-bacf-d165c8d99401", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sutton Coldfield Tennis", address="Highbridge Rd, The Royal Town of Sutton Coldfield, Birmingham, Sutton Coldfield B73 5QB",
      city="Birmingham", country="GB",
      latitude=52.5500184, longitude=-1.8280711,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5c025e40-5b99-48e2-a274-608b8ca3af63_photo.jpg",
      averageRating=4.5, totalRatingsCount=121,
      createdAt="2026-08-31T23:01:20.616848Z", updatedAt="2026-09-01T14:31:45.990285Z",
    ),
    ClubDto(
      id="49974a1f-d4a5-4f98-9d91-d08e0c62e529", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Edgbaston Priory Club", address="Sir Harrys Rd, Birmingham B15 2UZ",
      city="Birmingham", country="GB",
      latitude=52.4588966, longitude=-1.9126163,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/505cdb19-d66b-46fe-90d7-0374b2c9356f_photo.jpg",
      averageRating=4.5, totalRatingsCount=570,
      createdAt="2026-08-31T23:01:11.845306Z", updatedAt="2026-08-31T23:01:11.845306Z",
    ),
    ClubDto(
      id="6b2e8aaa-7243-4ead-a45f-b6f4b6156d45", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="West Warwickshire Sports Complex", address="78 Grange Rd, Solihull B91 1DA",
      city="Birmingham", country="GB",
      latitude=52.4291038, longitude=-1.806728,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4f30e693-4426-4073-a7fa-9d28aa298da7_photo.jpg",
      averageRating=4.5, totalRatingsCount=502,
      createdAt="2026-08-31T23:02:03.124129Z", updatedAt="2026-08-31T23:02:03.124129Z",
    ),
    ClubDto(
      id="10e277b3-7712-42b3-ac31-b0247f750472", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bishop Challoner Sports Centre", address="Institute Rd, King's Heath, Birmingham B14 7EG",
      city="Birmingham", country="GB",
      latitude=52.4334282, longitude=-1.8912443,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d63b8c7f-4d05-4719-a20f-8b7abe56e31c_photo.jpg",
      averageRating=4.4, totalRatingsCount=114,
      createdAt="2026-08-31T23:02:07.712038Z", updatedAt="2026-08-31T23:02:07.712038Z",
    ),
    ClubDto(
      id="ec8b1106-fb87-43d0-8239-acfea75a65d0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Powerleague Birmingham", address="Stadium, Lichfield Rd, Aston, Birmingham, Salford B6 7TG",
      city="Birmingham", country="GB",
      latitude=52.5082717, longitude=-1.864683,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a8a0a8d3-f748-4e97-a151-c3469d6df07f_photo.jpg",
      averageRating=4.4, totalRatingsCount=1155,
      createdAt="2026-08-31T23:00:53.325423Z", updatedAt="2026-08-31T23:00:53.325423Z",
    ),
    ClubDto(
      id="58f6b02c-d742-4cb3-864f-3b8eb151d0e7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stonebridge Golf Club", address="Somers Rd, Meriden, Coventry CV7 7PL",
      city="Birmingham", country="GB",
      latitude=52.4392871, longitude=-1.6694913,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a28f20c1-05ac-4e76-96ef-f8d0088168c6_photo.jpg",
      averageRating=4.4, totalRatingsCount=787,
      createdAt="2026-08-31T23:02:22.133170Z", updatedAt="2026-08-31T23:02:22.133170Z",
    ),
    ClubDto(
      id="a99f51f4-62e2-4066-a29f-8f863a3f2379", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TeamSport Go Karting Birmingham", address="Park Lane Industrial Estate, Park Ln, Oldbury B69 4JX",
      city="Birmingham", country="GB",
      latitude=52.4988267, longitude=-2.0148947,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/845bf82f-73f9-46db-8cdb-41472c3c5b3a_photo.jpg",
      averageRating=4.4, totalRatingsCount=3208,
      createdAt="2026-08-31T23:02:36.912427Z", updatedAt="2026-08-31T23:02:36.912427Z",
    ),
    ClubDto(
      id="a3b9720d-fd8f-4d24-9401-e6c9b1c3fc3a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Teamworks Birmingham City: Karting - Laser Tag - Simulator Racing", address="202 Fazeley St, Birmingham B5 5SE",
      city="Birmingham", country="GB",
      latitude=52.477966, longitude=-1.8813407,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5cb97e9b-ec6f-4dab-ba90-5008e35a16cb_photo.jpg",
      averageRating=4.4, totalRatingsCount=1436,
      createdAt="2026-08-31T23:02:41.465005Z", updatedAt="2026-08-31T23:02:41.465005Z",
    ),
    ClubDto(
      id="23971e47-ed1e-4b69-aa76-18fc2a1638a0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billesley Tennis and Fitness Centre", address="Wheelers Ln, Billesley, Birmingham B13 0ST",
      city="Birmingham", country="GB",
      latitude=52.4285723, longitude=-1.8764139,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a111c8ce-62fd-4ae3-b387-2358f2f14da7_photo.jpg",
      averageRating=4.3, totalRatingsCount=349,
      createdAt="2026-08-31T23:01:16.370214Z", updatedAt="2026-08-31T23:01:16.370214Z",
    ),
    ClubDto(
      id="fcd59270-d2f0-4697-9ffd-10835de31ccb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Birmingham City Football Club", address="St. Andrews Stadium, Cattell Rd, Birmingham B9 4RL",
      city="Birmingham", country="GB",
      latitude=52.4751008, longitude=-1.8687358,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/88ebd926-b839-41d5-8d2b-cd78d05006bf_photo.jpg",
      averageRating=4.3, totalRatingsCount=1721,
      createdAt="2026-08-31T23:00:49.258242Z", updatedAt="2026-08-31T23:00:49.258242Z",
    ),
    ClubDto(
      id="43480cb3-abce-4fae-891b-49cb965210ce", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hollyfields Sports & Conference Centre", address="Woodacre Rd, Erdington, Birmingham B24 0JT",
      city="Birmingham", country="GB",
      latitude=52.5226346, longitude=-1.8192817,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f914453a-3e45-4631-8cdd-b4be83633f8a_photo.jpg",
      averageRating=4.3, totalRatingsCount=364,
      createdAt="2026-08-31T23:01:06.919278Z", updatedAt="2026-08-31T23:01:06.919278Z",
    ),
    ClubDto(
      id="4d32bdd0-3699-45fe-b097-1a0f7db400bc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Shenley Lane Community Association & Sports Centre", address="472 Shenley Ln, Birmingham B29 4HZ",
      city="Birmingham", country="GB",
      latitude=52.4227531, longitude=-1.9673758,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a632210d-3f15-4963-9f01-cfca9b43187b_photo.jpg",
      averageRating=4.3, totalRatingsCount=89,
      createdAt="2026-08-31T23:02:12.622633Z", updatedAt="2026-08-31T23:02:12.622633Z",
    ),
    ClubDto(
      id="a1081328-c755-4c63-a17d-a6d981eecf75", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SnowHill Snooker Centre", address="141 Fazeley St, Birmingham B5 5RX",
      city="Birmingham", country="GB",
      latitude=52.4787169, longitude=-1.8838464,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/871ea07e-e310-41a4-8499-b56b4f85ffff_photo.jpg",
      averageRating=4.3, totalRatingsCount=324,
      createdAt="2026-08-31T23:03:05.951976Z", updatedAt="2026-08-31T23:03:05.951976Z",
    ),
    ClubDto(
      id="a727d9d5-270d-4b42-9976-58d933e0ea88", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Cube", address="196 Wharfside St, Birmingham B1 1RN",
      city="Birmingham", country="GB",
      latitude=52.4747919, longitude=-1.906877,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d37560dd-0b6f-46e5-ad7a-61de6fac6ebd_photo.jpg",
      averageRating=4.3, totalRatingsCount=2381,
      createdAt="2026-08-31T23:02:51.215169Z", updatedAt="2026-08-31T23:02:51.215169Z",
    ),
    ClubDto(
      id="63f3e4ce-c339-49f4-a7ed-913b714902f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Sir Doug Ellis Woodcock Sports Centre", address="Woodcock St, Birmingham B4 7ET",
      city="Birmingham", country="GB",
      latitude=52.4858952, longitude=-1.8866781,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/861df361-7991-4bb3-8d0d-66991eedaa27_photo.jpg",
      averageRating=4.3, totalRatingsCount=401,
      createdAt="2026-08-31T23:01:52.649181Z", updatedAt="2026-08-31T23:01:52.649181Z",
    ),
    ClubDto(
      id="2bda3617-f6ef-48a5-8787-d2e95b5fa15c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Core Padel", address="Redfern Rd, Tyseley, Birmingham B11 2BE",
      city="Birmingham", country="GB",
      latitude=52.4576097, longitude=-1.843559,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fbdb3eb9-65bd-4be9-b550-83a68b3d8859_photo.jpg",
      averageRating=4.2, totalRatingsCount=65,
      createdAt="2026-08-31T23:01:43.498382Z", updatedAt="2026-08-31T23:01:43.498382Z",
    ),
    ClubDto(
      id="bf486f4b-e428-44a8-bbcc-3a50649ed34a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Doug Ellis Sports Centre", address="Aldridge Rd, Perry Barr, Birmingham B42 2TP",
      city="Birmingham", country="GB",
      latitude=52.5198208, longitude=-1.8943933,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f4c30c40-f18a-4e31-be18-56985e7d7231_photo.jpg",
      averageRating=4.2, totalRatingsCount=278,
      createdAt="2026-08-31T23:01:57.464507Z", updatedAt="2026-08-31T23:01:57.464507Z",
    ),
    ClubDto(
      id="28a9f7f6-2ed1-49f1-bccb-ad118348dee6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hollywood Bowl Birmingham Rubery", address="Great Park, Park Way, Rubery, Birmingham B45 9FP",
      city="Birmingham", country="GB",
      latitude=52.3996887, longitude=-2.0057911,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ce8fc191-5808-4b17-947a-94bf3e75507b_photo.jpg",
      averageRating=4.2, totalRatingsCount=2758,
      createdAt="2026-08-31T23:02:46.424273Z", updatedAt="2026-08-31T23:02:46.424273Z",
    ),
    ClubDto(
      id="7c967cfd-57e2-4292-a742-77aa09dcdc21", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Quest Birmingham", address="Westley Rd, Acocks Green, Birmingham B27 7UH",
      city="Birmingham", country="GB",
      latitude=52.4458452, longitude=-1.8248726,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a8cdfd67-8b51-4a45-840d-74aec8f39adf_photo.jpg",
      averageRating=4.2, totalRatingsCount=351,
      createdAt="2026-08-31T23:03:10.605021Z", updatedAt="2026-08-31T23:03:10.605021Z",
    ),
    ClubDto(
      id="362931d1-de77-491a-8300-3bbd7b3ac742", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stechford Leisure Centre", address="Station Rd, Stechford, Birmingham B33 8QN",
      city="Birmingham", country="GB",
      latitude=52.4818937, longitude=-1.8082648,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e24e82ae-e126-4c28-a896-4585e1c32a5f_photo.jpg",
      averageRating=3.8, totalRatingsCount=1124,
      createdAt="2026-08-31T23:01:47.851427Z", updatedAt="2026-08-31T23:01:47.851427Z",
    ),
    ClubDto(
      id="88dc68e3-a1a4-473e-9f7c-1b1a2f6c7e68", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cheslyn Hay Table Tennis Club", address="Salem Church Rear of Church WALSALL 7AB, High St, Cheslyn Hay, Walsall WS6 7AD",
      city="Birmingham", country="GB",
      latitude=52.6603766, longitude=-2.0324434,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5975d55b-9c55-491d-b686-7bf146c00c47_photo.jpg",
      averageRating=4.7, totalRatingsCount=10,
      createdAt="2026-08-31T23:02:31.771160Z", updatedAt="2026-08-31T23:02:31.771160Z",
    ),
  )),
  CitySeo(slug="warsaw", name="Warsaw", country="PL", clubCount=31, sports=listOf(Pair("Football", 4), Pair("Volleyball", 4), Pair("Padel", 3), Pair("Tennis", 3), Pair("Billiards", 2), Pair("Karting", 2), Pair("Basketball", 2), Pair("Laser Tag", 2), Pair("Paintball", 2), Pair("Bowling", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="b5314f88-0838-4585-8cc0-605dd595ed84", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GRINDHOUSE - Treningi Koszykówki | Trener Przygotowania Motorycznego", address="Jutrzenki 114E/LU01, 02-231 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.1934317, longitude=20.9331513,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f2de3d13-14a1-4753-bc75-c7b51357d272_photo.jpg",
      averageRating=5.0, totalRatingsCount=130,
      createdAt="2026-08-31T14:54:38.932449Z", updatedAt="2026-08-31T14:54:38.932449Z",
    ),
    ClubDto(
      id="67d0d39d-0422-4aa5-9868-229a9a869cad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cybermachina Warszawa", address="Nowy Świat 52/56, 00-369 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2351763, longitude=21.01891,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d520ec36-f5e3-4263-91a1-dc68bd9f596e_ChIJ7UVAibjN_0.jpg",
      averageRating=4.7, totalRatingsCount=2803,
      createdAt="2026-08-30T21:25:28.875941Z", updatedAt="2026-08-30T21:56:21.621185Z",
    ),
    ClubDto(
      id="a7447d03-53dd-410c-9837-c548a1d8d46c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GAMP PAINTBALL LASER TAG", address="Kazimierza Gierdziejewskiego 5/272a, 02-495 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2055677, longitude=20.873946,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f94043f3-8f54-45ba-bc03-30c59a1a9fd9_ChIJRxWHESU1_0.jpg",
      averageRating=4.7, totalRatingsCount=543,
      createdAt="2026-08-30T21:26:47.160456Z", updatedAt="2026-08-30T21:26:47.160456Z",
    ),
    ClubDto(
      id="ced5178a-30f4-4424-9371-9719188d7b8b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KillHouse", address="Trakt Lubelski 158, 04-790 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.1925813, longitude=21.1397683,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7d1e962a-4708-43ed-8413-0acc564768e5_ChIJGwu-fDTM_0.jpg",
      averageRating=4.7, totalRatingsCount=713,
      createdAt="2026-08-30T21:26:32.712296Z", updatedAt="2026-08-30T21:57:33.511982Z",
    ),
    ClubDto(
      id="f6f1aee8-1537-4c21-88fe-a3f5c45db261", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Murall Annopol Centrum Wspinaczkowe", address="Annopol 3, 03-236 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.3023426, longitude=21.0199765,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e2ad7a8-6803-4102-9936-6946c74f08a7_ChIJ0xhf5EnJ_0.jpg",
      averageRating=4.7, totalRatingsCount=2663,
      createdAt="2026-08-30T21:26:05.051806Z", updatedAt="2026-08-30T21:58:43.747658Z",
    ),
    ClubDto(
      id="65249999-c955-455f-8130-36a87b601bc4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Olympic Golf Club", address="Wybrzeże Gdyńskie 2, 03-131 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.270124, longitude=21.00142,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/64fba9bb-d42a-4486-8e97-6a48b886c053_photo.jpg",
      averageRating=4.7, totalRatingsCount=238,
      createdAt="2026-08-31T14:55:24.546502Z", updatedAt="2026-08-31T14:55:24.546502Z",
    ),
    ClubDto(
      id="6bc7bb7b-7394-444e-aaea-3ec837c8cea0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Propadel Jutrzenki", address="Jutrzenki 12, 02-233 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.1782132, longitude=20.9218153,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/854a2ede-de24-4856-8504-3fb62186e3a0_ChIJj_SNIps0_0.jpg",
      averageRating=4.7, totalRatingsCount=240,
      createdAt="2026-08-30T21:27:09.519708Z", updatedAt="2026-08-30T21:59:40.282470Z",
    ),
    ClubDto(
      id="28bf8808-26db-4118-843c-2dba19bb9223", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Warsaw Padel Club - Padel & Squash", address="Annopol 3, 03-236 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.3030526, longitude=21.0194602,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83cd891d-cf96-4d6f-9ffa-44be60780381_ChIJLYgwfgDJ_0.jpg",
      averageRating=4.7, totalRatingsCount=348,
      createdAt="2026-08-30T21:26:54.577197Z", updatedAt="2026-08-30T22:02:25.697383Z",
    ),
    ClubDto(
      id="19d80acb-8022-454d-ab86-1092ca98812e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="A1Karting - Największy tor kartingowy | Organizacja eventów | Szkoła kartingowa | Symulatory | Miasteczko ruchu", address="Annopol 24B, 03-236 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.3153613, longitude=21.0150618,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ab96941-8281-42d2-bc2a-6ea34100dcc0_ChIJP1bXBQXM_0.jpg",
      averageRating=4.6, totalRatingsCount=3502,
      createdAt="2026-08-30T21:26:11.549035Z", updatedAt="2026-08-30T21:55:08.433508Z",
    ),
    ClubDto(
      id="45cf8046-ab60-4005-89e2-89b4547a0a2d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="WTS DeSki Klub Sportowy", address="Gen. Mariusza Zaruskiego 8, 00-468 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2223728, longitude=21.047753,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4bbba050-41de-4000-b41d-8d5d3e79e73b_ChIJUTLy9QTN_0.jpg",
      averageRating=4.6, totalRatingsCount=962,
      createdAt="2026-08-30T21:27:16.487750Z", updatedAt="2026-08-30T22:02:25.266829Z",
    ),
    ClubDto(
      id="b2e2d67f-6661-447d-8fee-aa12ff53f075", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bemowski Ośrodek Piłki Nożnej", address="Obrońców Tobruku 11, 01-494 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2598915, longitude=20.9389754,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e435e148-20dc-40e2-9b56-633dc9f32866_ChIJi8GzUa7L_0.jpg",
      averageRating=4.5, totalRatingsCount=582,
      createdAt="2026-08-30T21:25:14.117582Z", updatedAt="2026-08-30T21:25:14.117582Z",
    ),
    ClubDto(
      id="0e3f5c96-f502-4f2c-a861-024707ff6bbf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centrum Futbolu Warszawianka", address="Dominika Merliniego 2, Warszawa",
      city="Warsaw", country="PL",
      latitude=52.1955368, longitude=21.0286192,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fdf464da-8b38-40b9-b8f8-ac23248b9de7_ChIJnab4WizN_0.jpg",
      averageRating=4.5, totalRatingsCount=685,
      createdAt="2026-08-30T21:25:06.918761Z", updatedAt="2026-08-30T21:25:06.918761Z",
    ),
    ClubDto(
      id="728ad27b-754d-4d2d-9b0d-01605fbd90fe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fun Park Digiloo - Sala Zabaw - Urodziny dla dzieci - Półkolonie", address="Dominika Merliniego 2, 02-511 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.196522, longitude=21.02623,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f07b0ac1-f1af-4d15-a2d5-62f224eb101b_ChIJW75Kri7N_0.jpg",
      averageRating=4.5, totalRatingsCount=2561,
      createdAt="2026-08-30T21:26:26.021211Z", updatedAt="2026-08-30T21:26:26.021211Z",
    ),
    ClubDto(
      id="44c27b56-2c19-40b5-8bf2-247058c6317b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="InterPadel Warszawa", address="Bokserska 66A, 02-690 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.1729255, longitude=20.988609,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7764707d-1d4f-439c-9c4b-febffcb05e7f_ChIJI9ffQ2Iz_0.jpg",
      averageRating=4.5, totalRatingsCount=287,
      createdAt="2026-08-30T21:27:02.703924Z", updatedAt="2026-08-30T21:57:27.366159Z",
    ),
    ClubDto(
      id="537c942a-5638-43b9-8bed-d99d37f3a81a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Monta Beach Volley Club - siatkówka plażowa", address="Gen. Mariusza Zaruskiego 12, 00-468 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2254434, longitude=21.0459249,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ef487e1e-643e-4acd-b924-45a6536a99a0_photo.jpg",
      averageRating=4.5, totalRatingsCount=1059,
      createdAt="2026-08-31T14:54:58.451332Z", updatedAt="2026-08-31T14:54:58.451332Z",
    ),
    ClubDto(
      id="58b66694-6783-4acf-b55b-0f4e9eff80f4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball FORT Blizne | Paintball i Laser Tag", address="Lazurowa 187, 01-474 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2476069, longitude=20.8959267,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/115998ca-938d-4b31-98c2-37a08c9b2f2f_ChIJ7RBzOe7K_0.jpg",
      averageRating=4.5, totalRatingsCount=723,
      createdAt="2026-08-30T21:26:40.306362Z", updatedAt="2026-08-30T21:59:17.541898Z",
    ),
    ClubDto(
      id="8777357f-083a-4630-bd30-065afa4b2967", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pole-Position Bemowo", address="Powstańców Śląskich 126, 01-466 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.265032, longitude=20.9315077,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/311bcfaf-a923-4ab3-81c1-f5314fc2655c_ChIJze8sxrLL_0.jpg",
      averageRating=4.5, totalRatingsCount=1808,
      createdAt="2026-08-30T21:26:18.337299Z", updatedAt="2026-08-30T21:59:35.617401Z",
    ),
    ClubDto(
      id="016c6c86-4f15-44ed-83b2-745b6b58367d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stacja Grawitacja Warszawa", address="aleja Bohaterów Września 12, 02-389 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2126354, longitude=20.9621445,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/37bad42b-884b-421a-8850-a8891f85157a_ChIJFTKVAKnM_0.jpg",
      averageRating=4.5, totalRatingsCount=6212,
      createdAt="2026-08-30T21:25:57.074052Z", updatedAt="2026-08-30T22:00:38.082101Z",
    ),
    ClubDto(
      id="8a3486ea-faa0-4cf6-bc30-2d6bba22965e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="WaWa Golf Club", address="H. Albera 2, 02-591 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2124301, longitude=21.010878,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/748c2b29-79b1-4660-8add-e32a47e0d564_photo.jpg",
      averageRating=4.5, totalRatingsCount=196,
      createdAt="2026-08-31T14:55:33.634949Z", updatedAt="2026-08-31T14:55:33.634949Z",
    ),
    ClubDto(
      id="b13b4614-a8a5-413f-a25c-657d9c681802", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zagrywki", address="Nowy Świat 4A, 00-496 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2304271, longitude=21.0220979,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/56053892-e078-4c09-8ce7-48be567544c4_ChIJz55GNg7N_0.jpg",
      averageRating=4.5, totalRatingsCount=5011,
      createdAt="2026-08-30T21:25:50.409197Z", updatedAt="2026-08-30T21:25:50.409197Z",
    ),
    ClubDto(
      id="ace06ad0-78f3-4c99-9f52-6c720a50fb69", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aleja Sportów Miejskich", address="Gen. Tadeusza Pełczyńskiego 22H, 01-471 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2428018, longitude=20.9045061,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c60ede6f-d0ee-4b75-8aea-8ab7154d20bf_ChIJ_-HyeOTK_2.jpg",
      averageRating=4.4, totalRatingsCount=528,
      createdAt="2026-08-30T21:25:22.075089Z", updatedAt="2026-08-31T22:11:13.307355Z",
    ),
    ClubDto(
      id="7eb9dcfe-167e-4d0f-be74-43ad477edd20", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach volleyball court", address="Józefa i Jana Rostafińskich, 00-001 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2097896, longitude=20.9936801,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/297ff4d8-0823-43fb-8167-bd6ff667e6e9_photo.jpg",
      averageRating=4.4, totalRatingsCount=91,
      createdAt="2026-08-31T14:55:05.707064Z", updatedAt="2026-08-31T14:55:05.707064Z",
    ),
    ClubDto(
      id="f0350454-bc8f-4fbd-abab-df7464b9d90c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klub Sportowy Polonia Warszawa", address="Konwiktorska 6, 00-206 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.255447, longitude=21.0009238,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1e7df399-beec-4268-8f14-dadb83e81aa6_ChIJN2QSM3HM_0.jpg",
      averageRating=4.4, totalRatingsCount=705,
      createdAt="2026-08-30T21:24:59.527628Z", updatedAt="2026-08-30T21:57:36.866608Z",
    ),
    ClubDto(
      id="ce28c15a-e4b1-48e6-844c-c8045ca0d31c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="147 Break Nowogrodzka", address="Nowogrodzka 84/86, 02-018 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2241295, longitude=20.9906775,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c6114ef7-0d7d-4a34-857c-d3e174dc15cc_ChIJLX9w0JbM_0.jpg",
      averageRating=4.3, totalRatingsCount=1813,
      createdAt="2026-08-30T21:25:35.680658Z", updatedAt="2026-08-30T21:25:35.680658Z",
    ),
    ClubDto(
      id="6ba58101-e1ad-4846-8cdf-da4b3a28a3f9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Legia Tenis & Golf", address="Myśliwiecka 4A, 00-467 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2197775, longitude=21.0378754,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2accd9a9-de4d-4872-9139-f363ab1dc640_ChIJPeqAFh3N_0.jpg",
      averageRating=4.3, totalRatingsCount=465,
      createdAt="2026-08-30T21:27:31.304201Z", updatedAt="2026-08-30T21:58:28.606677Z",
    ),
    ClubDto(
      id="3cff4df3-2611-42ab-8d35-07a1fc5d1a46", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Okęcie Tennis Club", address="Radarowa 1, 02-137 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.1890774, longitude=20.9651171,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e2e9fcc7-3a7f-4863-ba91-c17d7400f782_ChIJTciOlUUz_0.jpg",
      averageRating=4.3, totalRatingsCount=555,
      createdAt="2026-08-30T21:27:23.945548Z", updatedAt="2026-08-30T21:27:23.945548Z",
    ),
    ClubDto(
      id="9e8f94a6-f1f6-4632-a83a-3d6716fb5263", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="HULAKULA – Rozrywkowe Centrum Miasta", address="Jagiellońska 82B, 03-301 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2729636, longitude=21.0168124,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7eeb0d02-f5ac-44ec-b2b6-bca52e41a320_ChIJZW2RNQTM_3.jpg",
      averageRating=4.1, totalRatingsCount=13684,
      createdAt="2026-08-30T21:25:42.700641Z", updatedAt="2026-08-31T22:11:17.220366Z",
    ),
    ClubDto(
      id="6b9f9522-c5cd-4fce-9cf1-99830e5b5667", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Warsaw Beach Sports Arena", address="ul. Bitwy Warszawskiej 1920 r. 15, 05-077 Warsaw",
      city="Warsaw", country="PL",
      latitude=52.2139985, longitude=20.9649445,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c2e5faa7-d18e-4757-a84e-7be4babd26dd_photo.jpg",
      averageRating=4.8, totalRatingsCount=20,
      createdAt="2026-08-31T14:54:46.617253Z", updatedAt="2026-08-31T14:54:46.617253Z",
    ),
    ClubDto(
      id="1f1de196-2c46-4702-b602-f73ae9971efb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BallSquad - Rezerwacja Obiektów Sportowych", address="Sienna 72/8, 00-833 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.2306568, longitude=20.9950737,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/78945896-b3ca-412b-b5cc-02ce200dffca_photo.jpg",
      averageRating=5.0, totalRatingsCount=11,
      createdAt="2026-08-31T14:54:32.167060Z", updatedAt="2026-08-31T14:54:32.167060Z",
    ),
    ClubDto(
      id="08759042-b5eb-40e3-9b9c-8c9030f667f5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polish Table Tennis Association", address="Puławska 300, 02-819 Warszawa",
      city="Warsaw", country="PL",
      latitude=52.1470214, longitude=21.0170727,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7279c775-d562-4fd7-9a57-adb17fcaaa80_photo.jpg",
      averageRating=4.6, totalRatingsCount=10,
      createdAt="2026-08-31T14:55:40.186250Z", updatedAt="2026-08-31T14:55:40.186250Z",
    ),
    ClubDto(
      id="14c643a4-91d1-4f67-a572-33ed60e8f52e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportowa Plaża 2025 - Wilanów", address="02-962 Warsaw",
      city="Warsaw", country="PL",
      latitude=52.1654688, longitude=21.0832749,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/28c32bb7-7255-484a-81a3-ea9048febfd7_photo.jpg",
      averageRating=4.2, totalRatingsCount=10,
      createdAt="2026-08-31T14:55:13.064431Z", updatedAt="2026-08-31T14:55:13.064431Z",
    ),
  )),
  CitySeo(slug="gothenburg", name="Gothenburg", country="SE", clubCount=31, sports=listOf(Pair("Volleyball", 5), Pair("Football", 4), Pair("Tennis", 3), Pair("Padel", 3), Pair("Basketball", 3), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Climbing", 2), Pair("Karting", 2), Pair("Paintball", 2), Pair("Golf", 1), Pair("Laser Tag", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="a5036b4b-ac16-48d5-be25-bf2ade3e7062", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klätterdomen", address="Övre Kaserngården 2, 415 27 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7362966, longitude=12.0305659,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06982c65-e056-48b5-afec-8939bbcd301a_ChIJz53JkUL0_0.jpg",
      averageRating=4.6, totalRatingsCount=847,
      createdAt="2026-08-30T23:01:31.758642Z", updatedAt="2026-08-30T23:01:31.758642Z",
    ),
    ClubDto(
      id="6a68e686-0a0e-4394-8f48-d14111eb52f4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BK Milen Biljard", address="Stigbergsliden 3, 414 63 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.6994738, longitude=11.9379472,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/afeda156-314d-41dc-86ad-7ca2c2fd0130_ChIJd00SEkbz_0.jpg",
      averageRating=4.5, totalRatingsCount=81,
      createdAt="2026-08-30T23:01:11.463269Z", updatedAt="2026-08-30T23:01:11.463269Z",
    ),
    ClubDto(
      id="89458cae-6274-42fd-8207-12cc32ba15b5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bon Padel Arena", address="Östra Sörredsvägen 4, 418 78 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7157363, longitude=11.8492812,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/01272827-85d3-4c58-9114-3419a7c3d0b2_ChIJ7UWU82yN_0.jpg",
      averageRating=4.5, totalRatingsCount=153,
      createdAt="2026-08-30T23:02:27.221894Z", updatedAt="2026-08-31T08:26:22.456135Z",
    ),
    ClubDto(
      id="bfb89245-8508-40ef-a23c-530e143ed1ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gokartcentralen Göteborg", address="Bergslagsgatan 6, 411 04 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7128338, longitude=11.9765608,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77921eae-d84e-4338-823c-bb8ec2315bb4_ChIJI9nZvGLz_0.jpg",
      averageRating=4.5, totalRatingsCount=1135,
      createdAt="2026-08-30T23:01:46.799713Z", updatedAt="2026-08-31T08:28:38.939522Z",
    ),
    ClubDto(
      id="518b4ef0-731a-468d-af8c-d6109b8ae982", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Center", address="Krutvägen 6, 415 27 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7379314, longitude=12.0364036,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1fd5a383-e894-4715-a2cc-ce5094ab2c89_photo.jpg",
      averageRating=4.4, totalRatingsCount=939,
      createdAt="2026-08-31T15:02:38.695961Z", updatedAt="2026-08-31T15:02:38.695961Z",
    ),
    ClubDto(
      id="e450a8f4-fdac-4538-9ad4-1284c2801772", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brew Padel Ringön", address="Ringögatan 10, avfart 8, 417 07 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7218045, longitude=11.9684674,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a015e008-3eee-47ba-9b6a-2a8781b70191_ChIJT1-yHA31_0.jpg",
      averageRating=4.4, totalRatingsCount=117,
      createdAt="2026-08-30T23:02:34.569646Z", updatedAt="2026-08-31T08:26:34.373084Z",
    ),
    ClubDto(
      id="df5fa754-386f-4fb4-8e86-fa04ee290b94", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fysiken Gibraltargatan", address="Gibraltargatan 39-41, 412 79 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.6818665, longitude=11.9835881,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0a189107-5b82-4da9-9096-34985400412a_photo.jpg",
      averageRating=4.4, totalRatingsCount=641,
      createdAt="2026-08-31T15:02:29.426748Z", updatedAt="2026-08-31T15:02:29.426748Z",
    ),
    ClubDto(
      id="a246b49d-7644-4966-9d21-515a9248353a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fysiken Klätterlabbet Centrum", address="Elektrovägen 1, 412 58 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.6874681, longitude=11.9804299,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/64d317df-8c7a-4865-bf64-82519eb0e089_ChIJWeNTWArz_0.jpg",
      averageRating=4.4, totalRatingsCount=595,
      createdAt="2026-08-30T23:01:39.460292Z", updatedAt="2026-08-31T08:28:08.481871Z",
    ),
    ClubDto(
      id="ec5425d8-4cd6-4cf5-8c86-28780e684991", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Göteborgs Gokartcenter AB", address="Bulyckevägen 20, 418 78 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7208503, longitude=11.8147009,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/803f82fb-20cb-46c0-a789-2698f1fbb00b_ChIJXcdRzA2M_0.jpg",
      averageRating=4.4, totalRatingsCount=611,
      createdAt="2026-08-30T23:01:53.835124Z", updatedAt="2026-08-31T08:28:51.159042Z",
    ),
    ClubDto(
      id="6f65a4ea-19b6-457d-b828-22d2d07d7447", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Högsbo Basket", address="Gothia Arena, Ängåsvallen 20, 421 47 Västra Frölunda",
      city="Gothenburg", country="SE",
      latitude=57.6453104, longitude=11.9150493,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/94b36554-4d8b-4cd3-aad9-0d8f61712192_photo.jpg",
      averageRating=4.4, totalRatingsCount=212,
      createdAt="2026-08-31T15:02:14.535721Z", updatedAt="2026-08-31T22:11:17.642608Z",
    ),
    ClubDto(
      id="1b4c559d-dc0b-4c58-be98-0303a8e70aaf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nordic Sportsbar 🎳", address="Mölndalsvägen 95, 412 63 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.678668, longitude=12.003399,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d9094cc5-e71e-4abd-b3d1-0af956bdb823_ChIJZbOVa9_z_0.jpg",
      averageRating=4.4, totalRatingsCount=882,
      createdAt="2026-08-30T23:01:24.783428Z", updatedAt="2026-08-31T08:33:17.694708Z",
    ),
    ClubDto(
      id="b688e2d3-6bc0-4186-adc2-66c8137a194b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ullevi", address="Ullevigatan, 411 40 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7058751, longitude=11.9873651,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0be77f09-a144-44b9-950a-96e092fdbe39_ChIJC1AblXvz_0.jpg",
      averageRating=4.4, totalRatingsCount=6588,
      createdAt="2026-08-30T23:00:37.658465Z", updatedAt="2026-08-31T08:38:15.832815Z",
    ),
    ClubDto(
      id="3282c386-2776-4fd2-a15f-ef83a050f374", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Alelyckans Sportcenter", address="Gamlestadsvägen 311, 415 02 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.754402, longitude=12.0116555,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a6029328-c196-4484-bb3d-fe101dba9a60_ChIJPUbs0f_0_0.jpg",
      averageRating=4.3, totalRatingsCount=580,
      createdAt="2026-08-30T23:02:41.834847Z", updatedAt="2026-08-30T23:02:41.834847Z",
    ),
    ClubDto(
      id="31ef73e9-ad32-4f0b-8c03-1b8307fdd373", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gamla Ullevi", address="Ullevigatan 5, 411 39 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7062618, longitude=11.9801329,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8278eeb7-f04a-4b77-bd7a-3a6213556d07_ChIJgdMAmHvz_0.jpg",
      averageRating=4.3, totalRatingsCount=2310,
      createdAt="2026-08-30T23:00:43.606195Z", updatedAt="2026-08-31T08:28:31.919412Z",
    ),
    ClubDto(
      id="7c7ef30b-87cd-48c0-9f0d-8f938137b722", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laserdome Hisingen", address="Gustaf Dalénsgatan 36, 417 24 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7239351, longitude=11.9446114,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/12de679b-9d0d-4c61-adb5-1ebaa75609da_ChIJSSKWQa_0_0.jpg",
      averageRating=4.3, totalRatingsCount=264,
      createdAt="2026-08-30T23:02:01.019747Z", updatedAt="2026-08-30T23:02:01.019747Z",
    ),
    ClubDto(
      id="d3f02949-72a3-408e-801e-ef000f7b7fd6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ullevi Tennisklubb", address="Smålandsgatan 2, 411 39 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7052038, longitude=11.9801077,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5565dffa-6b33-4aca-9945-7ef3302a8765_ChIJYcmnynvz_0.jpg",
      averageRating=4.3, totalRatingsCount=126,
      createdAt="2026-08-30T23:02:55.737662Z", updatedAt="2026-08-31T08:38:16.425133Z",
    ),
    ClubDto(
      id="1ecc8a47-b7cd-4a05-9f37-9243c17d4595", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gothia Tennis", address="Grimboåsen 4, 417 05 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7420348, longitude=11.9410432,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac190db3-75a5-48d0-ad00-38c3abe59cc0_ChIJnXhV68r0_0.jpg",
      averageRating=4.2, totalRatingsCount=288,
      createdAt="2026-08-30T23:02:48.678958Z", updatedAt="2026-09-01T14:31:47.762770Z",
    ),
    ClubDto(
      id="4edc6e03-ff00-4caa-aa0c-777e12cd52b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hisingens Golf & Friskvårdscenter", address="Östergärde Industriväg 1, 417 29 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7486845, longitude=11.8817383,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5b3d9b8-15dc-4e46-8b19-73bc648c7492_photo.jpg",
      averageRating=4.2, totalRatingsCount=286,
      createdAt="2026-08-31T15:03:18.311661Z", updatedAt="2026-08-31T15:03:18.311661Z",
    ),
    ClubDto(
      id="28f3c128-2669-4c3f-8acf-698f8577ff4c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kristinedals Träningscenter Göteborg", address="Byfogdegatan 4, 415 05 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7269499, longitude=12.0101096,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/de8f3035-f242-418c-aa3b-e1c5b11fab41_ChIJpcQ_i2P0_0.jpg",
      averageRating=4.2, totalRatingsCount=556,
      createdAt="2026-08-30T23:02:20.275570Z", updatedAt="2026-08-31T08:31:32.687142Z",
    ),
    ClubDto(
      id="d02c169d-36f6-4b3f-b641-3c78009d6524", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Biljardpalatset", address="Ekelundsgatan 11, 411 18 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7038682, longitude=11.9610583,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/21ba78b5-d35a-44ba-9d09-04c53ee80d8e_ChIJIb5aKGbz_0.jpg",
      averageRating=4.0, totalRatingsCount=2351,
      createdAt="2026-08-30T23:01:04.222155Z", updatedAt="2026-08-31T08:26:08.237528Z",
    ),
    ClubDto(
      id="a6d42d7d-d83a-476b-b9d0-93dc0fcfeed4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Classic Bowl", address="Gamlestadsvägen 2, 415 11 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7251149, longitude=12.0059042,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2a9dced0-4089-4242-b7eb-9ff65ce25ec8_ChIJM7ckoWP0_0.jpg",
      averageRating=4.0, totalRatingsCount=1196,
      createdAt="2026-08-30T23:01:17.890893Z", updatedAt="2026-08-31T08:26:58.086849Z",
    ),
    ClubDto(
      id="c8d4b8f7-c840-4c9c-a3e7-7005e70fda4f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Majvallen", address="Ekedalsgatan 20, 414 68 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.6893345, longitude=11.9359546,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2fcc0c0f-b0a7-4ff0-8645-ae892e8247c5_ChIJOSariDnz_0.jpg",
      averageRating=4.0, totalRatingsCount=352,
      createdAt="2026-08-30T23:00:50.924331Z", updatedAt="2026-08-30T23:00:50.924331Z",
    ),
    ClubDto(
      id="93e39ea8-1f73-42aa-a5ff-55c79a924503", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Valhalla IP", address="Valhallagatan 6, 412 51 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7014672, longitude=11.9903152,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2b252fa3-8c79-4cab-9452-a82ef5b28818_ChIJHWa0qYLz_0.jpg",
      averageRating=4.0, totalRatingsCount=319,
      createdAt="2026-08-30T23:00:57.881129Z", updatedAt="2026-08-31T08:38:19.570331Z",
    ),
    ClubDto(
      id="15dec9fd-cfea-405e-aa6a-66535fad6346", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lundbystrandshallen", address="Anders Carlssons g 10, 417 55 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7084749, longitude=11.9484292,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e95ee70a-c8c8-47a2-b010-47b58d2530a5_photo.jpg",
      averageRating=3.8, totalRatingsCount=610,
      createdAt="2026-08-31T15:02:21.654921Z", updatedAt="2026-08-31T15:02:21.654921Z",
    ),
    ClubDto(
      id="a3f14ac9-17aa-4cb6-a9a8-4ab550d7a668", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="adrenalin PAINTBALL", address="Askims Skytteväg 64, 416 64 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.6177962, longitude=11.9586458,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1c355f96-918b-474a-b035-60d0bc318d67_ChIJOfgFgG7z_0.jpg",
      averageRating=4.3, totalRatingsCount=42,
      createdAt="2026-08-30T23:02:07.567716Z", updatedAt="2026-08-30T23:02:07.567716Z",
    ),
    ClubDto(
      id="aacd0f92-1748-423c-ada9-ea00d01eb861", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gothia Volleybollklubb", address="Anders Carlssons g 10, 417 55 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7084749, longitude=11.9484292,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/75eff800-b005-46bf-a13c-43d8babd7648_photo.jpg",
      averageRating=5.0, totalRatingsCount=29,
      createdAt="2026-08-31T15:02:46.086465Z", updatedAt="2026-08-31T15:02:46.086465Z",
    ),
    ClubDto(
      id="42e18f31-7799-4c03-9a21-fea622148e94", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="adrenalin.nu - Teambuilding och företagsevent med paintball, bubble football och archery tag i Göteborg, Stockholm och Malmö.", address="Friggagatan 19 b, 416 64 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7114582, longitude=11.9888106,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bd3736ba-6e35-4889-baad-9ba5c8b58ce0_ChIJR8VSOX7z_0.jpg",
      averageRating=4.7, totalRatingsCount=28,
      createdAt="2026-08-30T23:02:13.808688Z", updatedAt="2026-08-30T23:02:13.808688Z",
    ),
    ClubDto(
      id="697dde2e-9a01-4b7f-992b-7b85f38938ab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolley", address="Skålmekärrsvägen, 416 55 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7030499, longitude=12.0414709,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f8b441a9-25c7-4699-969e-08c7a360b149_photo.jpg",
      averageRating=4.8, totalRatingsCount=12,
      createdAt="2026-08-31T15:03:09.839674Z", updatedAt="2026-08-31T15:03:09.839674Z",
    ),
    ClubDto(
      id="edca7891-939c-460e-968b-3c01bc097f59", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Göteborgs Beachvolleyboll", address="Krutvägen 6, 415 27 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7382927, longitude=12.0364491,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/25d7f247-583c-41bc-8f87-97e67ba54f22_photo.jpg",
      averageRating=5.0, totalRatingsCount=9,
      createdAt="2026-08-31T15:02:53.410196Z", updatedAt="2026-08-31T15:02:53.410196Z",
    ),
    ClubDto(
      id="490a4780-f842-45d2-b461-92944d60e736", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Göteborg Beachvolley Club", address="Krutvägen 6, 415 27 Göteborg",
      city="Gothenburg", country="SE",
      latitude=57.7382927, longitude=12.0364491,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ef3497b6-3233-4332-9add-4cfb5a6d80bf_photo.jpg",
      averageRating=4.8, totalRatingsCount=6,
      createdAt="2026-08-31T15:03:00.371730Z", updatedAt="2026-08-31T15:03:00.371730Z",
    ),
    ClubDto(
      id="38d50012-ef44-4ead-91fa-c1a3c86ed7e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Partille Table Tennis Club", address="Nygårdsvägen 3, 433 32 Partille",
      city="Gothenburg", country="SE",
      latitude=57.7461603, longitude=12.1242822,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e1beffae-3382-46cd-8fc1-fd0f3c60cdf5_photo.jpg",
      averageRating=3.6, totalRatingsCount=5,
      createdAt="2026-08-31T15:03:24.564361Z", updatedAt="2026-08-31T15:03:24.564361Z",
    ),
  )),
  CitySeo(slug="budapest", name="Budapest", country="HU", clubCount=31, sports=listOf(Pair("Volleyball", 5), Pair("Football", 3), Pair("Tennis", 3), Pair("Padel", 3), Pair("Basketball", 2), Pair("Paintball", 2), Pair("Golf", 2), Pair("Laser Tag", 2), Pair("Karting", 2), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Bowling", 2), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="2eba474a-6436-4c07-8137-340ff5afbd36", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Churchill Shooting Range Budapest", address="Budapest, Holló u. 6, 1075",
      city="Budapest", country="HU",
      latitude=47.4985014, longitude=19.0601033,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a90c9067-f016-4749-ad37-85f91fb6f5f3_ChIJ3y9JKTrb_1.jpg",
      averageRating=5.0, totalRatingsCount=4311,
      createdAt="2026-08-30T22:52:29.333418Z", updatedAt="2026-08-31T22:11:15.201441Z",
    ),
    ClubDto(
      id="6b7818d6-95eb-43e1-ada5-db89a16feb4d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel King Savoya", address="Budapest, Hunyadi János út 162, 1117",
      city="Budapest", country="HU",
      latitude=47.4337095, longitude=19.0439974,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bb886384-a817-4e5e-9c48-40dd1e23790f_ChIJjVMOVe3n_0.jpg",
      averageRating=5.0, totalRatingsCount=114,
      createdAt="2026-08-30T22:52:49.760523Z", updatedAt="2026-08-31T08:33:46.470112Z",
    ),
    ClubDto(
      id="1d331be6-39bb-4e5a-8f42-1bb8a805433d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SPINCITY Table Tennis - PEST", address="Budapest, Fáy u. 4, 1139",
      city="Budapest", country="HU",
      latitude=47.5380085, longitude=19.0706598,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8cc28b9a-a845-4675-83f5-ac732ca5c1b0_photo.jpg",
      averageRating=5.0, totalRatingsCount=151,
      createdAt="2026-08-31T15:09:19.733598Z", updatedAt="2026-08-31T15:09:19.733598Z",
    ),
    ClubDto(
      id="a62a7de3-04e0-41f6-b8f3-71df2e5f3cf6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel4All Hungary Padel Szaküzlet", address="Budapest, Premier Padel, Club Épületében, Villányi út 14, 1113",
      city="Budapest", country="HU",
      latitude=47.4776668, longitude=19.0425582,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b1d3c672-dada-4fb9-939e-9f9a424f1600_ChIJi_8njF7d_0.jpg",
      averageRating=4.9, totalRatingsCount=71,
      createdAt="2026-08-30T22:52:57.316671Z", updatedAt="2026-08-31T08:34:03.522837Z",
    ),
    ClubDto(
      id="9f58b3bc-1ff8-4f5c-9d1b-0a776e77eeed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Top Padel Club", address="Budapest, Szamos u. 2/c, 1122",
      city="Budapest", country="HU",
      latitude=47.5060891, longitude=19.0198558,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b5cf94ed-a0a1-426e-a90e-7b93a6f6c923_ChIJx4Hhv5ff_0.jpg",
      averageRating=4.9, totalRatingsCount=303,
      createdAt="2026-08-30T22:52:42.219090Z", updatedAt="2026-08-30T22:52:42.219090Z",
    ),
    ClubDto(
      id="ac8f531f-6f7b-4ed7-8d9d-0d45d56e330b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Budapest Beach Aréna", address="Budapest, Kőér u 2b, 1103",
      city="Budapest", country="HU",
      latitude=47.4681534, longitude=19.1298907,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9939380d-3320-41a5-b010-5fa079214c25_photo.png",
      averageRating=4.8, totalRatingsCount=52,
      createdAt="2026-08-31T15:08:48.984262Z", updatedAt="2026-08-31T15:08:48.984262Z",
    ),
    ClubDto(
      id="6dce7dc2-796c-4429-b2bd-6dca98a2b1ef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Budapest Tenisz Centrum", address="Budapest, Szamos u. 2/c, 1122",
      city="Budapest", country="HU",
      latitude=47.5066014, longitude=19.0183915,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4dbbfad6-23f4-47ea-b14d-4760e433d6de_ChIJz8ZXOqLe_0.jpg",
      averageRating=4.8, totalRatingsCount=266,
      createdAt="2026-08-30T22:53:10.785303Z", updatedAt="2026-08-30T22:53:10.785303Z",
    ),
    ClubDto(
      id="912e0fdd-de95-4610-871c-20d2be608c6c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cyberjump Buda Trambulin Park", address="Budapest, Hengermalom út 19, 1117",
      city="Budapest", country="HU",
      latitude=47.4599272, longitude=19.0512634,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4ea40cb0-9457-4c44-8086-7810ddd97285_ChIJv3AcWaDd_0.jpg",
      averageRating=4.7, totalRatingsCount=9428,
      createdAt="2026-08-30T22:52:17.205080Z", updatedAt="2026-08-31T08:27:11.787387Z",
    ),
    ClubDto(
      id="a05014f0-c41d-427b-aaf5-b4189302d3fe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Puskás Aréna", address="Budapest, Istvánmezei út 3-5, 1146",
      city="Budapest", country="HU",
      latitude=47.5031263, longitude=19.0979153,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/32d77b04-9f66-4629-8eb3-46b40b851bec_ChIJsxZQGYXc_0.jpg",
      averageRating=4.7, totalRatingsCount=13474,
      createdAt="2026-08-30T22:51:00.329413Z", updatedAt="2026-08-31T08:34:55.840288Z",
    ),
    ClubDto(
      id="4ec5132e-b9c4-4ea8-8dd9-201f27010d47", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Continental Citygolf Club", address="Budapest, Perényi út 6, 1037",
      city="Budapest", country="HU",
      latitude=47.5430577, longitude=19.0272521,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4dc79e10-29e7-446b-81b4-9367f92cacc0_photo.jpg",
      averageRating=4.6, totalRatingsCount=571,
      createdAt="2026-08-31T15:09:12.822289Z", updatedAt="2026-08-31T15:09:12.822289Z",
    ),
    ClubDto(
      id="5dfae1c8-1adf-413b-b221-628badeda756", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Elevenpark", address="Budapest, Hengermalom út 19-21, 1117",
      city="Budapest", country="HU",
      latitude=47.4599499, longitude=19.0512796,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7560ca5e-8a7a-41d7-8ad1-8da1e3a3e3f5_ChIJW8oj06Pd_0.jpg",
      averageRating=4.6, totalRatingsCount=7675,
      createdAt="2026-08-30T22:52:23.383883Z", updatedAt="2026-08-31T08:27:34.085936Z",
    ),
    ClubDto(
      id="a37eed1a-cf8b-4542-834b-be68f65f8ed7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mountex - Váci út", address="Budapest, Váci út 19, 1134",
      city="Budapest", country="HU",
      latitude=47.5204219, longitude=19.0618929,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc1dd51c-9e93-42aa-85bd-961b9646f816_ChIJmTtwUfTb_0.jpg",
      averageRating=4.6, totalRatingsCount=2124,
      createdAt="2026-08-30T22:51:51.715627Z", updatedAt="2026-08-31T08:33:07.712141Z",
    ),
    ClubDto(
      id="323806cb-b982-4e71-8b55-04286288eebb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Patriots Paintball Budafok", address="Budapest, IX. u. 9, 1224",
      city="Budapest", country="HU",
      latitude=47.408982, longitude=18.9983574,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/400e9488-2fdc-4930-8690-a449e18ca115_ChIJG9sCd2fg_2.jpg",
      averageRating=4.6, totalRatingsCount=449,
      createdAt="2026-08-30T22:52:36.022243Z", updatedAt="2026-08-31T22:11:20.143546Z",
    ),
    ClubDto(
      id="a5eb5c32-8f5c-46b5-b658-177f25fe30c7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pillangó Tenisz Klub", address="Budapest, Róna u. 25., 1143",
      city="Budapest", country="HU",
      latitude=47.5042907, longitude=19.1233626,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eebcfdde-3d33-4edf-a63a-ec9b1124fd26_ChIJ47QPHKfc_0.jpg",
      averageRating=4.6, totalRatingsCount=248,
      createdAt="2026-08-30T22:53:17.678891Z", updatedAt="2026-08-30T22:53:17.678891Z",
    ),
    ClubDto(
      id="66196f93-b2db-4659-8b72-e078a7c6ae28", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Silverkart Budapest Gokart és Rendezvényközpont X.", address="Budapest, Kozma u. 3/A, 1108",
      city="Budapest", country="HU",
      latitude=47.4839286, longitude=19.1777725,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ec656232-1fcd-4328-8a0d-e24472827acb_ChIJ4cp5CXHD_0.jpg",
      averageRating=4.6, totalRatingsCount=2737,
      createdAt="2026-08-30T22:52:05.597050Z", updatedAt="2026-08-31T08:36:07.679348Z",
    ),
    ClubDto(
      id="399fcac6-f846-43a5-ab37-c7493300ad82", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Spider Club", address="Budapest, Fényes Adolf u. 19-21, 1036",
      city="Budapest", country="HU",
      latitude=47.5355795, longitude=19.0417444,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9e2ebb81-affe-4dab-9f07-bfe02a90b29c_ChIJqXitPlnZ_0.jpg",
      averageRating=4.6, totalRatingsCount=1035,
      createdAt="2026-08-30T22:51:58.908264Z", updatedAt="2026-08-30T22:51:58.908264Z",
    ),
    ClubDto(
      id="06b3e4b7-8943-4891-af97-2019c1d78e1f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stifler Ház", address="Budapest, Klauzál u. 21, 1072",
      city="Budapest", country="HU",
      latitude=47.4984771, longitude=19.0664482,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aa3418ac-da9c-4a15-a7b9-bc5a2685bed9_ChIJEzCDorjd_2.jpg",
      averageRating=4.6, totalRatingsCount=3819,
      createdAt="2026-08-30T22:51:13.663262Z", updatedAt="2026-08-31T22:11:21.642098Z",
    ),
    ClubDto(
      id="dc003bcb-62ad-4de0-bcaf-fe3f57f3ca7a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BEAC", address="Budapest, Bogdánfy u. 10-B I. lépcsőház, 2. emelet, 1117",
      city="Budapest", country="HU",
      latitude=47.473038, longitude=19.0568292,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e4f1c272-4cd7-4d04-adb9-83c0730c1ba0_photo.jpg",
      averageRating=4.5, totalRatingsCount=902,
      createdAt="2026-08-31T15:08:30.522922Z", updatedAt="2026-08-31T22:11:13.696506Z",
    ),
    ClubDto(
      id="b3192b89-b448-450f-a73c-56bed6ce3994", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FlashKart Gokart", address="Budapest, Blaha Lujza tér 5, 1085",
      city="Budapest", country="HU",
      latitude=47.4960747, longitude=19.0702553,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9f85baa6-64d3-40a0-84d4-4d88bca7182a_ChIJ8Rcnamfc_0.jpg",
      averageRating=4.5, totalRatingsCount=1472,
      createdAt="2026-08-30T22:52:11.091144Z", updatedAt="2026-08-30T22:52:11.091144Z",
    ),
    ClubDto(
      id="7f7133e5-a49c-4ce1-acd0-13f2a6abca60", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Highland Golf Club", address="Budapest, Dózsa György út 99-103, 1224",
      city="Budapest", country="HU",
      latitude=47.417372, longitude=18.9872349,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2a0d499b-5d12-4431-8d96-34e37e39d473_photo.jpg",
      averageRating=4.5, totalRatingsCount=263,
      createdAt="2026-08-31T15:09:05.635024Z", updatedAt="2026-08-31T15:09:05.635024Z",
    ),
    ClubDto(
      id="87bd6d15-dc84-46d4-9666-923a79a32eed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Panorama Sports Center", address="Budapest, Kolozsvári Tamás u. 11, 1023",
      city="Budapest", country="HU",
      latitude=47.5251095, longitude=19.0332194,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3030d72a-220d-4728-b855-bd5d555fa3f5_photo.jpg",
      averageRating=4.5, totalRatingsCount=552,
      createdAt="2026-08-31T15:08:09.886643Z", updatedAt="2026-08-31T15:08:09.886643Z",
    ),
    ClubDto(
      id="cdd81bd2-899b-40d6-a380-d5ebd8dcddd2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BME Sporttelep", address="Budapest, Bogdánfy u. 12, 1117",
      city="Budapest", country="HU",
      latitude=47.4713984, longitude=19.0540359,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/44f03b40-5c76-4310-a294-2b1a4b4b8ca4_photo.jpg",
      averageRating=4.4, totalRatingsCount=1077,
      createdAt="2026-08-31T15:08:16.396770Z", updatedAt="2026-08-31T15:08:16.396770Z",
    ),
    ClubDto(
      id="8f227715-9f60-49dc-85e7-b23d65ef415c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Budapest Garden", address="Budapest, Árpád fejedelem útja 125, 1036",
      city="Budapest", country="HU",
      latitude=47.5315357, longitude=19.0431657,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/588c047f-fc54-4568-9a48-e02ce95aef2e_ChIJIT1dBVjZ_0.jpg",
      averageRating=4.4, totalRatingsCount=3594,
      createdAt="2026-08-30T22:51:19.648375Z", updatedAt="2026-08-31T08:26:39.075217Z",
    ),
    ClubDto(
      id="844c0963-9ded-403a-be5c-e661624bc780", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Margitszigeti Athletics Centre", address="Budapest, 1007",
      city="Budapest", country="HU",
      latitude=47.517181, longitude=19.0432882,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a399520d-67e0-4a28-b813-69a3d229045c_photo.jpg",
      averageRating=4.4, totalRatingsCount=105,
      createdAt="2026-08-31T15:08:23.922033Z", updatedAt="2026-08-31T15:08:23.922033Z",
    ),
    ClubDto(
      id="8dfff5d8-28fd-4619-8875-a27dad23bd1d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mérnök utcai sporttelep", address="Budapest, Mérnök u. 35, 1119",
      city="Budapest", country="HU",
      latitude=47.4648217, longitude=19.04031,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8dc6e199-8c6e-424e-a261-9c6ad2a9bfe7_photo.jpg",
      averageRating=4.4, totalRatingsCount=680,
      createdAt="2026-08-31T15:08:38.614913Z", updatedAt="2026-08-31T15:08:38.614913Z",
    ),
    ClubDto(
      id="96c7039d-3c9a-4a49-9fd6-03777f7c1fea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Noiret Biliárd és Darts Szalon", address="Budapest, Dessewffy u. 8-10, 1066",
      city="Budapest", country="HU",
      latitude=47.5048169, longitude=19.0562741,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e094931f-c06d-4976-b514-04e5ae311afc_ChIJtU2Yt2zc_0.jpg",
      averageRating=4.4, totalRatingsCount=3391,
      createdAt="2026-08-30T22:51:32.328286Z", updatedAt="2026-08-30T22:51:32.328286Z",
    ),
    ClubDto(
      id="280b8b47-d715-45b9-8095-31d6e4b505a8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Római Teniszakadémia", address="Budapest, Királyok útja 105, 1039",
      city="Budapest", country="HU",
      latitude=47.5842916, longitude=19.0657519,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6bdfdb62-c653-41bc-a6de-518631edb3e5_ChIJQ5yBPe7Z_0.jpg",
      averageRating=4.4, totalRatingsCount=475,
      createdAt="2026-08-30T22:53:03.822347Z", updatedAt="2026-08-31T08:35:33.188471Z",
    ),
    ClubDto(
      id="c83cbd05-1e82-4938-b0dd-da3e63665c8d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Strike Bowling Club", address="Budapest, Budafoki út 111, 1117",
      city="Budapest", country="HU",
      latitude=47.4627167, longitude=19.0520896,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fc0478ad-7f38-42e9-9a0f-27cb723e9194_ChIJxSlt1aDd_0.jpg",
      averageRating=4.3, totalRatingsCount=2424,
      createdAt="2026-08-30T22:51:38.572165Z", updatedAt="2026-08-31T08:37:03.307446Z",
    ),
    ClubDto(
      id="08d24bdb-e89f-4110-9f15-526f56825e86", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zöld Angyal étterem és Bowling Klub", address="Budapest, Országbíró u. 30, 1139",
      city="Budapest", country="HU",
      latitude=47.5318225, longitude=19.079009,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0f09cd5-0794-4b08-a789-3ee5216dac54_ChIJFWBaWpTb_2.jpg",
      averageRating=4.3, totalRatingsCount=1464,
      createdAt="2026-08-30T22:51:45.092741Z", updatedAt="2026-08-31T22:11:24.432153Z",
    ),
    ClubDto(
      id="d2f7b3df-2a64-442b-a585-ece498adbc5a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Füge Udvar", address="Budapest, Klauzál u. 19, 1072",
      city="Budapest", country="HU",
      latitude=47.4982918, longitude=19.0665025,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6865e57c-7186-48d9-8bb2-4b9ff693986b_ChIJTSTv2mfc_0.jpg",
      averageRating=4.2, totalRatingsCount=10258,
      createdAt="2026-08-30T22:51:26.227569Z", updatedAt="2026-08-31T08:28:13.742178Z",
    ),
    ClubDto(
      id="1740831f-724a-4224-832d-aa1d61acf8af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MESE Strandröplabda Centrum", address="Budapest, Vadaskerti u. 1-3, 1021",
      city="Budapest", country="HU",
      latitude=47.5331878, longitude=18.9823017,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77ed7a30-915c-46a6-bb96-6f9475258a36_photo.jpg",
      averageRating=4.3, totalRatingsCount=38,
      createdAt="2026-08-31T15:08:59.514516Z", updatedAt="2026-08-31T15:08:59.514516Z",
    ),
  )),
  CitySeo(slug="gdansk", name="Gdansk", country="PL", clubCount=31, sports=listOf(Pair("Football", 5), Pair("Padel", 3), Pair("Tennis", 3), Pair("Volleyball", 3), Pair("Basketball", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Billiards", 2), Pair("Karting", 2), Pair("Laser Tag", 2), Pair("Bowling", 2), Pair("Paintball", 2), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="c0085dcc-169d-48e7-836d-b4cb4d12c77f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Arena Gdańsk - paintball laserowy", address="Siennicka 25B, 80-758 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3596033, longitude=18.6823362,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0681555-6bb5-4bac-b8e2-8a4186c1570c_photo.jpg",
      averageRating=5.0, totalRatingsCount=145,
      createdAt="2026-08-31T23:33:53.119895Z", updatedAt="2026-08-31T23:33:53.119895Z",
    ),
    ClubDto(
      id="ceb54d2a-8f2c-409a-bc87-268f4fd25ff9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball & Laser Tag Gdańsk - LaserSport", address="Niwki, 80-731 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3382032, longitude=18.6837821,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5863a271-32c7-4b9f-a828-3591254aa7b5_photo.jpg",
      averageRating=5.0, totalRatingsCount=66,
      createdAt="2026-08-31T23:33:58.719031Z", updatedAt="2026-08-31T23:33:58.719031Z",
    ),
    ClubDto(
      id="909ff04d-d56e-4ee5-b930-9a665598a182", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Strefa 29 Gdańsk Czaple", address="Żurawia 29, 80-298 Czaple",
      city="Gdansk", country="PL",
      latitude=54.3641698, longitude=18.4222112,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49190e5e-ea9c-4f59-a376-34db147e756b_photo.jpg",
      averageRating=5.0, totalRatingsCount=104,
      createdAt="2026-08-31T23:34:08.214929Z", updatedAt="2026-08-31T23:34:08.214929Z",
    ),
    ClubDto(
      id="6c3645e7-4ba2-4df8-bc1c-be82a8518144", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GDYNIA PADEL CLUB", address="Ludwika Zamenhofa 17, 81-218 Gdynia",
      city="Gdansk", country="PL",
      latitude=54.5359897, longitude=18.4834839,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0cde514-c63b-432e-a156-03e170f6b0b7_photo.jpg",
      averageRating=4.9, totalRatingsCount=148,
      createdAt="2026-08-31T23:32:22.571650Z", updatedAt="2026-09-01T14:31:41.508437Z",
    ),
    ClubDto(
      id="a79c1e04-dc85-49e4-9133-24beff45f2a3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padbox Stadion - Padel Social Club - korty do padla", address="Pokoleń Lechii Gdańsk 1, 80-560 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3879744, longitude=18.638985,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5c30c96c-903b-41b6-9437-c922909e86cb_photo.jpg",
      averageRating=4.9, totalRatingsCount=401,
      createdAt="2026-08-31T23:32:08.761993Z", updatedAt="2026-08-31T23:32:08.761993Z",
    ),
    ClubDto(
      id="dcb41fb8-32e0-4e8f-9ad1-37d20565c695", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Arena", address="Matejki 31, 84-208 Bożanka",
      city="Gdansk", country="PL",
      latitude=54.4665919, longitude=18.3271842,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/18802d5c-5f0e-4028-a7b1-3342c2e7b825_photo.jpg",
      averageRating=4.9, totalRatingsCount=164,
      createdAt="2026-08-31T23:34:03.081701Z", updatedAt="2026-08-31T23:34:03.081701Z",
    ),
    ClubDto(
      id="f20ec709-a0ff-4df2-8bb5-e14d218098dd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Strefa DIAMOND - najlepszy klub bilardowy w Europie", address="aleja Grunwaldzka 309, 80-309 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3947887, longitude=18.5818125,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cd39323a-1b9d-48ab-8305-a7f4f4767bfc_photo.jpg",
      averageRating=4.9, totalRatingsCount=1134,
      createdAt="2026-08-31T23:33:46.078613Z", updatedAt="2026-08-31T23:33:46.078613Z",
    ),
    ClubDto(
      id="75019cb2-d77a-4603-8924-80dd733eb7a3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BRAWO. Padel & Squash", address="Galaktyczna 37, 80-299 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.4178761, longitude=18.4854622,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/05bc8a0f-6b77-48c7-9596-4eaff82ae33e_photo.jpg",
      averageRating=4.8, totalRatingsCount=184,
      createdAt="2026-08-31T23:32:15.392770Z", updatedAt="2026-08-31T23:32:15.392770Z",
    ),
    ClubDto(
      id="a1b3daf3-f01c-4a34-ab7a-fb0884de2f32", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centrum Sportów Rakietowych Gdańsk", address="Kazimierza Górskiego 1, 80-336 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.4193147, longitude=18.5619291,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4ef4c8a5-2bd7-4cdd-8cde-615dc3043be7_photo.jpg",
      averageRating=4.8, totalRatingsCount=537,
      createdAt="2026-08-31T23:31:53.579216Z", updatedAt="2026-08-31T23:31:53.579216Z",
    ),
    ClubDto(
      id="c65e8e9c-4ac6-49ec-94b9-32e76a08ac8c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Elewator, Ściana Wspinaczkowa", address="Leona Droszyńskiego 15 H, 80-381 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.4073199, longitude=18.5742449,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8d4d26ba-63cb-47ae-9364-c893e736470c_photo.jpg",
      averageRating=4.8, totalRatingsCount=718,
      createdAt="2026-08-31T23:33:33.343550Z", updatedAt="2026-08-31T23:33:33.343550Z",
    ),
    ClubDto(
      id="734b061e-794e-4caf-9ac2-d9c98edbe95a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KartCenter Gdańsk Gokarty", address="Schuberta 102A Galeria Morena, Poziom minus 2, 80-172 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.352628, longitude=18.5928151,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8c3d7441-8c9a-4819-8c45-65802812d35c_photo.jpg",
      averageRating=4.8, totalRatingsCount=2059,
      createdAt="2026-08-31T23:33:05.589077Z", updatedAt="2026-08-31T23:33:05.589077Z",
    ),
    ClubDto(
      id="a58c61e2-e3c9-431b-91a1-8be04001547e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kartcenter Karts Hostel Bar", address="3 Maja 69C, 81-850 Sopot",
      city="Gdansk", country="PL",
      latitude=54.4339595, longitude=18.5635584,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/44f017b6-9169-4114-adb5-a6972d1ed875_photo.jpg",
      averageRating=4.8, totalRatingsCount=1926,
      createdAt="2026-08-31T23:33:09.892872Z", updatedAt="2026-08-31T23:33:09.892872Z",
    ),
    ClubDto(
      id="6834852d-49bc-494c-83f0-ff5299992f33", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stangiel Tenis & Squash", address="Zeusa 84, 80-180 Kowale",
      city="Gdansk", country="PL",
      latitude=54.3019089, longitude=18.5767,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b86daa06-0ab5-4611-9adc-4d1a9089e312_photo.jpg",
      averageRating=4.8, totalRatingsCount=333,
      createdAt="2026-08-31T23:31:57.744746Z", updatedAt="2026-08-31T23:31:57.744746Z",
    ),
    ClubDto(
      id="4e482c8c-316c-4a23-9280-c614e03d0ea4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ERGO ARENA", address="plac Dwóch Miast 1, 80-344 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.4265, longitude=18.5805165,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f3b8accb-f893-4baa-ae29-d49a5721aec5_photo.jpg",
      averageRating=4.7, totalRatingsCount=17893,
      createdAt="2026-08-31T23:32:27.114762Z", updatedAt="2026-08-31T23:32:27.114762Z",
    ),
    ClubDto(
      id="c6b22652-e379-4b4c-a2c2-3aadfe0c7336", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gdańsk Golf & Country Club", address="83-042 Postołowo",
      city="Gdansk", country="PL",
      latitude=54.1352123, longitude=18.4524364,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/54953eb1-f098-4de5-9031-a35438a7c65a_photo.jpg",
      averageRating=4.7, totalRatingsCount=97,
      createdAt="2026-08-31T23:32:55.752244Z", updatedAt="2026-08-31T23:32:55.752244Z",
    ),
    ClubDto(
      id="2acbcb49-be3e-479d-8ed5-1aec95406d1e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Green Club", address="Hynka 69, 80-465 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3897815, longitude=18.5929172,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1e2973d2-0d05-49ef-b972-1060c0f4e334_photo.jpg",
      averageRating=4.7, totalRatingsCount=3228,
      createdAt="2026-08-31T23:33:38.388306Z", updatedAt="2026-08-31T23:33:38.388306Z",
    ),
    ClubDto(
      id="9264f5cd-4b47-4014-9b77-ed9906350913", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Plaża - Gdańsk Stogi", address="Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.374749, longitude=18.732818,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc072f34-07cb-4b25-9a35-de8acead7b3f_photo.jpg",
      averageRating=4.7, totalRatingsCount=9079,
      createdAt="2026-08-31T23:32:41.829217Z", updatedAt="2026-08-31T23:32:41.829217Z",
    ),
    ClubDto(
      id="96a352c3-cafc-4bb1-bb71-6178cfa9e278", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polsat Plus Arena Gdańsk", address="Pokoleń Lechii Gdańsk 1, 80-560 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3899458, longitude=18.6403027,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f9923ff5-54e9-4d81-ad08-e9c358338aef_photo.jpg",
      averageRating=4.7, totalRatingsCount=18153,
      createdAt="2026-08-31T23:31:24.426709Z", updatedAt="2026-08-31T23:31:24.426709Z",
    ),
    ClubDto(
      id="72f4f1d4-5a6e-4085-9ba6-15e731a55022", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Football Arena Gdańsk", address="Janusza Meissnera 5, 80-462 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.4016041, longitude=18.6019951,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/53103756-2b65-40df-922f-e55b9262d2c2_photo.jpg",
      averageRating=4.6, totalRatingsCount=210,
      createdAt="2026-08-31T23:31:47.914884Z", updatedAt="2026-08-31T23:31:47.914884Z",
    ),
    ClubDto(
      id="5da3e271-852e-4191-acd9-160513d2b974", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GOKF", address="aleja Grunwaldzka 244, 80-314 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3921967, longitude=18.5816574,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f435282-1140-4409-8e7b-2112ff89fa47_photo.jpg",
      averageRating=4.6, totalRatingsCount=248,
      createdAt="2026-08-31T23:31:40.740641Z", updatedAt="2026-08-31T23:31:40.740641Z",
    ),
    ClubDto(
      id="a609bb3f-96b9-4c91-917d-df45f01217ef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lechia Tennis Club", address="Traugutta 29, 80-221 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3664828, longitude=18.6189102,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fa75d892-7b1b-488a-94f1-88207938bad5_photo.jpg",
      averageRating=4.6, totalRatingsCount=171,
      createdAt="2026-08-31T23:32:02.228668Z", updatedAt="2026-08-31T23:32:02.228668Z",
    ),
    ClubDto(
      id="d94da439-66b1-4ced-adcc-8957592d6cb7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MOSiR w Gdańsku", address="Traugutta 29, 80-221 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3687203, longitude=18.6246217,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/22b45a14-7212-432a-a72e-3ba8f13ca854_photo.jpg",
      averageRating=4.6, totalRatingsCount=196,
      createdAt="2026-08-31T23:32:32.975078Z", updatedAt="2026-08-31T23:32:32.975078Z",
    ),
    ClubDto(
      id="38a2c4c1-db07-4e48-9401-302158834ae3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Murall Gdańsk", address="Mariana Hemara 23, 80-280 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3829753, longitude=18.5929726,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0bce8c83-8e53-4cd0-9d1f-bfdf6504004e_photo.jpg",
      averageRating=4.6, totalRatingsCount=1115,
      createdAt="2026-08-31T23:33:27.456697Z", updatedAt="2026-08-31T23:33:27.456697Z",
    ),
    ClubDto(
      id="545ee9fd-9b3f-49f8-99e5-062b01c2bc56", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Postołowo Golf Club", address="Postołowo, 83-042 Ełganowo",
      city="Gdansk", country="PL",
      latitude=54.137463, longitude=18.458191,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6c969923-c9ab-441d-b789-2e11bb02427f_photo.jpg",
      averageRating=4.6, totalRatingsCount=233,
      createdAt="2026-08-31T23:32:51.309659Z", updatedAt="2026-08-31T23:32:51.309659Z",
    ),
    ClubDto(
      id="9920a69b-9023-4457-b6df-79bd09509023", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gdansk Sports Club Gedania 1922", address="Aleja Generała Józefa Hallera 201, 80-416 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3960717, longitude=18.6229735,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5b1c6671-5744-410e-96b3-f6bfe0983c18_photo.jpg",
      averageRating=4.5, totalRatingsCount=706,
      createdAt="2026-08-31T23:31:30.255096Z", updatedAt="2026-08-31T23:31:30.255096Z",
    ),
    ClubDto(
      id="64410227-c304-4234-86ad-0ec7ea3f0e40", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pływalnia Stogi", address="ul, Wilhelma Stryjewskiego 28, 80-620 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3615036, longitude=18.7115267,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ea3c0df4-984f-44df-998c-3029782e3eb9_photo.jpg",
      averageRating=4.4, totalRatingsCount=1024,
      createdAt="2026-08-31T23:32:37.549649Z", updatedAt="2026-08-31T23:32:37.549649Z",
    ),
    ClubDto(
      id="3c1f86d1-206e-4509-8531-b6cb7abb6769", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Miejska Hala Sportowa Gdański Ośrodek Sportu", address="Kołobrzeska 61, 80-397 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.405653, longitude=18.597547,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c14373bb-b938-42ab-a140-26f42ebf848e_photo.jpg",
      averageRating=4.3, totalRatingsCount=254,
      createdAt="2026-08-31T23:31:35.817888Z", updatedAt="2026-08-31T23:31:35.817888Z",
    ),
    ClubDto(
      id="d06a8121-8adb-44a8-9191-5eff07c20d70", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MK Bowling. Entertainment center", address="aleja Grunwaldzka 82, 80-244 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.3773803, longitude=18.6072282,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2f5b300a-c483-4245-9072-de7fa4c11e81_photo.jpg",
      averageRating=4.2, totalRatingsCount=2287,
      createdAt="2026-08-31T23:33:14.696505Z", updatedAt="2026-08-31T23:33:14.696505Z",
    ),
    ClubDto(
      id="09ee7f22-54d4-442a-ba4f-b4c7b456cb68", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SOPRANO", address="aleja Rzeczypospolitej 3, 80-369 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.4022071, longitude=18.5941727,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/71248cfc-3821-4a62-83ae-09d848d91711_photo.jpg",
      averageRating=4.2, totalRatingsCount=2219,
      createdAt="2026-08-31T23:33:21.965872Z", updatedAt="2026-08-31T23:33:21.965872Z",
    ),
    ClubDto(
      id="f10258f5-b5d5-4592-84e2-6d1f4bbedab3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Olimpia Osowa Tenis Stołowy", address="Centrum Handlowe Osowa, Spacerowa 48, 80-299 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.4265094, longitude=18.491448,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/330de2e4-4c59-4bee-814c-cf39a1c320f6_photo.jpg",
      averageRating=5.0, totalRatingsCount=28,
      createdAt="2026-08-31T23:33:00.939223Z", updatedAt="2026-08-31T23:33:00.939223Z",
    ),
    ClubDto(
      id="fed3262e-f2c2-4a6d-a46e-a9610a0c93e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sala sportowa MyCourt", address="Juliusza Słowackiego 4, 80-257 Gdańsk",
      city="Gdansk", country="PL",
      latitude=54.380745, longitude=18.5958594,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f9728043-5c8c-41b1-b77d-42333bcfd732_photo.jpg",
      averageRating=4.5, totalRatingsCount=28,
      createdAt="2026-08-31T23:32:46.824348Z", updatedAt="2026-08-31T23:32:46.824348Z",
    ),
  )),
  CitySeo(slug="phoenix", name="Phoenix", country="US", clubCount=30, sports=listOf(Pair("Football", 5), Pair("Volleyball", 5), Pair("Padel", 3), Pair("Tennis", 3), Pair("Bowling", 2), Pair("Paintball", 2), Pair("Basketball", 2), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Karting", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="e5ff47cd-69f8-4dfe-a4e8-d209cff6648b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Conquer Padel Phoenix", address="7760 S Priest Dr Ste 108, Tempe, AZ 85284",
      city="Phoenix", country="US",
      latitude=33.3477314, longitude=-111.9652386,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e762b1f0-17b7-40b2-9283-81cb776c8b92_photo.jpg",
      averageRating=5.0, totalRatingsCount=87,
      createdAt="2026-09-20T19:18:48.085401Z", updatedAt="2026-09-20T19:18:48.085401Z",
    ),
    ClubDto(
      id="2f4136da-1dc4-4311-b4e6-177d82018edc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ability360 Sports & Fitness Center", address="5031 E Washington St, Phoenix, AZ 85034",
      city="Phoenix", country="US",
      latitude=33.4451355, longitude=-111.9737363,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7e6b17d7-4030-4dab-abb2-a1f52f6edf7b_photo.jpg",
      averageRating=4.8, totalRatingsCount=719,
      createdAt="2026-09-20T19:19:02.398677Z", updatedAt="2026-09-20T19:19:02.398677Z",
    ),
    ClubDto(
      id="1fc05455-0a10-4962-bde2-351e5820a7c6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fightertown Paintball Park", address="9825 N 121st Ave, El Mirage, AZ 85335",
      city="Phoenix", country="US",
      latitude=33.5737039, longitude=-112.3194067,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/500bb215-a0dc-4e6e-8e6e-25faac804825_photo.jpg",
      averageRating=4.8, totalRatingsCount=635,
      createdAt="2026-09-20T19:20:16.363212Z", updatedAt="2026-09-20T19:20:16.363212Z",
    ),
    ClubDto(
      id="edacfa50-b359-4e35-bda4-78ffe998e6fc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Phoenix Kart Racing Association (PKRA)", address="22500 43rd Ave E, Glendale, AZ 85310",
      city="Phoenix", country="US",
      latitude=33.6901779, longitude=-112.1559295,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/abc82c06-7fb4-401f-aaa9-0f1e6cf0e1cc_photo.jpg",
      averageRating=4.8, totalRatingsCount=138,
      createdAt="2026-09-20T19:19:49.135355Z", updatedAt="2026-09-20T19:19:49.135355Z",
    ),
    ClubDto(
      id="1ab8ea80-bfe2-41ef-b940-4661d1c35d8a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="810 Entertainment - Phoenix", address="50 W Jefferson St, Phoenix, AZ 85003",
      city="Phoenix", country="US",
      latitude=33.44749, longitude=-112.0747126,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6b26929c-223e-47b0-8b12-de5061a5e6a0_photo.jpg",
      averageRating=4.7, totalRatingsCount=1376,
      createdAt="2026-09-20T19:19:56.336843Z", updatedAt="2026-09-20T19:19:56.336843Z",
    ),
    ClubDto(
      id="ceda39c8-17a6-4502-93bd-2b6d8cb9d5b3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Phoenix Rock Gym", address="1353 E University Dr, Tempe, AZ 85288",
      city="Phoenix", country="US",
      latitude=33.4206696, longitude=-111.9162499,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e2f3a87e-93cf-4195-b3f4-1c05036f0b2c_photo.jpg",
      averageRating=4.7, totalRatingsCount=864,
      createdAt="2026-09-20T19:20:01.406096Z", updatedAt="2026-09-20T19:20:01.406096Z",
    ),
    ClubDto(
      id="1cfb8a4e-439c-4dd2-a422-cfe09692d816", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AZBATTLEZONE", address="2215 S 39th Ave, Phoenix, AZ 85009",
      city="Phoenix", country="US",
      latitude=33.4283629, longitude=-112.142963,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/af271f03-029b-45fb-865c-7c5b8108fc44_photo.jpg",
      averageRating=4.6, totalRatingsCount=422,
      createdAt="2026-09-20T19:20:20.270684Z", updatedAt="2026-09-20T19:20:20.270684Z",
    ),
    ClubDto(
      id="bb4fc353-4dda-4345-9eee-8fc1f325640c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Encanto Sports Complex", address="2121 N 15th Ave, Phoenix, AZ 85007",
      city="Phoenix", country="US",
      latitude=33.4725062, longitude=-112.0904679,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/343e6daa-dd70-45de-ba5d-9c8fcb31cc62_photo.jpg",
      averageRating=4.6, totalRatingsCount=208,
      createdAt="2026-09-20T19:19:17.102581Z", updatedAt="2026-09-20T19:19:17.102581Z",
    ),
    ClubDto(
      id="e39b0b9d-efb0-490e-98ec-a67c6c9dcdd3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FLC", address="5757 N Central Ave, Phoenix, AZ 85012",
      city="Phoenix", country="US",
      latitude=33.5213036, longitude=-112.07077,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77f37a69-b1d1-4cb6-a933-a5b4ab861e5f_photo.jpg",
      averageRating=4.6, totalRatingsCount=249,
      createdAt="2026-09-20T19:19:08.906453Z", updatedAt="2026-09-20T19:19:08.906453Z",
    ),
    ClubDto(
      id="c67b67c5-b36a-4f68-b541-9c12341919f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Reach 11 Sports Complex", address="2425 E Deer Valley Dr, Phoenix, AZ 85050",
      city="Phoenix", country="US",
      latitude=33.6821293, longitude=-112.0221328,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4b3f18a4-7d24-4398-8b41-8af0e2088e83_photo.jpg",
      averageRating=4.6, totalRatingsCount=1084,
      createdAt="2026-09-20T19:18:17.371463Z", updatedAt="2026-09-20T19:18:17.371463Z",
    ),
    ClubDto(
      id="7cc7f6e4-d984-4d19-8ba4-7588baae795b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Scottsdale Ranch Park & Tennis Center", address="10400 E Vía Linda, Scottsdale, AZ 85258",
      city="Phoenix", country="US",
      latitude=33.575895, longitude=-111.8594669,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8e1f22e5-e4b4-4040-97d7-e0d3c08a510d_photo.jpg",
      averageRating=4.6, totalRatingsCount=648,
      createdAt="2026-09-20T19:18:34.725158Z", updatedAt="2026-09-20T19:18:34.725158Z",
    ),
    ClubDto(
      id="57cfdb79-7fce-4e93-8534-701c6e9b9c3d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Scottsdale Sports Complex", address="8081 E Princess Dr, Scottsdale, AZ 85255",
      city="Phoenix", country="US",
      latitude=33.6417662, longitude=-111.905483,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2f274abc-a0ee-47c1-9580-26d05e8ef66c_photo.jpg",
      averageRating=4.6, totalRatingsCount=1054,
      createdAt="2026-09-20T19:18:21.175597Z", updatedAt="2026-09-20T19:18:21.175597Z",
    ),
    ClubDto(
      id="adde886f-0c4d-428f-97e9-4536adf44e9c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cactus Yards", address="4536 E Elliot Rd, Gilbert, AZ 85234",
      city="Phoenix", country="US",
      latitude=33.3553241, longitude=-111.6938918,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4014c80e-cab8-4924-b9d9-4ca1d5958875_photo.jpg",
      averageRating=4.5, totalRatingsCount=1109,
      createdAt="2026-09-20T19:18:12.567011Z", updatedAt="2026-09-20T19:18:12.567011Z",
    ),
    ClubDto(
      id="80a73c38-7650-4ceb-9eb0-c9017b3af767", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Focus Climbing Center", address="2150 W Broadway Rd #103, Mesa, AZ 85202",
      city="Phoenix", country="US",
      latitude=33.408853, longitude=-111.8777236,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e26028ee-7316-4e80-a7db-c3268fa165fe_photo.jpg",
      averageRating=4.5, totalRatingsCount=470,
      createdAt="2026-09-20T19:20:04.894451Z", updatedAt="2026-09-20T19:20:04.894451Z",
    ),
    ClubDto(
      id="1118370a-56b3-4d26-8352-be4240e82b65", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Surprise Tennis & Racquet Complex", address="14469 W Paradise Ln, Surprise, AZ 85374",
      city="Phoenix", country="US",
      latitude=33.6297222, longitude=-112.3716667,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/42a0f99f-f46f-49c6-843e-b29b11f395a6_photo.jpg",
      averageRating=4.5, totalRatingsCount=231,
      createdAt="2026-09-20T19:18:44.831866Z", updatedAt="2026-09-20T19:18:44.831866Z",
    ),
    ClubDto(
      id="ec1a8800-d219-409b-bb53-a374de1974c8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Victorium", address="9219 E Hidden Spur Trail, Scottsdale, AZ 85255",
      city="Phoenix", country="US",
      latitude=33.6441148, longitude=-111.8824764,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4c5d3b24-4701-4558-8269-110a3a9d92f6_photo.jpg",
      averageRating=4.5, totalRatingsCount=192,
      createdAt="2026-09-20T19:19:21.323515Z", updatedAt="2026-09-20T19:19:21.323515Z",
    ),
    ClubDto(
      id="71211e89-a206-419f-866e-2209ca0fec1c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="American Sports Centers-Avondale", address="755 N 114th Ave, Avondale, AZ 85323",
      city="Phoenix", country="US",
      latitude=33.4540111, longitude=-112.3046037,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc647603-7ea2-4a2b-9341-4fa55e2152a3_photo.jpg",
      averageRating=4.4, totalRatingsCount=940,
      createdAt="2026-09-20T19:18:25.113498Z", updatedAt="2026-09-20T19:18:25.113498Z",
    ),
    ClubDto(
      id="14bfb097-8976-40b9-85b3-627659700d66", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bull Shooters", address="3337 W Peoria Ave, Phoenix, AZ 85029",
      city="Phoenix", country="US",
      latitude=33.5806236, longitude=-112.1330566,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac45b13a-1076-450b-97c6-c14c221a3452_photo.jpg",
      averageRating=4.4, totalRatingsCount=3055,
      createdAt="2026-09-20T19:20:09.324343Z", updatedAt="2026-09-20T19:20:09.324343Z",
    ),
    ClubDto(
      id="6707cf48-9ae8-4416-8892-8d7919be47e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mavrix", address="9139 E Talking Stick Wy, Scottsdale, AZ 85250",
      city="Phoenix", country="US",
      latitude=33.5366956, longitude=-111.8841611,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d766f3d6-5444-4716-8187-f4810981c1dc_photo.jpg",
      averageRating=4.4, totalRatingsCount=1622,
      createdAt="2026-09-20T19:19:53.069224Z", updatedAt="2026-09-20T19:19:53.069224Z",
    ),
    ClubDto(
      id="2c019b0c-9125-42ad-9618-8b7da1c2fa0e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rose Mofford Sports Complex", address="9833 N 25th Ave, Phoenix, AZ 85021",
      city="Phoenix", country="US",
      latitude=33.5746849, longitude=-112.110839,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS", "BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/269c71d4-e6fa-474d-933f-693cfb9d439e_photo.jpg",
      averageRating=4.4, totalRatingsCount=905,
      createdAt="2026-09-20T19:18:28.846414Z", updatedAt="2026-09-20T19:18:28.846414Z",
    ),
    ClubDto(
      id="78d6733a-ead8-4729-a310-14cf35635a96", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Papago Golf Club", address="5595 E Karsten Wy, Phoenix, AZ 85008",
      city="Phoenix", country="US",
      latitude=33.4612508, longitude=-111.9607678,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9f9dfe79-08a9-4d1b-9530-c6b5f0b866cd_photo.jpg",
      averageRating=4.3, totalRatingsCount=825,
      createdAt="2026-09-20T19:19:42.397915Z", updatedAt="2026-09-20T19:19:42.397915Z",
    ),
    ClubDto(
      id="873a692a-4897-41c5-a7d3-cc67f29f3fd6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Clubs at Arrowhead", address="19888 N 73rd Ave, Glendale, AZ 85308",
      city="Phoenix", country="US",
      latitude=33.6635315, longitude=-112.2142039,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e4a4f06c-ca7b-4a67-b91f-9406dde07b8b_photo.jpg",
      averageRating=4.3, totalRatingsCount=607,
      createdAt="2026-09-20T19:18:40.259861Z", updatedAt="2026-09-20T19:18:40.259861Z",
    ),
    ClubDto(
      id="773e5e12-f726-4df3-8d2c-f7a431a9159e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Victory Lane Sports Park", address="22603 N 43rd Ave, Glendale, AZ 85310",
      city="Phoenix", country="US",
      latitude=33.6920676, longitude=-112.1497893,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e1f8cd4-6063-4da6-abe4-6ed225bd0118_photo.jpg",
      averageRating=4.3, totalRatingsCount=636,
      createdAt="2026-09-20T19:19:30.924847Z", updatedAt="2026-09-20T19:19:30.924847Z",
    ),
    ClubDto(
      id="8a574cc2-73a6-45b6-9c46-f3a167e1ffa9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Talking Stick Golf Club", address="9998 E Talking Stick Wy, Scottsdale, AZ 85256",
      city="Phoenix", country="US",
      latitude=33.5467498, longitude=-111.8654265,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/820f645a-4b1e-4bbb-9a26-05d13ee26fb5_photo.jpg",
      averageRating=4.2, totalRatingsCount=862,
      createdAt="2026-09-20T19:19:38.822283Z", updatedAt="2026-09-20T19:19:38.822283Z",
    ),
    ClubDto(
      id="c7c079b6-aaed-416b-a939-b8ba9760a6ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arizona Sports Complex", address="3555 W Pinnacle Peak Rd, Glendale, AZ 85310",
      city="Phoenix", country="US",
      latitude=33.697357, longitude=-112.13883,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/03a93790-fd8e-423d-8269-fa754bd54f58_photo.jpg",
      averageRating=3.9, totalRatingsCount=144,
      createdAt="2026-09-20T19:19:25.462050Z", updatedAt="2026-09-20T19:19:25.462050Z",
    ),
    ClubDto(
      id="b7547c9c-3f75-41ab-b352-def372709419", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MAYA Day + Night", address="7333 E Indian Plaza, Scottsdale, AZ 85251",
      city="Phoenix", country="US",
      latitude=33.501291, longitude=-111.9228153,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c3664e9a-0662-4e22-b942-b0571ab36310_photo.jpg",
      averageRating=3.8, totalRatingsCount=1379,
      createdAt="2026-09-20T19:20:13.306591Z", updatedAt="2026-09-20T19:20:13.306591Z",
    ),
    ClubDto(
      id="a52f5f78-2185-415f-8653-c55e650f9542", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mesa Padel Club", address="219 W Main St, Mesa, AZ 85201",
      city="Phoenix", country="US",
      latitude=33.4148291, longitude=-111.8375295,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d1ea7810-d473-4cb1-b6c6-769d80089357_photo.jpg",
      averageRating=5.0, totalRatingsCount=36,
      createdAt="2026-09-20T19:18:56.594141Z", updatedAt="2026-09-20T19:18:56.594141Z",
    ),
    ClubDto(
      id="944a8866-0f00-4980-a8d3-e97d42e115b2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Pals Club - East Valley Mesa/Gilbert", address="4945 S 71st St, Mesa, AZ 85212",
      city="Phoenix", country="US",
      latitude=33.3258407, longitude=-111.6798878,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/564bb2cc-7282-4717-88cd-e0cc210c4032_photo.jpg",
      averageRating=5.0, totalRatingsCount=36,
      createdAt="2026-09-20T19:18:52.107705Z", updatedAt="2026-09-20T19:18:52.107705Z",
    ),
    ClubDto(
      id="b8f7304c-0eec-4d7a-adf4-d3fee641f7e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Phoenix Table Tennis Club", address="1550 W Colter St, Phoenix, AZ 85015",
      city="Phoenix", country="US",
      latitude=33.5145098, longitude=-112.0927867,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/810ea94f-0162-4c63-8415-75aa5501c54e_photo.jpg",
      averageRating=4.7, totalRatingsCount=38,
      createdAt="2026-09-20T19:19:45.973710Z", updatedAt="2026-09-20T19:19:45.973710Z",
    ),
    ClubDto(
      id="fc8d190b-daa0-491b-b4c4-07a3b6160345", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Funkalicious Beach Volleyball", address="6398 E Oak St Sand Suite 101, Scottsdale, AZ 85257",
      city="Phoenix", country="US",
      latitude=33.4736065, longitude=-111.9449664,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c4ecf312-e582-4e94-868f-bd8cd0a0c60c_photo.jpg",
      averageRating=4.9, totalRatingsCount=32,
      createdAt="2026-09-20T19:19:34.547006Z", updatedAt="2026-09-20T19:19:34.547006Z",
    ),
  )),
  CitySeo(slug="rome", name="Rome", country="IT", clubCount=30, sports=listOf(Pair("Volleyball", 5), Pair("Padel", 3), Pair("Football", 3), Pair("Tennis", 3), Pair("Basketball", 2), Pair("Bowling", 2), Pair("Karting", 2), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Paintball", 2), Pair("Table Tennis", 1), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="bdd85b80-0698-42f8-b2da-1a44c3030f80", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Spartan Paintball Pietralata", address="Via Mesula, 14, 00158 Roma RM",
      city="Rome", country="IT",
      latitude=41.9242286, longitude=12.5356475,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/488f59d3-7ccf-4a4f-8ec5-9171874927ad_ChIJEe56NeFj_0.jpg",
      averageRating=4.8, totalRatingsCount=720,
      createdAt="2026-08-30T21:21:06.823054Z", updatedAt="2026-08-30T21:21:06.823054Z",
    ),
    ClubDto(
      id="773b94aa-a684-4377-9919-ff82917ead61", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Monkey Island", address="Via Cornelia, 493, 00166 Roma RM",
      city="Rome", country="IT",
      latitude=41.8917969, longitude=12.3845085,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/52bd20e1-6651-4a44-b9b5-7bf7a85c8eba_ChIJacsN_HBf_0.jpg",
      averageRating=4.7, totalRatingsCount=402,
      createdAt="2026-08-30T21:20:40.348488Z", updatedAt="2026-08-30T21:20:40.348488Z",
    ),
    ClubDto(
      id="1220860e-0f2e-45bd-adb2-74c370664f01", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rock it Climbing Roma", address="Via Biordo Michelotti, 22/int. 14/17, 00176 Roma RM",
      city="Rome", country="IT",
      latitude=41.8939513, longitude=12.5381148,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/18c9583d-656f-4489-80aa-05bebd652513_ChIJ5zY8Ei9i_0.jpg",
      averageRating=4.7, totalRatingsCount=433,
      createdAt="2026-08-30T21:20:33.744556Z", updatedAt="2026-08-30T21:59:49.231821Z",
    ),
    ClubDto(
      id="d6ec8aac-e433-4332-89a5-2207d5ca1915", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="White Padel", address="Viale Antonio Ciamarra, 18, 00173 Roma RM",
      city="Rome", country="IT",
      latitude=41.8474238, longitude=12.5917396,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c317feb6-446f-44c1-b9f5-cfa0e594ed9a_ChIJ372yKZeJ_0.jpg",
      averageRating=4.7, totalRatingsCount=232,
      createdAt="2026-08-30T21:21:33.546683Z", updatedAt="2026-08-30T21:21:33.546683Z",
    ),
    ClubDto(
      id="aba0fe99-5242-4419-ba7c-a340f930a754", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="e-goKart Roma", address="Via Salvatore Rebecchini, 5, 00148 Roma RM",
      city="Rome", country="IT",
      latitude=41.8152163, longitude=12.4117794,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6f0d9f5f-1fc6-4dbc-af15-cd4b09e98b7b_ChIJIYbofgD1_0.jpg",
      averageRating=4.7, totalRatingsCount=1218,
      createdAt="2026-08-30T21:20:46.990833Z", updatedAt="2026-08-30T22:02:34.964090Z",
    ),
    ClubDto(
      id="a71067f5-fde5-474f-a678-d165d594dc53", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bola Padel Club", address="Via Luigi Perna, 26, 00142 Roma RM",
      city="Rome", country="IT",
      latitude=41.8466004, longitude=12.4809105,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/468b6147-2878-44c7-a7b3-b12f081d9e84_ChIJlaVIMfSK_0.jpg",
      averageRating=4.6, totalRatingsCount=585,
      createdAt="2026-08-30T21:21:19.803960Z", updatedAt="2026-08-30T21:55:35.058717Z",
    ),
    ClubDto(
      id="de7da050-0b0e-406d-9921-2afb9da40053", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Joy Padel Club", address="Via di Torre Spaccata, 155, 00169 Roma RM",
      city="Rome", country="IT",
      latitude=41.8629175, longitude=12.5841257,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a449df9a-60d1-4613-a557-a9a5b2f69386_ChIJfdfBWz1j_0.jpg",
      averageRating=4.6, totalRatingsCount=456,
      createdAt="2026-08-30T21:21:26.648036Z", updatedAt="2026-08-30T21:57:29.008513Z",
    ),
    ClubDto(
      id="23d47640-b260-4830-b0b9-059c3e24656f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports City Beach", address="Via Cina, 91, 00144 Roma RM",
      city="Rome", country="IT",
      latitude=41.815141, longitude=12.4387389,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0acbfba-0758-4a05-9c56-04ec169635ab_photo.jpg",
      averageRating=4.6, totalRatingsCount=141,
      createdAt="2026-08-31T15:07:18.062815Z", updatedAt="2026-08-31T15:07:18.062815Z",
    ),
    ClubDto(
      id="50c54f56-9368-44a8-8cc3-5ec0cac1c9c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Due Ponti Sporting Club", address="V. dei Due Ponti, 48 A, 00189 Roma RM",
      city="Rome", country="IT",
      latitude=41.9586956, longitude=12.4786926,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/08305959-fded-4415-a2a0-6574bd5ce023_ChIJ_etVgihn_1.jpg",
      averageRating=4.5, totalRatingsCount=1165,
      createdAt="2026-08-30T21:21:46.384872Z", updatedAt="2026-08-31T22:11:15.745528Z",
    ),
    ClubDto(
      id="e0d28304-f408-4dd1-9aee-a97e5c96e700", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Towerpaintball - Paintball Roma", address="Via Ardeatina, 931, 00178 Roma RM",
      city="Rome", country="IT",
      latitude=41.7993957, longitude=12.5399522,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/639d1c4b-b63a-4343-8963-cc114d122ec7_ChIJqUH4sD5j_0.jpg",
      averageRating=4.5, totalRatingsCount=527,
      createdAt="2026-08-30T21:21:13.219414Z", updatedAt="2026-08-30T22:01:42.718453Z",
    ),
    ClubDto(
      id="d27e2856-5e61-411d-9d1a-6590aae5d84d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basket/Pallacanestro Roma Team Up", address="Viale Kant, 305, 00156 Roma RM",
      city="Rome", country="IT",
      latitude=41.9382163, longitude=12.5523721,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/786f6537-bc06-439c-a62d-c9d03a8f063a_photo.jpg",
      averageRating=4.4, totalRatingsCount=143,
      createdAt="2026-08-31T15:06:57.649011Z", updatedAt="2026-08-31T15:06:57.649011Z",
    ),
    ClubDto(
      id="07f3c9c0-fd3e-4cf1-8fb2-92b730c93f08", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Marlo's", address="Via Appia Nuova, 587a, 00179 Roma RM",
      city="Rome", country="IT",
      latitude=41.8687399, longitude=12.5300805,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c4594951-bab9-423b-90a5-f7a3951955ba_ChIJRdJgqvhh_0.jpg",
      averageRating=4.4, totalRatingsCount=279,
      createdAt="2026-08-30T21:20:04.368247Z", updatedAt="2026-08-30T21:20:04.368247Z",
    ),
    ClubDto(
      id="4b79b0e9-ed6b-4ffd-ae91-3da908202874", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PalaBeach", address="Parco Happy Family, Viale Cortina d'Ampezzo, 379/385, 00135 Roma RM",
      city="Rome", country="IT",
      latitude=41.9411348, longitude=12.4355901,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1240592-665d-40be-840d-2b6f97f0c761_photo.jpg",
      averageRating=4.4, totalRatingsCount=155,
      createdAt="2026-08-31T15:07:10.724960Z", updatedAt="2026-08-31T15:07:10.724960Z",
    ),
    ClubDto(
      id="988054ed-1b69-4044-a478-98dde0aca6dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Parco di Roma Golf Club", address="V. dei Due Ponti, 110, 00189 Roma RM",
      city="Rome", country="IT",
      latitude=41.9652343, longitude=12.4725513,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/40131458-60ad-497d-87fe-20ed1a26398a_photo.jpg",
      averageRating=4.4, totalRatingsCount=347,
      createdAt="2026-08-31T15:07:45.488357Z", updatedAt="2026-08-31T15:07:45.488357Z",
    ),
    ClubDto(
      id="50a517f5-59c6-4c5e-b0aa-e067d7846552", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stadio delle Tre Fontane", address="Via delle Tre Fontane, 5, 00144 Roma RM",
      city="Rome", country="IT",
      latitude=41.8412214, longitude=12.4701298,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a663f2f6-d899-4955-8ab5-fe68a61fade2_ChIJx9EIe-WK_0.jpg",
      averageRating=4.4, totalRatingsCount=987,
      createdAt="2026-08-30T21:19:57.628134Z", updatedAt="2026-08-30T21:19:57.628134Z",
    ),
    ClubDto(
      id="27b65583-7e3e-4010-8e35-d6b024baba57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tor Vergata Sporting Center", address="Via della Ricerca Scientifica, 00133 Roma RM",
      city="Rome", country="IT",
      latitude=41.8561896, longitude=12.6063578,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/73fe209e-ca8e-4c7e-be55-90a0b51afce7_photo.jpg",
      averageRating=4.4, totalRatingsCount=118,
      createdAt="2026-08-31T15:07:04.100302Z", updatedAt="2026-08-31T15:07:04.100302Z",
    ),
    ClubDto(
      id="57a8d8f9-ac14-4b7a-beff-f8afdc420b57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Xcalibur Lasergame Roma", address="Via Tripoli, 147C/F, 00199 Roma RM",
      city="Rome", country="IT",
      latitude=41.9285091, longitude=12.518326,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b8ea864-bd97-4e62-96be-8b08c27fe247_ChIJuUjiVVth_0.jpg",
      averageRating=4.4, totalRatingsCount=659,
      createdAt="2026-08-30T21:21:00.180716Z", updatedAt="2026-08-30T22:02:27.228882Z",
    ),
    ClubDto(
      id="dcd7f7be-993d-4859-91a1-099ef99cda29", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gli Ulivi Sporting Club", address="V. della Pisana, 1078, 00163 Roma RM",
      city="Rome", country="IT",
      latitude=41.8540203, longitude=12.3835652,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5d8ac7cb-028a-4a0e-8d68-5a7b2e041b6a_photo.jpg",
      averageRating=4.3, totalRatingsCount=466,
      createdAt="2026-08-31T15:07:24.886593Z", updatedAt="2026-08-31T15:07:24.886593Z",
    ),
    ClubDto(
      id="65991812-677e-4535-995e-64a51881188b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sala Biliardi Caesar", address="Circonvallazione Gianicolense, 300, 00152 Roma RM",
      city="Rome", country="IT",
      latitude=41.8754443, longitude=12.4460407,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ca36e7f9-431b-47b2-85b0-02b05a1617fc_ChIJ9Vc2IgFg_0.jpg",
      averageRating=4.3, totalRatingsCount=111,
      createdAt="2026-08-30T21:20:11.938212Z", updatedAt="2026-08-30T21:20:11.938212Z",
    ),
    ClubDto(
      id="45fabbf8-db46-4bcf-b319-1d0a1ec9a382", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tevere Golf", address="Via del Baiardo, 390, 00191 Roma RM",
      city="Rome", country="IT",
      latitude=41.947773, longitude=12.5002838,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c0febedb-1c0a-44a7-bab0-2a2634271482_photo.jpg",
      averageRating=4.3, totalRatingsCount=133,
      createdAt="2026-08-31T15:07:53.080172Z", updatedAt="2026-08-31T15:07:53.080172Z",
    ),
    ClubDto(
      id="75b71b16-a482-4ef7-bcf4-28f957f11e94", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Village Parco de' Medici", address="Via Salvatore Rebecchini, 5, 00148 Roma RM",
      city="Rome", country="IT",
      latitude=41.815065, longitude=12.4119262,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aac53c48-ae39-482a-b5a2-49579e9937ab_ChIJR_LEE5P0_0.jpg",
      averageRating=4.3, totalRatingsCount=10813,
      createdAt="2026-08-30T21:20:19.885580Z", updatedAt="2026-08-30T22:01:39.747904Z",
    ),
    ClubDto(
      id="db1dd0e4-a842-424f-8c06-3dd543ce374b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Brunswick", address="Lungotevere dell'Acqua Acetosa, 10, 00197 Roma RM",
      city="Rome", country="IT",
      latitude=41.9337886, longitude=12.4798388,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dfc80a09-ccc6-484a-b894-d316b1295ea5_ChIJsyUUT99g_0.jpg",
      averageRating=4.2, totalRatingsCount=4549,
      createdAt="2026-08-30T21:20:26.311570Z", updatedAt="2026-08-30T21:20:26.311570Z",
    ),
    ClubDto(
      id="07dd8fa3-9943-4334-818b-2874f1ee6ec4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="S.S.D. Polisportiva Cinecittà Bettini", address="Via Quinto Publicio, 39, 00173 Roma RM",
      city="Rome", country="IT",
      latitude=41.85734, longitude=12.576452,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77b20238-df7d-4565-bf43-7bc7308ff8eb_ChIJpShP2yqI_0.jpg",
      averageRating=4.2, totalRatingsCount=1104,
      createdAt="2026-08-30T21:19:51.026945Z", updatedAt="2026-08-30T21:19:51.026945Z",
    ),
    ClubDto(
      id="bf631801-51d8-4877-9827-4791ea6d8a93", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporting Club Panda", address="Via Nomentana, 1070, 00137 Roma RM",
      city="Rome", country="IT",
      latitude=41.9522691, longitude=12.5726542,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2189d056-e2f7-46c7-a9d4-de6940814168_ChIJHZbcnWFk_0.jpg",
      averageRating=4.2, totalRatingsCount=849,
      createdAt="2026-08-30T21:21:52.633594Z", updatedAt="2026-08-30T22:00:29.548545Z",
    ),
    ClubDto(
      id="97fe912e-7961-4863-8cd0-5fa44132b3f1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club Garden", address="Via delle Capannelle, 217, 00178 Roma RM",
      city="Rome", country="IT",
      latitude=41.8447747, longitude=12.5728092,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cb2bba26-996e-47cd-87a5-45a0802c218d_ChIJU1edu8yJ_0.jpg",
      averageRating=4.2, totalRatingsCount=1220,
      createdAt="2026-08-30T21:21:39.922081Z", updatedAt="2026-08-30T22:01:22.639437Z",
    ),
    ClubDto(
      id="1bfed116-6a5a-4e71-b3d1-c16b4ee9271c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bamboo Beach-Scuola Pallavolo", address="Viale Giorgio De Chirico, 113, 00155 Roma RM",
      city="Rome", country="IT",
      latitude=41.8972705, longitude=12.5891796,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/debc025b-6ece-49e1-ad17-1775bfab5414_photo.jpg",
      averageRating=4.5, totalRatingsCount=46,
      createdAt="2026-08-31T15:07:30.732249Z", updatedAt="2026-08-31T22:11:14.024474Z",
    ),
    ClubDto(
      id="fa2b799d-f7b8-45c1-ad1e-aba4e86b0d0a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Holykartroma", address="Via Silicella, 111, 00169 Roma RM",
      city="Rome", country="IT",
      latitude=41.860225, longitude=12.598613,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/90f14408-19d5-4b27-a8ce-7a502b1273bb_ChIJk6qzWZ9i_0.jpg",
      averageRating=4.1, totalRatingsCount=834,
      createdAt="2026-08-30T21:20:53.352591Z", updatedAt="2026-08-30T21:20:53.352591Z",
    ),
    ClubDto(
      id="3e342c8f-0cac-4ebe-a870-5decebb7ec9a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dabliu Eur Sport Club", address="Viale Egeo, 98, 00144 Roma RM",
      city="Rome", country="IT",
      latitude=41.8311327, longitude=12.4544276,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eab59c56-888c-4a2b-ab58-2b2f72747f5c_ChIJ2TE8xCCL_0.jpg",
      averageRating=4.0, totalRatingsCount=1318,
      createdAt="2026-08-30T21:19:44.735322Z", updatedAt="2026-09-01T14:31:56.528236Z",
    ),
    ClubDto(
      id="df441526-f208-4d13-8781-0ea94b514d2b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BVZ Beach Volley Zone", address="Via Franco Tosi, 19, 00133 Roma RM",
      city="Rome", country="IT",
      latitude=41.8573699, longitude=12.6429773,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04cc41df-f4a5-4789-9500-d5c1f2269e42_photo.jpg",
      averageRating=5.0, totalRatingsCount=20,
      createdAt="2026-08-31T15:07:36.928018Z", updatedAt="2026-08-31T15:07:36.928018Z",
    ),
    ClubDto(
      id="5c1d3078-14f8-405f-a4b7-5759cc9a89a4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="A.S.D. Roma Ping Pong (Scuola di Tennistavolo)", address="Via Rodolfo Lanciani, 51, 00162 Roma RM",
      city="Rome", country="IT",
      latitude=41.921392, longitude=12.52373,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d9bd35e8-bd19-4486-b7e0-1ebe83f481af_photo.jpg",
      averageRating=4.9, totalRatingsCount=12,
      createdAt="2026-08-31T15:08:01.760844Z", updatedAt="2026-08-31T15:08:01.760844Z",
    ),
  )),
  CitySeo(slug="toulouse", name="Toulouse", country="FR", clubCount=30, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Volleyball", 3), Pair("Climbing", 2), Pair("Table Tennis", 2), Pair("Paintball", 2), Pair("Bowling", 2), Pair("Basketball", 2), Pair("Golf", 2), Pair("Laser Tag", 2), Pair("Billiards", 2), Pair("Karting", 1), Pair("Padel", 1)), clubs=listOf(
    ClubDto(
      id="c0982682-6acd-4315-8e57-8b3c91e6fe8f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Volley Vibes", address="88 All. Jean Jaurès, 31000 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6088223, longitude=1.4540513,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7c4057bd-59b1-47b4-9a43-b797421f956f_photo.jpg",
      averageRating=5.0, totalRatingsCount=50,
      createdAt="2026-08-31T23:15:34.585624Z", updatedAt="2026-08-31T23:15:34.585624Z",
    ),
    ClubDto(
      id="c3dd6bd5-5e4b-4960-a5a9-d1802b0e3747", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Toulouse Padel Club & Squash", address="11 Rue Marie-Louise Dissard, 31300 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6015083, longitude=1.366907,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/97789d7a-d3cd-4bbe-948f-d17bc40087f5_photo.jpg",
      averageRating=4.8, totalRatingsCount=1435,
      createdAt="2026-08-31T23:15:10.126955Z", updatedAt="2026-08-31T23:15:10.126955Z",
    ),
    ClubDto(
      id="edfdafb3-d4d7-4250-9ba4-fe51fdc08314", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Horizonsport Stages Sportifs", address="13 Port Saint-Étienne, 31000 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6002086, longitude=1.4556658,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/35362a55-80bb-46dc-a4c5-c1b1a71178d1_photo.jpg",
      averageRating=4.7, totalRatingsCount=91,
      createdAt="2026-08-31T23:15:16.441986Z", updatedAt="2026-08-31T23:15:16.441986Z",
    ),
    ClubDto(
      id="68b726b0-7f70-40a5-91ad-34a09cefb5f6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Play Soccer", address="33 Av. de Larrieu, 31100 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.5512023, longitude=1.4098927,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f6954d0a-202d-4a5d-9fa4-d521e768a01c_photo.jpg",
      averageRating=4.7, totalRatingsCount=476,
      createdAt="2026-08-31T23:14:33.429382Z", updatedAt="2026-08-31T23:14:33.429382Z",
    ),
    ClubDto(
      id="a54813d4-fa4a-45ee-8862-b01b999aa906", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stade Ernest-Wallon", address="114 Rue des Troènes, 31200 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6215484, longitude=1.4151361,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/74bb3c94-b28b-4cab-aa4b-bedf53f04fe5_photo.jpg",
      averageRating=4.7, totalRatingsCount=7364,
      createdAt="2026-08-31T23:14:17.511518Z", updatedAt="2026-08-31T23:14:17.511518Z",
    ),
    ClubDto(
      id="05558169-8645-401d-90a5-ada437244def", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TOEC Association TENNIS", address="8 Rue Ernest Dufer, 31300 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.5992271, longitude=1.4000129,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/71bba0c1-f41b-4975-9084-78b0bc945052_photo.jpg",
      averageRating=4.7, totalRatingsCount=172,
      createdAt="2026-08-31T23:14:49.810170Z", updatedAt="2026-08-31T23:14:49.810170Z",
    ),
    ClubDto(
      id="487adbab-87d5-4e9d-afa7-c407de5fbd99", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Adventure Paintball Park", address="Rte de Quint, 31650 Saint-Orens-de-Gameville",
      city="Toulouse", country="FR",
      latitude=43.5721932, longitude=1.5492255,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7d1f95ba-68c0-4c39-8f94-62e15c4446a5_photo.jpg",
      averageRating=4.6, totalRatingsCount=334,
      createdAt="2026-08-31T23:16:51.680640Z", updatedAt="2026-08-31T23:16:51.680640Z",
    ),
    ClubDto(
      id="686ff395-2818-48dc-85ea-b10f55db5ab3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Classico Foot", address="5 Rue Sadi Carnot, 31830 Plaisance-du-Touch",
      city="Toulouse", country="FR",
      latitude=43.5946233, longitude=1.2910089,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f167e4b2-a1c5-4114-86c1-51898c99feea_photo.jpg",
      averageRating=4.6, totalRatingsCount=331,
      createdAt="2026-08-31T23:14:39.277077Z", updatedAt="2026-08-31T23:14:39.277077Z",
    ),
    ClubDto(
      id="84fce7ff-4164-428b-93fc-a52394ddb6af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PAINTBALL XXL TOULOUSE", address="1050 Rte de Baziege, 31450 Montlaur",
      city="Toulouse", country="FR",
      latitude=43.4775201, longitude=1.5746819,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/13237153-8e8e-4492-bf43-ee6de7b19652_photo.jpg",
      averageRating=4.6, totalRatingsCount=137,
      createdAt="2026-08-31T23:16:58.785039Z", updatedAt="2026-08-31T23:16:58.785039Z",
    ),
    ClubDto(
      id="fd7eef8b-851f-40f0-947b-f43b044e4dbc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TENNIS CLUB COLOMIERS", address="2 Bis All. des Alpilles, 31770 Colomiers",
      city="Toulouse", country="FR",
      latitude=43.5979876, longitude=1.3359732,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f6c4d006-4059-404b-8bbe-3efb2ee5632c_photo.jpg",
      averageRating=4.6, totalRatingsCount=152,
      createdAt="2026-08-31T23:14:54.299192Z", updatedAt="2026-08-31T23:14:54.299192Z",
    ),
    ClubDto(
      id="b86d9573-2a75-4597-b925-861b18bb94bd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ALTISSIMO Toulouse Montaudran", address="5 Rue Jean Rodier, 31400 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.5666573, longitude=1.487163,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bd425dd8-1598-4d74-8f4d-7a4ab91550ef_photo.jpg",
      averageRating=4.5, totalRatingsCount=607,
      createdAt="2026-08-31T23:16:26.481967Z", updatedAt="2026-08-31T23:16:26.481967Z",
    ),
    ClubDto(
      id="25b96c07-9566-4cc0-8b77-a5f6b86c3a8d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SOLO Escalade Toulouse", address="131 Chem. du Sang de Serp, 31200 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6200103, longitude=1.4205258,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/294ea7c1-3e96-43d6-a68f-13645fd5b1ae_photo.jpg",
      averageRating=4.5, totalRatingsCount=853,
      createdAt="2026-08-31T23:16:20.762750Z", updatedAt="2026-08-31T23:16:20.762750Z",
    ),
    ClubDto(
      id="93bbcc23-1c47-458b-bca3-e3bf7f40d938", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ASPTT Toulouse Tennis de Table", address="47 Rue de Soupetard, 31500 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6114631, longitude=1.4732616,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db2bd384-f00f-41cc-9a13-ff343f7049e5_photo.jpg",
      averageRating=4.4, totalRatingsCount=62,
      createdAt="2026-08-31T23:15:54.494436Z", updatedAt="2026-08-31T23:15:54.494436Z",
    ),
    ClubDto(
      id="627088f1-6819-4c87-8c44-9643472aa373", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Gramont", address="Porte du Lauragais, Centre Commercial Auchan, 2 Chem. de Gabardie, 31200 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6318049, longitude=1.4865616,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fa9c23d7-2fdb-4258-81f3-64867b6f1ed0_photo.jpg",
      averageRating=4.4, totalRatingsCount=4531,
      createdAt="2026-08-31T23:16:12.102268Z", updatedAt="2026-08-31T23:16:12.102268Z",
    ),
    ClubDto(
      id="54feb4d2-b52a-49f3-b1d9-f57b3475cd6d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Exclusiv Golf de Toulouse Seilh", address="Rte de Grenade, 31840 Seilh",
      city="Toulouse", country="FR",
      latitude=43.6838549, longitude=1.3583903,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1fb342f3-2dd4-47f1-8ca2-640ec58d2015_photo.jpg",
      averageRating=4.4, totalRatingsCount=931,
      createdAt="2026-08-31T23:15:51.120565Z", updatedAt="2026-08-31T23:15:51.120565Z",
    ),
    ClubDto(
      id="a7acf90c-d90a-4d60-8320-c3c87d29145d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Game Evolution Portet sur Garonne", address="36 Av. des Palanques, 31120 Portet-sur-Garonne",
      city="Toulouse", country="FR",
      latitude=43.5381194, longitude=1.4033318,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/88486b83-db1a-4de7-89eb-0198539f3de8_photo.jpg",
      averageRating=4.4, totalRatingsCount=85,
      createdAt="2026-08-31T23:16:44.621292Z", updatedAt="2026-08-31T23:16:44.621292Z",
    ),
    ClubDto(
      id="0c58b24a-60f4-4405-a3c5-9d32bbfeacce", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le 147", address="12 Rue des Amidonniers, 31000 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.605844, longitude=1.429596,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d9585ab5-ac56-4c73-823c-b6fb61f39406_photo.jpg",
      averageRating=4.4, totalRatingsCount=1326,
      createdAt="2026-08-31T23:16:30.150732Z", updatedAt="2026-08-31T23:16:30.150732Z",
    ),
    ClubDto(
      id="06b9d726-4aa0-4e19-bf1c-4fdbcf31029b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Spacer's Toulouse Volley", address="3 Rue Pierre Laplace, 31000 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6122206, longitude=1.4353479,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fc65aedf-f14a-4cd4-9ccf-09c8e838941d_photo.jpg",
      averageRating=4.4, totalRatingsCount=497,
      createdAt="2026-08-31T23:15:29.639920Z", updatedAt="2026-08-31T23:15:29.639920Z",
    ),
    ClubDto(
      id="913b6e0d-fc82-432b-991a-6e8e2c4fcaf2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Montaudran", address="164 Rte de Revel, 31400 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.5695668, longitude=1.4974945,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04359895-80e1-461f-a076-3f2565da9e4c_photo.jpg",
      averageRating=4.3, totalRatingsCount=2317,
      createdAt="2026-08-31T23:16:06.655624Z", updatedAt="2026-08-31T23:16:06.655624Z",
    ),
    ClubDto(
      id="0bb15413-fc19-42e1-8cc0-502718bf77c8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Quest", address="105 Rte d'Agde, 31500 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6297448, longitude=1.4808929,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84d28648-31e8-4c54-b7a0-e912dfdb06da_photo.jpg",
      averageRating=4.3, totalRatingsCount=601,
      createdAt="2026-08-31T23:16:39.489612Z", updatedAt="2026-08-31T23:16:39.489612Z",
    ),
    ClubDto(
      id="b385c2fc-c299-4a25-b204-bc34d09e3f94", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TOAC Omnisports", address="20 Chem. de Garric, 31200 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6217, longitude=1.4091,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fe4db538-21ab-4e5a-82ca-777e6cae66f9_photo.jpg",
      averageRating=4.3, totalRatingsCount=256,
      createdAt="2026-08-31T23:14:44.470226Z", updatedAt="2026-08-31T23:14:44.470226Z",
    ),
    ClubDto(
      id="3abe44c7-9123-460e-ba59-9cbb14c09f92", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UrbanSoccer - Toulouse Montaudran", address="5 Chem. Carrosse, 31400 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.574424, longitude=1.4803603,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/71b34e6c-7841-4038-a477-a403abb57961_photo.jpg",
      averageRating=4.3, totalRatingsCount=605,
      createdAt="2026-08-31T23:14:28.739716Z", updatedAt="2026-08-31T23:14:28.739716Z",
    ),
    ClubDto(
      id="e98ab241-9f0d-407a-aeb6-dd93090d02bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Comité Départemental de Basket-Ball de Haute-Garonne", address="36 Av. de l'Hers, 31500 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6138121, longitude=1.4805641,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/29e9d856-f8fd-4fbc-9d07-f798e0b9d67b_photo.jpg",
      averageRating=4.5, totalRatingsCount=47,
      createdAt="2026-08-31T23:15:23.367113Z", updatedAt="2026-08-31T23:15:23.367113Z",
    ),
    ClubDto(
      id="89fcc2d6-e544-4728-b7cf-c40e635636b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UGOLF: Golf de Toulouse La Ramée", address="Av. du Général Eisenhower, 31170 Tournefeuille",
      city="Toulouse", country="FR",
      latitude=43.5749274, longitude=1.3638801,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac482dfd-29e6-47e4-903b-3175fe2e3297_photo.jpg",
      averageRating=4.2, totalRatingsCount=1530,
      createdAt="2026-08-31T23:15:45.268984Z", updatedAt="2026-08-31T23:15:45.268984Z",
    ),
    ClubDto(
      id="563a9c9e-6ccf-4a23-be5d-d5e43b9ed65b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UrbanSoccer - Toulouse Sept Deniers", address="2 Rue de l'Égalité, 31200 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6321552, longitude=1.411696,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1850d834-7150-4c65-9a04-4c603de8b38c_photo.jpg",
      averageRating=4.2, totalRatingsCount=767,
      createdAt="2026-08-31T23:14:23.821216Z", updatedAt="2026-08-31T23:14:23.821216Z",
    ),
    ClubDto(
      id="63954e56-99b5-4bf4-9167-8ae7661a558f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Center", address="108 Bis Av. des Minimes, 31200 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6218544, longitude=1.4355014,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f4c6a3b3-4574-441a-a2f0-c10ae9133858_photo.jpg",
      averageRating=4.1, totalRatingsCount=1206,
      createdAt="2026-08-31T23:16:16.192702Z", updatedAt="2026-08-31T23:16:16.192702Z",
    ),
    ClubDto(
      id="197ebce3-534a-4915-aa4d-dd9a78ed6404", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BLAGNAC TENNIS CLUB", address="11 Av. des Tilleuls, 31700 Blagnac",
      city="Toulouse", country="FR",
      latitude=43.633652, longitude=1.380718,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6082a08c-91fa-433b-b799-f5f8b3246931_photo.jpg",
      averageRating=3.9, totalRatingsCount=123,
      createdAt="2026-08-31T23:15:03.265970Z", updatedAt="2026-09-01T14:31:42.904894Z",
    ),
    ClubDto(
      id="a58b20c4-11c2-4bdd-8e3f-fee96e8900be", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Toulouse Patte d'Oie Table Tennis", address="6 Rue des Turres, 31100 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.5877436, longitude=1.4213728,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/72625cf3-e816-4689-895a-ee596227a49d_photo.jpg",
      averageRating=4.2, totalRatingsCount=21,
      createdAt="2026-08-31T23:16:01.451508Z", updatedAt="2026-08-31T23:16:01.451508Z",
    ),
    ClubDto(
      id="72b1e92d-de6d-4918-a588-83e27d351983", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="academie toulousaine de billard", address="5 Rue Michel Ange, 31200 Toulouse",
      city="Toulouse", country="FR",
      latitude=43.6206406, longitude=1.4510726,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/564320e7-625e-498f-9db4-550950326f81_photo.jpg",
      averageRating=3.9, totalRatingsCount=17,
      createdAt="2026-08-31T23:16:33.128837Z", updatedAt="2026-08-31T23:16:33.128837Z",
    ),
    ClubDto(
      id="346383f0-e284-4ebb-9f86-9dd3786da1a5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Blagnac Volley Ball", address="20 Chem. de Bélisaire, 31700 Blagnac",
      city="Toulouse", country="FR",
      latitude=43.6333905, longitude=1.387614,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a62442e0-1eda-48d2-83ed-18d21d6d7963_photo.jpg",
      averageRating=4.4, totalRatingsCount=14,
      createdAt="2026-08-31T23:15:37.781246Z", updatedAt="2026-08-31T23:15:37.781246Z",
    ),
  )),
  CitySeo(slug="ankara", name="Ankara", country="TR", clubCount=30, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Volleyball", 4), Pair("Padel", 3), Pair("Basketball", 2), Pair("Golf", 2), Pair("Bowling", 2), Pair("Table Tennis", 2), Pair("Karting", 2), Pair("Paintball", 2), Pair("Laser Tag", 1), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="3e79bb5c-961c-4806-bd2d-cd34bad182f4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Angora Tenis Akademisi Spor Kulübü", address="Edip Akbayram Parkı, İnönü, 1767. Sk., 06370 Yenimahalle/Ankara",
      city="Ankara", country="TR",
      latitude=39.9510241, longitude=32.7175449,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c911b7b8-3201-4dee-bf50-9be6b624bcbd_photo.jpg",
      averageRating=4.9, totalRatingsCount=157,
      createdAt="2026-08-31T23:51:01.837647Z", updatedAt="2026-08-31T23:51:01.837647Z",
    ),
    ClubDto(
      id="310c0d4a-9875-4c7c-999d-c114852b8473", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="COUNTER LASER TAG ANKARA", address="Kızılay, Fevzi Çakmak-1 Sk. No:6/A, 06610 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.9242924, longitude=32.8517886,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/31b03510-bb9e-4e3d-a259-ff69ab3a34f7_photo.jpg",
      averageRating=4.9, totalRatingsCount=387,
      createdAt="2026-08-31T23:52:50.786450Z", updatedAt="2026-08-31T23:52:50.786450Z",
    ),
    ClubDto(
      id="32b2d731-9bb0-4b0f-867c-de8aaf0fd530", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MASA-DER Masa Tenisi Balgat Ankara", address="Oğuzlar mahallesi, Balgat, Osmanlı Cd. 12/D, 06520 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.9060124, longitude=32.8195062,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/87ef0d53-9d6e-48c5-a45c-5388c19bbc38_photo.jpg",
      averageRating=4.9, totalRatingsCount=112,
      createdAt="2026-08-31T23:52:17.731949Z", updatedAt="2026-08-31T23:52:17.731949Z",
    ),
    ClubDto(
      id="2c1f5b7f-5fd3-4230-a4ec-5100fd7cc7cf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ATK TENNIS ACADEMY", address="Konutkent, 06810 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.8798254, longitude=32.6728706,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4b98ca82-35d7-4378-9145-86a5b0ee8bea_photo.jpg",
      averageRating=4.7, totalRatingsCount=164,
      createdAt="2026-08-31T23:50:56.792401Z", updatedAt="2026-08-31T23:50:56.792401Z",
    ),
    ClubDto(
      id="5ded04a7-930f-4444-a60b-f9797ab04be7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Emek Masa Tenisi Kulübü", address="Emek, Bosna Hersek Cd. NO:10/B, 06000 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.917442, longitude=32.820991,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/baf2aee1-c795-4e05-b540-0fcc9ef398a4_photo.jpg",
      averageRating=4.7, totalRatingsCount=242,
      createdAt="2026-08-31T23:52:13.201719Z", updatedAt="2026-08-31T23:52:13.201719Z",
    ),
    ClubDto(
      id="19315714-ced1-428c-8c9b-7a7d346463e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Olimpik Go Kart", address="-2, Fevzi Çakmak, Fatih Cd. Bağcılar Olimpik Spor Salonu 50/A, 34200 Bağcılar/İstanbul",
      city="Ankara", country="TR",
      latitude=41.0421388, longitude=28.8537785,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ced9758f-bf40-431e-a9f7-8b990a8736ce_photo.jpg",
      averageRating=4.7, totalRatingsCount=5749,
      createdAt="2026-08-31T23:52:21.719708Z", updatedAt="2026-08-31T23:52:21.719708Z",
    ),
    ClubDto(
      id="6a6552b9-52fe-4a91-9b65-69937a8d99d0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Anittepe Sports Complex", address="Yücetepe, Spor Park Cd. No:3, 06570 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.9208302, longitude=32.8377148,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6a97fe0b-9ca2-4992-b171-793c73416334_photo.jpg",
      averageRating=4.6, totalRatingsCount=1484,
      createdAt="2026-08-31T23:51:30.412645Z", updatedAt="2026-08-31T23:51:30.412645Z",
    ),
    ClubDto(
      id="3d11292f-8683-45bc-88cb-18ca00522d43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Atasev Spor Kulübü", address="Batıkent Spor Salonu, Kentkoop, Batıkent Blv., 06170 Yenimahalle/Ankara",
      city="Ankara", country="TR",
      latitude=39.9661498, longitude=32.7260453,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a380d0c4-3d32-45e7-9f19-60d5311bd396_photo.jpg",
      averageRating=4.6, totalRatingsCount=134,
      createdAt="2026-08-31T23:51:47.862749Z", updatedAt="2026-08-31T23:51:47.862749Z",
    ),
    ClubDto(
      id="2d65d69a-2c0a-4996-98ff-edc7a73ba1fc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kapital Tenis & Padel Kulübü", address="Karşıyaka, 487. Sokak No:2, 06830 Gölbaşı/Ankara",
      city="Ankara", country="TR",
      latitude=39.7721971, longitude=32.749018,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49c5a5ac-1562-4c35-a056-859c384dce82_photo.jpg",
      averageRating=4.6, totalRatingsCount=83,
      createdAt="2026-08-31T23:51:06.974644Z", updatedAt="2026-09-01T14:32:02.889607Z",
    ),
    ClubDto(
      id="02ea9404-61ca-49d9-a9f5-950d74f8593d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ÇABA AKADEMİ Çocuk Spor Eğitim Merkezi", address="Ergazi, 1817. Sk., 06000 Yenimahalle/Ankara",
      city="Ankara", country="TR",
      latitude=39.9527721, longitude=32.7044193,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f9425db9-520c-4efb-bd87-7a62b1bb83c2_photo.jpg",
      averageRating=4.6, totalRatingsCount=220,
      createdAt="2026-08-31T23:50:33.905625Z", updatedAt="2026-08-31T23:50:33.905625Z",
    ),
    ClubDto(
      id="adc50e5a-49df-4e91-baf5-11ee54bf4ebc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ANKARA TENİS KULÜBÜ (A.T.K )", address="Karşıyaka, 575.Cad 8/32, 06830 Gölbaşı/Ankara",
      city="Ankara", country="TR",
      latitude=39.7810507, longitude=32.7593348,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/91fe4746-be0d-4e51-b393-27f558de57de_photo.jpg",
      averageRating=4.5, totalRatingsCount=331,
      createdAt="2026-08-31T23:50:44.151350Z", updatedAt="2026-08-31T23:50:44.151350Z",
    ),
    ClubDto(
      id="362341a0-f605-453e-bb9b-fe0a110fd195", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ankara Arena", address="Hacı Bayram, Ankara Hipodromu Kavşağı No:2, 06370 Altındağ/Ankara",
      city="Ankara", country="TR",
      latitude=39.9379959, longitude=32.8437919,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1692955e-79dd-4e00-b6c5-75f514529b39_photo.jpg",
      averageRating=4.5, totalRatingsCount=3874,
      createdAt="2026-08-31T23:51:25.965813Z", updatedAt="2026-08-31T23:51:25.965813Z",
    ),
    ClubDto(
      id="42fa2aa1-b1f9-4cd6-b7fd-9c9dc9b914ca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Base Life Club", address="Angora Caddesi, Çayyolu, Beysupark No 209 / 10, 06680Ankara Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.8778839, longitude=32.706356,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f694ee68-5a1b-4bc7-874f-9809f4c1c16b_photo.jpg",
      averageRating=4.5, totalRatingsCount=1143,
      createdAt="2026-08-31T23:51:58.833340Z", updatedAt="2026-08-31T23:51:58.833340Z",
    ),
    ClubDto(
      id="75a2527a-fe03-4b91-bb32-12f7bb81b5c4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TOPSPIN TENNIS ACADEMY", address="Üniversiteler, İhsan Doğramacı Blv no:1, 06800 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.8836043, longitude=32.7636247,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/38c33458-c8a6-4186-8e32-6dfdbe91683c_photo.jpg",
      averageRating=4.5, totalRatingsCount=278,
      createdAt="2026-08-31T23:50:49.776349Z", updatedAt="2026-08-31T23:50:49.776349Z",
    ),
    ClubDto(
      id="f6171eda-392c-4883-bda4-4e6ce9d03ae7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ankara Golf Club", address="Ahlatlıbel, Incek Şht. Savcı Mehmet Selim Kiraz Blv No:9, 06805 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.843075, longitude=32.789029,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3cb61cae-ae3c-4d34-b4dd-ea6b08911f16_photo.jpg",
      averageRating=4.4, totalRatingsCount=125,
      createdAt="2026-08-31T23:52:03.350318Z", updatedAt="2026-08-31T23:52:03.350318Z",
    ),
    ClubDto(
      id="c30757b5-96c6-4346-96c3-f0642a09461a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Anadolu Birlik Spor Kulübü", address="Yukarı Öveçler Mahallesi Lizbon Caddesi No:4, Yukarı Öveçler, 1290. Sk. 1/C, 06520 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.8945107, longitude=32.8228054,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2f88128d-0285-48d1-bddd-7d0625c7b824_photo.jpg",
      averageRating=4.3, totalRatingsCount=258,
      createdAt="2026-08-31T23:51:43.172411Z", updatedAt="2026-08-31T23:51:43.172411Z",
    ),
    ClubDto(
      id="1b33dee7-2034-44e2-8514-88337ca3f369", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GAZİ İHTİSAS SPOR KULÜBÜ", address="İlkyerleşim, 1955. Sk. No:2, 06370 Yenimahalle/Ankara",
      city="Ankara", country="TR",
      latitude=39.979911, longitude=32.728677,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d22c8c4c-62fe-4e9b-96ea-2796b50be76c_photo.jpg",
      averageRating=4.2, totalRatingsCount=122,
      createdAt="2026-08-31T23:51:52.841361Z", updatedAt="2026-08-31T23:51:52.841361Z",
    ),
    ClubDto(
      id="e9a9a34e-f116-4e26-b141-3a5fe4252401", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Park Ankara Ahlatlibel", address="İncek Yolu Üzeri Ahlatlıbel Spor Ve Dinlenme Tesisleri, Ahlatlıbel, 06650 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.8427688, longitude=32.7935298,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4ad9cfb8-676c-4765-b381-a850d5511201_photo.jpg",
      averageRating=4.2, totalRatingsCount=604,
      createdAt="2026-08-31T23:52:55.457829Z", updatedAt="2026-08-31T23:52:55.457829Z",
    ),
    ClubDto(
      id="10912666-93e4-4794-8d75-de75cd0a08c6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Şenol Güneş Spor Parkı/Futbol Sahası, Yaşamkent,Ankara", address="Yaşamkent Mahallesi Seviye Koleji yanı 3245. Sokak ile, Yaşamkent, 3251. Cadde, 06810 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.8608093, longitude=32.6410331,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3143362d-f125-47a9-bbb7-e0c5bbb8b30d_photo.jpg",
      averageRating=4.2, totalRatingsCount=142,
      createdAt="2026-08-31T23:50:39.215819Z", updatedAt="2026-08-31T23:50:39.215819Z",
    ),
    ClubDto(
      id="971e9c49-1674-4ddd-ad2b-16fbb1abf9b3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Champ's Billiards", address="Kızılay, Ziya Gökalp Cd. No:27/1, 06420 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.922116, longitude=32.859445,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c720f4b1-72dc-4826-884c-8f6e2dc48d60_photo.jpg",
      averageRating=4.1, totalRatingsCount=706,
      createdAt="2026-08-31T23:52:44.672026Z", updatedAt="2026-08-31T23:52:44.672026Z",
    ),
    ClubDto(
      id="e7052362-89f4-4ae3-9ae5-fbfdbb4c5837", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Can Spor Tesisleri", address="Cengizhan, Natoyolu Caddesı No:503, 06480 Mamak/Ankara",
      city="Ankara", country="TR",
      latitude=39.8934478, longitude=32.9270706,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9a4986a8-0efe-478b-ab86-afb806ebe3b2_photo.jpg",
      averageRating=4.0, totalRatingsCount=499,
      createdAt="2026-08-31T23:50:18.490424Z", updatedAt="2026-08-31T23:50:18.490424Z",
    ),
    ClubDto(
      id="4de4b499-17d3-48d8-bd37-b08799884470", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KARTING ANKARA, Ankara GoKart", address="Yeşilkent, 9. Cd., 06706 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.8398188, longitude=32.863368,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b5cdface-6576-4f89-82d3-dc4e43ee3517_photo.jpg",
      averageRating=4.0, totalRatingsCount=1261,
      createdAt="2026-08-31T23:52:26.919915Z", updatedAt="2026-08-31T23:52:26.919915Z",
    ),
    ClubDto(
      id="f1e214e8-4263-4902-a4cc-007a8e794979", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mühye Paintball - Anka Paintball - Paintsign Paintball", address="Yeşilkent mahallesi 15.sokak no : 4 Mühye Köyü, Çankaya, 06650 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.860383, longitude=32.879391,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06e880c1-348d-4201-ab40-d284cda90dc2_photo.jpg",
      averageRating=4.0, totalRatingsCount=508,
      createdAt="2026-08-31T23:53:01.188516Z", updatedAt="2026-08-31T23:53:01.188516Z",
    ),
    ClubDto(
      id="28828f99-9ac5-437c-98af-68ad19d4d634", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ÖVEÇLER HALI SAHA", address="Pakize Erdoğu Ortaokulu Yanı, Aşağı Öveçler, Kabil Cd. 6/A, 06460 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.892726, longitude=32.829021,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ec43ce1a-0288-4391-a97f-b436a0002e85_photo.jpg",
      averageRating=4.0, totalRatingsCount=410,
      createdAt="2026-08-31T23:50:23.793538Z", updatedAt="2026-08-31T23:50:23.793538Z",
    ),
    ClubDto(
      id="62598a56-8a60-417f-97f8-d6dc71c1e5bd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rollhouse Bowling ve Eğlence Merkezi", address="Üniversiteler, Ankuva AVM No:1, 06530 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.8836861, longitude=32.7560768,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49f90b4a-a1ab-4417-9833-8d3a586f0fc4_photo.jpg",
      averageRating=3.9, totalRatingsCount=994,
      createdAt="2026-08-31T23:52:32.383576Z", updatedAt="2026-08-31T23:52:32.383576Z",
    ),
    ClubDto(
      id="b29cec60-2e6b-40ed-957a-41581cab380f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bahçeli Bowling", address="Bahçelievler, Azerbaycan Cd. No:41, 06100 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.927679, longitude=32.826842,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d699f2af-e0a7-4e8f-9a0c-1c342699f577_photo.jpg",
      averageRating=3.6, totalRatingsCount=791,
      createdAt="2026-08-31T23:52:36.723735Z", updatedAt="2026-08-31T23:52:36.723735Z",
    ),
    ClubDto(
      id="6e29ebf2-e0e1-460d-9379-b3813d4dba80", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Regnum Golf Country Ankara", address="Halaçlı Mah. 190/1, Halaçlı, 06830 Gölbaşı/Ankara",
      city="Ankara", country="TR",
      latitude=39.6841005, longitude=32.5990484,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/20fbbb31-3292-4957-97aa-fc2f59ad5a58_photo.jpg",
      averageRating=4.4, totalRatingsCount=40,
      createdAt="2026-08-31T23:52:09.125668Z", updatedAt="2026-08-31T23:52:09.125668Z",
    ),
    ClubDto(
      id="a42d5da5-b60b-4e4a-a70f-6972931f73a5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Batıkent Futbol Park", address="Turgut Özal, Batıkent 1950 sok, 06370 Yenimahalle/Ankara",
      city="Ankara", country="TR",
      latitude=39.9899996, longitude=32.72584,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6b5e2062-1c01-45db-b437-c83f1d47d152_photo.jpg",
      averageRating=3.5, totalRatingsCount=400,
      createdAt="2026-08-31T23:50:28.208676Z", updatedAt="2026-08-31T23:50:28.208676Z",
    ),
    ClubDto(
      id="b539b837-7cf6-45e6-a14f-da8fca73583c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="So24 Padel", address="Hayran Kule, Konutkent, 3035. Cad., 06100 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.8726034, longitude=32.6498521,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1598b2ba-c7b8-4244-934f-b5789e21b29a_photo.jpg",
      averageRating=4.2, totalRatingsCount=19,
      createdAt="2026-08-31T23:51:10.490761Z", updatedAt="2026-08-31T23:51:10.490761Z",
    ),
    ClubDto(
      id="b95abfa5-7beb-4c73-9ccf-196df35da314", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="No1 Padel", address="Selim Gedik Parkı, Koru, 2579. Cadde no:1, 06810 Çankaya/Ankara",
      city="Ankara", country="TR",
      latitude=39.8875459, longitude=32.6857347,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0aba0a62-a2fa-498f-a7d3-834c346e0baa_photo.jpg",
      averageRating=5.0, totalRatingsCount=12,
      createdAt="2026-08-31T23:51:21.674592Z", updatedAt="2026-08-31T23:51:21.674592Z",
    ),
  )),
  CitySeo(slug="dallas", name="Dallas", country="US", clubCount=30, sports=listOf(Pair("Volleyball", 5), Pair("Football", 5), Pair("Padel", 3), Pair("Basketball", 3), Pair("Paintball", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Table Tennis", 1), Pair("Karting", 1), Pair("Tennis", 1), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="347b4dd8-6d49-4d44-b473-94949a45c1dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ascend Paintball", address="5236 Kiwanis Rd suite a, Dallas, TX 75236",
      city="Dallas", country="US",
      latitude=32.685829, longitude=-96.9318718,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5d71a361-6cb6-44cf-99a3-f3944d693e76_photo.jpg",
      averageRating=4.9, totalRatingsCount=288,
      createdAt="2026-09-20T19:18:09.680574Z", updatedAt="2026-09-20T19:18:09.680574Z",
    ),
    ClubDto(
      id="971729cb-147a-4463-b279-f0f14d8865ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kraken Padel Club", address="14510 S Josey Ln Ste 216, Farmers Branch, TX 75234",
      city="Dallas", country="US",
      latitude=32.945029, longitude=-96.8894302,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1a4d7382-c744-4c70-8f1d-0ab6b325eabc_photo.jpg",
      averageRating=4.9, totalRatingsCount=100,
      createdAt="2026-09-20T19:16:50.030009Z", updatedAt="2026-09-20T19:16:50.030009Z",
    ),
    ClubDto(
      id="6bed7ec2-ad93-46b6-9faa-af639d5a0e39", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TX Laser Combat - Tactical Laser Tag", address="2300 Coit Rd #400, Plano, TX 75075",
      city="Dallas", country="US",
      latitude=33.0303342, longitude=-96.7684266,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d0a4012-9e81-40b0-b672-77c25e9c41b3_photo.jpg",
      averageRating=4.9, totalRatingsCount=541,
      createdAt="2026-09-20T19:18:03.353094Z", updatedAt="2026-09-20T19:18:03.353094Z",
    ),
    ClubDto(
      id="73cef67b-f3b4-459f-8609-1d809a5c3bea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Blok Climbing Co", address="5252 W Vickery Blvd, Fort Worth, TX 76107",
      city="Dallas", country="US",
      latitude=32.7150935, longitude=-97.400523,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd68e01c-126d-4070-931e-293cf0c005d8_photo.jpg",
      averageRating=4.9, totalRatingsCount=305,
      createdAt="2026-09-20T19:17:54.793161Z", updatedAt="2026-09-20T19:17:54.793161Z",
    ),
    ClubDto(
      id="e7c9e3a3-fb55-4018-bcf2-5e4312ad180b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dallas Mavericks", address="2500 Victory Ave, Dallas, TX 75219",
      city="Dallas", country="US",
      latitude=32.7905225, longitude=-96.8110147,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/71274d31-4092-4103-acc5-0fef2352f604_photo.jpg",
      averageRating=4.8, totalRatingsCount=912,
      createdAt="2026-09-20T19:16:57.153167Z", updatedAt="2026-09-20T19:16:57.153167Z",
    ),
    ClubDto(
      id="0e69cc31-4bdf-4aeb-b9d7-06ea08294250", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Strong Fitness & Performance", address="4207 Simonton Rd, Farmers Branch, TX 75244",
      city="Dallas", country="US",
      latitude=32.9314141, longitude=-96.8382321,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/30863e39-c3c7-42a0-a9ab-36bdb9ce6a96_photo.jpg",
      averageRating=4.8, totalRatingsCount=333,
      createdAt="2026-09-20T19:17:50.886923Z", updatedAt="2026-09-20T19:17:50.886923Z",
    ),
    ClubDto(
      id="9ab52dc3-20d0-4eae-b579-348a6f8d3d9d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Giant Party Sports", address="4404 Dillehay Dr, Parker, TX 75002",
      city="Dallas", country="US",
      latitude=33.0617087, longitude=-96.6093645,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11adefa9-9438-4a73-890b-62c202040937_photo.jpg",
      averageRating=4.7, totalRatingsCount=671,
      createdAt="2026-09-20T19:18:06.659600Z", updatedAt="2026-09-20T19:18:06.659600Z",
    ),
    ClubDto(
      id="67ab3583-1873-4bea-a825-46b4f58db6db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Ranch Richardson", address="3570 Waterview Pkwy, Richardson, TX 75080",
      city="Dallas", country="US",
      latitude=32.999408, longitude=-96.745961,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a3e7cefb-9d40-4f7a-8335-e810dd77f0d2_photo.jpg",
      averageRating=4.7, totalRatingsCount=1137,
      createdAt="2026-09-20T19:17:33.227592Z", updatedAt="2026-09-20T19:17:33.227592Z",
    ),
    ClubDto(
      id="bd2b3493-31b8-4460-939d-fb6d91c9ed70", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Banner House at T Bar M", address="6060 Dilbeck Ln, Dallas, TX 75240",
      city="Dallas", country="US",
      latitude=32.9289876, longitude=-96.800642,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/981dca5f-b55c-4be0-ae9c-58fd18071677_photo.jpg",
      averageRating=4.6, totalRatingsCount=121,
      createdAt="2026-09-20T19:16:46.765658Z", updatedAt="2026-09-20T19:16:46.765658Z",
    ),
    ClubDto(
      id="e4b21ef0-e653-46f2-b682-7f6266aa11e6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Futsal", address="1224 S Cesar Chavez Blvd, Dallas, TX 75201",
      city="Dallas", country="US",
      latitude=32.7769718, longitude=-96.7876289,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c90fafb-fc4e-4c39-9e33-b6570b28f967_photo.jpg",
      averageRating=4.6, totalRatingsCount=261,
      createdAt="2026-09-20T19:17:17.846139Z", updatedAt="2026-09-20T19:17:17.846139Z",
    ),
    ClubDto(
      id="bcc46dbb-b339-41f1-8903-8751ae694cfe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lakeside Park Volleyball Court", address="515 Hill City Dr, Duncanville, TX 75116",
      city="Dallas", country="US",
      latitude=32.6558774, longitude=-96.9185236,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d531a667-e959-4c8f-92d8-c9f5cc6877ad_photo.jpg",
      averageRating=4.6, totalRatingsCount=178,
      createdAt="2026-09-20T19:17:23.301602Z", updatedAt="2026-09-20T19:17:23.301602Z",
    ),
    ClubDto(
      id="27a36a19-f158-43f0-920b-7c11a32c0ef7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Soccer Spectrum", address="1251 Digital Dr, Richardson, TX 75081",
      city="Dallas", country="US",
      latitude=32.9736862, longitude=-96.7026978,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0fb4e508-8634-4d56-9d3d-b3977fcee0f0_photo.jpg",
      averageRating=4.6, totalRatingsCount=566,
      createdAt="2026-09-20T19:28:30.312799Z", updatedAt="2026-09-20T19:28:30.312799Z",
    ),
    ClubDto(
      id="a0c2aef8-a034-49c3-b09f-9d939815f165", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dallas Table Tennis Club", address="2401 S Stemmons Fwy #1450 Lewisville, TX 75067",
      city="Dallas", country="US",
      latitude=33.0025515, longitude=-96.9735057,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e7e6f18b-44df-458d-a592-32c010106a7e_photo.jpg",
      averageRating=4.5, totalRatingsCount=100,
      createdAt="2026-09-20T19:17:36.370481Z", updatedAt="2026-09-20T19:17:36.370481Z",
    ),
    ClubDto(
      id="c3ad5bd1-44e7-402b-9cac-5d5b0d0c7466", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Royal Oaks Country Club", address="7915 Greenville Ave, Dallas, TX 75231",
      city="Dallas", country="US",
      latitude=32.8897895, longitude=-96.7596359,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/423a52bb-27a3-4d58-b348-c513d3b9c057_photo.jpg",
      averageRating=4.5, totalRatingsCount=309,
      createdAt="2026-09-20T19:16:43.293949Z", updatedAt="2026-09-20T19:16:43.293949Z",
    ),
    ClubDto(
      id="4b9f8e1b-bebf-41ef-a809-7e1093b2264f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowlounge", address="167 Turtle Creek Blvd #103, Dallas, TX 75207",
      city="Dallas", country="US",
      latitude=32.7936622, longitude=-96.8273941,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c96cc3d3-2d3d-423a-a97e-84ba449b4673_photo.jpg",
      averageRating=4.4, totalRatingsCount=2482,
      createdAt="2026-09-20T19:17:43.716036Z", updatedAt="2026-09-20T19:17:43.716036Z",
    ),
    ClubDto(
      id="4cd64d2c-3946-4645-8815-b93267ccda16", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dallas Soccer Park", address="2200 Walnut Hill Ln, Dallas, TX 75229",
      city="Dallas", country="US",
      latitude=32.8793621, longitude=-96.9071119,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83fa4e0b-dda2-4a41-85b5-164c495885f8_photo.jpg",
      averageRating=4.4, totalRatingsCount=835,
      createdAt="2026-09-20T19:28:24.780826Z", updatedAt="2026-09-20T19:28:24.780826Z",
    ),
    ClubDto(
      id="93985317-7a99-4562-bcc2-7d5803d04f79", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lone Star Kartpark", address="3545 Lone Star Cir, Fort Worth, TX 76177",
      city="Dallas", country="US",
      latitude=33.0306013, longitude=-97.2874526,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84fe465b-100e-4d97-adda-99898365dcef_photo.jpg",
      averageRating=4.4, totalRatingsCount=457,
      createdAt="2026-09-20T19:17:39.943532Z", updatedAt="2026-09-20T19:17:39.943532Z",
    ),
    ClubDto(
      id="ce99f7e1-adf8-4dcb-8bc2-93cf902e3c66", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Garden DFW", address="1850 E Belt Line Rd, Coppell, TX 75019",
      city="Dallas", country="US",
      latitude=32.9524728, longitude=-96.9408778,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/618ade63-82ae-481a-9398-cfc5a226d7db_photo.jpg",
      averageRating=4.4, totalRatingsCount=695,
      createdAt="2026-09-20T19:17:13.269872Z", updatedAt="2026-09-20T19:17:13.269872Z",
    ),
    ClubDto(
      id="2c105873-a9a3-4c19-933c-6e58b1fe9996", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Topgolf Dallas", address="8787 Park Ln, Dallas, TX 75231",
      city="Dallas", country="US",
      latitude=32.8692383, longitude=-96.7462693,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/da7b1b01-b6f4-460d-9052-e59bdfd02952_photo.jpg",
      averageRating=4.4, totalRatingsCount=3556,
      createdAt="2026-09-20T19:17:29.746126Z", updatedAt="2026-09-20T19:17:29.746126Z",
    ),
    ClubDto(
      id="d2f7290c-aa75-4998-95d6-65e1b2ffaf74", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UTD Soccer Field 5", address="800 W Campbell Rd, Richardson, TX 75080",
      city="Dallas", country="US",
      latitude=32.9819472, longitude=-96.7528466,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/324d4ce9-7611-4c44-9dd0-bd75d1240090_photo.jpg",
      averageRating=4.4, totalRatingsCount=353,
      createdAt="2026-09-20T19:16:36.439933Z", updatedAt="2026-09-20T19:16:36.439933Z",
    ),
    ClubDto(
      id="15c60bd5-4880-4eaa-80e1-fb55ce31cf1e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fieldhouse Grapevine", address="3000 Grapevine Mills Pkwy Ste 329, Grapevine, TX 76051",
      city="Dallas", country="US",
      latitude=32.9679882, longitude=-97.0405462,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/419dbe0c-059c-4fbf-a864-a63b03c6007e_photo.jpg",
      averageRating=4.3, totalRatingsCount=464,
      createdAt="2026-09-20T19:17:01.339120Z", updatedAt="2026-09-20T19:17:01.339120Z",
    ),
    ClubDto(
      id="02d3cfd4-eb53-4ab5-bb7c-08b2dff27d94", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FieldhouseUSA Frisco", address="6155 Sports Village Rd, Frisco, TX 75033",
      city="Dallas", country="US",
      latitude=33.1609182, longitude=-96.8301507,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0a23a38e-f242-42cf-a0eb-6bfa993a654f_photo.jpg",
      averageRating=4.3, totalRatingsCount=1089,
      createdAt="2026-09-20T19:17:08.925477Z", updatedAt="2026-09-20T19:17:08.925477Z",
    ),
    ClubDto(
      id="eff98e71-59b1-43b7-99d8-dd1448f2e6b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rack Daddy's", address="17509 Coit Rd A, Dallas, TX 75252",
      city="Dallas", country="US",
      latitude=32.9897804, longitude=-96.7684555,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b08147a8-8415-4438-b672-4b3f86abc491_photo.jpg",
      averageRating=4.3, totalRatingsCount=649,
      createdAt="2026-09-20T19:18:00.350011Z", updatedAt="2026-09-20T19:18:00.350011Z",
    ),
    ClubDto(
      id="33059cd6-5d99-4bae-b8b0-e6aa049bb453", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Beach at Craig Ranch", address="6145 Alma Rd, McKinney, TX 75070",
      city="Dallas", country="US",
      latitude=33.1394953, longitude=-96.7062142,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06427095-6451-4d36-96cf-216e38e56ce4_photo.jpg",
      averageRating=4.3, totalRatingsCount=174,
      createdAt="2026-09-20T19:17:26.528707Z", updatedAt="2026-09-20T19:17:26.528707Z",
    ),
    ClubDto(
      id="ce5cb055-903b-446f-bb66-d8d3aea17e2c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Billiard Den", address="580 W Arapaho Rd #136, Richardson, TX 75080",
      city="Dallas", country="US",
      latitude=32.9646165, longitude=-96.7377157,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a709f719-7c31-4ab5-8783-e87bc28ad86c_photo.jpg",
      averageRating=4.3, totalRatingsCount=875,
      createdAt="2026-09-20T19:17:57.909356Z", updatedAt="2026-09-20T19:17:57.909356Z",
    ),
    ClubDto(
      id="c2a10d8f-022b-4562-b6ad-b5a51e7e5ba6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TOCA Soccer Center Carrollton", address="1850 Legends Tr, Carrollton, TX 75006",
      city="Dallas", country="US",
      latitude=32.9666862, longitude=-96.9356231,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f2fd70af-7b92-4057-aeb5-e5ebf4fee412_photo.jpg",
      averageRating=4.2, totalRatingsCount=329,
      createdAt="2026-09-20T19:16:39.715904Z", updatedAt="2026-09-20T19:16:39.715904Z",
    ),
    ClubDto(
      id="71fb4469-bdc2-4a0b-9d0c-5fb1142bf030", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="World Cup Indoor Soccer", address="2600 Northaven Rd Ste 200, Dallas, TX 75229",
      city="Dallas", country="US",
      latitude=32.9031175, longitude=-96.8898936,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/36dc87e4-06ad-4c40-89e8-d0c9aeaeac63_photo.jpg",
      averageRating=4.1, totalRatingsCount=387,
      createdAt="2026-09-20T19:28:33.146182Z", updatedAt="2026-09-20T19:28:33.146182Z",
    ),
    ClubDto(
      id="7d57dc0b-6672-48d6-943d-4d722bd044ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowlski's Lakewood Theater", address="1825 Abrams Pkwy Ste C, Dallas, TX 75214",
      city="Dallas", country="US",
      latitude=32.8119169, longitude=-96.7532149,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6be2005e-4a38-446c-9b91-3ba1bcce28b3_photo.jpg",
      averageRating=4.0, totalRatingsCount=384,
      createdAt="2026-09-20T19:17:47.491989Z", updatedAt="2026-09-20T19:17:47.491989Z",
    ),
    ClubDto(
      id="8614f8f0-7bf0-4fe2-8917-2d4a0e185cb6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Foro Sports Club", address="14725 Preston Rd, Dallas, TX 75254",
      city="Dallas", country="US",
      latitude=32.948697, longitude=-96.8068838,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4de6757-a5f0-4576-a7d0-ba6a28c391f2_photo.jpg",
      averageRating=4.0, totalRatingsCount=380,
      createdAt="2026-09-20T19:17:04.911633Z", updatedAt="2026-09-20T19:17:04.911633Z",
    ),
    ClubDto(
      id="41bc7fa2-4308-43c7-af0e-1e38acba30ba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dallas Padel Club", address="3000 Belmeade Dr, Carrollton, TX 75006",
      city="Dallas", country="US",
      latitude=32.9805101, longitude=-96.8497469,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f00403fb-be9e-46a3-8a1b-02af806e2269_photo.jpg",
      averageRating=4.9, totalRatingsCount=33,
      createdAt="2026-09-20T19:16:52.849053Z", updatedAt="2026-09-20T19:16:52.849053Z",
    ),
  )),
  CitySeo(slug="houston", name="Houston", country="US", clubCount=29, sports=listOf(Pair("Football", 4), Pair("Tennis", 3), Pair("Volleyball", 3), Pair("Basketball", 3), Pair("Padel", 3), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Karting", 2), Pair("Climbing", 2), Pair("Paintball", 2), Pair("Golf", 2), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="ed02bb4e-44e8-4c0d-8c6f-b17218533313", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hoopston Athletics", address="6210 S Dairy Ashford Rd Ste B5, Houston, TX 77072",
      city="Houston", country="US",
      latitude=29.7124192, longitude=-95.6049328,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed04a08c-bfd5-4abf-b4f8-07831c9917eb_photo.jpg",
      averageRating=4.9, totalRatingsCount=218,
      createdAt="2026-09-20T19:16:08.877413Z", updatedAt="2026-09-20T19:16:08.877413Z",
    ),
    ClubDto(
      id="1724f351-aafd-4a98-9dd6-bee51b22683d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Houston Soccer Field", address="18850 FM 529, Cypress, TX 77433",
      city="Houston", country="US",
      latitude=29.8801358, longitude=-95.6977142,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7c9bb320-4be3-418a-8f91-c27b6581f19e_photo.jpg",
      averageRating=4.9, totalRatingsCount=393,
      createdAt="2026-09-20T19:27:25.527036Z", updatedAt="2026-09-20T19:27:25.527036Z",
    ),
    ClubDto(
      id="dc3ca2d1-e5e8-4df1-8f05-5e8198f56224", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Texas Legends Paintball", address="11099 Ponderosa Timbers Dr, The Woodlands, TX 77385",
      city="Houston", country="US",
      latitude=30.2005344, longitude=-95.4132685,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/181afa77-d913-4945-a3a0-b938fdf0ade7_photo.jpg",
      averageRating=4.9, totalRatingsCount=484,
      createdAt="2026-09-20T19:28:20.033355Z", updatedAt="2026-09-20T19:28:20.033355Z",
    ),
    ClubDto(
      id="85fde6e1-f78f-4497-9dd9-95ac7bc0943d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="iPadel Houston", address="1112 Egypt St, Houston, TX 77009",
      city="Houston", country="US",
      latitude=29.7978721, longitude=-95.3567107,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96a5f386-33e9-46e5-8fe7-173d0d0140dd_photo.jpg",
      averageRating=4.9, totalRatingsCount=60,
      createdAt="2026-09-20T19:15:52.835402Z", updatedAt="2026-09-20T19:15:52.835402Z",
    ),
    ClubDto(
      id="6ac3206c-7c6f-43f0-a32f-0759636d2978", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Momentum Indoor Climbing Silver Street", address="1401 Silver St, Houston, TX 77007",
      city="Houston", country="US",
      latitude=29.7712383, longitude=-95.3775558,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6efb7c1b-710a-4900-a68b-6d6deaab8ca5_photo.jpg",
      averageRating=4.8, totalRatingsCount=2679,
      createdAt="2026-09-20T19:27:59.368407Z", updatedAt="2026-09-20T19:27:59.368407Z",
    ),
    ClubDto(
      id="0733d09f-f9ea-4ab5-a9da-b41f12d81880", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TXR Paintball", address="15550 Grant Rd, Cypress, TX 77429",
      city="Houston", country="US",
      latitude=30.0241642, longitude=-95.6499735,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bf8a32ed-099c-4c31-8675-6991278ef835_photo.jpg",
      averageRating=4.8, totalRatingsCount=841,
      createdAt="2026-09-20T19:28:16.766655Z", updatedAt="2026-09-20T19:28:16.766655Z",
    ),
    ClubDto(
      id="0b09a6e8-c806-4d0a-85c7-0a12db1151f8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Third Coast Volleyball Club", address="5652 Forney Dr, Houston, TX 77036",
      city="Houston", country="US",
      latitude=29.7207262, longitude=-95.5030858,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4efb8926-ac09-48be-945e-334353efb728_photo.jpg",
      averageRating=4.8, totalRatingsCount=302,
      createdAt="2026-09-20T19:16:12.178566Z", updatedAt="2026-09-20T19:16:12.178566Z",
    ),
    ClubDto(
      id="d0bc1d52-40d7-43c1-84af-031ce24922c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="810 Entertainment - Houston", address="1201 San Jacinto St Ste 321, Houston, TX 77002",
      city="Houston", country="US",
      latitude=29.7539943, longitude=-95.3641749,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d8e2e3c8-3981-4f83-8042-beb796f92194_photo.jpg",
      averageRating=4.7, totalRatingsCount=1993,
      createdAt="2026-09-20T19:27:52.203385Z", updatedAt="2026-09-20T19:27:52.203385Z",
    ),
    ClubDto(
      id="3463b951-9051-45e4-b3d4-430421236a67", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Momentum Indoor Climbing Sandy", address="220 W 10600 S, Sandy, UT 84070",
      city="Houston", country="US",
      latitude=40.564405, longitude=-111.8978999,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/830e54cd-615a-4601-9d80-6922c1bafa8e_photo.jpg",
      averageRating=4.7, totalRatingsCount=1945,
      createdAt="2026-09-20T19:28:04.432412Z", updatedAt="2026-09-20T19:28:04.432412Z",
    ),
    ClubDto(
      id="ea4b0088-d2dd-4501-8a0e-2400a4898b45", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="West43 Padel", address="1009 Jerome St, Houston, TX 77009",
      city="Houston", country="US",
      latitude=29.801548, longitude=-95.384886,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1c18cfa8-e963-4e80-bb7a-05c0ba7e8e42_photo.jpg",
      averageRating=4.7, totalRatingsCount=78,
      createdAt="2026-09-20T19:15:48.774852Z", updatedAt="2026-09-20T19:15:48.774852Z",
    ),
    ClubDto(
      id="fa380caa-0820-4e72-924a-b95899abf948", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cube Padel Houston", address="7918 Breen Rd, Houston, TX 77064",
      city="Houston", country="US",
      latitude=29.899698, longitude=-95.5052001,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4daa203a-684a-470b-b58f-255c706f4eef_photo.jpg",
      averageRating=5.0, totalRatingsCount=46,
      createdAt="2026-09-20T19:15:57.147345Z", updatedAt="2026-09-20T19:15:57.147345Z",
    ),
    ClubDto(
      id="054d19cc-102e-4abd-a731-64569c32a6d5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Houston Karting Complex", address="3528 S Loop 336 E, Conroe, TX 77301",
      city="Houston", country="US",
      latitude=30.2978145, longitude=-95.4010456,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a4bc168b-8e01-41de-8676-da6a59dc5ea1_photo.jpg",
      averageRating=4.6, totalRatingsCount=256,
      createdAt="2026-09-20T19:27:49.102630Z", updatedAt="2026-09-20T19:27:49.102630Z",
    ),
    ClubDto(
      id="18cd50c0-d18d-4e95-a4f1-8afbf841974d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Houston Motorsports Park", address="11620 N Lake Houston Pkwy, Houston, TX 77044",
      city="Houston", country="US",
      latitude=29.8911304, longitude=-95.2304916,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/677aa3fb-dc73-4c12-912f-22b1aed5a200_photo.jpg",
      averageRating=4.6, totalRatingsCount=1233,
      createdAt="2026-09-20T19:27:46.018147Z", updatedAt="2026-09-20T19:27:46.018147Z",
    ),
    ClubDto(
      id="9297c1f2-e8f9-48ce-86db-a35097e4c7bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Houston Sports Park", address="12131 Kirby Dr, Houston, TX 77045",
      city="Houston", country="US",
      latitude=29.6380273, longitude=-95.3953253,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/016d1cab-4c93-4f91-be91-1c93c708b75b_photo.jpg",
      averageRating=4.6, totalRatingsCount=446,
      createdAt="2026-09-20T19:27:20.984993Z", updatedAt="2026-09-20T19:27:20.984993Z",
    ),
    ClubDto(
      id="28a63fc9-c14b-4fee-bbdb-e55c841f6c1a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Texas Table Tennis Club", address="5902 Sovereign Dr, Houston, TX 77036",
      city="Houston", country="US",
      latitude=29.7140695, longitude=-95.5541231,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fa272607-435f-4d07-af06-09746c779b12_photo.jpg",
      averageRating=4.6, totalRatingsCount=99,
      createdAt="2026-09-20T19:27:42.879325Z", updatedAt="2026-09-20T19:27:42.879325Z",
    ),
    ClubDto(
      id="3652fd23-9b08-4bac-a58a-d22f426be4f9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="uScore Soccer", address="19823 Stuebner Airline Rd, Spring, TX 77379",
      city="Houston", country="US",
      latitude=30.0588515, longitude=-95.545505,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/098ca421-ac04-427f-9792-912e2348fcb6_photo.jpg",
      averageRating=4.6, totalRatingsCount=390,
      createdAt="2026-09-20T19:15:31.477167Z", updatedAt="2026-09-20T19:15:31.477167Z",
    ),
    ClubDto(
      id="78eb4d8c-ade4-4778-8227-7b945a201981", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bay Oaks Country Club", address="14545 Bay Oaks Blvd, Houston, TX 77059",
      city="Houston", country="US",
      latitude=29.5933631, longitude=-95.1259643,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/52dcc60a-cc73-4747-a161-64bd2847f7b2_photo.jpg",
      averageRating=4.5, totalRatingsCount=378,
      createdAt="2026-09-20T19:15:38.888549Z", updatedAt="2026-09-20T19:15:38.888549Z",
    ),
    ClubDto(
      id="6227b727-1f00-4f5f-ba14-d6df48af3764", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Houston Racquet Club", address="10709 Memorial Dr, Houston, TX 77024",
      city="Houston", country="US",
      latitude=29.7652778, longitude=-95.4991667,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ccad3fe-0ab1-44b4-95c7-361a57e39712_photo.jpg",
      averageRating=4.5, totalRatingsCount=328,
      createdAt="2026-09-20T19:15:42.509748Z", updatedAt="2026-09-20T19:15:42.509748Z",
    ),
    ClubDto(
      id="ea63c62a-dd8e-49ac-974a-dd875d7a8d2a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="West Houston Indoor Soccer", address="17115 Clay Rd, Houston, TX 77084",
      city="Houston", country="US",
      latitude=29.8309451, longitude=-95.6599445,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bdd57374-b42a-4f23-9b57-f95649e2f8ef_photo.jpg",
      averageRating=4.5, totalRatingsCount=278,
      createdAt="2026-09-20T19:15:35.858940Z", updatedAt="2026-09-20T19:15:35.858940Z",
    ),
    ClubDto(
      id="ae9aa7f1-8db7-42ff-b660-e830c92a3d39", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bumpy Pickle", address="554 Lockwood Dr, Houston, TX 77011",
      city="Houston", country="US",
      latitude=29.7522407, longitude=-95.322362,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b018b067-a987-40b4-b442-dc08a7e3b659_photo.jpg",
      averageRating=4.4, totalRatingsCount=489,
      createdAt="2026-09-20T19:27:28.713592Z", updatedAt="2026-09-20T19:27:28.713592Z",
    ),
    ClubDto(
      id="9da59d99-ba67-4c74-abfa-88c13b090c06", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Met Athletic Club", address="340 W Dallas St, Houston, TX 77002",
      city="Houston", country="US",
      latitude=29.7570817, longitude=-95.3736894,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/185e22fc-dbad-483a-a892-0d4ca6d8346b_photo.jpg",
      averageRating=4.4, totalRatingsCount=295,
      createdAt="2026-09-20T19:15:45.895047Z", updatedAt="2026-09-20T19:15:45.895047Z",
    ),
    ClubDto(
      id="e0ad382d-b33b-484f-b384-266ea067c6c5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Zone", address="10371 Stella Link Rd 2nd Floor, Houston, TX 77025",
      city="Houston", country="US",
      latitude=29.6694275, longitude=-95.4375713,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/50703db9-540e-4b4d-bfef-15e7f232f1f7_photo.jpg",
      averageRating=4.4, totalRatingsCount=346,
      createdAt="2026-09-20T19:16:00.052973Z", updatedAt="2026-09-20T19:16:00.052973Z",
    ),
    ClubDto(
      id="192a24c8-13d7-4d97-8fff-1a81c536a232", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Topgolf Houston - Katy", address="1030 Memorial Brook Blvd, Houston, TX 77084",
      city="Houston", country="US",
      latitude=29.7867434, longitude=-95.6500505,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5c7321f5-6706-4e56-8998-acc91b267c33_photo.jpg",
      averageRating=4.4, totalRatingsCount=4572,
      createdAt="2026-09-20T19:27:36.650501Z", updatedAt="2026-09-20T19:27:36.650501Z",
    ),
    ClubDto(
      id="68c1f15d-40e0-49f1-8820-225c5b7a9ea7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Topgolf Webster", address="21401 Gulf Fwy, Webster, TX 77598",
      city="Houston", country="US",
      latitude=29.5176204, longitude=-95.1207231,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a97a48f8-13d7-4e21-86f3-4fc2e21fd3a3_photo.jpg",
      averageRating=4.4, totalRatingsCount=2410,
      createdAt="2026-09-20T19:27:39.449147Z", updatedAt="2026-09-20T19:27:39.449147Z",
    ),
    ClubDto(
      id="bbc81128-7d00-47c1-936a-9f8255b14249", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Copperfield Bowl", address="15615 Glen Chase Dr, Houston, TX 77095",
      city="Houston", country="US",
      latitude=29.8813113, longitude=-95.6423613,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a2ac0a8e-1093-40aa-aa54-c4a0efa27e45_photo.jpg",
      averageRating=4.3, totalRatingsCount=1104,
      createdAt="2026-09-20T19:27:55.502991Z", updatedAt="2026-09-20T19:27:55.502991Z",
    ),
    ClubDto(
      id="d86f2d06-f4f2-4e70-8717-b49e26746b6c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fast Eddie's Houston - Fuqua", address="12344 Gulf Fwy Ste A&B, Houston, TX 77034",
      city="Houston", country="US",
      latitude=29.6179474, longitude=-95.2200344,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/717f2c45-e900-4e32-a93d-9a85b7468234_photo.jpg",
      averageRating=4.3, totalRatingsCount=1191,
      createdAt="2026-09-20T19:28:07.341951Z", updatedAt="2026-09-20T19:28:07.341951Z",
    ),
    ClubDto(
      id="7deaf86b-a7c3-4ec0-8da6-7e73f8612c10", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Slick Willies", address="5913 Westheimer Rd, Houston, TX 77057",
      city="Houston", country="US",
      latitude=29.7374198, longitude=-95.4858084,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cfe44176-d1ab-4626-aca7-2a2b0b2a412a_photo.jpg",
      averageRating=4.3, totalRatingsCount=1025,
      createdAt="2026-09-20T19:28:11.909959Z", updatedAt="2026-09-20T19:28:11.909959Z",
    ),
    ClubDto(
      id="f43eb8b7-792e-4419-a7db-b2feeacb53de", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Creek", address="2619 Polk St, Houston, TX 77003",
      city="Houston", country="US",
      latitude=29.7463833, longitude=-95.352057,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6bfcaeb6-28f3-4d0b-9522-0f355017d88d_photo.jpg",
      averageRating=4.2, totalRatingsCount=342,
      createdAt="2026-09-20T19:27:33.370419Z", updatedAt="2026-09-20T19:27:33.370419Z",
    ),
    ClubDto(
      id="d86a654f-4560-4a84-acb9-b31c28994850", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Crossover Athletics, LLC", address="815 Summer Park Dr Ste 400, Stafford, TX 77477",
      city="Houston", country="US",
      latitude=29.6068704, longitude=-95.5697317,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8a798422-962b-4878-a15c-8c78ef95f7e3_photo.jpg",
      averageRating=4.0, totalRatingsCount=258,
      createdAt="2026-09-20T19:16:04.382612Z", updatedAt="2026-09-20T19:16:04.382612Z",
    ),
  )),
  CitySeo(slug="bologna", name="Bologna", country="IT", clubCount=29, sports=listOf(Pair("Volleyball", 5), Pair("Football", 5), Pair("Tennis", 4), Pair("Basketball", 3), Pair("Padel", 2), Pair("Karting", 2), Pair("Paintball", 2), Pair("Golf", 2), Pair("Table Tennis", 1), Pair("Billiards", 1), Pair("Bowling", 1), Pair("Climbing", 1)), clubs=listOf(
    ClubDto(
      id="0fed4248-6261-47f5-87a7-a6a0f726ab2d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fluo Paintball Bologna", address="Via Paolo Canali, 40127 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.5171298, longitude=11.4092381,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aa8648b3-ce34-4010-8b8c-9f4173338d4d_photo.jpg",
      averageRating=4.7, totalRatingsCount=129,
      createdAt="2026-08-31T23:28:55.975314Z", updatedAt="2026-08-31T23:28:55.975314Z",
    ),
    ClubDto(
      id="7a087162-8b86-4f77-adab-c43dcbdb1f48", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billiards Club", address="Via Umberto Tagliabue, 91, 20832 Desio MB",
      city="Bologna", country="IT",
      latitude=45.6228794, longitude=9.2279011,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/98d699c9-b074-43cd-819f-b73d2ee58695_photo.jpg",
      averageRating=4.6, totalRatingsCount=230,
      createdAt="2026-08-31T23:28:44.566139Z", updatedAt="2026-08-31T23:28:44.566139Z",
    ),
    ClubDto(
      id="215a2cda-f129-4b5b-82f4-1f2fb6c37e44", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Giardini Margherita", address="Viale Giovanni Gozzadini, 40136 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.4827156, longitude=11.3524117,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f87cfa12-a50b-430b-86f1-aeee4a434fe4_photo.jpg",
      averageRating=4.6, totalRatingsCount=17885,
      createdAt="2026-08-31T23:26:53.374291Z", updatedAt="2026-08-31T23:26:53.374291Z",
    ),
    ClubDto(
      id="3cdff5d8-65a4-4a97-988e-ec729f1636d6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Club Bologna", address="Monte San Pietro BO IT, Via Alfonso Sabattini, 69, 40050 Chiesa Nuova BO",
      city="Bologna", country="IT",
      latitude=44.5016961, longitude=11.1640747,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac3031ea-65a7-4b70-a251-32f69150d5eb_photo.jpg",
      averageRating=4.6, totalRatingsCount=451,
      createdAt="2026-08-31T23:28:09.650188Z", updatedAt="2026-08-31T23:28:09.650188Z",
    ),
    ClubDto(
      id="0d2636dd-3257-4167-a7be-431889bad021", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UP Urban Climbing", address="Via del Fonditore, 1/5, 40138 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.5039204, longitude=11.40428,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fcc8f340-a6a2-4505-abb2-6eb8bb5c3210_photo.jpg",
      averageRating=4.6, totalRatingsCount=610,
      createdAt="2026-08-31T23:28:39.720668Z", updatedAt="2026-08-31T23:28:39.720668Z",
    ),
    ClubDto(
      id="156514a1-2722-4f0f-9ff4-da866a5ef2b8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Extrema Kart", address="Via Abbà e Motto, 5/A, 41035 Massa Finalese MO",
      city="Bologna", country="IT",
      latitude=44.831657, longitude=11.2240319,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8625f172-2791-4fa8-b499-f3ed534c84f5_photo.jpg",
      averageRating=4.5, totalRatingsCount=770,
      createdAt="2026-08-31T23:28:24.996500Z", updatedAt="2026-08-31T23:28:24.996500Z",
    ),
    ClubDto(
      id="ba4a2264-9926-4212-b69f-1cbde1d76499", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PalaDozza", address="Piazza Manfredi Azzarita, 3, 40122 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.4999036, longitude=11.332551,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac1b6af4-7c10-4105-ad0a-2f1ba5f11aca_photo.jpg",
      averageRating=4.5, totalRatingsCount=2772,
      createdAt="2026-08-31T23:27:29.013884Z", updatedAt="2026-08-31T23:27:29.013884Z",
    ),
    ClubDto(
      id="9b0f8cb3-3035-4017-acba-c8b2392deb43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo Savena", address="Via della Torretta, 12/5, 40127 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.5002551, longitude=11.3666761,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/745f3797-2af7-464f-b6bc-9d2dc547c3d7_photo.jpg",
      averageRating=4.4, totalRatingsCount=319,
      createdAt="2026-08-31T23:26:30.587476Z", updatedAt="2026-09-01T14:31:51.642940Z",
    ),
    ClubDto(
      id="c2ff3708-0b9b-4b35-ad10-fde16d49ab43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fun City Family | Bowling Castel Bolognese", address="Via Martiri di Felisio, 53/D, 48014 Castel Bolognese RA",
      city="Bologna", country="IT",
      latitude=44.3252472, longitude=11.7878501,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83e7986f-ec70-4dd7-9460-68fd6e7a622d_photo.jpg",
      averageRating=4.4, totalRatingsCount=127,
      createdAt="2026-08-31T23:28:33.328257Z", updatedAt="2026-08-31T23:28:33.328257Z",
    ),
    ClubDto(
      id="40e17c3e-8299-4ccc-a78c-0bd326dfa2fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SavenaBeach", address="Via Speranza, 1, 40068 San Lazzaro di Savena BO",
      city="Bologna", country="IT",
      latitude=44.4736543, longitude=11.4130812,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1add3f18-84f7-466d-be7d-7987474a63b7_photo.jpg",
      averageRating=4.4, totalRatingsCount=54,
      createdAt="2026-08-31T23:27:54.154928Z", updatedAt="2026-08-31T23:27:54.154928Z",
    ),
    ClubDto(
      id="2e6a8eab-7a31-4e8d-824a-8d6d4af00b35", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport Village Bologna", address="Via S. Donato, 148, 40127 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.5073657, longitude=11.3741678,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5448ac3c-779e-477c-895a-c0e1c39b5571_photo.jpg",
      averageRating=4.4, totalRatingsCount=289,
      createdAt="2026-08-31T23:26:35.301229Z", updatedAt="2026-08-31T23:26:35.301229Z",
    ),
    ClubDto(
      id="3eee3215-224d-4955-9f44-0c40b749cf4c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Virtus Arena", address="Via Alfredo Calzoni, 40128 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.5100724, longitude=11.3664602,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a2229834-0484-491c-a531-fc613f455b05_photo.jpg",
      averageRating=4.4, totalRatingsCount=847,
      createdAt="2026-08-31T23:27:34.033647Z", updatedAt="2026-08-31T23:27:34.033647Z",
    ),
    ClubDto(
      id="77ea34ac-94cd-4dd4-be83-633f06a6ff35", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Circolo Tennis Italy", address="Via Coriolano Vighi, 35, 40133 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.4980601, longitude=11.2813501,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a85c6d3f-3309-4740-b1bc-11c0e6925a51_photo.jpg",
      averageRating=4.2, totalRatingsCount=397,
      createdAt="2026-08-31T23:27:07.092931Z", updatedAt="2026-08-31T23:27:07.092931Z",
    ),
    ClubDto(
      id="8cc7946b-5c67-47b7-b058-2a2b48842a42", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Coop. Karting Rioveggio (Soc. Coop. R. L.)", address="Frazione Rioveggio 58/A, Monzuno, BO 40036, 40036, 40036 Monzuno BO",
      city="Bologna", country="IT",
      latitude=44.2858428, longitude=11.2079305,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e084510f-77eb-4f8f-bed0-758c0378b991_photo.jpg",
      averageRating=4.2, totalRatingsCount=167,
      createdAt="2026-08-31T23:28:28.804612Z", updatedAt="2026-08-31T23:28:28.804612Z",
    ),
    ClubDto(
      id="056126f2-5dc1-4dda-96d5-19f7186513d4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Club Siepelunga", address="Via Siepelunga, 56/4, 40141 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.4626375, longitude=11.3630253,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f3fa14ce-e41a-445b-930e-c92dcb84a664_photo.jpg",
      averageRating=4.2, totalRatingsCount=78,
      createdAt="2026-08-31T23:28:15.554513Z", updatedAt="2026-08-31T23:28:15.554513Z",
    ),
    ClubDto(
      id="eda980d7-33cd-449f-a55d-4dd01d7576f2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="POL Antal Pallavicini", address="V. Marco Emilio Lepido, 194/10, 40132 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.5178385, longitude=11.2518803,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7270305-4b54-4120-b731-4bafe5fda3f3_photo.jpg",
      averageRating=4.2, totalRatingsCount=435,
      createdAt="2026-08-31T23:27:46.421571Z", updatedAt="2026-08-31T23:27:46.421571Z",
    ),
    ClubDto(
      id="451b7a2f-1a4e-477d-b580-8ba0e234b28f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="POLISPORTIVA PONTELUNGO A.D.", address="Via Agucchi, 121/18, 40133 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.5118894, longitude=11.3000372,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9b80f280-6444-4034-8cf0-2f965594b3d7_photo.jpg",
      averageRating=4.2, totalRatingsCount=340,
      createdAt="2026-08-31T23:27:12.444909Z", updatedAt="2026-08-31T23:27:12.444909Z",
    ),
    ClubDto(
      id="54146eab-65d9-48a6-93c2-167c491f93cf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Bologna Two Towers", address="Via del Paleotto, 11/13, 40141 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.4441328, longitude=11.3535066,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a617943a-4cb8-4a7a-8d62-0cb9ee62b92e_photo.jpg",
      averageRating=4.2, totalRatingsCount=386,
      createdAt="2026-08-31T23:28:49.081176Z", updatedAt="2026-08-31T23:28:49.081176Z",
    ),
    ClubDto(
      id="ee6880b4-26c4-4db1-8b84-386bd4b45116", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SIRO TENNIS asd", address="Via Tommaso Martelli, 31/4, 40138 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.4919671, longitude=11.398332,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7f9d8bc9-392d-4e4a-a10a-df8bc0ce43b3_photo.jpg",
      averageRating=4.2, totalRatingsCount=609,
      createdAt="2026-08-31T23:26:59.515715Z", updatedAt="2026-08-31T23:26:59.515715Z",
    ),
    ClubDto(
      id="af062170-ad04-41e2-90c2-fad6b773dd3c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BOLOGNA PADEL", address="Via Lame, 298, 40013 Castel Maggiore BO",
      city="Bologna", country="IT",
      latitude=44.5733923, longitude=11.3220255,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e932ab6f-d39e-4957-ad5b-7f55fb85bdfe_photo.jpg",
      averageRating=4.0, totalRatingsCount=665,
      createdAt="2026-08-31T23:27:17.939553Z", updatedAt="2026-09-01T14:31:43.068881Z",
    ),
    ClubDto(
      id="aa898eaa-dc43-4a52-b58b-b6e8def6bceb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fortitudo Soccer Camp \"Salus\"", address="Mura di Porta Saragozza, 5, ex, Via Frassinago, 26, 40123 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.4914575, longitude=11.3313021,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bdd18293-d225-4ae7-b247-42b54fe34037_photo.jpg",
      averageRating=4.0, totalRatingsCount=63,
      createdAt="2026-08-31T23:26:49.143744Z", updatedAt="2026-08-31T23:26:49.143744Z",
    ),
    ClubDto(
      id="5a24dc46-7d1b-46e9-9080-daf89bda31ca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="G.S. Cagliari", address="Via Scandellara, 52/3, 40138 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.4980359, longitude=11.3849114,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ce1c70e3-d801-46af-a0a3-a546ac5add86_photo.jpg",
      averageRating=4.0, totalRatingsCount=65,
      createdAt="2026-08-31T23:26:42.793290Z", updatedAt="2026-08-31T23:26:42.793290Z",
    ),
    ClubDto(
      id="07958b8f-4e2b-4ca6-ba0b-a5b0ae7c892c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gioka srl", address="V. Stalingrado, 12, 40128 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.5064053, longitude=11.3546336,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8a5763c7-b16e-4e7a-b830-5ef19f02bdbf_photo.jpg",
      averageRating=4.0, totalRatingsCount=74,
      createdAt="2026-08-31T23:26:38.757743Z", updatedAt="2026-08-31T23:26:38.757743Z",
    ),
    ClubDto(
      id="a1d8fe23-aed5-47cc-8a73-5b92e15b656c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gioka beach arena", address="V. Stalingrado, 12, 40128 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.508136, longitude=11.3525985,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/53df0671-c251-4565-b1be-e4bdd0aa15a4_photo.jpg",
      averageRating=3.9, totalRatingsCount=73,
      createdAt="2026-08-31T23:27:49.690443Z", updatedAt="2026-08-31T23:27:49.690443Z",
    ),
    ClubDto(
      id="9a4cc2c1-a367-4e98-95a1-cbca81d5311e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Center Corticelli - C.S.C.", address="Via Enzo Zoni, 2, 40133 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.5003395, longitude=11.3091144,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/453271b0-308c-4087-b23f-c946b01eec9a_photo.jpg",
      averageRating=3.9, totalRatingsCount=460,
      createdAt="2026-08-31T23:27:40.305261Z", updatedAt="2026-08-31T23:27:40.305261Z",
    ),
    ClubDto(
      id="ca262fc9-1659-49d6-a8b7-d2dcb3111dbf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Junior Club", address="Via Serrabella, 1 – Rastignano (BO, 40065 Pianoro BO",
      city="Bologna", country="IT",
      latitude=44.4176437, longitude=11.3498285,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7906a19e-32aa-4382-be37-0823ac387665_photo.jpg",
      averageRating=3.7, totalRatingsCount=1947,
      createdAt="2026-08-31T23:27:58.941899Z", updatedAt="2026-08-31T23:27:58.941899Z",
    ),
    ClubDto(
      id="08c8bf7b-3b11-4e07-9e18-e6d621e4e46f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BVC Beach Village Zer051", address="Via Giuseppe di Vittorio, 18, 40033 Zona Industriale Via del Lavoro BO",
      city="Bologna", country="IT",
      latitude=44.490324, longitude=11.2572363,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e113e32d-201e-49dc-bb4e-c2fcfe17489a_photo.jpg",
      averageRating=4.5, totalRatingsCount=41,
      createdAt="2026-08-31T23:28:05.408472Z", updatedAt="2026-08-31T23:28:05.408472Z",
    ),
    ClubDto(
      id="40def12c-9bdc-446e-83b3-0b41b6b55055", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Padel Bologna", address="Via Alberto Calda, 2, 40135 Bologna BO",
      city="Bologna", country="IT",
      latitude=44.4891909, longitude=11.2973534,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a772db38-da9c-43bc-8786-d8cd66de7f85_photo.jpg",
      averageRating=4.0, totalRatingsCount=44,
      createdAt="2026-08-31T23:27:23.315850Z", updatedAt="2026-08-31T23:27:23.315850Z",
    ),
    ClubDto(
      id="e467474b-716e-4038-b5fd-db61903614c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="A.S.D. Maior TennisTavolo", address="Via Gramsci, 175, 40013 Castel Maggiore BO",
      city="Bologna", country="IT",
      latitude=44.575859, longitude=11.3647165,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d2afc36-f519-42bf-98b0-d829c748c54b_photo.jpg",
      averageRating=4.5, totalRatingsCount=16,
      createdAt="2026-08-31T23:28:20.020231Z", updatedAt="2026-08-31T23:28:20.020231Z",
    ),
  )),
  CitySeo(slug="bucharest", name="Bucharest", country="RO", clubCount=29, sports=listOf(Pair("Tennis", 3), Pair("Football", 3), Pair("Volleyball", 3), Pair("Padel", 3), Pair("Karting", 2), Pair("Paintball", 2), Pair("Table Tennis", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Basketball", 2), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="4e01727d-2380-46b9-81ae-4736e15aa1d2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Airsoft Ieftin", address="Casa Presei, Corp A3, Piața Presei Libere, Etaj 2, 013701 București",
      city="Bucharest", country="RO",
      latitude=44.4825098, longitude=26.0696091,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dcac2d64-c6bc-4642-a8d9-c52df2cf1efb_ChIJu_ZHIEcC_2.jpg",
      averageRating=4.9, totalRatingsCount=938,
      createdAt="2026-08-30T22:50:01.947071Z", updatedAt="2026-08-31T22:11:13.189533Z",
    ),
    ClubDto(
      id="a59b8732-55b0-420c-90b1-5e239902972a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BLOKX Climbing Gym", address="Șoseaua Fabrica de Glucoză 15, 020331 București",
      city="Bucharest", country="RO",
      latitude=44.478906, longitude=26.1216903,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3730660b-f389-4528-9097-bbcc7e056503_ChIJ1blPitX5_0.jpg",
      averageRating=4.9, totalRatingsCount=587,
      createdAt="2026-08-30T22:49:26.112601Z", updatedAt="2026-08-31T08:25:51.650221Z",
    ),
    ClubDto(
      id="9b365237-c0ba-4b00-8be3-f4ae95df5d20", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="International Basketball Academy (IBA)", address="Bulevardul Pipera 196, 077190 Voluntari",
      city="Bucharest", country="RO",
      latitude=44.5285143, longitude=26.1455194,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5447fa33-084c-46a7-9f08-22c72b2faec4_photo.jpg",
      averageRating=4.9, totalRatingsCount=79,
      createdAt="2026-08-31T15:00:47.443459Z", updatedAt="2026-08-31T15:00:47.443459Z",
    ),
    ClubDto(
      id="a0c215c9-2df5-4960-aee4-e01018921aee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PING PONG TSPVIBE", address="Șoseaua Dudești-Pantelimon 44, 077145 București",
      city="Bucharest", country="RO",
      latitude=44.4385102, longitude=26.1943818,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c9693b8a-ea73-4788-acd1-69eb3ab802d7_photo.jpg",
      averageRating=4.8, totalRatingsCount=158,
      createdAt="2026-08-31T15:02:06.895776Z", updatedAt="2026-08-31T15:02:06.895776Z",
    ),
    ClubDto(
      id="82d3756a-1b11-4794-b19d-2ea59e0a216a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Haus Bucharest", address="Bucureşti Sectorul 3, 030352 București",
      city="Bucharest", country="RO",
      latitude=44.4281429, longitude=26.1801127,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/abaa043b-afe3-4eec-a5b6-79e9c620a280_ChIJTek4UQD__0.jpg",
      averageRating=4.8, totalRatingsCount=65,
      createdAt="2026-08-30T22:50:32.360430Z", updatedAt="2026-08-30T22:50:32.360430Z",
    ),
    ClubDto(
      id="3d0cc8fe-0fc6-4ba6-b817-91f060512bd3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel One", address="Nastase & Marica sport center, Șoseaua Pipera 38, 077190 București",
      city="Bucharest", country="RO",
      latitude=44.4769904, longitude=26.0982233,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2d3f4154-f5a7-4e5e-8807-c73386f15a49_ChIJz9kefnwD_0.jpg",
      averageRating=4.8, totalRatingsCount=68,
      createdAt="2026-08-30T22:50:23.343611Z", updatedAt="2026-08-30T22:50:23.343611Z",
    ),
    ClubDto(
      id="9d6a735e-a111-4375-a1fc-6e669d8fe61c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PadelMania Herastrau", address="Șoseaua Nordului 7-9, 077190 București",
      city="Bucharest", country="RO",
      latitude=44.478872, longitude=26.0855704,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49c349e0-efd5-498b-9e88-a74b288a9c2b_ChIJqdHzlmkC_0.jpg",
      averageRating=4.8, totalRatingsCount=110,
      createdAt="2026-08-30T22:50:15.984670Z", updatedAt="2026-08-31T08:34:08.286554Z",
    ),
    ClubDto(
      id="355b2fce-12eb-42d8-9d1b-c1f704b030b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Carpatic Climbing Gym", address="Sema Parc, Splaiul Independenței 319A, 060044 București",
      city="Bucharest", country="RO",
      latitude=44.4429197, longitude=26.0482796,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0340c80a-e0f2-4e2c-b814-1d7541f6d3fa_ChIJc3k2WZUB_0.jpg",
      averageRating=4.7, totalRatingsCount=700,
      createdAt="2026-08-30T22:49:19.020381Z", updatedAt="2026-08-31T08:26:43.824233Z",
    ),
    ClubDto(
      id="4f425d20-204e-4017-a3d6-bd36c2a814d4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Megazone", address="Bulevardul Iuliu Maniu 7, cladirea S, 061072 București",
      city="Bucharest", country="RO",
      latitude=44.4336929, longitude=26.0499649,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1a930042-81bc-4ecb-bcbe-2140ee0f60aa_ChIJhT93osUB_0.jpg",
      averageRating=4.7, totalRatingsCount=1272,
      createdAt="2026-08-30T22:49:52.279246Z", updatedAt="2026-08-31T08:32:11.525209Z",
    ),
    ClubDto(
      id="c025d1a1-2abf-4cc3-9ea3-2a8a6677ac14", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bucharest Golf Club", address="M398+PF, 077168 Vlădiceasca",
      city="Bucharest", country="RO",
      latitude=44.666482, longitude=26.0605416,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dc5f7534-72ca-412c-8eb9-ae8b14eed72f_photo.jpg",
      averageRating=4.6, totalRatingsCount=100,
      createdAt="2026-08-31T15:01:24.790894Z", updatedAt="2026-08-31T15:01:24.790894Z",
    ),
    ClubDto(
      id="e55911a5-645c-4056-ae2e-56ed3e3a1013", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="National Golf & Country Club", address="DC 159, 137330 Niculești",
      city="Bucharest", country="RO",
      latitude=44.6935501, longitude=25.9348168,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/97f8b886-8c7d-4b7a-9e67-eec37ea27c76_photo.jpg",
      averageRating=4.6, totalRatingsCount=110,
      createdAt="2026-08-31T15:01:32.910647Z", updatedAt="2026-08-31T15:01:32.910647Z",
    ),
    ClubDto(
      id="5a5c5ffb-5d64-4294-a80c-9f01343bc4b3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TRICKSHOT Promenada", address="Mall Promenada, Calea Floreasca 246B, 014476 București",
      city="Bucharest", country="RO",
      latitude=44.4785615, longitude=26.102815,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67843425-b356-46ee-9739-0445809fedd7_ChIJqeGKnnAC_0.jpg",
      averageRating=4.6, totalRatingsCount=11949,
      createdAt="2026-08-30T22:49:04.100516Z", updatedAt="2026-08-31T08:37:18.087551Z",
    ),
    ClubDto(
      id="863dbbf1-9fea-4a97-80a7-7aa583559ebe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AMC Kart", address="Centura București 5A, 077180 Tunari",
      city="Bucharest", country="RO",
      latitude=44.5352885, longitude=26.1489156,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9879f70b-bdcb-4693-9aa4-922b8cb7ed94_ChIJsTnqekId_0.jpg",
      averageRating=4.5, totalRatingsCount=2468,
      createdAt="2026-08-30T22:49:40.015673Z", updatedAt="2026-08-30T22:49:40.015673Z",
    ),
    ClubDto(
      id="e36ae596-7463-4c74-a1b3-fdf824430e25", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="As Club Politehnica", address="Strada Fruntaș Anghel Mihai 2, 061344 București",
      city="Bucharest", country="RO",
      latitude=44.4319319, longitude=26.0429136,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b9ce6242-afa3-4496-8df2-db4879abd3b1_ChIJlU9fWZIB_0.jpg",
      averageRating=4.5, totalRatingsCount=194,
      createdAt="2026-08-30T22:50:53.194851Z", updatedAt="2026-08-30T22:50:53.194851Z",
    ),
    ClubDto(
      id="ecf73e0d-b57a-4081-8d39-3cd5c5263ce6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mojo", address="Strada Lipscani 69, 030167 București",
      city="Bucharest", country="RO",
      latitude=44.4318515, longitude=26.1023786,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1990aa17-0bb8-43c7-8722-43c88be40ddf_ChIJ-7tVTT7__0.jpg",
      averageRating=4.5, totalRatingsCount=3240,
      createdAt="2026-08-30T22:48:50.408123Z", updatedAt="2026-08-31T08:32:58.210328Z",
    ),
    ClubDto(
      id="d8dafd86-f6bb-43c6-b5cc-b9043953faa2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="RATB Sports Association", address="Strada Trapezului 4, 077160 București",
      city="Bucharest", country="RO",
      latitude=44.4083204, longitude=26.1712068,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1efe875d-54a9-4ca6-8e9a-4e6dde8316ef_photo.jpg",
      averageRating=4.5, totalRatingsCount=304,
      createdAt="2026-08-31T15:01:09.892330Z", updatedAt="2026-08-31T15:01:09.892330Z",
    ),
    ClubDto(
      id="0bc5a2f5-998e-4e44-9dff-1e2fda3dd4c1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenis Club Tineretului", address="Bucureşti Sectorul 4, București",
      city="Bucharest", country="RO",
      latitude=44.407711, longitude=26.1022574,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fb48f362-e752-44e7-93f4-775ed32bf7c8_ChIJ_zF88ar__0.jpg",
      averageRating=4.5, totalRatingsCount=335,
      createdAt="2026-08-30T22:50:46.614121Z", updatedAt="2026-08-30T22:50:46.614121Z",
    ),
    ClubDto(
      id="92c9a8f0-26e8-4f43-a300-8c10a2f06010", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vmax Karting Romexpo", address="Romexpo, Pavilion, Bulevardul Mărăști 65-67, C4-C5, București",
      city="Bucharest", country="RO",
      latitude=44.4774734, longitude=26.0641268,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1ec49d0c-21cd-4f61-afef-d97a4c2aab8d_ChIJkWpcAowD_0.jpg",
      averageRating=4.5, totalRatingsCount=2748,
      createdAt="2026-08-30T22:49:33.151026Z", updatedAt="2026-08-31T08:38:54.476609Z",
    ),
    ClubDto(
      id="6660d48c-b56e-4b6f-b486-6e4bcae8c457", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Academia de Paintball", address="Șos. Vergului 18, București",
      city="Bucharest", country="RO",
      latitude=44.4373462, longitude=26.183369,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ec4dd79f-5511-4152-bf73-9b2a57002f6c_ChIJq9DsLFD5_0.jpg",
      averageRating=4.4, totalRatingsCount=444,
      createdAt="2026-08-30T22:50:08.718220Z", updatedAt="2026-08-31T08:24:42.156922Z",
    ),
    ClubDto(
      id="1de904b1-2770-4bb1-a183-645964976395", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="IDM Club", address="Splaiul Independenței 319B, 060044 București",
      city="Bucharest", country="RO",
      latitude=44.4446263, longitude=26.0492271,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0d5cc34a-c08d-4a6e-b4e0-1ca0fe8b21b8_ChIJl-paLZUB_1.jpg",
      averageRating=4.4, totalRatingsCount=6741,
      createdAt="2026-08-30T22:49:11.310272Z", updatedAt="2026-08-31T22:11:17.756208Z",
    ),
    ClubDto(
      id="ee61aa7d-4786-42d3-beb8-99b16bf17c01", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pescariu Sports & Spa", address="Strada Glodeni 1-3, 023824 București",
      city="Bucharest", country="RO",
      latitude=44.4712635, longitude=26.1115794,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e32924fe-2ae4-4dd3-8803-59df662eda17_ChIJR9HMmp74_0.jpg",
      averageRating=4.4, totalRatingsCount=1991,
      createdAt="2026-08-30T22:50:38.934690Z", updatedAt="2026-08-31T08:34:39.513666Z",
    ),
    ClubDto(
      id="16a93aaf-b3bf-4319-8448-b89c6c848275", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sud Arena", address="Șoseaua Vitan-Bârzești 5-7, 042121 București",
      city="Bucharest", country="RO",
      latitude=44.3949096, longitude=26.1442759,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4adace40-8a3d-409c-a2e5-4fd102c0717a_photo.jpg",
      averageRating=4.4, totalRatingsCount=953,
      createdAt="2026-08-31T15:00:54.021946Z", updatedAt="2026-08-31T22:11:21.849754Z",
    ),
    ClubDto(
      id="76e6038f-cb61-4411-a343-fe22b0cfc139", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BSP Arena", address="Aleea Moinești 1, 061238 București",
      city="Bucharest", country="RO",
      latitude=44.4299212, longitude=26.0161102,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/51f49c49-2884-4065-b993-e6ab9d06c2ab_ChIJK8Je3FIA_0.jpg",
      averageRating=4.3, totalRatingsCount=499,
      createdAt="2026-08-30T22:48:30.517184Z", updatedAt="2026-08-30T22:48:30.517184Z",
    ),
    ClubDto(
      id="310472b8-e500-41fd-bb90-d2b6b6076ccc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lions FC Bucuresti", address="Bulevardul Tineretului 2, 040341 București",
      city="Bucharest", country="RO",
      latitude=44.4077218, longitude=26.1111229,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dd6bc205-7f26-4179-843a-dc13f7d7383e_ChIJKdlcg__-_0.jpg",
      averageRating=4.3, totalRatingsCount=361,
      createdAt="2026-08-30T22:48:44.824657Z", updatedAt="2026-08-30T22:48:44.824657Z",
    ),
    ClubDto(
      id="65368e0a-f042-40db-9405-6e6afce82226", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Chez Gabi", address="Bulevardul Iuliu Maniu 11, 061073 București",
      city="Bucharest", country="RO",
      latitude=44.434146, longitude=26.049697,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/447def57-a8a9-4f3c-b32b-3046343f2ed3_ChIJZQqqvMUB_0.jpg",
      averageRating=4.2, totalRatingsCount=2249,
      createdAt="2026-08-30T22:48:57.198243Z", updatedAt="2026-08-31T08:26:58.856057Z",
    ),
    ClubDto(
      id="4d99cb57-6e21-4653-8786-f59827b0c6a4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Magic Arena", address="Splaiul Independenței 336, 060324 București",
      city="Bucharest", country="RO",
      latitude=44.4467701, longitude=26.0429009,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83ea1c74-ffae-48c9-9b7c-86a5238c8561_ChIJoy5hlv4B_0.jpg",
      averageRating=4.2, totalRatingsCount=457,
      createdAt="2026-08-30T22:48:36.863525Z", updatedAt="2026-08-30T22:48:36.863525Z",
    ),
    ClubDto(
      id="60087f76-a156-47d8-be36-3a32b5873178", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SandVibes Arena", address="Drumul Mănăstirii, 014336 București",
      city="Bucharest", country="RO",
      latitude=44.4851172, longitude=26.1026791,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c2b3f2f1-2d52-4818-9e46-b9a34335a0d9_photo.jpg",
      averageRating=5.0, totalRatingsCount=20,
      createdAt="2026-08-31T15:01:00.576704Z", updatedAt="2026-08-31T15:01:00.576704Z",
    ),
    ClubDto(
      id="68dbb557-a2ef-4af9-8bc2-d43975d2cc2d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Volleyball", address="Tei, Bucharest",
      city="Bucharest", country="RO",
      latitude=44.4688537, longitude=26.117278,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7160de5-5c07-4462-b4db-617ac8335d27_photo.jpg",
      averageRating=5.0, totalRatingsCount=7,
      createdAt="2026-08-31T15:01:17.726174Z", updatedAt="2026-08-31T15:01:17.726174Z",
    ),
    ClubDto(
      id="01cc3490-2a18-4ff4-967c-56d5aeda288f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Asociația Pro Table Tennis", address="Șoseaua Dudești-Pantelimon 44, 077145 București",
      city="Bucharest", country="RO",
      latitude=44.4385521, longitude=26.1943754,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/92d771cd-52db-44bf-b6bb-683e96c8db70_photo.jpg",
      averageRating=5.0, totalRatingsCount=6,
      createdAt="2026-08-31T15:02:00.774507Z", updatedAt="2026-08-31T15:02:00.774507Z",
    ),
  )),
  CitySeo(slug="vilnius", name="Vilnius", country="LT", clubCount=29, sports=listOf(Pair("Basketball", 3), Pair("Football", 3), Pair("Tennis", 3), Pair("Volleyball", 3), Pair("Bowling", 2), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Table Tennis", 2), Pair("Golf", 2), Pair("Padel", 2), Pair("Karting", 2), Pair("Laser Tag", 2), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="c3a617e3-7d86-47f1-abdd-a5edb1105159", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bronx", address="Konstitucijos pr. 12, 09309 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6948622, longitude=25.2782562,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04cbc5b8-18f5-4b86-bf96-31c9c5993864_ChIJl5QNUHCV_0.jpg",
      averageRating=5.0, totalRatingsCount=1523,
      createdAt="2026-08-30T23:34:03.169996Z", updatedAt="2026-08-30T23:34:03.169996Z",
    ),
    ClubDto(
      id="e74405f1-b8d2-4ca2-8c1f-864a5af44bfe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BONOBO climbing", address="Panerių g. 35, Vilnius, 03209 Vilniaus m. sav.",
      city="Vilnius", country="LT",
      latitude=54.6697915, longitude=25.2690891,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/00637ae1-2255-4b8b-8c48-f9dd7a58164d_ChIJudrS86eV_0.jpg",
      averageRating=4.9, totalRatingsCount=653,
      createdAt="2026-08-30T23:34:30.955228Z", updatedAt="2026-08-31T08:25:51.960881Z",
    ),
    ClubDto(
      id="5a9ea2ab-13d3-4860-92fe-de33467e0daa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kartodromas \"Kartlandas Max\", Savanorių pr. 178B, Vilnius", address="Savanorių pr. 178B, 03154 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6506859, longitude=25.2198042,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1de5d134-e7dc-4f06-b5cb-dee2e981a9fe_ChIJsbrveGuV_0.jpg",
      averageRating=4.9, totalRatingsCount=4708,
      createdAt="2026-08-30T23:34:45.156990Z", updatedAt="2026-08-31T08:31:14.927080Z",
    ),
    ClubDto(
      id="bf77f2af-d1e3-482c-a438-2d4dce33db8a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tinklinio Akademija", address="Justiniškių g. 12, Vilnius, 05131 Vilniaus m. sav.",
      city="Vilnius", country="LT",
      latitude=54.7031976, longitude=25.2194347,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8f7bb395-5b4f-4811-b7f7-cd131a776617_photo.jpg",
      averageRating=4.9, totalRatingsCount=106,
      createdAt="2026-08-31T15:12:30.314314Z", updatedAt="2026-08-31T15:12:30.314314Z",
    ),
    ClubDto(
      id="6693a5de-7ce8-4174-b7eb-e3556bcfa6f5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="VRARENA.LT - PRO Vilnius", address="Tarandės g. 34a, 14188 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.7487457, longitude=25.2073985,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a3ed4a8c-bf7c-4ebf-a898-966d1f18bfa5_ChIJGzsPCk6R_0.jpg",
      averageRating=4.9, totalRatingsCount=259,
      createdAt="2026-08-30T23:35:04.111626Z", updatedAt="2026-08-30T23:35:04.111626Z",
    ),
    ClubDto(
      id="d24b9a39-10a7-40e8-bbbd-0d4b5be2672c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="European Centre Golf Club", address="Golfo Gatve 20, 15130 Girija",
      city="Vilnius", country="LT",
      latitude=54.9102542, longitude=25.3123933,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/942c9986-9afd-440e-a268-9ed6d936ef21_photo.jpg",
      averageRating=4.8, totalRatingsCount=310,
      createdAt="2026-08-31T15:12:57.200961Z", updatedAt="2026-08-31T15:12:57.200961Z",
    ),
    ClubDto(
      id="0a099f74-5567-4960-8f8b-644dc8a233db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kartodromas \"Kartlandas Vilnius\"", address="Pramonės g. 141C, 11115 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6930088, longitude=25.4389705,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7298477d-9828-444a-bad3-db8d280c4029_ChIJP30RyYST_0.jpg",
      averageRating=4.8, totalRatingsCount=3141,
      createdAt="2026-08-30T23:34:51.345300Z", updatedAt="2026-08-31T08:31:16.717098Z",
    ),
    ClubDto(
      id="51233593-8c11-4fc3-8920-927ec15e3ba0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Montis Magia", address="PC \"PIKAS, Ukmergės g. 221, 07156 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.7147325, longitude=25.2490784,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cf30a906-dfd4-46bc-910d-e2fee532401a_ChIJReqa6wSU_0.jpg",
      averageRating=4.8, totalRatingsCount=514,
      createdAt="2026-08-30T23:34:37.923630Z", updatedAt="2026-08-30T23:34:37.923630Z",
    ),
    ClubDto(
      id="0a751ccf-f792-47d3-8480-9ecbe7a1b480", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Baltictennis", address="Telšių g. 17, 02161 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6635882, longitude=25.2773787,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a050e2d-8b39-43b6-a96a-b5a816242bbd_ChIJJUHMC12U_1.jpg",
      averageRating=4.7, totalRatingsCount=139,
      createdAt="2026-08-30T23:35:33.228160Z", updatedAt="2026-08-31T22:11:13.921526Z",
    ),
    ClubDto(
      id="670c6ab7-2a60-4170-a075-bf562285db4d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Biliardo klubas \"FUKSAS\"", address="Gedimino 24 Vilnius, 01104 Lithuania",
      city="Vilnius", country="LT",
      latitude=54.6876753, longitude=25.2756436,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ced6f582-6a26-462c-ab5a-ad199eefff8b_ChIJheAxsQ-U_0.jpg",
      averageRating=4.7, totalRatingsCount=1008,
      createdAt="2026-08-30T23:34:10.035428Z", updatedAt="2026-08-30T23:34:10.035428Z",
    ),
    ClubDto(
      id="503dd600-d095-4f8b-94e6-63873676607a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Delfi Sports Center", address="Ozo g. 14C, 08200 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.7163374, longitude=25.2752048,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/858382f1-569a-412d-9935-402f4f85bb0a_photo.jpg",
      averageRating=4.7, totalRatingsCount=627,
      createdAt="2026-08-31T15:12:06.266615Z", updatedAt="2026-08-31T15:12:06.266615Z",
    ),
    ClubDto(
      id="2ad86686-2a68-42b1-9fa5-229a35c749e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ping-pong, stalo teniso megeju ir profesionalu klubas", address="J. Jasinskio g. 6, 01112 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6873339, longitude=25.2651359,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a23fb886-e0b9-499d-a015-e3ed0fcfaaed_photo.jpg",
      averageRating=4.7, totalRatingsCount=69,
      createdAt="2026-08-31T15:13:11.120959Z", updatedAt="2026-08-31T15:13:11.120959Z",
    ),
    ClubDto(
      id="c9be13ff-f2a6-44d2-ad99-246d4e4ca8f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SEB Arena", address="Ąžuolyno g. 7, 07196 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.7069811, longitude=25.2344142,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f145d47f-72e4-4b78-846d-45c69691eae9_ChIJ-cjtW96T_0.jpg",
      averageRating=4.7, totalRatingsCount=1204,
      createdAt="2026-08-30T23:33:42.111719Z", updatedAt="2026-09-01T14:31:52.700280Z",
    ),
    ClubDto(
      id="37ad2381-1a35-4540-af9b-7c576608d082", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Akropolio ledas", address="Ozo g. 25, 07150 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.7101717, longitude=25.2624517,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/082fbd02-5343-408e-83b8-9dc07326e1ac_ChIJe9irTleR_0.jpg",
      averageRating=4.6, totalRatingsCount=514,
      createdAt="2026-08-30T23:33:49.347301Z", updatedAt="2026-08-30T23:33:49.347301Z",
    ),
    ClubDto(
      id="15b20737-57c0-414f-ae87-8f01641abee8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bernardinų sodų teniso kortai", address="Barboros Radvilaitės g. 6C, 01143 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6857183, longitude=25.2945108,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/05bde181-9536-4ba6-beb1-6cb0c65424e3_ChIJaaMy9BeU_0.jpg",
      averageRating=4.6, totalRatingsCount=100,
      createdAt="2026-08-30T23:35:40.319044Z", updatedAt="2026-08-31T08:26:02.087325Z",
    ),
    ClubDto(
      id="359546de-c229-4ab4-b800-2f7a0e801372", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lazerių arena", address="Ateities g. 1F, 08419 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.7397723, longitude=25.2735393,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/342062d2-7375-48a5-986d-723f0f22ae3b_ChIJb9XTND2R_0.jpg",
      averageRating=4.6, totalRatingsCount=337,
      createdAt="2026-08-30T23:34:57.423970Z", updatedAt="2026-08-30T23:34:57.423970Z",
    ),
    ClubDto(
      id="10637cae-cbb0-48fd-8658-454832e5772c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Smėlio arena", address="Justiniškių g. 12, Vilnius, 05131 Vilniaus m. sav.",
      city="Vilnius", country="LT",
      latitude=54.7032154, longitude=25.2193274,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/70d104c2-cf41-4003-b07e-bff86ea0b7ec_photo.jpg",
      averageRating=4.6, totalRatingsCount=652,
      createdAt="2026-08-31T15:12:21.076332Z", updatedAt="2026-08-31T15:12:21.076332Z",
    ),
    ClubDto(
      id="3ffc57ce-dfab-4d61-9f2d-769a62313de5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The V Golf Club Vilnius", address="14247 Masionys, Lithuania",
      city="Vilnius", country="LT",
      latitude=54.8304017, longitude=25.1267728,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff8579fa-57dc-4d0e-8d74-1e21d66ffac1_photo.jpg",
      averageRating=4.6, totalRatingsCount=289,
      createdAt="2026-08-31T15:12:47.189090Z", updatedAt="2026-08-31T15:12:47.189090Z",
    ),
    ClubDto(
      id="e5562798-34db-47ad-8ff5-02ad632ddca5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BFA Arena", address="D. Gerbutavičiaus g. 9, 04320 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6943607, longitude=25.209005,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7ceb573a-e2c2-44c1-a661-07a3ea2fee48_ChIJNRCe7piT_0.jpg",
      averageRating=4.5, totalRatingsCount=470,
      createdAt="2026-08-30T23:33:55.611220Z", updatedAt="2026-08-31T08:25:16.016642Z",
    ),
    ClubDto(
      id="1e3923de-d020-488f-bcf0-38c0683ee98c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mostai | Padelio klubas", address="Savanorių pr. 178B, 03154 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6507768, longitude=25.2200044,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/69f72250-a85c-4f21-a8c7-18f080e6d35b_ChIJU1tPjgST_0.jpg",
      averageRating=4.5, totalRatingsCount=89,
      createdAt="2026-08-30T23:35:47.623019Z", updatedAt="2026-09-01T14:31:43.979597Z",
    ),
    ClubDto(
      id="e845099f-309d-4d84-bb70-16cf25b5240f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AMERIGO boulingo ir biliardo klubas", address="Viršuliškių Skg. 28, 05132 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.702228, longitude=25.2126725,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1e9a94e0-264b-4c12-b2da-af26f12ca2eb_ChIJT-YRT9mT_0.jpg",
      averageRating=4.4, totalRatingsCount=1811,
      createdAt="2026-08-30T23:34:16.429375Z", updatedAt="2026-08-31T08:24:39.274274Z",
    ),
    ClubDto(
      id="c34d1951-48d7-4f02-8c41-b2da3fef924e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dažasvydis Vilniuje I Dažasvydžio centras", address="Vanaginės sodų 1-oji g., Visoriai, 08449 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.7715667, longitude=25.2516331,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e61dfb87-433b-4f75-856a-4b3184baaa2d_ChIJte0nVlmQ_0.jpg",
      averageRating=4.4, totalRatingsCount=235,
      createdAt="2026-08-30T23:35:12.181702Z", updatedAt="2026-08-31T08:27:17.169258Z",
    ),
    ClubDto(
      id="53c30c1a-5ef3-403c-b916-f840d3dc2a8e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="O'Learys Vilnius", address="Ozo g. 25, 08217 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.7104547, longitude=25.264696,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7d573be9-de71-4696-85f1-d59f6a475420_ChIJycanBI6R_0.jpg",
      averageRating=4.0, totalRatingsCount=1130,
      createdAt="2026-08-30T23:34:23.253621Z", updatedAt="2026-08-31T08:33:21.651543Z",
    ),
    ClubDto(
      id="d1f4aeac-168f-4304-87a7-5733314d2e20", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="NBA krepšinio aikštelė", address="Čiobiškio g. 1, 07179 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.7150188, longitude=25.2372315,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/58341312-3b57-46cb-8f8f-755f530ad172_photo.jpg",
      averageRating=4.5, totalRatingsCount=35,
      createdAt="2026-08-31T15:12:13.840342Z", updatedAt="2026-08-31T15:12:13.840342Z",
    ),
    ClubDto(
      id="fce31851-4d93-4776-929c-7427bb77581d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Capital Table Tennis Club", address="Žirmūnų g. 106, 09123 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.7259719, longitude=25.2984328,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/deab323c-b38a-4017-a2cf-72041cf311ae_photo.jpg",
      averageRating=4.7, totalRatingsCount=29,
      createdAt="2026-08-31T15:13:04.182518Z", updatedAt="2026-08-31T15:13:04.182518Z",
    ),
    ClubDto(
      id="4376cb2b-d247-47bd-8ef3-08c6cd548259", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fanų padelio arena", address="Plungės g. 4, 02300 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6601715, longitude=25.1459244,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e368bde0-9df8-4508-a345-7c463402502c_ChIJ3XehUwCT_0.jpg",
      averageRating=4.5, totalRatingsCount=25,
      createdAt="2026-08-30T23:35:18.994157Z", updatedAt="2026-08-30T23:35:18.994157Z",
    ),
    ClubDto(
      id="948a67d2-ddf8-40df-8da0-f0ec36a2ac63", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Factory arena", address="Savanorių pr. 180, 03154 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6478727, longitude=25.214155,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/716f7d96-1767-4c80-8196-240767349948_ChIJIT5wdtOT_0.jpg",
      averageRating=4.3, totalRatingsCount=22,
      createdAt="2026-08-30T23:35:26.683006Z", updatedAt="2026-08-31T08:33:45.548083Z",
    ),
    ClubDto(
      id="32045a4f-8c27-49f6-8edf-871491a078f7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aerottoria Arena", address="Dariaus ir Girėno g. 38A, Vilnius, 02189 Vilniaus m. sav.",
      city="Vilnius", country="LT",
      latitude=54.6496076, longitude=25.2728147,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d0ef97d-359a-45cf-955e-1885fc53b1d4_photo.jpg",
      averageRating=4.6, totalRatingsCount=13,
      createdAt="2026-08-31T15:11:57.903907Z", updatedAt="2026-08-31T15:11:57.903907Z",
    ),
    ClubDto(
      id="678914e4-b9c9-49af-9959-569b31b153a2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="White bridge beach volleyball courts", address="Upės g. 6, 09309 Vilnius",
      city="Vilnius", country="LT",
      latitude=54.6926501, longitude=25.275858,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2e541700-b541-4b39-9810-fe9ac6a017ca_photo.jpg",
      averageRating=4.8, totalRatingsCount=9,
      createdAt="2026-08-31T15:12:37.036394Z", updatedAt="2026-08-31T15:12:37.036394Z",
    ),
  )),
  CitySeo(slug="london", name="London", country="GB", clubCount=29, sports=listOf(Pair("Volleyball", 5), Pair("Football", 4), Pair("Tennis", 3), Pair("Padel", 3), Pair("Laser Tag", 2), Pair("Paintball", 2), Pair("Climbing", 2), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Table Tennis", 1), Pair("Karting", 1), Pair("Golf", 1), Pair("Basketball", 1)), clubs=listOf(
    ClubDto(
      id="0564a422-1413-4379-bf15-2da18690bc87", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Activate Oxford Street", address="536-540 Oxford St, London W1C 1LS",
      city="London", country="GB",
      latitude=51.513664, longitude=-0.1572113,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/885f5343-db64-4c52-971e-177e55a1a4b3_ChIJhYZ3RzUF_0.jpg",
      averageRating=5.0, totalRatingsCount=3738,
      createdAt="2026-08-30T23:13:18.318823Z", updatedAt="2026-08-31T08:24:44.056522Z",
    ),
    ClubDto(
      id="9436f797-7873-477c-8933-b1f6a6abfa6e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Apex Table Tennis", address="Aneurin Bevan House, 89-91 Commercial Rd, London E1 1RD",
      city="London", country="GB",
      latitude=51.515031, longitude=-0.0646045,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/10a7bfcb-6575-4aea-872f-d74d60db3941_photo.jpg",
      averageRating=5.0, totalRatingsCount=61,
      createdAt="2026-08-31T14:58:30.756245Z", updatedAt="2026-08-31T14:58:30.756245Z",
    ),
    ClubDto(
      id="96b7c41f-788d-414b-bc8f-62364469edc7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PlayFit Sports Club", address="Ursuline High School, The Downs, London SW20 8HF",
      city="London", country="GB",
      latitude=51.4146423, longitude=-0.2222377,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6cfd1bea-dcd7-4c8d-8ab2-027494b00b25_photo.jpg",
      averageRating=5.0, totalRatingsCount=71,
      createdAt="2026-08-31T14:57:56.144414Z", updatedAt="2026-08-31T22:11:20.695087Z",
    ),
    ClubDto(
      id="8a33c485-3a79-449b-a519-814312fefef1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Alpha Guns London (Camden)", address="84 Camden High St, London NW1 0LT",
      city="London", country="GB",
      latitude=51.5368303, longitude=-0.1405492,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a6641117-961f-4eef-b6fd-5be190b4aac4_ChIJHZ9O5B8b_1.jpg",
      averageRating=4.9, totalRatingsCount=1956,
      createdAt="2026-08-30T23:13:31.498140Z", updatedAt="2026-08-31T22:11:13.482262Z",
    ),
    ClubDto(
      id="b4235c62-d44a-4bd4-93f3-49cde8abd28d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportas", address="68 Hanbury St, London E1 5JL",
      city="London", country="GB",
      latitude=51.5200292, longitude=-0.0703168,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c55ce3e8-2701-47a9-bf69-8c6e9cff442e_photo.jpg",
      averageRating=4.9, totalRatingsCount=88,
      createdAt="2026-08-31T14:57:48.145263Z", updatedAt="2026-08-31T14:57:48.145263Z",
    ),
    ClubDto(
      id="1a53e5bc-fc68-4f0e-bc72-da38207ae050", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="All England Lawn Tennis & Croquet Club", address="Church Rd, London SW19 5AG",
      city="London", country="GB",
      latitude=51.4335559, longitude=-0.2153267,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/80eec44a-89e4-493f-83d1-d326b48b03ea_ChIJhfRDWzQP_0.jpg",
      averageRating=4.8, totalRatingsCount=11076,
      createdAt="2026-08-30T23:14:02.579494Z", updatedAt="2026-08-30T23:14:02.579494Z",
    ),
    ClubDto(
      id="0067b6dd-288a-406a-b48e-4469863133ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padium Canary Wharf", address="10 Bank St, Canary Wharf Estate, London E14 4DE",
      city="London", country="GB",
      latitude=51.5034279, longitude=-0.0233325,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b94f6154-3bee-479a-958f-7daa2800da73_ChIJTVUb9scC_0.jpg",
      averageRating=4.8, totalRatingsCount=833,
      createdAt="2026-08-30T23:13:43.629727Z", updatedAt="2026-09-01T14:31:51.057315Z",
    ),
    ClubDto(
      id="9e415784-ba0f-43ff-bc33-4a23179268c5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Barn Elms Beach Volleyball", address="Queen Elizabeth Walk, London SW13 0DG",
      city="London", country="GB",
      latitude=51.4754201, longitude=-0.2312717,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c1d6bdee-396a-4d4b-a13a-c0ca012620ab_photo.jpg",
      averageRating=4.7, totalRatingsCount=58,
      createdAt="2026-08-31T14:58:18.039640Z", updatedAt="2026-08-31T14:58:18.039640Z",
    ),
    ClubDto(
      id="0930da82-389b-45a4-8143-4fa5b9feaec3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stratford Padel Club", address="221 High St, London E15 2AE",
      city="London", country="GB",
      latitude=51.5345938, longitude=-0.0056932,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0d1d9b6-1b73-4e5c-aeba-e740d14ce6b7_ChIJxwqiKNYd_0.jpg",
      averageRating=4.7, totalRatingsCount=359,
      createdAt="2026-08-30T23:13:49.558337Z", updatedAt="2026-08-31T08:37:01.531998Z",
    ),
    ClubDto(
      id="06f0078d-0aee-4c59-b1c7-c8a8adffa034", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Castle Climbing Centre", address="Green Lanes, London N4 2HA",
      city="London", country="GB",
      latitude=51.5653079, longitude=-0.0925618,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d042a2f1-1e2e-4e58-a3ac-f6b4ce87e8aa_ChIJLyu983gc_0.jpg",
      averageRating=4.7, totalRatingsCount=3810,
      createdAt="2026-08-30T23:12:52.793491Z", updatedAt="2026-08-31T08:37:53.706980Z",
    ),
    ClubDto(
      id="6ea9bf71-320c-4aaa-ae43-302e95520eaa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climbing District | Bermondsey — Arch Climbing Wall", address="Tower Bridge Business, Drummond Rd, London SE16 4DG",
      city="London", country="GB",
      latitude=51.493443, longitude=-0.0608684,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/18631fbd-51c2-42dd-b9ad-65ef5cac6f87_ChIJOX7BxhcD_0.jpg",
      averageRating=4.6, totalRatingsCount=1565,
      createdAt="2026-08-30T23:12:58.952532Z", updatedAt="2026-08-31T08:26:58.495233Z",
    ),
    ClubDto(
      id="5577c2df-d5ec-48d4-980f-fa794c1e3980", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GO Paintball London & Laser Tag London Office", address="22 Upper Ground, London SE1 9PD",
      city="London", country="GB",
      latitude=51.5080972, longitude=-0.1074418,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6a226f88-5bb9-4796-96fc-b79236c9507a_ChIJVUuxmT4F_0.jpg",
      averageRating=4.6, totalRatingsCount=80,
      createdAt="2026-08-30T23:13:37.615499Z", updatedAt="2026-08-31T08:28:23.076857Z",
    ),
    ClubDto(
      id="687fd186-9cf5-4985-a82d-6bd05d2ba3c9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paddington Recreation Ground", address="Randolph Ave., London W9 1PF",
      city="London", country="GB",
      latitude=51.5301947, longitude=-0.1907844,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0394e8de-a8bf-42d2-94e8-22395633a1fe_ChIJYXZohAkQ_1.jpg",
      averageRating=4.6, totalRatingsCount=2445,
      createdAt="2026-08-30T23:12:01.023845Z", updatedAt="2026-08-31T22:11:19.378597Z",
    ),
    ClubDto(
      id="8a8fcd55-82c1-4d17-8f82-9ab145c55817", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Queen’s Club", address="Palliser Rd, London W14 9EQ",
      city="London", country="GB",
      latitude=51.4868794, longitude=-0.2122196,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a80ff5cb-485e-4e90-9eaa-2c28fb9200b6_ChIJ8Vo785QP_0.jpg",
      averageRating=4.6, totalRatingsCount=1129,
      createdAt="2026-08-30T23:14:08.886200Z", updatedAt="2026-08-31T08:34:57.771723Z",
    ),
    ClubDto(
      id="1f5699b6-e041-4aa0-8bdc-125824699b14", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Crystal Maze LIVE Experience", address="22 - 32 Shaftesbury Ave, London W1D 7EU",
      city="London", country="GB",
      latitude=51.5109186, longitude=-0.133551,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3b9874e7-35d0-4471-a6fb-9892a25201a6_ChIJjzKeFKcF_1.jpg",
      averageRating=4.6, totalRatingsCount=3309,
      createdAt="2026-08-30T23:13:24.828966Z", updatedAt="2026-08-31T22:11:22.913453Z",
    ),
    ClubDto(
      id="06e80eb7-6dbd-49ec-91d2-ecac3f8639ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Hurlingham Club", address="Ranelagh Gardens, London SW6 3PR",
      city="London", country="GB",
      latitude=51.4674121, longitude=-0.2049416,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3cdb4bef-a0ff-432f-8c01-5dfa5cc86c83_ChIJzU_uinMP_0.jpg",
      averageRating=4.6, totalRatingsCount=832,
      createdAt="2026-08-30T23:14:15.231291Z", updatedAt="2026-08-31T08:37:54.910343Z",
    ),
    ClubDto(
      id="86edbb9d-9b69-416e-9906-e90679d8d16d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Spots & Stripes Pool Club", address="64 Ewer St, London SE1 0NR",
      city="London", country="GB",
      latitude=51.5039579, longitude=-0.100669,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1520b1d9-a6f4-4ce6-bce7-acadfa7deb4f_ChIJA2W98KUE_0.jpg",
      averageRating=4.5, totalRatingsCount=445,
      createdAt="2026-08-30T23:12:27.197440Z", updatedAt="2026-08-30T23:12:27.197440Z",
    ),
    ClubDto(
      id="5a9f3cc3-3c0c-428c-95db-537a040d4ce6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hackney Marshes Centre", address="Homerton Rd, London E9 5PF",
      city="London", country="GB",
      latitude=51.5532444, longitude=-0.025582,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6de5d33a-af1a-4615-89e9-5799c31fbf68_ChIJBecZ0gkd_0.jpg",
      averageRating=4.4, totalRatingsCount=1035,
      createdAt="2026-08-30T23:12:08.148853Z", updatedAt="2026-08-31T08:28:56.400332Z",
    ),
    ClubDto(
      id="c2b7fd60-1585-45e3-b31b-0bc81b942c03", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Regal & Jordan Court", address="Beaufoy Walk, London SE11 6AA",
      city="London", country="GB",
      latitude=51.491348, longitude=-0.115375,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b3122d91-d2c6-40e1-99bb-794030d70d38_photo.jpg",
      averageRating=4.4, totalRatingsCount=128,
      createdAt="2026-08-31T14:57:39.281537Z", updatedAt="2026-08-31T14:57:39.281537Z",
    ),
    ClubDto(
      id="feb53adf-cc4f-4ebe-8904-55b6b37cac11", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Somers Town Community Sports Centre", address="134 Chalton St, London NW1 1RX",
      city="London", country="GB",
      latitude=51.5328712, longitude=-0.1330869,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1f118631-91b9-4078-82cc-2742747145a3_photo.jpg",
      averageRating=4.4, totalRatingsCount=167,
      createdAt="2026-08-31T14:58:02.528207Z", updatedAt="2026-08-31T14:58:02.528207Z",
    ),
    ClubDto(
      id="955c5ca8-c252-40c2-a444-6d3d0082d365", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Padel Yard - G4P", address="2 Armoury Way, London SW18 1SH",
      city="London", country="GB",
      latitude=51.459012, longitude=-0.1923357,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0136915-e62d-4569-ab5d-d81f51b3612c_ChIJSz0eWdUP_0.jpg",
      averageRating=4.4, totalRatingsCount=238,
      createdAt="2026-08-30T23:13:55.675673Z", updatedAt="2026-08-30T23:13:55.675673Z",
    ),
    ClubDto(
      id="cd04d60d-b432-45fd-ad60-e331ac12d5fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hurricane Room Colindale", address="287 Edgware Rd, London NW9 6NB",
      city="London", country="GB",
      latitude=51.5893778, longitude=-0.2539344,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc878ec0-cc22-4097-8153-553881e084ec_ChIJzTBwTDcR_0.jpg",
      averageRating=4.3, totalRatingsCount=424,
      createdAt="2026-08-30T23:12:33.160910Z", updatedAt="2026-08-30T23:12:33.160910Z",
    ),
    ClubDto(
      id="3de8c3da-fcf3-496b-b39a-eb376126afb1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Powerleague Shoreditch", address="Braithwaite Street Opposite Shoreditch High Street, Station, London E1 6GJ",
      city="London", country="GB",
      latitude=51.5232676, longitude=-0.074279,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/17b1f657-1ccf-4dd6-8759-88af5381758b_ChIJYUZEGLcc_0.jpg",
      averageRating=4.2, totalRatingsCount=596,
      createdAt="2026-08-30T23:12:15.098727Z", updatedAt="2026-08-31T08:34:52.249507Z",
    ),
    ClubDto(
      id="0f0f4b66-8f91-4bca-9340-59db9f3929ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenpin Acton", address="Royale Leisure Park, Western Ave, London W3 0PA",
      city="London", country="GB",
      latitude=51.5247845, longitude=-0.2809679,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/993ba0fc-f0dd-4b42-9d43-766ed779efc9_ChIJs-XR9fcR_0.jpg",
      averageRating=4.2, totalRatingsCount=5034,
      createdAt="2026-08-30T23:12:39.307860Z", updatedAt="2026-08-31T08:37:50.023638Z",
    ),
    ClubDto(
      id="e3d8824d-100b-4ffd-90e7-8a203bfed92e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gravity MAX Wandsworth", address="Wandsworth High St, London SW18 4TF",
      city="London", country="GB",
      latitude=51.4560633, longitude=-0.1934238,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d5cd6952-2e79-4dd8-9d6c-5aaf31e3fc06_ChIJexjwO1cP_0.jpg",
      averageRating=4.1, totalRatingsCount=3374,
      createdAt="2026-08-30T23:13:11.474607Z", updatedAt="2026-08-31T08:28:43.424758Z",
    ),
    ClubDto(
      id="90a9eb6c-3971-428a-b996-b25ff9dfc273", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Greenwich Peninsula Golf Range - JUST GOLF", address="265 Tunnel Ave, London SE10 0QE",
      city="London", country="GB",
      latitude=51.498, longitude=3.0E-4,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/51cdc045-1dd1-4bad-affa-dbade6bec024_photo.jpg",
      averageRating=4.1, totalRatingsCount=3218,
      createdAt="2026-08-31T14:58:24.934108Z", updatedAt="2026-08-31T14:58:24.934108Z",
    ),
    ClubDto(
      id="d77d956a-c01b-4b22-ac77-e013d63d0981", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hollywood Bowl Finchley", address="Leisure Wy, High Rd, London N12 0GL",
      city="London", country="GB",
      latitude=51.6038916, longitude=-0.1727031,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4c81948f-b9a6-413e-83a5-d8b0f84d11e3_ChIJx8nXKPEZ_0.jpg",
      averageRating=4.0, totalRatingsCount=4695,
      createdAt="2026-08-30T23:12:45.313100Z", updatedAt="2026-08-31T08:29:02.037479Z",
    ),
    ClubDto(
      id="7da5b7b8-57e4-46a3-aa5c-bf0a5034ee76", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PlayFootball Mile End", address="Mile End Park Leisure Centre, Rhodeswell Rd, London E3 4HL",
      city="London", country="GB",
      latitude=51.5194385, longitude=-0.032457,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a75076bf-cd3a-40ef-81d7-de9600136858_ChIJVb8isDMd_0.jpg",
      averageRating=4.0, totalRatingsCount=525,
      createdAt="2026-08-30T23:12:21.469906Z", updatedAt="2026-08-31T08:34:45.549661Z",
    ),
    ClubDto(
      id="5ae01ffe-b1bc-4146-9266-cdd09bf0a629", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Shoreditch Park Beach Volleyball Court", address="London N1 5EF",
      city="London", country="GB",
      latitude=51.5337273, longitude=-0.0857231,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/74917308-f4f7-4f69-8301-afccd1296f31_photo.jpg",
      averageRating=4.1, totalRatingsCount=7,
      createdAt="2026-08-31T14:58:09.662949Z", updatedAt="2026-08-31T14:58:09.662949Z",
    ),
  )),
  CitySeo(slug="cologne", name="Cologne", country="DE", clubCount=29, sports=listOf(Pair("Tennis", 4), Pair("Football", 4), Pair("Basketball", 3), Pair("Volleyball", 3), Pair("Karting", 2), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Table Tennis", 2), Pair("Bowling", 2), Pair("Paintball", 1), Pair("Laser Tag", 1), Pair("Padel", 1)), clubs=listOf(
    ClubDto(
      id="c1c3024d-bc52-4542-8fbd-1c1127bcd874", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach volleyball court IGS Holweide", address="Burgwiesenstraße 125, 51067 Köln-Mülheim",
      city="Cologne", country="DE",
      latitude=50.9613475, longitude=7.0378338,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd796158-0b94-4d6c-af98-77db421f3806_photo.jpg",
      averageRating=4.8, totalRatingsCount=102,
      createdAt="2026-08-31T22:50:12.913329Z", updatedAt="2026-08-31T22:50:12.913329Z",
    ),
    ClubDto(
      id="2705521d-1fd0-4217-a88d-232668826b25", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LaserTag Köln", address="Wilhelm-Mauser-Straße 14-16, 50827 Köln-Ehrenfeld",
      city="Cologne", country="DE",
      latitude=50.9580061, longitude=6.8956751,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/933940be-b4e1-442a-8cd6-b947a6c2bdee_photo.jpg",
      averageRating=4.8, totalRatingsCount=1800,
      createdAt="2026-08-31T22:51:36.906569Z", updatedAt="2026-08-31T22:51:36.906569Z",
    ),
    ClubDto(
      id="a2cf8359-ecc0-4412-b0d4-bf8f0057bc01", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Soccer Arena Köln", address="Stallagsbergweg 2, 50769 Köln-Chorweiler",
      city="Cologne", country="DE",
      latitude=51.0193876, longitude=6.919091,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e0b5f2b-3e11-4ce0-abb1-073c93ea07d7_photo.jpg",
      averageRating=4.8, totalRatingsCount=264,
      createdAt="2026-08-31T22:49:16.933929Z", updatedAt="2026-08-31T22:49:16.933929Z",
    ),
    ClubDto(
      id="b13aca1a-d7f9-4c03-be70-765d42216121", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BattleKart Köln", address="Butzweilerstraße 35-39, 50829 Köln",
      city="Cologne", country="DE",
      latitude=50.9817024, longitude=6.9001148,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7438dbf6-4918-48a8-ba32-e9179284f15f_photo.jpg",
      averageRating=4.7, totalRatingsCount=1032,
      createdAt="2026-08-31T22:50:46.725305Z", updatedAt="2026-08-31T22:50:46.725305Z",
    ),
    ClubDto(
      id="bd753b8c-8872-4143-8050-d6c163a738e7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf City Cologne Pulheim", address="Am Golfpl. 1, 50259 Pulheim",
      city="Cologne", country="DE",
      latitude=50.9405222, longitude=6.8041381,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c8139c2a-3d82-4e0a-a186-df0052e1d193_photo.jpg",
      averageRating=4.7, totalRatingsCount=1836,
      createdAt="2026-08-31T22:50:22.084733Z", updatedAt="2026-08-31T22:50:22.084733Z",
    ),
    ClubDto(
      id="021f050f-261f-4cf5-ae2a-94a487f04a3b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UniSport² Köln", address="Zülpicher Wall 1, 50674 Köln",
      city="Cologne", country="DE",
      latitude=50.9284292, longitude=6.9336193,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11a4086c-17a5-4208-aa6d-99ee5964351c_photo.jpg",
      averageRating=4.7, totalRatingsCount=237,
      createdAt="2026-08-31T22:49:21.269803Z", updatedAt="2026-08-31T22:49:21.269803Z",
    ),
    ClubDto(
      id="6abce5d1-539f-4c4c-b7cf-411ccc346d7e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketball Campus Köln powered by Flossbach von Storch", address="Wilhelm-Mauser-Straße 57, 50827 Köln-Ehrenfeld",
      city="Cologne", country="DE",
      latitude=50.9552536, longitude=6.8915119,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0c46df8a-f71f-4297-9a8b-baf8a57629d2_photo.jpg",
      averageRating=4.6, totalRatingsCount=99,
      createdAt="2026-08-31T22:49:53.909766Z", updatedAt="2026-08-31T22:49:53.909766Z",
    ),
    ClubDto(
      id="d98913f1-0a30-453d-8c58-0e78b51eac10", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boulderplanet | Boulder- Trainingsanlage & Bistro-Café", address="Oskar-Jäger-Straße 143H, 50825 Köln-Ehrenfeld",
      city="Cologne", country="DE",
      latitude=50.9449197, longitude=6.9050805,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e6627764-619c-4991-b61a-5ec45fb7c964_photo.jpg",
      averageRating=4.6, totalRatingsCount=1213,
      createdAt="2026-08-31T22:51:05.311480Z", updatedAt="2026-08-31T22:51:05.311480Z",
    ),
    ClubDto(
      id="f052e808-5f0a-43ba-bfbd-8fa562064853", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fun+Sport Arena Köln", address="Neusser Str. 222, 50733 Köln",
      city="Cologne", country="DE",
      latitude=50.9620694, longitude=6.9544847,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a7adb188-826c-488e-8880-81bd7312f557_photo.jpg",
      averageRating=4.6, totalRatingsCount=277,
      createdAt="2026-08-31T22:49:10.329609Z", updatedAt="2026-08-31T22:49:10.329609Z",
    ),
    ClubDto(
      id="80e5c6d7-ff3e-4ea2-8054-3fe9d20b62f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Racket Arena Rhein-Erft", address="Zum Hubertusbusch, 50171 Kerpen",
      city="Cologne", country="DE",
      latitude=50.8718735, longitude=6.6777996,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/daa5cf83-9a2c-40a9-b748-092481a284fe_photo.jpg",
      averageRating=4.6, totalRatingsCount=269,
      createdAt="2026-08-31T22:49:48.751135Z", updatedAt="2026-09-01T14:31:48.982331Z",
    ),
    ClubDto(
      id="8535db46-2311-4813-837a-dbea3adfe029", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Adrenalinpark Köln", address="Bergisch Gladbacher Str. 1025, 51069 Köln",
      city="Cologne", country="DE",
      latitude=50.9808671, longitude=7.0730506,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/df46d388-861e-4228-b0f6-7e38144c152e_photo.jpg",
      averageRating=4.5, totalRatingsCount=1024,
      createdAt="2026-08-31T22:51:43.815336Z", updatedAt="2026-08-31T22:51:43.815336Z",
    ),
    ClubDto(
      id="5bd21a72-366c-4704-9714-c7a81f89e5fb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cologne Cue Club", address="Barbarastraße 3-9, 50735 Köln",
      city="Cologne", country="DE",
      latitude=50.9699652, longitude=6.9726561,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eca4b097-da5e-4e3d-96d1-fec62913ace5_photo.jpg",
      averageRating=4.5, totalRatingsCount=431,
      createdAt="2026-08-31T22:51:32.961481Z", updatedAt="2026-08-31T22:51:32.961481Z",
    ),
    ClubDto(
      id="119ad573-32b1-401e-9631-402fa3aebb10", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kletterfabrik Köln", address="Oskar-Jäger-Straße 173, 50825 Köln-Ehrenfeld",
      city="Cologne", country="DE",
      latitude=50.9472196, longitude=6.9068888,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7d392c3c-0529-4c6a-9677-250cc80c67c5_photo.jpg",
      averageRating=4.5, totalRatingsCount=849,
      createdAt="2026-08-31T22:51:21.353121Z", updatedAt="2026-08-31T22:51:21.353121Z",
    ),
    ClubDto(
      id="4b159017-663e-42f5-9236-885ef7e36e78", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="pin-up Bornheim", address="Johann-Philipp-Reis-Straße 7, 53332 Bornheim",
      city="Cologne", country="DE",
      latitude=50.7587484, longitude=7.0217433,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2fdeb2c0-efdf-40ae-9193-02256970319a_photo.jpg",
      averageRating=4.5, totalRatingsCount=2462,
      createdAt="2026-08-31T22:50:51.169448Z", updatedAt="2026-08-31T22:50:51.169448Z",
    ),
    ClubDto(
      id="10a9ae46-2dc0-465a-a94b-67210d428031", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cologne hockey and tennis club Blau Weiss", address="Neuenhöfer Allee 69, 50935 Köln-Lindenthal",
      city="Cologne", country="DE",
      latitude=50.914299, longitude=6.9139537,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4259523-1c0a-4214-b1e9-1679d528e4b9_photo.jpg",
      averageRating=4.4, totalRatingsCount=140,
      createdAt="2026-08-31T22:49:33.419221Z", updatedAt="2026-09-01T14:31:56.072954Z",
    ),
    ClubDto(
      id="8fd7e985-1dc1-438c-a6cd-b6541bf886ea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kartcenter Cologne", address="Kelvinstraße 5-7, 50996 Köln-Rodenkirchen",
      city="Cologne", country="DE",
      latitude=50.8707962, longitude=6.9878039,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a7db4db0-74f9-4747-9e08-a1362e69950a_photo.jpg",
      averageRating=4.4, totalRatingsCount=2077,
      createdAt="2026-08-31T22:50:41.722640Z", updatedAt="2026-08-31T22:50:41.722640Z",
    ),
    ClubDto(
      id="799eb47e-ff0f-4b9d-8836-7d6d592a3481", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kölner Golfclub", address="Freimersdorfer Weg 43, 50859 Köln-Lindenthal",
      city="Cologne", country="DE",
      latitude=50.9656195, longitude=6.8488728,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/42c34ca1-d836-4d4f-9be5-762fd3a58fce_photo.jpg",
      averageRating=4.4, totalRatingsCount=857,
      createdAt="2026-08-31T22:50:26.772109Z", updatedAt="2026-08-31T22:50:26.772109Z",
    ),
    ClubDto(
      id="daac4e13-7049-44db-9d24-c884c36e2e8c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kölner Klub für Hockey- und Tennissport \"Schwarz-Weiß\" 1920 e.V.", address="Kuhweg 20, 50735 Köln-Nippes",
      city="Cologne", country="DE",
      latitude=50.9686538, longitude=6.9911492,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6179b641-beac-4f89-a804-c8c7dd9a8155_photo.jpg",
      averageRating=4.4, totalRatingsCount=180,
      createdAt="2026-08-31T22:49:25.852163Z", updatedAt="2026-08-31T22:49:25.852163Z",
    ),
    ClubDto(
      id="abe8e0a6-e563-4b21-9537-69ccaed21409", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis - Club Weiden | Tennis & Padel", address="Kronstädter Str. 100, 50859 Köln-Lindenthal",
      city="Cologne", country="DE",
      latitude=50.9286898, longitude=6.83906,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/92c5b951-d716-492c-bfef-31d905eaafac_photo.jpg",
      averageRating=4.4, totalRatingsCount=86,
      createdAt="2026-08-31T22:49:44.422554Z", updatedAt="2026-09-01T14:31:59.459026Z",
    ),
    ClubDto(
      id="7d6f6c0f-1ca3-4743-b859-114294fde6fc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billard Cafe Schneider", address="Kaiser-Wilhelm-Ring 30-32, 50672 Köln",
      city="Cologne", country="DE",
      latitude=50.9438211, longitude=6.9422335,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fcfe240c-61d4-4bfe-8a61-a0f89e7d38a9_photo.jpg",
      averageRating=4.3, totalRatingsCount=474,
      createdAt="2026-08-31T22:51:27.681443Z", updatedAt="2026-08-31T22:51:27.681443Z",
    ),
    ClubDto(
      id="9e642d95-6b46-408e-bf04-605d5a499e8b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kautz Sportcenter", address="Rhöndorfer str 10-13, 50939 Köln-Lindenthal",
      city="Cologne", country="DE",
      latitude=50.9166297, longitude=6.9346981,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e514cd37-845e-4140-9b81-ae6fdec227a9_photo.jpg",
      averageRating=4.2, totalRatingsCount=714,
      createdAt="2026-08-31T22:49:05.328080Z", updatedAt="2026-08-31T22:49:05.328080Z",
    ),
    ClubDto(
      id="cdca7194-e8bd-480f-86be-290c322b2683", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Playa in Cologne", address="Junkersdorfer Str. 1, 50933 Köln",
      city="Cologne", country="DE",
      latitude=50.9325255, longitude=6.8730352,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/34eba3cf-82e9-4c8b-a0d1-3872335d3f1b_photo.jpg",
      averageRating=4.2, totalRatingsCount=1336,
      createdAt="2026-08-31T22:50:08.453214Z", updatedAt="2026-08-31T22:50:08.453214Z",
    ),
    ClubDto(
      id="e7a5b37c-0c07-4032-9860-369ee8a2f219", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SV Henk Brinkmann", address="Piccoloministraße 393, 51067 Köln-Mülheim",
      city="Cologne", country="DE",
      latitude=50.9714431, longitude=7.0436296,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/58e1aefd-f963-429d-bf39-253baa62d4a2_photo.jpg",
      averageRating=4.2, totalRatingsCount=51,
      createdAt="2026-08-31T22:49:57.933509Z", updatedAt="2026-08-31T22:49:57.933509Z",
    ),
    ClubDto(
      id="f9af2e6d-6d35-4b75-9b6f-3d2fd5f171d4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="West Bowling Köln", address="Melatengürtel 21, 50933 Köln-Lindenthal",
      city="Cologne", country="DE",
      latitude=50.939426, longitude=6.910121,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e944d2c7-7851-484a-aa73-b6de6919d24f_photo.jpg",
      averageRating=4.0, totalRatingsCount=2396,
      createdAt="2026-08-31T22:50:58.577756Z", updatedAt="2026-08-31T22:50:58.577756Z",
    ),
    ClubDto(
      id="dd7822d6-d8dc-48f5-9259-ffb6c92fc90e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gastro DTC & Decksteiner Tennis-Club", address="Bachemer Landstraße 355, 50935 Köln",
      city="Cologne", country="DE",
      latitude=50.920958, longitude=6.889869,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/724eb1ba-b204-4f1e-bc95-c75513e3144c_photo.jpg",
      averageRating=3.9, totalRatingsCount=92,
      createdAt="2026-08-31T22:49:39.504896Z", updatedAt="2026-08-31T22:49:39.504896Z",
    ),
    ClubDto(
      id="7198017e-8fa8-47ec-9e14-e600408647cb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolleyballfelder Brühl", address="Bonnstraße 200D, 50321 Brühl",
      city="Cologne", country="DE",
      latitude=50.8157356, longitude=6.9045251,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/da330a8e-a662-4dde-ac54-1fdbab4e52c6_photo.jpg",
      averageRating=4.9, totalRatingsCount=38,
      createdAt="2026-08-31T22:50:17.679857Z", updatedAt="2026-08-31T22:50:17.679857Z",
    ),
    ClubDto(
      id="68a91b1c-18a6-4c51-acdf-d36aef5ef80a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tischtennis Schule Cologne", address="Am Grott 11, 51147 Köln",
      city="Cologne", country="DE",
      latitude=50.8428814, longitude=7.1094806,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b3e6c764-e5af-491e-8b21-dbe2cdd51db2_photo.jpg",
      averageRating=4.9, totalRatingsCount=32,
      createdAt="2026-08-31T22:50:33.822085Z", updatedAt="2026-08-31T22:50:33.822085Z",
    ),
    ClubDto(
      id="2a0bb844-96a5-44d6-b904-08d4686e062c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ballplatz am Klingelpütz", address="Köln-Altstadt-Nord, 50670 Cologne",
      city="Cologne", country="DE",
      latitude=50.9457761, longitude=6.9500697,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5be9f247-3149-417f-aa1b-35b4aa65e893_photo.jpg",
      averageRating=4.3, totalRatingsCount=19,
      createdAt="2026-08-31T22:50:01.234027Z", updatedAt="2026-08-31T22:50:01.234027Z",
    ),
    ClubDto(
      id="0db9717b-4385-4e85-b809-7f1422684e65", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TG Mülheim a. Rhein (Köln) von 1879 e.V. Abteilung Tischtennis", address="Graf-Adolf-Straße 59, 51065 Köln-Mülheim",
      city="Cologne", country="DE",
      latitude=50.9573411, longitude=7.0073034,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/14879071-4fbb-4efa-9f76-0dfe2cd8e231_photo.jpg",
      averageRating=4.6, totalRatingsCount=17,
      createdAt="2026-08-31T22:50:36.832415Z", updatedAt="2026-08-31T22:50:36.832415Z",
    ),
  )),
  CitySeo(slug="chicago", name="Chicago", country="US", clubCount=29, sports=listOf(Pair("Football", 6), Pair("Tennis", 3), Pair("Karting", 2), Pair("Golf", 2), Pair("Laser Tag", 2), Pair("Table Tennis", 2), Pair("Billiards", 2), Pair("Volleyball", 2), Pair("Climbing", 2), Pair("Basketball", 2), Pair("Bowling", 2), Pair("Paintball", 1), Pair("Padel", 1)), clubs=listOf(
    ClubDto(
      id="d150415d-b6cb-41d9-a34e-4a099cff1626", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Battle House Laser Tag - Lake Barrington", address="28039 W Northpointe Pkwy #4, Lake Barrington, IL 60010",
      city="Chicago", country="US",
      latitude=42.1872783, longitude=-88.1805782,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/30195957-2690-4ab6-b2e7-6940e9a473e1_photo.jpg",
      averageRating=4.9, totalRatingsCount=1514,
      createdAt="2026-09-20T19:13:30.385496Z", updatedAt="2026-09-20T19:13:30.385496Z",
    ),
    ClubDto(
      id="abe09bf5-06ad-462e-b414-cb556f48aece", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="First Ascent Arlington Heights", address="701 Rohlwing Rd, Arlington Heights, IL 60005",
      city="Chicago", country="US",
      latitude=42.0906052, longitude=-88.02438,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/02d28966-4f37-48a3-a72a-9a085fc54ae1_photo.jpg",
      averageRating=4.9, totalRatingsCount=550,
      createdAt="2026-09-20T19:13:19.843005Z", updatedAt="2026-09-20T19:13:19.843005Z",
    ),
    ClubDto(
      id="036833dd-1504-4821-bd4d-abe322a7ccfc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="EXACT Sports", address="140 S Dearborn St Ste 310, Chicago, IL 60603",
      city="Chicago", country="US",
      latitude=41.8797985, longitude=-87.6295472,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3690877d-6183-4d11-ba71-1540a4ecf688_photo.jpg",
      averageRating=4.8, totalRatingsCount=439,
      createdAt="2026-09-20T19:12:37.033548Z", updatedAt="2026-09-20T19:12:37.033548Z",
    ),
    ClubDto(
      id="2dbee0df-9afe-49a6-977f-3e6f2930d60f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="First Ascent Avondale", address="3516 N Spaulding Ave, Chicago, IL 60618",
      city="Chicago", country="US",
      latitude=41.9451929, longitude=-87.710382,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9f494b31-239d-499d-8432-59699fee778c_photo.jpg",
      averageRating=4.8, totalRatingsCount=814,
      createdAt="2026-09-20T19:13:16.418042Z", updatedAt="2026-09-20T19:13:16.418042Z",
    ),
    ClubDto(
      id="24ac6267-62bf-4de3-89ec-f3a69ac23fdb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Five Iron Golf", address="609 N Dearborn St, Chicago, IL 60654",
      city="Chicago", country="US",
      latitude=41.8928311, longitude=-87.6294036,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4e1b5ea6-7e9b-4c1c-bc88-43306ca6a750_photo.jpg",
      averageRating=4.8, totalRatingsCount=455,
      createdAt="2026-09-20T19:12:47.374594Z", updatedAt="2026-09-20T19:12:47.374594Z",
    ),
    ClubDto(
      id="f7a13f7f-a0ed-479c-be22-e05dc9b2d56f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paint Pursuit Games", address="2490 Van Dyke Rd, Minooka, IL 60447",
      city="Chicago", country="US",
      latitude=41.538121, longitude=-88.306818,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49a6e31b-ba41-4b0d-9d46-135bcb803829_photo.jpg",
      averageRating=4.8, totalRatingsCount=77,
      createdAt="2026-09-20T19:13:37.285101Z", updatedAt="2026-09-20T19:13:37.285101Z",
    ),
    ClubDto(
      id="e0cae905-3918-46e7-984c-278d33ef426d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fire Pitch", address="3626 N Talman Ave, Chicago, IL 60618",
      city="Chicago", country="US",
      latitude=41.9476147, longitude=-87.6955486,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f48c1f87-50af-470c-968a-4ab2e03ecc1b_photo.jpg",
      averageRating=4.7, totalRatingsCount=579,
      createdAt="2026-09-20T19:12:03.609250Z", updatedAt="2026-09-20T19:12:03.609250Z",
    ),
    ClubDto(
      id="969d1c61-452c-4623-b732-81d9c6598094", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lincoln Park North Avenue Beach South Volleyball Courts", address="1600 N Lake Shore Dr, Chicago, IL 60613",
      city="Chicago", country="US",
      latitude=41.9135653, longitude=-87.6224944,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/934dff38-bb5a-4b9e-a443-3ac52604260d_photo.jpg",
      averageRating=4.7, totalRatingsCount=207,
      createdAt="2026-09-20T19:12:40.697767Z", updatedAt="2026-09-20T19:12:40.697767Z",
    ),
    ClubDto(
      id="91ca9db8-9358-4e0a-88e6-3b10fc5d9aca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Westmont Yard Indoor Sports Complex", address="233 W 63rd St, Westmont, IL 60559",
      city="Chicago", country="US",
      latitude=41.7723462, longitude=-87.98118,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9415de0f-4cfa-44a0-8dcc-533fc0a06ef8_photo.jpg",
      averageRating=4.7, totalRatingsCount=372,
      createdAt="2026-09-20T19:12:07.659391Z", updatedAt="2026-09-20T19:12:07.659391Z",
    ),
    ClubDto(
      id="d499f125-57c7-4d32-9777-0153311335ea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lazer X Laser Tag", address="1455 W Lake St, Addison, IL 60101",
      city="Chicago", country="US",
      latitude=41.9456443, longitude=-88.0246582,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f81ba490-5cb2-41ea-a103-5c189f51223a_photo.jpg",
      averageRating=4.6, totalRatingsCount=355,
      createdAt="2026-09-20T19:13:34.064863Z", updatedAt="2026-09-20T19:13:34.064863Z",
    ),
    ClubDto(
      id="b60924e1-f570-4cc3-9506-7e919b544a29", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lincoln Park North Soccer Field 2", address="Lakefront Trl, Chicago, IL 60640",
      city="Chicago", country="US",
      latitude=41.9756149, longitude=-87.6479387,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c1e197bd-56fa-428e-bb36-532a1d358fdf_photo.jpg",
      averageRating=4.6, totalRatingsCount=300,
      createdAt="2026-09-20T19:12:11.635774Z", updatedAt="2026-09-20T19:12:11.635774Z",
    ),
    ClubDto(
      id="bcf96935-d373-44c5-80b7-b88a141c98e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sofive Soccer Centers La Pershing", address="3900 S Ashland Ave, Chicago, IL 60609",
      city="Chicago", country="US",
      latitude=41.8226457, longitude=-87.666601,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2b6126a1-4db1-4d1e-9861-14cd95b79ae5_photo.jpg",
      averageRating=4.6, totalRatingsCount=160,
      createdAt="2026-09-20T19:13:39.688430Z", updatedAt="2026-09-20T19:13:39.688430Z",
    ),
    ClubDto(
      id="82366ce8-11b1-4702-b3ae-09cd6467ca14", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arrowhead Golf Club", address="26W151 Butterfield Rd, Wheaton, IL 60189",
      city="Chicago", country="US",
      latitude=41.82897, longitude=-88.133915,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5b595c8f-8559-41b1-aee4-6239b5d57246_photo.jpg",
      averageRating=4.5, totalRatingsCount=1379,
      createdAt="2026-09-20T19:12:43.500656Z", updatedAt="2026-09-20T19:12:43.500656Z",
    ),
    ClubDto(
      id="cb035fc3-1a06-47ca-8b06-cbe5149f50ad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Chris's Billiards", address="4637 N Milwaukee Ave, Chicago, IL 60630",
      city="Chicago", country="US",
      latitude=41.9650312, longitude=-87.7580916,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/067bc75f-5643-485a-8c28-7ec833c41040_photo.jpg",
      averageRating=4.5, totalRatingsCount=670,
      createdAt="2026-09-20T19:13:22.286396Z", updatedAt="2026-09-20T19:13:22.286396Z",
    ),
    ClubDto(
      id="e847d696-b517-494a-97b8-44c9554b4b62", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lincoln Park Waveland Tennis Courts", address="3650 N Recreation Dr, Chicago, IL 60613",
      city="Chicago", country="US",
      latitude=41.9502704, longitude=-87.6427484,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/449c79a4-27f4-4686-b5e5-590bbda9be1f_photo.jpg",
      averageRating=4.5, totalRatingsCount=145,
      createdAt="2026-09-20T19:12:23.864322Z", updatedAt="2026-09-20T19:12:23.864322Z",
    ),
    ClubDto(
      id="5a44a00b-3f0b-4790-ad59-e4952c94a5eb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="McCook Athletic & Exposition", address="4750 Vernon Ave, La Grange, IL 60525",
      city="Chicago", country="US",
      latitude=41.804107, longitude=-87.846215,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1310af86-4308-4f3c-83b5-9a77039c88f7_photo.jpg",
      averageRating=4.5, totalRatingsCount=753,
      createdAt="2026-09-20T19:11:59.527382Z", updatedAt="2026-09-20T19:11:59.527382Z",
    ),
    ClubDto(
      id="7ce96e81-dcda-4645-a11f-8fed313d2788", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="McFetridge Sports Center", address="3843 N California Ave, Chicago, IL 60618",
      city="Chicago", country="US",
      latitude=41.9517076, longitude=-87.6970873,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4476af7d-910c-4d56-a5bc-b14940a45179_photo.jpg",
      averageRating=4.5, totalRatingsCount=481,
      createdAt="2026-09-20T19:12:20.548175Z", updatedAt="2026-09-20T19:12:20.548175Z",
    ),
    ClubDto(
      id="e3a185d5-4e61-403f-be5c-f0c26a78380e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SPIN Chicago", address="344 N State St, Chicago, IL 60654",
      city="Chicago", country="US",
      latitude=41.8886781, longitude=-87.6283111,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f3f9383f-9757-4464-95eb-a0194fe7c08f_photo.jpg",
      averageRating=4.5, totalRatingsCount=1150,
      createdAt="2026-09-20T19:12:17.498424Z", updatedAt="2026-09-20T19:12:17.498424Z",
    ),
    ClubDto(
      id="779352e8-b64b-43f5-a6e1-51c97b8493df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Wintrust Sports Complex", address="5499 W 65th St, Bedford Park, IL 60638",
      city="Chicago", country="US",
      latitude=41.7731065, longitude=-87.7588709,
      type="BASKETBALL",
      types=listOf("BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/609030e7-cbfa-4457-9c63-509b3413245f_photo.jpg",
      averageRating=4.5, totalRatingsCount=359,
      createdAt="2026-09-20T19:12:30.613140Z", updatedAt="2026-09-20T19:12:30.613140Z",
    ),
    ClubDto(
      id="1f84c235-32f6-49f3-b6e0-bbb6a7b98d5c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Andretti Indoor Karting & Games Schaumburg", address="1441 Thoreau Dr N, Schaumburg, IL 60173",
      city="Chicago", country="US",
      latitude=42.0617253, longitude=-88.0433275,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dd3f379d-7a54-4ad6-ad8a-34e970794deb_photo.jpg",
      averageRating=4.4, totalRatingsCount=721,
      createdAt="2026-09-20T19:13:01.000886Z", updatedAt="2026-09-20T19:13:01.000886Z",
    ),
    ClubDto(
      id="6c8442f1-3c27-4331-be65-00cf80090673", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Pool Hall & Sports Bar", address="640 W Hubbard St, Chicago, IL 60654",
      city="Chicago", country="US",
      latitude=41.8902778, longitude=-87.6447346,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e24f1f1f-039d-4186-8924-2d6013d8af7f_photo.jpg",
      averageRating=4.4, totalRatingsCount=567,
      createdAt="2026-09-20T19:13:25.780278Z", updatedAt="2026-09-20T19:13:25.780278Z",
    ),
    ClubDto(
      id="6ecbd209-1b26-454e-9a43-2fea77bb1ce8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kart Circuit Autobahn", address="1801 Centerpoint Way, Joliet, IL 60436",
      city="Chicago", country="US",
      latitude=41.4506978, longitude=-88.1236094,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eddf7642-8450-439e-aee4-6c8ba05fbf4c_photo.jpg",
      averageRating=4.3, totalRatingsCount=278,
      createdAt="2026-09-20T19:13:03.723094Z", updatedAt="2026-09-20T19:13:03.723094Z",
    ),
    ClubDto(
      id="c723f2a0-ab5c-4a5c-b1bf-e788b61f7076", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Waveland Bowl", address="3700 N Western Ave, Chicago, IL 60618",
      city="Chicago", country="US",
      latitude=41.9487292, longitude=-87.6886309,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6781a50f-9d92-4726-9ba7-0e1ed0c724a3_photo.jpg",
      averageRating=4.3, totalRatingsCount=2120,
      createdAt="2026-09-20T19:13:12.655884Z", updatedAt="2026-09-20T19:13:12.655884Z",
    ),
    ClubDto(
      id="228ad96f-4cf0-4a96-85e0-717177fe088f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TOCA Soccer and Sports Center Evanston", address="2454 Oakton St, Evanston, IL 60202",
      city="Chicago", country="US",
      latitude=42.0248511, longitude=-87.70771,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/931a3feb-01a3-450b-ada1-de9d8065a283_photo.jpg",
      averageRating=4.2, totalRatingsCount=248,
      createdAt="2026-09-20T19:12:14.557421Z", updatedAt="2026-09-20T19:12:14.557421Z",
    ),
    ClubDto(
      id="a36adf88-243e-47e9-9477-5ed1640b74fb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lucky Strike Chicago", address="322 E Illinois St, Chicago, IL 60611",
      city="Chicago", country="US",
      latitude=41.8914165, longitude=-87.6196235,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/444943df-8501-4daa-a479-4682763255d4_photo.jpg",
      averageRating=4.1, totalRatingsCount=3139,
      createdAt="2026-09-20T19:13:07.750971Z", updatedAt="2026-09-20T19:13:07.750971Z",
    ),
    ClubDto(
      id="fba6e0e2-54a5-4de6-8c08-91320b5ef8dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Life Time", address="15 W Chicago Ave, Chicago, IL 60654",
      city="Chicago", country="US",
      latitude=41.8962256, longitude=-87.6287417,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5701ca5-cab2-4693-8ba6-348b3828a6f4_photo.jpg",
      averageRating=3.9, totalRatingsCount=340,
      createdAt="2026-09-20T19:12:34.317219Z", updatedAt="2026-09-20T19:12:34.317219Z",
    ),
    ClubDto(
      id="b5b9a361-6e0c-4949-951b-44f8c0dd4c51", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Union Padel Club", address="207 N Paulina St, Chicago, IL 60612",
      city="Chicago", country="US",
      latitude=41.8853656, longitude=-87.6690805,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9403662d-99da-451e-a59d-c38c5a5b03a1_photo.jpg",
      averageRating=5.0, totalRatingsCount=30,
      createdAt="2026-09-20T19:12:27.011994Z", updatedAt="2026-09-20T19:12:27.011994Z",
    ),
    ClubDto(
      id="302c36b2-efe7-4924-9f62-84519d947593", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Chicago International Table Tennis Academy - CITTA", address="3660 Edison Pl, Rolling Meadows, IL 60008",
      city="Chicago", country="US",
      latitude=42.0989855, longitude=-88.0267502,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b97eb4e0-750b-448b-bb95-3cd2a8ed976a_photo.jpg",
      averageRating=4.8, totalRatingsCount=25,
      createdAt="2026-09-20T19:12:54.568158Z", updatedAt="2026-09-20T19:12:54.568158Z",
    ),
    ClubDto(
      id="cb5ac9f2-bc66-4204-845e-7525e869bf4f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Net & Paddle Table Tennis Club", address="4754 N Leavitt St, Chicago, IL 60625",
      city="Chicago", country="US",
      latitude=41.9680638, longitude=-87.6844351,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bfefa1cb-ea71-4f45-b4d2-787dff6ef066_photo.jpg",
      averageRating=4.9, totalRatingsCount=16,
      createdAt="2026-09-20T19:12:57.294479Z", updatedAt="2026-09-20T19:12:57.294479Z",
    ),
  )),
  CitySeo(slug="paris", name="Paris", country="FR", clubCount=29, sports=listOf(Pair("Volleyball", 4), Pair("Basketball", 3), Pair("Football", 3), Pair("Padel", 3), Pair("Tennis", 3), Pair("Climbing", 2), Pair("Paintball", 2), Pair("Karting", 2), Pair("Table Tennis", 2), Pair("Laser Tag", 2), Pair("Billiards", 1), Pair("Golf", 1), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="bf703d48-5dfe-427a-8b90-2ea23c946599", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BattleKart Paris Nord Villepinte – Karting Paris", address="Parc des expositions Paris Nord Villepinte ZAC Paris, Nord 2, Hall 1 Porte A4, 93420 Villepinte",
      city="Paris", country="FR",
      latitude=48.9756307, longitude=2.5171925,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3845b9af-6066-432d-b5c3-3c35f459fcdc_ChIJhbWJl5kV_0.jpg",
      averageRating=4.9, totalRatingsCount=3220,
      createdAt="2026-08-30T21:14:47.269547Z", updatedAt="2026-08-30T21:55:23.822067Z",
    ),
    ClubDto(
      id="18d0e2b2-82e2-4554-b311-edbc4f625f8e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Passing Club Tennis Paris 20", address="9 Rue des Frères Flavien, 75020 Paris",
      city="Paris", country="FR",
      latitude=48.8746153, longitude=2.4125738,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f01b2270-56c5-4d9e-87c1-fb80baa8e5f2_ChIJXaMk959t_0.jpg",
      averageRating=4.9, totalRatingsCount=109,
      createdAt="2026-08-30T21:15:52.835362Z", updatedAt="2026-08-30T21:59:25.906078Z",
    ),
    ClubDto(
      id="4c969e27-aa37-427c-a533-790c4b26c858", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Seven Squares Paris", address="Boom Boom Villette, 30 Av. Corentin Cariou, 75019 Paris",
      city="Paris", country="FR",
      latitude=48.895971, longitude=2.389393,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/24a22359-1f31-4673-879a-9a42c31c8ea0_ChIJfbUGhght_0.jpg",
      averageRating=4.9, totalRatingsCount=3659,
      createdAt="2026-08-30T21:14:39.823845Z", updatedAt="2026-08-30T21:59:57.501821Z",
    ),
    ClubDto(
      id="09bc2553-6468-4be1-81eb-3a650048ef23", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="HiTAC Airsoft", address="18 Rue de la Cr des Noues, 75020 Paris",
      city="Paris", country="FR",
      latitude=48.8644142, longitude=2.4018641,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bbdbb46d-80be-40c3-b938-892a3e587977_ChIJIersWoVt_0.jpg",
      averageRating=4.7, totalRatingsCount=111,
      createdAt="2026-08-30T21:15:17.388365Z", updatedAt="2026-08-30T21:57:16.451802Z",
    ),
    ClubDto(
      id="d912b5d3-7db0-4058-ae09-44373c2ba1de", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel-Horizon", address="3 Bis Rue de Paris, 94370 Sucy-en-Brie",
      city="Paris", country="FR",
      latitude=48.7741462, longitude=2.5036557,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1c9117df-9d2c-4349-9a6f-0fa0d56933d0_ChIJwaCGIWMN_0.jpg",
      averageRating=4.7, totalRatingsCount=383,
      createdAt="2026-08-30T21:15:25.116812Z", updatedAt="2026-08-30T21:59:05.554404Z",
    ),
    ClubDto(
      id="e24e31fa-f05b-4a63-b81d-3bff9f246679", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sand Fabrik", address="45 Rue Delizy, 93500 Pantin",
      city="Paris", country="FR",
      latitude=48.8977758, longitude=2.4066637,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4736b06e-79f7-42af-9194-ff15cdbfe4cd_photo.jpg",
      averageRating=4.7, totalRatingsCount=800,
      createdAt="2026-08-31T15:04:28.603161Z", updatedAt="2026-08-31T15:04:28.603161Z",
    ),
    ClubDto(
      id="67533469-303d-400e-b29e-007aecc20d8a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Atomik Paris", address="16 Rue de la Cr des Noues, 75020 Paris",
      city="Paris", country="FR",
      latitude=48.8644383, longitude=2.4019485,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c9b4f419-4ed0-4bef-82ad-3c12c4791dd9_ChIJXUPQRIVt_0.jpg",
      averageRating=4.6, totalRatingsCount=268,
      createdAt="2026-08-30T21:15:08.980525Z", updatedAt="2026-08-30T21:15:08.980525Z",
    ),
    ClubDto(
      id="f28c4cc8-acc1-43f4-9a45-a20b98d8cecd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="URBAN LASER GAME PARIS 14", address="13 Rue Ernest Cresson, 75014 Paris",
      city="Paris", country="FR",
      latitude=48.8326965, longitude=2.3288847,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/32cccf90-73aa-4c80-b2f0-cbe84b2dde8c_ChIJ5YQQIrdx_0.jpg",
      averageRating=4.6, totalRatingsCount=1113,
      createdAt="2026-08-30T21:14:54.660535Z", updatedAt="2026-08-30T22:01:49.445456Z",
    ),
    ClubDto(
      id="aca8b7ff-fd92-4240-860f-661fb1a3de34", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climb Up Paris Porte d'Italie", address="18 Av. de la Pte. d'Italie, 75013 Paris",
      city="Paris", country="FR",
      latitude=48.8170692, longitude=2.3598162,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/48d6abe6-5cbc-46e9-b21d-02921b150518_ChIJaTqc06Jx_0.jpg",
      averageRating=4.5, totalRatingsCount=2046,
      createdAt="2026-08-30T21:14:27.082460Z", updatedAt="2026-08-30T21:56:08.081948Z",
    ),
    ClubDto(
      id="acc17403-9582-4cc7-a2fd-1bd7bf3dc20a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Espérance de Reuilly Tennis de Table", address="26 Bd Carnot, 75012 Paris",
      city="Paris", country="FR",
      latitude=48.843113, longitude=2.412904,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f232000a-7fc3-466e-9e90-c1625030d8f2_photo.jpg",
      averageRating=4.5, totalRatingsCount=55,
      createdAt="2026-08-31T15:04:51.154858Z", updatedAt="2026-08-31T15:04:51.154858Z",
    ),
    ClubDto(
      id="01c1be63-1a1d-48fb-9fa3-755a369c483d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel 15", address="115 Rue Castagnary, 75015 Paris",
      city="Paris", country="FR",
      latitude=48.8298304, longitude=2.3047983,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4f06d22c-344d-47e7-95f7-f38c9e4fae28_ChIJLdPHepNx_0.jpg",
      averageRating=4.5, totalRatingsCount=124,
      createdAt="2026-08-30T21:15:32.076279Z", updatedAt="2026-08-30T21:58:55.635034Z",
    ),
    ClubDto(
      id="cffac153-dd38-43c6-be98-31eb7474ee43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club de Paris TCP", address="15 Av. Félix d'Herelle, 75016 Paris",
      city="Paris", country="FR",
      latitude=48.8347397, longitude=2.257086,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39513a61-cee5-4748-a2d0-f5d6c0468827_ChIJdfSB-ZR6_0.jpg",
      averageRating=4.5, totalRatingsCount=153,
      createdAt="2026-08-30T21:15:46.048578Z", updatedAt="2026-08-30T22:01:27.775556Z",
    ),
    ClubDto(
      id="5d390761-1743-4853-b8bd-ffd136586360", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Urban Laser Paris 11", address="160 Rue Saint-Maur, 75011 Paris",
      city="Paris", country="FR",
      latitude=48.8696611, longitude=2.3741401,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d0058bf7-8656-43dc-a96b-c648d34d02e7_ChIJ3y9dDORt_0.jpg",
      averageRating=4.5, totalRatingsCount=598,
      createdAt="2026-08-30T21:15:02.204977Z", updatedAt="2026-08-30T22:01:52.067023Z",
    ),
    ClubDto(
      id="1edf4597-6ef2-4eac-a41d-5de36e691f0c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="EIFFEL BASKET CLUB", address="107 Rue de la Croix Nivert, 75015 Paris",
      city="Paris", country="FR",
      latitude=48.8419422, longitude=2.2952766,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/55665a18-3b27-4ccd-9120-f534014fb194_photo.png",
      averageRating=4.7, totalRatingsCount=47,
      createdAt="2026-08-31T15:03:58.673465Z", updatedAt="2026-08-31T22:11:15.851281Z",
    ),
    ClubDto(
      id="40c44fa3-39ae-4c08-a150-2f8b9ca4d611", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hoops Factory", address="3 Rue Pierre Larousse, 93300 Aubervilliers",
      city="Paris", country="FR",
      latitude=48.9045026, longitude=2.3794253,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c2ed2653-0276-4bf7-85c2-d5c5c57f02ec_photo.jpg",
      averageRating=4.4, totalRatingsCount=1103,
      createdAt="2026-08-31T15:03:30.096220Z", updatedAt="2026-08-31T15:03:30.096220Z",
    ),
    ClubDto(
      id="b42b70eb-0f29-4dcd-8e5a-2dc3812b69ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club Parisien de Joinville", address="4 Av. de l'École de Joinville, 75012 Paris",
      city="Paris", country="FR",
      latitude=48.8211255, longitude=2.4603641,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4e6b457d-084e-4543-81d3-84f5ef24959e_ChIJMyOew8ty_0.jpg",
      averageRating=4.4, totalRatingsCount=101,
      createdAt="2026-08-30T21:15:59.869316Z", updatedAt="2026-08-30T21:15:59.869316Z",
    ),
    ClubDto(
      id="2811108b-441b-43d0-be91-67a199cd1dfe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basket Paris 14", address="52 Rue Raymond Losserand, 75014 Paris",
      city="Paris", country="FR",
      latitude=48.8346858, longitude=2.3190601,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/59e07ae4-d75a-44f0-a87c-8314db6799f8_photo.jpg",
      averageRating=4.3, totalRatingsCount=67,
      createdAt="2026-08-31T15:03:47.352312Z", updatedAt="2026-08-31T15:03:47.352312Z",
    ),
    ClubDto(
      id="383853fd-77f2-43a8-96e1-7b28f9bd0482", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf ParisLongchamp", address="61 Rte des Tribunes, 75016 Paris",
      city="Paris", country="FR",
      latitude=48.8577678, longitude=2.23266,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/89050593-9cdb-4a88-9074-1b206dcb4e33_photo.jpg",
      averageRating=4.3, totalRatingsCount=234,
      createdAt="2026-08-31T15:04:44.287180Z", updatedAt="2026-08-31T15:04:44.287180Z",
    ),
    ClubDto(
      id="11a660f0-350a-4ae0-9699-af0f64b7a919", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arkose Nation", address="35 Rue des Grands Champs Entresol, 75020 Paris",
      city="Paris", country="FR",
      latitude=48.851301, longitude=2.402267,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96e17054-a87d-4297-bf50-659e12a0a438_ChIJN8ojDpBz_0.jpg",
      averageRating=4.2, totalRatingsCount=1741,
      createdAt="2026-08-30T21:14:33.003844Z", updatedAt="2026-08-30T21:55:16.148932Z",
    ),
    ClubDto(
      id="6a6e70e8-a3cb-4109-9916-a6ddadedaede", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LE FIVE Paris 18", address="215 Rue d'Aubervilliers, 75018 Paris",
      city="Paris", country="FR",
      latitude=48.8978522, longitude=2.3700234,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4591c747-22ed-4500-9622-2e18d84e13e2_ChIJpVT4_n1u_0.jpg",
      averageRating=4.2, totalRatingsCount=1265,
      createdAt="2026-08-30T21:13:37.776928Z", updatedAt="2026-08-30T21:13:37.776928Z",
    ),
    ClubDto(
      id="733fbfce-d36d-4386-84f2-a2db3353fda9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Tête Dans Les Nuages Paris Opéra", address="Drouot, lignes 8, Métro Richelieu, 5 Bd des Italiens et 9, 75002 Paris",
      city="Paris", country="FR",
      latitude=48.8715563, longitude=2.3391802,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c90ad77b-cb40-4058-8d6a-ce4e0bf01144_ChIJkUxqWTlu_0.jpg",
      averageRating=4.2, totalRatingsCount=8322,
      createdAt="2026-08-30T21:14:20.002739Z", updatedAt="2026-08-30T21:58:16.730344Z",
    ),
    ClubDto(
      id="a498cbf8-be79-4f1b-8fcb-11ee51d538ef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Corcoran's Grands Boulevards", address="23 Bd Poissonnière, 75002 Paris",
      city="Paris", country="FR",
      latitude=48.871125, longitude=2.344125,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dd1e3673-cad6-4438-b9ab-36b18905a1a4_ChIJ02Lg3z1u_0.jpg",
      averageRating=4.1, totalRatingsCount=5519,
      createdAt="2026-08-30T21:14:06.323500Z", updatedAt="2026-08-30T21:14:06.323500Z",
    ),
    ClubDto(
      id="2bd98911-89e9-46ef-b161-fe1bc8f1d804", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LE FIVE Paris 17", address="26 Rue Hélène et François Missoffe, 75017 Paris",
      city="Paris", country="FR",
      latitude=48.900032, longitude=2.3213449,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8e05206b-e2bd-484b-b3d3-8f236c621c80_ChIJ7eI8sFNv_0.jpg",
      averageRating=4.1, totalRatingsCount=607,
      createdAt="2026-08-30T21:13:52.321151Z", updatedAt="2026-08-30T21:13:52.321151Z",
    ),
    ClubDto(
      id="3f9204b2-50f9-4419-b8f1-5302230dc430", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LE FIVE Paris 13", address="9 Av. de la Prte de Choisy, 75013 Paris",
      city="Paris", country="FR",
      latitude=48.8181616, longitude=2.3658795,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5fed8cf1-a9df-487b-9682-afe5f94340e2_ChIJ_bOSChhz_0.jpg",
      averageRating=4.0, totalRatingsCount=773,
      createdAt="2026-08-30T21:13:44.304486Z", updatedAt="2026-08-30T21:13:44.304486Z",
    ),
    ClubDto(
      id="1be73e7e-518f-41fa-9a66-dd050cc7c597", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paris Padel", address="340 Rue des Pyrénées, 75020 Paris",
      city="Paris", country="FR",
      latitude=48.8742397, longitude=2.3888057,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/16618665-388a-416c-96f5-b7d00a9281e8_ChIJQzPN8tRt_0.jpg",
      averageRating=4.0, totalRatingsCount=120,
      createdAt="2026-08-30T21:15:38.890473Z", updatedAt="2026-08-30T21:59:22.454500Z",
    ),
    ClubDto(
      id="7488c588-42ff-4e47-a632-48e153e737f9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sand System Association (Beach volley)", address="1 Av. de la Prte de Pantin, 75019 Paris",
      city="Paris", country="FR",
      latitude=48.890302, longitude=2.397433,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4886a53e-ff52-4d95-891e-209e8029a242_photo.jpg",
      averageRating=4.8, totalRatingsCount=31,
      createdAt="2026-08-31T15:04:21.750735Z", updatedAt="2026-08-31T15:04:21.750735Z",
    ),
    ClubDto(
      id="3bf5e3c8-74d2-44b4-9743-573c544f2fc7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paris Beach Volley", address="Complexe Sportif Louis Lumiere, 30 Rue Louis Lumière, 75020 Paris",
      city="Paris", country="FR",
      latitude=48.8601591, longitude=2.4133419,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ffe3bbc2-bdf5-4f10-832f-f30b468f30b5_photo.jpg",
      averageRating=3.7, totalRatingsCount=40,
      createdAt="2026-08-31T15:04:13.228240Z", updatedAt="2026-08-31T15:04:13.228240Z",
    ),
    ClubDto(
      id="96fafc0e-8ab7-4490-a1d4-bd8b914870dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis de Table Allée Verte", address="11 All. Verte, 75011 Paris",
      city="Paris", country="FR",
      latitude=48.8597075, longitude=2.3713274,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ead3286c-e49a-4398-a8ae-68ba9f1c32ed_photo.jpg",
      averageRating=4.6, totalRatingsCount=22,
      createdAt="2026-08-31T15:04:58.620547Z", updatedAt="2026-08-31T15:04:58.620547Z",
    ),
    ClubDto(
      id="b82e2d91-e913-4f7f-905c-a0d8e33cee6f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paris Volley Club", address="9 Rue Alphonse Baudin, 75011 Paris",
      city="Paris", country="FR",
      latitude=48.8604995, longitude=2.3702015,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b2f3158c-9903-460d-98d3-1a10cbc18eec_photo.png",
      averageRating=5.0, totalRatingsCount=12,
      createdAt="2026-08-31T15:04:04.694659Z", updatedAt="2026-08-31T15:04:04.694659Z",
    ),
  )),
  CitySeo(slug="boston", name="Boston", country="US", clubCount=29, sports=listOf(Pair("Football", 5), Pair("Volleyball", 3), Pair("Table Tennis", 3), Pair("Tennis", 3), Pair("Climbing", 2), Pair("Basketball", 2), Pair("Billiards", 2), Pair("Paintball", 2), Pair("Golf", 2), Pair("Bowling", 2), Pair("Padel", 2), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="0cce0aab-7944-4dbe-aac4-7a59c4e0516a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Boston", address="220 Rustcraft Rd, Dedham, MA 02026",
      city="Boston", country="US",
      latitude=42.231809, longitude=-71.1708769,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d13b1c97-c09d-4461-844b-5816011b1683_photo.jpg",
      averageRating=5.0, totalRatingsCount=129,
      createdAt="2026-09-20T19:24:42.899193Z", updatedAt="2026-09-20T19:24:42.899193Z",
    ),
    ClubDto(
      id="8c8e1bc2-f4cd-46cb-bb1d-06593bc80ec5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach House - Boston", address="18 Tech Cir, Natick, MA 01760",
      city="Boston", country="US",
      latitude=42.3153705, longitude=-71.3333666,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11a0a300-fba9-4cd8-92f8-a9b5e2e0d5e1_photo.jpg",
      averageRating=4.9, totalRatingsCount=104,
      createdAt="2026-09-20T19:25:01.278330Z", updatedAt="2026-09-20T19:25:01.278330Z",
    ),
    ClubDto(
      id="83d75694-7253-4911-9cc1-e80ac20342f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Friendly Fire Paintball", address="108 Grove St, Upton, MA 01568",
      city="Boston", country="US",
      latitude=42.1596736, longitude=-71.5981668,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39344140-ac0e-464d-8ae8-b6f694595f0f_photo.jpg",
      averageRating=4.9, totalRatingsCount=119,
      createdAt="2026-09-20T19:25:51.725381Z", updatedAt="2026-09-20T19:25:51.725381Z",
    ),
    ClubDto(
      id="391353fe-b170-43ce-86c3-59d4e8e35c5c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Central Rock Gym - Cambridge", address="170 Alewife Brook Pkwy, Cambridge, MA 02138",
      city="Boston", country="US",
      latitude=42.3907723, longitude=-71.1398849,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bde88323-d65e-47bd-baf4-d4e4d650d7cc_photo.jpg",
      averageRating=4.8, totalRatingsCount=291,
      createdAt="2026-09-20T19:25:34.840159Z", updatedAt="2026-09-20T19:25:34.840159Z",
    ),
    ClubDto(
      id="ce98212b-fcb3-42c8-8a58-9be41aef747d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LaserMaxx Danvers", address="139 Endicott St, Danvers, MA 01923",
      city="Boston", country="US",
      latitude=42.5523484, longitude=-70.9335987,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/317fdbee-c55d-4219-bbfd-54c7c2c651a6_photo.jpg",
      averageRating=4.8, totalRatingsCount=508,
      createdAt="2026-09-20T19:25:44.582543Z", updatedAt="2026-09-20T19:25:44.582543Z",
    ),
    ClubDto(
      id="0c65e003-ebb5-439c-ac97-8f97edee2888", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Westford Table Tennis Club", address="22 Town Farm Rd Ste 100, Westford, MA 01886",
      city="Boston", country="US",
      latitude=42.5824716, longitude=-71.4822164,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/583fe435-69fb-43ee-afb8-2e3d40a89b44_photo.jpg",
      averageRating=4.8, totalRatingsCount=49,
      createdAt="2026-09-20T19:25:22.213670Z", updatedAt="2026-09-20T19:25:22.213670Z",
    ),
    ClubDto(
      id="0ca2e079-8509-406f-b97f-96182a398fb7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dana Barros Basketball Club", address="1776 Washington St, Stoughton, MA 02072",
      city="Boston", country="US",
      latitude=42.0982732, longitude=-71.0954875,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83db3421-c6db-4b80-a36e-d0d6881e7370_photo.jpg",
      averageRating=4.7, totalRatingsCount=389,
      createdAt="2026-09-20T19:24:57.450585Z", updatedAt="2026-09-20T19:24:57.450585Z",
    ),
    ClubDto(
      id="a1e328ed-ded0-4d23-a4b8-eda548dd8566", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boston Table Tennis Club", address="407 Mystic Ave #24, Medford, MA 02155",
      city="Boston", country="US",
      latitude=42.4024353, longitude=-71.1004867,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d33b9bd8-f9f0-4a72-9bb4-b79ac08f1833_photo.jpg",
      averageRating=4.6, totalRatingsCount=76,
      createdAt="2026-09-20T19:25:18.661453Z", updatedAt="2026-09-20T19:25:18.661453Z",
    ),
    ClubDto(
      id="5e23a77d-43e6-41e6-a735-673b6fe2933e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="P&L Paintball, Inc.", address="1221 Bedford St, Bridgewater, MA 02324",
      city="Boston", country="US",
      latitude=41.954822, longitude=-70.9704151,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/daa82eb5-a09b-4d4b-8664-7e4cd65f3203_photo.jpg",
      averageRating=4.6, totalRatingsCount=347,
      createdAt="2026-09-20T19:25:48.175195Z", updatedAt="2026-09-20T19:25:48.175195Z",
    ),
    ClubDto(
      id="55bedf92-0529-447d-b3b8-83ac41eecd9d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tyngsboro Sports Center", address="500 Potash Hill Rd, Tyngsborough, MA 01879",
      city="Boston", country="US",
      latitude=42.6627574, longitude=-71.4164131,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/23a0479d-2649-4699-aa42-b01923da637d_photo.jpg",
      averageRating=4.6, totalRatingsCount=568,
      createdAt="2026-09-20T19:24:08.946504Z", updatedAt="2026-09-20T19:24:08.946504Z",
    ),
    ClubDto(
      id="c82c5629-3fc1-46c6-9434-6ca8c8c0158a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Union Point Sports Complex", address="170 Memorial Grove Ave, Weymouth, MA 02190",
      city="Boston", country="US",
      latitude=42.1607173, longitude=-70.9418852,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/88e10f52-ace9-4883-ab98-51aeb0664343_photo.jpg",
      averageRating=4.6, totalRatingsCount=295,
      createdAt="2026-09-20T19:24:19.424607Z", updatedAt="2026-09-20T19:24:19.424607Z",
    ),
    ClubDto(
      id="86036b5b-614a-417f-962b-facabfc0451f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="George Wright", address="420 West St, Hyde Park, MA 02136",
      city="Boston", country="US",
      latitude=42.2684323, longitude=-71.1327971,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c4e8f425-302b-4b4b-8e92-f49825b0041c_photo.jpg",
      averageRating=4.5, totalRatingsCount=359,
      createdAt="2026-09-20T19:25:15.358026Z", updatedAt="2026-09-20T19:25:15.358026Z",
    ),
    ClubDto(
      id="3be9088b-308c-41e9-a64c-d3f298e86093", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Harry Downes Field", address="24 Highland Rd, Brookline, MA 02445",
      city="Boston", country="US",
      latitude=42.3248696, longitude=-71.1184854,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b8612972-52c0-4a98-812f-dbf8081f40a2_photo.jpg",
      averageRating=4.5, totalRatingsCount=198,
      createdAt="2026-09-20T19:24:22.574746Z", updatedAt="2026-09-20T19:24:22.574746Z",
    ),
    ClubDto(
      id="c144fbed-0466-41f0-8402-b2735685e0c9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PKL Boston", address="64 C St, South Boston, MA 02127",
      city="Boston", country="US",
      latitude=42.3370907, longitude=-71.0558258,
      type="TENNIS",
      types=listOf("TENNIS", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4adfae54-e714-4a71-81e2-c1b8e35fd4fd_photo.jpg",
      averageRating=4.5, totalRatingsCount=238,
      createdAt="2026-09-20T19:24:32.129700Z", updatedAt="2026-09-20T19:24:32.129700Z",
    ),
    ClubDto(
      id="1b4867a2-d1bf-4647-aba6-79152bca15ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Reggie Lewis Track and Athletic Center", address="1350 Tremont St, Boston, MA 02120",
      city="Boston", country="US",
      latitude=42.3320087, longitude=-71.0929599,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dbbf807b-1501-45d1-aae9-6dc7fbfaf53e_photo.jpg",
      averageRating=4.5, totalRatingsCount=997,
      createdAt="2026-09-20T19:24:50.720423Z", updatedAt="2026-09-20T19:24:50.720423Z",
    ),
    ClubDto(
      id="cea89a31-47be-4f65-a019-422fcb244044", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SPIN Boston", address="30 Melcher St, Boston, MA 02210",
      city="Boston", country="US",
      latitude=42.3499329, longitude=-71.0503945,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/97b823bb-1d5f-4f8f-952c-c093ff0ae6e6_photo.jpg",
      averageRating=4.5, totalRatingsCount=235,
      createdAt="2026-09-20T19:24:35.322705Z", updatedAt="2026-09-20T19:24:35.322705Z",
    ),
    ClubDto(
      id="7e6136b5-9cb8-4f59-964a-c20a12a483f7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bouldering Project - Somerville", address="12A Tyler St, Somerville, MA 02143",
      city="Boston", country="US",
      latitude=42.3817711, longitude=-71.1059276,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ae778f02-2bbc-40bf-9034-e145b9316f25_photo.jpg",
      averageRating=4.4, totalRatingsCount=832,
      createdAt="2026-09-20T19:25:32.188086Z", updatedAt="2026-09-20T19:25:32.188086Z",
    ),
    ClubDto(
      id="a590c2b0-e97d-4f9d-ac3b-680249248acf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SLAM Volleyball Club", address="72 Jefferson St #100, Marlborough, MA 01752",
      city="Boston", country="US",
      latitude=42.3505066, longitude=-71.5559064,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1a97e9a-bc4b-4758-b2b3-077d37c4a0b3_photo.jpg",
      averageRating=4.4, totalRatingsCount=57,
      createdAt="2026-09-20T19:25:08.468616Z", updatedAt="2026-09-20T19:25:08.468616Z",
    ),
    ClubDto(
      id="2e6d4937-fdca-4297-9fb6-84d5f796efad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stone Meadow Golf", address="675 Waltham St #7935, Lexington, MA 02421",
      city="Boston", country="US",
      latitude=42.4243722, longitude=-71.2323194,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b14134d6-3214-470e-8469-08ca18e8fdba_photo.jpg",
      averageRating=4.4, totalRatingsCount=391,
      createdAt="2026-09-20T19:25:11.962616Z", updatedAt="2026-09-20T19:25:11.962616Z",
    ),
    ClubDto(
      id="ee7da053-7c65-4818-a0e9-28ba53b944e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Teamworks Acton", address="30 Great Rd, Acton, MA 01720",
      city="Boston", country="US",
      latitude=42.473101, longitude=-71.409115,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4e7ab4f6-1833-4f48-958a-1b467141a4ae_photo.jpg",
      averageRating=4.4, totalRatingsCount=320,
      createdAt="2026-09-20T19:24:16.375205Z", updatedAt="2026-09-20T19:24:16.375205Z",
    ),
    ClubDto(
      id="2eb11ad2-0b7e-45b6-99c4-7635d1d5a7f4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Town Line Luxury Lanes", address="665 Broadway, Malden, MA 02148",
      city="Boston", country="US",
      latitude=42.4430146, longitude=-71.0293584,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/262f0060-3d4a-4d2a-a54b-6441fbab7763_photo.jpg",
      averageRating=4.4, totalRatingsCount=1735,
      createdAt="2026-09-20T19:25:29.519003Z", updatedAt="2026-09-20T19:25:29.519003Z",
    ),
    ClubDto(
      id="51685d89-64e1-4d11-8daa-2df2b7de93ca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Woburn Racquet Club", address="9 Webster St, Woburn, MA 01801",
      city="Boston", country="US",
      latitude=42.5095518, longitude=-71.1668198,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0c1776bf-36d8-4862-9437-6b284e3350f4_photo.jpg",
      averageRating=4.4, totalRatingsCount=144,
      createdAt="2026-09-20T19:24:39.343369Z", updatedAt="2026-09-20T19:24:39.343369Z",
    ),
    ClubDto(
      id="fdfe8fe3-6817-48d9-b167-fec1e231ac2e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kings Dining & Entertainment", address="60 Seaport Blvd, Boston, MA 02210",
      city="Boston", country="US",
      latitude=42.3530189, longitude=-71.0471523,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1433206c-7f01-4613-ae25-c1433126e814_photo.jpg",
      averageRating=4.3, totalRatingsCount=1428,
      createdAt="2026-09-20T19:25:38.267941Z", updatedAt="2026-09-20T19:25:38.267941Z",
    ),
    ClubDto(
      id="40d3c42e-2b5c-4d08-8114-75c4d4af2ba0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Flat Top Johnny's", address="238 Main St, Cambridge, MA 02142",
      city="Boston", country="US",
      latitude=42.3615798, longitude=-71.0850754,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fe1dde45-8c7f-4cf0-8572-523287f11ffa_photo.jpg",
      averageRating=4.2, totalRatingsCount=705,
      createdAt="2026-09-20T19:25:41.310560Z", updatedAt="2026-09-20T19:25:41.310560Z",
    ),
    ClubDto(
      id="8098539e-0699-41c1-ae6c-93501950bdef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lucky Strike Fenway", address="145 Ipswich St, Boston, MA 02215",
      city="Boston", country="US",
      latitude=42.3474633, longitude=-71.0945813,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/967018aa-b25c-4a51-90d7-ac9f00f94aa8_photo.jpg",
      averageRating=4.2, totalRatingsCount=2645,
      createdAt="2026-09-20T19:25:26.239540Z", updatedAt="2026-09-20T19:25:26.239540Z",
    ),
    ClubDto(
      id="a956d025-f708-4a85-984f-e8d35cf66aab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Weymouth Club", address="75 Finnell Dr, Weymouth, MA 02188",
      city="Boston", country="US",
      latitude=42.1897523, longitude=-70.9674024,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e01bc93-e122-45aa-a512-37d6f1d72ed2_photo.jpg",
      averageRating=4.1, totalRatingsCount=289,
      createdAt="2026-09-20T19:24:28.889524Z", updatedAt="2026-09-20T19:24:28.889524Z",
    ),
    ClubDto(
      id="a125f231-801d-4155-bc16-3126e88beb43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="HUB Sports Boston", address="17 Main St, Watertown, MA 02472",
      city="Boston", country="US",
      latitude=42.3657779, longitude=-71.1847338,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f14b7ee0-1f40-469d-b677-aa9175b0b92b_photo.jpg",
      averageRating=4.0, totalRatingsCount=89,
      createdAt="2026-09-20T19:25:05.703548Z", updatedAt="2026-09-20T19:25:05.703548Z",
    ),
    ClubDto(
      id="c86e5f9c-6843-4351-8ae4-ff03bd67fd62", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Teamworks Revere/Greater Boston", address="321 Charger St, Revere, MA 02151",
      city="Boston", country="US",
      latitude=42.427408, longitude=-71.0068675,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/22749646-9a7e-4d14-9ab9-d6b12c91bdcc_photo.jpg",
      averageRating=4.0, totalRatingsCount=324,
      createdAt="2026-09-20T19:24:12.828190Z", updatedAt="2026-09-20T19:24:12.828190Z",
    ),
    ClubDto(
      id="62660257-51d4-4588-bc74-92ac619366fb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADELHUB - BOSTON", address="653 Summer St, Boston, MA 02210",
      city="Boston", country="US",
      latitude=42.3399535, longitude=-71.0437544,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99cb909c-6969-4095-82d7-1cdf18816688_photo.jpg",
      averageRating=4.9, totalRatingsCount=38,
      createdAt="2026-09-20T19:24:46.480843Z", updatedAt="2026-09-20T19:24:46.480843Z",
    ),
  )),
  CitySeo(slug="the-hague", name="The Hague", country="NL", clubCount=29, sports=listOf(Pair("Volleyball", 4), Pair("Football", 4), Pair("Tennis", 4), Pair("Padel", 2), Pair("Climbing", 2), Pair("Paintball", 2), Pair("Karting", 2), Pair("Billiards", 2), Pair("Golf", 2), Pair("Basketball", 2), Pair("Laser Tag", 1), Pair("Bowling", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="c15fd00e-8953-4fe7-b900-58680ff650bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hague Golf & Country Club", address="Groot Haesebroekseweg 22, 2243 EC Wassenaar",
      city="The Hague", country="NL",
      latitude=52.1329064, longitude=4.368983,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e02f2178-84e0-462b-83b4-fadd7f4ccf44_photo.jpg",
      averageRating=4.8, totalRatingsCount=167,
      createdAt="2026-08-31T23:46:29.399371Z", updatedAt="2026-08-31T23:46:29.399371Z",
    ),
    ClubDto(
      id="49e2f25b-1d62-4ff6-8b11-935f6df03d1a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Focus Billiards 🎱", address="Ammunitiehaven 751, 2511 XX Den Haag",
      city="The Hague", country="NL",
      latitude=52.0781029, longitude=4.3225687,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a2a31e22-2a44-4e51-aa07-9a2e4a1ecdd5_photo.jpg",
      averageRating=4.7, totalRatingsCount=92,
      createdAt="2026-08-31T23:47:08.630102Z", updatedAt="2026-08-31T23:47:08.630102Z",
    ),
    ClubDto(
      id="f83c7b00-4396-484b-889b-7b01f9cfa821", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bouldercentrum Delfts Bleau 🧗", address="Schieweg 15L, ingang Oost 2, 2627 AN Delft",
      city="The Hague", country="NL",
      latitude=51.9948222, longitude=4.3668582,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3b47428f-0922-481e-b6f2-6576500ddb06_photo.jpg",
      averageRating=4.6, totalRatingsCount=658,
      createdAt="2026-08-31T23:46:53.504373Z", updatedAt="2026-08-31T23:46:53.504373Z",
    ),
    ClubDto(
      id="badce432-0d10-4458-8a83-91d15fdf8932", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Outdoor-Delft", address="Rotterdamseweg 193, 2629 HH Delft",
      city="The Hague", country="NL",
      latitude=51.9825949, longitude=4.3833392,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8dded21a-744c-4721-b557-9eab333a3a37_photo.jpg",
      averageRating=4.6, totalRatingsCount=190,
      createdAt="2026-08-31T23:47:21.862005Z", updatedAt="2026-08-31T23:47:21.862005Z",
    ),
    ClubDto(
      id="843f04c4-5f33-4b1b-a3ff-6898c357a93a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Stadion", address="Strandweg 4, 2586 JW Den Haag",
      city="The Hague", country="NL",
      latitude=52.1015708, longitude=4.2613947,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4802df0a-04b2-4f10-a7d6-d57820ddb457_photo.jpg",
      averageRating=4.5, totalRatingsCount=1075,
      createdAt="2026-08-31T23:46:00.827227Z", updatedAt="2026-08-31T23:46:00.827227Z",
    ),
    ClubDto(
      id="1d8a8d03-cd3b-413d-98d7-c3e2dd0dfee6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hague 5", address="Gortstraat 7, 2511 AP Den Haag",
      city="The Hague", country="NL",
      latitude=52.0773774, longitude=4.3101894,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d3ea2944-9fe4-4b85-87bf-ef0028be4520_photo.jpg",
      averageRating=4.5, totalRatingsCount=757,
      createdAt="2026-08-31T23:44:52.430996Z", updatedAt="2026-08-31T23:44:52.430996Z",
    ),
    ClubDto(
      id="20a3f656-9d1f-416e-840a-aeba98503dac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Samonda Biljartcentrum 🎱", address="Genemuidenstraat 208, 2545 NZ Den Haag",
      city="The Hague", country="NL",
      latitude=52.0487933, longitude=4.281884,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dfd2f2f6-e289-4ae0-922d-f44faef3447c_photo.jpg",
      averageRating=4.5, totalRatingsCount=108,
      createdAt="2026-08-31T23:47:03.638209Z", updatedAt="2026-08-31T23:47:03.638209Z",
    ),
    ClubDto(
      id="2dc5a39b-aa99-432d-80b4-35e9edc52f1e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportcampus Zuiderpark", address="Meester P. Droogleever Fortuynweg 22, 2533 SR Den Haag",
      city="The Hague", country="NL",
      latitude=52.0564053, longitude=4.2907097,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9e2807e4-ca99-40ec-a84c-eb10421fed47_photo.jpg",
      averageRating=4.5, totalRatingsCount=1537,
      createdAt="2026-08-31T23:44:48.040041Z", updatedAt="2026-08-31T23:44:48.040041Z",
    ),
    ClubDto(
      id="2db815d4-0b1d-443f-a5a5-b45b5e0ac3d7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportcentrum Mariahoeve B.V.", address="Het Kleine Loo 12, 2592 CE Den Haag",
      city="The Hague", country="NL",
      latitude=52.0890774, longitude=4.3492299,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/05688c7a-8d72-43c2-ad51-e08c7670b3c5_photo.jpg",
      averageRating=4.5, totalRatingsCount=436,
      createdAt="2026-08-31T23:45:06.183658Z", updatedAt="2026-09-01T14:32:00.731891Z",
    ),
    ClubDto(
      id="14976502-7267-4a8c-a0e3-ed081c4a3773", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennispark Marlot", address="Leidsestraatweg 75, 2594 BB Den Haag",
      city="The Hague", country="NL",
      latitude=52.1032513, longitude=4.355341,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/727f17da-7dee-4aa7-abbd-907dbaa95c84_photo.jpg",
      averageRating=4.5, totalRatingsCount=96,
      createdAt="2026-08-31T23:45:33.402138Z", updatedAt="2026-09-01T14:31:41.926143Z",
    ),
    ClubDto(
      id="16c7a9ff-ad1a-44dd-87ed-a95aa87219d4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Binck Padel", address="Zonweg 23, 2516 AK Den Haag",
      city="The Hague", country="NL",
      latitude=52.0672003, longitude=4.3439144,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7574ce0c-3d4e-4013-89bc-abb769791b5b_photo.jpg",
      averageRating=4.4, totalRatingsCount=130,
      createdAt="2026-08-31T23:45:28.819121Z", updatedAt="2026-08-31T23:45:28.819121Z",
    ),
    ClubDto(
      id="74054e2d-d634-46ce-8b0f-bc9a0e7d28bc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Combat City Leiderdorp B.V.", address="Kabelbaan 12A, 2352 BL Leiderdorp",
      city="The Hague", country="NL",
      latitude=52.1635854, longitude=4.5197123,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9a21810b-2b92-468e-9907-56f35815fbab_photo.jpg",
      averageRating=4.4, totalRatingsCount=233,
      createdAt="2026-08-31T23:47:17.321242Z", updatedAt="2026-08-31T23:47:17.321242Z",
    ),
    ClubDto(
      id="7ba5596e-9317-487f-835d-e9c07e380935", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Ockenburgh", address="Wijndaelerweg 125, 2554 CA Den Haag",
      city="The Hague", country="NL",
      latitude=52.0553445, longitude=4.2160333,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/01a0f9a9-51a1-4baf-aa5c-5f9862515839_photo.jpg",
      averageRating=4.4, totalRatingsCount=262,
      createdAt="2026-08-31T23:46:24.058663Z", updatedAt="2026-08-31T23:46:24.058663Z",
    ),
    ClubDto(
      id="b2b99b26-8a7c-488e-8d14-dba637994695", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klimmuur", address="Waldorpstraat 15, 2521 CA Den Haag",
      city="The Hague", country="NL",
      latitude=52.0695159, longitude=4.3237387,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/68532b29-d2f8-41df-b583-74374679a0af_photo.jpg",
      averageRating=4.4, totalRatingsCount=284,
      createdAt="2026-08-31T23:46:59.070308Z", updatedAt="2026-08-31T23:46:59.070308Z",
    ),
    ClubDto(
      id="05bbb85e-5ee2-420f-b737-a766d58e17e6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lindobeach", address="Lindoduin 36-38, 2583 BG Den Haag",
      city="The Hague", country="NL",
      latitude=52.1004988, longitude=4.2747214,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/15f1a761-f761-4499-8d76-7cd350084239_photo.jpg",
      averageRating=4.4, totalRatingsCount=159,
      createdAt="2026-08-31T23:46:05.216979Z", updatedAt="2026-08-31T23:46:05.216979Z",
    ),
    ClubDto(
      id="cf5129f7-0310-4156-a876-0bfe3969d21a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sovicos Volleyball Association Hague", address="Steenwijklaan 16, 2541 RL Den Haag",
      city="The Hague", country="NL",
      latitude=52.0451051, longitude=4.2850943,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/254f31d6-07d2-40ff-9b94-d73ca34231dc_photo.jpg",
      averageRating=4.4, totalRatingsCount=53,
      createdAt="2026-08-31T23:46:18.311228Z", updatedAt="2026-08-31T23:46:18.311228Z",
    ),
    ClubDto(
      id="c0a16c29-a05b-44d8-9d94-3251e0d10118", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="WerkTalent Stadion", address="Haags Kwartier 55, 2491 BM Den Haag",
      city="The Hague", country="NL",
      latitude=52.0627505, longitude=4.3823742,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cdfa9658-fd7e-43f3-aaa7-1d81e3618b97_photo.jpg",
      averageRating=4.4, totalRatingsCount=3092,
      createdAt="2026-08-31T23:44:42.741125Z", updatedAt="2026-08-31T23:44:42.741125Z",
    ),
    ClubDto(
      id="44bc28d5-1a62-49da-88d8-3d7ba0a65b1f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennispark Berg & Dal", address="Daal en Bergselaan 11, 2565 AB Den Haag",
      city="The Hague", country="NL",
      latitude=52.072668, longitude=4.2497884,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fbe6603d-9983-43c7-9a2c-d26d2fe1b875_photo.jpg",
      averageRating=4.3, totalRatingsCount=236,
      createdAt="2026-08-31T23:45:11.738251Z", updatedAt="2026-08-31T23:45:11.738251Z",
    ),
    ClubDto(
      id="9c14fe28-c663-4277-814b-bc8b9f4420db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Welgelegen Tennis B.V. | Tennis & Padel", address="Laan te Blotinghe 1, 2282 NJ Rijswijk",
      city="The Hague", country="NL",
      latitude=52.0561343, longitude=4.3298477,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9b5c7184-4ab7-4b3d-b68e-978baf7e10bd_photo.jpg",
      averageRating=4.3, totalRatingsCount=227,
      createdAt="2026-08-31T23:45:19.039677Z", updatedAt="2026-09-01T14:31:55.599634Z",
    ),
    ClubDto(
      id="fc4a622e-47bd-46a7-a8f3-f8e8ffbeb42a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporthal Leidschenveen", address="Vaz Diasdreef 20, 2492 JL Den Haag",
      city="The Hague", country="NL",
      latitude=52.0673911, longitude=4.3984728,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/63d35cb3-7f1e-4e8a-bd85-c46e509dd75e_photo.jpg",
      averageRating=4.2, totalRatingsCount=155,
      createdAt="2026-08-31T23:46:09.568676Z", updatedAt="2026-08-31T23:46:09.568676Z",
    ),
    ClubDto(
      id="58f3bbbd-f848-4ba6-acd8-cf05ea749a4f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportpark De Verademing", address="Asmansweg 102, 2562 LD Den Haag",
      city="The Hague", country="NL",
      latitude=52.0752424, longitude=4.2879518,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9b692f81-96aa-4b58-ba07-c0adc15abdd2_photo.jpg",
      averageRating=4.2, totalRatingsCount=505,
      createdAt="2026-08-31T23:44:57.753401Z", updatedAt="2026-08-31T23:44:57.753401Z",
    ),
    ClubDto(
      id="0f98c3d5-ba75-4f93-bdce-892aa5676c81", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="HBV The Jumpers", address="Schimmelweg 202, 2283 TP Den Haag",
      city="The Hague", country="NL",
      latitude=52.0490631, longitude=4.3120378,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0ffc21a6-6da4-420f-a9a4-20fe2c41d9c3_photo.jpg",
      averageRating=4.2, totalRatingsCount=49,
      createdAt="2026-08-31T23:45:44.125022Z", updatedAt="2026-08-31T23:45:44.125022Z",
    ),
    ClubDto(
      id="e02050cb-ec3b-4b05-9803-43bc7f416b6a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="De Uithof", address="Jaap Edenweg 10, 2544 NL Den Haag",
      city="The Hague", country="NL",
      latitude=52.0382832, longitude=4.2396679,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/088f1370-efe2-471b-9a0f-6fabef4bc6aa_photo.jpg",
      averageRating=4.1, totalRatingsCount=3733,
      createdAt="2026-08-31T23:46:39.584304Z", updatedAt="2026-08-31T23:46:39.584304Z",
    ),
    ClubDto(
      id="21422622-914b-4874-b125-8854e26e950a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lawn Tennis Club Leeuwenbergh", address="Lindelaan 7, 2495 BA Den Haag",
      city="The Hague", country="NL",
      latitude=52.0584258, longitude=4.3601057,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2b061c2c-8d99-4eb8-8f03-87241df59f93_photo.jpg",
      averageRating=4.1, totalRatingsCount=168,
      createdAt="2026-08-31T23:45:23.452560Z", updatedAt="2026-09-01T14:31:45.752488Z",
    ),
    ClubDto(
      id="22bc94eb-92ec-452a-8a9c-ea9caf320f22", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ockenburgh Active Bowling", address="Wijndaelerduin, Schapenatjesduin 25, 2554 BX Den Haag",
      city="The Hague", country="NL",
      latitude=52.0613121, longitude=4.2209523,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ea75af2d-f262-47c5-ad30-916bc7e133c1_photo.jpg",
      averageRating=4.1, totalRatingsCount=582,
      createdAt="2026-08-31T23:46:48.646617Z", updatedAt="2026-08-31T23:46:48.646617Z",
    ),
    ClubDto(
      id="4bec675b-fd6e-4b78-81f7-a50a6db20086", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Race Planet Delft", address="Kleveringweg 18, 2616 LZ Delft",
      city="The Hague", country="NL",
      latitude=52.025149, longitude=4.36341,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67187669-6c8c-4ecd-a7cd-43afadc81c3a_photo.jpg",
      averageRating=4.1, totalRatingsCount=2395,
      createdAt="2026-08-31T23:46:43.491462Z", updatedAt="2026-08-31T23:46:43.491462Z",
    ),
    ClubDto(
      id="fb958f3b-5e4b-4af9-af37-8ef8bb236362", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporthal Houtrust", address="Laan van Poot 22, 2566 EC Den Haag",
      city="The Hague", country="NL",
      latitude=52.0864639, longitude=4.2681398,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e219d573-22d2-4627-b60a-82f58fd62230_photo.jpg",
      averageRating=3.9, totalRatingsCount=174,
      createdAt="2026-08-31T23:45:39.177954Z", updatedAt="2026-08-31T23:45:39.177954Z",
    ),
    ClubDto(
      id="5d3446bf-d13b-48ad-a2a3-7478a2efca20", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tafeltennisvereniging HTTV-070 🏓", address="Zuidlarenstraat 8, 2545 VX Den Haag",
      city="The Hague", country="NL",
      latitude=52.0508303, longitude=4.268476,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/53cbd426-c329-43e1-a632-f9fbab5fb338_photo.jpg",
      averageRating=4.3, totalRatingsCount=27,
      createdAt="2026-08-31T23:46:34.479232Z", updatedAt="2026-08-31T23:46:34.479232Z",
    ),
    ClubDto(
      id="245b4342-324a-41cd-b850-cd2643782ca8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasertagging", address="Schokkerweg 38, 2583 BH Den Haag",
      city="The Hague", country="NL",
      latitude=52.1004947, longitude=4.2714661,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f784b5f3-3b94-41af-8b80-dc8de5dc0fbe_photo.jpg",
      averageRating=4.9, totalRatingsCount=20,
      createdAt="2026-08-31T23:47:12.555100Z", updatedAt="2026-08-31T23:47:12.555100Z",
    ),
  )),
  CitySeo(slug="glasgow", name="Glasgow", country="GB", clubCount=29, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Volleyball", 4), Pair("Basketball", 3), Pair("Paintball", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Karting", 2), Pair("Climbing", 1), Pair("Laser Tag", 1), Pair("Padel", 1)), clubs=listOf(
    ClubDto(
      id="84338f33-d9ea-47ee-af6a-131135cf906c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Delta Force Paintball Glasgow", address="Turningshaw Rd, Johnstone PA6 7BP",
      city="Glasgow", country="GB",
      latitude=55.8820773, longitude=-4.5228876,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8c939b51-2295-40fb-9807-3319b9b9f1d3_photo.jpg",
      averageRating=4.9, totalRatingsCount=2680,
      createdAt="2026-08-31T23:07:43.841249Z", updatedAt="2026-08-31T23:07:43.841249Z",
    ),
    ClubDto(
      id="d9025dc6-2389-415a-be7e-40a77205f3a8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Glasgow Climbing Centre", address="534 Paisley Rd W, Glasgow G51 1RN",
      city="Glasgow", country="GB",
      latitude=55.8507167, longitude=-4.3053194,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ca41257-cb11-4b5c-97b8-926fb4082818_photo.jpg",
      averageRating=4.8, totalRatingsCount=774,
      createdAt="2026-08-31T23:07:22.375914Z", updatedAt="2026-08-31T23:07:22.375914Z",
    ),
    ClubDto(
      id="8460e0b6-7418-4107-90bc-fcd45c16ccaa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boom Battle Bar Glasgow", address="St. Enoch Shopping Centre, St Enoch Sq, Glasgow G1 4BW",
      city="Glasgow", country="GB",
      latitude=55.8571858, longitude=-4.2540485,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d684b3d-9dee-4d88-9f81-68f57ea7f222_photo.jpg",
      averageRating=4.7, totalRatingsCount=1972,
      createdAt="2026-08-31T23:07:26.942011Z", updatedAt="2026-08-31T23:07:26.942011Z",
    ),
    ClubDto(
      id="e4472315-dff2-487c-b24c-7deeb32e2544", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="David Lloyd Glasgow West End", address="242 Netherton Rd, Anniesland, Glasgow G13 1BJ",
      city="Glasgow", country="GB",
      latitude=55.8979425, longitude=-4.3250531,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/390599fb-a720-4fe8-9565-fcf6cdb5f5a9_photo.jpg",
      averageRating=4.7, totalRatingsCount=1072,
      createdAt="2026-08-31T23:06:11.485682Z", updatedAt="2026-09-01T14:31:56.640289Z",
    ),
    ClubDto(
      id="8958f28d-4d3c-4fbc-9a22-e653dec530e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Strathclyde Sport", address="160 Cathedral St, Glasgow G4 0RQ",
      city="Glasgow", country="GB",
      latitude=55.863339, longitude=-4.2421798,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/95230d55-838f-4b41-92ba-8b7060ee83d4_photo.jpg",
      averageRating=4.7, totalRatingsCount=808,
      createdAt="2026-08-31T23:06:24.476306Z", updatedAt="2026-08-31T23:06:24.476306Z",
    ),
    ClubDto(
      id="70523f7c-ee82-448f-b0b1-70a7489fa953", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TeamSport Go Karting Glasgow Cambuslang", address="Westburn Rd, Cambuslang, Glasgow G72 7UD",
      city="Glasgow", country="GB",
      latitude=55.8218226, longitude=-4.1531496,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6955ab74-3c71-4bd0-a75e-6460ac9186f1_photo.jpg",
      averageRating=4.7, totalRatingsCount=2744,
      createdAt="2026-08-31T23:07:01.718615Z", updatedAt="2026-08-31T23:07:01.718615Z",
    ),
    ClubDto(
      id="117d529b-310b-45e4-bba3-a7dfea5b6fea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Goals Glasgow South", address="941 Pollokshaws Rd, Glasgow G41 2DX",
      city="Glasgow", country="GB",
      latitude=55.8317977, longitude=-4.2762531,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8991a5c7-7cad-4165-8bb5-85ddebcdf793_photo.jpg",
      averageRating=4.6, totalRatingsCount=440,
      createdAt="2026-08-31T23:05:47.521659Z", updatedAt="2026-08-31T23:05:47.521659Z",
    ),
    ClubDto(
      id="c284f965-996d-4365-b718-d0de7f65380c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kelvingrove Lawn Bowls and Tennis Centre", address="Kelvingrove Park, Kelvin Way, Glasgow G3 7TA",
      city="Glasgow", country="GB",
      latitude=55.8670988, longitude=-4.287339,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bcbc469b-859c-4ceb-be02-266ff135f80e_photo.jpg",
      averageRating=4.6, totalRatingsCount=138,
      createdAt="2026-08-31T23:06:48.061750Z", updatedAt="2026-08-31T23:06:48.061750Z",
    ),
    ClubDto(
      id="5cf192e5-3f56-4055-91de-85a202c74b1a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TeamSport Go Karting Glasgow Clydebank", address="25 John Knox St, Glasgow, Clydebank G81 1NA",
      city="Glasgow", country="GB",
      latitude=55.8956433, longitude=-4.3941803,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/df3327de-b4f6-47ad-b278-12b26e06d741_photo.jpg",
      averageRating=4.6, totalRatingsCount=1773,
      createdAt="2026-08-31T23:07:05.754587Z", updatedAt="2026-08-31T23:07:05.754587Z",
    ),
    ClubDto(
      id="51df2a1c-bca1-4af0-9d9a-4e2a3fc930aa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Glasgow International Arena", address="1000 London Rd, Glasgow G40 3HG",
      city="Glasgow", country="GB",
      latitude=55.846978, longitude=-4.2073852,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc6c8c9f-2efb-42a9-9c88-a3f83969d071_photo.jpg",
      averageRating=4.5, totalRatingsCount=1895,
      createdAt="2026-08-31T23:06:19.817852Z", updatedAt="2026-08-31T23:06:19.817852Z",
    ),
    ClubDto(
      id="04d206c7-aa92-467c-a8ad-cd7fdccbee3f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mearns Castle Golf Academy", address="Waterfoot Rd, Newton Mearns, Glasgow G77 5RR",
      city="Glasgow", country="GB",
      latitude=55.7700842, longitude=-4.2911278,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc681599-171d-4f54-b602-9065b47670b2_photo.jpg",
      averageRating=4.5, totalRatingsCount=506,
      createdAt="2026-08-31T23:06:57.395231Z", updatedAt="2026-08-31T23:06:57.395231Z",
    ),
    ClubDto(
      id="44ee1c7e-57cd-48d4-9c69-d8258a31f8a3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Queen’s Park", address="Langside Rd, Glasgow G42 9QL",
      city="Glasgow", country="GB",
      latitude=55.8315832, longitude=-4.2704026,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ad613f7c-f1e3-4451-a6ef-786b477e76db_photo.jpg",
      averageRating=4.5, totalRatingsCount=3519,
      createdAt="2026-08-31T23:05:56.521575Z", updatedAt="2026-08-31T23:05:56.521575Z",
    ),
    ClubDto(
      id="6f49a331-2a78-4a9d-8948-2840c28bbfbb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Scotstoun Leisure centre", address="72 Danes Dr, Glasgow G14 9HD",
      city="Glasgow", country="GB",
      latitude=55.8813133, longitude=-4.3398542,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/57d6724b-b40e-47e8-9351-322922916a31_photo.jpg",
      averageRating=4.5, totalRatingsCount=1437,
      createdAt="2026-08-31T23:06:01.452650Z", updatedAt="2026-08-31T23:06:01.452650Z",
    ),
    ClubDto(
      id="ad5fd80e-5456-48b4-94b1-e5a82b216504", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Topgolf Glasgow", address="10 Duchess Pl, Rutherglen, Glasgow G73 1DR",
      city="Glasgow", country="GB",
      latitude=55.8312332, longitude=-4.2001145,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4be5a1d4-d670-4ca8-a760-62ba9529f1a7_photo.jpg",
      averageRating=4.5, totalRatingsCount=1507,
      createdAt="2026-08-31T23:06:52.968551Z", updatedAt="2026-08-31T23:06:52.968551Z",
    ),
    ClubDto(
      id="102686f7-1b51-488e-8603-590a06aabd78", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Toryglen Regional Football Centre", address="480 Prospecthill Rd, Glasgow G42 0BY",
      city="Glasgow", country="GB",
      latitude=55.8276772, longitude=-4.2433981,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2417287d-f54a-4378-a6c9-b75f57448111_photo.jpg",
      averageRating=4.5, totalRatingsCount=750,
      createdAt="2026-08-31T23:05:30.448350Z", updatedAt="2026-08-31T23:05:30.448350Z",
    ),
    ClubDto(
      id="aa25289f-d8b6-4583-a011-154f0fd73a38", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Garscube Sports Complex", address="West of Scotland Science Park, Maryhill Rd, Glasgow G20 0SP",
      city="Glasgow", country="GB",
      latitude=55.9026696, longitude=-4.3158688,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/416d9538-3963-480d-87bc-37d4d577f81f_photo.jpg",
      averageRating=4.4, totalRatingsCount=234,
      createdAt="2026-08-31T23:06:42.669098Z", updatedAt="2026-08-31T23:06:42.669098Z",
    ),
    ClubDto(
      id="937ba942-886a-49bb-b504-4c1ec0b5aa17", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Glasgow Club Glasgow Green Football Centre", address="28 King's Dr, Glasgow G40 1HB",
      city="Glasgow", country="GB",
      latitude=55.8462213, longitude=-4.2342857,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2dc0beeb-d096-4dc6-b453-403620303de8_photo.jpg",
      averageRating=4.4, totalRatingsCount=400,
      createdAt="2026-08-31T23:05:51.984689Z", updatedAt="2026-08-31T23:05:51.984689Z",
    ),
    ClubDto(
      id="cf8d0ee4-5386-4f30-8d8c-c2b304ae9d2b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Quest & QuizBox Glasgow", address="124 Portman St, Kinning Park, Glasgow G41 1EJ",
      city="Glasgow", country="GB",
      latitude=55.850462, longitude=-4.2818533,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/30ea004b-c230-434f-87ff-4151b77fe8ca_photo.jpg",
      averageRating=4.4, totalRatingsCount=287,
      createdAt="2026-08-31T23:07:37.881373Z", updatedAt="2026-08-31T23:07:37.881373Z",
    ),
    ClubDto(
      id="56243660-d591-4bf1-b435-df101c26898d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Easterhouse Sports Centre", address="12 Auchinlea Rd, Glasgow G34 9HQ",
      city="Glasgow", country="GB",
      latitude=55.869459, longitude=-4.1271868,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2b4459eb-06a6-45c2-b74e-902ab54e6bf6_photo.jpg",
      averageRating=4.3, totalRatingsCount=363,
      createdAt="2026-08-31T23:06:28.701701Z", updatedAt="2026-08-31T23:06:28.701701Z",
    ),
    ClubDto(
      id="caa10e37-1f44-4dd0-9d7f-a65a90ffff74", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hollywood Bowl Springfield Quay", address="Springfield Quay, Kinning Park, Glasgow G5 8NP",
      city="Glasgow", country="GB",
      latitude=55.854345, longitude=-4.2747681,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67244544-11ef-4f37-8f3d-92c7f7db4842_photo.jpg",
      averageRating=4.3, totalRatingsCount=3415,
      createdAt="2026-08-31T23:07:10.463095Z", updatedAt="2026-08-31T23:07:10.463095Z",
    ),
    ClubDto(
      id="048914e2-beb3-4e41-a356-7076e05f98a6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Powerleague Glasgow", address="Powerleague Soccer Centre, 1 Kennedy St, Glasgow G4 0PR",
      city="Glasgow", country="GB",
      latitude=55.8670005, longitude=-4.2381163,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f95e4257-c6c8-4e36-bbd9-114f914b5188_photo.jpg",
      averageRating=4.3, totalRatingsCount=490,
      createdAt="2026-08-31T23:05:43.100313Z", updatedAt="2026-08-31T23:05:43.100313Z",
    ),
    ClubDto(
      id="ec6eec1c-5c4f-4230-855d-c9bca3d0d354", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Glasgow Club Gorbals", address="275 Ballater St, Gorbals, Glasgow G5 0YP",
      city="Glasgow", country="GB",
      latitude=55.8501603, longitude=-4.2459668,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e2ec84d-2608-46d0-99a7-56f4d6b407dc_photo.jpg",
      averageRating=4.2, totalRatingsCount=1082,
      createdAt="2026-08-31T23:06:07.063658Z", updatedAt="2026-08-31T23:06:07.063658Z",
    ),
    ClubDto(
      id="75e6fc49-cbbb-4c36-b585-8550a685d742", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Reardon's Snooker and Pool - Central", address="24 Hope St, Glasgow G2 1AA",
      city="Glasgow", country="GB",
      latitude=55.8591106, longitude=-4.2589757,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c1adc42-302a-4609-b6a3-98f8e6672850_photo.jpg",
      averageRating=4.2, totalRatingsCount=829,
      createdAt="2026-08-31T23:07:32.403804Z", updatedAt="2026-08-31T23:07:32.403804Z",
    ),
    ClubDto(
      id="bad5b193-537a-4615-93fc-10104bba814f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SoccerWorld", address="Soccerworld Croft, 20 Croftcroighn Rd, Glasgow G33 3SL",
      city="Glasgow", country="GB",
      latitude=55.8696992, longitude=-4.1638058,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/40fb0e37-13ad-4bc8-8ec6-2d32b285f9d3_photo.jpg",
      averageRating=4.2, totalRatingsCount=552,
      createdAt="2026-08-31T23:05:38.833488Z", updatedAt="2026-08-31T23:05:38.833488Z",
    ),
    ClubDto(
      id="09956040-d5a3-4f71-b72a-926f310b34e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bedlam Paintball Glasgow Cumbernauld", address="Blairlinn Rd, Cumbernauld, Glasgow G67 4AA",
      city="Glasgow", country="GB",
      latitude=55.9284734, longitude=-3.9720521,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/74e8ae23-7636-4f3e-ad3e-e62670ddd1ff_photo.jpg",
      averageRating=4.1, totalRatingsCount=152,
      createdAt="2026-08-31T23:07:50.224161Z", updatedAt="2026-08-31T23:07:50.224161Z",
    ),
    ClubDto(
      id="e1280676-1457-4b1c-82a7-af04bfa7d870", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hollywood Bowl Glasgow Coatbridge", address="Showcase Leisure Park, Barrbridge Rd, Coatbridge, Glasgow G69 7TZ",
      city="Glasgow", country="GB",
      latitude=55.8484327, longitude=-4.0641304,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/65533cec-6e68-4847-9056-3eb54ffc4755_photo.jpg",
      averageRating=4.1, totalRatingsCount=1639,
      createdAt="2026-08-31T23:07:14.700501Z", updatedAt="2026-08-31T23:07:14.700501Z",
    ),
    ClubDto(
      id="0fb5baa3-ba98-4871-8808-2ec8c659fe48", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="John Wright Sports Centre", address="john wright sports center, Calderwood Rd, East Kilbride, Glasgow G74 3EU",
      city="Glasgow", country="GB",
      latitude=55.7665913, longitude=-4.1611321,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ec508a2c-252a-448a-a245-c965a4603a62_photo.jpg",
      averageRating=4.1, totalRatingsCount=470,
      createdAt="2026-08-31T23:06:33.368266Z", updatedAt="2026-08-31T23:06:33.368266Z",
    ),
    ClubDto(
      id="2f8324c7-a537-4abd-b964-87d29ee10db4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Firhill Complex", address="Firhill Sports Complex, 87 Hopehill Rd, Maryhill, Glasgow G20 7HH",
      city="Glasgow", country="GB",
      latitude=55.8769903, longitude=-4.2688023,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/470853ad-fe48-4a75-9b46-b08002bc1b43_photo.jpg",
      averageRating=4.1, totalRatingsCount=249,
      createdAt="2026-08-31T23:06:37.950446Z", updatedAt="2026-08-31T23:06:37.950446Z",
    ),
    ClubDto(
      id="c6940a5c-2b41-4106-a5a8-ca6078531331", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Court Padel Club", address="Unit 101, 147 Drakemire Dr, Glasgow G45 9SA",
      city="Glasgow", country="GB",
      latitude=55.8045254, longitude=-4.2490747,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/680d55cf-cde3-433a-a056-9fe707ad9c66_photo.jpg",
      averageRating=5.0, totalRatingsCount=23,
      createdAt="2026-08-31T23:06:15.301920Z", updatedAt="2026-08-31T23:06:15.301920Z",
    ),
  )),
  CitySeo(slug="lodz", name="Lodz", country="PL", clubCount=28, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Volleyball", 4), Pair("Basketball", 3), Pair("Golf", 2), Pair("Paintball", 2), Pair("Billiards", 2), Pair("Karting", 2), Pair("Bowling", 2), Pair("Padel", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="804d9908-6786-4885-b2f9-a48ad1686c45", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lobotomy Arena", address="Kwiatowa 37A, 94-238 Łódź",
      city="Lodz", country="PL",
      latitude=51.7871581, longitude=19.3974021,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/43e78d15-e13c-48dc-bbb3-f398e11c331e_photo.jpg",
      averageRating=5.0, totalRatingsCount=700,
      createdAt="2026-08-31T23:39:49.247224Z", updatedAt="2026-08-31T23:39:49.247224Z",
    ),
    ClubDto(
      id="e50a9855-bfbb-4cb0-abf7-217601ccbc8e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Golf Łódź", address="Elektronowa 4, 94-103 Łódź",
      city="Lodz", country="PL",
      latitude=51.7392652, longitude=19.424171,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/811fb200-3526-439f-bfe7-04e6cc5359c7_photo.jpg",
      averageRating=4.9, totalRatingsCount=95,
      createdAt="2026-08-31T23:38:54.921689Z", updatedAt="2026-08-31T23:38:54.921689Z",
    ),
    ClubDto(
      id="42ff463b-bcb1-4e54-8ec0-f42a6798b641", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Euro Tenis", address="Niciarniana 3/5, 92-208 Łódź",
      city="Lodz", country="PL",
      latitude=51.7679801, longitude=19.5060144,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/74f2fb19-0f99-442b-bad4-d098448ccc33_photo.jpg",
      averageRating=4.8, totalRatingsCount=157,
      createdAt="2026-08-31T23:38:03.659447Z", updatedAt="2026-08-31T23:38:03.659447Z",
    ),
    ClubDto(
      id="32c86968-a207-48c7-8150-706c9d55027c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pomorska Tenis Park", address="Pomorska 431a, 92-735 Łódź",
      city="Lodz", country="PL",
      latitude=51.7665302, longitude=19.5666604,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ae8fc387-f3a8-4bc2-aab9-e48942d857cd_photo.jpg",
      averageRating=4.8, totalRatingsCount=84,
      createdAt="2026-08-31T23:38:07.847164Z", updatedAt="2026-08-31T23:38:07.847164Z",
    ),
    ClubDto(
      id="3a38e063-a26a-4cc2-967c-8f3e421ae56f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SAWO GRUZ ARENA", address="al. Józefa Odrowąża 1, 91-134 Łódź",
      city="Lodz", country="PL",
      latitude=51.7925907, longitude=19.383575,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/30393382-1a51-4db2-bfcb-5ed6c7019078_photo.jpg",
      averageRating=4.8, totalRatingsCount=428,
      createdAt="2026-08-31T23:37:46.138263Z", updatedAt="2026-08-31T23:37:46.138263Z",
    ),
    ClubDto(
      id="a12d1bf5-00f3-40ce-b281-91649563a8b5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Battle Arena - Paintball Boat", address="99-120 Piekary",
      city="Lodz", country="PL",
      latitude=52.0845614, longitude=19.4873287,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/047af9e9-5494-437e-b91b-6a9a264053bb_photo.jpg",
      averageRating=4.7, totalRatingsCount=405,
      createdAt="2026-08-31T23:39:54.171467Z", updatedAt="2026-08-31T23:39:54.171467Z",
    ),
    ClubDto(
      id="e7550a42-bed2-482f-932d-8b1a3f4b30a5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Racing Center Łódź - tor gokartowy", address="Wydawnicza 5, 92-333 Łódź",
      city="Lodz", country="PL",
      latitude=51.763221, longitude=19.491859,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/10f68f7e-9a2d-40ad-8650-03e59d684d03_photo.jpg",
      averageRating=4.7, totalRatingsCount=2055,
      createdAt="2026-08-31T23:39:10.724473Z", updatedAt="2026-08-31T23:39:10.724473Z",
    ),
    ClubDto(
      id="9860eacb-9267-4bc3-868b-8c013b451208", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="STREFA Billiards & Darts", address="Al. Marsz. Józefa Piłsudskiego 6, 90-057 Łódź",
      city="Lodz", country="PL",
      latitude=51.7600739, longitude=19.4596284,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1d7d0d8a-8344-4699-b919-a57fb35a6581_photo.jpg",
      averageRating=4.7, totalRatingsCount=1227,
      createdAt="2026-08-31T23:39:44.860880Z", updatedAt="2026-08-31T23:39:44.860880Z",
    ),
    ClubDto(
      id="a638ab58-7452-4e5d-8f0b-6d4e2767a0df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Serce Łodzi - Stadion Widzewa Łódź", address="Al. Marsz. Józefa Piłsudskiego 138, 92-230 Łódź",
      city="Lodz", country="PL",
      latitude=51.7650844, longitude=19.5116544,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/40575b87-6d57-4985-b6cf-732d75c8f5bc_photo.jpg",
      averageRating=4.7, totalRatingsCount=9857,
      createdAt="2026-08-31T23:37:30.406653Z", updatedAt="2026-08-31T23:37:30.406653Z",
    ),
    ClubDto(
      id="044444fb-898f-47ff-840f-cace5bc20a24", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="\"Golf\" - Łódź's first golf club", address="Łagiewnicka 233, 91-509 Łódź",
      city="Lodz", country="PL",
      latitude=51.8178367, longitude=19.4568185,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/df0fa304-f646-40e7-8228-5498b011dc34_photo.jpg",
      averageRating=4.6, totalRatingsCount=87,
      createdAt="2026-08-31T23:39:00.490549Z", updatedAt="2026-08-31T23:39:00.490549Z",
    ),
    ClubDto(
      id="a177ea75-1a13-4f58-b75b-4025f0900d8b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Frame", address="prez. Gabriela Narutowicza 7/lok 311, 90-117 Łódź",
      city="Lodz", country="PL",
      latitude=51.770343, longitude=19.4585889,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/136908e9-508b-4879-af93-e488f49ab262_photo.jpg",
      averageRating=4.6, totalRatingsCount=1378,
      createdAt="2026-08-31T23:39:39.813164Z", updatedAt="2026-08-31T23:39:39.813164Z",
    ),
    ClubDto(
      id="d14acafb-ab9c-4a3b-9c50-c8138b97ca44", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gokart Arena Łódź", address="Smugowa 19, 91-433 Łódź",
      city="Lodz", country="PL",
      latitude=51.782055, longitude=19.466493,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/abf4010e-42ca-4267-9ab3-899882aa486e_photo.jpg",
      averageRating=4.6, totalRatingsCount=1225,
      createdAt="2026-08-31T23:39:21.662596Z", updatedAt="2026-08-31T23:39:21.662596Z",
    ),
    ClubDto(
      id="61f9c013-60d2-4aed-be99-0529d2f63b91", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zatoka Sportu Politechniki Łódzkiej", address="Aleje Politechniki 10, 93-590 Łódź",
      city="Lodz", country="PL",
      latitude=51.7465208, longitude=19.4516285,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/25d508b9-a9a7-4664-8195-a83c37ffc103_photo.jpg",
      averageRating=4.6, totalRatingsCount=5297,
      createdAt="2026-08-31T23:37:35.354759Z", updatedAt="2026-08-31T23:37:35.354759Z",
    ),
    ClubDto(
      id="3555d639-5165-469f-b8f0-a656efb551d6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Academic Sports Association", address="Patrice Lumumby 22/26, 91-404 Łódź",
      city="Lodz", country="PL",
      latitude=51.7815012, longitude=19.4920447,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e768f8a4-7862-4ccb-9766-f03693629314_photo.jpg",
      averageRating=4.5, totalRatingsCount=464,
      createdAt="2026-08-31T23:37:51.232542Z", updatedAt="2026-08-31T23:37:51.232542Z",
    ),
    ClubDto(
      id="3cf86d39-b064-47d6-b13e-6e5fa72659db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Atlas Arena", address="Al. ks. bp. Władysława Bandurskiego 7, 94-020 Łódź",
      city="Lodz", country="PL",
      latitude=51.7572185, longitude=19.4250945,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9603c9f1-47f3-4ef6-bb6c-ae0ab15e32af_photo.jpg",
      averageRating=4.5, totalRatingsCount=16797,
      createdAt="2026-08-31T23:37:26.340484Z", updatedAt="2026-08-31T23:37:26.340484Z",
    ),
    ClubDto(
      id="2a2c3d07-739c-4e8c-8ede-59dd3b8f9c85", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="King of Bowling Balls", address="CH Sukcesja, Aleje Politechniki 1, 93-590 Łódź",
      city="Lodz", country="PL",
      latitude=51.7498283, longitude=19.4490566,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9f30a4bf-d4e6-415c-8dca-c5279b2ce187_photo.jpg",
      averageRating=4.5, totalRatingsCount=2470,
      createdAt="2026-08-31T23:39:26.909933Z", updatedAt="2026-08-31T23:39:26.909933Z",
    ),
    ClubDto(
      id="2d2a4e49-1710-4e6f-becc-650e9f905f2d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Club Spolem", address="Północna 36, 91-425 Łódź",
      city="Lodz", country="PL",
      latitude=51.7819023, longitude=19.4705047,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3b6fa7ba-b04f-4a34-a6a5-f452a6d5c2d3_photo.jpg",
      averageRating=4.5, totalRatingsCount=273,
      createdAt="2026-08-31T23:38:40.004930Z", updatedAt="2026-08-31T23:38:40.004930Z",
    ),
    ClubDto(
      id="79431710-cdb7-4e71-ba3f-da36c07706c4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hala Sportowa MOSiR - Łodź", address="Stanisława Małachowskiego 5/7, 92-211 Łódź",
      city="Lodz", country="PL",
      latitude=51.7705279, longitude=19.498644,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96bc1d9e-ed98-449f-bb3f-457c28b9c7b9_photo.jpg",
      averageRating=4.4, totalRatingsCount=354,
      createdAt="2026-08-31T23:38:28.299018Z", updatedAt="2026-08-31T23:38:28.299018Z",
    ),
    ClubDto(
      id="f22db0af-93fb-47c7-a0df-5d9318a8bd7c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MOSiR Zgierz", address="Wschodnia 2, 95-100 Zgierz",
      city="Lodz", country="PL",
      latitude=51.8491327, longitude=19.4173243,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/400b119d-762a-438c-a3e6-f44effcb4c81_photo.jpg",
      averageRating=4.4, totalRatingsCount=695,
      createdAt="2026-08-31T23:38:19.392258Z", updatedAt="2026-08-31T23:38:19.392258Z",
    ),
    ClubDto(
      id="401321a0-9e54-4558-b593-3f9050567829", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Municipal Tennis Club", address="Stefana Żeromskiego 117, 90-542 Łódź",
      city="Lodz", country="PL",
      latitude=51.7548334, longitude=19.4421577,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/46a3b391-4f2e-4ac3-92dd-c20ccf0718b3_photo.jpg",
      averageRating=4.4, totalRatingsCount=195,
      createdAt="2026-08-31T23:37:57.532090Z", updatedAt="2026-08-31T23:37:57.532090Z",
    ),
    ClubDto(
      id="d6a7cd46-dca7-4baa-a088-277dbd66b070", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UKS Anilana", address="Sobolowa 1, 90-993 Łódź",
      city="Lodz", country="PL",
      latitude=51.7602806, longitude=19.5136888,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/692a4254-7702-4b22-bdec-4ea80e10a9a0_photo.jpg",
      averageRating=4.3, totalRatingsCount=530,
      createdAt="2026-08-31T23:38:35.149153Z", updatedAt="2026-08-31T23:38:35.149153Z",
    ),
    ClubDto(
      id="4c6dcd5c-7930-42a6-a4a3-68aaf5bd2bc9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Obiekt sportowy Karpacka - MOSiR Łódź", address="Karpacka 61, 93-536 Łódź",
      city="Lodz", country="PL",
      latitude=51.7252824, longitude=19.4617235,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/faed2ad2-2f21-465f-9827-1eaafe0ecc95_photo.jpg",
      averageRating=4.2, totalRatingsCount=374,
      createdAt="2026-08-31T23:38:24.365405Z", updatedAt="2026-08-31T23:38:24.365405Z",
    ),
    ClubDto(
      id="4b617ee6-6236-4947-9f77-c706251e6022", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="VeraSport", address="Siewna 15, 94-250 Łódź",
      city="Lodz", country="PL",
      latitude=51.7801496, longitude=19.4022069,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/15cdb507-57ad-494f-945c-0f5678f33c29_photo.jpg",
      averageRating=4.2, totalRatingsCount=727,
      createdAt="2026-08-31T23:37:41.108316Z", updatedAt="2026-08-31T23:37:41.108316Z",
    ),
    ClubDto(
      id="6b5f7bc6-64d9-478a-9ee8-24a77ec2e09d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MKS Metalowiec Lodz", address="Stanisława Jachowicza 1, 93-177 Łódź",
      city="Lodz", country="PL",
      latitude=51.7378421, longitude=19.4749021,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/05d7580b-7813-49b8-8f99-0ea94191c7d0_photo.jpg",
      averageRating=4.1, totalRatingsCount=209,
      createdAt="2026-08-31T23:38:44.498221Z", updatedAt="2026-08-31T23:38:44.498221Z",
    ),
    ClubDto(
      id="bc0b3e67-f24e-4072-abed-997cd7a31ef8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BOHO BEACH BAR MANUFAKTURA", address="Drewnowska 58, 91-002 Łódź",
      city="Lodz", country="PL",
      latitude=51.7807784, longitude=19.4466523,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9a8d8c0e-796a-4df8-8cfa-28b7f56a5319_photo.jpg",
      averageRating=4.4, totalRatingsCount=44,
      createdAt="2026-08-31T23:38:48.071221Z", updatedAt="2026-08-31T23:38:48.071221Z",
    ),
    ClubDto(
      id="189115ba-792c-4ed9-90a9-78c619f070db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stacja Padel", address="Kolumny 27, 93-610 Łódź",
      city="Lodz", country="PL",
      latitude=51.7096062, longitude=19.491715,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/874c0a9c-311a-4d7d-a5fe-1aab583cbadc_photo.jpg",
      averageRating=4.2, totalRatingsCount=23,
      createdAt="2026-08-31T23:38:12.574353Z", updatedAt="2026-08-31T23:38:12.574353Z",
    ),
    ClubDto(
      id="9f17359f-fdfb-4b2b-b70d-bbb4128f9ffe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Strefa Odbicia - Więcej Niż Tenis Stołowy", address="Brukowa 14, 91-341 Łódź",
      city="Lodz", country="PL",
      latitude=51.7995802, longitude=19.4085851,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6df44f28-af87-4d88-8bb6-42e867427c83_photo.jpg",
      averageRating=4.8, totalRatingsCount=13,
      createdAt="2026-08-31T23:39:05.327815Z", updatedAt="2026-08-31T23:39:05.327815Z",
    ),
    ClubDto(
      id="1abe0107-a03b-4f5f-b437-8c7cba09ca74", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportbowling", address="Drewnowska 58A, 91-002 Łódź",
      city="Lodz", country="PL",
      latitude=51.78032, longitude=19.449223,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e3eb6eab-43e7-4b51-b4c2-af8ca6602946_photo.jpg",
      averageRating=3.7, totalRatingsCount=11,
      createdAt="2026-08-31T23:39:31.085364Z", updatedAt="2026-08-31T23:39:31.085364Z",
    ),
  )),
  CitySeo(slug="lisbon", name="Lisbon", country="PT", clubCount=28, sports=listOf(Pair("Football", 5), Pair("Volleyball", 3), Pair("Padel", 3), Pair("Tennis", 3), Pair("Basketball", 3), Pair("Bowling", 2), Pair("Paintball", 2), Pair("Climbing", 2), Pair("Karting", 1), Pair("Golf", 1), Pair("Laser Tag", 1), Pair("Table Tennis", 1), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="e761b43b-125e-4a1c-bd82-d2a582413cec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Emboscada Parque Aventura - Monsanto", address="Lisboa Camping & Bungalows – Alto de Cabreira, Estr. da Circunvalação, 1400-061 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7246822, longitude=-9.2073704,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6efe0631-22d3-49f7-a182-c16e0d4f12b5_ChIJ6xMk9mbN_1.jpg",
      averageRating=4.9, totalRatingsCount=739,
      createdAt="2026-08-30T21:38:16.895088Z", updatedAt="2026-08-31T22:11:16.171290Z",
    ),
    ClubDto(
      id="e9d5f625-5b00-4837-a2cc-9ec16189a07a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Escala25", address="Avenida da Índia, Pte. 25 de Abril 52 Pilar 7, 1300-299 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7003533, longitude=-9.1788072,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77964cb6-00d2-4888-bf01-9cb768309839_ChIJRb0fXF81_0.jpg",
      averageRating=4.8, totalRatingsCount=483,
      createdAt="2026-08-30T21:37:56.691995Z", updatedAt="2026-08-30T21:56:36.095659Z",
    ),
    ClubDto(
      id="34ad41f3-e647-41b2-85a7-4f138cd4afc5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="W Padel Country Club", address="Lisboa Clube Ténis, 1500-114 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7293764, longitude=-9.205967,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cbf296c8-e89d-4bac-a5ac-68c396ce88c5_ChIJpxiDiCrN_0.jpg",
      averageRating=4.7, totalRatingsCount=348,
      createdAt="2026-08-30T21:38:37.629698Z", updatedAt="2026-08-30T21:38:37.629698Z",
    ),
    ClubDto(
      id="c969cc8a-eda1-439d-98c7-de2389bd7c77", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LX Indoor Padel", address="R. Palmares, 2680-159 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.8007094, longitude=-9.1426565,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c11d8aa0-54be-4aa2-bc4e-97a1472dcafc_ChIJ9cAVeYEt_0.jpg",
      averageRating=4.6, totalRatingsCount=516,
      createdAt="2026-08-30T21:38:30.677604Z", updatedAt="2026-08-30T21:38:30.677604Z",
    ),
    ClubDto(
      id="a88d6433-81cc-4f8c-a795-b2a79c538af2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vertigo Marvila - Climbing Center", address="Edifício Beira Rio, Av. Infante Dom Henrique Fração S, 1950-408 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7400043, longitude=-9.102017,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9475dcd4-5c01-4671-b5b5-9c668f2fa664_ChIJUZsEet8z_0.jpg",
      averageRating=4.6, totalRatingsCount=1073,
      createdAt="2026-08-30T21:37:50.211363Z", updatedAt="2026-08-30T22:02:10.371092Z",
    ),
    ClubDto(
      id="437bf3d3-c961-4666-a63d-216b733c4765", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lisboa Racket Centre", address="R. Alferes Malheiro, 1700-025 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7584309, longitude=-9.13433,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f5ae6b74-6727-4cbf-b9c4-d7923439144d_ChIJyxUyPVIy_0.jpg",
      averageRating=4.5, totalRatingsCount=732,
      createdAt="2026-08-30T21:38:50.917699Z", updatedAt="2026-09-01T14:32:01.678618Z",
    ),
    ClubDto(
      id="389aed9b-0d9d-42f7-87b4-fbaadfc4bcd9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Campo Grande", address="Jardim do, 1700-090 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.757071, longitude=-9.1529886,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9996ee3c-dfc5-4a7c-b312-7612df89d24b_ChIJ933BWvwy_3.jpg",
      averageRating=4.5, totalRatingsCount=640,
      createdAt="2026-08-30T21:38:57.706349Z", updatedAt="2026-09-01T14:31:55.252807Z",
    ),
    ClubDto(
      id="4857756d-9383-4469-a76a-7db52f7c4e52", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SUD Lisboa Terrazza", address="Pavilhão Poente (ao lado do MAAT, Av. Brasília, 1300-598 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.6963541, longitude=-9.1917573,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3800b744-e7ca-40d4-bce9-0609bed9f410_ChIJ3Qt2HU3L_0.jpg",
      averageRating=4.5, totalRatingsCount=10806,
      createdAt="2026-08-30T21:37:23.037365Z", updatedAt="2026-08-30T21:59:53.353095Z",
    ),
    ClubDto(
      id="3c195a55-5323-400d-8521-e9404e74a967", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UrbanSoccer", address="Grupo Desportivo Direito Parque Florestal de Monsanto, 1500-000 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7290756, longitude=-9.2062751,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ad12cd5-1885-47e7-80df-2d196ad3b6d8_ChIJ0VL4IsfM_0.jpg",
      averageRating=4.5, totalRatingsCount=1124,
      createdAt="2026-08-30T21:37:02.741602Z", updatedAt="2026-08-30T22:01:53.173382Z",
    ),
    ClubDto(
      id="3895d386-1878-466e-80ab-03218884ac2b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Volei", address="Av. Prof. Egas Moniz, 1600-190 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7506996, longitude=-9.164202,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ffb3e24-3128-40b8-a9d9-2dfea067b68e_photo.jpg",
      averageRating=4.5, totalRatingsCount=140,
      createdAt="2026-08-31T15:17:04.766329Z", updatedAt="2026-08-31T15:17:04.766329Z",
    ),
    ClubDto(
      id="a73841a7-9818-4bb8-862c-fd5bb62220c5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling City Colombo", address="Piso 2, Loja A 204, Av. Lusíada, 1500-392 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7551884, longitude=-9.1869079,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/180cfa99-89c5-423e-a10a-9670340f8e7e_ChIJK3_kYNQy_0.jpg",
      averageRating=4.4, totalRatingsCount=2024,
      createdAt="2026-08-30T21:37:43.496517Z", updatedAt="2026-08-30T21:55:39.442422Z",
    ),
    ClubDto(
      id="83becaf9-9f70-4993-84ba-d80b9f40366c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Clube de Padel", address="Doca de Santo Amaro, 1350-353 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.6990555, longitude=-9.17938,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4cc347dc-004c-4a89-b58d-132289fccec7_ChIJgQGeWpA1_0.jpg",
      averageRating=4.4, totalRatingsCount=225,
      createdAt="2026-08-30T21:38:44.155441Z", updatedAt="2026-08-30T21:38:44.155441Z",
    ),
    ClubDto(
      id="ed0918bc-fa34-4b4d-a029-b2dc421ea748", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Emboscada Parque Aventura Cascais", address="PQFX+R6, Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7245309, longitude=-9.2018805,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a43e25a6-37bc-468c-826d-9e34662a9f3c_ChIJnRgNn6rF_1.jpg",
      averageRating=4.4, totalRatingsCount=107,
      createdAt="2026-08-30T21:38:24.161685Z", updatedAt="2026-08-31T22:11:16.332913Z",
    ),
    ClubDto(
      id="9cb70a17-ade4-4b40-a84b-2822778c4565", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kartódromo do Montijo", address="R. do Charqueirão 657, 2870-669 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.6895657, longitude=-8.9404973,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eaab3b8d-4da2-4835-8792-e88bca38d0f5_ChIJnavb1yY5_0.jpg",
      averageRating=4.4, totalRatingsCount=1815,
      createdAt="2026-08-30T21:38:03.696339Z", updatedAt="2026-08-30T21:57:32.066329Z",
    ),
    ClubDto(
      id="7140b6af-23ce-481f-82e6-ef871c871b06", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lisbon Sports Club", address="Rua do Golfe nº 17, 2605-213 Belas",
      city="Lisbon", country="PT",
      latitude=38.7976639, longitude=-9.2758611,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/73d99036-18f6-4e05-9d71-241dca4b22d5_photo.jpg",
      averageRating=4.4, totalRatingsCount=423,
      createdAt="2026-08-31T15:18:09.998380Z", updatedAt="2026-08-31T15:18:09.998380Z",
    ),
    ClubDto(
      id="1652e63a-0252-4356-a049-9680dfe47de8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Login Laser Tag", address="R. Proletariado 2 Armazém 3, 2790-138 Carnaxide",
      city="Lisbon", country="PT",
      latitude=38.7205563, longitude=-9.2158364,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/05d79781-5df8-4c9d-ab3d-8cdcb77b31ac_photo.jpg",
      averageRating=4.4, totalRatingsCount=1144,
      createdAt="2026-08-31T15:18:26.713987Z", updatedAt="2026-08-31T22:11:18.504838Z",
    ),
    ClubDto(
      id="af0fc85c-1744-4759-b077-43967e2c8a17", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="THE ONE Hills Lisbon City Golf", address="Rua Formozinho Sanches, R. E da Quinta dos Alcoutins 79, 1600-263 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.776003, longitude=-9.171194,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/23486dd7-918e-425a-91c0-dd784bd041e1_ChIJQ55T0L0y_0.jpg",
      averageRating=4.3, totalRatingsCount=617,
      createdAt="2026-08-30T21:37:09.422732Z", updatedAt="2026-08-30T22:01:17.750944Z",
    ),
    ClubDto(
      id="f33a55de-e56e-41e8-a5bf-06e687795124", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Clube de Ténis de Monsanto", address="Estr. do Clube de Ténis, Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7176929, longitude=-9.1812048,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0f8158e4-f6e6-49c1-9d1d-a8eeb606bb6b_ChIJwTFtWFAz_0.jpg",
      averageRating=4.2, totalRatingsCount=579,
      createdAt="2026-08-30T21:39:05.292002Z", updatedAt="2026-08-30T21:39:05.292002Z",
    ),
    ClubDto(
      id="192b1397-7201-41e2-adca-bbe185bc8802", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Complexo Desportivo Clube TAP Portugal", address="Alameda Encarnação, 1700-111 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7704499, longitude=-9.1227032,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/48119275-3bf7-4dde-965e-6d94326833fe_ChIJjZ50a04y_1.jpg",
      averageRating=4.2, totalRatingsCount=536,
      createdAt="2026-08-30T21:37:16.529015Z", updatedAt="2026-08-31T22:11:15.303741Z",
    ),
    ClubDto(
      id="3cc164b1-44c7-42c4-b158-122667ba3897", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Joker Lounge", address="Av. Marquês de Tomar 44 b 1050-053, 1050-156 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7372192, longitude=-9.1494244,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6f9723ab-211c-4fe1-86a8-6041f6fbecab_ChIJgdZUxwsz_0.jpg",
      averageRating=4.0, totalRatingsCount=3367,
      createdAt="2026-08-30T21:37:36.837186Z", updatedAt="2026-08-30T21:37:36.837186Z",
    ),
    ClubDto(
      id="3a2c87f0-1f80-48b8-882c-246467fd3825", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport Lisboa e Olivais", address="Campo de Futebol, R. de Chibuto 1 R/C, 1800-012 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7615499, longitude=-9.1081876,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e48e75c-c1bb-4554-b051-4f3f1c4885e8_ChIJH1-4ICwy_0.jpg",
      averageRating=4.0, totalRatingsCount=1327,
      createdAt="2026-08-30T21:36:55.653499Z", updatedAt="2026-08-30T21:36:55.653499Z",
    ),
    ClubDto(
      id="fea7b353-fa0e-419d-b474-aa8555d6deca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Olissipo Table Tennis Club", address="R. Palmares nº2A 2º andar, 2680-159 Camarate",
      city="Lisbon", country="PT",
      latitude=38.8023856, longitude=-9.1440545,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/adf5e4a3-20fc-4875-b7ae-58f1b0ddd99c_photo.jpg",
      averageRating=4.6, totalRatingsCount=43,
      createdAt="2026-08-31T15:18:16.298981Z", updatedAt="2026-08-31T15:18:16.298981Z",
    ),
    ClubDto(
      id="e543081e-ca2f-4f3d-ba87-06301b3da398", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Parque de Jogos Victor Peralta - Operário Futebol Clube de Lisboa", address="R. do Bar. de Monte Pedral, 1170-039 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7217821, longitude=-9.1209711,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/089fbd85-82d5-42b3-aec4-2df793ed4e28_photo.jpg",
      averageRating=3.9, totalRatingsCount=376,
      createdAt="2026-08-31T15:17:31.247996Z", updatedAt="2026-08-31T15:17:31.247996Z",
    ),
    ClubDto(
      id="b3b42efb-0daa-4531-85bb-78aec08ffb17", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Team Lisbon Footvolley", address="R. Oliveira Cadornega, 1950-211 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7538876, longitude=-9.109872,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/222d7d6b-670c-4be4-ba09-1a365581e24f_photo.jpg",
      averageRating=5.0, totalRatingsCount=33,
      createdAt="2026-08-31T15:17:49.256633Z", updatedAt="2026-08-31T15:17:49.256633Z",
    ),
    ClubDto(
      id="2685c121-6eaf-4e46-9ae7-4caea6bab01b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Clube PlaySports - Voleibol", address="Largo José Joaquim Rodrigues 15, 2685-074 Sacavém",
      city="Lisbon", country="PT",
      latitude=38.7919721, longitude=-9.1123274,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d653e77-bdfe-4e82-aa02-9f13a70a15ff_photo.jpg",
      averageRating=4.6, totalRatingsCount=26,
      createdAt="2026-08-31T15:17:52.705212Z", updatedAt="2026-08-31T15:17:52.705212Z",
    ),
    ClubDto(
      id="032b2209-9d85-42ff-a1f0-2bff5446b1ea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lisbon Sun Setters", address="Praia de Carcavelos, 1700-000 Carcavelos",
      city="Lisbon", country="PT",
      latitude=38.6793952, longitude=-9.3340553,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d4c4e8c1-9fd4-49ef-b596-abc098114b5e_photo.jpg",
      averageRating=4.9, totalRatingsCount=10,
      createdAt="2026-08-31T15:17:42.446998Z", updatedAt="2026-08-31T15:17:42.446998Z",
    ),
    ClubDto(
      id="8eb431c9-2599-49b6-9531-723fb819ff41", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AD Pastéis Beachsoccer Arena", address="Av. João Paulo II, 1950-156 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7446325, longitude=-9.1143798,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/918a2602-e9ee-44ac-8d09-33c3088cc95e_photo.jpg",
      averageRating=4.8, totalRatingsCount=8,
      createdAt="2026-08-31T15:18:00.864003Z", updatedAt="2026-08-31T15:18:00.864003Z",
    ),
    ClubDto(
      id="8e747fcf-cd5a-4cf6-a2c0-caa4390605ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Portugal Basketball Festival", address="Av. Rio de Janeiro, 1700-330 Lisboa",
      city="Lisbon", country="PT",
      latitude=38.7519755, longitude=-9.1381378,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d3fdf210-02af-4182-8400-43e1e1562d04_photo.jpg",
      averageRating=4.7, totalRatingsCount=6,
      createdAt="2026-08-31T15:17:22.661716Z", updatedAt="2026-08-31T15:17:22.661716Z",
    ),
  )),
  CitySeo(slug="antalya", name="Antalya", country="TR", clubCount=28, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Basketball", 3), Pair("Padel", 3), Pair("Paintball", 2), Pair("Karting", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Volleyball", 2), Pair("Laser Tag", 1), Pair("Bowling", 1), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="018ba7eb-2bd6-4fc8-a6f6-e6e742436fd6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lara Padel Club (Antalya)", address="Güzeloluk, 1885. Sk. No:38, 07200 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8828197, longitude=30.7749055,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a17a6d84-caf7-4d48-8cf5-ff7d57163052_photo.jpg",
      averageRating=5.0, totalRatingsCount=98,
      createdAt="2026-08-31T23:56:40.909961Z", updatedAt="2026-08-31T23:56:40.909961Z",
    ),
    ClubDto(
      id="53ecefa8-54fc-4ecd-b0e4-5dc83b52b755", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AICOSPORTS PARK - FUTBOL OKULU", address="Şafak, 4540/1 Sokak No:6, 07220 Kepez/Antalya",
      city="Antalya", country="TR",
      latitude=36.9136605, longitude=30.6325108,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8196771f-ca42-4aa3-965c-ba20023d72e1_photo.jpg",
      averageRating=4.9, totalRatingsCount=303,
      createdAt="2026-08-31T23:56:07.261276Z", updatedAt="2026-08-31T23:56:07.261276Z",
    ),
    ClubDto(
      id="9ba8fda6-f2bd-4049-9345-e5a520ec69a1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Antalya Getto Paintball", address="no:, Fener, 1907. Sk. No:56, 07160 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8604975, longitude=30.7515616,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f44cb58f-ba47-4bf5-bd38-b8f888a85ec2_photo.jpg",
      averageRating=4.9, totalRatingsCount=555,
      createdAt="2026-08-31T23:58:10.676536Z", updatedAt="2026-08-31T23:58:10.676536Z",
    ),
    ClubDto(
      id="e97d66a3-34d7-4408-a36d-b1dc46f31af4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Power Paintball Alanya", address="İncekum, karabuynuzlar no No:637, 07415 Alanya/Antalya",
      city="Antalya", country="TR",
      latitude=36.6652262, longitude=31.7349071,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/66f63290-79b0-453d-b5a5-3f14125a6feb_photo.jpg",
      averageRating=4.9, totalRatingsCount=114,
      createdAt="2026-08-31T23:58:16.345224Z", updatedAt="2026-08-31T23:58:16.345224Z",
    ),
    ClubDto(
      id="7e822e92-7078-44f1-8489-b4a24972dc84", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Antalya Lara Tenis Kulübü", address="Güzelbağ, Zeybek Sk. No 117, 07070 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.873881, longitude=30.793711,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/35358b41-ada0-4a85-ac70-04ddf124f5be_photo.jpg",
      averageRating=4.8, totalRatingsCount=148,
      createdAt="2026-08-31T23:56:31.527741Z", updatedAt="2026-08-31T23:56:31.527741Z",
    ),
    ClubDto(
      id="d62df2f9-8cc2-493b-8a9f-670e14575ca2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boulder Jungle Climbing Gym", address="Mehmet akif ersoy mah. 6769 sok No 1A 8, Mehmet Akif Ersoy, 07090 Kepez/Antalya",
      city="Antalya", country="TR",
      latitude=36.9264287, longitude=30.7259762,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/81140e1d-1ebe-489c-b976-e8458c850496_photo.jpg",
      averageRating=4.8, totalRatingsCount=148,
      createdAt="2026-08-31T23:57:50.782272Z", updatedAt="2026-08-31T23:57:50.782272Z",
    ),
    ClubDto(
      id="9cf2189d-04c0-498f-a49f-a744be871f5f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gloria Golf Resort", address="Belek, Turizm Cad No: 74, 07506 Serik/Antalya",
      city="Antalya", country="TR",
      latitude=36.8404684, longitude=31.1123667,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/81e2edf7-6b87-4191-9921-fb2b29707077_photo.jpg",
      averageRating=4.8, totalRatingsCount=3982,
      createdAt="2026-08-31T23:57:20.739309Z", updatedAt="2026-08-31T23:57:20.739309Z",
    ),
    ClubDto(
      id="66c17366-4fed-493f-aa03-cf2cf40cc025", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cullinan Links Golf Club", address="Belek Üçkum Tepesi Mevkii, Kadriye, 07525 Serik/Antalya",
      city="Antalya", country="TR",
      latitude=36.8628375, longitude=30.9720092,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8473883c-1790-4728-b9bd-ef8c9fb78ac6_photo.jpg",
      averageRating=4.7, totalRatingsCount=1816,
      createdAt="2026-08-31T23:57:25.093285Z", updatedAt="2026-08-31T23:57:25.093285Z",
    ),
    ClubDto(
      id="f00a3f05-f7a8-4b79-a5ce-77faad95f2ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FUNBOX BOWLING", address="MarkAntalya Mall, Tahılpazarı, Kazım Özalp Cd. No:84, 07040 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8928954, longitude=30.7039314,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/85e59c06-bfa0-42b1-bbdd-db71c451f7b3_photo.jpg",
      averageRating=4.7, totalRatingsCount=1484,
      createdAt="2026-08-31T23:57:40.138726Z", updatedAt="2026-08-31T23:57:40.138726Z",
    ),
    ClubDto(
      id="dcf30fbc-a909-4e55-bf6f-056733836794", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gloria Sports Arena", address="Belek, Turizm Cd. No: 4, 07506 Serik/Antalya",
      city="Antalya", country="TR",
      latitude=36.8618358, longitude=31.0532769,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7dca493e-d2fd-4cfb-972d-a297f3007c3f_photo.jpg",
      averageRating=4.7, totalRatingsCount=127,
      createdAt="2026-08-31T23:57:16.174723Z", updatedAt="2026-08-31T23:57:16.174723Z",
    ),
    ClubDto(
      id="13c6c32e-22aa-47e6-8f7f-539fe52016c7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Antalya Sport Complex", address="Meltem, 07030 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8879141, longitude=30.6735418,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e659406d-8f15-4992-b805-bc6e1e2e97f8_photo.jpg",
      averageRating=4.6, totalRatingsCount=1686,
      createdAt="2026-08-31T23:56:57.215773Z", updatedAt="2026-08-31T23:56:57.215773Z",
    ),
    ClubDto(
      id="b9d69162-5ff9-40a1-b77c-7e0a094253ff", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Megasaray Tennis Academy", address="Kadriye, 07525 Serik/Antalya",
      city="Antalya", country="TR",
      latitude=36.8787307, longitude=30.9795761,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8ffd0ec4-c7a6-4d12-8e49-b84330a7dfcd_photo.jpg",
      averageRating=4.6, totalRatingsCount=157,
      createdAt="2026-08-31T23:56:26.240372Z", updatedAt="2026-09-01T14:31:43.854270Z",
    ),
    ClubDto(
      id="9be19e09-0083-4e21-ac89-9f1f67dac7d9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ANTALYA TENNIS CLUB AND SPORTS SPECIALIZED", address="Meltem, Sakıp Sabancı Blv. No:5, 07070 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8862714, longitude=30.6723622,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/230c7184-a02e-4597-b475-494971bb8c0a_photo.jpg",
      averageRating=4.5, totalRatingsCount=888,
      createdAt="2026-08-31T23:56:20.982642Z", updatedAt="2026-08-31T23:56:20.982642Z",
    ),
    ClubDto(
      id="48de76e9-e9e8-4096-bdb8-dc428063d9ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FitSector", address="No:82, Akkuyu, 25. Cd., 07070 Konyaaltı/Antalya",
      city="Antalya", country="TR",
      latitude=36.8821631, longitude=30.633875,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/517cd39c-d03a-41be-8b24-d8f96b014ef9_photo.jpg",
      averageRating=4.5, totalRatingsCount=202,
      createdAt="2026-08-31T23:57:44.433487Z", updatedAt="2026-08-31T23:57:44.433487Z",
    ),
    ClubDto(
      id="9e35926d-d707-45cd-9257-2eea5227bdab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Muratpaşa Belediyesi Süleyman Erol Olimpik Yüzme Havuzu", address="Süleyman Erol Yüzme Havuzu, Yeşilbahçe, Portakal Çiçeği Cd., 07070 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8732969, longitude=30.7231769,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6496c62d-df55-456e-9f75-cfbd8feb9f0a_photo.jpg",
      averageRating=4.5, totalRatingsCount=454,
      createdAt="2026-08-31T23:57:11.335373Z", updatedAt="2026-08-31T23:57:11.335373Z",
    ),
    ClubDto(
      id="3d3e6877-e6d1-4caf-a4f2-e574f5b3c892", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Antalya Gokart, Çocuk oyun alanı, Bowling", address="Altıntaş, Yörükoğlu Cd. No:15, 07112 Aksu/Antalya",
      city="Antalya", country="TR",
      latitude=36.886576, longitude=30.8189601,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1224160d-1c51-4348-a9f8-5209d223ce5a_photo.jpg",
      averageRating=4.4, totalRatingsCount=1889,
      createdAt="2026-08-31T23:57:29.820973Z", updatedAt="2026-08-31T23:57:29.820973Z",
    ),
    ClubDto(
      id="11a45350-f362-4f6c-9c89-f322b8911c9e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Club PRO Antalya", address="Go-Kart, Fatih, Antalya Blv. No: 410/3, 07080 Kepez/Antalya",
      city="Antalya", country="TR",
      latitude=36.9478016, longitude=30.6421172,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6215e7a9-20ba-4845-8d39-2a453b1dd94c_photo.jpg",
      averageRating=4.4, totalRatingsCount=378,
      createdAt="2026-08-31T23:57:34.294695Z", updatedAt="2026-08-31T23:57:34.294695Z",
    ),
    ClubDto(
      id="c44addbe-1797-4b40-aa07-27f0dd7c04b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Camp D Padel", address="Altınkale, 4554 sok no 10, 07190 Döşemealtı/Antalya",
      city="Antalya", country="TR",
      latitude=36.99258, longitude=30.589966,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/afb79c94-13b7-4e00-a695-55b2affe31a5_photo.jpg",
      averageRating=4.8, totalRatingsCount=45,
      createdAt="2026-08-31T23:56:46.993416Z", updatedAt="2026-08-31T23:56:46.993416Z",
    ),
    ClubDto(
      id="a4043a51-9a94-4c59-8de5-03256b33ec55", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ATİK-SEM", address="Meltem Mahallesi, 2. Cad. Arpet Sitesi karşısı, Muratpaşa, 07030 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8895797, longitude=30.6694431,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c3cbece-5da5-478b-94a2-99cb835ae5a7_photo.jpg",
      averageRating=4.3, totalRatingsCount=71,
      createdAt="2026-08-31T23:56:35.416853Z", updatedAt="2026-09-01T14:31:59.341260Z",
    ),
    ClubDto(
      id="99c4255e-67df-48f0-92c9-55b6f12f46d9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Anadolu Park", address="Konak, Serik Cd. Yanyolu, 07112 Çıkışı/Antalya",
      city="Antalya", country="TR",
      latitude=36.9472327, longitude=30.8372051,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b9464572-feaa-488e-9a1c-85360311e361_photo.jpg",
      averageRating=4.3, totalRatingsCount=1009,
      createdAt="2026-08-31T23:58:06.526451Z", updatedAt="2026-08-31T23:58:06.526451Z",
    ),
    ClubDto(
      id="2977e8b5-369d-4aaa-a1c2-640db38d17a3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="V7 PADEL Antalya", address="Molla Yusuf, Hürriyet Cd. No:51, 07070 Konyaaltı/Antalya",
      city="Antalya", country="TR",
      latitude=36.8965777, longitude=30.610447,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/170c3fe2-438d-4767-a61b-5d29590c4ba4_photo.jpg",
      averageRating=4.8, totalRatingsCount=44,
      createdAt="2026-08-31T23:56:52.096630Z", updatedAt="2026-08-31T23:56:52.096630Z",
    ),
    ClubDto(
      id="dbc02274-c3e5-4a40-9156-8cc75f6f8ca9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Central Park GYM", address="Fener, Fener Cd. Beyaz Dünya İş Merkezi No.15, 07230 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8512189, longitude=30.761446,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/216df4cf-5d5f-469a-806d-d030bbb1adeb_photo.jpg",
      averageRating=4.2, totalRatingsCount=466,
      createdAt="2026-08-31T23:57:01.677656Z", updatedAt="2026-08-31T23:57:01.677656Z",
    ),
    ClubDto(
      id="4c435fbd-8d83-45a6-af61-7f3d2dbd7e36", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kepez Municipality Sports Complex", address="Yeni, 2435. Sk. No:35, 07060 Kepez/Antalya",
      city="Antalya", country="TR",
      latitude=36.9247504, longitude=30.7106972,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff83e667-4cc2-456d-b0be-4b48cf32e22e_photo.jpg",
      averageRating=4.2, totalRatingsCount=420,
      createdAt="2026-08-31T23:57:06.613498Z", updatedAt="2026-08-31T23:57:06.613498Z",
    ),
    ClubDto(
      id="a15ab8e6-c117-4e7d-89d3-578aee994725", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Park Antalya Sports Facilities", address="Spor tesisleri, Kızıltoprak, 965. Sk. No:8 (Parkantalya, 07160 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8958526, longitude=30.7262391,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c29f82ff-4b3a-45e1-875a-7d3300de690e_photo.jpg",
      averageRating=4.2, totalRatingsCount=1385,
      createdAt="2026-08-31T23:55:55.820138Z", updatedAt="2026-08-31T23:55:55.820138Z",
    ),
    ClubDto(
      id="d5d903cc-385a-4eca-804f-8c1d9b850a6a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Muratpasa Belediyesi 75. Yil Spor Tesisleri", address="Yeşilbahçe, 1455. Sk. No:7, 07160 Muratpaşa/Antalya",
      city="Antalya", country="TR",
      latitude=36.8691329, longitude=30.7233295,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f00b3467-14bb-4e7b-a1e4-e6a9914db774_photo.jpg",
      averageRating=4.1, totalRatingsCount=147,
      createdAt="2026-08-31T23:56:11.559730Z", updatedAt="2026-09-01T14:31:44.110029Z",
    ),
    ClubDto(
      id="89c8e8cf-1548-442d-a3b5-fd1cf4b93691", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Şehitler Parkı Spor Tesisi", address="Yeni, 07090 Kepez/Antalya",
      city="Antalya", country="TR",
      latitude=36.9210201, longitude=30.7073364,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f36a63d-5162-43e4-bdf8-530b5463f683_photo.jpg",
      averageRating=4.1, totalRatingsCount=141,
      createdAt="2026-08-31T23:56:16.181467Z", updatedAt="2026-08-31T23:56:16.181467Z",
    ),
    ClubDto(
      id="46880899-42c6-4330-a198-78a82515ee7d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Match 2000 Football Field", address="Kültür, 3805. Sk. No:58, 07090 Kepez/Antalya",
      city="Antalya", country="TR",
      latitude=36.9018295, longitude=30.6536265,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc6c0969-da9d-48e9-aa95-ea3545a7c8fb_photo.jpg",
      averageRating=3.9, totalRatingsCount=322,
      createdAt="2026-08-31T23:56:01.934039Z", updatedAt="2026-08-31T23:56:01.934039Z",
    ),
    ClubDto(
      id="e914206a-653a-47d3-bd2f-c48b84e26499", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenpin Bowling Center", address="Arapsuyu 17. Caddesi, Öğretmenevleri, 901. Sk. no:2/a, 07070 Konyaaltı/Antalya",
      city="Antalya", country="TR",
      latitude=36.875116, longitude=30.642136,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e9f0c1fe-1ad2-46f9-8233-f7f6af84e05d_photo.jpg",
      averageRating=3.8, totalRatingsCount=1223,
      createdAt="2026-08-31T23:57:55.513014Z", updatedAt="2026-08-31T23:57:55.513014Z",
    ),
  )),
  CitySeo(slug="amsterdam", name="Amsterdam", country="NL", clubCount=28, sports=listOf(Pair("Volleyball", 4), Pair("Football", 4), Pair("Basketball", 3), Pair("Tennis", 3), Pair("Padel", 3), Pair("Climbing", 2), Pair("Golf", 2), Pair("Karting", 2), Pair("Bowling", 1), Pair("Paintball", 1), Pair("Table Tennis", 1), Pair("Billiards", 1), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="11342712-6fa3-425f-8ac5-970641836227", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PadelCasa B.V.", address="Johan Huizingalaan 763A, 1066 VH Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3430714, longitude=4.8289517,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac826504-7d68-473e-b0cd-9987fad0a7cc_ChIJQ6VIVmF1_0.jpg",
      averageRating=4.9, totalRatingsCount=678,
      createdAt="2026-08-30T21:34:10.850354Z", updatedAt="2026-08-30T21:34:10.850354Z",
    ),
    ClubDto(
      id="7015813d-4e51-497f-9e04-e450bf369c09", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PLAYERSHOME 2", address="Transformatorweg 35, 1014 AJ Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3906437, longitude=4.8516488,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fab0c441-d0a5-4070-a1c9-0d2bb5d63018_ChIJdQiz11zj_0.jpg",
      averageRating=4.8, totalRatingsCount=174,
      createdAt="2026-08-30T21:32:42.035813Z", updatedAt="2026-08-30T21:58:53.519622Z",
    ),
    ClubDto(
      id="21d33ef5-7a46-46dc-bd38-6a382dd76e2c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UP Events – Evenementen, Teambuilding, Meetings & Bedrijfsuitjes in Amsterdam", address="Tom Schreursweg 8, 1067 MC Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3818648, longitude=4.7857763,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d215998c-ee54-4296-ac35-aab0359f3ea5_ChIJtRUHw5rj_0.jpg",
      averageRating=4.8, totalRatingsCount=3188,
      createdAt="2026-08-30T21:33:32.373842Z", updatedAt="2026-08-30T22:01:48.822538Z",
    ),
    ClubDto(
      id="0258f3c8-ebf3-47b1-b6ff-7f5031b0ef53", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beest Boulders Amsterdam", address="Willem de Zwijgerlaan 338B, 1055 RD Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3816739, longitude=4.8594025,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1a2bda70-8888-4d28-9f14-695e4435cf00_ChIJY9lITH_j_0.jpg",
      averageRating=4.7, totalRatingsCount=1145,
      createdAt="2026-08-30T21:33:16.900538Z", updatedAt="2026-08-30T21:33:16.900538Z",
    ),
    ClubDto(
      id="bb92a9b5-2a9a-4f87-8053-283bc024fcc8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Monk bouldergym Amsterdam", address="Aambeeldstraat 26, 1021 KB Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3835983, longitude=4.9293842,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db900550-3be2-46b2-9aed-19b21cfaa8a1_ChIJA0gPcwEJ_0.jpg",
      averageRating=4.7, totalRatingsCount=963,
      createdAt="2026-08-30T21:33:24.967985Z", updatedAt="2026-08-30T21:58:38.115476Z",
    ),
    ClubDto(
      id="9fbf83b8-3d71-4ba2-8013-24cc677c7ca8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="All Day Athletes", address="Sloterweg 1045, 1066 CC Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3396775, longitude=4.8075941,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/696bbff7-14cd-4e84-8f6d-f8bd63166aa2_photo.jpg",
      averageRating=5.0, totalRatingsCount=46,
      createdAt="2026-08-31T15:27:35.098748Z", updatedAt="2026-08-31T15:27:35.098748Z",
    ),
    ClubDto(
      id="0d381345-0948-4fd1-b6b7-30ae8e4e1461", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Footy Park", address="Sportpark Spieringhorn 10, 1043 AA Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3861298, longitude=4.8290234,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e8291375-e5b4-46f8-9fc6-87e61a960bd3_ChIJpUtRlL4J_0.jpg",
      averageRating=4.6, totalRatingsCount=334,
      createdAt="2026-08-30T21:32:26.299039Z", updatedAt="2026-08-30T21:32:26.299039Z",
    ),
    ClubDto(
      id="315c9900-0faf-4a63-a2a9-e1094e53e006", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golflounge Amsterdam", address="Abcouderstraatweg 46, 1106 AS Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.2871888, longitude=4.9597743,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8c557880-4f9b-45bc-b1aa-41369648af32_photo.jpg",
      averageRating=4.6, totalRatingsCount=474,
      createdAt="2026-08-31T15:28:23.601204Z", updatedAt="2026-08-31T15:28:23.601204Z",
    ),
    ClubDto(
      id="a7450d9d-57aa-4bc5-a024-e86cf7414906", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Peakz Padel Amsterdam Kauwgomballenkwartier | Padelclub", address="Willem Fenengastraat 3, 1096 BE Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3347726, longitude=4.9200537,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5eb0b535-3898-46bd-9b92-ecf6fd21ae0f_ChIJm7yXcF0L_0.jpg",
      averageRating=4.6, totalRatingsCount=287,
      createdAt="2026-08-30T21:34:17.988219Z", updatedAt="2026-08-30T21:59:28.070180Z",
    ),
    ClubDto(
      id="160ecbb3-7ded-4ce2-947a-3a8877601768", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Waterhole", address="Korte Leidsedwarsstraat 49, 1017 PW Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.364865, longitude=4.882593,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/93e58ff2-97ab-40eb-9cd4-5ec0c40b55e0_ChIJZ2wmXugJ_0.jpg",
      averageRating=4.5, totalRatingsCount=4207,
      createdAt="2026-08-30T21:32:55.513589Z", updatedAt="2026-08-30T22:01:40.993226Z",
    ),
    ClubDto(
      id="48af74b2-5c54-40f4-9910-4fad426da84f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="USC Universum | Sport & Fitness🏃‍➡️", address="Science Park 306, 1098 XH Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3556418, longitude=4.9561063,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/22d13bb2-2f3f-4ca3-bedd-f6941fc4dce2_photo.png",
      averageRating=4.5, totalRatingsCount=360,
      createdAt="2026-08-31T15:28:03.650849Z", updatedAt="2026-08-31T15:28:03.650849Z",
    ),
    ClubDto(
      id="8834c5e4-ab73-4951-b5e6-88f7375f2bd5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoor Soccer Events", address="Rhoneweg 32, 1043 AH Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3902818, longitude=4.826416,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5cf21e4e-b897-459e-9385-996274761a2a_ChIJ8-hSHdvj_0.jpg",
      averageRating=4.4, totalRatingsCount=307,
      createdAt="2026-08-30T21:32:33.537606Z", updatedAt="2026-08-30T21:57:25.706999Z",
    ),
    ClubDto(
      id="b294569d-c86e-48da-91c7-f088e0733b34", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Beach", address="Oosteinderweg 247a, 1432 AT Aalsmeer",
      city="Amsterdam", country="NL",
      latitude=52.2813752, longitude=4.7849855,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/15cf9a20-f91c-4d9a-8b42-df4a54d78df0_photo.jpg",
      averageRating=4.4, totalRatingsCount=819,
      createdAt="2026-08-31T15:28:15.523538Z", updatedAt="2026-08-31T15:28:15.523538Z",
    ),
    ClubDto(
      id="cf8c8fa6-2c48-422e-a906-a5206908a1ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="De Hoge Dijk", address="Abcouderstraatweg 46, 1105 AA Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.2864485, longitude=4.9601711,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/42c99b21-c960-4e8c-b535-6b3978c475c4_photo.jpg",
      averageRating=4.3, totalRatingsCount=962,
      createdAt="2026-08-31T15:28:30.666505Z", updatedAt="2026-08-31T15:28:30.666505Z",
    ),
    ClubDto(
      id="f302b29f-68bc-49f0-ba23-15589c3cde86", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Silverstone", address="Weerenweg 21, 1161 AE Zwanenburg",
      city="Amsterdam", country="NL",
      latitude=52.3834249, longitude=4.7344341,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e3a4d04a-8850-4d8d-af00-dd5bdbedaf54_photo.jpg",
      averageRating=4.3, totalRatingsCount=2952,
      createdAt="2026-08-31T15:28:51.696955Z", updatedAt="2026-08-31T15:28:51.696955Z",
    ),
    ClubDto(
      id="b7a89ab7-e5bd-4bb8-9aa1-0e6ca94d9d7f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="USC Tennis & Padel 🎾", address="Radioweg 80, 1098 NJ Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3477325, longitude=4.9472835,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f7b079f2-457b-4deb-a4a5-9c22830226cf_ChIJsXIiIl4J_0.jpg",
      averageRating=4.3, totalRatingsCount=130,
      createdAt="2026-08-30T21:34:39.512618Z", updatedAt="2026-09-01T14:31:50.361086Z",
    ),
    ClubDto(
      id="e8b03996-272c-4b79-b53e-a05e5cb98437", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Amstelpark Tennisclub | Tennis, Padel & Squash", address="Koenenkade 8, 1081 KH Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.331197, longitude=4.853155,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4a9cfc8-2fae-41d5-9422-6056487b8efb_ChIJU_T9IuTh_0.jpg",
      averageRating=4.2, totalRatingsCount=367,
      createdAt="2026-08-30T21:34:25.807850Z", updatedAt="2026-09-01T14:32:03.385984Z",
    ),
    ClubDto(
      id="683b4d24-0e9e-452f-847c-9810a7131c6f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Amsterdam Racket Club", address="Van der Boechorststraat 38, 1081 BT Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3294368, longitude=4.8612945,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fabb9d59-1e8e-41d5-9a4e-94dfb6b2bcbd_ChIJI-0d6OHh_0.jpg",
      averageRating=4.2, totalRatingsCount=150,
      createdAt="2026-08-30T21:34:32.357736Z", updatedAt="2026-08-30T21:34:32.357736Z",
    ),
    ClubDto(
      id="4b2b9d03-f2ad-4729-88d8-8d8c248549ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="B. Amsterdam", address="Johan Huizingalaan 763A, 1066 VH Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3431327, longitude=4.8291255,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7633fbb6-aa6d-4ae8-bf96-ba6ae7a35962_ChIJXUl4ro7h_0.jpg",
      averageRating=4.2, totalRatingsCount=827,
      createdAt="2026-08-30T21:34:01.831816Z", updatedAt="2026-08-30T21:55:18.781955Z",
    ),
    ClubDto(
      id="ce8e87fe-c39f-492b-a3b2-d91d50855d10", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bijlmer Sportpark", address="Karspeldreef 501, 1102 BX Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3114011, longitude=4.9645898,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/916c3973-db16-4769-9050-e2eada585c75_ChIJpZkR5HcM_0.jpg",
      averageRating=4.2, totalRatingsCount=160,
      createdAt="2026-08-30T21:32:48.967845Z", updatedAt="2026-08-30T21:55:30.810216Z",
    ),
    ClubDto(
      id="99782e13-d042-4e8f-9cfd-7a336ef760fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportcentrum De Pijp", address="Lizzy Ansinghstraat 88, 1072 RD Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3497222, longitude=4.8944444,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e81ec0d-c516-432a-9e18-afe15d26876b_photo.jpg",
      averageRating=4.2, totalRatingsCount=308,
      createdAt="2026-08-31T15:28:09.652360Z", updatedAt="2026-08-31T15:28:09.652360Z",
    ),
    ClubDto(
      id="85054ca1-0081-44e9-bee2-68039b1e0c03", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporthallen Zuid", address="Burgerweeshuispad 54, 1076 EP Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3396568, longitude=4.8539472,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/85d74ca4-80e3-4496-8eb5-31aaeabd246b_photo.jpg",
      averageRating=4.2, totalRatingsCount=1296,
      createdAt="2026-08-31T15:27:50.153136Z", updatedAt="2026-08-31T15:27:50.153136Z",
    ),
    ClubDto(
      id="616691cb-6ef5-4bd6-9b60-ed3e3c9e62c2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ALOHA", address="De Ruijterkade 151, 1011 AC Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3777847, longitude=4.9096384,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/10721850-bbae-4ed3-b2a3-484336d2f384_ChIJe7EYlbAJ_0.jpg",
      averageRating=4.0, totalRatingsCount=4742,
      createdAt="2026-08-30T21:33:09.862656Z", updatedAt="2026-08-30T21:33:09.862656Z",
    ),
    ClubDto(
      id="3722ad82-37dd-44bc-9d63-fc667248e0a5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Race Planet Amsterdam", address="Herwijk 10, 1046 BC Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3961111, longitude=4.7891667,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bb919496-4af2-4555-a1a6-0a626e748105_photo.jpg",
      averageRating=3.9, totalRatingsCount=1915,
      createdAt="2026-08-31T15:28:45.021841Z", updatedAt="2026-08-31T15:28:45.021841Z",
    ),
    ClubDto(
      id="61e3c5cf-7b61-44b0-b983-549acc0e6ecc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Junggesellenabschied in Amsterdam mit Pissup Reisen", address="Spuistraat 56-3, 1012 TW Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.375722, longitude=4.8917036,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/08be6ebe-bbb4-4ec0-b606-4046f047cbea_ChIJ4Y8tSMYJ_2.jpg",
      averageRating=4.1, totalRatingsCount=44,
      createdAt="2026-08-30T21:33:47.141714Z", updatedAt="2026-08-31T22:11:18.187825Z",
    ),
    ClubDto(
      id="ec76382b-18bd-468f-85e5-6d0e8e986d9f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Amsterdam Basketball Academy", address="Apollolaan 4, 1077 BA Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3483637, longitude=4.8843468,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/72236763-4c6f-44a7-a1bb-59856a072134_photo.jpg",
      averageRating=5.0, totalRatingsCount=21,
      createdAt="2026-08-31T15:27:42.990664Z", updatedAt="2026-08-31T15:27:42.990664Z",
    ),
    ClubDto(
      id="282a70aa-1949-4257-8759-acd500d68b0e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Amsterdam Beach Club", address="Science Park, 1098 XH Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3551672, longitude=4.9553201,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/78577320-3801-48bb-86da-aac099300507_photo.jpg",
      averageRating=4.9, totalRatingsCount=13,
      createdAt="2026-08-31T15:27:57.913333Z", updatedAt="2026-08-31T15:27:57.913333Z",
    ),
    ClubDto(
      id="e222853a-802c-409e-8452-bedd43113fcd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Table Tennis Club De Volewijckers", address="J.H. Hisgenpad 388, 1025 WK Amsterdam",
      city="Amsterdam", country="NL",
      latitude=52.3997923, longitude=4.9258182,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d46eb998-512d-4593-a0ca-da079a66945d_photo.jpg",
      averageRating=4.7, totalRatingsCount=10,
      createdAt="2026-08-31T15:28:37.537066Z", updatedAt="2026-08-31T15:28:37.537066Z",
    ),
  )),
  CitySeo(slug="lille", name="Lille", country="FR", clubCount=28, sports=listOf(Pair("Volleyball", 4), Pair("Football", 4), Pair("Tennis", 4), Pair("Padel", 3), Pair("Basketball", 3), Pair("Golf", 2), Pair("Paintball", 2), Pair("Climbing", 1), Pair("Billiards", 1), Pair("Laser Tag", 1), Pair("Karting", 1), Pair("Table Tennis", 1), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="36e0587d-b86e-4c8a-98c1-13115c1c3514", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Topadel", address="171 Rue Carnot Premier étage, 59155 Faches-Thumesnil",
      city="Lille", country="FR",
      latitude=50.6025775, longitude=3.0676205,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c39ea052-5cce-4be1-883a-356442797603_photo.jpg",
      averageRating=5.0, totalRatingsCount=243,
      createdAt="2026-08-31T23:22:19.325647Z", updatedAt="2026-08-31T23:22:19.325647Z",
    ),
    ClubDto(
      id="fc0c92b1-56b0-4bc6-8545-a33098095364", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ESCAPAD – Centre d’escalade, restaurant et padel à Lille", address="100 Av. Willy Brandt 2ieme etage, 59000 Lille",
      city="Lille", country="FR",
      latitude=50.6370749, longitude=3.0726191,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7f1de987-d99c-4e4e-8a55-9226812d4b09_photo.jpg",
      averageRating=4.9, totalRatingsCount=174,
      createdAt="2026-08-31T23:22:23.797579Z", updatedAt="2026-08-31T23:22:23.797579Z",
    ),
    ClubDto(
      id="cf4c7691-b27a-4ffe-9f7f-17d8b4a93bc5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Lille", address="Imp. Jean Jaurès, 59175 Vendeville",
      city="Lille", country="FR",
      latitude=50.5771451, longitude=3.0857619,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7fcee132-9439-407f-b1b7-4a56c42412ec_photo.jpg",
      averageRating=4.9, totalRatingsCount=456,
      createdAt="2026-08-31T23:23:52.894396Z", updatedAt="2026-08-31T23:23:52.894396Z",
    ),
    ClubDto(
      id="4242dd6d-7cb4-45eb-a9f9-c224158f522a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Game Evolution Villeneuve d'Ascq - 3 Labyrinthes", address="bâtiment UGC, Av. de l'Avenir, 59650 Villeneuve-d'Ascq",
      city="Lille", country="FR",
      latitude=50.6160994, longitude=3.1247593,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d35d6178-4a67-4ccf-b59a-17362af956ac_photo.jpg",
      averageRating=4.7, totalRatingsCount=1638,
      createdAt="2026-08-31T23:23:47.915324Z", updatedAt="2026-08-31T23:23:47.915324Z",
    ),
    ClubDto(
      id="bc076433-bc8d-4f4b-8aac-af96256b6484", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="NORD AVENTURE - PAINTBALL", address="Chem. de la Croix Rouge, 59249 Aubers",
      city="Lille", country="FR",
      latitude=50.5871836, longitude=2.833751,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9537b8bb-96a8-4031-ba8c-7f139d3912d4_photo.jpg",
      averageRating=4.7, totalRatingsCount=194,
      createdAt="2026-08-31T23:23:57.822179Z", updatedAt="2026-08-31T23:23:57.822179Z",
    ),
    ClubDto(
      id="53136b69-a968-4621-b09c-9b814dba3665", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bon Spot Lille - Marcq en Baroeul", address="395 Rue du Général de Gaulle, 59700 Marcq-en-Barœul",
      city="Lille", country="FR",
      latitude=50.6483848, longitude=3.1167755,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f5fc7398-992b-4781-9073-89d7eaf0aa5c_photo.jpg",
      averageRating=4.6, totalRatingsCount=1011,
      createdAt="2026-08-31T23:23:32.133534Z", updatedAt="2026-08-31T23:23:32.133534Z",
    ),
    ClubDto(
      id="e0709451-7003-41b6-a322-5b07e445b855", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hoops Factory Lille", address="11 Rue Louis Braille, 59370 Mons-en-Barœul",
      city="Lille", country="FR",
      latitude=50.637863, longitude=3.0969382,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6bc9e756-f742-40c9-9ad0-2cf7ace1752b_photo.jpg",
      averageRating=4.6, totalRatingsCount=533,
      createdAt="2026-08-31T23:22:28.198518Z", updatedAt="2026-08-31T23:22:28.198518Z",
    ),
    ClubDto(
      id="6a71dded-2072-4ba2-92bd-262ec13db5f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Raquette de Villeneuve d'Ascq", address="Stade Jean Jacques - Rue du 8 Mai 1945, 59650 Villeneuve-d'Ascq",
      city="Lille", country="FR",
      latitude=50.6287748, longitude=3.1534186,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a86d5f7f-693b-4268-bde6-d9080d216a47_photo.jpg",
      averageRating=4.5, totalRatingsCount=116,
      createdAt="2026-08-31T23:21:59.445432Z", updatedAt="2026-09-01T14:31:45.393493Z",
    ),
    ClubDto(
      id="dd5edcf5-df7a-447f-a563-61f4c45e31ca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le Shaft - club de padel et de badminton", address="4 Rue Professeur Langevin, 59000 Lille",
      city="Lille", country="FR",
      latitude=50.6170381, longitude=3.0844275,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/98119e81-aeb5-4756-ba02-039180a2e1ca_photo.jpg",
      averageRating=4.5, totalRatingsCount=493,
      createdAt="2026-08-31T23:22:14.788910Z", updatedAt="2026-08-31T23:22:14.788910Z",
    ),
    ClubDto(
      id="4f69929c-4c6e-452b-96de-4639088f32a2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lille Métropole Tennis de Table", address="Complexe Micheline Ostermeyer, 19 Boulevard d'Alsace, 59000 Lille",
      city="Lille", country="FR",
      latitude=50.6178822, longitude=3.064788,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/45541573-8be3-4f85-a45b-b6b68836579d_photo.jpg",
      averageRating=4.5, totalRatingsCount=53,
      createdAt="2026-08-31T23:23:16.689199Z", updatedAt="2026-08-31T23:23:16.689199Z",
    ),
    ClubDto(
      id="e35e86be-af9b-451c-929a-d509879747dd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mérignies Golf and Country Club", address="1245 Av. du Golf, 59710 Mérignies",
      city="Lille", country="FR",
      latitude=50.5116546, longitude=3.141243,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3319c794-fb98-40c0-8b64-89be799e4590_photo.jpg",
      averageRating=4.5, totalRatingsCount=651,
      createdAt="2026-08-31T23:23:09.311422Z", updatedAt="2026-08-31T23:23:09.311422Z",
    ),
    ClubDto(
      id="2b32b8fb-7668-43ec-87e3-6163a786a3db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palacium", address="2 Rue Breughel, 59650 Villeneuve-d'Ascq",
      city="Lille", country="FR",
      latitude=50.6275335, longitude=3.134815,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e5319da-db00-45c2-8f2b-a171cd121630_photo.jpg",
      averageRating=4.5, totalRatingsCount=128,
      createdAt="2026-08-31T23:22:38.201962Z", updatedAt="2026-08-31T23:22:38.201962Z",
    ),
    ClubDto(
      id="d48f05e3-c7fc-4e20-9c5e-f4fd02390ac1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Footsal Cousinerie", address="36 Rue de la Cousinerie, 59650 Villeneuve-d'Ascq",
      city="Lille", country="FR",
      latitude=50.6440829, longitude=3.1459612,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/34266bf2-a3d5-410f-a32d-0a2efd4cf319_photo.jpg",
      averageRating=4.4, totalRatingsCount=380,
      createdAt="2026-08-31T23:21:41.770891Z", updatedAt="2026-09-01T14:31:52.424097Z",
    ),
    ClubDto(
      id="b97f3462-7caa-4475-9e4b-04108dcef260", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Madeleine Tennis Club", address="305 Rue du Président Georges Pompidou, 59110 La Madeleine",
      city="Lille", country="FR",
      latitude=50.6627798, longitude=3.0630984,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/66f83c0c-9eeb-4b92-b6aa-692ba5bee534_photo.jpg",
      averageRating=4.4, totalRatingsCount=72,
      createdAt="2026-08-31T23:22:06.212672Z", updatedAt="2026-08-31T23:22:06.212672Z",
    ),
    ClubDto(
      id="cf62bd37-8c1e-4dfd-98c7-fba1c864a014", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palais des Sports Saint-Sauveur", address="78 Av. du Président John F. Kennedy, 59800 Lille",
      city="Lille", country="FR",
      latitude=50.632615, longitude=3.0719698,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7222a44d-1228-4470-9cb6-05f13fa6b334_photo.jpg",
      averageRating=4.4, totalRatingsCount=471,
      createdAt="2026-08-31T23:22:34.071271Z", updatedAt="2026-08-31T23:22:34.071271Z",
    ),
    ClubDto(
      id="5ceef496-12c0-471f-a485-cc422b56771f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arena de Lambersart🏐", address="51 Av. du Champ de Course, 59130 Lambersart",
      city="Lille", country="FR",
      latitude=50.6421564, longitude=3.0361693,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83c48464-563e-457e-9422-c435dca41908_photo.jpg",
      averageRating=4.3, totalRatingsCount=78,
      createdAt="2026-08-31T23:22:42.994196Z", updatedAt="2026-08-31T23:22:42.994196Z",
    ),
    ClubDto(
      id="ebd1e043-042c-4351-86f2-7615b4ad262d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Lille Métropole", address="Rdpt des Acacias, 59790 Ronchin",
      city="Lille", country="FR",
      latitude=50.6079455, longitude=3.1120398,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9c5f6210-894b-4035-8382-4434ebc60142_photo.jpg",
      averageRating=4.3, totalRatingsCount=721,
      createdAt="2026-08-31T23:23:04.453572Z", updatedAt="2026-08-31T23:23:04.453572Z",
    ),
    ClubDto(
      id="bf1b1e75-d19c-4dda-acd7-fefad61c0a52", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lille Karting", address="Centre Commercial Englos les Géants, Rue Eugène Imbert de la Phalecque, 59320 Ennetières-en-Weppes",
      city="Lille", country="FR",
      latitude=50.6346761, longitude=2.9686314,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9b8587c9-018b-4539-b81d-fdae4f78a920_photo.jpg",
      averageRating=4.3, totalRatingsCount=1765,
      createdAt="2026-08-31T23:23:22.066493Z", updatedAt="2026-08-31T23:23:22.066493Z",
    ),
    ClubDto(
      id="a2a949ef-7935-4fff-8311-364fe434de22", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport Joie Lille", address="Bd de la Moselle, 59000 Lille",
      city="Lille", country="FR",
      latitude=50.6245898, longitude=3.0298099,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ee52331-7b7b-45aa-8c89-45e783abe5e0_photo.jpg",
      averageRating=4.2, totalRatingsCount=59,
      createdAt="2026-08-31T23:22:47.387460Z", updatedAt="2026-08-31T23:22:47.387460Z",
    ),
    ClubDto(
      id="4523cdc8-c27e-4bbe-a4d7-97bf107cfe95", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UrbanSoccer - Lille Bondues", address="5 Chem. des Grands Obeaux, 59910 Bondues",
      city="Lille", country="FR",
      latitude=50.6913774, longitude=3.0860264,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04ef5562-91c2-42fc-ad83-79c05a281580_photo.jpg",
      averageRating=4.2, totalRatingsCount=630,
      createdAt="2026-08-31T23:21:34.838191Z", updatedAt="2026-08-31T23:21:34.838191Z",
    ),
    ClubDto(
      id="f01e741a-92f8-4a71-ba72-9462f7279d12", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UrbanSoccer - Lille Lezennes", address="4 Rue Paul Langevin ZI du Hellu, 59260 Lezennes",
      city="Lille", country="FR",
      latitude=50.6162725, longitude=3.0998108,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/818c982c-4261-485a-8394-9d9bb2b4c43f_photo.jpg",
      averageRating=4.2, totalRatingsCount=952,
      createdAt="2026-08-31T23:21:29.120333Z", updatedAt="2026-08-31T23:21:29.120333Z",
    ),
    ClubDto(
      id="11313d4d-e69a-4b49-b3ea-682e976e7eae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Cub Lomme - OSML Tennis", address="3 bis rue de lompret, 59160 Lomme",
      city="Lille", country="FR",
      latitude=50.6508476, longitude=2.9959804,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e856627f-ad63-43c4-ad11-d70782bae5b8_photo.jpg",
      averageRating=4.1, totalRatingsCount=64,
      createdAt="2026-08-31T23:22:09.825392Z", updatedAt="2026-08-31T23:22:09.825392Z",
    ),
    ClubDto(
      id="3918a1a2-a720-46c0-9934-6b7e50fa569c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Métro Bowling : Bar, Restaurant, Bowling & Jeux d’Arcade à Lille", address="17 Bd Victor Hugo, 59000 Lille",
      city="Lille", country="FR",
      latitude=50.6238267, longitude=3.0668216,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2a019e92-9a79-4c32-9da1-f3aadc77fd4f_photo.jpg",
      averageRating=4.0, totalRatingsCount=2300,
      createdAt="2026-08-31T23:23:27.505245Z", updatedAt="2026-08-31T23:23:27.505245Z",
    ),
    ClubDto(
      id="d48d16c2-a6ac-423c-89cf-3527ed1d4354", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stade Jean Baratte", address="235 Rue Anatole de la Forge, 59800 Lille",
      city="Lille", country="FR",
      latitude=50.6285611, longitude=3.097839,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9dc51d8c-587d-4de3-b587-d17a5af575f0_photo.jpg",
      averageRating=4.0, totalRatingsCount=125,
      createdAt="2026-08-31T23:21:48.892031Z", updatedAt="2026-08-31T23:21:48.892031Z",
    ),
    ClubDto(
      id="c24012be-6ad1-4283-a280-9d32d0fbe651", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le Fronton-Citi", address="177 bis Rue des Stations 59800, 59000 Lille",
      city="Lille", country="FR",
      latitude=50.6256986, longitude=3.0420994,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c10bcd2b-abf8-4214-96e2-df3cf564d8ab_photo.jpg",
      averageRating=3.9, totalRatingsCount=118,
      createdAt="2026-08-31T23:21:53.910246Z", updatedAt="2026-08-31T23:21:53.910246Z",
    ),
    ClubDto(
      id="3da3733f-1b6a-4311-96ca-2ae079af4707", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling & Billards Van Gogh", address="1 Rue des Vétérans, 59650 Villeneuve-d'Ascq",
      city="Lille", country="FR",
      latitude=50.6232565, longitude=3.1335096,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d89fa301-797e-4b30-99da-597ce1475c29_photo.jpg",
      averageRating=3.8, totalRatingsCount=2399,
      createdAt="2026-08-31T23:23:39.348215Z", updatedAt="2026-08-31T23:23:39.348215Z",
    ),
    ClubDto(
      id="c45430ba-ba96-498d-8d08-b6a040fb425e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Salle Delannoy", address="Rue Ferdinand Buisson, 59260 Lille",
      city="Lille", country="FR",
      latitude=50.6298968, longitude=3.1175615,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/37cfecf1-fb8a-40dc-a758-1f5b1e1be581_photo.jpg",
      averageRating=4.5, totalRatingsCount=40,
      createdAt="2026-08-31T23:22:51.609383Z", updatedAt="2026-08-31T23:22:51.609383Z",
    ),
    ClubDto(
      id="dc2700fa-7902-48ed-bf0b-faafcd78bcbb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le Skyball - 59ers Beach-volley", address="Av. du Général de Gaulle Aerodrome de, 59910 Bondues",
      city="Lille", country="FR",
      latitude=50.6865445, longitude=3.0827928,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cda6ee7a-7487-4bba-be35-ac29a174f1d9_photo.jpg",
      averageRating=4.6, totalRatingsCount=11,
      createdAt="2026-08-31T23:22:56.016202Z", updatedAt="2026-08-31T23:22:56.016202Z",
    ),
  )),
  CitySeo(slug="nice", name="Nice", country="FR", clubCount=28, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Basketball", 3), Pair("Padel", 3), Pair("Climbing", 2), Pair("Volleyball", 2), Pair("Billiards", 2), Pair("Golf", 2), Pair("Karting", 2), Pair("Paintball", 2), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="834ab631-7a39-4b35-8e47-4bc0e5c4cd69", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Warrior Paintball Antibes", address="435 Av. du Pylône, 06600 Antibes",
      city="Nice", country="FR",
      latitude=43.6120057, longitude=7.1206886,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/36a9bb53-0aff-4f93-b05a-7a35def868bf_photo.jpg",
      averageRating=5.0, totalRatingsCount=1320,
      createdAt="2026-08-31T23:19:15.595861Z", updatedAt="2026-08-31T23:19:15.595861Z",
    ),
    ClubDto(
      id="31efa89f-695f-4388-b510-6b736e42f59e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climbpro Center", address="C. Ebanistería-1, 8, 03008 Alicante, Spain",
      city="Nice", country="FR",
      latitude=38.3342, longitude=-0.5163963,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/92c9a553-b462-4efb-ba19-00344c50a2fb_photo.jpg",
      averageRating=4.8, totalRatingsCount=378,
      createdAt="2026-08-31T23:18:56.764492Z", updatedAt="2026-08-31T23:18:56.764492Z",
    ),
    ClubDto(
      id="657592ce-56c8-48b4-bc2e-2b42f02a1e9f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Greenpoint Carlone", address="52 Route de Saint-Antoine, 06200 Nice",
      city="Nice", country="FR",
      latitude=43.6942151, longitude=7.2355715,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9a5effde-fcd8-44b8-a09a-2aec8fdfb375_photo.jpg",
      averageRating=4.8, totalRatingsCount=132,
      createdAt="2026-08-31T23:17:40.940037Z", updatedAt="2026-08-31T23:17:40.940037Z",
    ),
    ClubDto(
      id="678509c3-96d7-42fd-8c32-af76b26d979f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PAINTBALL TITANES ALACANT", address="CV-821, Km. 4 (Frente al Karting, cerca del Autocine, 03112 Alicante, Spain",
      city="Nice", country="FR",
      latitude=38.3980888, longitude=-0.4850123,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/290da91e-ac94-4687-b427-ee302a97c738_photo.jpg",
      averageRating=4.8, totalRatingsCount=433,
      createdAt="2026-08-31T23:19:20.516603Z", updatedAt="2026-08-31T23:19:20.516603Z",
    ),
    ClubDto(
      id="fbc45fda-592c-4105-8949-a6988bea70ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Monte-Carlo Country Club", address="155 Av. Princesse Grace, 06190 Roquebrune-Cap-Martin",
      city="Nice", country="FR",
      latitude=43.7516314, longitude=7.4407329,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/529e72aa-fe01-46f4-a46a-436f9accd69f_photo.jpg",
      averageRating=4.7, totalRatingsCount=1893,
      createdAt="2026-08-31T23:17:26.728206Z", updatedAt="2026-08-31T23:17:26.728206Z",
    ),
    ClubDto(
      id="4ac96f6f-dd00-4b5e-a114-41b91eb5f786", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Art Bloc Escalade", address="23 Av. Auguste Verola, 06200 Nice",
      city="Nice", country="FR",
      latitude=43.7102388, longitude=7.1932726,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/090484fe-d085-4d47-be4b-2f0253339205_photo.jpg",
      averageRating=4.6, totalRatingsCount=317,
      createdAt="2026-08-31T23:19:02.795646Z", updatedAt="2026-08-31T23:19:02.795646Z",
    ),
    ClubDto(
      id="37efab9f-e125-41bc-af45-f541b8c1227d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Volley", address="71 Quai des États-Unis, 06300 Nice",
      city="Nice", country="FR",
      latitude=43.6948739, longitude=7.2743611,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c8df11d6-14a2-46df-9d33-53755e2ededd_photo.jpg",
      averageRating=4.6, totalRatingsCount=68,
      createdAt="2026-08-31T23:18:24.285299Z", updatedAt="2026-08-31T23:18:24.285299Z",
    ),
    ClubDto(
      id="653263ae-4d60-4c9a-a951-b5d5d214c894", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf De La Vanade", address="Rte de Grasse, 06270 Villeneuve-Loubet",
      city="Nice", country="FR",
      latitude=43.6632347, longitude=7.0969271,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1c364a2b-24e3-42b7-bf55-8b902f015e32_photo.jpg",
      averageRating=4.5, totalRatingsCount=469,
      createdAt="2026-08-31T23:18:37.442234Z", updatedAt="2026-08-31T23:18:37.442234Z",
    ),
    ClubDto(
      id="32708b23-0bb0-48e4-946e-b907ff56d634", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Boule Noire", address="12 Rue Halévy, 06000 Nice",
      city="Nice", country="FR",
      latitude=43.6962483, longitude=7.2652515,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5d151505-e932-4c71-a38d-bc8dfcfe5587_photo.jpg",
      averageRating=4.5, totalRatingsCount=688,
      createdAt="2026-08-31T23:19:06.936528Z", updatedAt="2026-08-31T23:19:06.936528Z",
    ),
    ClubDto(
      id="8e3b4dbe-1ff9-4470-bb28-4d96b3928fd7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nice Volleyball", address="3 Chem. Saint-Philippe, 06000 Nice",
      city="Nice", country="FR",
      latitude=43.6983541, longitude=7.2549068,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/448cd94d-faa6-4ec1-99b5-e8d5c3a89024_photo.jpg",
      averageRating=4.5, totalRatingsCount=79,
      createdAt="2026-08-31T23:18:20.165582Z", updatedAt="2026-08-31T23:18:20.165582Z",
    ),
    ClubDto(
      id="3d2a680b-842e-495e-b97e-3c8a173dedd3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Padel Club Montaleigne", address="1 Chem. de l'Estelle, 06800 Cagnes-sur-Mer",
      city="Nice", country="FR",
      latitude=43.6930046, longitude=7.1748671,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/81b1eeea-4713-4212-8569-c439c0b34feb_photo.jpg",
      averageRating=4.5, totalRatingsCount=143,
      createdAt="2026-08-31T23:17:45.603922Z", updatedAt="2026-09-01T14:31:47.523992Z",
    ),
    ClubDto(
      id="0daccdaf-e349-41f5-8912-c08c80afd435", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UrbanSoccer - Villeneuve Loubet", address="2284 Rte de Grasse, 06270 Villeneuve-Loubet",
      city="Nice", country="FR",
      latitude=43.6613922, longitude=7.0952177,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3a09b2ae-2ba2-48c5-b165-25546ef202c4_photo.jpg",
      averageRating=4.5, totalRatingsCount=791,
      createdAt="2026-08-31T23:17:03.664157Z", updatedAt="2026-08-31T23:17:03.664157Z",
    ),
    ClubDto(
      id="a1257370-242f-4676-914e-d09f9340f544", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mouratoglou Tennis Academy", address="Mouratoglou Tennis Academy, 3550 Rte des Dolines, 06410 Biot",
      city="Nice", country="FR",
      latitude=43.6206181, longitude=7.0592973,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1b56d2e4-ba0d-438a-81ed-76fd1048b5ed_photo.jpg",
      averageRating=4.4, totalRatingsCount=659,
      createdAt="2026-08-31T23:17:31.576758Z", updatedAt="2026-08-31T23:17:31.576758Z",
    ),
    ClubDto(
      id="ab84bfd1-f926-4c02-b268-a47878dcfbcb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Tennis Nice Valrose", address="65 Av. Valrose, 06000 Nice",
      city="Nice", country="FR",
      latitude=43.7170524, longitude=7.2652192,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2098eec4-0309-4853-b364-cdcfcebe6696_photo.jpg",
      averageRating=4.4, totalRatingsCount=110,
      createdAt="2026-08-31T23:17:58.686215Z", updatedAt="2026-09-01T14:31:58.736704Z",
    ),
    ClubDto(
      id="89d9eaba-a6b6-4aaa-9ffc-d284bd5ec50f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ULTRA FABRON - PADEL et FOOTBALL", address="279 Av. de Fabron, 06200 Nice",
      city="Nice", country="FR",
      latitude=43.6927075, longitude=7.2102779,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1e12fa0-ec7a-4a3d-b71f-7e9bc029ffb2_photo.jpg",
      averageRating=4.4, totalRatingsCount=123,
      createdAt="2026-08-31T23:17:52.299450Z", updatedAt="2026-09-01T14:31:50.240069Z",
    ),
    ClubDto(
      id="19c025e6-c356-4b83-a3c6-ea88fd50b3ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KARTING ALACANT", address="CV-821, Km. 3, 8, 03112, Alicante, Spain",
      city="Nice", country="FR",
      latitude=38.3964614, longitude=-0.4848683,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f0d8c5a6-37e9-46bd-b06a-e29abfa68703_photo.jpg",
      averageRating=4.3, totalRatingsCount=1068,
      createdAt="2026-08-31T23:18:45.937760Z", updatedAt="2026-08-31T23:18:45.937760Z",
    ),
    ClubDto(
      id="7c31f24d-99ce-490e-9ef1-19f12cda8d32", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Old Course Cannes Mandelieu", address="265 Rte du Golf, 06210 Mandelieu-la-Napoule",
      city="Nice", country="FR",
      latitude=43.5321083, longitude=6.9403133,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/16e1cfd8-4ddb-46dc-b77f-06304c40c341_photo.jpg",
      averageRating=4.2, totalRatingsCount=550,
      createdAt="2026-08-31T23:18:29.421560Z", updatedAt="2026-08-31T23:18:29.421560Z",
    ),
    ClubDto(
      id="01196343-689c-40de-a452-bb2a523136b9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nice Mercantour Sports Complex", address="114 Bd du Mercantour, 06200 Nice",
      city="Nice", country="FR",
      latitude=43.6717787, longitude=7.2031418,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/54724706-af78-46e9-9632-50acccb77fcf_photo.jpg",
      averageRating=4.2, totalRatingsCount=174,
      createdAt="2026-08-31T23:18:12.771336Z", updatedAt="2026-08-31T23:18:12.771336Z",
    ),
    ClubDto(
      id="0f82dc8c-6c50-4280-be84-e47ab73931f9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Salle Serge Leyrit", address="16 Rue Fornero Meneï, 06300 Nice",
      city="Nice", country="FR",
      latitude=43.7150944, longitude=7.2914496,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e46400b-5a7f-4a13-a675-ae888791f76e_photo.jpg",
      averageRating=4.2, totalRatingsCount=200,
      createdAt="2026-08-31T23:18:08.121999Z", updatedAt="2026-08-31T23:18:08.121999Z",
    ),
    ClubDto(
      id="b7f83ef3-954c-4454-9ba2-8358b8cca20c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club des Combes | Tennis & Padel", address="768 Bd du Mercantour, 06200 Nice",
      city="Nice", country="FR",
      latitude=43.7451388, longitude=7.1875632,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/56090880-988a-40e7-967c-50559ca79f52_photo.jpg",
      averageRating=4.2, totalRatingsCount=387,
      createdAt="2026-08-31T23:17:36.466051Z", updatedAt="2026-09-01T14:31:47.402908Z",
    ),
    ClubDto(
      id="24a80b59-510a-4dd0-9ef8-024344aaae4f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ultra Cimiez - Tennis et Football", address="19 Av. de la Marne, 06100 Nice",
      city="Nice", country="FR",
      latitude=43.7262197, longitude=7.2697374,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7be204c4-1c15-49b3-9765-dbd8b37c975b_photo.jpg",
      averageRating=4.2, totalRatingsCount=130,
      createdAt="2026-08-31T23:17:22.632868Z", updatedAt="2026-09-01T14:31:50.706231Z",
    ),
    ClubDto(
      id="017a6cca-7e02-4047-b51d-50df90591d87", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="International Racing Karting", address="189 Chemin de Villeneuve, Av. du 8 Mai 1945, 83600 Fréjus",
      city="Nice", country="FR",
      latitude=43.4224476, longitude=6.7289635,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/32a0ec73-6a49-4d1d-9211-649176e1a41c_photo.jpg",
      averageRating=4.1, totalRatingsCount=899,
      createdAt="2026-08-31T23:18:51.784238Z", updatedAt="2026-08-31T23:18:51.784238Z",
    ),
    ClubDto(
      id="844a3efd-0d7a-4bf4-81bc-f8ab14fa4c72", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stade Charles-Ehrmann", address="155 Rte de Grenoble, 06200 Nice",
      city="Nice", country="FR",
      latitude=43.6769981, longitude=7.1964783,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aecd05ec-4cd8-496a-b323-7be22b6b76c6_photo.jpg",
      averageRating=4.1, totalRatingsCount=345,
      createdAt="2026-08-31T23:17:11.460863Z", updatedAt="2026-08-31T23:17:11.460863Z",
    ),
    ClubDto(
      id="9b3f1d37-acc1-4f3d-8e50-6cd3208cb5ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Complex of Lauvette", address="La Lauvette, 06340 Nice",
      city="Nice", country="FR",
      latitude=43.7535301, longitude=7.301148,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/df96654f-5d64-449e-95f3-e5c25d946e60_photo.jpg",
      averageRating=4.0, totalRatingsCount=348,
      createdAt="2026-08-31T23:17:07.237689Z", updatedAt="2026-08-31T23:17:07.237689Z",
    ),
    ClubDto(
      id="2c872f01-9129-4c2e-bca3-787a69aced7e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Complex Jean Bouin", address="2 Rue Jean Allègre, 06000 Nice",
      city="Nice", country="FR",
      latitude=43.7080556, longitude=7.2811111,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f2370876-0493-4813-ae5f-79c73e2a9349_photo.jpg",
      averageRating=3.9, totalRatingsCount=1617,
      createdAt="2026-08-31T23:18:03.005469Z", updatedAt="2026-08-31T23:18:03.005469Z",
    ),
    ClubDto(
      id="0ba30113-73bd-41f8-9fb4-4679e763d8fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CAVIGAL Nice Tennis de Table", address="8 Av. Raoul Dufy, 06200 Nice",
      city="Nice", country="FR",
      latitude=43.6794401, longitude=7.2171569,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b661227e-75b2-4fe1-8f61-7ea5c5e00f61_photo.jpg",
      averageRating=4.8, totalRatingsCount=39,
      createdAt="2026-08-31T23:18:41.352359Z", updatedAt="2026-08-31T23:18:41.352359Z",
    ),
    ClubDto(
      id="a83d25e1-a71f-4cc8-9916-abd69e9e8b6a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nice Cavigal Sports Section Football", address="1 Rue Louis Genari, 06300 Nice",
      city="Nice", country="FR",
      latitude=43.7185517, longitude=7.292041,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/172d5806-a214-45eb-b857-46e0a344ff91_photo.jpg",
      averageRating=3.7, totalRatingsCount=138,
      createdAt="2026-08-31T23:17:15.910052Z", updatedAt="2026-08-31T23:17:15.910052Z",
    ),
    ClubDto(
      id="21bf783f-4b50-42a6-b373-3af4bea076fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billard Club de Nice", address="64 Av. Cyrille Besset, 06100 Nice",
      city="Nice", country="FR",
      latitude=43.7181447, longitude=7.2546901,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/afc20bc5-294f-4140-b550-e51ee632475f_photo.jpg",
      averageRating=4.2, totalRatingsCount=11,
      createdAt="2026-08-31T23:19:10.859758Z", updatedAt="2026-08-31T23:19:10.859758Z",
    ),
  )),
  CitySeo(slug="athens", name="Athens", country="GR", clubCount=28, sports=listOf(Pair("Volleyball", 5), Pair("Football", 4), Pair("Tennis", 3), Pair("Basketball", 3), Pair("Paintball", 2), Pair("Golf", 2), Pair("Table Tennis", 2), Pair("Billiards", 2), Pair("Karting", 2), Pair("Climbing", 2), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="064d15f5-e2b2-42fc-ac73-977cad64988f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Athens Beach Center", address="Mpichaki 33, Ag. Ioannis Rentis 182 33",
      city="Athens", country="GR",
      latitude=37.9662783, longitude=23.6749256,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b09737fb-9e0a-4fd5-a21e-85e54c294271_photo.jpg",
      averageRating=5.0, totalRatingsCount=70,
      createdAt="2026-08-31T15:50:19.111469Z", updatedAt="2026-08-31T15:50:19.111469Z",
    ),
    ClubDto(
      id="d86a4baf-53c9-4c0d-999a-38658744d5f8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Volley Academy court Village Ρέντη", address="Thivon 228, Ag. Ioannis Rentis 182 33",
      city="Athens", country="GR",
      latitude=37.9752619, longitude=23.6685647,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1af0eca8-e277-4665-a3a8-4ff8177fda87_photo.jpg",
      averageRating=4.9, totalRatingsCount=56,
      createdAt="2026-08-31T15:50:24.731957Z", updatedAt="2026-08-31T15:50:24.731957Z",
    ),
    ClubDto(
      id="5d1d621e-2897-4f76-967d-45f79db395b3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ilion A.C.C. Table Tennis Club", address="Nestoros 102, Ilion 131 22",
      city="Athens", country="GR",
      latitude=38.0303547, longitude=23.7085277,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4b880b71-0a74-454c-b33c-26f9c440feb3_photo.png",
      averageRating=4.9, totalRatingsCount=93,
      createdAt="2026-08-31T15:51:18.345567Z", updatedAt="2026-08-31T15:51:18.345567Z",
    ),
    ClubDto(
      id="56e291d4-b75c-4743-afca-4ca8372baf78", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="RACING STAR", address="Αμβροσίου Φραντζή 94, Αθήνα 117 44",
      city="Athens", country="GR",
      latitude=37.9576069, longitude=23.7311494,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04437222-aada-4962-910e-5f722d64f470_ChIJ8TVzLgm9_0.jpg",
      averageRating=4.9, totalRatingsCount=121,
      createdAt="2026-08-30T22:39:27.404311Z", updatedAt="2026-08-30T22:39:27.404311Z",
    ),
    ClubDto(
      id="67cee452-143a-4449-9da0-252567226a5c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nova Tennis Club", address="Αθήνα 115 25",
      city="Athens", country="GR",
      latitude=37.9992304, longitude=23.7793795,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39c8dedb-5a3b-4242-a648-7f400ccdb5e4_ChIJYTaUvhOY_0.jpg",
      averageRating=4.8, totalRatingsCount=57,
      createdAt="2026-08-30T22:39:50.925456Z", updatedAt="2026-08-30T22:39:50.925456Z",
    ),
    ClubDto(
      id="b1752077-2685-4cc7-8659-f20fef4a9727", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Redpoint Athens Climbing Center", address="Σοφιανοπούλου 3, Αθήνα 111 45",
      city="Athens", country="GR",
      latitude=38.0129042, longitude=23.7276201,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2b397ab2-4de6-4f9b-a74f-d57295dcd3a9_ChIJ7Sw5s8Ki_0.jpg",
      averageRating=4.8, totalRatingsCount=66,
      createdAt="2026-08-30T22:39:14.061689Z", updatedAt="2026-08-30T22:39:14.061689Z",
    ),
    ClubDto(
      id="6e273cc5-aa4d-4ace-be56-4231adc34e8f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Athens Padel Club", address="Andrea Papandreou 86, Likourgou 43, Athina 166 75",
      city="Athens", country="GR",
      latitude=37.8738144, longitude=23.756431,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/323ef2e9-f951-41d6-bf2e-eb18d23ee8aa_ChIJPdSZuC6-_0.jpg",
      averageRating=4.7, totalRatingsCount=206,
      createdAt="2026-08-30T22:39:43.678869Z", updatedAt="2026-09-01T14:31:42.779193Z",
    ),
    ClubDto(
      id="c64443fd-f8d7-42c7-be20-e993bd070e77", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Athens Sports Hall", address="Themiskiras 1, Athina 104 42",
      city="Athens", country="GR",
      latitude=37.9949982, longitude=23.7121748,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b233438d-f38e-421b-ae13-773f68cffdd5_photo.jpg",
      averageRating=4.7, totalRatingsCount=547,
      createdAt="2026-08-31T15:49:57.061178Z", updatedAt="2026-08-31T15:49:57.061178Z",
    ),
    ClubDto(
      id="38cf69f6-e702-4c0a-9021-249293c0ca6e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Box Club", address="Samou 31, Marousi 151 25",
      city="Athens", country="GR",
      latitude=38.0342302, longitude=23.8079177,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ca98e7f5-e8a3-4e97-908c-954a19e52654_photo.jpg",
      averageRating=4.7, totalRatingsCount=109,
      createdAt="2026-08-31T15:50:45.234351Z", updatedAt="2026-08-31T15:50:45.234351Z",
    ),
    ClubDto(
      id="33be2017-2ea8-4c47-a1e6-cb6943978945", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Glyfada Sole Shareholder Municipal S.A.", address="Κωνσταντίνου Καραμανλή τέρμα, Glifada 165 00",
      city="Athens", country="GR",
      latitude=37.8766052, longitude=23.7438271,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/63930f57-55ac-408a-9871-8df84b1960f2_photo.jpg",
      averageRating=4.7, totalRatingsCount=884,
      createdAt="2026-08-31T15:51:01.044979Z", updatedAt="2026-08-31T15:51:01.044979Z",
    ),
    ClubDto(
      id="b849e65c-3004-41b2-87c2-d1c52e61f912", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lucky Man Billiards Panormou", address="Αχαΐας 46, Αθήνα 115 24",
      city="Athens", country="GR",
      latitude=37.9929526, longitude=23.7611794,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0bc2f31a-37a9-4acc-a17f-aded34e9868b_ChIJY2Phl6mi_2.jpg",
      averageRating=4.7, totalRatingsCount=363,
      createdAt="2026-08-30T22:38:53.827121Z", updatedAt="2026-08-31T22:11:18.619428Z",
    ),
    ClubDto(
      id="eb73c4eb-389a-4f59-99bc-a2c8aabdfa15", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="OAKA INDOOR BEACH VOLLEY", address="Εθνικό Προπονητήριο Στίβου, Οδός Αρτέμιδος, Athina 151 25",
      city="Athens", country="GR",
      latitude=38.0414014, longitude=23.7872364,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/562deb64-cbf5-4571-b22d-969c368d8ed8_photo.jpg",
      averageRating=4.7, totalRatingsCount=70,
      createdAt="2026-08-31T15:50:39.626850Z", updatedAt="2026-08-31T15:50:39.626850Z",
    ),
    ClubDto(
      id="9200afb9-d6e0-47f6-9131-5af8dee518e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="iBeach Volleyball Club", address="Nevrokopiou 1, Papagos 156 69",
      city="Athens", country="GR",
      latitude=37.9898803, longitude=23.7868305,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac806cd4-dd6d-4160-9cdb-451ecacb0f04_photo.jpg",
      averageRating=4.7, totalRatingsCount=382,
      createdAt="2026-08-31T15:50:31.797457Z", updatedAt="2026-08-31T15:50:31.797457Z",
    ),
    ClubDto(
      id="c34d9375-cbbe-42d1-bcf3-949cbfd6136f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Παναθηναϊκό Στάδιο", address="Λεωφ. Βασιλέως Κωνσταντίνου, Αθήνα 116 35",
      city="Athens", country="GR",
      latitude=37.9683342, longitude=23.7411118,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ae001b5c-5b9e-41a3-bc89-ff9c9ae14719_ChIJYRK_3mq9_0.jpg",
      averageRating=4.7, totalRatingsCount=45984,
      createdAt="2026-08-30T22:38:28.290821Z", updatedAt="2026-08-31T08:40:25.676904Z",
    ),
    ClubDto(
      id="a3f8e069-e4b9-468b-a0ad-1798ff593ca3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Glyfada Golf Club of Athens", address="Kon/nou Karamanli, Glifada 166 10",
      city="Athens", country="GR",
      latitude=37.876626, longitude=23.7437138,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7232b64a-fe02-4209-89f1-ad4c65c2c29e_photo.jpg",
      averageRating=4.6, totalRatingsCount=1521,
      createdAt="2026-08-31T15:50:53.407543Z", updatedAt="2026-08-31T15:50:53.407543Z",
    ),
    ClubDto(
      id="68dfd0e9-717e-40e8-aff3-45f1db1e5f67", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Όμιλος Αντισφαιρίσεως Αθηνών", address="Λεωφ. Βασιλίσσης Όλγας 1, Αθήνα 105 57",
      city="Athens", country="GR",
      latitude=37.9691467, longitude=23.7351455,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4045a97e-d2ad-476d-821b-985c1f90e35d_ChIJeZJNNRS9_0.jpg",
      averageRating=4.6, totalRatingsCount=452,
      createdAt="2026-08-30T22:39:36.964242Z", updatedAt="2026-08-30T22:39:36.964242Z",
    ),
    ClubDto(
      id="95c9d56f-e389-48a3-ac56-d08564ba2fd9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Athens Paintball Village", address="Σπύρου Δάβαρη, Κορωπί 194 00",
      city="Athens", country="GR",
      latitude=37.9142199, longitude=23.9124118,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f3a51371-59fc-45b8-bea9-bb7c949483e0_photo.png",
      averageRating=4.5, totalRatingsCount=324,
      createdAt="2026-08-31T15:51:32.598835Z", updatedAt="2026-08-31T15:51:32.598835Z",
    ),
    ClubDto(
      id="ce7df44b-085b-48cb-a29f-23feaeb3ebb5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Magic Paintball Arena Spata.", address="Κοιμήσεως Θεοτοκου θεση πετρέζα, Spata 190 04",
      city="Athens", country="GR",
      latitude=37.9890246, longitude=23.9408951,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6794f48e-54d8-4921-9fff-ee8d6ee79665_photo.jpg",
      averageRating=4.5, totalRatingsCount=398,
      createdAt="2026-08-31T15:51:40.933114Z", updatedAt="2026-08-31T15:51:40.933114Z",
    ),
    ClubDto(
      id="801e2723-43c6-40ff-8326-02111e058176", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Oldschool", address="Σολωμού 13-15, Αθήνα 106 82",
      city="Athens", country="GR",
      latitude=37.9864705, longitude=23.7332458,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d3ac60fb-5818-4e11-bc1d-756720cf658e_ChIJT5t8xbO9_0.jpg",
      averageRating=4.5, totalRatingsCount=287,
      createdAt="2026-08-30T22:39:00.768811Z", updatedAt="2026-08-30T22:39:00.768811Z",
    ),
    ClubDto(
      id="ec029092-38a9-4d41-b2bc-04b41f8d44a4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Γήπεδο Απόστολος Νικολαΐδης", address="Λεωφ. Αλεξάνδρας 160, Αθήνα 115 21",
      city="Athens", country="GR",
      latitude=37.9871904, longitude=23.7541828,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/45b3b2ab-9b26-4f36-bd7a-ed3127c057b8_ChIJS08s2VK9_0.jpg",
      averageRating=4.4, totalRatingsCount=6168,
      createdAt="2026-08-30T22:38:41.318246Z", updatedAt="2026-09-01T14:31:48.015992Z",
    ),
    ClubDto(
      id="440e17ac-9305-4f06-863b-cf62dd0b069a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Γυμναστήριο Παντείου Πανεπιστημίου", address="Ιππώνακτος 36, Αθήνα 117 44",
      city="Athens", country="GR",
      latitude=37.9586956, longitude=23.7276445,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ea455828-688f-47dc-b20b-1f74e359f821_ChIJy5O7qgi9_0.jpg",
      averageRating=4.4, totalRatingsCount=60,
      createdAt="2026-08-30T22:39:20.720108Z", updatedAt="2026-08-30T22:39:20.720108Z",
    ),
    ClubDto(
      id="0fad8f24-2245-446c-be86-770d30ef4bbd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ολυμπιακό Αθλητικό Κέντρο Αθηνών \"Σπύρος Λούης\"", address="Λεωφ. Ολυμπιονίκου Σπύρου Λούη 1, Κ. 151 23, Τ, Αθήνα 151 23",
      city="Athens", country="GR",
      latitude=38.0385619, longitude=23.7864796,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5c0cf6e8-6c01-4786-990d-98c6d37289da_ChIJpVFQJ5WY_0.jpg",
      averageRating=4.4, totalRatingsCount=21466,
      createdAt="2026-08-30T22:38:35.046645Z", updatedAt="2026-08-31T08:40:24.464Z",
    ),
    ClubDto(
      id="f3979120-58b4-49a7-9cdb-fdfe041ecb0e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Metropolitan Bowling Center", address="28ης Οκτωβρίου 122, Αθήνα 112 57",
      city="Athens", country="GR",
      latitude=37.9976556, longitude=23.7329825,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/38e91efa-f0de-4650-98d5-1d258bab9455_ChIJgUQxqM6i_0.jpg",
      averageRating=4.2, totalRatingsCount=690,
      createdAt="2026-08-30T22:39:06.491310Z", updatedAt="2026-08-30T22:39:06.491310Z",
    ),
    ClubDto(
      id="adf1e1a9-af34-4257-9bae-b1713ec240c8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Γήπεδο Γεώργιος Καμάρας", address="Αθήνα 111 42",
      city="Athens", country="GR",
      latitude=38.0282055, longitude=23.741044,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/efe87275-56d9-48c1-bbd6-cf9349a9c6a7_ChIJvUBeH4ui_0.jpg",
      averageRating=4.1, totalRatingsCount=2020,
      createdAt="2026-08-30T22:38:47.225223Z", updatedAt="2026-08-30T22:38:47.225223Z",
    ),
    ClubDto(
      id="70659a16-7896-4566-aa65-572afa871420", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="METS Athens Municipal Indoor Basketball Hall", address="Mark. Mousourou 70, Τ.Κ, Athina 116 36",
      city="Athens", country="GR",
      latitude=37.9639015, longitude=23.7399339,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0ec0348e-b77f-47c8-ae25-8287b11fb7df_photo.jpg",
      averageRating=3.9, totalRatingsCount=510,
      createdAt="2026-08-31T15:50:06.787026Z", updatedAt="2026-08-31T15:50:06.787026Z",
    ),
    ClubDto(
      id="eed361b6-67d1-444e-ab05-622c8e5feca5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Strefi Indoor Stadium", address="Anexartisias, Athina 114 73",
      city="Athens", country="GR",
      latitude=37.9888126, longitude=23.7374425,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9223b68a-7ab9-4f48-81b0-4bd4e187b5d0_photo.jpg",
      averageRating=3.7, totalRatingsCount=233,
      createdAt="2026-08-31T15:50:12.177738Z", updatedAt="2026-08-31T22:11:21.750266Z",
    ),
    ClubDto(
      id="5fd78a55-0a1c-44b4-9485-5c7562704e2d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nitro Kart Team", address="Καλλιρρόης 158, Αθήνα 118 52",
      city="Athens", country="GR",
      latitude=37.963934, longitude=23.7118875,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6243dd36-625f-4448-841c-8f855dbc14d6_ChIJEZJGRfy8_0.jpg",
      averageRating=5.0, totalRatingsCount=20,
      createdAt="2026-08-30T22:39:29.838754Z", updatedAt="2026-08-30T22:39:29.838754Z",
    ),
    ClubDto(
      id="935e1368-1ab6-442b-b7ba-3ecb36283bee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sen7 Table Tennis Club Αιγάλεω - Περιστέρι", address="Leof. Kifisou 166, Egaleo 122 41",
      city="Athens", country="GR",
      latitude=37.9958235, longitude=23.6933471,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a1f056f4-4ac7-4a00-8e27-747ae36cda67_photo.jpg",
      averageRating=4.9, totalRatingsCount=16,
      createdAt="2026-08-31T15:51:10.319438Z", updatedAt="2026-08-31T15:51:10.319438Z",
    ),
  )),
  CitySeo(slug="munich", name="Munich", country="DE", clubCount=28, sports=listOf(Pair("Football", 4), Pair("Basketball", 3), Pair("Volleyball", 3), Pair("Tennis", 3), Pair("Padel", 3), Pair("Bowling", 2), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Laser Tag", 2), Pair("Table Tennis", 2), Pair("Golf", 1), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="a0209f25-0fcb-41d1-9f78-3b0393b5ea33", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PATO Pickleball", address="Königinstraße 34, 80802 München",
      city="Munich", country="DE",
      latitude=48.1556287, longitude=11.5890326,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d39a467a-d81d-4b38-ab74-148c7cf90ec2_ChIJw_0yF451_0.jpg",
      averageRating=4.9, totalRatingsCount=212,
      createdAt="2026-08-30T21:10:19.040445Z", updatedAt="2026-08-30T21:58:53.032275Z",
    ),
    ClubDto(
      id="51a95a73-fda1-4922-adfd-c74d480c542b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Seasons", address="Paul-Ehrlich-Weg 6, 80999 München",
      city="Munich", country="DE",
      latitude=48.1947531, longitude=11.4553491,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac7ea816-a896-4690-97b4-8ecddf018ff7_ChIJ1ZEFqGZ5_0.jpg",
      averageRating=4.8, totalRatingsCount=101,
      createdAt="2026-08-30T21:10:25.522928Z", updatedAt="2026-08-30T21:59:04.181528Z",
    ),
    ClubDto(
      id="98b1c56f-df57-4c78-98fb-7f4b34f1d7bb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball München | PaintballZone", address="Robert-Bosch-Straße 12, 85748 Garching bei München",
      city="Munich", country="DE",
      latitude=48.255024, longitude=11.612558,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b99aa1a2-d295-4abb-9274-41b1e64b2d5f_ChIJOWHhgFNz_0.jpg",
      averageRating=4.8, totalRatingsCount=10464,
      createdAt="2026-08-30T21:09:58.863872Z", updatedAt="2026-08-30T21:59:18.090893Z",
    ),
    ClubDto(
      id="46d3ece4-ea42-4051-8d8a-fa984cf32d8e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boulderwelt München Ost", address="Hanne-Hiob-Straße 4, 81671 München",
      city="Munich", country="DE",
      latitude=48.125872, longitude=11.6110615,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84ee8c52-4ed1-425e-bc59-7253e80f188e_ChIJX4daR4bf_0.jpg",
      averageRating=4.7, totalRatingsCount=3134,
      createdAt="2026-08-30T21:09:43.614619Z", updatedAt="2026-08-30T21:55:36.677619Z",
    ),
    ClubDto(
      id="742a1fab-f118-44ee-8316-9c61d43e40bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasertag München | LaserZone", address="Robert-Bosch-Straße 12, 85748 Garching bei München-Hochbrück",
      city="Munich", country="DE",
      latitude=48.2551801, longitude=11.6130972,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/05342557-3218-42da-9324-4777c031bff0_ChIJK9P9Y_Bz_0.jpg",
      averageRating=4.7, totalRatingsCount=8073,
      createdAt="2026-08-30T21:10:05.109694Z", updatedAt="2026-08-30T21:58:22.877988Z",
    ),
    ClubDto(
      id="c4a06334-b794-4ae9-9439-c3791de17e6e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FLEX", address="Ringseisstraße 11A, 80337 München-Ludwigsvorstadt-Isarvorstadt",
      city="Munich", country="DE",
      latitude=48.1294365, longitude=11.5613863,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/80f90cba-4473-485c-9d7e-1485d7bffb4b_ChIJrWWbTlrf_0.jpg",
      averageRating=4.6, totalRatingsCount=1258,
      createdAt="2026-08-30T21:09:10.492564Z", updatedAt="2026-08-30T21:56:37.607946Z",
    ),
    ClubDto(
      id="1ba8600c-8573-44ef-8016-41b5689f054a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golfpark München Aschheim", address="Fasanenallee 10, 85609 Aschheim",
      city="Munich", country="DE",
      latitude=48.1782818, longitude=11.69937,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2f49f845-f287-4f84-b00e-b323da918aef_photo.jpg",
      averageRating=4.5, totalRatingsCount=221,
      createdAt="2026-08-31T15:16:29.317084Z", updatedAt="2026-08-31T15:16:29.317084Z",
    ),
    ClubDto(
      id="cc499745-7533-45c1-abb5-eb1a82178b25", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hollywood Super Bowling München", address="Forstenrieder Allee 74, 81476 München-Thalkirchen-Obersendling-Forstenried-Fürstenried-Solln",
      city="Munich", country="DE",
      latitude=48.0957756, longitude=11.4975653,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cda294d9-30c9-4f3a-a431-da4c27af0233_ChIJlRMxwxvZ_0.jpg",
      averageRating=4.5, totalRatingsCount=2921,
      createdAt="2026-08-30T21:09:23.898210Z", updatedAt="2026-08-30T21:57:17.269048Z",
    ),
    ClubDto(
      id="90411eea-c521-4cc3-9c5e-27b87d63b3c7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MTTC Iphitos e.V.", address="Aumeisterweg 10, 80805 München-Schwabing-Freimann",
      city="Munich", country="DE",
      latitude=48.1846637, longitude=11.6138191,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ae330c8a-afe4-4143-9046-fcd970ef4f5c_ChIJKbwZ3lt0_0.jpg",
      averageRating=4.5, totalRatingsCount=284,
      createdAt="2026-08-30T21:10:40.324512Z", updatedAt="2026-08-30T21:58:36.667045Z",
    ),
    ClubDto(
      id="88d18621-14f0-4d2d-baae-83b704958eb8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporttraum GmbH", address="Hürderstraße 2a, 85551 Kirchheim bei München",
      city="Munich", country="DE",
      latitude=48.1573447, longitude=11.7563024,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/22939f3e-f328-449c-8e95-fe98c0a13fce_ChIJLaUV5NIL_0.jpg",
      averageRating=4.5, totalRatingsCount=545,
      createdAt="2026-08-30T21:08:49.273131Z", updatedAt="2026-08-30T22:00:37.030997Z",
    ),
    ClubDto(
      id="cc072b84-da49-47ed-a504-18692ea45d1e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TIVO", address="Oettingenstraße 74, 80538 München-Altstadt-Lehel",
      city="Munich", country="DE",
      latitude=48.1493061, longitude=11.595058,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bd8cb17f-4983-4b9f-9d05-04aefe87124e_ChIJlZ_2yo11_1.jpg",
      averageRating=4.5, totalRatingsCount=119,
      createdAt="2026-08-30T21:10:57.044896Z", updatedAt="2026-08-31T22:11:22.280830Z",
    ),
    ClubDto(
      id="eb845f8e-6ed7-43d3-8fad-495fea358e2d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis /Beachvolleyball Hirschau", address="Gyßlingstraße 15, 80805 München-Schwabing-Freimann",
      city="Munich", country="DE",
      latitude=48.1620225, longitude=11.6036768,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bb14f88d-c659-4eea-9537-dac6712902fd_ChIJAcojwaV1_0.jpg",
      averageRating=4.5, totalRatingsCount=122,
      createdAt="2026-08-30T21:10:47.895317Z", updatedAt="2026-08-30T21:10:47.895317Z",
    ),
    ClubDto(
      id="46cfe33f-fe80-48b1-be5d-2ff14923f3e8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beacharena", address="Föhringer Ring 5, 80805 München",
      city="Munich", country="DE",
      latitude=48.1863889, longitude=11.6130556,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/461c3bc2-888f-4072-8883-421b9a65293d_photo.jpg",
      averageRating=4.4, totalRatingsCount=402,
      createdAt="2026-08-31T15:15:54.802873Z", updatedAt="2026-08-31T15:15:54.802873Z",
    ),
    ClubDto(
      id="b886b229-0103-4c78-bc94-22cebf0a725f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Globetrotter München", address="Isartorpl. 8-10, 80331 München-Altstadt-Lehel",
      city="Munich", country="DE",
      latitude=48.1342245, longitude=11.5820781,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c21780d3-0ae6-4a16-9bcb-209f9438ec95_ChIJs4qDdmLf_0.jpg",
      averageRating=4.4, totalRatingsCount=4478,
      createdAt="2026-08-30T21:09:37.174124Z", updatedAt="2026-08-31T08:28:37.316833Z",
    ),
    ClubDto(
      id="22b3cac0-d77a-466b-83ac-1a6ebdeef39c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PadelCity München Tucherpark", address="Am Eisbach 5, 80538 München",
      city="Munich", country="DE",
      latitude=48.1565867, longitude=11.6018468,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f3621c6e-3776-49a0-a295-e879be46fadf_ChIJUYPiglp1_0.jpg",
      averageRating=4.4, totalRatingsCount=84,
      createdAt="2026-08-30T21:10:32.191861Z", updatedAt="2026-08-30T21:10:32.191861Z",
    ),
    ClubDto(
      id="a50b3072-3976-4ad9-b22d-2596d9f78e7b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Soccerworld München", address="Georg-Kainz-Straße 8, 80993 München-Moosach",
      city="Munich", country="DE",
      latitude=48.1903066, longitude=11.5051646,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/71a66c1d-54b4-4068-9ee2-580221ac28b9_ChIJrZxCdAV3_0.jpg",
      averageRating=4.4, totalRatingsCount=894,
      createdAt="2026-08-30T21:08:41.854694Z", updatedAt="2026-08-30T21:08:41.854694Z",
    ),
    ClubDto(
      id="45e488c6-8cf5-45bf-bee1-07d037a2e4ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BOB'S Rock & Bowl München", address="Stockacher Str. 5, 81243 München-Aubing-Lochhausen-Langwied",
      city="Munich", country="DE",
      latitude=48.1500336, longitude=11.4423632,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5f739048-130b-4878-8cc0-281ba9c244fc_ChIJPWPjzQB4_0.jpg",
      averageRating=4.3, totalRatingsCount=2388,
      createdAt="2026-08-30T21:09:30.791922Z", updatedAt="2026-08-30T21:55:19.996744Z",
    ),
    ClubDto(
      id="5b050a3e-d15c-468e-b9cb-197c620d35dd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MAXX Arena", address="Hürderstraße 4, 85551 Kirchheim bei München-Heimstetten",
      city="Munich", country="DE",
      latitude=48.1568169, longitude=11.7579645,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f1812fc-ff47-49e0-90fc-96f23f457108_ChIJkVmS19IL_0.jpg",
      averageRating=4.3, totalRatingsCount=3602,
      createdAt="2026-08-30T21:10:11.814320Z", updatedAt="2026-08-30T21:58:33.871699Z",
    ),
    ClubDto(
      id="88b408f4-9943-49d4-a9ac-9fdf59c9804a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rothof Sport und Restaurant", address="Denninger Str. 120, 81925 München-Bogenhausen",
      city="Munich", country="DE",
      latitude=48.146745, longitude=11.624683,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f7f23c35-187e-4fa3-a5ae-700bd8ab3fb8_photo.jpg",
      averageRating=4.3, totalRatingsCount=678,
      createdAt="2026-08-31T15:16:02.236052Z", updatedAt="2026-08-31T15:16:02.236052Z",
    ),
    ClubDto(
      id="41d38a88-075f-4236-9b77-70130b3a0b0d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TSV Maccabi München e.V.", address="Riemer Str. 300, 81829 München-Trudering-Riem",
      city="Munich", country="DE",
      latitude=48.1390876, longitude=11.6739597,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06e58eca-7fe5-4e84-803c-97fcf65136a0_ChIJm0Sm47sK_0.jpg",
      averageRating=4.3, totalRatingsCount=96,
      createdAt="2026-08-30T21:09:03.598585Z", updatedAt="2026-08-30T21:09:03.598585Z",
    ),
    ClubDto(
      id="5a48d149-e1b7-4e86-b1ad-bb2d283d42aa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Treffpunkt Sportsbar", address="Schleißheimer Str. 125, 80797 München-Schwabing-West",
      city="Munich", country="DE",
      latitude=48.1622011, longitude=11.5635092,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6a582986-78cc-48f4-ac49-fb26221da3c0_ChIJfXFnPtl1_0.jpg",
      averageRating=4.2, totalRatingsCount=730,
      createdAt="2026-08-30T21:09:17.391176Z", updatedAt="2026-08-30T21:09:17.391176Z",
    ),
    ClubDto(
      id="a4219b47-bf34-4050-a972-00f8030e69e3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport-Verein München von 1880 e. V.", address="Tübinger Str. 10, 80686 München-Sendling-Westpark",
      city="Munich", country="DE",
      latitude=48.132298, longitude=11.524829,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7760852-81e3-4e5f-b1ed-d20b26486b71_ChIJG06moKPY_0.jpg",
      averageRating=4.1, totalRatingsCount=110,
      createdAt="2026-08-30T21:08:55.809487Z", updatedAt="2026-08-30T21:08:55.809487Z",
    ),
    ClubDto(
      id="4d610930-99d7-402d-bc54-ffbb916ddc54", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketballplatz Heimeranplatz", address="Astallerstraße 31, 80339 München-Schwanthalerhöhe",
      city="Munich", country="DE",
      latitude=48.1356308, longitude=11.5309064,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a92c58fb-593c-4033-99f8-bd69a9ceb89b_photo.jpg",
      averageRating=4.6, totalRatingsCount=37,
      createdAt="2026-08-31T15:15:47.584622Z", updatedAt="2026-08-31T15:15:47.584622Z",
    ),
    ClubDto(
      id="ca810d69-bf7b-4da8-ac0e-3cb8550697c1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="München Basket", address="Dachauer Str. 98, 80335 München-Maxvorstadt",
      city="Munich", country="DE",
      latitude=48.1529939, longitude=11.5560479,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4712c776-43a3-4dda-9a85-2cd87089788e_photo.jpg",
      averageRating=4.4, totalRatingsCount=31,
      createdAt="2026-08-31T15:15:22.947630Z", updatedAt="2026-08-31T15:15:22.947630Z",
    ),
    ClubDto(
      id="18416fcd-ad11-4d89-8069-133e0e4f8d63", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fc Bayern Basketball GmbH", address="Siegenburger Str. 45, 81373 München",
      city="Munich", country="DE",
      latitude=48.1260869, longitude=11.5256505,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2f8e6349-0aa0-4e37-aecb-5627bd42b36a_photo.jpg",
      averageRating=4.8, totalRatingsCount=27,
      createdAt="2026-08-31T15:15:41.128722Z", updatedAt="2026-08-31T22:11:16.662453Z",
    ),
    ClubDto(
      id="3c758ec6-b2af-4454-a96c-ad3a77a7b2fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach volleyball courts Riemer See", address="Seeweg, 81829 München-Trudering-Riem",
      city="Munich", country="DE",
      latitude=48.127517, longitude=11.711908,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/52bacad5-a269-4a45-be5a-22837475e00f_photo.jpg",
      averageRating=4.3, totalRatingsCount=20,
      createdAt="2026-08-31T15:16:10.487593Z", updatedAt="2026-08-31T15:16:10.487593Z",
    ),
    ClubDto(
      id="a1866820-4f93-4eee-b790-12442a809c5b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TSC Maxvorstadt e.V. - Tischtennis Schwabing", address="Infanteriestraße 27, 80797 München",
      city="Munich", country="DE",
      latitude=48.1606994, longitude=11.5534396,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b7968dd-c88a-4e8e-bc54-cb83860a2e26_photo.jpg",
      averageRating=4.7, totalRatingsCount=6,
      createdAt="2026-08-31T15:16:58.477570Z", updatedAt="2026-08-31T15:16:58.477570Z",
    ),
    ClubDto(
      id="8bfe76ca-e511-473c-86ac-58b21abec381", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tischtennisverein Bayern München", address="Säbener Str. 49, 81547 München-Untergiesing-Harlaching",
      city="Munich", country="DE",
      latitude=48.1027526, longitude=11.5734133,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/430e52dc-13ee-410a-936e-7257d2cff308_photo.jpg",
      averageRating=3.9, totalRatingsCount=7,
      createdAt="2026-08-31T15:16:44.675657Z", updatedAt="2026-08-31T15:16:44.675657Z",
    ),
  )),
  CitySeo(slug="tallinn", name="Tallinn", country="EE", clubCount=28, sports=listOf(Pair("Volleyball", 3), Pair("Tennis", 3), Pair("Football", 3), Pair("Basketball", 3), Pair("Padel", 3), Pair("Golf", 2), Pair("Karting", 2), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Paintball", 2), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="9853c05d-4d67-4dc3-ba36-ff989be5bedf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach House Ülemiste", address="Valukoja tn 12, 11415 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4200036, longitude=24.808812,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/69601c68-375d-4f34-9bcc-770e5a7d05cf_photo.jpg",
      averageRating=4.8, totalRatingsCount=192,
      createdAt="2026-08-31T15:19:45.953666Z", updatedAt="2026-08-31T15:19:45.953666Z",
    ),
    ClubDto(
      id="3a47a19f-33ed-49f9-beee-4720b853b8d6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KIVI Climbing", address="Pärnu mnt. 139e, 11317 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.404781, longitude=24.7348823,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/425ecd35-dc0d-40d6-9e07-af3e40ee6c22_ChIJOxcXrU2V_0.jpg",
      averageRating=4.8, totalRatingsCount=254,
      createdAt="2026-08-30T23:28:05.070678Z", updatedAt="2026-08-31T08:31:06.244165Z",
    ),
    ClubDto(
      id="f496eda2-1950-459d-8710-de47f973ff30", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Terase siserand", address="Lõuka tn 6, 13521 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4271305, longitude=24.6349474,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/20165474-f841-4bfd-9395-bd3fc0691f0c_photo.png",
      averageRating=4.8, totalRatingsCount=589,
      createdAt="2026-08-31T15:19:21.009148Z", updatedAt="2026-08-31T15:19:21.009148Z",
    ),
    ClubDto(
      id="17e80ba0-2361-4029-a1c5-c8404a290dfd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Estonian Golf & Country Club", address="Klubi tee 4, Manniva, 74217 Harju maakond",
      city="Tallinn", country="EE",
      latitude=59.467147, longitude=25.1384568,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/72c5db12-43cf-421f-86f6-c137edb9500d_photo.jpg",
      averageRating=4.7, totalRatingsCount=484,
      createdAt="2026-08-31T15:19:53.489687Z", updatedAt="2026-08-31T15:19:53.489687Z",
    ),
    ClubDto(
      id="3a44c807-560e-4120-aea3-be3c672fff27", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FORUS Spordikeskus Tondi", address="Sõjakooli tn 10, 11316 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4044225, longitude=24.7207098,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e93e994-e388-40c1-ba27-064530c39e32_ChIJnYPr3-eU_0.jpg",
      averageRating=4.7, totalRatingsCount=197,
      createdAt="2026-08-30T23:29:14.671258Z", updatedAt="2026-08-31T08:27:44.979298Z",
    ),
    ClubDto(
      id="5d8d0a9a-841e-4cdf-8094-d2924f9d3664", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Militaarseiklus OÜ", address="Männiku tee 106, 11216 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.3652062, longitude=24.7170905,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/55a3fd25-d8d4-44f1-931d-8974a3691642_ChIJMeC-hkmV_0.jpg",
      averageRating=4.7, totalRatingsCount=324,
      createdAt="2026-08-30T23:28:40.085689Z", updatedAt="2026-08-30T23:28:40.085689Z",
    ),
    ClubDto(
      id="de863542-32d1-4b75-ae13-b1c9d6668528", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Play Arena", address="Punane tn 6, 13619 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4318958, longitude=24.8142059,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/146cf996-a8f3-4ed7-89fc-3db450a70192_photo.jpg",
      averageRating=4.7, totalRatingsCount=79,
      createdAt="2026-08-31T15:18:57.827438Z", updatedAt="2026-08-31T15:18:57.827438Z",
    ),
    ClubDto(
      id="fa41bd4e-efea-4254-81ad-868b3d76d113", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rae Golf", address="Golfi tee, Suuresta, Suuresta, 75318 Harju maakond",
      city="Tallinn", country="EE",
      latitude=59.3077756, longitude=24.9759592,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e86cdcdf-a3fd-4100-8795-92ee9188906a_photo.jpg",
      averageRating=4.7, totalRatingsCount=311,
      createdAt="2026-08-31T15:20:02.671893Z", updatedAt="2026-08-31T15:20:02.671893Z",
    ),
    ClubDto(
      id="540543e1-18ab-4a51-8552-ab9907024f8e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ronimisministeerium Hipodroom", address="Hipodroomi tn 13, 10614 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4349682, longitude=24.7029006,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2d742d64-cbe4-42fb-a11a-e2bff5c2c1ce_ChIJy34dg6mU_0.jpg",
      averageRating=4.7, totalRatingsCount=376,
      createdAt="2026-08-30T23:27:58.342386Z", updatedAt="2026-08-31T08:35:25.809059Z",
    ),
    ClubDto(
      id="8e8d3e98-5562-4ec9-bc30-342f8ef84e50", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tallink Tennisekeskus", address="Osmussaare tn 7, 13811 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4365217, longitude=24.8664383,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ad106352-d801-4f44-a206-c906ea46ca29_ChIJAVAc0ezs_0.jpg",
      averageRating=4.7, totalRatingsCount=577,
      createdAt="2026-08-30T23:29:07.927217Z", updatedAt="2026-08-31T08:37:23.060922Z",
    ),
    ClubDto(
      id="4b35f430-a732-417b-af71-ca3cb851146a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golden Club", address="Sõjakooli tn 10, 11316 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4044574, longitude=24.7209841,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/376ef4e9-05bb-4230-81c6-22d137203ffb_ChIJsXu4deiU_2.jpg",
      averageRating=4.6, totalRatingsCount=166,
      createdAt="2026-08-30T23:29:21.585842Z", updatedAt="2026-08-31T22:11:17.103517Z",
    ),
    ClubDto(
      id="992b855f-f909-412f-aae3-6d5576242733", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kalev Sports Hall", address="Juhkentali tn 12, 10132 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4273164, longitude=24.7604675,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a20c57b-3dac-4b34-b134-f665f5f6ae71_photo.jpg",
      averageRating=4.6, totalRatingsCount=918,
      createdAt="2026-08-31T15:19:04.654203Z", updatedAt="2026-08-31T15:19:04.654203Z",
    ),
    ClubDto(
      id="14bbecc0-785b-4fd3-98c7-099d02ede92b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasergame Megazone", address="Madara tn 22a, 10613 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4307193, longitude=24.720568,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ccee769c-b73e-4c31-8648-1a6be314c1ef_ChIJg359Xb_s_0.jpg",
      averageRating=4.6, totalRatingsCount=827,
      createdAt="2026-08-30T23:28:26.669387Z", updatedAt="2026-08-30T23:28:26.669387Z",
    ),
    ClubDto(
      id="500a5ccb-a982-482a-a5c2-9c9a843b78a1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel+ Kawe", address="Paepargi tn 11, 11414 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4299289, longitude=24.8008098,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2455b72c-02e2-44a4-bf41-edf69b01057d_ChIJfzV_JgDt_0.jpg",
      averageRating=4.6, totalRatingsCount=61,
      createdAt="2026-08-30T23:28:54.486472Z", updatedAt="2026-08-30T23:28:54.486472Z",
    ),
    ClubDto(
      id="edb1c603-9c03-43d6-b48d-fbc60295dc16", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel+ Klick", address="Suur-Paala tn 19, 11415 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4287815, longitude=24.8135157,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/88c1d93e-c077-4fc0-bbd6-4dd68981df40_ChIJKxYPrh3t_0.jpg",
      averageRating=4.6, totalRatingsCount=77,
      createdAt="2026-08-30T23:28:47.382355Z", updatedAt="2026-09-01T14:31:58.852807Z",
    ),
    ClubDto(
      id="146ca4bb-d4ba-48b8-9baf-931472c442d7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Võidusõidu OÜ", address="Pärnu mnt. 556a, 76401 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.3430484, longitude=24.615467,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a0f8d17-66d3-44c2-8562-4ef7cb616f72_ChIJDw34tMq__0.jpg",
      averageRating=4.6, totalRatingsCount=502,
      createdAt="2026-08-30T23:28:12.366490Z", updatedAt="2026-08-30T23:28:12.366490Z",
    ),
    ClubDto(
      id="76ea5d95-644d-4b05-bcaa-4e441339714a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FK Keskus", address="Paldiski mnt 229a, 13520 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.406784, longitude=24.6272342,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1b8eac6e-333c-4808-ac27-bed62bc2662b_ChIJNWTId8yV_0.jpg",
      averageRating=4.5, totalRatingsCount=476,
      createdAt="2026-08-30T23:28:19.693808Z", updatedAt="2026-08-31T08:27:43.525267Z",
    ),
    ClubDto(
      id="6cb9c73c-2024-435f-aca6-b1e05a926a55", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kadrioru Staadion", address="Roheline aas 24, 10127 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4345024, longitude=24.7833478,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ab387884-dace-4570-ae05-93125b22d034_ChIJwWq70lCT_0.jpg",
      averageRating=4.5, totalRatingsCount=803,
      createdAt="2026-08-30T23:27:21.583805Z", updatedAt="2026-08-30T23:27:21.583805Z",
    ),
    ClubDto(
      id="6a2d2150-2a3c-4893-9195-f924bdd23fd0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kingpool147", address="J. Kunderi tn 8a, 10121 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4329794, longitude=24.7653865,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b3700a6-44af-4a70-bc01-922d5e35f05d_ChIJv7HmSV-T_0.jpg",
      averageRating=4.5, totalRatingsCount=160,
      createdAt="2026-08-30T23:27:35.655622Z", updatedAt="2026-08-30T23:27:35.655622Z",
    ),
    ClubDto(
      id="fd7c5339-4298-44e0-862e-e149f7ce70fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KrabiBowling", address="Punane tn 16/2, 13619 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4324575, longitude=24.8239678,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a8b25860-915d-4df9-a8e6-bf7ded51cc88_ChIJc94xr7rs_0.jpg",
      averageRating=4.5, totalRatingsCount=975,
      createdAt="2026-08-30T23:27:51.581846Z", updatedAt="2026-08-30T23:27:51.581846Z",
    ),
    ClubDto(
      id="3cb059a5-f503-440f-918d-da26346d90e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PROTO Invention Factory", address="Peetri tn 10, 10415 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4516665, longitude=24.7303614,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6fc8f0e1-bb87-4d67-89e5-a34b02735992_ChIJswrDzM-T_0.jpg",
      averageRating=4.5, totalRatingsCount=3429,
      createdAt="2026-08-30T23:28:33.007843Z", updatedAt="2026-08-31T08:33:38.877645Z",
    ),
    ClubDto(
      id="f3a8478c-d4f7-4ff1-a3d1-9a02761b4850", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pepsi Piljard", address="Mahtra tn 7, 13811 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4415877, longitude=24.874086,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f75ddf32-8b89-42e9-800e-27c37a152791_ChIJmcEIZe7s_0.jpg",
      averageRating=4.5, totalRatingsCount=416,
      createdAt="2026-08-30T23:27:28.328126Z", updatedAt="2026-08-30T23:27:28.328126Z",
    ),
    ClubDto(
      id="f0849713-68d8-4d94-8656-30f301a0aefa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sparta Sports Club", address="Pärnu mnt. 139c, 11317 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4064407, longitude=24.7340679,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9cfadddc-a866-47f0-bb6c-5cbc471ab2d4_photo.jpg",
      averageRating=4.5, totalRatingsCount=792,
      createdAt="2026-08-31T15:19:12.084046Z", updatedAt="2026-08-31T15:19:12.084046Z",
    ),
    ClubDto(
      id="95726c4a-be3c-4b1e-b1f0-faa0c98b8360", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tondiraba Jäähall", address="Varraku tn 14, 13917 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4434906, longitude=24.8485379,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/52883887-f57b-4852-a95b-4b8d3538de25_ChIJfc4bGMHs_1.jpg",
      averageRating=4.5, totalRatingsCount=3381,
      createdAt="2026-08-30T23:27:01.127973Z", updatedAt="2026-08-31T22:11:23.345235Z",
    ),
    ClubDto(
      id="1a60dc91-c992-4af8-9277-b2e14703c8d5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kuulsaal Mere pst.", address="Mere pst 6, 10111 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4393694, longitude=24.7542874,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/590d76c6-d42e-4175-879a-40982ce077f4_ChIJb7NJJWGT_0.jpg",
      averageRating=4.4, totalRatingsCount=2186,
      createdAt="2026-08-30T23:27:44.576628Z", updatedAt="2026-08-31T08:31:37.172265Z",
    ),
    ClubDto(
      id="79beb2a1-ab28-4e88-9693-102267c947ea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sõle Spordikeskus", address="Sõle tn 40a, 10317 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4421069, longitude=24.706986,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e654400-e14e-4d88-9fda-5ef84795351b_ChIJv-UfuniU_0.jpg",
      averageRating=4.4, totalRatingsCount=1221,
      createdAt="2026-08-30T23:27:15.063154Z", updatedAt="2026-08-30T23:27:15.063154Z",
    ),
    ClubDto(
      id="4acdc1d3-6fdb-47c4-af84-0d548ad61ea8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padelstar Helme Keskus", address="Helme tn 18, 10614 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4395689, longitude=24.7006149,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e67a7412-34d3-459b-a140-0d6ba1380a3d_ChIJvVxVMACV_0.jpg",
      averageRating=4.1, totalRatingsCount=53,
      createdAt="2026-08-30T23:29:01.348292Z", updatedAt="2026-08-31T08:34:11.568988Z",
    ),
    ClubDto(
      id="fe457862-db0b-4f7b-9154-f571fe924407", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ring Sport Beach - Rannavolle & Rannatennis & Rannajalgpall", address="Õismäe tee 130, 13513 Tallinn",
      city="Tallinn", country="EE",
      latitude=59.4172446, longitude=24.6447758,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0877c8ea-56aa-4807-8e44-21e1f425507d_photo.jpg",
      averageRating=4.5, totalRatingsCount=32,
      createdAt="2026-08-31T15:19:32.491981Z", updatedAt="2026-08-31T22:11:21.122261Z",
    ),
  )),
  CitySeo(slug="istanbul", name="Istanbul", country="TR", clubCount=27, sports=listOf(Pair("Volleyball", 3), Pair("Padel", 3), Pair("Tennis", 3), Pair("Basketball", 3), Pair("Football", 2), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Paintball", 2), Pair("Karting", 2), Pair("Bowling", 1), Pair("Table Tennis", 1), Pair("Golf", 1)), clubs=listOf(
    ClubDto(
      id="5fbc3bc2-7dbd-4ff0-8062-db77d47aec2c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le Padel", address="Clubsporium, Akat, Cumhuriyet Cd. No:4, 34335 Beşiktaş/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.0871719, longitude=29.0242892,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/982ebf6b-f457-470f-a1c7-1c4c5ce4f654_ChIJhaHPzmi3_0.jpg",
      averageRating=4.9, totalRatingsCount=63,
      createdAt="2026-08-30T23:09:21.824018Z", updatedAt="2026-08-31T08:32:26.284691Z",
    ),
    ClubDto(
      id="6b25ad23-2e55-4e09-bcd5-b54e919f7fdc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bilardo Max", address="Bahçelievler Mahallesi Mehmetçik Sokak, Gökbakan İşmerkezi, Bahçelievler, 6/3. Sk., 34180 Bahçelievler/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9967978, longitude=28.8650671,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f52f838-32c2-487a-ae7d-7cecf6b42935_ChIJpavgJVK7_0.jpg",
      averageRating=4.8, totalRatingsCount=525,
      createdAt="2026-08-30T23:07:48.790994Z", updatedAt="2026-08-30T23:07:48.790994Z",
    ),
    ClubDto(
      id="bf457845-1fc2-4603-9aef-532041143e21", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="DuvarX", address="Aydınevler Mah.Çimenlikli Sok. B Blok No:3/B Küçükyalı, Aydınevler, 34854 Maltepe/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.95057, longitude=29.124172,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0530bfc-7685-43a1-b71c-3797d9f71950_ChIJXdLFzO3G_0.jpg",
      averageRating=4.8, totalRatingsCount=325,
      createdAt="2026-08-30T23:08:25.034342Z", updatedAt="2026-08-30T23:08:25.034342Z",
    ),
    ClubDto(
      id="aa6ee930-a4de-4f68-8d6a-22c1fee2a645", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Frame Bilardo & Snooker Salonu", address="Fulya, Vefa Deresi Sk. No:29/B, 34394 Şişli/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.061631, longitude=29.0011714,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b050cd77-ba4a-4fb1-b035-508505efceb7_ChIJRYmKH_m3_1.jpg",
      averageRating=4.8, totalRatingsCount=409,
      createdAt="2026-08-30T23:07:56.044033Z", updatedAt="2026-08-31T22:11:16.888575Z",
    ),
    ClubDto(
      id="98a1bb2d-8ceb-49a1-a07f-429e04db1318", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boulderhane", address="Levent, Büyükdere Cd. Metrocity AVM içi No:171 D:1.kat, 34330 Şişli/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.07595, longitude=29.01342,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8af66731-e4b0-4a2a-bb61-5130f05041f3_ChIJJ0StOGO2_0.jpg",
      averageRating=4.7, totalRatingsCount=512,
      createdAt="2026-08-30T23:08:18.320072Z", updatedAt="2026-08-31T08:26:24.988763Z",
    ),
    ClubDto(
      id="f2d69a5c-ec11-4495-835c-5050e9b6fef8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fenerbahçe Veteran Table Tennis Club", address="Adres:, Fikirtepe, Hızırbey Cd. No:115, 34720 Kadıköy/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9906183, longitude=29.0538352,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/398bd7bb-813f-44c6-9624-9270e3e3b3c6_photo.jpg",
      averageRating=4.7, totalRatingsCount=99,
      createdAt="2026-08-31T15:15:13.922186Z", updatedAt="2026-08-31T15:15:13.922186Z",
    ),
    ClubDto(
      id="161387e6-959c-4fe9-9c5b-5804badc91f5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Olimpik Gokart", address="-2, Fevzi Çakmak, Fatih Cd. Bağcılar Olimpik Spor Salonu 50/A, 34200 Bağcılar/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.0421388, longitude=28.8537785,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0d1e35b6-3d05-4094-9dbe-280681f70846_ChIJi2ZXpsy6_0.jpg",
      averageRating=4.7, totalRatingsCount=5749,
      createdAt="2026-08-30T23:08:30.830262Z", updatedAt="2026-08-30T23:08:30.830262Z",
    ),
    ClubDto(
      id="c7e3976b-938b-4df6-ba01-869d4ab74198", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tüpraş Stadyumu", address="Vişnezade, Dolmabahçe Cd. No:1, 34357 Beşiktaş/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.0390029, longitude=28.9945064,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db700361-f3fc-4f51-8ffc-3454cbba3950_ChIJ615x-Xa3_0.jpg",
      averageRating=4.7, totalRatingsCount=27638,
      createdAt="2026-08-30T23:07:29.543987Z", updatedAt="2026-08-30T23:07:29.543987Z",
    ),
    ClubDto(
      id="d35b5c94-b2cf-470d-9b07-711577ec6993", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ülker Sports Arena", address="Barbaros, Ihlamur Blv., 34746 Ataşehir/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9928526, longitude=29.1048085,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/255a3572-1ced-4b53-a303-fe7e2383e6f0_photo.jpg",
      averageRating=4.7, totalRatingsCount=9481,
      createdAt="2026-08-31T15:14:30.558918Z", updatedAt="2026-08-31T15:14:30.558918Z",
    ),
    ClubDto(
      id="119bbab7-ae38-4549-b75f-7cd98e654189", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Casa Kilyos Padel Club", address="Kumköy, 34450 Sarıyer, Kumköy, 34450 Sarıyer/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.2398338, longitude=29.0410919,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed806028-959b-4120-8a41-ac12afb6291e_ChIJ2URJW-7n_0.jpg",
      averageRating=4.6, totalRatingsCount=297,
      createdAt="2026-08-30T23:09:14.399717Z", updatedAt="2026-08-31T08:26:44.419590Z",
    ),
    ClubDto(
      id="37c71901-ddd2-4e55-b8aa-c7c11d715bd7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sinan Erdem Dome", address="Zuhuratbaba, Ataköy Blv. No:14, 34147 Bakırköy/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9884318, longitude=28.8539956,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e3748090-9ef7-49b8-b4e2-cf262e9953f8_photo.jpg",
      averageRating=4.6, totalRatingsCount=5658,
      createdAt="2026-08-31T15:14:36.455100Z", updatedAt="2026-08-31T15:14:36.455100Z",
    ),
    ClubDto(
      id="c140bdff-5287-4cdf-b806-c3f359bc5db4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Alfie The Padel Bostancı", address="Bostancı, Tünel Girişi Sk. No:10, 34744 Kadıköy, Bostancı, 34744 Kadıköy/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9600312, longitude=29.1090767,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7cd39cfe-c756-4ec1-8196-c2150ade8a1c_ChIJxYh3xz_H_0.jpg",
      averageRating=4.5, totalRatingsCount=51,
      createdAt="2026-08-30T23:09:29.002868Z", updatedAt="2026-08-30T23:09:29.002868Z",
    ),
    ClubDto(
      id="50703d39-c1b8-45b0-946f-6220ccf78a35", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Counter Laser Tag", address="Yamanevler, Küçüksu Cd. No:8/B, 34768 Ümraniye/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.0253923, longitude=29.1008586,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cfd9bbd2-ac2d-4210-af3e-70154dc02fec_ChIJE_XYiojF_0.jpg",
      averageRating=4.5, totalRatingsCount=759,
      createdAt="2026-08-30T23:08:52.306665Z", updatedAt="2026-08-30T23:08:52.306665Z",
    ),
    ClubDto(
      id="5bd3fe19-5733-4d02-afbe-9d912fc95919", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Enka Spor Kulübü", address="Sadi Gülçelik Spor Sitesi, Poligon Mah, İstinye, Katar Cd 15/A, 34440 Sarıyer/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.1116539, longitude=29.0377733,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/500a6a2f-2209-4266-bbb5-492461f38bfe_ChIJSZvsOoy1_0.jpg",
      averageRating=4.5, totalRatingsCount=871,
      createdAt="2026-08-30T23:09:36.553890Z", updatedAt="2026-09-01T14:31:49.500332Z",
    ),
    ClubDto(
      id="3d43d103-c53b-494a-9a77-9dba88bdadf4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hedef Paintball", address="Piknik mesire alanı, Başıbüyük, Büyükbakkalköy-Ümraniye Bağlantı Yolu No:94, 34854 Maltepe/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9607696, longitude=29.1685616,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac37d40e-8773-4e56-b02a-4fbb610f0a70_ChIJ____4r3F_0.jpg",
      averageRating=4.5, totalRatingsCount=969,
      createdAt="2026-08-30T23:09:05.878946Z", updatedAt="2026-08-31T08:28:59.191043Z",
    ),
    ClubDto(
      id="69ac8719-88dd-4183-824f-c45ae4d57af9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Istanbul Metropolitan Municipality Maltepe Sports Facilities", address="Orhangazi Şehir Parkı Maltepe Sahil Dolgu Alanı, Turgut Özal Blv. No:167 Yalı Mahallesi 34844 Maltepe/Istanbul, Çınar, 34844 Maltepe/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9404614, longitude=29.1094846,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/87832003-bb70-457b-94a0-8da4e9df82b8_photo.jpg",
      averageRating=4.5, totalRatingsCount=882,
      createdAt="2026-08-31T15:14:41.665410Z", updatedAt="2026-08-31T22:11:17.971150Z",
    ),
    ClubDto(
      id="7e68cd00-17dc-4e9b-9dee-de78e91b010c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TENİS ESKRİM DAĞCILIK KULÜBÜ (TED)", address="Tarabya, Tarabya Bayırı Cd. No:80 No:80, 34457 Sarıyer/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.1393581, longitude=29.0329454,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b9d043f1-4551-4e2d-b63d-1e46d05de508_ChIJaSZsAWW1_0.jpg",
      averageRating=4.5, totalRatingsCount=571,
      createdAt="2026-08-30T23:09:51.337095Z", updatedAt="2026-08-31T08:37:14.119689Z",
    ),
    ClubDto(
      id="7cd8bd3a-8748-4410-845f-845e45adbb87", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="EVO Sports", address="Uğur Mumcu, Samandıra Cad., 34882 Kartal/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9325247, longitude=29.2213875,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/22a8837a-6deb-430e-8117-f34843d0520d_ChIJk0trVy_F_0.jpg",
      averageRating=4.4, totalRatingsCount=1342,
      createdAt="2026-08-30T23:08:45.144080Z", updatedAt="2026-08-31T08:27:33.357993Z",
    ),
    ClubDto(
      id="171c451b-f540-4428-b5b4-b3940d5005a2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Yeşilyurt Spor Kulübü", address="Yeşilyurt, Sahil Yolu Cd. No:6, 34149 Bakırköy/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9621034, longitude=28.8413185,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1b965b17-610a-4ca9-b087-cab4a4f5a8ae_ChIJZUMsdSSj_0.jpg",
      averageRating=4.4, totalRatingsCount=871,
      createdAt="2026-08-30T23:09:44.059612Z", updatedAt="2026-08-31T08:39:14.585634Z",
    ),
    ClubDto(
      id="560f6ab6-5ad5-4ae9-b439-6e530e36f9ad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ÜCRETSİZ OTOPARK AÇIK ALAN ( TOSFED ) KALİTE ÖDÜLLÜ ARAÇ ÇOK (SIRA YOK) GOKART", address="Beylerbeyi, Beybostanı Sk. 2-5, 34676 Üsküdar/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.0411223, longitude=29.0434635,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11970fc9-77ea-4293-992f-50b53de5435c_ChIJN1nB1tm3_0.jpg",
      averageRating=4.3, totalRatingsCount=2068,
      createdAt="2026-08-30T23:08:38.586839Z", updatedAt="2026-08-30T23:08:38.586839Z",
    ),
    ClubDto(
      id="00adeefd-e6d7-4354-89ee-1dc55a35ad39", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Natural Paintball & Laser Tag", address="Başıbüyük, Başıbüyük Yolu Cd no:54 f, 34854 Maltepe/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9687308, longitude=29.1442775,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5117d78d-1e16-4d67-8eb6-bfeaa6013b5a_ChIJKdz-gXbH_0.jpg",
      averageRating=4.2, totalRatingsCount=985,
      createdAt="2026-08-30T23:08:58.921754Z", updatedAt="2026-08-31T08:33:12.884288Z",
    ),
    ClubDto(
      id="cbf67288-cf56-4feb-baf1-7a2ef51c8e49", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Başakşehir Fatih Terim Stadyumu", address="4.Etap Fatih Teri̇m Stadı Başakşehir, Başak, Yunus Emre Cd., 34480 Başakşehir/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.122784, longitude=28.8087189,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d6ef9c4-a162-4e0b-b2ab-8326f0c709df_ChIJg4JaiP2u_0.jpg",
      averageRating=4.1, totalRatingsCount=4624,
      createdAt="2026-08-30T23:07:42.372343Z", updatedAt="2026-08-30T23:07:42.372343Z",
    ),
    ClubDto(
      id="323181c7-bffd-46bf-b3ff-3f32d9df862a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hakkı Başar Sport Complex", address="Tuna, Hakkı Başar Sk. No:16, 34225 Esenler/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.0452778, longitude=28.8663889,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77975c7f-0a83-42e3-a9de-91f59b112c47_photo.jpg",
      averageRating=4.1, totalRatingsCount=722,
      createdAt="2026-08-31T15:14:53.487420Z", updatedAt="2026-08-31T15:14:53.487420Z",
    ),
    ClubDto(
      id="8507adb9-f1fb-46b7-b426-d2ad0a31f0b8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Alley", address="Şehit Muhtar, İstiklal Cd. NO:12, 34435 Beyoğlu/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.0358966, longitude=28.9828536,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/334d76ce-5822-4d10-9850-1c7665619ed7_ChIJucsy2yS3_0.jpg",
      averageRating=4.0, totalRatingsCount=646,
      createdAt="2026-08-30T23:08:04.233863Z", updatedAt="2026-08-30T23:08:04.233863Z",
    ),
    ClubDto(
      id="4fbb3bfb-a3f3-4d91-8097-a4efc2116e40", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Istanbul Golf Club", address="Kuzguncuk, Kuşbakışı Sk., Gümüşyolu Caddesi, Bağlarbaşı Korusu No:16, 34674 Üsküdar/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.0318744, longitude=29.0400222,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0d6572ea-9d06-41a6-978f-41edb0968210_photo.jpg",
      averageRating=4.2, totalRatingsCount=43,
      createdAt="2026-08-31T15:15:07.435104Z", updatedAt="2026-08-31T15:15:07.435104Z",
    ),
    ClubDto(
      id="ddc63f23-c916-44ba-9c23-924e49d56558", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Unipro Sportif Faaliyetler Anonim Şirketi Haydarpaşa Halısaha", address="Haydarpaşa M.T, Selimiye, Tıbbiye Cd A.L. no :29/1, 34660 Üsküdar/İstanbul",
      city="Istanbul", country="TR",
      latitude=41.0030603, longitude=29.0224114,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cdd4fd28-317c-48d8-b86d-85fe4d2d2178_photo.png",
      averageRating=3.6, totalRatingsCount=103,
      createdAt="2026-08-31T15:15:00.202148Z", updatedAt="2026-08-31T15:15:00.202148Z",
    ),
    ClubDto(
      id="53b49621-a069-4c5d-b85f-f38b3c53c16d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="10 Sports ARENA", address="Atatürk, Şeref Sk. No:1, 34758 Ataşehir/İstanbul",
      city="Istanbul", country="TR",
      latitude=40.9849833, longitude=29.1366931,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5743cd22-884b-4f6d-ad65-87966771cf38_photo.jpg",
      averageRating=4.3, totalRatingsCount=29,
      createdAt="2026-08-31T15:14:47.686057Z", updatedAt="2026-08-31T15:14:47.686057Z",
    ),
  )),
  CitySeo(slug="lyon", name="Lyon", country="FR", clubCount=27, sports=listOf(Pair("Volleyball", 4), Pair("Football", 4), Pair("Tennis", 3), Pair("Basketball", 3), Pair("Table Tennis", 2), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Laser Tag", 2), Pair("Golf", 2), Pair("Karting", 1), Pair("Paintball", 1), Pair("Padel", 1)), clubs=listOf(
    ClubDto(
      id="f0f8ae35-7e64-4556-91db-52637b4abd4c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hapik Salle d'escalade et accrobranche Lyon", address="133 Rue Servient, 69003 Lyon",
      city="Lyon", country="FR",
      latitude=45.7620194, longitude=4.8538965,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dd8e75ac-a4fd-49cb-9fdf-d0a25f03a351_ChIJ9TFuJk_r_0.jpg",
      averageRating=4.9, totalRatingsCount=1608,
      createdAt="2026-08-30T21:16:57.050941Z", updatedAt="2026-08-30T21:57:13.452673Z",
    ),
    ClubDto(
      id="4169cd53-f0a0-4931-bc2d-6743313ca5fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SENSAS LYON", address="14 Rue Michel Félizat, 69007 Lyon",
      city="Lyon", country="FR",
      latitude=45.7361306, longitude=4.8350255,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/624f0432-a26f-4423-9e7a-a1315d4422d1_ChIJu_EJDzDq_0.jpg",
      averageRating=4.9, totalRatingsCount=5682,
      createdAt="2026-08-30T21:17:10.702127Z", updatedAt="2026-08-30T21:59:49.985035Z",
    ),
    ClubDto(
      id="235926f3-2e3d-459c-a3ff-ada4dea59fd8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club de Gerland", address="405 Av. Jean Jaurès, 69007 Lyon",
      city="Lyon", country="FR",
      latitude=45.7209481, longitude=4.8277911,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/18399288-b0a8-455a-8762-74aa5b8e7a84_ChIJlct1_x_p_0.jpg",
      averageRating=4.9, totalRatingsCount=71,
      createdAt="2026-08-30T21:17:48.629994Z", updatedAt="2026-08-30T22:01:26.614723Z",
    ),
    ClubDto(
      id="5389b3e8-9dc5-43dd-94d6-349a356443ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cap Tennis Lyon", address="28 Quai Victor Augagneur, 69003 Lyon",
      city="Lyon", country="FR",
      latitude=45.757372, longitude=4.8409106,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d582aff0-5cd6-4d1f-bda1-6b8d6c344e45_ChIJ81s_RFrq_1.jpg",
      averageRating=4.8, totalRatingsCount=112,
      createdAt="2026-08-30T21:17:33.253394Z", updatedAt="2026-08-31T22:11:14.779246Z",
    ),
    ClubDto(
      id="e0eb48f9-c00c-4f7d-a6e9-fe1944b24758", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Canopée - LYONSO Basket", address="30 Rue Charles de Gaulle, 69310 Oullins-Pierre-Bénite",
      city="Lyon", country="FR",
      latitude=45.6995855, longitude=4.8181981,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/224c8054-73ce-403d-ae6c-19fedc565c83_photo.jpg",
      averageRating=4.8, totalRatingsCount=166,
      createdAt="2026-08-31T15:45:47.592266Z", updatedAt="2026-08-31T15:45:47.592266Z",
    ),
    ClubDto(
      id="bf1aa38a-c304-4e66-aea1-d773707e3899", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Foot.FR Lyon", address="12 Av. Jean Jaurès, 69007 Lyon",
      city="Lyon", country="FR",
      latitude=45.753096, longitude=4.8463149,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d34267c9-fe5b-4674-88bc-6b1377232db3_ChIJLc2UbAXr_1.jpg",
      averageRating=4.7, totalRatingsCount=188,
      createdAt="2026-08-30T21:16:21.083879Z", updatedAt="2026-08-31T22:11:16.781445Z",
    ),
    ClubDto(
      id="65d682bc-e8dc-4ea6-a03b-1b3f0c0f0ad4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mini karting du Parc de la Tête d'Or - LA PISTE DU BOIS", address="Allée de l'Orangerie, All. des Ébats, 69006 Lyon",
      city="Lyon", country="FR",
      latitude=45.7796492, longitude=4.8568813,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/91beda2d-139a-4c9e-b4eb-cec80bcfdcd0_ChIJQVmzqZXq_0.jpg",
      averageRating=4.7, totalRatingsCount=75,
      createdAt="2026-08-30T21:17:04.287614Z", updatedAt="2026-08-30T21:58:37.616719Z",
    ),
    ClubDto(
      id="c5b31885-0cb0-413e-b7d9-05939b05e4d6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Nature Mions", address="71 bis Rue Mangetemps, 69780 Mions",
      city="Lyon", country="FR",
      latitude=45.67088, longitude=4.9420308,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/18caa842-6974-4dc0-8342-2e45a44a4d32_photo.jpg",
      averageRating=4.7, totalRatingsCount=366,
      createdAt="2026-08-31T15:46:51.069519Z", updatedAt="2026-08-31T22:11:19.698610Z",
    ),
    ClubDto(
      id="d34bbbe7-355e-41d8-8bb0-1d85222dd97e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climb Up Lyon Gerland", address="11 Rue Lortet, 69007 Lyon",
      city="Lyon", country="FR",
      latitude=45.7431257, longitude=4.83558,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6703a3cc-211b-492a-9ad6-92f2064b2f6e_ChIJvy_Mmzfq_0.jpg",
      averageRating=4.6, totalRatingsCount=2135,
      createdAt="2026-08-30T21:16:50.072262Z", updatedAt="2026-08-30T21:56:07.188450Z",
    ),
    ClubDto(
      id="1e09ea57-3472-4afe-85c8-175e0011a926", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lyon Golf Club", address="3 Rue des Acacias, 38280 Villette-d'Anthon",
      city="Lyon", country="FR",
      latitude=45.8056446, longitude=5.1096666,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8ec9dae2-dda4-4219-9cf1-a6513387cb56_photo.jpg",
      averageRating=4.6, totalRatingsCount=345,
      createdAt="2026-08-31T15:46:20.898703Z", updatedAt="2026-08-31T15:46:20.898703Z",
    ),
    ClubDto(
      id="750e6fe3-2d23-47c0-b336-b5fb8148d894", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paddy's Corner", address="4 Rue de la Terrasse, 69004 Lyon",
      city="Lyon", country="FR",
      latitude=45.774746, longitude=4.8307184,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1535c7ae-904c-4700-821e-06cc82f0f67f_ChIJv-_lZx3r_0.jpg",
      averageRating=4.5, totalRatingsCount=2640,
      createdAt="2026-08-30T21:16:36.025385Z", updatedAt="2026-08-30T21:58:55.110229Z",
    ),
    ClubDto(
      id="e6e85ce6-2449-46c5-ae70-6a7eac8e62c5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport dans la Ville - Campus Rhône-Alpes", address="15 Quai de la Gare d'Eau Bât 2, 69009 Lyon",
      city="Lyon", country="FR",
      latitude=45.7811703, longitude=4.8081568,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f472b039-4f8f-462c-9f7a-9b824ce0d240_ChIJoUEDcmvr_0.jpg",
      averageRating=4.5, totalRatingsCount=924,
      createdAt="2026-08-30T21:16:13.363453Z", updatedAt="2026-08-30T21:16:13.363453Z",
    ),
    ClubDto(
      id="16edf403-51b6-4af2-bc14-6e456eb3f5c1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="James Beer House", address="19 Rue Saint-Jean, 69005 Lyon",
      city="Lyon", country="FR",
      latitude=45.7630556, longitude=4.8280122,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2c1b97c7-3e41-4c77-b683-1f8e9265dedb_ChIJhc2jlarr_0.jpg",
      averageRating=4.3, totalRatingsCount=1958,
      createdAt="2026-08-30T21:16:42.818512Z", updatedAt="2026-08-30T21:16:42.818512Z",
    ),
    ClubDto(
      id="965f320b-40cb-4fe9-8755-637377e23bff", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lyon Salvagny Golf Club", address="100 Rue des Granges, 69890 La Tour-de-Salvagny",
      city="Lyon", country="FR",
      latitude=45.822108, longitude=4.7052397,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fcde4634-2a5e-4249-8364-d774cfe6dce7_photo.png",
      averageRating=4.3, totalRatingsCount=353,
      createdAt="2026-08-31T15:46:27.915964Z", updatedAt="2026-08-31T15:46:27.915964Z",
    ),
    ClubDto(
      id="915c09ba-68c5-49af-904e-f38ddd86d9f1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palais des Sports de Gerland Lyon", address="350 Av. Jean Jaurès, 69007 Lyon",
      city="Lyon", country="FR",
      latitude=45.7243016, longitude=4.8288344,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1617205a-ca90-4322-bb43-61a769b18f77_photo.jpg",
      averageRating=4.3, totalRatingsCount=1766,
      createdAt="2026-08-31T15:45:33.060746Z", updatedAt="2026-08-31T15:45:33.060746Z",
    ),
    ClubDto(
      id="dae70c98-203a-4f34-9702-3b57078361e8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Plaine des Jeux de Gerland", address="405 Av. Jean Jaurès, 69007 Lyon",
      city="Lyon", country="FR",
      latitude=45.7213257, longitude=4.8272967,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ebebbe67-1e8c-4273-845f-3b5e6fff8f4f_ChIJBYG18IPp_0.jpg",
      averageRating=4.3, totalRatingsCount=954,
      createdAt="2026-08-30T21:16:06.572920Z", updatedAt="2026-08-30T21:59:34.641575Z",
    ),
    ClubDto(
      id="acf574a7-dab3-4094-a6f4-dd952eca0f9c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ASUL Lyon 8 Table Tennis", address="16 Rue du Commandant Pegout, 69008 Lyon",
      city="Lyon", country="FR",
      latitude=45.7306519, longitude=4.867595,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/493e00ad-222b-4007-82f1-cc7079fd753c_photo.jpg",
      averageRating=4.6, totalRatingsCount=46,
      createdAt="2026-08-31T15:46:42.743446Z", updatedAt="2026-08-31T15:46:42.743446Z",
    ),
    ClubDto(
      id="ea18cd64-d0c9-4bc0-9974-ed5d9b59cc46", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Lou Tennis", address="1 Quai Fillon, 69007 Lyon",
      city="Lyon", country="FR",
      latitude=45.7196346, longitude=4.8238906,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c5cf37b4-74e0-4c22-8311-cfb46fe2e4d0_ChIJYdOwsYPp_0.jpg",
      averageRating=4.2, totalRatingsCount=89,
      createdAt="2026-08-30T21:17:40.936191Z", updatedAt="2026-08-30T21:17:40.936191Z",
    ),
    ClubDto(
      id="ee73dc2f-988c-46a4-a3f2-e39b66b41807", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Tête dans les Nuages", address="112 Cr Charlemagne, 69002 Lyon",
      city="Lyon", country="FR",
      latitude=45.7411723, longitude=4.8173016,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3737bf38-a1a5-4a4d-abe9-5a05466f3172_ChIJo2fvNk_r_0.jpg",
      averageRating=4.1, totalRatingsCount=2218,
      createdAt="2026-08-30T21:17:17.724121Z", updatedAt="2026-08-30T21:58:17.161014Z",
    ),
    ClubDto(
      id="11e37e0a-9651-4127-835f-9d8da85ec86c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stade du Clos Layat", address="260 Rte de Vienne, 69008 Lyon",
      city="Lyon", country="FR",
      latitude=45.7266016, longitude=4.8506704,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/315ea418-5899-493e-aa82-e815af9e5b79_ChIJcycR_Rzq_0.jpg",
      averageRating=4.0, totalRatingsCount=129,
      createdAt="2026-08-30T21:16:29.062656Z", updatedAt="2026-08-30T21:16:29.062656Z",
    ),
    ClubDto(
      id="ac645117-fd47-4427-9653-ae72f0244c69", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club Municipal du 5ème (TCM5)", address="57 Rue des Aqueducs, 69005 Lyon",
      city="Lyon", country="FR",
      latitude=45.7590619, longitude=4.7912308,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b1fb2310-d2e4-4074-9475-7181e47e1941_ChIJt5StKITr_0.jpg",
      averageRating=4.1, totalRatingsCount=44,
      createdAt="2026-08-30T21:17:26.071264Z", updatedAt="2026-09-01T14:31:59.816929Z",
    ),
    ClubDto(
      id="44f9349c-d068-4e66-af74-b823235b9cd6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ASUL Lyon Volley", address="20 Av. Paul Santy, 69008 Lyon",
      city="Lyon", country="FR",
      latitude=45.7349204, longitude=4.8703858,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ffa357c9-e615-4e0d-a406-a0de7418b63a_photo.jpg",
      averageRating=4.8, totalRatingsCount=34,
      createdAt="2026-08-31T15:45:54.734276Z", updatedAt="2026-08-31T15:45:54.734276Z",
    ),
    ClubDto(
      id="d136fdf8-d469-4e1d-9585-4661b35b4fe8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lyon PESD", address="53 Rue Philippe de Lassalle, 69004 Lyon",
      city="Lyon", country="FR",
      latitude=45.7806953, longitude=4.8200915,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/71ca6f44-2c0a-4ee7-a964-3f17c2869b31_photo.jpg",
      averageRating=4.4, totalRatingsCount=34,
      createdAt="2026-08-31T15:46:01.451130Z", updatedAt="2026-08-31T15:46:01.451130Z",
    ),
    ClubDto(
      id="53c207a7-efba-459f-85cd-faf08c8ecc52", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Terrain de Sport du Colombier", address="70-72 Rue Chevreul, 69007 Lyon",
      city="Lyon", country="FR",
      latitude=45.7465841, longitude=4.844449,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7231e0f2-848f-45ae-a737-992ebfb4e7e9_photo.jpg",
      averageRating=4.1, totalRatingsCount=36,
      createdAt="2026-08-31T15:45:39.897740Z", updatedAt="2026-08-31T15:45:39.897740Z",
    ),
    ClubDto(
      id="3ec3ef94-fc52-4431-92ae-72880499d85c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ALCR Tennis de Table Lyon 4", address="15 Rue Louis Thévenet, 69004 Lyon",
      city="Lyon", country="FR",
      latitude=45.7792056, longitude=4.8372251,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9cea7222-b7d4-430b-877e-ab9e9b521e7a_photo.jpg",
      averageRating=4.9, totalRatingsCount=11,
      createdAt="2026-08-31T15:46:35.093988Z", updatedAt="2026-08-31T15:46:35.093988Z",
    ),
    ClubDto(
      id="d0710ae0-1ec4-44cc-a2c3-fb25af9a6eca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fidésienne Volley-Ball", address="All. Alban Vistel, 69110 Sainte-Foy-lès-Lyon",
      city="Lyon", country="FR",
      latitude=45.7346052, longitude=4.7885898,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77842936-b643-4255-b31e-468f3110ac41_photo.jpg",
      averageRating=4.4, totalRatingsCount=7,
      createdAt="2026-08-31T15:46:07.471684Z", updatedAt="2026-08-31T15:46:07.471684Z",
    ),
    ClubDto(
      id="6b0ae608-b658-4d03-82d9-9ff7de5695ab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach volley OnlyBeach & PESD", address="17 Rue Louis Pize, 69004 Lyon",
      city="Lyon", country="FR",
      latitude=45.7819057, longitude=4.8222263,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/50c27908-87ff-4dd9-ba05-4251141008a1_photo.jpg",
      averageRating=3.8, totalRatingsCount=5,
      createdAt="2026-08-31T15:46:13.642243Z", updatedAt="2026-08-31T15:46:13.642243Z",
    ),
  )),
  CitySeo(slug="dublin", name="Dublin", country="IE", clubCount=27, sports=listOf(Pair("Football", 4), Pair("Volleyball", 3), Pair("Tennis", 3), Pair("Padel", 3), Pair("Billiards", 2), Pair("Basketball", 2), Pair("Climbing", 2), Pair("Paintball", 2), Pair("Laser Tag", 2), Pair("Bowling", 1), Pair("Karting", 1), Pair("Golf", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="7d6a5db9-5764-444a-884f-6c3ca248ea34", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Loop Table Tennis Club", address="Ardscoil La Salle, Raheny Rd, Raheny, Dublin, D05 Y132",
      city="Dublin", country="IE",
      latitude=53.388932, longitude=-6.169582,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4bb415e7-191d-461e-a13d-0eb429d6e3c2_photo.jpg",
      averageRating=4.9, totalRatingsCount=72,
      createdAt="2026-08-31T15:06:02.339944Z", updatedAt="2026-08-31T15:06:02.339944Z",
    ),
    ClubDto(
      id="367f2251-2e71-4389-be5a-4d60ee9670ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zero Latency Sandyford, Dublin", address="21 Maple Ave, Sandyford, Dublin, A94 N6V9",
      city="Dublin", country="IE",
      latitude=53.2788662, longitude=-6.2193866,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/362f23d7-d023-49c3-8800-21a185c5816e_ChIJfQZadeYJ_0.jpg",
      averageRating=4.9, totalRatingsCount=1692,
      createdAt="2026-08-30T22:58:22.500836Z", updatedAt="2026-08-30T22:58:22.500836Z",
    ),
    ClubDto(
      id="a0fb37c9-f7ca-426a-9b07-267332b64b25", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GoQuest Carrickmines", address="Unit 6, Ballyogan Business Park, Ballyogan Rd, Jamestown, Dublin 18, D18 CF57",
      city="Dublin", country="IE",
      latitude=53.2563982, longitude=-6.1925008,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac0a15d8-c9b1-4ed7-a17f-587a0ab99e91_ChIJUd-TgVUJ_0.jpg",
      averageRating=4.8, totalRatingsCount=1279,
      createdAt="2026-08-30T22:58:29.538597Z", updatedAt="2026-08-31T08:28:38.136560Z",
    ),
    ClubDto(
      id="1fe7f7d6-a5ef-42a1-8aee-d6fd21f4a8bb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hobby Airsoft", address="Unit 3B, Ballymount Retail Centre, Ballymount Dr, Ballymount Little, Dublin 12, D24 N732",
      city="Dublin", country="IE",
      latitude=53.312207, longitude=-6.3596105,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e22f335f-2277-416e-abed-a32a2cb7abf0_ChIJF8GfcAl0_1.jpg",
      averageRating=4.7, totalRatingsCount=564,
      createdAt="2026-08-30T22:58:36.201138Z", updatedAt="2026-08-31T22:11:17.433546Z",
    ),
    ClubDto(
      id="5c3e52d8-a939-4be1-a1bc-f0c3e5c3d99d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kylemore Karting", address="1A, Kylemore Industrial Estate, Killeen Rd, Kylemore, Dublin 10",
      city="Dublin", country="IE",
      latitude=53.3338632, longitude=-6.3546976,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/45e08ac9-306b-4a40-83c2-40ad738b6247_ChIJjaZVDKkO_0.jpg",
      averageRating=4.7, totalRatingsCount=2324,
      createdAt="2026-08-30T22:58:16.275313Z", updatedAt="2026-08-30T22:58:16.275313Z",
    ),
    ClubDto(
      id="17711e08-5a41-45c2-b541-1b31b0fe8721", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport Ireland National Indoor Arena", address="Sport Ireland Campus, Snugborough Rd, Blanchardstown, Dublin 15, D15 EPN4",
      city="Dublin", country="IE",
      latitude=53.3981058, longitude=-6.3598317,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d6a79cf-61a5-4da3-89e5-1d81c55b0a87_ChIJdapRFgET_0.jpg",
      averageRating=4.7, totalRatingsCount=360,
      createdAt="2026-08-30T22:57:31.483623Z", updatedAt="2026-08-31T08:36:17.139405Z",
    ),
    ClubDto(
      id="8ef0f970-1901-4dc9-a7be-2f6287e2ff31", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bushy Park Tennis And Padel Club", address="Rathdown Ave, Terenure, Dublin 6W, Co. Dublin, D6W TX24",
      city="Dublin", country="IE",
      latitude=53.3026614, longitude=-6.289463,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e2258d6-be6d-435a-bf61-1fc4e1d38080_ChIJjZ6KD40L_0.jpg",
      averageRating=4.6, totalRatingsCount=191,
      createdAt="2026-08-30T22:59:24.851893Z", updatedAt="2026-09-01T14:31:51.403614Z",
    ),
    ClubDto(
      id="0de3a1af-9a4a-4263-9e78-c75c62908b2d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Castleknock Lawn Tennis Club", address="Old Navan Rd, Castleknock, Dublin 15, D15 NY10",
      city="Dublin", country="IE",
      latitude=53.3808284, longitude=-6.3619042,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3037986d-b39a-4567-ac56-b17fba8aa522_ChIJDcD5XkIN_1.jpg",
      averageRating=4.6, totalRatingsCount=269,
      createdAt="2026-08-30T22:59:11.981643Z", updatedAt="2026-08-31T22:11:14.884210Z",
    ),
    ClubDto(
      id="8a57f8d5-4617-4bc1-8ad9-80d3f55242e8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Corduff Sports Centre", address="Blackcourt Road, Corduff, Dublin 15, D15 T861",
      city="Dublin", country="IE",
      latitude=53.3982823, longitude=-6.3780199,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c17efe91-47f4-45ea-810b-8a167821676f_photo.png",
      averageRating=4.6, totalRatingsCount=263,
      createdAt="2026-08-31T15:05:09.965064Z", updatedAt="2026-08-31T15:05:09.965064Z",
    ),
    ClubDto(
      id="50a41445-e8f5-4422-98a9-3e64dbbfb56b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UCD Sports Centre", address="UCD Sports Centre, Belfield, Dublin",
      city="Dublin", country="IE",
      latitude=53.3081571, longitude=-6.2295381,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a1649d7d-b13a-4d26-9f42-abfb60951dc7_ChIJz1yvijYJ_0.jpg",
      averageRating=4.6, totalRatingsCount=577,
      createdAt="2026-08-30T22:57:19.548566Z", updatedAt="2026-08-31T08:38:12.896849Z",
    ),
    ClubDto(
      id="b99c2ef7-0f75-4375-9158-1a89f655d00d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dublin Sports Dome", address="The Sports Dome, Sportslink Complex, Turnapin Great, Dublin, Co. Dublin, D09 V8XT",
      city="Dublin", country="IE",
      latitude=53.4083481, longitude=-6.2420685,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/93af97b8-6082-4e09-9197-8309c0efdd2b_ChIJm7EPPdcR_0.jpg",
      averageRating=4.5, totalRatingsCount=570,
      createdAt="2026-08-30T22:57:25.753918Z", updatedAt="2026-08-31T08:27:26.430122Z",
    ),
    ClubDto(
      id="3105be62-64f7-42e5-9c48-0da7e983c295", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Explorium - National Sport & Science Centre", address="Blackglen Rd, Sandyford, Dublin 18, D18 N1F2",
      city="Dublin", country="IE",
      latitude=53.2668535, longitude=-6.2376714,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9cf83c99-e62a-4e9f-becb-bb24b5ec7631_ChIJNWFakIMJ_0.jpg",
      averageRating=4.5, totalRatingsCount=1823,
      createdAt="2026-08-30T22:58:09.899284Z", updatedAt="2026-08-31T08:27:41.836048Z",
    ),
    ClubDto(
      id="a2566006-f1dc-41f5-ac4c-bdf26f931bf2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fitzwilliam Lawn Tennis Club", address="Winton Rd, Ranelagh, Dublin, D06 X6X2",
      city="Dublin", country="IE",
      latitude=53.3278581, longitude=-6.249333,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4a1f4423-ecf6-48c8-b810-024614ffb463_ChIJUd-iL7sO_0.jpg",
      averageRating=4.5, totalRatingsCount=223,
      createdAt="2026-08-30T22:59:18.222136Z", updatedAt="2026-08-30T22:59:18.222136Z",
    ),
    ClubDto(
      id="11c7d9cd-4f05-410d-9356-678de458005b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Flynn Park", address="Flynn Park, Courtlough, Balbriggan, Co. Dublin, K32 N884",
      city="Dublin", country="IE",
      latitude=53.5702502, longitude=-6.187897,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/22e3e6a3-c8fb-4f08-a967-cd980e764ea2_ChIJv80VcQQY_0.jpg",
      averageRating=4.5, totalRatingsCount=420,
      createdAt="2026-08-30T22:58:43.780547Z", updatedAt="2026-08-31T08:27:55.500744Z",
    ),
    ClubDto(
      id="dc62f479-2216-42df-9871-16aa4d5df3de", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ALSAA Sports Centre", address="Old Airport Rd, Toberbunny, Co. Dublin, K67 YV06",
      city="Dublin", country="IE",
      latitude=53.4222423, longitude=-6.2296893,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49200223-21ea-46b7-9d99-f6d28f34f6de_photo.jpg",
      averageRating=4.4, totalRatingsCount=1294,
      createdAt="2026-08-31T15:05:34.735977Z", updatedAt="2026-08-31T15:05:34.735977Z",
    ),
    ClubDto(
      id="5476ab15-2297-49d3-ac80-7000cc54d41b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dundrum Town Centre", address="Sandyford Rd, Dundrum, Dublin, 16",
      city="Dublin", country="IE",
      latitude=53.286982, longitude=-6.242252,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e8773696-418d-4350-b4fa-8318a18cc80a_ChIJ1ar75WUJ_0.jpg",
      averageRating=4.4, totalRatingsCount=36868,
      createdAt="2026-08-30T22:57:51.249167Z", updatedAt="2026-08-31T08:27:26.943368Z",
    ),
    ClubDto(
      id="57539498-e647-4a54-8cd6-f6a8739e8666", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Oblate Basketball Club", address="Tyrconnell Rd, Inchicore, Dublin",
      city="Dublin", country="IE",
      latitude=53.337587, longitude=-6.3264808,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b4770db-88c6-4436-88b6-58212488fd78_photo.jpg",
      averageRating=4.4, totalRatingsCount=178,
      createdAt="2026-08-31T15:05:17.923430Z", updatedAt="2026-08-31T15:05:17.923430Z",
    ),
    ClubDto(
      id="bb8f909a-7135-43ef-b1c2-dec814dfee3e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Astropark Coolock", address="Oscar Traynor Rd, Dublin 17, D17 Y998",
      city="Dublin", country="IE",
      latitude=53.3971295, longitude=-6.2301426,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5b24940f-9d74-4131-a898-847e7280e41d_ChIJY4lD6ysO_0.jpg",
      averageRating=4.3, totalRatingsCount=681,
      createdAt="2026-08-30T22:57:12.857462Z", updatedAt="2026-08-31T08:25:03.410466Z",
    ),
    ClubDto(
      id="5ecc85cd-6159-4d81-ac2c-cb098f56560b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="House of Padel", address="5 Old Belgard Rd, Cookstown Industrial Estate, Dublin, D24 WD00",
      city="Dublin", country="IE",
      latitude=53.2971448, longitude=-6.3723214,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6068fa23-928f-41db-bb5c-24df5f52e13a_ChIJ-zhvslR1_0.jpg",
      averageRating=4.3, totalRatingsCount=141,
      createdAt="2026-08-30T22:58:57.564764Z", updatedAt="2026-08-31T08:29:04.141455Z",
    ),
    ClubDto(
      id="7213db5c-e1b7-4d9a-bd0e-fbcb3aaa94ef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Leopardstown Golf Centre", address="Carmanhall And Leopardstown, Dublin",
      city="Dublin", country="IE",
      latitude=53.2662888, longitude=-6.1891136,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/edf4f2d4-8045-4550-9f00-2d139acf7a15_photo.jpg",
      averageRating=4.3, totalRatingsCount=497,
      createdAt="2026-08-31T15:05:49.034316Z", updatedAt="2026-08-31T15:05:49.034316Z",
    ),
    ClubDto(
      id="dd15a202-05d2-4f39-833a-a1b82b337f6b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Portmarnock Sports & Leisure Club", address="Blackwood Ln, Beechwood, Portmarnock, Co. Dublin",
      city="Dublin", country="IE",
      latitude=53.4343876, longitude=-6.1391846,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3b732b36-0835-4a4b-9bdb-30f1c5d49b88_ChIJh_RtwO4a_0.jpg",
      averageRating=4.3, totalRatingsCount=430,
      createdAt="2026-08-30T22:58:51.586753Z", updatedAt="2026-08-31T08:34:50.424299Z",
    ),
    ClubDto(
      id="bd46701a-da78-4e06-85c4-b2fecb50eb19", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Wool Shed", address="Parnell St, Centre, Dublin, D01 K5N8",
      city="Dublin", country="IE",
      latitude=53.3502932, longitude=-6.2673601,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83d5c43b-aa14-47dc-bf24-8fecd268c6a1_ChIJEff8I4IO_0.jpg",
      averageRating=4.3, totalRatingsCount=3753,
      createdAt="2026-08-30T22:57:37.644347Z", updatedAt="2026-08-31T08:38:02.258824Z",
    ),
    ClubDto(
      id="ea14cb11-ba5f-48a2-81cf-bc960eb4d798", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Buskers on the Ball", address="13-17 Fleet St, Temple Bar, Dublin, D02 WD51",
      city="Dublin", country="IE",
      latitude=53.3459092, longitude=-6.2603638,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/da3961f6-321e-43dc-9f8f-65ff23c8ec76_ChIJR9mP8ScM_0.jpg",
      averageRating=4.2, totalRatingsCount=3368,
      createdAt="2026-08-30T22:57:44.866174Z", updatedAt="2026-08-30T22:57:44.866174Z",
    ),
    ClubDto(
      id="a91aed04-a560-4376-85d1-9cb95ad14329", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Dome", address="Sportslink Complex, The Sports Dome, Santry, Dublin, D09 V8XT",
      city="Dublin", country="IE",
      latitude=53.4083225, longitude=-6.242021,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/764d5967-b400-4ef0-bcfa-fd018049d580_ChIJ5x9WqdwR_0.jpg",
      averageRating=4.1, totalRatingsCount=60,
      createdAt="2026-08-30T22:59:04.419751Z", updatedAt="2026-08-31T08:33:44.130844Z",
    ),
    ClubDto(
      id="e24ea3be-9563-48fc-968d-4dd7b363332a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="West Wood Club", address="Clontarf Rd, Clontarf West, Dublin 3, D03 T6T3",
      city="Dublin", country="IE",
      latitude=53.3634033, longitude=-6.2286442,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bbca8ebc-4ad5-4355-8637-1da9e8fb606c_ChIJTywo8AkP_0.jpg",
      averageRating=4.1, totalRatingsCount=2084,
      createdAt="2026-08-30T22:58:03.480682Z", updatedAt="2026-08-31T08:39:04.701003Z",
    ),
    ClubDto(
      id="a1486cbb-a3cc-4143-88c7-3217e5e2160d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Santry Volleyball Club", address="Beaumont Recreational Centre, Beaumont, Dublin",
      city="Dublin", country="IE",
      latitude=53.3848779, longitude=-6.2167361,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/14fc6ecf-e619-4908-aa4a-f1f1874caf05_photo.png",
      averageRating=5.0, totalRatingsCount=25,
      createdAt="2026-08-31T15:05:42.166378Z", updatedAt="2026-08-31T15:05:42.166378Z",
    ),
    ClubDto(
      id="2660e7de-8697-462a-9bcb-5eb16e846d0a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gardians Volleyball Club", address="Coláiste De Híde, Tymon Rd, Tymon North, Dublin 24",
      city="Dublin", country="IE",
      latitude=53.3012578, longitude=-6.3482214,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2ad5cee5-695e-4d1b-bd16-77c36341aa9d_photo.jpg",
      averageRating=4.6, totalRatingsCount=24,
      createdAt="2026-08-31T15:05:24.478576Z", updatedAt="2026-08-31T15:05:24.478576Z",
    ),
  )),
  CitySeo(slug="bratislava", name="Bratislava", country="SK", clubCount=27, sports=listOf(Pair("Football", 4), Pair("Basketball", 3), Pair("Tennis", 3), Pair("Padel", 2), Pair("Billiards", 2), Pair("Golf", 2), Pair("Bowling", 2), Pair("Paintball", 2), Pair("Karting", 2), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Volleyball", 1)), clubs=listOf(
    ClubDto(
      id="7dbfb9b5-031e-421d-aef0-97071b7e3a79", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hero Factory No Limits - Paintball Bratislava", address="108, Vajnorská 10301, 831 04 Bratislava-Nové Mesto",
      city="Bratislava", country="SK",
      latitude=48.1741639, longitude=17.1483992,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/30b42d73-5f14-44a6-8f18-6700eb1ecb24_ChIJeyNif-qO_0.jpg",
      averageRating=4.9, totalRatingsCount=1001,
      createdAt="2026-08-30T22:43:50.079756Z", updatedAt="2026-08-31T08:29:00.007178Z",
    ),
    ClubDto(
      id="12df26d1-7f5d-491c-9ab9-20b3c1e083cb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hunter Club - strelnica Bratislava", address="Kamenné Námestie 1A, 811 08 Bratislava",
      city="Bratislava", country="SK",
      latitude=48.1451001, longitude=17.1139153,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/07089d62-0e05-4cef-822c-03b790b78487_ChIJX51U1M2O_1.jpg",
      averageRating=4.9, totalRatingsCount=528,
      createdAt="2026-08-30T22:43:56.897445Z", updatedAt="2026-08-31T22:11:17.538170Z",
    ),
    ClubDto(
      id="2cafab5e-f361-4d1f-97c1-fac149dfad32", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="WOLF Aréna Petržalka", address="Kopčianska 6211, 851 01 Bratislava",
      city="Bratislava", country="SK",
      latitude=48.1170244, longitude=17.0934395,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/75cb27eb-0535-46cb-a9be-ad5b550e8ddf_ChIJ0cz4c3OJ_0.jpg",
      averageRating=4.9, totalRatingsCount=102,
      createdAt="2026-08-30T22:44:04.038960Z", updatedAt="2026-08-30T22:44:04.038960Z",
    ),
    ClubDto(
      id="e3a178b8-47d7-4724-a5eb-3ce6dcb6d8bd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Drazdiak Beach Volley Club", address="Tematínska, 851 05 Bratislava-Petržalka",
      city="Bratislava", country="SK",
      latitude=48.1074838, longitude=17.1132499,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2028b238-5cc5-46e5-a4f2-f13654780ed8_photo.jpg",
      averageRating=4.8, totalRatingsCount=548,
      createdAt="2026-08-31T15:06:30.170393Z", updatedAt="2026-08-31T15:06:30.170393Z",
    ),
    ClubDto(
      id="4873c7fd-9241-4cd6-8edc-39fb7924d37d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lezecká stena K2", address="Stará Ivanská cesta 1B, 821 04 Bratislava",
      city="Bratislava", country="SK",
      latitude=48.1713538, longitude=17.1778812,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fff8e4d8-085d-46e9-baab-6d1fe0571464_ChIJ4cMediKP_0.jpg",
      averageRating=4.8, totalRatingsCount=1602,
      createdAt="2026-08-30T22:43:24.547111Z", updatedAt="2026-08-31T08:32:27.584645Z",
    ),
    ClubDto(
      id="8a396ab5-e191-4119-a758-33d47c802cea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Športový areál Patrónka", address="Lovinského 4653/43, 811 04 Bratislava-Staré Mesto",
      city="Bratislava", country="SK",
      latitude=48.1638906, longitude=17.0799528,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/65f64d39-865c-4bc6-9a7c-0a84fa51f193_photo.jpg",
      averageRating=4.8, totalRatingsCount=167,
      createdAt="2026-08-31T15:06:23.740445Z", updatedAt="2026-08-31T15:06:23.740445Z",
    ),
    ClubDto(
      id="129c84d1-8ee1-4ab8-b76c-8cd4d86c80f6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lezecké Centrum Vertigo", address="47, Trenčianska 453, 821 09 Bratislava-Ružinov",
      city="Bratislava", country="SK",
      latitude=48.1523508, longitude=17.1389974,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/831a9e4a-4642-412a-a384-13f48eed01d7_ChIJ2y0wOzKJ_0.jpg",
      averageRating=4.7, totalRatingsCount=835,
      createdAt="2026-08-30T22:43:30.796440Z", updatedAt="2026-08-31T08:32:30.714535Z",
    ),
    ClubDto(
      id="b7c95b37-05fc-45ad-9227-18f61dc85fe7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Motokáry MAX 60", address="Vajnorská 127/A, 831 04 Bratislava-Nové Mesto",
      city="Bratislava", country="SK",
      latitude=48.180883, longitude=17.1535382,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed3d6e6c-47bf-4590-bed1-ac772a54156c_ChIJ_7hVt-6O_0.jpg",
      averageRating=4.7, totalRatingsCount=1994,
      createdAt="2026-08-30T22:43:37.341563Z", updatedAt="2026-08-31T08:33:06.735249Z",
    ),
    ClubDto(
      id="f8f7c13a-f215-4ff0-84b3-d24c270dc0dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PAPA CQB Aréna Petržalka", address="Kopčianska 6211, 851 01 Bratislava",
      city="Bratislava", country="SK",
      latitude=48.1170244, longitude=17.0934395,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c88078bc-1d79-4811-8a29-744348d45485_ChIJe_fafJuJ_0.jpg",
      averageRating=4.7, totalRatingsCount=99,
      createdAt="2026-08-30T22:44:10.880851Z", updatedAt="2026-08-30T22:44:10.880851Z",
    ),
    ClubDto(
      id="1848c070-35f1-45e8-b974-87b9c82ac7c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Park Jama", address="831 04 Bratislava-Nové Mesto",
      city="Bratislava", country="SK",
      latitude=48.1614494, longitude=17.134734,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b3a80f95-b61e-43a6-a4d7-fe3b693bf0a7_ChIJ52NfF8qO_0.jpg",
      averageRating=4.7, totalRatingsCount=1650,
      createdAt="2026-08-30T22:42:48.486951Z", updatedAt="2026-08-30T22:42:48.486951Z",
    ),
    ClubDto(
      id="8a9888f1-cfa5-4ccb-8540-b8ee63ee5cef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis One", address="Nobelova 34, 831 02 Bratislava-Nové Mesto",
      city="Bratislava", country="SK",
      latitude=48.1838419, longitude=17.1391033,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/57624e9c-80d6-4e3f-b79d-e4ef42da9809_ChIJTf4VspGO_0.jpg",
      averageRating=4.7, totalRatingsCount=55,
      createdAt="2026-08-30T22:44:39.082926Z", updatedAt="2026-08-30T22:44:39.082926Z",
    ),
    ClubDto(
      id="a2efe663-bd2d-4353-9e70-e08c6a0836b0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aircraft Sport House", address="Ivanská cesta 30d, 821 04 Bratislava-Ružinov",
      city="Bratislava", country="SK",
      latitude=48.1749885, longitude=17.1906517,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04664e21-d7a8-41e5-9ef1-1efc0d678ad0_photo.jpg",
      averageRating=4.6, totalRatingsCount=485,
      createdAt="2026-08-31T15:06:15.510525Z", updatedAt="2026-08-31T15:06:15.510525Z",
    ),
    ClubDto(
      id="8d4df10e-d9c6-4c1d-8d28-ab038d8f97c2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FitCamp - športový areál Bratislava Ružinov", address="Drieňová 11/A, 821 03 Bratislava-Ružinov",
      city="Bratislava", country="SK",
      latitude=48.1606746, longitude=17.1525831,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0ee826f0-cd98-4bee-a93b-a699b4ed63eb_photo.jpg",
      averageRating=4.6, totalRatingsCount=468,
      createdAt="2026-08-31T15:06:08.295294Z", updatedAt="2026-08-31T15:06:08.295294Z",
    ),
    ClubDto(
      id="25c56e89-7e01-4d14-8c54-4c35b652d40b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kart One Arena", address="Kopčianska 82/A, 851 01 Bratislava-Petržalka",
      city="Bratislava", country="SK",
      latitude=48.1115903, longitude=17.0893561,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d5b13db-a888-4bec-9564-06cd6554f358_ChIJ_xtdOpCJ_0.jpg",
      averageRating=4.6, totalRatingsCount=1337,
      createdAt="2026-08-30T22:43:43.387021Z", updatedAt="2026-08-31T08:31:09.235325Z",
    ),
    ClubDto(
      id="ef11a5f5-0f66-4341-b197-66cab8068b46", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Národný futbalový štadión Tehelné pole", address="Viktora Tegelhoffa 4, 831 04 Bratislava",
      city="Bratislava", country="SK",
      latitude=48.1632445, longitude=17.1367963,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4129d6a7-f132-4042-86d3-998d49d0963c_ChIJP76-XMqO_0.jpg",
      averageRating=4.6, totalRatingsCount=5059,
      createdAt="2026-08-30T22:42:42.760414Z", updatedAt="2026-08-31T08:33:19.685156Z",
    ),
    ClubDto(
      id="1399cc14-032d-4960-8daa-d644f87967ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zimný štadión Ondreja Nepelu", address="Odbojárov 9, 831 04 Bratislava-Nové Mesto",
      city="Bratislava", country="SK",
      latitude=48.1601864, longitude=17.1362163,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/306ddeb2-e5c6-429e-bab0-18a0746fb47e_ChIJVwUiq8uO_2.jpg",
      averageRating=4.6, totalRatingsCount=8450,
      createdAt="2026-08-30T22:42:36.982158Z", updatedAt="2026-08-31T22:11:24.099430Z",
    ),
    ClubDto(
      id="da0ae725-d7e0-4951-b91e-062311c98afb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Love4Tennis - Dominika Cibulkova Academy", address="Turbínová 3528/1, 831 04 Bratislava-Nové Mesto",
      city="Bratislava", country="SK",
      latitude=48.1723411, longitude=17.1579143,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0f8f1464-053a-49c2-9848-7a188539067e_ChIJQVVsSt2O_0.jpg",
      averageRating=4.9, totalRatingsCount=46,
      createdAt="2026-08-30T22:44:45.943864Z", updatedAt="2026-08-31T08:32:34.475088Z",
    ),
    ClubDto(
      id="21309b7e-14ea-4a0e-80ea-66c35c51006c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billiard club Lavos - Bread and Games", address="Plynárenská 4937/6, 821 09 Bratislava-Ružinov",
      city="Bratislava", country="SK",
      latitude=48.1433085, longitude=17.1420314,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c8c181c6-d3e4-4e06-9884-2404c77698b0_ChIJvWT244eO_1.jpg",
      averageRating=4.5, totalRatingsCount=609,
      createdAt="2026-08-30T22:43:00.357348Z", updatedAt="2026-08-31T22:11:14.453742Z",
    ),
    ClubDto(
      id="1c63aeda-323f-47e5-b799-fba9882f92e5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Petržalské Bowlingové Centrum", address="Tupolevova 7a, 851 01 Bratislava-Petržalka",
      city="Bratislava", country="SK",
      latitude=48.115916, longitude=17.1042043,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2a96c606-dda7-4011-8ff9-f8061921aaf9_ChIJ0cbTrZiJ_0.jpg",
      averageRating=4.5, totalRatingsCount=1855,
      createdAt="2026-08-30T22:43:17.767290Z", updatedAt="2026-08-31T08:34:42.072987Z",
    ),
    ClubDto(
      id="a3c64d3b-a72b-4009-a0cc-979676324f40", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aurial Padel Bratislava", address="Bajkalská 7, 831 04 Bratislava",
      city="Bratislava", country="SK",
      latitude=48.1638472, longitude=17.1397581,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ba4ea2f5-327c-40c8-8d9b-638d38572303_ChIJF0JlxkOP_0.jpg",
      averageRating=4.4, totalRatingsCount=59,
      createdAt="2026-08-30T22:44:17.595142Z", updatedAt="2026-08-30T22:44:17.595142Z",
    ),
    ClubDto(
      id="a30a3c1b-b402-4366-8e10-1ce2612031c2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowlingové Národné Centrum", address="Turbínová 1, 831 04 Bratislava",
      city="Bratislava", country="SK",
      latitude=48.1726167, longitude=17.1568654,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/035b4284-454f-4c2a-bd2d-38a89e07328f_ChIJAfDKEN2O_0.jpg",
      averageRating=4.4, totalRatingsCount=2060,
      createdAt="2026-08-30T22:43:12.141627Z", updatedAt="2026-08-31T08:26:33.728978Z",
    ),
    ClubDto(
      id="2dbefef2-5b46-494f-890a-614d0ff1149b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PEUGEOT aréna", address="Príkopova 6, 831 03 Bratislava-Nové Mesto",
      city="Bratislava", country="SK",
      latitude=48.1631833, longitude=17.1345617,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8824fa46-9b8c-4bfe-85b5-ea3464bb68e6_ChIJ1xf3_MmO_0.jpg",
      averageRating=4.4, totalRatingsCount=2467,
      createdAt="2026-08-30T22:44:32.026574Z", updatedAt="2026-08-31T08:33:35.647880Z",
    ),
    ClubDto(
      id="61fa24cf-80ed-4970-9057-243737228979", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Black River Golf Resort BRATISLAVA", address="Kaštieľ 1, 900 27 Bernolákovo",
      city="Bratislava", country="SK",
      latitude=48.2020161, longitude=17.2861737,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1c26b3f6-5dbe-4b29-8ab7-64a2fca72794_photo.jpg",
      averageRating=4.2, totalRatingsCount=257,
      createdAt="2026-08-31T15:06:36.862830Z", updatedAt="2026-08-31T15:06:36.862830Z",
    ),
    ClubDto(
      id="e18db9eb-b98b-4db7-a895-925fe4376e28", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Mamut", address="Cintorínska 2372/32, 811 08 Bratislava",
      city="Bratislava", country="SK",
      latitude=48.1476284, longitude=17.1207326,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/53444668-6110-4421-9d2f-4eb43e478951_ChIJZRcWTUaJ_0.jpg",
      averageRating=4.1, totalRatingsCount=261,
      createdAt="2026-08-30T22:43:06.043732Z", updatedAt="2026-08-30T22:43:06.043732Z",
    ),
    ClubDto(
      id="8cc5e43f-b06e-40b4-908d-abe771c168e5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zimný štadión Vladimíra Dzurillu", address="Ružinovská 4811/4, 821 01 Bratislava-Ružinov",
      city="Bratislava", country="SK",
      latitude=48.1558582, longitude=17.1505139,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc7737e8-e270-4d09-9239-8c81842c4186_ChIJ51wjRdOO_1.jpg",
      averageRating=4.1, totalRatingsCount=828,
      createdAt="2026-08-30T22:42:55.035479Z", updatedAt="2026-08-31T22:11:24.207993Z",
    ),
    ClubDto(
      id="3307dc65-0acf-4cb4-89d8-bdb2554164ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="OFFGREEN Indoor Golf Club", address="Polus, Vajnorská 10645/100, 831 04 Bratislava",
      city="Bratislava", country="SK",
      latitude=48.1685171, longitude=17.1393851,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/98fbab8f-cd47-474f-a47a-db7a207e1950_photo.jpg",
      averageRating=5.0, totalRatingsCount=39,
      createdAt="2026-08-31T15:06:43.820357Z", updatedAt="2026-08-31T15:06:43.820357Z",
    ),
    ClubDto(
      id="e6296b6d-7f44-428a-9ab9-128da237601d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Športový Park Rebelov", address="Delená 5542/13, 841 07 Bratislava-Devínska Nová Ves",
      city="Bratislava", country="SK",
      latitude=48.2122077, longitude=16.9795017,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8cb6c875-cc51-43ac-8b7c-6b6ffa219989_ChIJVXgehNvz_0.jpg",
      averageRating=5.0, totalRatingsCount=35,
      createdAt="2026-08-30T22:44:24.598567Z", updatedAt="2026-09-01T14:31:47.885524Z",
    ),
  )),
  CitySeo(slug="sofia", name="Sofia", country="BG", clubCount=27, sports=listOf(Pair("Football", 4), Pair("Volleyball", 3), Pair("Tennis", 3), Pair("Basketball", 2), Pair("Golf", 2), Pair("Bowling", 2), Pair("Laser Tag", 2), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Paintball", 2), Pair("Padel", 1), Pair("Karting", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="b4387293-efc1-40ce-b161-27872ca7822c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Таргет 14 - Пейнтбол София", address="м. Къро, бул. „проф. Цветан Лазаров“ 14, 1592 София",
      city="Sofia", country="BG",
      latitude=42.6719214, longitude=23.3801987,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5b49b1f1-09a0-464a-808f-56003f63c5cb_ChIJJ8_-ZgCH_1.jpg",
      averageRating=4.9, totalRatingsCount=443,
      createdAt="2026-08-30T23:24:11.202499Z", updatedAt="2026-08-31T22:11:27.481818Z",
    ),
    ClubDto(
      id="c5ae7dc5-7b69-4692-a433-209ca72c8be1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Levski Sofia Sports Hall", address="в.з. Малинова долинаMladost, ul. “Donka Ushlinova“ 2, 1766 Sofia",
      city="Sofia", country="BG",
      latitude=42.6225819, longitude=23.3736227,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1bbf95f5-ce02-4e3e-b311-99e5d9751f3b_photo.jpg",
      averageRating=4.8, totalRatingsCount=312,
      createdAt="2026-08-31T15:26:38.958295Z", updatedAt="2026-08-31T15:26:38.958295Z",
    ),
    ClubDto(
      id="05325492-2ed5-4a39-a283-e46383462074", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Mania Home - игрища за плажен волейбол/тенис в София.", address="между 131СОУ и пазара, ж.к. Младост 4Mladost, ul. \"Filip Avramov\", 1712 Sofia",
      city="Sofia", country="BG",
      latitude=42.6352825, longitude=23.3814222,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/03a35db7-883e-435f-90b0-05864aa9a303_photo.jpg",
      averageRating=4.7, totalRatingsCount=72,
      createdAt="2026-08-31T15:26:46.387994Z", updatedAt="2026-08-31T15:26:46.387994Z",
    ),
    ClubDto(
      id="caff7182-4ec2-4e37-a665-85fcdd49cf7b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Club Sofia", address="кв. ДрагалевциВитоша, Софийски околовръстен път 72, 1415 София",
      city="Sofia", country="BG",
      latitude=42.6366563, longitude=23.3169851,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0a59ae36-d7e6-4e00-9b02-b12dc3493842_ChIJC-YQEMeF_0.jpg",
      averageRating=4.7, totalRatingsCount=64,
      createdAt="2026-08-30T23:24:24.931754Z", updatedAt="2026-08-31T08:33:42.422066Z",
    ),
    ClubDto(
      id="cb7a4039-828a-45ce-a602-8ad2a6f15688", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Национална Спортна Академия Васил Левски", address="Студентски Комплекс, ул. „Акад. Стефан Младенов“ 21, 1700 София",
      city="Sofia", country="BG",
      latitude=42.6463976, longitude=23.3483633,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96ba68c7-01c8-403b-b02e-723cdbf1cb73_ChIJ0W9OIx-E_0.jpg",
      averageRating=4.7, totalRatingsCount=1157,
      createdAt="2026-08-30T23:23:05.921929Z", updatedAt="2026-08-30T23:23:05.921929Z",
    ),
    ClubDto(
      id="f9c63e29-22dc-4ae5-bda8-35d11d101616", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="St. Sofia Golf & Spa", address="ул. Преслав, ulitsa Preslav, 2129 Равно поле",
      city="Sofia", country="BG",
      latitude=42.6714281, longitude=23.5376484,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8eb23585-4b55-48b4-8f41-9421a1e429e3_photo.jpg",
      averageRating=4.6, totalRatingsCount=1141,
      createdAt="2026-08-31T15:27:10.871817Z", updatedAt="2026-08-31T15:27:10.871817Z",
    ),
    ClubDto(
      id="ae93dfb5-77a7-4288-86d8-aeb1c87fd5b0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ДЕМА", address="g.k. Mladost 1A Mladost, ж.к. Младост 1АМладост, бул. „Александър Малинов“ No 19, 1729 София",
      city="Sofia", country="BG",
      latitude=42.6528823, longitude=23.3808407,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96b0b9a3-9094-43a0-ad3a-54c105ae7960_ChIJp832fo6G_0.jpg",
      averageRating=4.5, totalRatingsCount=387,
      createdAt="2026-08-30T23:24:47.358584Z", updatedAt="2026-08-30T23:24:47.358584Z",
    ),
    ClubDto(
      id="ba2f2ca8-e9c7-4a7c-be1f-4e33a535c6b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Джой Стейшън", address="Студентски Комплекс, ул. „Акад. Стефан Младенов“ 3, 1700 София",
      city="Sofia", country="BG",
      latitude=42.6544073, longitude=23.346991,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/da532e1b-2f0d-4aac-af95-bd2ed25e1396_ChIJabC_tCSE_0.jpg",
      averageRating=4.5, totalRatingsCount=4982,
      createdAt="2026-08-30T23:23:24.917917Z", updatedAt="2026-08-31T08:40:39.448039Z",
    ),
    ClubDto(
      id="316c8b25-072a-453f-9057-85d0b3daec1e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Моментум Катерене на Зала София", address="м. Къро, бул. „Цариградско шосе“ 111V, 1784 София",
      city="Sofia", country="BG",
      latitude=42.6655963, longitude=23.3744015,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/37f74ef3-9bf3-4629-9d15-e06448e4be6f_ChIJb-T_J3-G_0.jpg",
      averageRating=4.5, totalRatingsCount=1367,
      createdAt="2026-08-30T23:23:38.105198Z", updatedAt="2026-08-30T23:23:38.105198Z",
    ),
    ClubDto(
      id="9c655cef-1705-4e75-902f-d9e008fdfda3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Парадайс център", address="Хладилника, бул. „Черни връх“ 100, 1407 София",
      city="Sofia", country="BG",
      latitude=42.6576426, longitude=23.3150385,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d120fe8e-f078-4e14-b25c-147f4396456b_ChIJPzCgFFyE_0.jpg",
      averageRating=4.5, totalRatingsCount=41343,
      createdAt="2026-08-30T23:23:57.584710Z", updatedAt="2026-08-31T08:41:01.704251Z",
    ),
    ClubDto(
      id="6a0b70ef-a4db-4fb4-bad9-f32654183c70", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="София картинг ринг", address="в.з. Симеоново - северВитоша, Софийски околовръстен път 214, 1434 София",
      city="Sofia", country="BG",
      latitude=42.6241262, longitude=23.3529,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8de40969-377c-4d20-8276-7bc7ef2daea7_ChIJ9yVbzNKG_0.jpg",
      averageRating=4.5, totalRatingsCount=3168,
      createdAt="2026-08-30T23:23:51.393762Z", updatedAt="2026-08-31T08:41:10.979017Z",
    ),
    ClubDto(
      id="536206b5-35e0-4938-974b-c929e3022932", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спортна София 2000 ЕАД", address="ж.к. Зона Б-5, ул. „Българска морава“ 2, 1303 София",
      city="Sofia", country="BG",
      latitude=42.69424, longitude=23.30476,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06e1fa23-4061-48a7-8a05-761003f1fe23_ChIJ12rdRT-F_1.jpg",
      averageRating=4.5, totalRatingsCount=1867,
      createdAt="2026-08-30T23:22:51.977693Z", updatedAt="2026-08-31T22:11:26.943687Z",
    ),
    ClubDto(
      id="158121f6-aace-4aff-92b8-85274d79fc64", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стадион „Георги Аспарухов“", address="район Подуяне, ул. „Тодорини кукли“ №47, 1517 София",
      city="Sofia", country="BG",
      latitude=42.7053331, longitude=23.3632479,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/068bc615-f4bc-44ef-ba7f-cb6415b8a980_ChIJ3YT2UmOP_0.jpg",
      averageRating=4.5, totalRatingsCount=4646,
      createdAt="2026-08-30T23:22:45.510637Z", updatedAt="2026-08-31T08:41:15.781863Z",
    ),
    ClubDto(
      id="d779fa5a-66b1-4537-a6aa-9dd071031660", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стикс", address="National Palace of Culture, main underpass, Ндк, sq. \"Bulgaria 1, 1463 София",
      city="Sofia", country="BG",
      latitude=42.6856413, longitude=23.3196318,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11d71a2d-6ed5-4bf3-a97f-5ab9962f5a7c_ChIJHyWYvA-F_0.jpg",
      averageRating=4.5, totalRatingsCount=1501,
      createdAt="2026-08-30T23:23:11.946340Z", updatedAt="2026-08-30T23:23:11.946340Z",
    ),
    ClubDto(
      id="a4d44c05-1e50-4c8b-9426-cb01d8db1063", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Amik Sport", address="София ул.академик Георги Бончев N:4, БАН IV км., 1000 Sofia",
      city="Sofia", country="BG",
      latitude=42.6736371, longitude=23.3704308,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0ad5c927-0ab4-4adb-9749-a61421ef1087_photo.jpg",
      averageRating=4.4, totalRatingsCount=421,
      createdAt="2026-08-31T15:26:25.361010Z", updatedAt="2026-08-31T15:26:25.361010Z",
    ),
    ClubDto(
      id="fa4e1e4a-09a5-40e4-acf4-6bf54472ad3a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mega Xtreme Bowling", address="Jawaharlal Nehru Boulevard 26А, ж.к. Люлин - Център, бул. „Джавахарлал Неру“ 26А, 1336 София",
      city="Sofia", country="BG",
      latitude=42.7148933, longitude=23.2554397,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11812bf3-1985-4b8e-9eb7-fe33c4e6877a_ChIJEWhnY4Wa_0.jpg",
      averageRating=4.4, totalRatingsCount=956,
      createdAt="2026-08-30T23:23:30.967747Z", updatedAt="2026-08-30T23:23:30.967747Z",
    ),
    ClubDto(
      id="51ed5c2b-319b-4789-8a91-932148b01848", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="БиЕсДи 2", address="В подлеза на бул. \"България\" и бул. \"Фритьоф Нансен\", Old City Center, ул. „Професор Фритьоф Нансен“, 1142 София",
      city="Sofia", country="BG",
      latitude=42.683525, longitude=23.3207187,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c16fec92-5389-4e5f-871d-50e2a00771cf_ChIJg-Cpaw-F_0.jpg",
      averageRating=4.4, totalRatingsCount=1365,
      createdAt="2026-08-30T23:23:18.536315Z", updatedAt="2026-08-30T23:23:18.536315Z",
    ),
    ClubDto(
      id="fea0d101-f880-42f0-be09-c5b88f98bae2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбол София", address="Карпузица, Бл. „Никола Петков“ 67, 1619 София",
      city="Sofia", country="BG",
      latitude=42.6655644, longitude=23.2590177,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/848bc599-e8de-4a04-9dfd-2160d634b415_ChIJY8z5JrWE_0.jpg",
      averageRating=4.4, totalRatingsCount=384,
      createdAt="2026-08-30T23:24:18.672916Z", updatedAt="2026-08-30T23:24:18.672916Z",
    ),
    ClubDto(
      id="b7d02975-9ddb-4fed-be8e-0b902f8c54b8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Club Air Sofia", address="Tsentar, ul. Shesti Septemvri 1, 2050 Ihtiman",
      city="Sofia", country="BG",
      latitude=42.4368782, longitude=23.8104267,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd395e73-64c5-4f2a-a0b8-402c5d77b115_photo.jpg",
      averageRating=4.3, totalRatingsCount=179,
      createdAt="2026-08-31T15:27:19.209457Z", updatedAt="2026-08-31T15:27:19.209457Z",
    ),
    ClubDto(
      id="58a2edc4-7f65-48d8-b5e8-5b5f4a911668", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Грийн спорт", address="Складово-производствена зона - Слатина, 1574 София",
      city="Sofia", country="BG",
      latitude=42.6771807, longitude=23.380704,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/81228772-bc4e-44ce-9422-174c03343b20_ChIJ744xh9-F_0.jpg",
      averageRating=4.3, totalRatingsCount=1521,
      createdAt="2026-08-30T23:22:59.238581Z", updatedAt="2026-08-30T23:22:59.238581Z",
    ),
    ClubDto(
      id="12909afb-3f60-4b72-a09c-8f27c9873eaf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенис клуб Малееви", address="София, бул. Н.Й.Вапцаров 57, Промишлена зона Хладилника, бул. „Никола Й. Вапцаров“ 57, 1407 София",
      city="Sofia", country="BG",
      latitude=42.6678421, longitude=23.3281531,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a8f21a40-adb8-44d6-9566-5f798b9db7f6_ChIJZ-87PFKE_0.jpg",
      averageRating=4.3, totalRatingsCount=756,
      createdAt="2026-08-30T23:24:32.807273Z", updatedAt="2026-08-31T08:41:26.172815Z",
    ),
    ClubDto(
      id="d507a53f-3f93-488f-ba5d-b83c6811aa45", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Софийски тенис клуб 360", address="Борисова Градина, 1164 София",
      city="Sofia", country="BG",
      latitude=42.6873577, longitude=23.340728,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/259433a2-46c1-46d2-bd09-b96ad353daff_ChIJy6GRmqKF_0.jpg",
      averageRating=4.2, totalRatingsCount=395,
      createdAt="2026-08-30T23:24:40.426954Z", updatedAt="2026-08-31T08:41:09.564690Z",
    ),
    ClubDto(
      id="75a190c7-6f08-4907-b292-21187c361755", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Playground, Paradise Center", address="Хладилника, бул. „Черни връх“ 100, 1407 София",
      city="Sofia", country="BG",
      latitude=42.6570602, longitude=23.3156266,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a7808a7-668c-4949-9cec-98e97b630203_ChIJ384ZsGeE_0.jpg",
      averageRating=4.1, totalRatingsCount=994,
      createdAt="2026-08-30T23:24:04.622528Z", updatedAt="2026-08-30T23:24:04.622528Z",
    ),
    ClubDto(
      id="ef1984bd-ea87-45ba-a134-b6dcef55e8fc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vasil Simov Hall", address="София, бул. Асен Йорданов 1, БАН IV км., 1113 Sofia",
      city="Sofia", country="BG",
      latitude=42.6736317, longitude=23.3717636,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cebb3039-e30f-4ab4-8bf4-e3b85833718f_photo.jpg",
      averageRating=4.1, totalRatingsCount=243,
      createdAt="2026-08-31T15:26:55.240009Z", updatedAt="2026-08-31T15:26:55.240009Z",
    ),
    ClubDto(
      id="7ffe419e-db93-4057-bcee-28e0bf513959", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Бонсист", address="ж.к. Студентски град, ул. „проф. Николай Генчев“ 2, 1700 София",
      city="Sofia", country="BG",
      latitude=42.649384, longitude=23.3537317,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8b80996c-11dc-48e5-b579-deb5c57aa728_ChIJLVpNHSGE_0.jpg",
      averageRating=4.1, totalRatingsCount=907,
      createdAt="2026-08-30T23:23:45.185114Z", updatedAt="2026-08-31T08:40:34.442317Z",
    ),
    ClubDto(
      id="d08cf182-48f4-4c89-8808-a9d27f734e49", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Center Garitage", address="Sports Center Garitage, в.з. Малинова долинаMladost, ul. “Donka Ushlinova“ 2, сграда 2, 1766 Sofia",
      city="Sofia", country="BG",
      latitude=42.6225756, longitude=23.3720971,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/76aa87f0-47a3-4ad3-98f7-a4b314f81030_photo.jpg",
      averageRating=4.0, totalRatingsCount=403,
      createdAt="2026-08-31T15:27:02.413157Z", updatedAt="2026-08-31T15:27:02.413157Z",
    ),
    ClubDto(
      id="3a87a5bd-5d3f-4db4-8d1a-7b185fbdf8d8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенис на маса (Table Tennis Station СК Витоша)", address="Промишлена зона Хладилника, Blvd. \"Cherni vrah\" 47, 1407 Sofia",
      city="Sofia", country="BG",
      latitude=42.6624558, longitude=23.3178039,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f401cf29-2891-412b-a5f1-abdf16794667_photo.png",
      averageRating=4.7, totalRatingsCount=24,
      createdAt="2026-08-31T15:27:27.994862Z", updatedAt="2026-08-31T15:27:27.994862Z",
    ),
  )),
  CitySeo(slug="las-palmas", name="Las Palmas", country="ES", clubCount=27, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Basketball", 3), Pair("Volleyball", 3), Pair("Padel", 3), Pair("Golf", 2), Pair("Karting", 2), Pair("Climbing", 2), Pair("Laser Tag", 1), Pair("Billiards", 1), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="1be62606-7393-48ca-a6b0-7f46042c8e1f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Darrod Tennis Academy", address="C. las Margaritas, S/N, 35100 Maspalomas, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=27.7728149, longitude=-15.5474509,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5dc98571-a929-4046-ba08-413a6827abab_photo.jpg",
      averageRating=5.0, totalRatingsCount=173,
      createdAt="2026-09-01T08:55:59.731038Z", updatedAt="2026-09-01T08:55:59.731038Z",
    ),
    ClubDto(
      id="a3879ddc-9a64-4006-8459-f6d260fcafff", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Grand Climb - Your Climbing Guide on Gran Canaria", address="Cam. Cruz del Gamonal, 86, 35308 Sta Brígida, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.0187636, longitude=-15.5115137,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a948d663-df2a-4c0d-84f2-c3bcc2aef50c_photo.jpg",
      averageRating=5.0, totalRatingsCount=72,
      createdAt="2026-09-01T08:57:41.240673Z", updatedAt="2026-09-01T08:57:41.240673Z",
    ),
    ClubDto(
      id="1fd6a06d-5567-47fc-8425-17bdd35cc31c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Arena 22 Vigo", address="Cabral, 36318 Vigo, Pontevedra",
      city="Las Palmas", country="ES",
      latitude=42.2121972, longitude=-8.6688663,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c99c0a3c-92d8-4f15-bfb6-8a567b268c2e_photo.jpg",
      averageRating=4.9, totalRatingsCount=165,
      createdAt="2026-09-01T08:57:50.256986Z", updatedAt="2026-09-01T08:57:50.256986Z",
    ),
    ClubDto(
      id="924cd649-5582-42ad-845f-667e773cc1af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Voley Playa Net7", address="Playa de Las Alcaravaneras, 35006, 35006, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.1319032, longitude=-15.4294989,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e747dad-5b24-4dd7-93bf-00fb3ea96f11_photo.jpg",
      averageRating=4.9, totalRatingsCount=47,
      createdAt="2026-09-01T08:56:59.355840Z", updatedAt="2026-09-01T08:56:59.355840Z",
    ),
    ClubDto(
      id="dc91276f-1fc4-4d39-abe2-fdfd923c4aa5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Unión Deportiva Las Palmas", address="Estadio de Gran Canaria Calle Germán Dévora Ceballos, s/n, 35019 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.1004267, longitude=-15.45766,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/21c3eab9-b235-411e-b6c7-bb0c0aadbaf3_photo.jpg",
      averageRating=4.5, totalRatingsCount=497,
      createdAt="2026-09-01T08:55:34.390923Z", updatedAt="2026-09-01T08:55:34.390923Z",
    ),
    ClubDto(
      id="0b9e1792-c7b6-4707-8857-8fb70e71a727", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Anfi Tauro Golf", address="Valle de Tauro, s/n, 35138, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=27.8024135, longitude=-15.7186241,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8674a4c6-eca9-41f6-97fb-9743b86aa71c_photo.jpg",
      averageRating=4.4, totalRatingsCount=1486,
      createdAt="2026-09-01T08:57:14.107695Z", updatedAt="2026-09-01T08:57:14.107695Z",
    ),
    ClubDto(
      id="c41f1620-fa26-4d1f-962c-7f2a9b562568", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club de Tenis Alacant", address="C. Med Jorge Serrano Mate, 21, 03112 Alicante",
      city="Las Palmas", country="ES",
      latitude=38.3932878, longitude=-0.4922007,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/339f6f00-570f-45b2-bbc4-8638d4f73be3_photo.jpg",
      averageRating=4.4, totalRatingsCount=171,
      createdAt="2026-09-01T08:56:04.684162Z", updatedAt="2026-09-01T08:56:04.684162Z",
    ),
    ClubDto(
      id="30c9693a-991e-4b93-9efb-bebba47e1f5d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Conde Jackson Tennis", address="Av. Touroperador Tjaereborg, 9, 35100 Maspalomas, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=27.7557432, longitude=-15.5862488,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f59af010-d988-490c-8923-1b830fb9fcfa_photo.jpg",
      averageRating=4.4, totalRatingsCount=180,
      createdAt="2026-09-01T08:55:54.514762Z", updatedAt="2026-09-01T08:55:54.514762Z",
    ),
    ClubDto(
      id="d49bdd7e-6f91-4e5b-8a4b-248e98823ac7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gran Canaria Padel indoor", address="C. El Modem, 18, 35220 Telde, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.0259175, longitude=-15.3955988,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/47315168-2ae2-4d53-b70c-6068ffc68666_photo.jpg",
      averageRating=4.4, totalRatingsCount=491,
      createdAt="2026-09-01T08:56:12.513915Z", updatedAt="2026-09-01T08:56:12.513915Z",
    ),
    ClubDto(
      id="a78ffec7-2eb3-4f12-ad30-fba9ff6265f7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Spin Padel Club", address="C. Antonio José de Sucre, 6, 35214 Telde, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=27.9987757, longitude=-15.3894867,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e182039-0248-44fb-bfe6-e33db308997e_photo.jpg",
      averageRating=4.4, totalRatingsCount=361,
      createdAt="2026-09-01T08:56:26.821026Z", updatedAt="2026-09-01T08:56:26.821026Z",
    ),
    ClubDto(
      id="9e1dd718-4ca0-4b6b-b43e-f3a182675333", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Padel Club Drago", address="C. Paraná, 5, 35014 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.0924624, longitude=-15.4420748,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f892349b-dfd9-4944-a9dd-e075e346866f_photo.jpg",
      averageRating=4.4, totalRatingsCount=421,
      createdAt="2026-09-01T08:56:21.124228Z", updatedAt="2026-09-01T08:56:21.124228Z",
    ),
    ClubDto(
      id="c15a6713-388a-4088-bd0a-56b5d297622a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Anexo Estadio de Gran Canaria", address="Service Building, C. Fondos de Segura, s/n, 1st floor, 35019 Las Palmas de Gran Canaria, Stadium",
      city="Las Palmas", country="ES",
      latitude=28.1026115, longitude=-15.4555807,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/43b1f646-77dd-4dc6-a479-34f83ce95cca_photo.jpg",
      averageRating=4.3, totalRatingsCount=791,
      createdAt="2026-09-01T08:55:28.406403Z", updatedAt="2026-09-01T08:55:28.406403Z",
    ),
    ClubDto(
      id="0dc7efd6-ea20-4389-9b05-926f25862c9b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ciudad Deportiva Gran Canaria", address="P.º Blas Cabrera Felipe \"Físico\", 3, 35016 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.0786476, longitude=-15.4165925,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ccd058b-e59c-4a29-bc9f-559c98699f86_photo.jpg",
      averageRating=4.3, totalRatingsCount=990,
      createdAt="2026-09-01T08:56:31.202403Z", updatedAt="2026-09-01T08:56:31.202403Z",
    ),
    ClubDto(
      id="4eb8c6a6-87b5-4735-aeae-3e01f73a3de6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoorwall Gran Canaria", address="Calle Dr. Juan Domínguez Pérez, 47, 35008 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.1602114, longitude=-15.4119745,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e0de273d-d442-4aa3-995f-8d6dace0e613_photo.jpg",
      averageRating=4.3, totalRatingsCount=256,
      createdAt="2026-09-01T08:57:34.858995Z", updatedAt="2026-09-01T08:57:34.858995Z",
    ),
    ClubDto(
      id="bed0c656-0eb0-43ed-8593-91134e120fe9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="POOL FICTION LPA", address="C. Secretario Artiles, 22, 35007 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.1375119, longitude=-15.4316734,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4d220bc1-008e-4880-b9b6-c7cab25510d2_photo.jpg",
      averageRating=4.3, totalRatingsCount=773,
      createdAt="2026-09-01T08:57:45.724989Z", updatedAt="2026-09-01T08:57:45.724989Z",
    ),
    ClubDto(
      id="176acfd6-3077-4b1b-a80e-35056a6efa96", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo de fútbol de Lomo Blanco", address="C. Ana María Margenat, 30, 35015 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.0859276, longitude=-15.4448472,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1e67d578-ea00-4b59-a6b0-57dac90183bc_photo.jpg",
      averageRating=4.2, totalRatingsCount=352,
      createdAt="2026-09-01T08:55:39.705065Z", updatedAt="2026-09-01T08:55:39.705065Z",
    ),
    ClubDto(
      id="f6ea4f2e-3a08-47ac-abbc-17ca19028877", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gran Karting Club", address="Av. de Wind Surfing, 0, 35100 Bahía Feliz, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=27.7853394, longitude=-15.5052861,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f57af4b6-6cd5-4a7c-b468-06b8b4675be9_photo.jpg",
      averageRating=4.2, totalRatingsCount=1266,
      createdAt="2026-09-01T08:57:24.241280Z", updatedAt="2026-09-01T08:57:24.241280Z",
    ),
    ClubDto(
      id="050bf606-a2c6-43c3-940e-8ecbb2ef6bdf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kart Racing", address="Frente Aqualand, Carr. Palmitos Park, 35100 Maspalomas, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=27.7751945, longitude=-15.6038727,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/80a0ad56-2aa3-427a-a2ac-1d1e4a2a99df_photo.jpg",
      averageRating=4.2, totalRatingsCount=918,
      createdAt="2026-09-01T08:57:30.373438Z", updatedAt="2026-09-01T08:57:30.373438Z",
    ),
    ClubDto(
      id="2f8a54a7-89f6-4c25-9f31-ecc812d40a89", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Las Palmeras Golf", address="Calle Dr. Alfonso Chiscano Díaz, s/n, 35010 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.1247838, longitude=-15.4439113,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/384d4ceb-4e4f-4a1e-9496-8666f426cee7_photo.jpg",
      averageRating=4.2, totalRatingsCount=560,
      createdAt="2026-09-01T08:57:19.621467Z", updatedAt="2026-09-01T08:57:19.621467Z",
    ),
    ClubDto(
      id="8d2912c8-8aa1-4803-aacf-ff3b36444ac0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pabellón Polideportivo La Paterna", address="C. Manuel de Falla, 46, 35013 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.091145, longitude=-15.4496443,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7d6c9d15-e8be-40ae-9ae0-8c72229437ea_photo.jpg",
      averageRating=4.2, totalRatingsCount=86,
      createdAt="2026-09-01T08:56:52.676476Z", updatedAt="2026-09-01T08:56:52.676476Z",
    ),
    ClubDto(
      id="8475ea76-a88f-454b-8bc9-5652b66e511a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pepe Armas Sports Facilities", address="C. Fondos de Segura, 21, 35019 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.0979415, longitude=-15.4568817,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4a964d73-37f6-41c8-8b4c-4d6afdf4daf1_photo.jpg",
      averageRating=4.0, totalRatingsCount=118,
      createdAt="2026-09-01T08:56:47.662727Z", updatedAt="2026-09-01T08:56:47.662727Z",
    ),
    ClubDto(
      id="dee10c8d-ee11-4e7f-b9eb-b3ee063151a8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo De Fútbol La Mayordomía", address="C. los Cuarteles, 9, 35018 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.0998909, longitude=-15.4669687,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fb38b62f-1166-44be-8144-420672a972f5_photo.jpg",
      averageRating=3.9, totalRatingsCount=280,
      createdAt="2026-09-01T08:55:49.298157Z", updatedAt="2026-09-01T08:55:49.298157Z",
    ),
    ClubDto(
      id="b1e3f0ae-a13a-4e96-9555-42df6fe60d0c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Solajero Paintball", address="C. Guarela, 35010 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.1246242, longitude=-15.4514038,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7d1767cc-f734-447b-a131-6344ad2d1c84_photo.jpg",
      averageRating=3.9, totalRatingsCount=59,
      createdAt="2026-09-01T08:57:54.466525Z", updatedAt="2026-09-01T08:57:54.466525Z",
    ),
    ClubDto(
      id="32f871bc-2add-4eb2-b667-b65e22bda462", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo de Fútbol El Pilar", address="C. Pablo Rada, 35012 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.114497, longitude=-15.4447268,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b3edd67-4fa4-4daa-920c-032d186e0be6_photo.jpg",
      averageRating=3.8, totalRatingsCount=297,
      createdAt="2026-09-01T08:55:44.890107Z", updatedAt="2026-09-01T08:55:44.890107Z",
    ),
    ClubDto(
      id="50f12448-bb57-447a-8288-00c19077504e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dreamfit Pádel El muelle", address="Centro Comercial El Muelle, Muelle de Sta. Catalina, 1, 35008 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.14139, longitude=-15.4275307,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/70578bda-6507-4e88-a06f-79d9a55eb9ca_photo.jpg",
      averageRating=3.7, totalRatingsCount=160,
      createdAt="2026-09-01T08:56:08.972142Z", updatedAt="2026-09-01T14:31:56.861652Z",
    ),
    ClubDto(
      id="a8a7593e-2ed1-4c86-9748-7320b9a05821", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Voleibol Sayre Mayser Gran Canaria", address="Polígono Cruz de Piedra, C. Farmacéutico Pedro Rivero, 22, Loc 10, 35013 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.1042026, longitude=-15.4359679,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/81cb8b04-fe96-4acc-855f-c71a23f2f321_photo.png",
      averageRating=4.5, totalRatingsCount=18,
      createdAt="2026-09-01T08:57:03.421902Z", updatedAt="2026-09-01T08:57:03.421902Z",
    ),
    ClubDto(
      id="fd7c7eb2-6fc4-4190-933f-aa0f2d546922", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Voleyplaya Elitefitgc", address="Las Canteras, 35007 Las Palmas de Gran Canaria, Las Palmas",
      city="Las Palmas", country="ES",
      latitude=28.144355, longitude=-15.4316409,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aed75830-cfdf-436d-a80f-d6ca15cd77fa_photo.jpg",
      averageRating=4.8, totalRatingsCount=16,
      createdAt="2026-09-01T08:57:10.262564Z", updatedAt="2026-09-01T08:57:10.262564Z",
    ),
  )),
  CitySeo(slug="katowice", name="Katowice", country="PL", clubCount=27, sports=listOf(Pair("Football", 5), Pair("Volleyball", 4), Pair("Tennis", 3), Pair("Padel", 3), Pair("Billiards", 2), Pair("Karting", 2), Pair("Bowling", 2), Pair("Paintball", 2), Pair("Climbing", 2), Pair("Golf", 1), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="ca61457d-1bc2-49e1-9885-0e11a93daded", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Center & Academy", address="Lwowska 40, 40-389 Katowice",
      city="Katowice", country="PL",
      latitude=50.2502311, longitude=19.0893664,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4f0264ff-2e64-4af9-9ef5-2508538ccbcc_photo.jpg",
      averageRating=5.0, totalRatingsCount=175,
      createdAt="2026-08-31T23:40:38.065027Z", updatedAt="2026-08-31T23:40:38.065027Z",
    ),
    ClubDto(
      id="344e5b50-9e04-48aa-b332-d57de225f479", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Katowice - Viva Padel", address="Józefa Mackiewicza 1, 40-561 Katowice",
      city="Katowice", country="PL",
      latitude=50.2699352, longitude=19.068841,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06287945-fb74-4985-bff1-6ec892d9493e_photo.jpg",
      averageRating=4.9, totalRatingsCount=64,
      createdAt="2026-08-31T23:40:45.427330Z", updatedAt="2026-08-31T23:40:45.427330Z",
    ),
    ClubDto(
      id="bcbb3cc4-0bcb-4f82-9d04-ad6202fe21e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="E1GOKART Chorzów - Gokarty Śląsk", address="Gabriela Narutowicza 9, 41-503 Chorzów",
      city="Katowice", country="PL",
      latitude=50.3129097, longitude=18.9726442,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e796b8ac-1307-49e4-92ad-f3a7a5adc062_photo.jpg",
      averageRating=4.8, totalRatingsCount=2183,
      createdAt="2026-08-31T23:41:29.086340Z", updatedAt="2026-08-31T23:41:29.086340Z",
    ),
    ClubDto(
      id="4eab0d6c-21ba-47b0-a805-7c603b0fbccb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poziom 450", address="Gabriela Narutowicza 51, 41-200 Sosnowiec",
      city="Katowice", country="PL",
      latitude=50.2810814, longitude=19.1488812,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8651d32b-4094-42f5-bc83-76384d5e03e0_photo.jpg",
      averageRating=4.8, totalRatingsCount=1909,
      createdAt="2026-08-31T23:41:48.887084Z", updatedAt="2026-08-31T23:41:48.887084Z",
    ),
    ClubDto(
      id="d947be38-0102-4a9c-b1a0-7263031b36cf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="S-Kart Tor Kartingowy", address="Księdza Jerzego Popiełuszki 1, 41-906 Bytom",
      city="Katowice", country="PL",
      latitude=50.350861, longitude=18.8793357,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9de4a9fe-89b7-4e1f-a84e-1d4b50f07a2a_photo.jpg",
      averageRating=4.8, totalRatingsCount=3287,
      createdAt="2026-08-31T23:41:23.381045Z", updatedAt="2026-08-31T23:41:23.381045Z",
    ),
    ClubDto(
      id="9c572545-fd53-4ec5-a784-f8f93f7a933e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="padel up", address="Żelazna 15 a, 40-851 Katowice",
      city="Katowice", country="PL",
      latitude=50.2653029, longitude=19.005887,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/927d9160-3d4e-4423-9655-dc861394905a_photo.jpg",
      averageRating=4.8, totalRatingsCount=51,
      createdAt="2026-08-31T23:40:55.707875Z", updatedAt="2026-08-31T23:40:55.707875Z",
    ),
    ClubDto(
      id="93b12d13-e408-4a77-8667-111d1c9d235f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arena Katowice", address="Nowa Bukowa 1, 40-803 Katowice",
      city="Katowice", country="PL",
      latitude=50.2509766, longitude=18.9730558,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/91adbebd-c860-4338-a0ec-0820da1fb69a_photo.jpg",
      averageRating=4.7, totalRatingsCount=859,
      createdAt="2026-08-31T23:40:04.128419Z", updatedAt="2026-08-31T23:40:04.128419Z",
    ),
    ClubDto(
      id="57643189-f39b-46f1-9f73-64c88252b9a0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kopalnia Futbolu", address="Milowicka 1F, 40-312 Katowice",
      city="Katowice", country="PL",
      latitude=50.2794324, longitude=19.0728569,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8f03888c-ab9f-48dc-ae7d-80471eeeb2c0_photo.jpg",
      averageRating=4.7, totalRatingsCount=580,
      createdAt="2026-08-31T23:40:09.065345Z", updatedAt="2026-08-31T23:40:09.065345Z",
    ),
    ClubDto(
      id="07086406-3073-46cc-9676-30aab48eb743", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Krakow Valley Golf & Country Club", address="Paczółtowice 328, 32-063 Krzeszowice",
      city="Katowice", country="PL",
      latitude=50.1846411, longitude=19.6521163,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f799212-5a1c-413f-88fd-08bdcc89d2df_photo.jpg",
      averageRating=4.7, totalRatingsCount=532,
      createdAt="2026-08-31T23:41:18.963656Z", updatedAt="2026-08-31T23:41:18.963656Z",
    ),
    ClubDto(
      id="507eb2d9-1235-4671-b389-b882e3204554", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ośrodek Sportowy KOLEJARZ", address="Alfreda 1, 40-152 Katowice",
      city="Katowice", country="PL",
      latitude=50.286907, longitude=19.0140034,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f07c5457-83cd-4f28-bf67-95a0e302b3df_photo.jpg",
      averageRating=4.7, totalRatingsCount=355,
      createdAt="2026-08-31T23:41:08.805119Z", updatedAt="2026-08-31T23:41:08.805119Z",
    ),
    ClubDto(
      id="d88c1d2e-439b-4c8c-b740-4a378aaac028", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Factory", address="Walerego Goetla 9, 40-749 Katowice",
      city="Katowice", country="PL",
      latitude=50.2087804, longitude=19.039444,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/75c4b650-7538-4311-bae8-960d634cf406_photo.jpg",
      averageRating=4.7, totalRatingsCount=441,
      createdAt="2026-08-31T23:42:08.005417Z", updatedAt="2026-08-31T23:42:08.005417Z",
    ),
    ClubDto(
      id="ed38e288-22cc-4294-a801-10816e88fa67", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laserhouse", address="Kamienna 9, 40-067 Katowice",
      city="Katowice", country="PL",
      latitude=50.2572131, longitude=19.0120192,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/be432ed8-0ee5-4e75-88b4-2f6fd6e71567_photo.jpg",
      averageRating=4.6, totalRatingsCount=961,
      createdAt="2026-08-31T23:42:03.636706Z", updatedAt="2026-08-31T23:42:03.636706Z",
    ),
    ClubDto(
      id="70be83d0-3451-48c0-8084-90f1f97a4888", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ośrodek Sportowy PODLESIANKA", address="Sołtysia 25, 40-748 Katowice",
      city="Katowice", country="PL",
      latitude=50.1800915, longitude=18.9761732,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b322bda6-f63e-4d2a-b178-35ab47e4eccd_photo.jpg",
      averageRating=4.6, totalRatingsCount=352,
      createdAt="2026-08-31T23:40:27.621986Z", updatedAt="2026-09-01T14:31:48.747279Z",
    ),
    ClubDto(
      id="dc3ce0e2-beca-4d84-aea4-fcc868e67558", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ośrodek sportowy SŁOWIAN", address="1 Maja 99, 40-235 Katowice",
      city="Katowice", country="PL",
      latitude=50.2595843, longitude=19.0559676,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e771da90-c713-417d-acc0-5ce39750f74e_photo.jpg",
      averageRating=4.6, totalRatingsCount=533,
      createdAt="2026-08-31T23:40:13.509401Z", updatedAt="2026-08-31T23:40:13.509401Z",
    ),
    ClubDto(
      id="39a19b8d-1402-4923-9133-a8d1612918b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Skarpa Bytom Rozbark", address="Wojciecha Kilara 33, 41-902 Bytom",
      city="Katowice", country="PL",
      latitude=50.3426017, longitude=18.9306735,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9803442f-2c7a-4caf-a489-f479cb1406da_photo.jpg",
      averageRating=4.6, totalRatingsCount=1942,
      createdAt="2026-08-31T23:41:42.760752Z", updatedAt="2026-08-31T23:41:42.760752Z",
    ),
    ClubDto(
      id="638700b1-0187-4d62-b0fb-61f9f83c08a0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kręgielnia Renoma & Burgerownia Cozy Burger - Strefa rozrywki Siemianowickiej Spółdzielni Mieszkaniowej", address="Wróblewskiego 37, 41-106 Siemianowice Śląskie",
      city="Katowice", country="PL",
      latitude=50.3023, longitude=19.004441,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ae1c40f9-a799-4136-92e6-33ce80dde80f_photo.jpg",
      averageRating=4.5, totalRatingsCount=1387,
      createdAt="2026-08-31T23:41:38.546632Z", updatedAt="2026-08-31T23:41:38.546632Z",
    ),
    ClubDto(
      id="71623d8f-796d-4f60-ba61-e09e0bb90a77", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ośrodek Sportowy SZOPIENICE", address="11 Listopada 16, 40-387 Katowice",
      city="Katowice", country="PL",
      latitude=50.2606794, longitude=19.0902579,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a701da5-473b-484c-9c50-837d9843397f_photo.jpg",
      averageRating=4.5, totalRatingsCount=942,
      createdAt="2026-08-31T23:41:04.835671Z", updatedAt="2026-08-31T23:41:04.835671Z",
    ),
    ClubDto(
      id="454d6518-68a2-4fe2-83f9-cc1d62300e7a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ośrodek rekreacyjno wypoczynkowy BUGLA", address="Żeliwna 26, 40-599 Katowice",
      city="Katowice", country="PL",
      latitude=50.2531203, longitude=18.993732,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a204d2f0-c3ac-4f41-a126-b70390d15389_photo.jpg",
      averageRating=4.5, totalRatingsCount=1949,
      createdAt="2026-08-31T23:41:00.487482Z", updatedAt="2026-08-31T23:41:00.487482Z",
    ),
    ClubDto(
      id="abcbff59-eadf-496f-95db-91b7cde56210", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centrum Sportowe Bażantowo", address="Pijarska 3, 40-959 Katowice",
      city="Katowice", country="PL",
      latitude=50.1970024, longitude=18.9812469,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cb6436fd-de6b-4041-97d5-16174e7e7f77_photo.jpg",
      averageRating=4.4, totalRatingsCount=1239,
      createdAt="2026-08-31T23:40:23.421537Z", updatedAt="2026-08-31T23:40:23.421537Z",
    ),
    ClubDto(
      id="10434485-c6c0-4852-b754-8da8c880c0f5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ośrodek Sportowy HETMAN", address="ks. Wiktora Siwka 6, 40-306 Katowice",
      city="Katowice", country="PL",
      latitude=50.2775821, longitude=19.0625496,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2adb953a-5c0e-4788-bb74-5b16df3ab5a7_photo.jpg",
      averageRating=4.4, totalRatingsCount=336,
      createdAt="2026-08-31T23:40:32.101496Z", updatedAt="2026-09-01T14:31:48.629227Z",
    ),
    ClubDto(
      id="8b048946-87eb-4373-a268-52b26fc565b8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stadion Miejski - Katowice", address="Bukowa 1A, 40-108 Katowice",
      city="Katowice", country="PL",
      latitude=50.2797131, longitude=19.0012173,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/569952fa-8dbb-4267-8495-0bb332db5989_photo.jpg",
      averageRating=4.4, totalRatingsCount=1431,
      createdAt="2026-08-31T23:39:58.762079Z", updatedAt="2026-08-31T23:39:58.762079Z",
    ),
    ClubDto(
      id="99ed35b8-6461-4477-9625-507a9a43628f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach at Three Lakes valley", address="Trzech Stawów 23, 40-289 Katowice",
      city="Katowice", country="PL",
      latitude=50.2417442, longitude=19.0467826,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/43a0ac1c-6ee3-4b30-9832-de81590564d5_photo.jpg",
      averageRating=4.3, totalRatingsCount=134,
      createdAt="2026-08-31T23:41:12.924295Z", updatedAt="2026-08-31T23:41:12.924295Z",
    ),
    ClubDto(
      id="0fc385cd-640f-4ac2-b1ec-9a860a06b0a6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Diament - Bowling & Billiards Club", address="Adama Mickiewicza 4, 40-092 Katowice",
      city="Katowice", country="PL",
      latitude=50.2597852, longitude=19.0208815,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1dab2a1a-2ce7-469e-adb5-a3d4d31d8187_photo.jpg",
      averageRating=4.3, totalRatingsCount=573,
      createdAt="2026-08-31T23:41:58.896102Z", updatedAt="2026-08-31T23:41:58.896102Z",
    ),
    ClubDto(
      id="e2874fc6-de00-4753-a114-ffbc2a121070", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gravitacja", address="Punkt 44, Gliwicka 44, 40-853 Katowice",
      city="Katowice", country="PL",
      latitude=50.2627038, longitude=19.0053754,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5f02b2a-a43f-44e4-b579-d75e880b239b_photo.jpg",
      averageRating=4.3, totalRatingsCount=2880,
      createdAt="2026-08-31T23:41:33.643772Z", updatedAt="2026-08-31T23:41:33.643772Z",
    ),
    ClubDto(
      id="a535e9d0-8576-4301-9472-6f913624de27", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MK Bowling Katowice", address="Tadeusza Kościuszki 229, 40-600 Katowice",
      city="Katowice", country="PL",
      latitude=50.2237738, longitude=18.9877325,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1cc4ec15-8910-4ec2-92e4-115b768741b4_photo.jpg",
      averageRating=4.3, totalRatingsCount=1156,
      createdAt="2026-08-31T23:41:53.502038Z", updatedAt="2026-08-31T23:41:53.502038Z",
    ),
    ClubDto(
      id="d9e28753-1a4b-4639-bbc5-60242b0da588", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boiska Sportowe RAPID", address="Jana Nepomucena Stęślickiego 6, 40-120 Katowice",
      city="Katowice", country="PL",
      latitude=50.2707455, longitude=19.0168439,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/675ec33a-1109-4116-b416-d97b5f803531_photo.jpg",
      averageRating=4.2, totalRatingsCount=467,
      createdAt="2026-08-31T23:40:18.181510Z", updatedAt="2026-08-31T23:40:18.181510Z",
    ),
    ClubDto(
      id="982b431c-edd6-4af2-97c9-9904641e2559", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="paintballpark.pl", address="aleja Spacerowa 23, 41-408 Mysłowice",
      city="Katowice", country="PL",
      latitude=50.1919716, longitude=19.0924581,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1db8afc0-5f81-4a81-98b1-bb7a57134fbb_photo.jpg",
      averageRating=5.0, totalRatingsCount=33,
      createdAt="2026-08-31T23:42:14.694756Z", updatedAt="2026-08-31T23:42:14.694756Z",
    ),
  )),
  CitySeo(slug="helsinki", name="Helsinki", country="FI", clubCount=27, sports=listOf(Pair("Volleyball", 4), Pair("Football", 3), Pair("Tennis", 3), Pair("Basketball", 3), Pair("Padel", 3), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Bowling", 2), Pair("Paintball", 1), Pair("Karting", 1), Pair("Golf", 1)), clubs=listOf(
    ClubDto(
      id="246bddcf-1add-48d0-8af4-2b731d64df43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kiipeilyareena - Kalasatama", address="Kauppakeskus, Kauppakeskus REDI, 00540 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1861818, longitude=24.9783482,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d36843b0-b194-48c0-ac81-db08859edf9c_ChIJG2zWTqAJ_0.jpg",
      averageRating=4.7, totalRatingsCount=558,
      createdAt="2026-08-30T23:06:06.825273Z", updatedAt="2026-08-31T08:31:19.562497Z",
    ),
    ClubDto(
      id="cf49f499-85ec-478d-8770-6d899e7b067a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kiipeilyareena - Salmisaari", address="Energiakatu 3, 00180 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1660876, longitude=24.9041841,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/95c86452-f02c-419a-84d7-7f8e9275d75c_ChIJ6RVCS0YK_0.jpg",
      averageRating=4.7, totalRatingsCount=852,
      createdAt="2026-08-30T23:06:00.325821Z", updatedAt="2026-08-31T08:31:20.352666Z",
    ),
    ClubDto(
      id="7a3961d9-9e6b-46cb-97b7-75274e2400fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arenaharbor", address="Eteläloisto, 00980 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.2108802, longitude=25.177473,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/078686fe-b48a-4ce2-93b7-ddd703d81019_ChIJ-9p5JxEP_0.jpg",
      averageRating=4.6, totalRatingsCount=120,
      createdAt="2026-08-30T23:06:35.787842Z", updatedAt="2026-08-30T23:06:35.787842Z",
    ),
    ClubDto(
      id="81c07df0-c39d-4007-8d20-b0c464ad88f9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laserareena", address="Hermannin rantatie 5a, 00580 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1873095, longitude=24.9777874,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/02d4fc5a-bffe-445d-a1e6-424fda0c9ff3_ChIJ15EcKmL1_0.jpg",
      averageRating=4.5, totalRatingsCount=107,
      createdAt="2026-08-30T23:06:27.480012Z", updatedAt="2026-08-31T08:32:14.503105Z",
    ),
    ClubDto(
      id="8be08ecd-b86c-4a77-aab1-c726426ae82b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Megazone Salmisaari", address="Energiakatu 3, 00180 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1654617, longitude=24.9028417,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2984e352-42d3-4e1f-a613-e8cdccc83b6f_ChIJYadhykcK_0.jpg",
      averageRating=4.5, totalRatingsCount=750,
      createdAt="2026-08-30T23:06:20.290921Z", updatedAt="2026-08-31T08:32:50.105135Z",
    ),
    ClubDto(
      id="2e7afd9b-573a-4a2f-9900-1b5230162ca1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Point Konala", address="Malminkartanonkuja 2, 00390 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.2426795, longitude=24.8515605,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/46c9b94f-3979-47ca-9a1f-3dcc2e28b2a8_ChIJ6TyH1333_0.jpg",
      averageRating=4.5, totalRatingsCount=78,
      createdAt="2026-08-30T23:06:49.423223Z", updatedAt="2026-08-31T08:33:57.607319Z",
    ),
    ClubDto(
      id="7acec9d8-594e-4b98-83f6-42bce39b9da6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sörnäisten Padel Oy", address="Rantapromenadi 1, 00540 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1824313, longitude=24.9630464,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f190406e-ed97-480d-b129-614fad3729a7_ChIJkwKqhRAJ_0.jpg",
      averageRating=4.5, totalRatingsCount=56,
      createdAt="2026-08-30T23:06:56.064387Z", updatedAt="2026-08-31T08:37:08.255027Z",
    ),
    ClubDto(
      id="2bb00458-1ff5-4516-9f37-f1af2c1289da", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mäkelänrinne Sports Centre", address="Mäkelänkatu 49, 00550 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1996214, longitude=24.9470577,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8ade2339-8a28-4feb-affe-a09a72382fe7_photo.jpg",
      averageRating=4.4, totalRatingsCount=2178,
      createdAt="2026-08-31T15:21:54.686540Z", updatedAt="2026-08-31T15:21:54.686540Z",
    ),
    ClubDto(
      id="d53e93b5-cdd4-412a-9dc5-36a33cea4a07", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Viikinranta", address="Jokisuuntie 5, 00560 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.2182692, longitude=24.9875859,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/91af3be4-002f-462e-8b75-a44595000ea8_ChIJkYm3ZgcJ_0.jpg",
      averageRating=4.4, totalRatingsCount=80,
      createdAt="2026-08-30T23:06:43.656600Z", updatedAt="2026-08-30T23:06:43.656600Z",
    ),
    ClubDto(
      id="09954d4c-40df-4c90-b38c-ddcebd94547b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UniSport Kumpula", address="Väinö Auerin katu 11, 00560 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.205676, longitude=24.9616969,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d9bdb9a-9d3e-46c0-bbf4-ad650d5636ca_photo.jpg",
      averageRating=4.4, totalRatingsCount=336,
      createdAt="2026-08-31T15:21:47.733459Z", updatedAt="2026-08-31T15:21:47.733459Z",
    ),
    ClubDto(
      id="380058ac-c013-44df-ab81-4bcd72e01b43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Varuste.net", address="Malminkartanontie 1, 00390 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.2442258, longitude=24.8481747,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/50ac905c-80ba-4726-9369-c7667d64c55f_ChIJy3B8Bkf2_0.jpg",
      averageRating=4.4, totalRatingsCount=3363,
      createdAt="2026-08-30T23:05:05.755008Z", updatedAt="2026-08-31T08:38:32.629764Z",
    ),
    ClubDto(
      id="b7ae2810-04b2-4e46-8d49-0305a0e091b5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Helsingin Golfklubi ry", address="Talin puistotie 12, 00380 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.2119191, longitude=24.8608502,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/87c346ef-e304-4adc-bd55-3ede2db7edbd_photo.jpg",
      averageRating=4.3, totalRatingsCount=327,
      createdAt="2026-08-31T15:22:21.231454Z", updatedAt="2026-08-31T15:22:21.231454Z",
    ),
    ClubDto(
      id="bd7c61f9-82f3-4137-aae2-a0286ecde2f1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Meilahden Liikuntakeskus", address="Zaidankatu 9, 00250 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1902619, longitude=24.8970496,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d63bdeb2-7d82-4e31-9df5-b7c3fc627aa3_ChIJAQAA0JYJ_0.jpg",
      averageRating=4.3, totalRatingsCount=342,
      createdAt="2026-08-30T23:07:08.906445Z", updatedAt="2026-08-31T08:32:50.660141Z",
    ),
    ClubDto(
      id="bc9b04b7-5dc0-4da1-b96e-d0dc7702c4ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Talin Tenniskeskus", address="Talin Urheilupuisto, Kutomokuja 4, 00380 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.2129641, longitude=24.8764479,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c775b745-2982-4b3f-9ddc-9075d0286c03_ChIJSbRWchv2_0.jpg",
      averageRating=4.3, totalRatingsCount=709,
      createdAt="2026-08-30T23:07:02.644836Z", updatedAt="2026-09-01T14:32:03.137752Z",
    ),
    ClubDto(
      id="b7733df0-318e-47f8-9174-5de9b96f93d0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tapanilan Urheilukeskus", address="Erätie 3, 00730 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.2654007, longitude=25.0180147,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f7ed0f26-6cea-41de-b283-290b5724ffa0_ChIJ06m8wHkI_0.jpg",
      averageRating=4.3, totalRatingsCount=724,
      createdAt="2026-08-30T23:05:46.054183Z", updatedAt="2026-08-31T08:37:23.911679Z",
    ),
    ClubDto(
      id="d35b83a9-9122-4bb3-9396-db3b59f9a08d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Corona Baari & Biljardi", address="Traverssikuja 3, 00510 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1941315, longitude=24.9452057,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ba396c0d-b486-4f94-98ba-1fb1d69458cd_ChIJ7Ys8I8sL_0.jpg",
      averageRating=4.2, totalRatingsCount=852,
      createdAt="2026-08-30T23:05:32.770039Z", updatedAt="2026-08-31T08:27:08.051472Z",
    ),
    ClubDto(
      id="b9026c0f-1103-4871-a27c-965811b663b0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Talin jalkapallohalli", address="Purotie 8, 00380 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.2146701, longitude=24.8681515,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/10886c5e-0fe0-48f6-9138-55bca88f761a_ChIJt5KaFsX3_0.jpg",
      averageRating=4.2, totalRatingsCount=919,
      createdAt="2026-08-30T23:05:26.274959Z", updatedAt="2026-08-30T23:05:26.274959Z",
    ),
    ClubDto(
      id="f150d6cb-80e6-46ef-b168-079d7a9fd0df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boothill", address="Lönnrotinkatu 25, 00180 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1646872, longitude=24.9333832,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/765ad6ee-ea26-4886-9acd-27d592f931eb_ChIJuc7K7MoL_0.jpg",
      averageRating=4.1, totalRatingsCount=394,
      createdAt="2026-08-30T23:05:39.502745Z", updatedAt="2026-08-30T23:05:39.502745Z",
    ),
    ClubDto(
      id="e35f74bb-31e1-4797-a6e8-82be913d930f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Chaplin", address="Vuorikatu 14, 00100 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1716091, longitude=24.9463094,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4dc43bce-268a-4e68-b700-37b2e694ab6e_ChIJtV0n-ssL_0.jpg",
      averageRating=4.1, totalRatingsCount=1008,
      createdAt="2026-08-30T23:05:19.321533Z", updatedAt="2026-08-30T23:05:19.321533Z",
    ),
    ClubDto(
      id="75e0bbc2-f05a-4d12-bd16-03f04222a263", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ruusulan keilahalli", address="Ruusulankatu 5, 00260 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1819445, longitude=24.9249753,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/85693481-2d87-46db-b322-1c80b5dc0b1c_ChIJy3_aZy8K_0.jpg",
      averageRating=4.1, totalRatingsCount=606,
      createdAt="2026-08-30T23:05:52.650053Z", updatedAt="2026-08-31T08:35:32.425704Z",
    ),
    ClubDto(
      id="4914924f-0920-4da6-8bd8-a07b660bfe0e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Töölö Sports Hall", address="Paavo Nurmen kuja 1 C, 00250 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.183778, longitude=24.9258364,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eb70285c-d702-411f-85ef-61587659c957_photo.jpg",
      averageRating=4.1, totalRatingsCount=1959,
      createdAt="2026-08-31T15:21:26.000042Z", updatedAt="2026-08-31T15:21:26.000042Z",
    ),
    ClubDto(
      id="1bc46ca6-e399-479f-a4db-5485929c3043", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Formula Center Helsinki", address="Yläkivenrinne 1, 00920 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.2216707, longitude=25.0694986,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6883b65b-69fe-4bf6-8b27-a70e6d9f6669_ChIJHXcu29EI_0.jpg",
      averageRating=4.0, totalRatingsCount=510,
      createdAt="2026-08-30T23:06:13.426889Z", updatedAt="2026-08-31T08:27:59.130418Z",
    ),
    ClubDto(
      id="2ce8f341-1d90-4c90-9889-725742be6a74", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laajasalon tennishallit Oy", address="Sarvastonkaari 23, 00840 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1746257, longitude=25.0565104,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/285d721f-1762-40f7-affa-e3e27da71a76_ChIJrzDWMa4O_0.jpg",
      averageRating=4.0, totalRatingsCount=229,
      createdAt="2026-08-30T23:07:15.775706Z", updatedAt="2026-09-01T14:31:45.509247Z",
    ),
    ClubDto(
      id="28bdf77c-e601-4e76-8ac2-6e01e6a552b2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pasilan Urheiluhalli", address="Radiokatu 22, 00240 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.2042393, longitude=24.9167035,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd5c5505-581e-4511-8ca5-d286d6d3be81_photo.jpg",
      averageRating=3.9, totalRatingsCount=268,
      createdAt="2026-08-31T15:21:32.925155Z", updatedAt="2026-08-31T15:21:32.925155Z",
    ),
    ClubDto(
      id="6062fedf-5674-4a12-be6c-dfee0b3e3aa0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Merihaan Pallohalli Oy", address="Haapaniemenkatu 14, 00530 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.179642, longitude=24.9629867,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c51aad81-cbdf-4b6b-a1dc-6bcba64dff35_photo.jpg",
      averageRating=3.7, totalRatingsCount=505,
      createdAt="2026-08-31T15:21:40.650952Z", updatedAt="2026-08-31T15:21:40.650952Z",
    ),
    ClubDto(
      id="96da2ed1-406d-472f-a036-3864d2ee14e5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hietsu Beach Volley ry", address="Hiekkarannantie 11, 00100 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.1732272, longitude=24.9046447,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ace0ee9-c099-4820-8e8b-179e75ba83ee_photo.jpg",
      averageRating=4.3, totalRatingsCount=15,
      createdAt="2026-08-31T15:22:04.660834Z", updatedAt="2026-08-31T15:22:04.660834Z",
    ),
    ClubDto(
      id="98c522e7-f87c-4238-8a76-a2d635731e5d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hietsu Beachbox", address="Hiekkarannantie 11, 00100 Helsinki",
      city="Helsinki", country="FI",
      latitude=60.17547, longitude=24.9089016,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eb4840e7-50ff-48aa-b355-72a27bbd8220_photo.jpg",
      averageRating=5.0, totalRatingsCount=5,
      createdAt="2026-08-31T15:22:13.573742Z", updatedAt="2026-08-31T15:22:13.573742Z",
    ),
  )),
  CitySeo(slug="leipzig", name="Leipzig", country="DE", clubCount=27, sports=listOf(Pair("Football", 4), Pair("Tennis", 4), Pair("Volleyball", 3), Pair("Padel", 3), Pair("Climbing", 2), Pair("Basketball", 2), Pair("Karting", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="0f83a68a-1610-4de4-9c28-a5fc1158679c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="VAMOS - Padel Club Leipzig", address="Görlitzer Str. 5, 04129 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.3661203, longitude=12.3875117,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/232ee185-f23b-462d-a0cc-86063ddf8459_photo.jpg",
      averageRating=4.9, totalRatingsCount=72,
      createdAt="2026-08-31T22:59:06.334813Z", updatedAt="2026-08-31T22:59:06.334813Z",
    ),
    ClubDto(
      id="098d1572-3866-4ac5-abb8-a6f4cea01951", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BeachL e.V. - Beachhalle & Beachvolleyball Außenanlage Sunlight", address="Carl-Weichelt-Straße 5, 04249 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.2973339, longitude=12.3186507,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b162606-7271-4adc-843d-48afbf293c40_photo.jpg",
      averageRating=4.8, totalRatingsCount=78,
      createdAt="2026-08-31T22:59:31.024078Z", updatedAt="2026-08-31T22:59:31.024078Z",
    ),
    ClubDto(
      id="bc742802-b9c4-4532-998b-9daf14239867", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ONYX Boulderspot Leipzig", address="Franz-Flemming-Straße 35, 04179 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.3467131, longitude=12.3051985,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9336081d-7990-49a4-b2f0-fdd52cf6aec1_photo.jpg",
      averageRating=4.8, totalRatingsCount=418,
      createdAt="2026-08-31T23:00:29.564617Z", updatedAt="2026-08-31T23:00:29.564617Z",
    ),
    ClubDto(
      id="806a4985-3c8a-4436-9a58-ad7de5568618", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PadelCity Leipzig Leutzsch", address="Franz-Flemming-Straße 3a, 04179 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.3420996, longitude=12.3127201,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/643dcd7f-1a13-4c09-b220-3b2b7877cade_photo.jpg",
      averageRating=4.8, totalRatingsCount=157,
      createdAt="2026-08-31T22:59:00.868464Z", updatedAt="2026-08-31T22:59:00.868464Z",
    ),
    ClubDto(
      id="21567f9b-d215-47e1-9583-b34f0c9b5e61", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BattleKart Halle - Leipzig", address="Berliner Str. 191, 06116 Halle (Saale)",
      city="Leipzig", country="DE",
      latitude=51.4948001, longitude=12.0104223,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2005d6ca-0604-48de-bf0f-bdf810f62aaa_photo.jpg",
      averageRating=4.7, totalRatingsCount=139,
      createdAt="2026-08-31T23:00:03.696058Z", updatedAt="2026-08-31T23:00:03.696058Z",
    ),
    ClubDto(
      id="baeb61db-10e5-4aba-b40e-de2410f04fcb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bi Ba Bo", address="Engertstraße 36, 04229 Leipzig-Alt-West",
      city="Leipzig", country="DE",
      latitude=51.3273041, longitude=12.3222309,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e338a76a-9c27-46a7-b29b-bb8024271d32_photo.jpg",
      averageRating=4.7, totalRatingsCount=1257,
      createdAt="2026-08-31T23:00:35.485539Z", updatedAt="2026-08-31T23:00:35.485539Z",
    ),
    ClubDto(
      id="07b8dde8-8cc1-4566-a051-a925eb079c83", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GolfPark Leipzig GmbH", address="Bergweg 10, 04356 Leipzig-Nord",
      city="Leipzig", country="DE",
      latitude=51.4041721, longitude=12.4083947,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e76c9fa-473e-4f45-8a03-91019cb1430f_photo.jpg",
      averageRating=4.6, totalRatingsCount=175,
      createdAt="2026-08-31T22:59:44.666110Z", updatedAt="2026-08-31T22:59:44.666110Z",
    ),
    ClubDto(
      id="bde9e86e-7547-4ee7-9ee7-515bd8fc8fcd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golfclub Markkleeberg am See", address="Mühlweg 1, 04416 Markkleeberg-Südwest",
      city="Leipzig", country="DE",
      latitude=51.2695823, longitude=12.3501654,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b8306bc3-5ad0-4747-a202-a1913405973b_photo.jpg",
      averageRating=4.6, totalRatingsCount=119,
      createdAt="2026-08-31T22:59:50.048719Z", updatedAt="2026-08-31T22:59:50.048719Z",
    ),
    ClubDto(
      id="faab3996-0dac-41e1-926c-dc7cf3f69003", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lap's Kart Center Grimma", address="Südstraße 80, 04668 Grimma",
      city="Leipzig", country="DE",
      latitude=51.2191216, longitude=12.717691,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7109fee1-d052-42e8-afb5-2c6e3d82259f_photo.jpg",
      averageRating=4.6, totalRatingsCount=986,
      createdAt="2026-08-31T22:59:58.810930Z", updatedAt="2026-08-31T22:59:58.810930Z",
    ),
    ClubDto(
      id="cac078d6-87d5-4d46-8501-0489b51e3f65", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Matchball Sportcenter", address="Lützner Str. 175, 04179 Leipzig-Alt-West",
      city="Leipzig", country="DE",
      latitude=51.3269456, longitude=12.3080996,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1faae193-bbca-4708-bb03-41ce4a053a18_photo.jpg",
      averageRating=4.6, totalRatingsCount=653,
      createdAt="2026-08-31T22:58:36.857706Z", updatedAt="2026-08-31T22:58:36.857706Z",
    ),
    ClubDto(
      id="6150ed96-cece-4a66-94d7-dc0060c5bd49", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BLOC NO LIMIT", address="Brandenburger Str. 26, 04347 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.3518548, longitude=12.3955194,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fbab3ebb-d124-4d80-923e-aafaddd1364a_photo.jpg",
      averageRating=4.5, totalRatingsCount=1334,
      createdAt="2026-08-31T23:00:21.552482Z", updatedAt="2026-08-31T23:00:21.552482Z",
    ),
    ClubDto(
      id="7ad12813-d4ae-4b84-91fb-a11054d60f4e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Leipziger Sport Club 1901 e.V.", address="Pistorisstraße 30, 04229 Leipzig-Schleußig",
      city="Leipzig", country="DE",
      latitude=51.313067, longitude=12.341163,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f46a4402-7bdc-4dee-a220-05c572808fba_photo.jpg",
      averageRating=4.5, totalRatingsCount=230,
      createdAt="2026-08-31T22:58:46.255129Z", updatedAt="2026-09-01T14:32:01.560819Z",
    ),
    ClubDto(
      id="241546da-d976-403e-bcf3-d8aa8b2c8ddf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Saxon Tennis Association STV", address="Abtnaundorfer Str. 47, 04347 Leipzig-Nordost",
      city="Leipzig", country="DE",
      latitude=51.3633185, longitude=12.4154804,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5bd69b4-f156-40bc-9033-83453ff918b2_photo.jpg",
      averageRating=4.5, totalRatingsCount=68,
      createdAt="2026-08-31T22:58:55.468665Z", updatedAt="2026-08-31T22:58:55.468665Z",
    ),
    ClubDto(
      id="37ec44b9-0b44-4e2c-9b7b-7e61550a561c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Starlight-Bowling Leipzig", address="Diezmannstraße 5, 04207 Leipzig-Kleinzschocher",
      city="Leipzig", country="DE",
      latitude=51.3189441, longitude=12.317843,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2ecf7fc0-22ea-4f15-b629-3b53589a9f79_photo.jpg",
      averageRating=4.5, totalRatingsCount=2031,
      createdAt="2026-08-31T23:00:08.163709Z", updatedAt="2026-08-31T23:00:08.163709Z",
    ),
    ClubDto(
      id="a276c916-205f-48ca-b23a-c0d3a71da0e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachhalle No Limit", address="Dessauer Str. 2, 04129 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.3562002, longitude=12.384713,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e46a4176-f0ba-4c87-8012-0aebc060db76_photo.jpg",
      averageRating=4.4, totalRatingsCount=70,
      createdAt="2026-08-31T22:59:35.187125Z", updatedAt="2026-08-31T22:59:35.187125Z",
    ),
    ClubDto(
      id="86b0e9c5-52b3-4fad-be31-ce61409f5e1d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billard Café Schönefeld", address="Ossietzkystraße 13, 04347 Leipzig-Nordost",
      city="Leipzig", country="DE",
      latitude=51.3592411, longitude=12.4150703,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/026ade15-f5ea-46ef-9486-6a59796aa5f6_photo.jpg",
      averageRating=4.4, totalRatingsCount=530,
      createdAt="2026-08-31T23:00:44.922229Z", updatedAt="2026-08-31T23:00:44.922229Z",
    ),
    ClubDto(
      id="ab4780dc-19a9-4960-b0cb-4e7bfa4aec7c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowl Play GmbH", address="Sachsenpark/ Neue Messe, Handelsstraße 4, 04356 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.401357, longitude=12.3994761,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dbfc1eb0-115c-4b9e-af1a-f19cfea32bc8_photo.jpg",
      averageRating=4.4, totalRatingsCount=1218,
      createdAt="2026-08-31T23:00:16.300498Z", updatedAt="2026-08-31T23:00:16.300498Z",
    ),
    ClubDto(
      id="ed6c64f9-69d3-440b-94ac-a6e59d2178ba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportpark Leipzig", address="Schongauerstraße 37, 04329 Leipzig-Ost",
      city="Leipzig", country="DE",
      latitude=51.3490024, longitude=12.4691004,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a65492e2-882a-4164-968c-7dca7a9524a1_photo.jpg",
      averageRating=4.4, totalRatingsCount=356,
      createdAt="2026-08-31T22:58:42.028191Z", updatedAt="2026-08-31T22:58:42.028191Z",
    ),
    ClubDto(
      id="a7a6f499-7be1-47a8-943b-c70073fe1d0a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bruno-Plache-Stadion", address="Connewitzer Str. 21, 04289 Leipzig-Südost",
      city="Leipzig", country="DE",
      latitude=51.3029009, longitude=12.4192096,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/30f21ee4-4f16-409c-bf73-33ef1744412b_photo.jpg",
      averageRating=4.3, totalRatingsCount=1827,
      createdAt="2026-08-31T22:58:27.344379Z", updatedAt="2026-08-31T22:58:27.344379Z",
    ),
    ClubDto(
      id="d5498b9d-6159-4ce7-9ab1-1e87a0caa1fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Leipzig Tennis Club 1990 e.V.", address="Am Sportforum 7, 04105 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.3500904, longitude=12.3440186,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aa4f9340-e93e-4331-8c6f-d84c0227e60e_photo.jpg",
      averageRating=4.3, totalRatingsCount=112,
      createdAt="2026-08-31T22:58:51.126312Z", updatedAt="2026-08-31T22:58:51.126312Z",
    ),
    ClubDto(
      id="7ab4338a-87fa-4b3b-9008-ae40f6fc2f51", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Red Bull Arena", address="Am Sportforum 3, 04105 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.3457655, longitude=12.3482697,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d516a59a-4405-426b-a962-bc28e3978fe9_photo.jpg",
      averageRating=4.2, totalRatingsCount=22922,
      createdAt="2026-08-31T22:58:23.164169Z", updatedAt="2026-08-31T22:58:23.164169Z",
    ),
    ClubDto(
      id="aaca1dd8-7f00-482c-b258-47b1975b7033", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="soccerworld Deutschland GmbH", address="Curiestraße 10, 04103 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.3211753, longitude=12.4008483,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d80eada-421f-4d38-9f34-8d638d22f606_photo.jpg",
      averageRating=4.2, totalRatingsCount=1081,
      createdAt="2026-08-31T22:58:32.051279Z", updatedAt="2026-08-31T22:58:32.051279Z",
    ),
    ClubDto(
      id="36c3f13a-88cb-4bb6-a210-b4984d6cf1fc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tischtennis Flemming", address="Bodenreformweg 15, 04347 Leipzig-Nordost",
      city="Leipzig", country="DE",
      latitude=51.3637233, longitude=12.4236575,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a8f4d715-024c-43c9-b5c6-4a0b45f99206_photo.jpg",
      averageRating=5.0, totalRatingsCount=41,
      createdAt="2026-08-31T22:59:54.237838Z", updatedAt="2026-08-31T22:59:54.237838Z",
    ),
    ClubDto(
      id="81384918-23ab-472c-ad5f-937591748d98", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Schladitzer Bucht - Beachvolleyballfeld", address="Haynaer Str., 04519 Rackwitz",
      city="Leipzig", country="DE",
      latitude=51.4377713, longitude=12.3439321,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1c7fb18a-8be6-4b4d-81ff-9e079acbd82f_photo.jpg",
      averageRating=4.6, totalRatingsCount=28,
      createdAt="2026-08-31T22:59:40.235844Z", updatedAt="2026-08-31T22:59:40.235844Z",
    ),
    ClubDto(
      id="e1915b15-a563-40f3-899e-5f308516a02d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PadelCity Leipzig Plagwitz", address="Zschochersche Str. 79c, 04229 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.3229805, longitude=12.3342768,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1ca48f72-129e-4482-b4fa-4f8e7d5e13cc_photo.jpg",
      averageRating=4.9, totalRatingsCount=21,
      createdAt="2026-08-31T22:59:13.110299Z", updatedAt="2026-08-31T22:59:13.110299Z",
    ),
    ClubDto(
      id="110e435a-d801-42b6-9756-19776e01ca78", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketballplatz Bernhardiplatz", address="-C.-Hinrichs-Straße, J.-C.-Hinrichs-Straße 1A, 04315 Leipzig-Ost",
      city="Leipzig", country="DE",
      latitude=51.3406407, longitude=12.4037319,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2023a99f-a6b3-4e3a-94d5-765a3e52f440_photo.jpg",
      averageRating=4.0, totalRatingsCount=21,
      createdAt="2026-08-31T22:59:17.967855Z", updatedAt="2026-08-31T22:59:17.967855Z",
    ),
    ClubDto(
      id="2645da74-9d61-4e22-aadd-41b8f73ee8e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GutsMuths-Halle", address="Jahnallee 59, 04109 Leipzig",
      city="Leipzig", country="DE",
      latitude=51.3383641, longitude=12.3508671,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db7a4261-3167-4106-b5de-72e9f2a59ed4_photo.jpg",
      averageRating=4.6, totalRatingsCount=12,
      createdAt="2026-08-31T22:59:22.907192Z", updatedAt="2026-08-31T22:59:22.907192Z",
    ),
  )),
  CitySeo(slug="bilbao", name="Bilbao", country="ES", clubCount=27, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Padel", 3), Pair("Basketball", 3), Pair("Volleyball", 3), Pair("Climbing", 2), Pair("Karting", 2), Pair("Golf", 2), Pair("Paintball", 2), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="981e90d3-3035-4828-93b0-8c74e008e085", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo Voley Playa Muchavista", address="Av. Jaime I el Conquistador, 43, 03560 El Campello, Alicante",
      city="Bilbao", country="ES",
      latitude=38.384868, longitude=-0.408818,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c77f007-6992-46a2-aece-142a95aa4b2f_photo.jpg",
      averageRating=4.8, totalRatingsCount=189,
      createdAt="2026-08-31T22:46:06.790039Z", updatedAt="2026-08-31T22:46:06.790039Z",
    ),
    ClubDto(
      id="db365492-fb9e-4471-841d-fc0ae8479857", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Voley Playa Costa Blanca", address="Av. de Niza, 23, 03540 Alicante",
      city="Bilbao", country="ES",
      latitude=38.3754796, longitude=-0.40989,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fc6c6370-f542-45d1-b05f-e91b3ef63f6d_photo.jpg",
      averageRating=4.8, totalRatingsCount=90,
      createdAt="2026-08-31T22:46:11.770052Z", updatedAt="2026-08-31T22:46:11.770052Z",
    ),
    ClubDto(
      id="f22bf57e-2528-4edd-8922-9bd9550babb6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Iturgutxi", address="Goiko Auzoa, s/n, 01208 Galarreta, Álava",
      city="Bilbao", country="ES",
      latitude=42.899517, longitude=-2.361924,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/643b650e-b2d8-4d58-ba9b-d7078ade4607_photo.jpg",
      averageRating=4.8, totalRatingsCount=164,
      createdAt="2026-08-31T22:47:21.331447Z", updatedAt="2026-08-31T22:47:21.331447Z",
    ),
    ClubDto(
      id="e7533714-7f0e-46b0-8782-fe145050a6f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="San Mamés Stadium", address="P.º Rafael Moreno \"Pitxitxi\", s/n, Basurto-Zorroza, 48013 Bilbao, Vizcaya",
      city="Bilbao", country="ES",
      latitude=43.2641706, longitude=-2.9493731,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c377af34-ffc1-4bcc-a145-9bf0fd992585_photo.jpg",
      averageRating=4.7, totalRatingsCount=31920,
      createdAt="2026-08-31T22:44:54.143567Z", updatedAt="2026-09-01T14:31:44.238310Z",
    ),
    ClubDto(
      id="673cb8bf-99ad-4bb3-a4d7-3c508064c737", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Rivas", address="C. de la Fundición, 89, 28522 Rivas-Vaciamadrid, Madrid",
      city="Bilbao", country="ES",
      latitude=40.3471656, longitude=-3.5353533,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ec5ebc0d-5eb1-471f-b135-01987732e40e_photo.jpg",
      averageRating=4.6, totalRatingsCount=2988,
      createdAt="2026-08-31T22:46:32.030244Z", updatedAt="2026-08-31T22:46:32.030244Z",
    ),
    ClubDto(
      id="315610a9-4bec-4523-a9fd-91baa5f1cbc7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADELBAI", address="Etorbidea Santo Domingo Etorbidea, 10, 48160, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.28849, longitude=-2.89052,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/17a59f74-6596-4a14-97b7-8523ba27d286_photo.jpg",
      averageRating=4.5, totalRatingsCount=277,
      createdAt="2026-08-31T22:45:29.628882Z", updatedAt="2026-08-31T22:45:29.628882Z",
    ),
    ClubDto(
      id="2a5a179c-ebde-4562-8bbf-61a2515e93eb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BamVolea Padel Indoor Center", address="Kareaga K., 115, 48903 San Vicente de Barakaldo, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.2890209, longitude=-3.0133429,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ee13fed2-9ef2-469e-aa7a-3aee2d6122b9_photo.jpg",
      averageRating=4.4, totalRatingsCount=622,
      createdAt="2026-08-31T22:45:24.811860Z", updatedAt="2026-09-01T14:31:46.637862Z",
    ),
    ClubDto(
      id="880c5104-ae1a-4df8-8ae6-1ce359db0900", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MIR Racing Villena Circuit - Karting y Motos", address="Ctra. Yecla, 03400 Villena, Alicante",
      city="Bilbao", country="ES",
      latitude=38.6311569, longitude=-0.8920186,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1d4e81ba-fb3d-4ff9-9645-ab736971da4d_photo.jpg",
      averageRating=4.4, totalRatingsCount=1460,
      createdAt="2026-08-31T22:46:37.927655Z", updatedAt="2026-08-31T22:46:37.927655Z",
    ),
    ClubDto(
      id="e9033c44-4acb-42ac-93c0-bddcc093bfa1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo Bilbao", address="Alameda de Recalde, 28, Abando, 48009 Bilbao, Vizcaya",
      city="Bilbao", country="ES",
      latitude=43.264712, longitude=-2.934511,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a09e3085-8e7e-4fcf-aa05-d98eb061e2c7_photo.jpg",
      averageRating=4.3, totalRatingsCount=140,
      createdAt="2026-08-31T22:45:51.530273Z", updatedAt="2026-08-31T22:45:51.530273Z",
    ),
    ClubDto(
      id="69f9368f-8eaf-44f1-880e-2ce4b48036d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Real Club Jolaseta", address="Los Chopos Etorbidea, 18, 48992 Algorta, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.3386383, longitude=-3.0011761,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c12f0049-239a-4ec7-80b2-d0ddb276628b_photo.jpg",
      averageRating=4.3, totalRatingsCount=484,
      createdAt="2026-08-31T22:45:10.092380Z", updatedAt="2026-09-01T14:31:49.377831Z",
    ),
    ClubDto(
      id="0555f02e-e352-4a70-bebf-fc2605f05bd4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Real Nuevo Club Golf Basozabal", address="GOIAZTXIKI / GOIAZTXIKI BIDEA 41, BAJO, 20014 Donostia / San Sebastián, Gipuzkoa",
      city="Bilbao", country="ES",
      latitude=43.2877437, longitude=-1.9646263,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7cf5075f-0cef-4a0d-ac17-fbe83ddd53ae_photo.jpg",
      averageRating=4.3, totalRatingsCount=444,
      createdAt="2026-08-31T22:46:25.804527Z", updatedAt="2026-08-31T22:46:25.804527Z",
    ),
    ClubDto(
      id="8ebfd532-7843-4c81-a0d7-d805c5b3ff98", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Biwak Climbing", address="Astintze Kalea, 4, 48160 Elexalde Derio, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.2902674, longitude=-2.8874876,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/607c030d-cbcd-4f09-9beb-312efcdb5c2c_photo.jpg",
      averageRating=4.2, totalRatingsCount=394,
      createdAt="2026-08-31T22:46:59.757454Z", updatedAt="2026-08-31T22:46:59.757454Z",
    ),
    ClubDto(
      id="13036383-368e-4c8a-88ea-3e3595ac2a3d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Open Air", address="Anton Mendikoa Auzoa, Amorebieta, Caserío Izartza Goikoa, 48340 Amorebieta, Vizcaya",
      city="Bilbao", country="ES",
      latitude=43.2026214, longitude=-2.74655,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/27b394d1-d817-4bc7-8a81-d7fe94ca5835_photo.jpg",
      averageRating=4.2, totalRatingsCount=208,
      createdAt="2026-08-31T22:47:15.827692Z", updatedAt="2026-08-31T22:47:15.827692Z",
    ),
    ClubDto(
      id="7b5f7a5a-0920-4d95-88c3-18daa7307502", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Piugaz Bilbao", address="Olagorta Kalea, 25, Deusto, 48014 Bilbao, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.2720812, longitude=-2.9629882,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/549ba265-ceb6-416a-92a1-f2706fa19661_photo.jpg",
      averageRating=4.2, totalRatingsCount=345,
      createdAt="2026-08-31T22:47:11.549335Z", updatedAt="2026-08-31T22:47:11.549335Z",
    ),
    ClubDto(
      id="600cf58c-bf60-4bb2-91ad-f71f144df4a8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polideportivo Miribilla", address="San Luis Meategiaren Kalea, S/N, Ibaiondo, 48003 Bilbao, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.2527198, longitude=-2.9258089,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1d925e9f-6750-42bb-af9c-feb8ce8f3fff_photo.jpg",
      averageRating=4.2, totalRatingsCount=370,
      createdAt="2026-08-31T22:45:47.165928Z", updatedAt="2026-08-31T22:45:47.165928Z",
    ),
    ClubDto(
      id="fadda4b8-4917-46a4-ba9b-6a5bbc77f908", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Meaztegi Golf Club", address="Carretera Triano a La Arboleda, s/n, 48530, Vizcaya",
      city="Bilbao", country="ES",
      latitude=43.288304, longitude=-3.062932,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77501476-36c3-4663-a8e4-6df0dd724f68_photo.jpg",
      averageRating=4.1, totalRatingsCount=938,
      createdAt="2026-08-31T22:46:21.412698Z", updatedAt="2026-08-31T22:46:21.412698Z",
    ),
    ClubDto(
      id="9c09f910-d14f-4b94-9059-2ed90cc7c8fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pabellón La Casilla", address="Etxetxua Plaza, 11, Errekalde, 48012 Bilbao, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.2567006, longitude=-2.943647,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d68d6d1f-7117-430a-b17b-eeb0d9f4d44f_photo.jpg",
      averageRating=4.1, totalRatingsCount=2023,
      createdAt="2026-08-31T22:45:01.327259Z", updatedAt="2026-08-31T22:45:01.327259Z",
    ),
    ClubDto(
      id="1e3fbb7b-fda6-4041-b201-dad649583603", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="San Ignazio Sports Centre", address="Arturo Campión Kalea, 8, Deusto, 48015 Bilbao, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.279986, longitude=-2.9601274,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f5f0eaef-c510-491d-b8e1-6dd7f2e8dd32_photo.jpg",
      averageRating=4.1, totalRatingsCount=920,
      createdAt="2026-08-31T22:44:38.947882Z", updatedAt="2026-08-31T22:44:38.947882Z",
    ),
    ClubDto(
      id="19ca5874-43e8-404f-958d-64328f0b17e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo de futbol de Mallona", address="Mallona Zeharkalea, Ibaiondo, 48006 Bilbao, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.2609251, longitude=-2.9199309,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9003f002-67c4-4296-b657-f3a8d1d539af_photo.jpg",
      averageRating=4.0, totalRatingsCount=593,
      createdAt="2026-08-31T22:44:47.637059Z", updatedAt="2026-08-31T22:44:47.637059Z",
    ),
    ClubDto(
      id="6c1ab72e-5e56-476a-87d5-cb1cf804eedc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Roseta Futbol Zelaia", address="Parque San Antonio Iturrigorri, s/n, Errekalde, 48002 Bilbao, Vizcaya",
      city="Bilbao", country="ES",
      latitude=43.2439679, longitude=-2.9445939,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8ea427e8-14e0-4f5b-864f-2525e749f1e9_photo.jpg",
      averageRating=4.0, totalRatingsCount=602,
      createdAt="2026-08-31T22:44:42.611968Z", updatedAt="2026-08-31T22:44:42.611968Z",
    ),
    ClubDto(
      id="6028abe8-b8c7-4222-bd30-c340ce3ef650", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polideportivo Atxuri", address="Parque Encarnación, s/n, Ibaiondo, 48006 Bilbao, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.2530208, longitude=-2.9199644,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3369e0c4-5e47-4377-91b6-9b80685f10bb_photo.jpg",
      averageRating=4.0, totalRatingsCount=458,
      createdAt="2026-08-31T22:45:17.568062Z", updatedAt="2026-08-31T22:45:17.568062Z",
    ),
    ClubDto(
      id="9b2efdd5-efd0-4b7f-bfa8-aecef3afa63e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BrincoZone", address="CC Ballonti, Av. Ballonti, 1, Local B9, 48920 Portugalete, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.3111254, longitude=-3.0215634,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/309c2152-f4bb-4f00-9f4e-be394876e86b_photo.jpg",
      averageRating=3.9, totalRatingsCount=210,
      createdAt="2026-08-31T22:46:42.215183Z", updatedAt="2026-08-31T22:46:42.215183Z",
    ),
    ClubDto(
      id="6ad5e8fd-2748-4b57-9b35-87d8edcb6284", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Errekaldeko Kiroldegia", address="Carretera Errekalde Larraskitu, 53, Errekalde, 48003 Bilbao, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.2457398, longitude=-2.9367801,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/947afe54-b4bf-406e-b8e0-8ef520a03e80_photo.jpg",
      averageRating=3.9, totalRatingsCount=1209,
      createdAt="2026-08-31T22:44:31.211Z", updatedAt="2026-08-31T22:44:31.211Z",
    ),
    ClubDto(
      id="8a869b37-7b43-47fd-b743-51f5d7bc4963", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Txurdinagako Kiroldegia", address="Circo Amateur del Club Deportivo Kalea, 2, 48004 Bilbao, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.2501671, longitude=-2.9076685,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ef2a64af-5d06-49ef-9373-68e5e9819d81_photo.jpg",
      averageRating=3.9, totalRatingsCount=1618,
      createdAt="2026-08-31T22:44:24.615741Z", updatedAt="2026-08-31T22:44:24.615741Z",
    ),
    ClubDto(
      id="50333086-af89-4eb2-961e-5a407ca37fc2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pádel Derio Club", address="Larrauri Kalea, 1, 48160 Elexalde Derio, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.294, longitude=-2.8796484,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c3fc613a-e59b-49f0-87a4-8a623633de69_photo.jpg",
      averageRating=3.7, totalRatingsCount=252,
      createdAt="2026-08-31T22:45:34.955508Z", updatedAt="2026-08-31T22:45:34.955508Z",
    ),
    ClubDto(
      id="8e89022f-2d90-4ba5-9cc5-e98dacf7c57c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Sunrise Beach Volley Alicante", address="Av. Jaime I el Conquistador, 150, 03560 El Campello, Alicante",
      city="Bilbao", country="ES",
      latitude=38.389956, longitude=-0.4079318,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a5b749fc-6c33-4108-822f-291a43d2fb8e_photo.jpg",
      averageRating=4.8, totalRatingsCount=25,
      createdAt="2026-08-31T22:46:16.161352Z", updatedAt="2026-08-31T22:46:16.161352Z",
    ),
    ClubDto(
      id="c5aac2a9-01f3-409f-bc2e-6f5273b50df4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Saskibaloi-zelaia", address="Evaristo Churruca Kaia, 1 48001, Abando, 48001 Bilbao, Bizkaia",
      city="Bilbao", country="ES",
      latitude=43.267967, longitude=-2.9429023,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a40194a1-6ef0-47e2-acda-5a5bb1402f51_photo.jpg",
      averageRating=3.9, totalRatingsCount=14,
      createdAt="2026-08-31T22:46:02.078612Z", updatedAt="2026-08-31T22:46:02.078612Z",
    ),
  )),
  CitySeo(slug="berlin", name="Berlin", country="DE", clubCount=27, sports=listOf(Pair("Volleyball", 4), Pair("Basketball", 3), Pair("Padel", 3), Pair("Tennis", 3), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Paintball", 2), Pair("Football", 2), Pair("Table Tennis", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="4cbc8d5b-59c5-4a3a-a68b-01a9935d110a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Virtual Lasertag / Paintball Berlin - VR Arcade", address="Mauerstraße 78, 10117 Berlin",
      city="Berlin", country="DE",
      latitude=52.5093286, longitude=13.388102,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d72a98cd-b1fe-4d87-aa14-5f6c1771b316_ChIJlwcIjk1R_0.jpg",
      averageRating=4.9, totalRatingsCount=152,
      createdAt="2026-08-30T21:07:50.091751Z", updatedAt="2026-08-30T21:07:50.091751Z",
    ),
    ClubDto(
      id="e812eead-b24b-4f9f-aed1-9756d244c32c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="mitte — charlotte | Boutique Padel Club", address="Sophie-Charlotten-Straße 14, 14059 Berlin",
      city="Berlin", country="DE",
      latitude=52.5201992, longitude=13.2852226,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c62148d6-1b94-4c3a-911d-4f81448c0f2e_ChIJsw1iPgBR_0.jpg",
      averageRating=4.9, totalRatingsCount=975,
      createdAt="2026-08-30T21:08:04.311659Z", updatedAt="2026-08-30T21:08:04.311659Z",
    ),
    ClubDto(
      id="410a183d-2e8a-429b-b29f-8d8541aaf286", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ding Dong Ping Pong GmbH", address="Prenzlauer Allee 38, 10405 Berlin",
      city="Berlin", country="DE",
      latitude=52.5350441, longitude=13.4221898,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6534c6e3-09e6-438d-bcf0-1fed36fb34ca_photo.jpg",
      averageRating=4.8, totalRatingsCount=181,
      createdAt="2026-08-31T15:25:21.569684Z", updatedAt="2026-08-31T15:25:21.569684Z",
    ),
    ClubDto(
      id="3d87cd02-71cc-4e90-920e-b5420101b38f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ID-Paintball Shop", address="Romain-Rolland-Straße 14-24, 13089 Berlin-Bezirk Pankow",
      city="Berlin", country="DE",
      latitude=52.565177, longitude=13.4455929,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5b6703d2-ebf0-4d21-ac07-f3df85d1ceb0_ChIJ45n2G5JN_0.jpg",
      averageRating=4.8, totalRatingsCount=514,
      createdAt="2026-08-30T21:07:42.810740Z", updatedAt="2026-08-30T21:07:42.810740Z",
    ),
    ClubDto(
      id="0b624bcb-e138-4ae8-872f-4db9d9cc536b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Berlin", address="Wiesenweg 1-4, 10365 Berlin-Bezirk Lichtenberg",
      city="Berlin", country="DE",
      latitude=52.507804, longitude=13.4740868,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/66ce2735-9237-463c-be51-0786506c976c_ChIJXxVRh_FO_0.jpg",
      averageRating=4.8, totalRatingsCount=434,
      createdAt="2026-08-30T21:08:11.649764Z", updatedAt="2026-08-30T21:58:57.718721Z",
    ),
    ClubDto(
      id="4f6d5214-1446-44b6-b9c8-4713bb4bac27", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport 365 Community", address="Kreuzberg, 10999 Berlin",
      city="Berlin", country="DE",
      latitude=52.4974932, longitude=13.4361273,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/66290efd-c333-4669-9f8d-044b4a7248cd_photo.jpg",
      averageRating=4.8, totalRatingsCount=322,
      createdAt="2026-08-31T15:24:21.386860Z", updatedAt="2026-08-31T15:24:21.386860Z",
    ),
    ClubDto(
      id="7b6e89da-a383-41da-ae52-bb24cf41b193", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach 61 Outdoor Beachvolleyball", address="Park am Gleisdreieck, 10965 Berlin",
      city="Berlin", country="DE",
      latitude=52.4960933, longitude=13.3719352,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7bfd0d95-153a-4371-9934-93a8a536e830_photo.jpg",
      averageRating=4.6, totalRatingsCount=826,
      createdAt="2026-08-31T15:24:28.972350Z", updatedAt="2026-08-31T15:24:28.972350Z",
    ),
    ClubDto(
      id="8fc7b735-cca2-4f0b-804c-823138247dc3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Berta Block", address="Mühlenstraße 62, 13187 Berlin",
      city="Berlin", country="DE",
      latitude=52.5636824, longitude=13.4099068,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2264fd8e-55e9-4afd-bbe1-d624e399ce8c_ChIJI7Yo2xJS_0.jpg",
      averageRating=4.6, totalRatingsCount=2993,
      createdAt="2026-08-30T21:07:16.383485Z", updatedAt="2026-08-30T21:55:28.582321Z",
    ),
    ClubDto(
      id="ea8c78d2-3e01-4b9c-8770-99fff4ce2311", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketball Court", address="Am Friedrichshain 9, 10407 Berlin-Bezirk Friedrichshain-Kreuzberg",
      city="Berlin", country="DE",
      latitude=52.5286911, longitude=13.4327562,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/beaaad18-df7d-445b-ac11-20ea6a1d29e3_photo.jpg",
      averageRating=4.5, totalRatingsCount=68,
      createdAt="2026-08-31T15:24:01.960013Z", updatedAt="2026-08-31T15:24:01.960013Z",
    ),
    ClubDto(
      id="9edf5cbe-19c7-47c6-a4a3-8b52fc8518e7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BeachMitte", address="Caroline-Michaelis-Straße 8, 10115 Berlin",
      city="Berlin", country="DE",
      latitude=52.5331828, longitude=13.3849394,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/55454a40-4699-47d8-be4b-eab07853a36c_ChIJPZloRe1R_0.jpg",
      averageRating=4.5, totalRatingsCount=3248,
      createdAt="2026-08-30T21:07:56.710120Z", updatedAt="2026-08-30T21:55:26.004890Z",
    ),
    ClubDto(
      id="16e8999b-6284-4420-b87e-b588a56e5c2a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billard House Friedrichshain", address="Rudolfstraße 4, 10245 Berlin",
      city="Berlin", country="DE",
      latitude=52.504698, longitude=13.4513354,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a191f753-88ee-4269-bb9c-1b008f88505e_ChIJnf61mFBO_0.jpg",
      averageRating=4.5, totalRatingsCount=1442,
      createdAt="2026-08-30T21:06:49.351152Z", updatedAt="2026-08-30T21:06:49.351152Z",
    ),
    ClubDto(
      id="3db6487d-d922-4f0e-8b22-0c3525efa945", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="East61 Indoor Beachvolleyball", address="Wilhelm-Kabus-Straße 42, 10829 Berlin",
      city="Berlin", country="DE",
      latitude=52.4818448, longitude=13.3640401,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67a6b6bf-e8db-4936-860e-28046148f06b_photo.jpg",
      averageRating=4.5, totalRatingsCount=626,
      createdAt="2026-08-31T15:24:37.579592Z", updatedAt="2026-08-31T15:24:37.579592Z",
    ),
    ClubDto(
      id="0447b64a-f468-4dbf-8537-8c577f0b7be5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Zentrum Berlin auf der Trabrennbahn Berlin Mariendorf", address="Hirzerweg 51, 12107 Berlin",
      city="Berlin", country="DE",
      latitude=52.4297803, longitude=13.3874087,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/74747b60-6a40-404d-a111-79c90e6099fc_photo.jpg",
      averageRating=4.4, totalRatingsCount=97,
      createdAt="2026-08-31T15:25:15.065245Z", updatedAt="2026-08-31T15:25:15.065245Z",
    ),
    ClubDto(
      id="ccc1098d-9043-4f69-ae03-8621497b60f2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MOBIKART Fun Racing GmbH", address="Bornitzstraße 106, 10365 Berlin",
      city="Berlin", country="DE",
      latitude=52.5200711, longitude=13.4974965,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/37211e2b-eeec-43cf-90f8-7c385cb829ff_ChIJ0Q59bBdM_0.jpg",
      averageRating=4.4, totalRatingsCount=1413,
      createdAt="2026-08-30T21:07:23.034112Z", updatedAt="2026-08-30T21:07:23.034112Z",
    ),
    ClubDto(
      id="b36d7402-15fc-4e89-a158-d5361d63f0ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paule's Metall- Eck UG", address="Krossener Str. 15, 10245 Berlin-Bezirk Friedrichshain-Kreuzberg",
      city="Berlin", country="DE",
      latitude=52.5107001, longitude=13.4568162,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/869e2491-a67e-46bd-9f7a-08bece8feba9_ChIJp9VTul5O_0.jpg",
      averageRating=4.4, totalRatingsCount=2383,
      createdAt="2026-08-30T21:06:42.724050Z", updatedAt="2026-08-30T21:06:42.724050Z",
    ),
    ClubDto(
      id="0da114fc-35b0-4bdf-9183-2b59e98966e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportforum Hohenschönhausen", address="Weißenseer Weg 53, 13053 Berlin",
      city="Berlin", country="DE",
      latitude=52.5400262, longitude=13.4771251,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fbc8b5de-32f5-4571-aece-9a7bc902f707_ChIJ74yLVdNN_0.jpg",
      averageRating=4.4, totalRatingsCount=2892,
      createdAt="2026-08-30T21:06:21.667316Z", updatedAt="2026-08-30T21:06:21.667316Z",
    ),
    ClubDto(
      id="ae6b3a49-b622-46e0-9795-35ed762a464c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TCW Tenniscenter GmbH Tennisanlagen", address="Roelckestraße 105, 13088 Berlin-Bezirk Pankow",
      city="Berlin", country="DE",
      latitude=52.5649858, longitude=13.4595533,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b671dd5b-7eea-4e97-b23f-79f8907a8758_ChIJm7BjfJVN_0.jpg",
      averageRating=4.4, totalRatingsCount=364,
      createdAt="2026-08-30T21:08:19.030183Z", updatedAt="2026-08-30T21:08:19.030183Z",
    ),
    ClubDto(
      id="e204d8f0-e4e7-4893-9bcc-b2b93c59b1c1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis-Club 1899 e.V. Blau-Weiss", address="Waldmeisterstraße 10-20, 14193 Berlin-Bezirk Charlottenburg-Wilmersdorf",
      city="Berlin", country="DE",
      latitude=52.4763815, longitude=13.273487,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/58dde878-732d-4d97-899a-9b354272d5a5_ChIJ6W1L0qhQ_0.jpg",
      averageRating=4.4, totalRatingsCount=314,
      createdAt="2026-08-30T21:08:26.435730Z", updatedAt="2026-08-30T22:01:30.726528Z",
    ),
    ClubDto(
      id="0a0a40b2-98a4-4d70-ae01-4bfb504e90a0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Resort Berlin Pankow GmbH", address="Blankenburger Pflasterweg 40, 13129 Berlin-Bezirk Pankow",
      city="Berlin", country="DE",
      latitude=52.5843848, longitude=13.4693868,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d4f28db1-4b0f-494f-b965-77749e404d20_photo.jpg",
      averageRating=4.3, totalRatingsCount=579,
      createdAt="2026-08-31T15:25:05.686100Z", updatedAt="2026-08-31T15:25:05.686100Z",
    ),
    ClubDto(
      id="70fba22d-7d22-47e2-9f58-d035c6a955e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KANGAROO'S LAND Bowling Berlin", address="Hansastraße 236, 13051 Berlin-Bezirk Lichtenberg",
      city="Berlin", country="DE",
      latitude=52.5611181, longitude=13.5000115,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eb91dfac-5ca7-4bbd-9f0f-e3f3bb428995_ChIJDZIseE9M_0.jpg",
      averageRating=4.3, totalRatingsCount=2322,
      createdAt="2026-08-30T21:06:55.707957Z", updatedAt="2026-08-30T21:06:55.707957Z",
    ),
    ClubDto(
      id="a50f9f76-e198-4e86-a076-9f98badbc682", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Urban Sports Club", address="Novalisstraße 10, 10115 Berlin",
      city="Berlin", country="DE",
      latitude=52.5288614, longitude=13.3875332,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/02eac5c7-eda8-43e9-882b-d29c6a729104_ChIJecAmki1O_0.jpg",
      averageRating=4.3, totalRatingsCount=8071,
      createdAt="2026-08-30T21:07:09.395498Z", updatedAt="2026-08-30T21:07:09.395498Z",
    ),
    ClubDto(
      id="866150d0-317b-4fff-8469-ca281d40660c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lawn-Tennis-Turnier-Club \"Rot-Weiß\" e.V. vorstand", address="Gottfried-von-Cramm-Weg 47-55, 14193 Berlin-Bezirk Charlottenburg-Wilmersdorf",
      city="Berlin", country="DE",
      latitude=52.4844872, longitude=13.2592041,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6de72631-0eb5-43ed-a400-5c1880846fc6_ChIJ4aEI8k1X_0.jpg",
      averageRating=4.2, totalRatingsCount=217,
      createdAt="2026-08-30T21:08:33.783279Z", updatedAt="2026-08-30T21:58:25.092422Z",
    ),
    ClubDto(
      id="d9af566e-cd18-48d5-b337-10eb214324e3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kickerworld Berlin Spandau", address="Kleine Eiswerderstraße 1, 13599 Berlin-Bezirk Spandau",
      city="Berlin", country="DE",
      latitude=52.5489035, longitude=13.2266492,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7356c844-9477-40a3-9d70-224a44728385_ChIJ10Hq42NW_0.jpg",
      averageRating=4.1, totalRatingsCount=1172,
      createdAt="2026-08-30T21:06:35.568373Z", updatedAt="2026-08-30T21:57:32.712457Z",
    ),
    ClubDto(
      id="2b1bedd0-cd32-4c2d-b5d5-c7a8a2b51855", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling World Berlin", address="Uber Platz / beim UCI Kinoeingang / 1.OG, Mildred-Harnack-Straße 13, 10243 Berlin",
      city="Berlin", country="DE",
      latitude=52.5053342, longitude=13.4417382,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83901a0f-4c47-4ceb-a440-f4ce2232175e_ChIJh8l8ekFP_0.jpg",
      averageRating=4.0, totalRatingsCount=2079,
      createdAt="2026-08-30T21:07:02.999583Z", updatedAt="2026-08-30T21:55:53.030380Z",
    ),
    ClubDto(
      id="07b82700-ebd7-4cfd-a1c8-0bd115ad09a3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Funkhaus Beach", address="Köpenicker Ch 11-14, 10317 Berlin",
      city="Berlin", country="DE",
      latitude=52.4861659, longitude=13.4972218,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/65eddd1a-e6da-4b5b-948f-16ce56ddf77c_photo.jpg",
      averageRating=4.0, totalRatingsCount=53,
      createdAt="2026-08-31T15:24:52.150705Z", updatedAt="2026-08-31T15:24:52.150705Z",
    ),
    ClubDto(
      id="235aef28-ef8d-4734-8c8c-06630da3c209", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Berlin Beachvolleyball – Kurse, Camps & Training", address="Schünemannweg 25A, 12247 Berlin-Bezirk Steglitz-Zehlendorf",
      city="Berlin", country="DE",
      latitude=52.4440437, longitude=13.3515752,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8f321167-e5b4-4df9-9924-6ddc60c04ec9_photo.jpg",
      averageRating=5.0, totalRatingsCount=31,
      createdAt="2026-08-31T15:24:45.171650Z", updatedAt="2026-08-31T15:24:45.171650Z",
    ),
    ClubDto(
      id="6bf423fb-242f-4e8e-9363-a46ec02c2836", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketball Court", address="Str. am Schoelerpark 30, 10715 Berlin-Bezirk Charlottenburg-Wilmersdorf",
      city="Berlin", country="DE",
      latitude=52.4835264, longitude=13.3255694,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c10510fe-d530-4e98-ad0e-baf2de67c7f0_photo.jpg",
      averageRating=3.9, totalRatingsCount=30,
      createdAt="2026-08-31T15:24:11.407067Z", updatedAt="2026-08-31T15:24:11.407067Z",
    ),
  )),
  CitySeo(slug="kyiv", name="Kyiv", country="UA", clubCount=27, sports=listOf(Pair("Football", 4), Pair("Tennis", 3), Pair("Billiards", 2), Pair("Padel", 2), Pair("Volleyball", 2), Pair("Basketball", 2), Pair("Paintball", 2), Pair("Climbing", 2), Pair("Karting", 2), Pair("Table Tennis", 2), Pair("Laser Tag", 2), Pair("Bowling", 1), Pair("Golf", 1)), clubs=listOf(
    ClubDto(
      id="ea88aa8a-a378-4371-8f23-db800b04ba96", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг (лазерні бої) Перший Легіон в DREAM berry", address="Оболонський проспект, 21Б ТРЦ DREAM berry (2, 1st Legion\"®, й поверх, Київ, 02000 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.5168343, longitude=30.4986592,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5541015c-d1d0-4ab0-bb4c-3e8fc80b8016_ChIJP6Ee6OnT_0.jpg",
      averageRating=5.0, totalRatingsCount=1789,
      createdAt="2026-08-30T17:05:42.421228Z", updatedAt="2026-08-30T20:52:36.900561Z",
    ),
    ClubDto(
      id="418dfb2c-a10f-4e32-a326-2998087d5bc0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг G-75", address="Obolonskiy Avenue, 1Б Dream yellow, 1, третій поверх, Київ, 04205 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.5076171, longitude=30.4983592,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06b726d0-1fa9-4b03-b836-cdd5415971c2_ChIJq0NaiILT_0.jpg",
      averageRating=5.0, totalRatingsCount=2014,
      createdAt="2026-08-30T17:05:34.943066Z", updatedAt="2026-08-30T20:52:37.035099Z",
    ),
    ClubDto(
      id="4b91bac6-4cfd-4e2c-b836-3bdeff21fadc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбол клуб GANZ в Києві (ВДНГ)", address="просп. Академіка Глушкова, 1, п21, Kyiv, 03680 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.3772128, longitude=30.4864299,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/de400b67-0ae0-47e0-b324-d8b31a2489a9_ChIJk9T5Q_rJ_0.jpg",
      averageRating=4.9, totalRatingsCount=1069,
      createdAt="2026-08-30T17:05:57.923113Z", updatedAt="2026-08-30T20:52:42.380427Z",
    ),
    ClubDto(
      id="617125d6-fa78-4f08-b5db-02f73cbab0e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="СЕТ - пляжний волейбол та теніс на піску з підігрівом. Піклбол Київ", address="проспект Степана Бандери, Київ, 02000",
      city="Kyiv", country="UA",
      latitude=50.5009012, longitude=30.5482398,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1f26a87-39c3-4ff7-b65a-4261a664a818_photo.jpg",
      averageRating=4.9, totalRatingsCount=201,
      createdAt="2026-08-31T15:10:00.152882Z", updatedAt="2026-08-31T15:10:00.152882Z",
    ),
    ClubDto(
      id="6053f16c-2a27-432d-927f-6f89a787a6fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скеледром Цех", address="вул. Борщагівська 154 ТРЦ Мармелад, 6-й поверх, Київ, 03056 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.4464144, longitude=30.4428245,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/137cc8ce-0a8f-4c4a-bb23-7710f1168b3e_ChIJdwNZ2tPN_0.jpg",
      averageRating=4.8, totalRatingsCount=641,
      createdAt="2026-08-30T17:05:04.584539Z", updatedAt="2026-08-30T20:52:46.903813Z",
    ),
    ClubDto(
      id="219f878e-d8c9-455b-892a-d9071870844d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг-центр INGUL KART", address="ТРЦ Атмосфера, Столичне шосе, 103, Київ, 02000",
      city="Kyiv", country="UA",
      latitude=50.3409805, longitude=30.551752,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d75ed624-57b3-4c8c-a217-d6d74a026bb4_photo.png",
      averageRating=4.7, totalRatingsCount=1291,
      createdAt="2026-08-31T15:10:16.810277Z", updatedAt="2026-08-31T15:10:16.810277Z",
    ),
    ClubDto(
      id="12d2d4e6-0a2e-421d-9967-79b9a202d6e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Buffalo", address="вул. Ревуцького, 46, Київ, 02140 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.3947593, longitude=30.6524129,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b1d5a4fd-8548-41f3-a7e5-2029db86ad27_ChIJmfwT6FrE_0.jpg",
      averageRating=4.6, totalRatingsCount=919,
      createdAt="2026-08-30T17:04:35.243335Z", updatedAt="2026-08-30T20:52:08.910884Z",
    ),
    ClubDto(
      id="ed99e6e2-9dcc-4087-9021-b88435723e8f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="REJO-ВДНГ", address="проспект Академіка Глушкова, 1, Київ, 03127 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.3717705, longitude=30.4764401,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7cc710c4-7932-4f0b-b937-e1e5665a538b_ChIJq6rqYu7I_0.jpg",
      averageRating=4.6, totalRatingsCount=634,
      createdAt="2026-08-30T17:04:27.691608Z", updatedAt="2026-08-30T20:52:21.299147Z",
    ),
    ClubDto(
      id="95b09485-ac69-4db7-96f9-419921c8f075", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Гепард", address="50.739999, 30.663358, Pirnove, 07342 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.7397504, longitude=30.6632391,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bdd90968-a146-4655-bc5f-e0715ed7cf33_ChIJoUIzjZwt_0.jpg",
      averageRating=4.6, totalRatingsCount=1775,
      createdAt="2026-08-30T17:05:50.403626Z", updatedAt="2026-08-30T20:52:29.876312Z",
    ),
    ClubDto(
      id="1be6e03f-3a7d-4640-b3b3-4ee5c4451a07", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Гіперіон Скеледром", address="вулиця Кирилівська, 46, Київ, 02000 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.4734102, longitude=30.4979936,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/37ef78a0-7336-4b5d-81af-da97a686d307_ChIJIaKCYQvO_0.jpg",
      averageRating=4.6, totalRatingsCount=521,
      createdAt="2026-08-30T17:05:12.531994Z", updatedAt="2026-08-30T20:52:30.005330Z",
    ),
    ClubDto(
      id="db3b092d-aeeb-4115-99e7-038445047d35", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісна Арена", address="проспект Повітряних Сил, 63, Київ, 02000 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.4141951, longitude=30.4469503,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc82d2ac-2471-46dd-ac5d-5e16ff958954_ChIJ45hHkUvJ_0.jpg",
      averageRating=4.6, totalRatingsCount=325,
      createdAt="2026-08-30T17:06:59.610440Z", updatedAt="2026-08-30T20:52:51.316899Z",
    ),
    ClubDto(
      id="d99892f4-f115-41fd-ae94-1916d6687aea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="DREAM yellow", address="Оболонський проспект, 1Б, Київ, 04205 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.5073525, longitude=30.4984281,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/02cfedae-2a5f-49ca-ae4b-6afed6a72ecf_ChIJcZlrpBPS_0.jpg",
      averageRating=4.5, totalRatingsCount=35313,
      createdAt="2026-08-30T17:04:57.158959Z", updatedAt="2026-08-30T20:52:12.128735Z",
    ),
    ClubDto(
      id="2ed002c3-a6ac-4f18-b6e8-02ad2bbc62a9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Elit Courts", address="8JGX+WR2, Гнідин, 08340 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.3273125, longitude=30.6495625,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cd381f3d-3ae8-48d8-9b93-33606a4d6239_ChIJ8bRG2Z_B_0.jpg",
      averageRating=4.5, totalRatingsCount=84,
      createdAt="2026-08-30T17:06:29.877395Z", updatedAt="2026-09-01T14:31:57.312705Z",
    ),
    ClubDto(
      id="e0428277-4c0b-4121-8885-70f155d2ab8d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг-центр Жага Швидкості", address="проспект Академіка Глушкова, 9, Київ, 03127",
      city="Kyiv", country="UA",
      latitude=50.3733171, longitude=30.4651257,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fe0008c1-0b28-4013-9de6-cd2be6e0401c_photo.jpg",
      averageRating=4.5, totalRatingsCount=1443,
      createdAt="2026-08-31T15:10:24.165530Z", updatedAt="2026-08-31T15:10:24.165530Z",
    ),
    ClubDto(
      id="029afb27-87cd-457d-bb09-7001382a4b91", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Локомотив", address="Стадіонний провулок, 10/2, Київ, 03049 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.437989, longitude=30.481698,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9adf7e3e-c700-429d-9372-663e59a95ea5_ChIJa4fcaZPO_0.jpg",
      averageRating=4.5, totalRatingsCount=705,
      createdAt="2026-08-30T17:04:18.870651Z", updatedAt="2026-08-30T20:52:38.789581Z",
    ),
    ClubDto(
      id="83aa1716-e214-4f31-a42d-36dc8431d7e5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Настільний теніс", address="вулиця Анни Ахматової, 30, Київ, 02000 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.4087625, longitude=30.622653,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c764458b-fda5-484c-8ac2-44a28eeeb84e_ChIJCQ3vcabF_0.jpg",
      averageRating=4.5, totalRatingsCount=242,
      createdAt="2026-08-30T17:06:05.771023Z", updatedAt="2026-08-30T20:52:40.455545Z",
    ),
    ClubDto(
      id="2dc87d4d-3517-4ca8-85e8-139138f5cde8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Український тенісний центр", address="Господарська вул., 1, вулиця Центральна, 54, Святопетрівське, 08141 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.387598, longitude=30.3123877,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7584648-bf19-46e7-8c15-5bce53e3627f_ChIJAc91ymDK_0.jpg",
      averageRating=4.5, totalRatingsCount=492,
      createdAt="2026-08-30T17:06:44.884211Z", updatedAt="2026-08-30T20:52:52.774268Z",
    ),
    ClubDto(
      id="03f2e1cc-8686-4fdb-96cc-4a6512318068", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="REJO- Політ", address="проспект Повітряних Сил, 80, Київ, 03151 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.4156879, longitude=30.4448187,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f7aad339-6ef4-419d-a92b-3f643939ff8c_ChIJZSnxaEzJ_0.jpg",
      averageRating=4.4, totalRatingsCount=957,
      createdAt="2026-08-30T17:04:04.010118Z", updatedAt="2026-08-30T20:52:21.177546Z",
    ),
    ClubDto(
      id="f7c87f63-2369-4d2c-b038-573124cf70b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="RSP KYOTO", address="вулиця Кіото, 25, Київ, 02156 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.468188, longitude=30.6465004,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6ea01daf-133c-4ea9-8ed9-7dd339e8b42e_ChIJhwOYGkHb_0.jpg",
      averageRating=4.4, totalRatingsCount=50,
      createdAt="2026-08-30T17:06:37.603513Z", updatedAt="2026-08-30T20:52:21.526040Z",
    ),
    ClubDto(
      id="a496de02-0f85-4ed4-876b-1fd7d1655da0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sunrise - Beach Sports Academy", address="FH2H+QQ, Київ, 02000",
      city="Kyiv", country="UA",
      latitude=50.4517262, longitude=30.5782842,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5dd22425-f358-4893-a3a3-956c27cfddc1_photo.jpg",
      averageRating=4.4, totalRatingsCount=77,
      createdAt="2026-08-31T15:09:53.620003Z", updatedAt="2026-08-31T15:09:53.620003Z",
    ),
    ClubDto(
      id="ada25b8d-77ea-44ca-a5cd-55344e61ebbf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Авангард", address="вулиця Юрія Іллєнка, 46, Київ, 04119",
      city="Kyiv", country="UA",
      latitude=50.4733542, longitude=30.4560475,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c644927f-0c25-4218-86d7-87c580ca7b09_photo.jpg",
      averageRating=4.4, totalRatingsCount=240,
      createdAt="2026-08-31T15:09:46.579467Z", updatedAt="2026-08-31T15:09:46.579467Z",
    ),
    ClubDto(
      id="081b5c90-b49f-4a69-8769-ab39c9bcca97", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Футбольное поле манеж аренда Киев стадiон «Спартак».", address="вулиця Кирилівська, 105, Київ, 04080 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.4823399, longitude=30.4756294,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4ae8e567-7e01-4863-a624-d4d5778f2d68_ChIJhwmDMOnN_0.jpg",
      averageRating=4.4, totalRatingsCount=783,
      createdAt="2026-08-30T17:04:10.787970Z", updatedAt="2026-08-30T20:52:53.672340Z",
    ),
    ClubDto(
      id="bd61e333-eee0-44d0-ad68-16fcfe7c69de", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Weekend", address="вулиця Казимира Малевича, 107, Київ, 02000 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.4163899, longitude=30.5191441,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e0609b77-4218-4336-818d-9c947c23aa69_ChIJOXFcxjzP_0.jpg",
      averageRating=4.3, totalRatingsCount=804,
      createdAt="2026-08-30T17:04:41.361545Z", updatedAt="2026-08-30T20:52:25.296343Z",
    ),
    ClubDto(
      id="a10c5d85-3a2c-48bf-b660-95bff8c926c6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Клуб настольного тенниса", address="вулиця Солом'янська, 14, Київ, 02000 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.4248532, longitude=30.4770696,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/28abaeff-fa95-427a-bff2-8d3718a550a0_ChIJI5A7g8bO_0.jpg",
      averageRating=4.3, totalRatingsCount=192,
      createdAt="2026-08-30T17:06:12.832739Z", updatedAt="2026-08-30T20:52:34.367310Z",
    ),
    ClubDto(
      id="8b1fab46-c700-4b21-bfb6-d1331c7fa9ff", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Палац спорту «Венето-Sport»", address="вулиця Героїв Севастополя, 11В, Київ, 03124",
      city="Kyiv", country="UA",
      latitude=50.4413767, longitude=30.4197831,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/630b748e-1977-4421-8e2f-bd8e2b3638be_photo.jpg",
      averageRating=4.3, totalRatingsCount=1255,
      createdAt="2026-08-31T15:09:40.278162Z", updatedAt="2026-08-31T15:09:40.278162Z",
    ),
    ClubDto(
      id="34d8cb91-79b3-4224-94fa-615429c2e832", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Корти на Подолі", address="вулиця Межигірська, 56/63А, Київ, 04071 Kyiv, Ukraine",
      city="Kyiv", country="UA",
      latitude=50.4723093, longitude=30.505881,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b9bc693f-8fd1-4621-abf1-e02f61c5216c_ChIJlUUAghLO_0.jpg",
      averageRating=4.2, totalRatingsCount=416,
      createdAt="2026-08-30T17:06:52.763252Z", updatedAt="2026-08-30T20:52:35.395391Z",
    ),
    ClubDto(
      id="c799391c-b703-4e99-bb69-11285d6bc58e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lisnyky Golf&Villas", address="вулиця Вишнева, 36, Лісники, Київська область, 08172",
      city="Kyiv", country="UA",
      latitude=50.3143578, longitude=30.5167626,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eda1928d-cd75-460c-957e-ea006205c6d7_photo.jpg",
      averageRating=4.9, totalRatingsCount=17,
      createdAt="2026-08-31T15:10:08.929356Z", updatedAt="2026-08-31T15:10:08.929356Z",
    ),
  )),
  CitySeo(slug="sevilla", name="Sevilla", country="ES", clubCount=27, sports=listOf(Pair("Football", 4), Pair("Tennis", 3), Pair("Padel", 3), Pair("Basketball", 3), Pair("Volleyball", 2), Pair("Table Tennis", 2), Pair("Golf", 2), Pair("Bowling", 2), Pair("Paintball", 2), Pair("Karting", 1), Pair("Laser Tag", 1), Pair("Climbing", 1), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="555650cf-c2e0-4ffd-b116-91f1a297bd8a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MOVE Climbing", address="C. Artesanía, 21, 41927 Mairena del Aljarafe, Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3576772, longitude=-6.0557999,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/687520b8-86ce-497c-9249-c8674af51980_photo.jpg",
      averageRating=4.9, totalRatingsCount=253,
      createdAt="2026-08-31T22:41:23.734097Z", updatedAt="2026-08-31T22:41:23.734097Z",
    ),
    ClubDto(
      id="5ce15048-8b7d-44b4-84b1-54c2ccac8ec8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Sevilla FriendlyFire", address="La Hacienda de Orán Ctra, A-8029, KM 7, 41710 Utrera, Sevilla",
      city="Sevilla", country="ES",
      latitude=37.1989821, longitude=-5.8729518,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11a07808-f874-4e21-b999-b1bf105a783d_photo.jpg",
      averageRating=4.9, totalRatingsCount=3780,
      createdAt="2026-08-31T22:41:43.187400Z", updatedAt="2026-08-31T22:41:43.187400Z",
    ),
    ClubDto(
      id="c8d00edc-f605-4b7a-9da9-aa9ab624c935", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sevilla Tenis De Mesa City (Pongcity)", address="Calle Gral. Luis Alarcón de la Lastra, 10, 41006 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3852961, longitude=-5.9514334,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3a4577fa-2b57-4bf1-9e27-c507d6758f61_photo.jpg",
      averageRating=4.9, totalRatingsCount=68,
      createdAt="2026-08-31T22:40:54.106348Z", updatedAt="2026-08-31T22:40:54.106348Z",
    ),
    ClubDto(
      id="c1e5805d-445f-4d94-8f50-ca11f9e54c8f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Tenis de Mesa Miki Juarbe. CTM Hispalis-CTM Sevilla", address="Polígono Industrial Navisa, C/ Quejío, 35, 41006 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3657913, longitude=-5.9587078,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/10e50198-4b82-400c-b33d-5e814d6e0a7d_photo.jpg",
      averageRating=4.8, totalRatingsCount=56,
      createdAt="2026-08-31T22:40:58.174006Z", updatedAt="2026-08-31T22:40:58.174006Z",
    ),
    ClubDto(
      id="208b410d-18a8-46bb-81e3-989fc462739c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Tag Station", address="Lower Ground Floor, 137 Sir James Pieris Mawatha, Colombo 00200, Sri Lanka",
      city="Sevilla", country="ES",
      latitude=6.9174374, longitude=79.8549729,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e85cfac0-7a9e-41dd-89a1-c971b3cb2a85_photo.jpg",
      averageRating=4.8, totalRatingsCount=288,
      createdAt="2026-08-31T22:41:34.692714Z", updatedAt="2026-08-31T22:41:34.692714Z",
    ),
    ClubDto(
      id="20cbd46c-138c-4a41-be95-c737ab697e7c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Infinity Indoor", address="Adalid Domingo Ledesma, 9, 41703 Fuente del Rey, Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3127283, longitude=-5.9763305,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/88a29afd-17f7-4b1c-9bc6-49c4e2763c34_photo.jpg",
      averageRating=4.5, totalRatingsCount=621,
      createdAt="2026-08-31T22:40:09.290076Z", updatedAt="2026-08-31T22:40:09.290076Z",
    ),
    ClubDto(
      id="21adc7de-da08-4bce-8104-eb55f63d4d2b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KARTING SEVILLA", address="ALCALA DEL RIO a Villaverde km 6 Carretera de, 41200 Esquivel, Sevilla",
      city="Sevilla", country="ES",
      latitude=37.5588264, longitude=-5.9319863,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/310b45db-ca72-4704-89f7-02bfde199881_photo.jpg",
      averageRating=4.5, totalRatingsCount=1957,
      createdAt="2026-08-31T22:41:04.353846Z", updatedAt="2026-08-31T22:41:04.353846Z",
    ),
    ClubDto(
      id="26720e25-601b-4bf0-a30e-551cc1374a9b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pooltour 61,billar,copa，LIKE", address="Av. la Prensa, 3, 41007 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3901226, longitude=-5.9574883,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1bee2e81-ac96-41e6-b5df-907645368193_photo.jpg",
      averageRating=4.5, totalRatingsCount=77,
      createdAt="2026-08-31T22:41:28.635855Z", updatedAt="2026-08-31T22:41:28.635855Z",
    ),
    ClubDto(
      id="d412d220-bec0-4610-aa27-90cac5e5fc4f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Real Club Sevilla Golf", address="Carretera Sevilla - Utrera, km 3, 2, 41500 Alcalá de Guadaíra, Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3518126, longitude=-5.9198279,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/64e9fa4d-bc83-4e0e-9432-cad741d3875d_photo.jpg",
      averageRating=4.5, totalRatingsCount=1052,
      createdAt="2026-08-31T22:40:44.813234Z", updatedAt="2026-08-31T22:40:44.813234Z",
    ),
    ClubDto(
      id="13e25f43-7bc8-4512-98d5-ce4bac559cea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Náutico Sevilla", address="P.º Remeros de Sevilla, s/n, 41011 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3690557, longitude=-5.9951083,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c6d5981d-a61f-4283-9e1b-8948ae6b7a02_photo.jpg",
      averageRating=4.4, totalRatingsCount=1300,
      createdAt="2026-08-31T22:39:47.601163Z", updatedAt="2026-08-31T22:39:47.601163Z",
    ),
    ClubDto(
      id="c8a461a1-4a99-4539-83ba-05d599a080ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Zaudín Golf Sevilla", address="Glorieta del Zaudín y Puerta de las Marismas, 9W5Q+3F, 41940 Tomares, Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3636343, longitude=-6.0569549,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d389d9fa-416f-49c0-aaf4-333c7df75a30_photo.jpg",
      averageRating=4.4, totalRatingsCount=327,
      createdAt="2026-08-31T22:40:49.709007Z", updatedAt="2026-08-31T22:40:49.709007Z",
    ),
    ClubDto(
      id="cd01d6c5-22e8-4d91-8115-c2aafa99cc01", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Palace", address="Carretera espartelera, 41720 Los Palacios y Villafranca, Sevilla",
      city="Sevilla", country="ES",
      latitude=37.171916, longitude=-5.903899,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/53e27d41-c0e0-4ad0-a169-cbac60a9cee2_photo.jpg",
      averageRating=4.4, totalRatingsCount=195,
      createdAt="2026-08-31T22:41:47.499842Z", updatedAt="2026-08-31T22:41:47.499842Z",
    ),
    ClubDto(
      id="ce2cfdb3-6e9b-44a6-898c-9444ab5e3506", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Real Club Pineda de Sevilla", address="922M+FH, Av. de Jerez, s/n, 41014 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3511559, longitude=-5.9646321,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c013c006-cb0c-48d3-94fa-a5d27b165462_photo.jpg",
      averageRating=4.4, totalRatingsCount=1248,
      createdAt="2026-08-31T22:39:51.945175Z", updatedAt="2026-08-31T22:39:51.945175Z",
    ),
    ClubDto(
      id="16dc4443-13d6-4c32-90fc-9b4c0f09b783", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sould Park Bowling Dos Hermanas, Sevilla - Bolera CC Entre Nasas", address="Poligono Sen, 54 CC Entrenasas, 41704 Dos Hermanas, Sevilla",
      city="Sevilla", country="ES",
      latitude=37.31148, longitude=-5.93885,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9c85a568-5d61-4ddd-be28-22b9d3fe710a_photo.jpg",
      averageRating=4.4, totalRatingsCount=187,
      createdAt="2026-08-31T22:41:17.388984Z", updatedAt="2026-08-31T22:41:17.388984Z",
    ),
    ClubDto(
      id="f286926f-6cac-42d3-b48c-93608da1ba94", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ElRemate Pádel Club", address="Av. de Montes Sierra, 38, 41007 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3946904, longitude=-5.9503898,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8d40348f-1676-45da-8721-77e094b317d6_photo.jpg",
      averageRating=4.3, totalRatingsCount=625,
      createdAt="2026-08-31T22:40:04.399005Z", updatedAt="2026-08-31T22:40:04.399005Z",
    ),
    ClubDto(
      id="0668b6b9-00de-4f7c-b032-bd2fc57bf225", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="IOpadel", address="Av. la Prensa, 36, 41007 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3893198, longitude=-5.9526758,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b6849309-8fd2-41bd-bb5c-e3e478c1a85c_photo.jpg",
      averageRating=4.3, totalRatingsCount=440,
      createdAt="2026-08-31T22:40:14.979551Z", updatedAt="2026-09-01T14:32:00.496016Z",
    ),
    ClubDto(
      id="a3810ba0-9204-4943-bf95-cc7d85ac8f33", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Galaxy Park Bowling CC Way Dos Hermanas", address="CC Way, Av. Ing. José Luis Prats, 3, 41701 Dos Hermanas, Sevilla",
      city="Sevilla", country="ES",
      latitude=37.2868423, longitude=-5.9386978,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/76302d79-b600-46fe-8140-41a8bc603e78_photo.jpg",
      averageRating=4.2, totalRatingsCount=425,
      createdAt="2026-08-31T22:41:10.256879Z", updatedAt="2026-08-31T22:41:10.256879Z",
    ),
    ClubDto(
      id="e2e6c0c7-fdc0-4869-97be-349ca1665e21", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polideportivo San Pablo", address="Calle Dr. Laffon Soto, s/n, 41007 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3961927, longitude=-5.9634922,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/43dd1cad-e0bb-4afc-9e9d-2c59349f560f_photo.jpg",
      averageRating=4.2, totalRatingsCount=2932,
      createdAt="2026-08-31T22:40:19.756569Z", updatedAt="2026-08-31T22:40:19.756569Z",
    ),
    ClubDto(
      id="1f15efe6-d614-4ff3-9b9e-05a523d92691", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club de Campo La Motilla", address="C. Orión, 41703 Dos Hermanas, Sevilla",
      city="Sevilla", country="ES",
      latitude=37.2875, longitude=-5.9527778,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/08490559-8991-43b2-9074-6aec9ad6127d_photo.jpg",
      averageRating=4.1, totalRatingsCount=846,
      createdAt="2026-08-31T22:39:37.539490Z", updatedAt="2026-09-01T14:31:54.047995Z",
    ),
    ClubDto(
      id="54114f8f-0f6b-4a83-9c98-b24ab5f2870d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Center Hytasa", address="Av. de Hytasa, 10, 41006 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3709207, longitude=-5.9612122,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4d97236d-3c2d-4808-b3ca-997cd0e7a5c9_photo.jpg",
      averageRating=4.1, totalRatingsCount=1690,
      createdAt="2026-08-31T22:39:27.188152Z", updatedAt="2026-08-31T22:39:27.188152Z",
    ),
    ClubDto(
      id="a88f3e9f-53e5-410c-96ec-6b8147b458cc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo Amate", address="Av. la Revoltosa, s/n, 41006 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3792245, longitude=-5.9452787,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aec00ac0-e9dd-4d4b-b4f5-f3d2c146b7b1_photo.jpg",
      averageRating=4.0, totalRatingsCount=784,
      createdAt="2026-08-31T22:39:41.733319Z", updatedAt="2026-09-01T14:31:57.659917Z",
    ),
    ClubDto(
      id="3e22837d-6904-4078-913a-00d5afad28b7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo Pino Montano", address="C. Cortijo de las Casillas, s/n, Norte, 41015 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.4215025, longitude=-5.9595308,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2bcabdf4-8ffe-46fd-a111-4ef6fadd92b0_photo.jpg",
      averageRating=4.0, totalRatingsCount=458,
      createdAt="2026-08-31T22:40:32.883997Z", updatedAt="2026-08-31T22:40:32.883997Z",
    ),
    ClubDto(
      id="4b25c405-c70f-4f35-9a2e-e908b262814d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="San Roque Football", address="Av. de Altamira, 29A, 41020 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.399964, longitude=-5.9356866,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/56b21083-b4e3-4618-b79e-2edcf7ff343b_photo.jpg",
      averageRating=4.0, totalRatingsCount=862,
      createdAt="2026-08-31T22:39:32.480064Z", updatedAt="2026-08-31T22:39:32.480064Z",
    ),
    ClubDto(
      id="0b2111ee-1ae8-4571-8f16-ed10e474c8e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Center Vega de Triana", address="Parque Vega de, Av. de Coria, 41010 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3826608, longitude=-6.0150292,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f65981a1-10f3-476c-ad54-6ed315b40b94_photo.jpg",
      averageRating=4.0, totalRatingsCount=614,
      createdAt="2026-08-31T22:40:28.138658Z", updatedAt="2026-08-31T22:40:28.138658Z",
    ),
    ClubDto(
      id="0c2586b7-3d0b-46bd-b78e-d5211834fe08", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo Huerta Del Perejil", address="C. Estafeta, s/n, Norte, 41015 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.4153058, longitude=-5.9697121,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6a7876e4-a6dc-4576-82f3-d92f90a705e7_photo.jpg",
      averageRating=3.8, totalRatingsCount=655,
      createdAt="2026-08-31T22:39:56.875226Z", updatedAt="2026-09-01T14:31:57.780187Z",
    ),
    ClubDto(
      id="ba4f171e-852b-4933-a4f6-8f27bd35a92f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo Ifni", address="Calle Ifni, 1 Email: cdifni@imd.sevilla.org, 41012 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3549512, longitude=-5.982748,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b75b9cdc-49eb-4435-bc44-a4a32baaef1d_photo.jpg",
      averageRating=3.8, totalRatingsCount=360,
      createdAt="2026-08-31T22:40:37.648073Z", updatedAt="2026-08-31T22:40:37.648073Z",
    ),
    ClubDto(
      id="dc49241a-64a3-46e3-a2ba-89d9bab11b4c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SANTE SPORT & SOCIAL CLUB", address="Av. del Deporte, 12, 41020 Sevilla",
      city="Sevilla", country="ES",
      latitude=37.3999863, longitude=-5.9189659,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b1bcab03-3906-4c55-ba46-14ceeb4eaf57_photo.jpg",
      averageRating=3.8, totalRatingsCount=705,
      createdAt="2026-08-31T22:40:23.663116Z", updatedAt="2026-08-31T22:40:23.663116Z",
    ),
  )),
  CitySeo(slug="thessaloniki", name="Thessaloniki", country="GR", clubCount=26, sports=listOf(Pair("Volleyball", 4), Pair("Football", 4), Pair("Basketball", 3), Pair("Tennis", 3), Pair("Laser Tag", 2), Pair("Bowling", 2), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Table Tennis", 1), Pair("Paintball", 1), Pair("Karting", 1), Pair("Golf", 1)), clubs=listOf(
    ClubDto(
      id="45418f18-0edd-41e6-bd9b-5e1c667e1111", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ATTAK ARENA - PING PONG THESSALONIKI", address="Ioustinianou 9, Kalamaria 551 34",
      city="Thessaloniki", country="GR",
      latitude=40.5888964, longitude=22.9624957,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/88e92db4-2b96-4048-b1b4-d5c0eb95eb2a_photo.jpg",
      averageRating=5.0, totalRatingsCount=55,
      createdAt="2026-08-31T15:40:01.162425Z", updatedAt="2026-08-31T15:40:01.162425Z",
    ),
    ClubDto(
      id="5e6803b6-8ed0-44a0-be8a-c43fb2486c56", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Great Escape Rooms Thessaloniki", address="Πτολεμαίων 29Β, Θεσσαλονίκη 546 30",
      city="Thessaloniki", country="GR",
      latitude=40.6390681, longitude=22.9401157,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/09468e64-1e06-4a38-a9ae-deb8b2935fbd_ChIJZfZNGgg5_0.jpg",
      averageRating=4.9, totalRatingsCount=1532,
      createdAt="2026-08-30T23:30:30.522290Z", updatedAt="2026-08-30T23:30:30.522290Z",
    ),
    ClubDto(
      id="47f9f8e9-905e-49c5-bb99-38f40a9f03cd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ολυμπιάδα Tennis Club -Thessaloniki", address="Μαρίας Κάλλας 23, Θεσσαλονίκη 546 46",
      city="Thessaloniki", country="GR",
      latitude=40.595742, longitude=22.9499188,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cca336bb-3d99-45eb-b95d-26230d62fee0_ChIJOWCWqis5_0.jpg",
      averageRating=4.9, totalRatingsCount=323,
      createdAt="2026-08-30T23:30:51.567675Z", updatedAt="2026-08-30T23:30:51.567675Z",
    ),
    ClubDto(
      id="af0044f1-c055-4941-bdf2-2f8406afaaf8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Crux", address="Στρ. Ναπολέοντος Ζέρβα 20, Θεσσαλονίκη 546 40",
      city="Thessaloniki", country="GR",
      latitude=40.6213188, longitude=22.9561176,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/15664654-52c0-475d-8ec2-e0fa3badb89c_ChIJZUop7PM5_0.jpg",
      averageRating=4.8, totalRatingsCount=243,
      createdAt="2026-08-30T23:30:17.054558Z", updatedAt="2026-08-30T23:30:17.054558Z",
    ),
    ClubDto(
      id="d35a3dda-ea13-46a7-86bf-1ca512426275", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ELITE SPORTS CLUB", address="12th km National Road, Thessaloniki 570 01, ΘΕΣΣΑΛΟΝΙΚΗ 570 01",
      city="Thessaloniki", country="GR",
      latitude=40.5452591, longitude=22.9973198,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/286c1c48-c7b8-4565-8e89-8ea0a8b8d849_photo.jpg",
      averageRating=4.8, totalRatingsCount=106,
      createdAt="2026-08-31T15:39:26.486077Z", updatedAt="2026-08-31T15:39:26.486077Z",
    ),
    ClubDto(
      id="3d380763-6649-4d1f-8e07-886a49b3f3c0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Imperial Port | Convention Club Thessaloniki", address="26ης Οκτωβρίου 59, Θεσσαλονίκη 546 27",
      city="Thessaloniki", country="GR",
      latitude=40.6428291, longitude=22.9111793,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/92fc110f-717a-404b-a6e1-42c9f752b13b_ChIJ1RD53FY5_0.jpg",
      averageRating=4.8, totalRatingsCount=2200,
      createdAt="2026-08-30T23:29:55.672832Z", updatedAt="2026-08-31T08:31:02.740458Z",
    ),
    ClubDto(
      id="18f5e40d-ab55-4c7f-ac08-ca515003d9c9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PXP Climbing", address="Λεωφ. Κωνσταντίνου Καραμανλή 124, Θεσσαλονίκη 542 48",
      city="Thessaloniki", country="GR",
      latitude=40.6038639, longitude=22.9638514,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/24e28a0c-a821-4838-9f58-c3d49b42c0aa_ChIJQ8_B4No4_0.jpg",
      averageRating=4.8, totalRatingsCount=324,
      createdAt="2026-08-30T23:30:09.339870Z", updatedAt="2026-08-31T08:33:39.200072Z",
    ),
    ClubDto(
      id="59a303bc-c6c1-4e85-a502-765acfcc0a45", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="\"Ivanofeio\" Sports Arena", address="Leof. 3is Septemvriou, Thessaloniki 546 36",
      city="Thessaloniki", country="GR",
      latitude=40.6281548, longitude=22.964057,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9373f8e6-53af-462f-aec9-7c1a70690807_photo.jpg",
      averageRating=4.7, totalRatingsCount=280,
      createdAt="2026-08-31T15:39:04.121643Z", updatedAt="2026-08-31T15:39:04.121643Z",
    ),
    ClubDto(
      id="5fbdb45a-27dc-4527-8b84-8090256272a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Adventure Paintball", address="Α/Δ Θεσσαλονίκης Ν. Μουδανιών, Θέρμη 570 01",
      city="Thessaloniki", country="GR",
      latitude=40.5469457, longitude=22.9967448,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b13eb8d-da2b-4b34-a913-da7d989d9343_ChIJjWIYZ38__0.jpg",
      averageRating=4.7, totalRatingsCount=1298,
      createdAt="2026-08-30T23:30:44.501285Z", updatedAt="2026-08-30T23:30:44.501285Z",
    ),
    ClubDto(
      id="dd9a8072-c235-40a9-aa58-3557a1d41713", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Drivepark Gokart Circuit Thessaloniki", address="15 klm Thessaloniki - N.Mihaniona, Νέο Ρύσιο 570 01",
      city="Thessaloniki", country="GR",
      latitude=40.5141183, longitude=22.9917777,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/89b7f107-8a64-4e09-9b62-7eb0d5d137ab_ChIJeZkoffs__0.jpg",
      averageRating=4.7, totalRatingsCount=1157,
      createdAt="2026-08-30T23:30:23.386547Z", updatedAt="2026-08-31T08:27:25.673934Z",
    ),
    ClubDto(
      id="2a2fec77-1e79-4fe5-ac9f-d2447f35e4d8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Αλεξάνδρειο Αθλητικό Μέλαθρο", address="Γρ. Λαμπράκη 2, Θεσσαλονίκη 546 36",
      city="Thessaloniki", country="GR",
      latitude=40.6268244, longitude=22.9573401,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7aeadefe-2ede-4c1f-8ca2-1b680c646856_ChIJs9p3Jfw4_0.jpg",
      averageRating=4.7, totalRatingsCount=2354,
      createdAt="2026-08-30T23:29:35.143719Z", updatedAt="2026-08-30T23:29:35.143719Z",
    ),
    ClubDto(
      id="0813edf8-a4b7-46b9-ac9f-ceb86775402f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dizzy Dolls", address="Αἰγύπτου 5, Θεσσαλονίκη 546 25",
      city="Thessaloniki", country="GR",
      latitude=40.6350029, longitude=22.9370583,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cedf53a7-f780-42a8-8059-54c73f8823ff_ChIJH38CwAk5_0.jpg",
      averageRating=4.6, totalRatingsCount=1151,
      createdAt="2026-08-30T23:30:02.459966Z", updatedAt="2026-08-30T23:30:02.459966Z",
    ),
    ClubDto(
      id="3f63b728-5bb1-4adc-8aa9-fb59786fe63e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fairplay Tennis & Padel Club Thessaloniki - Γήπεδα Τένις - Ακαδημία Τένις", address="13o χλμ, Θεσσαλονίκης - Περαίας, Θέρμη 570 01",
      city="Thessaloniki", country="GR",
      latitude=40.5272806, longitude=22.9999328,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f0241009-89dc-4df4-aedb-762980c93abe_ChIJN_Map-k__0.jpg",
      averageRating=4.6, totalRatingsCount=81,
      createdAt="2026-08-30T23:30:57.675511Z", updatedAt="2026-09-01T14:31:50.009831Z",
    ),
    ClubDto(
      id="60c0ed52-ce59-49b4-93ba-64d3358b226f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Family Sports Club", address="Τοσίτσα 18, Θεσσαλονίκη 570 10",
      city="Thessaloniki", country="GR",
      latitude=40.6556594, longitude=22.9951254,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7445e979-1c52-4366-a9f0-16eebacfe844_ChIJCUQtKgQ4_0.jpg",
      averageRating=4.6, totalRatingsCount=1105,
      createdAt="2026-08-30T23:29:49.592345Z", updatedAt="2026-09-01T14:31:50.129839Z",
    ),
    ClubDto(
      id="af4c1d86-da93-4237-bd98-81fdbb37f0b5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PAOK Sports Arena", address="Antoni Tritsi 12, Pilea Chortiatis 555 10",
      city="Thessaloniki", country="GR",
      latitude=40.5656143, longitude=22.9814005,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6c7203fd-89da-44d9-8e3f-1bdf96fcc76f_photo.jpg",
      averageRating=4.6, totalRatingsCount=3353,
      createdAt="2026-08-31T15:38:56.944382Z", updatedAt="2026-08-31T15:38:56.944382Z",
    ),
    ClubDto(
      id="5c8ec062-411f-4880-9f57-5e8a83f1610c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Αθλητικός Όμιλος Λέοντες", address="Μεσολογγίου, έναντι Παπαγεωργίου, περιφερειακή Θεσσαλονικης, Θεσσαλονίκη 564 29",
      city="Thessaloniki", country="GR",
      latitude=40.6774088, longitude=22.9549054,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eff8cc48-e0ec-4aef-984e-faec2033ca75_ChIJL40VPoI3_0.jpg",
      averageRating=4.6, totalRatingsCount=1174,
      createdAt="2026-08-30T23:29:41.735562Z", updatedAt="2026-08-31T08:39:46.405881Z",
    ),
    ClubDto(
      id="cd0cc581-9946-4611-b545-a91a720af558", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Γήπεδο Κλεάνθης Βικελίδης", address="Αλ. Παπαναστασίου 154, Θεσσαλονίκη 542 49",
      city="Thessaloniki", country="GR",
      latitude=40.6000328, longitude=22.9694709,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/74f09582-922b-485a-913b-0c47d82f6b18_ChIJz1axZ884_0.jpg",
      averageRating=4.6, totalRatingsCount=6401,
      createdAt="2026-08-30T23:29:28.321140Z", updatedAt="2026-08-31T08:40:18.257145Z",
    ),
    ClubDto(
      id="9319d690-5d33-46e2-a439-5afd2e009e03", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sunset Beach Volley Club", address="Gimnastiriou Mikras, Kalamaria 551 32",
      city="Thessaloniki", country="GR",
      latitude=40.5627683, longitude=22.9652519,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0eae6539-aecf-4f72-b938-6ff9ebb70129_photo.jpg",
      averageRating=5.0, totalRatingsCount=45,
      createdAt="2026-08-31T15:39:42.083378Z", updatedAt="2026-08-31T15:39:42.083378Z",
    ),
    ClubDto(
      id="893f99c8-d1c3-4c11-9b42-b147cc0e422c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="\"Katsaneio\" Volleyball Hall", address="Ag. Dimitriou 159B, Thessaloniki 546 35",
      city="Thessaloniki", country="GR",
      latitude=40.6294246, longitude=22.9626497,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cad1f9b0-9931-4d67-8f6b-d4976273f917_photo.jpg",
      averageRating=4.4, totalRatingsCount=277,
      createdAt="2026-08-31T15:39:19.745004Z", updatedAt="2026-08-31T15:39:19.745004Z",
    ),
    ClubDto(
      id="b1697981-75d1-4307-a747-c0e89d4f4965", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Battlenet 3D Aristotelous", address="Βασ. Ηρακλειου 40, Θεσσαλονίκη 546 23",
      city="Thessaloniki", country="GR",
      latitude=40.6333825, longitude=22.9435802,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6ecec1c5-b893-4930-ac3a-56bf4b400933_ChIJuz10vAc5_0.jpg",
      averageRating=4.4, totalRatingsCount=732,
      createdAt="2026-08-30T23:30:37.554278Z", updatedAt="2026-08-30T23:30:37.554278Z",
    ),
    ClubDto(
      id="335ae4fb-576b-4c24-b8ba-f251fffe7d33", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Porto Carras Golf & Country Club", address="Neos Marmaras 630 81",
      city="Thessaloniki", country="GR",
      latitude=40.0794562, longitude=23.7996205,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ecd7e56-a352-4234-b9f3-4562557ea376_photo.jpg",
      averageRating=4.4, totalRatingsCount=53,
      createdAt="2026-08-31T15:39:54.480985Z", updatedAt="2026-08-31T15:39:54.480985Z",
    ),
    ClubDto(
      id="782b6831-64e8-4e7b-9546-af678656c51e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="YMCA - Young Men's Christian Association", address="Nik. Germanou 1, Thessaloniki 546 21",
      city="Thessaloniki", country="GR",
      latitude=40.6266842, longitude=22.952265,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1f8b9de3-36f7-4c1b-ab7f-e18c9fd72ac9_photo.jpg",
      averageRating=4.4, totalRatingsCount=542,
      createdAt="2026-08-31T15:39:12.891087Z", updatedAt="2026-08-31T15:39:12.891087Z",
    ),
    ClubDto(
      id="e54051ac-1b2d-4223-bfcd-d24f7e15d8c7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pin City", address="17is Noemvriou 75, Pilea 555 35",
      city="Thessaloniki", country="GR",
      latitude=40.6071845, longitude=22.9953931,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/805ba78f-c4a7-47f4-9a96-4007c27f2e80_photo.jpg",
      averageRating=4.2, totalRatingsCount=1900,
      createdAt="2026-08-31T15:40:08.249854Z", updatedAt="2026-08-31T22:11:20.364494Z",
    ),
    ClubDto(
      id="ed935583-838d-4790-8575-c8ee1e9a6dca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cafe Juris Billiard And Bowling", address="Al. Papanastasiou 58, Thessaloniki 546 42",
      city="Thessaloniki", country="GR",
      latitude=40.611857, longitude=22.9639628,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/af835bcd-dca3-4f3b-8caf-9843f80c592d_photo.jpg",
      averageRating=4.0, totalRatingsCount=1069,
      createdAt="2026-08-31T15:40:14.617747Z", updatedAt="2026-08-31T15:40:14.617747Z",
    ),
    ClubDto(
      id="1229c57f-ca3a-4465-a982-9a9e2987fcf4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Μίκρα Beach Volley", address="Kalamaria Municipality 551 32",
      city="Thessaloniki", country="GR",
      latitude=40.5627973, longitude=22.9651222,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a326ca6b-3fbf-4542-a0f8-2bc23dbe7018_photo.jpg",
      averageRating=3.9, totalRatingsCount=67,
      createdAt="2026-08-31T15:39:48.188918Z", updatedAt="2026-08-31T15:39:48.188918Z",
    ),
    ClubDto(
      id="975fc91c-5944-45df-a9d3-418814795379", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Stars", address="Μαρίας Κάλλας 23 και, 25ης Μαρτίου, Θεσσαλονίκη 546 45",
      city="Thessaloniki", country="GR",
      latitude=40.5980704, longitude=22.950363,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/201ef50e-224c-4f33-9595-e09b04baade6_ChIJT15Cvrk5_0.jpg",
      averageRating=4.0, totalRatingsCount=45,
      createdAt="2026-08-30T23:31:01.560926Z", updatedAt="2026-08-30T23:31:01.560926Z",
    ),
  )),
  CitySeo(slug="dusseldorf", name="Dusseldorf", country="DE", clubCount=26, sports=listOf(Pair("Tennis", 4), Pair("Padel", 3), Pair("Football", 3), Pair("Basketball", 3), Pair("Billiards", 2), Pair("Golf", 2), Pair("Climbing", 2), Pair("Table Tennis", 2), Pair("Bowling", 1), Pair("Karting", 1), Pair("Laser Tag", 1), Pair("Paintball", 1), Pair("Volleyball", 1)), clubs=listOf(
    ClubDto(
      id="c36951e1-cf92-4833-b6ac-1767fec185af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="mitte – highline | Boutique Padel Club", address="Höherweg 247, 40231 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.2212355, longitude=6.8247222,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/153bfe31-e72d-4f54-a676-be649b7a4b21_photo.jpg",
      averageRating=5.0, totalRatingsCount=492,
      createdAt="2026-08-31T22:56:44.846286Z", updatedAt="2026-08-31T22:56:44.846286Z",
    ),
    ClubDto(
      id="ccfe1859-66f9-490c-8564-136fec50efed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BattleKart Düsseldorf-Neuss", address="Ruhrstraße 49, 41469 Neuss",
      city="Dusseldorf", country="DE",
      latitude=51.1571446, longitude=6.7442372,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7601b9e4-28bc-4c05-a4cd-64e1b3fa719d_photo.jpg",
      averageRating=4.9, totalRatingsCount=1368,
      createdAt="2026-08-31T22:57:39.571167Z", updatedAt="2026-08-31T22:57:39.571167Z",
    ),
    ClubDto(
      id="a3ee1709-25ca-4aae-af62-807f539ee3bd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="mitte – bøhler | Boutique Padel Club", address="Böhlerstraße 1/Halle 10, 40549 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.246189, longitude=6.7095469,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/273acae6-eed2-49a2-8e84-2518ddc921b2_photo.jpg",
      averageRating=4.9, totalRatingsCount=451,
      createdAt="2026-08-31T22:56:50.452837Z", updatedAt="2026-08-31T22:56:50.452837Z",
    ),
    ClubDto(
      id="dc29d235-4008-4d63-b8fb-6a9ee124e58a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Frank's Billard Café", address="Kölner Str. 40A, 40211 Düsseldorf-Stadtbezirk 1",
      city="Dusseldorf", country="DE",
      latitude=51.2259649, longitude=6.7945129,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/767d83a0-9e60-4d0f-aec4-734fbcf909f2_photo.jpg",
      averageRating=4.8, totalRatingsCount=562,
      createdAt="2026-08-31T22:58:05.333567Z", updatedAt="2026-08-31T22:58:05.333567Z",
    ),
    ClubDto(
      id="f9969c0b-1968-4a17-a1e5-d3cfc2cdc933", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasertag Evolution Dusseldorf", address="Ubierstraße 18, 40223 Düsseldorf-Stadtbezirk 3",
      city="Dusseldorf", country="DE",
      latitude=51.1977194, longitude=6.7719576,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0f6c4238-46f2-462c-93f8-b8bb06a32331_photo.jpg",
      averageRating=4.8, totalRatingsCount=5851,
      createdAt="2026-08-31T22:58:14.493254Z", updatedAt="2026-08-31T22:58:14.493254Z",
    ),
    ClubDto(
      id="c0f0e8ea-d6a8-4eed-bda1-c2a5bddcd6d9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Superblock Boulderhalle", address="Fichtenstraße 53, 40233 Düsseldorf-Stadtbezirk 2",
      city="Dusseldorf", country="DE",
      latitude=51.2139988, longitude=6.812478,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39506ec5-6630-4294-9b08-999767efc74a_photo.jpg",
      averageRating=4.8, totalRatingsCount=771,
      createdAt="2026-08-31T22:57:56.237542Z", updatedAt="2026-08-31T22:57:56.237542Z",
    ),
    ClubDto(
      id="9b0f74df-5750-4e2e-828b-f609124081f5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TC Rot-Weiss Dusseldorf", address="Lenaustraße 14, 40470 Düsseldorf-Stadtbezirk 7",
      city="Dusseldorf", country="DE",
      latitude=51.2493899, longitude=6.8229555,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83aa5c1e-7b5f-4c8c-ab62-c7eaa7ccada9_photo.jpg",
      averageRating=4.8, totalRatingsCount=144,
      createdAt="2026-08-31T22:56:16.541511Z", updatedAt="2026-08-31T22:56:16.541511Z",
    ),
    ClubDto(
      id="4f5b7ece-de5f-4e18-9613-6d72be18eabf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="einstein - Klettern in der Boulderhalle Düsseldorf", address="Lierenfelder Str. 49, 40231 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.2128936, longitude=6.821655,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/afe96618-2951-4dcc-84c4-7e67f5185065_photo.jpg",
      averageRating=4.8, totalRatingsCount=853,
      createdAt="2026-08-31T22:57:49.927542Z", updatedAt="2026-08-31T22:57:49.927542Z",
    ),
    ClubDto(
      id="b8f8f911-2fc4-4097-8ead-aa0b0cf58f79", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintballpark Aachen", address="Karl-Friedrich-Straße 72, 52072 Aachen-Grünenthal",
      city="Dusseldorf", country="DE",
      latitude=50.8093929, longitude=6.0524569,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c5d79b1-3931-4564-bc83-05ad7cd2941f_photo.jpg",
      averageRating=4.7, totalRatingsCount=399,
      createdAt="2026-08-31T22:58:18.764630Z", updatedAt="2026-08-31T22:58:18.764630Z",
    ),
    ClubDto(
      id="778add1e-e9b9-48ce-9497-a45eb4f68fad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TG Nord Düsseldorf e.V. | Tennis & Padel", address="Neusser Weg 92, 40474 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.2745687, longitude=6.7315899,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d885a65-03c0-4343-9e40-5677c47d5592_photo.jpg",
      averageRating=4.7, totalRatingsCount=102,
      createdAt="2026-08-31T22:56:32.277706Z", updatedAt="2026-09-01T14:31:46.356673Z",
    ),
    ClubDto(
      id="0ed2f3f3-8da1-4933-b766-a5b1b8ec145e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennisclub Gerresheim e.V.", address="Gerricusstraße 25, 40625 Düsseldorf-Stadtbezirk 7",
      city="Dusseldorf", country="DE",
      latitude=51.2384075, longitude=6.8651605,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ea444f3a-fa8c-40c7-ae67-8d60fb1a6062_photo.jpg",
      averageRating=4.7, totalRatingsCount=93,
      createdAt="2026-08-31T22:56:39.111714Z", updatedAt="2026-08-31T22:56:39.111714Z",
    ),
    ClubDto(
      id="dd64e6fc-efe7-4d97-9d38-cb9ff725b848", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rochusclub", address="Rolander Weg 15, 40629 Düsseldorf-Stadtbezirk 7",
      city="Dusseldorf", country="DE",
      latitude=51.2508311, longitude=6.8287462,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/35a41a73-9734-45c7-b767-ef32eb252ddd_photo.jpg",
      averageRating=4.6, totalRatingsCount=140,
      createdAt="2026-08-31T22:56:25.535706Z", updatedAt="2026-08-31T22:56:25.535706Z",
    ),
    ClubDto(
      id="aa93b6c8-809f-4c30-ba66-630baa019601", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BOWLING PLANET", address="Werdener Str. 87, 40233 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.2202339, longitude=6.8087991,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e62b51e1-d27c-45b6-aa86-ff7b806fc236_photo.jpg",
      averageRating=4.5, totalRatingsCount=525,
      createdAt="2026-08-31T22:57:45.732047Z", updatedAt="2026-08-31T22:57:45.732047Z",
    ),
    ClubDto(
      id="b83b0a2d-e634-4553-9d12-6c3f9d9b6760", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golfanlage Düsseldorf-Grafenberg", address="Rennbahnstraße 24-26, 40629 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.2538444, longitude=6.8450485,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/03b57f08-f5de-4688-a8f5-9e6375b2749b_photo.jpg",
      averageRating=4.4, totalRatingsCount=546,
      createdAt="2026-08-31T22:57:22.716449Z", updatedAt="2026-08-31T22:57:22.716449Z",
    ),
    ClubDto(
      id="2015e3ce-a38f-46e8-816e-83e792aa5894", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paul-Janes-Stadion", address="Flinger Broich 87, 40235 Düsseldorf-Stadtbezirk 2",
      city="Dusseldorf", country="DE",
      latitude=51.2249998, longitude=6.8272246,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aa252372-b331-40b2-a438-d74ff62b8ee0_photo.jpg",
      averageRating=4.4, totalRatingsCount=705,
      createdAt="2026-08-31T22:56:06.680900Z", updatedAt="2026-08-31T22:56:06.680900Z",
    ),
    ClubDto(
      id="f95b94de-fb37-49c0-bc3e-873f00b3dd58", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Home of the ART Gi", address="Lütticher Str. 34, 40545 Düsseldorf-Stadtbezirk 4",
      city="Dusseldorf", country="DE",
      latitude=51.2363081, longitude=6.7450844,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d028c6c-2ede-48f8-bd60-94707e2dc119_photo.jpg",
      averageRating=4.4, totalRatingsCount=49,
      createdAt="2026-08-31T22:57:01.470125Z", updatedAt="2026-08-31T22:57:01.470125Z",
    ),
    ClubDto(
      id="36e95c95-bfba-4f6e-9383-36b92afbcb8e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billard-Forum", address="Kölner Str. 67, 40211 Düsseldorf-Stadtbezirk 1",
      city="Dusseldorf", country="DE",
      latitude=51.22443, longitude=6.7953848,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed5a0fe5-5891-41cf-9e95-cafe9a245ffb_photo.jpg",
      averageRating=4.3, totalRatingsCount=475,
      createdAt="2026-08-31T22:58:10.397567Z", updatedAt="2026-08-31T22:58:10.397567Z",
    ),
    ClubDto(
      id="ceb4998d-f18f-4d3e-b7f2-4118546b8c36", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GSV Golf-Sport-Verein Düsseldorf e.V.", address="Auf der Lausward 51, 40221 Düsseldorf-Stadtbezirk 3",
      city="Dusseldorf", country="DE",
      latitude=51.223087, longitude=6.738197,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e98a3b0-4c22-4143-98a6-eb11be5744d3_photo.jpg",
      averageRating=4.3, totalRatingsCount=356,
      createdAt="2026-08-31T22:57:26.625582Z", updatedAt="2026-08-31T22:57:26.625582Z",
    ),
    ClubDto(
      id="98be6e00-9fda-4aaf-bbc7-12dcc2f971c1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MERKUR SPIEL-ARENA", address="Arena-Straße 1, 40474 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.261241, longitude=6.7324382,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/07d0945d-fe1e-45f6-80fe-df785660ab2d_photo.jpg",
      averageRating=4.3, totalRatingsCount=18045,
      createdAt="2026-08-31T22:56:02.339623Z", updatedAt="2026-08-31T22:56:02.339623Z",
    ),
    ClubDto(
      id="151e90e3-bd60-43c0-9d1d-66bf9937c0f8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="4PADEL Düsseldorf", address="Am Gatherhof 57, 40472 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.2657986, longitude=6.8152197,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f972984d-ce20-4402-89b0-7314b1945750_photo.jpg",
      averageRating=4.2, totalRatingsCount=246,
      createdAt="2026-08-31T22:56:56.934619Z", updatedAt="2026-08-31T22:56:56.934619Z",
    ),
    ClubDto(
      id="d710f14d-6a9c-4bc6-81cb-330e7c7c7fcd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cageball Düsseldorf", address="Ulenbergstraße 5, 40223 Düsseldorf-Stadtbezirk 3",
      city="Dusseldorf", country="DE",
      latitude=51.195989, longitude=6.7710283,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d8355f6a-62f1-4925-8d7a-70b069c24a9b_photo.jpg",
      averageRating=4.0, totalRatingsCount=293,
      createdAt="2026-08-31T22:56:11.205036Z", updatedAt="2026-08-31T22:56:11.205036Z",
    ),
    ClubDto(
      id="f2e679d7-335e-4141-ad89-bc3f5adf0411", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ljubav Basketball-Arena", address="Mindener Str. 91, 40227 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.2130355, longitude=6.8096399,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f739e562-4fc6-4a76-818b-4c6f08935156_photo.jpg",
      averageRating=4.9, totalRatingsCount=34,
      createdAt="2026-08-31T22:57:09.529766Z", updatedAt="2026-08-31T22:57:09.529766Z",
    ),
    ClubDto(
      id="a990e236-37a6-48a6-ac6d-32656310812d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tischtennis - DJK Jugend Eller 1910 e.V.", address="Richardstraße 14, 40231 Düsseldorf-Stadtbezirk 8",
      city="Dusseldorf", country="DE",
      latitude=51.20508, longitude=6.83746,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ae9f621f-661e-47c1-9803-a841cf5b58ff_photo.jpg",
      averageRating=4.8, totalRatingsCount=28,
      createdAt="2026-08-31T22:57:30.108608Z", updatedAt="2026-08-31T22:57:30.108608Z",
    ),
    ClubDto(
      id="5e34a47b-ea02-416b-8efd-5765a34e5533", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Hall Düsseldorf", address="Heesenstraße 70, 40549 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.2299301, longitude=6.7122292,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4162f865-c039-40ec-972b-a2ee7a546aa4_photo.jpg",
      averageRating=4.8, totalRatingsCount=24,
      createdAt="2026-08-31T22:57:14.876539Z", updatedAt="2026-08-31T22:57:14.876539Z",
    ),
    ClubDto(
      id="c78b91e0-f883-4f2c-942c-dc1c46acabe4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SPONTENT Playground | Beachvolleyball & Events", address="Posener Str. 156, 40231 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.21612, longitude=6.8374296,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/76539017-8948-4523-9db8-e610012ceb51_photo.jpg",
      averageRating=4.2, totalRatingsCount=21,
      createdAt="2026-08-31T22:57:17.972339Z", updatedAt="2026-08-31T22:57:17.972339Z",
    ),
    ClubDto(
      id="f7aa265f-cfea-431d-be38-4d3d4a2d9790", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Table tennis (ping-pong)", address="Düsseldorf-Pempelfort, 40479 Düsseldorf",
      city="Dusseldorf", country="DE",
      latitude=51.2323117, longitude=6.7785901,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/208684c7-3b75-4721-988c-59c3e35720f5_photo.jpg",
      averageRating=4.9, totalRatingsCount=10,
      createdAt="2026-08-31T22:57:35.013721Z", updatedAt="2026-08-31T22:57:35.013721Z",
    ),
  )),
  CitySeo(slug="turin", name="Turin", country="IT", clubCount=26, sports=listOf(Pair("Volleyball", 4), Pair("Football", 4), Pair("Padel", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Climbing", 2), Pair("Karting", 2), Pair("Tennis", 2), Pair("Paintball", 2), Pair("Golf", 2), Pair("Basketball", 2)), clubs=listOf(
    ClubDto(
      id="b98ce1e8-2999-4355-bbd4-3b82da68ac36", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Full Metal Paintball Carmagnola", address="Via Ceis, 80, 10022 Carmagnola TO",
      city="Turin", country="IT",
      latitude=44.8675381, longitude=7.7076827,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/88490b40-bdad-482a-a6ad-99a56c257086_photo.jpg",
      averageRating=4.9, totalRatingsCount=575,
      createdAt="2026-08-31T23:26:22.098407Z", updatedAt="2026-08-31T23:26:22.098407Z",
    ),
    ClubDto(
      id="a865ffbb-ba98-4648-9e11-41df4be8f8c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bside Climbing Village", address="Via Amedeo Ravina, 28, 10153 Torino TO",
      city="Turin", country="IT",
      latitude=45.0775596, longitude=7.713637,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/12b53e1f-bce7-4d83-b5e4-208eb63a4d98_photo.jpg",
      averageRating=4.7, totalRatingsCount=551,
      createdAt="2026-08-31T23:26:01.237302Z", updatedAt="2026-08-31T23:26:01.237302Z",
    ),
    ClubDto(
      id="a30d6c7b-a538-4fba-a86a-13e8d98752f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Turin indoor kart", address="Via Enrico Fermi, 11, 10148 Torino TO",
      city="Turin", country="IT",
      latitude=45.113795, longitude=7.6735053,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11a84828-ff97-438e-9569-d7d2b491fda4_photo.jpg",
      averageRating=4.6, totalRatingsCount=779,
      createdAt="2026-08-31T23:25:46.522509Z", updatedAt="2026-08-31T23:25:46.522509Z",
    ),
    ClubDto(
      id="638ccea6-f6d4-4234-ae9c-060c520d4662", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="All Star", address="V. San Marino, 31, 10134 Torino TO",
      city="Turin", country="IT",
      latitude=45.0363121, longitude=7.646635,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ec5168a8-c54f-4150-a365-b349ab88a63f_photo.jpg",
      averageRating=4.5, totalRatingsCount=115,
      createdAt="2026-08-31T23:26:12.543445Z", updatedAt="2026-08-31T23:26:12.543445Z",
    ),
    ClubDto(
      id="c07965c0-c2c4-4a91-af9e-25763f83ed98", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Inalpi Arena", address="Corso Sebastopoli, 123, 10134 Torino TO",
      city="Turin", country="IT",
      latitude=45.0415285, longitude=7.6521908,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c03e66ae-d9c6-4913-b673-4d8924c8942a_photo.jpg",
      averageRating=4.5, totalRatingsCount=13936,
      createdAt="2026-08-31T23:24:02.959216Z", updatedAt="2026-09-01T14:32:00.612550Z",
    ),
    ClubDto(
      id="b2e77b8b-ecda-4fcc-9032-d8fe24dc9760", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le Dune - Beach Club", address="Str. Borgaretto, 6, 10092 Borgaretto TO",
      city="Turin", country="IT",
      latitude=45.0117289, longitude=7.5895716,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ec7483e2-1aef-4f5c-982c-79110d0dbf2f_photo.jpg",
      averageRating=4.5, totalRatingsCount=453,
      createdAt="2026-08-31T23:25:20.352609Z", updatedAt="2026-08-31T23:25:20.352609Z",
    ),
    ClubDto(
      id="fb3c5229-3a2d-4cd1-8d02-ea397db6fb14", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="4SIDE Padel Servais", address="V. Giovanni Servais, 200/A, 10146 Torino TO",
      city="Turin", country="IT",
      latitude=45.0870806, longitude=7.6155293,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d340a236-c190-490c-ae7c-a68b1725b1db_photo.jpg",
      averageRating=4.4, totalRatingsCount=127,
      createdAt="2026-08-31T23:24:43.374521Z", updatedAt="2026-08-31T23:24:43.374521Z",
    ),
    ClubDto(
      id="2d7d24be-3285-49de-9aaf-9faccd311da7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cerrina Race Track", address="Via Piossasco - Rivalta, n° 1, 10040 Bruino TO",
      city="Turin", country="IT",
      latitude=45.0000456, longitude=7.4891021,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8b400644-1b2a-4709-b61c-14247ad95cc0_photo.jpg",
      averageRating=4.4, totalRatingsCount=1414,
      createdAt="2026-08-31T23:25:39.407567Z", updatedAt="2026-08-31T23:25:39.407567Z",
    ),
    ClubDto(
      id="ebd93fef-7c0d-46cd-8d8b-91d90f889199", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CircoloBorgonuovo", address="Via Cascina Nuova, 1, 10036 Settimo Torinese TO",
      city="Turin", country="IT",
      latitude=45.1473094, longitude=7.7700694,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c45b81fd-f930-4fc9-9682-e530161d1f0c_photo.jpg",
      averageRating=4.4, totalRatingsCount=133,
      createdAt="2026-08-31T23:26:08.747939Z", updatedAt="2026-08-31T23:26:08.747939Z",
    ),
    ClubDto(
      id="70a935a0-b0e7-4806-a321-268a12f6f130", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GPADEL Torino Cenisia", address="Via Cesana, 17, 10139 Torino TO",
      city="Turin", country="IT",
      latitude=45.0698467, longitude=7.6508314,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eabfba44-fee4-43d3-88ea-de871eb27b8b_photo.jpg",
      averageRating=4.4, totalRatingsCount=145,
      createdAt="2026-08-31T23:24:38.756821Z", updatedAt="2026-09-01T14:31:41.670677Z",
    ),
    ClubDto(
      id="5c75374d-7c80-4207-acfb-853312f36086", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Club La Margherita", address="S.P. 134 Carmagnola/Pralormo.3, 10046 Poirino TO",
      city="Turin", country="IT",
      latitude=44.8571374, longitude=7.8198688,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/812b40e5-d049-4025-9e01-3e7548b13b51_photo.jpg",
      averageRating=4.4, totalRatingsCount=420,
      createdAt="2026-08-31T23:25:27.551299Z", updatedAt="2026-08-31T23:25:27.551299Z",
    ),
    ClubDto(
      id="31f27c5c-52a1-4735-ad2b-91d16d2ef23e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Motovelodromo Torino \"Fausto Coppi\"", address="Corso Casale, 144, 10132 Torino TO",
      city="Turin", country="IT",
      latitude=45.0687332, longitude=7.717915,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b018b18d-e640-45ea-8df7-9786b34111d1_photo.jpg",
      averageRating=4.4, totalRatingsCount=709,
      createdAt="2026-08-31T23:25:15.494497Z", updatedAt="2026-08-31T23:25:15.494497Z",
    ),
    ClubDto(
      id="67d02aa2-ce55-4abc-9ecc-9e72efd485fb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palazzo dello Sport Ruffini", address="Viale Leonardo Bistolfi, 10, 10141 Torino TO",
      city="Turin", country="IT",
      latitude=45.0577227, longitude=7.6324169,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a5d940e2-36ec-4715-af5c-b25da9c6a13a_photo.jpg",
      averageRating=4.4, totalRatingsCount=1721,
      createdAt="2026-08-31T23:24:48.530946Z", updatedAt="2026-08-31T23:24:48.530946Z",
    ),
    ClubDto(
      id="1343d2ee-0641-4828-bc97-b24fd8452ea2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SASP", address="Corso Enrico Tazzoli, 78/Bis, 10137 Torino TO",
      city="Turin", country="IT",
      latitude=45.0340135, longitude=7.6327374,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/efcefd71-cca3-4522-bbff-2353a2cece25_photo.jpg",
      averageRating=4.4, totalRatingsCount=361,
      createdAt="2026-08-31T23:26:05.036440Z", updatedAt="2026-08-31T23:26:05.036440Z",
    ),
    ClubDto(
      id="c389beca-8d56-4b05-9d96-52ffb140f296", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Associazione Culturale Variante Bunker", address="Via Niccolò Paganini, 0/200, 10154 Torino TO",
      city="Turin", country="IT",
      latitude=45.0842416, longitude=7.704729,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2306571a-1f3b-47b5-b337-9475bcae8dbc_photo.jpg",
      averageRating=4.3, totalRatingsCount=1676,
      createdAt="2026-08-31T23:25:08.570980Z", updatedAt="2026-08-31T23:25:08.570980Z",
    ),
    ClubDto(
      id="0e067f0d-3dad-4f1a-99cf-deffde0dd08c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Circolo della Stampa - Sporting A.P.S - A.S.D.", address="Corso Giovanni Agnelli, 45, 10134 Torino TO",
      city="Turin", country="IT",
      latitude=45.0395902, longitude=7.6474557,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d754c040-f8b9-4e1c-8c7f-eeec79c2cb36_photo.jpg",
      averageRating=4.3, totalRatingsCount=849,
      createdAt="2026-08-31T23:24:28.576196Z", updatedAt="2026-08-31T23:24:28.576196Z",
    ),
    ClubDto(
      id="6a4b757a-005b-41c2-89f6-644479c09648", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polisportiva Campus", address="Via Pietro Cossa, 293/12, 10151 Torino TO",
      city="Turin", country="IT",
      latitude=45.0967556, longitude=7.632879,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d9f919c8-e8a5-4461-ab88-b259af321849_photo.jpg",
      averageRating=4.3, totalRatingsCount=537,
      createdAt="2026-08-31T23:24:12.671699Z", updatedAt="2026-08-31T23:24:12.671699Z",
    ),
    ClubDto(
      id="af80cd5f-ec89-43ef-882d-ef788a330b71", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sisport Mirafiori", address="Via Pier Domenico Olivero, 40, 10135 Torino TO",
      city="Turin", country="IT",
      latitude=45.0307446, longitude=7.6479711,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d062d37d-433a-4df1-bbd7-53d75390b0b2_photo.jpg",
      averageRating=4.3, totalRatingsCount=1853,
      createdAt="2026-08-31T23:25:02.642061Z", updatedAt="2026-08-31T23:25:02.642061Z",
    ),
    ClubDto(
      id="9a6a8416-bfc7-42df-b2eb-96559ac5bcf8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Monviso Sporting Club", address="Corso C. G. Allamano, 25, 10095 Grugliasco TO",
      city="Turin", country="IT",
      latitude=45.0525751, longitude=7.5838084,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b3c02ca0-e4bc-4a80-b3ad-1765c8cf225c_photo.jpg",
      averageRating=4.2, totalRatingsCount=929,
      createdAt="2026-08-31T23:24:22.954536Z", updatedAt="2026-08-31T23:24:22.954536Z",
    ),
    ClubDto(
      id="0a8af1a7-562b-46cc-a7d7-fd9e45d128a5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Village", address="V. San Pancrazio, 11, 10040 San Gillio TO",
      city="Turin", country="IT",
      latitude=45.138652, longitude=7.5365571,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/34f74c33-48fb-4a92-8608-85d89a374be9_photo.jpg",
      averageRating=4.2, totalRatingsCount=65,
      createdAt="2026-08-31T23:26:26.329369Z", updatedAt="2026-08-31T23:26:26.329369Z",
    ),
    ClubDto(
      id="54e8154b-ef73-4530-a4b6-99b0ea397675", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palacollegno", address="Via Antica di Rivoli, 21, 10093 Collegno TO",
      city="Turin", country="IT",
      latitude=45.0829477, longitude=7.5610373,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11f68478-84e8-4d91-a26f-e7575027ed28_photo.jpg",
      averageRating=4.2, totalRatingsCount=879,
      createdAt="2026-08-31T23:24:54.722812Z", updatedAt="2026-08-31T23:24:54.722812Z",
    ),
    ClubDto(
      id="01de6f50-ed73-4b9c-a512-9cabb298e0a9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Club Stupinigi", address="Corso Unione Sovietica, 506/A, 10135 Torino TO",
      city="Turin", country="IT",
      latitude=45.0176249, longitude=7.6284843,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9b2d7d2e-17f2-493a-942d-a0535227e4fe_photo.jpg",
      averageRating=4.1, totalRatingsCount=296,
      createdAt="2026-08-31T23:25:32.888112Z", updatedAt="2026-08-31T23:25:32.888112Z",
    ),
    ClubDto(
      id="a2135f5a-a871-45c6-b5a5-c9bb725d09ff", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="XGAMER BEINASCO", address="Str. Torino, 31, 10092 Beinasco TO",
      city="Turin", country="IT",
      latitude=45.0262393, longitude=7.592338,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9177ee1b-ac8f-4f20-8234-f52a0e7b317d_photo.jpg",
      averageRating=4.1, totalRatingsCount=206,
      createdAt="2026-08-31T23:25:57.104259Z", updatedAt="2026-08-31T23:25:57.104259Z",
    ),
    ClubDto(
      id="c930ba2f-0341-46d5-8a6e-9af0b5f2dfc7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Leini", address="Via Torino, 135, 10040 Leini TO",
      city="Turin", country="IT",
      latitude=45.1663954, longitude=7.7125325,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b88493f0-7203-47a3-8e90-063bc9aec97a_photo.jpg",
      averageRating=3.8, totalRatingsCount=1147,
      createdAt="2026-08-31T23:25:52.731197Z", updatedAt="2026-08-31T23:25:52.731197Z",
    ),
    ClubDto(
      id="7172783a-c745-4d5b-a9cc-4620465261f2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cit Turin LDE", address="C.so Francesco Ferrucci, 63A, 10138 Torino TO",
      city="Turin", country="IT",
      latitude=45.0699097, longitude=7.6559494,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d068505c-194c-4cfe-b5da-9e15b34788b1_photo.jpg",
      averageRating=3.7, totalRatingsCount=756,
      createdAt="2026-08-31T23:24:08.441289Z", updatedAt="2026-08-31T23:24:08.441289Z",
    ),
    ClubDto(
      id="933a1c6c-a485-4a65-b922-75b4c6eabb27", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="U.S.D. Barracuda", address="Via Enrico Dandolo, 48/A, 10137 Torino TO",
      city="Turin", country="IT",
      latitude=45.0375846, longitude=7.6308421,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bde6e4cf-8822-418a-9ed2-3122d7cf1286_photo.jpg",
      averageRating=3.6, totalRatingsCount=465,
      createdAt="2026-08-31T23:24:18.366627Z", updatedAt="2026-08-31T23:24:18.366627Z",
    ),
  )),
  CitySeo(slug="florence", name="Florence", country="IT", clubCount=26, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Basketball", 3), Pair("Padel", 3), Pair("Volleyball", 3), Pair("Paintball", 2), Pair("Climbing", 2), Pair("Golf", 1), Pair("Karting", 1), Pair("Billiards", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="1259f762-0506-409c-ad22-364c254e852f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Agliana Padel Club", address="Via Giovannella, 6, 51031 Agliana PT",
      city="Florence", country="IT",
      latitude=43.9088299, longitude=10.9990539,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d131614e-cea5-4ef2-956e-3f825eb85233_photo.jpg",
      averageRating=5.0, totalRatingsCount=178,
      createdAt="2026-08-31T23:30:01.485775Z", updatedAt="2026-08-31T23:30:01.485775Z",
    ),
    ClubDto(
      id="a55b536c-581b-4bb6-9e0c-cee4ab9c4f11", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ASD Paintball Florence", address="Via dei Platani, 13B, 50013 Campi Bisenzio FI",
      city="Florence", country="IT",
      latitude=43.7954895, longitude=11.1379961,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bbea01db-7d8a-4de3-8fe3-80a81e5a955e_photo.jpg",
      averageRating=4.8, totalRatingsCount=94,
      createdAt="2026-08-31T23:31:19.594055Z", updatedAt="2026-08-31T23:31:19.594055Z",
    ),
    ClubDto(
      id="63234d37-103d-4621-8076-a78663b6126d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Padel Firenze", address="Via Generale C. A. dalla Chiesa, 11, 50136 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7644455, longitude=11.3091739,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4685e29-5175-477a-b59b-0a81a1cdba0c_photo.jpg",
      averageRating=4.8, totalRatingsCount=110,
      createdAt="2026-08-31T23:30:05.103671Z", updatedAt="2026-08-31T23:30:05.103671Z",
    ),
    ClubDto(
      id="62ab9e0c-caa1-4be5-890d-307f2693c8dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rocco B. Commisso Viola Park", address="Q85C+23, Via Pian di Ripoli, 5, 50012 Bagno a Ripoli FI",
      city="Florence", country="IT",
      latitude=43.7574507, longitude=11.3201044,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/40c2d85f-3cd5-4a4a-b0ce-a80af8eb04dd_photo.jpg",
      averageRating=4.8, totalRatingsCount=993,
      createdAt="2026-08-31T23:28:59.670287Z", updatedAt="2026-08-31T23:28:59.670287Z",
    ),
    ClubDto(
      id="cb3a6810-fbca-4e6c-8a47-ef6631773a91", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beta House Climbing", address="Via Giulio Pastore, 34, 50019 Sesto Fiorentino FI",
      city="Florence", country="IT",
      latitude=43.8318114, longitude=11.180184,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e57c86a-23a5-4df8-b633-10928194d779_photo.jpg",
      averageRating=4.7, totalRatingsCount=153,
      createdAt="2026-08-31T23:31:02.620199Z", updatedAt="2026-08-31T23:31:02.620199Z",
    ),
    ClubDto(
      id="e70457b9-47ae-498c-afd6-fc3c909ffe35", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bpadel Guelfi Firenze", address="Via del Perugino, 45, 50142 Firenze FI",
      city="Florence", country="IT",
      latitude=43.776777, longitude=11.1876975,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/970c928c-56c7-45bc-80f2-8a904feee79a_photo.jpg",
      averageRating=4.7, totalRatingsCount=87,
      createdAt="2026-08-31T23:30:09.755622Z", updatedAt="2026-08-31T23:30:09.755622Z",
    ),
    ClubDto(
      id="945fcd2a-a43f-49f2-aa4d-164ca2998838", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Area51 Climbing Center", address="Via di Casellina, 73/E, 50018 Scandicci FI",
      city="Florence", country="IT",
      latitude=43.757362, longitude=11.1666397,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/32438495-1b31-4d92-a2e1-447f9f85e180_photo.jpg",
      averageRating=4.6, totalRatingsCount=187,
      createdAt="2026-08-31T23:30:57.795705Z", updatedAt="2026-08-31T23:30:57.795705Z",
    ),
    ClubDto(
      id="371c8fff-c96a-4ac1-8595-9e79f002bebb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Circolo Golf dell'Ugolino", address="Via Chiantigiana Per Strada, 3, 50023 Impruneta FI",
      city="Florence", country="IT",
      latitude=43.6974074, longitude=11.2966044,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fbfe6d86-19ac-48fe-b5c9-c3eb2fd838f9_photo.jpg",
      averageRating=4.6, totalRatingsCount=497,
      createdAt="2026-08-31T23:30:43.211502Z", updatedAt="2026-08-31T23:30:43.211502Z",
    ),
    ClubDto(
      id="7503fd79-2ffa-4baf-b268-8c12bc604461", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Match Ball Firenze Country Club s.s.d.", address="Via della Massa, 40, 50012 Bagno a Ripoli FI",
      city="Florence", country="IT",
      latitude=43.7664142, longitude=11.329844,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0f402fb5-f788-45fa-89e2-40bc246bcc94_photo.jpg",
      averageRating=4.6, totalRatingsCount=379,
      createdAt="2026-08-31T23:29:47.758743Z", updatedAt="2026-09-01T14:31:43.580872Z",
    ),
    ClubDto(
      id="87a6f0ac-fcab-40b0-b1ff-f228fb20736b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="A Colpi Di Paintball a.s.d.", address="Via Piandaccoli, 50055 Ginestra Fiorentina FI",
      city="Florence", country="IT",
      latitude=43.7200637, longitude=11.0423143,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/29f2ca6b-44f4-4bc6-89c9-5bc2531f2e5f_photo.jpg",
      averageRating=4.5, totalRatingsCount=238,
      createdAt="2026-08-31T23:31:14.727240Z", updatedAt="2026-08-31T23:31:14.727240Z",
    ),
    ClubDto(
      id="55f35cb4-2ddc-4688-bd99-801027cd79e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Games Firenze", address="Via Empoli, 16/2, 50142 Firenze FI",
      city="Florence", country="IT",
      latitude=43.771074, longitude=11.204142,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0c4654b9-e8b7-4cac-a32a-3c80471965af_photo.jpg",
      averageRating=4.4, totalRatingsCount=141,
      createdAt="2026-08-31T23:30:26.980322Z", updatedAt="2026-08-31T23:30:26.980322Z",
    ),
    ClubDto(
      id="5cadc5ef-0332-4b63-96dd-9b850c3325ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Sportivo Firenze", address="Via del Fosso Macinante, 13, 50144 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7783265, longitude=11.2339148,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/92079599-12dc-4776-95e3-13b82938620c_photo.jpg",
      averageRating=4.4, totalRatingsCount=229,
      createdAt="2026-08-31T23:29:25.086551Z", updatedAt="2026-08-31T23:29:25.086551Z",
    ),
    ClubDto(
      id="6c45befe-2dbe-451b-96b3-148628c1b8b7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hangar 42", address="Via Vittorio Emanuele, 42, 50041 Calenzano FI",
      city="Florence", country="IT",
      latitude=43.8464698, longitude=11.174468,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/26678930-cbd2-4d87-91ed-c7786b244277_photo.jpg",
      averageRating=4.4, totalRatingsCount=919,
      createdAt="2026-08-31T23:30:54.162243Z", updatedAt="2026-08-31T23:30:54.162243Z",
    ),
    ClubDto(
      id="20c239ac-a035-4939-bbc5-bbce3e917318", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Baloncesto Basket Firenze", address="Via A. Canova, 1, 50142 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7741759, longitude=11.2119005,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e9ee38bf-5890-4c03-a937-8ba7a2cad9d2_photo.jpg",
      averageRating=4.3, totalRatingsCount=65,
      createdAt="2026-08-31T23:30:23.230146Z", updatedAt="2026-08-31T23:30:23.230146Z",
    ),
    ClubDto(
      id="b2466440-90f6-47f0-bbee-0b706a12af69", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Fiorita Tennis Padel Club \" Consalvo Romoli\"", address="Via Alfiero Gemmi caduto dello Scire, 2, 50018 Badia a Settimo, FI",
      city="Florence", country="IT",
      latitude=43.776694, longitude=11.14402,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/642dd662-833e-4746-af68-0f6a02bcd970_photo.jpg",
      averageRating=4.3, totalRatingsCount=271,
      createdAt="2026-08-31T23:29:56.894378Z", updatedAt="2026-09-01T14:31:45.141312Z",
    ),
    ClubDto(
      id="4f63b1b3-9ef1-4ae3-817f-3003a5bc7e29", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="A.D. Dlf Firenze Basket", address="Via Giovanni Paisiello, 131, 50144 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7845975, longitude=11.2247207,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5deacd00-6f3e-4868-94a4-31c0b5513b3f_photo.jpg",
      averageRating=4.2, totalRatingsCount=90,
      createdAt="2026-08-31T23:30:18.250223Z", updatedAt="2026-08-31T23:30:18.250223Z",
    ),
    ClubDto(
      id="affa5aba-9e36-42b6-a9bf-a2ee2cc065eb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BeachVolley&Tennis - Centro Sportivo Associazione Dipendenti IGM (Ex \"Il Giglio\")", address="Via Giuseppe de Robertis, 7/2, 50135 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7756529, longitude=11.306079,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8d547ca0-adff-4539-96ba-b7188d3275aa_photo.jpg",
      averageRating=4.2, totalRatingsCount=73,
      createdAt="2026-08-31T23:30:31.856489Z", updatedAt="2026-08-31T23:30:31.856489Z",
    ),
    ClubDto(
      id="ca7daaaf-9c65-499d-acc7-a1c5dbff7205", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Sportivo Anchetta", address="Via Aretina, 42, 50014 Fiesole FI",
      city="Florence", country="IT",
      latitude=43.7705965, longitude=11.3449489,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/21a59fb8-ffd6-4aa1-9b10-0fc95f47894d_photo.jpg",
      averageRating=4.2, totalRatingsCount=338,
      createdAt="2026-08-31T23:29:52.535459Z", updatedAt="2026-09-01T14:31:58.132513Z",
    ),
    ClubDto(
      id="3238c6b9-a619-4055-a38a-fca97ed7e8fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club Sesto", address="Via degli Scarpettini, 39/A, 50019 Sesto Fiorentino FI",
      city="Florence", country="IT",
      latitude=43.8433848, longitude=11.1933271,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6fb3b1e3-78a3-4e0f-80f5-e00bf8e693fe_photo.jpg",
      averageRating=4.2, totalRatingsCount=454,
      createdAt="2026-08-31T23:29:41.900468Z", updatedAt="2026-08-31T23:29:41.900468Z",
    ),
    ClubDto(
      id="ec30a2d8-90d4-44b6-9580-f8e1748254f8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="A.S.D. Florence Sporting Club", address="Via di Ugnano, 50142 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7865758, longitude=11.1670288,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d553952e-7d45-4a4b-8f25-825a5d041e81_photo.jpg",
      averageRating=4.1, totalRatingsCount=282,
      createdAt="2026-08-31T23:29:14.956271Z", updatedAt="2026-08-31T23:29:14.956271Z",
    ),
    ClubDto(
      id="6fa12a9a-609e-4b65-9926-8f38faa07fe8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stadio Comunale Gino Bozzi", address="Via Stefano Borgonovo, 50125 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7490654, longitude=11.2386694,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d34f3195-5b5e-41f7-a1f2-2b0870dc06d4_photo.jpg",
      averageRating=4.1, totalRatingsCount=715,
      createdAt="2026-08-31T23:29:05.595286Z", updatedAt="2026-08-31T23:29:05.595286Z",
    ),
    ClubDto(
      id="7c666af1-bcb2-46a5-b4a1-8f858563e794", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Upd Isolotto", address="Via Pio Fedi, 7, 50142 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7803747, longitude=11.2049889,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8ac9b85c-1a4e-406a-85d5-08d2ae3d5ae1_photo.jpg",
      averageRating=4.1, totalRatingsCount=285,
      createdAt="2026-08-31T23:29:10.864966Z", updatedAt="2026-08-31T23:29:10.864966Z",
    ),
    ClubDto(
      id="26f665ad-d539-47aa-812c-39829ac7e73f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Florence West Volleyball", address="Piazza Primo Maggio, 50145 Brozzi, Firenze FI",
      city="Florence", country="IT",
      latitude=43.7956784, longitude=11.1692795,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7dded22e-45e2-4c8e-b9bb-2458fc90f21a_photo.jpg",
      averageRating=4.0, totalRatingsCount=68,
      createdAt="2026-08-31T23:30:38.240493Z", updatedAt="2026-08-31T23:30:38.240493Z",
    ),
    ClubDto(
      id="2dd76d98-6215-4860-bc08-080a17a54f7e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Piscine Le Pavoniere", address="Viale della Catena, 2, 50144 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7794402, longitude=11.2237343,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5905a760-b39c-4f68-800e-42995ff80ce6_photo.jpg",
      averageRating=3.9, totalRatingsCount=2660,
      createdAt="2026-08-31T23:31:06.309773Z", updatedAt="2026-08-31T23:31:06.309773Z",
    ),
    ClubDto(
      id="7ba31832-672c-46e1-96d5-872b5676e3ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sancat", address="Via del Mezzetta, 1, 50135 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7716458, longitude=11.2982214,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/66576deb-acff-4583-b998-25caf073df38_photo.jpg",
      averageRating=3.9, totalRatingsCount=313,
      createdAt="2026-08-31T23:30:13.260218Z", updatedAt="2026-08-31T23:30:13.260218Z",
    ),
    ClubDto(
      id="8d2d402f-0ec2-46b8-8428-e01974d08129", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SSD CIATT FIRENZE Tennistavolo", address="Via Lunga, 94, 50142 Firenze FI",
      city="Florence", country="IT",
      latitude=43.7755241, longitude=11.204317,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4004a0aa-656d-46b6-a76b-fc567a0c28f5_photo.jpg",
      averageRating=4.8, totalRatingsCount=18,
      createdAt="2026-08-31T23:30:49.558128Z", updatedAt="2026-08-31T23:30:49.558128Z",
    ),
  )),
  CitySeo(slug="izmir", name="Izmir", country="TR", clubCount=26, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Volleyball", 3), Pair("Bowling", 2), Pair("Padel", 2), Pair("Basketball", 2), Pair("Paintball", 2), Pair("Karting", 2), Pair("Billiards", 2), Pair("Climbing", 1), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="df78ebc8-fd5f-4f92-a39c-c20836771464", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bornova ES Tenis Kulübü", address="Yakaköy, Reyhan Sk. No:11 D:2, 35040 Bornova/İzmir",
      city="Izmir", country="TR",
      latitude=38.5102797, longitude=27.3189785,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d7c653a5-3476-47f3-9519-35648396f260_photo.jpg",
      averageRating=5.0, totalRatingsCount=181,
      createdAt="2026-08-31T23:53:38.163952Z", updatedAt="2026-08-31T23:53:38.163952Z",
    ),
    ClubDto(
      id="fe81df0b-6866-4862-bf20-4200e502c562", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Area Padel Club", address="Atatürk OSB, 10015. Sk. No:10 A.O.S.B, 35620 Çiğli/İzmir",
      city="Izmir", country="TR",
      latitude=38.4899769, longitude=27.0422018,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b232b1f5-476a-44e3-95ff-1b9c2b0c7ce9_photo.jpg",
      averageRating=4.9, totalRatingsCount=78,
      createdAt="2026-08-31T23:54:05.221634Z", updatedAt="2026-08-31T23:54:05.221634Z",
    ),
    ClubDto(
      id="1581ba30-d531-4d8a-9f12-d1fa10e454e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PINE PADEL CLUB", address="Zafer, Atatürk Cd. No:196, 35395 Buca/İzmir",
      city="Izmir", country="TR",
      latitude=38.3647488, longitude=27.2165369,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/280c6570-b8f5-4d28-9b71-d118f965f7e1_photo.jpg",
      averageRating=4.9, totalRatingsCount=91,
      createdAt="2026-08-31T23:53:56.589918Z", updatedAt="2026-08-31T23:53:56.589918Z",
    ),
    ClubDto(
      id="91c390bc-ab84-4070-8958-6a0bd26b65b7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Royal Bowling Gokart Balçova (Selway)", address="Çetin Emeç Mah. Çeşme, Kıvanç Sok. Selway Outlet AVM, Çetin Emeç, İzmir Çevre Yolu, 35330 Balçova/İzmir",
      city="Izmir", country="TR",
      latitude=38.3762433, longitude=27.0755736,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a5119322-5eb1-418a-b3bd-faac002b5160_photo.jpg",
      averageRating=4.9, totalRatingsCount=1112,
      createdAt="2026-08-31T23:54:45.952688Z", updatedAt="2026-08-31T23:54:45.952688Z",
    ),
    ClubDto(
      id="2f7bc33a-a717-4f23-a66f-3b737c24a50c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BULUT TENİS AKADEMİSİ KORTU", address="Yenigün, 265/8. Sk., 35240 Buca/İzmir",
      city="Izmir", country="TR",
      latitude=38.3787542, longitude=27.1601719,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fbf81917-d85d-4b14-a2f3-550cb57d34bc_photo.jpg",
      averageRating=4.8, totalRatingsCount=132,
      createdAt="2026-08-31T23:53:51.580025Z", updatedAt="2026-08-31T23:53:51.580025Z",
    ),
    ClubDto(
      id="d9adc843-0731-4dd8-905b-344485e262bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ALTIN RAKET TENİS KULÜBÜ", address="Dokuz Eylül, 698. Sk. No:5, 35410 Gaziemir/İzmir",
      city="Izmir", country="TR",
      latitude=38.3074678, longitude=27.1449498,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dab1721e-9daa-4ad2-828f-32839b5f9c2f_photo.jpg",
      averageRating=4.7, totalRatingsCount=166,
      createdAt="2026-08-31T23:53:46.874750Z", updatedAt="2026-08-31T23:53:46.874750Z",
    ),
    ClubDto(
      id="3a86be8e-ba84-4c72-953d-56d591ca3ab8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ISONEM Park Gürsel Aksel Spor ve Sağlıklı Yaşam Merkezi", address="Mehmet Ali Akman, İnönü Cd. No: 640, 35290 Konak/İzmir",
      city="Izmir", country="TR",
      latitude=38.3968929, longitude=27.0758606,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1b85dc05-d89c-4d30-9a0b-1d155d6f36ab_photo.jpg",
      averageRating=4.7, totalRatingsCount=4541,
      createdAt="2026-08-31T23:53:06.538297Z", updatedAt="2026-08-31T23:53:06.538297Z",
    ),
    ClubDto(
      id="eb31313e-7b29-4f6b-ad45-8c5e427fd38c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mustafa Kemal Spor Salonu", address="Mavişehir, Hasan Tahsin Uzer Cad., 35540 Karşıyaka/İzmir",
      city="Izmir", country="TR",
      latitude=38.4744555, longitude=27.0762271,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/af6f994e-6c60-470e-9aa8-f639b23e55b2_photo.jpg",
      averageRating=4.6, totalRatingsCount=1200,
      createdAt="2026-08-31T23:54:09.936366Z", updatedAt="2026-08-31T23:54:09.936366Z",
    ),
    ClubDto(
      id="51b68061-57bd-432c-a7e7-8f0606b546ab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sarnıç Football and Tennis Club", address="Hürriyet, Çamlık Cd. No : 81, 35414 Gaziemir/İzmir",
      city="Izmir", country="TR",
      latitude=38.3018772, longitude=27.179955,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84e95bf0-44ed-4bc5-a04d-20700219a3c4_photo.jpg",
      averageRating=4.6, totalRatingsCount=161,
      createdAt="2026-08-31T23:53:23.406547Z", updatedAt="2026-09-01T14:31:44.361661Z",
    ),
    ClubDto(
      id="6e274dba-acd8-4577-a05a-e226b8f8948d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tribal Bilardo Ihtisas Ve Spor Kulübü", address="Onur, Böğürtlen Sk. 3/A, 35330 Balçova/İzmir",
      city="Izmir", country="TR",
      latitude=38.3896856, longitude=27.0573168,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5dd240d1-2b9a-428e-a175-c6882f4fac45_photo.jpg",
      averageRating=4.6, totalRatingsCount=135,
      createdAt="2026-08-31T23:55:25.277187Z", updatedAt="2026-08-31T23:55:25.277187Z",
    ),
    ClubDto(
      id="516bbddd-69b8-4bb7-9080-adc3ab874c1a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Altınordu Futbol Okulu", address="Kazımdirik, İzmir Çevre Yolu, 35100 Bornova/İzmir",
      city="Izmir", country="TR",
      latitude=38.4629325, longitude=27.2054119,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8baa2a84-7e81-401c-ac1a-f29f42623df5_photo.jpg",
      averageRating=4.5, totalRatingsCount=284,
      createdAt="2026-08-31T23:53:17.059441Z", updatedAt="2026-08-31T23:53:17.059441Z",
    ),
    ClubDto(
      id="4e1ddff4-be97-4719-9546-3576ae8de5b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Batı Paintball", address="Şht, Aktepe, Altan Aydın Cd. No:55, 35410 Gaziemir/İzmir",
      city="Izmir", country="TR",
      latitude=38.3567397, longitude=27.1243637,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0ed1a729-7d15-4f09-b681-802aee148758_photo.jpg",
      averageRating=4.5, totalRatingsCount=731,
      createdAt="2026-08-31T23:55:34.496641Z", updatedAt="2026-08-31T23:55:34.496641Z",
    ),
    ClubDto(
      id="8ce3e444-6474-4bf2-b5b5-7b6b2f006e73", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climbinn", address="Narpark Residance, Kazımdirik, 367/4 Sk no/5, 35100 Bornova/İzmir",
      city="Izmir", country="TR",
      latitude=38.4525566, longitude=27.2044618,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a878fd4-8f7e-4947-95a0-40954598e379_photo.jpg",
      averageRating=4.5, totalRatingsCount=137,
      createdAt="2026-08-31T23:55:16.547696Z", updatedAt="2026-08-31T23:55:16.547696Z",
    ),
    ClubDto(
      id="8436db2e-c2bd-469d-afb2-286b5a964fe3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karşıyaka Spor Kulübü Selçuk Yaşar Spor Tesisleri", address="Ataşehir, Yeni Havaalanı Cd. No:13, 35620 Çiğli/İzmir",
      city="Izmir", country="TR",
      latitude=38.4852391, longitude=27.0739507,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c9ab4ff1-198e-4c47-a463-756b6186ba07_photo.jpg",
      averageRating=4.5, totalRatingsCount=660,
      createdAt="2026-08-31T23:54:41.670184Z", updatedAt="2026-08-31T23:54:41.670184Z",
    ),
    ClubDto(
      id="6fcfaee6-77b6-489a-ae25-9b7c5f6accc0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Royal Bowling & Bilardo", address="Kidsmall, Kazımdirik, 367/6 Sk No: 5/11-12, 35100 Bornova/İzmir",
      city="Izmir", country="TR",
      latitude=38.4502289, longitude=27.2074394,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/372bfc2f-10d5-4f68-a1de-bdfba201d9f9_photo.jpg",
      averageRating=4.5, totalRatingsCount=571,
      createdAt="2026-08-31T23:54:55.827063Z", updatedAt="2026-08-31T23:54:55.827063Z",
    ),
    ClubDto(
      id="fe83ee81-3d35-43ac-9c55-9af0ea6cced7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Atatürk Sports Hall", address="Mimar Sinan, Ali Çetinkaya Blv No:75, 35220 Konak/İzmir",
      city="Izmir", country="TR",
      latitude=38.433708, longitude=27.1474491,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/13ab2bd0-d0d3-40a1-b142-f643e5ace7d3_photo.jpg",
      averageRating=4.4, totalRatingsCount=926,
      createdAt="2026-08-31T23:54:15.087652Z", updatedAt="2026-08-31T23:54:15.087652Z",
    ),
    ClubDto(
      id="4ac02cd9-4bf4-4c4b-a6c0-5c3de52aa2c1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kültürpark Tenis Kulübü", address="Mimar Sinan, 35220 Konak/İzmir",
      city="Izmir", country="TR",
      latitude=38.4300728, longitude=27.1477508,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/144dd46a-ef41-48f0-aea4-5a819a1ef1ff_photo.jpg",
      averageRating=4.4, totalRatingsCount=227,
      createdAt="2026-08-31T23:53:33.731409Z", updatedAt="2026-08-31T23:53:33.731409Z",
    ),
    ClubDto(
      id="8ebb8eda-46bf-47f5-baaa-c23f654a9ec6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="OLİMPİYAT HALI SAHA", address="1595 Sokak.no:189.karşıyaka Devlet Hastanesi Yanı, İmbatlı, 06101 Karşıyaka/İzmir",
      city="Izmir", country="TR",
      latitude=38.4755087, longitude=27.1047472,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c45e8157-9345-4d24-9564-be124502f635_photo.jpg",
      averageRating=4.4, totalRatingsCount=132,
      createdAt="2026-08-31T23:53:27.796213Z", updatedAt="2026-08-31T23:53:27.796213Z",
    ),
    ClubDto(
      id="4acc4da9-edc7-482c-acc6-02dd0a30a5cf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Salon 8 Bilardo", address="1671 SOKAK NO 56/A KARŞIYAKA ALAYBEY METRO YANI, Bahariye, 35600 Karşıyaka/İzmir",
      city="Izmir", country="TR",
      latitude=38.4605761, longitude=27.1214015,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/61ca29f1-fbbe-46e8-a2d3-4d3e3fc83f78_photo.jpg",
      averageRating=4.4, totalRatingsCount=250,
      createdAt="2026-08-31T23:55:20.591181Z", updatedAt="2026-08-31T23:55:20.591181Z",
    ),
    ClubDto(
      id="42981495-260f-4352-bb22-0781ea872ac7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Celal Atik Sports Hall", address="Mimar Sinan, Basmane Fuariçi Cad., 35220 ALSANCAK / KONAK/Konak/İzmir",
      city="Izmir", country="TR",
      latitude=38.42598, longitude=27.1432861,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d9196956-5fc0-4979-a867-7400fe8ce269_photo.jpg",
      averageRating=4.2, totalRatingsCount=745,
      createdAt="2026-08-31T23:54:31.504804Z", updatedAt="2026-08-31T23:54:31.504804Z",
    ),
    ClubDto(
      id="ab418937-fad9-4707-8dda-9937bd39a600", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="İzmir Arena", address="Turan, 1649. Sk. No:107, 35540 Bayraklı/İzmir",
      city="Izmir", country="TR",
      latitude=38.4655803, longitude=27.1452416,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99df4585-0af9-4d5e-8e46-be8e56336ed5_photo.jpg",
      averageRating=4.2, totalRatingsCount=2609,
      createdAt="2026-08-31T23:55:30.306085Z", updatedAt="2026-08-31T23:55:30.306085Z",
    ),
    ClubDto(
      id="67e45f36-f122-4338-980f-a73f3633742d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Evka-4 Sports Complexes", address="Evka 4, 1027. Sk. No:24, 35030 Bornova/İzmir",
      city="Izmir", country="TR",
      latitude=38.4894386, longitude=27.2139517,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6240e4b7-913a-42c7-b2df-59de06e432d2_photo.jpg",
      averageRating=4.1, totalRatingsCount=672,
      createdAt="2026-08-31T23:54:36.542372Z", updatedAt="2026-08-31T23:54:36.542372Z",
    ),
    ClubDto(
      id="10a2f4f8-4796-4d8c-b3b6-20914922901c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Homer Paintball", address="Homeros Vadisi 4. Piknik Alanı, Çamiçi, Çilek Sk. 17/A, 35040 Bornova/İzmir",
      city="Izmir", country="TR",
      latitude=38.5100066, longitude=27.2305748,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1535d903-7b83-4af0-863f-b34b33f0b2a0_photo.jpg",
      averageRating=4.1, totalRatingsCount=575,
      createdAt="2026-08-31T23:55:39.784834Z", updatedAt="2026-08-31T23:55:39.784834Z",
    ),
    ClubDto(
      id="41e3bfd5-7541-4eb8-a063-7ea4b8f7cc06", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vizyon Sports", address="Mevlana, 35050 Bornova/İzmir",
      city="Izmir", country="TR",
      latitude=38.4485606, longitude=27.219168,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84624628-1df5-4495-a200-081b3ebcd490_photo.jpg",
      averageRating=4.1, totalRatingsCount=324,
      createdAt="2026-08-31T23:53:11.442149Z", updatedAt="2026-08-31T23:53:11.442149Z",
    ),
    ClubDto(
      id="ae5e5644-1baf-429d-889a-93d325024429", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="İzmir Go Park", address="Dokuz Eylül, 695. Sk. No 6, 35410 Gaziemir/İzmir",
      city="Izmir", country="TR",
      latitude=38.3118806, longitude=27.1482505,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f0ba69d4-8c20-4949-849f-83fe6444f2c3_photo.jpg",
      averageRating=3.8, totalRatingsCount=1037,
      createdAt="2026-08-31T23:54:49.846367Z", updatedAt="2026-08-31T23:54:49.846367Z",
    ),
    ClubDto(
      id="5d2a97f4-272b-4c74-96ef-4063a11f4227", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AFM Bowling", address="Doğanlar Mahallesi Ankara Asfaltı Park Bornova Outlet Center No:192, Doğanlar, Park Bornova Outlet Center, 35050 Bornova/İzmir",
      city="Izmir", country="TR",
      latitude=38.4565647, longitude=27.2468285,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c8748aae-8030-42f4-b2db-3108007a120b_photo.jpg",
      averageRating=3.6, totalRatingsCount=261,
      createdAt="2026-08-31T23:55:00.800176Z", updatedAt="2026-08-31T23:55:00.800176Z",
    ),
  )),
  CitySeo(slug="krakow", name="Krakow", country="PL", clubCount=26, sports=listOf(Pair("Padel", 3), Pair("Football", 3), Pair("Tennis", 3), Pair("Climbing", 2), Pair("Volleyball", 2), Pair("Bowling", 2), Pair("Basketball", 2), Pair("Karting", 2), Pair("Paintball", 2), Pair("Table Tennis", 2), Pair("Laser Tag", 1), Pair("Golf", 1), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="15a7a81e-5bad-4bd6-9ee7-3cb2b9006f86", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bajada Padel Club", address="Tyniecka 215, 30-381 Kraków",
      city="Krakow", country="PL",
      latitude=50.0243957, longitude=19.8373337,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8273a494-55d9-4ae4-bce5-d8b7afa59640_ChIJx1BRAgpd_0.jpg",
      averageRating=5.0, totalRatingsCount=74,
      createdAt="2026-08-30T21:29:32.002732Z", updatedAt="2026-09-01T14:31:46.524617Z",
    ),
    ClubDto(
      id="a9e30fc2-551d-4f1d-9ea1-0e27b42f8af4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Walks Krakow", address="Rynek Główny 4, 33-332 Kraków",
      city="Krakow", country="PL",
      latitude=50.0613712, longitude=19.9386619,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4690c8a7-64f0-4c01-9e8f-15f09b444180_ChIJB2Qi97Nb_0.jpg",
      averageRating=5.0, totalRatingsCount=1778,
      createdAt="2026-08-30T21:28:00.075141Z", updatedAt="2026-08-30T21:56:06.249863Z",
    ),
    ClubDto(
      id="c61dd5b0-ae6e-4382-be9a-5433656db578", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SmartPong Tenis Stołowy Ping Pong", address="Zakopiańska 58, 30-418 Kraków",
      city="Krakow", country="PL",
      latitude=50.0170896, longitude=19.9335427,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1d14a2fc-8b96-433d-9ee7-5001e88f4b1a_photo.jpg",
      averageRating=5.0, totalRatingsCount=88,
      createdAt="2026-08-31T15:14:18.061636Z", updatedAt="2026-08-31T15:14:18.061636Z",
    ),
    ClubDto(
      id="560c318e-0f2a-4157-8b79-04a4625d5f18", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Jednostka Paintballowa Kraków Zakrzówek", address="Świętego Jacka, 30-364 Kraków",
      city="Krakow", country="PL",
      latitude=50.0331288, longitude=19.9139613,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/abfa3a7a-8989-4542-834c-22645f0f7549_ChIJm-4J5npd_0.jpg",
      averageRating=4.9, totalRatingsCount=1955,
      createdAt="2026-08-30T21:29:10.205719Z", updatedAt="2026-08-30T21:57:28.629475Z",
    ),
    ClubDto(
      id="e4cba9f4-85d2-495a-85c0-cca1e53c1ab6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FUN PARK Kraków", address="Osiedle Teatralne 10, 31-946 Kraków",
      city="Krakow", country="PL",
      latitude=50.0780957, longitude=20.0301189,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f046fa94-a0e6-4e9e-9daf-0cf8c891eb52_ChIJ7c-xCCdF_1.jpg",
      averageRating=4.8, totalRatingsCount=1108,
      createdAt="2026-08-30T21:29:17.018686Z", updatedAt="2026-08-31T22:11:16.550627Z",
    ),
    ClubDto(
      id="957a4856-97a5-4b25-845c-76922e557cba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AVATAR Climbing Gym", address="Sikorki 21A, 31-589 Kraków",
      city="Krakow", country="PL",
      latitude=50.061538, longitude=20.0170731,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dee54b8f-a87f-4f64-8546-a0dff3fc432f_ChIJdV0xg7lE_0.jpg",
      averageRating=4.7, totalRatingsCount=1625,
      createdAt="2026-08-30T21:28:41.919716Z", updatedAt="2026-08-30T21:55:11.856220Z",
    ),
    ClubDto(
      id="9e5d4f18-7578-4570-8740-692933c44616", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Krakow Valley Golf & Country Club", address="Paczółtowice 328, 32-063 Krzeszowice",
      city="Krakow", country="PL",
      latitude=50.1846411, longitude=19.6521163,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9b168238-c847-4b22-b022-191a9d3ee9e2_photo.jpg",
      averageRating=4.7, totalRatingsCount=532,
      createdAt="2026-08-31T15:14:09.943061Z", updatedAt="2026-08-31T15:14:09.943061Z",
    ),
    ClubDto(
      id="2d508d49-bcfd-4e32-af8c-032c496e0b49", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laserpark - laserowy paintball", address="Bosaków 5a/LU86, 31-476 Kraków",
      city="Krakow", country="PL",
      latitude=50.0841931, longitude=19.9624755,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bf199365-fb63-4f78-b0f4-348be4a44684_ChIJ937RzElb_0.jpg",
      averageRating=4.7, totalRatingsCount=2654,
      createdAt="2026-08-30T21:29:02.799265Z", updatedAt="2026-08-30T21:58:20.771472Z",
    ),
    ClubDto(
      id="769f3489-bebf-44e2-8b05-fe669c49fddd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TCF HUB Centrum Sportu i Integracji", address="Osiedle Zielone 9, 31-968 Kraków",
      city="Krakow", country="PL",
      latitude=50.0798907, longitude=20.0438848,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ba4e56cc-fac3-49ce-8d68-d8f5e60e7213_ChIJOYXBx_Fa_0.jpg",
      averageRating=4.7, totalRatingsCount=951,
      createdAt="2026-08-30T21:29:46.067372Z", updatedAt="2026-08-30T22:01:03.869832Z",
    ),
    ClubDto(
      id="aa8b7827-864b-411e-bcf2-eff734452410", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="WRT karting Nowa Huta & HANGAR 30", address="Kornela Makuszyńskiego 30, 31-752 Kraków",
      city="Krakow", country="PL",
      latitude=50.0903803, longitude=20.0348869,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4cb57ada-024b-4885-b869-38c6f5a6bfcc_ChIJ1SDEEUNF_0.jpg",
      averageRating=4.7, totalRatingsCount=2500,
      createdAt="2026-08-30T21:28:48.527484Z", updatedAt="2026-08-30T22:02:22.256530Z",
    ),
    ClubDto(
      id="6bc07f14-081a-4bdd-a327-408d24dbf273", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klub Tenisowy Błonia", address="Na Błoniach 1, 30-213 Kraków",
      city="Krakow", country="PL",
      latitude=50.0582215, longitude=19.9072059,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7692e478-d99b-409c-b104-0a9574b3079e_ChIJkURloplb_0.jpg",
      averageRating=4.6, totalRatingsCount=173,
      createdAt="2026-08-30T21:30:00.046304Z", updatedAt="2026-09-01T14:31:43.319160Z",
    ),
    ClubDto(
      id="2b1f3f70-4dc8-41f1-b11a-a1d0d52988a6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Omerta", address="Kupa 3, 31-057 Kraków",
      city="Krakow", country="PL",
      latitude=50.0521894, longitude=19.9457002,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b791c229-87ef-4990-ae0d-154fa51b2ba5_ChIJmQgaY2pb_0.jpg",
      averageRating=4.6, totalRatingsCount=2742,
      createdAt="2026-08-30T21:27:52.492485Z", updatedAt="2026-08-30T21:27:52.492485Z",
    ),
    ClubDto(
      id="cb2ee779-5e72-424f-9d46-4e9fe620fc69", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling House", address="Stanisława Klimeckiego 14B, 30-706 Kraków",
      city="Krakow", country="PL",
      latitude=50.0489802, longitude=19.9703482,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/be06f2f0-7b4b-46d8-b914-48e71b0acf7b_ChIJf1T_baxb_0.jpg",
      averageRating=4.5, totalRatingsCount=1575,
      createdAt="2026-08-30T21:28:20.925162Z", updatedAt="2026-08-30T21:55:42.660326Z",
    ),
    ClubDto(
      id="27e762e2-5e6d-458b-92e6-a56a7edbea5f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Błonia Sport", address="al. 3 Maja 57, 30-062 Kraków",
      city="Krakow", country="PL",
      latitude=50.0631, longitude=19.9059077,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c2557814-f515-4b6b-8e94-930caa575a98_photo.jpg",
      averageRating=4.5, totalRatingsCount=464,
      createdAt="2026-08-31T15:13:17.031271Z", updatedAt="2026-08-31T15:13:17.031271Z",
    ),
    ClubDto(
      id="d70dd9e5-3c70-427d-ba75-12457b0f1fd1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stara Zajezdnia Kraków", address="Św. Wawrzyńca 12, 31-060 Kraków",
      city="Krakow", country="PL",
      latitude=50.0501198, longitude=19.9471163,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/526f0477-08c6-4f29-9393-6225b8e6a20f_ChIJ6TAc70Fb_1.jpg",
      averageRating=4.5, totalRatingsCount=6214,
      createdAt="2026-08-30T21:27:46.079181Z", updatedAt="2026-08-31T22:11:21.429014Z",
    ),
    ClubDto(
      id="ffdfb661-48cd-47bd-ab21-dc9768d8973e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Plac Nowy 1", address="plac Nowy 1, 31-056 Kraków",
      city="Krakow", country="PL",
      latitude=50.0514183, longitude=19.9454059,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/01a8bdf6-7450-401c-bea6-cba0b7a072e1_ChIJN9gUQ2pb_0.jpg",
      averageRating=4.4, totalRatingsCount=1100,
      createdAt="2026-08-30T21:28:27.744828Z", updatedAt="2026-08-30T21:55:50.143441Z",
    ),
    ClubDto(
      id="bf6e0516-7808-440b-983d-22d4698d0ea1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bronowianka. Sport Club", address="Zarzecze 124a, 30-134 Kraków",
      city="Krakow", country="PL",
      latitude=50.0756127, longitude=19.8815345,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4255690-e839-4259-b054-b244bdc55ac2_photo.jpg",
      averageRating=4.4, totalRatingsCount=582,
      createdAt="2026-08-31T15:14:00.757826Z", updatedAt="2026-08-31T15:14:00.757826Z",
    ),
    ClubDto(
      id="ec6f73ec-c7c0-4628-8eac-ff3f3aba79f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GO Karting Center", address="Mariana Domagały 25, 30-798 Kraków",
      city="Krakow", country="PL",
      latitude=50.0271674, longitude=20.0504354,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/75dfe2ca-ba27-45e8-96b0-867eb09805a4_ChIJd2v5121E_0.jpg",
      averageRating=4.4, totalRatingsCount=1106,
      createdAt="2026-08-30T21:28:55.340536Z", updatedAt="2026-08-30T21:57:03.774291Z",
    ),
    ClubDto(
      id="89226fd0-1673-4a36-bd35-8a3e84a95383", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADEL LOUNGE", address="Morelowa 34, 30-222 Kraków",
      city="Krakow", country="PL",
      latitude=50.0703146, longitude=19.8682074,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/333a87e9-9dd8-494b-baf5-190b2a43e434_ChIJnQzrMgBb_0.jpg",
      averageRating=4.3, totalRatingsCount=70,
      createdAt="2026-08-30T21:29:39.748443Z", updatedAt="2026-08-30T21:29:39.748443Z",
    ),
    ClubDto(
      id="8d712311-f1d8-4a62-8c60-5173e441992a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Park Wodny w Krakowie S.A.", address="Dobrego Pasterza 126, 31-416 Kraków",
      city="Krakow", country="PL",
      latitude=50.0892456, longitude=19.9828089,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d37fac1e-0dd2-4d46-a256-4960232b5c52_ChIJHwzCLcda_0.jpg",
      averageRating=4.2, totalRatingsCount=19554,
      createdAt="2026-08-30T21:28:34.063759Z", updatedAt="2026-08-30T21:59:23.228822Z",
    ),
    ClubDto(
      id="8ddc30e5-f4d9-4f7d-9bdc-04040cc0aa8c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stowarzyszenie Klub Sportowy Grzegórzecki", address="Aleja Pokoju 16, 31-543 Kraków",
      city="Krakow", country="PL",
      latitude=50.062456, longitude=19.967812,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/63f0027d-ced1-4c6d-9569-b58f57485a62_ChIJcZ6DrDpb_0.jpg",
      averageRating=4.1, totalRatingsCount=254,
      createdAt="2026-08-30T21:29:53.745323Z", updatedAt="2026-08-30T22:00:43.540718Z",
    ),
    ClubDto(
      id="6e01a739-1ad8-447f-a1db-6c89f8af67bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel House", address="Rzemieślnicza 20A, 30-363 Kraków",
      city="Krakow", country="PL",
      latitude=50.0323975, longitude=19.9357204,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f3e5a6dd-5cfb-4692-8953-2ddedef9d982_ChIJ1RtcFgBd_0.jpg",
      averageRating=4.0, totalRatingsCount=105,
      createdAt="2026-08-30T21:29:24.515112Z", updatedAt="2026-08-30T21:29:24.515112Z",
    ),
    ClubDto(
      id="58420f27-f77e-4ed9-872f-1169e4552094", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SOHO Cracow / Music Club", address="Bracka 4, 31-005 Kraków",
      city="Krakow", country="PL",
      latitude=50.0603631, longitude=19.9363609,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/65254b19-529a-4c7a-be84-d66dea0dc14c_ChIJqfE_jQ1b_0.jpg",
      averageRating=4.0, totalRatingsCount=905,
      createdAt="2026-08-30T21:28:14.039387Z", updatedAt="2026-08-30T21:59:50.695004Z",
    ),
    ClubDto(
      id="4ac3363f-9c0c-4624-adc0-8685c2b4beba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Outdoor Basketball Court", address="Celarowska, 31-408 Kraków",
      city="Krakow", country="PL",
      latitude=50.0846347, longitude=19.9572838,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0497b455-836f-43b9-b08c-a2868fe5190f_photo.jpg",
      averageRating=4.6, totalRatingsCount=40,
      createdAt="2026-08-31T15:13:37.006640Z", updatedAt="2026-08-31T15:13:37.006640Z",
    ),
    ClubDto(
      id="89f5ea8a-b88c-410c-acfa-8e64776bc068", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Topset - Nauka gry w ping ponga dla dzieci i dorosłych Kraków", address="Odmogile 1b, 31-751 Kraków",
      city="Krakow", country="PL",
      latitude=50.0846055, longitude=20.0441382,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d8254380-5cb5-4e19-a9f7-1de5d667c140_photo.jpg",
      averageRating=5.0, totalRatingsCount=19,
      createdAt="2026-08-31T15:14:24.768453Z", updatedAt="2026-08-31T15:14:24.768453Z",
    ),
    ClubDto(
      id="06b6fc0b-82a5-40e0-abf6-d4a78e474a08", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boisko do siatkówki plażowej", address="33J2+9V, 31-752 Kraków",
      city="Krakow", country="PL",
      latitude=50.080908, longitude=20.0522241,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c1492bff-64d2-48ef-af72-c45e96a4595a_photo.jpg",
      averageRating=5.0, totalRatingsCount=5,
      createdAt="2026-08-31T15:13:45.181904Z", updatedAt="2026-08-31T15:13:45.181904Z",
    ),
  )),
  CitySeo(slug="aarhus", name="Aarhus", country="DK", clubCount=26, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Padel", 3), Pair("Golf", 2), Pair("Volleyball", 2), Pair("Bowling", 2), Pair("Basketball", 2), Pair("Climbing", 2), Pair("Billiards", 1), Pair("Laser Tag", 1), Pair("Paintball", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="087b51b9-053e-4bcc-8bbc-9cd6369dfbec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aarhus Beachvolley Club", address="Vesterengvej 35, 8200 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.1824559, longitude=10.1831926,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c2ba458-c0bd-40d0-b422-c8e99c5e3a64_photo.jpg",
      averageRating=5.0, totalRatingsCount=53,
      createdAt="2026-09-01T00:09:55.112660Z", updatedAt="2026-09-01T00:09:55.112660Z",
    ),
    ClubDto(
      id="17c18f08-e2b6-430e-8503-88457f9d9e2a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PadelPadel Aarhus - LUNAR ARENA", address="Langdyssen 2, 8200 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.2187986, longitude=10.1440404,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f4515659-36bd-45a5-9d24-fec10735e2de_photo.jpg",
      averageRating=4.8, totalRatingsCount=138,
      createdAt="2026-09-01T00:09:21.377353Z", updatedAt="2026-09-01T00:09:21.377353Z",
    ),
    ClubDto(
      id="e0cbf7ea-5720-4a44-a563-81b7cfaf5a95", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boulders Aarhus City", address="Ankersgade 12c, 8000 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.1482289, longitude=10.1908979,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d0e6795a-21bf-42d8-9d4e-8ca489e09749_photo.jpg",
      averageRating=4.7, totalRatingsCount=241,
      createdAt="2026-09-01T00:10:58.602541Z", updatedAt="2026-09-01T00:10:58.602541Z",
    ),
    ClubDto(
      id="859864f0-c71c-44bb-900b-7f2c35515bb8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klatresjov Århus", address="Holmstrupgårdvej 18, 8220 Brabrand",
      city="Aarhus", country="DK",
      latitude=56.165273, longitude=10.1213789,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0da234ce-7910-452e-8854-a1e8c98a6dbc_photo.jpg",
      averageRating=4.7, totalRatingsCount=590,
      createdAt="2026-09-01T00:10:53.580560Z", updatedAt="2026-09-01T00:10:53.580560Z",
    ),
    ClubDto(
      id="acff8bbd-0370-42f7-9d89-d4ef1f72a1e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aarhus Tigers", address="Engelundsvej 11, 8260 Viby J",
      city="Aarhus", country="DK",
      latitude=56.119188, longitude=10.1271305,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/86a0f3e8-b31e-477f-bb5c-96b049c74644_photo.jpg",
      averageRating=4.6, totalRatingsCount=88,
      createdAt="2026-09-01T00:08:30.378934Z", updatedAt="2026-09-01T00:08:30.378934Z",
    ),
    ClubDto(
      id="d161aefa-0a54-4453-be14-7beefbe61929", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Friluftscenter Sprækkebjerg", address="Farrevej 20, 8450 Voldby",
      city="Aarhus", country="DK",
      latitude=56.233363, longitude=9.87966,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a2651a7-f3f1-4fea-aeff-694a0b62474b_photo.jpg",
      averageRating=4.6, totalRatingsCount=178,
      createdAt="2026-09-01T00:08:21.575319Z", updatedAt="2026-09-01T00:08:21.575319Z",
    ),
    ClubDto(
      id="0adf1922-ba6a-4863-9139-20e90449f1e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Outdoor Games", address="Benneshede 2, 8462 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.147163, longitude=10.0130695,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8e40c8d0-e4cb-4b2c-9494-29bc2f6b7c61_photo.jpg",
      averageRating=4.6, totalRatingsCount=51,
      createdAt="2026-09-01T00:11:16.766655Z", updatedAt="2026-09-01T00:11:16.766655Z",
    ),
    ClubDto(
      id="9c9a6ae0-1a5f-4ce8-8716-3a961abb87a4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Lounge Aarhus", address="Graham Bells Vej 23B, 8200 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.2081383, longitude=10.1763985,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eadc4963-810b-41d0-8d5e-f2cccc8ea239_photo.jpg",
      averageRating=4.6, totalRatingsCount=64,
      createdAt="2026-09-01T00:09:30.614825Z", updatedAt="2026-09-01T00:09:30.614825Z",
    ),
    ClubDto(
      id="bdfd260c-c224-47e4-9389-89b6273f334c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Racehall", address="Hasselager Centervej 30, 8260 Viby J",
      city="Aarhus", country="DK",
      latitude=56.1170939, longitude=10.1218091,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1033f4eb-c0ed-4396-895e-919b838ae77a_photo.jpg",
      averageRating=4.6, totalRatingsCount=920,
      createdAt="2026-09-01T00:10:25.988667Z", updatedAt="2026-09-01T00:10:25.988667Z",
    ),
    ClubDto(
      id="1633fd13-2712-4f14-b735-c2a279265e23", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aarhus Snooker & Pool", address="Ravnsøvej 40F, 8240 Risskov",
      city="Aarhus", country="DK",
      latitude=56.2025759, longitude=10.2449305,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0fcf179-01f3-4526-8dc3-4330940a61d4_photo.jpg",
      averageRating=4.5, totalRatingsCount=126,
      createdAt="2026-09-01T00:11:04.530556Z", updatedAt="2026-09-01T00:11:04.530556Z",
    ),
    ClubDto(
      id="38b9700d-faa2-4bfa-b2c4-866e912e04f4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Battlearena Lasergame og Paintball", address="Sylbækvej 7, 9, 8230 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.1436843, longitude=10.1482967,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ebff224f-9d5f-44b4-8bdb-bdfa9daedf50_photo.jpg",
      averageRating=4.5, totalRatingsCount=185,
      createdAt="2026-09-01T00:11:12.328918Z", updatedAt="2026-09-01T00:11:12.328918Z",
    ),
    ClubDto(
      id="fb00b8c2-4f5f-4e7c-9d43-b676a7f44345", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pakhus 77", address="Hveensgade 5, 8000 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.1617837, longitude=10.222663,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2d50f20e-4352-40ef-acda-9c1f6a061f18_photo.jpg",
      averageRating=4.4, totalRatingsCount=113,
      createdAt="2026-09-01T00:08:36.255508Z", updatedAt="2026-09-01T00:08:36.255508Z",
    ),
    ClubDto(
      id="8659e50d-a0e3-4166-9f92-0f68700e42fc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Skovbakken Tennis And Squash Centre", address="Hvidkildevej 19, 8240 Risskov",
      city="Aarhus", country="DK",
      latitude=56.1908073, longitude=10.2092113,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2af5e8a9-3758-4bfb-95f0-da442e7f7b80_photo.jpg",
      averageRating=4.4, totalRatingsCount=69,
      createdAt="2026-09-01T00:08:42.457941Z", updatedAt="2026-09-01T00:08:42.457941Z",
    ),
    ClubDto(
      id="93d4dc2e-10f8-44d1-b9bf-dff4b03d6183", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aarhus Aadal Golf Club", address="Brydehøjvej 35, 8462 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.122107, longitude=10.013314,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/60b86974-96e2-4e40-8e0e-cc968f9dbbe1_photo.jpg",
      averageRating=4.2, totalRatingsCount=211,
      createdAt="2026-09-01T00:10:20.453529Z", updatedAt="2026-09-01T00:10:20.453529Z",
    ),
    ClubDto(
      id="3e59b3d4-515b-40c8-94ee-a14ae12807aa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aarhus Svømmestadion", address="F. Vestergaards Gade 5, 8000 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.1438616, longitude=10.1970013,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/617d2c3b-3c77-4e9b-a360-864d58889913_photo.jpg",
      averageRating=4.2, totalRatingsCount=485,
      createdAt="2026-09-01T00:09:37.655029Z", updatedAt="2026-09-01T00:09:37.655029Z",
    ),
    ClubDto(
      id="7c0dc9b8-1921-4159-9134-dedfe2446f66", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Match Padel Aarhus", address="Sindalsvej 2, 8240 Risskov",
      city="Aarhus", country="DK",
      latitude=56.2084736, longitude=10.224751,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/70f0a9a5-2bf6-423a-8091-a3b0c4d628f1_photo.jpg",
      averageRating=4.2, totalRatingsCount=149,
      createdAt="2026-09-01T00:09:14.207010Z", updatedAt="2026-09-01T14:31:43.721263Z",
    ),
    ClubDto(
      id="54cc2e81-4f27-4c60-8b2e-5809a41c762e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sharks", address="Frederiksgade 25, 8000 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.1555213, longitude=10.2062253,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/20c84af7-7282-4151-9343-8e3e092331da_photo.jpg",
      averageRating=4.2, totalRatingsCount=2079,
      createdAt="2026-09-01T00:08:01.323104Z", updatedAt="2026-09-01T00:08:01.323104Z",
    ),
    ClubDto(
      id="c8fb71dc-cfc0-4acd-a34b-3be0db5d82ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mollerup Golf Club", address="Kun 10 min. fra motorvejen, Mollerupvej 7, 8240 Risskov",
      city="Aarhus", country="DK",
      latitude=56.213171, longitude=10.194625,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5fa4a2c3-a65f-4b42-8fc6-d8d6d05d6f4b_photo.jpg",
      averageRating=4.1, totalRatingsCount=225,
      createdAt="2026-09-01T00:10:12.678003Z", updatedAt="2026-09-01T00:10:12.678003Z",
    ),
    ClubDto(
      id="4df6ddfa-1dc6-4e60-9a36-0e5cf10a4748", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aarhus Firma Sport", address="Paludan-Müllers Vej 110, 8200 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.1815557, longitude=10.1754551,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8945db09-91b8-4d02-96a9-8f01d8a1784b_photo.jpg",
      averageRating=4.0, totalRatingsCount=353,
      createdAt="2026-09-01T00:08:16.037458Z", updatedAt="2026-09-01T00:08:16.037458Z",
    ),
    ClubDto(
      id="d1a9e632-ef26-4942-a8c3-70f27a4564b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vejlby-Risskov Hallen", address="Vejlby Centervej 51, 8240 Risskov",
      city="Aarhus", country="DK",
      latitude=56.193179, longitude=10.2084463,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd2269d8-7828-4584-ba81-3cc2f199fea4_photo.jpg",
      averageRating=4.0, totalRatingsCount=682,
      createdAt="2026-09-01T00:08:09.901229Z", updatedAt="2026-09-01T00:08:09.901229Z",
    ),
    ClubDto(
      id="ce28d6f3-8962-4539-a106-079c56f56de2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowl'n'Fun Aarhus", address="Skanderborgvej 226, 8260 Viby J",
      city="Aarhus", country="DK",
      latitude=56.1248638, longitude=10.1539964,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c66bb691-d4b5-44f0-a51d-10610d4f5086_photo.jpg",
      averageRating=3.9, totalRatingsCount=1235,
      createdAt="2026-09-01T00:10:36.742420Z", updatedAt="2026-09-01T00:10:36.742420Z",
    ),
    ClubDto(
      id="bda0e5d5-27ad-49ca-bf34-498e6dcb4402", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aarhus Bowlinghal", address="Eckersbergsgade 15, 8000 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.152183, longitude=10.195984,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4c116ae1-cc50-4239-bbd8-0289a91f764f_photo.jpg",
      averageRating=3.8, totalRatingsCount=707,
      createdAt="2026-09-01T00:10:45.137746Z", updatedAt="2026-09-01T00:10:45.137746Z",
    ),
    ClubDto(
      id="555795a7-e220-4f79-88e9-3909523c04f2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bordtennisklubben Sisu/MBK", address="Nørre Blvd. 1, 8000 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.164946, longitude=10.2099215,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2a202947-22ba-4729-bf44-b3280c196d91_photo.jpg",
      averageRating=4.8, totalRatingsCount=39,
      createdAt="2026-09-01T00:08:56.180180Z", updatedAt="2026-09-01T00:08:56.180180Z",
    ),
    ClubDto(
      id="d636aac5-168b-4310-997a-fa48dba14c09", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Christiansbjerghallen", address="Christiansbjerg, Gøteborg Allé 9, 8200 Aarhus",
      city="Aarhus", country="DK",
      latitude=56.1819472, longitude=10.1897344,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bfa22064-65c4-4040-8566-4924f08b6f8f_photo.jpg",
      averageRating=4.2, totalRatingsCount=33,
      createdAt="2026-09-01T00:09:47.613649Z", updatedAt="2026-09-01T00:09:47.613649Z",
    ),
    ClubDto(
      id="380582e2-d5d5-4edc-9d7b-b3ee49a54b31", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aarhus 1900 Tennis", address="Lyseng Alle 25, 8270 Højbjerg",
      city="Aarhus", country="DK",
      latitude=56.1107065, longitude=10.199942,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/42c49c5b-b5c5-47f0-9f3d-3e8107f532ec_photo.jpg",
      averageRating=4.5, totalRatingsCount=26,
      createdAt="2026-09-01T00:09:07.340751Z", updatedAt="2026-09-01T00:09:07.340751Z",
    ),
    ClubDto(
      id="153e7375-9b33-404b-86da-1ce82bc7798b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="If Lyseng Volleyball", address="Holmevej 200, 8270 Højbjerg",
      city="Aarhus", country="DK",
      latitude=56.1184717, longitude=10.1782597,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/05e4f0ab-fafe-49b3-8645-9b2b965dc2d4_photo.jpg",
      averageRating=4.6, totalRatingsCount=14,
      createdAt="2026-09-01T00:10:04.419730Z", updatedAt="2026-09-01T00:10:04.419730Z",
    ),
  )),
  CitySeo(slug="luxembourg", name="Luxembourg", country="LU", clubCount=26, sports=listOf(Pair("Football", 5), Pair("Padel", 3), Pair("Basketball", 3), Pair("Paintball", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Laser Tag", 2), Pair("Volleyball", 2), Pair("Tennis", 2), Pair("Billiards", 1), Pair("Karting", 1), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="abaf441a-6766-489a-99c7-aaff0223a950", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Api Padel", address="2bis Rue du Canal, 57970 Basse-Ham, France",
      city="Luxembourg", country="LU",
      latitude=49.3776481, longitude=6.2244132,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0281f66-6a42-435c-8c88-51cd2f4ce2b6_photo.jpg",
      averageRating=5.0, totalRatingsCount=58,
      createdAt="2026-09-01T09:05:54.218139Z", updatedAt="2026-09-01T09:05:54.218139Z",
    ),
    ClubDto(
      id="a041b1b6-90da-4e5a-8250-4cdb436bd5ff", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Airsoft | Paintball | LaserTag | Shooting", address="Route de la barrière 84 b, 6971 Champlon, Belgium",
      city="Luxembourg", country="LU",
      latitude=50.1116459, longitude=5.470557,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0aeb9f22-415d-4c3d-b5b1-c9788fa8d1b3_photo.jpg",
      averageRating=4.8, totalRatingsCount=316,
      createdAt="2026-09-01T09:07:05.851746Z", updatedAt="2026-09-01T09:07:05.851746Z",
    ),
    ClubDto(
      id="50d9718b-f731-49aa-ab48-a5efd89ddfa2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Eifelblock Trier", address="Niederkircher Str. 10, 54294 Trier, Germany",
      city="Luxembourg", country="LU",
      latitude=49.7287494, longitude=6.6052164,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7d379228-89d2-414f-b5ec-a1389a8c4dd9_photo.jpg",
      averageRating=4.8, totalRatingsCount=320,
      createdAt="2026-09-01T09:06:45.919212Z", updatedAt="2026-09-01T09:06:45.919212Z",
    ),
    ClubDto(
      id="ead6869d-b281-4f19-993a-c4169bffc6de", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="L'Escale", address="Av. de Mersch 20, 6700 Arlon, Belgium",
      city="Luxembourg", country="LU",
      latitude=49.685965, longitude=5.824534,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0003c53c-eb88-4517-bf9b-7167f278aaeb_photo.jpg",
      averageRating=4.7, totalRatingsCount=387,
      createdAt="2026-09-01T09:06:41.601867Z", updatedAt="2026-09-01T09:06:41.601867Z",
    ),
    ClubDto(
      id="22fc8aac-6e06-4875-a11c-d22c5da262aa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADFIVE", address="13/17 espace des 4 chemins, 54720 Lexy, France",
      city="Luxembourg", country="LU",
      latitude=49.5086297, longitude=5.7136605,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7fb1be7e-3aba-4327-89e4-627c71431be2_photo.jpg",
      averageRating=4.7, totalRatingsCount=99,
      createdAt="2026-09-01T09:05:48.408437Z", updatedAt="2026-09-01T14:31:48.866757Z",
    ),
    ClubDto(
      id="bb4e90d2-0a58-4414-8216-aae3aaa7fc9c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gaume paintball site western indien", address="Rue du Vieux Moulin, 6747 Saint-Léger, Belgium",
      city="Luxembourg", country="LU",
      latitude=49.59958, longitude=5.65578,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96c1230c-d762-4b2a-963c-c5c78b9b0181_photo.jpg",
      averageRating=4.6, totalRatingsCount=168,
      createdAt="2026-09-01T09:07:10.767499Z", updatedAt="2026-09-01T09:07:10.767499Z",
    ),
    ClubDto(
      id="135e4b79-4af6-4fcb-81e4-3ad20ed65e11", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf de Luxembourg - Belenhaff", address="Domaine de Belenhaff, 6141 Junglinster",
      city="Luxembourg", country="LU",
      latitude=49.7321693, longitude=6.2537033,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a769ba5-c733-43a2-aba2-bf19f350cf9f_photo.jpg",
      averageRating=4.6, totalRatingsCount=266,
      createdAt="2026-09-01T09:06:22.608986Z", updatedAt="2026-09-01T09:06:22.608986Z",
    ),
    ClubDto(
      id="21e306f8-a88b-4cc3-81bd-8044aae0159f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club des Arquebusiers", address="140 Val Ste. Croix, 1370 Belair Luxembourg",
      city="Luxembourg", country="LU",
      latitude=49.6128685, longitude=6.1047958,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6bafabc9-affb-4d16-806b-f9638362312d_photo.jpg",
      averageRating=4.6, totalRatingsCount=94,
      createdAt="2026-09-01T09:05:37.874361Z", updatedAt="2026-09-01T09:05:37.874361Z",
    ),
    ClubDto(
      id="921c07ef-8254-424b-9cd2-e611ee877622", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Coque National Sports and Culture Centre", address="2 Rue Léon Hengen, 1745 Kirchberg Luxembourg",
      city="Luxembourg", country="LU",
      latitude=49.623552, longitude=6.1519527,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0a5cae77-6b15-4199-8bfc-5049abec3ddc_photo.jpg",
      averageRating=4.5, totalRatingsCount=2211,
      createdAt="2026-09-01T09:05:09.412730Z", updatedAt="2026-09-01T09:05:09.412730Z",
    ),
    ClubDto(
      id="45cf49b7-2289-42f6-955c-c04ad1918eeb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Mondercange", address="152 Rue de Limpach, 3932 Mondercange",
      city="Luxembourg", country="LU",
      latitude=49.5454, longitude=5.97817,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8e2af707-3e88-4018-b98b-4a4e3b5bedc4_photo.jpg",
      averageRating=4.5, totalRatingsCount=507,
      createdAt="2026-09-01T09:06:31.414767Z", updatedAt="2026-09-01T09:06:31.414767Z",
    ),
    ClubDto(
      id="3d240690-ca3e-46ef-8d27-a3f0f3b30e10", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Game Evolution Ettelbruck", address="3 Rue Jean-Pierre Thill, 9085 Ettelbruck",
      city="Luxembourg", country="LU",
      latitude=49.8391611, longitude=6.096516,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d031966-4ff6-421b-8fd5-517176d5bf5d_photo.jpg",
      averageRating=4.5, totalRatingsCount=273,
      createdAt="2026-09-01T09:07:00.185709Z", updatedAt="2026-09-01T09:07:00.185709Z",
    ),
    ClubDto(
      id="32311f75-6702-4733-b133-c647215a0d4d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Game Evolution Luxembourg", address="3 Rue Pletzer, 8080 Helfent Bertrange",
      city="Luxembourg", country="LU",
      latitude=49.6034215, longitude=6.0723028,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8273eef5-5e35-4b6e-b666-e5ebb4617eec_photo.jpg",
      averageRating=4.5, totalRatingsCount=820,
      createdAt="2026-09-01T09:06:54.749159Z", updatedAt="2026-09-01T09:06:54.749159Z",
    ),
    ClubDto(
      id="f47039fd-1f41-4da8-a178-6d14fb9d21d5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport4lux Sàrl", address="34 Rue Gabriel Lippmann, 5365 Munsbach Schuttrange",
      city="Luxembourg", country="LU",
      latitude=49.6437, longitude=6.27228,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cd869ca2-ddef-4eac-ae19-855f9028870f_photo.jpg",
      averageRating=4.5, totalRatingsCount=294,
      createdAt="2026-09-01T09:05:20.589050Z", updatedAt="2026-09-01T14:31:44.623008Z",
    ),
    ClubDto(
      id="9c108ff6-f924-4186-9677-404d70969cdb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Fields Boy Konen", address="279 Rue des Sports, 1321 Cessange Luxembourg",
      city="Luxembourg", country="LU",
      latitude=49.5808805, longitude=6.0900632,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1ceec80b-98b3-4f9e-840e-9c865ae0acd9_photo.jpg",
      averageRating=4.5, totalRatingsCount=257,
      createdAt="2026-09-01T09:05:24.729068Z", updatedAt="2026-09-01T09:05:24.729068Z",
    ),
    ClubDto(
      id="d54f8c03-c8f9-4a97-8dc3-7876a2ae23cf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="National Sports Institute", address="66 Rue de Treves, 2630 Grund Luxembourg",
      city="Luxembourg", country="LU",
      latitude=49.6108698, longitude=6.1462297,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4837eae2-6b1b-40b1-9b86-a6a8d1027de5_photo.jpg",
      averageRating=4.4, totalRatingsCount=362,
      createdAt="2026-09-01T09:06:13.328888Z", updatedAt="2026-09-01T09:06:13.328888Z",
    ),
    ClubDto(
      id="10adee95-37cb-4fc2-a0ea-a4b4c5a23497", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Spora", address="1264 Muhlenbach, Luxembourg Luxembourg",
      city="Luxembourg", country="LU",
      latitude=49.6318512, longitude=6.1139588,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c28316a8-195c-4b1f-914c-3c3534960713_photo.jpg",
      averageRating=4.4, totalRatingsCount=199,
      createdAt="2026-09-01T09:05:33.672944Z", updatedAt="2026-09-01T09:05:33.672944Z",
    ),
    ClubDto(
      id="2a7d6a51-59ff-4136-b626-2ea07d628047", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CK Sportcenter Kockelscheuer", address="20 Rte de Bettembourg, 1899 Kockelscheuer Luxembourg",
      city="Luxembourg", country="LU",
      latitude=49.5730778, longitude=6.1098018,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/79de8d77-f4d0-4a70-be44-65117624e975_photo.jpg",
      averageRating=4.3, totalRatingsCount=746,
      createdAt="2026-09-01T09:05:15.137981Z", updatedAt="2026-09-01T09:05:15.137981Z",
    ),
    ClubDto(
      id="61f4beb9-8017-4b7d-9f47-7fc8d3b492fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Grand-Ducal Golf Club", address="1 Rte de Treves, 2633 Senningerberg Niederanven",
      city="Luxembourg", country="LU",
      latitude=49.6384342, longitude=6.2126707,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aacdd9cd-e9ef-40be-9b51-e5517bb72349_photo.jpg",
      averageRating=4.3, totalRatingsCount=128,
      createdAt="2026-09-01T09:06:27.209192Z", updatedAt="2026-09-01T09:06:27.209192Z",
    ),
    ClubDto(
      id="e0e9c460-af36-4e2d-8e1d-06187e652a0a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hall Omnisports Bonnevoie", address="42 Rue Jean-François Gangler, 1613 Bouneweg-Süd Luxembourg",
      city="Luxembourg", country="LU",
      latitude=49.5963842, longitude=6.145825,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f8b0120e-e508-4976-9357-24557c6d5edd_photo.jpg",
      averageRating=4.3, totalRatingsCount=61,
      createdAt="2026-09-01T09:06:04.909020Z", updatedAt="2026-09-01T09:06:04.909020Z",
    ),
    ClubDto(
      id="f3f9df29-9291-46d9-bc5e-b599f9abb6c7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="All In Family Fun Center - Bowling Center Fuussekaul Sarl", address="22 Am Clemensbongert, 9158 Heiderscheid Esch-sur-Sûre",
      city="Luxembourg", country="LU",
      latitude=49.885952, longitude=5.983128,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7689ed80-a2cc-400f-acad-78d03f67c27d_photo.jpg",
      averageRating=4.1, totalRatingsCount=615,
      createdAt="2026-09-01T09:06:50.378027Z", updatedAt="2026-09-01T09:06:50.378027Z",
    ),
    ClubDto(
      id="3cbe3d9b-7b9e-4ebd-87eb-aba6d782b4c8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Garisart Sports Club", address="Rue Claude Berg 30, 6700 Arlon, Belgium",
      city="Luxembourg", country="LU",
      latitude=49.6502971, longitude=5.8231076,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/458920ad-a34f-416d-862d-9f3a35852a2b_photo.jpg",
      averageRating=4.1, totalRatingsCount=174,
      createdAt="2026-09-01T09:05:43.804306Z", updatedAt="2026-09-01T09:05:43.804306Z",
    ),
    ClubDto(
      id="8e23f214-6d2a-46ba-9852-2334ee3b4117", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hall Omnisports Alain Marchetti", address="10 Rue des Vergers, 7339 Mullendorf Steinsel",
      city="Luxembourg", country="LU",
      latitude=49.6788365, longitude=6.1250021,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd010afb-94b2-4b6d-b309-920b7cd0146f_photo.jpg",
      averageRating=4.1, totalRatingsCount=74,
      createdAt="2026-09-01T09:05:57.871637Z", updatedAt="2026-09-01T09:05:57.871637Z",
    ),
    ClubDto(
      id="04f7fd9b-99a9-4579-a133-09e1003f99c4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hall Sportif Nicolas Frantz", address="1 Rue de Bertrange, 8216 Mamer",
      city="Luxembourg", country="LU",
      latitude=49.6232071, longitude=6.0248168,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c8b43b5c-e2dd-4752-a061-91b1695af42c_photo.jpg",
      averageRating=4.1, totalRatingsCount=56,
      createdAt="2026-09-01T09:06:08.630201Z", updatedAt="2026-09-01T09:06:08.630201Z",
    ),
    ClubDto(
      id="dd27e3e8-4a5f-490a-b300-55af97b18b06", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="X-Trem Bowling & Billard", address="11 Rue du Brill, 3898 Foetz Mondercange",
      city="Luxembourg", country="LU",
      latitude=49.5209, longitude=6.00873,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c234e99c-5e27-43eb-9749-118f32972d0a_photo.jpg",
      averageRating=3.6, totalRatingsCount=974,
      createdAt="2026-09-01T09:06:35.943565Z", updatedAt="2026-09-01T09:06:35.943565Z",
    ),
    ClubDto(
      id="31cc0528-8fb5-4908-8114-e9f05474cc5a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ISL Football Pitch", address="36 Bd Pierre Dupong, 1430 Hollerich Luxembourg",
      city="Luxembourg", country="LU",
      latitude=49.6017749, longitude=6.1082975,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/788e7102-c946-473b-b08f-0c0a8259e715_photo.jpg",
      averageRating=4.5, totalRatingsCount=33,
      createdAt="2026-09-01T09:05:29.003740Z", updatedAt="2026-09-01T09:05:29.003740Z",
    ),
    ClubDto(
      id="cee6e82a-3a2a-4c23-9311-78b2081d42bd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="VCB – Volley Club Belair", address="14 Rue d'Ostende, 2271 Belair Luxembourg",
      city="Luxembourg", country="LU",
      latitude=49.6134277, longitude=6.1087998,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ea296403-8c64-4d80-bc16-9fa47374dded_photo.jpg",
      averageRating=4.6, totalRatingsCount=10,
      createdAt="2026-09-01T09:06:17.202388Z", updatedAt="2026-09-01T09:06:17.202388Z",
    ),
  )),
  CitySeo(slug="copenhagen", name="Copenhagen", country="DK", clubCount=26, sports=listOf(Pair("Football", 4), Pair("Volleyball", 3), Pair("Basketball", 3), Pair("Tennis", 3), Pair("Padel", 3), Pair("Climbing", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Billiards", 2), Pair("Table Tennis", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="2c4464c9-ac5a-4eff-bad7-7c1af079c1c4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boulders København Sydhavn", address="Bådehavnsgade 38, port 1, 2450 København",
      city="Copenhagen", country="DK",
      latitude=55.6411893, longitude=12.5391755,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7f5a985d-8287-4059-ba45-7c54b3bcb26b_ChIJ-_24foRU_0.jpg",
      averageRating=4.5, totalRatingsCount=1095,
      createdAt="2026-08-30T22:56:07.949647Z", updatedAt="2026-08-31T08:26:25.425616Z",
    ),
    ClubDto(
      id="207c4945-af75-41ca-acea-c867a282c91d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CopenHill", address="Vindmøllevej 6, 2300 København",
      city="Copenhagen", country="DK",
      latitude=55.6846011, longitude=12.6200294,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b51cee3d-d021-4f8f-af9d-552188930f86_ChIJQ1wUoCtT_0.jpg",
      averageRating=4.5, totalRatingsCount=2520,
      createdAt="2026-08-30T22:55:47.442432Z", updatedAt="2026-08-31T08:27:06.712614Z",
    ),
    ClubDto(
      id="116250cd-0aa1-46e0-ae53-b505525a373f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hafnia-Hallen", address="Julius Andersens Vej 6, 2450 København",
      city="Copenhagen", country="DK",
      latitude=55.6478334, longitude=12.5100159,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/16132463-1de1-4d83-9d08-a4d4b76c1a8c_photo.jpg",
      averageRating=4.5, totalRatingsCount=781,
      createdAt="2026-08-31T15:40:22.899160Z", updatedAt="2026-08-31T15:40:22.899160Z",
    ),
    ClubDto(
      id="d7d8ab9d-e03f-4cae-b04f-fd77daac2ddc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Københavns Gokart Bane. Fritids og -ungdomsklub", address="Kraftværksvej 10, 2300 København",
      city="Copenhagen", country="DK",
      latitude=55.6789167, longitude=12.6193058,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0cf67439-c4f3-49e6-8bb4-b33a4b96b2c0_ChIJeaaNPC1T_0.jpg",
      averageRating=4.5, totalRatingsCount=99,
      createdAt="2026-08-30T22:56:23.036489Z", updatedAt="2026-08-30T22:56:23.036489Z",
    ),
    ClubDto(
      id="c953b48e-79fe-4337-896a-7a75aaff52da", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Airtrix Trampolinpark Nordhavn", address="Kattegatvej 4, 2150 København",
      city="Copenhagen", country="DK",
      latitude=55.7174071, longitude=12.6070251,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/caa51ec5-28a1-4b5b-8c5c-ca1801ade6cf_ChIJkVPyB75S_0.jpg",
      averageRating=4.4, totalRatingsCount=841,
      createdAt="2026-08-30T22:56:15.767686Z", updatedAt="2026-08-30T22:56:15.767686Z",
    ),
    ClubDto(
      id="90b450ba-de3d-4068-907b-25b7d11e85f1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fælledparken", address="Østerbro, 2100 København",
      city="Copenhagen", country="DK",
      latitude=55.7017892, longitude=12.567908,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8d1adc39-9a6c-4269-b834-946211af37fa_ChIJq6qqavhS_0.jpg",
      averageRating=4.4, totalRatingsCount=6028,
      createdAt="2026-08-30T22:55:34.130916Z", updatedAt="2026-08-31T08:28:09.631121Z",
    ),
    ClubDto(
      id="646006be-37d3-4389-9651-8ab6257aee08", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pro Padel", address="Kattegatvej 6, 2150 København",
      city="Copenhagen", country="DK",
      latitude=55.7180612, longitude=12.607195,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/89e6a668-b45f-4831-a51b-ded49da77b95_ChIJ-d43Wp1T_0.jpg",
      averageRating=4.4, totalRatingsCount=78,
      createdAt="2026-08-30T22:56:46.234274Z", updatedAt="2026-08-31T08:34:55.250636Z",
    ),
    ClubDto(
      id="12c43c25-14fb-4e38-b329-30b2c6257c2e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Grøndal MultiCenter", address="Hvidkildevej 64, 2400 København",
      city="Copenhagen", country="DK",
      latitude=55.7006431, longitude=12.5154866,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/80d27394-d64e-4d4e-a39f-be87a3d36106_ChIJdQkOuDJS_0.jpg",
      averageRating=4.3, totalRatingsCount=1492,
      createdAt="2026-08-30T22:56:52.684123Z", updatedAt="2026-08-31T08:28:47.796064Z",
    ),
    ClubDto(
      id="5fc1bc07-33ed-40aa-8fd6-9ba2dde3b80e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Match Padel Kløvermarken", address="Raffinaderivej 20, 2300 København",
      city="Copenhagen", country="DK",
      latitude=55.67504, longitude=12.6166854,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ee8757ab-18ad-4fe9-a061-c93b4b79aec6_ChIJCyUhjJxT_0.jpg",
      averageRating=4.3, totalRatingsCount=116,
      createdAt="2026-08-30T22:56:30.429744Z", updatedAt="2026-08-30T22:56:30.429744Z",
    ),
    ClubDto(
      id="1027dc89-e498-40e6-a34b-88acad265740", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Steel House Copenhagen", address="Herholdtsgade 6, 1605 København",
      city="Copenhagen", country="DK",
      latitude=55.6763401, longitude=12.5597626,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/79f56bbf-2a7e-4410-853c-585205e50aa0_ChIJU2TeCgxT_2.jpg",
      averageRating=4.3, totalRatingsCount=5856,
      createdAt="2026-08-30T22:55:53.611176Z", updatedAt="2026-08-31T22:11:21.538494Z",
    ),
    ClubDto(
      id="6b36734c-a99f-4ce2-89f1-10f38ab7be7d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cecilie's", address="Hørkær 1, 2730 Herlev",
      city="Copenhagen", country="DK",
      latitude=55.7208623, longitude=12.42924,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc9680ab-7e51-468c-800e-2d0d17fab849_photo.jpg",
      averageRating=4.2, totalRatingsCount=1710,
      createdAt="2026-08-31T15:41:22.538235Z", updatedAt="2026-08-31T15:41:22.538235Z",
    ),
    ClubDto(
      id="fe4e496d-8b63-490a-9d40-1a91999e977a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Parken", address="Per Henrik Lings Allé 2, 2100 København",
      city="Copenhagen", country="DK",
      latitude=55.7027203, longitude=12.5723096,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/87421a1a-1c00-46d1-8f7f-7d85bddbef59_ChIJS6iKkflS_0.jpg",
      averageRating=4.2, totalRatingsCount=8402,
      createdAt="2026-08-30T22:55:27.773268Z", updatedAt="2026-08-31T08:34:35.563306Z",
    ),
    ClubDto(
      id="3dd58788-cb0c-45ba-921c-169eb69a69b7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Racket Club", address="Raffinaderivej 10E, 2300 København",
      city="Copenhagen", country="DK",
      latitude=55.671306, longitude=12.621773,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2580e152-ff68-4530-8a0a-db7d92a37c32_ChIJ4RBDZGyt_0.jpg",
      averageRating=4.2, totalRatingsCount=82,
      createdAt="2026-08-30T22:57:06.012075Z", updatedAt="2026-09-01T14:31:49.111347Z",
    ),
    ClubDto(
      id="1c9d0508-1ec3-483b-9725-3e4afd670c56", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="McKluud", address="Istedgade 126, 1650 København",
      city="Copenhagen", country="DK",
      latitude=55.6683991, longitude=12.5500947,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/28a4c381-1a2c-4cc7-9483-0142ce7a0f89_ChIJs58Q7HVT_0.jpg",
      averageRating=4.1, totalRatingsCount=656,
      createdAt="2026-08-30T22:56:00.324703Z", updatedAt="2026-08-30T22:56:00.324703Z",
    ),
    ClubDto(
      id="4afd4263-d72d-4bb4-81ce-08394ee9c4cf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nørrebrohallen", address="Nørrebrogade 208, 2200 København",
      city="Copenhagen", country="DK",
      latitude=55.7000758, longitude=12.5437411,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8fc865b5-7573-4fdc-b577-aa07e5a2425e_photo.jpg",
      averageRating=4.1, totalRatingsCount=1418,
      createdAt="2026-08-31T15:40:29.104609Z", updatedAt="2026-08-31T15:40:29.104609Z",
    ),
    ClubDto(
      id="00549db9-d7f2-45a8-a63a-5156ab04ed77", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Svanemøllehallen", address="Østerbrogade 240, 2100 København",
      city="Copenhagen", country="DK",
      latitude=55.7141701, longitude=12.5786231,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/95bf28e9-96d1-4f21-8af0-1e11efb335d3_photo.jpg",
      averageRating=4.1, totalRatingsCount=372,
      createdAt="2026-08-31T15:40:50.253495Z", updatedAt="2026-08-31T22:11:22.058108Z",
    ),
    ClubDto(
      id="9faa99d7-7fc4-4a37-a8e2-4a5f5940d80b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="DGI Byen", address="Tietgensgade 65, 1704 København",
      city="Copenhagen", country="DK",
      latitude=55.6700553, longitude=12.5650302,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/86a383e1-bedb-4dfa-9acf-4ede74e08342_ChIJX8mNz3ZT_0.jpg",
      averageRating=4.0, totalRatingsCount=4267,
      createdAt="2026-08-30T22:55:41.009355Z", updatedAt="2026-08-31T08:27:12.968515Z",
    ),
    ClubDto(
      id="9e9d9bf1-722f-4264-8f1b-04f78ff2bf37", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kfiu-hallen", address="Knuthenborgvej 24, 2500 København",
      city="Copenhagen", country="DK",
      latitude=55.66808, longitude=12.489353,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/932a8003-b1f9-414c-99fd-d841f758ac9a_ChIJ4aFAVONT_0.jpg",
      averageRating=4.0, totalRatingsCount=90,
      createdAt="2026-08-30T22:56:59.518225Z", updatedAt="2026-08-30T22:56:59.518225Z",
    ),
    ClubDto(
      id="a859248a-2d8c-4621-a497-8f6c31710f95", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Yard", address="Refshalevej 167e, 1432 København",
      city="Copenhagen", country="DK",
      latitude=55.6938811, longitude=12.6112143,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc51a2cf-cffc-49b8-8ae7-b92b8f10b67a_ChIJHbnsVjNT_0.jpg",
      averageRating=4.0, totalRatingsCount=85,
      createdAt="2026-08-30T22:56:37.747774Z", updatedAt="2026-08-31T08:33:59.327443Z",
    ),
    ClubDto(
      id="ecf112c3-30e8-41ce-85fd-99e96cc36713", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Amager Strand Beach Volleyball", address="Amager Strandvej 173, 2300 København",
      city="Copenhagen", country="DK",
      latitude=55.6566768, longitude=12.637896,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5d46c484-7944-43f0-a6c5-a0061b090e61_photo.jpg",
      averageRating=4.8, totalRatingsCount=41,
      createdAt="2026-08-31T15:40:43.466632Z", updatedAt="2026-08-31T15:40:43.466632Z",
    ),
    ClubDto(
      id="617d8419-b213-402f-b76e-1ef202f84fe0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ballerup Bowling & Minigolf", address="Tempovej 35, 2750 Ballerup",
      city="Copenhagen", country="DK",
      latitude=55.7236089, longitude=12.3722215,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7cf30013-ed2a-4205-a370-cfeed6cda41c_photo.jpg",
      averageRating=3.9, totalRatingsCount=649,
      createdAt="2026-08-31T15:41:28.631611Z", updatedAt="2026-08-31T15:41:28.631611Z",
    ),
    ClubDto(
      id="d5adfa60-855c-4e70-880b-fb1450055fa1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bellahøj Hallerne", address="Bellahøjvej 1, 2700 København",
      city="Copenhagen", country="DK",
      latitude=55.7057122, longitude=12.5148163,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/806b0a4d-42a4-4d45-9938-59f9a9675884_photo.jpg",
      averageRating=3.8, totalRatingsCount=147,
      createdAt="2026-08-31T15:40:36.137839Z", updatedAt="2026-08-31T15:40:36.137839Z",
    ),
    ClubDto(
      id="21fc558f-6a2e-4226-a68d-5bf460fe8864", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Royal Golf Club", address="Center Blvd. 4, 2300 Copenhagen S",
      city="Copenhagen", country="DK",
      latitude=55.638446, longitude=12.5728478,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/82d8b883-ec2c-4127-9cc8-4c1527a1edfc_photo.jpg",
      averageRating=3.8, totalRatingsCount=262,
      createdAt="2026-08-31T15:41:03.499540Z", updatedAt="2026-08-31T15:41:03.499540Z",
    ),
    ClubDto(
      id="64d651d3-db03-46a2-a37e-76f278776c8a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Amager Volley", address="Englandsvej 61, 2300 København",
      city="Copenhagen", country="DK",
      latitude=55.649774, longitude=12.600348,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d463baef-1aa3-4846-8775-1515440b2de4_photo.jpg",
      averageRating=4.5, totalRatingsCount=19,
      createdAt="2026-08-31T15:40:56.360233Z", updatedAt="2026-08-31T15:40:56.360233Z",
    ),
    ClubDto(
      id="52fa148f-38d3-4dae-bd5b-22f31506885f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gladsaxe Bordtennisklub", address="Gladsaxevej 200, 2860 Søborg",
      city="Copenhagen", country="DK",
      latitude=55.7324424, longitude=12.4959719,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2c9ab5a0-e1d0-4235-91cc-fc62dac89dc4_photo.jpg",
      averageRating=4.6, totalRatingsCount=12,
      createdAt="2026-08-31T15:41:15.951689Z", updatedAt="2026-08-31T15:41:15.951689Z",
    ),
    ClubDto(
      id="245c91ce-ccb0-40b8-ba1d-dc589443b27a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Copenhagen Driving Range", address="Center Blvd. 4, 2300 København",
      city="Copenhagen", country="DK",
      latitude=55.640038, longitude=12.5750369,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0f986071-75b8-415e-b5cd-7da1f5fb1123_photo.jpg",
      averageRating=4.1, totalRatingsCount=7,
      createdAt="2026-08-31T15:41:10.666819Z", updatedAt="2026-08-31T15:41:10.666819Z",
    ),
  )),
  CitySeo(slug="marseille", name="Marseille", country="FR", clubCount=26, sports=listOf(Pair("Volleyball", 5), Pair("Football", 4), Pair("Tennis", 3), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Table Tennis", 2), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Golf", 1), Pair("Basketball", 1), Pair("Karting", 1), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="40c26224-ca19-4f93-b753-077cd0b85255", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Game Party 13", address="Plan de campagne, Zone Commercial, 845 Rte de Calas, 13170 Les Pennes-Mirabeau",
      city="Marseille", country="FR",
      latitude=43.4124968, longitude=5.3667542,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/314e514f-86e8-4e03-9827-1611f4fc3c9a_photo.jpg",
      averageRating=4.9, totalRatingsCount=823,
      createdAt="2026-08-31T15:42:37.365728Z", updatedAt="2026-08-31T15:42:37.365728Z",
    ),
    ClubDto(
      id="4027ca2b-b799-4203-a32e-6874186d322e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climb Up Marseille - La Valentine", address="4 Mnt Commandant de Robien, 13011 Marseille",
      city="Marseille", country="FR",
      latitude=43.286396, longitude=5.4854121,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c39bce2-77cb-4a8d-baad-c449e141a6a6_ChIJtxjMdLm-_0.jpg",
      averageRating=4.8, totalRatingsCount=787,
      createdAt="2026-08-30T21:18:58.011857Z", updatedAt="2026-08-30T21:56:07.682376Z",
    ),
    ClubDto(
      id="1dd74708-43bd-4659-b15e-81763bd005ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MARSEILLE LOISIRS", address="17 Mnt Commandant de Robien, 13011 Marseille",
      city="Marseille", country="FR",
      latitude=43.2905286, longitude=5.4850765,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/79e70289-9ef1-4492-adf9-90a2cd12f0c3_ChIJpYU1eRm8_0.jpg",
      averageRating=4.7, totalRatingsCount=1672,
      createdAt="2026-08-30T21:18:37.707560Z", updatedAt="2026-08-30T21:18:37.707560Z",
    ),
    ClubDto(
      id="f74e4836-d4c7-41b9-99ea-7dbee5bb9450", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CEPAC Vélodrome", address="3 Bd Michelet, 13008 Marseille",
      city="Marseille", country="FR",
      latitude=43.269859, longitude=5.3959015,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e678e558-ed87-4b77-8a57-355df7e11af2_ChIJGRyneKe4_0.jpg",
      averageRating=4.6, totalRatingsCount=41974,
      createdAt="2026-08-30T21:17:55.563053Z", updatedAt="2026-08-30T21:55:55.386294Z",
    ),
    ClubDto(
      id="ca651887-b034-43c3-ab15-522000b33fb1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le monde du pingpong", address="le monde du pingpong, 268 Av. de la Capelette, 13010 Marseille",
      city="Marseille", country="FR",
      latitude=43.2790292, longitude=5.4134248,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ca55a526-5cda-4808-89df-83e993fd367d_photo.jpg",
      averageRating=4.6, totalRatingsCount=51,
      createdAt="2026-08-31T15:42:30.033505Z", updatedAt="2026-08-31T15:42:30.033505Z",
    ),
    ClubDto(
      id="96257cf8-b23f-4631-9631-d8cc4046516e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MONCLUB 2.0", address="73 Bd de Saint-Marcel, 13011 Marseille",
      city="Marseille", country="FR",
      latitude=43.2888652, longitude=5.459798,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d6df70ef-4312-4a37-a742-f4eec4df8bbf_ChIJv9owGLm-_0.jpg",
      averageRating=4.5, totalRatingsCount=471,
      createdAt="2026-08-30T21:18:09.303586Z", updatedAt="2026-09-01T14:32:01.802679Z",
    ),
    ClubDto(
      id="cde48bac-77a9-4fd7-88a4-0feccaee81c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Terrains de paintball", address="l'Aumône, 99 Chem. du Bois de l'Aumône, 13011 Marseille",
      city="Marseille", country="FR",
      latitude=43.291121, longitude=5.5217672,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ef406aa0-a0dc-470c-b736-28bff03dc0f2_ChIJy4xOaIq8_0.jpg",
      averageRating=4.5, totalRatingsCount=201,
      createdAt="2026-08-30T21:19:11.878252Z", updatedAt="2026-08-30T21:19:11.878252Z",
    ),
    ClubDto(
      id="b9f1456e-d0d5-4525-b46f-8e31ea8afb77", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le 13 - Foot en salle - Marseille", address="18 Bd Frédéric Sauvage, 13014 Marseille",
      city="Marseille", country="FR",
      latitude=43.3337007, longitude=5.3703896,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e9fb0b54-6ce6-4dfc-89af-a902ac27c2bc_ChIJR62kUm_B_0.jpg",
      averageRating=4.4, totalRatingsCount=389,
      createdAt="2026-08-30T21:18:16.027660Z", updatedAt="2026-08-30T21:58:25.786961Z",
    ),
    ClubDto(
      id="95849ba7-b685-4f8c-a03e-582fc9946b76", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MARSEILLE LOISIRS BOWLING EVOLUTION", address="17 Mnt Commandant de Robien, 13011 Marseille",
      city="Marseille", country="FR",
      latitude=43.2903512, longitude=5.4852794,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9737b43c-5e63-46d5-8de8-1648b603aea3_ChIJa5HEZr29_0.jpg",
      averageRating=4.4, totalRatingsCount=299,
      createdAt="2026-08-30T21:18:45.417436Z", updatedAt="2026-08-30T21:58:31.654481Z",
    ),
    ClubDto(
      id="cf77d72a-3ca7-4ebd-b923-7d665678fb30", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TENNIS CLUB LA FOURRAGERE ASPTT", address="13012 Marseille",
      city="Marseille", country="FR",
      latitude=43.2994158, longitude=5.4275829,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a193497-8bea-4845-a0c4-e1157dcc6f7a_ChIJx1cLURi__0.jpg",
      averageRating=4.4, totalRatingsCount=218,
      createdAt="2026-08-30T21:19:25.600763Z", updatedAt="2026-08-30T21:19:25.600763Z",
    ),
    ClubDto(
      id="d2fd31b9-4434-48d9-8d32-841760eef059", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Park de Marseille | Tennis & Padel", address="92 Chem. des Accates, 13011 Marseille",
      city="Marseille", country="FR",
      latitude=43.3020412, longitude=5.4926866,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1f3ccd2-de46-409e-94ee-d01c640c0441_ChIJFec6JTq8_0.jpg",
      averageRating=4.4, totalRatingsCount=258,
      createdAt="2026-08-30T21:19:18.472032Z", updatedAt="2026-09-01T14:31:47.641486Z",
    ),
    ClubDto(
      id="e23b38de-7ef0-4841-823f-ddeee7cbf829", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aix Marseille Golf Club", address="Rue Jean René Guillibert Gauthier de la Lauzière, 13290 Aix-en-Provence",
      city="Marseille", country="FR",
      latitude=43.4854629, longitude=5.3651929,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9979288a-67f4-4c82-b2f6-bf7bc7ea476c_photo.jpg",
      averageRating=4.3, totalRatingsCount=123,
      createdAt="2026-08-31T15:42:15.544585Z", updatedAt="2026-08-31T15:42:15.544585Z",
    ),
    ClubDto(
      id="8161f9ec-7457-4ec1-a3fc-6496e1692eff", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arkose Marseille Prado", address="101 Bd Michelet, 13009 Marseille",
      city="Marseille", country="FR",
      latitude=43.267733, longitude=5.394701,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b888a02-0166-43d3-948c-d4c9e91d5663_ChIJET9leKe4_0.jpg",
      averageRating=4.3, totalRatingsCount=794,
      createdAt="2026-08-30T21:18:51.670532Z", updatedAt="2026-08-30T21:55:15.597762Z",
    ),
    ClubDto(
      id="4d2e922a-11d0-4dec-bf90-292eb65289b7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Catalans Beach Volley", address="1 Rue des Catalans, 13007 Marseille",
      city="Marseille", country="FR",
      latitude=43.2903295, longitude=5.3558604,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84492929-c619-446b-b382-bdbf5a121f19_photo.jpg",
      averageRating=4.3, totalRatingsCount=64,
      createdAt="2026-08-31T15:42:00.320834Z", updatedAt="2026-08-31T22:11:14.988072Z",
    ),
    ClubDto(
      id="1b28f6da-79dc-4686-917c-895a1536d065", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UrbanSoccer Marseille La Valentine", address="1 Mnt Commandant de Robien, 13011 Marseille",
      city="Marseille", country="FR",
      latitude=43.2859688, longitude=5.4882746,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/91506441-fec0-460b-888e-7e45aea5bbb9_ChIJ41AMCxC8_0.jpg",
      averageRating=4.3, totalRatingsCount=626,
      createdAt="2026-08-30T21:18:02.445907Z", updatedAt="2026-08-30T21:18:02.445907Z",
    ),
    ClubDto(
      id="f699785d-a9e1-490b-a483-ff4af916d52b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Patinoire Palais Omnisports Marseille Grand-Est", address="12 Bd Fernand Bonnefoy, 13010 Marseille",
      city="Marseille", country="FR",
      latitude=43.2820888, longitude=5.4017534,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4ddaf142-24d1-48b6-86f9-201a63362114_ChIJD2_v-FK__0.jpg",
      averageRating=4.2, totalRatingsCount=3480,
      createdAt="2026-08-30T21:19:04.573628Z", updatedAt="2026-08-30T21:59:26.967036Z",
    ),
    ClubDto(
      id="ec1e171a-b337-4f86-a85f-d668308de43d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Shamrock", address="16 Quai de Rive Neuve, 13007 Marseille",
      city="Marseille", country="FR",
      latitude=43.2929839, longitude=5.3704731,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/72dbb6c1-b267-47d7-afd2-66f356b5c420_ChIJH8aneMbA_3.jpg",
      averageRating=4.2, totalRatingsCount=3169,
      createdAt="2026-08-30T21:18:30.451949Z", updatedAt="2026-08-31T22:11:23.022548Z",
    ),
    ClubDto(
      id="648e47ad-a28d-4743-8f50-c9389f1acabf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Marseille Sports Palace", address="81 Rue Raymond Teisseire, 13009 Marseille",
      city="Marseille", country="FR",
      latitude=43.2706253, longitude=5.4009917,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/001232df-f7fe-4498-99c2-409c9fb22ed0_photo.jpg",
      averageRating=4.1, totalRatingsCount=1481,
      createdAt="2026-08-31T15:41:34.097824Z", updatedAt="2026-08-31T15:41:34.097824Z",
    ),
    ClubDto(
      id="8d1fe858-2405-4784-a0cf-1d9e6288ef7b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club de Marseille | Tennis", address="10 Bd de Tunis, 13008 Marseille",
      city="Marseille", country="FR",
      latitude=43.2678952, longitude=5.3807777,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4042352-8fe2-4c31-9973-86f78cafeb28_ChIJQSnIUETH_0.jpg",
      averageRating=4.1, totalRatingsCount=181,
      createdAt="2026-08-30T21:19:32.149637Z", updatedAt="2026-08-30T22:01:27.040457Z",
    ),
    ClubDto(
      id="d0d5ddf2-1303-44cf-a50b-271188315808", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="THE QUEEN VICTORIA", address="1 Pl. aux Huiles, 13001 Marseille",
      city="Marseille", country="FR",
      latitude=43.2933333, longitude=5.3719071,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f000ee13-316a-4050-9465-9aa048827251_ChIJcVCaEsfA_0.jpg",
      averageRating=4.0, totalRatingsCount=4778,
      createdAt="2026-08-30T21:18:23.227299Z", updatedAt="2026-08-30T22:01:18.254352Z",
    ),
    ClubDto(
      id="6524f108-c499-42df-b950-a411a5725a01", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BEACH CONNECT - Beach Volley & Beach Tennis | Camps & Coaching", address="26 Trav. Pourrière, 13008 Marseille",
      city="Marseille", country="FR",
      latitude=43.2441671, longitude=5.385283,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7350c846-0708-4f9c-8d28-dddddf9ec84e_photo.jpg",
      averageRating=5.0, totalRatingsCount=29,
      createdAt="2026-08-31T15:42:07.361240Z", updatedAt="2026-08-31T15:42:07.361240Z",
    ),
    ClubDto(
      id="9ad4ad19-f4d5-40db-b948-4b7bcfb35e0c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Marseille Tennis de Table", address="488 Av. de Mazargues, 13008 Marseille",
      city="Marseille", country="FR",
      latitude=43.2553123, longitude=5.3938848,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/07e2d256-96ff-40ea-b206-ec9bdd4e2f49_photo.jpg",
      averageRating=4.8, totalRatingsCount=25,
      createdAt="2026-08-31T15:42:22.150921Z", updatedAt="2026-08-31T15:42:22.150921Z",
    ),
    ClubDto(
      id="a7879f63-1173-463a-9160-0d582d4b9fc2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Game Party 13", address="Av. du Prado, 13001 Marseille",
      city="Marseille", country="FR",
      latitude=43.2866621, longitude=5.3998522,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8d18cfff-a056-4769-89b1-50e41f6be8ca_photo.png",
      averageRating=3.7, totalRatingsCount=9,
      createdAt="2026-08-31T15:42:42.892549Z", updatedAt="2026-08-31T15:42:42.892549Z",
    ),
    ClubDto(
      id="84516583-c072-488e-9e7b-8fafdc28b69f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Massalia Volley", address="3 Chem. de la Colline Saint-Joseph, 13009 Marseille",
      city="Marseille", country="FR",
      latitude=43.2554309, longitude=5.4123542,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c6fcc5e6-5074-46f7-b81f-9b331ff63596_photo.jpg",
      averageRating=4.7, totalRatingsCount=7,
      createdAt="2026-08-31T15:41:38.363010Z", updatedAt="2026-08-31T15:41:38.363010Z",
    ),
    ClubDto(
      id="2e436d2f-c54d-4a49-b344-c62407866360", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Asptt Marseille Club Omnisports", address="3 Port de la Pointe Rouge Entrée n° 1, 13008 Marseille",
      city="Marseille", country="FR",
      latitude=43.2445059, longitude=5.3687052,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/218de397-9e79-4366-98ee-e2a0b5387cee_photo.jpg",
      averageRating=4.4, totalRatingsCount=7,
      createdAt="2026-08-31T15:41:51.870528Z", updatedAt="2026-08-31T15:41:51.870528Z",
    ),
    ClubDto(
      id="a280175f-7130-4779-bb35-92dc27c6bff6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cvbc Club De Volley-Ball Des Catalans", address="Plage des Catalans, 13007 Marseille",
      city="Marseille", country="FR",
      latitude=43.2908539, longitude=5.3555309,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cdb80e98-9b14-44a0-9b1e-3b66af10f022_photo.jpg",
      averageRating=3.5, totalRatingsCount=8,
      createdAt="2026-08-31T15:41:45.365828Z", updatedAt="2026-08-31T15:41:45.365828Z",
    ),
  )),
  CitySeo(slug="zagreb", name="Zagreb", country="HR", clubCount=26, sports=listOf(Pair("Volleyball", 4), Pair("Football", 4), Pair("Padel", 3), Pair("Tennis", 3), Pair("Karting", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Paintball", 2), Pair("Basketball", 1), Pair("Climbing", 1)), clubs=listOf(
    ClubDto(
      id="a9fe39a2-fec3-421d-88c8-4d59b867ead1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Embassy", address="Slavonska avenija 17, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8038157, longitude=16.0664368,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99388a36-7d77-4d1c-8f80-383edddf4dc1_ChIJA79OgzF5_0.jpg",
      averageRating=4.9, totalRatingsCount=77,
      createdAt="2026-08-30T23:37:33.344101Z", updatedAt="2026-08-31T08:33:44.908566Z",
    ),
    ClubDto(
      id="f8d600b8-7f1a-449c-b073-f4d9ddee9eed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Šervudska šuma", address="Stara karlovačka cesta 91, Pavučnjak, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7224929, longitude=15.7788727,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/36156bbf-2ec0-480b-b686-e5debafdaee0_ChIJXfEuyrAt_0.jpg",
      averageRating=4.9, totalRatingsCount=730,
      createdAt="2026-08-30T23:37:12.979221Z", updatedAt="2026-08-30T23:37:12.979221Z",
    ),
    ClubDto(
      id="5d4319fd-78a7-42e6-8485-813c00c518d5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Clubhouse Golf - Weddings & Events", address="Jadranska avenija 6-1, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7779147, longitude=15.8961505,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bd2a4ba5-5eaf-451c-a1e7-abfc064512ba_photo.png",
      averageRating=4.8, totalRatingsCount=576,
      createdAt="2026-08-31T15:21:17.828967Z", updatedAt="2026-08-31T15:21:17.828967Z",
    ),
    ClubDto(
      id="794efd7c-497a-47ec-9cef-f4d5771a71c2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportski centar Fairplay", address="Jazbina 150, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8584399, longitude=15.9984444,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4f57cfda-ccc5-4282-b634-6b37c5a121d9_ChIJ8wbJcdDZ_0.jpg",
      averageRating=4.7, totalRatingsCount=708,
      createdAt="2026-08-30T23:36:01.543669Z", updatedAt="2026-08-31T08:36:41.379159Z",
    ),
    ClubDto(
      id="fb2965a7-a25a-4dd1-9ad3-2ebd54c3d9b3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportski centar Mali Dom", address="Štefanovec ul. 37, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8608618, longitude=16.0224124,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dcd54036-5a9f-4e5e-a9a9-e19fa08ee209_ChIJl3cLKDHY_1.jpg",
      averageRating=4.7, totalRatingsCount=706,
      createdAt="2026-08-30T23:36:08.362093Z", updatedAt="2026-08-31T22:11:21.326075Z",
    ),
    ClubDto(
      id="dfa0394d-1932-47fb-9e84-61e6b603b8e6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Amazinga", address="Avenija Dubrovnik 15/39 Zagrebački Velesajam, Paviljon 36, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7828981, longitude=15.9754591,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed2e6dba-78a9-488e-baf5-3ab1d3df5ba5_ChIJRyv8VuvX_2.jpg",
      averageRating=4.6, totalRatingsCount=4215,
      createdAt="2026-08-30T23:37:06.472605Z", updatedAt="2026-08-31T22:11:13.590637Z",
    ),
    ClubDto(
      id="7fda1a3e-16f5-4468-900a-c32cdbd6203f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach volleyball club Siget", address="Siget ul. 24, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7714033, longitude=15.9694624,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d6dd834-bb32-4c44-a96f-cc62e1b1c4b4_photo.jpg",
      averageRating=4.6, totalRatingsCount=118,
      createdAt="2026-08-31T15:20:56.598078Z", updatedAt="2026-08-31T15:20:56.598078Z",
    ),
    ClubDto(
      id="7f456eb4-d27b-492f-8436-7dfad032fbda", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Iglu Šport", address="Zagrebačka cesta 194, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8008775, longitude=15.9140755,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/179153bd-1204-40e8-9f19-4026a9a6c858_ChIJHQ493W16_0.jpg",
      averageRating=4.6, totalRatingsCount=776,
      createdAt="2026-08-30T23:36:53.119752Z", updatedAt="2026-08-30T23:36:53.119752Z",
    ),
    ClubDto(
      id="f98f0f4e-084a-413f-af1c-35620802b0a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Metropolis Music & Billiards Club", address="Avenija Dubrovnik 10, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7770682, longitude=15.9749134,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/19821fed-d27d-4895-ba2a-7e20e0942d8b_ChIJx8Ju9XjW_3.jpg",
      averageRating=4.6, totalRatingsCount=469,
      createdAt="2026-08-30T23:36:27.198879Z", updatedAt="2026-08-31T22:11:19.062497Z",
    ),
    ClubDto(
      id="90c88027-48f3-40ab-9a8a-735ce41b38ad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rekreacijsko sportski centar Jarun", address="Aleja Matije Ljubeka 3, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7852914, longitude=15.9134231,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c70a9c56-38ea-496b-8a38-c03600badaa7_photo.jpg",
      averageRating=4.6, totalRatingsCount=921,
      createdAt="2026-08-31T15:20:49.218845Z", updatedAt="2026-08-31T15:20:49.218845Z",
    ),
    ClubDto(
      id="9e1c4486-ed55-4aeb-81b6-a9560cd7408d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Riverside Golf Zagreb", address="Jadranska avenija 6-1, 10020, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7779147, longitude=15.8961505,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/582efb52-ed1c-4e6f-ac1f-2e6725c6bf9d_photo.jpg",
      averageRating=4.6, totalRatingsCount=1441,
      createdAt="2026-08-31T15:21:09.761720Z", updatedAt="2026-08-31T15:21:09.761720Z",
    ),
    ClubDto(
      id="f3b781b1-924d-44e0-bd07-51af9c463d37", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="San-spin tenis centar", address="Miroševečina ul., 10040, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8548691, longitude=16.0266064,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1cc247fa-ff34-4c64-bf29-e4aeaf07dad5_ChIJl1ND3STY_0.jpg",
      averageRating=4.6, totalRatingsCount=225,
      createdAt="2026-08-30T23:37:55.094048Z", updatedAt="2026-08-31T08:36:01.282146Z",
    ),
    ClubDto(
      id="7fee019a-5463-4926-ab12-c17899f8561f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TK Chromos", address="Prisavlje, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7893829, longitude=16.0019953,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9fc3d611-fbfa-445e-b73b-405b6e0a089c_ChIJJY63rBXW_0.jpg",
      averageRating=4.6, totalRatingsCount=204,
      createdAt="2026-08-30T23:38:01.959599Z", updatedAt="2026-08-30T23:38:01.959599Z",
    ),
    ClubDto(
      id="8e110bf3-4ad8-4f9f-b62e-0d4264694469", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Biljarski klub Las Vegas", address="Ilica 209, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8138071, longitude=15.9396476,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1374aa25-3520-4afc-892f-8768352bc159_ChIJVfBMQ9HW_0.jpg",
      averageRating=4.5, totalRatingsCount=734,
      createdAt="2026-08-30T23:36:20.854602Z", updatedAt="2026-08-30T23:36:20.854602Z",
    ),
    ClubDto(
      id="473c6700-407c-40c7-a4e3-f43ba74f816c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling club", address="Ul. Florijana Andrašeca 14, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8014144, longitude=15.9606008,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/acdf524a-6cbc-4764-828e-d1f817e6d68a_ChIJ0d0QNOzW_0.jpg",
      averageRating=4.5, totalRatingsCount=1131,
      createdAt="2026-08-30T23:36:33.543256Z", updatedAt="2026-08-31T08:26:32.826411Z",
    ),
    ClubDto(
      id="be0897cd-f5e1-49e8-b7ce-118dbe3c9896", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dom odbojke Bojan Stranić", address="Jarunska ul. 5, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7835844, longitude=15.9483076,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0932086f-8af3-4afe-b5d4-945621e57b9b_photo.jpg",
      averageRating=4.5, totalRatingsCount=324,
      createdAt="2026-08-31T15:20:35.051394Z", updatedAt="2026-08-31T22:11:15.408641Z",
    ),
    ClubDto(
      id="80f2786f-b3c9-44b1-a6e0-a6e6c56859ea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dražen Petrović Basketball Hall", address="Savska cesta 30, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.802595, longitude=15.9634016,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/19209f5b-d664-481d-9332-c25a85ba38d4_photo.jpg",
      averageRating=4.5, totalRatingsCount=664,
      createdAt="2026-08-31T15:20:27.650653Z", updatedAt="2026-08-31T15:20:27.650653Z",
    ),
    ClubDto(
      id="c93c50f6-4e0b-4e59-9387-dda4a239cff4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel klub 'Padel.hr'", address="Avenija Dubrovnik 15, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7777832, longitude=15.9743977,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67a093d3-d75c-4356-bfc3-c6078b436df2_ChIJZf5SynnW_0.jpg",
      averageRating=4.5, totalRatingsCount=305,
      createdAt="2026-08-30T23:37:26.185594Z", updatedAt="2026-08-30T23:37:26.185594Z",
    ),
    ClubDto(
      id="04123d77-b7f6-4e23-b1d1-85b1ee42328f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KOOGLANA Zagreb - Bowling Importanne Galleria", address="Trg Drage Iblera 10, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8131864, longitude=15.985044,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e1f9c00-34f1-4e16-bb26-d93fbeae0b1f_ChIJXzuWVVXW_0.jpg",
      averageRating=4.4, totalRatingsCount=964,
      createdAt="2026-08-30T23:36:39.265123Z", updatedAt="2026-08-31T08:31:08.196580Z",
    ),
    ClubDto(
      id="40f02090-b764-4fa6-a925-d3bb7e1c0a19", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sanatorij Brestovac", address="10000, Podsljeme, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8919216, longitude=15.9525217,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/22b6ce37-b8d6-4cf5-a1ae-fac77eaa7fe5_ChIJsbjawDXa_2.jpg",
      averageRating=4.4, totalRatingsCount=490,
      createdAt="2026-08-30T23:37:19.852116Z", updatedAt="2026-08-31T22:11:21.223227Z",
    ),
    ClubDto(
      id="fdd2e48c-5782-4e3f-aba5-2708ca731aca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportski centar Concordia", address="Klanječka ul. 37a, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8058333, longitude=15.9363889,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cf9186a4-4778-4949-9ea1-3c3b621c6e21_ChIJaXYOzc7W_0.jpg",
      averageRating=4.4, totalRatingsCount=564,
      createdAt="2026-08-30T23:36:14.992264Z", updatedAt="2026-08-30T23:36:14.992264Z",
    ),
    ClubDto(
      id="e4c47681-f697-43a3-a0c0-963a127806f9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenis centar Maksimir", address="V Ravnice 10, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8196797, longitude=16.033606,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a591530e-b9e4-4082-a752-4d61caf3e358_ChIJNSVp1hwq_0.jpg",
      averageRating=4.4, totalRatingsCount=367,
      createdAt="2026-08-30T23:37:47.641069Z", updatedAt="2026-08-31T08:37:25.923155Z",
    ),
    ClubDto(
      id="f09d529d-5999-4433-aa08-9eb1428d019d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="NC Šalata (Paviljon 1)", address="Ul. Radoslava Cimermana 1, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7787877, longitude=15.9667605,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8dd51b24-a0be-4601-a0fe-6de9a4800f1c_ChIJh95xxn_W_0.jpg",
      averageRating=4.3, totalRatingsCount=1202,
      createdAt="2026-08-30T23:35:54.619521Z", updatedAt="2026-08-30T23:35:54.619521Z",
    ),
    ClubDto(
      id="04f47584-0cd0-4a89-b66a-09f6c0db2ab3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zagrebački velesajam d.o.o.", address="Avenija Dubrovnik 15, 10020, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7779219, longitude=15.9694918,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d7dc7d6-5515-4bf0-920e-4296c945d584_ChIJ48sfdH_W_0.jpg",
      averageRating=4.2, totalRatingsCount=10867,
      createdAt="2026-08-30T23:37:00.129091Z", updatedAt="2026-08-31T08:39:15.423836Z",
    ),
    ClubDto(
      id="f523f684-c419-451a-9276-415e06fd367e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klub odbojke na pijesku Erste Zagreb", address="Aleja Matije Ljubeka, 10000, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.7809705, longitude=15.9341342,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d09643ea-3a49-4f35-a2e5-277906353c4a_photo.jpg",
      averageRating=4.1, totalRatingsCount=100,
      createdAt="2026-08-31T15:20:41.521684Z", updatedAt="2026-08-31T15:20:41.521684Z",
    ),
    ClubDto(
      id="50eaa519-3c3b-42d2-8086-22ce580c99ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel&Pickleball Academy Borčec", address="Borčec ul. 44, 10090, Zagreb",
      city="Zagreb", country="HR",
      latitude=45.8332455, longitude=15.8825392,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/93a14eca-cb35-478b-94ce-994c6481e671_ChIJ7-KZFiPR_0.jpg",
      averageRating=4.6, totalRatingsCount=37,
      createdAt="2026-08-30T23:37:40.448889Z", updatedAt="2026-08-30T23:37:40.448889Z",
    ),
  )),
  CitySeo(slug="porto", name="Porto", country="PT", clubCount=26, sports=listOf(Pair("Football", 4), Pair("Tennis", 3), Pair("Padel", 3), Pair("Laser Tag", 2), Pair("Golf", 2), Pair("Basketball", 2), Pair("Volleyball", 2), Pair("Karting", 2), Pair("Climbing", 2), Pair("Billiards", 1), Pair("Paintball", 1), Pair("Bowling", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="2b8c3f52-20a0-4985-af77-22efd143e3ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Banzai (Bolhão)", address="Rua, R. do Dr. António Emílio de Magalhães nº 24, 4000-090 Porto",
      city="Porto", country="PT",
      latitude=41.1482922, longitude=-8.6079514,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67c4c5b0-85ed-433f-b606-a53aed89f9b8_ChIJQV8sTLNl_1.jpg",
      averageRating=4.9, totalRatingsCount=2446,
      createdAt="2026-08-30T21:40:12.182867Z", updatedAt="2026-08-31T22:11:14.129297Z",
    ),
    ClubDto(
      id="e6a97edd-64bb-4ad4-9827-3067b9fc26d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="São Rock Climbing", address="R. de Godim 312, 4300-277 Porto",
      city="Porto", country="PT",
      latitude=41.1544231, longitude=-8.5873118,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e88c7c6-6214-457d-aad1-88c5fda5335f_ChIJ0aMxCC5l_0.jpg",
      averageRating=4.8, totalRatingsCount=708,
      createdAt="2026-08-30T21:39:50.860115Z", updatedAt="2026-08-30T21:39:50.860115Z",
    ),
    ClubDto(
      id="5b952ac8-1918-41bb-84e5-74e68732198f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Estádio do Dragão", address="Entrada Poente, Via Futebol Clube do Porto Porta 1, Piso 3, 4350-415 Porto",
      city="Porto", country="PT",
      latitude=41.16177, longitude=-8.583591,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83923dfe-2f59-45e0-8035-a9cadc4c41d3_ChIJ9wuiogJl_0.jpg",
      averageRating=4.7, totalRatingsCount=44571,
      createdAt="2026-08-30T21:39:12.509711Z", updatedAt="2026-08-30T21:56:37.223096Z",
    ),
    ClubDto(
      id="03818c05-a49f-4fff-9d23-afa537d5c929", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The North Wall", address="Rua do Tronco 375 Núcleo Empresarial Sarcol - Espaço W0.5, 4465-275 Porto",
      city="Porto", country="PT",
      latitude=41.1846055, longitude=-8.6217375,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/afaf53a1-b46e-4a13-b715-c9464e799a7a_ChIJCZ84QV1l_0.jpg",
      averageRating=4.7, totalRatingsCount=233,
      createdAt="2026-08-30T21:39:57.706556Z", updatedAt="2026-08-30T21:39:57.706556Z",
    ),
    ClubDto(
      id="d1eaccdd-da33-41e6-86d0-1bae91f3da4b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Your Padel", address="R. Eng. Ferreira Dias 241, 4100-246 Porto",
      city="Porto", country="PT",
      latitude=41.1713537, longitude=-8.6428723,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d1f0947f-27f2-4e6b-b56d-3899b355a957_ChIJ0-DTQ8tl_0.jpg",
      averageRating=4.7, totalRatingsCount=205,
      createdAt="2026-08-30T21:40:40.888743Z", updatedAt="2026-08-30T22:02:27.733367Z",
    ),
    ClubDto(
      id="d240af83-687b-47c8-a95a-cb553f22b26c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Complexo Desportivo do Monte Aventino", address="R. do Monte Aventino S/N, 4350-233 Porto",
      city="Porto", country="PT",
      latitude=41.1616955, longitude=-8.5898635,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b79f8a20-5d96-48e4-bcbe-bda42ac0b97d_ChIJV_Ow-mFk_0.jpg",
      averageRating=4.6, totalRatingsCount=230,
      createdAt="2026-08-30T21:41:02.073119Z", updatedAt="2026-09-01T14:31:56.299146Z",
    ),
    ClubDto(
      id="e7fc4fb0-3041-4c47-9df0-046e4b91327f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Estela Golf Club", address="Rio Alto, 4570-242 Estela",
      city="Porto", country="PT",
      latitude=41.4564771, longitude=-8.7766298,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5c30214c-daa3-4860-afa2-ae3eccc8b6ff_photo.png",
      averageRating=4.6, totalRatingsCount=561,
      createdAt="2026-08-31T15:34:11.627533Z", updatedAt="2026-08-31T15:34:11.627533Z",
    ),
    ClubDto(
      id="166ffc47-18db-4908-9fb2-be75c4996ace", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Jumpers - Trampolim Parque - Porto", address="R. Eng. Ferreira Dias 874, 4100-246 Porto",
      city="Porto", country="PT",
      latitude=41.1758863, longitude=-8.6467817,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db31276e-cde9-4589-b9db-c650aa307eaa_ChIJY02F0JJl_1.jpg",
      averageRating=4.6, totalRatingsCount=2607,
      createdAt="2026-08-30T21:40:05.023518Z", updatedAt="2026-08-31T22:11:18.078358Z",
    ),
    ClubDto(
      id="b6139463-1d38-474e-9f87-fb7b0317c8bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Motion Degree Paintball Porto", address="Estr. Real, Lugar das Guardeiras, 4470-274 Porto",
      city="Porto", country="PT",
      latitude=41.2548543, longitude=-8.6538896,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d38ea59f-b14b-49f7-a6cd-46502bcb3fc7_ChIJ6W9sRQto_0.jpg",
      averageRating=4.6, totalRatingsCount=88,
      createdAt="2026-08-30T21:40:20.392219Z", updatedAt="2026-08-30T21:40:20.392219Z",
    ),
    ClubDto(
      id="6874a29f-f885-4441-98b1-2ce27a65c007", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Norte Padel", address="Av. Fontes Pereira de Melo 246, 4100-259 Porto",
      city="Porto", country="PT",
      latitude=41.1776981, longitude=-8.6517579,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5f1b4d1e-8ac5-42e7-a68e-1f7f5e34ca37_ChIJfVkZ35pl_0.jpg",
      averageRating=4.6, totalRatingsCount=231,
      createdAt="2026-08-30T21:40:33.729288Z", updatedAt="2026-08-30T21:40:33.729288Z",
    ),
    ClubDto(
      id="0e0d333b-d50e-4016-8443-5ed74524cf9d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Oporto Cricket And Lawn Tennis Club", address="Rua do Campo Alegre 530, 4050-170 Porto",
      city="Porto", country="PT",
      latitude=41.1524306, longitude=-8.6348046,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c13ce3d-66ef-47b5-a227-9e45a401200e_ChIJi-UKhwtl_0.jpg",
      averageRating=4.6, totalRatingsCount=308,
      createdAt="2026-08-30T21:40:55.216581Z", updatedAt="2026-08-30T21:40:55.216581Z",
    ),
    ClubDto(
      id="527f84fe-5daf-4120-8c20-d12f34ded8d0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Athletic Club", address="R. Eng. Ferreira Dias 1010, 4100-248 Porto",
      city="Porto", country="PT",
      latitude=41.1772504, longitude=-8.6484527,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5595301d-21d1-45ff-ba39-21d3802d26b3_ChIJdWH2HGdl_0.jpg",
      averageRating=4.6, totalRatingsCount=234,
      createdAt="2026-08-30T21:40:27.065362Z", updatedAt="2026-09-01T14:31:53.432436Z",
    ),
    ClubDto(
      id="9a3485f3-e741-4ad9-a6e0-02e885a1c28d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Clube de Ténis do Porto", address="R. de Damião de Góis 405, 4050-227 Porto",
      city="Porto", country="PT",
      latitude=41.1611078, longitude=-8.6144573,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a9cdc27-ec71-45fd-9704-47eda544351e_ChIJuS_e5VRk_0.jpg",
      averageRating=4.5, totalRatingsCount=462,
      createdAt="2026-08-30T21:40:47.486884Z", updatedAt="2026-08-30T21:56:11.355408Z",
    ),
    ClubDto(
      id="2548ebd9-5fa9-4e2c-8e61-ba5b7cbdb71a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kartodromo de Baltar", address="Av. de São Silvestre 760, 4585-050 Baltar",
      city="Porto", country="PT",
      latitude=41.1878079, longitude=-8.3972331,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0c9f04a9-311c-42c4-b5c1-e425931c9c4e_photo.jpg",
      averageRating=4.5, totalRatingsCount=1038,
      createdAt="2026-08-31T15:34:39.143655Z", updatedAt="2026-08-31T15:34:39.143655Z",
    ),
    ClubDto(
      id="375f7ec7-7b3c-4c0d-aecd-3fd505873e1c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Baixa_Bar", address="R. de Cândido dos Reis 52, 4050-151 Porto",
      city="Porto", country="PT",
      latitude=41.1467493, longitude=-8.6138894,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/140f3933-8df9-43c6-a0bb-1502aaaf5823_ChIJiQSR-eJk_0.jpg",
      averageRating=4.4, totalRatingsCount=1328,
      createdAt="2026-08-30T21:39:44.710296Z", updatedAt="2026-08-30T21:39:44.710296Z",
    ),
    ClubDto(
      id="c5304efc-dcc7-4bda-816f-ef33ae2d95e8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CityGolf - Senhora da Hora", address="R. Abade Correia da Serra 150, 4460-208 Sra. da Hora",
      city="Porto", country="PT",
      latitude=41.1842062, longitude=-8.6398378,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cb40b05b-2c0c-49f7-ab11-836e8e2cfb21_photo.jpg",
      averageRating=4.4, totalRatingsCount=423,
      createdAt="2026-08-31T15:34:03.469328Z", updatedAt="2026-08-31T15:34:03.469328Z",
    ),
    ClubDto(
      id="76020dfa-5593-4a14-94e4-311c85a843bb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kart Center de Matosinhos", address="R. do Progresso 359 375, 4455-533 Perafita",
      city="Porto", country="PT",
      latitude=41.217756, longitude=-8.6954001,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e8782993-d986-4d9d-9bd1-7e59115581ba_photo.jpg",
      averageRating=4.4, totalRatingsCount=1635,
      createdAt="2026-08-31T15:34:27.928208Z", updatedAt="2026-08-31T15:34:27.928208Z",
    ),
    ClubDto(
      id="e14400b8-7f33-49d1-b539-d532ef22af6b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Associação Juvenil Escola de Futebol Hernâni Gonçalves", address="R. de Alves Redol 292, 4050-042 Porto",
      city="Porto", country="PT",
      latitude=41.1597079, longitude=-8.6155367,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cccbfc1e-9fe1-49d9-8820-4b6dc95c8615_ChIJ8ThPNFVk_0.jpg",
      averageRating=4.3, totalRatingsCount=517,
      createdAt="2026-08-30T21:39:32.592031Z", updatedAt="2026-08-30T21:39:32.592031Z",
    ),
    ClubDto(
      id="09b5f589-22fe-4b74-a07f-2b9809bb8309", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Footspace - Indoor Soccer", address="R. Manuel Pinto de Azevedo 269, 4100-321 Porto",
      city="Porto", country="PT",
      latitude=41.172201, longitude=-8.6465015,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9a8e7252-7520-4d78-a9e6-922fd0ae06f8_photo.jpg",
      averageRating=4.3, totalRatingsCount=489,
      createdAt="2026-08-31T15:33:24.055666Z", updatedAt="2026-08-31T15:33:24.055666Z",
    ),
    ClubDto(
      id="39f520a5-3369-43bf-b48c-e340d67602b9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Grupo Desportivo Cultural e Social de Santo Eugénio", address="R. Andorinhas 18, 4250-036 Porto",
      city="Porto", country="PT",
      latitude=41.1809125, longitude=-8.638096,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/465a7224-064e-457d-9f85-5dc5166dbfbd_photo.jpg",
      averageRating=4.3, totalRatingsCount=126,
      createdAt="2026-08-31T15:33:52.861982Z", updatedAt="2026-08-31T15:33:52.861982Z",
    ),
    ClubDto(
      id="811da8c8-a806-4906-a8db-0656e97543d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Oporto Indoor Games", address="R. Eng. Ferreira Dias 1063, 4100-247 Porto",
      city="Porto", country="PT",
      latitude=41.176975, longitude=-8.648656,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff7fe18c-2987-4cc6-840e-f4733c3227a2_ChIJ19cEDJNl_0.jpg",
      averageRating=4.3, totalRatingsCount=640,
      createdAt="2026-08-30T21:39:25.321238Z", updatedAt="2026-08-30T21:39:25.321238Z",
    ),
    ClubDto(
      id="947c3b69-d166-42d9-8e6c-a44029936c00", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoor Soccer Arca d'Água", address="R. de Nove de Abril 912, 4250-345 Porto",
      city="Porto", country="PT",
      latitude=41.1700634, longitude=-8.6156129,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fb612c03-6f6d-41d4-b715-207221686d65_photo.jpg",
      averageRating=4.2, totalRatingsCount=460,
      createdAt="2026-08-31T15:33:31.926734Z", updatedAt="2026-08-31T22:11:17.864509Z",
    ),
    ClubDto(
      id="371b07df-918f-4941-9722-5615d6ee7659", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Parque Desportivo de Ramalde", address="R. Dr. Aarão de Lacerda, 4100-015 Porto",
      city="Porto", country="PT",
      latitude=41.1679394, longitude=-8.6572953,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aec4f040-2a0e-4e70-b29e-6ed9c17d3bb3_ChIJhRmwsoll_0.jpg",
      averageRating=4.2, totalRatingsCount=1192,
      createdAt="2026-08-30T21:39:18.758756Z", updatedAt="2026-08-30T21:39:18.758756Z",
    ),
    ClubDto(
      id="3c595b3d-154e-4f7d-beaf-fdda4e5e775d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sould Park Bowling Porto", address="ArrábidaShopping, PCT de Henrique Moreira 244, 4400-346 Vila Nova de Gaia",
      city="Porto", country="PT",
      latitude=41.1413143, longitude=-8.6370288,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b2810583-5b17-40d8-8bce-4f5d3dd49f89_photo.jpg",
      averageRating=4.2, totalRatingsCount=397,
      createdAt="2026-08-31T15:34:47.562688Z", updatedAt="2026-08-31T15:34:47.562688Z",
    ),
    ClubDto(
      id="239e6dac-3e5a-4d94-8837-b354ac34bde8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TTPOR - Table Tennis Academy", address="Vitória Futebol Clube, Estádio do Bonfim, 2901-882 Setúbal",
      city="Porto", country="PT",
      latitude=38.53032, longitude=-8.891499,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7f52c5be-9daf-414e-ad69-c6716f503031_photo.jpg",
      averageRating=5.0, totalRatingsCount=29,
      createdAt="2026-08-31T15:34:19.222585Z", updatedAt="2026-08-31T15:34:19.222585Z",
    ),
    ClubDto(
      id="1f708347-ce45-494a-92a2-615ef0437e3a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Center POLYTECHNIC OF PORTO", address="R. Dr. Manuel Pereira da Silva 30, Porto",
      city="Porto", country="PT",
      latitude=41.1790945, longitude=-8.598132,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e1f8aab-952e-4662-9e0b-9fc75684aadf_photo.jpg",
      averageRating=4.5, totalRatingsCount=24,
      createdAt="2026-08-31T15:33:41.306524Z", updatedAt="2026-08-31T15:33:41.306524Z",
    ),
  )),
  CitySeo(slug="oslo", name="Oslo", country="NO", clubCount=26, sports=listOf(Pair("Football", 4), Pair("Padel", 3), Pair("Volleyball", 3), Pair("Basketball", 3), Pair("Table Tennis", 2), Pair("Tennis", 2), Pair("Climbing", 2), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Golf", 1), Pair("Karting", 1), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="00eb7c55-f5d4-4dea-b06f-f977b0bb3919", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Oslo Klatresenter", address="Olaf Helsets vei 5, 0694 Oslo",
      city="Oslo", country="NO",
      latitude=59.8675669, longitude=10.8416712,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/60b94001-521b-4a4d-ac69-1f2fd6ae83c3_ChIJMx576VBv_0.jpg",
      averageRating=4.8, totalRatingsCount=1421,
      createdAt="2026-08-30T23:17:01.742551Z", updatedAt="2026-08-31T08:33:32.422753Z",
    ),
    ClubDto(
      id="266ee8da-29b4-4ef5-9fa4-1d60eb1f3f41", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nordic Padel", address="Østre Aker vei 60, 0581 Oslo",
      city="Oslo", country="NO",
      latitude=59.9314928, longitude=10.8240128,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b0d614f2-1a1b-4272-981c-d13e09001e68_ChIJOd9B43pv_0.jpg",
      averageRating=4.7, totalRatingsCount=180,
      createdAt="2026-08-30T23:17:28.315514Z", updatedAt="2026-08-31T08:33:17.302078Z",
    ),
    ClubDto(
      id="c7abc096-dfbf-4590-9fca-0a7e3a0170b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klatreverket I Torshov klatresenter", address="Myrens Verksted 3K, 0473 Oslo",
      city="Oslo", country="NO",
      latitude=59.9347922, longitude=10.759512,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6a576589-e0a7-4904-aeb1-dd6ae2ccc46f_ChIJZTd8TRNu_0.jpg",
      averageRating=4.5, totalRatingsCount=696,
      createdAt="2026-08-30T23:17:08.810Z", updatedAt="2026-08-31T08:31:22.078147Z",
    ),
    ClubDto(
      id="e4b184f5-b780-446a-818d-bef3f0939eb0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Oslo Beach volleyball club", address="Uelands gate 85, 0462 Oslo",
      city="Oslo", country="NO",
      latitude=59.9438483, longitude=10.7522051,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39cf3c91-8326-4cca-9e09-60facb39b648_photo.jpg",
      averageRating=4.5, totalRatingsCount=74,
      createdAt="2026-08-31T15:44:34.850261Z", updatedAt="2026-08-31T15:44:34.850261Z",
    ),
    ClubDto(
      id="16d6642e-be7a-4725-9f9b-f7d53f915e80", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Athletica Domus", address="Trimveien 4, 0372 Oslo",
      city="Oslo", country="NO",
      latitude=59.9465611, longitude=10.7239376,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c26f79aa-cd87-4bc6-86e6-51c03856bbb6_ChIJhbVX-eRt_0.jpg",
      averageRating=4.4, totalRatingsCount=685,
      createdAt="2026-08-30T23:16:35.418640Z", updatedAt="2026-08-31T08:25:04.317173Z",
    ),
    ClubDto(
      id="298830d5-0a16-4f75-b5a5-2b70a746061a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Furuset Tennis IF", address="Tevlingveien 5, 1081 Oslo",
      city="Oslo", country="NO",
      latitude=59.9335836, longitude=10.8696669,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/76457a48-b2e4-4ffe-ba5c-091885195148_ChIJPbSYBfFv_0.jpg",
      averageRating=4.4, totalRatingsCount=56,
      createdAt="2026-08-30T23:17:47.851496Z", updatedAt="2026-09-01T14:31:52.546321Z",
    ),
    ClubDto(
      id="33672d50-0de4-471b-b513-a9014801b629", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Harald Huysman Karting", address="Smalvollveien 34, 0667 Oslo",
      city="Oslo", country="NO",
      latitude=59.9191215, longitude=10.8365072,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9bcf4ad9-d24a-41a6-bb56-c8f86aecf387_ChIJtSP6DL1v_0.jpg",
      averageRating=4.4, totalRatingsCount=1658,
      createdAt="2026-08-30T23:17:14.990467Z", updatedAt="2026-08-30T23:17:14.990467Z",
    ),
    ClubDto(
      id="2d15b04c-36b8-4feb-97d5-579b90a67a91", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Highjump Event AS", address="Stensrudåsveien 5, 1294 Oslo",
      city="Oslo", country="NO",
      latitude=59.824489, longitude=10.866682,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5bbe169b-6e12-4298-ad33-dcda9736fbe4_ChIJ0ebpFtVt_0.jpg",
      averageRating=4.4, totalRatingsCount=174,
      createdAt="2026-08-30T23:17:21.895729Z", updatedAt="2026-08-31T08:29:00.889664Z",
    ),
    ClubDto(
      id="9a38e614-f54a-4e70-aa35-9f6db289d3d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tilt", address="Badstugata 6, 0183 Oslo",
      city="Oslo", country="NO",
      latitude=59.9161988, longitude=10.7507114,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4b8facf6-9fcf-4681-95a0-f460406c4f53_ChIJWRPZOGJu_0.jpg",
      averageRating=4.4, totalRatingsCount=2147,
      createdAt="2026-08-30T23:16:55.571327Z", updatedAt="2026-08-30T23:16:55.571327Z",
    ),
    ClubDto(
      id="1aac2ccb-1557-42ab-be7a-71fb42b75c57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SATS Colosseum", address="Middelthuns gate 19, 0368 Oslo",
      city="Oslo", country="NO",
      latitude=59.9285995, longitude=10.7108446,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fb303882-e699-4a0f-a546-51fdfcff99a7_photo.jpg",
      averageRating=4.3, totalRatingsCount=575,
      createdAt="2026-08-31T15:44:19.590107Z", updatedAt="2026-08-31T15:44:19.590107Z",
    ),
    ClubDto(
      id="78642aef-10df-45e5-a100-dfbed5b01041", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Spikersuppa skøytebane", address="Karl Johans gt. 41B, 0162 Oslo",
      city="Oslo", country="NO",
      latitude=59.9139132, longitude=10.7370464,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4b49341b-2b28-441a-8b4c-fbb7877f671b_ChIJRb8leH1u_0.jpg",
      averageRating=4.3, totalRatingsCount=3072,
      createdAt="2026-08-30T23:16:20.417627Z", updatedAt="2026-08-30T23:16:20.417627Z",
    ),
    ClubDto(
      id="af4d9fce-9af4-4ee1-988b-c8c6ce9da9e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Voldsløkka idrettspark", address="Stavangergata 40, 0467 Oslo",
      city="Oslo", country="NO",
      latitude=59.9450712, longitude=10.7569457,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/efb4e896-ec70-4adb-a09a-4b697f3329ff_ChIJOwgkFA5u_1.jpg",
      averageRating=4.3, totalRatingsCount=667,
      createdAt="2026-08-30T23:16:41.888868Z", updatedAt="2026-08-31T22:11:23.785922Z",
    ),
    ClubDto(
      id="67885d64-228e-4efe-a1cb-6d23418b3999", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KFUM-hallen", address="Ekebergveien 109, 1178 Oslo",
      city="Oslo", country="NO",
      latitude=59.8886806, longitude=10.7821698,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/823bd894-0365-4ac8-a75f-70ea8039e056_photo.jpg",
      averageRating=4.2, totalRatingsCount=70,
      createdAt="2026-08-31T15:44:52.081957Z", updatedAt="2026-08-31T15:44:52.081957Z",
    ),
    ClubDto(
      id="5c6c870e-4dc5-474e-bc30-22f746db67f8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vallhall Arena", address="Dronning Margretes Vei 11, 0663 Oslo",
      city="Oslo", country="NO",
      latitude=59.9204919, longitude=10.8061455,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b0586a16-5546-4fd0-a42c-9f642e1debff_ChIJT7sMjLJv_0.jpg",
      averageRating=4.2, totalRatingsCount=988,
      createdAt="2026-08-30T23:16:27.216965Z", updatedAt="2026-08-30T23:16:27.216965Z",
    ),
    ClubDto(
      id="bda67fce-fac0-4d6c-bfc8-e142871b424f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Voksenhallen", address="Jarbakken 1, 0771 Oslo",
      city="Oslo", country="NO",
      latitude=59.9552176, longitude=10.655031,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/42d7f199-ce5d-4301-adab-ebcc8db760a4_photo.jpg",
      averageRating=4.2, totalRatingsCount=61,
      createdAt="2026-08-31T15:44:44.957996Z", updatedAt="2026-08-31T15:44:44.957996Z",
    ),
    ClubDto(
      id="200c38bd-90c4-4766-a216-50ced2a6bd0d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Groruddalen Golf Club", address="Karen Platous Vei 33, 0988 Oslo",
      city="Oslo", country="NO",
      latitude=59.9699855, longitude=10.9166037,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/946c54dd-5648-4b14-8140-cf414da3e57d_photo.png",
      averageRating=4.1, totalRatingsCount=213,
      createdAt="2026-08-31T15:44:59.933557Z", updatedAt="2026-08-31T15:44:59.933557Z",
    ),
    ClubDto(
      id="ff9140b5-b78b-460f-aa93-1ebb8c4e553c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Scotsman", address="Karl Johans gt. 35, 0162 Oslo",
      city="Oslo", country="NO",
      latitude=59.9140278, longitude=10.7380861,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/14bbb183-a63b-4659-9b97-d90c94d9df09_ChIJxUdpoGJu_0.jpg",
      averageRating=4.1, totalRatingsCount=5620,
      createdAt="2026-08-30T23:16:48.069199Z", updatedAt="2026-08-31T08:36:03.128193Z",
    ),
    ClubDto(
      id="168ea00a-4f99-4688-8bc4-b90ae7268c4b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="InterPadel Oslo", address="Stålfjæra 28, 0975 Oslo",
      city="Oslo", country="NO",
      latitude=59.950246, longitude=10.8805531,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1e774fc1-6ac7-4364-9d57-cb0b423f3cce_ChIJAVUUZtlx_0.jpg",
      averageRating=4.0, totalRatingsCount=117,
      createdAt="2026-08-30T23:17:35.154448Z", updatedAt="2026-08-31T08:31:04.645957Z",
    ),
    ClubDto(
      id="eb896aed-9632-46b1-8da0-2ce8694d3716", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Solli Bowling", address="Henrik Ibsens gate 100, 0255 Oslo",
      city="Oslo", country="NO",
      latitude=59.913969, longitude=10.718906,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d980ca7-da2d-4e55-bf6b-554129dbadaf_photo.jpg",
      averageRating=3.9, totalRatingsCount=539,
      createdAt="2026-08-31T15:45:19.044848Z", updatedAt="2026-08-31T15:45:19.044848Z",
    ),
    ClubDto(
      id="b40e5ca8-3110-4f6a-9fe0-4d7f633413cf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fokus Table Tennis Club", address="Traktorveien 15, 0678 Oslo",
      city="Oslo", country="NO",
      latitude=59.899086, longitude=10.8124,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1c3cd6b4-903e-475f-b333-bc2cf43452dd_photo.jpg",
      averageRating=4.5, totalRatingsCount=43,
      createdAt="2026-08-31T15:45:06.688050Z", updatedAt="2026-08-31T15:45:06.688050Z",
    ),
    ClubDto(
      id="f86d5f11-a816-4e87-ba1f-533644a0ec53", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lucky Bowl Veitvet", address="Veitvetveien 8, 0596 Oslo",
      city="Oslo", country="NO",
      latitude=59.9440845, longitude=10.8475201,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bb865386-8048-423b-9c5c-de35609c4d61_photo.jpg",
      averageRating=3.8, totalRatingsCount=519,
      createdAt="2026-08-31T15:45:27.181191Z", updatedAt="2026-08-31T15:45:27.181191Z",
    ),
    ClubDto(
      id="39508130-268a-46c5-a6d9-0eb97986787d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ullern Tennisklubb", address="Furulundsveien 15, 0282 Oslo",
      city="Oslo", country="NO",
      latitude=59.9241465, longitude=10.649715,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f3a4dadd-8455-4b7e-8523-90d8e5177214_ChIJt_r0lgBt_2.jpg",
      averageRating=4.7, totalRatingsCount=38,
      createdAt="2026-08-30T23:17:59.955327Z", updatedAt="2026-09-01T14:31:50.592592Z",
    ),
    ClubDto(
      id="3d1eb7e8-795a-4c0b-99e3-42a853412119", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kubaparken basketball court", address="Marselis' gate 15B, 0551 Oslo",
      city="Oslo", country="NO",
      latitude=59.9229537, longitude=10.7550748,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2126b953-afe2-4e6b-80ec-4605fe7c6514_photo.jpg",
      averageRating=4.4, totalRatingsCount=33,
      createdAt="2026-08-31T15:44:10.346237Z", updatedAt="2026-08-31T15:44:10.346237Z",
    ),
    ClubDto(
      id="43938ae2-51b5-4717-bb8a-423864875832", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="POP Nydalen (Padel & Golfsimulator Nydalen)", address="Gullhaug Torg 3, 0484 Oslo",
      city="Oslo", country="NO",
      latitude=59.9511111, longitude=10.7658333,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3afa66a1-543f-410b-9c24-541af86bdac6_ChIJc7lVn7tv_0.jpg",
      averageRating=4.5, totalRatingsCount=26,
      createdAt="2026-08-30T23:17:41.517041Z", updatedAt="2026-08-31T08:33:36.027592Z",
    ),
    ClubDto(
      id="145e4f3b-7d73-436a-aba7-593e71b1d629", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Oppsal Basket", address="Vetlandsveien 49, 0671 Oslo",
      city="Oslo", country="NO",
      latitude=59.9060704, longitude=10.8465373,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/efcfca9e-e10a-4bf4-b923-dbd825df7994_photo.jpg",
      averageRating=4.5, totalRatingsCount=22,
      createdAt="2026-08-31T15:44:26.883450Z", updatedAt="2026-08-31T15:44:26.883450Z",
    ),
    ClubDto(
      id="08019862-c5ae-43d1-9daa-dc94fe013465", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fornebu Bordtennisklubb", address="Forneburingen 300, 1364 Fornebu",
      city="Oslo", country="NO",
      latitude=59.8944294, longitude=10.611349,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2c2d466c-505d-4a88-86f8-805f9e29bdd4_photo.jpg",
      averageRating=4.9, totalRatingsCount=20,
      createdAt="2026-08-31T15:45:12.236458Z", updatedAt="2026-08-31T15:45:12.236458Z",
    ),
  )),
  CitySeo(slug="philadelphia", name="Philadelphia", country="US", clubCount=26, sports=listOf(Pair("Tennis", 4), Pair("Volleyball", 3), Pair("Padel", 3), Pair("Football", 3), Pair("Billiards", 2), Pair("Table Tennis", 2), Pair("Laser Tag", 2), Pair("Golf", 2), Pair("Bowling", 2), Pair("Climbing", 2), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="6b2c21c7-4731-4351-aef7-c4849e6b08b7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Five Iron Golf", address="1717 Arch St #140, Philadelphia, PA 19103",
      city="Philadelphia", country="US",
      latitude=39.9554152, longitude=-75.169043,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4d38c320-c0b4-4f96-b654-1c9be9da12bb_photo.jpg",
      averageRating=5.0, totalRatingsCount=416,
      createdAt="2026-09-20T19:21:25.504201Z", updatedAt="2026-09-20T19:21:25.504201Z",
    ),
    ClubDto(
      id="e4084491-364c-4cec-8496-1f3b65f6f5a9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club28 Table Tennis Club", address="3559 Edgemont St, Philadelphia, PA 19134",
      city="Philadelphia", country="US",
      latitude=39.9883609, longitude=-75.0942754,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ecfe2f7a-77e8-4e94-8a9f-4126eaf5c67b_photo.jpg",
      averageRating=4.8, totalRatingsCount=55,
      createdAt="2026-09-20T19:21:32.258128Z", updatedAt="2026-09-20T19:21:32.258128Z",
    ),
    ClubDto(
      id="71467e9a-6a61-4ed6-a852-21e32c1c62db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stryke Force Laser Tag", address="540 E Union St, West Chester, PA 19382",
      city="Philadelphia", country="US",
      latitude=39.9601131, longitude=-75.5946827,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/968e8a56-6b89-4103-90ea-3dc019160f31_photo.jpg",
      averageRating=4.8, totalRatingsCount=221,
      createdAt="2026-09-20T19:22:12.184224Z", updatedAt="2026-09-20T19:22:12.184224Z",
    ),
    ClubDto(
      id="5b1e4665-e81d-437e-bd5f-ece2ed6fa5b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Trolley Car Table Tennis Club", address="3300 Henry Ave, Philadelphia, PA 19129",
      city="Philadelphia", country="US",
      latitude=40.0121287, longitude=-75.1833402,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c41e76e6-422c-4f0c-a6f1-65c8870b6aa6_photo.jpg",
      averageRating=4.7, totalRatingsCount=82,
      createdAt="2026-09-20T19:21:28.851004Z", updatedAt="2026-09-20T19:21:28.851004Z",
    ),
    ClubDto(
      id="af25f75d-eba4-422a-b942-fad8aede18d4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ballers Philadelphia", address="1325 N Beach St, Philadelphia, PA 19125",
      city="Philadelphia", country="US",
      latitude=39.967446, longitude=-75.126293,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/308b0aca-e1e7-4cce-9272-1dee03304cad_photo.jpg",
      averageRating=4.6, totalRatingsCount=64,
      createdAt="2026-09-20T19:21:17.612914Z", updatedAt="2026-09-20T19:21:17.612914Z",
    ),
    ClubDto(
      id="5f7464ae-c598-4c04-b2c0-05950e1ede83", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fireball Mountain", address="295 Meany Rd, Wrightstown, NJ 08562",
      city="Philadelphia", country="US",
      latitude=40.0552102, longitude=-74.5607114,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5b0e49c9-c563-4618-a6c2-6f33a3818601_photo.jpg",
      averageRating=4.6, totalRatingsCount=421,
      createdAt="2026-09-20T19:22:06.514402Z", updatedAt="2026-09-20T19:22:06.514402Z",
    ),
    ClubDto(
      id="3293ad0d-2c57-4347-88f7-c1ef62147d82", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Phield House", address="814 Spring Garden St, Philadelphia, PA 19123",
      city="Philadelphia", country="US",
      latitude=39.9610315, longitude=-75.1527963,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "BASKETBALL", "VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/df952b76-0808-4b93-b185-ae061b02474e_photo.jpg",
      averageRating=4.6, totalRatingsCount=232,
      createdAt="2026-09-20T19:20:31.542097Z", updatedAt="2026-09-20T19:20:31.542097Z",
    ),
    ClubDto(
      id="ed63f52c-84ea-4341-ac8d-e2b344b27062", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Philadelphia Cricket Club", address="415 W Willow Grove Ave, Philadelphia, PA 19118",
      city="Philadelphia", country="US",
      latitude=40.0649746, longitude=-75.2092527,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ae603a5d-a6e0-4a2c-bb2f-2b0a81f0122c_photo.jpg",
      averageRating=4.6, totalRatingsCount=225,
      createdAt="2026-09-20T19:20:46.869865Z", updatedAt="2026-09-20T19:20:46.869865Z",
    ),
    ClubDto(
      id="105c9163-2c43-4c7c-b2d9-d0f98394537a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Philadelphia Rock Gyms - East Falls", address="B, 3500 Scotts Ln #3, Philadelphia, PA 19129",
      city="Philadelphia", country="US",
      latitude=40.0086794, longitude=-75.1840163,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5cd1c23d-78b7-4a3e-b005-281bd1fc3383_photo.jpg",
      averageRating=4.6, totalRatingsCount=359,
      createdAt="2026-09-20T19:21:55.603809Z", updatedAt="2026-09-20T19:21:55.603809Z",
    ),
    ClubDto(
      id="0ebc910f-7440-45a0-ab68-6e8b3b526346", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Racquet Club of Philadelphia", address="215 S 16th St, Philadelphia, PA 19102",
      city="Philadelphia", country="US",
      latitude=39.9490989, longitude=-75.1675357,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96f3eb4e-122a-4d17-9788-215adcff3f39_photo.jpg",
      averageRating=4.6, totalRatingsCount=161,
      createdAt="2026-09-20T19:20:53.263389Z", updatedAt="2026-09-20T19:20:53.263389Z",
    ),
    ClubDto(
      id="d8b7fafc-3799-4921-8ac6-b560f4e51af7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Germantown Cricket Club", address="411 Manheim St, Philadelphia, PA 19144",
      city="Philadelphia", country="US",
      latitude=40.0238817, longitude=-75.1733262,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d999b401-5c73-43b4-959c-ccbf921985de_photo.jpg",
      averageRating=4.5, totalRatingsCount=292,
      createdAt="2026-09-20T19:20:35.242543Z", updatedAt="2026-09-20T19:20:35.242543Z",
    ),
    ClubDto(
      id="e4d408d2-2a0a-4262-9b14-bfaf90f3adbd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Movement Callowhill", address="1010 Callowhill St, Philadelphia, PA 19123",
      city="Philadelphia", country="US",
      latitude=39.9586048, longitude=-75.1558168,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4620644f-4ba6-4bc4-8a0a-0f089ffe61d3_photo.jpg",
      averageRating=4.5, totalRatingsCount=542,
      createdAt="2026-09-20T19:21:50.971414Z", updatedAt="2026-09-20T19:21:50.971414Z",
    ),
    ClubDto(
      id="fc96d8b1-3ff4-48df-aca8-e8bfc42fc469", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pinsetter Bar & Bowl", address="7111 Maple Ave, Merchantville, NJ 08109",
      city="Philadelphia", country="US",
      latitude=39.952057, longitude=-75.0362373,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ea94b07c-e06a-4ca1-8f40-87cdb1e3bdd7_photo.jpg",
      averageRating=4.5, totalRatingsCount=1783,
      createdAt="2026-09-20T19:21:42.145687Z", updatedAt="2026-09-20T19:21:42.145687Z",
    ),
    ClubDto(
      id="1bd876d7-373c-4e3c-b903-b10b7747e75a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="YSC Sports", address="224 County Line Rd, Wayne, PA 19087",
      city="Philadelphia", country="US",
      latitude=40.0773687, longitude=-75.4039779,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/01f50910-9cd9-4917-ab21-f89892b95820_photo.jpg",
      averageRating=4.5, totalRatingsCount=474,
      createdAt="2026-09-20T19:20:27.040102Z", updatedAt="2026-09-20T19:20:27.040102Z",
    ),
    ClubDto(
      id="8250e620-b2ec-444e-b638-f37f8f4d5892", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Northeast Racquet Club & Fitness Center", address="9389 Krewstown Rd, Philadelphia, PA 19115",
      city="Philadelphia", country="US",
      latitude=40.0875548, longitude=-75.0434278,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/16948352-2c9d-424d-9e48-46afc8cfa548_photo.jpg",
      averageRating=4.4, totalRatingsCount=266,
      createdAt="2026-09-20T19:20:42.737918Z", updatedAt="2026-09-20T19:20:42.737918Z",
    ),
    ClubDto(
      id="9c2ed4d4-f1d4-4432-bcbb-b6bc5e877f30", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Parx Racing", address="2999 Street Rd, Bensalem, PA 19020",
      city="Philadelphia", country="US",
      latitude=40.1212051, longitude=-74.9521981,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/01c61c46-d836-40ce-aa90-90813c4fba24_photo.jpg",
      averageRating=4.4, totalRatingsCount=1115,
      createdAt="2026-09-20T19:21:35.940188Z", updatedAt="2026-09-20T19:21:35.940188Z",
    ),
    ClubDto(
      id="ab4a3a95-e594-4ae6-a69c-cf3cabf46c3d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Buffalo Billiards", address="118 Chestnut St, Philadelphia, PA 19106",
      city="Philadelphia", country="US",
      latitude=39.9481848, longitude=-75.1432796,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e3b1ffe6-8ab7-4f7c-bf9a-4ec9040ff549_photo.jpg",
      averageRating=4.3, totalRatingsCount=1069,
      createdAt="2026-09-20T19:22:02.788591Z", updatedAt="2026-09-20T19:22:02.788591Z",
    ),
    ClubDto(
      id="e8e7e388-bc70-4d79-bfc4-a0d08579983f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sofive Soccer Centers Cherry Hill (XL Sports World)", address="650 Kresson Rd, Cherry Hill Township, NJ 08034",
      city="Philadelphia", country="US",
      latitude=39.8890828, longitude=-75.0000176,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3a0c79ab-9b91-460c-87a4-cf04b9bddec5_photo.jpg",
      averageRating=4.3, totalRatingsCount=568,
      createdAt="2026-09-20T19:20:23.694265Z", updatedAt="2026-09-20T19:20:23.694265Z",
    ),
    ClubDto(
      id="c0c34017-c14e-41d8-ae8d-e4cbe81e8aa0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Competitive Edge Sports", address="320 S Henderson Rd, King of Prussia, PA 19406",
      city="Philadelphia", country="US",
      latitude=40.0896315, longitude=-75.3567947,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1eca1fd5-60c1-4a60-b988-8ef48ee79a5e_photo.jpg",
      averageRating=4.2, totalRatingsCount=344,
      createdAt="2026-09-20T19:21:10.986763Z", updatedAt="2026-09-20T19:21:10.986763Z",
    ),
    ClubDto(
      id="62d07789-0666-494a-aa0a-5406a9b958d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lucky Strike Philadelphia", address="1336 Chestnut St, Philadelphia, PA 19107",
      city="Philadelphia", country="US",
      latitude=39.9503182, longitude=-75.1632025,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/991fe84f-6f80-4c3b-bb2b-f82f4be0b442_photo.jpg",
      averageRating=4.2, totalRatingsCount=1568,
      createdAt="2026-09-20T19:21:46.216535Z", updatedAt="2026-09-20T19:21:46.216535Z",
    ),
    ClubDto(
      id="9aadacd6-2488-4592-bb3f-b6bec396b019", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="South Bowl", address="19 E Oregon Ave, Philadelphia, PA 19148",
      city="Philadelphia", country="US",
      latitude=39.9142764, longitude=-75.1471563,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a71d1e8-596a-4d52-a107-c0966ef37c3d_photo.jpg",
      averageRating=4.2, totalRatingsCount=1553,
      createdAt="2026-09-20T19:21:59.354365Z", updatedAt="2026-09-20T19:21:59.354365Z",
    ),
    ClubDto(
      id="b31e1662-8fba-48ce-81e9-690857232f12", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Heyday Athletic", address="3800 Manayunk Ave, Philadelphia, PA 19128",
      city="Philadelphia", country="US",
      latitude=40.0198024, longitude=-75.210871,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2fc5f4ea-3bfe-486a-b5cb-57d5219a28c1_photo.jpg",
      averageRating=4.1, totalRatingsCount=191,
      createdAt="2026-09-20T19:21:14.410021Z", updatedAt="2026-09-20T19:21:14.410021Z",
    ),
    ClubDto(
      id="db07ae81-24ce-4831-a4ae-0c81ed2674d6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Topgolf Philadelphia", address="2140 Byberry Rd, Philadelphia, PA 19116",
      city="Philadelphia", country="US",
      latitude=40.1083018, longitude=-75.0016091,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b865f792-f392-4963-9abe-72c844f53832_photo.jpg",
      averageRating=4.1, totalRatingsCount=860,
      createdAt="2026-09-20T19:21:21.068464Z", updatedAt="2026-09-20T19:21:21.068464Z",
    ),
    ClubDto(
      id="4a8e534b-6252-4853-bab2-0a9faa9cf00a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="VIVA Padel & Pickleball", address="1300 N 8th St, Philadelphia, PA 19122",
      city="Philadelphia", country="US",
      latitude=39.9729987, longitude=-75.1498463,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6b5f3477-bd36-481a-a998-8909e28947c1_photo.jpg",
      averageRating=5.0, totalRatingsCount=28,
      createdAt="2026-09-20T19:20:57.214606Z", updatedAt="2026-09-20T19:20:57.214606Z",
    ),
    ClubDto(
      id="da76ca11-383d-4b5c-956e-6093259b6209", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADELphia", address="601 Righters Ferry Rd, Bala Cynwyd, PA 19004",
      city="Philadelphia", country="US",
      latitude=40.0138832, longitude=-75.2113513,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0797bca3-2bc1-4777-9795-b6e61fb2c0bf_photo.jpg",
      averageRating=4.5, totalRatingsCount=22,
      createdAt="2026-09-20T19:21:00.906922Z", updatedAt="2026-09-20T19:21:00.906922Z",
    ),
    ClubDto(
      id="f6f42642-2bb0-4c4d-85f9-719173bb006b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Portres Sports Club", address="901 N Front St, 914 Canal St, Philadelphia, PA 19123",
      city="Philadelphia", country="US",
      latitude=39.9630478, longitude=-75.1378691,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/79aef184-7fbd-4b14-a8f2-72433389e39d_photo.jpg",
      averageRating=5.0, totalRatingsCount=17,
      createdAt="2026-09-20T19:21:07.547756Z", updatedAt="2026-09-20T19:21:07.547756Z",
    ),
  )),
  CitySeo(slug="belgrade", name="Belgrade", country="RS", clubCount=26, sports=listOf(Pair("Tennis", 3), Pair("Padel", 3), Pair("Football", 3), Pair("Billiards", 2), Pair("Paintball", 2), Pair("Table Tennis", 2), Pair("Basketball", 2), Pair("Karting", 2), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Bowling", 2), Pair("Volleyball", 1)), clubs=listOf(
    ClubDto(
      id="9494b849-af1e-4a48-abc7-15f5b32b60d8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bunker Airsoft i Glowblaster", address="Спасеновићева 17, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.7564464, longitude=20.4143732,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/751728c5-5da8-4948-a69b-87e459263ef7_ChIJ69zt9Vqa_0.jpg",
      averageRating=5.0, totalRatingsCount=95,
      createdAt="2026-08-30T22:41:38.760720Z", updatedAt="2026-08-31T08:26:41.150048Z",
    ),
    ClubDto(
      id="8b2a5f51-5c5a-4585-97b2-f75bb0e12f12", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Klub Max Beograd", address="Petrac kanal 39, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.7857627, longitude=20.3628819,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ecf08a9-ccc8-462e-bf0e-a031b6e8d93a_ChIJURYHZCtv_0.jpg",
      averageRating=5.0, totalRatingsCount=56,
      createdAt="2026-08-30T22:41:46.439712Z", updatedAt="2026-08-30T22:41:46.439712Z",
    ),
    ClubDto(
      id="4311725c-0af9-4bce-8a7a-4e42c87d681b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stretch Centar", address="Тошин бунар 181, Београд 11075",
      city="Belgrade", country="RS",
      latitude=44.8127003, longitude=20.3911419,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/10244323-85da-4646-9429-89f6c15ad5f4_ChIJd8L3C-pv_0.jpg",
      averageRating=5.0, totalRatingsCount=396,
      createdAt="2026-08-30T22:41:02.509357Z", updatedAt="2026-08-31T08:37:02.138959Z",
    ),
    ClubDto(
      id="de435d6b-1e8f-4b6b-9e15-5e43e48185af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hoop And Pump - Kosarkaska Hala i Teretana", address="Mije Aleksića 26, Beograd",
      city="Belgrade", country="RS",
      latitude=44.8036648, longitude=20.3336142,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8df21717-3440-43ad-b287-9765785284f4_photo.jpg",
      averageRating=4.9, totalRatingsCount=75,
      createdAt="2026-08-31T14:58:37.022147Z", updatedAt="2026-08-31T14:58:37.022147Z",
    ),
    ClubDto(
      id="00a30209-b050-47a7-bc33-2acfa2773cd2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rođendaonica Laser Tag Beograd Predator", address="Чаробне фруле 36, Београд 11160",
      city="Belgrade", country="RS",
      latitude=44.7930654, longitude=20.5369601,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a3f6f2c7-baf2-4977-9459-5fa8b32d8bfa_ChIJOwZcgiN7_0.jpg",
      averageRating=4.9, totalRatingsCount=275,
      createdAt="2026-08-30T22:41:23.801410Z", updatedAt="2026-08-31T08:35:29.203527Z",
    ),
    ClubDto(
      id="db231f2c-97c6-40f9-be88-5e98802664a2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Champions", address="Цара Душана 66, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.8215141, longitude=20.463225,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/03c22778-6424-416a-9c26-bb7e49738a94_ChIJE6bKqbV6_0.jpg",
      averageRating=4.7, totalRatingsCount=408,
      createdAt="2026-08-30T22:40:34.368283Z", updatedAt="2026-08-30T22:40:34.368283Z",
    ),
    ClubDto(
      id="728dffde-1a45-4d03-a338-6553977d8c7f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ташмајдан", address="Илије Гарашанина 26, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.8093187, longitude=20.4706762,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/51fd239f-9cbe-4c8e-9722-ad97eb9a1d24_ChIJ8fgqaaR6_0.jpg",
      averageRating=4.7, totalRatingsCount=21359,
      createdAt="2026-08-30T22:40:11.716683Z", updatedAt="2026-08-31T08:41:25.307567Z",
    ),
    ClubDto(
      id="31a7daf4-9833-46b3-9be6-660abc9eafc2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Baseline", address="Олимпијских игара 9, Београд",
      city="Belgrade", country="RS",
      latitude=44.765338, longitude=20.4202688,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9f04f6c1-ee40-45eb-b958-4ec54a3cedec_ChIJyw1Xu9dx_0.jpg",
      averageRating=4.6, totalRatingsCount=307,
      createdAt="2026-08-30T22:42:30.354222Z", updatedAt="2026-08-30T22:42:30.354222Z",
    ),
    ClubDto(
      id="b72653a7-5db0-44c7-942d-bcdf3f0c44b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beogradski padel klub - zatvoreni padel tereni", address="Жоржа Клемансоа 41, Београд",
      city="Belgrade", country="RS",
      latitude=44.8275179, longitude=20.4738704,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/09b97a71-5eb3-45ed-9cbb-e7a742cad10b_ChIJvbyZeQB7_0.jpg",
      averageRating=4.6, totalRatingsCount=118,
      createdAt="2026-08-30T22:42:00.563451Z", updatedAt="2026-08-31T08:26:01.749894Z",
    ),
    ClubDto(
      id="cef3d8d1-8bd1-4421-a8c1-0700b2f4576e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Bros", address="Ada Ciganlija BB, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.7921102, longitude=20.4089002,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/21b15a1e-f325-4193-b7e2-ecf75e0dcff2_ChIJlZzqjTBv_0.jpg",
      averageRating=4.6, totalRatingsCount=100,
      createdAt="2026-08-30T22:42:08.078530Z", updatedAt="2026-09-01T14:31:53.675636Z",
    ),
    ClubDto(
      id="eba3dd79-7865-4135-9628-a9acc750ec03", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Planet Gym & Fitness", address="Вишњичка, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.8179938, longitude=20.5100785,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8aa9a551-7f32-492b-8c73-f165b570febd_ChIJ_xjqTPR6_1.jpg",
      averageRating=4.6, totalRatingsCount=597,
      createdAt="2026-08-30T22:40:54.423652Z", updatedAt="2026-08-31T22:11:20.470652Z",
    ),
    ClubDto(
      id="1635f47d-9c34-4bd8-968c-6679288bbbba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vamos Padel Serbia", address="Ada Ciganlija bb Beograd, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.7897204, longitude=20.4076504,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8479c78f-ecd6-45ad-b620-b344e4946c9f_ChIJ221s_Uhv_0.jpg",
      averageRating=4.6, totalRatingsCount=197,
      createdAt="2026-08-30T22:41:53.511218Z", updatedAt="2026-08-30T22:41:53.511218Z",
    ),
    ClubDto(
      id="a869e9a3-916d-49d2-9944-0754ad7f5df8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стадион Рајко Митић", address="Љутице Богдана 1a, Београд 11040",
      city="Belgrade", country="RS",
      latitude=44.7832036, longitude=20.4649268,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/32b2c6c9-dc4c-45d3-a28d-317bd79114db_ChIJX2SclUFw_0.jpg",
      averageRating=4.6, totalRatingsCount=22031,
      createdAt="2026-08-30T22:40:04.650364Z", updatedAt="2026-08-31T08:41:12.822604Z",
    ),
    ClubDto(
      id="2e9ab6c0-07e3-4f5f-942e-d16476432d1d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting - KartLand Ada Huja Beograd", address="Пут за Ада Хују bb, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.8221166, longitude=20.5214333,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e56433aa-cb2e-49ad-961f-d9df54fe6a4f_ChIJl9zt21l6_0.jpg",
      averageRating=4.5, totalRatingsCount=2104,
      createdAt="2026-08-30T22:41:16.754446Z", updatedAt="2026-08-31T08:31:11.941708Z",
    ),
    ClubDto(
      id="76533471-96de-42c7-b343-723af85e5318", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportsko Selo", address="Deligradska bb, Beograd 11000",
      city="Belgrade", country="RS",
      latitude=44.7957332, longitude=20.4613855,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8578edc8-225d-49c5-ac2d-27f5be01728c_photo.jpg",
      averageRating=4.5, totalRatingsCount=896,
      createdAt="2026-08-31T14:58:43.594339Z", updatedAt="2026-08-31T14:58:43.594339Z",
    ),
    ClubDto(
      id="40a71f0f-ea7f-416f-99c5-564b3b97a48c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Аутокомерц картинг центар", address="Светог Саве 84/c, Београд 11271",
      city="Belgrade", country="RS",
      latitude=44.8331531, longitude=20.3082436,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a7fe8032-45fd-4573-bd19-88f49518dd51_ChIJq6ru1ilm_0.jpg",
      averageRating=4.5, totalRatingsCount=2132,
      createdAt="2026-08-30T22:41:09.599171Z", updatedAt="2026-08-31T08:40:30.919108Z",
    ),
    ClubDto(
      id="1f2196a3-723a-4630-83af-e13247d2155b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Жабац куглана Стари Меркатор", address="Палмира Тољатија 7, Београд 11070",
      city="Belgrade", country="RS",
      latitude=44.8293655, longitude=20.4120042,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0067c0b8-7ab8-45d8-9d83-c353c89e03b4_ChIJLY6OLnFl_0.jpg",
      averageRating=4.5, totalRatingsCount=1771,
      createdAt="2026-08-30T22:40:48.083392Z", updatedAt="2026-08-31T08:40:41.498650Z",
    ),
    ClubDto(
      id="7c0352e4-ac0d-4b0d-bfc8-51048fd69345", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bilijar kafe Tašmajdan", address="Илије Гарашанина 26, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.8106551, longitude=20.471473,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e0a1db9-ee6f-4c01-a6ab-9790b0fdafc1_ChIJlyBwkaR6_0.jpg",
      averageRating=4.4, totalRatingsCount=641,
      createdAt="2026-08-30T22:40:25.767327Z", updatedAt="2026-08-30T22:40:25.767327Z",
    ),
    ClubDto(
      id="b736fa7f-b5a4-49a5-a073-46889b61e314", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Žabac Bowling, Vidikovac", address="Патријарха Јоаникија 2a, Београд 11090",
      city="Belgrade", country="RS",
      latitude=44.7318164, longitude=20.4214065,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2e18e651-47fe-4b2b-8fd0-d27d24c76aa7_ChIJpdgN2iFy_0.jpg",
      averageRating=4.4, totalRatingsCount=2211,
      createdAt="2026-08-30T22:40:41.411596Z", updatedAt="2026-08-31T08:39:40.405503Z",
    ),
    ClubDto(
      id="ae8c9002-4244-451c-b27a-7df4fbf6bd51", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rođendaonica Laser Tag Beograd", address="Браће Миладинов 10, Београд",
      city="Belgrade", country="RS",
      latitude=44.7915433, longitude=20.502124,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/66bbfb7c-fe66-4ee0-801c-a1bccf64fdd1_ChIJqz23pjty_0.jpg",
      averageRating=4.3, totalRatingsCount=269,
      createdAt="2026-08-30T22:41:30.479438Z", updatedAt="2026-08-30T22:41:30.479438Z",
    ),
    ClubDto(
      id="bb629607-69b1-4946-befc-b18f948bbe7b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Table Tennis Academy Kocic", address="Gradski Park 2, Beograd 11080",
      city="Belgrade", country="RS",
      latitude=44.8404452, longitude=20.4108391,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3b0df39c-77ce-4655-bf1d-82ad217952f9_photo.jpg",
      averageRating=4.3, totalRatingsCount=733,
      createdAt="2026-08-31T14:59:11.190948Z", updatedAt="2026-08-31T14:59:11.190948Z",
    ),
    ClubDto(
      id="7f4cf700-2183-4ae7-9b51-64a9b53bc79f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стадион ФК \"Партизан\"", address="Хумска 1, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.788511, longitude=20.4585281,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6301394d-8c08-4fd6-91b2-12864f4d98a5_ChIJl3gqWxRw_0.jpg",
      averageRating=4.3, totalRatingsCount=8304,
      createdAt="2026-08-30T22:40:18.179575Z", updatedAt="2026-08-31T08:41:14.256414Z",
    ),
    ClubDto(
      id="17192bb9-fce8-43b7-b3e4-07e312597b40", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Center “Mirko Sandić”", address="Sjenička 1, Beograd 11000",
      city="Belgrade", country="RS",
      latitude=44.7992794, longitude=20.4836421,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9cb3b095-7f4f-471c-b330-349ed44d52a7_photo.jpg",
      averageRating=4.2, totalRatingsCount=1338,
      createdAt="2026-08-31T14:58:57.121907Z", updatedAt="2026-08-31T14:58:57.121907Z",
    ),
    ClubDto(
      id="7971e71f-ad7c-4d04-8a1b-78b05cc9a83e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tipsarevic Tennis Academy", address="QGV5+JJ, Вјекослава Ковача 11, Београд 11000",
      city="Belgrade", country="RS",
      latitude=44.7937232, longitude=20.5083694,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d20909d-ede0-452c-ad39-bafa68a67675_ChIJS5_RMlll_0.jpg",
      averageRating=4.2, totalRatingsCount=339,
      createdAt="2026-08-30T22:42:23.006478Z", updatedAt="2026-08-30T22:42:23.006478Z",
    ),
    ClubDto(
      id="4cf35f53-b7c2-4481-a3aa-61b0942c1e45", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тениски клуб „Трим“", address="Кнеза Вишеслава 72, Београд",
      city="Belgrade", country="RS",
      latitude=44.7662973, longitude=20.4275252,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c9684c44-5b79-4ebf-bc03-8d44d25408f3_ChIJ87C0a9Fx_0.jpg",
      averageRating=4.2, totalRatingsCount=1143,
      createdAt="2026-08-30T22:42:16.252469Z", updatedAt="2026-08-30T22:42:16.252469Z",
    ),
    ClubDto(
      id="98b3a656-badc-4c54-9819-f0f9307a623e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GTT, Glisha table tennis, Milorad Glisic personal coach", address="Cvetna 4, Beograd 11080",
      city="Belgrade", country="RS",
      latitude=44.8388961, longitude=20.409404,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1f9db454-9414-4515-b76e-7be62ea202e0_photo.jpg",
      averageRating=5.0, totalRatingsCount=16,
      createdAt="2026-08-31T14:59:02.197070Z", updatedAt="2026-08-31T14:59:02.197070Z",
    ),
  )),
  CitySeo(slug="malaga", name="Malaga", country="ES", clubCount=26, sports=listOf(Pair("Football", 5), Pair("Tennis", 3), Pair("Padel", 3), Pair("Bowling", 2), Pair("Karting", 2), Pair("Golf", 2), Pair("Paintball", 2), Pair("Basketball", 2), Pair("Climbing", 1), Pair("Volleyball", 1), Pair("Billiards", 1), Pair("Laser Tag", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="a9362dfe-bd8d-4ce1-8b02-d76595b4fb67", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Málaga LaserTag", address="PCC7+QJ, 29570 Santa Rosalía, Málaga",
      city="Malaga", country="ES",
      latitude=36.7219386, longitude=-4.5859857,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/85fa2655-95e9-464c-ac79-71d62def4303_photo.jpg",
      averageRating=5.0, totalRatingsCount=182,
      createdAt="2026-08-31T22:44:04.944201Z", updatedAt="2026-08-31T22:44:04.944201Z",
    ),
    ClubDto(
      id="6aafffe7-9dad-477d-8978-5bf5c216ac80", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Finura Padel & Gym", address="Pol. Ind. Villarosa, C. Pascal, 20, Churriana, 29004 Málaga",
      city="Malaga", country="ES",
      latitude=36.671949, longitude=-4.4695492,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/50cfac6a-6c5d-4aef-96c8-f19272552a2f_photo.jpg",
      averageRating=4.9, totalRatingsCount=426,
      createdAt="2026-08-31T22:42:41.738774Z", updatedAt="2026-08-31T22:42:41.738774Z",
    ),
    ClubDto(
      id="9ffe0a77-71ba-4aa9-9cc1-ebc83ad08a21", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Estepona", address="Camino de Puerto Romano,Finca los Limoneros, s/n Río Padrón, 29680 Málaga",
      city="Malaga", country="ES",
      latitude=36.4434717, longitude=-5.1116922,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f12630ae-d200-4319-ac1a-7731d7cac12b_photo.jpg",
      averageRating=4.8, totalRatingsCount=536,
      createdAt="2026-08-31T22:44:12.585492Z", updatedAt="2026-08-31T22:44:12.585492Z",
    ),
    ClubDto(
      id="99eee110-f492-4669-9c35-f8d2a6265f03", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Malaga", address="C. Roberto Harvey, 19, 29791 Macharaviaya, Málaga",
      city="Malaga", country="ES",
      latitude=36.761406, longitude=-4.211272,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e60bc184-2261-4e35-9eb0-ad73d20275d6_photo.jpg",
      averageRating=4.8, totalRatingsCount=421,
      createdAt="2026-08-31T22:44:17.118555Z", updatedAt="2026-08-31T22:44:17.118555Z",
    ),
    ClubDto(
      id="29840c90-550a-4406-8ff5-15946a088803", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campillos Karting Circuit KartCenter", address="A-384, Km. 101, 29320 Campillos, Málaga",
      city="Malaga", country="ES",
      latitude=37.0383529, longitude=-4.9137902,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aafbfec5-b83e-4331-b536-fe48999f5220_photo.jpg",
      averageRating=4.7, totalRatingsCount=2097,
      createdAt="2026-08-31T22:43:28.913259Z", updatedAt="2026-08-31T22:43:28.913259Z",
    ),
    ClubDto(
      id="1d99a5c4-cd08-4d4e-b35d-afaeedb7eb22", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Isla Pool Club", address="Complejo la Hípica, Camino de los Almendrales, s/n, Málaga-Este, 29013 Málaga",
      city="Malaga", country="ES",
      latitude=36.749209, longitude=-4.388964,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c8ce1d42-99ce-4987-81af-704c9cb9d9d9_photo.jpg",
      averageRating=4.7, totalRatingsCount=1617,
      createdAt="2026-08-31T22:44:00.065140Z", updatedAt="2026-08-31T22:44:00.065140Z",
    ),
    ClubDto(
      id="24b31f65-ae26-4682-9d43-88da2866947d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Estadio La Rosaleda", address="P.º Martiricos, s/n, Palma-Palmilla, 29011 Málaga",
      city="Malaga", country="ES",
      latitude=36.7335802, longitude=-4.426652,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fbbc076e-4ce2-4bf3-a627-4c48fc9fa28b_photo.jpg",
      averageRating=4.6, totalRatingsCount=11032,
      createdAt="2026-08-31T22:41:53.876831Z", updatedAt="2026-08-31T22:41:53.876831Z",
    ),
    ClubDto(
      id="82ea6370-ba19-42a8-b796-8923c7bd6f91", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palacio de Deportes José María Martín Carpena", address="Calle Miguel de Mérida Nicolich, 2, Carretera de Cádiz, 29004 Málaga",
      city="Malaga", country="ES",
      latitude=36.6825427, longitude=-4.4599657,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2deb7b97-92b2-4c35-b870-727c5e38b0b5_photo.jpg",
      averageRating=4.6, totalRatingsCount=6786,
      createdAt="2026-08-31T22:42:50.785845Z", updatedAt="2026-08-31T22:42:50.785845Z",
    ),
    ClubDto(
      id="b0fae966-abe3-4235-8877-70441741edd1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports center Cortijo Alto", address="C. Hamlet, 1, Teatinos-Universidad, 29006 Málaga",
      city="Malaga", country="ES",
      latitude=36.7089167, longitude=-4.4585678,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a047bee2-7646-477e-b719-073f6263cc34_photo.jpg",
      averageRating=4.6, totalRatingsCount=264,
      createdAt="2026-08-31T22:42:56.381276Z", updatedAt="2026-08-31T22:42:56.381276Z",
    ),
    ClubDto(
      id="1aad1061-7bb9-42dc-ae24-716f3c4f7cc7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling 80", address="Parque Empresarial Alameda, C. Caracola, 3, y 5, Cruz de Humilladero, 29006 Málaga",
      city="Malaga", country="ES",
      latitude=36.7112439, longitude=-4.4717531,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1617d80c-c6bc-48e8-baa2-f66a1ee013c0_photo.jpg",
      averageRating=4.5, totalRatingsCount=886,
      createdAt="2026-08-31T22:43:37.376406Z", updatedAt="2026-08-31T22:43:37.376406Z",
    ),
    ClubDto(
      id="7fb26ede-781a-4954-abd7-2e4d59a6f99a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Torrequebrada", address="C. Club de Golf, 1, 29630 Benalmádena, Málaga",
      city="Malaga", country="ES",
      latitude=36.5886002, longitude=-4.5517703,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/21c16bff-fd23-4f01-acd7-2f7d04d26a34_photo.jpg",
      averageRating=4.5, totalRatingsCount=1779,
      createdAt="2026-08-31T22:43:12.600622Z", updatedAt="2026-08-31T22:43:12.600622Z",
    ),
    ClubDto(
      id="6fcb5a4b-3411-43b2-81e2-4e7c869f64b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vals Sport Ave Maria", address="Av de Sor Teresa Prat, 53, Carretera de Cádiz, 29003 Málaga",
      city="Malaga", country="ES",
      latitude=36.6962038, longitude=-4.44207,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a922ceb9-9942-4f4d-99ff-4162006db3bc_photo.jpg",
      averageRating=4.5, totalRatingsCount=1002,
      createdAt="2026-08-31T22:42:24.252271Z", updatedAt="2026-08-31T22:42:24.252271Z",
    ),
    ClubDto(
      id="c3370b87-6be0-426b-9537-141c7f0e3e87", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BeClimb - Climbing Centers", address="C. Licurgo, 6, Carretera de Cádiz, 29004 Málaga",
      city="Malaga", country="ES",
      latitude=36.6930783, longitude=-4.4624158,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5470b4cc-ca39-4425-adc1-0f4da12298bf_photo.jpg",
      averageRating=4.4, totalRatingsCount=557,
      createdAt="2026-08-31T22:43:53.867398Z", updatedAt="2026-08-31T22:43:53.867398Z",
    ),
    ClubDto(
      id="f3319914-04ff-400e-ab34-a4f33d338833", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo Malaga Beach Volleyball", address="C/ Pacífico, Carretera de Cádiz, 29004 Málaga",
      city="Malaga", country="ES",
      latitude=36.6953321, longitude=-4.4387725,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b010af4-b70d-4126-bd25-c87bc455cf41_photo.jpg",
      averageRating=4.4, totalRatingsCount=92,
      createdAt="2026-08-31T22:43:01.083767Z", updatedAt="2026-08-31T22:43:01.083767Z",
    ),
    ClubDto(
      id="e713faf4-9184-4f23-a181-8bdf9aa248ce", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fantasy Padel SL", address="C. Caballito de Mar, 7, Cruz de Humilladero, 29006 Málaga",
      city="Malaga", country="ES",
      latitude=36.7051345, longitude=-4.4681989,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f5dc148b-58db-4e84-8782-24b89f9bc7ca_photo.jpg",
      averageRating=4.4, totalRatingsCount=524,
      createdAt="2026-08-31T22:42:33.691234Z", updatedAt="2026-08-31T22:42:33.691234Z",
    ),
    ClubDto(
      id="a16d1108-3417-400b-b1c5-15511182fc42", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Málaga Indoor", address="C. de Alfredo Corrochano, 9, Cruz de Humilladero, 29006 Málaga",
      city="Malaga", country="ES",
      latitude=36.7132556, longitude=-4.473778,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/08d83e63-7ecf-4e1f-8412-e6c838e4361c_photo.jpg",
      averageRating=4.4, totalRatingsCount=403,
      createdAt="2026-08-31T22:42:46.597875Z", updatedAt="2026-08-31T22:42:46.597875Z",
    ),
    ClubDto(
      id="e90a5ad5-47a6-46f3-b92e-12735d859758", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Experience Miramar", address="Av. de la Encarnación, s/n, 29640 Fuengirola, Málaga",
      city="Malaga", country="ES",
      latitude=36.5299432, longitude=-4.632412,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/168b51ac-252e-492e-a7b0-c2cf01dcd971_photo.jpg",
      averageRating=4.3, totalRatingsCount=1002,
      createdAt="2026-08-31T22:43:32.894385Z", updatedAt="2026-08-31T22:43:32.894385Z",
    ),
    ClubDto(
      id="e10bb020-cff7-4540-aea1-3dbf4af93e02", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mijas Golf International SAU - MIJAS GOLF CLUB", address="Av. de Louison Bobet, 1, 3, 5, 29650 Las Lagunas de Mijas, Málaga",
      city="Malaga", country="ES",
      latitude=36.5492897, longitude=-4.6691512,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d1e40b76-0cd2-401c-89ea-6a4e88b6b390_photo.jpg",
      averageRating=4.3, totalRatingsCount=1428,
      createdAt="2026-08-31T22:43:18.987855Z", updatedAt="2026-08-31T22:43:18.987855Z",
    ),
    ClubDto(
      id="e8c210e9-7232-47ce-85fa-c632c48c3545", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club de Tenis Málaga", address="Av. San Antón, 22, Málaga-Este, 29018 Málaga",
      city="Malaga", country="ES",
      latitude=36.7317808, longitude=-4.3613047,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6aaea3f5-f8fd-44f8-95b9-9498fa8c2395_photo.jpg",
      averageRating=4.2, totalRatingsCount=349,
      createdAt="2026-08-31T22:42:29.180896Z", updatedAt="2026-09-01T14:31:54.200462Z",
    ),
    ClubDto(
      id="2d6d12e6-896b-4dda-80fc-a6d601770ae4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Galaxy Park Bowling Muelle Uno", address="P.º del Muelle Uno, 24, Distrito Centro, 29016 Málaga",
      city="Malaga", country="ES",
      latitude=36.7176783, longitude=-4.4127797,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/134e0cda-b308-4261-a3c5-56d78c80fce8_photo.jpg",
      averageRating=4.2, totalRatingsCount=326,
      createdAt="2026-08-31T22:43:44.273660Z", updatedAt="2026-08-31T22:43:44.273660Z",
    ),
    ClubDto(
      id="d6439e50-82fd-4c62-b7e4-3d4f37cf1fee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="polideportivo", address="Pl. de John F. Kennedy, Cdad. Jardín, 29014 Málaga",
      city="Malaga", country="ES",
      latitude=36.7500853, longitude=-4.4238338,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e8d0828-845d-4920-b866-3c62747c5ec2_photo.jpg",
      averageRating=4.2, totalRatingsCount=1694,
      createdAt="2026-08-31T22:42:17.163067Z", updatedAt="2026-09-01T14:31:55.020051Z",
    ),
    ClubDto(
      id="c69b80fe-cb7e-4bc5-b665-d0d37570afeb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo de Fútbol Municipal Malaka", address="C. Virgen de las Flores, 22, Cruz de Humilladero, 29007 Málaga",
      city="Malaga", country="ES",
      latitude=36.7200748, longitude=-4.4421139,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/122ce124-6c07-4288-a3bf-9ab65525369b_photo.jpg",
      averageRating=4.0, totalRatingsCount=586,
      createdAt="2026-08-31T22:41:57.739525Z", updatedAt="2026-08-31T22:41:57.739525Z",
    ),
    ClubDto(
      id="58d08067-5966-4bb4-941c-afb54e82add2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Football Field El Duende, San Andrés", address="C. Mahler, S/N, Cruz de Humilladero, 29006 Málaga",
      city="Malaga", country="ES",
      latitude=36.7018318, longitude=-4.4555287,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1904cfe0-1445-4da3-a97e-b56196254aaa_photo.jpg",
      averageRating=4.0, totalRatingsCount=490,
      createdAt="2026-08-31T22:42:05.634214Z", updatedAt="2026-08-31T22:42:05.634214Z",
    ),
    ClubDto(
      id="e0cfb30a-2d3e-4863-8f11-f92e1410d3f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="San Ignacio football field (El Palo)", address="C. Practicante Fernández Alcolea, 59, Málaga-Este, 29018 Málaga",
      city="Malaga", country="ES",
      latitude=36.719411, longitude=-4.3554011,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9f86d04e-7cb5-4cc1-9588-884eeaff32d1_photo.jpg",
      averageRating=3.9, totalRatingsCount=480,
      createdAt="2026-08-31T22:42:09.626326Z", updatedAt="2026-08-31T22:42:09.626326Z",
    ),
    ClubDto(
      id="04411183-88ed-4153-a4ac-c76626bcb8de", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo de Fútbol Conejito de Málaga", address="Av de Europa, 126, Carretera de Cádiz, 29004 Málaga",
      city="Malaga", country="ES",
      latitude=36.6970631, longitude=-4.4608257,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b1a14de5-30a4-4b0b-ae56-53e03eec1092_photo.jpg",
      averageRating=3.8, totalRatingsCount=516,
      createdAt="2026-08-31T22:42:01.333835Z", updatedAt="2026-08-31T22:42:01.333835Z",
    ),
    ClubDto(
      id="7bce659a-3245-465e-9556-e5dd86b12eba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenis de Mesa Malaga el Palo", address="Ctra. de Olias, Málaga-Este, 29018 Málaga",
      city="Malaga", country="ES",
      latitude=36.7224642, longitude=-4.3473663,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e7c91878-6845-45d9-a876-891fa7854bda_photo.jpg",
      averageRating=5.0, totalRatingsCount=13,
      createdAt="2026-08-31T22:43:22.816281Z", updatedAt="2026-08-31T22:43:22.816281Z",
    ),
  )),
  CitySeo(slug="utrecht", name="Utrecht", country="NL", clubCount=26, sports=listOf(Pair("Football", 5), Pair("Volleyball", 3), Pair("Climbing", 2), Pair("Bowling", 2), Pair("Karting", 2), Pair("Billiards", 2), Pair("Paintball", 2), Pair("Basketball", 2), Pair("Tennis", 2), Pair("Table Tennis", 2), Pair("Padel", 1), Pair("Golf", 1)), clubs=listOf(
    ClubDto(
      id="783e3db4-3309-479f-9437-2fb7460dbbaa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boulderhal Energiehaven", address="Elektronweg 10A, 3542 AC Utrecht",
      city="Utrecht", country="NL",
      latitude=52.1001312, longitude=5.0709264,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b1d3f915-1242-47ed-8b79-cb927e9afb1e_photo.jpg",
      averageRating=4.8, totalRatingsCount=1450,
      createdAt="2026-08-31T23:44:10.929888Z", updatedAt="2026-08-31T23:44:10.929888Z",
    ),
    ClubDto(
      id="d5d469a4-d7f8-4d7f-bec8-0c56ba5745eb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boulderhal Zuidhaven", address="Vrieslantlaan 2, 3526 AA Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0645938, longitude=5.1044239,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d9630c1d-5654-4764-a8ed-cdc97c67d793_photo.jpg",
      averageRating=4.8, totalRatingsCount=500,
      createdAt="2026-08-31T23:44:15.371385Z", updatedAt="2026-08-31T23:44:15.371385Z",
    ),
    ClubDto(
      id="0f842e05-ebc8-4b25-9003-02fd36ee5361", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Peakz Padel Utrecht Vechtsebanen | Padelclub", address="Mississippidreef 161, 3565 CE Utrecht",
      city="Utrecht", country="NL",
      latitude=52.1223369, longitude=5.08756,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d491bd62-6b0e-4a4f-a01d-1cb0ae10ccdb_photo.jpg",
      averageRating=4.7, totalRatingsCount=393,
      createdAt="2026-08-31T23:43:03.096532Z", updatedAt="2026-08-31T23:43:03.096532Z",
    ),
    ClubDto(
      id="889fb96e-fb25-4344-a554-a36d2ba3ebf9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Teamsport E-Karting The Wall Utrecht", address="The Wall, Hertogswetering, Parking, The Wall P1 183, 3543 AS Utrecht",
      city="Utrecht", country="NL",
      latitude=52.1079263, longitude=5.0534813,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/feab4b09-cc0b-491b-b711-20027ff7b80e_photo.jpg",
      averageRating=4.7, totalRatingsCount=2310,
      createdAt="2026-08-31T23:43:54.737860Z", updatedAt="2026-08-31T23:43:54.737860Z",
    ),
    ClubDto(
      id="39b91ca3-bde1-4f1d-b489-196952256c03", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolleybal Irene Beach 🏐", address="Larenstein, Tweelingen 142a, 3721 WS Bilthoven",
      city="Utrecht", country="NL",
      latitude=52.12252, longitude=5.1787853,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cbc1a5d0-172e-4f05-aa21-e1ca64068bdd_photo.jpg",
      averageRating=4.5, totalRatingsCount=67,
      createdAt="2026-08-31T23:43:23.317352Z", updatedAt="2026-08-31T23:43:23.317352Z",
    ),
    ClubDto(
      id="d0069804-ee5e-4c16-8cac-01e2b5837869", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tafeltennisvereniging SVE 🏓", address="Loevenhoutsedijk 4, 3552 XE Utrecht",
      city="Utrecht", country="NL",
      latitude=52.1075446, longitude=5.1111654,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8125d87d-7e67-4417-bbc8-33d4a59d75e2_photo.jpg",
      averageRating=4.5, totalRatingsCount=66,
      createdAt="2026-08-31T23:43:39.597756Z", updatedAt="2026-08-31T23:43:39.597756Z",
    ),
    ClubDto(
      id="d8373963-60b7-459b-bf4e-36384c09d9c9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Olround Utrecht", address="Mariaplaats 13A, 3511 LJ Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0900477, longitude=5.1169678,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bb268cca-386d-4e35-861e-d66fae108e27_photo.jpg",
      averageRating=4.4, totalRatingsCount=1447,
      createdAt="2026-08-31T23:43:59.419397Z", updatedAt="2026-08-31T23:43:59.419397Z",
    ),
    ClubDto(
      id="95358042-3297-4d77-84ac-2f2df19b4851", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ozebi | Snooker & Pool", address="Biltstraat 4, 3572 BA Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0956185, longitude=5.1269087,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c02787b8-0776-468f-a135-fc90f797b326_photo.jpg",
      averageRating=4.4, totalRatingsCount=1056,
      createdAt="2026-08-31T23:44:25.306519Z", updatedAt="2026-08-31T23:44:25.306519Z",
    ),
    ClubDto(
      id="9cb258db-cd53-4b90-ae07-5adaed9ecd95", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poolcafé Hart Van Utrecht 🎱", address="Ganzenmarkt 16B, 3512 GD Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0923119, longitude=5.1194169,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d5e3940-78b8-4331-871f-04454592f8f3_photo.jpg",
      averageRating=4.4, totalRatingsCount=1705,
      createdAt="2026-08-31T23:44:20.568733Z", updatedAt="2026-08-31T23:44:20.568733Z",
    ),
    ClubDto(
      id="a121ede9-377d-48d0-9057-9854ae1f3bab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="T. C. Domstad", address="Kennedylaan 7, 3533 KH Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0809407, longitude=5.0823608,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2a891259-b92b-49b7-ae87-d98941c19b3d_photo.jpg",
      averageRating=4.4, totalRatingsCount=124,
      createdAt="2026-08-31T23:42:53.021916Z", updatedAt="2026-09-01T14:31:46.115139Z",
    ),
    ClubDto(
      id="be528a57-918c-44cd-b6f9-841d17846da4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis At Risk", address="Olympus 1, 3524 WB Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0639459, longitude=5.1284192,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/25beb963-af62-440b-a17d-2ba6b426d85c_photo.jpg",
      averageRating=4.4, totalRatingsCount=74,
      createdAt="2026-08-31T23:42:58.131833Z", updatedAt="2026-08-31T23:42:58.131833Z",
    ),
    ClubDto(
      id="6ac83826-968e-45c7-b07e-edb8915706c4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kartfabrique - Karten, Lasergamen, Simracen, Prison Island en Food & Drinks", address="Westkanaaldijk 7, 3542 DA Utrecht",
      city="Utrecht", country="NL",
      latitude=52.1289333, longitude=5.0485946,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7fc4272b-882f-4fde-ab0b-8619da6488fa_photo.jpg",
      averageRating=4.3, totalRatingsCount=3928,
      createdAt="2026-08-31T23:43:49.712648Z", updatedAt="2026-08-31T23:43:49.712648Z",
    ),
    ClubDto(
      id="61c3b66f-f4b2-4a92-a6fe-765cf1d728d5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Hillegom", address="Kanaalpad Noord-West 4, 2231 NX Rijnsburg",
      city="Utrecht", country="NL",
      latitude=52.1977765, longitude=4.4369102,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d5dab632-3539-4ded-81f2-1bb46aab4b9a_photo.jpg",
      averageRating=4.3, totalRatingsCount=265,
      createdAt="2026-08-31T23:44:37.456187Z", updatedAt="2026-08-31T23:44:37.456187Z",
    ),
    ClubDto(
      id="3bc22104-edd2-4b9f-8a5e-3b5cb2adda70", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Jungle", address="Wandelweg, bij Station Wormerveer Parkeren, achter station 12A, 1521 AG Wormerveer",
      city="Utrecht", country="NL",
      latitude=52.4871907, longitude=4.7943621,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b6acf03-d702-4662-9eb3-a765df5a2cc3_photo.jpg",
      averageRating=4.3, totalRatingsCount=654,
      createdAt="2026-08-31T23:44:32.111627Z", updatedAt="2026-08-31T23:44:32.111627Z",
    ),
    ClubDto(
      id="be86679d-5702-4171-ab73-17f44ec14543", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stadion Galgenwaard", address="Herculesplein 241, 3584 AA Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0783638, longitude=5.1458244,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c3cb2d57-f06b-4f76-84ce-8b4c216f4af3_photo.jpg",
      averageRating=4.3, totalRatingsCount=4825,
      createdAt="2026-08-31T23:42:21.052657Z", updatedAt="2026-08-31T23:42:21.052657Z",
    ),
    ClubDto(
      id="c9cf517e-1ffb-4453-ad0b-23637b9964e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="VIVES Volleybal", address="Oranje Nassaulaan 50, 3402 CS IJsselstein",
      city="Utrecht", country="NL",
      latitude=52.0259319, longitude=5.0473819,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a2227e6e-d3c2-47da-acc6-205ada6adc5c_photo.jpg",
      averageRating=4.3, totalRatingsCount=106,
      createdAt="2026-08-31T23:43:17.110240Z", updatedAt="2026-08-31T23:43:17.110240Z",
    ),
    ClubDto(
      id="5cb44da6-11f7-4377-81f5-8ed0b0ea2156", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SV Kampong", address="Laan van Maarschalkerweerd 14, 3585 LJ Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0750208, longitude=5.1509593,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/df35ce42-27e4-4880-b892-91fbb4be5936_photo.jpg",
      averageRating=4.2, totalRatingsCount=237,
      createdAt="2026-08-31T23:42:48.800636Z", updatedAt="2026-08-31T23:42:48.800636Z",
    ),
    ClubDto(
      id="285244e1-c7dc-4b36-a35f-d0e43ded97b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="USV Hercules", address="Voorveldselaan 2, 3573 PV Utrecht",
      city="Utrecht", country="NL",
      latitude=52.107278, longitude=5.1482025,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/262558cb-47f2-4b1c-b4a4-9d02cc239fb9_photo.jpg",
      averageRating=4.2, totalRatingsCount=279,
      createdAt="2026-08-31T23:42:43.493614Z", updatedAt="2026-08-31T23:42:43.493614Z",
    ),
    ClubDto(
      id="24a630fc-79c2-4a90-b203-b53796ca0ca1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="sports Center Olympos", address="Uppsalalaan 3, 3584 CT Utrecht",
      city="Utrecht", country="NL",
      latitude=52.09119, longitude=5.1751264,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/555a0907-9a63-4f8a-b997-31b1d63adbc7_photo.jpg",
      averageRating=4.2, totalRatingsCount=635,
      createdAt="2026-08-31T23:42:25.720306Z", updatedAt="2026-08-31T23:42:25.720306Z",
    ),
    ClubDto(
      id="8e0f61ac-5c64-487b-ba5c-dbd8ed6759bd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Mitland Utrecht", address="Ariënslaan 1, 3573 PT Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0985584, longitude=5.1444449,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/33e871c3-70db-44ca-a545-e306f8e2e959_photo.jpg",
      averageRating=4.1, totalRatingsCount=543,
      createdAt="2026-08-31T23:44:06.321165Z", updatedAt="2026-08-31T23:44:06.321165Z",
    ),
    ClubDto(
      id="8ebeeeff-f5f7-4456-a7ed-02947497fea2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporthal Lunetten", address="Zwarte Woud 201, 3524 SG Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0634512, longitude=5.1426978,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/24c7462d-b9eb-49f3-9de1-9ff55ea16457_photo.jpg",
      averageRating=4.0, totalRatingsCount=201,
      createdAt="2026-08-31T23:43:07.564517Z", updatedAt="2026-08-31T23:43:07.564517Z",
    ),
    ClubDto(
      id="3a8d25f0-3977-41b2-a9ed-4658d1fbb712", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MFA Nieuw Welgelegen", address="Grebbeberglaan 3 - 13, 3527 VX Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0799631, longitude=5.0997464,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/59e8e4d4-def8-4d95-a4c3-008954303b5a_photo.jpg",
      averageRating=3.9, totalRatingsCount=475,
      createdAt="2026-08-31T23:42:37.910775Z", updatedAt="2026-08-31T23:42:37.910775Z",
    ),
    ClubDto(
      id="d3e24c8c-9aed-43f9-a5ef-03c8214604f8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ShortGolf Utrecht", address="Sportpark Galecop 10, 3438 HX Nieuwegein",
      city="Utrecht", country="NL",
      latitude=52.0586613, longitude=5.0910332,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f9f5f49f-ada4-4ba2-8e92-33b5a3e976d8_photo.jpg",
      averageRating=3.9, totalRatingsCount=126,
      createdAt="2026-08-31T23:43:32.633484Z", updatedAt="2026-08-31T23:43:32.633484Z",
    ),
    ClubDto(
      id="0e66a673-981d-42a7-8d15-139d8ca82439", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportzaal De Speler", address="Thorbeckelaan 18C, 3552 CS Utrecht",
      city="Utrecht", country="NL",
      latitude=52.106638, longitude=5.0979836,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/872d93a2-82d8-4955-9eb6-f1a1bb40fd21_photo.jpg",
      averageRating=4.2, totalRatingsCount=44,
      createdAt="2026-08-31T23:43:11.824671Z", updatedAt="2026-08-31T23:43:11.824671Z",
    ),
    ClubDto(
      id="93dd346f-d546-488f-b31c-7b9cff9b50ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BeachvolleybalUtrecht 🏐", address="Burgemeester Norbruislaan 680, 3555 EZ Utrecht",
      city="Utrecht", country="NL",
      latitude=52.1221327, longitude=5.0641988,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d2e56d2c-77b3-47e0-93dd-9d77cac234f9_photo.jpg",
      averageRating=4.3, totalRatingsCount=33,
      createdAt="2026-08-31T23:43:27.488252Z", updatedAt="2026-08-31T23:43:27.488252Z",
    ),
    ClubDto(
      id="ffa347b8-f6c4-48c3-8a97-ac7040d68a19", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UTTC Tafeltennisvereniging🏓", address="Duurstedelaan 14a, 3525 AL Utrecht",
      city="Utrecht", country="NL",
      latitude=52.0647494, longitude=5.1203858,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ec6952cb-05fd-4927-afcb-751a2b4e2c82_photo.jpg",
      averageRating=4.6, totalRatingsCount=27,
      createdAt="2026-08-31T23:43:45.163240Z", updatedAt="2026-08-31T23:43:45.163240Z",
    ),
  )),
  CitySeo(slug="geneva", name="Geneva", country="CH", clubCount=26, sports=listOf(Pair("Basketball", 3), Pair("Football", 3), Pair("Volleyball", 3), Pair("Billiards", 2), Pair("Paintball", 2), Pair("Golf", 2), Pair("Laser Tag", 2), Pair("Karting", 2), Pair("Climbing", 2), Pair("Bowling", 2), Pair("Table Tennis", 1), Pair("Tennis", 1), Pair("Padel", 1)), clubs=listOf(
    ClubDto(
      id="23dc2b7f-aadd-4e5e-9e29-7a6ce2d0b2ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Top Smash | Magasin Tennis, Padel, Badminton et Squash", address="Rue Voltaire 26, 1201 Genève",
      city="Geneva", country="CH",
      latitude=46.2082638, longitude=6.1362432,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6acfcb9d-3915-4962-b4ff-03fed879bdcd_ChIJ729Mpkhl_0.jpg",
      averageRating=5.0, totalRatingsCount=76,
      createdAt="2026-08-30T23:00:24.062423Z", updatedAt="2026-09-01T14:31:52.174339Z",
    ),
    ClubDto(
      id="3528dec7-9b4a-43d3-85bb-71c1514fbccd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GVA PaintBall", address="Chem. des Coquelicots 29, 1214 Vernier",
      city="Geneva", country="CH",
      latitude=46.2217493, longitude=6.0932094,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8a493524-16cd-4449-9823-a52c93141319_photo.png",
      averageRating=4.9, totalRatingsCount=122,
      createdAt="2026-08-31T16:00:15.754339Z", updatedAt="2026-08-31T16:00:15.754339Z",
    ),
    ClubDto(
      id="18ac4691-e2b0-4538-af8b-80fa8d5f1d0c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billardcenter Bluff", address="Rue du Nant 29, 1207 Genève",
      city="Geneva", country="CH",
      latitude=46.2032008, longitude=6.161987,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/022baf56-7f64-46d5-8d0c-4a6d57aab920_ChIJ45z7OTZl_0.jpg",
      averageRating=4.8, totalRatingsCount=56,
      createdAt="2026-08-30T23:00:05.091198Z", updatedAt="2026-08-30T23:00:05.091198Z",
    ),
    ClubDto(
      id="95bd7b4a-8b37-4a4c-a2b0-1239e5c28bed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LaseRed", address="Rue de Zurich 15, 1201 Genève",
      city="Geneva", country="CH",
      latitude=46.2112406, longitude=6.1478144,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d3f0a2b-dc10-41f0-8f3d-5239b66b5b4b_ChIJu6sJqzBl_0.jpg",
      averageRating=4.8, totalRatingsCount=241,
      createdAt="2026-08-30T23:00:17.375954Z", updatedAt="2026-08-31T08:32:06.279400Z",
    ),
    ClubDto(
      id="d673428b-7175-4e1c-9f3f-7f59ff2b89c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Geneva Golf Club", address="4181 Geneva Golf Club Dr, Alexandria, MN 56308, USA",
      city="Geneva", country="CH",
      latitude=45.8997917, longitude=-95.3121261,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7bcc9624-db49-46f4-bd4d-8f8b3b6392fd_photo.jpg",
      averageRating=4.6, totalRatingsCount=146,
      createdAt="2026-08-31T15:59:23.031198Z", updatedAt="2026-08-31T15:59:23.031198Z",
    ),
    ClubDto(
      id="561ec3ae-8911-4c2c-92ec-715e3af1cf84", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MK Circuit Scientrier « KARTING »", address="2930 Rte de l'Arve suivre, 74930 Scientrier, France",
      city="Geneva", country="CH",
      latitude=46.1349583, longitude=6.3199382,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a59d8391-37bd-49b9-b8ea-df42b2866219_photo.jpg",
      averageRating=4.6, totalRatingsCount=560,
      createdAt="2026-08-31T15:59:41.010767Z", updatedAt="2026-08-31T15:59:41.010767Z",
    ),
    ClubDto(
      id="cfa0041b-36c4-40a4-a325-ea53ae6c01b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="OCHSNER SPORT", address="Rue du Marché 9/11, 1204 Genève",
      city="Geneva", country="CH",
      latitude=46.2034511, longitude=6.1465502,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e0296965-ea71-44ea-aa08-f724bb2bac88_ChIJycASKFhl_0.jpg",
      averageRating=4.6, totalRatingsCount=1116,
      createdAt="2026-08-30T22:59:36.918143Z", updatedAt="2026-08-31T08:33:25.871653Z",
    ),
    ClubDto(
      id="76a6cc0b-07eb-4b27-adbf-5737d7a61a06", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Parc des Franchises", address="Av. de Châtelaine, 1203 Genève",
      city="Geneva", country="CH",
      latitude=46.2111207, longitude=6.1166838,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d9de70e4-a283-4a34-aa1b-092c007af6f7_photo.jpg",
      averageRating=4.6, totalRatingsCount=366,
      createdAt="2026-08-31T15:59:07.941386Z", updatedAt="2026-08-31T22:11:20.036823Z",
    ),
    ClubDto(
      id="1feb672f-7467-489b-a815-4400086a5cca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Planet Climbing", address="Av. des Morgines 10, 1213 Petit-Lancy",
      city="Geneva", country="CH",
      latitude=46.1906384, longitude=6.1113449,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/70b49011-2163-4636-977d-7a976ba08e29_photo.jpg",
      averageRating=4.6, totalRatingsCount=155,
      createdAt="2026-08-31T16:00:00.482247Z", updatedAt="2026-08-31T16:00:00.482247Z",
    ),
    ClubDto(
      id="3c35ce32-d23e-48e0-b4e3-6a815b16da5e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Planet Climbing Plan-les-Ouates, Genève", address="Rte de la Galaise 13B, 1228 Plan-les-Ouates",
      city="Geneva", country="CH",
      latitude=46.16564, longitude=6.1035508,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/95c0086a-1271-4db7-9295-f073827c5cf1_photo.jpg",
      averageRating=4.6, totalRatingsCount=141,
      createdAt="2026-08-31T16:00:08.907437Z", updatedAt="2026-08-31T16:00:08.907437Z",
    ),
    ClubDto(
      id="b98ba8f9-2ddf-4424-a375-9cbccfc5113d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poolmania55", address="Rue de Lyon 55, 1203 Genève",
      city="Geneva", country="CH",
      latitude=46.2086148, longitude=6.1330082,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e8bf3d04-13b9-4243-a030-7d5ee52bb18f_ChIJuZ9PiNpk_0.jpg",
      averageRating=4.6, totalRatingsCount=149,
      createdAt="2026-08-30T22:59:58.531405Z", updatedAt="2026-08-31T08:34:49.903850Z",
    ),
    ClubDto(
      id="76acd86a-a8e0-4d21-96ba-be3eff5a23f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club of Geneva Eaux-Vives", address="Parc des Eaux-Vives, 1207 Genève",
      city="Geneva", country="CH",
      latitude=46.2078575, longitude=6.1709113,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eb8ce4fa-f8c4-4b0d-bad6-87e09bd43904_ChIJJXqxxUVl_0.jpg",
      averageRating=4.6, totalRatingsCount=153,
      createdAt="2026-08-30T23:00:30.886848Z", updatedAt="2026-08-30T23:00:30.886848Z",
    ),
    ClubDto(
      id="ca8dc6ff-710d-4ef7-a131-2c1f0acf82c9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Club De Geneve", address="Rte de la Capite 70, 1253 Vandœuvres",
      city="Geneva", country="CH",
      latitude=46.2219681, longitude=6.1923012,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/33528fba-2a83-421e-b159-7512c7e83427_photo.jpg",
      averageRating=4.5, totalRatingsCount=213,
      createdAt="2026-08-31T15:59:14.933922Z", updatedAt="2026-08-31T15:59:14.933922Z",
    ),
    ClubDto(
      id="7c904a4b-ba4d-4939-b0ee-5b6e94811857", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Paradis", address="500 Rte du Pont de Zone, 74100 Étrembières, France",
      city="Geneva", country="CH",
      latitude=46.1733316, longitude=6.2135866,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/31094cdc-f9af-4296-8ea0-91e713724b36_photo.jpg",
      averageRating=4.5, totalRatingsCount=429,
      createdAt="2026-08-31T16:00:23.131439Z", updatedAt="2026-08-31T16:00:23.131439Z",
    ),
    ClubDto(
      id="6e567ad8-d69d-4e4b-aff0-8d3d03dff89f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centre Sportif de Vessy", address="Rte de Vessy 31, 1234 Vessy",
      city="Geneva", country="CH",
      latitude=46.1846438, longitude=6.1660444,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/57e2f4b6-416a-4314-829e-7f6afc9f91dd_photo.jpg",
      averageRating=4.4, totalRatingsCount=648,
      createdAt="2026-08-31T15:58:47.431687Z", updatedAt="2026-08-31T15:58:47.431687Z",
    ),
    ClubDto(
      id="4e50a2cc-e7f2-4ee0-baa5-f597b926b224", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centre Sportif de la Queue d'Arve", address="Rue François-Dussaud 12, 1227 Genève",
      city="Geneva", country="CH",
      latitude=46.1964067, longitude=6.1313025,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1991b073-a8ba-411c-bdbd-80c16015beb6_ChIJLxLMAi17_0.jpg",
      averageRating=4.4, totalRatingsCount=420,
      createdAt="2026-08-30T22:59:43.190506Z", updatedAt="2026-08-30T22:59:43.190506Z",
    ),
    ClubDto(
      id="737681eb-f2c5-4c25-9a92-6c2d70945e87", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centre Sportif des Vernets", address="Rue Hans Wilsdorf 4, 1227 Genève",
      city="Geneva", country="CH",
      latitude=46.194927, longitude=6.1341692,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/510d0545-3f20-48b8-9b1a-8f2ad9deb808_ChIJXZFYjyt7_2.jpg",
      averageRating=4.4, totalRatingsCount=327,
      createdAt="2026-08-30T22:59:49.607098Z", updatedAt="2026-08-31T22:11:15.096115Z",
    ),
    ClubDto(
      id="2c69c3b3-5703-4b42-8019-d7c101d06ec1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centre sportif du Bois-des-Frères", address="Chem. de l'Ecu 22, 1219 Vernier",
      city="Geneva", country="CH",
      latitude=46.2101871, longitude=6.1055841,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d17589f2-6d67-44a8-a4cc-e44f2779f02b_photo.jpg",
      averageRating=4.4, totalRatingsCount=533,
      createdAt="2026-08-31T15:58:40.178544Z", updatedAt="2026-08-31T15:58:40.178544Z",
    ),
    ClubDto(
      id="9b9c13d8-7781-42bc-890d-b63b2321c1f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports center Bout-du-Monde", address="Rte de Vessy 12, 1206 Genève",
      city="Geneva", country="CH",
      latitude=46.1807109, longitude=6.1555282,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1642a2b4-5dac-4b02-aa72-854ebac9b1a5_photo.jpg",
      averageRating=4.4, totalRatingsCount=1087,
      createdAt="2026-08-31T15:58:34.181247Z", updatedAt="2026-08-31T15:58:34.181247Z",
    ),
    ClubDto(
      id="54291c15-2bbe-4953-857c-9651142170e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="On'Kart", address="1618 Rte de la Gare, 74580 Viry, France",
      city="Geneva", country="CH",
      latitude=46.1295112, longitude=6.029452,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/69ae0e04-2a20-477f-89c6-daaffde7b498_photo.jpg",
      averageRating=4.2, totalRatingsCount=1368,
      createdAt="2026-08-31T15:59:32.934118Z", updatedAt="2026-08-31T15:59:32.934118Z",
    ),
    ClubDto(
      id="82796065-6ad9-4138-8a9f-7211cf3ad438", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Salle omnisports Henry-Dunant", address="Av. Edmond-Vaucher 20, 1203 Genève",
      city="Geneva", country="CH",
      latitude=46.2138172, longitude=6.1173959,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/71dad506-3e08-4deb-a208-8a243883bda7_photo.jpg",
      averageRating=4.2, totalRatingsCount=88,
      createdAt="2026-08-31T15:58:53.675373Z", updatedAt="2026-08-31T15:58:53.675373Z",
    ),
    ClubDto(
      id="7078fa69-49cb-4486-a706-4bc6c4cb05fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Bowling La Praille", address="Rte des Jeunes 10, 1212 Lancy",
      city="Geneva", country="CH",
      latitude=46.1792995, longitude=6.1278351,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e15a9fc5-6f81-4237-ba18-e75c639f6a07_photo.jpg",
      averageRating=4.2, totalRatingsCount=1602,
      createdAt="2026-08-31T15:59:47.049256Z", updatedAt="2026-08-31T15:59:47.049256Z",
    ),
    ClubDto(
      id="d4cc3feb-d8d5-413b-974c-229fe5e1e646", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Game", address="Rte de Chêne 26, 1207 Genève",
      city="Geneva", country="CH",
      latitude=46.1998875, longitude=6.165742,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/741d1a7b-440d-45a2-8992-248ca23e8d2e_ChIJN8YLhjZl_0.jpg",
      averageRating=4.1, totalRatingsCount=383,
      createdAt="2026-08-30T23:00:11.092627Z", updatedAt="2026-08-31T08:32:09.793456Z",
    ),
    ClubDto(
      id="1718bb58-1061-4520-8759-90c3b3a598d2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Bowling Balexert", address="Av. du Pailly 21, 1220 Vernier",
      city="Geneva", country="CH",
      latitude=46.2187325, longitude=6.1104406,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7867d766-bebd-42c8-bfbf-e2223d1f7547_photo.jpg",
      averageRating=4.1, totalRatingsCount=1214,
      createdAt="2026-08-31T15:59:52.383763Z", updatedAt="2026-08-31T15:59:52.383763Z",
    ),
    ClubDto(
      id="4b783be1-fc51-477e-ba71-3720bcf2f961", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CTT Châtelaine - Club de tennis de table", address="Av. du Pailly 15, 1219 Vernier",
      city="Geneva", country="CH",
      latitude=46.2163998, longitude=6.1096382,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8a0ca7a7-ecf0-4237-8a81-93ad03a47093_photo.jpg",
      averageRating=4.5, totalRatingsCount=15,
      createdAt="2026-08-31T15:59:26.891051Z", updatedAt="2026-08-31T22:11:14.557385Z",
    ),
    ClubDto(
      id="906d9225-9338-4c35-a0f9-d63a010df124", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Genève Volley", address="Av. Louis-Casaï 43, 1220 Vernier",
      city="Geneva", country="CH",
      latitude=46.2198522, longitude=6.1123369,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/491d0cb4-3dcf-446e-915c-c922daf20467_photo.jpg",
      averageRating=4.6, totalRatingsCount=9,
      createdAt="2026-08-31T15:59:01.470253Z", updatedAt="2026-08-31T15:59:01.470253Z",
    ),
  )),
  CitySeo(slug="alicante", name="Alicante", country="ES", clubCount=25, sports=listOf(Pair("Tennis", 4), Pair("Football", 4), Pair("Volleyball", 4), Pair("Padel", 2), Pair("Basketball", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Karting", 2), Pair("Paintball", 2), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="f1df602b-59ef-43d3-a7d2-86f1e75a97a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Clique", address="C. Argensola, 5, 03002 Alicante",
      city="Alicante", country="ES",
      latitude=38.3469243, longitude=-0.4833256,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c0c81207-356c-41c4-acfd-29b911eeae70_photo.jpg",
      averageRating=5.0, totalRatingsCount=179,
      createdAt="2026-09-01T08:51:15.688477Z", updatedAt="2026-09-01T08:51:15.688477Z",
    ),
    ClubDto(
      id="291429cf-4a80-4dd2-a66e-b4fdf6e26b5b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climbpro Center", address="C. Ebanistería-1, 8, 03008 Alicante",
      city="Alicante", country="ES",
      latitude=38.3342, longitude=-0.5163963,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ddcff379-8f26-4e35-a5e2-fbf7f533356c_photo.jpg",
      averageRating=4.8, totalRatingsCount=379,
      createdAt="2026-09-01T08:51:10.167751Z", updatedAt="2026-09-01T08:51:10.167751Z",
    ),
    ClubDto(
      id="af52eb3e-6a9f-4a55-b7d3-ea0ec8a19b65", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo Voley Playa Muchavista", address="Av. Jaime I el Conquistador, 43, 03560 El Campello, Alicante",
      city="Alicante", country="ES",
      latitude=38.384868, longitude=-0.408818,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f3f7090-6044-43fa-a0ea-2d71824b099b_photo.jpg",
      averageRating=4.8, totalRatingsCount=189,
      createdAt="2026-09-01T08:50:28.727643Z", updatedAt="2026-09-01T08:50:28.727643Z",
    ),
    ClubDto(
      id="577052ac-e8ea-46cf-9479-cee0b560a57d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Voley Playa Costa Blanca", address="Av. de Niza, 23, 03540 Alicante",
      city="Alicante", country="ES",
      latitude=38.3754796, longitude=-0.40989,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cac39096-ee3d-461f-bfbc-a09353de35d8_photo.jpg",
      averageRating=4.8, totalRatingsCount=90,
      createdAt="2026-09-01T08:50:33.548819Z", updatedAt="2026-09-01T08:50:33.548819Z",
    ),
    ClubDto(
      id="2f68607b-1ae0-4686-bcb7-0d0502a0a0f6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PAINTBALL TITANES ALACANT", address="CV-821, Km. 4 (Frente al Karting, cerca del Autocine, 03112 Alicante",
      city="Alicante", country="ES",
      latitude=38.3980888, longitude=-0.4850123,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e1ce4062-6d71-447f-b575-ae84df7cdfe5_photo.jpg",
      averageRating=4.8, totalRatingsCount=433,
      createdAt="2026-09-01T08:51:19.954699Z", updatedAt="2026-09-01T08:51:19.954699Z",
    ),
    ClubDto(
      id="a89418bf-c9e7-47f7-8989-42a0d31cc884", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AN Padel Indoor", address="C. Pintor Rosales, 12, 03009 Alicante",
      city="Alicante", country="ES",
      latitude=38.3734564, longitude=-0.5021894,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/01ccb5f3-3e8e-43a7-b0bf-37280c6be5aa_photo.jpg",
      averageRating=4.7, totalRatingsCount=415,
      createdAt="2026-09-01T08:50:14.591882Z", updatedAt="2026-09-01T08:50:14.591882Z",
    ),
    ClubDto(
      id="7768d3a1-aeb5-4409-8bba-88623423b0e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Las Colinas", address="Av. de las Colinas, 2, 03189 Dehesa de Campoamor, Alicante",
      city="Alicante", country="ES",
      latitude=37.9279868, longitude=-0.8090538,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/97dfcaf1-9ff4-47d8-b0f7-444ec4da512f_photo.jpg",
      averageRating=4.6, totalRatingsCount=2013,
      createdAt="2026-09-01T08:50:50.878296Z", updatedAt="2026-09-01T08:50:50.878296Z",
    ),
    ClubDto(
      id="f24b51ca-fc87-4044-8692-10539947d39f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Club Alacant", address="Av. de Neptuno, 16, 03007 Alicante",
      city="Alicante", country="ES",
      latitude=38.3415793, longitude=-0.5199906,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84ec8428-5a26-4864-bc6f-4198e35dd070_photo.jpg",
      averageRating=4.6, totalRatingsCount=532,
      createdAt="2026-09-01T08:50:10.482888Z", updatedAt="2026-09-01T08:50:10.482888Z",
    ),
    ClubDto(
      id="302bf042-2caa-4c14-9d02-beb1998334e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Elx", address="38.251218, -0.773574, 03330 Elche, Alicante",
      city="Alicante", country="ES",
      latitude=38.251215, longitude=-0.7735911,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c441aef2-cb92-4e9f-8f0d-94eadf6412f4_photo.jpg",
      averageRating=4.6, totalRatingsCount=170,
      createdAt="2026-09-01T08:51:26.070672Z", updatedAt="2026-09-01T08:51:26.070672Z",
    ),
    ClubDto(
      id="7fad41a0-ff04-468c-af4c-300ed234426a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="40/15 Club Deportivo", address="CAMI DEL MAHONES, PARTIDA EL COLLAO, PARC.200, 03110 Mutxamel, Alicante",
      city="Alicante", country="ES",
      latitude=38.4176136, longitude=-0.4873236,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/73c67f58-d5d2-4f3e-82ee-21a759d5e1e9_photo.jpg",
      averageRating=4.5, totalRatingsCount=269,
      createdAt="2026-09-01T08:50:04.757517Z", updatedAt="2026-09-01T14:31:59.222289Z",
    ),
    ClubDto(
      id="bbeb8d44-13c4-44b8-b58e-c6330f833f54", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoorwall", address="Av. Mare Nostrum, 8, 03007 Alacant, Alicante",
      city="Alicante", country="ES",
      latitude=38.3420919, longitude=-0.525132,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/61c8a117-54b7-470e-a351-a47d93fde425_photo.jpg",
      averageRating=4.5, totalRatingsCount=515,
      createdAt="2026-09-01T08:51:05.068436Z", updatedAt="2026-09-01T08:51:05.068436Z",
    ),
    ClubDto(
      id="7df5afe7-8af7-407e-ab2a-8fd178d8012e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting 932 | Electric Indoor Karting", address="C. Estaño, 2, 03690 San Vicente del Raspeig, Alicante",
      city="Alicante", country="ES",
      latitude=38.3872757, longitude=-0.5101856,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f9f89523-34d8-4dd9-9605-86b6d2b6de9f_photo.jpg",
      averageRating=4.5, totalRatingsCount=889,
      createdAt="2026-09-01T08:51:00.287182Z", updatedAt="2026-09-01T08:51:00.287182Z",
    ),
    ClubDto(
      id="09f97069-df64-480e-9950-59e574f01471", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Atlético Montemar", address="Carrer Virgili, 25, 03016 Alacant, Alicante",
      city="Alicante", country="ES",
      latitude=38.3718843, longitude=-0.4392512,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a245ca28-5c48-4853-b8a4-de534dd24caa_photo.jpg",
      averageRating=4.3, totalRatingsCount=2286,
      createdAt="2026-09-01T08:49:32.141287Z", updatedAt="2026-09-01T14:31:48.270378Z",
    ),
    ClubDto(
      id="b09b0ca4-92bd-4be6-bd12-925d29725fbe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KARTING ALACANT", address="CV-821, Km. 3, 8, 03112, Alicante",
      city="Alicante", country="ES",
      latitude=38.3964614, longitude=-0.4848683,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1dd49acf-1047-4f72-b2d7-4aebae959981_photo.jpg",
      averageRating=4.3, totalRatingsCount=1068,
      createdAt="2026-09-01T08:50:56.325328Z", updatedAt="2026-09-01T08:50:56.325328Z",
    ),
    ClubDto(
      id="543e3fc5-cbef-449e-8d02-7459242ed0dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportclub Alicante - Gimnasio y club deportivo familiar al aire libre", address="Partida de Orgegia, s/n, 03015 Alacant, Alicante",
      city="Alicante", country="ES",
      latitude=38.380606, longitude=-0.459516,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99703179-b6e2-420e-8035-a94804629e5a_photo.jpg",
      averageRating=4.3, totalRatingsCount=747,
      createdAt="2026-09-01T08:49:55.955811Z", updatedAt="2026-09-01T14:32:00.847957Z",
    ),
    ClubDto(
      id="f067fa40-e2b0-44b2-89b4-ea276841b24f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="El Plantío Golf Resort", address="Antigua -Elche Km.3 (A-79 Carretera, 03114 Alacant, Alicante",
      city="Alicante", country="ES",
      latitude=38.3096893, longitude=-0.5401117,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06011baa-7dae-428d-ac2b-9a0699b7f373_photo.jpg",
      averageRating=4.2, totalRatingsCount=2057,
      createdAt="2026-09-01T08:50:45.380773Z", updatedAt="2026-09-01T08:50:45.380773Z",
    ),
    ClubDto(
      id="657b6fa8-c3db-44ac-acd4-01c5c3646eb1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Estadio Municipal de Atletismo", address="C. Hondón de las Nieves, S/N, 03005 Alicante",
      city="Alicante", country="ES",
      latitude=38.355775, longitude=-0.4948568,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/71abf6ad-f650-4d6d-9c92-64695194bdc7_photo.jpg",
      averageRating=4.2, totalRatingsCount=380,
      createdAt="2026-09-01T08:49:41.056706Z", updatedAt="2026-09-01T14:31:49.740694Z",
    ),
    ClubDto(
      id="08a3621a-4ac9-46a3-b569-c307f460462d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hércules de Alicante C.F. S.A.D.", address="Estadio José Rico Pérez, C/ Foguerer Romeu Zarandieta, s/n, 03005 Alacant, Alicante",
      city="Alicante", country="ES",
      latitude=38.3578823, longitude=-0.4933081,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9f7db9b6-fb79-4374-af55-8bc2589d6261_photo.jpg",
      averageRating=4.2, totalRatingsCount=446,
      createdAt="2026-09-01T08:49:36.712982Z", updatedAt="2026-09-01T08:49:36.712982Z",
    ),
    ClubDto(
      id="e31a81de-e26e-41d6-b7df-1ce332eae69b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club esportiu Arena Alacant", address="Av. del Locutor Vicente Hipólito, s/n, 03540 Alicante",
      city="Alicante", country="ES",
      latitude=38.3755546, longitude=-0.4248433,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d6d2b089-c0db-45f2-afeb-21edff660207_photo.jpg",
      averageRating=4.1, totalRatingsCount=860,
      createdAt="2026-09-01T08:49:49.519562Z", updatedAt="2026-09-01T08:49:49.519562Z",
    ),
    ClubDto(
      id="b2a6c017-b9d0-4b86-bb6a-c629d3bfe0fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club de Campo Alicante", address="Carrer de la Sardina, 1, 03110 Mutxamel, Alicante",
      city="Alicante", country="ES",
      latitude=38.3963889, longitude=-0.4630556,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2c866f08-ce76-4bd3-ae4b-9eb3178485e6_photo.jpg",
      averageRating=4.0, totalRatingsCount=747,
      createdAt="2026-09-01T08:50:00.054366Z", updatedAt="2026-09-01T14:31:53.928923Z",
    ),
    ClubDto(
      id="545f40e9-90b5-4c2d-b720-6646afdfa1a5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo Municipal Gran Vía de Supera", address="C. Foguerer José Angel Guirao, S/N, 03015 Alicante",
      city="Alicante", country="ES",
      latitude=38.3655833, longitude=-0.4686883,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6f226a5b-06c9-4e4b-b309-71279aa61823_photo.jpg",
      averageRating=3.9, totalRatingsCount=1732,
      createdAt="2026-09-01T08:50:18.724458Z", updatedAt="2026-09-01T08:50:18.724458Z",
    ),
    ClubDto(
      id="45eb2586-842a-40f5-814b-11968b6200ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Baloncesto Montemar", address="Av. del Padre Esplá, 40, 03013 Alicante",
      city="Alicante", country="ES",
      latitude=38.3571811, longitude=-0.4755256,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/85b61a1d-6a8b-44c3-821a-4416ed62a0cb_photo.jpg",
      averageRating=4.29, totalRatingsCount=42,
      createdAt="2026-09-01T08:50:24.312632Z", updatedAt="2026-09-10T09:38:15.491881Z",
    ),
    ClubDto(
      id="49ed9710-274e-47b8-adec-5902761e51a5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo de fútbol Cabo de la Huerta", address="C. del Palangre, 8, 03540 Alicante",
      city="Alicante", country="ES",
      latitude=38.3586962, longitude=-0.4261879,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f8041b8a-b960-437e-af39-a51b9b11c7ba_photo.jpg",
      averageRating=3.6, totalRatingsCount=314,
      createdAt="2026-09-01T08:49:45.031817Z", updatedAt="2026-09-01T08:49:45.031817Z",
    ),
    ClubDto(
      id="6a411076-0e77-4813-bedf-f44cee5b90cd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Voley Playa Aloha Guardamar", address="Carrer Jorge Juan, 35, 03140 Guardamar del Segura, Alicante",
      city="Alicante", country="ES",
      latitude=38.0852575, longitude=-0.6474402,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9609be2f-a505-4507-8712-49c0463ed11a_photo.jpg",
      averageRating=4.9, totalRatingsCount=27,
      createdAt="2026-09-01T08:50:37.637447Z", updatedAt="2026-09-01T08:50:37.637447Z",
    ),
    ClubDto(
      id="8cb956ca-7200-40a5-997e-18fa4ab2c057", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Sunrise Beach Volley Alicante", address="Av. Jaime I el Conquistador, 150, 03560 El Campello, Alicante",
      city="Alicante", country="ES",
      latitude=38.389956, longitude=-0.4079318,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/70ff495e-27b5-492a-bfdb-e0a28b5ce90a_photo.jpg",
      averageRating=4.8, totalRatingsCount=25,
      createdAt="2026-09-01T08:50:41.710345Z", updatedAt="2026-09-01T08:50:41.710345Z",
    ),
  )),
  CitySeo(slug="nicosia", name="Nicosia", country="CY", clubCount=25, sports=listOf(Pair("Football", 5), Pair("Volleyball", 4), Pair("Tennis", 4), Pair("Basketball", 3), Pair("Billiards", 2), Pair("Paintball", 1), Pair("Karting", 1), Pair("Bowling", 1), Pair("Golf", 1), Pair("Laser Tag", 1), Pair("Climbing", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="3ddf18ab-200d-424a-b4ff-d4f6f4a648f5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Exceed Cafe & Bar", address="B17 22, Aglantzia, Lefkosia 2101",
      city="Nicosia", country="CY",
      latitude=35.1600347, longitude=33.3880248,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d4bc61d2-3411-49ff-a004-99aa84e2945f_photo.jpg",
      averageRating=4.9, totalRatingsCount=91,
      createdAt="2026-09-01T09:09:03.701256Z", updatedAt="2026-09-01T09:09:03.701256Z",
    ),
    ClubDto(
      id="9f6dd420-3f76-4c2a-b239-19de115e25c0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Little Kickers Cyprus", address="Kyrenias 200, Aglantzia, Lefkosia 2112",
      city="Nicosia", country="CY",
      latitude=35.1486431, longitude=33.3755274,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a5e712fc-613c-47f5-8291-a0aa9cfa276e_photo.jpg",
      averageRating=4.9, totalRatingsCount=59,
      createdAt="2026-09-01T09:07:36.416020Z", updatedAt="2026-09-01T09:07:36.416020Z",
    ),
    ClubDto(
      id="617b4c71-1bf3-46a8-9571-9f3b2b1cb99e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Marios Golf Park Par 3", address="Chlorakas 158 Chloraka Paphos CY, Chlorakas, Pafos 8020",
      city="Nicosia", country="CY",
      latitude=34.8096764, longitude=32.3965358,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0ca6cfdf-69ea-4198-85ba-61cfccdd2fa3_photo.jpg",
      averageRating=4.8, totalRatingsCount=683,
      createdAt="2026-09-01T09:08:37.782380Z", updatedAt="2026-09-01T09:08:37.782380Z",
    ),
    ClubDto(
      id="c9b530a4-3a8f-40c8-824f-130b4ce0f313", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ungravity Rock Wall LTD", address="Giorgou Seferi 1, Egkomi Lefkosias, Lefkosia 2408",
      city="Nicosia", country="CY",
      latitude=35.1528216, longitude=33.3149322,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b84e4e81-4e56-430b-b30d-dd165e3e502e_photo.jpg",
      averageRating=4.7, totalRatingsCount=76,
      createdAt="2026-09-01T09:08:59.011111Z", updatedAt="2026-09-01T09:08:59.011111Z",
    ),
    ClubDto(
      id="5d514518-ad2f-43c1-915b-77dff9bd2406", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="APOEL RUNNERS", address="John Kennedy, Nicosia, Lefkosia 1077",
      city="Nicosia", country="CY",
      latitude=35.157276, longitude=33.373117,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3bc176b4-a9b5-4347-9509-fa79605dfcab_photo.jpg",
      averageRating=4.6, totalRatingsCount=92,
      createdAt="2026-09-01T09:08:24.406416Z", updatedAt="2026-09-01T09:08:24.406416Z",
    ),
    ClubDto(
      id="7410921b-4c23-414b-9dbd-8d970e861574", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cyprus Paintball Arena", address="Ayioi Trimithias, Nicosia 2671",
      city="Nicosia", country="CY",
      latitude=35.1186097, longitude=33.2544166,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ee0286ac-5579-47fc-902b-f22d61117f42_photo.jpg",
      averageRating=4.6, totalRatingsCount=143,
      createdAt="2026-09-01T09:09:22.186922Z", updatedAt="2026-09-01T09:09:22.186922Z",
    ),
    ClubDto(
      id="2382e49c-7a1a-42a5-afa6-5a8c9f86beab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KYKKO BOWLING (ΚΥΚΚΟ ΜΠΟΟΥΛΙΝΓΚ)", address="Archimidous 15, Egkomi Lefkosias, Lefkosia 2411",
      city="Nicosia", country="CY",
      latitude=35.162154, longitude=33.3269281,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/86c72061-945c-451b-b76f-5aa1f24316c0_photo.jpg",
      averageRating=4.6, totalRatingsCount=983,
      createdAt="2026-09-01T09:08:50.710007Z", updatedAt="2026-09-01T09:08:50.710007Z",
    ),
    ClubDto(
      id="599eafa2-21d8-42da-8170-6e61f3ab0a57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nuevo Campo", address="ΔΙΔΥΜΟΤΕΙΧΟΥ, Lefkoşa 2032",
      city="Nicosia", country="CY",
      latitude=35.1168266, longitude=33.3651114,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/469f5285-9d6b-4f3f-8553-d04634ae6ad0_photo.jpg",
      averageRating=4.6, totalRatingsCount=254,
      createdAt="2026-09-01T09:07:18.844250Z", updatedAt="2026-09-01T09:07:18.844250Z",
    ),
    ClubDto(
      id="14626b27-2cee-4b05-be24-1bb940ad1504", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Strovolos Municipal Sports Centre", address="5923+8QM, Korytsas, Strovolos, Lefkosia 2011",
      city="Nicosia", country="CY",
      latitude=35.1517372, longitude=33.3550643,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/78ec57ed-8e64-4e1e-bb21-68bfbeb38caf_photo.jpg",
      averageRating=4.5, totalRatingsCount=102,
      createdAt="2026-09-01T09:07:26.537368Z", updatedAt="2026-09-01T14:31:45.873751Z",
    ),
    ClubDto(
      id="8fcb2f76-3a8a-46b2-bb55-2139d8fc3cc1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TAG ARENAS CITY", address="Aigaiou 20, Pera Chorio, Lefkosia 2571",
      city="Nicosia", country="CY",
      latitude=35.0401057, longitude=33.3841603,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/00d6a6ac-9878-4a70-bf12-52aa75669961_photo.jpg",
      averageRating=4.5, totalRatingsCount=58,
      createdAt="2026-09-01T09:09:18.264461Z", updatedAt="2026-09-01T09:09:18.264461Z",
    ),
    ClubDto(
      id="64f43ace-a77a-4142-bea7-0db8b8701abb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ΕΘΑ ΕΓΚΩΜΗΣ FUTSAL", address="Grigori Afxentiou 52, Egkomi Lefkosias, Lefkosia 2407",
      city="Nicosia", country="CY",
      latitude=35.1635714, longitude=33.3355327,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3097a27e-82d6-4ea0-96ec-1fe2db163572_photo.jpg",
      averageRating=4.5, totalRatingsCount=65,
      createdAt="2026-09-01T09:07:30.918736Z", updatedAt="2026-09-01T09:07:30.918736Z",
    ),
    ClubDto(
      id="1a8cab24-9446-4544-b6d6-13015d323213", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Daytona Raceway", address="E120, Nisou, Lefkosia 2571",
      city="Nicosia", country="CY",
      latitude=35.0533409, longitude=33.3755798,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5ae8c00-ed57-4c36-9909-88e6e1b38a3f_photo.jpg",
      averageRating=4.4, totalRatingsCount=439,
      createdAt="2026-09-01T09:08:46.561812Z", updatedAt="2026-09-01T09:08:46.561812Z",
    ),
    ClubDto(
      id="e109c01d-dd1c-492c-9f7e-9136ac7cc858", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aphrodite Hills Tennis Academy", address="Kouklia, Paphos 8500",
      city="Nicosia", country="CY",
      latitude=34.6848784, longitude=32.6059145,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f04e587c-1822-4e95-82c7-cec6b1cd357a_photo.jpg",
      averageRating=4.3, totalRatingsCount=66,
      createdAt="2026-09-01T09:07:57.057055Z", updatedAt="2026-09-01T09:07:57.057055Z",
    ),
    ClubDto(
      id="cd2dbc25-d8f1-4799-8e9b-ae9f1d9126dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lemon Park", address="1 Vasili Michaelide st, Uluyurt, Lefkoşa 2237",
      city="Nicosia", country="CY",
      latitude=35.108501, longitude=33.3658392,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/985b8332-b29c-4b95-91a8-444b2be6f7ca_photo.jpg",
      averageRating=4.3, totalRatingsCount=261,
      createdAt="2026-09-01T09:07:48.463593Z", updatedAt="2026-09-01T09:07:48.463593Z",
    ),
    ClubDto(
      id="59d11d10-c463-4c6a-b235-0fc385610e1e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="New Life Health Centre - Nicosia Gym", address="Stadiou 47, Strovolos, Lefkosia 2058",
      city="Nicosia", country="CY",
      latitude=35.1519307, longitude=33.3391893,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fa468d78-19d4-4fa7-a2a8-0919a226e401_photo.jpg",
      averageRating=4.3, totalRatingsCount=183,
      createdAt="2026-09-01T09:08:16.889465Z", updatedAt="2026-09-01T09:08:16.889465Z",
    ),
    ClubDto(
      id="f4e32d94-2151-4104-a225-faf085004233", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Eleon Tennis Club", address="Vasili Micaelide, Egkomi Lefkosias, Lefkosia 2406",
      city="Nicosia", country="CY",
      latitude=35.1639814, longitude=33.3449085,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5b9eba0b-7db1-4d11-9b52-7ffc793760bd_photo.jpg",
      averageRating=4.2, totalRatingsCount=73,
      createdAt="2026-09-01T09:07:52.985715Z", updatedAt="2026-09-01T14:31:57.199539Z",
    ),
    ClubDto(
      id="dfae932d-d49b-4582-b90d-251881a7db1b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lefkotheo", address="48X8+46P, Lefkotheou, Nicosia, Lefkosia 2400",
      city="Nicosia", country="CY",
      latitude=35.1478462, longitude=33.3155822,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/687adc85-21db-4bc5-b8d6-6f54b06e7b83_photo.jpg",
      averageRating=4.2, totalRatingsCount=59,
      createdAt="2026-09-01T09:07:41.248473Z", updatedAt="2026-09-01T09:07:41.248473Z",
    ),
    ClubDto(
      id="a05fd0e4-cf28-4589-b1e1-18705c7e3bec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Agios Dometios Sports Center", address="B18 156, Agios Dometios, Lefkosia 2365",
      city="Nicosia", country="CY",
      latitude=35.172492, longitude=33.322841,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8a77057e-cf4e-4769-befb-bd221f06a973_photo.jpg",
      averageRating=4.1, totalRatingsCount=70,
      createdAt="2026-09-01T09:08:08.524091Z", updatedAt="2026-09-01T09:08:08.524091Z",
    ),
    ClubDto(
      id="979009b9-93fd-461e-988a-0a78c38d0091", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Eleftheria Stadium", address="48W6+XQX, Egkomi, Nicosia 2400",
      city="Nicosia", country="CY",
      latitude=35.14748, longitude=33.3119735,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/34d99cc1-0542-4e53-9ae0-100d34eb2ce6_photo.jpg",
      averageRating=4.1, totalRatingsCount=146,
      createdAt="2026-09-01T09:08:05.015148Z", updatedAt="2026-09-01T09:08:05.015148Z",
    ),
    ClubDto(
      id="0001b0c4-4aaf-424c-8a4e-c42a5a16e129", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nicosia City Club", address="Ortakoy 99010",
      city="Nicosia", country="CY",
      latitude=35.184473, longitude=33.34763,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39a62592-72c1-4f7a-8a32-eb5eb92d2e68_photo.jpg",
      averageRating=4.1, totalRatingsCount=56,
      createdAt="2026-09-01T09:08:00.577752Z", updatedAt="2026-09-01T09:08:00.577752Z",
    ),
    ClubDto(
      id="8fd6b547-95ea-49ef-be5c-880b687b506b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CAMPEONE SPORTS CENTER", address="47GQ+246, Lakatamia, Nicosia 2306",
      city="Nicosia", country="CY",
      latitude=35.1250406, longitude=33.2877718,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/94745db7-0fcc-4eff-9eef-00544a29e857_photo.jpg",
      averageRating=4.3, totalRatingsCount=47,
      createdAt="2026-09-01T09:08:12.719392Z", updatedAt="2026-09-01T09:08:12.719392Z",
    ),
    ClubDto(
      id="6aee5d01-fca5-4a3a-bc0e-2b96427058b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="AC Omonia Nicosia", address="Papanikoli 5, Nicosia, Lefkosia 1077",
      city="Nicosia", country="CY",
      latitude=35.160053, longitude=33.3690659,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/527d14dd-662e-49cc-94b0-3dd49ebeef5b_photo.jpg",
      averageRating=4.0, totalRatingsCount=47,
      createdAt="2026-09-01T09:08:28.294557Z", updatedAt="2026-09-01T09:08:28.294557Z",
    ),
    ClubDto(
      id="e04a66ed-4adb-4df9-be17-16252accee4e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Room 9 Cafe & Billiards", address="Kantaras 12, Nicosia, Lefkosia 1041",
      city="Nicosia", country="CY",
      latitude=35.1811062, longitude=33.385477,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e57d82f3-3aa2-42f5-86f1-6cdc0929cb9e_photo.jpg",
      averageRating=4.9, totalRatingsCount=24,
      createdAt="2026-09-01T09:09:10.074735Z", updatedAt="2026-09-01T09:09:10.074735Z",
    ),
    ClubDto(
      id="f6171ea5-fd66-44af-a908-25810a6141e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ΑΚΑΔΗΜΙΕΣ PING PONG(Table tennis club - academy )", address="Αθηνάς, Dali, Lefkosia 2548",
      city="Nicosia", country="CY",
      latitude=35.0703827, longitude=33.3871282,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/652adb8a-91e5-4be7-8609-087770665609_photo.jpg",
      averageRating=5.0, totalRatingsCount=23,
      createdAt="2026-09-01T09:08:42.116251Z", updatedAt="2026-09-01T09:08:42.116251Z",
    ),
    ClubDto(
      id="f6b8426e-1bde-4cd1-87df-a8c1230d5d76", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="JP Beach Volley Academy", address="St Raphael Beach Parking Lot, Pyrgos Lemesou, Lemesos 4520",
      city="Nicosia", country="CY",
      latitude=34.7113541, longitude=33.1670088,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0d4f0211-d8ea-46f7-bf04-277fddc5aa3d_photo.jpg",
      averageRating=5.0, totalRatingsCount=11,
      createdAt="2026-09-01T09:08:33.112032Z", updatedAt="2026-09-01T09:08:33.112032Z",
    ),
  )),
  CitySeo(slug="chisinau", name="Chisinau", country="MD", clubCount=25, sports=listOf(Pair("Football", 5), Pair("Volleyball", 5), Pair("Tennis", 4), Pair("Basketball", 3), Pair("Padel", 3), Pair("Billiards", 2), Pair("Paintball", 1), Pair("Golf", 1), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="1d25ab73-d390-4940-af95-34e5f00fd1df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Chisinau Bouldering Project", address="Strada Independenței 32/2, MD-2072, Chișinău",
      city="Chisinau", country="MD",
      latitude=46.9765586, longitude=28.8601379,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/be138bce-7439-4665-82cb-39f5b71b3a6e_photo.jpg",
      averageRating=4.9, totalRatingsCount=244,
      createdAt="2026-09-01T09:15:42.523964Z", updatedAt="2026-09-01T09:15:42.523964Z",
    ),
    ClubDto(
      id="36e5d2ac-85ba-437f-a501-d785b67f3ef1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Top Academy", address="Strada Bucuriei 12a, MD-2001, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0391202, longitude=28.8170744,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a1a8898-2dfe-489d-a7f8-8f54b02a7fc9_photo.jpg",
      averageRating=4.9, totalRatingsCount=76,
      createdAt="2026-09-01T09:14:54.620239Z", updatedAt="2026-09-01T09:14:54.620239Z",
    ),
    ClubDto(
      id="4e9167c5-e7a4-46e6-bea0-b6de512b442b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ursu Padel Club", address="Chișinău, IP Zarea .strada Viilor 232 Chișinău.Zarea, Truşeni",
      city="Chisinau", country="MD",
      latitude=47.0179411, longitude=28.6974888,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5e5a0c3-1c6a-4f72-ad6b-ec24d3078d47_photo.jpg",
      averageRating=5.0, totalRatingsCount=49,
      createdAt="2026-09-01T09:15:04.153525Z", updatedAt="2026-09-01T09:15:04.153525Z",
    ),
    ClubDto(
      id="f6219b77-cc4c-492d-9360-a65530361ad9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Commandos Paintball Club", address="M14, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.1566816, longitude=28.7337767,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9868c92f-5775-4d76-8c2b-7405d119acb3_photo.jpg",
      averageRating=4.8, totalRatingsCount=720,
      createdAt="2026-09-01T09:16:18.977034Z", updatedAt="2026-09-01T09:16:18.977034Z",
    ),
    ClubDto(
      id="21ee2351-aa2f-4616-9aa0-48a85e2e9f0a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketball Court", address="Strada Valea Trandafirilor 16, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0051826, longitude=28.8517673,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/59d63f94-0610-49ef-89bc-f076c1e6ee1c_photo.jpg",
      averageRating=4.7, totalRatingsCount=151,
      createdAt="2026-09-01T09:15:33.113536Z", updatedAt="2026-09-01T09:15:33.113536Z",
    ),
    ClubDto(
      id="6544bb6c-a84e-4302-a9bf-3912532977e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Volleyball Court", address="Strada Braniștii, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0405191, longitude=28.8712123,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e5df08c-3ac8-4be9-9f48-0cb1b4f924f9_photo.jpg",
      averageRating=4.7, totalRatingsCount=66,
      createdAt="2026-09-01T09:15:52.087632Z", updatedAt="2026-09-01T09:15:52.087632Z",
    ),
    ClubDto(
      id="cbd613b6-a037-4530-81b3-cd491ae1fc80", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Speranța", address="Strada Ion Creangă 47, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0276444, longitude=28.7981278,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/90296b4b-3d0d-4458-b8fc-57b7539aafd3_photo.jpg",
      averageRating=4.7, totalRatingsCount=183,
      createdAt="2026-09-01T09:15:46.666586Z", updatedAt="2026-09-01T09:15:46.666586Z",
    ),
    ClubDto(
      id="7fecc0d9-eb63-4472-81f4-cb0f9942cc27", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tracia", address="Chișinău MD, Strada Independenței 1, MD-2023, Chișinău",
      city="Chisinau", country="MD",
      latitude=46.9855622, longitude=28.8460596,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1faf7a40-33ba-4999-bb05-63a53a57529f_photo.jpg",
      averageRating=4.7, totalRatingsCount=104,
      createdAt="2026-09-01T09:14:31.363405Z", updatedAt="2026-09-01T09:14:31.363405Z",
    ),
    ClubDto(
      id="26ebb408-70e1-4c1d-b6bf-f9d85ea2d4d3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PREMIER Football Club", address="Durlești MD, str. Regele Carol 5, MD-2003",
      city="Chisinau", country="MD",
      latitude=47.0066619, longitude=28.7617977,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5cdab76a-a655-4623-b3a1-a635652e2559_photo.jpg",
      averageRating=4.8, totalRatingsCount=48,
      createdAt="2026-09-01T09:14:35.621359Z", updatedAt="2026-09-01T09:14:35.621359Z",
    ),
    ClubDto(
      id="27c547ef-4614-4f7d-bcb8-cf1335965df8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ArtSport Arena", address="MD-2002, Strada Ghidighici 1/1, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0472694, longitude=28.783214,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/12e4d79b-eaab-487f-94d3-a7194a1ba4c1_photo.jpg",
      averageRating=4.6, totalRatingsCount=1008,
      createdAt="2026-09-01T09:14:17.044971Z", updatedAt="2026-09-01T09:14:17.044971Z",
    ),
    ClubDto(
      id="9867c37a-a7fb-45f8-b09f-d77df7af42d2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Chișinău Arena", address="130 Calea Orheiului Street, Stauceni town, MD-4839, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.072235, longitude=28.8618048,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c61990be-e5e7-4b47-a69e-143d29ed1a6f_photo.jpg",
      averageRating=4.6, totalRatingsCount=2646,
      createdAt="2026-09-01T09:15:21.213317Z", updatedAt="2026-09-01T09:15:21.213317Z",
    ),
    ClubDto(
      id="9a694017-b9ad-4c26-bb84-6453b2fdbbd7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Radu Rebeja Football Academy", address="Strada Alba Iulia 200/2, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0422563, longitude=28.7668979,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f32a05f-cdfa-48a9-94e7-0b15381ed8bb_photo.jpg",
      averageRating=4.6, totalRatingsCount=174,
      createdAt="2026-09-01T09:14:26.808489Z", updatedAt="2026-09-01T09:14:26.808489Z",
    ),
    ClubDto(
      id="d76395c3-6310-43bb-9f2b-047049f9b92d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport Park", address="Strada Nicolae Dimo 32, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0583775, longitude=28.8738593,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2bbd1992-4434-4368-be91-c65d08299977_photo.jpg",
      averageRating=4.6, totalRatingsCount=630,
      createdAt="2026-09-01T09:14:46.179826Z", updatedAt="2026-09-01T09:14:46.179826Z",
    ),
    ClubDto(
      id="c0ff1bb0-e3ad-4e39-904b-57fdd738584a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Acvila Tennis Club", address="Calea Iesilor 10b (pe jos Mesager 4 (cu auto Chisinau, MD-2069, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0426845, longitude=28.7990941,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3fd41c0f-9d91-40de-b027-c4cfc2b7cf87_photo.jpg",
      averageRating=4.5, totalRatingsCount=300,
      createdAt="2026-09-01T09:14:50.286939Z", updatedAt="2026-09-01T09:14:50.286939Z",
    ),
    ClubDto(
      id="0ab88246-abe8-4599-ad6c-ecea7341bf4c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billiard Hall", address="MD-2069, Strada Calea Ieşilor 10, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0399093, longitude=28.8025257,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/85c10ef9-5d43-4c6e-8065-2638e34b5c9f_photo.jpg",
      averageRating=4.5, totalRatingsCount=387,
      createdAt="2026-09-01T09:16:14.159769Z", updatedAt="2026-09-01T09:16:14.159769Z",
    ),
    ClubDto(
      id="d035db7e-3794-4ccf-b741-f0026abd34ce", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fitness & Wellness Club Alexia", address="Бульвар Юрия Гагарина 14, MD-2001, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0097326, longitude=28.8578909,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fbc48725-c692-496a-ac48-71738256bc89_photo.jpg",
      averageRating=4.4, totalRatingsCount=588,
      createdAt="2026-09-01T09:15:38.316348Z", updatedAt="2026-09-01T09:15:38.316348Z",
    ),
    ClubDto(
      id="038fde12-fd93-45a6-a13f-618e3378800f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ASEM Sports Complex", address="Strada Ion Doncev, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0340883, longitude=28.8313919,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/58b5ec0d-efc2-4546-8030-4d40f5dc9c6b_photo.jpg",
      averageRating=4.3, totalRatingsCount=307,
      createdAt="2026-09-01T09:15:28.686266Z", updatedAt="2026-09-01T09:15:28.686266Z",
    ),
    ClubDto(
      id="5a0b730e-06cb-4d2a-85d5-b9bd3d218bcd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Looza Billiard Club", address="Bulevardul Mircea cel Bătrîn 12, 5",
      city="Chisinau", country="MD",
      latitude=47.0442084, longitude=28.8911059,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b942564-12ef-4597-96c4-05234490b8f7_photo.jpg",
      averageRating=3.9, totalRatingsCount=417,
      createdAt="2026-09-01T09:16:09.436135Z", updatedAt="2026-09-01T09:16:09.436135Z",
    ),
    ClubDto(
      id="f8e352bf-b1ac-466c-a626-a8439d05854c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rock & Roll Bowling", address="Strada Arborilor 21, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0049691, longitude=28.8408769,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dd8c131c-2379-4488-b210-47532964987b_photo.jpg",
      averageRating=3.9, totalRatingsCount=745,
      createdAt="2026-09-01T09:16:04.911593Z", updatedAt="2026-09-01T09:16:04.911593Z",
    ),
    ClubDto(
      id="f030b7ff-211a-4991-898a-fb6907265f68", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centrul Național de Tenis", address="Spiru Haret 1, Chișinău",
      city="Chisinau", country="MD",
      latitude=46.9513028, longitude=28.9044723,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4cfe5dba-51e5-492d-a5c0-e0ea37606080_photo.jpg",
      averageRating=4.8, totalRatingsCount=38,
      createdAt="2026-09-01T09:14:59.775888Z", updatedAt="2026-09-01T14:31:58.247700Z",
    ),
    ClubDto(
      id="b6edcaae-9083-4793-ae5e-383151b27e53", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club - Arena Chișinău", address="Stăuceni MD, Strada Calea Orheiului 130, MD-4839",
      city="Chisinau", country="MD",
      latitude=47.070628, longitude=28.8636882,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d5e5f290-3dbe-412c-85fd-435ed2e4d140_photo.jpg",
      averageRating=4.0, totalRatingsCount=34,
      createdAt="2026-09-01T09:15:56.326163Z", updatedAt="2026-09-01T09:15:56.326163Z",
    ),
    ClubDto(
      id="5abfe09f-e182-47d3-ac7f-ba8915afedb5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lemon Tree Padel Club", address="Strada Calea Moşilor 18, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0321968, longitude=28.8539871,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/17a3eb7c-7bf4-48c8-aa70-448159c93d80_photo.jpg",
      averageRating=5.0, totalRatingsCount=24,
      createdAt="2026-09-01T09:15:09.615703Z", updatedAt="2026-09-01T09:15:09.615703Z",
    ),
    ClubDto(
      id="1b7da516-4648-4a1a-95dc-cf9afa7b2f7a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Divi Padel Club", address="Ул Chisinau MD, Andrei Doga 26, MD-2024, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0342065, longitude=28.8561879,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/777b0ad9-19c9-4788-8632-903066c6f692_photo.jpg",
      averageRating=4.8, totalRatingsCount=19,
      createdAt="2026-09-01T09:15:14.839584Z", updatedAt="2026-09-01T09:15:14.839584Z",
    ),
    ClubDto(
      id="e2067d4c-9941-45e2-80a5-5adec0244414", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Merops Golf Club", address="str,Militarilor, Chetrosu",
      city="Chisinau", country="MD",
      latitude=46.9172908, longitude=29.0683873,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ded49b8-f18f-4dde-bb5d-7ab059de111d_photo.jpg",
      averageRating=5.0, totalRatingsCount=14,
      createdAt="2026-09-01T09:16:00.334719Z", updatedAt="2026-09-01T09:16:00.334719Z",
    ),
    ClubDto(
      id="e1e76230-3d5d-4c6e-9636-f5e578a8d223", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Clubul de Fotbal RAPID CHIȘINĂU", address="MD-2059, Strada Poştei 44, Chișinău",
      city="Chisinau", country="MD",
      latitude=47.0457873, longitude=28.8454739,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/948a51fd-40ee-4c60-b71a-dd9d7691bb4b_photo.jpg",
      averageRating=4.5, totalRatingsCount=15,
      createdAt="2026-09-01T09:14:40.165435Z", updatedAt="2026-09-01T09:14:40.165435Z",
    ),
  )),
  CitySeo(slug="linz", name="Linz", country="AT", clubCount=25, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Volleyball", 3), Pair("Padel", 3), Pair("Billiards", 2), Pair("Golf", 2), Pair("Climbing", 2), Pair("Bowling", 1), Pair("Laser Tag", 1), Pair("Karting", 1), Pair("Basketball", 1)), clubs=listOf(
    ClubDto(
      id="3353b2a1-c8eb-41c0-af77-9975fcf3b507", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolleyballfelder Linz", address="Saxingerstraße 8, 4020 Linz",
      city="Linz", country="AT",
      latitude=48.305111, longitude=14.3304953,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5efc59b-b886-4874-831e-985fd01d7cea_photo.jpg",
      averageRating=4.8, totalRatingsCount=54,
      createdAt="2026-09-01T00:02:19.790342Z", updatedAt="2026-09-01T00:02:19.790342Z",
    ),
    ClubDto(
      id="8aa0f32c-b227-479f-9960-fb399ae216ad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Resort Kremstal", address="Am Golfpl. 1, 4531 Kematen an der Krems",
      city="Linz", country="AT",
      latitude=48.1081975, longitude=14.1833365,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/86d3ef22-ccdf-43e6-9afa-62cc962774dd_photo.jpg",
      averageRating=4.7, totalRatingsCount=464,
      createdAt="2026-09-01T00:02:40.986216Z", updatedAt="2026-09-01T00:02:40.986216Z",
    ),
    ClubDto(
      id="90869a8d-e11a-4408-9248-77f9c816e02f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="boulderbar Linz", address="Doktor-Hermann-Thurner-Straße 1, 4060 Leonding",
      city="Linz", country="AT",
      latitude=48.2474017, longitude=14.2328534,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1a7623f3-9598-431a-abdc-4435d81f2581_photo.jpg",
      averageRating=4.6, totalRatingsCount=310,
      createdAt="2026-09-01T00:03:13.794058Z", updatedAt="2026-09-01T00:03:13.794058Z",
    ),
    ClubDto(
      id="d967e5cf-3135-490a-8944-190c929c430b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ATZ Tenniszentrum Linz", address="Ferdinand-Markl-Straße 2, 4040 Linz",
      city="Linz", country="AT",
      latitude=48.3326857, longitude=14.2921015,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff54688b-d3d6-4d0a-a1e0-c990e96cdfed_photo.jpg",
      averageRating=4.5, totalRatingsCount=83,
      createdAt="2026-09-01T00:01:26.027120Z", updatedAt="2026-09-01T00:01:26.027120Z",
    ),
    ClubDto(
      id="b5046ebb-e627-4f35-95f7-30117c9ed040", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cafe Rolling, Bowling & Kegelbahnen", address="Laahener Str. 30, 4600 Wels",
      city="Linz", country="AT",
      latitude=48.1663068, longitude=14.0138514,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/65d4aebc-32f8-4728-bb54-099d7c29264e_photo.jpg",
      averageRating=4.5, totalRatingsCount=185,
      createdAt="2026-09-01T00:03:00.138718Z", updatedAt="2026-09-01T00:03:00.138718Z",
    ),
    ClubDto(
      id="df42000a-fd00-4ab4-98e5-0f0ad210cde9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golfclub Donau Freizeitland Linz-Feldkirchen", address="Golfplatzstraße 12, 4101 Feldkirchen an der Donau",
      city="Linz", country="AT",
      latitude=48.331058, longitude=14.0695028,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d6a0ebee-1ca1-4d4e-bd6e-22404e8e1eb9_photo.jpg",
      averageRating=4.5, totalRatingsCount=264,
      createdAt="2026-09-01T00:02:49.108541Z", updatedAt="2026-09-01T00:02:49.108541Z",
    ),
    ClubDto(
      id="cc186a6d-47f8-4947-bd22-9ab3c4ea6228", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poolhall Linz", address="Wattstraße 6, 4030 Linz",
      city="Linz", country="AT",
      latitude=48.2467305, longitude=14.2654608,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ee7e6181-1a35-439d-8539-ddea7605cb41_photo.jpg",
      averageRating=4.5, totalRatingsCount=614,
      createdAt="2026-09-01T00:03:20.944853Z", updatedAt="2026-09-01T00:03:20.944853Z",
    ),
    ClubDto(
      id="7bb01868-61b8-4574-b404-b6d492be7bd9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rotax MAX Dome Linz", address="Holzstraße 3, 4020 Linz",
      city="Linz", country="AT",
      latitude=48.3135744, longitude=14.3007469,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c1a6a54b-1dee-41eb-883a-890e703b6922_photo.jpg",
      averageRating=4.5, totalRatingsCount=697,
      createdAt="2026-09-01T00:02:54.538071Z", updatedAt="2026-09-01T00:02:54.538071Z",
    ),
    ClubDto(
      id="bf44cb81-d76d-422f-9a17-fa76ce19e430", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SOCCERARENA SOCCAFIFE", address="Further Str. 13, 4040 Linz",
      city="Linz", country="AT",
      latitude=48.3266537, longitude=14.3220131,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d0d5f41-9edd-42ae-a3d4-3af12f568538_photo.jpg",
      averageRating=4.5, totalRatingsCount=301,
      createdAt="2026-09-01T00:01:19.466894Z", updatedAt="2026-09-01T14:31:53.059412Z",
    ),
    ClubDto(
      id="fca7adac-635e-4259-aa6d-5b5d987ba862", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportpark Lissfeld", address="Hausleitnerweg 105, 4020 Linz",
      city="Linz", country="AT",
      latitude=48.2682792, longitude=14.2982413,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e664bb9-bc09-4a52-bb70-2688922ac115_photo.jpg",
      averageRating=4.5, totalRatingsCount=700,
      createdAt="2026-09-01T00:00:56.423612Z", updatedAt="2026-09-01T14:32:02.283657Z",
    ),
    ClubDto(
      id="41374d05-9e60-4ff7-94b7-33ea8cd080f2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="der steinbock Linz - Boulderhalle", address="Kapuzinerstraße 84, 4020 Linz",
      city="Linz", country="AT",
      latitude=48.2988704, longitude=14.2747691,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7222910a-e954-45ab-a908-23467d8f8981_photo.jpg",
      averageRating=4.5, totalRatingsCount=393,
      createdAt="2026-09-01T00:03:06.591118Z", updatedAt="2026-09-01T00:03:06.591118Z",
    ),
    ClubDto(
      id="d29ac728-96f1-4dc6-b2e3-fd580bc97a4f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hofmann Personal Stadion - FC Blau-Weiß Linz", address="Straßerau 3, 4020 Linz",
      city="Linz", country="AT",
      latitude=48.3162746, longitude=14.2991547,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc43404e-7d38-48d5-888d-d5b14f68ad98_photo.jpg",
      averageRating=4.4, totalRatingsCount=398,
      createdAt="2026-09-01T00:01:06.610439Z", updatedAt="2026-09-01T00:01:06.610439Z",
    ),
    ClubDto(
      id="fbc9afce-e1c9-4045-b055-0ca357d9e396", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportpark Keplinger", address="Rubensstraße 20, 4050 Traun",
      city="Linz", country="AT",
      latitude=48.2351199, longitude=14.2703673,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/975f012f-d677-49d0-ad30-8ce9a5b553f6_photo.jpg",
      averageRating=4.4, totalRatingsCount=80,
      createdAt="2026-09-01T00:01:33.296164Z", updatedAt="2026-09-01T00:01:33.296164Z",
    ),
    ClubDto(
      id="ee02e13e-eab7-4a1b-8064-6e0a987cb188", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportpark Pichling", address="Weikerlseestraße 73-75, 4030 Linz",
      city="Linz", country="AT",
      latitude=48.2608048, longitude=14.3642707,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8d0d8398-9ec8-45e9-8d91-384fa3240109_photo.jpg",
      averageRating=4.4, totalRatingsCount=313,
      createdAt="2026-09-01T00:01:12.911153Z", updatedAt="2026-09-01T00:01:12.911153Z",
    ),
    ClubDto(
      id="ce82c063-c288-483f-aa91-a20b38e4e909", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasertron", address="Prinz-Eugen-Straße 22, 4020 Lustenau",
      city="Linz", country="AT",
      latitude=48.3012966, longitude=14.3215101,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/954efae0-9fed-4b89-9ae7-75f084036201_photo.jpg",
      averageRating=4.3, totalRatingsCount=415,
      createdAt="2026-09-01T00:03:32.822834Z", updatedAt="2026-09-01T00:03:32.822834Z",
    ),
    ClubDto(
      id="1060ea3d-d488-4bf4-b79f-7989cad465c0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TipsArena Linz", address="Ziegeleistraße 76, 4020 Linz",
      city="Linz", country="AT",
      latitude=48.2925823, longitude=14.2756622,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e03f25c2-7213-4b6d-8438-88205081b821_photo.jpg",
      averageRating=4.3, totalRatingsCount=2537,
      createdAt="2026-09-01T00:00:49.665322Z", updatedAt="2026-09-01T00:00:49.665322Z",
    ),
    ClubDto(
      id="455b3407-5582-479a-b19f-d64ca5c15fd0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billardtempel Linz", address="Wegscheider Str. 1/3, 4030 Linz",
      city="Linz", country="AT",
      latitude=48.2545425, longitude=14.2817025,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4ba61b2e-b49a-4c24-b2bf-b53811274043_photo.jpg",
      averageRating=4.0, totalRatingsCount=217,
      createdAt="2026-09-01T00:03:26.662444Z", updatedAt="2026-09-01T00:03:26.662444Z",
    ),
    ClubDto(
      id="d36d3a3e-9340-4f66-bd74-e9ef6f12093f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportclub Urfahr 1883", address="Bachlbergweg 8, 4040 Linz",
      city="Linz", country="AT",
      latitude=48.3247109, longitude=14.2765656,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/23501af5-7009-4f7e-8778-ea5871a6d8dc_photo.jpg",
      averageRating=4.3, totalRatingsCount=42,
      createdAt="2026-09-01T00:01:40.156939Z", updatedAt="2026-09-01T00:01:40.156939Z",
    ),
    ClubDto(
      id="71b0f873-113e-47d9-891a-5ed6a176885f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportklub SK-VÖEST Sport- und Kommunikationszentrum", address="Lunzerstraße 74, 4030 Linz",
      city="Linz", country="AT",
      latitude=48.2663144, longitude=14.3443023,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a18744e4-5e04-4b3e-8737-453102cb953c_photo.jpg",
      averageRating=4.8, totalRatingsCount=32,
      createdAt="2026-09-01T00:02:26.257973Z", updatedAt="2026-09-01T00:02:26.257973Z",
    ),
    ClubDto(
      id="aefc9bf4-5f6f-4a72-a4ea-ca402a070137", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ASKÖ Waldegg Linz", address="Breitwiesergutstraße 15, 4020 Linz",
      city="Linz", country="AT",
      latitude=48.2846519, longitude=14.2987644,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d05c061-6694-472c-903c-776d2c5e0bda_photo.jpg",
      averageRating=4.7, totalRatingsCount=32,
      createdAt="2026-09-01T00:01:46.713476Z", updatedAt="2026-09-01T00:01:46.713476Z",
    ),
    ClubDto(
      id="a0844bef-4e86-461f-8406-6e92627cabee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADELZONE Linz", address="Julius-Raab-Straße 6/8, 4040 Linz",
      city="Linz", country="AT",
      latitude=48.329861, longitude=14.3240644,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/29d06ca0-1f2c-4574-85d3-b8b80118dc33_photo.jpg",
      averageRating=4.8, totalRatingsCount=30,
      createdAt="2026-09-01T00:01:52.860855Z", updatedAt="2026-09-01T00:01:52.860855Z",
    ),
    ClubDto(
      id="d3acd392-cc74-4a03-b241-8554f1b72763", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ASKÖ Pichling", address="Traundorfer Str. 297, 4030 Linz",
      city="Linz", country="AT",
      latitude=48.2459573, longitude=14.3796969,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9e2250f6-5412-42ce-9012-7f9d5eb724fd_photo.jpg",
      averageRating=4.7, totalRatingsCount=29,
      createdAt="2026-09-01T00:02:32.783964Z", updatedAt="2026-09-01T00:02:32.783964Z",
    ),
    ClubDto(
      id="3520bb8a-8924-4f8f-a45d-6646b97414f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zero Limits Trendsporthalle", address="Julius-Raab-Straße 10, 4040 Linz",
      city="Linz", country="AT",
      latitude=48.3313752, longitude=14.3236873,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a442b157-dab3-4d8f-b6d5-132e9c9fc56e_photo.jpg",
      averageRating=5.0, totalRatingsCount=22,
      createdAt="2026-09-01T00:02:14.089836Z", updatedAt="2026-09-01T00:02:14.089836Z",
    ),
    ClubDto(
      id="0b922af4-ad63-4a2e-b46e-da90629a9235", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADELBASE Linz Halle | Padel Halle Linz", address="Melissenweg 27, 4020 Linz",
      city="Linz", country="AT",
      latitude=48.2580079, longitude=14.2791779,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c3a17fcc-bd42-45bb-ac57-b626bb2a142e_photo.jpg",
      averageRating=4.5, totalRatingsCount=15,
      createdAt="2026-09-01T00:01:59.648369Z", updatedAt="2026-09-01T00:01:59.648369Z",
    ),
    ClubDto(
      id="a589e5de-bb27-409c-b9af-d47c0c55153e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADELBASE Linz Kleinmünchen | Padel Linz", address="Pestalozzistraße 79, 4030 Linz",
      city="Linz", country="AT",
      latitude=48.2565567, longitude=14.3117729,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b9a486b6-67c9-42a1-931b-0afe34e0b7b4_photo.jpg",
      averageRating=4.8, totalRatingsCount=14,
      createdAt="2026-09-01T00:02:06.287316Z", updatedAt="2026-09-01T00:02:06.287316Z",
    ),
  )),
  CitySeo(slug="leeds", name="Leeds", country="GB", clubCount=25, sports=listOf(Pair("Football", 5), Pair("Tennis", 2), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Paintball", 2), Pair("Karting", 2), Pair("Bowling", 2), Pair("Basketball", 2), Pair("Padel", 2), Pair("Volleyball", 2), Pair("Laser Tag", 1), Pair("Golf", 1)), clubs=listOf(
    ClubDto(
      id="69636c8d-4de2-40a3-89d2-1ec93c652e2c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="King Pins", address="White Rose Shopping Centre, Dewsbury Rd, Leeds LS11 8LU",
      city="Leeds", country="GB",
      latitude=53.7578287, longitude=-1.574549,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a13ec1c6-d6fc-4467-901f-dbaec7aa08d2_photo.jpg",
      averageRating=4.9, totalRatingsCount=726,
      createdAt="2026-08-31T23:04:50.090716Z", updatedAt="2026-08-31T23:04:50.090716Z",
    ),
    ClubDto(
      id="16364120-2538-4c65-896a-5ca4d96e2b08", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pure Padel North Leeds", address="Moor Allerton Golf Club, Coal Rd, Leeds LS17 9NH",
      city="Leeds", country="GB",
      latitude=53.8702125, longitude=-1.4812465,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8ae95edb-50fb-486f-9c18-59545326601b_photo.jpg",
      averageRating=4.9, totalRatingsCount=100,
      createdAt="2026-08-31T23:04:07.738933Z", updatedAt="2026-08-31T23:04:07.738933Z",
    ),
    ClubDto(
      id="83634acb-4d85-4a87-b836-76e96028cc95", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Yorkshire Outdoor Activity Park", address="Escrick Park Estate, Broad Ln, Skipwith, Selby YO8 5SW",
      city="Leeds", country="GB",
      latitude=53.8520765, longitude=-0.9943448,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/12c2ef8d-d3a0-46aa-a5ae-21b44bbef557_photo.jpg",
      averageRating=4.9, totalRatingsCount=486,
      createdAt="2026-08-31T23:05:26.061342Z", updatedAt="2026-08-31T23:05:26.061342Z",
    ),
    ClubDto(
      id="ddf1c360-a951-4b08-911a-313d9cf89109", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boom Battle Bar Leeds", address="S43 Harewood Street Victoria Gate, Ground Floor Level and First Floor Level, Leeds LS2 7AR",
      city="Leeds", country="GB",
      latitude=53.7978421, longitude=-1.539223,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7ba42f77-fc82-4ae1-8078-b2866c7e0f3b_photo.jpg",
      averageRating=4.8, totalRatingsCount=1899,
      createdAt="2026-08-31T23:05:05.400933Z", updatedAt="2026-08-31T23:05:05.400933Z",
    ),
    ClubDto(
      id="9f065608-c51b-407b-966d-ff096573153c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Bloc Indoor Climbing Wall", address="1 Kitson Rd, Leeds LS10 1NT",
      city="Leeds", country="GB",
      latitude=53.785681, longitude=-1.534019,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cb1a4985-02b8-4247-8f46-3e5f9153b5ab_photo.jpg",
      averageRating=4.8, totalRatingsCount=578,
      createdAt="2026-08-31T23:05:01.516684Z", updatedAt="2026-08-31T23:05:01.516684Z",
    ),
    ClubDto(
      id="cd64f16a-ba8f-4d08-b65f-888d977f2acf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Delta Force Paintball Leeds", address="Denby Dale Rd, Wakefield WF4 4JN",
      city="Leeds", country="GB",
      latitude=53.6317974, longitude=-1.5571752,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7da3cb94-03c1-497c-aa0d-ed3b91979ac2_photo.jpg",
      averageRating=4.8, totalRatingsCount=2137,
      createdAt="2026-08-31T23:05:18.242616Z", updatedAt="2026-08-31T23:05:18.242616Z",
    ),
    ClubDto(
      id="c3508b6f-65f0-4f58-b455-8ba4577125a2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Slazenger Padel Club Leeds", address="Unit B, Coal Rd, Leeds LS14 1PS",
      city="Leeds", country="GB",
      latitude=53.831811, longitude=-1.4619924,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/82707b1a-01d4-41ee-ab31-91d8eb311a2f_photo.jpg",
      averageRating=4.8, totalRatingsCount=109,
      createdAt="2026-08-31T23:04:01.268322Z", updatedAt="2026-08-31T23:04:01.268322Z",
    ),
    ClubDto(
      id="3b3758d2-6054-442d-bd05-2420df14fc23", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Climbing Lab", address="12, 14 & 15, Kirkstall industrial Park, Burley, Leeds LS4 2AZ",
      city="Leeds", country="GB",
      latitude=53.803373, longitude=-1.5795904,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/929280e6-0470-4381-bf92-e6f7bccbf214_photo.jpg",
      averageRating=4.8, totalRatingsCount=950,
      createdAt="2026-08-31T23:04:54.798105Z", updatedAt="2026-08-31T23:04:54.798105Z",
    ),
    ClubDto(
      id="9becd8ae-182c-4cec-9409-160d73756e83", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Chapel Allerton Lawn Tennis & Squash Club", address="Wensley Avenue, Chapel Allerton, Leeds LS7 3QX",
      city="Leeds", country="GB",
      latitude=53.8300407, longitude=-1.540637,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1ed16414-dadd-4fc7-86f0-92aca7f56aea_photo.jpg",
      averageRating=4.6, totalRatingsCount=125,
      createdAt="2026-08-31T23:03:50.212700Z", updatedAt="2026-09-01T14:31:58.620505Z",
    ),
    ClubDto(
      id="666d3d23-2e48-4702-9a3b-5ce7a2848892", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Northern Snooker Centre", address="92 Kirkstall Rd, Leeds LS3 1LT",
      city="Leeds", country="GB",
      latitude=53.8006706, longitude=-1.566012,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d977589e-3e8c-456d-bf3d-ea3a6c9d25f3_photo.jpg",
      averageRating=4.6, totalRatingsCount=1265,
      createdAt="2026-08-31T23:05:09.396248Z", updatedAt="2026-08-31T23:05:09.396248Z",
    ),
    ClubDto(
      id="2147ba69-92a5-4296-89f6-28d376f14468", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Goals Leeds", address="Redcote Ln, Leeds LS4 2AW",
      city="Leeds", country="GB",
      latitude=53.8052672, longitude=-1.5898449,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/72436705-3207-4018-81a6-43e0cc85b7c6_photo.jpg",
      averageRating=4.5, totalRatingsCount=721,
      createdAt="2026-08-31T23:03:26.908224Z", updatedAt="2026-08-31T23:03:26.908224Z",
    ),
    ClubDto(
      id="adde8434-fec7-48ac-b8c7-9f10fba199ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TeamSport Go Karting Leeds", address="S Accommodation Rd, Leeds LS10 1NQ",
      city="Leeds", country="GB",
      latitude=53.7859686, longitude=-1.530096,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d38f53d4-92c8-4535-8cc1-b2cfa326a0bf_photo.jpg",
      averageRating=4.5, totalRatingsCount=3037,
      createdAt="2026-08-31T23:04:36.302610Z", updatedAt="2026-08-31T23:04:36.302610Z",
    ),
    ClubDto(
      id="5eb0fb26-fdce-4647-934d-8732f58d13d3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Manor", address="Bradford Rd, Drighlington, Bradford BD11 1AB",
      city="Leeds", country="GB",
      latitude=53.7610855, longitude=-1.6680724,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5eef7b0e-336a-4ebb-ac29-f8d77202523c_photo.jpg",
      averageRating=4.5, totalRatingsCount=742,
      createdAt="2026-08-31T23:04:30.858678Z", updatedAt="2026-08-31T23:04:30.858678Z",
    ),
    ClubDto(
      id="0dfb08c6-77fa-4177-b7da-f6b3e2fab535", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Football World Leeds", address="Pontefract Ln, Leeds LS9 0RA",
      city="Leeds", country="GB",
      latitude=53.7859101, longitude=-1.5059809,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b0616ab1-5610-4336-98df-58e7671adfb8_photo.jpg",
      averageRating=4.4, totalRatingsCount=345,
      createdAt="2026-08-31T23:03:30.868356Z", updatedAt="2026-08-31T23:03:30.868356Z",
    ),
    ClubDto(
      id="50d8f3a7-ad99-4b9b-8fb4-62e59d078c8d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Go Karting Leeds - GT Karting", address="Hudson Rd, Harehills, Leeds LS9 7DX",
      city="Leeds", country="GB",
      latitude=53.8052453, longitude=-1.5097924,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5207e5a6-a54f-45fe-9b33-8a6b5cb17df1_photo.jpg",
      averageRating=4.4, totalRatingsCount=475,
      createdAt="2026-08-31T23:04:41.304042Z", updatedAt="2026-08-31T23:04:41.304042Z",
    ),
    ClubDto(
      id="4622967a-b08b-4c26-9750-eb7c3f809fab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laserforce Leeds", address="164 Armley Rd, Armley, Leeds LS12 2TY",
      city="Leeds", country="GB",
      latitude=53.7989778, longitude=-1.5803873,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/92a83fa7-c779-407f-9f33-0a9201c6ed24_photo.jpg",
      averageRating=4.4, totalRatingsCount=155,
      createdAt="2026-08-31T23:05:13.652936Z", updatedAt="2026-08-31T23:05:13.652936Z",
    ),
    ClubDto(
      id="52a7d8d1-7521-4e25-9181-75d8d8238a81", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hollywood Bowl Leeds", address="Cardigan Fields, Kirkstall Rd, Burley, Leeds LS4 2DG",
      city="Leeds", country="GB",
      latitude=53.8038576, longitude=-1.582616,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f64bdf83-2654-4232-9caf-8f6eb6a6bf1e_photo.jpg",
      averageRating=4.3, totalRatingsCount=3411,
      createdAt="2026-08-31T23:04:45.712761Z", updatedAt="2026-08-31T23:04:45.712761Z",
    ),
    ClubDto(
      id="5fd2f92b-684e-49b3-822a-7b427cad723c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Powerleague Leeds Central", address="Wellington Bridge St, Leeds LS3 1LW",
      city="Leeds", country="GB",
      latitude=53.7976305, longitude=-1.5636941,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/673361a6-84fc-483b-84b4-75c80b66be67_photo.jpg",
      averageRating=4.3, totalRatingsCount=303,
      createdAt="2026-08-31T23:03:35.353673Z", updatedAt="2026-08-31T23:03:35.353673Z",
    ),
    ClubDto(
      id="9e028e13-be09-4008-9a4f-63c0f2eb58fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Edge", address="University Of Leeds, Willow Terrace Rd, Woodhouse, Leeds LS2 9JT",
      city="Leeds", country="GB",
      latitude=53.8041841, longitude=-1.553214,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4ba968dd-7424-4a87-bc07-7c2c55be15e4_photo.jpg",
      averageRating=4.2, totalRatingsCount=803,
      createdAt="2026-08-31T23:04:22.302887Z", updatedAt="2026-08-31T23:04:22.302887Z",
    ),
    ClubDto(
      id="13ef71f9-707f-4237-98aa-0d85239e4954", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fives Football", address="Limewood Approach, Seacroft, Leeds LS14 1NH",
      city="Leeds", country="GB",
      latitude=53.8285829, longitude=-1.4624275,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f505584e-3c8f-491d-af60-334f7b259d09_photo.jpg",
      averageRating=4.1, totalRatingsCount=189,
      createdAt="2026-08-31T23:03:40.605382Z", updatedAt="2026-08-31T23:03:40.605382Z",
    ),
    ClubDto(
      id="65c21aeb-1545-4bb3-b954-cb856a72ac05", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Quarry House Leisure Centre", address="Quarry House, Quarry Hill, Leeds LS2 7UA",
      city="Leeds", country="GB",
      latitude=53.7981264, longitude=-1.5302515,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dc058bf5-d6f8-4a94-8970-8d02aabd5668_photo.jpg",
      averageRating=3.9, totalRatingsCount=229,
      createdAt="2026-08-31T23:04:12.940476Z", updatedAt="2026-08-31T23:04:12.940476Z",
    ),
    ClubDto(
      id="e8123557-47a1-4758-84d0-4508db79fe91", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Active Leeds John Charles Tennis Centre", address="Middleton Grove, Belle Isle, Leeds LS11 5DJ",
      city="Leeds", country="GB",
      latitude=53.763431, longitude=-1.5417312,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f6a80a03-99d6-45ed-af27-2112235caa09_photo.jpg",
      averageRating=4.9, totalRatingsCount=28,
      createdAt="2026-08-31T23:03:54.847148Z", updatedAt="2026-08-31T23:03:54.847148Z",
    ),
    ClubDto(
      id="46d0f18f-0e37-4957-a798-ccd6cd525dc3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Leeds LDM Basketball", address="Hillside Enterprise Centre, Beeston Rd, Holbeck, Leeds LS11 8ND",
      city="Leeds", country="GB",
      latitude=53.7809325, longitude=-1.5529429,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8724c7f2-349a-45df-8932-4cdc691e7637_photo.jpg",
      averageRating=5.0, totalRatingsCount=20,
      createdAt="2026-08-31T23:04:18.159701Z", updatedAt="2026-08-31T23:04:18.159701Z",
    ),
    ClubDto(
      id="92250b04-4874-4ec5-a75c-87313ff2972b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Scott Hall Playing Fields", address="Leeds LS7 3JR",
      city="Leeds", country="GB",
      latitude=53.8239786, longitude=-1.5432841,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1a4bf252-f5ac-42f3-8d17-8b26109fe44a_photo.jpg",
      averageRating=4.1, totalRatingsCount=23,
      createdAt="2026-08-31T23:03:46.040815Z", updatedAt="2026-08-31T23:03:46.040815Z",
    ),
    ClubDto(
      id="62ca394d-4492-44f6-b091-9e5617583ff6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stockport Volleyball Club", address="Northumberland Rd, Brinnington, Stockport SK5 8LS",
      city="Leeds", country="GB",
      latitude=53.4281994, longitude=-2.1368016,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/12fab7e8-56af-4ef4-a1bf-b69335be5c10_photo.jpg",
      averageRating=4.9, totalRatingsCount=10,
      createdAt="2026-08-31T23:04:26.370922Z", updatedAt="2026-08-31T23:04:26.370922Z",
    ),
  )),
  CitySeo(slug="liverpool", name="Liverpool", country="GB", clubCount=25, sports=listOf(Pair("Football", 6), Pair("Volleyball", 2), Pair("Golf", 2), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Laser Tag", 2), Pair("Paintball", 2), Pair("Bowling", 2), Pair("Tennis", 2), Pair("Basketball", 1), Pair("Padel", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="872d83fa-f9aa-4d45-a92d-2f3a613cfbd1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ignite Padel Speke", address="Stirling Rd, Speke, Liverpool L24 1AR",
      city="Liverpool", country="GB",
      latitude=53.3425268, longitude=-2.86111,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a27e7980-14b1-4ed7-9d30-67a7f3ec2d65_photo.jpg",
      averageRating=4.9, totalRatingsCount=165,
      createdAt="2026-08-31T23:12:26.455721Z", updatedAt="2026-08-31T23:12:26.455721Z",
    ),
    ClubDto(
      id="74572291-cda2-48eb-8fcf-8817906ac7bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Awesome Walls, Liverpool", address="St Albans Church, Athol St, Liverpool L5 9TN",
      city="Liverpool", country="GB",
      latitude=53.4239953, longitude=-2.9957409,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/07c1d3d2-bd5d-46be-8184-6c59ba6de9df_photo.jpg",
      averageRating=4.8, totalRatingsCount=731,
      createdAt="2026-08-31T23:13:20.338147Z", updatedAt="2026-08-31T23:13:20.338147Z",
    ),
    ClubDto(
      id="f983ecde-3d07-4162-a689-9814f6258fc3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boom Battle Bar Liverpool", address="101-110 St George's Pl, Liverpool L1 1LU",
      city="Liverpool", country="GB",
      latitude=53.4073664, longitude=-2.9804988,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c9b9b86c-355b-4f2e-92ee-3d5f47659ddb_photo.jpg",
      averageRating=4.8, totalRatingsCount=1398,
      createdAt="2026-08-31T23:13:30.919762Z", updatedAt="2026-08-31T23:13:30.919762Z",
    ),
    ClubDto(
      id="d343836d-10e1-45a1-88ee-8859db71e914", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rileys Sports Bar Liverpool", address="Bolton St, Liverpool L3 5LX",
      city="Liverpool", country="GB",
      latitude=53.4060333, longitude=-2.9776781,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c764ecf9-bebb-4c09-8b72-fa9710fd3d12_photo.jpg",
      averageRating=4.8, totalRatingsCount=2226,
      createdAt="2026-08-31T23:13:25.625885Z", updatedAt="2026-08-31T23:13:25.625885Z",
    ),
    ClubDto(
      id="086822d8-63e3-4a7c-b212-cbb420dda0f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Climbing Hangar Liverpool North", address="6 Birchall St, Liverpool L20 8PD",
      city="Liverpool", country="GB",
      latitude=53.4318634, longitude=-2.9912599,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/004438f5-cca5-4e07-a88a-8310da471c09_photo.jpg",
      averageRating=4.8, totalRatingsCount=1403,
      createdAt="2026-08-31T23:13:14.509619Z", updatedAt="2026-08-31T23:13:14.509619Z",
    ),
    ClubDto(
      id="fe0ca71b-8219-4730-a6e5-1ff88ce9b7ab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lane7 Liverpool", address="Clayton Square, Cases St, Liverpool L1 1QR",
      city="Liverpool", country="GB",
      latitude=53.4052355, longitude=-2.9806296,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9755d4f7-a2aa-4eda-8611-511c48fa3060_photo.jpg",
      averageRating=4.7, totalRatingsCount=1043,
      createdAt="2026-08-31T23:13:09.052019Z", updatedAt="2026-08-31T23:13:09.052019Z",
    ),
    ClubDto(
      id="2b068af8-da19-4d01-96c8-9c138817ccf4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TeamSport Go Karting Liverpool", address="182 Sefton St, Liverpool L3 4BQ",
      city="Liverpool", country="GB",
      latitude=53.380291, longitude=-2.9736154,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/38e11f8b-9d3b-4aa6-862d-02c6ef6635a2_photo.jpg",
      averageRating=4.7, totalRatingsCount=2287,
      createdAt="2026-08-31T23:12:58.985546Z", updatedAt="2026-08-31T23:12:58.985546Z",
    ),
    ClubDto(
      id="97679a62-463f-43ba-8ebc-ffcbd7fb1c65", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Delta Force Paintball Liverpool", address="Knowsley Safari Park, Liverpool, Prescot L34 4AN",
      city="Liverpool", country="GB",
      latitude=53.4354236, longitude=-2.8129143,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/05b3b6eb-3cf9-4b52-9629-d2787462d2ba_photo.jpg",
      averageRating=4.6, totalRatingsCount=779,
      createdAt="2026-08-31T23:13:52.705911Z", updatedAt="2026-08-31T23:13:52.705911Z",
    ),
    ClubDto(
      id="3a188fd7-d96f-4fc8-a094-34bee64be3c4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Leisure United Simpson", address="Hillfoot Rd, Hunt's Cross, Liverpool L25 7UJ",
      city="Liverpool", country="GB",
      latitude=53.3659542, longitude=-2.8720508,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fb5fc3d9-b2e7-4565-b5b0-a4cc69753491_photo.jpg",
      averageRating=4.6, totalRatingsCount=191,
      createdAt="2026-08-31T23:12:07.142611Z", updatedAt="2026-08-31T23:12:07.142611Z",
    ),
    ClubDto(
      id="172fa0bf-8b21-434f-911e-926ca228c06f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Leisure United Jeffrey Humble", address="Long Ln, Aintree, Liverpool L9 6AG",
      city="Liverpool", country="GB",
      latitude=53.454107, longitude=-2.9393335,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f3112da2-9f8e-4c03-847f-c058cccd5520_photo.jpg",
      averageRating=4.5, totalRatingsCount=294,
      createdAt="2026-08-31T23:11:48.372492Z", updatedAt="2026-08-31T23:11:48.372492Z",
    ),
    ClubDto(
      id="006701ee-9313-4a69-95be-e270a7d20c2b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Liverpool Golf Centre & Driving Range", address="12 Caldway Dr, Liverpool L27 0YB",
      city="Liverpool", country="GB",
      latitude=53.3930588, longitude=-2.8373263,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1f4a6c7-8a11-4413-a102-eac6cc2e89db_photo.jpg",
      averageRating=4.5, totalRatingsCount=608,
      createdAt="2026-08-31T23:12:53.929851Z", updatedAt="2026-08-31T23:12:53.929851Z",
    ),
    ClubDto(
      id="4a1a72c6-f2c4-4aac-baa2-75e6a95d9f3f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="M&S Bank Arena", address="King's Dock, Port of Liverpool, 16 Monarchs Quay, Liverpool L3 4FP",
      city="Liverpool", country="GB",
      latitude=53.3974791, longitude=-2.9915926,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f06f7010-2b6f-4eeb-8bef-8ddc3858537c_photo.jpg",
      averageRating=4.5, totalRatingsCount=6775,
      createdAt="2026-08-31T23:13:36.489728Z", updatedAt="2026-08-31T23:13:36.489728Z",
    ),
    ClubDto(
      id="64243519-b256-4ad6-83c2-9dd4db0649e3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Allerton Manor Golf Club", address="Allerton Manor Golf Club, Manor Golf Club, Allerton Rd, Allerton, Liverpool L18 3JT",
      city="Liverpool", country="GB",
      latitude=53.3734742, longitude=-2.8874562,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/72604178-28cb-4271-9665-f24dde18d4ac_photo.jpg",
      averageRating=4.4, totalRatingsCount=1510,
      createdAt="2026-08-31T23:12:48.220124Z", updatedAt="2026-08-31T23:12:48.220124Z",
    ),
    ClubDto(
      id="d436b581-47b4-4e4a-bc98-e77d5d4e8de5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Darkstar Ultimate Laser Tag Arena", address="The Arena, Central St, St Helens, Saint Helens WA10 1TZ",
      city="Liverpool", country="GB",
      latitude=53.4580447, longitude=-2.735161,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67e9a760-c2aa-402b-a772-6317ed1e5b58_photo.jpg",
      averageRating=4.4, totalRatingsCount=261,
      createdAt="2026-08-31T23:13:47.579896Z", updatedAt="2026-08-31T23:13:47.579896Z",
    ),
    ClubDto(
      id="4060b590-fbb8-4dc3-99a6-eb6989123d6d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FireFit Youth and Community Hub", address="115 Upper Warwick St, Toxteth, Liverpool L8 8HD",
      city="Liverpool", country="GB",
      latitude=53.3919122, longitude=-2.9667645,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e4bb3fa3-5f42-429b-bf48-6dca41889be2_photo.jpg",
      averageRating=4.4, totalRatingsCount=292,
      createdAt="2026-08-31T23:12:31.196435Z", updatedAt="2026-08-31T23:12:31.196435Z",
    ),
    ClubDto(
      id="8d3560d4-2f5b-443d-a9cb-ca0a97ec35a0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Greenbank Sports Academy", address="Greenbank Ln, Liverpool L17 1AG",
      city="Liverpool", country="GB",
      latitude=53.3844958, longitude=-2.9310332,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e694c06f-7046-4f5f-ad6a-e63a120427ea_photo.jpg",
      averageRating=4.4, totalRatingsCount=323,
      createdAt="2026-08-31T23:11:41.804722Z", updatedAt="2026-08-31T23:11:41.804722Z",
    ),
    ClubDto(
      id="4e355e68-30f4-4578-aa70-0035500c1c4c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Leisure United Jericho Lane", address="Otterspool Dr, Liverpool L17 5AR",
      city="Liverpool", country="GB",
      latitude=53.3664295, longitude=-2.9378403,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4a629f16-9218-4d20-808f-70f18181ac1e_photo.jpg",
      averageRating=4.4, totalRatingsCount=197,
      createdAt="2026-08-31T23:11:59.680750Z", updatedAt="2026-08-31T23:11:59.680750Z",
    ),
    ClubDto(
      id="1072b730-0a56-4562-8b99-8f7ae81a27ed", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Liverpool Tennis Centre", address="Wavertree Sports Park, Wellington Rd, Liverpool L15 4LE",
      city="Liverpool", country="GB",
      latitude=53.3954035, longitude=-2.9256741,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c71435ff-d568-4659-b2e9-6ff01b1ef138_photo.jpg",
      averageRating=4.4, totalRatingsCount=142,
      createdAt="2026-08-31T23:12:11.643607Z", updatedAt="2026-08-31T23:12:11.643607Z",
    ),
    ClubDto(
      id="476e4bb2-0380-44c9-88be-ff15a73480af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Wavertree Sports Park", address="Wellington Rd, Grant Ave, Liverpool L15 4LE",
      city="Liverpool", country="GB",
      latitude=53.3981816, longitude=-2.9250321,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2698f222-2110-4267-8cd5-41067cb98618_photo.jpg",
      averageRating=4.4, totalRatingsCount=284,
      createdAt="2026-08-31T23:11:52.967410Z", updatedAt="2026-09-01T14:31:55.484725Z",
    ),
    ClubDto(
      id="3c0eb99b-7f68-4732-8532-6a5625bfdb5a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Alder Sports & Social Club", address="Alder Rd, Liverpool L12 2AY",
      city="Liverpool", country="GB",
      latitude=53.4203071, longitude=-2.9059805,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a1e3c90b-6021-4e08-a868-c9f7ca40b380_photo.jpg",
      averageRating=4.3, totalRatingsCount=177,
      createdAt="2026-08-31T23:12:35.788615Z", updatedAt="2026-08-31T23:12:35.788615Z",
    ),
    ClubDto(
      id="952f6a30-277e-4d3b-85d4-71ebaced39ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vagabonds", address="433 Queens Dr, Stoneycroft, Liverpool L13 0AG",
      city="Liverpool", country="GB",
      latitude=53.422775, longitude=-2.913104,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2df9f61a-2c34-4894-b990-70efabc567e7_photo.jpg",
      averageRating=4.2, totalRatingsCount=107,
      createdAt="2026-08-31T23:12:15.515112Z", updatedAt="2026-08-31T23:12:15.515112Z",
    ),
    ClubDto(
      id="0a47be4b-e863-4ba2-b3fe-6771b88e27de", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hollywood Bowl Liverpool Edge Lane", address="Retail Park, Edge Ln, Montrose Wy., Old Swan, Liverpool, Merseyside L13 1EW",
      city="Liverpool", country="GB",
      latitude=53.4088425, longitude=-2.9221175,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3bcdce98-9157-46e3-adc0-dd852dd5f778_photo.jpg",
      averageRating=4.0, totalRatingsCount=1806,
      createdAt="2026-08-31T23:13:04.148722Z", updatedAt="2026-08-31T23:13:04.148722Z",
    ),
    ClubDto(
      id="5d089763-200f-49b3-a8e8-e0c5623d74f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Clubmoor - Football Pitch", address="Townsend Ln, Liverpool L13 9DY",
      city="Liverpool", country="GB",
      latitude=53.4346013, longitude=-2.9391821,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8730a866-5f32-48bb-9de4-02ad947a9df6_photo.jpg",
      averageRating=4.1, totalRatingsCount=39,
      createdAt="2026-08-31T23:14:01.049352Z", updatedAt="2026-08-31T23:14:01.049352Z",
    ),
    ClubDto(
      id="e315be57-5541-4218-b159-14488228027b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LC Sports", address="N Mossley Hill Rd, Liverpool L18 8BG",
      city="Liverpool", country="GB",
      latitude=53.3830257, longitude=-2.9209315,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/564b9db9-8e56-4870-a607-3fedeadb22a7_photo.jpg",
      averageRating=4.5, totalRatingsCount=29,
      createdAt="2026-08-31T23:12:40.307330Z", updatedAt="2026-08-31T23:12:40.307330Z",
    ),
    ClubDto(
      id="7baa2855-c23c-41be-8d97-4dfef7944d88", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UKPaintball Ormskirk", address="Firswood Road, Lathom, Ormskirk WN8 8UT",
      city="Liverpool", country="GB",
      latitude=53.558086, longitude=-2.8186129,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0f1f2e2f-b383-4dd7-a315-4e7bf38cd695_photo.jpg",
      averageRating=4.5, totalRatingsCount=11,
      createdAt="2026-08-31T23:13:57.287920Z", updatedAt="2026-08-31T23:13:57.287920Z",
    ),
  )),
  CitySeo(slug="brussels", name="Brussels", country="BE", clubCount=25, sports=listOf(Pair("Volleyball", 4), Pair("Football", 4), Pair("Basketball", 3), Pair("Climbing", 2), Pair("Tennis", 2), Pair("Billiards", 2), Pair("Paintball", 2), Pair("Padel", 2), Pair("Karting", 1), Pair("Bowling", 1), Pair("Table Tennis", 1), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="efa9d0f2-38ae-451e-96f2-20fe19504476", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintbal Brussel", address="Av. d'Auderghem 102, 1040 Etterbeek",
      city="Brussels", country="BE",
      latitude=50.8379221, longitude=4.3865212,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/33e169f0-34e0-4683-9098-a09885bd7214_photo.jpg",
      averageRating=4.9, totalRatingsCount=87,
      createdAt="2026-08-31T15:49:50.566007Z", updatedAt="2026-08-31T15:49:50.566007Z",
    ),
    ClubDto(
      id="6a1d7c2c-0c2c-4775-9851-69924f931955", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Bruxelles Brussel - Team Building, Anniversaire et EVG-EVJF", address="Rue de l'Etoile 80, 1301 Wavre",
      city="Brussels", country="BE",
      latitude=50.7137402, longitude=4.5678945,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2b216272-61b6-49e3-9c7a-2c4b7b1db17d_photo.jpg",
      averageRating=4.9, totalRatingsCount=64,
      createdAt="2026-08-31T15:49:43.976134Z", updatedAt="2026-08-31T15:49:43.976134Z",
    ),
    ClubDto(
      id="b444d267-5962-43f7-94f6-522e08715e09", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BattleKart Tour & Taxis", address="Av. du Port 86C, Shed 3, 1000 Bruxelles",
      city="Brussels", country="BE",
      latitude=50.8648626, longitude=4.348225,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8d11e85d-cbe5-4bde-a99e-805d6d934602_ChIJVyqv57XD_0.jpg",
      averageRating=4.6, totalRatingsCount=704,
      createdAt="2026-08-30T22:47:46.051752Z", updatedAt="2026-08-31T08:25:56.006986Z",
    ),
    ClubDto(
      id="1a095c61-9604-4a78-b769-013b48f01868", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le Petit Lion", address="Hoogstraat 232, 1000 Brussel",
      city="Brussels", country="BE",
      latitude=50.8369613, longitude=4.3487024,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/833984d2-2c85-42bc-86bb-bb65175c2fdb_ChIJWeQWxmTE_0.jpg",
      averageRating=4.5, totalRatingsCount=660,
      createdAt="2026-08-30T22:47:19.049914Z", updatedAt="2026-08-30T22:47:19.049914Z",
    ),
    ClubDto(
      id="45411436-2447-4f43-977d-b11c7ef8e4cf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Logis Auderghem Table Tennis", address="Waversesteenweg 1690, 1160 Oudergem",
      city="Brussels", country="BE",
      latitude=50.8168487, longitude=4.4299902,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f406cc7d-d83d-40e3-9fe0-996eda0a58d3_photo.jpg",
      averageRating=4.5, totalRatingsCount=133,
      createdAt="2026-08-31T15:49:25.458573Z", updatedAt="2026-08-31T15:49:25.458573Z",
    ),
    ClubDto(
      id="c0389614-9557-4364-a6eb-b0e392cc872f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Space Laser Game", address="Shopping Saint Michel / Parking carrefour gratuit 1 rue de l'escadron, Sint Michielswarande 97, 1040 Etterbeek",
      city="Brussels", country="BE",
      latitude=50.8338778, longitude=4.4010813,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1d1966c3-8ea6-4bd9-9a48-bf82419b8deb_photo.png",
      averageRating=4.4, totalRatingsCount=790,
      createdAt="2026-08-31T15:49:33.813534Z", updatedAt="2026-08-31T15:49:33.813534Z",
    ),
    ClubDto(
      id="ad4ca968-5bba-43a6-a3ff-c592f3d64d2f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Terres Neuves", address="Nieuwland 28, 1000 Brussel",
      city="Brussels", country="BE",
      latitude=50.8425491, longitude=4.3475808,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b0a51c0d-fa86-42ac-bb25-6386ca60d1bd_ChIJ-cngJXrE_0.jpg",
      averageRating=4.4, totalRatingsCount=299,
      createdAt="2026-08-30T22:47:39.819113Z", updatedAt="2026-08-31T08:37:52.457595Z",
    ),
    ClubDto(
      id="3509f7f6-9977-472f-a400-c6d2bc198d92", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tour&Taxis Padel Club", address="Havenlaan 86C, 1000 Brussel",
      city="Brussels", country="BE",
      latitude=50.8654665, longitude=4.3484567,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7613a482-ce42-42b6-9f2e-62e610c8b114_ChIJJVPLykrD_0.jpg",
      averageRating=4.4, totalRatingsCount=108,
      createdAt="2026-08-30T22:47:52.840257Z", updatedAt="2026-08-30T22:47:52.840257Z",
    ),
    ClubDto(
      id="2e1d9308-058c-4c60-ace8-8764277e9f0e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arkose Canal", address="Groendreef 52, 1000 Brussel",
      city="Brussels", country="BE",
      latitude=50.8679591, longitude=4.3576903,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6094d5e7-97e3-4cf8-be81-cb834f2f116a_ChIJU_Af0YPD_0.jpg",
      averageRating=4.3, totalRatingsCount=549,
      createdAt="2026-08-30T22:47:32.255181Z", updatedAt="2026-08-31T08:25:02.257798Z",
    ),
    ClubDto(
      id="bfbcd314-000e-48ea-aa5b-3094a19df18e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brussels Lawn Tennis Club", address="Waterloosesteenweg 890, 1000 Brussel",
      city="Brussels", country="BE",
      latitude=50.8041511, longitude=4.3730402,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4e395c9b-2ab4-45de-837d-d4f826bd23bb_ChIJD-w7Nh7F_0.jpg",
      averageRating=4.3, totalRatingsCount=170,
      createdAt="2026-08-30T22:48:14.913095Z", updatedAt="2026-08-30T22:48:14.913095Z",
    ),
    ClubDto(
      id="63f3e3d0-cd47-45b0-83d2-00bfb3a7c36a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centre Sportif de la Forêt de Soignes", address="Waversesteenweg 2057, 1160 Oudergem",
      city="Brussels", country="BE",
      latitude=50.8094539, longitude=4.4436746,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/63013c94-88d4-47a0-90f7-fc79368c6e7f_photo.jpg",
      averageRating=4.3, totalRatingsCount=1071,
      createdAt="2026-08-31T15:48:36.660605Z", updatedAt="2026-08-31T15:48:36.660605Z",
    ),
    ClubDto(
      id="96557e8e-eaf6-494a-a9f9-18890beb56ce", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Delva 🎳", address="Emile Delvastraat 96B, 1020 Brussel",
      city="Brussels", country="BE",
      latitude=50.8797235, longitude=4.3423014,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f8728cfc-9296-423e-9d93-af1918f1a04b_ChIJDTEXRbbD_0.jpg",
      averageRating=4.2, totalRatingsCount=300,
      createdAt="2026-08-30T22:47:25.711735Z", updatedAt="2026-08-31T08:26:30.363078Z",
    ),
    ClubDto(
      id="fd470ca4-8e3f-418a-948f-5f6662ad31ab", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fit Five", address="Tielemansstraat 2, 1020 Brussel",
      city="Brussels", country="BE",
      latitude=50.8746422, longitude=4.345181,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/73fcaabf-6727-4d8d-b5ed-29c762b77ee3_ChIJ04XFdbvD_0.jpg",
      averageRating=4.2, totalRatingsCount=670,
      createdAt="2026-08-30T22:46:45.164559Z", updatedAt="2026-08-30T22:46:45.164559Z",
    ),
    ClubDto(
      id="127a6b0d-fe06-494c-a834-9fb8fe56e2e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Primerose | Tennis - Padel", address="Dikkelindelaan 41, 1020 Brussel",
      city="Brussels", country="BE",
      latitude=50.8924882, longitude=4.3409458,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3adf6c05-d9ee-4199-bc05-c6e056666468_ChIJOTJahkrC_0.jpg",
      averageRating=4.2, totalRatingsCount=282,
      createdAt="2026-08-30T22:48:07.065704Z", updatedAt="2026-09-01T14:31:58.975020Z",
    ),
    ClubDto(
      id="145908f9-a435-49f2-a60a-a58fa63476bb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport- en cultureel centrum Noordpool", address="Antwerpsesteenweg 208, 1000 Brussel",
      city="Brussels", country="BE",
      latitude=50.8648205, longitude=4.3576477,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9921fdcb-6d4b-4c83-9d56-7f43440ff814_ChIJndeU857D_0.jpg",
      averageRating=4.2, totalRatingsCount=221,
      createdAt="2026-08-30T22:46:57.939936Z", updatedAt="2026-08-31T08:36:20.032749Z",
    ),
    ClubDto(
      id="5ea9e101-b824-4275-9954-de9892fc18a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportcity", address="Av. Salomé 2, 1150 Woluwe-Saint-Pierre",
      city="Brussels", country="BE",
      latitude=50.8304262, longitude=4.4564883,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/82cecc45-1ba1-4589-aad2-8b5a5999758e_photo.jpg",
      averageRating=4.2, totalRatingsCount=1860,
      createdAt="2026-08-31T15:48:55.041864Z", updatedAt="2026-08-31T15:48:55.041864Z",
    ),
    ClubDto(
      id="2eeddfc7-d263-4015-bd6d-dec5d2c9ce37", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Big Game Brussels", address="Henri Mausstraat 5, 1000 Brussel",
      city="Brussels", country="BE",
      latitude=50.8477886, longitude=4.349595,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d5b97c2b-af14-4b65-9622-a75bf28e873e_ChIJ-fpfgXjE_0.jpg",
      averageRating=4.2, totalRatingsCount=3185,
      createdAt="2026-08-30T22:47:12.383144Z", updatedAt="2026-08-30T22:47:12.383144Z",
    ),
    ClubDto(
      id="4a9982b8-0353-4abc-b1b9-aeac18d79372", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport Complex van Bempt", address="Brits Tweedelegerlaan 600, 1190 Bruxelles",
      city="Brussels", country="BE",
      latitude=50.8005447, longitude=4.3095283,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/633d96ad-1978-462c-a46f-0ebafeac6a1d_ChIJrSZ9FNHF_0.jpg",
      averageRating=4.1, totalRatingsCount=245,
      createdAt="2026-08-30T22:46:51.606296Z", updatedAt="2026-08-30T22:46:51.606296Z",
    ),
    ClubDto(
      id="fb2a95d1-ec06-453c-a8df-aa5dc3908c33", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporta Brussels Volleyball Club", address="Av. des Anciens Combattants 300, 1140 Evere",
      city="Brussels", country="BE",
      latitude=50.8694405, longitude=4.4070789,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d7a65f00-ce9a-4cad-860b-d94251310414_photo.jpg",
      averageRating=4.1, totalRatingsCount=81,
      createdAt="2026-08-31T15:48:44.434101Z", updatedAt="2026-08-31T15:48:44.434101Z",
    ),
    ClubDto(
      id="a57a52fe-93f8-4477-b799-849f3a05f535", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportcentrum Neder-over-Heembeek", address="Korte Groenweg 99, 1120 Brussel",
      city="Brussels", country="BE",
      latitude=50.8998337, longitude=4.3936101,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/03253f50-c4bd-49aa-9970-fc4ed98fb746_ChIJrYBTv8LC_0.jpg",
      averageRating=4.1, totalRatingsCount=92,
      createdAt="2026-08-30T22:47:05.938080Z", updatedAt="2026-08-31T08:36:25.128655Z",
    ),
    ClubDto(
      id="4f7c36e8-1bd5-4d34-acdd-d986fec74087", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Complexe sportif du Palais du Midi", address="Rue Roger van der Weyden 3, 1000 Bruxelles",
      city="Brussels", country="BE",
      latitude=50.8418317, longitude=4.3438097,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ce67304d-14d6-43f3-a445-5844998bde98_photo.jpg",
      averageRating=4.0, totalRatingsCount=549,
      createdAt="2026-08-31T15:48:27.160350Z", updatedAt="2026-08-31T15:48:27.160350Z",
    ),
    ClubDto(
      id="da474eb4-cc07-43e4-93db-9318b05502b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports accommodation VUB", address="1050 Ixelles",
      city="Brussels", country="BE",
      latitude=50.8248585, longitude=4.3954362,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/387cfdbe-dfbe-48b0-86b2-e0e85a044ff0_photo.jpg",
      averageRating=4.3, totalRatingsCount=43,
      createdAt="2026-08-31T15:49:01.734199Z", updatedAt="2026-08-31T15:49:01.734199Z",
    ),
    ClubDto(
      id="4d555cf7-a371-40b8-aca8-5f3282fde3c1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tierra247 Padel Club", address="Vilvoordsesteenweg 172, 1120 Brussel",
      city="Brussels", country="BE",
      latitude=50.8997726, longitude=4.4028862,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7ea02830-c8f7-4dac-aef1-35310ba9b818_ChIJVe1HQnDD_0.jpg",
      averageRating=4.7, totalRatingsCount=29,
      createdAt="2026-08-30T22:47:59.686162Z", updatedAt="2026-08-31T08:38:02.880119Z",
    ),
    ClubDto(
      id="b0fa7ba0-f892-4f05-ab7c-2c25bad89d03", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Volleyball Court Petite Suisse", address="Pl. de la Petite Suisse 15, 1050 Ixelles",
      city="Brussels", country="BE",
      latitude=50.8172169, longitude=4.3846191,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fed896a6-e157-4106-ae6c-8558b2ce04a5_photo.jpg",
      averageRating=4.4, totalRatingsCount=20,
      createdAt="2026-08-31T15:49:08.765386Z", updatedAt="2026-08-31T15:49:08.765386Z",
    ),
    ClubDto(
      id="74229575-5d23-45c5-9d7b-dd6c8f83b5f5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketbalveld Margaretaplein", address="Sq. Marguerite, 1000 Bruxelles",
      city="Brussels", country="BE",
      latitude=50.8468134, longitude=4.3857041,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4a5b484e-a203-42da-a9d7-4a47d8ee1d09_photo.jpg",
      averageRating=4.1, totalRatingsCount=17,
      createdAt="2026-08-31T15:48:21.470354Z", updatedAt="2026-08-31T15:48:21.470354Z",
    ),
  )),
  CitySeo(slug="ljubljana", name="Ljubljana", country="SI", clubCount=25, sports=listOf(Pair("Football", 4), Pair("Basketball", 3), Pair("Tennis", 3), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Bowling", 2), Pair("Paintball", 2), Pair("Volleyball", 2), Pair("Laser Tag", 1), Pair("Padel", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="3e54e2c1-805a-4639-8d01-eb5b03fa783e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Ljubljana", address="Križišče Ižanske ceste in Hauptmance, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=45.9990878, longitude=14.5179932,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0b70aae-ef12-4e21-b6ed-dfd54120a98e_ChIJz_ZDyEYs_0.jpg",
      averageRating=4.9, totalRatingsCount=624,
      createdAt="2026-08-30T23:11:19.704427Z", updatedAt="2026-08-31T08:34:24.032693Z",
    ),
    ClubDto(
      id="2d986cb3-a276-4b78-be20-75cf60149109", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bolder Scena", address="Magistrova ul. 1, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0729088, longitude=14.4976159,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/54370877-bd82-4204-8752-a2bd4190cb85_ChIJBacLBYcy_0.jpg",
      averageRating=4.7, totalRatingsCount=412,
      createdAt="2026-08-30T23:10:59.133214Z", updatedAt="2026-08-31T08:26:20.660046Z",
    ),
    ClubDto(
      id="729cd3ac-e192-4870-a4e6-7ac25b309f02", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Plezalni center Ljubljana", address="Pesarska cesta 10, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.049668, longitude=14.5486568,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eb141f94-6551-40b6-8b5e-2e76c474e17d_ChIJF2Bdj3Qy_0.jpg",
      averageRating=4.7, totalRatingsCount=1122,
      createdAt="2026-08-30T23:10:52.661703Z", updatedAt="2026-08-31T08:34:48.647767Z",
    ),
    ClubDto(
      id="52966b9e-106f-40e7-b35a-79c818ab0c0d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ŠUS - Evrofitnes, športna rekreacija d.o.o.", address="Vodnikova cesta 155, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0711927, longitude=14.4777293,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c33456b-ca78-4717-8688-baf9cb6cd225_photo.jpg",
      averageRating=4.7, totalRatingsCount=269,
      createdAt="2026-08-31T15:32:17.631650Z", updatedAt="2026-08-31T15:32:17.631650Z",
    ),
    ClubDto(
      id="cdcb88dc-0b0b-488d-804c-0a4ced0e0697", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BAZA Nogometna dvorana", address="Pesarska cesta 12, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0490349, longitude=14.5483979,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7249e6f9-39b2-4ce5-9b1c-a06a077aed9b_ChIJB0wsTHUy_0.jpg",
      averageRating=4.6, totalRatingsCount=435,
      createdAt="2026-08-30T23:10:11.627003Z", updatedAt="2026-08-31T08:25:13.824672Z",
    ),
    ClubDto(
      id="505a802f-dffa-4da8-a19f-9848b74c1acb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ludus Beach Park Ljubljana", address="Šlandrova ulica 11, 1231 Ljubljana - Črnuče",
      city="Ljubljana", country="SI",
      latitude=46.097692, longitude=14.528833,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/de0bd1f2-6162-4e48-ad47-cd05bbbb6700_ChIJ03JlgBkz_0.jpg",
      averageRating=4.6, totalRatingsCount=868,
      createdAt="2026-08-30T23:11:33.819993Z", updatedAt="2026-08-31T08:32:38.089635Z",
    ),
    ClubDto(
      id="6740455e-e02e-46ca-b2a6-ca5787ee5705", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Piknik prostori RIC SAVA - Šport Ljubljana", address="Dajnkova ulica, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0822366, longitude=14.5418939,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a69b9ff-58b9-4cf6-94fa-ebcc9689758a_ChIJv-h6uVYy_0.jpg",
      averageRating=4.6, totalRatingsCount=425,
      createdAt="2026-08-30T23:10:18.391067Z", updatedAt="2026-08-31T08:34:42.800599Z",
    ),
    ClubDto(
      id="efe21490-aaba-46bb-9008-84f4425a6b57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dvorana Stožice - Šport Ljubljana", address="Vojkova cesta 100, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0814406, longitude=14.521489,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc2de597-e7b8-4311-a2a0-610c96352283_ChIJVVVVieUy_0.jpg",
      averageRating=4.5, totalRatingsCount=3860,
      createdAt="2026-08-30T23:09:58.403527Z", updatedAt="2026-08-31T08:27:27.715108Z",
    ),
    ClubDto(
      id="15273587-ead9-4df8-acde-9d34d5a84e02", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf center Stanežiče - Šport Ljubljana", address="Stanežiče, 1210 Ljubljana - Šentvid",
      city="Ljubljana", country="SI",
      latitude=46.1038027, longitude=14.4484964,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7eada4eb-95b6-43a1-9a3d-0f1643147afc_photo.jpg",
      averageRating=4.5, totalRatingsCount=119,
      createdAt="2026-08-31T15:32:31.688043Z", updatedAt="2026-08-31T15:32:31.688043Z",
    ),
    ClubDto(
      id="ff686a3f-3f71-4b81-9685-ebc7f4a5707c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Spyder Ljubljana", address="Cesta v Gorice 13, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0202133, longitude=14.4627654,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b30291f6-bddf-4841-94df-e22a4b7b4ade_ChIJl_CTjbDT_0.jpg",
      averageRating=4.5, totalRatingsCount=251,
      createdAt="2026-08-30T23:11:27.089087Z", updatedAt="2026-08-30T23:11:27.089087Z",
    ),
    ClubDto(
      id="f618e14c-9fb8-4da9-8d37-274691d9435b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Žensko košarkarsko društvo Ježica", address="Savlje 6, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0950543, longitude=14.5082164,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c4f1bd8f-03df-416e-9a06-5230f09c69e4_photo.jpg",
      averageRating=4.7, totalRatingsCount=47,
      createdAt="2026-08-31T15:32:05.237198Z", updatedAt="2026-08-31T15:32:05.237198Z",
    ),
    ClubDto(
      id="7073b1d4-ee3b-4f45-b3a4-f3e00aff2a00", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenis društvo ob Savi", address="Tenis drustvo, ob Savi, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.1039555, longitude=14.513021,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db7ad815-8287-4bab-903d-086f92f35bd8_ChIJlbri4CAz_0.jpg",
      averageRating=4.4, totalRatingsCount=165,
      createdAt="2026-08-30T23:11:40.453339Z", updatedAt="2026-08-31T08:37:26.671137Z",
    ),
    ClubDto(
      id="65421421-8010-4d2c-a4e2-eab81b07e1f8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Teniški klub Gibi Šport", address="Avšičeva cesta 70, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.1003037, longitude=14.4860132,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/86bd7a9b-f536-4a57-b85e-3f591a76146f_photo.jpg",
      averageRating=4.4, totalRatingsCount=366,
      createdAt="2026-08-31T15:31:56.236130Z", updatedAt="2026-08-31T15:31:56.236130Z",
    ),
    ClubDto(
      id="009ac4f3-9cfa-4de9-b624-7659f803ecbb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Teniški klub Schweiger", address="Cesta v Zgornji Log 32, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0322942, longitude=14.458977,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/91238355-ef2a-43ba-9243-cd6d0521c2b0_ChIJweP5Gs3S_0.jpg",
      averageRating=4.4, totalRatingsCount=158,
      createdAt="2026-08-30T23:11:47.558326Z", updatedAt="2026-08-30T23:11:47.558326Z",
    ),
    ClubDto(
      id="c1d7bd14-234f-4b09-a258-235c71bf5d07", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Woop! Arena", address="Moskovska ulica 10, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0648238, longitude=14.5484449,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/702ccb04-8cc9-49a8-a42f-363f05e81c96_ChIJmX_srsUz_0.jpg",
      averageRating=4.4, totalRatingsCount=1109,
      createdAt="2026-08-30T23:10:44.996577Z", updatedAt="2026-08-31T08:39:13.245633Z",
    ),
    ClubDto(
      id="ab49cb5f-0ea4-4fc7-b692-f5fe994bdd21", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ŠPORTNI PARK Savsko naselje", address="Kranjčeva ulica 24, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0678866, longitude=14.5207066,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/be3c28e9-b518-4fed-a052-c396cbab87c8_ChIJt64Yvo0y_0.jpg",
      averageRating=4.4, totalRatingsCount=139,
      createdAt="2026-08-30T23:11:54.314488Z", updatedAt="2026-08-31T08:39:34.306687Z",
    ),
    ClubDto(
      id="4a99e55a-1997-45af-91f7-3e963d3eebda", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Caffe Fontana", address="Dunajska c. 111a, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0747098, longitude=14.5105102,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d4296ac-838e-4510-a496-15f553cc4c17_ChIJGYTajuoy_3.jpg",
      averageRating=4.3, totalRatingsCount=475,
      createdAt="2026-08-30T23:10:25.430877Z", updatedAt="2026-08-31T22:11:14.671428Z",
    ),
    ClubDto(
      id="bce3af38-638d-477e-b197-51d23fc9e16e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf course Trnovo Ljubljana", address="Cesta dveh cesarjev, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0289617, longitude=14.4728354,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f083569-b6a9-46e0-9ea5-c4e5bd7175c9_photo.jpg",
      averageRating=4.3, totalRatingsCount=174,
      createdAt="2026-08-31T15:32:24.608882Z", updatedAt="2026-08-31T15:32:24.608882Z",
    ),
    ClubDto(
      id="67601cab-1a26-4201-9d0d-73121f052764", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="WOOP! KARTING & GLOW GOLF", address="Moskovska ulica 10, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0653249, longitude=14.5481716,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ecb1033c-0053-4825-8d8d-c492d43e9426_ChIJP_0EdlIz_0.jpg",
      averageRating=4.3, totalRatingsCount=735,
      createdAt="2026-08-30T23:11:05.992291Z", updatedAt="2026-08-31T08:38:58.274699Z",
    ),
    ClubDto(
      id="755cbf3e-4cef-477f-abe0-3dc348ad9e9d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Športno društvo Šentvid - Ljubljana", address="Bokalova ulica 14, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0885077, longitude=14.47072,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6fe2ddf5-d72f-4239-9745-5d46a636fc84_ChIJc8A9oSTN_0.jpg",
      averageRating=4.3, totalRatingsCount=440,
      createdAt="2026-08-30T23:10:05.433598Z", updatedAt="2026-08-30T23:10:05.433598Z",
    ),
    ClubDto(
      id="cabfb522-1c68-44fe-8333-dcb5761e9780", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BILJARDNA HIŠA LJUBLJANA Slovenska - Bavarski dvor", address="Slovenska cesta 58, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.056599, longitude=14.5059778,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fc79c400-d708-482a-90f0-fdb09102153e_ChIJ32lK0mYz_0.jpg",
      averageRating=4.2, totalRatingsCount=426,
      createdAt="2026-08-30T23:10:31.570642Z", updatedAt="2026-08-30T23:10:31.570642Z",
    ),
    ClubDto(
      id="abf03650-a3fa-4483-bed0-1af09263f1e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Športni Center Ilirija", address="Celovška cesta 3, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0565273, longitude=14.5004928,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4dc002c3-ae8b-475a-ae0d-41a6e52c0d8e_photo.jpg",
      averageRating=4.1, totalRatingsCount=118,
      createdAt="2026-08-31T15:32:11.037398Z", updatedAt="2026-08-31T15:32:11.037398Z",
    ),
    ClubDto(
      id="aa71e243-97f1-47d1-8a7a-f318d2bd64b5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klub 300", address="Regentova cesta 35, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0813313, longitude=14.4693778,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d476c8a1-e01e-47fa-81cd-4c33de4a3017_ChIJu4lyDDnN_0.jpg",
      averageRating=4.0, totalRatingsCount=1750,
      createdAt="2026-08-30T23:10:38.290733Z", updatedAt="2026-08-31T08:31:26.538628Z",
    ),
    ClubDto(
      id="15d4c168-bf16-4464-b674-0a1dfe148b11", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SportSpace Šiška", address="Stegne 13a, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=46.0844197, longitude=14.48329,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a4bb945e-cde4-4617-94c7-59b1927f5981_photo.jpg",
      averageRating=4.9, totalRatingsCount=36,
      createdAt="2026-08-31T15:31:47.610255Z", updatedAt="2026-08-31T15:31:47.610255Z",
    ),
    ClubDto(
      id="40de0ffa-f0f4-4df2-ac75-094ecc5f8c40", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser tag Ljubljana", address="kržišče Ižanska ceste in huptmace, 1000, 1000 Ljubljana",
      city="Ljubljana", country="SI",
      latitude=45.9987023, longitude=14.5178787,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/22e4af0f-31ea-4f36-b21b-6786e15078d3_ChIJTyFT6UUt_0.jpg",
      averageRating=4.9, totalRatingsCount=25,
      createdAt="2026-08-30T23:11:13.054026Z", updatedAt="2026-08-31T08:32:12.430187Z",
    ),
  )),
  CitySeo(slug="ostrava", name="Ostrava", country="CZ", clubCount=25, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Volleyball", 3), Pair("Climbing", 2), Pair("Golf", 2), Pair("Karting", 2), Pair("Bowling", 2), Pair("Basketball", 2), Pair("Billiards", 1), Pair("Laser Tag", 1), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="ff337ed4-f58b-4771-abeb-2438f14b0bfb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FAJNE", address="Gen. Sochora 12, 708 00 Ostrava-Poruba",
      city="Ostrava", country="CZ",
      latitude=49.832908, longitude=18.1848035,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/00156789-cf9a-422b-9931-ff0d8cb4be41_photo.jpg",
      averageRating=4.7, totalRatingsCount=783,
      createdAt="2026-08-31T23:59:15.824320Z", updatedAt="2026-08-31T23:59:15.824320Z",
    ),
    ClubDto(
      id="9b65d7dc-5e44-4b32-a533-d9c1cc10875e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FIT PARK", address="1. máje 3236/103, 703 00 Moravská Ostrava a Přívoz",
      city="Ostrava", country="CZ",
      latitude=49.8194014, longitude=18.2645156,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6bf911ff-0869-4138-b4aa-fb0b9ed95ce5_photo.jpg",
      averageRating=4.7, totalRatingsCount=545,
      createdAt="2026-08-31T23:58:46.983578Z", updatedAt="2026-09-01T14:31:49.883572Z",
    ),
    ClubDto(
      id="1384e2c2-49b5-4654-b4ca-45fae1118a08", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Game Ostrava Jih", address="Výškovická 122, 700 30 Ostrava-Ostrava-jih",
      city="Ostrava", country="CZ",
      latitude=49.7884269, longitude=18.2258245,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0dc96e7c-fc61-44a8-8eed-10842a134e41_photo.jpg",
      averageRating=4.7, totalRatingsCount=223,
      createdAt="2026-09-01T00:00:36.504689Z", updatedAt="2026-09-01T00:00:36.504689Z",
    ),
    ClubDto(
      id="eeac9431-4068-40a2-8ed4-e9b1891ff7e8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Motokáry Mošnov-Albrechtičky", address="Unnamed Road, 742 55 Albrechtičky",
      city="Ostrava", country="CZ",
      latitude=49.7100805, longitude=18.1134205,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/29bd67a0-1b90-4e53-ae13-f495e04ae6c4_photo.jpg",
      averageRating=4.7, totalRatingsCount=153,
      createdAt="2026-08-31T23:59:46.914644Z", updatedAt="2026-08-31T23:59:46.914644Z",
    ),
    ClubDto(
      id="13cd0ec0-f0d5-4d5a-b87c-0387a0b9ee75", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tendon Blok", address="Sad Jožky Jabůrkové sad, Jožky Jabůrkové, 703 00 Ostrava-Vítkovice",
      city="Ostrava", country="CZ",
      latitude=49.8109568, longitude=18.2734847,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/004d4cea-f0bb-4b62-84a7-2cb19585abec_photo.jpg",
      averageRating=4.7, totalRatingsCount=155,
      createdAt="2026-09-01T00:00:16.614057Z", updatedAt="2026-09-01T00:00:16.614057Z",
    ),
    ClubDto(
      id="7897a3eb-3799-4a79-94c9-1e0f9c159f98", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CDU SPORT - LEISURE Z.S.", address="Charvátská 734/10, 700 30 Ostrava-jih-Výškovice",
      city="Ostrava", country="CZ",
      latitude=49.7790972, longitude=18.2166027,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/807f3aa7-3f42-446f-bee3-784e84c43e2b_photo.jpg",
      averageRating=4.6, totalRatingsCount=326,
      createdAt="2026-08-31T23:58:37.052409Z", updatedAt="2026-08-31T23:58:37.052409Z",
    ),
    ClubDto(
      id="a8f37154-e0eb-4767-83de-b651bdd0eee8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Park Lhotka", address="Kamínky, 725 28 Ostrava-Lhotka",
      city="Ostrava", country="CZ",
      latitude=49.8537314, longitude=18.2304451,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/69ab1ed6-872b-4bd8-b641-8e0aece927a3_photo.jpg",
      averageRating=4.6, totalRatingsCount=743,
      createdAt="2026-08-31T23:59:37.243674Z", updatedAt="2026-08-31T23:59:37.243674Z",
    ),
    ClubDto(
      id="b2c286e4-6dc4-4f3f-8cf4-d2fdf2b76d2e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ostravar Aréna", address="Ruská 3077 /135, Zábřeh, 700 30 Ostrava-Ostrava-jih",
      city="Ostrava", country="CZ",
      latitude=49.8049479, longitude=18.2484347,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/848326c6-0f5f-4ae8-85b7-62813a9fd82a_photo.jpg",
      averageRating=4.6, totalRatingsCount=7258,
      createdAt="2026-08-31T23:58:21.198859Z", updatedAt="2026-08-31T23:58:21.198859Z",
    ),
    ClubDto(
      id="57460881-a8fe-4c86-b869-edca19cdc0db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bazaly", address="Bukovanského 1028/4, 710 00 Slezská Ostrava",
      city="Ostrava", country="CZ",
      latitude=49.8454405, longitude=18.2983163,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f50b8ecc-ddde-4d5d-bd1e-fa9fd83d7c5b_photo.jpg",
      averageRating=4.5, totalRatingsCount=355,
      createdAt="2026-08-31T23:58:32.055724Z", updatedAt="2026-08-31T23:58:32.055724Z",
    ),
    ClubDto(
      id="b473aa72-7687-40b9-9b0c-800de0a10c60", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MojeMotokáry Ostrava", address="U Cementárny 1173, 703 00 Ostrava-Vítkovice",
      city="Ostrava", country="CZ",
      latitude=49.8149683, longitude=18.2401532,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/44258387-22ee-482a-b393-7e3089c880a0_photo.jpg",
      averageRating=4.5, totalRatingsCount=161,
      createdAt="2026-08-31T23:59:42.233993Z", updatedAt="2026-08-31T23:59:42.233993Z",
    ),
    ClubDto(
      id="1372fd97-ea5c-4552-a77e-a86e62aede17", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pizzerie - restaurace Bowling Sky", address="Rušná 1717/4, 708 00 Ostrava-Poruba",
      city="Ostrava", country="CZ",
      latitude=49.8477673, longitude=18.1791163,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/de71139c-b68d-480c-ba47-4b137ebf92b2_photo.jpg",
      averageRating=4.5, totalRatingsCount=1557,
      createdAt="2026-08-31T23:59:52.621493Z", updatedAt="2026-08-31T23:59:52.621493Z",
    ),
    ClubDto(
      id="40c9250d-8a4a-4bd7-bd3b-472d4a83b5d3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Prosper Golf Resort Celadna", address="Čeladná 741, 739 12 Čeladná",
      city="Ostrava", country="CZ",
      latitude=49.5311918, longitude=18.3260171,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1ea210c9-2436-41e5-85b2-646f22355bd8_photo.jpg",
      averageRating=4.5, totalRatingsCount=833,
      createdAt="2026-08-31T23:59:31.930894Z", updatedAt="2026-08-31T23:59:31.930894Z",
    ),
    ClubDto(
      id="5d1d4e6f-57fa-4024-95de-ec0ce540de06", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ridera Sport", address="Závodní 2885/86, 703 00 Ostrava-Vítkovice",
      city="Ostrava", country="CZ",
      latitude=49.8038835, longitude=18.2582228,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/50f535ee-7cf9-4380-bb37-619ac3871476_photo.jpg",
      averageRating=4.5, totalRatingsCount=677,
      createdAt="2026-08-31T23:58:27.141038Z", updatedAt="2026-08-31T23:58:27.141038Z",
    ),
    ClubDto(
      id="60d96bb6-4eb3-4c23-b893-303021c00e30", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Trojhalí Karolina - Sportoviště a Dvojhalí", address="Trojhalí, K Trojhalí, 702 00 Moravská Ostrava a Přívoz",
      city="Ostrava", country="CZ",
      latitude=49.8282215, longitude=18.2869156,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7599c08e-2f35-4b17-a04c-33a770732f79_photo.jpg",
      averageRating=4.5, totalRatingsCount=1732,
      createdAt="2026-08-31T23:59:05.111016Z", updatedAt="2026-08-31T23:59:05.111016Z",
    ),
    ClubDto(
      id="553df790-9f31-4e02-868c-925ece5c9bd6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Marley", address="Černá louka 3188, 702 00 Moravská Ostrava a Přívoz",
      city="Ostrava", country="CZ",
      latitude=49.8340169, longitude=18.2939449,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bb759cad-f929-4952-aebb-85123a109d54_photo.jpg",
      averageRating=4.4, totalRatingsCount=396,
      createdAt="2026-08-31T23:58:55.604223Z", updatedAt="2026-08-31T23:58:55.604223Z",
    ),
    ClubDto(
      id="c18e5bac-17b9-4652-936c-c77edc5b7f64", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Hall Sareza", address="Hrušovská 15/2953, 702 00 Ostrava-Moravská Ostrava a Přívoz",
      city="Ostrava", country="CZ",
      latitude=49.8517258, longitude=18.2827849,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/79ec9fe5-3873-4196-994f-e8b87180d572_photo.jpg",
      averageRating=4.3, totalRatingsCount=382,
      createdAt="2026-08-31T23:59:21.195731Z", updatedAt="2026-08-31T23:59:21.195731Z",
    ),
    ClubDto(
      id="27f090c3-352c-4479-9d67-7d50a53e1c14", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports center Dubina", address="81, Horní 287, 700 30 Ostrava-jih",
      city="Ostrava", country="CZ",
      latitude=49.7736515, longitude=18.2482961,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/17b9617b-2251-4dc6-8b6f-bc611b633a2e_photo.jpg",
      averageRating=4.3, totalRatingsCount=327,
      createdAt="2026-08-31T23:59:10.812415Z", updatedAt="2026-08-31T23:59:10.812415Z",
    ),
    ClubDto(
      id="09397584-138c-419c-a127-1e71f56d649f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="OSTRA Sport Centrum", address="Budečská 3214/4, 702 00 Moravská Ostrava a Přívoz",
      city="Ostrava", country="CZ",
      latitude=49.8480823, longitude=18.2904688,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e8ec0aff-ba77-43f3-9b16-bc73828720e9_photo.jpg",
      averageRating=4.2, totalRatingsCount=340,
      createdAt="2026-08-31T23:59:00.414185Z", updatedAt="2026-08-31T23:59:00.414185Z",
    ),
    ClubDto(
      id="8cd91de2-6db4-477f-9501-b0254f4c420a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports complex Poruba", address="11, Skautská 6093, 708 00 Ostrava-Poruba",
      city="Ostrava", country="CZ",
      latitude=49.8236908, longitude=18.1781045,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/850330db-f5ef-440a-b14b-4e1ed78f860a_photo.jpg",
      averageRating=4.1, totalRatingsCount=295,
      createdAt="2026-08-31T23:58:41.526341Z", updatedAt="2026-08-31T23:58:41.526341Z",
    ),
    ClubDto(
      id="b1ea7cd3-7869-42b6-8776-3939d141ac2e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bonver arena", address="Cingrova 1627/10, 702 00 Moravská Ostrava a Přívoz",
      city="Ostrava", country="CZ",
      latitude=49.8335502, longitude=18.2807156,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/63d4ff0a-3652-4aab-8cb0-d2dca9cb2165_photo.jpg",
      averageRating=4.0, totalRatingsCount=398,
      createdAt="2026-08-31T23:58:51.506020Z", updatedAt="2026-08-31T23:58:51.506020Z",
    ),
    ClubDto(
      id="d1ea622b-b041-4cb6-9e15-a9a53b54b13b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pivnice bowling TREMP", address="U Hrůbků 154, 700 30 Ostrava-Ostrava-jih",
      city="Ostrava", country="CZ",
      latitude=49.8077449, longitude=18.2320438,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2715bdef-22c0-4de2-810d-032ef6533cc0_photo.jpg",
      averageRating=4.0, totalRatingsCount=424,
      createdAt="2026-09-01T00:00:09.346398Z", updatedAt="2026-09-01T00:00:09.346398Z",
    ),
    ClubDto(
      id="3447022a-a0bf-48b4-825d-c959f9c01545", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Družba Bouldering Wall", address="13, Žilinská 1889, 708 00 Ostrava-Poruba",
      city="Ostrava", country="CZ",
      latitude=49.8371252, longitude=18.182277,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fae11d3d-fc32-4e4e-bf64-9a522b912824_photo.jpg",
      averageRating=4.8, totalRatingsCount=29,
      createdAt="2026-09-01T00:00:20.595305Z", updatedAt="2026-09-01T00:00:20.595305Z",
    ),
    ClubDto(
      id="af3a26e9-ca03-4c6c-b9ad-196dc65b0c10", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Elite Vietcong !!!", address="Elektrárenská, 722 00 Ostrava-Svinov",
      city="Ostrava", country="CZ",
      latitude=49.8291678, longitude=18.2209577,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1a23c747-d811-41e1-b0b0-ffddc4cc25e4_photo.jpg",
      averageRating=4.0, totalRatingsCount=23,
      createdAt="2026-09-01T00:00:43.325461Z", updatedAt="2026-09-01T00:00:43.325461Z",
    ),
    ClubDto(
      id="ca0d5bdf-f72d-492d-9778-5d22aa044b8d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ostrava Beach Pro", address="Ruská 2993, 703 00 Ostrava-Vítkovice",
      city="Ostrava", country="CZ",
      latitude=49.8189646, longitude=18.2795458,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e4da399b-3073-4ed9-aa99-97a5d211ffa4_photo.jpg",
      averageRating=4.9, totalRatingsCount=17,
      createdAt="2026-08-31T23:59:26.430359Z", updatedAt="2026-08-31T23:59:26.430359Z",
    ),
    ClubDto(
      id="26a3e255-32e8-4a1a-950c-b9b31d84703f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BC Ostrava z.s.", address="V Zálomu 1, 700 30 Ostrava-jih",
      city="Ostrava", country="CZ",
      latitude=49.8109054, longitude=18.2314127,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c4ac2ebf-640d-4251-a940-f9ea57f48120_photo.jpg",
      averageRating=4.9, totalRatingsCount=14,
      createdAt="2026-09-01T00:00:30.414807Z", updatedAt="2026-09-01T00:00:30.414807Z",
    ),
  )),
  CitySeo(slug="zurich", name="Zurich", country="CH", clubCount=25, sports=listOf(Pair("Basketball", 3), Pair("Volleyball", 3), Pair("Tennis", 3), Pair("Football", 3), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Karting", 2), Pair("Laser Tag", 1), Pair("Paintball", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="e3946921-f304-4ac7-9200-72c3f33443dd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BIQ - Basketball im Quartier", address="Neumünsterstrasse 25, 8008 Zürich",
      city="Zurich", country="CH",
      latitude=47.3615354, longitude=8.5593645,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff0c140b-fd2f-4e9c-81aa-b1da3700099a_photo.jpg",
      averageRating=5.0, totalRatingsCount=93,
      createdAt="2026-08-31T15:53:17.492633Z", updatedAt="2026-08-31T15:53:17.492633Z",
    ),
    ClubDto(
      id="15c50735-9a63-475b-8b12-7ac102d43719", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MVTA Tennis Academy", address="Fronwaldstrasse 115, 8046 Zürich",
      city="Zurich", country="CH",
      latitude=47.4206159, longitude=8.5119667,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/68f35591-702a-4630-9ebb-c54e704ec999_ChIJJ-uUxzEL_0.jpg",
      averageRating=5.0, totalRatingsCount=94,
      createdAt="2026-08-30T23:39:36.616806Z", updatedAt="2026-08-31T08:32:42.208676Z",
    ),
    ClubDto(
      id="9a6b4eb1-4ed2-4be6-a627-b5221d782245", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MilSim Events", address="Schaffhauserstrasse 491, 8052 Zürich",
      city="Zurich", country="CH",
      latitude=47.4209435, longitude=8.549073,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/66a242e0-fa56-48d7-902f-38e770c407ef_ChIJd0KZtC4L_0.jpg",
      averageRating=5.0, totalRatingsCount=202,
      createdAt="2026-08-30T23:39:16.124745Z", updatedAt="2026-08-31T08:32:52.663097Z",
    ),
    ClubDto(
      id="7687a589-2b17-4079-a96c-4257a3c73c94", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FUN BOWL Bowling & Freizeitcenter", address="Zürichstrasse 183, 8910 Affoltern am Albis",
      city="Zurich", country="CH",
      latitude=47.2871321, longitude=8.4523564,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d1dd1ff7-cf60-426e-ad2e-752924a94ab5_ChIJwxA_ViQG_0.jpg",
      averageRating=4.6, totalRatingsCount=931,
      createdAt="2026-08-30T23:38:48.258470Z", updatedAt="2026-08-30T23:38:48.258470Z",
    ),
    ClubDto(
      id="40cf62a0-ef00-4d8f-9842-0a1dcf636024", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Barfly’z", address="Gotthardstrasse 21, 8002 Zürich",
      city="Zurich", country="CH",
      latitude=47.3659385, longitude=8.5368185,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3969e5fa-ba44-40fb-82ed-2d124a30a050_ChIJg755c_8J_0.jpg",
      averageRating=4.5, totalRatingsCount=843,
      createdAt="2026-08-30T23:38:41.661296Z", updatedAt="2026-08-30T23:38:41.661296Z",
    ),
    ClubDto(
      id="7755610c-9293-4d4b-9ad8-b75db046f313", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kart - Bahn - Wohlen AG", address="Gründlistrasse 17 oder, Heuelstrasse, 5622 Waltenschwil",
      city="Zurich", country="CH",
      latitude=47.3258967, longitude=8.2964963,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b11c94a9-a9c5-4e67-a9e3-7b04d3cec66d_photo.jpg",
      averageRating=4.5, totalRatingsCount=977,
      createdAt="2026-08-31T15:54:27.642042Z", updatedAt="2026-08-31T15:54:27.642042Z",
    ),
    ClubDto(
      id="c2e91b03-0ed5-465f-8098-7f57925fb3c0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Swiss Golf Park", address="Sportplatzweg 1, 8820 Wädenswil",
      city="Zurich", country="CH",
      latitude=47.2056989, longitude=8.6704457,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/210782aa-0708-4dbc-a387-331d44d95602_photo.jpg",
      averageRating=4.5, totalRatingsCount=84,
      createdAt="2026-08-31T15:54:05.560075Z", updatedAt="2026-08-31T15:54:05.560075Z",
    ),
    ClubDto(
      id="49ca33b3-4bbc-4479-a207-b06cfe71cf58", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennisanlage Mythenquai", address="Mythenquai 200, 8002 Zürich",
      city="Zurich", country="CH",
      latitude=47.3522879, longitude=8.5336873,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9b9dbc76-5264-4401-8662-b024e569dc85_ChIJDbS2h-EJ_1.jpg",
      averageRating=4.5, totalRatingsCount=110,
      createdAt="2026-08-30T23:39:29.604961Z", updatedAt="2026-08-31T22:11:22.702180Z",
    ),
    ClubDto(
      id="98cad10b-80d9-4af1-82e6-bd0691f1d798", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennisclub Seeblick", address="Talweg 110, 8038 Zürich",
      city="Zurich", country="CH",
      latitude=47.3330182, longitude=8.5382976,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1f517825-893f-4c64-8adf-8b69c9d38a26_ChIJt0yuhXun_1.jpg",
      averageRating=4.5, totalRatingsCount=145,
      createdAt="2026-08-30T23:39:22.242900Z", updatedAt="2026-08-31T22:11:22.810428Z",
    ),
    ClubDto(
      id="2e194740-af85-4315-a5c2-564ee39635cb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bächli Bergsport Zürich Oerlikon", address="Binzmühlestrasse 80, 8050 Zürich",
      city="Zurich", country="CH",
      latitude=47.4142262, longitude=8.5419769,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b67e96f-e892-4858-838e-10889f8ec147_ChIJBaYYj48K_0.jpg",
      averageRating=4.4, totalRatingsCount=696,
      createdAt="2026-08-30T23:39:09.377636Z", updatedAt="2026-08-31T08:26:42.342571Z",
    ),
    ClubDto(
      id="9ad3a70a-069f-4b39-888a-210e3f3bec85", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Arena", address="Brandschenkestrasse 178, 8002 Zürich",
      city="Zurich", country="CH",
      latitude=47.362292, longitude=8.5262946,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/785ab7df-75f4-4d44-a8f3-d7b95cc98761_photo.jpg",
      averageRating=4.4, totalRatingsCount=1012,
      createdAt="2026-08-31T15:54:34.257274Z", updatedAt="2026-08-31T15:54:34.257274Z",
    ),
    ClubDto(
      id="09d294f2-56d7-40b1-838b-3fd3b4ca2960", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MINIMUM Flüela", address="Flüelastrasse 31, 8047 Zürich",
      city="Zurich", country="CH",
      latitude=47.381681, longitude=8.4953816,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/12fc8b89-403d-458e-a7fa-1e34e6ee95fb_ChIJ1SHmOs0L_0.jpg",
      averageRating=4.4, totalRatingsCount=1109,
      createdAt="2026-08-30T23:39:02.601236Z", updatedAt="2026-08-31T08:32:40.591157Z",
    ),
    ClubDto(
      id="b393db07-434e-4339-a4f1-36efb1ce6fb0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="OCHSNER SPORT", address="Kalanderpl. 1, 8045 Zürich",
      city="Zurich", country="CH",
      latitude=47.3578368, longitude=8.5227638,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/29625948-a11a-4275-80b2-7f605e8e2df6_ChIJt-b_zu8J_0.jpg",
      averageRating=4.4, totalRatingsCount=667,
      createdAt="2026-08-30T23:38:21.542312Z", updatedAt="2026-08-31T08:33:24.538369Z",
    ),
    ClubDto(
      id="c03c0e6a-c3ba-4f12-a67b-3c79e1c3e9e7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportanlage Hardhof", address="Hardhof 19, 8064 Zürich",
      city="Zurich", country="CH",
      latitude=47.3965574, longitude=8.4974915,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f13b5ac8-4ab3-48ed-9952-1b446884b372_photo.jpg",
      averageRating=4.4, totalRatingsCount=320,
      createdAt="2026-08-31T15:53:24.787864Z", updatedAt="2026-08-31T15:53:24.787864Z",
    ),
    ClubDto(
      id="782f8861-dfab-40dc-8ff6-fe05de7d9114", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportzentrum Heerenschürli", address="Helen-Keller-Strasse 20, 8051 Zürich",
      city="Zurich", country="CH",
      latitude=47.4011059, longitude=8.5953503,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2c73f152-c167-472d-8809-0f51ea284558_ChIJaYOr8X2g_0.jpg",
      averageRating=4.4, totalRatingsCount=617,
      createdAt="2026-08-30T23:38:28.098413Z", updatedAt="2026-09-01T14:32:02.400564Z",
    ),
    ClubDto(
      id="19f6ce72-d47b-4a80-8acb-9e4448a77c39", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportzentrum Heuried", address="Wasserschöpfi 71, 8055 Zürich",
      city="Zurich", country="CH",
      latitude=47.3678151, longitude=8.5060045,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4e1fc34d-bb90-4a98-9f80-f2c84c323219_ChIJPVnzQIgJ_0.jpg",
      averageRating=4.4, totalRatingsCount=684,
      createdAt="2026-08-30T23:38:15.193039Z", updatedAt="2026-08-30T23:38:15.193039Z",
    ),
    ClubDto(
      id="27f53e47-435e-4e78-9e75-d8aa1a224169", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Center Master", address="Glatttalstrasse 40, 8052 Zürich",
      city="Zurich", country="CH",
      latitude=47.4252398, longitude=8.5486145,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/15c96d4b-80d7-4ca3-a82b-5b8795699120_ChIJXwabYk0L_0.jpg",
      averageRating=4.3, totalRatingsCount=439,
      createdAt="2026-08-30T23:38:55.129972Z", updatedAt="2026-08-30T23:38:55.129972Z",
    ),
    ClubDto(
      id="83b7496a-8efa-45e2-8a2e-cf7e708bfeb3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kartbahn Spreitenbach AG", address="Industriestrasse 166a, 8957 Spreitenbach",
      city="Zurich", country="CH",
      latitude=47.4262075, longitude=8.3681388,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a2bc668-0781-4ed7-b09b-6ee17b43c417_photo.jpg",
      averageRating=4.3, totalRatingsCount=917,
      createdAt="2026-08-31T15:54:19.522584Z", updatedAt="2026-08-31T15:54:19.522584Z",
    ),
    ClubDto(
      id="24ee8c74-6c6e-45b9-a8df-8e5c4845ca91", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billiardino", address="Heinrichstrasse 245, 8005 Zürich",
      city="Zurich", country="CH",
      latitude=47.3884279, longitude=8.5222697,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bf3f1dd6-d378-409a-80cf-b0172c978294_ChIJBwlLA0AK_0.jpg",
      averageRating=4.2, totalRatingsCount=1190,
      createdAt="2026-08-30T23:38:34.331159Z", updatedAt="2026-08-30T23:38:34.331159Z",
    ),
    ClubDto(
      id="0b96435e-f0fc-4cb1-845f-266ed0b04406", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf driving range Adlisberg", address="Adlisbergstrasse 35, 8044 Zürich",
      city="Zurich", country="CH",
      latitude=47.3761238, longitude=8.5778574,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/16a5ec88-4f58-4b83-b6fa-7f44b405cda3_photo.jpg",
      averageRating=4.2, totalRatingsCount=138,
      createdAt="2026-08-31T15:53:57.946412Z", updatedAt="2026-08-31T15:53:57.946412Z",
    ),
    ClubDto(
      id="1b6ec258-f4ef-43c5-a48e-7b0c0dbc8f1b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachhalle Zürich Nord AG", address="Grindelstrasse 20, 8303 Bassersdorf",
      city="Zurich", country="CH",
      latitude=47.4437007, longitude=8.6097533,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b5c30456-edfd-4dab-a101-4dd3e035e358_photo.jpg",
      averageRating=4.9, totalRatingsCount=39,
      createdAt="2026-08-31T15:53:45.271637Z", updatedAt="2026-08-31T15:53:45.271637Z",
    ),
    ClubDto(
      id="58711762-a1a0-4ae9-a125-390e65e423fe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketball Club Zürich 93", address="Schulhaus Leutschenbach, 8050 Zürich",
      city="Zurich", country="CH",
      latitude=47.4134032, longitude=8.5627674,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/552ea80b-29f9-4322-bb40-3e0a82326fb5_photo.png",
      averageRating=4.8, totalRatingsCount=36,
      createdAt="2026-08-31T15:53:30.411583Z", updatedAt="2026-08-31T15:53:30.411583Z",
    ),
    ClubDto(
      id="bbc5f2fe-2f67-4392-b7d1-fc5da9d69144", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolleyballfelder Allenmoos", address="Allenmoosstrasse 64, 8057 Zürich",
      city="Zurich", country="CH",
      latitude=47.4040954, longitude=8.5398048,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1b688792-8c2f-4ee2-824d-4ebef7972974_photo.jpg",
      averageRating=4.7, totalRatingsCount=31,
      createdAt="2026-08-31T15:53:36.754341Z", updatedAt="2026-08-31T15:53:36.754341Z",
    ),
    ClubDto(
      id="926b5fbc-df9b-4545-be95-0346cdff9aa1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach volleyball courts", address="Schwimmbadstrasse 20, 8302 Kloten",
      city="Zurich", country="CH",
      latitude=47.4435085, longitude=8.5820284,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49a20484-066b-4dc8-8ed5-861b6c695493_photo.jpg",
      averageRating=4.6, totalRatingsCount=16,
      createdAt="2026-08-31T15:53:51.148668Z", updatedAt="2026-08-31T15:53:51.148668Z",
    ),
    ClubDto(
      id="ceca2d39-db54-40e7-9848-f50d36052266", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tischtennisclub Zürich Affoltern", address="Rümlangstrasse 89, 8052 Zürich",
      city="Zurich", country="CH",
      latitude=47.4308729, longitude=8.5398105,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f331cb54-fa2b-4679-98a3-436a132ad243_photo.jpg",
      averageRating=5.0, totalRatingsCount=10,
      createdAt="2026-08-31T15:54:13.224280Z", updatedAt="2026-08-31T22:11:23.235113Z",
    ),
  )),
  CitySeo(slug="brno", name="Brno", country="CZ", clubCount=25, sports=listOf(Pair("Football", 4), Pair("Volleyball", 3), Pair("Tennis", 3), Pair("Karting", 2), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Basketball", 2), Pair("Laser Tag", 2), Pair("Climbing", 2), Pair("Paintball", 2), Pair("Golf", 1)), clubs=listOf(
    ClubDto(
      id="a29e87f7-0b71-485d-9e73-5488090390b2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="HANGAR Brno - lezecké centrum Adama Ondry", address="Pražákova 1027/53, 619 00 Brno-Brno-střed",
      city="Brno", country="CZ",
      latitude=49.1672588, longitude=16.6020229,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d3ff036a-8824-4495-85d5-ca9e1a0dc152_ChIJP9P0Xv6V_0.jpg",
      averageRating=4.8, totalRatingsCount=1117,
      createdAt="2026-08-30T22:45:45.732789Z", updatedAt="2026-08-31T08:28:53.145470Z",
    ),
    ClubDto(
      id="ff8341f5-ca71-4c53-9c06-a1e22b8ebf52", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="HUDY lezecká stěna", address="Vídeňská 297/v, 639 00 Brno-střed-Štýřice",
      city="Brno", country="CZ",
      latitude=49.173771, longitude=16.5998321,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7fd0a80-2b75-4058-97ae-d5d156a212e3_ChIJ53vX_aaV_0.jpg",
      averageRating=4.8, totalRatingsCount=969,
      createdAt="2026-08-30T22:45:52.385341Z", updatedAt="2026-08-30T22:45:52.385341Z",
    ),
    ClubDto(
      id="5afdf79c-58ef-4f37-a09f-2027edc03c9d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TENIS U LOMU", address="Střelnice, 628 00 Brno",
      city="Brno", country="CZ",
      latitude=49.2194072, longitude=16.6898266,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c6abf913-37a1-4815-8b87-eb31d67fe8cf_ChIJjXVkaB-U_0.jpg",
      averageRating=4.8, totalRatingsCount=126,
      createdAt="2026-08-30T22:46:31.920559Z", updatedAt="2026-08-31T08:37:12.505437Z",
    ),
    ClubDto(
      id="984bcc6a-d698-429e-badc-b37633d54f5b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tron Laser Aréna", address="Jugoslávská 713/5, 613 00 Brno-Brno-sever",
      city="Brno", country="CZ",
      latitude=49.2034034, longitude=16.6228949,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/55e05594-f2b2-4680-a62e-dc5db803c210_ChIJldGfOvWU_0.jpg",
      averageRating=4.8, totalRatingsCount=588,
      createdAt="2026-08-30T22:45:58.645842Z", updatedAt="2026-08-31T08:38:12.378591Z",
    ),
    ClubDto(
      id="3aea3b43-cb30-4274-8cde-78e27cd70063", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BRNO Circuit", address="Masarykův okruh 201, 664 81 Ostrovačice",
      city="Brno", country="CZ",
      latitude=49.2035779, longitude=16.4441283,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fc7edc55-02ab-4e5e-9398-18956e603bb7_photo.jpg",
      averageRating=4.7, totalRatingsCount=6020,
      createdAt="2026-08-31T15:35:47.006759Z", updatedAt="2026-08-31T15:35:47.006759Z",
    ),
    ClubDto(
      id="25706023-cb42-4e5a-8d97-42ef38599eef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Brno", address="Líšeňská 4515 /80, 636 00 Brno-Židenice",
      city="Brno", country="CZ",
      latitude=49.1968918, longitude=16.6637783,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c299df3a-42dd-4579-93de-3462790ee83d_ChIJK_0XDciU_0.jpg",
      averageRating=4.6, totalRatingsCount=3150,
      createdAt="2026-08-30T22:45:33.466852Z", updatedAt="2026-08-31T08:26:26.646952Z",
    ),
    ClubDto(
      id="5267b620-157d-4b9f-b810-07ba866254b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KŠÍROVKA FOTBALGOLF", address="K Lávce 705/8, 619 00 Brno-jih",
      city="Brno", country="CZ",
      latitude=49.1690977, longitude=16.6188546,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b64eac7-2500-480b-9c66-6bafddfd2086_photo.jpg",
      averageRating=4.6, totalRatingsCount=148,
      createdAt="2026-08-31T15:35:35.118128Z", updatedAt="2026-08-31T15:35:35.118128Z",
    ),
    ClubDto(
      id="8c5bdd30-3bae-416a-a107-ac0304ced63f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="X Arena", address="Tuřanka 55, 627 00 Brno-Slatina",
      city="Brno", country="CZ",
      latitude=49.173424, longitude=16.6834461,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cd350c83-b5fc-4b09-a421-d6b416c503af_ChIJU0Xj6tjq_0.jpg",
      averageRating=4.6, totalRatingsCount=351,
      createdAt="2026-08-30T22:45:14.073656Z", updatedAt="2026-09-01T14:31:55.832855Z",
    ),
    ClubDto(
      id="35ea5361-ee7d-4753-8b62-e607ea738380", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CITY BEACH Brno", address="49°10'57.7\"N 16°36'37, Brno 6\"E, 602 00 Brno",
      city="Brno", country="CZ",
      latitude=49.1826775, longitude=16.6104686,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/57ed3228-5bbd-445e-a53a-fc24b252718b_photo.jpg",
      averageRating=4.5, totalRatingsCount=77,
      createdAt="2026-08-31T15:35:15.802021Z", updatedAt="2026-08-31T15:35:15.802021Z",
    ),
    ClubDto(
      id="a23128b3-f893-40b0-9cc6-930fb679e8e7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Colatransport", address="18, Písníky 409, 620 00 Brno-Tuřany",
      city="Brno", country="CZ",
      latitude=49.1424354, longitude=16.6563239,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9abd1aff-b6d9-46a7-b843-0b251b5b3d1c_ChIJ08YKLa_q_0.jpg",
      averageRating=4.5, totalRatingsCount=1050,
      createdAt="2026-08-30T22:45:40.112772Z", updatedAt="2026-08-31T08:27:01.732221Z",
    ),
    ClubDto(
      id="dc7017cf-56f4-452c-9c4f-0c0a6560dcf2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Hall Brno - Husovice", address="Bří Mrštíků 1552/34, 614 00 Brno-sever-Husovice",
      city="Brno", country="CZ",
      latitude=49.2108182, longitude=16.636792,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11053ace-80e9-4d12-97a9-8036561ccf69_ChIJLW9LwSKV_0.jpg",
      averageRating=4.5, totalRatingsCount=57,
      createdAt="2026-08-30T22:46:18.319661Z", updatedAt="2026-08-30T22:46:18.319661Z",
    ),
    ClubDto(
      id="26b4c2fe-eab4-4216-a134-2cbd0944f262", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportovní areál Komec", address="Hněvkovského 630/62c, 617 00 Brno-jih",
      city="Brno", country="CZ",
      latitude=49.169882, longitude=16.6234766,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/14713707-d893-4131-ad47-2440e3aabfa1_ChIJ39ajMhGV_0.jpg",
      averageRating=4.5, totalRatingsCount=971,
      createdAt="2026-08-30T22:44:53.706475Z", updatedAt="2026-08-31T08:36:31.532023Z",
    ),
    ClubDto(
      id="1adef2e1-e6ea-446e-8704-4d81f395e7d7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenisové kurty a sauna 4hand Lužánky", address="Lidická 1875/40, Černá Pole, 602 00 Brno-Brno-střed",
      city="Brno", country="CZ",
      latitude=49.2070852, longitude=16.6053309,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/344da786-6da4-4770-b8b6-606521f6b3f3_ChIJvUr6zVyU_0.jpg",
      averageRating=4.5, totalRatingsCount=152,
      createdAt="2026-08-30T22:46:25.588143Z", updatedAt="2026-08-30T22:46:25.588143Z",
    ),
    ClubDto(
      id="92d18fd1-d840-4725-a630-e16f5044e64e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kluziště Vodova", address="Vodova 336/108, 612 00 Brno-Královo Pole",
      city="Brno", country="CZ",
      latitude=49.2264936, longitude=16.5851741,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b75eb00a-c661-47c5-b88c-830632c53784_ChIJTf4EtQaU_0.jpg",
      averageRating=4.4, totalRatingsCount=580,
      createdAt="2026-08-30T22:45:00.175474Z", updatedAt="2026-08-31T08:31:27.397854Z",
    ),
    ClubDto(
      id="fcffa6ea-97dd-4fea-b890-567b641b840a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PallSo - Paintball Brno Soběšice", address="Kociánka 91/25d, 612 00 Brno-Brno-Královo Pole",
      city="Brno", country="CZ",
      latitude=49.2413069, longitude=16.6084401,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b7d5f9e-95c5-4716-85a3-f1cea83dcc2a_ChIJJfhKhxaU_0.jpg",
      averageRating=4.4, totalRatingsCount=136,
      createdAt="2026-08-30T22:46:12.246084Z", updatedAt="2026-08-30T22:46:12.246084Z",
    ),
    ClubDto(
      id="620274c4-8ac8-4ee8-8238-ed674ea7b968", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportovní areál Káčata (KTL Brno)", address="Svratecká 449, 624 00 Brno-Komín",
      city="Brno", country="CZ",
      latitude=49.2175444, longitude=16.5506116,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b18ed3c0-2558-4ccf-9b53-b3e00492c720_photo.jpg",
      averageRating=4.4, totalRatingsCount=174,
      createdAt="2026-08-31T15:35:28.712445Z", updatedAt="2026-08-31T15:35:28.712445Z",
    ),
    ClubDto(
      id="4c6fecea-06b9-4afb-87df-517b4b727a29", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tělocvičná jednota Sokol Brno I", address="Kounicova 686/22, 602 00 Brno-střed-Veveří",
      city="Brno", country="CZ",
      latitude=49.2034326, longitude=16.6000649,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0ad909b-d868-4523-962c-8da31cc8be3e_photo.jpg",
      averageRating=4.4, totalRatingsCount=675,
      createdAt="2026-08-31T15:35:21.418882Z", updatedAt="2026-08-31T15:35:21.418882Z",
    ),
    ClubDto(
      id="2c62ef01-64b5-44a5-ae3d-ee5ae4d13b15", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CENTRUM VIKTORIA", address="2, Vodařská 232, 619 00 Brno-Brno-jih",
      city="Brno", country="CZ",
      latitude=49.1762199, longitude=16.6167926,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5f605b5d-d0a2-4032-962c-d0a33ac51563_photo.jpg",
      averageRating=4.3, totalRatingsCount=1029,
      createdAt="2026-08-31T15:35:01.890967Z", updatedAt="2026-08-31T15:35:01.890967Z",
    ),
    ClubDto(
      id="3418a8f6-7a4e-46b0-99bd-5a78e7afa129", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KART ARENA BRNO, Ltd.", address="Křížkovského 516/51, 603 00 Brno-střed-Pisárky",
      city="Brno", country="CZ",
      latitude=49.1839389, longitude=16.581838,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6889544f-5fa4-4017-9e3d-fa31098294d9_photo.jpg",
      averageRating=4.3, totalRatingsCount=1203,
      createdAt="2026-08-31T15:35:40.815346Z", updatedAt="2026-08-31T15:35:40.815346Z",
    ),
    ClubDto(
      id="9b2b8bff-ec4d-46e2-8a8b-519d92b4159e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pool Grill", address="9A, Okružní 843, 638 00 Brno-sever-Lesná",
      city="Brno", country="CZ",
      latitude=49.2229806, longitude=16.6240447,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ee1cb27d-5a32-4386-89cc-bddf4537b012_ChIJX4Sf53iU_0.jpg",
      averageRating=4.3, totalRatingsCount=399,
      createdAt="2026-08-30T22:45:26.989423Z", updatedAt="2026-08-30T22:45:26.989423Z",
    ),
    ClubDto(
      id="86957de0-dcae-4739-b344-66ddd41c9066", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TJ Tatran Bohunice z.s.", address="Neužilova 201/35, 625 00 Brno-Brno-Bohunice",
      city="Brno", country="CZ",
      latitude=49.1707812, longitude=16.5759975,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b76e08b1-6e5b-4823-b862-05763b0f5b40_ChIJC8LgSb6V_0.jpg",
      averageRating=4.3, totalRatingsCount=440,
      createdAt="2026-08-30T22:45:07.247862Z", updatedAt="2026-08-30T22:45:07.247862Z",
    ),
    ClubDto(
      id="09f45e2a-72fd-4fbf-bab8-8216895d3c51", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brio Club kulečník Brno", address="Šumavská 414/1, 602 00 Brno-Královo Pole",
      city="Brno", country="CZ",
      latitude=49.2126629, longitude=16.6007251,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2f5a66e6-8947-429d-8d9c-3bd01d13bf14_ChIJb7lOfmuU_0.jpg",
      averageRating=4.2, totalRatingsCount=406,
      createdAt="2026-08-30T22:45:20.343262Z", updatedAt="2026-08-31T08:26:34.733016Z",
    ),
    ClubDto(
      id="b49c720e-ed50-41e8-b919-35c0b69b608d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hala Morenda", address="9, Vídeňská 470, 639 00 Brno-střed-Štýřice",
      city="Brno", country="CZ",
      latitude=49.1844133, longitude=16.5961492,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a2344443-b2bf-4aa5-b2ab-1c80776419a6_photo.jpg",
      averageRating=4.2, totalRatingsCount=118,
      createdAt="2026-08-31T15:35:07.792311Z", updatedAt="2026-08-31T15:35:07.792311Z",
    ),
    ClubDto(
      id="96044463-a756-4d56-969e-400dae59daeb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Game Center Brno", address="9, Jánská 453, 602 00 Brno-střed",
      city="Brno", country="CZ",
      latitude=49.1944503, longitude=16.609621,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5d44acdb-8106-4698-b39e-486011b43b70_ChIJ-9AzOleU_0.jpg",
      averageRating=4.1, totalRatingsCount=270,
      createdAt="2026-08-30T22:46:05.305298Z", updatedAt="2026-08-31T08:28:30.813433Z",
    ),
    ClubDto(
      id="3c7ffe2b-5c12-4960-a82c-02284b7aa3a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ŽLTC Brno", address="Bubeníčkova 4248/52, 615 00 Brno-Židenice",
      city="Brno", country="CZ",
      latitude=49.2009283, longitude=16.6410499,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8aa16a80-beff-412d-b6df-eb8035bfd3f2_ChIJoXfuueyU_0.jpg",
      averageRating=4.0, totalRatingsCount=78,
      createdAt="2026-08-30T22:46:38.389398Z", updatedAt="2026-08-31T08:39:35.584956Z",
    ),
  )),
  CitySeo(slug="stuttgart", name="Stuttgart", country="DE", clubCount=25, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Padel", 3), Pair("Basketball", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Volleyball", 2), Pair("Climbing", 2), Pair("Karting", 1), Pair("Laser Tag", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="c6b1fdc3-358f-442f-8eb8-36bf9f7ab3f5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stuttgarter Golf-Club Solitude", address="Schloßfeld Obermönsheim 8, 71297 Mönsheim",
      city="Stuttgart", country="DE",
      latitude=48.854, longitude=8.8547676,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/82361b25-5af9-4a48-8418-eaea95f19dcd_photo.jpg",
      averageRating=4.8, totalRatingsCount=179,
      createdAt="2026-08-31T22:55:10.780320Z", updatedAt="2026-08-31T22:55:10.780320Z",
    ),
    ClubDto(
      id="6031ffd1-a3a0-48d5-b1c7-58704aedcd54", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CITYGOLF STUTTGART | Eventlocation | Golfübungsanlage | Adventure Minigolf", address="Wagrainstraße 136, 70378 Stuttgart-Mühlhausen",
      city="Stuttgart", country="DE",
      latitude=48.8274229, longitude=9.2162861,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/575bdd4f-0baa-4eb6-ae49-d035bf314791_photo.jpg",
      averageRating=4.7, totalRatingsCount=393,
      createdAt="2026-08-31T22:55:03.524546Z", updatedAt="2026-08-31T22:55:03.524546Z",
    ),
    ClubDto(
      id="d63af5ea-e83d-4eee-916c-eb4a1b313c3d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasertag Kornwestheim near Stuttgart", address="Enzstraße 35, 70806 Kornwestheim",
      city="Stuttgart", country="DE",
      latitude=48.86328, longitude=9.20991,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a81d68b-d2b9-44f8-b509-38ddd9eb1fb0_photo.jpg",
      averageRating=4.6, totalRatingsCount=935,
      createdAt="2026-08-31T22:55:57.891448Z", updatedAt="2026-08-31T22:55:57.891448Z",
    ),
    ClubDto(
      id="37495c87-5a7f-42c5-8571-a69e3b52a6f1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Battle Stuttgart - TSV Jahn Büsnau", address="Adolf-Engster-Weg 10, 70569 Stuttgart-Vaihingen",
      city="Stuttgart", country="DE",
      latitude=48.7484287, longitude=9.0827817,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c535cc3e-b98a-491b-854a-62f6c82b4bd9_photo.jpg",
      averageRating=4.6, totalRatingsCount=63,
      createdAt="2026-08-31T22:54:27.956446Z", updatedAt="2026-08-31T22:54:27.956446Z",
    ),
    ClubDto(
      id="25aed4c1-4280-40e3-af7a-a77299db20c7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Power Laser Lasertag Stuttgart", address="Emerholzweg 73A, 70439 Stuttgart-Stammheim",
      city="Stuttgart", country="DE",
      latitude=48.8540388, longitude=9.1381043,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1ac5bfbe-c48f-47ca-a447-afeccb083ff3_photo.jpg",
      averageRating=4.6, totalRatingsCount=714,
      createdAt="2026-08-31T22:53:51.569857Z", updatedAt="2026-08-31T22:53:51.569857Z",
    ),
    ClubDto(
      id="d84de38c-0397-4302-84dd-40c18716d161", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Turnverein Cannstatt 1846 e.V. - Kindersportschule move", address="Am Schnarrenberg 5, 70376 Stuttgart",
      city="Stuttgart", country="DE",
      latitude=48.826125, longitude=9.1982798,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cef1e03d-69cb-4a2c-835a-67680060baab_photo.jpg",
      averageRating=4.6, totalRatingsCount=71,
      createdAt="2026-08-31T22:54:56.571697Z", updatedAt="2026-08-31T22:54:56.571697Z",
    ),
    ClubDto(
      id="36d61f5d-abf6-4342-ac08-c62f94defee8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="VELS Die Boulderhalle in Stuttgart", address="Handwerkstraße 21, 70565 Stuttgart-Möhringen",
      city="Stuttgart", country="DE",
      latitude=48.71928, longitude=9.12838,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ab28785f-b4d3-49a2-ba11-51c23a25f492_photo.jpg",
      averageRating=4.6, totalRatingsCount=1982,
      createdAt="2026-08-31T22:55:39.174393Z", updatedAt="2026-08-31T22:55:39.174393Z",
    ),
    ClubDto(
      id="898b7faf-c9eb-42b9-9b68-36b1ea852af8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kart-o-Mania Stuttgart", address="Langwiesenweg 30, 70327 Stuttgart-Wangen",
      city="Stuttgart", country="DE",
      latitude=48.782292, longitude=9.2331029,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/565c229e-4d21-4f51-8d61-d12309c3cf0c_photo.jpg",
      averageRating=4.5, totalRatingsCount=1894,
      createdAt="2026-08-31T22:55:22.168224Z", updatedAt="2026-08-31T22:55:22.168224Z",
    ),
    ClubDto(
      id="d9026c9d-9c8a-4f52-92b1-4e636877fa5e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MHPArena", address="Mercedesstraße 87, 70372 Stuttgart",
      city="Stuttgart", country="DE",
      latitude=48.7922577, longitude=9.23208,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2805edac-2977-44bd-8944-7b60f1ce2f7b_photo.jpg",
      averageRating=4.5, totalRatingsCount=16061,
      createdAt="2026-08-31T22:53:40.567272Z", updatedAt="2026-08-31T22:53:40.567272Z",
    ),
    ClubDto(
      id="1178efb1-1cf1-437b-8786-313cd3b4b36f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Soccer Arena Sindelfingen", address="Schwertstraße 5, 71065 Sindelfingen",
      city="Stuttgart", country="DE",
      latitude=48.7048429, longitude=9.0160811,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e90f41c0-80c4-4348-8c05-39e5ed8ac10d_photo.jpg",
      averageRating=4.5, totalRatingsCount=880,
      createdAt="2026-08-31T22:53:46.155061Z", updatedAt="2026-08-31T22:53:46.155061Z",
    ),
    ClubDto(
      id="024137cb-f4ac-4250-b535-55da981154f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TC Blau-Weiss Vaihingen-Rohr", address="Heßbrühlstraße 64, 70565 Stuttgart-Vaihingen",
      city="Stuttgart", country="DE",
      latitude=48.722226, longitude=9.1188672,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd1f2c32-5ad1-4373-8415-c6ba014f6901_photo.jpg",
      averageRating=4.5, totalRatingsCount=155,
      createdAt="2026-08-31T22:54:23.267894Z", updatedAt="2026-08-31T22:54:23.267894Z",
    ),
    ClubDto(
      id="34335064-8a6c-4686-866b-9fb64c11352b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club Weissenhof", address="Parlerstraße 102, 70192 Nord",
      city="Stuttgart", country="DE",
      latitude=48.7965106, longitude=9.1703333,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a752edb0-59db-4ede-9787-aecaee036dfe_photo.jpg",
      averageRating=4.5, totalRatingsCount=365,
      createdAt="2026-08-31T22:54:13.356944Z", updatedAt="2026-09-01T14:31:47.279385Z",
    ),
    ClubDto(
      id="71279436-2ad2-4255-86af-95c9f126aa7a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="match center Erlebniswelt", address="Mahlestraße 70, 70794 Filderstadt-Bonlanden",
      city="Stuttgart", country="DE",
      latitude=48.6509165, longitude=9.2045775,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/584495bd-5da3-4bfc-962f-9ba169f610ac_photo.jpg",
      averageRating=4.5, totalRatingsCount=274,
      createdAt="2026-08-31T22:54:18.688761Z", updatedAt="2026-08-31T22:54:18.688761Z",
    ),
    ClubDto(
      id="cd2e7d2a-9e7f-4e3e-9374-969382eb7501", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="rockerei", address="Stammheimer Str. 41, 70435 Stuttgart-Zuffenhausen",
      city="Stuttgart", country="DE",
      latitude=48.8343823, longitude=9.1638089,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/745134f9-9b89-4567-ae90-8f1d4ead24a0_photo.jpg",
      averageRating=4.5, totalRatingsCount=974,
      createdAt="2026-08-31T22:55:53.182601Z", updatedAt="2026-08-31T22:55:53.182601Z",
    ),
    ClubDto(
      id="061f7b15-27ac-41c8-9cb7-ab439b58dbef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MTV Stuttgart 1843 e.V.", address="Am Kräherwald 190A, 70193 Stuttgart",
      city="Stuttgart", country="DE",
      latitude=48.78521, longitude=9.14383,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/19849384-f59d-4a89-897d-916ae3c7e9fd_photo.jpg",
      averageRating=4.4, totalRatingsCount=422,
      createdAt="2026-08-31T22:54:07.759127Z", updatedAt="2026-08-31T22:54:07.759127Z",
    ),
    ClubDto(
      id="eba17dbe-80d9-4be3-96b3-cf6ef75328bd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="VfL-Stuttgart Vereinsgelände", address="Benzstraße 151, 70372 Stuttgart-Bad Cannstatt",
      city="Stuttgart", country="DE",
      latitude=48.7942525, longitude=9.2326417,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e2ecbab5-8099-4748-bcfb-3e8f57949b6c_photo.jpg",
      averageRating=4.4, totalRatingsCount=196,
      createdAt="2026-08-31T22:54:51.355196Z", updatedAt="2026-08-31T22:54:51.355196Z",
    ),
    ClubDto(
      id="e38c97ff-60dc-4a96-ab62-b60ffff0d6ce", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportverein Vaihingen 1889 e.V.", address="Dürrlewangstraße 70, 70565 Stuttgart-Vaihingen",
      city="Stuttgart", country="DE",
      latitude=48.7218462, longitude=9.1117313,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d0bb1c73-5420-4caf-9f2b-2e18c1ce48a5_photo.jpg",
      averageRating=4.3, totalRatingsCount=111,
      createdAt="2026-08-31T22:53:56.249248Z", updatedAt="2026-08-31T22:53:56.249248Z",
    ),
    ClubDto(
      id="01e5ef48-41d0-4229-af1e-8daf4d750804", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Arena Stuttgart", address="Am Sportpark 9, 70469 Stuttgart",
      city="Stuttgart", country="DE",
      latitude=48.8102458, longitude=9.1405071,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b3444df4-a1fc-4298-b23a-cf0da19235eb_photo.jpg",
      averageRating=4.2, totalRatingsCount=1454,
      createdAt="2026-08-31T22:55:34.805797Z", updatedAt="2026-08-31T22:55:34.805797Z",
    ),
    ClubDto(
      id="ee446109-6dff-4b4b-b30d-27a25d9f932c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Association Feuerbach 1883 eV.", address="Vereins-Servicezentrum, Triebweg 85, 70469 Stuttgart",
      city="Stuttgart", country="DE",
      latitude=48.8082635, longitude=9.1413893,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d3815e95-f1fd-4736-b656-6040b1208088_photo.jpg",
      averageRating=4.2, totalRatingsCount=82,
      createdAt="2026-08-31T22:54:02.302907Z", updatedAt="2026-08-31T22:54:02.302907Z",
    ),
    ClubDto(
      id="ca6a7204-4e84-4fa5-9e8f-c5daaf1f2ca6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dream-Bowl Fellbach", address="Bühlstraße 140, 70736 Fellbach",
      city="Stuttgart", country="DE",
      latitude=48.8173737, longitude=9.2855113,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6426d74c-4d66-4e34-b180-72b4058ebc63_photo.jpg",
      averageRating=3.8, totalRatingsCount=2495,
      createdAt="2026-08-31T22:55:27.039830Z", updatedAt="2026-08-31T22:55:27.039830Z",
    ),
    ClubDto(
      id="6df11d12-2371-4a03-accc-f815f6a9ce92", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporthalle Bebelstraße (Hasenbergschule)", address="Bebelstraße 24, 70193 Stuttgart-West",
      city="Stuttgart", country="DE",
      latitude=48.7757323, longitude=9.1545713,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/60e1c1d4-d513-4cad-990e-72c4ab5914d8_photo.jpg",
      averageRating=3.5, totalRatingsCount=82,
      createdAt="2026-08-31T22:54:42.231469Z", updatedAt="2026-08-31T22:54:42.231469Z",
    ),
    ClubDto(
      id="f7bce407-29e6-41aa-bfc0-1d26d4e5f91c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Top Padel Stuttgart", address="Schönbergstraße 38, 73760 Ostfildern",
      city="Stuttgart", country="DE",
      latitude=48.7248055, longitude=9.2227471,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d88f0dd1-a46f-4b98-8884-708b10aeb73d_photo.jpg",
      averageRating=4.6, totalRatingsCount=24,
      createdAt="2026-08-31T22:54:33.206821Z", updatedAt="2026-08-31T22:54:33.206821Z",
    ),
    ClubDto(
      id="aaa3df0d-bb51-4b20-bcf6-03e18541b7b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Club Esslingen", address="Weilstraße 199, 73733 Esslingen am Neckar",
      city="Stuttgart", country="DE",
      latitude=48.7379314, longitude=9.2768293,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e63a3afa-a014-4588-ac3d-6c7e5c96c729_photo.jpg",
      averageRating=4.6, totalRatingsCount=16,
      createdAt="2026-08-31T22:54:38.149605Z", updatedAt="2026-08-31T22:54:38.149605Z",
    ),
    ClubDto(
      id="1a67f6cc-0b89-4843-9bcd-c6d340470848", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SV Böblingen Tischtennis", address="Silberweg 20, 71032 Böblingen",
      city="Stuttgart", country="DE",
      latitude=48.6952067, longitude=9.0228251,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e434c2eb-8ddc-49eb-8699-89d2bccaf831_photo.jpg",
      averageRating=4.9, totalRatingsCount=15,
      createdAt="2026-08-31T22:55:16.984848Z", updatedAt="2026-08-31T22:55:16.984848Z",
    ),
    ClubDto(
      id="f4c1e819-f6cd-498b-9663-7beb209a38f2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketball Court", address="Marienplatz, 70178 Stuttgart",
      city="Stuttgart", country="DE",
      latitude=48.7642705, longitude=9.1689867,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3fd61c9d-637e-4510-8dfa-805c27f6c3d6_photo.jpg",
      averageRating=3.6, totalRatingsCount=13,
      createdAt="2026-08-31T22:54:47.088164Z", updatedAt="2026-08-31T22:54:47.088164Z",
    ),
  )),
  CitySeo(slug="riga", name="Riga", country="LV", clubCount=25, sports=listOf(Pair("Volleyball", 5), Pair("Football", 3), Pair("Tennis", 3), Pair("Karting", 2), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Paintball", 2), Pair("Basketball", 2)), clubs=listOf(
    ClubDto(
      id="fc6e207b-d8d6-4306-90b8-6f9d3cb4b0af", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GUNSnLASERS", address="Mārkalnes iela 10, Vidzemes priekšpilsēta, Rīga, LV-1024",
      city="Riga", country="LV",
      latitude=56.9909207, longitude=24.2276921,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c3a42465-bb7c-4483-81c4-7f65c6a2d855_ChIJRx2sV73O_1.jpg",
      averageRating=4.9, totalRatingsCount=2349,
      createdAt="2026-08-30T23:21:51.816821Z", updatedAt="2026-08-31T22:11:16.998543Z",
    ),
    ClubDto(
      id="d29f5a61-4c32-430f-8373-5a7a339ff05a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GUNSnLASERS Šampēteris", address="Šampētera iela 1, Zemgales priekšpilsēta, Rīga, LV-1046",
      city="Riga", country="LV",
      latitude=56.9426279, longitude=24.0432272,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9898e1f1-4c66-4f35-acfa-aad317e9911e_ChIJB77lBOvP_0.jpg",
      averageRating=4.9, totalRatingsCount=919,
      createdAt="2026-08-30T23:21:58.299037Z", updatedAt="2026-08-31T08:28:30.275300Z",
    ),
    ClubDto(
      id="bb46bdae-1453-4060-8e46-b3858b008860", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Players Club XL", address="Jēkaba iela 3-5, Centra rajons, Rīga, LV-1050",
      city="Riga", country="LV",
      latitude=56.9503066, longitude=24.1051075,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b3521f7-b93a-4e26-8915-3f4902a3f0ed_ChIJu7mwewDP_0.jpg",
      averageRating=4.9, totalRatingsCount=899,
      createdAt="2026-08-30T23:21:11.385804Z", updatedAt="2026-08-31T08:34:46.076473Z",
    ),
    ClubDto(
      id="112077c0-425d-4ada-9497-cf944bee9d58", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Falkors, Boulderinga centrs", address="Ūnijas iela 14, Vidzemes priekšpilsēta, Rīga, LV-1084",
      city="Riga", country="LV",
      latitude=56.9685955, longitude=24.1662817,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/afccfcc0-21cf-43a0-a156-a0ba581c957f_ChIJm3naTlDO_0.jpg",
      averageRating=4.8, totalRatingsCount=367,
      createdAt="2026-08-30T23:21:31.859032Z", updatedAt="2026-08-31T08:27:46.974538Z",
    ),
    ClubDto(
      id="329eecad-fdda-4190-96c4-e8919f22a293", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GUNSnLASERS Mežaparks", address="Viestura prospekts 2, Ziemeļu rajons, Rīga, LV-1005",
      city="Riga", country="LV",
      latitude=57.0067645, longitude=24.1306622,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2dcd6a2e-4f94-441f-b873-3324a3205116_ChIJ3xuivmvP_0.jpg",
      averageRating=4.8, totalRatingsCount=439,
      createdAt="2026-08-30T23:22:05.355987Z", updatedAt="2026-08-31T08:28:28.047764Z",
    ),
    ClubDto(
      id="9212a9f6-7d5e-4913-9733-752f7d128e0f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="O-Sands pludmales volejbols", address="Grostonas iela 6b, Vidzemes priekšpilsēta, Rīga, LV-1013",
      city="Riga", country="LV",
      latitude=56.967678, longitude=24.1248092,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc87083f-58e8-43ec-98ed-f207c2763130_photo.jpg",
      averageRating=4.8, totalRatingsCount=68,
      createdAt="2026-08-31T15:22:51.962981Z", updatedAt="2026-08-31T15:22:51.962981Z",
    ),
    ClubDto(
      id="c719b7cf-6abf-49e2-9993-096158198ef9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Peintbols un Lāzertags PIF PAF", address="\"Lielas lapas\", Salaspils LT, Rīga, LV-2117",
      city="Riga", country="LV",
      latitude=56.855108, longitude=24.421137,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd2cff2a-fa54-4317-bfec-91593d0ebc67_ChIJ18BgAMIt_0.jpg",
      averageRating=4.8, totalRatingsCount=260,
      createdAt="2026-08-30T23:22:11.336823Z", updatedAt="2026-08-31T08:34:37.552269Z",
    ),
    ClubDto(
      id="fc70f750-64f2-4369-8043-c60e429f6349", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SQUAD Hour", address="Gustava Zemgala gat. 74-k-1, Vidzemes priekšpilsēta, Rīga, LV-1039",
      city="Riga", country="LV",
      latitude=56.9759206, longitude=24.1655914,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3fe9782b-023e-45d4-a6f3-4bdf254a92a0_ChIJqzuR4lbO_0.jpg",
      averageRating=4.8, totalRatingsCount=130,
      createdAt="2026-08-30T23:21:38.402960Z", updatedAt="2026-08-30T23:21:38.402960Z",
    ),
    ClubDto(
      id="2c48a5f9-051a-4589-ad18-44893a851db4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Biķernieku trase", address="Sergeja Eizenšteina iela 4, Vidzemes priekšpilsēta, Rīga, LV-1079",
      city="Riga", country="LV",
      latitude=56.9638536, longitude=24.2297683,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e5e8338-dd69-4f9b-97de-52e4caaf98ed_ChIJfdsH_dPN_0.jpg",
      averageRating=4.7, totalRatingsCount=4241,
      createdAt="2026-08-30T23:21:44.970140Z", updatedAt="2026-08-30T23:21:44.970140Z",
    ),
    ClubDto(
      id="184b183f-a80d-440b-9802-735725bb2f3c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centra sporta kvartāls", address="Krišjāņa Barona iela 116A, Latgales priekšpilsēta, Rīga, LV-1012",
      city="Riga", country="LV",
      latitude=56.9616848, longitude=24.1433372,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/94f78854-d7bb-41e3-b3c5-2abbdcd5a204_ChIJHfI1aUrO_0.jpg",
      averageRating=4.7, totalRatingsCount=2174,
      createdAt="2026-08-30T23:20:56.761423Z", updatedAt="2026-08-30T23:20:56.761423Z",
    ),
    ClubDto(
      id="bf16916a-f08c-47e5-b6fd-86abbde40bac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenisa klubs ENRI", address="Vaidavas iela 4, Vidzemes priekšpilsēta, Rīga, LV-1084",
      city="Riga", country="LV",
      latitude=56.9638017, longitude=24.1744434,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4e4918e4-2e39-4037-a943-92b5ef6a0153_ChIJO1mA5ELO_0.jpg",
      averageRating=4.7, totalRatingsCount=96,
      createdAt="2026-08-30T23:22:31.372680Z", updatedAt="2026-08-31T08:37:27.766773Z",
    ),
    ClubDto(
      id="afbb93e6-0bc8-4316-aa47-6f28477abb19", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lucavsalas atpūtas parks", address="Zemgales priekšpilsēta, Rīga, LV-1004",
      city="Riga", country="LV",
      latitude=56.9302778, longitude=24.1116667,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7218651-4ed8-4955-ae7c-cf0c844d7ab5_ChIJ21CjkM3R_0.jpg",
      averageRating=4.6, totalRatingsCount=6138,
      createdAt="2026-08-30T23:20:43.945210Z", updatedAt="2026-08-30T23:20:43.945210Z",
    ),
    ClubDto(
      id="06d6b9e4-97bf-4c3f-8b5f-c16d6490d844", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palms Beach Club", address="Mūkupurva iela 1C, Zemgales priekšpilsēta, Rīga, LV-1029",
      city="Riga", country="LV",
      latitude=56.9310269, longitude=24.005024,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99b3767c-62a9-4fcf-9c9f-0cee1ed6f475_photo.jpg",
      averageRating=4.6, totalRatingsCount=197,
      createdAt="2026-08-31T15:23:07.350406Z", updatedAt="2026-08-31T15:23:07.350406Z",
    ),
    ClubDto(
      id="7ee5d9f5-5a39-4828-b407-3c43ecccb97e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenisa centrs \"Rimi\"", address="Kārļa Ulmaņa gatve 150, Zemgales priekšpilsēta, Rīga, LV-1029",
      city="Riga", country="LV",
      latitude=56.9471281, longitude=23.9929894,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f7a5fcd9-e8cb-4519-895f-df96932dcbfe_ChIJbZmgk8Da_0.jpg",
      averageRating=4.6, totalRatingsCount=74,
      createdAt="2026-08-30T23:22:38.536Z", updatedAt="2026-08-30T23:22:38.536Z",
    ),
    ClubDto(
      id="5aa94a81-db39-4391-beeb-c2e1eb53ea71", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Box", address="Brīvības gat. 197B, Vidzemes priekšpilsēta, Rīga, LV-1039",
      city="Riga", country="LV",
      latitude=56.9711603, longitude=24.1586691,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/efeeabda-75f2-4c31-93a0-e54cb79b30b1_photo.jpg",
      averageRating=4.5, totalRatingsCount=210,
      createdAt="2026-08-31T15:22:43.049471Z", updatedAt="2026-08-31T15:22:43.049471Z",
    ),
    ClubDto(
      id="be62208b-dd54-4073-ae38-c7b882cf5af0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ENRI, Tenisa korti", address="Stirnu iela 34A, Vidzemes priekšpilsēta, Rīga, LV-1084",
      city="Riga", country="LV",
      latitude=56.960192, longitude=24.1888687,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/52a694fc-f802-439b-87c9-4e20668edd4b_ChIJ3yqjIW_O_1.jpg",
      averageRating=4.5, totalRatingsCount=228,
      createdAt="2026-08-30T23:22:24.787462Z", updatedAt="2026-08-31T22:11:15.959329Z",
    ),
    ClubDto(
      id="159486dc-f568-4b39-a6dc-2a3c257697a9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Skyline", address="Elizabetes iela 55, Centra rajons, Rīga, LV-1010",
      city="Riga", country="LV",
      latitude=56.9549827, longitude=24.1179294,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b8602be3-17ba-47ba-8bb9-a4ed5528b641_ChIJT_GkCM7P_0.jpg",
      averageRating=4.5, totalRatingsCount=6379,
      createdAt="2026-08-30T23:20:37.616177Z", updatedAt="2026-08-31T08:36:08.677210Z",
    ),
    ClubDto(
      id="861b813d-38e4-43ac-a235-3eda62cfb696", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pepsi, boulinga un skvoša centrs", address="Uzvaras bulvāris 10, Zemgales priekšpilsēta, Rīga, LV-1048",
      city="Riga", country="LV",
      latitude=56.939059, longitude=24.0909,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b8e11bb2-e66e-47ca-ae57-03ffef3dda0c_ChIJe3HbOCXQ_1.jpg",
      averageRating=4.3, totalRatingsCount=2941,
      createdAt="2026-08-30T23:21:18.401346Z", updatedAt="2026-08-31T22:11:20.254089Z",
    ),
    ClubDto(
      id="dbb9212a-3e4d-4383-a774-2616ed13885c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="NB, biljarda klubs", address="Šķūņu iela 9, Centra rajons, Rīga, LV-1050",
      city="Riga", country="LV",
      latitude=56.9489789, longitude=24.1075639,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f41d78c9-44fb-4814-8951-7f2f6346c2ae_ChIJt53-J9fP_0.jpg",
      averageRating=4.2, totalRatingsCount=1347,
      createdAt="2026-08-30T23:21:03.568562Z", updatedAt="2026-08-30T23:21:03.568562Z",
    ),
    ClubDto(
      id="2ab2ae71-00fc-4039-8b35-878ead85adc6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="O'Learys", address="Latgales iela 257, Latgales priekšpilsēta, Rīga, LV-1019",
      city="Riga", country="LV",
      latitude=56.9247113, longitude=24.1752253,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/521d000d-4cfe-4235-9c3d-b1f0b2f6a922_ChIJBSeAM-jN_0.jpg",
      averageRating=4.2, totalRatingsCount=1669,
      createdAt="2026-08-30T23:21:24.941251Z", updatedAt="2026-08-30T23:21:24.941251Z",
    ),
    ClubDto(
      id="5cc9497c-136f-44d3-a3bb-596acf8b1f44", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mežaparks Sports Village, atpūtas komplekss", address="Ezermalas iela 30, Ziemeļu rajons, Rīga, LV-1014",
      city="Riga", country="LV",
      latitude=57.0026505, longitude=24.1712446,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2f3b3bdc-ca41-42e6-b072-668a8e9ac693_photo.jpg",
      averageRating=4.0, totalRatingsCount=1074,
      createdAt="2026-08-31T15:23:00.775256Z", updatedAt="2026-08-31T15:23:00.775256Z",
    ),
    ClubDto(
      id="48c61b2b-7795-47da-b9b7-87c502f1da3c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ProBaller Arena", address="Ulmaņa Parks II, Kalniņi, Mārupes pagasts, Mārupes novads, LV-2167",
      city="Riga", country="LV",
      latitude=56.9275853, longitude=24.0134004,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7d75b289-6f28-48f5-a918-b1b1bb6a71e5_photo.png",
      averageRating=4.9, totalRatingsCount=34,
      createdAt="2026-08-31T15:22:35.817741Z", updatedAt="2026-08-31T15:22:35.817741Z",
    ),
    ClubDto(
      id="146c11e8-ae10-48fa-af76-5caa5056ef3a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Speedsoft Arena", address="Dzērvju iela 8, Latgales priekšpilsēta, Rīga, LV-1019",
      city="Riga", country="LV",
      latitude=56.9306476, longitude=24.1673511,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5b36de9-927d-473d-b9e5-d2032426d62e_ChIJVak6cOLP_0.jpg",
      averageRating=5.0, totalRatingsCount=29,
      createdAt="2026-08-30T23:22:17.832536Z", updatedAt="2026-08-30T23:22:17.832536Z",
    ),
    ClubDto(
      id="c2cbc1c5-3f7d-485a-9ab9-e94f36642302", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="“Depo sports” sporta zāle", address="Jūrkalnes iela 1, Zemgales priekšpilsēta, Rīga, LV-1046",
      city="Riga", country="LV",
      latitude=56.9457903, longitude=24.0390435,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/56d25f19-223c-4b22-a764-8b60f69bbac1_photo.jpg",
      averageRating=4.7, totalRatingsCount=19,
      createdAt="2026-08-31T15:22:27.915264Z", updatedAt="2026-08-31T15:22:27.915264Z",
    ),
    ClubDto(
      id="71e14952-6727-4615-8fc1-9d215ea78030", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="O-sands outdoor beach volleyball courts", address="Skanstes iela 16, Vidzemes priekšpilsēta, Rīga, LV-1045",
      city="Riga", country="LV",
      latitude=56.9711003, longitude=24.119856,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/45bf577f-c58f-4f24-b218-c65e747ed0c9_photo.jpg",
      averageRating=4.0, totalRatingsCount=5,
      createdAt="2026-08-31T15:23:14.665771Z", updatedAt="2026-08-31T15:23:14.665771Z",
    ),
  )),
  CitySeo(slug="wroclaw", name="Wroclaw", country="PL", clubCount=25, sports=listOf(Pair("Volleyball", 4), Pair("Football", 4), Pair("Tennis", 3), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Karting", 2), Pair("Billiards", 2), Pair("Basketball", 2), Pair("Golf", 1), Pair("Paintball", 1), Pair("Padel", 1), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="492f2963-7c7c-4929-902c-ebcc77d8e6aa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="NP Tennis Academy", address="Lotnicza 72, 54-155 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1317169, longitude=16.9595958,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d839548f-bd8f-4d1d-926a-f9893bcad861_ChIJ4xP2rzvr_0.jpg",
      averageRating=5.0, totalRatingsCount=278,
      createdAt="2026-08-30T21:32:18.783384Z", updatedAt="2026-08-30T21:58:44.373482Z",
    ),
    ClubDto(
      id="6d421451-3d8f-43b5-a094-17d31cbcc86a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CityPaintball", address="Ignacego Jana Paderewskiego 35, 51-611 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1158244, longitude=17.0988102,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/18806ce4-a2b3-4eb3-a2e5-ec389ed20b32_ChIJVyMpSDzo_0.jpg",
      averageRating=4.9, totalRatingsCount=1362,
      createdAt="2026-08-30T21:31:40.783208Z", updatedAt="2026-08-30T21:31:40.783208Z",
    ),
    ClubDto(
      id="8d77c041-7809-48ce-a051-97be7eaeb62b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pitlane Gokarty Wrocław - Tor Kartingowy Wroclavia track carts", address="Wroclavia Poziom -2, Sucha 1, 50-086 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.0964484, longitude=17.0348373,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8f964b28-2960-4891-9f62-d237bca6419a_ChIJnzKgN_XD_0.jpg",
      averageRating=4.9, totalRatingsCount=4779,
      createdAt="2026-08-30T21:31:12.004202Z", updatedAt="2026-08-30T21:59:33.946945Z",
    ),
    ClubDto(
      id="7fccc72b-ca31-4c6d-971b-0475409a35e6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centrum Piłkarskie Ślęza Wrocław - Kłokoczyce", address="Kłokoczycka 5, 51-376 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1521712, longitude=17.1127822,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a2bf3514-fbc5-48bb-9f23-00064ace7a43_ChIJJ4jGn_bp_0.jpg",
      averageRating=4.8, totalRatingsCount=669,
      createdAt="2026-08-30T21:30:14.710356Z", updatedAt="2026-09-01T14:31:58.364990Z",
    ),
    ClubDto(
      id="936216f5-70cb-4e64-8b73-ac8626bcf08c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kwatera Główna Centrum Laser Tag - Wystrzałowa Zabawa!", address="Henryka Sienkiewicza 8A, 50-335 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1183254, longitude=17.0440019,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/56a35f05-8428-4b9b-9465-d3a5d0da74b7_ChIJGcCFU9rp_0.jpg",
      averageRating=4.8, totalRatingsCount=796,
      createdAt="2026-08-30T21:31:26.618094Z", updatedAt="2026-08-30T21:57:40.865576Z",
    ),
    ClubDto(
      id="14807ffb-3c88-45bd-b9f1-59342985a1e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel PL", address="Żmigrodzka 242D, 51-131 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1606711, longitude=17.0234629,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/222586bc-accc-4406-a6b4-0f4fe7c5dbd4_ChIJddho_aTr_0.jpg",
      averageRating=4.8, totalRatingsCount=219,
      createdAt="2026-08-30T21:31:56.024204Z", updatedAt="2026-08-30T21:59:03.807340Z",
    ),
    ClubDto(
      id="2766e839-8ef1-4676-905b-353d9ff1ff02", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zagrywki", address="Wojciecha Bogusławskiego 16, 50-529 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1000198, longitude=17.0300468,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eb3d1a24-2864-4068-a69f-e3b59679a2c0_ChIJG0urwo7D_0.jpg",
      averageRating=4.8, totalRatingsCount=3570,
      createdAt="2026-08-30T21:30:43.137408Z", updatedAt="2026-08-30T22:02:28.732069Z",
    ),
    ClubDto(
      id="fa4259e0-aeb7-4917-95e9-6d8d3240931a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centrum Wspinaczkowe Tarnogaj", address="Nyska 59, wjazd od, Otmuchowska 15, 50-505 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.0865602, longitude=17.0512932,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/13360f5c-f6ba-4384-8a02-d68ca237e564_ChIJH05BofTC_0.jpg",
      averageRating=4.7, totalRatingsCount=1001,
      createdAt="2026-08-30T21:30:57.127386Z", updatedAt="2026-08-30T21:30:57.127386Z",
    ),
    ClubDto(
      id="b114455d-8477-4a64-90a8-77639f68cfcb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="WKK Sport Center", address="Czajcza 19, 51-422 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1313347, longitude=17.0954849,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3435d6c4-11ec-4434-8400-58426d63eb74_photo.jpg",
      averageRating=4.7, totalRatingsCount=522,
      createdAt="2026-08-31T15:25:28.544284Z", updatedAt="2026-08-31T15:25:28.544284Z",
    ),
    ClubDto(
      id="d39eb056-cc68-4b83-8ddb-7dcf28c053db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ścianka Wspinaczkowa FPINKA", address="Jana Długosza 57, 51-162 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1357027, longitude=17.0670257,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a6bb9078-1585-4712-ac23-026ce76f1f0b_ChIJ5TvI_WrC_0.jpg",
      averageRating=4.7, totalRatingsCount=764,
      createdAt="2026-08-30T21:31:04.917442Z", updatedAt="2026-08-30T21:31:04.917442Z",
    ),
    ClubDto(
      id="f225f2d5-0a57-4dc5-b5bd-5c002f715b82", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centrum Tenisowe Redeco", address="al. Generała Józefa Hallera 81A, 53-325 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.0906021, longitude=16.9972528,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/363a46b0-591e-4602-ae9e-5eab128ae68a_ChIJ85rynyTC_0.jpg",
      averageRating=4.6, totalRatingsCount=325,
      createdAt="2026-08-30T21:32:10.493154Z", updatedAt="2026-08-30T21:32:10.493154Z",
    ),
    ClubDto(
      id="664fcb29-55e6-44ed-8ca1-ffc07917c501", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Golf", address="Parking City Golf, Rodzinne Centrum Golfa, Grabiszyńska 346, 53-235 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.0831575, longitude=16.9755341,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c021cdcc-e14b-4457-8b53-b88541110fed_photo.jpg",
      averageRating=4.6, totalRatingsCount=214,
      createdAt="2026-08-31T15:26:17.128086Z", updatedAt="2026-08-31T15:26:17.128086Z",
    ),
    ClubDto(
      id="8364017a-1c4e-4f85-a77d-0c873de840d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Match Point Sp.", address="Szyszkowa 6, 55-040 Ślęza",
      city="Wroclaw", country="PL",
      latitude=51.0407892, longitude=16.9854707,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e15724e6-ab3e-44fd-8ec7-2acfb2885c3c_photo.jpg",
      averageRating=4.6, totalRatingsCount=703,
      createdAt="2026-08-31T15:25:51.586114Z", updatedAt="2026-08-31T15:25:51.586114Z",
    ),
    ClubDto(
      id="f12d79db-67cb-4a8c-ae0d-6961673bb48d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Młodzieżowe Centrum Sportu Wrocław", address="al Ignacego Jana Paderewskiego 35/9, 51-612 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1183212, longitude=17.0968334,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/92fb4d64-15d6-4c04-8c88-73fd38980d2b_photo.jpg",
      averageRating=4.6, totalRatingsCount=1778,
      createdAt="2026-08-31T15:25:57.487709Z", updatedAt="2026-08-31T15:25:57.487709Z",
    ),
    ClubDto(
      id="9c134b3c-c69e-4964-ad24-1294d73218e8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Śląsk Wrocław Basketball S.A. 18-krotny mistrz Polski", address="Mieszczańska 4, 50-201 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1174057, longitude=17.0240559,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f81eb702-635f-42db-bb33-d69300cda99b_photo.jpg",
      averageRating=4.6, totalRatingsCount=139,
      createdAt="2026-08-31T15:25:36.447592Z", updatedAt="2026-08-31T15:25:36.447592Z",
    ),
    ClubDto(
      id="91e53f3b-44e6-47a9-be44-bbb99191cff5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GEM Boiska", address="Józefa Mianowskiego 2B, 51-605 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1266009, longitude=17.0707583,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d66eed3-5206-41ff-a7fb-1c88de02bb4c_ChIJxwI1QTXo_0.jpg",
      averageRating=4.5, totalRatingsCount=198,
      createdAt="2026-08-30T21:30:28.639483Z", updatedAt="2026-08-30T21:57:00.433827Z",
    ),
    ClubDto(
      id="936108bb-c3e2-4763-93a6-51b48a04a1be", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hala Orbita", address="Wejherowska 34, 54-239 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1324712, longitude=16.9870748,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/81a30fce-806a-4186-8c8d-04d40f004b28_photo.jpg",
      averageRating=4.5, totalRatingsCount=2277,
      createdAt="2026-08-31T15:25:43.681820Z", updatedAt="2026-08-31T15:25:43.681820Z",
    ),
    ClubDto(
      id="c465ac82-4ed6-4239-a07f-2855f0843189", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zona 71", address="Robotnicza 1a, 53-607 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1089478, longitude=17.0165672,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7dc87e97-040d-403f-a6c4-e1876db0e3bf_ChIJS6hWTfrB_0.jpg",
      averageRating=4.5, totalRatingsCount=737,
      createdAt="2026-08-30T21:31:33.779340Z", updatedAt="2026-08-30T22:02:31.947975Z",
    ),
    ClubDto(
      id="903eb501-e46d-4b77-a0ee-1fc1f5e43884", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centrum Treningowe LUBIŃSKA - WCT Spartan", address="Lubińska 53, 53-623 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1188672, longitude=17.0062653,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c3fbffef-af4f-4d65-8caa-0b445623003d_ChIJwaIf8f7p_0.jpg",
      averageRating=4.4, totalRatingsCount=1786,
      createdAt="2026-08-30T21:30:07.380129Z", updatedAt="2026-09-01T14:31:58.501817Z",
    ),
    ClubDto(
      id="e5e9a76e-ef4e-40b1-a24f-521336024e82", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Korty Morskie Oko", address="Fryderyka Chopina 27, 51-609 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1250989, longitude=17.0852286,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dea041ec-876b-4978-a857-52e7aaa400e1_ChIJ71NEpXXC_3.jpg",
      averageRating=4.4, totalRatingsCount=453,
      createdAt="2026-08-30T21:32:03.137265Z", updatedAt="2026-08-31T22:11:18.294274Z",
    ),
    ClubDto(
      id="d51f8714-a605-4255-99ab-6644fd96d9df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kosmos Arena", address="Mieroszowska 2, 54-034 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1425631, longitude=16.8968815,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d9bf272-fa24-44c4-b30a-97ade8ca17cd_ChIJl_49fKLr_0.jpg",
      averageRating=4.4, totalRatingsCount=281,
      createdAt="2026-08-30T21:30:21.501908Z", updatedAt="2026-08-30T21:57:39.212876Z",
    ),
    ClubDto(
      id="d15de493-2c86-476e-8b66-8fd5e68fd3d6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Le Mans Wrocław Tor Kartingowy", address="al. Śląska 1, 54-118 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1427373, longitude=16.943518,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7f8ee08-9c63-42b9-be79-b4698d7d8c03_ChIJc2AUXIzq_0.jpg",
      averageRating=4.4, totalRatingsCount=3381,
      createdAt="2026-08-30T21:31:20.218309Z", updatedAt="2026-08-30T21:31:20.218309Z",
    ),
    ClubDto(
      id="91552cfb-39e8-453c-8f8b-70452cdb587a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PRL - klubokawiarnia", address="Rynek Ratusz 10, 50-106 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1106182, longitude=17.0318452,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ab357b63-2a43-42a6-9c23-c00ff5366ffc_ChIJjw67oXXC_0.jpg",
      averageRating=4.2, totalRatingsCount=4583,
      createdAt="2026-08-30T21:30:35.817359Z", updatedAt="2026-08-30T21:30:35.817359Z",
    ),
    ClubDto(
      id="58ebd289-fc9d-4b8a-b52f-27ac56aeb9fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sky Bowling", address="Powstańców Śląskich 95, 53-332 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.0944022, longitude=17.0191728,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2b7e4a86-fa22-45b9-9219-24dfbbc95312_ChIJgwhXVmrC_0.jpg",
      averageRating=4.2, totalRatingsCount=3074,
      createdAt="2026-08-30T21:30:50.131704Z", updatedAt="2026-08-30T22:00:01.948428Z",
    ),
    ClubDto(
      id="77080bb8-3ad8-45f9-abeb-51e148d002c9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachcampy.pl", address="54-034 Wrocław",
      city="Wroclaw", country="PL",
      latitude=51.1397841, longitude=16.9296931,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dc25901d-92bf-46e9-94a0-0a0631e9b597_photo.jpg",
      averageRating=5.0, totalRatingsCount=23,
      createdAt="2026-08-31T15:26:06.514983Z", updatedAt="2026-08-31T15:26:06.514983Z",
    ),
  )),
  CitySeo(slug="san-sebastian", name="San Sebastian", country="ES", clubCount=25, sports=listOf(Pair("Football", 5), Pair("Basketball", 3), Pair("Volleyball", 3), Pair("Billiards", 2), Pair("Padel", 2), Pair("Tennis", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Laser Tag", 1), Pair("Karting", 1), Pair("Paintball", 1), Pair("Climbing", 1)), clubs=listOf(
    ClubDto(
      id="44dda2e2-e350-4988-82c4-cf91f440c0df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pinter Tennis San Sebastian", address="Uba Bidea, 61, 20014 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3054734, longitude=-1.9522606,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd8c2223-f815-48eb-9d4e-9ff1d4951dde_photo.jpg",
      averageRating=4.9, totalRatingsCount=60,
      createdAt="2026-09-01T09:02:01.967627Z", updatedAt="2026-09-01T09:02:01.967627Z",
    ),
    ClubDto(
      id="d6e831b6-8de5-4cd7-928c-8b8bfd7da92f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Factory Boulder", address="pabellones 1-2-3, Ursalto Kalea, 4, 20014 Donostia / San Sebastián, Guipúzcoa",
      city="San Sebastian", country="ES",
      latitude=43.3018564, longitude=-1.943942,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9380be7d-35c3-4c8a-b6fb-e2d8be556d33_photo.jpg",
      averageRating=4.8, totalRatingsCount=404,
      createdAt="2026-09-01T09:03:15.868692Z", updatedAt="2026-09-01T09:03:15.868692Z",
    ),
    ClubDto(
      id="c1ec3762-1618-43b4-9fbc-2c4c4a9c9c32", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Donostia Laser Parkea", address="Portuetxe K., 53, B, 20018 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3011082, longitude=-2.0175752,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/708c6a28-f31b-450a-816f-e85c61122649_photo.jpg",
      averageRating=4.7, totalRatingsCount=187,
      createdAt="2026-09-01T09:03:28.620220Z", updatedAt="2026-09-01T09:03:28.620220Z",
    ),
    ClubDto(
      id="9a3d0dc9-070c-4218-90a2-fe89f6bda53d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ibaeta Padel Trinketea", address="Igara Bidea, 71, 20018 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3000026, longitude=-2.0144844,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f7894e65-9860-4e6e-a9f2-7f5a4afc6b05_photo.jpg",
      averageRating=4.6, totalRatingsCount=198,
      createdAt="2026-09-01T09:02:06.644722Z", updatedAt="2026-09-01T09:02:06.644722Z",
    ),
    ClubDto(
      id="25ae0d24-1e37-4e6f-982e-24ab6806ef59", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sould Park Bowling San Fernando", address="CC BAHÍA SUR, Avda. Caño Herrera, s/n, 11100 San Fernando, Cádiz",
      city="San Sebastian", country="ES",
      latitude=36.4708622, longitude=-6.2099382,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9aec5e14-4890-4f89-b94b-2a9b2ba60fb3_photo.jpg",
      averageRating=4.6, totalRatingsCount=563,
      createdAt="2026-09-01T09:03:11.070512Z", updatedAt="2026-09-01T09:03:11.070512Z",
    ),
    ClubDto(
      id="930c79f5-2d1e-4b49-8d9f-4b1012280fbb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club social Padel Pau 5", address="Av. Conrado Albaladejo, 46, 03540 Alicante",
      city="San Sebastian", country="ES",
      latitude=38.388188, longitude=-0.4205043,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3af02735-6e1c-4535-a590-5356a50893f8_photo.jpg",
      averageRating=4.5, totalRatingsCount=52,
      createdAt="2026-09-01T09:02:12.374704Z", updatedAt="2026-09-01T09:02:12.374704Z",
    ),
    ClubDto(
      id="e347e316-6ac1-40fe-96cb-665ae2a60b6d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kursaal Kasinoa", address="C. Mayor, 1, 20003 Donostia / San Sebastián, Guipúzcoa",
      city="San Sebastian", country="ES",
      latitude=43.3222967, longitude=-1.9854459,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d106c0f0-0f80-48e7-a5ce-9b640743239e_photo.jpg",
      averageRating=4.4, totalRatingsCount=1183,
      createdAt="2026-09-01T09:03:03.158738Z", updatedAt="2026-09-01T09:03:03.158738Z",
    ),
    ClubDto(
      id="b00901cc-ed45-4c79-95f7-16e61e6c752d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PAINTBALL DONOSTI", address="Petritza Bidea, 12, 20170 Zubieta, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.2691968, longitude=-2.0352883,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b788bda0-692f-4bc7-9a76-2d9cfae6e79b_photo.jpg",
      averageRating=4.4, totalRatingsCount=111,
      createdAt="2026-09-01T09:03:36.846124Z", updatedAt="2026-09-01T09:03:36.846124Z",
    ),
    ClubDto(
      id="33347ee3-811d-4dc5-8954-7ffbf9212306", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Real Golf Club de San Sebastián", address="Barrio Jaizubia Chalet Borda-Gain Apartado 6, Jaitzubia Auzoa, 78, 20280, Guipúzcoa",
      city="San Sebastian", country="ES",
      latitude=43.3382417, longitude=-1.8267181,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11acd5b9-cbbd-47e7-aab2-b25bcd4dff60_photo.jpg",
      averageRating=4.4, totalRatingsCount=360,
      createdAt="2026-09-01T09:02:53.356274Z", updatedAt="2026-09-01T09:02:53.356274Z",
    ),
    ClubDto(
      id="024f6d07-d219-4c82-b9fb-9dbd124e2fc2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo de Hockey y polideportivo Atletico San Sebastián", address="43°18'06.0\"N 1°59'41., Kalea 3, 20115 Astigarraga, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3016745, longitude=-1.9947988,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/147d51bd-390a-4e2f-af5a-55465e9dfd0c_photo.jpg",
      averageRating=4.3, totalRatingsCount=69,
      createdAt="2026-09-01T09:02:27.580474Z", updatedAt="2026-09-01T09:02:27.580474Z",
    ),
    ClubDto(
      id="c032bede-4710-46ea-8eb4-dd9160b11d92", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="EHU Kirol Instalazioak", address="Ondarreta Pasealekua, 22, 20018 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3122529, longitude=-2.0119126,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7e79aac6-3dee-45dd-a75c-f6361c5c0ad1_photo.jpg",
      averageRating=4.3, totalRatingsCount=142,
      createdAt="2026-09-01T09:01:56.075221Z", updatedAt="2026-09-01T09:01:56.075221Z",
    ),
    ClubDto(
      id="c25b59e2-a027-4f15-8f52-8f2839f535d4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polideportivo Municipal Dehesa Boyal", address="Av. de Navarrondán, s/n, 28702 San Sebastián de los Reyes, Madrid",
      city="San Sebastian", country="ES",
      latitude=40.5682436, longitude=-3.6317798,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6ebc15f2-d232-4a8f-92a8-563844f66e1b_photo.jpg",
      averageRating=4.3, totalRatingsCount=4496,
      createdAt="2026-09-01T09:02:32.265314Z", updatedAt="2026-09-01T09:02:32.265314Z",
    ),
    ClubDto(
      id="e8b7ea53-e8a0-4058-bbd8-623cc5c899e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Real Nuevo Club Golf Basozabal", address="GOIAZTXIKI / GOIAZTXIKI BIDEA 41, BAJO, 20014 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.2877437, longitude=-1.9646263,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b61e8364-fc68-45fd-bad1-a02cb76e08f0_photo.jpg",
      averageRating=4.3, totalRatingsCount=444,
      createdAt="2026-09-01T09:02:45.268585Z", updatedAt="2026-09-01T09:02:45.268585Z",
    ),
    ClubDto(
      id="e356e620-8da7-409f-9325-0bf51b4fadc6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bentaberri municipal sports centre", address="Xalbador Bertsolariaren Kalea, 2, 20018 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3104021, longitude=-2.0051492,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0c7e807-cc7f-4999-b341-f951cd8a5e3e_photo.jpg",
      averageRating=4.1, totalRatingsCount=789,
      createdAt="2026-09-01T09:03:20.619233Z", updatedAt="2026-09-01T09:03:20.619233Z",
    ),
    ClubDto(
      id="5cf1bbec-9f40-4c92-b079-2f01116c798d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo La Viña - Sanse Deporte", address="Av. de la Sierra, 24, 28701 San Sebastián de los Reyes, Madrid",
      city="San Sebastian", country="ES",
      latitude=40.5482406, longitude=-3.6342267,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a56edb07-1b39-46c4-9efa-05eeb2f4a60e_photo.jpg",
      averageRating=4.1, totalRatingsCount=421,
      createdAt="2026-09-01T09:02:36.962463Z", updatedAt="2026-09-01T09:02:36.962463Z",
    ),
    ClubDto(
      id="6a6cba40-1a77-4108-9a5b-36839e73769d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Metropolitan San Sebastián", address="Pío Baroja Pasealekua, 15, 20008 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3115129, longitude=-1.9958146,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11529414-1e14-4b6f-be4b-869a62f9b9d6_photo.jpg",
      averageRating=4.1, totalRatingsCount=605,
      createdAt="2026-09-01T09:03:24.889264Z", updatedAt="2026-09-01T09:03:24.889264Z",
    ),
    ClubDto(
      id="a991fbfc-76af-4652-8340-46a4d437cf9c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Etxadi Udal Kiroldegia", address="Borroto Kalea, 32, 20009 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3020172, longitude=-1.9886846,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a7fe017-f94d-4d09-ac0f-fcfe059de110_photo.jpg",
      averageRating=4.1, totalRatingsCount=588,
      createdAt="2026-09-01T09:02:19.337545Z", updatedAt="2026-09-01T09:02:19.337545Z",
    ),
    ClubDto(
      id="d27aa90d-a703-4066-8743-e1b24b5ec093", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Indoor Irun - Vilariño Motorsport", address="Molino Errepidea, 33, 20305 Irun, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3348922, longitude=-1.814008,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e327850f-ad7b-4421-a435-7a21583eba5c_photo.jpg",
      averageRating=4.1, totalRatingsCount=108,
      createdAt="2026-09-01T09:02:57.505467Z", updatedAt="2026-09-01T09:02:57.505467Z",
    ),
    ClubDto(
      id="4becffbf-8ae0-46d6-b759-771bae934f2c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo Municipal de Fútbol / Rugby Puio", address="Kalea, Lanberri Kalea, 5, 20009 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3007092, longitude=-1.9826611,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/01a5305d-acd4-4912-824b-8591cf803714_photo.jpg",
      averageRating=4.0, totalRatingsCount=419,
      createdAt="2026-09-01T09:01:45.162035Z", updatedAt="2026-09-01T09:01:45.162035Z",
    ),
    ClubDto(
      id="6fda613b-6dfb-411e-b947-0a11c411d2e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Matigoxotegi Udal Futbol Zelaia", address="Sibilia Kalea, 48, 20012 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3177801, longitude=-1.962342,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1ad394b0-97d3-4fd5-8b0a-2354dab7aeff_photo.jpg",
      averageRating=4.0, totalRatingsCount=338,
      createdAt="2026-09-01T09:01:49.390547Z", updatedAt="2026-09-01T09:01:49.390547Z",
    ),
    ClubDto(
      id="a4007ba6-f960-4f57-b60f-6cd56908660d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bidebieta Kiroldegia", address="Serapio Mujika, 1, 20016 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.322024, longitude=-1.9432647,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/19448632-6cdc-46e8-b963-bb3f819a6355_photo.jpg",
      averageRating=3.9, totalRatingsCount=626,
      createdAt="2026-09-01T09:02:16.139377Z", updatedAt="2026-09-01T09:02:16.139377Z",
    ),
    ClubDto(
      id="713f2716-f5c0-4c38-b6b1-b9b37b7639bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Camp de futbol Sant Sebastià", address="Carrer d'Antoni Galiana i Moltó, 3, 03100 Xixona, Alicante",
      city="San Sebastian", country="ES",
      latitude=38.5321759, longitude=-0.5057922,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc8dbf37-ad96-490b-9439-25cf4e04094a_photo.jpg",
      averageRating=3.9, totalRatingsCount=106,
      createdAt="2026-09-01T09:03:46.641741Z", updatedAt="2026-09-01T09:03:46.641741Z",
    ),
    ClubDto(
      id="76c9e1dc-6771-4547-8f90-cbaf9608f845", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Salle", address="20014 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3090518, longitude=-1.9686707,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/032f0f53-0c23-4a2e-8377-983bfcf77955_photo.jpg",
      averageRating=3.9, totalRatingsCount=120,
      createdAt="2026-09-01T09:03:42.164380Z", updatedAt="2026-09-01T09:03:42.164380Z",
    ),
    ClubDto(
      id="703e5ce5-419c-46be-8ab3-6e53c9eefc47", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo de Fútbol Municipal Cesar Benito", address="Alcalde J. Elosegi Hiribidea, 283, 20015 Donostia / San Sebastián, Gipuzkoa",
      city="San Sebastian", country="ES",
      latitude=43.3223095, longitude=-1.9468251,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/323b69cb-8435-4454-aefb-5eabf6b30c4b_photo.jpg",
      averageRating=3.7, totalRatingsCount=449,
      createdAt="2026-09-01T09:01:41.234043Z", updatedAt="2026-09-01T09:01:41.234043Z",
    ),
    ClubDto(
      id="0328cf84-db5c-4d26-a028-9be30b18e013", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CLUB ALICANTE SUN BEACH VOLLEY", address="Av. de Niza, 26, 03540 Alicante",
      city="San Sebastian", country="ES",
      latitude=38.3765495, longitude=-0.4099672,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/54d6af88-0132-4ea8-a603-05ed20c32e1e_photo.jpg",
      averageRating=5.0, totalRatingsCount=21,
      createdAt="2026-09-01T09:02:40.597023Z", updatedAt="2026-09-01T09:02:40.597023Z",
    ),
  )),
  CitySeo(slug="bordeaux", name="Bordeaux", country="FR", clubCount=25, sports=listOf(Pair("Football", 4), Pair("Padel", 3), Pair("Climbing", 2), Pair("Table Tennis", 2), Pair("Volleyball", 2), Pair("Tennis", 2), Pair("Golf", 2), Pair("Basketball", 2), Pair("Laser Tag", 2), Pair("Bowling", 1), Pair("Billiards", 1), Pair("Karting", 1), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="f1797687-2cab-4cd4-b364-becb80b5bfe4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel House", address="4 Rue du Professeur Langevin, 33150 Cenon",
      city="Bordeaux", country="FR",
      latitude=44.8544026, longitude=-0.5223777,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d9fbcf78-8c8f-4f67-9e5c-c23b90c90389_photo.jpg",
      averageRating=4.9, totalRatingsCount=250,
      createdAt="2026-08-31T23:20:01.722113Z", updatedAt="2026-08-31T23:20:01.722113Z",
    ),
    ClubDto(
      id="14aa9873-671f-44b5-9dea-1d2d453d2979", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hoops Factory Bordeaux", address="9 Rue Dumont d'Urville, 33300 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8789943, longitude=-0.5578631,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6377a267-475a-4d2d-99be-2aab7082fc47_photo.jpg",
      averageRating=4.8, totalRatingsCount=160,
      createdAt="2026-08-31T23:20:10.493478Z", updatedAt="2026-08-31T23:20:10.493478Z",
    ),
    ClubDto(
      id="e6f66d6c-012a-4582-b590-091743f45a26", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Big Padel", address="Décathlon Village, 5 Rue Hipparque, 33700 Mérignac",
      city="Bordeaux", country="FR",
      latitude=44.8287376, longitude=-0.679984,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a54cfe73-1f75-469d-925a-021bd0efcbce_photo.jpg",
      averageRating=4.7, totalRatingsCount=161,
      createdAt="2026-08-31T23:20:06.656826Z", updatedAt="2026-08-31T23:20:06.656826Z",
    ),
    ClubDto(
      id="b8da21db-be26-40d2-960a-bf40071b1a75", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Game", address="6 Rue Charles Tellier, 33130 Bègles",
      city="Bordeaux", country="FR",
      latitude=44.7901962, longitude=-0.5377674,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc39ae55-b1e9-48cf-9051-53b005c1201e_photo.jpg",
      averageRating=4.7, totalRatingsCount=358,
      createdAt="2026-08-31T23:21:09.004351Z", updatedAt="2026-08-31T23:21:09.004351Z",
    ),
    ClubDto(
      id="019a7279-8762-481a-82ad-d318aa8d5299", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Block'Out Bordeaux", address="3 Rue Georges Barres, 33300 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8881436, longitude=-0.5476119,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/58201f6c-e46d-4fb8-b596-57dcd0ca5bf3_photo.jpg",
      averageRating=4.6, totalRatingsCount=848,
      createdAt="2026-08-31T23:20:58.211250Z", updatedAt="2026-08-31T23:20:58.211250Z",
    ),
    ClubDto(
      id="f9c3bec7-f8b8-4d68-9fbb-672df9b6c016", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Game du Bassin", address="20 Av. des Loisirs, 33470 Gujan-Mestras",
      city="Bordeaux", country="FR",
      latitude=44.6212099, longitude=-1.1030108,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8a5ea4e4-a4ba-4fd5-8b84-547f1d8b29cf_photo.jpg",
      averageRating=4.6, totalRatingsCount=351,
      createdAt="2026-08-31T23:21:14.632200Z", updatedAt="2026-08-31T23:21:14.632200Z",
    ),
    ClubDto(
      id="a8d1bb41-b0fd-4529-a167-3af889492ba5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Bordeaux Merignac", address="90 Av. du Rouquet, 33700 Mérignac",
      city="Bordeaux", country="FR",
      latitude=44.8181525, longitude=-0.6560891,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e64cf672-a45a-48de-94e4-b5c66f591eef_photo.jpg",
      averageRating=4.6, totalRatingsCount=476,
      createdAt="2026-08-31T23:21:24.497387Z", updatedAt="2026-08-31T23:21:24.497387Z",
    ),
    ClubDto(
      id="8edb8615-962c-4356-8da4-c51e1e1100de", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SquashBad33", address="23 Rue René Magné, 33300 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8889289, longitude=-0.5443745,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b53c9f37-60d1-4022-a781-c227e7885afc_photo.jpg",
      averageRating=4.5, totalRatingsCount=332,
      createdAt="2026-08-31T23:19:56.022890Z", updatedAt="2026-08-31T23:19:56.022890Z",
    ),
    ClubDto(
      id="f3c95fe5-9d22-45b5-b47d-bd6700ae82c7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CAM Bordeaux Tennis de Table", address="7 Rue André Maginot, 33200 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.843117, longitude=-0.6267779,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5afe9dc0-4d92-4f28-96df-4cc7d7914424_photo.jpg",
      averageRating=4.4, totalRatingsCount=85,
      createdAt="2026-08-31T23:20:41.006709Z", updatedAt="2026-08-31T23:20:41.006709Z",
    ),
    ClubDto(
      id="f176d2b6-6d22-4d83-ae9c-517a7315c313", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ESCALADE BORDEAUX GINKO", address="6 Cr de Québec, 33300 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8751487, longitude=-0.5713971,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/498e49f0-e7d4-4518-a519-30f787b9f4fe_photo.jpg",
      averageRating=4.4, totalRatingsCount=86,
      createdAt="2026-08-31T23:21:03.179957Z", updatedAt="2026-08-31T23:21:03.179957Z",
    ),
    ClubDto(
      id="49bea846-7220-4d17-a71e-7ff6f9dae729", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Futbol Futbol Artigues", address="20 Av. du Périgord, 33370 Artigues-près-Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8656786, longitude=-0.4777631,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fe19191d-fb41-4fa4-bfd4-0d792a542285_photo.jpg",
      averageRating=4.4, totalRatingsCount=214,
      createdAt="2026-08-31T23:19:40.191337Z", updatedAt="2026-08-31T23:19:40.191337Z",
    ),
    ClubDto(
      id="8282c18e-0027-4c0b-bf62-6cb231722afe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UrbanSoccer - Bordeaux-Pessac", address="16 Av. Louis de Broglie, 33600 Pessac",
      city="Bordeaux", country="FR",
      latitude=44.778831, longitude=-0.6443834,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c6821e5a-e90d-42ec-a73f-7c16e126bea3_photo.jpg",
      averageRating=4.4, totalRatingsCount=812,
      createdAt="2026-08-31T23:19:31.188152Z", updatedAt="2026-08-31T23:19:31.188152Z",
    ),
    ClubDto(
      id="5ce85c28-f979-4577-9558-907646ef3605", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Complexe sportif Chauffour", address="15 Rue Chauffour, 33000 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8400539, longitude=-0.5901094,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/87dc96ed-c309-42de-95d4-2ca65e0d1fe2_photo.jpg",
      averageRating=4.3, totalRatingsCount=58,
      createdAt="2026-08-31T23:20:24.962802Z", updatedAt="2026-08-31T23:20:24.962802Z",
    ),
    ClubDto(
      id="c236cf7a-05e2-42a8-9c87-104ab684b01b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Halle des Sports", address="2 All. Pierre de Coubertin, 33400 Talence",
      city="Bordeaux", country="FR",
      latitude=44.800499, longitude=-0.6040422,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/610601f9-0513-427e-b456-495b076ba452_photo.jpg",
      averageRating=4.3, totalRatingsCount=86,
      createdAt="2026-08-31T23:20:15.749680Z", updatedAt="2026-08-31T23:20:15.749680Z",
    ),
    ClubDto(
      id="037c002b-91b1-47f9-b5af-8a0c8edc6038", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Covered Tennis Badminton Mériadeck", address="30 Rue Claude Bonnier, 33000 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8370132, longitude=-0.5878246,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/df6a5123-759e-4966-85d5-63f5f7a1afd0_photo.jpg",
      averageRating=4.2, totalRatingsCount=398,
      createdAt="2026-08-31T23:19:44.678681Z", updatedAt="2026-08-31T23:19:44.678681Z",
    ),
    ClubDto(
      id="1cd985ba-f13c-4a46-9d21-dfdf3560e9a5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Blue Green Pessac", address="1 Rue de la Princesse, 33600 Pessac",
      city="Bordeaux", country="FR",
      latitude=44.7970962, longitude=-0.7165958,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff6a9a81-ad72-41b5-b342-47cc53a74cc5_photo.jpg",
      averageRating=4.2, totalRatingsCount=727,
      createdAt="2026-08-31T23:20:34.162189Z", updatedAt="2026-08-31T23:20:34.162189Z",
    ),
    ClubDto(
      id="9c109b01-89be-421c-83cc-c5553b48b96f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Plaine des Sports Colette Besson", address="6 Cr Jules Ladoumegue, 33300 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8988362, longitude=-0.5674297,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f2d20e20-18df-461d-808a-788691112372_photo.jpg",
      averageRating=4.2, totalRatingsCount=180,
      createdAt="2026-08-31T23:19:49.451386Z", updatedAt="2026-08-31T23:19:49.451386Z",
    ),
    ClubDto(
      id="41472143-78b4-405e-9440-17ad967d5deb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stade Atlantique Bordeaux Métropole", address="Cr Jules Ladoumegue, 33300 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8973583, longitude=-0.5615863,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/655854e5-7f3f-412e-9e1a-2c9676b50bd9_photo.jpg",
      averageRating=4.2, totalRatingsCount=3311,
      createdAt="2026-08-31T23:19:25.598876Z", updatedAt="2026-08-31T23:19:25.598876Z",
    ),
    ClubDto(
      id="de8641b8-5feb-4b9a-812f-19427dd192be", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UrbanSoccer - Bordeaux Mérignac", address="21 Rue Archimède, 33700 Mérignac",
      city="Bordeaux", country="FR",
      latitude=44.825426, longitude=-0.6839709,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4d1f507b-56de-4ed7-8204-592f8707abb2_photo.jpg",
      averageRating=4.2, totalRatingsCount=638,
      createdAt="2026-08-31T23:19:36.084973Z", updatedAt="2026-08-31T23:19:36.084973Z",
    ),
    ClubDto(
      id="5a4c5a0c-dc5d-4a4a-af00-d6a65a099550", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Blue Green Bordeaux Lac", address="Golf de, Av. de Pernon, 33300 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.9087944, longitude=-0.570082,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/33e9421d-09c9-406c-ab5c-f39d3bafb2f1_photo.jpg",
      averageRating=4.1, totalRatingsCount=815,
      createdAt="2026-08-31T23:20:29.368444Z", updatedAt="2026-08-31T23:20:29.368444Z",
    ),
    ClubDto(
      id="5552664c-a090-4989-9255-c13798dacfef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KART System Indoor - karting et bowling", address="Rue du Grand Barail, 33300 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.888934, longitude=-0.5622633,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/75ea5646-f0bd-4874-ab01-9bf96a181a39_photo.jpg",
      averageRating=4.0, totalRatingsCount=2135,
      createdAt="2026-08-31T23:20:48.514476Z", updatedAt="2026-08-31T23:20:48.514476Z",
    ),
    ClubDto(
      id="0a08c606-5345-43a1-9e7b-4a9e182bf286", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports area Maître Jean", address="1 Rue de Maître Jean, 33000 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8293835, longitude=-0.6134491,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f4de7610-920d-442f-9ff9-a6cea8a0d341_photo.jpg",
      averageRating=4.0, totalRatingsCount=100,
      createdAt="2026-08-31T23:20:20.141771Z", updatedAt="2026-08-31T23:20:20.141771Z",
    ),
    ClubDto(
      id="ffcd92ec-debd-4ba9-8395-87ed2340683f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowlingstar Bègles-Bordeaux", address="Chem. de Courrejean, 33130 Bègles",
      city="Bordeaux", country="FR",
      latitude=44.7879296, longitude=-0.5369492,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b143a4f9-7cf9-4e86-b869-adff8718c000_photo.jpg",
      averageRating=3.5, totalRatingsCount=2470,
      createdAt="2026-08-31T23:20:53.472626Z", updatedAt="2026-08-31T23:20:53.472626Z",
    ),
    ClubDto(
      id="83cfc788-fe6f-489b-8cda-2ab0700a384e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Coqs Rouges Section Tennis de Table, ping-pong", address="14 Imp. Caillabet, 33000 Bordeaux",
      city="Bordeaux", country="FR",
      latitude=44.8341306, longitude=-0.5777931,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2f88836c-52f6-45dc-8df7-a7509060fd43_photo.jpg",
      averageRating=5.0, totalRatingsCount=10,
      createdAt="2026-08-31T23:20:44.197295Z", updatedAt="2026-08-31T23:20:44.197295Z",
    ),
    ClubDto(
      id="707d0b27-2fb5-499f-8cd4-9d458150d9d3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Bump - Cadaujac", address="160 All. du Petit Bois, 33140 Cadaujac",
      city="Bordeaux", country="FR",
      latitude=44.7297595, longitude=-0.5286618,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a1b1e7d0-19db-4066-85ae-c118ccbadb1f_photo.jpg",
      averageRating=5.0, totalRatingsCount=10,
      createdAt="2026-08-31T23:21:19.866219Z", updatedAt="2026-08-31T23:21:19.866219Z",
    ),
  )),
  CitySeo(slug="dnipro", name="Dnipro", country="UA", clubCount=25, sports=listOf(Pair("Football", 4), Pair("Tennis", 3), Pair("Volleyball", 2), Pair("Karting", 2), Pair("Basketball", 2), Pair("Billiards", 2), Pair("Table Tennis", 2), Pair("Laser Tag", 2), Pair("Paintball", 2), Pair("Golf", 1), Pair("Bowling", 1), Pair("Climbing", 1), Pair("Padel", 1)), clubs=listOf(
    ClubDto(
      id="393e70b3-9c5b-45b4-9c1b-7551127d3e4d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг/Пейнтбол/Альтанки \"1`st Legion\" Придніпровськ", address="Шляхова вулиця, 2, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4403105, longitude=35.1136629,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/16973c22-8ca2-421f-8f0c-219476621ad8_ChIJl2Y18q3j_0.jpg",
      averageRating=5.0, totalRatingsCount=280,
      createdAt="2026-08-30T17:10:58.680871Z", updatedAt="2026-08-30T20:52:38.024468Z",
    ),
    ClubDto(
      id="b8cd5fd7-aae1-4578-828e-14d40f7409d5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Golf", address="вулиця Архітектора Олега Петрова, 37, Дніпро, Дніпропетровська область, 49000",
      city="Dnipro", country="UA",
      latitude=48.4529606, longitude=35.0528097,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c56e66f6-bb78-49a7-a450-047bdccda963_photo.jpg",
      averageRating=4.9, totalRatingsCount=323,
      createdAt="2026-08-31T15:33:05.220909Z", updatedAt="2026-08-31T15:33:05.220909Z",
    ),
    ClubDto(
      id="9815292a-9993-4d96-a5ea-f839f991ec85", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Перший Легіон – Лазертаг Дніпро | Дитячий центр", address="Турдові резерви, 1, Dnipro, 49041 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.3942579, longitude=35.041307,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/824cb649-c638-4719-bf68-5a5aca80bacc_ChIJlcWjzMz8_0.jpg",
      averageRating=4.9, totalRatingsCount=1102,
      createdAt="2026-08-30T17:10:37.436531Z", updatedAt="2026-08-30T20:52:44.002170Z",
    ),
    ClubDto(
      id="01d688cc-7154-4318-9063-1edeb1004455", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club SPIN", address="вулиця Шевченка, 59, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4615404, longitude=35.0465776,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/372117ff-d795-452b-9588-86fc5a7add80_ChIJLdPh293i_0.jpg",
      averageRating=4.8, totalRatingsCount=130,
      createdAt="2026-08-30T17:11:28.438581Z", updatedAt="2026-08-30T20:52:24.334455Z",
    ),
    ClubDto(
      id="4672b273-3a6f-48cc-824d-717dd5eb5bc1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Баскетбольний клуб Дніпро", address="проспект Богдана Хмельницького, 118Д, Дніпро, Дніпропетровська область, 49000",
      city="Dnipro", country="UA",
      latitude=48.4063557, longitude=35.0004844,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/635d48f2-f690-4f64-bc95-838fe4cf163b_photo.jpg",
      averageRating=4.8, totalRatingsCount=196,
      createdAt="2026-08-31T15:32:38.907528Z", updatedAt="2026-08-31T15:32:38.907528Z",
    ),
    ClubDto(
      id="cec940a6-8d4e-49d8-9b63-6118644a9b76", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбол, Лазертаг Клуб \"1-й Легіон\"", address="Донецьке шосе, 2 д, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.5056018, longitude=34.9804366,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a19fa69f-314f-4961-b3b5-50ceaeb19b1c_ChIJKahEfeZX_0.jpg",
      averageRating=4.8, totalRatingsCount=578,
      createdAt="2026-08-30T17:10:51.820980Z", updatedAt="2026-08-30T20:52:42.628645Z",
    ),
    ClubDto(
      id="37fa0da3-416b-4253-bad4-609cbec14944", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dnipro Kart", address="Дніпробудівська вулиця, 67, Кам’янське, 51909 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.5386199, longitude=34.5409431,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a61bdab4-aa70-4cc8-9df7-e739c205ab11_ChIJXyC0BYDQ_0.jpg",
      averageRating=4.7, totalRatingsCount=568,
      createdAt="2026-08-30T17:10:30.623735Z", updatedAt="2026-08-30T20:52:12.379760Z",
    ),
    ClubDto(
      id="cb9d8d80-f07e-46b3-95f7-5282898fbd13", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Клуб настільного тенісу STARTT", address="проспект Олександра Поля, 50Д/13, Дніпро, Дніпропетровська область, 49000",
      city="Dnipro", country="UA",
      latitude=48.4511662, longitude=35.0178018,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/620f4943-6d71-467a-b6eb-7db68a54a2d2_photo.jpg",
      averageRating=4.7, totalRatingsCount=129,
      createdAt="2026-08-31T15:33:13.646208Z", updatedAt="2026-08-31T15:33:13.646208Z",
    ),
    ClubDto(
      id="423b9b6e-9ffc-49db-89a8-cf3074b11d7b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг Агресор Дніпро", address="Новокодацький парк, вулиця Набережна Заводська, 53, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4831771, longitude=34.948293,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5b5317a1-ece0-4723-bd8c-8d3054128216_ChIJd1_m8Hjh_0.jpg",
      averageRating=4.6, totalRatingsCount=994,
      createdAt="2026-08-30T17:10:45.306466Z", updatedAt="2026-08-30T20:52:37.278498Z",
    ),
    ClubDto(
      id="9d85f092-3577-43c6-ae0a-c2bf4c64086a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Олімпійські резерви", address="проспект Богдана Хмельницького, 29-д, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4329635, longitude=35.0193128,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dd4f8277-8611-4e42-8690-4154b8703072_ChIJMxRH4lnj_0.jpg",
      averageRating=4.6, totalRatingsCount=1003,
      createdAt="2026-08-30T17:09:15.432270Z", updatedAt="2026-09-01T14:31:51.759165Z",
    ),
    ClubDto(
      id="fee28e50-c1fe-46b4-a746-1d8413b32579", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скеледром \"La Scala\"", address="вулиця Барикадна, 5/7, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4632926, longitude=35.0520519,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d758a423-47e9-402a-b299-7ef777d52960_ChIJGxXcYBzj_0.jpg",
      averageRating=4.6, totalRatingsCount=63,
      createdAt="2026-08-30T17:10:16.065395Z", updatedAt="2026-08-30T20:52:46.251989Z",
    ),
    ClubDto(
      id="2d27fc57-e332-41b6-80f7-51fabc73020a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Human", address="проспект Пилипа Орлика, 20а, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4494029, longitude=35.024198,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/33761468-531f-420f-be6b-e22574c070ac_ChIJ47520hfj_0.jpg",
      averageRating=4.5, totalRatingsCount=1117,
      createdAt="2026-08-30T17:11:13.384233Z", updatedAt="2026-09-01T14:32:00.054579Z",
    ),
    ClubDto(
      id="6707c39f-3ddd-4c0a-b466-3536773de406", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Гараж", address="вулиця Набережна Заводська, 82д, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4903987, longitude=34.93526,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4bde30c-6afb-4719-a568-8b57863639a5_ChIJrYhu4nbh_0.jpg",
      averageRating=4.5, totalRatingsCount=1112,
      createdAt="2026-08-30T17:10:23.707860Z", updatedAt="2026-08-30T20:52:29.750958Z",
    ),
    ClubDto(
      id="6d71b94e-5fb6-4fc7-9ccd-c1ed244b9139", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Классик", address="вулиця Старокозацька, 12, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4612582, longitude=35.0442124,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/478710f1-286f-4452-a06e-660b9c0868a0_ChIJJcj8rFPm_0.jpg",
      averageRating=4.5, totalRatingsCount=289,
      createdAt="2026-08-30T17:09:52.584342Z", updatedAt="2026-08-30T20:52:34.112120Z",
    ),
    ClubDto(
      id="ac6cf1c5-3ef6-4b9a-a98d-10fabdc9a4e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Восход", address="вулиця Набережна Перемоги, 51, Дніпро, 49094 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4313211, longitude=35.0685384,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/54f378d7-1d73-421e-a040-f38d0b5044c6_ChIJfwSpyk77_0.jpg",
      averageRating=4.4, totalRatingsCount=727,
      createdAt="2026-08-30T17:09:30.366756Z", updatedAt="2026-08-30T20:52:29.361849Z",
    ),
    ClubDto(
      id="c188a6c3-6dd9-4211-b5eb-f2646a7b0d4a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Мегарон", address="вулиця Костомарівська, 6А, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4605814, longitude=35.0352063,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5839e1c5-efc2-404d-b0f6-c03a46259926_ChIJDZcZzuHi_0.jpg",
      averageRating=4.4, totalRatingsCount=218,
      createdAt="2026-08-30T17:09:38.038763Z", updatedAt="2026-08-30T20:52:39.333848Z",
    ),
    ClubDto(
      id="2edf2e93-f484-4b22-9f6f-725f1fd00d50", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Оранж", address="вулиця Путилівська, 16, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.5113715, longitude=35.0719751,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7cb8f8ef-bfc6-4862-8a99-54023ad3c3d8_ChIJaXu7dopY_0.jpg",
      averageRating=4.4, totalRatingsCount=929,
      createdAt="2026-08-30T17:09:22.793553Z", updatedAt="2026-08-30T20:52:41.203954Z",
    ),
    ClubDto(
      id="d0f33842-eca3-466b-a517-48c521f027a9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спарта, Спортивный клуб, Днепр, Украина", address="вулиця Павла Нірінберга, 10а, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.46658, longitude=35.055141,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/14e88c05-45ba-458e-9852-3bff62c79853_ChIJf7ELKc7i_0.jpg",
      averageRating=4.4, totalRatingsCount=83,
      createdAt="2026-08-30T17:11:05.904078Z", updatedAt="2026-08-30T20:52:47.552396Z",
    ),
    ClubDto(
      id="4b407e3b-c3c3-4ac2-8f0a-520bf551b2ea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Maximus", address="Золотые ключи, вулиця Київська, 27, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.544284, longitude=35.083637,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ca44abf9-cb24-4873-9073-29721e714ad3_ChIJe6NozhlZ_0.jpg",
      averageRating=4.1, totalRatingsCount=422,
      createdAt="2026-08-30T17:11:21.445362Z", updatedAt="2026-08-30T20:52:18.533752Z",
    ),
    ClubDto(
      id="aecc669b-aec1-412d-999c-ca0ee5ab939f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Мелроуз", address="проспект Богдана Хмельницького, 31Д, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4281044, longitude=35.0149154,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/984037c3-6e11-4fd3-9d1c-6194d47ad2a8_ChIJlxgdDVrj_3.jpg",
      averageRating=4.0, totalRatingsCount=4649,
      createdAt="2026-08-30T17:10:07.921521Z", updatedAt="2026-08-31T22:11:26.079183Z",
    ),
    ClubDto(
      id="a1c90f98-825c-428b-8791-3af2251fa706", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Схід", address="вулиця Набережна Перемоги, 82Б, Дніпро, 49000 Dnipro, Ukraine",
      city="Dnipro", country="UA",
      latitude=48.4296747, longitude=35.0652436,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e9b32fa-9a66-45d4-a985-3228f9aedbc3_ChIJdeyT8Mb8_2.jpg",
      averageRating=4.0, totalRatingsCount=320,
      createdAt="2026-08-30T17:09:45.432589Z", updatedAt="2026-08-31T22:11:27.269334Z",
    ),
    ClubDto(
      id="1d092a7b-078e-4f7f-833f-31e149ce9d08", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Бадминтонный клуб \"Papa's court\"", address="Печерський узвіз, 3, Дніпро, Дніпропетровська область, 49000",
      city="Dnipro", country="UA",
      latitude=48.4460979, longitude=35.0633769,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/918d1486-3e1b-43e1-9c25-566dd973842f_photo.jpg",
      averageRating=4.2, totalRatingsCount=30,
      createdAt="2026-08-31T15:32:45.370143Z", updatedAt="2026-08-31T15:32:45.370143Z",
    ),
    ClubDto(
      id="20436243-5dea-46c7-bba9-2c859373ebfb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dnepr-Volley", address="Площадки Dnepr-Volley Воронцовская дача, проспект Мануйлівський, Dnipro, Dnipropetrovs'ka oblast, 49000",
      city="Dnipro", country="UA",
      latitude=48.483346, longitude=35.0591302,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9fba7718-1087-444a-9456-d28685368afb_photo.jpg",
      averageRating=4.7, totalRatingsCount=6,
      createdAt="2026-08-31T15:32:52.025616Z", updatedAt="2026-08-31T15:32:52.025616Z",
    ),
    ClubDto(
      id="90703200-55cd-417a-bd91-3e2d65415690", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Настольный теннис", address="пр-т Миру, 1Б, Дніпро, Дніпропетровська область, 49000",
      city="Dnipro", country="UA",
      latitude=48.5248271, longitude=35.0228345,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8aeb3c45-3d8a-4c3e-9130-b1837d72c9eb_photo.jpg",
      averageRating=5.0, totalRatingsCount=5,
      createdAt="2026-08-31T15:33:17.207701Z", updatedAt="2026-08-31T15:33:17.207701Z",
    ),
    ClubDto(
      id="38384947-f060-4ced-91a0-d4cd4184e798", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пляжный Волейбол 2/2", address="Дніпро, Дніпропетровська область, 49000",
      city="Dnipro", country="UA",
      latitude=48.51343, longitude=34.9829085,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3841ef87-222e-425c-a586-e3512ac5dd21_photo.jpg",
      averageRating=5.0, totalRatingsCount=5,
      createdAt="2026-08-31T15:32:58.603161Z", updatedAt="2026-08-31T15:32:58.603161Z",
    ),
  )),
  CitySeo(slug="rotterdam", name="Rotterdam", country="NL", clubCount=24, sports=listOf(Pair("Football", 4), Pair("Volleyball", 3), Pair("Padel", 3), Pair("Basketball", 3), Pair("Tennis", 3), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Table Tennis", 1), Pair("Bowling", 1), Pair("Paintball", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="97b6aa26-d6eb-4406-9eb8-997f16275be4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Comet Club - Home of Fried Chicken, Karaoke & Ping Pong", address="Goudsesingel 260, 3011 KG Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9241153, longitude=4.4900456,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/91f3ccc0-28d6-475d-b585-c5183892da6c_photo.jpg",
      averageRating=4.9, totalRatingsCount=76,
      createdAt="2026-08-31T15:37:11.319657Z", updatedAt="2026-08-31T15:37:11.319657Z",
    ),
    ClubDto(
      id="678ae36e-8eaa-450a-9ed2-c404582fdb71", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennisvereniging \"TC Schiebroek\"", address="Melanchtonweg 80, 3052 KV Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9483376, longitude=4.4725244,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/61fc348b-468a-4894-94bb-55f921dcf3ed_ChIJNfDUY1rL_0.jpg",
      averageRating=4.6, totalRatingsCount=79,
      createdAt="2026-08-30T21:36:47.748426Z", updatedAt="2026-09-01T14:31:42.053023Z",
    ),
    ClubDto(
      id="4620ebc5-3e50-4003-9734-d0e50493e70d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Adventure City Rotterdam", address="Dorpslaan 428, 3084 LL Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.8683541, longitude=4.4685953,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e3293b94-66d5-4c3f-afc7-85a40aac9998_ChIJic-EAgY1_0.jpg",
      averageRating=4.5, totalRatingsCount=657,
      createdAt="2026-08-30T21:35:41.405366Z", updatedAt="2026-08-30T21:55:12.291454Z",
    ),
    ClubDto(
      id="9047209f-33b1-423e-aae1-d5bd681f86a3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klimbos Fun Forest Rotterdam", address="Langepad 71, 3062 CJ Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9404678, longitude=4.5080552,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f699b9b3-efa7-4ddc-b6ce-a7302d290e0b_ChIJdZhWGcrM_0.jpg",
      averageRating=4.5, totalRatingsCount=968,
      createdAt="2026-08-30T21:35:34.893811Z", updatedAt="2026-08-30T21:35:34.893811Z",
    ),
    ClubDto(
      id="f5b42093-0356-4594-9101-074d272e189c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padelclub Rotterdam - Terbregge", address="Ommoordseweg 34, 3056 JP Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9534867, longitude=4.5258251,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/280646d1-cd91-4386-991d-a65f3050a3d7_ChIJrQ1YxLXN_0.jpg",
      averageRating=4.5, totalRatingsCount=97,
      createdAt="2026-08-30T21:36:10.450484Z", updatedAt="2026-08-30T21:59:13.081109Z",
    ),
    ClubDto(
      id="7b34ce1f-d4fd-485a-beb3-58d71495c9d2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poolcafé Delfshaven 🎱", address="Aelbrechtskolk 45B, 3025 HB Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9086469, longitude=4.4480232,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/384061e5-06e5-4eeb-be2c-9c04c1738819_photo.jpg",
      averageRating=4.5, totalRatingsCount=1058,
      createdAt="2026-08-31T15:37:18.111704Z", updatedAt="2026-08-31T15:37:18.111704Z",
    ),
    ClubDto(
      id="5e7e173f-1f7c-4beb-bf0b-b3ab72ef42f1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Varkenoord", address="Olympiaweg 280, 3078 XX Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.8915838, longitude=4.5252349,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/13f921ae-393b-442e-9369-624501c7d554_ChIJbaoNslUy_0.jpg",
      averageRating=4.5, totalRatingsCount=1093,
      createdAt="2026-08-30T21:34:45.665009Z", updatedAt="2026-08-30T21:34:45.665009Z",
    ),
    ClubDto(
      id="fa0f37f4-72f7-4135-956b-9bcebadd2165", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padelclub Rotterdam - Feijenoord", address="Korte Stadionweg 109, 3077 ME Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9010183, longitude=4.5142168,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/199f0524-01f3-48bc-b30a-30e60b46a83e_ChIJ9Z6Slgkz_0.jpg",
      averageRating=4.4, totalRatingsCount=95,
      createdAt="2026-08-30T21:36:17.172267Z", updatedAt="2026-08-30T21:59:10.935424Z",
    ),
    ClubDto(
      id="e76d402d-239d-48c6-b3f2-0e7c1aff88d6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Topsportcentrum Rotterdam", address="Van Zandvlietplein 20, 3077 AA Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.8938056, longitude=4.5261667,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dd4d14fd-b3d6-4a1d-8217-235e703d7446_photo.jpg",
      averageRating=4.4, totalRatingsCount=288,
      createdAt="2026-08-31T15:36:05.178348Z", updatedAt="2026-08-31T22:11:23.467449Z",
    ),
    ClubDto(
      id="ece87c73-93c4-4782-9f15-d2916f6e0c8d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dok 99 Rotterdam", address="Straatweg 99, 3054 AB Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.947465, longitude=4.484691,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/964753f0-5d15-4254-b008-2c27837db1b1_ChIJ71u60qfM_0.jpg",
      averageRating=4.3, totalRatingsCount=1958,
      createdAt="2026-08-30T21:35:27.098163Z", updatedAt="2026-08-30T21:56:26.580474Z",
    ),
    ClubDto(
      id="d5d48bb6-6e2a-420a-8f6e-2a58bae0b752", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Erasmus Sport Center", address="Burgemeester Oudlaan 50, 3062 PA Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.916487, longitude=4.5282075,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f7d1cc62-5a19-4101-8b1f-1929f6c4a90f_photo.jpg",
      averageRating=4.3, totalRatingsCount=431,
      createdAt="2026-08-31T15:36:22.248660Z", updatedAt="2026-08-31T15:36:22.248660Z",
    ),
    ClubDto(
      id="9f7b0712-e100-4a37-8fe1-840527630f8c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Project 7 Cablepark", address="Kosboulevard 35, 3059 XZ Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9792594, longitude=4.5735225,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e712af2a-fb94-4695-ba38-0dbc6523d3e8_ChIJFZI65ZzN_1.jpg",
      averageRating=4.3, totalRatingsCount=373,
      createdAt="2026-08-30T21:35:54.965764Z", updatedAt="2026-08-31T22:11:20.917505Z",
    ),
    ClubDto(
      id="2d57ca33-714e-47a5-9dd4-9fb2ccf62128", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zwemcentrum Rotterdam", address="Annie M.G. Schmidtplein 8, 3083 NZ Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.8871344, longitude=4.4873994,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c2f7599e-66ac-41ae-b1e3-057f7c9df8bb_ChIJqXccE5sz_1.jpg",
      averageRating=4.3, totalRatingsCount=839,
      createdAt="2026-08-30T21:34:52.036680Z", updatedAt="2026-08-31T22:11:24.326112Z",
    ),
    ClubDto(
      id="8d6af81a-9d61-4bf0-b95b-b7445d89e708", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poolcentrum Blaak", address="Mariniersweg 451, 3011 NM Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9206454, longitude=4.4903877,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a0218f0c-6428-465a-ac90-9d23eca2dd14_photo.jpg",
      averageRating=4.2, totalRatingsCount=446,
      createdAt="2026-08-31T15:37:25.092129Z", updatedAt="2026-08-31T15:37:25.092129Z",
    ),
    ClubDto(
      id="fcb55726-3329-4e98-af25-57b1adb1e83d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennispark Blijdorp", address="Vroesenpad, 3039 MC Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9310255, longitude=4.4503685,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3785b37a-55cb-4161-9ae5-e7e41e2673e1_ChIJu1ecTLE0_0.jpg",
      averageRating=4.2, totalRatingsCount=114,
      createdAt="2026-08-30T21:36:40.597084Z", updatedAt="2026-08-30T21:36:40.597084Z",
    ),
    ClubDto(
      id="40cca91f-7787-40a0-8b76-987c0615aa84", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Rotterdam", address="naast Post nl, 3034 KA Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9490643, longitude=4.5256093,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7716209c-3099-4dbb-b87e-1372c0d543f6_ChIJO7IJXMDT_0.jpg",
      averageRating=4.1, totalRatingsCount=172,
      createdAt="2026-08-30T21:36:03.079223Z", updatedAt="2026-08-30T21:36:03.079223Z",
    ),
    ClubDto(
      id="637993f0-3dab-49d7-88b9-02ee68f79fe7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporthal Schuttersveld", address="Crooswijksestraat 93, 3034 AE Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9333924, longitude=4.491062,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/acfdc7d5-ff9a-4181-99d8-777727eb65ce_ChIJ8ZYCYFIz_0.jpg",
      averageRating=4.1, totalRatingsCount=541,
      createdAt="2026-08-30T21:35:05.957107Z", updatedAt="2026-08-30T21:35:05.957107Z",
    ),
    ClubDto(
      id="2e372e83-e8fe-4f6d-8a2f-5d52856b54a9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Victoria Tennishal", address="Kralingseweg 226, 3062 CG Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9297222, longitude=4.5361111,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ec42f8b2-c843-4473-8fb9-a418da98fea8_ChIJL7RPPtQy_0.jpg",
      averageRating=4.1, totalRatingsCount=356,
      createdAt="2026-08-30T21:36:32.855433Z", updatedAt="2026-08-30T21:36:32.855433Z",
    ),
    ClubDto(
      id="248f835b-2de2-4bde-b253-7e0963363878", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportcentrum De Wilgenring", address="Melanchtonweg 70, 3052 KV Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9488944, longitude=4.4719389,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/76307d9f-691d-46c0-a7eb-3b1016269817_ChIJN0zsZlrL_0.jpg",
      averageRating=4.0, totalRatingsCount=807,
      createdAt="2026-08-30T21:34:58.576078Z", updatedAt="2026-08-30T22:00:16.090239Z",
    ),
    ClubDto(
      id="8e4db55c-0f82-4800-99a4-4d2fab2e127c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rotterdam Basketball", address="Sjanghailaan 275, 3066 SJ Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9397222, longitude=4.5588889,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd4c785d-a243-4a1b-a7a8-1973bea2a086_photo.jpg",
      averageRating=3.9, totalRatingsCount=58,
      createdAt="2026-08-31T15:35:55.470246Z", updatedAt="2026-08-31T15:35:55.470246Z",
    ),
    ClubDto(
      id="ce540067-3644-413d-b133-a823ae47376d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportfondsen Oostervant", address="Oostervantstraat 25, 3021 PT Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9202851, longitude=4.4608449,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f0f6bf95-4bf8-4514-9e2a-fc8542f38653_photo.jpg",
      averageRating=3.9, totalRatingsCount=500,
      createdAt="2026-08-31T15:36:41.133383Z", updatedAt="2026-08-31T15:36:41.133383Z",
    ),
    ClubDto(
      id="c8da2cf8-5fae-4cdc-a882-69d960d971a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padelclub Rotterdam - Victoria", address="Kralingseweg 226, 3062 CG Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9301565, longitude=4.5358533,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a1ac8463-6a82-4ad9-83c6-88a560f9cac3_ChIJL7RPPtQy_0.jpg",
      averageRating=4.4, totalRatingsCount=39,
      createdAt="2026-08-30T21:36:24.596632Z", updatedAt="2026-09-01T14:31:50.942609Z",
    ),
    ClubDto(
      id="07655af7-f589-4f21-aee5-89fd079da929", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Volleybalvereniging HOU STAND", address="Spaanseweg 2, 3028 HW Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.9197304, longitude=4.4291432,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/216fa147-e74f-4a2c-9cdf-b994992fec11_photo.jpg",
      averageRating=4.6, totalRatingsCount=19,
      createdAt="2026-08-31T15:36:27.437928Z", updatedAt="2026-08-31T15:36:27.437928Z",
    ),
    ClubDto(
      id="703b8ec5-c4c0-448e-bf91-55ed907727dd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rotterdam City Basketball", address="Van Zandvlietplein 20, 3077 AA Rotterdam",
      city="Rotterdam", country="NL",
      latitude=51.8938802, longitude=4.5263202,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4eb7071a-1722-481e-9adb-0e4b314f8c57_photo.jpg",
      averageRating=5.0, totalRatingsCount=10,
      createdAt="2026-08-31T15:36:16.904767Z", updatedAt="2026-08-31T15:36:16.904767Z",
    ),
  )),
  CitySeo(slug="malta", name="Malta", country="MT", clubCount=24, sports=listOf(Pair("Football", 5), Pair("Tennis", 3), Pair("Basketball", 3), Pair("Padel", 3), Pair("Table Tennis", 2), Pair("Volleyball", 2), Pair("Climbing", 2), Pair("Golf", 1), Pair("Karting", 1), Pair("Bowling", 1), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="07730199-d0bb-4f07-abf1-4266b4191828", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Crashpad Climbing Centre", address="13 Crashpad Ltd, Zone 5, Central Business District, Triq il-Bankiera, Qormi",
      city="Malta", country="MT",
      latitude=35.885508, longitude=14.473707,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1194076d-07b0-4aa8-9387-09de800bc5c0_photo.jpg",
      averageRating=4.9, totalRatingsCount=64,
      createdAt="2026-09-01T09:12:56.197751Z", updatedAt="2026-09-01T09:12:56.197751Z",
    ),
    ClubDto(
      id="24f2c719-1868-4b6d-b3f1-63ee94c513c8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Billiard House Malta", address="Triq San Gwakkin, Birkirkara",
      city="Malta", country="MT",
      latitude=35.8886709, longitude=14.4650558,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/164198e2-ec5f-4aa3-ac62-d6f3bda61da9_photo.jpg",
      averageRating=4.9, totalRatingsCount=112,
      createdAt="2026-09-01T09:13:00.958999Z", updatedAt="2026-09-01T09:13:00.958999Z",
    ),
    ClubDto(
      id="d6f8927d-f2c6-46d6-acb6-ea62c3b6e06a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Malta", address="Triq L-Imhallef William Harding Pembroke, WFFM+V5R, Pembroke PBK 1532",
      city="Malta", country="MT",
      latitude=35.9246139, longitude=14.482335,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0958cba2-0e2c-4159-85bb-954e6c2f1497_photo.jpg",
      averageRating=4.8, totalRatingsCount=111,
      createdAt="2026-09-01T09:11:51.944139Z", updatedAt="2026-09-01T09:11:51.944139Z",
    ),
    ClubDto(
      id="91efe440-9504-4f35-b1d0-66bd12383dc6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Depiro Sports Club", address="Ta Ir Regimenti Maltin, L-Imtarfa",
      city="Malta", country="MT",
      latitude=35.893668, longitude=14.4002651,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/85e606ae-eaf8-4d09-894d-f6c115b63306_photo.jpg",
      averageRating=4.7, totalRatingsCount=72,
      createdAt="2026-09-01T09:12:10.735507Z", updatedAt="2026-09-01T09:12:10.735507Z",
    ),
    ClubDto(
      id="f87beaf7-61e9-48cf-9586-62be8aca1a1a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vittoriosa Lawn Tennis Club", address="Corradino Rd, Paola PLA 3000",
      city="Malta", country="MT",
      latitude=35.8799039, longitude=14.5102073,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/856d25c6-70a5-485a-8d4d-c3ca7ec9b6cd_photo.jpg",
      averageRating=4.7, totalRatingsCount=164,
      createdAt="2026-09-01T09:11:36.883585Z", updatedAt="2026-09-01T09:11:36.883585Z",
    ),
    ClubDto(
      id="0e317fad-fad4-47bd-ab4a-fc2ce2014965", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Birkirkara Tennis Club", address="Misrah It-Tigieg, Birkirkara",
      city="Malta", country="MT",
      latitude=35.9030227, longitude=14.4686555,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c59a8853-dd21-4513-9f70-75cda97b52f6_photo.jpg",
      averageRating=4.6, totalRatingsCount=60,
      createdAt="2026-09-01T09:11:46.704728Z", updatedAt="2026-09-01T09:11:46.704728Z",
    ),
    ClubDto(
      id="79f22f75-f789-4c7d-9d8f-ff293bf69cb5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gymnasia", address="Vjal Sir Paul Boffa, Raħal Ġdid",
      city="Malta", country="MT",
      latitude=35.874278, longitude=14.501295,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2cc145ce-cd49-4428-ba5a-5d7b73c8b840_photo.jpg",
      averageRating=4.6, totalRatingsCount=317,
      createdAt="2026-09-01T09:12:51.906365Z", updatedAt="2026-09-01T09:12:51.906365Z",
    ),
    ClubDto(
      id="f010781f-3067-4845-8ba5-342397f9954f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kirkop Sports Complex", address="Triq Raffaele Caruana, Ħal Kirkop",
      city="Malta", country="MT",
      latitude=35.8382125, longitude=14.4852547,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4ab1fb11-d3d5-4906-83fa-e4bc24fc65f6_photo.jpg",
      averageRating=4.6, totalRatingsCount=374,
      createdAt="2026-09-01T09:12:05.140041Z", updatedAt="2026-09-01T09:12:05.140041Z",
    ),
    ClubDto(
      id="96e1bdb1-7272-4aec-900a-95969f089947", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pieta' Grounds", address="Triq Id - Duluri, Tal-Pietà",
      city="Malta", country="MT",
      latitude=35.8901103, longitude=14.4949579,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e5b49d6f-696c-46c0-a242-4e354500afdb_photo.jpg",
      averageRating=4.5, totalRatingsCount=398,
      createdAt="2026-09-01T09:11:14.661235Z", updatedAt="2026-09-01T09:11:14.661235Z",
    ),
    ClubDto(
      id="d0c8a222-da2a-4d89-a638-c00e3edb5fcc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Infetti Football grounds", address="VFV5+M5R, Triq B. Bontadini, Birkirkara",
      city="Malta", country="MT",
      latitude=35.894239, longitude=14.4578791,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d54d4712-ce27-45d5-b0d4-3f4a6cba3bc7_photo.jpg",
      averageRating=4.4, totalRatingsCount=284,
      createdAt="2026-09-01T09:11:19.024740Z", updatedAt="2026-09-01T14:32:02.644844Z",
    ),
    ClubDto(
      id="1987c445-28be-44e2-80cf-ca8d7f4aad69", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="San Gwann Football Grounds", address="WF6F+2Q8, Triq il-Kampanella, San Ġwann",
      city="Malta", country="MT",
      latitude=35.9100272, longitude=14.474438,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/223a621c-415c-4cc9-84b4-e0e8e8a8b6f1_photo.jpg",
      averageRating=4.4, totalRatingsCount=141,
      createdAt="2026-09-01T09:11:27.080974Z", updatedAt="2026-09-01T09:11:27.080974Z",
    ),
    ClubDto(
      id="cc5e8901-709c-4462-8cc7-20c5013e7214", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Swieqi Tennis Club.", address="WFCJ+P2G, Triq Il-Qatta, Is-Swieqi",
      city="Malta", country="MT",
      latitude=35.9218163, longitude=14.4800845,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/60de91b6-c284-48d6-b8b0-33250389f8c7_photo.jpg",
      averageRating=4.4, totalRatingsCount=91,
      createdAt="2026-09-01T09:11:41.395168Z", updatedAt="2026-09-01T09:11:41.395168Z",
    ),
    ClubDto(
      id="01f96150-9efb-4ff3-a55a-f6bea8963f46", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Żebbuġ Football Pitch", address="Haz, VCFR+PXR, Ħaż-Żebbuġ",
      city="Malta", country="MT",
      latitude=35.8743696, longitude=14.4423769,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/af7ae840-fd37-4d2c-928b-b7442114c65f_photo.jpg",
      averageRating=4.4, totalRatingsCount=230,
      createdAt="2026-09-01T09:11:23.378808Z", updatedAt="2026-09-01T09:11:23.378808Z",
    ),
    ClubDto(
      id="31390d62-882b-40e0-ad0e-4191133d723e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Alpha Table Tennis Klabb Malta - Mosta", address="151 Fortress St, Mosta",
      city="Malta", country="MT",
      latitude=35.917527, longitude=14.4247264,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4b975a86-22b5-4863-ac50-0204f8bc18f3_photo.jpg",
      averageRating=5.0, totalRatingsCount=42,
      createdAt="2026-09-01T09:12:32.240104Z", updatedAt="2026-09-01T09:12:32.240104Z",
    ),
    ClubDto(
      id="26a2d70e-9b9e-477a-9d14-ccaed76e9d90", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Reve Karting Track", address="Birżebbuġa",
      city="Malta", country="MT",
      latitude=35.8188166, longitude=14.5033988,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0d110dbb-c217-4d81-b4ea-d9a3a575786d_photo.jpg",
      averageRating=4.2, totalRatingsCount=59,
      createdAt="2026-09-01T09:12:42.534422Z", updatedAt="2026-09-01T09:12:42.534422Z",
    ),
    ClubDto(
      id="2444bc45-4ee8-4cb1-8a76-06da27cbba3b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Qormi FC", address="Triq Il-Belt Valletta, Ħal Qormi",
      city="Malta", country="MT",
      latitude=35.8826177, longitude=14.4763756,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/661a8265-ede4-48d1-b133-90c18bd7fa1f_photo.jpg",
      averageRating=4.2, totalRatingsCount=127,
      createdAt="2026-09-01T09:11:31.322445Z", updatedAt="2026-09-01T09:11:31.322445Z",
    ),
    ClubDto(
      id="82233f5b-f50c-4b41-b884-a5d257345df5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tal-Qroqq Sports Complex", address="WF3P+CXG, Msida",
      city="Malta", country="MT",
      latitude=35.9035514, longitude=14.4874664,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3abface5-7e94-41cb-8717-1ca4c38f5456_photo.jpg",
      averageRating=4.2, totalRatingsCount=946,
      createdAt="2026-09-01T09:12:18.716981Z", updatedAt="2026-09-01T09:12:18.716981Z",
    ),
    ClubDto(
      id="26a3ec98-3f14-4a83-99a5-5773dd826bc4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="IK Padel", address="WF3W+MMH, Triq Il-Forti Manoel, Il-Gżira",
      city="Malta", country="MT",
      latitude=35.9041821, longitude=14.4967255,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eb1b0f7a-c72f-4885-9045-14c2b4d4f882_photo.jpg",
      averageRating=4.1, totalRatingsCount=82,
      createdAt="2026-09-01T09:11:56.969334Z", updatedAt="2026-09-01T09:11:56.969334Z",
    ),
    ClubDto(
      id="2832e293-07b0-4e8c-a0ce-164ba6abc0cb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SuperBowl", address="Triq Santu Wistin, San Ġiljan STJ 3310",
      city="Malta", country="MT",
      latitude=35.9238541, longitude=14.4875699,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a5227ec4-7da6-4d80-805b-9a3ebd06f5df_photo.jpg",
      averageRating=4.1, totalRatingsCount=1147,
      createdAt="2026-09-01T09:12:47.403039Z", updatedAt="2026-09-01T09:12:47.403039Z",
    ),
    ClubDto(
      id="79fdd189-08ed-4370-a4c9-86ad4903aa98", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="HiTT Malta Table Tennis Ibragg Triq il Kwarta Swieqi Ibragg", address="Ibragg Church Annexe level -1 Triq il, Kwarta, Swieqi SWQ 2043",
      city="Malta", country="MT",
      latitude=35.9212316, longitude=14.4745198,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc3a1129-6392-428e-8c5b-9e5e8a771838_photo.jpg",
      averageRating=4.8, totalRatingsCount=40,
      createdAt="2026-09-01T09:12:37.261932Z", updatedAt="2026-09-01T09:12:37.261932Z",
    ),
    ClubDto(
      id="13d709fa-544b-47cf-948f-2aa96a314f37", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Malta Basketball Association", address="Parking lot, Attard",
      city="Malta", country="MT",
      latitude=35.8938941, longitude=14.4174242,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5d4ec2fa-5a7e-4f84-a7dc-940ef1ff2f8f_photo.jpg",
      averageRating=4.4, totalRatingsCount=43,
      createdAt="2026-09-01T09:12:14.385081Z", updatedAt="2026-09-01T09:12:14.385081Z",
    ),
    ClubDto(
      id="dc8bbaf0-7006-48cf-a539-f14354083d59", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Academy Malta", address="Aldo Moro Rd, Marsa MRS 9064",
      city="Malta", country="MT",
      latitude=35.8748829, longitude=14.4892838,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7774694b-e024-4c2b-bcf0-de086c308349_photo.jpg",
      averageRating=4.8, totalRatingsCount=39,
      createdAt="2026-09-01T09:12:26.684733Z", updatedAt="2026-09-01T09:12:26.684733Z",
    ),
    ClubDto(
      id="c7d3fe31-7458-4570-8ac9-bfffb907f676", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="IK Lija Padel", address="42 G. Barbara, Ħal Lija",
      city="Malta", country="MT",
      latitude=35.9026065, longitude=14.4491989,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f6c753e0-4435-4a71-b8ac-495f6d6af5a4_photo.jpg",
      averageRating=4.3, totalRatingsCount=23,
      createdAt="2026-09-01T09:12:00.957836Z", updatedAt="2026-09-01T09:12:00.957836Z",
    ),
    ClubDto(
      id="67713815-850b-4ddd-b6ad-1de7ed97933d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Sport Grounds", address="RGFH+WJC, Birżebbuġa",
      city="Malta", country="MT",
      latitude=35.8248023, longitude=14.5290206,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2dd95244-aacd-4aa5-81d1-85474805100a_photo.jpg",
      averageRating=4.3, totalRatingsCount=16,
      createdAt="2026-09-01T09:12:22.571987Z", updatedAt="2026-09-01T09:12:22.571987Z",
    ),
  )),
  CitySeo(slug="palma", name="Palma", country="ES", clubCount=24, sports=listOf(Pair("Volleyball", 5), Pair("Tennis", 4), Pair("Padel", 3), Pair("Football", 2), Pair("Karting", 2), Pair("Basketball", 2), Pair("Golf", 2), Pair("Climbing", 2), Pair("Bowling", 1), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="669942b3-19cc-448a-a9a1-9cb466d60e97", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club BeachVolley Balear", address="Passeig Mar, 07181 Palmanova, Illes Balears",
      city="Palma", country="ES",
      latitude=39.520716, longitude=2.5374053,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/161ba0bb-cc21-468e-9fe4-27b4dbb846b7_photo.jpg",
      averageRating=5.0, totalRatingsCount=77,
      createdAt="2026-09-01T08:54:36.203304Z", updatedAt="2026-09-01T08:54:36.203304Z",
    ),
    ClubDto(
      id="fdb0f303-f31a-4bc2-b31e-dfa8139ef050", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo NZA Beach Volley Academy CTEIB", address="Carrer Gremi de Forners, 4, Nord, 07009 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.6085973, longitude=2.6645885,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/18207650-3e75-4f21-b1ab-e4ca77d4870b_photo.jpg",
      averageRating=5.0, totalRatingsCount=54,
      createdAt="2026-09-01T08:54:26.514074Z", updatedAt="2026-09-01T08:54:26.514074Z",
    ),
    ClubDto(
      id="463ac8d1-2fe1-46d5-9039-5e5765bfa141", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Club Mallorca", address="Carrer George Sand, 4, Llevant, 07007 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5742562, longitude=2.6799845,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dfd42a0a-dade-419f-a06b-70cbe6aec439_photo.jpg",
      averageRating=4.7, totalRatingsCount=199,
      createdAt="2026-09-01T08:54:02.788598Z", updatedAt="2026-09-01T08:54:02.788598Z",
    ),
    ClubDto(
      id="dc0411cd-576d-4366-a25a-bdefe09df13d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palma Sport & Tennis Club", address="Carrer Joan Maria Thomàs, 4, Ponent, 07014 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5715956, longitude=2.6319437,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1f4c3ac1-b9e5-44b7-b9b9-99347257157d_photo.jpg",
      averageRating=4.6, totalRatingsCount=448,
      createdAt="2026-09-01T08:53:31.561060Z", updatedAt="2026-09-01T08:53:31.561060Z",
    ),
    ClubDto(
      id="a77af4b4-a62a-4ac5-bd0c-5a23da3d86cb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rocòdrom Es Cau", address="Carrer de Jaume Ferran, 72, Nord, 07004 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5840837, longitude=2.6603085,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/158b9190-336a-4464-9ae5-62a701ce5efd_photo.jpg",
      averageRating=4.6, totalRatingsCount=261,
      createdAt="2026-09-01T08:55:08.505534Z", updatedAt="2026-09-01T08:55:08.505534Z",
    ),
    ClubDto(
      id="b01affa2-5f48-44bf-b0e1-9eb7cb7376e6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mallorca Country Club | Tennis & Padel", address="Avinguda del Golf, 20, 07180 Santa Ponça, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5095763, longitude=2.5034827,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8f7ce5e5-703d-4a64-b02d-131e7e8cf073_photo.jpg",
      averageRating=4.5, totalRatingsCount=164,
      createdAt="2026-09-01T08:53:44.976679Z", updatedAt="2026-09-01T14:32:02.050155Z",
    ),
    ClubDto(
      id="135e7f03-a972-4583-a95c-13d56035d765", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vall D'or Golf", address="Ctra Cala d’Or - Portocolom, Km. 7,7, 07669 Felanitx, Illes Balears",
      city="Palma", country="ES",
      latitude=39.4311252, longitude=3.2173191,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cda265cc-daad-4bd9-896d-e0d76986c9cb_photo.jpg",
      averageRating=4.5, totalRatingsCount=888,
      createdAt="2026-09-01T08:54:48.121452Z", updatedAt="2026-09-01T08:54:48.121452Z",
    ),
    ClubDto(
      id="73cef2f5-ed8e-4791-aaed-29dd59bb50a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Son Muntaner", address="Carrer Miquel Lladó, s/n, Ponent, 07013 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.585708, longitude=2.6035442,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5151380a-84e5-41e0-a173-6f652d1d9009_photo.jpg",
      averageRating=4.4, totalRatingsCount=943,
      createdAt="2026-09-01T08:54:42.489591Z", updatedAt="2026-09-01T08:54:42.489591Z",
    ),
    ClubDto(
      id="79dc1a98-7b93-4539-a9e2-9fd1f7751fba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palma Padel", address="Carrer de Castellà la Manxa, 6, Ponent, 07013 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5856301, longitude=2.6226177,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e274986-dba4-4150-a6cc-bdc70a17952b_photo.jpg",
      averageRating=4.4, totalRatingsCount=794,
      createdAt="2026-09-01T08:53:51.452504Z", updatedAt="2026-09-01T14:31:51.171941Z",
    ),
    ClubDto(
      id="2423abaf-45b1-4d60-b317-56188438a560", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pins Pádel Club", address="Calle Lluis Ferbal, 7, Ponent, 07014 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.57538, longitude=2.61911,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c427dc83-c1e8-4cf5-a4ae-42a410ce0320_photo.jpg",
      averageRating=4.4, totalRatingsCount=651,
      createdAt="2026-09-01T08:53:57.359345Z", updatedAt="2026-09-01T08:53:57.359345Z",
    ),
    ClubDto(
      id="a2cad3b9-84d2-48d0-abfe-da8a676ad382", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palma Racket Club", address="Carrer de Galícia, 7, Ponent, 07013 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5814808, longitude=2.6247618,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ad8aaaab-2e55-4682-9a25-3415f9ca0798_photo.jpg",
      averageRating=4.3, totalRatingsCount=658,
      createdAt="2026-09-01T08:53:26.901346Z", updatedAt="2026-09-01T08:53:26.901346Z",
    ),
    ClubDto(
      id="edf52650-c094-4950-a69c-ef1da852135e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Voleibol Pòrtol", address="Carrer de Montcaire, 26, Cas Miot, 07141 Es Pont d'Inca Nou, Illes Balears",
      city="Palma", country="ES",
      latitude=39.6044184, longitude=2.6943128,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4bc5ad89-c28b-4b52-b59f-11a4dc25474f_photo.jpg",
      averageRating=4.2, totalRatingsCount=96,
      createdAt="2026-09-01T08:54:18.642232Z", updatedAt="2026-09-01T08:54:18.642232Z",
    ),
    ClubDto(
      id="5273c7cb-5f08-4638-8301-3af67b926860", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kart Magaluf", address="Camí Porrassa, s/n, 07181, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5038495, longitude=2.5230092,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eff9e600-23f4-40f5-ad46-728905cdeed2_photo.jpg",
      averageRating=4.2, totalRatingsCount=1036,
      createdAt="2026-09-01T08:54:52.033538Z", updatedAt="2026-09-01T08:54:52.033538Z",
    ),
    ClubDto(
      id="59602b59-88f1-46e2-b086-f86759d49097", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Udyr Sport · Club Deportivo l Pádel, Tenis y Piscina", address="Carrer de Son Bessó, 15, Nord, 07120 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.6088889, longitude=2.6516667,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/202cd157-b231-4b84-8176-d88ca333ea4e_photo.jpg",
      averageRating=4.2, totalRatingsCount=755,
      createdAt="2026-09-01T08:53:20.085403Z", updatedAt="2026-09-01T14:31:50.475339Z",
    ),
    ClubDto(
      id="8f63dde0-699d-42f3-b729-821fa91697d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club de bàsquet La Salle Palma", address="Camí de Son Rapinya, 29, Ponent, 07013 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5812411, longitude=2.6206725,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f3190c0b-3087-4e36-a54d-b520ba76924f_photo.jpg",
      averageRating=4.1, totalRatingsCount=203,
      createdAt="2026-09-01T08:54:12.854910Z", updatedAt="2026-09-01T08:54:12.854910Z",
    ),
    ClubDto(
      id="ab6b29df-0f87-45f3-9078-ac14468540d2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Palma Palace Pool Bar", address="Carrer Aragó, 186A, Llevant, 07008 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5853667, longitude=2.6728682,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e7be458-af7e-49c3-af07-a63ad43258f5_photo.jpg",
      averageRating=4.1, totalRatingsCount=119,
      createdAt="2026-09-01T08:55:12.399548Z", updatedAt="2026-09-01T08:55:12.399548Z",
    ),
    ClubDto(
      id="8cd4ce37-bbb5-4069-b719-49ab5c0edffc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CIRCUIT MALLORCA LLUCMAJOR", address="Ma-19, km 16.800, 07620, Illes Balears",
      city="Palma", country="ES",
      latitude=39.4942321, longitude=2.7948093,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7f8482eb-fcba-4ea7-bf26-6096bb8f6e1d_photo.jpg",
      averageRating=4.0, totalRatingsCount=567,
      createdAt="2026-09-01T08:54:56.035494Z", updatedAt="2026-09-01T08:54:56.035494Z",
    ),
    ClubDto(
      id="fa5e2c99-7d1c-47a8-b34f-29c8dd0ca078", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Consorci Velòdrom Illes Balears", address="Carrer de l'Uruguai, s/n, Nord, 07010 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5878486, longitude=2.643579,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/64ce1951-0331-4e93-8969-761e06b8814e_photo.jpg",
      averageRating=4.0, totalRatingsCount=639,
      createdAt="2026-09-01T08:54:06.846869Z", updatedAt="2026-09-01T08:54:06.846869Z",
    ),
    ClubDto(
      id="1552ccfc-762a-4c56-8e53-e3482e0bbc74", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mallorca Bowling", address="Camí dels Reis, 211, Ponent, 07011 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5949547, longitude=2.6354121,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3b27930c-7cea-44c1-a94e-6a415bf19f8e_photo.jpg",
      averageRating=4.0, totalRatingsCount=1925,
      createdAt="2026-09-01T08:55:00.465764Z", updatedAt="2026-09-01T08:55:00.465764Z",
    ),
    ClubDto(
      id="4756ab7f-d888-4c9f-80b7-bed1e4ae936b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Anima Beach Palma", address="Autopista de Llevant, s/n, Llevant, 07006 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.563766, longitude=2.6582952,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b899cceb-1856-465f-ac63-6ca3f9911fca_photo.jpg",
      averageRating=3.9, totalRatingsCount=6097,
      createdAt="2026-09-01T08:54:31.148436Z", updatedAt="2026-09-01T08:54:31.148436Z",
    ),
    ClubDto(
      id="cfccf6ff-2cc5-463e-856c-f9dd78ff9515", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoorwall Mallorca", address="Carrer Gremí de Corredors, 39, Norte, 07009 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.6058545, longitude=2.6560403,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/900b65c0-9db7-4ded-9699-c1501d6aa9c8_photo.jpg",
      averageRating=3.9, totalRatingsCount=449,
      createdAt="2026-09-01T08:55:03.926884Z", updatedAt="2026-09-01T08:55:03.926884Z",
    ),
    ClubDto(
      id="6085b8c0-bb7a-4f29-a462-1f62489456a5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brisasport", address="Avinguda de Bartomeu Riutort, 101, Platja de Palma i Pla de Sant Jordi, 07610 Can Pastilla, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5311793, longitude=2.7277619,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3cd93ab8-f457-4ae6-80ef-579253b7fb50_photo.jpg",
      averageRating=3.8, totalRatingsCount=181,
      createdAt="2026-09-01T08:53:10.256034Z", updatedAt="2026-09-01T08:53:10.256034Z",
    ),
    ClubDto(
      id="b8ff515c-9766-4222-9c9a-e5aafa52e8bb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Voley Ciutat Cide", address="Carrer de l'Arner, 5, Ponent, 07013 Sa Vileta - Son Rapinya, Illes Balears",
      city="Palma", country="ES",
      latitude=39.59044, longitude=2.6102029,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed9bd5d4-6162-4745-a71c-ff1a23891655_photo.jpg",
      averageRating=3.8, totalRatingsCount=59,
      createdAt="2026-09-01T08:54:22.349621Z", updatedAt="2026-09-01T08:54:22.349621Z",
    ),
    ClubDto(
      id="6ce24d3b-5970-47b8-8a01-a2f941d35e11", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Poliesportiu Sant Ferran", address="Camí de Ca l'Ardiaca, Nord, 07010 Palma, Illes Balears",
      city="Palma", country="ES",
      latitude=39.5901792, longitude=2.6413479,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b831db00-828d-44f6-897a-d2ad99d31678_photo.jpg",
      averageRating=4.2, totalRatingsCount=36,
      createdAt="2026-09-01T08:53:15.194434Z", updatedAt="2026-09-01T08:53:15.194434Z",
    ),
  )),
  CitySeo(slug="skopje", name="Skopje", country="MK", clubCount=23, sports=listOf(Pair("Football", 5), Pair("Basketball", 3), Pair("Tennis", 3), Pair("Volleyball", 3), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Laser Tag", 2), Pair("Golf", 1), Pair("Paintball", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="b4dcc3d0-40ae-47a5-8d51-5e333fb97dd3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ATG Macedonia Fitness Center", address="Braka Galevi 16, Skopje 1000",
      city="Skopje", country="MK",
      latitude=42.000889, longitude=21.3741438,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/417ff800-e28d-4009-8c20-b1bc6ad344d0_photo.jpg",
      averageRating=5.0, totalRatingsCount=261,
      createdAt="2026-09-01T09:19:48.244931Z", updatedAt="2026-09-01T09:19:48.244931Z",
    ),
    ClubDto(
      id="ec85d08f-7ee7-42fd-b43d-c60239a285f6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Jane Sandanski Sports Center", address="ASNOM Blvd 1000, Skopje 1000",
      city="Skopje", country="MK",
      latitude=41.9932534, longitude=21.4645728,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/35064628-568d-4860-b864-520e1d63ff14_photo.jpg",
      averageRating=4.7, totalRatingsCount=1633,
      createdAt="2026-09-01T09:19:07.302420Z", updatedAt="2026-09-01T09:19:07.302420Z",
    ),
    ClubDto(
      id="d8533572-2e9f-490e-b58f-8e2057752e57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball arena Best", address="Justinijan Prvi, Drachevo",
      city="Skopje", country="MK",
      latitude=41.9412958, longitude=21.5020587,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/26ef2b77-3277-4c8d-82d9-fd33de42e326_photo.jpg",
      averageRating=4.7, totalRatingsCount=183,
      createdAt="2026-09-01T09:20:51.607226Z", updatedAt="2026-09-01T09:20:51.607226Z",
    ),
    ClubDto(
      id="19da9f1f-3384-4738-a1aa-7c58ae846b99", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gran Klub", address="50-та Дивизија 24a, Skopje 1000",
      city="Skopje", country="MK",
      latitude=41.989285, longitude=21.4260989,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d675b5fc-ed7c-4fee-8ede-250baadc2118_photo.jpg",
      averageRating=4.6, totalRatingsCount=467,
      createdAt="2026-09-01T09:20:30.112237Z", updatedAt="2026-09-01T09:20:30.112237Z",
    ),
    ClubDto(
      id="5b5d6e1f-d005-481b-b2c5-2f56ab3605bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Magnus", address="XCQM+595, Boulevard Macedonia, Skopje 1000",
      city="Skopje", country="MK",
      latitude=41.987898, longitude=21.4334893,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8c840357-b8d4-4593-b3b6-971c74880574_photo.jpg",
      averageRating=4.6, totalRatingsCount=138,
      createdAt="2026-09-01T09:19:52.882462Z", updatedAt="2026-09-01T09:19:52.882462Z",
    ),
    ClubDto(
      id="d76c93df-ee3d-4314-b73f-c61d6e1f39ad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Subway Arena - LaserTag / Сабвеј Арена - ЛасерТаг", address="Orce Nikolov 188, 1000, Skopje 1000",
      city="Skopje", country="MK",
      latitude=42.006476, longitude=21.407544,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7c610acb-1fc1-4863-ad64-ca283a57e758_photo.jpg",
      averageRating=4.6, totalRatingsCount=59,
      createdAt="2026-09-01T09:20:46.086141Z", updatedAt="2026-09-01T09:20:46.086141Z",
    ),
    ClubDto(
      id="9f11fcd5-af90-46d4-a186-3b8c6b948611", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Adventure Park Skopje", address="Karposh, Skopje 1000",
      city="Skopje", country="MK",
      latitude=42.0089749, longitude=21.3929769,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7deb1ff6-559b-40d6-b520-99d9ae02890f_photo.jpg",
      averageRating=4.5, totalRatingsCount=123,
      createdAt="2026-09-01T09:19:58.114860Z", updatedAt="2026-09-01T09:19:58.114860Z",
    ),
    ClubDto(
      id="11e8446c-af59-4a3a-a232-6c7377cdf165", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laserhunt Fun Center Macedonia", address="Mariovska, Skopje 1000",
      city="Skopje", country="MK",
      latitude=41.973659, longitude=21.4375827,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dbf69dfe-4d8f-4644-96d2-1219c9208181_photo.jpg",
      averageRating=4.5, totalRatingsCount=251,
      createdAt="2026-09-01T09:20:40.281496Z", updatedAt="2026-09-01T09:20:40.281496Z",
    ),
    ClubDto(
      id="652a63b0-7b0a-4065-bfb9-7a4db978c304", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Center “Marko Bozinovski”", address="XFJH+G56, Skopje 1000",
      city="Skopje", country="MK",
      latitude=41.9812827, longitude=21.4778842,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/26c6d00d-feb2-4c8d-945a-66df457901cf_photo.jpg",
      averageRating=4.5, totalRatingsCount=302,
      createdAt="2026-09-01T09:19:16.149340Z", updatedAt="2026-09-01T09:19:16.149340Z",
    ),
    ClubDto(
      id="251080d1-63ca-454b-8dad-08a714f422cd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Todor Proeski National Arena", address="Стадион Филип Втори, Leninova, Skopje 1000",
      city="Skopje", country="MK",
      latitude=42.0057329, longitude=21.4255963,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d6b43212-42c4-423e-9b45-4ba9573c18a4_photo.jpg",
      averageRating=4.5, totalRatingsCount=3152,
      createdAt="2026-09-01T09:19:03.377673Z", updatedAt="2026-09-01T09:19:03.377673Z",
    ),
    ClubDto(
      id="ed7faa60-a238-406f-bdb6-0118495549da", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club Jug", address="Gradski Park b.b, 1000, Skopje 1000",
      city="Skopje", country="MK",
      latitude=42.006488, longitude=21.4214301,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99e1b066-c2b0-478d-807f-f6cffa6cd61c_photo.jpg",
      averageRating=4.4, totalRatingsCount=185,
      createdAt="2026-09-01T09:19:35.101379Z", updatedAt="2026-09-01T09:19:35.101379Z",
    ),
    ClubDto(
      id="f7034b52-01a7-4778-b1b8-522a3347cb77", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Courts Aleksandar Palace", address="2C64+M76, Vardar Trail, Skopje 1000",
      city="Skopje", country="MK",
      latitude=42.0116511, longitude=21.4056302,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a784c0a-4d8f-49ca-a4b6-4770635e7be7_photo.jpg",
      averageRating=4.4, totalRatingsCount=384,
      createdAt="2026-09-01T09:19:25.539673Z", updatedAt="2026-09-01T09:19:25.539673Z",
    ),
    ClubDto(
      id="cd36c4b2-3f5b-4fb9-9f5c-62caf12d6d1d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скај Карт", address="Unnamed Road, Vollkova",
      city="Skopje", country="MK",
      latitude=42.0412675, longitude=21.3539219,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/751bfa18-8c0b-4b55-8abc-9e24b14fa88d_photo.jpg",
      averageRating=4.4, totalRatingsCount=400,
      createdAt="2026-09-01T09:20:12.851058Z", updatedAt="2026-09-01T09:20:12.851058Z",
    ),
    ClubDto(
      id="2e42031a-f1e0-4d87-82fe-d4a8d39ca3fe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Forza Sport Center", address="Boulevard Ilinden, Skopje 1000",
      city="Skopje", country="MK",
      latitude=42.0063169, longitude=21.4118924,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/66676596-aa14-4a34-a26c-c27248a53324_photo.jpg",
      averageRating=4.3, totalRatingsCount=278,
      createdAt="2026-09-01T09:19:21.338903Z", updatedAt="2026-09-01T09:19:21.338903Z",
    ),
    ClubDto(
      id="30550f1c-e70b-4fdc-980c-f7e8980595a9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Olympic Pool - Center", address="Boulevard Krushevska Republika, Skopje 1000",
      city="Skopje", country="MK",
      latitude=41.9912307, longitude=21.4389539,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6615fb80-3c8e-4810-a4d1-23c2d58c1c4b_photo.jpg",
      averageRating=4.3, totalRatingsCount=685,
      createdAt="2026-09-01T09:19:39.490550Z", updatedAt="2026-09-01T09:19:39.490550Z",
    ),
    ClubDto(
      id="1bb2f765-2aff-457e-91bc-a8223aa80bf3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ATK Premium Club", address="Skopje 1000",
      city="Skopje", country="MK",
      latitude=42.0087003, longitude=21.4052145,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ce42d98a-2831-47c4-ae72-8ae32bfa3846_photo.jpg",
      averageRating=4.2, totalRatingsCount=336,
      createdAt="2026-09-01T09:19:30.778647Z", updatedAt="2026-09-01T09:19:30.778647Z",
    ),
    ClubDto(
      id="af095597-d76b-4476-bd6e-b1f2b5a9261a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Center Aerodrom", address="XCPX+7V6, Franjo Kluz, Skopje 1000",
      city="Skopje", country="MK",
      latitude=41.985671, longitude=21.4496362,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0e3a70c2-4264-44a6-9a36-8fd563941b9a_photo.jpg",
      averageRating=4.2, totalRatingsCount=113,
      createdAt="2026-09-01T09:20:01.990965Z", updatedAt="2026-09-01T09:20:01.990965Z",
    ),
    ClubDto(
      id="5c022cda-1965-4e7c-b65e-6d3f1cdccc36", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="4Bowling", address="Boulevard Jane Sandanski 3, Skopje 1000",
      city="Skopje", country="MK",
      latitude=41.9862223, longitude=21.4665154,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ccb7088-7cca-40cf-96d5-555920d8fc7a_photo.jpg",
      averageRating=4.0, totalRatingsCount=119,
      createdAt="2026-09-01T09:20:17.248484Z", updatedAt="2026-09-01T09:20:17.248484Z",
    ),
    ClubDto(
      id="d5d56619-2e4c-4b13-94f4-edc248471a47", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kale Sports Hall", address="2C3J+6HM, Lazar Lichenoski St. Lazar Licenovski 31, Skopje 1000",
      city="Skopje", country="MK",
      latitude=42.0028398, longitude=21.4314082,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9688a8c5-eb80-49cb-8cba-dcfbc82f385c_photo.jpg",
      averageRating=4.0, totalRatingsCount=302,
      createdAt="2026-09-01T09:19:43.756825Z", updatedAt="2026-09-01T09:19:43.756825Z",
    ),
    ClubDto(
      id="e38f7618-7fe7-41bc-b721-0ae2b883205a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MTP Sports Club", address="Georgi Dimitrov bb, Skopje 1000",
      city="Skopje", country="MK",
      latitude=41.9995829, longitude=21.4020934,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ab5ea369-e8be-411b-bdb7-6b5a9dd22071_photo.jpg",
      averageRating=4.0, totalRatingsCount=389,
      createdAt="2026-09-01T09:19:12.066436Z", updatedAt="2026-09-01T14:32:01.917168Z",
    ),
    ClubDto(
      id="8b4f1095-159a-4510-8930-3b48834a69f7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sky Wellness - Community Fitness & Health Club", address="Mateja Mateski 22, Shkupi 1000",
      city="Skopje", country="MK",
      latitude=41.9800493, longitude=21.4658066,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1a35a072-429a-49f9-aa0b-e2857697a359_photo.jpg",
      averageRating=3.8, totalRatingsCount=199,
      createdAt="2026-09-01T09:20:35.728097Z", updatedAt="2026-09-01T09:20:35.728097Z",
    ),
    ClubDto(
      id="5c361070-8811-49b3-a3fe-01f2207d63e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Club Ohrid CZG", address="Klenoec 1, Ohrid 6000",
      city="Skopje", country="MK",
      latitude=41.1310721, longitude=20.8127989,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/75aaeddd-442c-465f-8c65-af59ba06a2c3_photo.jpg",
      averageRating=4.8, totalRatingsCount=31,
      createdAt="2026-09-01T09:20:08.038448Z", updatedAt="2026-09-01T09:20:08.038448Z",
    ),
    ClubDto(
      id="dc4b30c6-345a-408f-a9e0-f77c4b1af8d7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Musandra Bowling Alley", address="XCVM+R9H, 11th October St., Skopje 1000",
      city="Skopje", country="MK",
      latitude=41.9945621, longitude=21.4334923,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d764d4b1-15c2-4878-bd9d-a003cc72ad01_photo.jpg",
      averageRating=4.2, totalRatingsCount=33,
      createdAt="2026-09-01T09:20:24.367085Z", updatedAt="2026-09-01T09:20:24.367085Z",
    ),
  )),
  CitySeo(slug="limassol", name="Limassol", country="CY", clubCount=23, sports=listOf(Pair("Football", 4), Pair("Tennis", 4), Pair("Basketball", 3), Pair("Padel", 3), Pair("Volleyball", 2), Pair("Paintball", 2), Pair("Billiards", 1), Pair("Golf", 1), Pair("Climbing", 1), Pair("Laser Tag", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="600b0673-8ab1-4bc2-a8a8-f41ecd39feef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laserwar Club - Lasertag Games", address="Limassol 3112",
      city="Limassol", country="CY",
      latitude=34.7136546, longitude=33.0057995,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/622d595c-4d0c-4b80-9c88-b6ae97ba80c2_photo.jpg",
      averageRating=5.0, totalRatingsCount=284,
      createdAt="2026-09-01T09:11:01.611533Z", updatedAt="2026-09-01T09:11:01.611533Z",
    ),
    ClubDto(
      id="92f0dc0d-3e48-422d-9b07-ba9fb7e0df40", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Green Padel Club", address="Ποταμιάς 157, Germasogeia, Lemesos 4045",
      city="Limassol", country="CY",
      latitude=34.7374447, longitude=33.0848869,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e49fc7f-c141-4dee-9257-7dc5897c9319_photo.jpg",
      averageRating=4.9, totalRatingsCount=83,
      createdAt="2026-09-01T09:10:12.456809Z", updatedAt="2026-09-01T09:10:12.456809Z",
    ),
    ClubDto(
      id="6488d947-833d-431f-b0a5-7fbf578feb84", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Syndicate", address="Limassol 3117",
      city="Limassol", country="CY",
      latitude=34.7111615, longitude=33.0246455,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/11e81879-5046-4694-97e4-d46c8ea2efea_photo.jpg",
      averageRating=4.9, totalRatingsCount=91,
      createdAt="2026-09-01T09:10:07.790132Z", updatedAt="2026-09-01T09:10:07.790132Z",
    ),
    ClubDto(
      id="474ebe47-9119-4190-96c3-e8616b7b8114", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball In Action Cyprus", address="QX3J+JQ4, Palodia, Limassol 4549",
      city="Limassol", country="CY",
      latitude=34.7540051, longitude=32.9819507,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83844ec2-1494-425e-adf0-8e287fd8c045_photo.jpg",
      averageRating=4.9, totalRatingsCount=98,
      createdAt="2026-09-01T09:11:10.527013Z", updatedAt="2026-09-01T09:11:10.527013Z",
    ),
    ClubDto(
      id="ce9b550a-6611-4cc0-9fc6-39e64a6526f4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cyprus Paintball", address="A1, Πύργος, Limasol 4529",
      city="Limassol", country="CY",
      latitude=34.7229433, longitude=33.1976116,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fddfe18d-9b6d-45d4-b3c7-9aa7289bac95_photo.jpg",
      averageRating=4.8, totalRatingsCount=201,
      createdAt="2026-09-01T09:11:05.851515Z", updatedAt="2026-09-01T09:11:05.851515Z",
    ),
    ClubDto(
      id="00788579-0fad-494b-934e-90fe17ca0c89", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LCC Limassol Climbing Club", address="Lamprou Porfira 2A, Lemesos 3100",
      city="Limassol", country="CY",
      latitude=34.6901371, longitude=33.0582831,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/93b0cd19-1bbf-43d1-93da-e105a42e4705_photo.jpg",
      averageRating=4.7, totalRatingsCount=70,
      createdAt="2026-09-01T09:10:53.459081Z", updatedAt="2026-09-01T09:10:53.459081Z",
    ),
    ClubDto(
      id="44df014c-6e50-4a72-a59b-8ba9bdaf0844", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="THE TENNIS & PADEL ACADEMY LIMASSOL", address="Eleutherias Αvenue, Palodeia, Lemesos 3119",
      city="Limassol", country="CY",
      latitude=34.735404, longitude=33.009174,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/66ed15a9-aa69-48d0-be9f-12191e83a36b_photo.jpg",
      averageRating=4.7, totalRatingsCount=77,
      createdAt="2026-09-01T09:09:49.089965Z", updatedAt="2026-09-01T14:32:03.013Z",
    ),
    ClubDto(
      id="51e224a2-9170-4788-b9e3-5cea26310444", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Korineum Golf & Beach Resort", address="Esentepe Yolu üzeri 10. Km Esentepe- Girne North Cyprus Girne, Esentepe",
      city="Limassol", country="CY",
      latitude=35.3256393, longitude=33.5165036,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/46190469-8710-4a5d-9563-c7700cb872a6_photo.jpg",
      averageRating=4.6, totalRatingsCount=1055,
      createdAt="2026-09-01T09:10:45.013129Z", updatedAt="2026-09-01T09:10:45.013129Z",
    ),
    ClubDto(
      id="5bfac0aa-d6ab-4d4d-9925-ae3551f9193a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="NAIS Sports Club", address="Agias Paraskevis 12, Germasogeia, Lemesos 4045",
      city="Limassol", country="CY",
      latitude=34.709074, longitude=33.0874723,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7dd0f705-1490-4bef-a6f8-20bc1ea5d261_photo.jpg",
      averageRating=4.5, totalRatingsCount=86,
      createdAt="2026-09-01T09:09:28.467303Z", updatedAt="2026-09-01T14:31:44.874195Z",
    ),
    ClubDto(
      id="43762b98-50da-4583-876a-9016b0eda9f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Need4Speed Go Karting", address="Leoforos Troodous 1, Çanakkale, Limasol 4631",
      city="Limassol", country="CY",
      latitude=34.6837386, longitude=32.9109195,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a78842c9-b9be-4b4c-9d8a-b53108e9957c_photo.jpg",
      averageRating=4.5, totalRatingsCount=292,
      createdAt="2026-09-01T09:10:49.395961Z", updatedAt="2026-09-01T09:10:49.395961Z",
    ),
    ClubDto(
      id="07c08d04-f810-4411-929d-4ff2beb89d0c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="goALL Padel Centers Limassol", address="Δομινίτσας Λανίτου Καβουδίνου, Lemesos 3080",
      city="Limassol", country="CY",
      latitude=34.7033799, longitude=33.0245359,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9dacbfd8-069b-4a8f-94a9-b25b12c0fbaa_photo.jpg",
      averageRating=4.5, totalRatingsCount=71,
      createdAt="2026-09-01T09:10:16.596404Z", updatedAt="2026-09-01T14:31:54.673002Z",
    ),
    ClubDto(
      id="705e98f4-123c-4d0c-a0df-8fd8880cdbf2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Football Park", address="M2MG+P3W, Limassol 3071",
      city="Limassol", country="CY",
      latitude=34.6843509, longitude=33.0252115,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6c713840-0117-4b0a-a299-f681814adb8f_photo.jpg",
      averageRating=4.6, totalRatingsCount=48,
      createdAt="2026-09-01T09:09:36.933274Z", updatedAt="2026-09-01T09:09:36.933274Z",
    ),
    ClubDto(
      id="b5c82963-df0b-49db-b565-1d4bb2e66c57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Wembley Ypsonas Mini Football Limassol", address="MXJG+JQH, Ilia Kannaourou, Ypsonas, Lemesos 4186",
      city="Limassol", country="CY",
      latitude=34.6815588, longitude=32.9769757,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f8b9e7c8-cf3d-4aaf-b8c4-9e50c5e4ad0d_photo.jpg",
      averageRating=4.4, totalRatingsCount=64,
      createdAt="2026-09-01T09:09:33.192919Z", updatedAt="2026-09-01T09:09:33.192919Z",
    ),
    ClubDto(
      id="85ae8be9-c725-4e89-8dd0-051555a62e54", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Valley Sports Arena", address="Kalogiron 5, Germasogeia, Lemesos 4045",
      city="Limassol", country="CY",
      latitude=34.711282, longitude=33.0908847,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/43fb4a08-c521-43cc-b112-da7f33f34732_photo.jpg",
      averageRating=4.4, totalRatingsCount=48,
      createdAt="2026-09-01T09:09:44.180012Z", updatedAt="2026-09-01T09:09:44.180012Z",
    ),
    ClubDto(
      id="f8dab183-281f-46b1-9e50-8a97f2ffbc92", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Apollon Limassol Basketball Stadium", address="Limassol 3012",
      city="Limassol", country="CY",
      latitude=34.669621, longitude=33.0259913,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/666456da-ab13-47bc-9a2a-d6f8293669f2_photo.jpg",
      averageRating=4.2, totalRatingsCount=39,
      createdAt="2026-09-01T09:10:20.513936Z", updatedAt="2026-09-01T09:10:20.513936Z",
    ),
    ClubDto(
      id="b1e4e3fb-8566-48c6-b972-9bd419b14985", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SMASH PADEL AND TENNIS ACADEMY", address="113th St 20, Kato Polemidia, Lemesos 4130",
      city="Limassol", country="CY",
      latitude=34.7002634, longitude=32.9934294,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9c082215-7d5c-4de7-b085-9049bd1058d3_photo.jpg",
      averageRating=4.5, totalRatingsCount=35,
      createdAt="2026-09-01T09:09:52.697356Z", updatedAt="2026-09-01T14:31:52.813965Z",
    ),
    ClubDto(
      id="de6d9f17-7165-4e3b-8f11-19a3e14a5488", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="IOANNIDES TENNIS ACADEMY - Limassol", address="Ypsonas, Akrotiri and Dhekelia 4186, United Kingdom",
      city="Limassol", country="CY",
      latitude=34.6748938, longitude=32.9794825,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/16dd3553-82c8-44b7-bc70-06985623a04d_photo.jpg",
      averageRating=4.4, totalRatingsCount=32,
      createdAt="2026-09-01T09:09:57.780593Z", updatedAt="2026-09-01T09:09:57.780593Z",
    ),
    ClubDto(
      id="5ad988e8-ee77-4198-a58b-ac754296d063", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Marcos Baghdatis Tennis Academy", address="Nikou Kavvadia, Lemesos 3150",
      city="Limassol", country="CY",
      latitude=34.6496802, longitude=32.9932145,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9ddc1232-b3d4-48ac-afa1-2986c9d89da5_photo.jpg",
      averageRating=4.6, totalRatingsCount=27,
      createdAt="2026-09-01T09:10:03.451047Z", updatedAt="2026-09-01T09:10:03.451047Z",
    ),
    ClubDto(
      id="e37356ab-284a-4f53-8c2d-22eb75e1fbb3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Δημοτικό Κέντρο Αθλημάτων Παραλίας / Municipal Beach Sports Center", address="M3P8+VF2, 28 October Ave, Lemesos 3107",
      city="Limassol", country="CY",
      latitude=34.6871352, longitude=33.0661343,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d3f273b-9aee-477e-8cd3-7b8e57d9982b_photo.jpg",
      averageRating=4.5, totalRatingsCount=20,
      createdAt="2026-09-01T09:10:25.787237Z", updatedAt="2026-09-01T09:10:25.787237Z",
    ),
    ClubDto(
      id="800bb9c8-9066-40b6-83c4-8967561d084a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ARENA Billiards Club", address="Agiou Georgiou 4189, Ypsonas, Lemesos 4189",
      city="Limassol", country="CY",
      latitude=34.6814654, longitude=32.9510006,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d2a311f-7691-444d-8262-a04c1028ceca_photo.jpg",
      averageRating=4.8, totalRatingsCount=17,
      createdAt="2026-09-01T09:10:56.900014Z", updatedAt="2026-09-01T09:10:56.900014Z",
    ),
    ClubDto(
      id="af3a98ca-2d36-425f-9735-e37a94d2b4ef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LSC Sporting Center", address="Grigori Afxentiou 58, Kato Polemidia, Lemesos 4159",
      city="Limassol", country="CY",
      latitude=34.7032862, longitude=32.9882406,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3759b579-d9d4-4d27-8aaa-893b7a380398_photo.jpg",
      averageRating=4.4, totalRatingsCount=17,
      createdAt="2026-09-01T09:10:35.588348Z", updatedAt="2026-09-01T09:10:35.588348Z",
    ),
    ClubDto(
      id="9aae2dac-c5dc-459e-9d0c-42e19ad9aef6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fitidio Athletic Center GSO", address="M3J3+G96, Νικολάου, Lemesos 3035",
      city="Limassol", country="CY",
      latitude=34.6812841, longitude=33.0534015,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b25402d1-61aa-46c6-8e8c-cf12111b9148_photo.jpg",
      averageRating=3.5, totalRatingsCount=19,
      createdAt="2026-09-01T09:10:30.928174Z", updatedAt="2026-09-01T09:10:30.928174Z",
    ),
    ClubDto(
      id="2b1863d8-5f5f-4f71-b783-94b774e71c48", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Apollon Limassol Athletic Club", address="Μεσολογγίου 1, Lemesos 3032",
      city="Limassol", country="CY",
      latitude=34.6815597, longitude=33.0471402,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a873d31-2c29-4be5-9c56-196e73ec2eca_photo.jpg",
      averageRating=4.9, totalRatingsCount=11,
      createdAt="2026-09-01T09:10:39.634115Z", updatedAt="2026-09-01T09:10:39.634115Z",
    ),
  )),
  CitySeo(slug="manchester", name="Manchester", country="GB", clubCount=23, sports=listOf(Pair("Football", 4), Pair("Basketball", 3), Pair("Table Tennis", 2), Pair("Paintball", 2), Pair("Climbing", 2), Pair("Bowling", 2), Pair("Volleyball", 2), Pair("Billiards", 2), Pair("Karting", 2), Pair("Laser Tag", 1), Pair("Golf", 1)), clubs=listOf(
    ClubDto(
      id="4bf29d0a-e489-4be4-a3a5-f475a19c58e7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Altrincham Table Tennis Social Group", address="Marlborough Rd, Bowdon Rise, Hale, Altrincham WA14 2RS",
      city="Manchester", country="GB",
      latitude=53.3753685, longitude=-2.3503325,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8033c776-5e68-49b9-b439-72b83e4f7658_photo.jpg",
      averageRating=5.0, totalRatingsCount=82,
      createdAt="2026-08-31T15:31:34.446320Z", updatedAt="2026-08-31T15:31:34.446320Z",
    ),
    ClubDto(
      id="e02e4edd-0d5f-4b86-b83e-3b9c0224ca0e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Depot Climbing Manchester", address="N1, N2, Central Park Estate, Central Park Trading Estate, 14 Mosley Rd, Trafford Park, Stretford, Manchester M17 1PG",
      city="Manchester", country="GB",
      latitude=53.4639754, longitude=-2.3207343,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6f657738-7134-4e2a-8d54-e3d2aa114617_ChIJB8K3P4au_0.jpg",
      averageRating=4.8, totalRatingsCount=1577,
      createdAt="2026-08-30T23:15:13.962119Z", updatedAt="2026-08-31T08:27:19.076512Z",
    ),
    ClubDto(
      id="81546bb9-8da6-4589-a2c4-4c0cb28006d7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lane7 Manchester", address="Unit 3, 235 Deansgate, Manchester M3 4EN",
      city="Manchester", country="GB",
      latitude=53.4776532, longitude=-2.2491125,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04a85bdb-1085-49c7-be97-9bbf8652a896_ChIJSYviVW2x_0.jpg",
      averageRating=4.8, totalRatingsCount=4488,
      createdAt="2026-08-30T23:15:08.156358Z", updatedAt="2026-08-30T23:15:08.156358Z",
    ),
    ClubDto(
      id="84368a27-88ee-4967-9e17-186bcf5c4fc0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="National Basketball Performance Centre", address="Kirkmanshulme Ln, Manchester M12 4TF",
      city="Manchester", country="GB",
      latitude=53.460041, longitude=-2.1911988,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2a285fde-8e00-44de-a08d-21de0d2472b1_photo.jpg",
      averageRating=4.8, totalRatingsCount=206,
      createdAt="2026-08-31T15:30:52.206964Z", updatedAt="2026-08-31T15:30:52.206964Z",
    ),
    ClubDto(
      id="654e4bd7-d148-4ab4-b3d9-9b72485a734a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Roxy Ball Room Manchester Arndale", address="Unit R3, Withy Grove, Manchester M4 3AQ",
      city="Manchester", country="GB",
      latitude=53.4844558, longitude=-2.2411556,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a32df180-606d-4dc9-9201-d98a1fa6e4ad_ChIJO4tlBXKx_0.jpg",
      averageRating=4.8, totalRatingsCount=2394,
      createdAt="2026-08-30T23:14:55.038087Z", updatedAt="2026-08-31T08:35:26.288471Z",
    ),
    ClubDto(
      id="5843c744-d663-447c-85c8-fc3b5a41e926", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Roxy Ball Room Manchester Deansgate", address="76-78 Deansgate, Manchester M3 2FN",
      city="Manchester", country="GB",
      latitude=53.4828103, longitude=-2.2471387,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ff73e86-be0f-425d-993c-b418be732a31_ChIJ4TfBisOx_0.jpg",
      averageRating=4.8, totalRatingsCount=3748,
      createdAt="2026-08-30T23:14:47.907823Z", updatedAt="2026-08-31T08:35:26.688013Z",
    ),
    ClubDto(
      id="a744083d-f454-4cfd-bc5d-53acdff23747", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Delta Force Paintball Manchester", address="Bottany Bay Woods, Grange Rd, Eccles, Worsley, Manchester M30 8JW",
      city="Manchester", country="GB",
      latitude=53.4874537, longitude=-2.4005848,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a21142a-a457-4e89-84db-c1c9deb2a1cb_ChIJ8zTCGxmw_0.jpg",
      averageRating=4.7, totalRatingsCount=2849,
      createdAt="2026-08-30T23:15:46.572456Z", updatedAt="2026-08-31T08:27:18.666567Z",
    ),
    ClubDto(
      id="0ea27073-6c18-4c8b-a042-810b3126cd46", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rock Over Climbing", address="Park Garage, Cheviot St, Cheetham Hill, Manchester M3 1LW",
      city="Manchester", country="GB",
      latitude=53.4914426, longitude=-2.2452413,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1e875bf-5649-4c32-942f-471955f57caa_ChIJo7zbKM-x_0.jpg",
      averageRating=4.7, totalRatingsCount=1199,
      createdAt="2026-08-30T23:15:20.708539Z", updatedAt="2026-08-30T23:15:20.708539Z",
    ),
    ClubDto(
      id="eac3648a-7611-467b-834a-e577fed65e00", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Manchester Golf Club", address="Hopwood Cottage, Rochdale Rd, Middleton, Manchester M24 6QP",
      city="Manchester", country="GB",
      latitude=53.572923, longitude=-2.179287,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/15b787a5-674c-49f6-8868-3e909b153e99_photo.jpg",
      averageRating=4.6, totalRatingsCount=421,
      createdAt="2026-08-31T15:31:26.709142Z", updatedAt="2026-08-31T15:31:26.709142Z",
    ),
    ClubDto(
      id="1c05cab1-31aa-4754-b9cf-1dfbe73fc527", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Manchester United", address="Sir Matt Busby Way, Old Trafford, Stretford, Manchester M16 0RA",
      city="Manchester", country="GB",
      latitude=53.4626394, longitude=-2.2919724,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a9f086ed-3335-479f-a41d-d11d58573a3e_ChIJaX_k53Ku_0.jpg",
      averageRating=4.6, totalRatingsCount=6644,
      createdAt="2026-08-30T23:14:22.309715Z", updatedAt="2026-08-30T23:14:22.309715Z",
    ),
    ClubDto(
      id="60f0811c-49a8-4eb9-bb87-49666f1a9fae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TeamSport Go Karting Manchester Trafford Park", address="4, Wharfside Wy., Trafford Park, Stretford, Manchester M17 1NF",
      city="Manchester", country="GB",
      latitude=53.4667043, longitude=-2.3012494,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b2ea81e-6461-437d-ae4e-a7549cb30569_ChIJRz_05G-u_0.jpg",
      averageRating=4.6, totalRatingsCount=3032,
      createdAt="2026-08-30T23:15:26.492741Z", updatedAt="2026-08-31T08:37:24.332911Z",
    ),
    ClubDto(
      id="00b64404-232a-40ab-a2b9-e02ec2bd7e65", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Denmark Road Sports Centre", address="120 Denmark Rd, Manchester M15 6FG",
      city="Manchester", country="GB",
      latitude=53.4605153, longitude=-2.2345993,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5419b1ec-4654-4124-8663-aadfa8a0d249_photo.jpg",
      averageRating=4.5, totalRatingsCount=118,
      createdAt="2026-08-31T15:30:59.105272Z", updatedAt="2026-08-31T15:30:59.105272Z",
    ),
    ClubDto(
      id="0485dbed-fdde-4ba4-8490-300da6ceaa01", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Quest Trafford Centre", address="203, Trafford Centre, The Dome, Trafford Park, Stretford, Manchester M17 8DF",
      city="Manchester", country="GB",
      latitude=53.465674, longitude=-2.348305,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9c39febe-f06b-487f-b7b2-f1e6b4e05504_ChIJgRZ44Lqu_0.jpg",
      averageRating=4.5, totalRatingsCount=704,
      createdAt="2026-08-30T23:15:39.013735Z", updatedAt="2026-08-30T23:15:39.013735Z",
    ),
    ClubDto(
      id="a5220d9f-5743-4a62-9283-cc18bb79a37e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Manchester Basketball Centre", address="Whalley Range 11, 18 Wilbraham Rd, Manchester M16 8GW",
      city="Manchester", country="GB",
      latitude=53.4420556, longitude=-2.2485233,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/961e9936-c8eb-42de-a55b-7ddb4e9fda7f_photo.jpg",
      averageRating=4.5, totalRatingsCount=126,
      createdAt="2026-08-31T15:31:07.168695Z", updatedAt="2026-08-31T15:31:07.168695Z",
    ),
    ClubDto(
      id="69328203-9241-4ac2-87bc-150edce74aec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Manchester Tennis and Football Centre", address="9 Sportcity Way, Etihad Campus, Manchester M11 3DU",
      city="Manchester", country="GB",
      latitude=53.4860194, longitude=-2.2027149,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/279c6b5f-02a2-47ac-8e8c-ba95b52240e4_ChIJNUgrnQ6x_0.jpg",
      averageRating=4.5, totalRatingsCount=679,
      createdAt="2026-08-30T23:14:41.031920Z", updatedAt="2026-09-01T14:32:02.169420Z",
    ),
    ClubDto(
      id="8927d73e-b224-4390-9a28-34533b33fab0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Powerleague Manchester Central", address="20 Union St, Manchester M12 4JD",
      city="Manchester", country="GB",
      latitude=53.4723838, longitude=-2.2198532,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eddf557a-9ba2-4434-8eb8-396a8512a7dc_ChIJbx-m4Jux_0.jpg",
      averageRating=4.5, totalRatingsCount=972,
      createdAt="2026-08-30T23:14:28.755350Z", updatedAt="2026-08-31T08:34:51.904328Z",
    ),
    ClubDto(
      id="172498d4-370b-4bcd-a337-1b4070b18046", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Platt Lane Sports Complex", address="Platt Lane Complex, Yew Tree Rd, Fallowfield, Manchester M14 7UU",
      city="Manchester", country="GB",
      latitude=53.4478492, longitude=-2.2287799,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/51335f92-f53d-4447-9539-94a04fb211b5_photo.jpg",
      averageRating=4.4, totalRatingsCount=588,
      createdAt="2026-08-31T15:31:19.907082Z", updatedAt="2026-08-31T22:11:20.582247Z",
    ),
    ClubDto(
      id="c7d6f68e-ed74-42c3-9209-9f40c8caec34", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TeamSport Go Karting Manchester Victoria", address="Victoria Station Approach, Hunts Bank, Cheetham Hill, Manchester M99 1ZW",
      city="Manchester", country="GB",
      latitude=53.4873764, longitude=-2.2430616,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e07cacae-c6bf-4d3d-8fc9-46efd91e4977_ChIJK4bqIcax_0.jpg",
      averageRating=4.4, totalRatingsCount=2365,
      createdAt="2026-08-30T23:15:32.310104Z", updatedAt="2026-08-31T08:37:24.737952Z",
    ),
    ClubDto(
      id="fbe9cc39-6a4f-47ba-a0fc-d450f90d6887", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hough End Playing Fields", address="480 Princess Rd, Manchester M20 1HP",
      city="Manchester", country="GB",
      latitude=53.4360084, longitude=-2.2460658,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bd92408f-bcac-42d2-b615-de847de10e3c_ChIJN-vvGg2y_0.jpg",
      averageRating=4.3, totalRatingsCount=777,
      createdAt="2026-08-30T23:14:35.270156Z", updatedAt="2026-09-01T14:31:59.936013Z",
    ),
    ClubDto(
      id="983b660f-f7ff-4728-8dde-a713329741a8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Printworks", address="27 Withy Grove, Manchester M4 2BS",
      city="Manchester", country="GB",
      latitude=53.485184, longitude=-2.240651,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1ef67fda-5409-4f49-890c-b199c4792661_ChIJa6iSDcex_0.jpg",
      averageRating=4.3, totalRatingsCount=14172,
      createdAt="2026-08-30T23:15:01.505250Z", updatedAt="2026-08-31T08:34:54.407089Z",
    ),
    ClubDto(
      id="8ad740c7-3844-46ec-970a-157ab27c5e9a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UKPaintball Manchester - Bolton", address="Ringley Woods, Radcliffe, Manchester M26 1DY",
      city="Manchester", country="GB",
      latitude=53.5439505, longitude=-2.3441133,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e337888-e5e4-48eb-9c0c-ce32f2ab237f_ChIJyz1lmYul_0.jpg",
      averageRating=4.2, totalRatingsCount=112,
      createdAt="2026-08-30T23:15:52.982329Z", updatedAt="2026-08-30T23:15:52.982329Z",
    ),
    ClubDto(
      id="7cfd5df1-5df0-47cd-8c68-864aba3598ac", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sugden Sports Centre", address="114 Grosvenor St, Manchester M1 7HL",
      city="Manchester", country="GB",
      latitude=53.4711565, longitude=-2.2363113,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a4e221b6-02bc-4af2-90b4-e1cb9b7c77e9_photo.jpg",
      averageRating=4.1, totalRatingsCount=539,
      createdAt="2026-08-31T15:31:13.189832Z", updatedAt="2026-08-31T22:11:21.953745Z",
    ),
    ClubDto(
      id="1f4b6edd-6070-4c42-b864-bffe43558a8c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TopSpin Table Tennis Manchester", address="St Matthews Court, Chapel Ln, Stretford, Manchester M32 9AJ",
      city="Manchester", country="GB",
      latitude=53.4434213, longitude=-2.3105597,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f6ba8bd0-bfb8-4f26-ada7-bbdffa4c8eb3_photo.jpg",
      averageRating=5.0, totalRatingsCount=6,
      createdAt="2026-08-31T15:31:41.387995Z", updatedAt="2026-08-31T15:31:41.387995Z",
    ),
  )),
  CitySeo(slug="milan", name="Milan", country="IT", clubCount=23, sports=listOf(Pair("Tennis", 3), Pair("Volleyball", 3), Pair("Football", 3), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Laser Tag", 2), Pair("Paintball", 2), Pair("Table Tennis", 2), Pair("Climbing", 2), Pair("Golf", 1), Pair("Basketball", 1)), clubs=listOf(
    ClubDto(
      id="cab9b67a-53b9-4c9f-b530-373498cb417e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LOG Lot Of Games - Merlata Bloom", address="Merlata Bloom - Primo piano, Via Triboniano, 20156 Milano MI",
      city="Milan", country="IT",
      latitude=45.5140455, longitude=9.1019777,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1961b702-a80c-4c23-8af1-50280d599d5e_ChIJ1Vb9C_zr_0.jpg",
      averageRating=4.8, totalRatingsCount=1602,
      createdAt="2026-08-30T21:23:11.271676Z", updatedAt="2026-08-30T21:57:57.520082Z",
    ),
    ClubDto(
      id="5946ef9d-d157-49ec-b2e7-1e53c673b748", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PalaBovisa Ping Pong Tennis Tavolo Milano", address="presso chiesa parrocchiale, Via Privata Catone, 12, 20158 Milano MI",
      city="Milan", country="IT",
      latitude=45.4981566, longitude=9.1715783,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed867c19-087b-4293-a4d6-91d4a427c945_photo.jpg",
      averageRating=4.8, totalRatingsCount=111,
      createdAt="2026-08-31T15:43:33.549065Z", updatedAt="2026-08-31T15:43:33.549065Z",
    ),
    ClubDto(
      id="f9a4a2ca-5159-4ee9-881d-ee15d5cfa054", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Town", address="Piazza Marco Polo, all'interno di, Sporting Milano, 3, 20079 Basiglio MI",
      city="Milan", country="IT",
      latitude=45.3581154, longitude=9.1580003,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0d885a4d-a27d-4324-8640-3a0ac1c2a425_photo.png",
      averageRating=4.7, totalRatingsCount=285,
      createdAt="2026-08-31T15:43:18.225762Z", updatedAt="2026-08-31T15:43:18.225762Z",
    ),
    ClubDto(
      id="c5b7b392-dbce-4402-8278-912fdbe22589", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Headbangers", address="Via Tito Livio, 33/A, 20137 Milano MI",
      city="Milan", country="IT",
      latitude=45.4505934, longitude=9.2199089,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1d2ec207-01a0-481a-9433-e28d7ba4b6e5_ChIJwQV-NBnF_0.jpg",
      averageRating=4.7, totalRatingsCount=442,
      createdAt="2026-08-30T21:22:32.187909Z", updatedAt="2026-08-30T21:57:14.475675Z",
    ),
    ClubDto(
      id="2cd72135-43a4-429b-952a-250726699c4f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Martesana", address="Strada Vicinale Della Baraghetta 50, 20060, 20041 Bussero MI",
      city="Milan", country="IT",
      latitude=45.5453963, longitude=9.362891,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/539fac8c-9113-46a3-9cba-ea86d77e9d49_photo.jpg",
      averageRating=4.7, totalRatingsCount=370,
      createdAt="2026-08-31T15:44:02.847491Z", updatedAt="2026-08-31T22:11:19.587652Z",
    ),
    ClubDto(
      id="c399b932-99b2-4eb9-a48b-a413c7789961", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ping Pong Milano TennsTavolo Silver Lining ASD", address="Via Filippo Turati, 2, 20032 Cormano MI",
      city="Milan", country="IT",
      latitude=45.5400842, longitude=9.1736106,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a6af416d-b770-442f-99dd-f12cd7437d72_photo.jpg",
      averageRating=4.7, totalRatingsCount=105,
      createdAt="2026-08-31T15:43:46.679210Z", updatedAt="2026-08-31T15:43:46.679210Z",
    ),
    ClubDto(
      id="0e034802-0d60-417c-8515-f5d1fda1c272", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Aspria Harbour Club Milan", address="Via Cascina Bellaria, 19, 20153 Milano MI",
      city="Milan", country="IT",
      latitude=45.4807273, longitude=9.1054362,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f47da9c3-ea39-434f-bf64-710fb4a8c84f_ChIJIeOzT-_B_0.jpg",
      averageRating=4.6, totalRatingsCount=1017,
      createdAt="2026-08-30T21:23:23.720272Z", updatedAt="2026-08-30T21:55:16.797453Z",
    ),
    ClubDto(
      id="13be789e-276c-4bcb-ad43-67408dd85cfd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Space Milano", address="Via Novara, 15, 20147 Milano MI",
      city="Milan", country="IT",
      latitude=45.4683543, longitude=9.127763,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fc2d1cc7-3c97-42d0-878b-96b4cd350f04_ChIJK3azIubB_0.jpg",
      averageRating=4.5, totalRatingsCount=574,
      createdAt="2026-08-30T21:22:44.873587Z", updatedAt="2026-08-30T21:55:51.735153Z",
    ),
    ClubDto(
      id="c30c7288-d364-4247-b09d-8b30d83671d3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Club Milano", address="Via Regina Margherita, 25, 20853 Biassono MB",
      city="Milan", country="IT",
      latitude=45.615922, longitude=9.2930326,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bbdd3ab3-ff89-4f05-8161-5e5b3e5fc441_photo.jpg",
      averageRating=4.5, totalRatingsCount=319,
      createdAt="2026-08-31T15:43:26.583826Z", updatedAt="2026-08-31T15:43:26.583826Z",
    ),
    ClubDto(
      id="80343695-668b-40f3-aff4-48f890a03ee8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Milano", address="Via Cascina Manzola, 20046 Cisliano MI",
      city="Milan", country="IT",
      latitude=45.449762, longitude=8.9667447,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1188b71-4cd7-42df-8407-0820f51fd516_photo.png",
      averageRating=4.5, totalRatingsCount=1427,
      createdAt="2026-08-31T15:43:55.185431Z", updatedAt="2026-08-31T15:43:55.185431Z",
    ),
    ClubDto(
      id="e9acbf81-5717-4adb-b448-a0ba17f31f1f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PlayMore!", address="Via della Moscova, 26/A, 20121 Milano MI",
      city="Milan", country="IT",
      latitude=45.4771982, longitude=9.190838,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/df3c4b36-8ade-4fa1-9d1a-d74f76be2ad4_photo.jpg",
      averageRating=4.5, totalRatingsCount=632,
      createdAt="2026-08-31T15:42:49.380268Z", updatedAt="2026-08-31T15:42:49.380268Z",
    ),
    ClubDto(
      id="d81b1948-3a40-498d-a5e3-a60f590f4395", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zero-Gravity Milano", address="Via Carlo Valvassori Peroni, 48, 20133 Milano MI",
      city="Milan", country="IT",
      latitude=45.4789599, longitude=9.2372017,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b915b4f-7000-470e-b936-b8ad2b7cf059_ChIJC9QDLl_G_0.jpg",
      averageRating=4.5, totalRatingsCount=6361,
      createdAt="2026-08-30T21:22:51.313863Z", updatedAt="2026-08-30T22:02:30.403574Z",
    ),
    ClubDto(
      id="9b2d1a4c-f5a6-4c5e-9248-382370fad67a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KONAMI FOOTBALL CENTRE in Memory of Giacinto Facchetti", address="Via Camillo Sbarbaro, 3, 20161 Milano MI",
      city="Milan", country="IT",
      latitude=45.51739, longitude=9.180298,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/da42042c-1a61-4f8f-b33d-bb77ccbe6811_ChIJza1vpr_A_0.jpg",
      averageRating=4.4, totalRatingsCount=433,
      createdAt="2026-08-30T21:22:11.866693Z", updatedAt="2026-08-30T21:57:31.234211Z",
    ),
    ClubDto(
      id="ab6cc2bf-4c35-4dd9-96f7-22444d495155", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasergame Sesto Marelli", address="Via Privata Viserba, 16, 20126 Milano MI",
      city="Milan", country="IT",
      latitude=45.5219867, longitude=9.2248471,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c98c490d-5194-4901-b439-a930767d0109_ChIJsfXwTl3H_0.jpg",
      averageRating=4.3, totalRatingsCount=655,
      createdAt="2026-08-30T21:23:17.238415Z", updatedAt="2026-08-30T21:23:17.238415Z",
    ),
    ClubDto(
      id="47a1703e-295e-4635-bb27-06516182f0db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Osteria del biliardo", address="Via Enrico Cialdini, 107, 20161 Milano MI",
      city="Milan", country="IT",
      latitude=45.5148886, longitude=9.1694231,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/185bc176-d060-4c2e-91d2-ba2e604a8c10_ChIJm2y8kuzA_2.jpg",
      averageRating=4.3, totalRatingsCount=1097,
      createdAt="2026-08-30T21:22:25.935769Z", updatedAt="2026-08-31T22:11:19.170174Z",
    ),
    ClubDto(
      id="08b9c74b-c6de-4bb4-b415-e4e00d557bf2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="OpenBeach", address="Via Giorgio Washington, 33, 20146 Milano MI",
      city="Milan", country="IT",
      latitude=45.4625412, longitude=9.1553677,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/82b40d5b-bbbe-4de1-9142-213e53342f53_photo.jpg",
      averageRating=4.1, totalRatingsCount=128,
      createdAt="2026-08-31T15:43:02.905123Z", updatedAt="2026-08-31T15:43:02.905123Z",
    ),
    ClubDto(
      id="1c27f8e6-502d-4884-a796-2716ba5970aa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Villaggio Faenza", address="Viale Faenza, 7, 20142 Milano MI",
      city="Milan", country="IT",
      latitude=45.4362945, longitude=9.1523742,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2338fa01-fcc6-461d-8190-890e2d4ed488_ChIJMQRvHZbD_0.jpg",
      averageRating=4.1, totalRatingsCount=392,
      createdAt="2026-08-30T21:22:18.788384Z", updatedAt="2026-08-30T21:22:18.788384Z",
    ),
    ClubDto(
      id="9a275cd2-9a6b-4e31-b3f9-7179d0be64b0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Non Solo Bowling", address="Via Peloritana, 58, 20024 Garbagnate Milanese MI",
      city="Milan", country="IT",
      latitude=45.5758895, longitude=9.0666065,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9a316807-4f57-4c5b-b767-14e2e23640d1_ChIJBY7h6fCU_0.jpg",
      averageRating=4.0, totalRatingsCount=1329,
      createdAt="2026-08-30T21:22:38.318746Z", updatedAt="2026-08-30T21:22:38.318746Z",
    ),
    ClubDto(
      id="7e496140-7abe-4f22-9d58-44462d5fc5bb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="OpenBeach", address="Via Lorenteggio fronte civico 238, 20147, Via Lorenteggio, 20146 Milano MI",
      city="Milan", country="IT",
      latitude=45.4448013, longitude=9.1251897,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/940c651e-ba61-40f2-81b1-4a7f0328b55d_photo.jpg",
      averageRating=4.0, totalRatingsCount=169,
      createdAt="2026-08-31T15:43:09.114907Z", updatedAt="2026-08-31T15:43:09.114907Z",
    ),
    ClubDto(
      id="f48eee47-8ddb-4f7f-bae3-ea18dc11043b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polisportiva Lombardia 1", address="Largo Antonio Balestra, 5, 20146 Milano MI",
      city="Milan", country="IT",
      latitude=45.4471191, longitude=9.1421456,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c69630bb-e561-4359-aeb6-9de28d2c92a1_ChIJf_F9DsbD_0.jpg",
      averageRating=4.0, totalRatingsCount=637,
      createdAt="2026-08-30T21:22:05.221078Z", updatedAt="2026-08-30T21:59:36.137099Z",
    ),
    ClubDto(
      id="74f3f7f2-aa37-402e-8743-35e491c370eb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Quanta Club - Tennis a Milano", address="Via Assietta, 19, 20161 Milano MI",
      city="Milan", country="IT",
      latitude=45.5180933, longitude=9.1634687,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9c2ef97e-8caf-4b36-bb77-1b208cf02562_ChIJAbP_II3A_0.jpg",
      averageRating=4.0, totalRatingsCount=529,
      createdAt="2026-08-30T21:23:36.677196Z", updatedAt="2026-08-30T21:59:42.324152Z",
    ),
    ClubDto(
      id="545f4316-0959-4e09-910f-c3354893d9e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club Ambrosiano", address="Via Feltre, 33, 20134 Milano MI",
      city="Milan", country="IT",
      latitude=45.4916573, longitude=9.2425742,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b86a8076-1584-47ee-a616-f3d829db28d6_ChIJkRUs0lTG_1.jpg",
      averageRating=4.0, totalRatingsCount=642,
      createdAt="2026-08-30T21:23:30.197750Z", updatedAt="2026-08-31T22:11:22.385165Z",
    ),
    ClubDto(
      id="57c1e746-e48c-4267-9107-0fc2a118fee2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tonic Milano Lambrate", address="Via Mestre, 7, 20132 Milano MI",
      city="Milan", country="IT",
      latitude=45.4924384, longitude=9.2400451,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5d2df5fe-6265-41ef-abd8-88f66d03cffd_ChIJr8BHTVXG_0.jpg",
      averageRating=4.0, totalRatingsCount=1515,
      createdAt="2026-08-30T21:22:58.208269Z", updatedAt="2026-08-30T22:01:42.085638Z",
    ),
  )),
  CitySeo(slug="graz", name="Graz", country="AT", clubCount=23, sports=listOf(Pair("Padel", 3), Pair("Football", 3), Pair("Tennis", 3), Pair("Basketball", 3), Pair("Climbing", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Laser Tag", 2), Pair("Billiards", 1), Pair("Paintball", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="9ae1a19b-e855-4a36-9049-e2c6a40c7c1e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BLOC house - Boulderhalle", address="Puchstraße 17-21, 8020 Graz",
      city="Graz", country="AT",
      latitude=47.0506487, longitude=15.4347204,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/165e2e24-555f-434c-911b-b69fbe404bc5_ChIJC-8odqBK_0.jpg",
      averageRating=4.8, totalRatingsCount=819,
      createdAt="2026-08-30T23:03:52.936454Z", updatedAt="2026-08-31T08:25:48.850023Z",
    ),
    ClubDto(
      id="532a77a4-3315-4945-8ce2-a0d73620c0bd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boulderclub", address="Triesterstraße 391, 8055 Graz",
      city="Graz", country="AT",
      latitude=47.0254961, longitude=15.4363833,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/afc261db-81da-4e82-9531-86eab45d9d0d_ChIJOSoCIk61_0.jpg",
      averageRating=4.8, totalRatingsCount=912,
      createdAt="2026-08-30T23:03:46.725569Z", updatedAt="2026-08-31T08:26:23.305469Z",
    ),
    ClubDto(
      id="5e449c02-19aa-46ea-984d-1aabf869c440", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="UNI Graz sports center Rosenhain", address="Aigner-Rollett-Allee 11, 8010 Graz",
      city="Graz", country="AT",
      latitude=47.083143, longitude=15.4503387,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b0e59f83-ba92-49c0-8942-997bcffcae50_photo.jpg",
      averageRating=4.8, totalRatingsCount=63,
      createdAt="2026-08-31T15:23:30.174290Z", updatedAt="2026-08-31T22:11:23.575265Z",
    ),
    ClubDto(
      id="0c7a6e9d-3b26-43e5-87e4-28d16ef37a3c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="iFight", address="Weblinger Gürtel 25, 8054 Graz",
      city="Graz", country="AT",
      latitude=47.0339342, longitude=15.4171999,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/298824b6-5009-4766-bb4a-8340cd56bbe8_ChIJt_4TvG41_0.jpg",
      averageRating=4.8, totalRatingsCount=167,
      createdAt="2026-08-30T23:04:05.851091Z", updatedAt="2026-08-30T23:04:05.851091Z",
    ),
    ClubDto(
      id="455e94d6-0950-404f-9165-b8ca39746f47", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sand und Mehr", address="Tannhofweg 5, 8044 Graz",
      city="Graz", country="AT",
      latitude=47.1042008, longitude=15.4901594,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49b12a7f-0d1c-4f89-a490-68816552475e_photo.jpg",
      averageRating=4.8, totalRatingsCount=49,
      createdAt="2026-08-31T15:23:37.905652Z", updatedAt="2026-08-31T15:23:37.905652Z",
    ),
    ClubDto(
      id="5cedb411-883b-481b-8010-1ecdb7dfc5d7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Raiffeisen Sportpark Graz", address="Hüttenbrennergasse 31 (Eingang, Schönaugasse, 8010 Graz",
      city="Graz", country="AT",
      latitude=47.0550663, longitude=15.4419078,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/59e35157-05f7-417a-a41b-1f232402afee_ChIJhYqx2uZL_0.jpg",
      averageRating=4.7, totalRatingsCount=553,
      createdAt="2026-08-30T23:03:15.458140Z", updatedAt="2026-08-31T08:35:21.927608Z",
    ),
    ClubDto(
      id="380f5c9a-9edf-45da-a7bc-56c8c5ce9758", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Graz", address="Gewerbepark, 8075 Hart bei Graz",
      city="Graz", country="AT",
      latitude=47.042072, longitude=15.516075,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fa8f0dc4-f684-46a0-8a25-9e086a2f7036_ChIJuVY9WWpL_0.jpg",
      averageRating=4.6, totalRatingsCount=223,
      createdAt="2026-08-30T23:04:18.954681Z", updatedAt="2026-08-31T08:34:15.867680Z",
    ),
    ClubDto(
      id="17ddd13c-6bd5-479f-9699-5c4611e3c12f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Styriakarting INDOOR", address="Feldkirchenstraße 30, 8401 Kalsdorf bei Graz",
      city="Graz", country="AT",
      latitude=46.9702543, longitude=15.4625076,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b5c6c254-1ba5-4aed-ba7c-f942e29ce1b4_ChIJI3S7C0e0_0.jpg",
      averageRating=4.6, totalRatingsCount=547,
      createdAt="2026-08-30T23:03:59.390807Z", updatedAt="2026-08-31T08:37:04.095403Z",
    ),
    ClubDto(
      id="d33944f0-c4dd-47cc-bb30-0e865051845f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Club Liebenau", address="Golfstraße 10, 8077 Gössendorf",
      city="Graz", country="AT",
      latitude=47.013936, longitude=15.47063,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/32c593a5-0388-4eca-bb6d-f8ee651e34d8_photo.jpg",
      averageRating=4.5, totalRatingsCount=143,
      createdAt="2026-08-31T15:23:46.206110Z", updatedAt="2026-08-31T15:23:46.206110Z",
    ),
    ClubDto(
      id="6f1b1abb-6752-4abd-992b-49351371da24", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Racket Sport Center Graz", address="Ragnitzstraße 58b, 8047 Graz",
      city="Graz", country="AT",
      latitude=47.0773739, longitude=15.4789242,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0b7b6406-2a05-42fb-bf50-3f13f2a68349_ChIJA-ZVlEJK_0.jpg",
      averageRating=4.5, totalRatingsCount=292,
      createdAt="2026-08-30T23:04:44.199881Z", updatedAt="2026-09-01T14:31:49.230944Z",
    ),
    ClubDto(
      id="e2279202-324d-438a-bc50-d544d3005e80", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brot & Spiele", address="Mariahilfer Str. 17, 8020 Graz",
      city="Graz", country="AT",
      latitude=47.0733092, longitude=15.4330756,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/358a7fe4-9bb4-462e-a7f3-e0d4814dde3b_ChIJOye5Tp01_0.jpg",
      averageRating=4.4, totalRatingsCount=3547,
      createdAt="2026-08-30T23:03:40.348512Z", updatedAt="2026-08-30T23:03:40.348512Z",
    ),
    ClubDto(
      id="fccdb3f0-3f03-4f4c-b044-670667fe9869", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Unionhalle", address="Gaußgasse 3, 8010 Graz",
      city="Graz", country="AT",
      latitude=47.073072, longitude=15.4586811,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b127e84d-9165-42cb-9cff-537ca1113615_ChIJBSnkkHxK_1.jpg",
      averageRating=4.4, totalRatingsCount=302,
      createdAt="2026-08-30T23:03:21.821819Z", updatedAt="2026-08-31T22:11:23.678442Z",
    ),
    ClubDto(
      id="c047c816-2141-4005-93fa-fcd17871dae6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golfclub Klockerhof", address="Hahnhofweg 22, 8075 Hart bei Graz",
      city="Graz", country="AT",
      latitude=47.0525633, longitude=15.5256544,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7e7a5bec-604b-4091-a292-a068e6dd925c_photo.jpg",
      averageRating=4.5, totalRatingsCount=48,
      createdAt="2026-08-31T15:23:54.423578Z", updatedAt="2026-08-31T15:23:54.423578Z",
    ),
    ClubDto(
      id="60512c9d-e699-44db-9ca1-62086dd13927", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Center West", address="Weblinger Gürtel 25, 8054 Graz",
      city="Graz", country="AT",
      latitude=47.0338994, longitude=15.4158296,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9a5fde5d-fc67-418a-be11-27ef479bed3e_ChIJHfIcuKzK_0.jpg",
      averageRating=4.3, totalRatingsCount=7165,
      createdAt="2026-08-30T23:03:34.054951Z", updatedAt="2026-08-30T23:03:34.054951Z",
    ),
    ClubDto(
      id="e7c4c2a4-2054-4258-85d2-34ccf9c258e5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gigasport Graz", address="Kaiser-Franz-Josef-Kai 8, 8010 Graz",
      city="Graz", country="AT",
      latitude=47.0715312, longitude=15.4356874,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/53db483d-1a96-4144-98f4-44d656c67d5c_ChIJo0-Ge3g1_0.jpg",
      averageRating=4.3, totalRatingsCount=905,
      createdAt="2026-08-30T23:03:08.727569Z", updatedAt="2026-08-31T08:28:36.483035Z",
    ),
    ClubDto(
      id="82d3f15e-75ca-4549-9fde-5db046673c1a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Grazer Athletiksportklub-Tennis", address="Körösistraße 57, 8010 Graz",
      city="Graz", country="AT",
      latitude=47.0820393, longitude=15.4310466,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ef62a50-4527-482f-af3a-d64ff60dc4fe_ChIJ56ZI-pk1_0.jpg",
      averageRating=4.3, totalRatingsCount=96,
      createdAt="2026-08-30T23:04:58.808243Z", updatedAt="2026-08-30T23:04:58.808243Z",
    ),
    ClubDto(
      id="c96f2c30-502d-47f8-84c2-e38076cb13b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis-Point", address="Weblinger Gürtel 20, 8054 Graz",
      city="Graz", country="AT",
      latitude=47.032051, longitude=15.4180917,
      type="PADEL",
      types=listOf("PADEL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/310fbbf1-700d-46af-afc2-b044c19c235b_ChIJ2-7FiazK_0.jpg",
      averageRating=4.3, totalRatingsCount=317,
      createdAt="2026-08-30T23:04:31.847977Z", updatedAt="2026-09-01T14:31:41.800494Z",
    ),
    ClubDto(
      id="d95cf0ac-0438-4d0d-8f6e-6af2c7274c5e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenniscenter Straßgang", address="Martinhofstraße 13, 8054 Graz",
      city="Graz", country="AT",
      latitude=47.026817, longitude=15.39668,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d8d0751-6038-494f-bd39-ed38fd861d81_ChIJkTROOrjK_0.jpg",
      averageRating=4.3, totalRatingsCount=131,
      createdAt="2026-08-30T23:04:51.529369Z", updatedAt="2026-08-30T23:04:51.529369Z",
    ),
    ClubDto(
      id="b84a43a1-9f2a-457e-bb3e-facfe1517947", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Der Klub", address="Halbärthgasse 14, 8010 Graz",
      city="Graz", country="AT",
      latitude=47.076368, longitude=15.4498077,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d6caf487-f443-4791-8e6f-972826907364_ChIJh18amHhK_0.jpg",
      averageRating=4.2, totalRatingsCount=71,
      createdAt="2026-08-30T23:03:27.951711Z", updatedAt="2026-08-31T08:27:20.817857Z",
    ),
    ClubDto(
      id="1d4a61cd-1384-419e-b0c6-03ef73840069", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportland Steiermark GmbH", address="Jahngasse 3, 8010 Graz",
      city="Graz", country="AT",
      latitude=47.0784618, longitude=15.439713,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/70878065-3bac-4672-8c48-2730912a0614_photo.png",
      averageRating=4.2, totalRatingsCount=169,
      createdAt="2026-08-31T15:23:23.995819Z", updatedAt="2026-08-31T15:23:23.995819Z",
    ),
    ClubDto(
      id="c8858986-6c61-43bf-833e-25469d075270", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Direct", address="Weblinger Gürtel 25, 8054 Graz",
      city="Graz", country="AT",
      latitude=47.0340553, longitude=15.4156197,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6efbf46f-e5e2-4d0b-a22c-fdaf5d4b0ec5_ChIJFXp_uazK_0.jpg",
      averageRating=4.1, totalRatingsCount=1257,
      createdAt="2026-08-30T23:04:25.501441Z", updatedAt="2026-08-31T08:36:33.848823Z",
    ),
    ClubDto(
      id="94a13450-c301-4797-9f13-1f5f45f69734", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GDG Sportcenter", address="Pichlergasse 22, 8041 Graz",
      city="Graz", country="AT",
      latitude=47.0427911, longitude=15.4437879,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4bf5eade-154b-4d1e-8d02-47c470f95571_ChIJI_YiMqVK_0.jpg",
      averageRating=4.0, totalRatingsCount=250,
      createdAt="2026-08-30T23:04:37.873612Z", updatedAt="2026-08-31T08:28:22.620697Z",
    ),
    ClubDto(
      id="e7a76ff9-758e-4ae1-9fa8-6137d94b5d2d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Virtual Lasertag Graz", address="Plüddemanngasse 51, 8010 Graz",
      city="Graz", country="AT",
      latitude=47.064982, longitude=15.4646334,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4df145ea-372e-41d6-a37b-f6a497e4fce3_ChIJvyr2YCk1_0.jpg",
      averageRating=5.0, totalRatingsCount=38,
      createdAt="2026-08-30T23:04:12.196571Z", updatedAt="2026-08-30T23:04:12.196571Z",
    ),
  )),
  CitySeo(slug="frankfurt", name="Frankfurt", country="DE", clubCount=23, sports=listOf(Pair("Football", 4), Pair("Tennis", 4), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Paintball", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Volleyball", 2), Pair("Basketball", 1), Pair("Laser Tag", 1), Pair("Padel", 1)), clubs=listOf(
    ClubDto(
      id="e13583e3-2e51-4f57-a44d-10671920e463", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dynochrom Boulderhalle Frankfurt", address="Flinschstraße 45, 60388 Frankfurt am Main-Frankfurt-Ost",
      city="Frankfurt", country="DE",
      latitude=50.1368911, longitude=8.7327079,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1df0a878-4b90-4833-b35e-94ddf628b2cd_photo.jpg",
      averageRating=4.8, totalRatingsCount=1460,
      createdAt="2026-08-31T22:53:08.944691Z", updatedAt="2026-08-31T22:53:08.944691Z",
    ),
    ClubDto(
      id="12171fe7-c0c7-4e05-bb94-f9045cb7bfa7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lasertag Frankfurt", address="Henschelstraße 26, 60314 Frankfurt am Main-Bornheim/Ostend",
      city="Frankfurt", country="DE",
      latitude=50.1151491, longitude=8.7104627,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d3d6e8a7-cdcc-49eb-a810-e78bf68f0491_photo.jpg",
      averageRating=4.8, totalRatingsCount=1677,
      createdAt="2026-08-31T22:53:26.036875Z", updatedAt="2026-08-31T22:53:26.036875Z",
    ),
    ClubDto(
      id="d0579238-cf3f-48db-8e59-afa4deced9c6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Makkabi Tennis & Squash Park", address="Ginnheimer Landstraße 49, 60487 Frankfurt am Main-Innenstadt II",
      city="Frankfurt", country="DE",
      latitude=50.134247, longitude=8.6452411,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0e4dd3f9-fece-488f-9353-45307febda6b_photo.jpg",
      averageRating=4.8, totalRatingsCount=156,
      createdAt="2026-08-31T22:52:19.035829Z", updatedAt="2026-08-31T22:52:19.035829Z",
    ),
    ClubDto(
      id="0b034b22-f800-48de-8907-45bd991480b8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportpark Frankfurt", address="August-Schanz-Straße 24-26, 60433 Frankfurt am Main",
      city="Frankfurt", country="DE",
      latitude=50.1633625, longitude=8.6879363,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/860491f7-155f-4c59-967e-56fbfc39efd8_photo.jpg",
      averageRating=4.8, totalRatingsCount=386,
      createdAt="2026-08-31T22:51:52.493052Z", updatedAt="2026-09-01T14:32:01.321853Z",
    ),
    ClubDto(
      id="0266f463-ac4f-4917-9c8a-aaa8ba5041fc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Empire Billard Club", address="Louisenstraße 123, 61348 Bad Homburg vor der Höhe",
      city="Frankfurt", country="DE",
      latitude=50.223335, longitude=8.6241803,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7fcebe3f-de44-449a-9f8f-f1805e19964e_photo.jpg",
      averageRating=4.7, totalRatingsCount=634,
      createdAt="2026-08-31T22:53:22.186289Z", updatedAt="2026-08-31T22:53:22.186289Z",
    ),
    ClubDto(
      id="43f8060c-1a8e-4953-862f-2b226098aa4d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KletterBar - Offenbach", address="Sprendlinger Landstraße 177b, 63069 Offenbach am Main",
      city="Frankfurt", country="DE",
      latitude=50.0851646, longitude=8.7437487,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e73e319e-8809-4395-8faf-e8b7b24189b5_photo.jpg",
      averageRating=4.7, totalRatingsCount=616,
      createdAt="2026-08-31T22:53:13.362723Z", updatedAt="2026-08-31T22:53:13.362723Z",
    ),
    ClubDto(
      id="8fe35e15-f5df-4c4b-a5f6-5c77dd84a41e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Planet Paintball Nidda", address="Über d. Breit 9, 63667 Nidda",
      city="Frankfurt", country="DE",
      latitude=50.4067515, longitude=8.9931243,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/834c1131-e58a-42d4-8c93-1af8b45d2a7f_photo.jpg",
      averageRating=4.7, totalRatingsCount=1723,
      createdAt="2026-08-31T22:53:30.577288Z", updatedAt="2026-08-31T22:53:30.577288Z",
    ),
    ClubDto(
      id="8ef8336f-3531-4b56-b1c1-0d65ef7f121c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BOWL for Fun Langen", address="Robert-Bosch-Straße 7, 63225 Langen (Hessen)",
      city="Frankfurt", country="DE",
      latitude=50.0007985, longitude=8.6522914,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/418d78fc-5260-4bd4-a954-f7bde8580c68_photo.jpg",
      averageRating=4.6, totalRatingsCount=1309,
      createdAt="2026-08-31T22:53:03.678742Z", updatedAt="2026-08-31T22:53:03.678742Z",
    ),
    ClubDto(
      id="0a0f891f-0eb4-4ff9-a5ed-697b49bb4921", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Color Area", address="Möhnestraße 8, 63452 Hanau",
      city="Frankfurt", country="DE",
      latitude=50.1450483, longitude=8.939201,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db4949ab-5ed1-49c9-927e-f0b3f8a747c5_photo.jpg",
      averageRating=4.6, totalRatingsCount=584,
      createdAt="2026-08-31T22:53:35.710558Z", updatedAt="2026-08-31T22:53:35.710558Z",
    ),
    ClubDto(
      id="017a273b-a491-444a-8bb8-63c58c03c331", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf-Club Neuhof e.V.", address="Hofgut Neuhof, 63303 Dreieich-Götzenhain",
      city="Frankfurt", country="DE",
      latitude=50.0157054, longitude=8.7265952,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e472c768-14c7-4ac8-a5dd-150f2318fa61_photo.jpg",
      averageRating=4.6, totalRatingsCount=304,
      createdAt="2026-08-31T22:52:55.285275Z", updatedAt="2026-08-31T22:52:55.285275Z",
    ),
    ClubDto(
      id="681bb9b1-4caa-4ef5-bb8b-6db7c74ff913", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Frankfurt", address="Am Ginnheimer Wäldchen 1, 60431 Frankfurt am Main-Frankfurt-Mitte-Nord",
      city="Frankfurt", country="DE",
      latitude=50.1384251, longitude=8.639433,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/42e5634e-6789-4510-9e03-7aec5fcb4e2a_photo.jpg",
      averageRating=4.6, totalRatingsCount=51,
      createdAt="2026-08-31T22:52:31.094700Z", updatedAt="2026-08-31T22:52:31.094700Z",
    ),
    ClubDto(
      id="9e7d7977-e026-48c1-8866-a9473641238b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Deutsche Bank Park", address="Mörfelder Landstraße 362, 60528 Frankfurt am Main",
      city="Frankfurt", country="DE",
      latitude=50.0685807, longitude=8.645472,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0da1c264-b427-4695-a739-f1e2e60e2138_photo.jpg",
      averageRating=4.5, totalRatingsCount=30060,
      createdAt="2026-08-31T22:51:48.007984Z", updatedAt="2026-08-31T22:51:48.007984Z",
    ),
    ClubDto(
      id="69908d57-f836-4a1f-be69-0ba55def88e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf-Club Golf Range Frankfurt", address="Am Martinszehnten 6, 60437 Frankfurt am Main-Kalbach-Riedberg",
      city="Frankfurt", country="DE",
      latitude=50.1878662, longitude=8.6514558,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3f47e0d4-0ae3-4189-a905-b63e11bdd649_photo.jpg",
      averageRating=4.5, totalRatingsCount=364,
      createdAt="2026-08-31T22:52:50.641530Z", updatedAt="2026-08-31T22:52:50.641530Z",
    ),
    ClubDto(
      id="bd03af89-01e8-4a2e-998d-569752e3d221", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Frankfurter Turnverein 1860", address="Pfingstweidstraße 7, 60316 Frankfurt am Main-Bornheim/Ostend",
      city="Frankfurt", country="DE",
      latitude=50.1162295, longitude=8.6967697,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f49ae9ee-761e-49a8-8f47-6a5eac18eaa7_photo.jpg",
      averageRating=4.4, totalRatingsCount=116,
      createdAt="2026-08-31T22:52:36.060172Z", updatedAt="2026-08-31T22:52:36.060172Z",
    ),
    ClubDto(
      id="a04ebaaa-c2c3-46a7-95f8-da8754b2c3ea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SOCCERBEAT", address="Zeil 106/MyZeil, 2. Etage, 60313 Frankfurt am Main",
      city="Frankfurt", country="DE",
      latitude=50.1148439, longitude=8.6814467,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dfa355bc-ffec-4320-a981-a942de903ef6_photo.jpg",
      averageRating=4.4, totalRatingsCount=210,
      createdAt="2026-08-31T22:52:02.165242Z", updatedAt="2026-08-31T22:52:02.165242Z",
    ),
    ClubDto(
      id="97bb069f-d0b8-4dbb-a5d7-8f7638435cf4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportpark Preungesheim", address="Goldpeppingstraße 8, 60435 Frankfurt am Main Nord-Ost",
      city="Frankfurt", country="DE",
      latitude=50.1511194, longitude=8.7019795,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/58685507-ebe3-4f6f-bc69-b761e56f671c_photo.jpg",
      averageRating=4.4, totalRatingsCount=344,
      createdAt="2026-08-31T22:51:56.755402Z", updatedAt="2026-08-31T22:51:56.755402Z",
    ),
    ClubDto(
      id="9b9829d8-b308-4281-be38-d069af8b3f75", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Magic-Bowl GmbH", address="Hans-Mess-Straße 2C, 61440 Oberursel (Taunus)-Oberstedten",
      city="Frankfurt", country="DE",
      latitude=50.22318, longitude=8.58152,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e136dfa0-71a6-46f6-b3ec-50433ab69f23_photo.jpg",
      averageRating=4.3, totalRatingsCount=1435,
      createdAt="2026-08-31T22:52:59.346601Z", updatedAt="2026-08-31T22:52:59.346601Z",
    ),
    ClubDto(
      id="7ef32a24-66a4-4270-aad3-9187bda5cede", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Höchster Tennis- und Hockey-Club 1899 e.V.", address="Grasmückenweg 10, 65929 Frankfurt am Main West",
      city="Frankfurt", country="DE",
      latitude=50.103792, longitude=8.5326631,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39b611b8-bbf0-4386-a463-6798fa0ce094_photo.jpg",
      averageRating=4.2, totalRatingsCount=183,
      createdAt="2026-08-31T22:52:14.526355Z", updatedAt="2026-09-01T14:32:00.375192Z",
    ),
    ClubDto(
      id="5c6c0fd6-78c1-4031-ba3c-9cc3470a90b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport Club Frankfurt 1880 e.V.", address="Feldgerichtstraße 29, 60320 Frankfurt am Main",
      city="Frankfurt", country="DE",
      latitude=50.134531, longitude=8.6799673,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3e3ea897-a310-4416-b285-43799998c5dd_photo.jpg",
      averageRating=4.2, totalRatingsCount=273,
      createdAt="2026-08-31T22:52:40.258715Z", updatedAt="2026-08-31T22:52:40.258715Z",
    ),
    ClubDto(
      id="c8e4b423-1584-4ac0-bdab-62fa4aabf35c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bornheimer Billardtreff", address="Inheidener Str. 67, 60385 Frankfurt am Main-Bornheim/Ostend",
      city="Frankfurt", country="DE",
      latitude=50.1311234, longitude=8.7166577,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5c950bf7-cfb6-4003-8d2a-a539f84d3964_photo.jpg",
      averageRating=4.1, totalRatingsCount=1062,
      createdAt="2026-08-31T22:53:17.774981Z", updatedAt="2026-08-31T22:53:17.774981Z",
    ),
    ClubDto(
      id="25674c26-ef66-4b56-8e37-b53b08371673", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportclub SAFO Frankfurt e.V.", address="Kennedyallee 129, 60596 Frankfurt am Main-Frankfurt-Süd",
      city="Frankfurt", country="DE",
      latitude=50.0920085, longitude=8.6645034,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/542c7d91-ed03-49b6-9ccc-20b3243f4435_photo.jpg",
      averageRating=4.1, totalRatingsCount=189,
      createdAt="2026-08-31T22:52:08.190659Z", updatedAt="2026-09-01T14:32:00.967467Z",
    ),
    ClubDto(
      id="99f4929f-1620-42c1-8182-24115dffd4f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Turn- und Sportgemeinde Nordwest 1898 Frankfurt/M. e.V.", address="Weißkirchener Weg 12, 60439 Frankfurt am Main-Frankfurt-Nord-West",
      city="Frankfurt", country="DE",
      latitude=50.166159, longitude=8.6204203,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99c57b11-fa7a-4bb7-a729-64d6f75ec236_photo.jpg",
      averageRating=4.2, totalRatingsCount=47,
      createdAt="2026-08-31T22:52:45.635890Z", updatedAt="2026-08-31T22:52:45.635890Z",
    ),
    ClubDto(
      id="d7ae45a1-7e17-45bf-b5b3-29863df8d4ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Targa Tennis & Soccer Hall Niedererlenbach", address="Am Ohlenstück 171, ehemals 37, 60437 Frankfurt am Main",
      city="Frankfurt", country="DE",
      latitude=50.2033161, longitude=8.7030984,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04e4c7c0-054a-4907-82ff-cfc64234d421_photo.jpg",
      averageRating=3.9, totalRatingsCount=143,
      createdAt="2026-08-31T22:52:24.278239Z", updatedAt="2026-09-01T14:32:03.263352Z",
    ),
  )),
  CitySeo(slug="naples", name="Naples", country="IT", clubCount=22, sports=listOf(Pair("Football", 4), Pair("Basketball", 3), Pair("Billiards", 2), Pair("Volleyball", 2), Pair("Bowling", 2), Pair("Karting", 2), Pair("Laser Tag", 1), Pair("Golf", 1), Pair("Table Tennis", 1), Pair("Padel", 1), Pair("Paintball", 1), Pair("Climbing", 1), Pair("Tennis", 1)), clubs=listOf(
    ClubDto(
      id="ad0e8413-6366-4f7c-bef9-e6cc40cd8240", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rocky Bulls", address="via 80136, Via Guglielmo Appulo, 25, 80136 Napoli NA",
      city="Naples", country="IT",
      latitude=40.856745, longitude=14.2437039,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6dcef999-5b2d-4371-80cf-509e444ee087_ChIJv6w2GGEI_0.jpg",
      averageRating=4.9, totalRatingsCount=260,
      createdAt="2026-08-30T21:24:38.721375Z", updatedAt="2026-08-30T21:24:38.721375Z",
    ),
    ClubDto(
      id="cca24cca-b355-4cb0-9179-0d9ad7f538e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="San Germano Football & More (Calcetto e Calciotto)", address="Via Antonio Beccadelli, 75, 80125 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8262876, longitude=14.1675222,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/614038df-517c-4e5f-a07c-fd7d6e4aee10_ChIJU3M0WyoP_0.jpg",
      averageRating=4.8, totalRatingsCount=110,
      createdAt="2026-08-30T21:23:58.117429Z", updatedAt="2026-08-30T21:59:56.413578Z",
    ),
    ClubDto(
      id="cdfea145-03da-43f8-a60c-d588c6a437cd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Elastic Boys Club 2.0 ex Eurocalcetto Padel e Calcetto", address="Via Augusto Righi, 66, 80125 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8324642, longitude=14.1559553,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3b3a6135-9c95-48cd-b89d-8a720ecc6b74_ChIJCUPh8Z0P_0.jpg",
      averageRating=4.6, totalRatingsCount=175,
      createdAt="2026-08-30T21:23:51.420337Z", updatedAt="2026-09-01T14:31:57.083597Z",
    ),
    ClubDto(
      id="b32ff06a-9b78-4609-84ad-66296e00782d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Football Padel Club Secondigliano", address="Via Privata Detta Scippa, 80144 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8871161, longitude=14.2641785,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7cab9348-7c99-48be-b9a7-55ed0ea323bd_ChIJZ3cqlb8H_0.jpg",
      averageRating=4.6, totalRatingsCount=66,
      createdAt="2026-08-30T21:24:04.357530Z", updatedAt="2026-09-01T14:31:52.300690Z",
    ),
    ClubDto(
      id="3d18a0b9-ed04-4e9b-923f-094554b57ec0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kartodromo Napoli", address="Via Santa Maria la Nova, 1, 80021 Afragola NA",
      city="Naples", country="IT",
      latitude=40.932471, longitude=14.3528313,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b5fd49fb-26de-4d86-9ef8-06bf82c637ae_photo.png",
      averageRating=4.6, totalRatingsCount=715,
      createdAt="2026-08-31T15:58:15.593231Z", updatedAt="2026-08-31T15:58:15.593231Z",
    ),
    ClubDto(
      id="625a8578-8da5-4fdf-b915-96cf6c9b7952", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Black Hole Laser Game", address="Largo Antignano, 7, 80128 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8475541, longitude=14.2274383,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b61eb7a4-32d4-47fb-a55d-8e7f48a4718c_photo.jpg",
      averageRating=4.5, totalRatingsCount=87,
      createdAt="2026-08-31T15:58:21.794481Z", updatedAt="2026-08-31T15:58:21.794481Z",
    ),
    ClubDto(
      id="f43ab7ca-deb6-4717-9c63-18f32f350ea3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Club Napoli Centro", address="Via Costantino Grimaldi, 26, 80143 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8611145, longitude=14.2860345,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aafd8291-7544-4b02-8a4b-250ec5e93751_ChIJiSv7N3cJ_0.jpg",
      averageRating=4.5, totalRatingsCount=59,
      createdAt="2026-08-30T21:24:45.679482Z", updatedAt="2026-08-30T21:59:01.096562Z",
    ),
    ClubDto(
      id="55f81e29-14eb-469b-b68d-911bd6276fb3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Napoli", address="Via Lufrano, SNC, 80026 Casoria NA",
      city="Naples", country="IT",
      latitude=40.8899267, longitude=14.3283675,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/666a4de7-1ffa-4365-9ec3-c68741de3a79_photo.jpg",
      averageRating=4.5, totalRatingsCount=662,
      createdAt="2026-08-31T15:58:27.818286Z", updatedAt="2026-08-31T15:58:27.818286Z",
    ),
    ClubDto(
      id="f735be37-aa7e-43d7-b997-9f04bcd67d9d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paradise Coast Sports Complex", address="3940 City Gate Blvd N, Naples, FL 34117, USA",
      city="Naples", country="IT",
      latitude=26.1666741, longitude=-81.6707141,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ec50fa02-5b91-40aa-a9e8-e410ec6d15d2_photo.jpg",
      averageRating=4.5, totalRatingsCount=457,
      createdAt="2026-08-31T15:57:34.460189Z", updatedAt="2026-08-31T22:11:19.920882Z",
    ),
    ClubDto(
      id="e6b7c8c6-eee2-41cf-b35c-df37aedf1966", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports CLUB of Naples", address="3275 Pine Ridge Rd, Naples, FL 34109, USA",
      city="Naples", country="IT",
      latitude=26.2128534, longitude=-81.7550658,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b37fd893-2ae3-49dc-97d7-153c2d138f62_photo.jpg",
      averageRating=4.5, totalRatingsCount=74,
      createdAt="2026-08-31T15:57:20.726711Z", updatedAt="2026-08-31T15:57:20.726711Z",
    ),
    ClubDto(
      id="5a10f6fe-058f-43d7-a539-641b3a05c11d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bull&Pool - Billiard Club", address="Largo Francesco Celebrano, 30, 80129 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8500033, longitude=14.232532,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/95f31898-53ad-4739-a2e1-d340d5a57060_ChIJtyUOX_EI_0.jpg",
      averageRating=4.4, totalRatingsCount=175,
      createdAt="2026-08-30T21:24:18.451319Z", updatedAt="2026-08-30T21:24:18.451319Z",
    ),
    ClubDto(
      id="df58bdc6-86dd-4901-b64d-293c90741bce", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Circuito Internazionale Napoli", address="Via Sarno Palma, 80036 Sarno SA",
      city="Naples", country="IT",
      latitude=40.8381704, longitude=14.5663348,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7ea2ba62-c856-4de1-8dc9-20cc03211cd8_photo.jpg",
      averageRating=4.4, totalRatingsCount=1276,
      createdAt="2026-08-31T15:58:08.229313Z", updatedAt="2026-08-31T15:58:08.229313Z",
    ),
    ClubDto(
      id="5bddd314-9c63-4bf8-9f71-c075601fc280", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ALCOTT Arena", address="Viale Giochi del Mediterraneo, 80125 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8223266, longitude=14.1790714,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/53949289-dfc0-474e-8a7e-f5c19babb38d_photo.jpg",
      averageRating=4.3, totalRatingsCount=727,
      createdAt="2026-08-31T15:57:27.452415Z", updatedAt="2026-08-31T15:57:27.452415Z",
    ),
    ClubDto(
      id="f019a416-a85a-4468-8914-32dbb2199be4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporting Club San Francesco", address="Via Francesco Spinelli, 35, 80145 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8971453, longitude=14.2203319,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3b4d678b-adb5-4def-94b0-bee08954c0a1_ChIJ4STMcEcG_0.jpg",
      averageRating=4.3, totalRatingsCount=288,
      createdAt="2026-08-30T21:23:44.534759Z", updatedAt="2026-08-30T21:23:44.534759Z",
    ),
    ClubDto(
      id="bb8f45f9-3725-49dd-83a6-dface92fa863", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club Napoli", address="Viale Anton Dohrn, 80122 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8318581, longitude=14.2282852,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e9b04f08-4520-4608-90bb-5ae652cd8db8_ChIJheqdSwMJ_1.jpg",
      averageRating=4.3, totalRatingsCount=993,
      createdAt="2026-08-30T21:24:52.269368Z", updatedAt="2026-08-31T22:11:22.489232Z",
    ),
    ClubDto(
      id="197abbad-2b88-44a1-8201-670d78b9668d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ASSOCIAZIONE CULTURALE SOLIMENA", address="Via Francesco Solimena, 95, 80129 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8444595, longitude=14.2298107,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0f1cca1f-34f4-4b5a-9636-b2202e52c25d_ChIJG8sjlPoI_0.jpg",
      averageRating=4.2, totalRatingsCount=272,
      createdAt="2026-08-30T21:24:11.527993Z", updatedAt="2026-08-30T21:24:11.527993Z",
    ),
    ClubDto(
      id="8449177c-be02-4e67-8c5d-79efa3e120ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Oltremare - Fuorigrotta", address="Viale John Fitzgerald Kennedy, 12, 80125 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8234309, longitude=14.1839123,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/27a7886a-0380-4651-b7a3-9cb6f76fba4e_ChIJ1Q1APcsO_0.jpg",
      averageRating=4.1, totalRatingsCount=2560,
      createdAt="2026-08-30T21:24:25.253286Z", updatedAt="2026-08-30T21:55:46.056168Z",
    ),
    ClubDto(
      id="8120f9f0-139c-4b81-accd-fdb27f0c588c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Show Bowl", address="Via Augusto Righi, 17, 80125 Napoli NA",
      city="Naples", country="IT",
      latitude=40.8315201, longitude=14.1602276,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/59f3dd0c-90a9-4d43-866e-0d3bc5611da4_ChIJoTz20e8O_0.jpg",
      averageRating=4.1, totalRatingsCount=2241,
      createdAt="2026-08-30T21:24:31.853305Z", updatedAt="2026-08-30T21:24:31.853305Z",
    ),
    ClubDto(
      id="3eaeec73-b0c3-47ef-aa9e-5f12951364c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Naples Pong Table Tennis", address="12725 Tamiami Trl E suite 134, Naples, FL 34113, USA",
      city="Naples", country="IT",
      latitude=26.0673343, longitude=-81.698781,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/697c27bd-3586-4b22-a900-c5c38421356f_photo.jpg",
      averageRating=5.0, totalRatingsCount=36,
      createdAt="2026-08-31T15:57:55.648606Z", updatedAt="2026-08-31T15:57:55.648606Z",
    ),
    ClubDto(
      id="d008dce4-0f0a-4679-9c20-271dd4944240", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hibiscus Golf Club", address="5375 Hibiscus Dr, Naples, FL 34113, USA",
      city="Naples", country="IT",
      latitude=26.1076661, longitude=-81.7383629,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e9573045-29af-423f-9393-78ec560c61b5_photo.jpg",
      averageRating=3.5, totalRatingsCount=210,
      createdAt="2026-08-31T15:57:48.922604Z", updatedAt="2026-08-31T22:11:17.329543Z",
    ),
    ClubDto(
      id="1759c177-ae6d-4ad9-9bb1-0627d04cde54", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="US Open Pickleball Academy", address="3500 Thomasson Dr, Naples, FL 34112, USA",
      city="Naples", country="IT",
      latitude=26.1072451, longitude=-81.7628074,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d89330cf-e8ad-4bd2-bc0d-94154ae348ca_photo.jpg",
      averageRating=4.6, totalRatingsCount=35,
      createdAt="2026-08-31T15:57:13.249451Z", updatedAt="2026-08-31T15:57:13.249451Z",
    ),
    ClubDto(
      id="c5a56a24-50c2-4120-9039-99db77c2ccbf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Volley Napoli", address="c/o Paintball Napoli Extreme, Via Lufrano, SNC, 80026 Casoria NA",
      city="Naples", country="IT",
      latitude=40.889393, longitude=14.3280991,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ceca503c-4a95-4a40-9ddd-dd8d2076eebc_photo.jpg",
      averageRating=4.5, totalRatingsCount=13,
      createdAt="2026-08-31T15:57:40.441439Z", updatedAt="2026-08-31T15:57:40.441439Z",
    ),
  )),
  CitySeo(slug="kharkiv", name="Kharkiv", country="UA", clubCount=22, sports=listOf(Pair("Tennis", 3), Pair("Basketball", 3), Pair("Football", 3), Pair("Volleyball", 3), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Table Tennis", 2), Pair("Paintball", 2), Pair("Bowling", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="ffb3af87-3dbe-4bf2-8ab1-63c81a7888c8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Дитячий баскетбольний клуб Push Team", address="вулиця Григорія Сковороди, 77, Харків, Харківська область, 61024",
      city="Kharkiv", country="UA",
      latitude=50.0053831, longitude=36.2459515,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b7818cf4-5969-4594-bac7-5b4fd767d989_photo.jpg",
      averageRating=5.0, totalRatingsCount=112,
      createdAt="2026-08-31T15:38:01.903149Z", updatedAt="2026-08-31T15:38:01.903149Z",
    ),
    ClubDto(
      id="f477cf76-51c0-45c0-832a-cc109016ce58", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MurawayNick", address="майдан Свободи, 5, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=50.0066699, longitude=36.2270766,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eb672616-2d2d-483d-b510-5fd28584df07_ChIJ0d7Y8x-h_0.jpg",
      averageRating=4.8, totalRatingsCount=242,
      createdAt="2026-08-30T17:08:06.545304Z", updatedAt="2026-08-30T20:52:18.880583Z",
    ),
    ClubDto(
      id="623d8d56-6c32-4edc-a441-7cef53c547e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Форпост", address="вулиця Плеханівська, 134, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=49.9652218, longitude=36.293787,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e0cb1fe-6e7d-49dc-98dd-8056b341e5ed_ChIJc9MUGGYK_0.jpg",
      averageRating=4.8, totalRatingsCount=2008,
      createdAt="2026-08-30T17:07:21.434519Z", updatedAt="2026-08-30T20:52:53.281467Z",
    ),
    ClubDto(
      id="0fbc5c96-486f-4763-b9f0-0df0c82663e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбольний комплекс \"Екстремал\"", address="проспект Любові Малої, 93, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=49.9587558, longitude=36.1782426,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0ef823d8-c2d9-4d66-a03a-82c292d88328_ChIJ4RXRFimg_0.jpg",
      averageRating=4.7, totalRatingsCount=1781,
      createdAt="2026-08-30T17:08:37.967758Z", updatedAt="2026-08-30T20:52:43.650326Z",
    ),
    ClubDto(
      id="e3f54844-246d-4211-81c9-f5084f13b998", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Футбольні поля в Парку Горького", address="вулиця Сумська, 81, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=50.0217589, longitude=36.246461,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d140c19e-c514-42af-8845-78e978411820_ChIJY2Vt9Cqh_2.jpg",
      averageRating=4.7, totalRatingsCount=1574,
      createdAt="2026-08-30T17:07:29.536551Z", updatedAt="2026-08-31T22:11:28.028491Z",
    ),
    ClubDto(
      id="8024bc53-5980-4b3d-b434-ae585f680d83", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Central Park Tennis Club", address="вулиця Сумська, 81, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=50.0217824, longitude=36.2498385,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aa042046-e220-42ab-9f65-2308db8cf13c_ChIJV0FAoiqh_0.jpg",
      averageRating=4.6, totalRatingsCount=368,
      createdAt="2026-08-30T17:09:01.797231Z", updatedAt="2026-08-30T20:52:09.688076Z",
    ),
    ClubDto(
      id="3f4e705b-0434-467c-bb5f-742a2a2023b4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Локомотив", address="вулиця Велика Панасівська, 90, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=49.9996752, longitude=36.2054577,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6018a032-2f58-41d2-a02a-19b5f13ffb8b_ChIJnbudXQSh_0.jpg",
      averageRating=4.6, totalRatingsCount=3737,
      createdAt="2026-08-30T17:07:14.057923Z", updatedAt="2026-08-30T20:52:38.662355Z",
    ),
    ClubDto(
      id="05d1879a-058f-49c0-82bf-b1fc78e02b80", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Піонер", address="вулиця Георгія Тарасенка, 126, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=49.974779, longitude=36.279709,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ddfea99-22d7-47a8-ba91-ae8bcca04718_ChIJoWLBpvqg_0.jpg",
      averageRating=4.6, totalRatingsCount=463,
      createdAt="2026-08-30T17:08:30.317518Z", updatedAt="2026-08-30T20:52:44.613762Z",
    ),
    ClubDto(
      id="82db5c14-834d-425e-a77d-0add2a24f5fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скалодром \"ПИК\" Центр", address="вулиця Академіка Павлова, 44-Б, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=49.990484, longitude=36.290299,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a4c8784d-cc3b-4200-b40b-9753c280cde2_ChIJE41lraCg_0.jpg",
      averageRating=4.6, totalRatingsCount=241,
      createdAt="2026-08-30T17:08:15.004924Z", updatedAt="2026-08-30T20:52:45.883180Z",
    ),
    ClubDto(
      id="cc46a5ba-1fc1-446b-8c2d-6d6ff978a2ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спорт & корт", address="вулиця Дмитрівська, 12, Харків, Харківська область, 61000",
      city="Kharkiv", country="UA",
      latitude=49.9905221, longitude=36.2154446,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c3b0d07a-dbf2-4608-9570-d4f3dc1a08ae_photo.jpg",
      averageRating=4.6, totalRatingsCount=247,
      createdAt="2026-08-31T15:38:10.427840Z", updatedAt="2026-08-31T15:38:10.427840Z",
    ),
    ClubDto(
      id="180ad8e9-4e44-4ace-abd3-c523024eaa93", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="АКС Спорт", address="Ювілейний проспект, 54Г, Харків, Харківська область, 61000",
      city="Kharkiv", country="UA",
      latitude=49.9928863, longitude=36.3338782,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/173c38c3-efbf-444f-99e9-39bda3ae512c_photo.jpg",
      averageRating=4.5, totalRatingsCount=78,
      createdAt="2026-08-31T15:38:16.931812Z", updatedAt="2026-08-31T15:38:16.931812Z",
    ),
    ClubDto(
      id="bf8b99ef-3432-4972-b2cf-b4bd71083033", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="СХІД", address="вулиця 12-го Квітня, 5, Харків, Харківська область, 61000",
      city="Kharkiv", country="UA",
      latitude=49.9398087, longitude=36.3871085,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cf0cfe30-773c-41fc-b136-cd4885c78ab0_photo.jpg",
      averageRating=4.4, totalRatingsCount=836,
      createdAt="2026-08-31T15:38:37.765397Z", updatedAt="2026-08-31T15:38:37.765397Z",
    ),
    ClubDto(
      id="1a8df33a-4d09-4c6a-8f0d-eb9b3506ab7c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TETRA", address="вулиця Сумська, 85, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=50.0275615, longitude=36.2548363,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c71d3422-2be3-4fff-9d24-1e5ca7f7413d_ChIJ-5jjhtam_1.jpg",
      averageRating=4.3, totalRatingsCount=301,
      createdAt="2026-08-30T17:09:07.952344Z", updatedAt="2026-08-31T22:11:22.167350Z",
    ),
    ClubDto(
      id="ff2bec59-b800-4d5b-96ca-9321c89d95f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Бильярдный клуб \"Олимп\"", address="вулиця Ахсарова, 21, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=50.047338, longitude=36.213218,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/876efcda-c09f-4c7f-b56b-4371a58833f9_ChIJocnHUq-m_0.jpg",
      averageRating=4.3, totalRatingsCount=432,
      createdAt="2026-08-30T17:07:44.684661Z", updatedAt="2026-08-30T20:52:27.841339Z",
    ),
    ClubDto(
      id="0ae3559e-e915-4575-b78f-c38435fa14db", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Волна", address="вулиця Астрономічна, 7А, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=50.0487812, longitude=36.2922225,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/82abd41b-d8b2-4861-ba81-7d2cbac95a87_ChIJAQDQAwKn_0.jpg",
      averageRating=4.3, totalRatingsCount=1467,
      createdAt="2026-08-30T17:08:53.096524Z", updatedAt="2026-08-30T20:52:29.235588Z",
    ),
    ClubDto(
      id="f895b50e-b2cb-4e60-ab29-700c41c122cd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ОХОТА Бильярдный и Развлекательный Клуб", address="вул. Бригади Хартія, 56, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=49.9541323, longitude=36.3528178,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/02062c13-9f61-48fc-95ec-795ae8f815e8_ChIJy6zFDrwL_0.jpg",
      averageRating=4.2, totalRatingsCount=925,
      createdAt="2026-08-30T17:07:36.693737Z", updatedAt="2026-08-30T20:52:40.588962Z",
    ),
    ClubDto(
      id="179f739c-80e3-4b4a-8319-d60053788837", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Уніфехт", address="провулок Отакара Яроша, 14, Харків, Харківська область, 61000",
      city="Kharkiv", country="UA",
      latitude=50.024308, longitude=36.2189553,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c32bcf64-0382-4353-9afa-d25a34f764ed_photo.jpg",
      averageRating=4.1, totalRatingsCount=139,
      createdAt="2026-08-31T15:38:23.329726Z", updatedAt="2026-08-31T15:38:23.329726Z",
    ),
    ClubDto(
      id="c846a35e-98f8-4c53-a321-46c5c8f938bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Боулінґ-клуб 24", address="вулиця Каденюка, 11А, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=49.9557056, longitude=36.3204667,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff6d41ee-cfa5-44cc-8c9e-766a66b7c841_ChIJy_eFe1QK_0.jpg",
      averageRating=4.0, totalRatingsCount=2418,
      createdAt="2026-08-30T17:07:59.040581Z", updatedAt="2026-08-30T20:52:28.218405Z",
    ),
    ClubDto(
      id="fa3feb2b-e0e7-4886-808b-f808e2275584", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Клуб настольного тенниса Spirit", address="Аерокосмічний проспект, 70, Харків, Харківська область, 61000",
      city="Kharkiv", country="UA",
      latitude=49.9727935, longitude=36.2529033,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/37be2491-c8bb-4aef-93c9-5912d29ecf77_photo.jpg",
      averageRating=5.0, totalRatingsCount=32,
      createdAt="2026-08-31T15:38:51.321928Z", updatedAt="2026-08-31T15:38:51.321928Z",
    ),
    ClubDto(
      id="5b653e81-a346-4ae8-b5ef-aee88a7f9c72", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбольный клуб ТАКТИК ПРО", address="вулиця Фронтова, 3, Харків, 61000 Kharkiv, Ukraine",
      city="Kharkiv", country="UA",
      latitude=50.0342568, longitude=36.2552118,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ff3e2a2e-6c71-4e8c-a9f8-ea90b7df099f_ChIJBfbBKUCn_0.jpg",
      averageRating=4.9, totalRatingsCount=21,
      createdAt="2026-08-30T17:08:45.395950Z", updatedAt="2026-08-30T20:52:43.883613Z",
    ),
    ClubDto(
      id="208641da-42d5-4043-b22b-bcc4d20e59ad", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пляжний волейбол", address="Харків, Харківська область, 61000",
      city="Kharkiv", country="UA",
      latitude=50.0378252, longitude=36.1856015,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/617ea1dd-32a2-4ee1-9cbc-5e71c1ccb2fc_photo.jpg",
      averageRating=4.9, totalRatingsCount=14,
      createdAt="2026-08-31T15:38:30.296216Z", updatedAt="2026-08-31T15:38:30.296216Z",
    ),
    ClubDto(
      id="fc4aa5dc-1d3e-4b33-87bb-8f3e173baf97", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Настільний теніс Smash", address="майдан Героїв Небесної Сотні, 19, Харків, Харківська область, 61000",
      city="Kharkiv", country="UA",
      latitude=49.9847838, longitude=36.2469054,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd336524-3187-49cc-8dcf-b08f25cec612_photo.jpg",
      averageRating=5.0, totalRatingsCount=8,
      createdAt="2026-08-31T15:38:45.043756Z", updatedAt="2026-08-31T15:38:45.043756Z",
    ),
  )),
  CitySeo(slug="tbilisi", name="Tbilisi", country="GE", clubCount=21, sports=listOf(Pair("Volleyball", 3), Pair("Football", 3), Pair("Tennis", 3), Pair("Padel", 3), Pair("Billiards", 2), Pair("Karting", 2), Pair("Basketball", 2), Pair("Climbing", 1), Pair("Paintball", 1), Pair("Golf", 1)), clubs=listOf(
    ClubDto(
      id="0f2a78bf-0e50-4b57-9692-b524e1748cf9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Monument - Urban Climbing - guided sessions", address="PRH8+2VX, Nikoloz Khudadovi St, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.7276059, longitude=44.8172481,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c6540ce-248e-44cb-86ee-08446ab393d8_photo.jpg",
      averageRating=4.9, totalRatingsCount=49,
      createdAt="2026-09-01T09:24:04.263098Z", updatedAt="2026-09-01T09:24:04.263098Z",
    ),
    ClubDto(
      id="71440286-cc36-44d4-92ea-e68bc2f26069", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tbilisi Hills Golf", address="Gardabani district, Village Kvemo Teleti, T'bilisi 0313",
      city="Tbilisi", country="GE",
      latitude=41.6537667, longitude=44.8523926,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/55cf3df2-16cf-4e94-8859-278a7cc4f6a0_photo.jpg",
      averageRating=4.8, totalRatingsCount=572,
      createdAt="2026-09-01T09:23:31.405949Z", updatedAt="2026-09-01T09:23:31.405949Z",
    ),
    ClubDto(
      id="28647157-174f-4d61-ac2a-dacf7548c680", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Volleyball Court", address="8 Kiev Street, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.7072131, longitude=44.8014007,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d5c19fa-582a-44b1-a4b8-2388bdfcfd3b_photo.jpg",
      averageRating=4.8, totalRatingsCount=90,
      createdAt="2026-09-01T09:23:23.199984Z", updatedAt="2026-09-01T09:23:23.199984Z",
    ),
    ClubDto(
      id="8875c27e-99c1-4aa1-ac59-fcd4bfff0980", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Boris Paichadze Dinamo Arena", address="2 Akaki Tsereteli Ave, T'bilisi 0112",
      city="Tbilisi", country="GE",
      latitude=41.7230129, longitude=44.7897691,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f3933505-94fe-452b-b859-b23f27fecb86_photo.jpg",
      averageRating=4.7, totalRatingsCount=5100,
      createdAt="2026-09-01T09:22:25.249645Z", updatedAt="2026-09-01T09:22:25.249645Z",
    ),
    ClubDto(
      id="cbbb66f5-a9f2-4214-838f-da467a66d58e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dinamo Academy", address="62 ლუბლიანას ქუჩა, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.7778667, longitude=44.7735595,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/35416b1e-9eb9-4bf2-b6f5-416a06a5b9e7_photo.jpg",
      averageRating=4.7, totalRatingsCount=266,
      createdAt="2026-09-01T09:23:18.804378Z", updatedAt="2026-09-01T09:23:18.804378Z",
    ),
    ClubDto(
      id="ba9f42f7-f9a5-480c-b8a9-e7e057b541b2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pool Room", address="N 5 მ. ნოზაძის ქუჩა, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.7907963, longitude=44.8187311,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5c26f16d-7462-4a9f-8cda-3b1a0a662b63_photo.jpg",
      averageRating=4.6, totalRatingsCount=167,
      createdAt="2026-09-01T09:24:12.058275Z", updatedAt="2026-09-01T09:24:12.058275Z",
    ),
    ClubDto(
      id="7984b783-4d9e-4ca1-9a67-9168ddf1cc68", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rustavi International Motorpark", address="21 Rustavi Racing Track, Rustavi",
      city="Tbilisi", country="GE",
      latitude=41.5713296, longitude=44.9478723,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ab471912-1332-45e1-9316-034b89649d53_photo.jpg",
      averageRating=4.6, totalRatingsCount=1092,
      createdAt="2026-09-01T09:23:36.456982Z", updatedAt="2026-09-01T09:23:36.456982Z",
    ),
    ClubDto(
      id="1c43a6a2-b58c-4187-b675-f4a34ce3dbbc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zaza Pachulia Basketball Academy", address="105ა Akaki Tsereteli Ave, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.7423131, longitude=44.7803596,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c91baa71-e160-4cf9-89d0-5bd63b320c25_photo.jpg",
      averageRating=4.6, totalRatingsCount=127,
      createdAt="2026-09-01T09:23:14.219657Z", updatedAt="2026-09-01T09:23:14.219657Z",
    ),
    ClubDto(
      id="882054d9-0aa2-4960-9cfc-14083dd6bac6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billiard Club Rio", address="45 Vazha Pshavela Ave, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.7259645, longitude=44.7436686,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e9163e07-ca8e-4410-8d56-69188325351a_photo.jpg",
      averageRating=4.5, totalRatingsCount=274,
      createdAt="2026-09-01T09:24:08.013579Z", updatedAt="2026-09-01T09:24:08.013579Z",
    ),
    ClubDto(
      id="61958992-821c-486b-91a6-42a41ba3bcf4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Sport court", address="7ა Mikheil Asatiani St, T'bilisi 0177",
      city="Tbilisi", country="GE",
      latitude=41.7266385, longitude=44.7518966,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bc8fe987-b608-4bc4-af02-218936aea453_photo.jpg",
      averageRating=4.4, totalRatingsCount=156,
      createdAt="2026-09-01T09:22:49.211146Z", updatedAt="2026-09-01T09:22:49.211146Z",
    ),
    ClubDto(
      id="7c759485-d3b8-45cd-bffe-5e46c3343a78", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mziuri Tennis Courts", address="20 Nino Ramishvili St, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.713208, longitude=44.7663622,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8ae6b5e9-e268-4965-984e-c70cf967a712_photo.jpg",
      averageRating=4.4, totalRatingsCount=291,
      createdAt="2026-09-01T09:22:43.827576Z", updatedAt="2026-09-01T09:22:43.827576Z",
    ),
    ClubDto(
      id="14cb6eb5-6aff-4525-9e6e-24fed16af1c4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tbilisi Sports Palace", address="1-26 ოცდაექვსი მაისის მოედანი, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.7195543, longitude=44.7796029,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/52625480-069b-4984-a9a5-482119ca6096_photo.jpg",
      averageRating=4.4, totalRatingsCount=1825,
      createdAt="2026-09-01T09:23:08.662809Z", updatedAt="2026-09-01T09:23:08.662809Z",
    ),
    ClubDto(
      id="281eebe5-7648-447e-89db-5e1169cfcf38", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Leila Meskhi Tennis Academy Fitness And Pool", address="29 Kote Marjanishvili St, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.709551, longitude=44.7988479,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c756c0c6-73dd-470c-882a-09335c918e9d_photo.jpg",
      averageRating=4.3, totalRatingsCount=389,
      createdAt="2026-09-01T09:22:39.322767Z", updatedAt="2026-09-01T09:22:39.322767Z",
    ),
    ClubDto(
      id="e99b2e05-d4d8-4b0f-aed9-78cbd4e3d614", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arena", address="2 University St, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.7182552, longitude=44.7420305,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9fbc5f3f-d9e1-464f-bbf6-bf6ba2197f2d_photo.jpg",
      averageRating=4.2, totalRatingsCount=1144,
      createdAt="2026-09-01T09:22:30.017676Z", updatedAt="2026-09-01T09:22:30.017676Z",
    ),
    ClubDto(
      id="859066a1-9d2a-49f6-a6c7-04c0ca4a2887", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Lilo - კარტინგ ლილო", address="2 Mshvidoba St, T'bilisi 0151",
      city="Tbilisi", country="GE",
      latitude=41.6940257, longitude=45.0115766,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/14eeaafd-9cb2-4819-8f75-876eb9be9c54_photo.jpg",
      averageRating=4.2, totalRatingsCount=84,
      createdAt="2026-09-01T09:23:40.889178Z", updatedAt="2026-09-01T09:23:40.889178Z",
    ),
    ClubDto(
      id="2db17699-6dbd-447f-81d0-29cd562bc9bd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Academy of Georgia", address="26 Petre Kavtaradze St, T'bilisi 0186",
      city="Tbilisi", country="GE",
      latitude=41.7210273, longitude=44.734255,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/720db031-4ac9-4e0e-9254-f96c968e58b4_photo.jpg",
      averageRating=4.2, totalRatingsCount=68,
      createdAt="2026-09-01T09:22:54.221011Z", updatedAt="2026-09-01T09:22:54.221011Z",
    ),
    ClubDto(
      id="283512a2-4b74-4f97-b998-2ae9b5af93ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="padelbade Dighomi", address="240 Davit Aghmashenebeli Ave, T'bilisi 0159",
      city="Tbilisi", country="GE",
      latitude=41.8050415, longitude=44.7686565,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84f4fab5-1035-4a49-9834-c22012363c1f_photo.jpg",
      averageRating=4.8, totalRatingsCount=31,
      createdAt="2026-09-01T09:22:59.041551Z", updatedAt="2026-09-01T09:22:59.041551Z",
    ),
    ClubDto(
      id="f0d81eef-9c02-4862-9453-2cdd33d69b1b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ACE Tbilisi Volleyball Club-ფრენბურთის კლუბი ,,ეისი-თბილისი''", address="2 Petre Melikishvili St, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.7064068, longitude=44.7860233,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/793f06c5-f027-4182-93b6-3ed16b044e19_photo.jpg",
      averageRating=5.0, totalRatingsCount=29,
      createdAt="2026-09-01T09:23:26.881454Z", updatedAt="2026-09-01T09:23:26.881454Z",
    ),
    ClubDto(
      id="9d3102d8-55c9-45ab-b128-c6eb2fdfc545", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Center Imedi", address="182 Davit Aghmashenebeli Ave, T'bilisi",
      city="Tbilisi", country="GE",
      latitude=41.7209918, longitude=44.7876847,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/faa29426-9dba-4c89-98ee-6a30da61a8e4_photo.jpg",
      averageRating=4.7, totalRatingsCount=28,
      createdAt="2026-09-01T09:22:35.123261Z", updatedAt="2026-09-01T09:22:35.123261Z",
    ),
    ClubDto(
      id="0303d2eb-f748-433f-bae1-50375054d061", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KUS TBA PADEL / კუს ტბა პადელი", address="Turtle Lake, T'bilisi 0179",
      city="Tbilisi", country="GE",
      latitude=41.700655, longitude=44.7574481,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7617c091-91c8-44c9-a64f-f4e188ac5e27_photo.jpg",
      averageRating=4.7, totalRatingsCount=27,
      createdAt="2026-09-01T09:23:05.122161Z", updatedAt="2026-09-01T09:23:05.122161Z",
    ),
    ClubDto(
      id="e4886767-6e49-41a1-a11b-3aa1abc25783", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PAINTBALL PARK", address="Unnamed Road, Gamarjveba, Tbilisi",
      city="Tbilisi", country="GE",
      latitude=41.6684369, longitude=45.0258055,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bbd858a8-c9dc-4e6f-a424-4bc0bdc0f7bc_photo.jpg",
      averageRating=4.5, totalRatingsCount=16,
      createdAt="2026-09-01T09:24:17.179898Z", updatedAt="2026-09-01T09:24:17.179898Z",
    ),
  )),
  CitySeo(slug="murcia", name="Murcia", country="ES", clubCount=21, sports=listOf(Pair("Volleyball", 4), Pair("Tennis", 3), Pair("Football", 3), Pair("Golf", 2), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Karting", 2), Pair("Padel", 1), Pair("Paintball", 1), Pair("Climbing", 1)), clubs=listOf(
    ClubDto(
      id="8d9265a5-2298-4246-bd40-9d4de0ded811", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball León Bacons Bridge", address="Carril de los Canos, 41, a, 30006 Puente Tocinos, Murcia",
      city="Murcia", country="ES",
      latitude=37.9988124, longitude=-1.1070634,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/561e84f3-9e4a-480f-aa83-8839aa4fb110_photo.jpg",
      averageRating=4.8, totalRatingsCount=437,
      createdAt="2026-09-01T08:53:06.328768Z", updatedAt="2026-09-01T08:53:06.328768Z",
    ),
    ClubDto(
      id="29f85e90-69c8-47fd-a637-e86b53d64956", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Oriokart Orihuela Karting, sl", address="CV-870, 03316, Alicante",
      city="Murcia", country="ES",
      latitude=38.1097789, longitude=-0.9361382,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/268e9144-4dcb-4f94-9d80-51a174ef3b6d_photo.jpg",
      averageRating=4.6, totalRatingsCount=922,
      createdAt="2026-09-01T08:52:40.260763Z", updatedAt="2026-09-01T08:52:40.260763Z",
    ),
    ClubDto(
      id="3a472a65-a3e2-4427-becc-a07c571aa480", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bolera Karaoke Tulum", address="Av. del Rocío, 5, 30007 Puente Tocinos, Murcia",
      city="Murcia", country="ES",
      latitude=37.9929999, longitude=-1.116229,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f1521796-f495-4655-acb5-c83833864213_photo.jpg",
      averageRating=4.5, totalRatingsCount=773,
      createdAt="2026-09-01T08:52:44.946678Z", updatedAt="2026-09-01T08:52:44.946678Z",
    ),
    ClubDto(
      id="1127bb2b-0170-4f30-87b5-58e81271ad81", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Murcia Tennis Club", address="C. Cronista Carlos Valcárcel, 5, 30008 Murcia",
      city="Murcia", country="ES",
      latitude=37.9930922, longitude=-1.134578,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39315cee-c75b-463c-a640-ec6bf6e83b18_photo.jpg",
      averageRating=4.5, totalRatingsCount=467,
      createdAt="2026-09-01T08:51:52.544044Z", updatedAt="2026-09-01T08:51:52.544044Z",
    ),
    ClubDto(
      id="e7154428-2e51-4aac-86ea-94633b743dd4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Vóley Playa Arena Alicante", address="Av. de Niza, 25B, 03540 Alicante",
      city="Murcia", country="ES",
      latitude=38.3760052, longitude=-0.4102579,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0e62a034-c7f6-4179-b7f7-08aadaaecdd2_photo.jpg",
      averageRating=4.8, totalRatingsCount=46,
      createdAt="2026-09-01T08:52:19.140485Z", updatedAt="2026-09-01T08:52:19.140485Z",
    ),
    ClubDto(
      id="b7ac04c4-3cdc-4181-ac8a-c52c1dae625d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Altaona Golf & Country Village", address="San Javier (RM19, Autovía de Murcia, km 1,4, 30155 Baños y Mendigo, Murcia",
      city="Murcia", country="ES",
      latitude=37.8665295, longitude=-1.0969823,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b17c3c06-bc9b-4ccb-a2d4-c1ff4599d711_photo.jpg",
      averageRating=4.4, totalRatingsCount=260,
      createdAt="2026-09-01T08:52:30.842285Z", updatedAt="2026-09-01T08:52:30.842285Z",
    ),
    ClubDto(
      id="eeb882fb-1892-4e48-bced-18f8cad5915d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="El Valle Golf", address="Autovía Murcia-San Javier, Km 4, 30155 Baños y Mendigos, Murcia",
      city="Murcia", country="ES",
      latitude=37.8812395, longitude=-1.0852693,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9b9d2484-af10-4b51-929b-e6e4608dfc54_photo.jpg",
      averageRating=4.4, totalRatingsCount=1461,
      createdAt="2026-09-01T08:52:23.525754Z", updatedAt="2026-09-01T08:52:23.525754Z",
    ),
    ClubDto(
      id="368a1ae9-6933-460c-afdd-7a0b679a0184", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Go-Karts Orihuela Costa", address="Carretera Torrevieja - Cartagena, km 5, 700, 03189 Orihuela Costa, Alicante",
      city="Murcia", country="ES",
      latitude=37.940593, longitude=-0.7193146,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8b131db9-d806-4e66-aa31-5493235819f1_photo.jpg",
      averageRating=4.4, totalRatingsCount=2742,
      createdAt="2026-09-01T08:52:35.687551Z", updatedAt="2026-09-01T08:52:35.687551Z",
    ),
    ClubDto(
      id="254690b5-587f-429c-b89a-77c39cfe2198", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rocodromo Magic Mountain: Climbing Murcia", address="C. Don Quijote, 0, 30009 Murcia",
      city="Murcia", country="ES",
      latitude=37.9960908, longitude=-1.143687,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/36d376d1-12f1-4927-bfa1-41f9d343108d_photo.jpg",
      averageRating=4.4, totalRatingsCount=234,
      createdAt="2026-09-01T08:52:53.115560Z", updatedAt="2026-09-01T08:52:53.115560Z",
    ),
    ClubDto(
      id="f227b7f1-1456-433a-b871-9cfd41dec8eb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Carlos Alcaraz Academy", address="Av. Buenavista, 30120 El Palmar, Murcia",
      city="Murcia", country="ES",
      latitude=37.9258728, longitude=-1.1613615,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/88f82384-61ee-4c1b-8cfe-69f2bb847abc_photo.jpg",
      averageRating=4.3, totalRatingsCount=413,
      createdAt="2026-09-01T08:51:58.684721Z", updatedAt="2026-09-01T08:51:58.684721Z",
    ),
    ClubDto(
      id="fd8c8823-24a8-4a9e-b575-cc03777fd2c9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Pádel Murcia", address="C. los Gavilanes, s/n, 30107 Guadalupe, Murcia",
      city="Murcia", country="ES",
      latitude=38.0004723, longitude=-1.1832699,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3b0283e5-51be-4c0a-9a4d-88185e07bde7_photo.jpg",
      averageRating=4.3, totalRatingsCount=456,
      createdAt="2026-09-01T08:52:03.175253Z", updatedAt="2026-09-01T08:52:03.175253Z",
    ),
    ClubDto(
      id="941dd60d-c652-436a-8b8e-6650e4ce2d0c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bolera Las Palmeras", address="Carretera Mazarrón, Naves 5-6, 30833 Murcia",
      city="Murcia", country="ES",
      latitude=37.9334937, longitude=-1.1975793,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1a8261f4-4486-4318-a1ce-81d639a037ef_photo.jpg",
      averageRating=4.2, totalRatingsCount=669,
      createdAt="2026-09-01T08:52:48.777283Z", updatedAt="2026-09-01T08:52:48.777283Z",
    ),
    ClubDto(
      id="4f67e574-7adf-437c-8816-2d52f80f0415", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polideportivo Infante", address="Av. Pío Baroja, 8D, 30011 Murcia",
      city="Murcia", country="ES",
      latitude=37.9763137, longitude=-1.1212723,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1f331a85-2afe-4a94-98f6-db615fe239bf_photo.jpg",
      averageRating=4.1, totalRatingsCount=380,
      createdAt="2026-09-01T08:52:07.203170Z", updatedAt="2026-09-01T08:52:07.203170Z",
    ),
    ClubDto(
      id="6a99c8f7-9bcd-48a7-bec1-73f363eae56c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polideportivo Municipal José Barnés", address="Calle Mar Menor, 30009 Murcia",
      city="Murcia", country="ES",
      latitude=37.9955533, longitude=-1.1363447,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d6dd5eb0-bc2e-4a11-8411-6684b2307343_photo.jpg",
      averageRating=4.1, totalRatingsCount=722,
      createdAt="2026-09-01T08:51:46.517749Z", updatedAt="2026-09-01T14:31:55.135703Z",
    ),
    ClubDto(
      id="3be52bce-bd21-4cd0-b317-2c6dad4c1e68", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Murcia fútbol indoor", address="C. de la Palmera, 2, 30009 Murcia",
      city="Murcia", country="ES",
      latitude=37.9992889, longitude=-1.1450645,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/21fe02ac-9d8f-4f17-91e8-42c48af7d9f1_photo.jpg",
      averageRating=4.0, totalRatingsCount=267,
      createdAt="2026-09-01T08:51:37.793116Z", updatedAt="2026-09-01T08:51:37.793116Z",
    ),
    ClubDto(
      id="7dc1d19e-ecb2-416f-af86-45baafa73684", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport Joven Futura", address="C. Escritor Francisco Alemán Sainz, 1, 30100 Murcia",
      city="Murcia", country="ES",
      latitude=38.0025176, longitude=-1.1597176,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0e73e243-430c-465e-aa6c-b26e069140c6_photo.jpg",
      averageRating=4.0, totalRatingsCount=495,
      createdAt="2026-09-01T08:51:32.424741Z", updatedAt="2026-09-01T08:51:32.424741Z",
    ),
    ClubDto(
      id="4fd3fddc-a051-462c-8d62-821837b02107", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pabellón Polideportivo de Espinardo", address="C. Virgen del Carmen, 30100, 9, 30100 Murcia",
      city="Murcia", country="ES",
      latitude=38.0098434, longitude=-1.1510814,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1315a1d1-b6e9-46dd-a7b9-65b52eb17de0_photo.jpg",
      averageRating=3.9, totalRatingsCount=126,
      createdAt="2026-09-01T08:52:11.356029Z", updatedAt="2026-09-01T08:52:11.356029Z",
    ),
    ClubDto(
      id="844ab600-fc78-4b87-8454-93ff8091f7a4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polideportivo Playa Paraíso", address="playa paraíso, C. Himilce, 30385 Playa Honda, Murcia",
      city="Murcia", country="ES",
      latitude=37.6310949, longitude=-0.7264053,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2b558951-36b4-4982-999a-58f13abe61a0_photo.jpg",
      averageRating=3.9, totalRatingsCount=75,
      createdAt="2026-09-01T08:52:14.929349Z", updatedAt="2026-09-01T08:52:14.929349Z",
    ),
    ClubDto(
      id="979482f9-4137-4c8b-8bfa-3281e9c5cda0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Elx Billar Club", address="Carrer Brea, 03206 Elche, Alicante",
      city="Murcia", country="ES",
      latitude=38.2822847, longitude=-0.7160568,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5c5455ae-085a-4d14-8901-b491590370b1_photo.jpg",
      averageRating=4.8, totalRatingsCount=34,
      createdAt="2026-09-01T08:52:57.121934Z", updatedAt="2026-09-01T08:52:57.121934Z",
    ),
    ClubDto(
      id="2c00d2c8-49a7-40f3-b564-2b12d6e239e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ciudad Del Fútbol Murcia", address="C. del Ing. José Manuel López Hernández, 30100 Murcia",
      city="Murcia", country="ES",
      latitude=38.0315957, longitude=-1.1769213,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6a52b9d0-cd3b-4101-903d-21debdbc2d0a_photo.jpg",
      averageRating=4.0, totalRatingsCount=34,
      createdAt="2026-09-01T08:51:41.950730Z", updatedAt="2026-09-01T14:31:48.142371Z",
    ),
    ClubDto(
      id="1255f07b-fc66-4c80-9f47-3385ed0159d4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mula Senators Snooker & Pool Club", address="C. del Voluntariado, 3, 30170 Mula, Murcia",
      city="Murcia", country="ES",
      latitude=38.0367454, longitude=-1.4954599,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/40e2b65f-5c6a-4609-8aa4-5fab79adc4c7_photo.jpg",
      averageRating=5.0, totalRatingsCount=20,
      createdAt="2026-09-01T08:53:01.982857Z", updatedAt="2026-09-01T08:53:01.982857Z",
    ),
  )),
  CitySeo(slug="sarajevo", name="Sarajevo", country="BA", clubCount=21, sports=listOf(Pair("Tennis", 4), Pair("Football", 3), Pair("Billiards", 2), Pair("Laser Tag", 2), Pair("Padel", 2), Pair("Climbing", 2), Pair("Paintball", 2), Pair("Karting", 1), Pair("Golf", 1), Pair("Volleyball", 1), Pair("Basketball", 1)), clubs=listOf(
    ClubDto(
      id="3993052b-734c-44fc-ab01-164d673e0790", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MEGA PADEL ARENA - SARAJEVO", address="Vojvode Živojina Mišića 159, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8003514, longitude=18.3397352,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/826fe72e-5477-4501-b207-79549952f590_photo.jpg",
      averageRating=5.0, totalRatingsCount=76,
      createdAt="2026-09-01T09:17:57.072328Z", updatedAt="2026-09-01T09:17:57.072328Z",
    ),
    ClubDto(
      id="10c6e96b-d508-4529-9265-c2722dab6db8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bilijar klub \"Jump\" sarajevo", address="Merhemića trg bb, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8654232, longitude=18.409191,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/801f27c8-595a-4329-a165-14b7f0dc8880_photo.jpg",
      averageRating=4.9, totalRatingsCount=119,
      createdAt="2026-09-01T09:18:41.457556Z", updatedAt="2026-09-01T09:18:41.457556Z",
    ),
    ClubDto(
      id="92eb66b0-9421-4b63-9f87-ffb7bb01cbb7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball klub Predator", address="Kenana Brkanića, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8908828, longitude=18.3910156,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c4162500-378a-4aad-9850-dfa503c2bb75_photo.jpg",
      averageRating=4.9, totalRatingsCount=152,
      createdAt="2026-09-01T09:18:59.550241Z", updatedAt="2026-09-01T09:18:59.550241Z",
    ),
    ClubDto(
      id="750eb667-c222-4036-9dca-c555d8023381", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenis centar \"Novi Grad\"", address="Olimpijska bb, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.839288, longitude=18.34755,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/73aae55a-b28c-4b63-90e0-dc0d2d9b1070_photo.jpg",
      averageRating=4.9, totalRatingsCount=79,
      createdAt="2026-09-01T09:17:34.761213Z", updatedAt="2026-09-01T09:17:34.761213Z",
    ),
    ClubDto(
      id="45fd1966-e4bc-4c85-8818-11b49f88a52a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BILLIARD SNOOKER DART CLUB MERCUR", address="Kranjčevićeva b b, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8579708, longitude=18.4040846,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e92055d0-3545-4619-9218-b1ccc99fae1d_photo.jpg",
      averageRating=4.8, totalRatingsCount=266,
      createdAt="2026-09-01T09:18:36.448269Z", updatedAt="2026-09-01T09:18:36.448269Z",
    ),
    ClubDto(
      id="3f84013f-f209-46c1-8512-e5cfeb8253a4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball center Jungle Sarajevo", address="Dobroševićka bb, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.878315, longitude=18.286608,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc34b9f9-d770-4408-8fb1-db3cc46fbdfe_photo.jpg",
      averageRating=4.8, totalRatingsCount=188,
      createdAt="2026-09-01T09:18:54.912560Z", updatedAt="2026-09-01T09:18:54.912560Z",
    ),
    ClubDto(
      id="b79ee782-478d-479d-a679-7fffad0a47e2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="R Sport Centar", address="71000, Patriotske lige 52, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8760345, longitude=18.4122806,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/29673268-4e62-4b8f-9c5e-4ecffabad32f_photo.jpg",
      averageRating=4.8, totalRatingsCount=297,
      createdAt="2026-09-01T09:17:24.236662Z", updatedAt="2026-09-01T09:17:24.236662Z",
    ),
    ClubDto(
      id="4932a92d-a496-4785-80b8-557fca00f584", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Friendly Fire Sarajevo", address="Zmaja od Bosne 7, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8549382, longitude=18.3995588,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e0186dd1-0585-4975-ad78-1e00460ffe2a_photo.jpg",
      averageRating=4.7, totalRatingsCount=243,
      createdAt="2026-09-01T09:18:45.904425Z", updatedAt="2026-09-01T09:18:45.904425Z",
    ),
    ClubDto(
      id="08498f6b-26f7-49d2-a0b4-0d9fe0e41ab2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TC Arena Padel and Football", address="Sarajevo",
      city="Sarajevo", country="BA",
      latitude=43.8375485, longitude=18.3329748,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/09af3b89-0968-4449-a1ba-42c634dce383_photo.jpg",
      averageRating=4.7, totalRatingsCount=179,
      createdAt="2026-09-01T09:17:29.225509Z", updatedAt="2026-09-01T14:31:46.240163Z",
    ),
    ClubDto(
      id="6052cea3-263e-4b0b-a89d-2f2632be6497", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Tag Arena", address="Pilanska BB, Banja Luka 78000",
      city="Sarajevo", country="BA",
      latitude=44.7845115, longitude=17.2070407,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/60896d01-48e2-4dbe-9ce3-3002c41a5907_photo.jpg",
      averageRating=4.6, totalRatingsCount=147,
      createdAt="2026-09-01T09:18:50.420099Z", updatedAt="2026-09-01T09:18:50.420099Z",
    ),
    ClubDto(
      id="d47ac6de-85cf-4d35-baae-03c39ee14425", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sarajevo Golf Club", address="Armije RBiH 17, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8851499, longitude=18.4093365,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6ceefe78-68e5-477f-88d2-61b2720a1bcb_photo.jpg",
      averageRating=4.6, totalRatingsCount=391,
      createdAt="2026-09-01T09:18:15.133437Z", updatedAt="2026-09-01T09:18:15.133437Z",
    ),
    ClubDto(
      id="978fd9f9-01f2-491e-aa76-0ba862a9eb54", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportska dvorana \"Goran Čengić\"", address="Bulevar Ivice Osima 23, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8472047, longitude=18.3887795,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b29d2f02-411b-483d-8856-664fc388391c_photo.jpg",
      averageRating=4.6, totalRatingsCount=675,
      createdAt="2026-09-01T09:18:07.209765Z", updatedAt="2026-09-01T09:18:07.209765Z",
    ),
    ClubDto(
      id="d43d9c0e-7d32-4e31-ac19-f2f0fdbeffae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Teniski centar Stup", address="Nikole Šopa 217, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8446314, longitude=18.3183906,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ac64b19e-7e43-4571-9dbb-36f24bac2b29_photo.jpg",
      averageRating=4.6, totalRatingsCount=67,
      createdAt="2026-09-01T09:17:42.592606Z", updatedAt="2026-09-01T09:17:42.592606Z",
    ),
    ClubDto(
      id="f5fe5932-798c-4a1f-bd61-93abafedace2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Hall Istočno Sarajevo", address="Trg Republike Srbije, 71123",
      city="Sarajevo", country="BA",
      latitude=43.8221486, longitude=18.3625568,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b274bd4e-70f4-49a6-a043-1958c4321a9c_photo.jpg",
      averageRating=4.5, totalRatingsCount=302,
      createdAt="2026-09-01T09:18:10.427238Z", updatedAt="2026-09-01T09:18:10.427238Z",
    ),
    ClubDto(
      id="c98ccb22-359c-44f2-8c9a-262a25a17360", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Teniski klub Bosna", address="Patriotske lige 13, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8711948, longitude=18.4114227,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/31c87600-6929-4c87-b189-06e1f79e4e4a_photo.jpg",
      averageRating=4.5, totalRatingsCount=59,
      createdAt="2026-09-01T09:17:46.967507Z", updatedAt="2026-09-01T09:17:46.967507Z",
    ),
    ClubDto(
      id="1fe13d4b-b748-4472-979d-471cd3267989", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FIS", address="Mis Irbina 10, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8573806, longitude=18.4154109,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9573c17a-b36e-4374-9371-1a549781f41d_photo.jpg",
      averageRating=4.4, totalRatingsCount=340,
      createdAt="2026-09-01T09:17:20.563462Z", updatedAt="2026-09-01T09:17:20.563462Z",
    ),
    ClubDto(
      id="7787641c-9811-4139-b3e0-111d60d1a4fa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Sarajevo", address="poligon, Sarajevo 71210",
      city="Sarajevo", country="BA",
      latitude=43.833711, longitude=18.3110877,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8d04ef07-1a3b-402e-996b-f8dbe6634171_photo.jpg",
      averageRating=4.2, totalRatingsCount=207,
      createdAt="2026-09-01T09:18:19.629494Z", updatedAt="2026-09-01T09:18:19.629494Z",
    ),
    ClubDto(
      id="b63b358d-aa05-49f5-8f1e-4ef3450f2f7d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="No Comment penjački klub", address="Terezija, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8552066, longitude=18.414712,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a30edb6d-680e-4ee1-a70b-15758cbd8d11_photo.jpg",
      averageRating=4.8, totalRatingsCount=41,
      createdAt="2026-09-01T09:18:24.337629Z", updatedAt="2026-09-01T09:18:24.337629Z",
    ),
    ClubDto(
      id="a31a2b42-5d76-4457-933a-836133b11eb6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GTA Teniska Akademija Sarajevo", address="Hotonj II, Sarajevo 71320",
      city="Sarajevo", country="BA",
      latitude=43.8958239, longitude=18.370939,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bb5886d3-4a60-4406-b867-196511f61adb_photo.jpg",
      averageRating=4.7, totalRatingsCount=32,
      createdAt="2026-09-01T09:17:53.237811Z", updatedAt="2026-09-01T09:17:53.237811Z",
    ),
    ClubDto(
      id="c33e1e14-c572-4c32-9cc6-51de0cb20bd1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vertical Masters Sarajevo", address="Vahide Maglajlić 7, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.8242328, longitude=18.3522323,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3a0a3571-5436-4730-ae48-6ffecd75bdc6_photo.jpg",
      averageRating=5.0, totalRatingsCount=16,
      createdAt="2026-09-01T09:18:28.627962Z", updatedAt="2026-09-01T09:18:28.627962Z",
    ),
    ClubDto(
      id="fcff8bef-41ba-4b33-af9f-ec9923326c37", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel centar Hills", address="Butmirska cesta 18, Sarajevo 71000",
      city="Sarajevo", country="BA",
      latitude=43.826597, longitude=18.3119361,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/878f4807-8232-42fc-ba75-df77860f82ce_photo.jpg",
      averageRating=4.6, totalRatingsCount=12,
      createdAt="2026-09-01T09:18:02.053584Z", updatedAt="2026-09-01T09:18:02.053584Z",
    ),
  )),
  CitySeo(slug="san-francisco", name="San Francisco", country="US", clubCount=21, sports=listOf(Pair("Padel", 3), Pair("Football", 3), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Volleyball", 2), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Golf", 2), Pair("Paintball", 1), Pair("Basketball", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="b7df6cee-72d1-432c-bcea-58b2b8ac8c08", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bay Padel - Dogpatch", address="1070 Maryland St, San Francisco, CA 94107",
      city="San Francisco", country="US",
      latitude=37.7583983, longitude=-122.3843617,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aab6a60d-78df-4ba0-a620-7eeb331ca332_photo.jpg",
      averageRating=4.8, totalRatingsCount=77,
      createdAt="2026-09-20T19:22:57.997834Z", updatedAt="2026-09-20T19:22:57.997834Z",
    ),
    ClubDto(
      id="4b48a21b-579a-42ae-a503-0ec598cfe13f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bay Padel - Treasure Island", address="29 Avenue G, San Francisco, CA 94130",
      city="San Francisco", country="US",
      latitude=37.8182878, longitude=-122.3683708,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a98a5ace-c257-4a57-abc4-49663c5ccb79_photo.jpg",
      averageRating=4.8, totalRatingsCount=136,
      createdAt="2026-09-20T19:22:53.867857Z", updatedAt="2026-09-20T19:22:53.867857Z",
    ),
    ClubDto(
      id="5f209761-28c0-4527-9f3a-fbf3ccccf9a6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Crissy Field East Beach", address="Crissy Field East Beach, San Francisco, CA 94129",
      city="San Francisco", country="US",
      latitude=37.8064291, longitude=-122.4506915,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bb78aa29-ab99-4dec-b81d-905dc345073a_photo.jpg",
      averageRating=4.8, totalRatingsCount=1207,
      createdAt="2026-09-20T19:23:10.227013Z", updatedAt="2026-09-20T19:23:10.227013Z",
    ),
    ClubDto(
      id="74ebf880-db91-4194-9bbd-ff5f5bd9c0b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LaserMaxx San Carlos", address="1119 Industrial Rd Ste F, San Carlos, CA 94070",
      city="San Francisco", country="US",
      latitude=37.503707, longitude=-122.2458425,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8beffea4-2bdc-4d60-a487-6cf20f133f47_photo.jpg",
      averageRating=4.8, totalRatingsCount=1487,
      createdAt="2026-09-20T19:24:01.750129Z", updatedAt="2026-09-20T19:24:01.750129Z",
    ),
    ClubDto(
      id="d2185e21-c43a-4b46-bb8b-30bbeef18a46", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LaserMaxx San Jose", address="1035 E Capitol Expy, San Jose, CA 95121",
      city="San Francisco", country="US",
      latitude=37.3010878, longitude=-121.8232721,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/48f09c1a-81bc-41dc-8a7d-e3ee0e187241_photo.jpg",
      averageRating=4.8, totalRatingsCount=1664,
      createdAt="2026-09-20T19:23:57.981110Z", updatedAt="2026-09-20T19:23:57.981110Z",
    ),
    ClubDto(
      id="4dfd0146-0d3a-4a54-b3b2-48e4e8e69ed8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pacific Pipe", address="2140 Mandela Pkwy, Oakland, CA 94607",
      city="San Francisco", country="US",
      latitude=37.8156283, longitude=-122.2887373,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7e745272-0538-4617-ac44-8e5d10b8a4a5_photo.jpg",
      averageRating=4.8, totalRatingsCount=740,
      createdAt="2026-09-20T19:23:47.018352Z", updatedAt="2026-09-20T19:23:47.018352Z",
    ),
    ClubDto(
      id="1b86e2ef-6a9b-45aa-a3e6-0d68616d01f5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Chalet Athletic Fields", address="1400-1598 John F Kennedy Dr, San Francisco, CA 94121",
      city="San Francisco", country="US",
      latitude=37.7673557, longitude=-122.508802,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a209c83-7309-43b4-bd88-a25b26930a62_photo.jpg",
      averageRating=4.7, totalRatingsCount=752,
      createdAt="2026-09-20T19:22:41.579570Z", updatedAt="2026-09-20T19:22:41.579570Z",
    ),
    ClubDto(
      id="ce2fa8f7-f500-4079-8caa-3df33a211bd6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dogpatch Boulders", address="2573 3rd St, San Francisco, CA 94107",
      city="San Francisco", country="US",
      latitude=37.7567012, longitude=-122.3877444,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/20e825d7-a6d0-48a2-ac2c-f3cf48892325_photo.jpg",
      averageRating=4.7, totalRatingsCount=998,
      createdAt="2026-09-20T19:23:43.884350Z", updatedAt="2026-09-20T19:23:43.884350Z",
    ),
    ClubDto(
      id="19f3628a-8deb-4493-bbd0-35d1276e60d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Park Padel", address="The Embarcadero, San Francisco, CA 94105",
      city="San Francisco", country="US",
      latitude=37.7952743, longitude=-122.3952279,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ffd813f9-bdd2-46ca-a1bc-e55230e34163_photo.jpg",
      averageRating=4.7, totalRatingsCount=73,
      createdAt="2026-09-20T19:23:01.392054Z", updatedAt="2026-09-20T19:23:01.392054Z",
    ),
    ClubDto(
      id="733f5f8f-388f-4c53-b668-ac0718d7e5c4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mariners Point Golf Center", address="2401 E 3rd Ave, Foster City, CA 94404",
      city="San Francisco", country="US",
      latitude=37.5711713, longitude=-122.2844816,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/68ce6c64-d43f-46f0-8ec7-445ea82dac13_photo.jpg",
      averageRating=4.6, totalRatingsCount=573,
      createdAt="2026-09-20T19:23:31.792928Z", updatedAt="2026-09-20T19:23:31.792928Z",
    ),
    ClubDto(
      id="cc7c366f-dd66-455f-a457-3b4017bd34f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="California Billiards", address="40510 Albrae St, Fremont, CA 94538",
      city="San Francisco", country="US",
      latitude=37.5199674, longitude=-121.9875482,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/33f29024-02ce-4a87-8ca2-1936502bbc16_photo.jpg",
      averageRating=4.5, totalRatingsCount=794,
      createdAt="2026-09-20T19:23:50.384776Z", updatedAt="2026-09-20T19:23:50.384776Z",
    ),
    ClubDto(
      id="4e6c7ed5-c883-4821-88fa-dc9ee75c4bb2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Combat Paintball Park", address="31050 Charlie Canyon Rd, Castaic, CA 91384",
      city="San Francisco", country="US",
      latitude=34.4927983, longitude=-118.5971041,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8358e558-8da9-4c34-8579-e70d3ff14c8f_photo.jpg",
      averageRating=4.5, totalRatingsCount=480,
      createdAt="2026-09-20T19:24:05.241716Z", updatedAt="2026-09-20T19:24:05.241716Z",
    ),
    ClubDto(
      id="887f837b-4b30-40c2-a968-75f18229cb2d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Crocker Amazon Soccer Fields", address="soccer field & Parking lot, 785 Moscow St, San Francisco, CA 94112",
      city="San Francisco", country="US",
      latitude=37.7133516, longitude=-122.4291461,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/03b46f8e-caa1-4a8e-a35d-6ffcb67ae586_photo.jpg",
      averageRating=4.5, totalRatingsCount=816,
      createdAt="2026-09-20T19:22:26.882949Z", updatedAt="2026-09-20T19:22:26.882949Z",
    ),
    ClubDto(
      id="b42763e8-ad91-40d4-b3ab-ed15955ba861", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Final Final", address="2990 Baker St, San Francisco, CA 94123",
      city="San Francisco", country="US",
      latitude=37.7985426, longitude=-122.4458232,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e584ce72-7c9d-4e47-ad14-41401e7bbdad_photo.jpg",
      averageRating=4.5, totalRatingsCount=488,
      createdAt="2026-09-20T19:23:54.244720Z", updatedAt="2026-09-20T19:23:54.244720Z",
    ),
    ClubDto(
      id="fab62fab-c6cf-43e6-9285-f8e833c3b047", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Presidio Golf Course", address="300 Finley Rd, San Francisco, CA 94129",
      city="San Francisco", country="US",
      latitude=37.7904944, longitude=-122.4597914,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3da1880d-9209-44b6-9cba-860e28a23851_photo.jpg",
      averageRating=4.5, totalRatingsCount=951,
      createdAt="2026-09-20T19:23:28.199864Z", updatedAt="2026-09-20T19:23:28.199864Z",
    ),
    ClubDto(
      id="2343434f-6813-4bc2-9169-600a4484caf1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SPIN San Francisco", address="690 Folsom St #100, San Francisco, CA 94107",
      city="San Francisco", country="US",
      latitude=37.7842349, longitude=-122.3992112,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/75996007-8f6d-4a04-ad19-7b1dbb5387e5_photo.jpg",
      averageRating=4.5, totalRatingsCount=1632,
      createdAt="2026-09-20T19:22:49.736862Z", updatedAt="2026-09-20T19:22:49.736862Z",
    ),
    ClubDto(
      id="cc38bb64-4821-4bb9-8a5b-54a5df62a36f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bel Mateo Bowl", address="4330 Olympic Ave, San Mateo, CA 94403",
      city="San Francisco", country="US",
      latitude=37.5282392, longitude=-122.2904835,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bfa3829b-0ab8-46ec-bed2-344df97feb3d_photo.jpg",
      averageRating=4.4, totalRatingsCount=1229,
      createdAt="2026-09-20T19:23:36.360929Z", updatedAt="2026-09-20T19:23:36.360929Z",
    ),
    ClubDto(
      id="cc11cfa5-c687-40a9-97be-a1ad984ea43d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Volo Sports San Francisco", address="1700 Montgomery St, San Francisco, CA 94111",
      city="San Francisco", country="US",
      latitude=37.8052715, longitude=-122.4047486,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0438fde2-471b-40de-b2fc-f333b9915b32_photo.jpg",
      averageRating=4.2, totalRatingsCount=206,
      createdAt="2026-09-20T19:22:47.023687Z", updatedAt="2026-09-20T19:22:47.023687Z",
    ),
    ClubDto(
      id="71e31be4-2028-4111-8bbf-3568456a40a3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lucky Strike San Francisco", address="200 King St, San Francisco, CA 94107",
      city="San Francisco", country="US",
      latitude=37.7782254, longitude=-122.392387,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b598b924-3b8c-40ef-8881-a764d51d2a5a_photo.jpg",
      averageRating=4.1, totalRatingsCount=1225,
      createdAt="2026-09-20T19:23:40.652103Z", updatedAt="2026-09-20T19:23:40.652103Z",
    ),
    ClubDto(
      id="c8948e2f-162d-45d3-973d-79bb843345f5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Equinox Sports Club San Francisco", address="747 Market St, San Francisco, CA 94103",
      city="San Francisco", country="US",
      latitude=37.7866201, longitude=-122.4043897,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d7bb1d2e-02bb-468f-aece-f06a34470d84_photo.jpg",
      averageRating=3.5, totalRatingsCount=306,
      createdAt="2026-09-20T19:23:05.268629Z", updatedAt="2026-09-20T19:23:05.268629Z",
    ),
    ClubDto(
      id="020088f9-18b7-4a3a-b58b-6d6d72bd7c07", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mission Creek Beach Volleyball Court", address="San Francisco, CA 94158",
      city="San Francisco", country="US",
      latitude=37.7711212, longitude=-122.3980521,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/199defd8-17bc-449b-908c-528a7fe243ce_photo.jpg",
      averageRating=4.7, totalRatingsCount=33,
      createdAt="2026-09-20T19:23:25.067634Z", updatedAt="2026-09-20T19:23:25.067634Z",
    ),
  )),
  CitySeo(slug="granada", name="Granada", country="ES", clubCount=21, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Padel", 3), Pair("Volleyball", 2), Pair("Golf", 2), Pair("Climbing", 1), Pair("Basketball", 1), Pair("Karting", 1), Pair("Billiards", 1), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="961232ef-912f-4dee-bb78-a6efe883daa2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cursos Escalada Granada - Campo Base", address="18211 Cogollos Vega, Granada",
      city="Granada", country="ES",
      latitude=37.2751524, longitude=-3.5654547,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c728be36-ae0f-41ae-a52d-bdf392fe1bc9_photo.jpg",
      averageRating=5.0, totalRatingsCount=73,
      createdAt="2026-09-01T08:59:47.821211Z", updatedAt="2026-09-01T08:59:47.821211Z",
    ),
    ClubDto(
      id="0d928ad1-30aa-4d37-847a-0fb5e7545449", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Odeco Padel Cubierto Armilla, Churriana y Granada", address="C. Habana, 103, 18194 Churriana de la Vega, Granada",
      city="Granada", country="ES",
      latitude=37.1476173, longitude=-3.6304945,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/506f855e-9ff9-47da-a159-dd1a41a1cdbc_photo.jpg",
      averageRating=4.8, totalRatingsCount=85,
      createdAt="2026-09-01T08:59:02.967012Z", updatedAt="2026-09-16T07:55:22.643501Z",
    ),
    ClubDto(
      id="dcf3d0cc-8e62-45e8-93d9-f1b09cbc4c4b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pub Bolera Monge", address="Cam. de Ronda, 148, Ronda, 18003 Granada",
      city="Granada", country="ES",
      latitude=37.178319, longitude=-3.6106563,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d509695d-28af-4224-8022-2d7cacadd727_photo.jpg",
      averageRating=4.8, totalRatingsCount=428,
      createdAt="2026-09-01T08:59:41.226543Z", updatedAt="2026-09-01T08:59:41.226543Z",
    ),
    ClubDto(
      id="89128e35-f3eb-4f5e-ac14-5bcf9805c358", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CAMPUS TENNIS CLUB GRANADA", address="C. Menéndez Pelayo, 2 18016, 18016 Granada",
      city="Granada", country="ES",
      latitude=37.1441353, longitude=-3.6067424,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e98ff06-61d3-4bfb-a7b6-cc881786b209_photo.jpg",
      averageRating=4.7, totalRatingsCount=83,
      createdAt="2026-09-01T08:58:47.751201Z", updatedAt="2026-09-01T14:31:51.525321Z",
    ),
    ClubDto(
      id="268feb45-88d3-4f23-8772-84243daf1a1a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Central Padel", address="Av. Andalucía, 5, 18210 Peligros, Granada",
      city="Granada", country="ES",
      latitude=37.2267557, longitude=-3.6236755,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7bc389ab-775f-4c6b-a411-f2117a76146e_photo.jpg",
      averageRating=4.6, totalRatingsCount=100,
      createdAt="2026-09-01T08:58:57.339731Z", updatedAt="2026-09-01T08:58:57.339731Z",
    ),
    ClubDto(
      id="8ebb0a9a-c385-45a4-a38f-d164d24bc86c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club de Tenis Cid Hiaya", address="Carr. de Murcia, Km. 176, 18800 Baza, Granada",
      city="Granada", country="ES",
      latitude=37.4975509, longitude=-2.7485482,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9a3602c1-161c-4b73-81e2-c9b5cfc53b7f_photo.jpg",
      averageRating=4.6, totalRatingsCount=122,
      createdAt="2026-09-01T08:58:43.132485Z", updatedAt="2026-09-01T08:58:43.132485Z",
    ),
    ClubDto(
      id="feab679a-a6ca-42a4-b431-a9dd7dc397b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Granada Golf Course", address="2001 Granada Blvd, Coral Gables, FL 33134, USA",
      city="Granada", country="ES",
      latitude=25.7525704, longitude=-80.2746846,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c4643c3e-1ed4-4644-a647-63e6a24554fe_photo.jpg",
      averageRating=4.6, totalRatingsCount=548,
      createdAt="2026-09-01T08:59:21.794710Z", updatedAt="2026-09-01T08:59:21.794710Z",
    ),
    ClubDto(
      id="6b9cc5a2-8ad8-4b51-8648-09aeaa831799", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Granada Mas Baloncesto", address="Calle la Palmita, Norte, 18014 Granada",
      city="Granada", country="ES",
      latitude=37.200636, longitude=-3.619028,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/76e36ce7-a896-49ee-9e99-5eb6a207166d_photo.jpg",
      averageRating=4.6, totalRatingsCount=85,
      createdAt="2026-09-01T08:59:08.002166Z", updatedAt="2026-09-01T08:59:08.002166Z",
    ),
    ClubDto(
      id="f11d97ec-f3cf-494b-902b-f8140dcda2b5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pabellon Fuentenueva Granada", address="Paseo Prof. Juan Ossorio, 2, Beiro, 18003 Granada",
      city="Granada", country="ES",
      latitude=37.183188, longitude=-3.611556,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3bb39525-bbf4-4bf1-b025-c55e835454e6_photo.jpg",
      averageRating=4.6, totalRatingsCount=128,
      createdAt="2026-09-01T08:59:12.184592Z", updatedAt="2026-09-01T08:59:12.184592Z",
    ),
    ClubDto(
      id="c112fd78-12b2-42ea-820d-06efd0e6e025", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Nuevo Estadio de Los Cármenes", address="C. Pintor Manuel Maldonado, s/n, Zaidín, 18007 Granada",
      city="Granada", country="ES",
      latitude=37.1529018, longitude=-3.5957356,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d17860b6-33f7-4b15-869e-f6c205ac49d5_photo.jpg",
      averageRating=4.5, totalRatingsCount=6609,
      createdAt="2026-09-01T08:58:00.142440Z", updatedAt="2026-09-01T08:58:00.142440Z",
    ),
    ClubDto(
      id="65c6f1d7-8b0d-4d9b-a2f4-9ef72f7ae296", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Sport Granada Indoor", address="18100 Armilla, Granada",
      city="Granada", country="ES",
      latitude=37.1546849, longitude=-3.615548,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e693b319-2ce4-4c60-b485-2050028de191_photo.jpg",
      averageRating=4.5, totalRatingsCount=419,
      createdAt="2026-09-01T08:58:52.515688Z", updatedAt="2026-09-01T08:58:52.515688Z",
    ),
    ClubDto(
      id="11d6ca79-ec0a-4401-a3e0-afda26178436", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ValsSport Ilusión", address="C. de María Guerrero, s/n, Ronda, 18003 Granada",
      city="Granada", country="ES",
      latitude=37.1816036, longitude=-3.6163926,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/72ad06a4-05af-4c1f-97a8-5957f93498b5_photo.jpg",
      averageRating=4.5, totalRatingsCount=201,
      createdAt="2026-09-01T08:58:36.547516Z", updatedAt="2026-09-01T14:31:57.545090Z",
    ),
    ClubDto(
      id="b4da9103-f380-4b41-833c-31e882b3ef1b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo Malaga Beach Volleyball", address="C/ Pacífico, Carretera de Cádiz, 29004 Málaga",
      city="Granada", country="ES",
      latitude=36.6953321, longitude=-4.4387725,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7e4d21ec-1af6-4038-99d2-7f73c511b9dc_photo.jpg",
      averageRating=4.4, totalRatingsCount=92,
      createdAt="2026-09-01T08:59:17.335060Z", updatedAt="2026-09-01T08:59:17.335060Z",
    ),
    ClubDto(
      id="b1af375d-e51c-44b1-9e1f-53bd34289543", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Granada Golf Club", address="Avda. de los Cosarios, s/n, 18110 Las Gabias, Granada",
      city="Granada", country="ES",
      latitude=37.1202485, longitude=-3.6616876,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/562314cb-f051-4899-97ca-940c58e97e56_photo.jpg",
      averageRating=4.4, totalRatingsCount=481,
      createdAt="2026-09-01T08:59:31.372653Z", updatedAt="2026-09-01T08:59:31.372653Z",
    ),
    ClubDto(
      id="7b8d471f-cd5a-42fc-aa4b-2c0fffe3b2bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Granada", address="por carretera 3305 km2, Pje. de San José, Ronda, 18102 Purchil, Granada",
      city="Granada", country="ES",
      latitude=37.174987, longitude=-3.6552933,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/da889a89-68a9-41ff-b7d6-cbff011c349f_photo.jpg",
      averageRating=4.4, totalRatingsCount=1163,
      createdAt="2026-09-01T08:59:37.007764Z", updatedAt="2026-09-01T08:59:37.007764Z",
    ),
    ClubDto(
      id="5741b721-6c85-41fa-8283-1da5c5a7460b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LO + POOL", address="C. Prosperidad, 8, Ronda, 18004 Granada",
      city="Granada", country="ES",
      latitude=37.1741545, longitude=-3.6075865,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2d0d255c-5427-4c2e-a6ca-8db0e830096e_photo.jpg",
      averageRating=4.4, totalRatingsCount=603,
      createdAt="2026-09-01T08:59:51.081449Z", updatedAt="2026-09-01T08:59:51.081449Z",
    ),
    ClubDto(
      id="2e797ad6-dcf9-4764-a03c-7e184784dcc7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Complejo Deportivo Nuñez Blanca Zaidín", address="Torre Pedro de Morales, s/n, Genil, 18008 Granada",
      city="Granada", country="ES",
      latitude=37.1572474, longitude=-3.5937249,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a09cd645-3201-4ece-aa57-d152492ccd9f_photo.jpg",
      averageRating=4.3, totalRatingsCount=1336,
      createdAt="2026-09-01T08:58:03.745279Z", updatedAt="2026-09-01T08:58:03.745279Z",
    ),
    ClubDto(
      id="4cee9d0b-d3cd-4c0f-8e4a-8d159a073b44", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="♔ Royal Society of Tennis of Granada", address="Urbanizacion el serrallo, Aixa la Horra, 23, Genil, 18008 Granada",
      city="Granada", country="ES",
      latitude=37.161595, longitude=-3.579446,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e724eca2-3fb4-41a6-80ad-12a11a916196_photo.jpg",
      averageRating=4.3, totalRatingsCount=228,
      createdAt="2026-09-01T08:58:31.585891Z", updatedAt="2026-09-01T14:31:42.650738Z",
    ),
    ClubDto(
      id="8780fbf1-0958-410e-a152-a147ded77fc5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ciudad Deportiva del Granada CF", address="Crta. de Alfacar, s/n, Norte, 18011 Granada",
      city="Granada", country="ES",
      latitude=37.2083391, longitude=-3.5963087,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eb4d500e-bb03-4ff9-9c07-36f44b70b569_photo.jpg",
      averageRating=4.2, totalRatingsCount=432,
      createdAt="2026-09-01T08:58:15.837169Z", updatedAt="2026-09-01T08:58:15.837169Z",
    ),
    ClubDto(
      id="547181a2-b35c-44b9-a16b-6e4c7acfe181", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Complejo Deportivo Bola de Oro", address="C. Borreguiles, s, Genil, 18008 Granada",
      city="Granada", country="ES",
      latitude=37.1642564, longitude=-3.583331,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/322416c6-3de4-419f-9ae8-54e7e2cfe5d5_photo.jpg",
      averageRating=4.2, totalRatingsCount=974,
      createdAt="2026-09-01T08:58:07.760855Z", updatedAt="2026-09-01T14:31:56.184592Z",
    ),
    ClubDto(
      id="69ea657d-a203-4a80-81d7-50408fe86cea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Estadio de la Juventud", address="Cam. de Ronda, 171, Ronda, 18003 Granada",
      city="Granada", country="ES",
      latitude=37.1843111, longitude=-3.6146134,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0244f4cd-5c9f-4c34-87bc-e29f96d41760_photo.jpg",
      averageRating=4.2, totalRatingsCount=791,
      createdAt="2026-09-01T08:58:11.514279Z", updatedAt="2026-09-16T07:57:19.732400Z",
    ),
  )),
  CitySeo(slug="vigo", name="Vigo", country="ES", clubCount=20, sports=listOf(Pair("Football", 5), Pair("Tennis", 3), Pair("Karting", 2), Pair("Padel", 2), Pair("Golf", 2), Pair("Climbing", 2), Pair("Paintball", 1), Pair("Bowling", 1), Pair("Volleyball", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="3770b862-386e-4947-b74f-fba62df2b275", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Win Pádel Club", address="Av. da Ponte, 80, Cabral, 36215 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2165517, longitude=-8.6707575,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ddf800e-3d33-40e4-9321-5384893ff006_photo.jpg",
      averageRating=4.9, totalRatingsCount=99,
      createdAt="2026-09-01T09:00:32.451935Z", updatedAt="2026-09-01T14:31:55.717632Z",
    ),
    ClubDto(
      id="ac826f03-9483-4b2f-ba7b-d63c0f44d556", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mg12 Rocódromo", address="Poligono Industrial do Rebullon, 72, 36416, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2063155, longitude=-8.6632637,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/21147a46-037d-471d-9b26-98b2dac4f28a_photo.jpg",
      averageRating=4.8, totalRatingsCount=256,
      createdAt="2026-09-01T09:01:25.765473Z", updatedAt="2026-09-01T09:01:25.765473Z",
    ),
    ClubDto(
      id="2003d88d-277f-48b6-962f-e88c4cbc71eb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rocódromo Mapache Climbing Vigo", address="Mapache Climbing, Av. Ricardo Mella, 123, Nave 1, 36330 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.1976089, longitude=-8.7728264,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/97bb67ca-4558-42fc-a179-8774b9550ce3_photo.jpg",
      averageRating=4.8, totalRatingsCount=162,
      createdAt="2026-09-01T09:01:31.855729Z", updatedAt="2026-09-01T09:01:31.855729Z",
    ),
    ClubDto(
      id="b3a0f0df-eb87-4cf5-b5ef-08b88c3655da", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Twelve Padel Zenter Vigo", address="Estrada Fragosiño, 30, Sárdoma, 36214 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2129857, longitude=-8.7101214,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/651719d5-343e-4653-8967-64d94f6e866a_photo.jpg",
      averageRating=4.7, totalRatingsCount=391,
      createdAt="2026-09-01T09:00:38.172075Z", updatedAt="2026-09-01T09:00:38.172075Z",
    ),
    ClubDto(
      id="611be1c5-59b3-42bc-8ea6-1e32b8ce5264", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="A nave do Paintball", address="Estrada do Zondal, 36315 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.1707382, longitude=-8.74053,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/335c8a63-97db-447a-b08e-ad43e75231de_photo.jpg",
      averageRating=4.6, totalRatingsCount=306,
      createdAt="2026-09-01T09:01:36.137043Z", updatedAt="2026-09-01T09:01:36.137043Z",
    ),
    ClubDto(
      id="38610d54-c274-4693-a342-89a835dc958b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Go-Kart O Porriño", address="Carretera de Porriño a Pontellas s/n, 36412 Porriño, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.1423248, longitude=-8.632204,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5d751fff-0e04-4627-ab8a-0eddcacc8f83_photo.jpg",
      averageRating=4.4, totalRatingsCount=540,
      createdAt="2026-09-01T09:01:15.856892Z", updatedAt="2026-09-01T09:01:15.856892Z",
    ),
    ClubDto(
      id="b90f227d-d7a0-4974-91c7-195db198cce6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Racing Dakart Sanxenxo", address="Praza Major, s/n, 36990, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.4152964, longitude=-8.8663496,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8723c119-714f-4327-bafc-85e6b30d34a3_photo.jpg",
      averageRating=4.4, totalRatingsCount=3527,
      createdAt="2026-09-01T09:01:09.763421Z", updatedAt="2026-09-01T09:01:09.763421Z",
    ),
    ClubDto(
      id="82ff32f4-fa75-4d69-ab5c-599cac1346e5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vistabella Golf", address="Av. del Golf, 447, 03319 Orihuela, Alicante",
      city="Vigo", country="ES",
      latitude=38.0381284, longitude=-0.8236343,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/681398e5-9b6d-4d45-82b6-36a2dc00a2c5_photo.jpg",
      averageRating=4.4, totalRatingsCount=460,
      createdAt="2026-09-01T09:00:57.372285Z", updatedAt="2026-09-01T09:00:57.372285Z",
    ),
    ClubDto(
      id="f40d62d7-52e6-41f7-af4c-6254f218965d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Cidade Deportiva Círculo Mercantil Vigo", address="Estrada das Plantas, 131, 36313 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.1780069, longitude=-8.6687403,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/82b4ec36-6f91-44b7-bbb6-b507cc50886f_photo.jpg",
      averageRating=4.3, totalRatingsCount=776,
      createdAt="2026-09-01T09:00:22.214341Z", updatedAt="2026-09-01T09:00:22.214341Z",
    ),
    ClubDto(
      id="0d5e9c72-889b-4c4d-91c5-209505c7a710", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Estadio de Balaídos", address="Av. de Balaídos, s/n, Coia, 36210 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2119201, longitude=-8.73974,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a8870c1f-e59e-4ddb-b715-598161201e86_photo.jpg",
      averageRating=4.3, totalRatingsCount=9768,
      createdAt="2026-09-01T08:59:55.174140Z", updatedAt="2026-09-01T08:59:55.174140Z",
    ),
    ClubDto(
      id="72839bac-efcb-43f2-9019-b9f00d7bba76", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sede do Real Club Celta de Vigo", address="Rúa do Príncipe, 44, Santiago de Vigo, 36202 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2363609, longitude=-8.7221559,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/63672081-9aa3-4fd5-9007-9b10f614742e_photo.jpg",
      averageRating=4.3, totalRatingsCount=645,
      createdAt="2026-09-01T09:00:00.873361Z", updatedAt="2026-09-01T09:00:00.873361Z",
    ),
    ClubDto(
      id="66d4de82-5750-4728-801b-e6673313d81c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Vigo", address="Av. Samil, 43, 36212 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.208542, longitude=-8.7749497,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/231d1d58-e685-44f7-8b91-e976067c658a_photo.jpg",
      averageRating=4.2, totalRatingsCount=1216,
      createdAt="2026-09-01T09:01:21.346617Z", updatedAt="2026-09-01T09:01:21.346617Z",
    ),
    ClubDto(
      id="293edb1b-c130-4519-9c75-0aaa97a9f0b8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo da Mina", address="Camiño da Galindra, 18, 36213 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2086754, longitude=-8.7231894,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9ad530a7-a720-4ca7-87f3-c4772617396f_photo.jpg",
      averageRating=4.2, totalRatingsCount=391,
      createdAt="2026-09-01T09:00:13.039990Z", updatedAt="2026-09-01T09:00:13.039990Z",
    ),
    ClubDto(
      id="503f5392-ce86-4e22-ae8b-5ca6abc929de", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Escola de tenis Samil", address="Av. Samil, 32, 36212 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.203666, longitude=-8.777738,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dc0882c1-44fe-4b7c-9c13-6526e61653ca_photo.jpg",
      averageRating=4.1, totalRatingsCount=288,
      createdAt="2026-09-01T09:00:28.120434Z", updatedAt="2026-09-01T14:31:49.621055Z",
    ),
    ClubDto(
      id="4f00e0b6-e9d7-42a7-bb5d-0edb22306572", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoorvigo club de padel", address="Camiño Gandariña, 19, nave 6, Lavadores, 36214 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2192351, longitude=-8.6976247,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/41525956-5980-46bf-b6cc-4eec739eb9cf_photo.jpg",
      averageRating=4.1, totalRatingsCount=214,
      createdAt="2026-09-01T09:00:43.299108Z", updatedAt="2026-09-01T09:00:43.299108Z",
    ),
    ClubDto(
      id="80115232-edc4-4cd8-b562-58fd8ff9254d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="La Marquesa Golf", address="C. Quesada Ballester, 1, 03170 Rojales, Alicante",
      city="Vigo", country="ES",
      latitude=38.0846806, longitude=-0.7098799,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/69794b00-55d0-4eee-bdc8-5dc721cd5fa7_photo.jpg",
      averageRating=4.1, totalRatingsCount=475,
      createdAt="2026-09-01T09:00:52.167111Z", updatedAt="2026-09-01T09:00:52.167111Z",
    ),
    ClubDto(
      id="72bfbe32-ac97-4d3c-bc88-a2fe923e3a08", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="U. D. Santa Mariña", address="Subida ao Cotogrande s/n (campo de fútbol, Cabral, 36318 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2179265, longitude=-8.6501119,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7aa6935-6318-4a64-9e17-b90301117ba9_photo.jpg",
      averageRating=4.1, totalRatingsCount=433,
      createdAt="2026-09-01T09:00:05.732045Z", updatedAt="2026-09-01T09:00:05.732045Z",
    ),
    ClubDto(
      id="ee304645-68d0-4b73-a242-84a150238e8a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Campo de fútbol das Relfas", address="Camiño Campo da Feira, 2A, Sárdoma, 36214 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2067695, longitude=-8.7088689,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3908ab97-f616-41af-b6c0-92ad9bcf7eee_photo.jpg",
      averageRating=3.9, totalRatingsCount=369,
      createdAt="2026-09-01T09:00:17.615916Z", updatedAt="2026-09-01T09:00:17.615916Z",
    ),
    ClubDto(
      id="5372d909-8c8e-4a5f-9463-be1cc2dd713f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Vigo Voleibol", address="Av. de Castelao, 66B, Coia, 36209 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.2179688, longitude=-8.7510026,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/436361d7-e18d-4e5f-b61b-368c9307804d_photo.jpg",
      averageRating=4.8, totalRatingsCount=26,
      createdAt="2026-09-01T09:00:47.123193Z", updatedAt="2026-09-01T09:00:47.123193Z",
    ),
    ClubDto(
      id="28c91640-1395-4fab-886d-94ec579255a4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club de Tenis de Mesa Vigo", address="Colexio Público da Carrasqueira, 36331 Vigo, Pontevedra",
      city="Vigo", country="ES",
      latitude=42.1977996, longitude=-8.7810144,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/48ecfe1d-7c65-48fc-af2a-a8b0173c093b_photo.jpg",
      averageRating=5.0, totalRatingsCount=15,
      createdAt="2026-09-01T09:01:02.006265Z", updatedAt="2026-09-01T09:01:02.006265Z",
    ),
  )),
  CitySeo(slug="los-angeles", name="Los Angeles", country="US", clubCount=20, sports=listOf(Pair("Football", 3), Pair("Tennis", 2), Pair("Billiards", 2), Pair("Bowling", 2), Pair("Climbing", 2), Pair("Golf", 2), Pair("Table Tennis", 2), Pair("Laser Tag", 2), Pair("Paintball", 1), Pair("Basketball", 1), Pair("Volleyball", 1)), clubs=listOf(
    ClubDto(
      id="feac7f02-5a5c-4141-b3eb-2668931a4727", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Party Plot mobile laser tag", address="1227 Boynton St, Glendale, CA 91205",
      city="Los Angeles", country="US",
      latitude=34.1316356, longitude=-118.2492732,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4f8a75c2-1371-4bfc-92b3-fa5fc6b8f127_photo.jpg",
      averageRating=5.0, totalRatingsCount=283,
      createdAt="2026-09-20T19:11:45.547247Z", updatedAt="2026-09-20T19:11:45.547247Z",
    ),
    ClubDto(
      id="f20d7782-958e-42af-9868-620d8d712007", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sofive Soccer Centers Covina", address="699 S Barranca Ave, Covina, CA 91723",
      city="Los Angeles", country="US",
      latitude=34.077669, longitude=-117.8817225,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3df0f0c7-fadb-498c-bb7d-3dba24e66895_photo.jpg",
      averageRating=4.9, totalRatingsCount=723,
      createdAt="2026-09-20T19:10:50.283505Z", updatedAt="2026-09-20T19:10:50.283505Z",
    ),
    ClubDto(
      id="c10d2769-b23b-4b0d-8d30-891508f49b6c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hollywood Boulders", address="1107 N Bronson Ave, Los Angeles, CA 90038",
      city="Los Angeles", country="US",
      latitude=34.0913422, longitude=-118.318188,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6fa4de91-a017-4234-b8ac-cbfe4f53c4e3_photo.jpg",
      averageRating=4.7, totalRatingsCount=537,
      createdAt="2026-09-20T19:11:30.380144Z", updatedAt="2026-09-20T19:11:30.380144Z",
    ),
    ClubDto(
      id="ad0908c3-eef5-46aa-a397-828b65d2efb2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Will Rogers State Beach", address="17000 CA-1, Pacific Palisades, CA 90272",
      city="Los Angeles", country="US",
      latitude=34.0351317, longitude=-118.5366493,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4d40de8-caa6-46e2-b413-24353d76da21_photo.jpg",
      averageRating=4.7, totalRatingsCount=4831,
      createdAt="2026-09-20T19:11:04.348992Z", updatedAt="2026-09-20T19:11:04.348992Z",
    ),
    ClubDto(
      id="337e3bd8-b5a7-4ea8-ac4f-6c39358c2e02", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Mission Cliffs", address="2295 Harrison St, San Francisco, CA 94110",
      city="Los Angeles", country="US",
      latitude=37.7609759, longitude=-122.4125139,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96c67846-bcc1-40a2-928e-aba7b4d8e0ee_photo.jpg",
      averageRating=4.6, totalRatingsCount=833,
      createdAt="2026-09-20T19:11:27.717198Z", updatedAt="2026-09-20T19:11:27.717198Z",
    ),
    ClubDto(
      id="87134b0c-adfd-4740-89d6-f22856404bb9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sofive Soccer Centers South Gate", address="9599 Pinehurst Ave, South Gate, CA 90280",
      city="Los Angeles", country="US",
      latitude=33.9456376, longitude=-118.1830401,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/347821a1-b4b1-4bf8-b058-54c60f647b95_photo.jpg",
      averageRating=4.6, totalRatingsCount=1309,
      createdAt="2026-09-20T19:10:47.190300Z", updatedAt="2026-09-20T19:10:47.190300Z",
    ),
    ClubDto(
      id="d45735ad-1b45-4b7e-a6b3-2c3cdd4dd01e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Lakes at El Segundo", address="398 Pacific Coast Hwy, El Segundo, CA 90245",
      city="Los Angeles", country="US",
      latitude=33.9110808, longitude=-118.3952783,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5386e37d-91ce-4c9a-942d-cb4cb414ffa9_photo.jpg",
      averageRating=4.6, totalRatingsCount=1345,
      createdAt="2026-09-20T19:11:10.118332Z", updatedAt="2026-09-20T19:11:10.118332Z",
    ),
    ClubDto(
      id="32aafd06-3a1d-4e5a-adc2-4684950a47f2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brentwood Country Club", address="590 S Burlingame Ave, Los Angeles, CA 90049",
      city="Los Angeles", country="US",
      latitude=34.0462792, longitude=-118.4849549,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/815ac539-dfe9-4163-90b3-d3142edcf54d_photo.jpg",
      averageRating=4.5, totalRatingsCount=179,
      createdAt="2026-09-20T19:10:56.666078Z", updatedAt="2026-09-20T19:10:56.666078Z",
    ),
    ClubDto(
      id="91d8c9b4-99d6-4d21-b16d-a245cfd9e8b7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LA Galaxy Soccer Center", address="540 Maple Ave, Torrance, CA 90503",
      city="Los Angeles", country="US",
      latitude=33.8411562, longitude=-118.3394828,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/12396f59-b8d6-4660-9d3b-6fd5940be883_photo.jpg",
      averageRating=4.5, totalRatingsCount=587,
      createdAt="2026-09-20T19:11:55.976632Z", updatedAt="2026-09-20T19:11:55.976632Z",
    ),
    ClubDto(
      id="1c01077b-e20e-47a0-9382-5b1d48764d83", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Los Angeles Table Tennis Association", address="10180 Valley Blvd, El Monte, CA 91731",
      city="Los Angeles", country="US",
      latitude=34.0761933, longitude=-118.0490417,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/24977a51-8743-43ec-948a-18b8be681e77_photo.jpg",
      averageRating=4.5, totalRatingsCount=91,
      createdAt="2026-09-20T19:11:17.201944Z", updatedAt="2026-09-20T19:11:17.201944Z",
    ),
    ClubDto(
      id="55a68230-748f-4959-972f-4d9c2a5f3037", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Orange County Table Tennis Academy", address="18071 Mt Washington St, Fountain Valley, CA 92708",
      city="Los Angeles", country="US",
      latitude=33.7008355, longitude=-117.9332146,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e9649267-979d-4ae5-bd24-6e40e0d3f02f_photo.jpg",
      averageRating=4.5, totalRatingsCount=105,
      createdAt="2026-09-20T19:11:14.027613Z", updatedAt="2026-09-20T19:11:14.027613Z",
    ),
    ClubDto(
      id="c56adf5d-8287-4b5e-8cb2-e19e1127c04e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Balboa Tennis Center", address="5651 Balboa Blvd, Encino, CA 91316",
      city="Los Angeles", country="US",
      latitude=34.1732362, longitude=-118.5021095,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/31422946-36fc-46d9-bbc8-c8bbdf4a5d3e_photo.jpg",
      averageRating=4.4, totalRatingsCount=192,
      createdAt="2026-09-20T19:10:53.286710Z", updatedAt="2026-09-20T19:10:53.286710Z",
    ),
    ClubDto(
      id="71565eb2-266e-42c7-85ce-2c5de83f396a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gage Bowl", address="3477 E Gage Ave, Huntington Park, CA 90255",
      city="Los Angeles", country="US",
      latitude=33.979854, longitude=-118.2031238,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aeff54ef-d780-4e34-8ed8-ca77a74f4b66_photo.jpg",
      averageRating=4.4, totalRatingsCount=1732,
      createdAt="2026-09-20T19:11:21.831430Z", updatedAt="2026-09-20T19:11:21.831430Z",
    ),
    ClubDto(
      id="4e6ae375-f68c-4aac-820b-cab052dc3698", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Highland Park Bowl", address="5621 N Figueroa St, Los Angeles, CA 90042",
      city="Los Angeles", country="US",
      latitude=34.1093965, longitude=-118.1935786,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d3256b30-0732-4562-a280-03a15f679730_photo.jpg",
      averageRating=4.4, totalRatingsCount=1342,
      createdAt="2026-09-20T19:11:25.121901Z", updatedAt="2026-09-20T19:11:25.121901Z",
    ),
    ClubDto(
      id="249b0229-9e4b-4155-a039-454e1c703991", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Industry Hills Golf Club at Pacific Palms Resort", address="1 Industry Hills Pkwy, City of Industry, CA 91744",
      city="Los Angeles", country="US",
      latitude=34.0202784, longitude=-117.9270418,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/81d03fa3-59ae-403f-b4d7-2d00c928afb7_photo.jpg",
      averageRating=4.4, totalRatingsCount=1821,
      createdAt="2026-09-20T19:11:07.064450Z", updatedAt="2026-09-20T19:11:07.064450Z",
    ),
    ClubDto(
      id="ea800da7-f65a-4b27-9a48-4b70219a7da9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SC Village", address="8900 McCarty Rd, Corona, CA 92880",
      city="Los Angeles", country="US",
      latitude=33.9316, longitude=-117.620181,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed3c258d-8bb9-40b1-8d65-c94def605168_photo.jpg",
      averageRating=4.4, totalRatingsCount=1812,
      createdAt="2026-09-20T19:11:52.358676Z", updatedAt="2026-09-20T19:11:52.358676Z",
    ),
    ClubDto(
      id="28f0ccdf-d446-4742-96d8-8c2c8c5be477", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fantasia Billiards", address="131 N San Fernando Blvd, Burbank, CA 91502",
      city="Los Angeles", country="US",
      latitude=34.1811822, longitude=-118.3095726,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c75f7cca-c55e-4129-ab6a-17fa8421418b_photo.jpg",
      averageRating=4.2, totalRatingsCount=848,
      createdAt="2026-09-20T19:11:34.533011Z", updatedAt="2026-09-20T19:11:34.533011Z",
    ),
    ClubDto(
      id="624eb63a-0192-4c34-81b0-2c849cf4065c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Q's Billiard Club & Restaurant", address="11835 Wilshire Blvd, Los Angeles, CA 90025",
      city="Los Angeles", country="US",
      latitude=34.0476814, longitude=-118.4634866,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3800e14b-3cd4-42b7-ad90-c2aa91ec50f1_photo.jpg",
      averageRating=4.2, totalRatingsCount=839,
      createdAt="2026-09-20T19:11:39.406315Z", updatedAt="2026-09-20T19:11:39.406315Z",
    ),
    ClubDto(
      id="52f30715-0156-4cf3-9c36-d631dc7d2399", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Map Sports Facility", address="The Map Sports Facility, 12552 Western Ave, Garden Grove, CA 92841",
      city="Los Angeles", country="US",
      latitude=33.7804204, longitude=-118.000898,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1e5030ab-2f2b-4ef1-bef9-10ce72e6a494_photo.jpg",
      averageRating=4.2, totalRatingsCount=622,
      createdAt="2026-09-20T19:10:59.772939Z", updatedAt="2026-09-20T19:10:59.772939Z",
    ),
    ClubDto(
      id="2be0a5d1-d71a-4048-8f57-73c99afec4fc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ultrazone", address="231 E Main St, Alhambra, CA 91801",
      city="Los Angeles", country="US",
      latitude=34.0965194, longitude=-118.1243668,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9b5d8dc7-10d4-4c77-8b02-73ae720ac7c5_photo.jpg",
      averageRating=4.2, totalRatingsCount=250,
      createdAt="2026-09-20T19:11:49.074112Z", updatedAt="2026-09-20T19:11:49.074112Z",
    ),
  )),
  CitySeo(slug="cluj-napoca", name="Cluj-Napoca", country="RO", clubCount=20, sports=listOf(Pair("Tennis", 3), Pair("Football", 2), Pair("Karting", 2), Pair("Basketball", 2), Pair("Climbing", 2), Pair("Laser Tag", 2), Pair("Bowling", 2), Pair("Volleyball", 1), Pair("Billiards", 1), Pair("Padel", 1), Pair("Golf", 1), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="71363ffb-debb-4145-8075-1e757a7ccb9e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ParaPark Cluj", address="Strada Bolyai János 9, 400096 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7710509, longitude=23.5912164,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/863eb478-4bc2-4060-b59d-974b236a03c2_ChIJaQVQhJ0O_2.jpg",
      averageRating=4.9, totalRatingsCount=1251,
      createdAt="2026-08-30T22:54:03.767643Z", updatedAt="2026-08-31T22:11:19.807431Z",
    ),
    ClubDto(
      id="b502fe7f-dd8b-44a4-8100-c19e37cda730", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SKAI Urban Crag", address="Calea Baciului 1-3, 400230 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7827504, longitude=23.5458349,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6f538f9f-6fc5-453b-93dc-c4bf69040ac0_ChIJ35rEROEO_0.jpg",
      averageRating=4.9, totalRatingsCount=377,
      createdAt="2026-08-30T22:54:17.360553Z", updatedAt="2026-08-31T08:35:36.199717Z",
    ),
    ClubDto(
      id="d59d7504-4b69-47eb-abe7-7d520e24e946", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SMASH SPORTS CENTER", address="Strada Orăștiei 10, 400394 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7800731, longitude=23.6606482,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4f0e5e24-c1df-4af6-8db9-abec6447f2cc_ChIJD7N9a5AN_0.jpg",
      averageRating=4.9, totalRatingsCount=83,
      createdAt="2026-08-30T22:55:20.928495Z", updatedAt="2026-09-01T14:31:52.931153Z",
    ),
    ClubDto(
      id="ab61cc4d-1f24-4e74-84fe-7c8a4bd599c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Baza Sportivă Gheorgheni", address="Strada Mareșal Constantin Prezan, 400416 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7700626, longitude=23.6360361,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f5dcaa26-853f-4f43-9eea-43b6217a815f_ChIJ6XB0M2gM_0.jpg",
      averageRating=4.8, totalRatingsCount=6068,
      createdAt="2026-08-30T22:53:43.797454Z", updatedAt="2026-09-01T14:31:47.008299Z",
    ),
    ClubDto(
      id="c09c2d8b-da8c-4a2b-b490-0fdfb530f0ca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gravity", address="Drumul Sfântul Ioan, 400527 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7488307, longitude=23.541903,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a057fc70-6d98-48d9-9a5b-2af6365aedc1_ChIJGaD0BtkN_0.jpg",
      averageRating=4.8, totalRatingsCount=437,
      createdAt="2026-08-30T22:54:10.988591Z", updatedAt="2026-08-31T08:28:42.324628Z",
    ),
    ClubDto(
      id="b9addb3d-235e-47d2-9908-b25fe5fc0a12", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Baza Sportivă „La Terenuri”", address="Mănăștur, 400001 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7489241, longitude=23.55459,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/14f9f1be-de0d-49e8-95ac-7ff3658bbe9b_photo.png",
      averageRating=4.7, totalRatingsCount=1040,
      createdAt="2026-08-31T15:37:48.103070Z", updatedAt="2026-08-31T15:37:48.103070Z",
    ),
    ClubDto(
      id="a9733e18-50f8-4d04-b54d-f3d75331708e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BuggyZone - Buggy & Off-Road Tours Cluj", address="Livada Steluța, 400253 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.8029514, longitude=23.5750258,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/137725c1-ca92-4f16-b37b-99f69074a549_ChIJR415zhAM_0.jpg",
      averageRating=4.7, totalRatingsCount=120,
      createdAt="2026-08-30T22:54:31.362343Z", updatedAt="2026-08-31T08:26:40.879755Z",
    ),
    ClubDto(
      id="b9b9f8ef-b4a0-46f9-a507-1f10ac20f436", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser-Tag Fonix", address="Strada Berăriei 6, 400380 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7635017, longitude=23.570194,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fed16d36-38af-4a1c-ba2f-336c0955034a_ChIJSQk0tGML_0.jpg",
      averageRating=4.7, totalRatingsCount=359,
      createdAt="2026-08-30T22:54:44.315035Z", updatedAt="2026-08-30T22:54:44.315035Z",
    ),
    ClubDto(
      id="58e98b88-2ef2-417b-b653-cbe03933a81f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vmax Karting", address="Str. Fabricii de Zahăr 165, 400394 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7930341, longitude=23.6269342,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1fcdc9d4-6212-4d7e-a96d-f8437d623994_ChIJPUafcTkL_0.jpg",
      averageRating=4.7, totalRatingsCount=985,
      createdAt="2026-08-30T22:54:24.083427Z", updatedAt="2026-08-31T08:38:53.242256Z",
    ),
    ClubDto(
      id="36dce6e2-a5b5-47f0-bf7a-5ea51739101f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="War-Zone", address="Strada Colonia Breaza 999, Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.8033332, longitude=23.5747241,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f5f5d2b0-2881-480d-9b80-7cf769ac302a_ChIJX4nB8LcO_0.jpg",
      averageRating=4.7, totalRatingsCount=651,
      createdAt="2026-08-30T22:54:37.794733Z", updatedAt="2026-08-31T08:39:03.991280Z",
    ),
    ClubDto(
      id="3147338b-797c-4f9b-ad19-13ae170814c0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Wonderland", address="PHCQ+7J, 407270 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7206875, longitude=23.5890625,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/38c68c79-70d7-4694-9144-c9a8aeaa4daa_ChIJb82nOokN_2.jpg",
      averageRating=4.7, totalRatingsCount=8859,
      createdAt="2026-08-30T22:53:37.076057Z", updatedAt="2026-08-31T22:11:23.888705Z",
    ),
    ClubDto(
      id="bf958360-9a92-41c3-8799-8b53d50f02fe", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Marc Tennis", address="Bună Ziua, Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7516547, longitude=23.6054305,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d737d528-1839-4aa4-af33-9e31c3a3967e_ChIJv7kkZcoN_0.jpg",
      averageRating=4.6, totalRatingsCount=103,
      createdAt="2026-08-30T22:55:07.304828Z", updatedAt="2026-08-30T22:55:07.304828Z",
    ),
    ClubDto(
      id="6a4aaf73-0100-4522-a0a4-c7062ac5bad0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Casa de Padel", address="Strada Orăștiei 10, 400394 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7792033, longitude=23.656482,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8931e606-3dbe-4dda-bc53-81f8004232b5_ChIJL6hR-qwN_0.jpg",
      averageRating=4.5, totalRatingsCount=55,
      createdAt="2026-08-30T22:55:00.324562Z", updatedAt="2026-08-31T08:26:44.896837Z",
    ),
    ClubDto(
      id="963c7cae-cc00-4c0f-b95e-f2d2c290e716", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Transilvania", address="Bulevardul 1 Decembrie 1918 41, 400699 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7622508, longitude=23.5472352,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8c95b048-86f3-46a1-aabe-1bca4eca9d9e_photo.jpg",
      averageRating=4.5, totalRatingsCount=1041,
      createdAt="2026-08-31T15:37:33.524392Z", updatedAt="2026-08-31T15:37:33.524392Z",
    ),
    ClubDto(
      id="bb4e4710-651d-4985-ba51-0fcae35d6ebb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="OH Sports Complex", address="Str. Mărișel 17, 400535 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7475076, longitude=23.5561455,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e7a6910b-4cad-486f-a290-d30ca9836d4c_photo.jpg",
      averageRating=4.5, totalRatingsCount=341,
      createdAt="2026-08-31T15:37:41.092578Z", updatedAt="2026-08-31T15:37:41.092578Z",
    ),
    ClubDto(
      id="16b875a2-1467-41b5-8a31-1344ccdc72eb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Oqtagon Airsoft", address="Strada Câmpina 62A, 400635 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.787112, longitude=23.6258096,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a65a019a-d9e8-4e92-9996-9057d5ad5b57_ChIJU00wKBIM_0.jpg",
      averageRating=4.5, totalRatingsCount=551,
      createdAt="2026-08-30T22:54:51.846050Z", updatedAt="2026-08-30T22:54:51.846050Z",
    ),
    ClubDto(
      id="7801b462-329d-42cd-bb4a-958bb052e954", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenis Clujana", address="Str. Tăbăcarilor 15, 400139 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7900489, longitude=23.6118039,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f4e6b72f-92b5-4bbf-8e5a-982da38e2742_ChIJDX7FmwEM_0.jpg",
      averageRating=4.5, totalRatingsCount=85,
      createdAt="2026-08-30T22:55:13.954729Z", updatedAt="2026-08-30T22:55:13.954729Z",
    ),
    ClubDto(
      id="0433318e-7e89-430a-9cea-3f5d67db6ea1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Blue Galaxy", address="Strada Liviu Rebreanu 48, 400000 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.765255, longitude=23.6198862,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/138b85fc-5899-45ef-aedb-04b0f3802267_ChIJ0YMebEcM_0.jpg",
      averageRating=4.3, totalRatingsCount=466,
      createdAt="2026-08-30T22:53:50.957403Z", updatedAt="2026-08-30T22:53:50.957403Z",
    ),
    ClubDto(
      id="ea7a3801-d332-45eb-8382-1bc2b4bde886", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Multiplex Leul", address="Str. Argeș 5, 400107 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7740811, longitude=23.5938239,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d8dc9d5c-e1e4-4920-9f64-12664dbaae6f_ChIJLYpLIp4O_0.jpg",
      averageRating=4.0, totalRatingsCount=2358,
      createdAt="2026-08-30T22:53:57.247431Z", updatedAt="2026-08-30T22:53:57.247431Z",
    ),
    ClubDto(
      id="c40cd4af-c16e-492a-897b-eaa32963a044", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Driving Range", address="Calea Turzii 176-178, 400347 Cluj-Napoca",
      city="Cluj-Napoca", country="RO",
      latitude=46.7477452, longitude=23.5916543,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c0713974-917f-42ea-8b13-f23b6c82a853_photo.jpg",
      averageRating=4.9, totalRatingsCount=16,
      createdAt="2026-08-31T15:37:54.588102Z", updatedAt="2026-08-31T15:37:54.588102Z",
    ),
  )),
  CitySeo(slug="ternopil", name="Ternopil", country="UA", clubCount=20, sports=listOf(Pair("Tennis", 3), Pair("Football", 3), Pair("Basketball", 3), Pair("Billiards", 2), Pair("Karting", 2), Pair("Volleyball", 2), Pair("Laser Tag", 2), Pair("Climbing", 1), Pair("Bowling", 1), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="d41d8b65-c51b-4fc7-a8f6-b7b779313fd8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="«ДЮСШ «Футбольна академія Тернопіль» ТМР", address="вулиця Торговиця, 11б, Тернопіль, 46000 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.543712, longitude=25.5902961,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a495d5f8-4c73-478d-adae-a650d2b4a43b_ChIJY8nJWAA3_0.jpg",
      averageRating=5.0, totalRatingsCount=108,
      createdAt="2026-08-30T17:23:22.220276Z", updatedAt="2026-08-30T20:52:25.910535Z",
    ),
    ClubDto(
      id="4ea4e17b-eac1-4671-9d77-2987b7424f15", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Футбольна Академія Тернопіль", address="вулиця Текстильна, 18, Тернопіль, 46002 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.5645115, longitude=25.6147821,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cf1e883d-e475-48ad-987f-e11ce72f94fa_ChIJb9pinOgx_0.jpg",
      averageRating=5.0, totalRatingsCount=59,
      createdAt="2026-08-30T17:23:30.362352Z", updatedAt="2026-08-30T20:52:53.548461Z",
    ),
    ClubDto(
      id="07a95e6b-152d-4883-9173-c96363c1669b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Комплексна дитячо-юнацька спортивна школа з футболу та інших ігрових видів спорту", address="вулиця Братів Бойчуків, 4A, Тернопіль, Тернопільська область, 46002",
      city="Ternopil", country="UA",
      latitude=49.5603672, longitude=25.6391877,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ba788362-3475-459e-9f9c-90f75accbe50_photo.jpg",
      averageRating=4.9, totalRatingsCount=54,
      createdAt="2026-08-31T15:51:55.374571Z", updatedAt="2026-08-31T22:11:25.427756Z",
    ),
    ClubDto(
      id="219c0220-8c4b-4fc8-b585-6d5cf3ab5557", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ЛАЗЕРТАГ АРЕНА РОЗВАГ", address="вулиця Патріарха Йосифа Сліпого, 7, Тернопіль, 46000 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.551553, longitude=25.5913277,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1260eb4e-dec8-4a20-acb3-0850046a6aba_ChIJy51ofNo3_0.jpg",
      averageRating=4.9, totalRatingsCount=167,
      createdAt="2026-08-30T17:24:26.855366Z", updatedAt="2026-08-30T20:52:36.374693Z",
    ),
    ClubDto(
      id="60064098-f586-4834-b5a9-d167c1c6b264", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Wellness Centre “Каруна”", address="проспект Степана Бандери, 50, Тернопіль, 46000 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.5508787, longitude=25.6178882,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1cbc8045-6f75-407b-b9b8-8540b6f6740d_ChIJy5_LdVUx_0.jpg",
      averageRating=4.8, totalRatingsCount=229,
      createdAt="2026-08-30T17:24:12.033343Z", updatedAt="2026-08-30T20:52:25.424904Z",
    ),
    ClubDto(
      id="95ad91b9-a539-404b-b370-beb63160c93e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг Тернопіль клуб “Dark Side”", address="вулиця Князя Острозького, 45, Тернопіль, 46001 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.5460409, longitude=25.6007449,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed9d639d-e022-43d3-b86e-0cf4094e9d28_ChIJPUp7ZFYx_0.jpg",
      averageRating=4.8, totalRatingsCount=52,
      createdAt="2026-08-30T17:24:38.275410Z", updatedAt="2026-08-30T20:52:37.654042Z",
    ),
    ClubDto(
      id="5273eba1-7318-41de-b678-fb5d2ceb65ec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Дитячо-юнацька спортивна школа № 2", address="вулиця Князя Острозького, 16, Тернопіль, Тернопільська область, 46000",
      city="Ternopil", country="UA",
      latitude=49.5483657, longitude=25.5966023,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/90994991-4ee4-4d04-8cc2-972ff63f7ede_photo.jpg",
      averageRating=4.6, totalRatingsCount=97,
      createdAt="2026-08-31T15:52:13.641723Z", updatedAt="2026-08-31T15:52:13.641723Z",
    ),
    ClubDto(
      id="3d78b5c8-7d45-4c9d-ac1e-92eeb13135ea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісний клуб \"MASTERS\"", address="Тернопіль, 46001 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.555022, longitude=25.6340533,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/79ec177f-ff29-4717-a08c-7ecc989f2120_ChIJ0xhJXO0z_1.jpg",
      averageRating=4.6, totalRatingsCount=141,
      createdAt="2026-08-30T17:24:53.301962Z", updatedAt="2026-08-31T22:11:27.704643Z",
    ),
    ClubDto(
      id="f247b979-4394-43a6-b9b0-36e3156d0141", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісний корт", address="Тернопіль, 46001 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.5549868, longitude=25.6340503,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cf065156-f93b-4f68-b2c5-0da960afbb69_ChIJ5xpPtOQz_0.jpg",
      averageRating=4.5, totalRatingsCount=86,
      createdAt="2026-08-30T17:25:01.404319Z", updatedAt="2026-08-30T20:52:52.002357Z",
    ),
    ClubDto(
      id="6466d999-9c14-4857-9035-b0f6b3f479cc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="картингова траса", address="вулиця Митрополита Шептицького, 51, Тернопіль, 46002 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.5428375, longitude=25.5889594,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2fa02289-59e0-4462-be78-32fa854ed46d_ChIJrcv3Xbo2_0.jpg",
      averageRating=4.5, totalRatingsCount=65,
      createdAt="2026-08-30T17:24:20.081516Z", updatedAt="2026-08-30T20:52:55.313807Z",
    ),
    ClubDto(
      id="585c4492-f0bc-4316-aae4-292553786a9d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Happiness family club", address="проспект Степана Бандери, 50, Тернопіль, 46000 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.550823, longitude=25.6179096,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/896cd2b1-691f-4120-9c1f-700029275550_ChIJAb0r6uUz_0.jpg",
      averageRating=4.4, totalRatingsCount=945,
      createdAt="2026-08-30T17:23:55.158402Z", updatedAt="2026-08-30T20:52:14.693298Z",
    ),
    ClubDto(
      id="dc61a995-21de-419a-952e-b14bf4eec0ff", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Central Park Tennis", address="вулиця Торговиця, 15 г, Тернопіль, 46002 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.5452477, longitude=25.5866049,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7558b118-9ce5-472a-8f71-41e31f028bc2_ChIJG6NDvPA3_0.jpg",
      averageRating=4.3, totalRatingsCount=62,
      createdAt="2026-08-30T17:25:09.082891Z", updatedAt="2026-08-30T20:52:09.560732Z",
    ),
    ClubDto(
      id="c1082777-697c-4406-8619-38612e87fc67", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лисий", address="вулиця Січових Стрільців, 3, Тернопіль, 46001 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.5505657, longitude=25.5979267,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99e8122b-2ea3-4bf1-a511-923051fbc3f3_ChIJZaot-rI2_0.jpg",
      averageRating=4.2, totalRatingsCount=1538,
      createdAt="2026-08-30T17:23:46.943574Z", updatedAt="2026-08-30T20:52:38.402222Z",
    ),
    ClubDto(
      id="43309d6c-f43f-4e98-b084-1067b195c2f6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спортивна база \"Спартак\"", address="Тернопіль, Тернопільська область, 46000",
      city="Ternopil", country="UA",
      latitude=49.5687199, longitude=25.5834916,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b3d9e23b-1692-4de6-b3b8-3f35a6bb0bf2_photo.jpg",
      averageRating=4.2, totalRatingsCount=54,
      createdAt="2026-08-31T15:52:01.717319Z", updatedAt="2026-08-31T22:11:26.725178Z",
    ),
    ClubDto(
      id="d6e2f21c-a8cf-4c57-a7c1-bd1ca64b89e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбольний клуб Легіонер", address="Тернопіль, вул. Сергія Короля, 48, Тернопіль, 46000 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.5503959, longitude=25.5438537,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/13bb3234-4f37-44f9-a7f1-fad16661de0c_ChIJ____02Ix_0.jpg",
      averageRating=4.6, totalRatingsCount=45,
      createdAt="2026-08-30T17:24:45.630510Z", updatedAt="2026-08-30T20:52:43.380563Z",
    ),
    ClubDto(
      id="0029e82e-e1b4-4eff-abbf-a973f7e204b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Silver", address="вулиця Текстильна, 28, Тернопіль, 46020 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.5753533, longitude=25.6379492,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/79766f7d-b7eb-43f6-b806-76931eeed7f2_ChIJE95heG8x_0.jpg",
      averageRating=4.1, totalRatingsCount=478,
      createdAt="2026-08-30T17:24:02.955962Z", updatedAt="2026-08-30T20:52:23.448860Z",
    ),
    ClubDto(
      id="7435bf28-b553-4b3f-a3db-1a8b882144dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Текстильник Sports Factory", address="TEKSTYLNYK SPORTS FACTORY, вулиця Текстильна, 18, Тернопіль, 46002 Ternopil, Ukraine",
      city="Ternopil", country="UA",
      latitude=49.566821, longitude=25.6139462,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bde31ab8-2b16-4d3f-b9ca-8321e4869b28_ChIJJ99oyQMx_0.jpg",
      averageRating=4.7, totalRatingsCount=30,
      createdAt="2026-08-30T17:23:39.689125Z", updatedAt="2026-08-30T20:52:50.702466Z",
    ),
    ClubDto(
      id="737b2646-5038-478e-8620-c50c5a3b801d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Комплексна дитячо-юнацька спортивна школа з водних видів спорту", address="вулиця Білецька, 54, Тернопіль, Тернопільська область, 46003",
      city="Ternopil", country="UA",
      latitude=49.5679929, longitude=25.583971,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a4c288b0-4d51-450f-afda-472593b95189_photo.jpg",
      averageRating=5.0, totalRatingsCount=12,
      createdAt="2026-08-31T15:52:08.298861Z", updatedAt="2026-08-31T22:11:25.323200Z",
    ),
    ClubDto(
      id="4b50163e-8f16-4e3f-8856-c672cf89b742", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climbing room", address="вулиця Микулинецька, 46, Тернопіль, Тернопільська область, 46005",
      city="Ternopil", country="UA",
      latitude=49.5297586, longitude=25.6031932,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1e61548e-8180-478a-84a7-6261ecab5a3c_photo.jpg",
      averageRating=5.0, totalRatingsCount=8,
      createdAt="2026-08-31T15:52:20.700519Z", updatedAt="2026-08-31T15:52:20.700519Z",
    ),
    ClubDto(
      id="a754dad3-f97b-47da-a703-5d9e2afffd08", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Фізкультурно оздоровчий комплекс", address="вулиця Братів Бойчуків, 4А, Тернопіль, Тернопільська область, 46023",
      city="Ternopil", country="UA",
      latitude=49.5605567, longitude=25.639528,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e8e276b5-182b-42a2-832c-ef0a20154116_photo.jpg",
      averageRating=4.4, totalRatingsCount=7,
      createdAt="2026-08-31T15:51:47.996238Z", updatedAt="2026-08-31T15:51:47.996238Z",
    ),
  )),
  CitySeo(slug="lviv", name="Lviv", country="UA", clubCount=19, sports=listOf(Pair("Football", 3), Pair("Golf", 2), Pair("Tennis", 2), Pair("Padel", 2), Pair("Laser Tag", 2), Pair("Climbing", 2), Pair("Paintball", 2), Pair("Basketball", 1), Pair("Billiards", 1), Pair("Karting", 1), Pair("Table Tennis", 1)), clubs=listOf(
    ClubDto(
      id="e763dcd2-bd11-48bf-b171-c527607bdd92", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Golf - клуб неонового міні-гольфу", address="вулиця Зелена, 269н, Львів, Львівська область, 79066",
      city="Lviv", country="UA",
      latitude=49.8016353, longitude=24.067692,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1969c085-c8e6-4fc5-9747-b8be7aed4bc0_photo.jpg",
      averageRating=4.9, totalRatingsCount=138,
      createdAt="2026-08-31T15:18:51.459814Z", updatedAt="2026-08-31T15:18:51.459814Z",
    ),
    ClubDto(
      id="d1f3ba3e-a68f-4bd6-bac7-69cd97741619", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lev Padel Club", address="вулиця Пластова, 7, Львів, 79000 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.8615176, longitude=24.0666693,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bb6aac91-7f2f-44f4-9d2b-b321cb8d4c56_ChIJuwV3SG2V_0.jpg",
      averageRating=4.8, totalRatingsCount=50,
      createdAt="2026-08-30T17:13:43.207646Z", updatedAt="2026-08-30T20:52:17.190726Z",
    ),
    ClubDto(
      id="b92203d9-9360-4730-97aa-59f650bd7c98", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MEGA PARK — Дитячий Розважальний Центр у Львові", address="вулиця Газова, 30А, Львів, 79000 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.8492766, longitude=24.0223924,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fc676627-2cd9-415f-8444-c3223dd90e4b_ChIJmdZUUADd_0.jpg",
      averageRating=4.8, totalRatingsCount=1872,
      createdAt="2026-08-30T17:13:00.377272Z", updatedAt="2026-08-30T20:52:17.693067Z",
    ),
    ClubDto(
      id="94054701-0260-47a4-af8c-46d6d824ba2a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбольний клуб Хантер пейнтбол, лазертаг.", address="вул. Лікарська, 2, Брюховичі, 79044 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.9086815, longitude=23.952581,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fcadef21-46e3-4844-aff0-4bdc6e81e077_ChIJD5DZ95Te_0.jpg",
      averageRating=4.8, totalRatingsCount=376,
      createdAt="2026-08-30T17:13:22.678310Z", updatedAt="2026-08-30T20:52:43.517857Z",
    ),
    ClubDto(
      id="7ac18808-ced4-4f83-a1a8-1375535aa812", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спортивно-відпочинковий комплекс \"BNB\": пейнтбол, лазертаг, дитячий пейнтбол у Львові.", address="Дорошенка 1, Кожичі, 81084 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.878189, longitude=23.889479,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2f849404-b170-4e90-8eec-d03183e26e3e_ChIJtYR6kbff_0.jpg",
      averageRating=4.8, totalRatingsCount=274,
      createdAt="2026-08-30T17:13:29.692082Z", updatedAt="2026-08-30T20:52:48.371377Z",
    ),
    ClubDto(
      id="cfdeefb9-ffa7-4df1-9705-0f31e9d53927", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="LEOLAND спортивно-розважальний комплекс", address="вулиця Мельника, 18, Львів, 79057 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.8298498, longitude=24.0039774,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c885a460-3f26-402b-ae88-0963467b70fa_ChIJVVWl03_d_0.jpg",
      averageRating=4.7, totalRatingsCount=1031,
      createdAt="2026-08-30T17:11:56.845053Z", updatedAt="2026-08-30T20:52:16.432563Z",
    ),
    ClubDto(
      id="cab67024-e2be-40b0-bb4d-5dd700b6018f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Wall", address="вулиця Героїв УПА, 72, Львів, 79000 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.83226, longitude=23.996549,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/27fe68ee-a35a-47c7-8d38-c3eccf842683_ChIJya1kZIDd_0.jpg",
      averageRating=4.6, totalRatingsCount=340,
      createdAt="2026-08-30T17:12:36.631532Z", updatedAt="2026-08-30T20:52:24.643563Z",
    ),
    ClubDto(
      id="84400f23-e147-4b38-94f4-b51a47aa390c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Арена Львів", address="вулиця Стрийська, 199, Львів, 79031 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.7748612, longitude=24.02768,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/21c57194-12fc-49c4-9d7e-530092b43e0d_ChIJ70jWWsTn_0.jpg",
      averageRating=4.6, totalRatingsCount=11326,
      createdAt="2026-08-30T17:11:34.918393Z", updatedAt="2026-08-30T20:52:26.761723Z",
    ),
    ClubDto(
      id="3c73cc40-1a71-46eb-be4b-47afee5e798c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скеледром Бухта", address="вулиця Сяйво, 12, Львів, 79000 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.839659, longitude=23.981114,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/14e0f2dc-e18d-4a93-84ec-b6179792c837_ChIJW4KLk7fd_0.jpg",
      averageRating=4.6, totalRatingsCount=250,
      createdAt="2026-08-30T17:12:44.799922Z", updatedAt="2026-08-30T20:52:46.655432Z",
    ),
    ClubDto(
      id="abaefd45-1987-4221-802e-4df038c049be", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Dynamo - Tennis court", address="вулиця Янева, 10, Львів, 79000 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.8125663, longitude=24.0122558,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1cd63f60-e680-4533-b1f6-5f4e9702beb3_ChIJLX-4-ZTn_0.jpg",
      averageRating=4.5, totalRatingsCount=57,
      createdAt="2026-08-30T17:14:17.669308Z", updatedAt="2026-08-30T20:52:12.503652Z",
    ),
    ClubDto(
      id="d1dceb19-ed4b-45a2-9c9d-d5a3269330a9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Більярдний клуб ZoVeX", address="вулиця Богдана Хмельницького, 212, Львів, 79037 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.8688253, longitude=24.0574959,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/96017381-905b-4e85-bd79-ebf4b8d809d6_ChIJpWPznQHo_0.jpg",
      averageRating=4.5, totalRatingsCount=473,
      createdAt="2026-08-30T17:12:14.206997Z", updatedAt="2026-08-30T20:52:28.870952Z",
    ),
    ClubDto(
      id="42cd604c-1db2-4d5e-91f9-2755e41f90d7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг на \"Арена Львів\" Xtreme Karts", address="вулиця Стрийська, 199, Львів, 79000 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.7731459, longitude=24.027632,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5f2b434d-736b-4bef-8398-075f6a87dace_ChIJJRTiJDHn_1.jpg",
      averageRating=4.5, totalRatingsCount=584,
      createdAt="2026-08-30T17:12:51.768104Z", updatedAt="2026-08-31T22:11:25.208871Z",
    ),
    ClubDto(
      id="bb7a15dc-d7f2-4fb9-89c7-b9ce68f0354b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Теніс Life", address="Львів, 79000 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.7834222, longitude=24.0246081,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/94d50543-f806-4267-8975-d5a73edee9b8_ChIJ86nLDNXn_0.jpg",
      averageRating=4.3, totalRatingsCount=201,
      createdAt="2026-08-30T17:13:59.296258Z", updatedAt="2026-09-01T14:31:47.131137Z",
    ),
    ClubDto(
      id="25cf9c10-169c-4d2f-a7d1-a9cac5ce1e53", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Планета мрій", address="вулиця Газова, 30А, Львів, 79000 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.8493011, longitude=24.0223957,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a73bf39e-3b5a-4d01-8188-7dafd774e927_ChIJJwqDAwvd_0.jpg",
      averageRating=4.2, totalRatingsCount=1334,
      createdAt="2026-08-30T17:13:08.781541Z", updatedAt="2026-08-30T20:52:44.236061Z",
    ),
    ClubDto(
      id="2c47b54f-630e-43de-836f-538189e07f82", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="СКА", address="вулиця Клепарівська, 39А, Львів, 79000 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.8527399, longitude=24.013528,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/714d110a-5354-4a21-8d02-a9657c9db286_ChIJ9z00aaHd_0.jpg",
      averageRating=4.1, totalRatingsCount=1312,
      createdAt="2026-08-30T17:11:49.748773Z", updatedAt="2026-08-30T20:52:45.489898Z",
    ),
    ClubDto(
      id="5bdaf1c3-33e7-41da-bb47-891c3bc9f4a6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Green Padel House", address="вулиця Зелена, 238-з, Львів, 79035 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.8049572, longitude=24.062096,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2f82678e-8065-45ea-9d14-b24d0bc5011b_ChIJW6PYxnHp_0.jpg",
      averageRating=4.8, totalRatingsCount=27,
      createdAt="2026-08-30T17:13:51.516548Z", updatedAt="2026-08-30T20:52:14.393196Z",
    ),
    ClubDto(
      id="d78807e5-e1ee-4de8-a1bc-859e1d607bdd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Agiotage Beach", address="просп. Святого Івана Павла ІІ, 35Б, Львів, Львівська область, 79000",
      city="Lviv", country="UA",
      latitude=49.8042489, longitude=24.0364146,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c934df00-93f9-49ac-a30e-0771347dcf99_photo.jpg",
      averageRating=5.0, totalRatingsCount=25,
      createdAt="2026-08-31T15:18:35.275318Z", updatedAt="2026-08-31T15:18:35.275318Z",
    ),
    ClubDto(
      id="ec04312f-d6ea-4557-9cd7-75db78deb797", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Клуб настільного тенісу «Автосервіс»", address="вулиця Стрийська, 45б, Львів, 79000 Lviv, Ukraine",
      city="Lviv", country="UA",
      latitude=49.8088659, longitude=24.0195189,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/848cd304-cb79-44b3-aaca-91bebe2ca613_ChIJgT0wrmbn_0.jpg",
      averageRating=5.0, totalRatingsCount=21,
      createdAt="2026-08-30T17:13:36.701379Z", updatedAt="2026-08-30T20:52:34.613084Z",
    ),
    ClubDto(
      id="65cd5674-dc9f-4e9b-89bf-14895331ad93", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sim Golf", address="вулиця Івана Рубчака, 21 А, Львів, Львівська область, 79004",
      city="Lviv", country="UA",
      latitude=49.8056469, longitude=24.0105075,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/83fb9ae3-e4e9-40ba-a6f1-36ae4e036ac6_photo.jpg",
      averageRating=5.0, totalRatingsCount=18,
      createdAt="2026-08-31T15:18:44.017012Z", updatedAt="2026-08-31T15:18:44.017012Z",
    ),
  )),
  CitySeo(slug="antwerp", name="Antwerp", country="BE", clubCount=19, sports=listOf(Pair("Volleyball", 5), Pair("Tennis", 3), Pair("Bowling", 2), Pair("Basketball", 2), Pair("Climbing", 2), Pair("Billiards", 1), Pair("Paintball", 1), Pair("Karting", 1), Pair("Laser Tag", 1), Pair("Football", 1)), clubs=listOf(
    ClubDto(
      id="da91f7b8-5a88-4445-82af-a5867b5ba5e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klimzaal Blok🧗", address="IJskelderstraat 12/1, 2660 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.1804028, longitude=4.3499687,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/34199867-770f-416b-9b8d-4ca51a81f1f4_ChIJt6tkRfjz_0.jpg",
      averageRating=4.6, totalRatingsCount=715,
      createdAt="2026-08-30T22:37:33.501221Z", updatedAt="2026-08-30T22:37:33.501221Z",
    ),
    ClubDto(
      id="9888d194-fb42-4350-88bd-60f20854923c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klimzaal Wallstreet", address="Van Duyststraat 16, 2100 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.2313443, longitude=4.4435169,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c685bec-05a3-4f86-9317-aa75246dfc59_ChIJm2x_Tb33_0.jpg",
      averageRating=4.6, totalRatingsCount=567,
      createdAt="2026-08-30T22:37:39.912022Z", updatedAt="2026-08-31T08:31:24.564855Z",
    ),
    ClubDto(
      id="def9e7da-a176-48db-9162-1c919a7d3861", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laser Alliance", address="Hessenplein 2, 2000 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.2266995, longitude=4.4092425,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cdbb13f3-32ba-4fe9-ab02-c18c803dae08_ChIJpUkvLnT3_0.jpg",
      averageRating=4.6, totalRatingsCount=157,
      createdAt="2026-08-30T22:37:52.454718Z", updatedAt="2026-08-30T22:37:52.454718Z",
    ),
    ClubDto(
      id="e52d4e1d-e1d2-4bd3-9c0a-0abe0311abcc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Antwerp Padelclub", address="Filip Williotstraat 1, 2600 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.1856644, longitude=4.4358363,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a5a1bc0e-30f3-4252-90ce-366dd7805f2d_ChIJbdGRFTb3_0.jpg",
      averageRating=4.5, totalRatingsCount=296,
      createdAt="2026-08-30T22:38:06.367145Z", updatedAt="2026-09-01T14:32:03.501940Z",
    ),
    ClubDto(
      id="91f56a69-6e43-4431-b06b-156fa7be0928", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="COSTA TESLA Beach Club", address="Lerenveld 35 B, 2547 Lint",
      city="Antwerp", country="BE",
      latitude=51.1297589, longitude=4.5125313,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2a04250f-3698-4842-b8f6-ccd13c6d2a44_photo.jpg",
      averageRating=4.4, totalRatingsCount=54,
      createdAt="2026-08-31T15:48:14.381751Z", updatedAt="2026-08-31T15:48:14.381751Z",
    ),
    ClubDto(
      id="5688315e-399d-4cd8-a9f0-268c9cc7a7cf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Experience Factory Antwerp | Karting, Time Mission, Bijlwerpen, Arcades, Karaoke & veel meer", address="Michiganstraat 1, 2030 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.2530015, longitude=4.4195599,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5bffcadd-5942-4517-a888-b808e32a6d06_ChIJxeTQk7f3_0.jpg",
      averageRating=4.4, totalRatingsCount=594,
      createdAt="2026-08-30T22:37:12.661324Z", updatedAt="2026-08-31T08:27:40.904511Z",
    ),
    ClubDto(
      id="86af3386-3d02-4169-aed1-22e6601fe281", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportcentrum Wilrijkse Plein - Antwerpen", address="Vogelzanglaan 6, 2020 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.1886593, longitude=4.397569,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c8e9aa60-f731-4be0-a0af-0c3d78f211ba_ChIJaS3TNs72_0.jpg",
      averageRating=4.4, totalRatingsCount=573,
      createdAt="2026-08-30T22:36:59.923803Z", updatedAt="2026-08-31T08:36:28.095301Z",
    ),
    ClubDto(
      id="5d775139-6ac5-4b72-bb2d-295948181d43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Indoorkarting Antwerpen", address="Noorderlaan 95, 2030 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.259518, longitude=4.4186316,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7dabea57-5c13-4498-baad-305bd1d4268b_ChIJD7_tMyv2_0.jpg",
      averageRating=4.3, totalRatingsCount=788,
      createdAt="2026-08-30T22:37:46.278884Z", updatedAt="2026-08-31T08:31:04.128149Z",
    ),
    ClubDto(
      id="fc6d2fec-2ad6-440c-b5bd-ff5e8a225d57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TC Ruggeveld", address="Ter Rivierenhof, 2100 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.215389, longitude=4.4796874,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4600f0b7-3545-41f6-aee2-31f97add6648_ChIJU1uHdiX4_0.jpg",
      averageRating=4.3, totalRatingsCount=151,
      createdAt="2026-08-30T22:38:20.833363Z", updatedAt="2026-08-31T08:37:08.857438Z",
    ),
    ClubDto(
      id="83e98de4-0fee-4f04-b7cb-5b3291b77585", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketbalclub Olicsa Antwerpen 🏀", address="Begijnenstraat 53/67, 2000 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.2129564, longitude=4.4013323,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e2ae1596-ec26-46e9-b642-0e91254e4422_photo.jpg",
      averageRating=4.2, totalRatingsCount=52,
      createdAt="2026-08-31T15:47:26.829320Z", updatedAt="2026-08-31T15:47:26.829320Z",
    ),
    ClubDto(
      id="4f0fcf14-e469-4a04-8dbf-758ea9e66525", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling Stones", address="Noorderlaan 104A, 2030 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.2497886, longitude=4.4210475,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f457fbf5-56c8-4f39-b4a0-b251765b0089_ChIJ49_vMDP2_0.jpg",
      averageRating=4.2, totalRatingsCount=1147,
      createdAt="2026-08-30T22:37:26.860956Z", updatedAt="2026-08-31T08:26:32.089977Z",
    ),
    ClubDto(
      id="d14bfdab-a823-43f8-9f26-f7f88d3306a9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis 7e Olympiade | Tennis & Padel 🎾", address="Julius de Geyterstraat 133, 2020 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.1839523, longitude=4.3793331,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2d931874-8f9e-4de1-b5ce-8897c2cbb6a5_ChIJ46LmfbP2_0.jpg",
      averageRating=4.2, totalRatingsCount=173,
      createdAt="2026-08-30T22:38:13.705016Z", updatedAt="2026-09-01T14:31:59.576897Z",
    ),
    ClubDto(
      id="0ef822c6-a1f1-4f6a-a7f7-05a2f0f63803", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Antwerp Amusement Center (Antwerp Bowling)", address="Blancefloerlaan 181/B, 2050 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.2185836, longitude=4.3692106,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49fcd7ca-7023-42b3-9798-2d5b07d50a9f_ChIJLxwwgIH2_0.jpg",
      averageRating=4.1, totalRatingsCount=1418,
      createdAt="2026-08-30T22:37:19.133829Z", updatedAt="2026-08-31T08:24:59.196925Z",
    ),
    ClubDto(
      id="f0a98aae-1ef9-40a6-8a04-a4f38aefb8c3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports complex", address="Emiel Vloorsstraat 2, 2020 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.194447, longitude=4.3787974,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/30f26964-9275-440b-81f0-09e67136c9c9_photo.jpg",
      averageRating=4.0, totalRatingsCount=191,
      createdAt="2026-08-31T15:47:58.383963Z", updatedAt="2026-08-31T15:47:58.383963Z",
    ),
    ClubDto(
      id="feee3cf8-dfe7-44ec-b811-0c730d38fa64", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports Hall Plantin Moretus - Borgerhout", address="Plantin en Moretuslei 343, 2140 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.2097015, longitude=4.4399838,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/29de45bf-b846-4416-acd0-0c055f5a1e17_photo.jpg",
      averageRating=4.3, totalRatingsCount=46,
      createdAt="2026-08-31T15:47:45.713681Z", updatedAt="2026-08-31T15:47:45.713681Z",
    ),
    ClubDto(
      id="eea25723-2729-4123-8b1c-d0a02b3f31c0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gellyball", address="Viaduct-Dam 35, 2060 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.2332304, longitude=4.4234396,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/995554fd-7613-44d7-b003-7e47f941b1e2_ChIJ006htl8H_0.jpg",
      averageRating=4.9, totalRatingsCount=34,
      createdAt="2026-08-30T22:37:59.322543Z", updatedAt="2026-08-31T08:28:35.810566Z",
    ),
    ClubDto(
      id="99a8d60a-ccf3-47ca-97f8-a2e802bb05c6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beach Volley Europe", address="@ Circle Park, Rue Dante 22, 1070 Anderlecht",
      city="Antwerp", country="BE",
      latitude=50.8317557, longitude=4.319784,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1317848e-e111-4687-a3ea-9505348d38a6_photo.jpg",
      averageRating=4.5, totalRatingsCount=27,
      createdAt="2026-08-31T15:48:07.994415Z", updatedAt="2026-08-31T15:48:07.994415Z",
    ),
    ClubDto(
      id="c8fca3a9-6e45-43e6-87e0-3d24ba1f478d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sporthal Kiel 2 - Antwerpen", address="August Leyweg 2, 2020 Antwerpen",
      city="Antwerp", country="BE",
      latitude=51.1947201, longitude=4.3788144,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ab592d8a-2cb9-4598-94d5-46efb66446b3_photo.jpg",
      averageRating=4.1, totalRatingsCount=24,
      createdAt="2026-08-31T15:47:52.531557Z", updatedAt="2026-08-31T15:47:52.531557Z",
    ),
    ClubDto(
      id="d688a317-34af-4af8-9381-39d62c8a0a1b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Basketbalplein Sint-jansvliet 🏀", address="2000 Antwerp",
      city="Antwerp", country="BE",
      latitude=51.2185865, longitude=4.3964066,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7e60c29-7397-47ff-8822-5d7bdfc8f253_photo.jpg",
      averageRating=4.5, totalRatingsCount=15,
      createdAt="2026-08-31T15:47:39.170775Z", updatedAt="2026-08-31T15:47:39.170775Z",
    ),
  )),
  CitySeo(slug="zaragoza", name="Zaragoza", country="ES", clubCount=19, sports=listOf(Pair("Volleyball", 4), Pair("Football", 3), Pair("Climbing", 2), Pair("Golf", 2), Pair("Paintball", 2), Pair("Karting", 2), Pair("Tennis", 2), Pair("Padel", 1), Pair("Basketball", 1)), clubs=listOf(
    ClubDto(
      id="91af798c-266f-46b8-8804-b81b006bfca0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bulderland Centro de Escalada", address="Av. de Navarra, 22, 50010 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6551634, longitude=-0.9034089,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b16742bd-eb93-4e2a-85ca-d1f4c81a325b_photo.jpg",
      averageRating=4.8, totalRatingsCount=831,
      createdAt="2026-08-31T22:48:42.498390Z", updatedAt="2026-08-31T22:48:42.498390Z",
    ),
    ClubDto(
      id="9bd3ef50-a79d-4a47-9889-f141083c744e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting Mozota", address="Barranco de Viñas, s/n, 50440 Mozota, Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.4900218, longitude=-1.057071,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b765f1dc-47e9-4e7e-a8e6-c467b659b58d_photo.jpg",
      averageRating=4.6, totalRatingsCount=197,
      createdAt="2026-08-31T22:49:00.690350Z", updatedAt="2026-08-31T22:49:00.690350Z",
    ),
    ClubDto(
      id="b72a2fa5-3f69-457f-a8b4-7ee87235b797", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintballmania Zaragoza", address="Cam. del Río, 50430 María de Huerva, Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.5372614, longitude=-0.9919709,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0f64c0d3-a222-4e8a-92f5-f9da97cb5ebd_photo.jpg",
      averageRating=4.6, totalRatingsCount=307,
      createdAt="2026-08-31T22:48:55.919584Z", updatedAt="2026-08-31T22:48:55.919584Z",
    ),
    ClubDto(
      id="ee626d4e-81ca-4ab8-8413-64bfbe0e42d7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Real Club de Golf La Peñaza", address="N-II, km308, 50197 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.625395, longitude=-1.030606,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d9a0a0d4-99ae-453e-a3e3-e3b34d2ac3ab_photo.jpg",
      averageRating=4.6, totalRatingsCount=541,
      createdAt="2026-08-31T22:48:19.168649Z", updatedAt="2026-08-31T22:48:19.168649Z",
    ),
    ClubDto(
      id="5ad7bcc7-2331-47c6-98ae-2560b411bd84", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Pádel Zaragoza", address="C. de San Juan Bautista de la Salle, 1, Casablanca, 50012 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6328457, longitude=-0.9272858,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/021b09d3-9928-44f0-b7d9-3a5a89ec9526_photo.jpg",
      averageRating=4.5, totalRatingsCount=716,
      createdAt="2026-08-31T22:47:53.412225Z", updatedAt="2026-08-31T22:47:53.412225Z",
    ),
    ClubDto(
      id="4918e48c-c0bc-4944-b87b-14f1bdc9d703", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting la Torre", address="Camino San Antonio Cartuja Ba, 20, 50013 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6227654, longitude=-0.8519629,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/156a9b6e-d478-4f2d-96e6-7715c0a1782c_photo.jpg",
      averageRating=4.5, totalRatingsCount=309,
      createdAt="2026-08-31T22:48:34.060049Z", updatedAt="2026-08-31T22:48:34.060049Z",
    ),
    ClubDto(
      id="43f9c16c-f762-4740-a637-b6a90650ab71", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Prince Philip Hall", address="Av. de Cesáreo Alierta, 120, San José, 50013 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6354463, longitude=-0.8658883,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/673f9d5a-4468-40ab-86f3-1c9c01f283d3_photo.jpg",
      averageRating=4.5, totalRatingsCount=6097,
      createdAt="2026-08-31T22:47:57.081616Z", updatedAt="2026-08-31T22:47:57.081616Z",
    ),
    ClubDto(
      id="c4a48511-6ebb-4b73-99c0-aea78ad4aa72", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Zuera International Circuit", address="Carretera N-330, Km 521, 50800 Zuera, Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.8285484, longitude=-0.8122507,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0fdefdab-d390-4865-a2da-52720d6b6b9b_photo.jpg",
      averageRating=4.5, totalRatingsCount=1942,
      createdAt="2026-08-31T22:48:28.792506Z", updatedAt="2026-08-31T22:48:28.792506Z",
    ),
    ClubDto(
      id="bc434a22-6cfc-40ed-9b81-e6a8baf6ddf3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CDM Siglo XXI", address="C. de Luis Legaz Lacambra, 35, 50018 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6754371, longitude=-0.8973053,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/64e94763-c7ed-48b2-89f2-b8a9115d01f6_photo.jpg",
      averageRating=4.4, totalRatingsCount=2365,
      createdAt="2026-08-31T22:48:01.494696Z", updatedAt="2026-08-31T22:48:01.494696Z",
    ),
    ClubDto(
      id="a25e758d-ddb5-4baa-91ef-7f99372b6360", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fútbol Indoor Zaragoza", address="Carretera Valencia, KM 7.5, 50410 Cuarte de Huerva, Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.597369, longitude=-0.937898,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fe8a15ec-1eaf-4e10-9398-1fcacb95ed4b_photo.jpg",
      averageRating=4.4, totalRatingsCount=383,
      createdAt="2026-08-31T22:48:10.447223Z", updatedAt="2026-08-31T22:48:10.447223Z",
    ),
    ClubDto(
      id="11746d93-6dfa-4c33-aabd-23513d08b1e5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Golf Los Lagos", address="Camino de Vinales, s/n, 50298 Pinseque, Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.7290747, longitude=-1.0705129,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/08d6198d-f936-4851-9ea8-fcc5f4161cba_photo.jpg",
      averageRating=4.4, totalRatingsCount=440,
      createdAt="2026-08-31T22:48:23.715754Z", updatedAt="2026-08-31T22:48:23.715754Z",
    ),
    ClubDto(
      id="ab9ab4b0-5eb6-4473-9cfa-df3b7353fb58", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Stadium Venecia", address="C. de Fray Julián Garcés, 100, 50007 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6253204, longitude=-0.8895969,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d8f289db-6378-4b6e-bf65-76f5417b723c_photo.jpg",
      averageRating=4.2, totalRatingsCount=1054,
      createdAt="2026-08-31T22:47:46.369571Z", updatedAt="2026-09-01T14:31:43.192658Z",
    ),
    ClubDto(
      id="ee560d77-8de7-4284-a6af-f059a145642d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climbat Zaragoza", address="C. de Pikolin, 50011 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6754462, longitude=-0.9522764,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/23f2fa83-3795-48c5-aef7-969f961967d6_photo.jpg",
      averageRating=4.1, totalRatingsCount=313,
      createdAt="2026-08-31T22:48:51.401036Z", updatedAt="2026-08-31T22:48:51.401036Z",
    ),
    ClubDto(
      id="b1323c97-396b-4489-8b7c-df7196be57c7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Soccerworld Sports Zaragoza", address="P.º de la Noria, 8, 50018 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6734582, longitude=-0.9006669,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9ffd9825-f75b-438f-a581-d44421c8b696_photo.jpg",
      averageRating=4.1, totalRatingsCount=1064,
      createdAt="2026-08-31T22:47:27.226597Z", updatedAt="2026-08-31T22:47:27.226597Z",
    ),
    ClubDto(
      id="55b69951-ddf3-4033-9fbc-c8e1daced79c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="C. F. Atlético Escalerillas", address="C. de los Lagos de Millares, 50, 50011 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6490885, longitude=-0.9258493,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7b7f187-fde8-4076-872b-1ea049dfac32_photo.jpg",
      averageRating=4.0, totalRatingsCount=533,
      createdAt="2026-08-31T22:47:36.914100Z", updatedAt="2026-08-31T22:47:36.914100Z",
    ),
    ClubDto(
      id="12acdf33-3eba-452c-a975-17769917d9ff", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Centro Deportivo Municipal La Almozara", address="Av. de la Almozara, 65, 50003 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6631427, longitude=-0.8994849,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6e4d140f-83fb-40b3-9df0-73e620d3e39d_photo.jpg",
      averageRating=4.0, totalRatingsCount=527,
      createdAt="2026-08-31T22:48:05.936087Z", updatedAt="2026-08-31T22:48:05.936087Z",
    ),
    ClubDto(
      id="a79a0277-6f52-42cf-954d-8a2d820cb61b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ciudad Deportiva del Real Zaragoza", address="Código postal*, C. Valencia, Km. 8, 50012 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.595124, longitude=-0.9494249,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b5966ab-03a6-49fd-a51b-604ad4fcd3b5_photo.jpg",
      averageRating=3.7, totalRatingsCount=641,
      createdAt="2026-08-31T22:47:31.262167Z", updatedAt="2026-08-31T22:47:31.262167Z",
    ),
    ClubDto(
      id="83a41ff5-2705-47bc-8419-6ae7edc9c4d2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Parque Deportivo Ebro", address="Parque Deportivo Ebro, Cam. de Monzalbarba, 318, 50011 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.6684081, longitude=-0.9225569,
      type="TENNIS",
      types=listOf("TENNIS", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/21f12732-de79-4d45-bac9-e73e5bb49012_photo.jpg",
      averageRating=3.7, totalRatingsCount=1182,
      createdAt="2026-08-31T22:47:42.207501Z", updatedAt="2026-09-01T14:31:51.287029Z",
    ),
    ClubDto(
      id="00754e2b-c09d-48f6-b472-4aaeb90ba0d4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Deportivo Beach Center Arena", address="Av. de la Diag., 3, 50197 Zaragoza",
      city="Zaragoza", country="ES",
      latitude=41.63225, longitude=-0.9911416,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/002a9d29-d8a5-40fb-af12-23840ae555de_photo.jpg",
      averageRating=4.6, totalRatingsCount=16,
      createdAt="2026-08-31T22:48:14.571290Z", updatedAt="2026-08-31T22:48:14.571290Z",
    ),
  )),
  CitySeo(slug="cherkasy", name="Cherkasy", country="UA", clubCount=18, sports=listOf(Pair("Football", 4), Pair("Billiards", 2), Pair("Climbing", 2), Pair("Bowling", 2), Pair("Basketball", 2), Pair("Karting", 2), Pair("Laser Tag", 1), Pair("Table Tennis", 1), Pair("Paintball", 1), Pair("Tennis", 1)), clubs=listOf(
    ClubDto(
      id="7c2fca58-290d-4934-afa5-cd9ff22c5c7e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GRIZZLY MMA ACADEMY", address="вулиця Благовісна, 170, Черкаси, Черкаська область, 18000",
      city="Cherkasy", country="UA",
      latitude=49.4383856, longitude=32.0567418,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/944d24e6-4e1a-4ce1-a447-62a48915a545_photo.jpg",
      averageRating=4.9, totalRatingsCount=220,
      createdAt="2026-08-31T16:02:59.548954Z", updatedAt="2026-08-31T16:02:59.548954Z",
    ),
    ClubDto(
      id="0f4281fa-9565-4b3a-ae63-afceae47edf8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг-Пейнтбол клуб Черкаси", address="5/1, проспект Перемоги, Черкаси, 18029 Cherkasy, Ukraine",
      city="Cherkasy", country="UA",
      latitude=49.4232572, longitude=32.0141272,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/43d569c2-e1c5-403b-a545-81e304ab0d11_ChIJe3-w5A1M_0.jpg",
      averageRating=4.8, totalRatingsCount=839,
      createdAt="2026-08-30T17:31:30.829862Z", updatedAt="2026-08-30T20:52:33.341143Z",
    ),
    ClubDto(
      id="3c48617f-ef81-4545-b16d-a845bfdbbabc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спеціалізована дитячо-юнацька спортивна школа олімпійського резерву", address="вулиця Пастерівська, 102, Черкаси, Черкаська, 18000 Cherkasy, Ukraine",
      city="Cherkasy", country="UA",
      latitude=49.4258277, longitude=32.0634465,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/48a6be8f-1968-4a68-8ea3-c69c6b1afe1f_ChIJYbBTRplL_0.jpg",
      averageRating=4.7, totalRatingsCount=121,
      createdAt="2026-08-30T17:30:59.748712Z", updatedAt="2026-09-01T14:31:51.929665Z",
    ),
    ClubDto(
      id="0143a85c-2c88-4b30-bf55-628d9b827e27", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="7 луза", address="Центральний ринок, вулиця Гоголя, 287, Черкаси, Черкаська область, 18000",
      city="Cherkasy", country="UA",
      latitude=49.4387588, longitude=32.0648536,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/38436afd-2455-45cb-b9c2-04c419c81a17_photo.jpg",
      averageRating=4.5, totalRatingsCount=130,
      createdAt="2026-08-31T16:03:12.716252Z", updatedAt="2026-08-31T16:03:12.716252Z",
    ),
    ClubDto(
      id="5c0d8d8c-3eca-4f67-9e0a-bd9aeeaaeae2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг-клуб Черкаси", address="вулиця Смілянська, 132/3, Черкаси, 18000 Cherkasy, Ukraine",
      city="Cherkasy", country="UA",
      latitude=49.4137649, longitude=32.0270115,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/be9ca36f-44a7-4a70-896c-0d8a33c5b8ff_ChIJDc6vaxNL_0.jpg",
      averageRating=4.5, totalRatingsCount=552,
      createdAt="2026-08-30T17:31:38.414537Z", updatedAt="2026-08-30T20:52:33.470426Z",
    ),
    ClubDto(
      id="89b1cdee-8551-400d-aefd-c5fbf9a2bdeb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Манеж", address="вулиця Максима Залізняка, 146, Черкаси, 18006 Cherkasy, Ukraine",
      city="Cherkasy", country="UA",
      latitude=49.4142269, longitude=32.0433488,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d1344454-9f77-43d9-953a-79a0f704f0d7_ChIJg28lN-5L_2.jpg",
      averageRating=4.5, totalRatingsCount=107,
      createdAt="2026-08-30T17:31:07.070158Z", updatedAt="2026-08-31T22:11:25.964807Z",
    ),
    ClubDto(
      id="26fbd189-b5e8-4cdf-a05f-de1a484866c8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Палац Спорту", address="проспект Хіміків, 50/1, Черкаси, 18000 Cherkasy, Ukraine",
      city="Cherkasy", country="UA",
      latitude=49.4053404, longitude=32.0477769,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9bad5468-10c8-4dbc-91d1-8ea87d4b0d4e_ChIJdRQHk-dL_0.jpg",
      averageRating=4.5, totalRatingsCount=1021,
      createdAt="2026-08-30T17:30:51.898606Z", updatedAt="2026-08-30T20:52:41.530216Z",
    ),
    ClubDto(
      id="16606b09-8766-4094-be2e-d702e6a8726e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beast Gym", address="вулиця Михайла Грушевського, 110, Черкаси, Черкаська область, 18000",
      city="Cherkasy", country="UA",
      latitude=49.4469666, longitude=32.0508936,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/36481f84-7c7f-487b-ae6b-089fbe7b909b_photo.jpg",
      averageRating=4.9, totalRatingsCount=45,
      createdAt="2026-08-31T16:02:52.872450Z", updatedAt="2026-08-31T16:02:52.872450Z",
    ),
    ClubDto(
      id="6ad3118b-6e8c-42bb-9d29-ddc2b780c634", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Megazone", address="вулиця Героїв Дніпра, 23, Черкаси, 18021 Cherkasy, Ukraine",
      city="Cherkasy", country="UA",
      latitude=49.437054, longitude=32.09149,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bda7a922-9be3-461b-a677-7861a82e7ae7_ChIJS906Rw1L_0.jpg",
      averageRating=4.4, totalRatingsCount=123,
      createdAt="2026-08-30T17:31:45.867082Z", updatedAt="2026-08-30T20:52:18.767852Z",
    ),
    ClubDto(
      id="8a185785-022e-4d23-94a6-d5cfda07634d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="МСК \"Дніпро\"", address="Черкаси, 18000 Cherkasy, Ukraine",
      city="Cherkasy", country="UA",
      latitude=49.4359849, longitude=32.0546615,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d3122733-360b-4c49-ab26-8c5555e55a2d_ChIJPT6XqIFL_0.jpg",
      averageRating=4.4, totalRatingsCount=1170,
      createdAt="2026-08-30T17:30:44.128126Z", updatedAt="2026-08-30T20:52:38.913200Z",
    ),
    ClubDto(
      id="3679e38f-bc06-46f2-9c5a-582c57349153", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lucky Strike", address="ТРЦ \"Lubava\", 4 поверх 208/1, бульвар Шевченка, Cherkasy, Cherkas'ka oblast, 18000",
      city="Cherkasy", country="UA",
      latitude=49.444815, longitude=32.056425,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/70eb22ef-b155-4674-8f6f-07973fa822b5_photo.jpg",
      averageRating=4.3, totalRatingsCount=1173,
      createdAt="2026-08-31T16:02:47.118705Z", updatedAt="2026-08-31T22:11:18.734863Z",
    ),
    ClubDto(
      id="48db0953-b954-4c0a-a598-a31b30cfa7f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Космос Боулінг", address="вулиця Припортова, 34Б, Черкаси, Черкаська область, 18009",
      city="Cherkasy", country="UA",
      latitude=49.4341218, longitude=32.0912508,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cb098247-6d22-4503-a90c-c44c8442ca29_photo.jpg",
      averageRating=4.3, totalRatingsCount=1720,
      createdAt="2026-08-31T16:02:40.301038Z", updatedAt="2026-08-31T16:02:40.301038Z",
    ),
    ClubDto(
      id="02538342-69c4-429d-8f29-6787be132c4b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sport Life", address="вулиця Ярославська, 7/1, Черкаси, Черкаська область, 18029",
      city="Cherkasy", country="UA",
      latitude=49.4354514, longitude=32.0115547,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e11f6334-34e8-4477-9f30-ec34eb5d74bf_photo.jpg",
      averageRating=4.2, totalRatingsCount=580,
      createdAt="2026-08-31T16:02:15.032835Z", updatedAt="2026-08-31T16:02:15.032835Z",
    ),
    ClubDto(
      id="1a7702b9-2908-42c6-9ef3-a7828b43ea06", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Бункер", address="ТРЦ \"Хрещатик Сіті\", -минус, вулиця Остафія Дашковича, 19, 3 поверх, Cherkasy, Cherkas'ka oblast, 18000",
      city="Cherkasy", country="UA",
      latitude=49.4449748, longitude=32.0650723,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/051ae4d0-f5bc-441e-a514-01900cf35208_photo.jpg",
      averageRating=4.2, totalRatingsCount=354,
      createdAt="2026-08-31T16:03:05.783356Z", updatedAt="2026-08-31T16:03:05.783356Z",
    ),
    ClubDto(
      id="0555f2ef-8691-45fd-a031-4e864a8f1804", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спортохота", address="вулиця Берегова, Черкаси, 18000 Cherkasy, Ukraine",
      city="Cherkasy", country="UA",
      latitude=49.409504, longitude=32.128461,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8f986fc5-72eb-4a21-b3e0-43062c9a2719_ChIJExNUIVpK_0.jpg",
      averageRating=4.1, totalRatingsCount=1765,
      createdAt="2026-08-30T17:31:53.928362Z", updatedAt="2026-08-30T20:52:48.624191Z",
    ),
    ClubDto(
      id="4155db67-6778-400c-ab0a-0970992616f3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісні корти Sett Hall | Оренда тенісних кортів", address="вул. Князя Ольгерда, 5, Черкаси, 18000 Cherkasy, Ukraine",
      city="Cherkasy", country="UA",
      latitude=49.4609278, longitude=32.0470358,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/37760d43-0389-4d36-9615-a7c2d6c2ab6c_ChIJY6boCwBN_0.jpg",
      averageRating=5.0, totalRatingsCount=25,
      createdAt="2026-08-30T17:32:01.829549Z", updatedAt="2026-08-30T20:52:52.276402Z",
    ),
    ClubDto(
      id="b0cd63b5-2c6a-42a2-a37e-3f61efd74aa4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="pingpong777", address="Сержанта Жужомы 7, офис №4, Cherkasy, Cherkas'ka oblast, 18021",
      city="Cherkasy", country="UA",
      latitude=49.4486476, longitude=32.0742349,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b59cb24-7f8e-4a37-b22e-3b2cbfff9a1d_photo.jpg",
      averageRating=4.6, totalRatingsCount=10,
      createdAt="2026-08-31T16:02:34.312402Z", updatedAt="2026-08-31T16:02:34.312402Z",
    ),
    ClubDto(
      id="af70a103-bc1e-4f1b-9da6-f6d6aa07a2b8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Комплексна дитячо-юнацька спортивна школа №1", address="вулиця Смілянська, 94, Черкаси, Черкаська область, 18000",
      city="Cherkasy", country="UA",
      latitude=49.4287335, longitude=32.047298,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/86e75272-d161-4b1b-b086-78703bb0ada7_photo.jpg",
      averageRating=5.0, totalRatingsCount=6,
      createdAt="2026-08-31T16:02:20.944309Z", updatedAt="2026-08-31T16:02:20.944309Z",
    ),
  )),
  CitySeo(slug="basel", name="Basel", country="CH", clubCount=18, sports=listOf(Pair("Tennis", 3), Pair("Padel", 3), Pair("Climbing", 2), Pair("Volleyball", 2), Pair("Bowling", 2), Pair("Basketball", 2), Pair("Billiards", 1), Pair("Golf", 1), Pair("Karting", 1), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="25695e5e-56a4-45ca-87c2-c6bc70b99658", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="B2 - Boulders & Bar", address="Hardstrasse 46, 4133 Pratteln",
      city="Basel", country="CH",
      latitude=47.526021, longitude=7.6836721,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/86e934f2-1a66-4fb0-90d1-4fdf8891ca04_photo.jpg",
      averageRating=4.8, totalRatingsCount=540,
      createdAt="2026-09-01T00:05:35.061649Z", updatedAt="2026-09-01T00:05:35.061649Z",
    ),
    ClubDto(
      id="e29ab6d1-8766-4b2a-ad5b-953537385124", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Play Padel Pratteln", address="Lohagstrasse 16, 4133 Pratteln",
      city="Basel", country="CH",
      latitude=47.531698, longitude=7.7024778,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c2e5354-e48d-4199-8bbf-290aff0ef8a9_photo.jpg",
      averageRating=4.8, totalRatingsCount=77,
      createdAt="2026-09-01T00:04:00.186007Z", updatedAt="2026-09-01T00:04:00.186007Z",
    ),
    ClubDto(
      id="02e48d32-a6ab-467b-88f2-ae06b00b52d0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ELYS Boulderloft", address="Elsässerstrasse 215a, 4056 Basel",
      city="Basel", country="CH",
      latitude=47.5745146, longitude=7.5738665,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/aaea832d-ed17-4531-90a7-6572e85a08a5_photo.jpg",
      averageRating=4.7, totalRatingsCount=487,
      createdAt="2026-09-01T00:05:41.514305Z", updatedAt="2026-09-01T00:05:41.514305Z",
    ),
    ClubDto(
      id="191f40bc-75bb-420e-87d3-cb7adb5b5111", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kartbahn Basel", address="Gartenstrasse 149, 4052 Basel",
      city="Basel", country="CH",
      latitude=47.5468444, longitude=7.5921698,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/55778a39-4ba3-4f3a-bac1-8c68d407c76d_photo.jpg",
      averageRating=4.7, totalRatingsCount=138,
      createdAt="2026-09-01T00:04:57.069224Z", updatedAt="2026-09-01T00:04:57.069224Z",
    ),
    ClubDto(
      id="459d2cb8-27fa-4777-ac2b-ba03222357e6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billard-Saloon", address="Steinentorstrasse 35, 4051 Basel",
      city="Basel", country="CH",
      latitude=47.5511551, longitude=7.5882959,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c982be24-fecd-425b-862d-d3a90e03c115_photo.jpg",
      averageRating=4.4, totalRatingsCount=318,
      createdAt="2026-09-01T00:05:48.604900Z", updatedAt="2026-09-01T00:05:48.604900Z",
    ),
    ClubDto(
      id="3c4254b6-04c9-4690-9816-33d153b820c2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Freizeithalle Dreirosen", address="Unterer Rheinweg 168, 4057 Basel",
      city="Basel", country="CH",
      latitude=47.5705429, longitude=7.5870329,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/edd7812c-c744-402a-84cd-097207c4abb3_photo.jpg",
      averageRating=4.4, totalRatingsCount=268,
      createdAt="2026-09-01T00:03:38.839876Z", updatedAt="2026-09-01T00:03:38.839876Z",
    ),
    ClubDto(
      id="d42a2f39-9469-4d6a-95ab-a92befa192ae", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Arena Luzern", address="Rüeggisingerstrasse 152, 6032 Emmen",
      city="Basel", country="CH",
      latitude=47.08788, longitude=8.2941933,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f63cfb00-d2e4-49a1-b1e6-914284c2dadb_photo.jpg",
      averageRating=4.4, totalRatingsCount=453,
      createdAt="2026-09-01T00:05:55.755179Z", updatedAt="2026-09-01T00:05:55.755179Z",
    ),
    ClubDto(
      id="c9f2ac0a-2b94-401c-bb91-8afac1b2ba7c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="St. Jakob-Park", address="St. Jakobs-Strasse 395, 4052 Basel",
      city="Basel", country="CH",
      latitude=47.5415894, longitude=7.6200756,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0a4dd855-ecd2-420c-8bd5-67dbc9bf2758_photo.jpg",
      averageRating=4.4, totalRatingsCount=8065,
      createdAt="2026-09-01T00:04:19.397261Z", updatedAt="2026-09-01T00:04:19.397261Z",
    ),
    ClubDto(
      id="194b7d8b-46ad-4482-872d-8878400789ef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="St. Jakobshalle", address="St. Jakobs-Strasse 390, 4052 Basel",
      city="Basel", country="CH",
      latitude=47.5400015, longitude=7.6183398,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49c2c4b7-2aa3-46c3-ab03-b0fc11182dbf_photo.jpg",
      averageRating=4.4, totalRatingsCount=3439,
      createdAt="2026-09-01T00:04:27.709890Z", updatedAt="2026-09-01T00:04:27.709890Z",
    ),
    ClubDto(
      id="5da71386-2bd6-4f07-ab99-2a55697d16d6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Social Padel Club", address="Binningerstrasse 106, 4123 Allschwil",
      city="Basel", country="CH",
      latitude=47.5470868, longitude=7.5499161,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/214dd5bc-4898-4e8c-a1dd-b6af4ce003d5_photo.jpg",
      averageRating=4.2, totalRatingsCount=57,
      createdAt="2026-09-01T00:04:06.222447Z", updatedAt="2026-09-01T00:04:06.222447Z",
    ),
    ClubDto(
      id="af925e4c-c069-4263-a2ae-6d42b813a281", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Diamond Bowl", address="160 Rue de Mulhouse, 68300 Saint-Louis, France",
      city="Basel", country="CH",
      latitude=47.602993, longitude=7.5452294,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6434d4b0-e663-4861-b646-08c09b261489_photo.jpg",
      averageRating=4.1, totalRatingsCount=499,
      createdAt="2026-09-01T00:05:13.868202Z", updatedAt="2026-09-01T00:05:13.868202Z",
    ),
    ClubDto(
      id="466a4a73-99a4-4057-9e88-3668fd9a3a22", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling by ARENA", address="Hochbergerstrasse 70, 4057 Basel",
      city="Basel", country="CH",
      latitude=47.5812746, longitude=7.5968615,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/469bdf52-e4f9-462a-ba14-6b3faba13c00_photo.jpg",
      averageRating=3.5, totalRatingsCount=299,
      createdAt="2026-09-01T00:05:25.335479Z", updatedAt="2026-09-01T00:05:25.335479Z",
    ),
    ClubDto(
      id="d2f64b19-9c2c-4363-9f53-618d67398571", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club Basler Lawn", address="Gundeldingerstrasse 1A, 4053 Basel",
      city="Basel", country="CH",
      latitude=47.5433349, longitude=7.5828318,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f6838d89-9d0c-4d83-855a-697140262216_photo.jpg",
      averageRating=4.7, totalRatingsCount=33,
      createdAt="2026-09-01T00:03:45.737870Z", updatedAt="2026-09-01T00:03:45.737870Z",
    ),
    ClubDto(
      id="b5a5faea-c5e9-48dc-992e-d180690c4680", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Beachvolley Uptown Basel", address="Kanalstrasse 1, 4144 Arlesheim",
      city="Basel", country="CH",
      latitude=47.4993805, longitude=7.6086793,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c9e8c4f6-a8ad-43ea-a238-6d9210d17bcb_photo.jpg",
      averageRating=4.7, totalRatingsCount=32,
      createdAt="2026-09-01T00:04:33.955656Z", updatedAt="2026-09-01T00:04:33.955656Z",
    ),
    ClubDto(
      id="7325e703-15dc-4a33-871b-dc7a4349c3b6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Basel Dreispitz", address="Lyon-Strasse 11, 4053 Basel",
      city="Basel", country="CH",
      latitude=47.5358321, longitude=7.6082916,
      type="PADEL",
      types=listOf("PADEL", "FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6072eecd-c80a-4f33-b68b-52d4a24db237_photo.jpg",
      averageRating=4.3, totalRatingsCount=34,
      createdAt="2026-09-01T00:04:12.654743Z", updatedAt="2026-09-01T14:31:53.553928Z",
    ),
    ClubDto(
      id="645b2884-f4a5-463a-8f87-502ff59026e5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club Allschwil", address="Hegenheimermattweg 104, 4123 Allschwil",
      city="Basel", country="CH",
      latitude=47.556448, longitude=7.5468603,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3eed4822-4eae-447b-a215-f6d6ca64e650_photo.jpg",
      averageRating=4.4, totalRatingsCount=30,
      createdAt="2026-09-01T00:03:54.135392Z", updatedAt="2026-09-01T00:03:54.135392Z",
    ),
    ClubDto(
      id="5b4a7656-b5ef-47e1-b08b-77c0ac12dd2c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City Golf Basel Bachgraben", address="Hegenheimermattweg 200, 4123 Allschwil",
      city="Basel", country="CH",
      latitude=47.5620605, longitude=7.5555459,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/81ed14ae-dc75-4d82-a121-766e6ec6b48c_photo.jpg",
      averageRating=4.2, totalRatingsCount=26,
      createdAt="2026-09-01T00:04:50.871075Z", updatedAt="2026-09-01T00:04:50.871075Z",
    ),
    ClubDto(
      id="effda9c6-0346-4f01-b809-a678ba3393bd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BTV Aarau Volleyball", address="Sekretariat, 5000 Aarau",
      city="Basel", country="CH",
      latitude=47.3963978, longitude=8.0571179,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/50f3e251-a64e-4a18-a851-4cab121965a2_photo.jpg",
      averageRating=4.2, totalRatingsCount=12,
      createdAt="2026-09-01T00:04:41.504916Z", updatedAt="2026-09-01T00:04:41.504916Z",
    ),
  )),
  CitySeo(slug="lutsk", name="Lutsk", country="UA", clubCount=17, sports=listOf(Pair("Football", 3), Pair("Karting", 2), Pair("Paintball", 2), Pair("Basketball", 2), Pair("Volleyball", 2), Pair("Laser Tag", 1), Pair("Bowling", 1), Pair("Climbing", 1), Pair("Table Tennis", 1), Pair("Tennis", 1), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="c2316808-1a76-4cd3-b596-3502781a52d0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="БAZA 43 Пейнтбол Страйкбол Лазертаг у Луцьку", address="вулиця Кравчука, 20, Луцьк, 43000 Lutsk, Ukraine",
      city="Lutsk", country="UA",
      latitude=50.7640465, longitude=25.3627982,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/01d4c2fd-5b1c-4558-80b6-7c920c1bb401_ChIJGbmPafCX_0.jpg",
      averageRating=5.0, totalRatingsCount=122,
      createdAt="2026-08-30T17:26:25.660729Z", updatedAt="2026-08-30T20:52:27.448562Z",
    ),
    ClubDto(
      id="be134f83-cb1d-484d-9013-486417ff85e7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбол Луцьк- Extreme Pro", address="вулиця Данила Галицького, 14, Луцьк, 43017 Lutsk, Ukraine",
      city="Lutsk", country="UA",
      latitude=50.7384288, longitude=25.3174176,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/079b835d-c782-4085-8284-38c908ae2f99_ChIJpbuW0H-Z_0.jpg",
      averageRating=5.0, totalRatingsCount=338,
      createdAt="2026-08-30T17:26:17.208823Z", updatedAt="2026-08-30T20:52:42.138672Z",
    ),
    ClubDto(
      id="03d9225d-f301-4e5a-85ba-779f42bec556", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Extreme Pro (Пейнтбол, лазертаг, пальоти, пароплани в Луцьку)", address="Зона відпочинку, Сирники, Волинська область, 45633",
      city="Lutsk", country="UA",
      latitude=50.8184911, longitude=25.2310022,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a56ba693-776b-4e8a-9d62-2119e3495327_photo.jpg",
      averageRating=4.9, totalRatingsCount=114,
      createdAt="2026-08-31T15:56:19.986033Z", updatedAt="2026-08-31T15:56:19.986033Z",
    ),
    ClubDto(
      id="5b4bd4e0-8086-4b46-866b-eb11bacfe45f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Клуб настільного тенісу «David club table tennis»", address="Берестейський просп., 38, Київ, 03057",
      city="Lutsk", country="UA",
      latitude=50.4536517, longitude=30.4547094,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6855bc72-d500-444d-8974-5832388b8cd8_photo.jpg",
      averageRating=4.6, totalRatingsCount=106,
      createdAt="2026-08-31T15:56:01.046100Z", updatedAt="2026-08-31T15:56:01.046100Z",
    ),
    ClubDto(
      id="33c7b829-e636-44c5-9e42-a8a3ab351177", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="РЦ «Промінь»", address="проспект Президента Грушевського, 2, Луцьк, 43000 Lutsk, Ukraine",
      city="Lutsk", country="UA",
      latitude=50.753532, longitude=25.3332049,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/269d7c45-4328-41ed-aed3-20e02855dc55_ChIJefc7TR-Z_0.jpg",
      averageRating=4.6, totalRatingsCount=1505,
      createdAt="2026-08-30T17:25:53.816562Z", updatedAt="2026-08-30T20:52:44.866477Z",
    ),
    ClubDto(
      id="ef877ebf-e01e-4d70-b59f-4106ac208dcd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Авангард", address="проспект Перемоги, 7а, Луцьк, 43000 Lutsk, Ukraine",
      city="Lutsk", country="UA",
      latitude=50.754098, longitude=25.3376067,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/64b76afb-205a-45a4-a0b8-b3b21d4ec57d_ChIJzxHHGeOZ_0.jpg",
      averageRating=4.4, totalRatingsCount=1057,
      createdAt="2026-08-30T17:25:17.363165Z", updatedAt="2026-08-30T20:52:26.270701Z",
    ),
    ClubDto(
      id="610a1e52-0738-4eed-b979-61fce897d4e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Драйв", address="Ковельська вулиця, 40, Луцьк, Волинська область, 43000",
      city="Lutsk", country="UA",
      latitude=50.746272, longitude=25.310965,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f88be5cc-8825-433d-8dc4-bfea80327940_photo.jpg",
      averageRating=4.4, totalRatingsCount=60,
      createdAt="2026-08-31T15:55:27.753854Z", updatedAt="2026-08-31T15:55:27.753854Z",
    ),
    ClubDto(
      id="00a770c7-d3d7-451f-90f8-fb281c889373", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спорткомплекс ЛНТУ", address="вулиця Львівська, 75, Луцьк, 43000 Lutsk, Ukraine",
      city="Lutsk", country="UA",
      latitude=50.724011, longitude=25.2983228,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3d8fab84-864b-447f-bf9e-66fb77ce9475_ChIJg_Ytbp-Z_2.jpg",
      averageRating=4.3, totalRatingsCount=544,
      createdAt="2026-08-30T17:25:24.849354Z", updatedAt="2026-08-31T22:11:26.836325Z",
    ),
    ClubDto(
      id="ac66f0c2-f96b-4039-bcf6-91f30d33661f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="George's Club", address="проспект Президента Грушевського, 2, Луцьк, 43000 Lutsk, Ukraine",
      city="Lutsk", country="UA",
      latitude=50.753532, longitude=25.3332049,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b2a860e7-e38c-430c-9324-777c5b222a13_ChIJGVhmkuOZ_0.jpg",
      averageRating=4.2, totalRatingsCount=713,
      createdAt="2026-08-30T17:26:00.626870Z", updatedAt="2026-08-30T20:52:14.138340Z",
    ),
    ClubDto(
      id="5d50d04f-4ad5-486e-9184-eb66416f7e24", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Генератор міста", address="2-й поверх, вулиця Сухомлинського, 1, Луцьк, Волинська область, 43000",
      city="Lutsk", country="UA",
      latitude=50.7553262, longitude=25.3560645,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/769542f8-1754-46a5-ab17-6225fe0c936f_photo.png",
      averageRating=4.2, totalRatingsCount=173,
      createdAt="2026-08-31T15:55:21.937575Z", updatedAt="2026-08-31T15:55:21.937575Z",
    ),
    ClubDto(
      id="2f361a36-929e-4a71-990a-a81f8bb7ff40", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Олімпія", address="вулиця Кравчука, 13, Луцьк, 43000 Lutsk, Ukraine",
      city="Lutsk", country="UA",
      latitude=50.7655314, longitude=25.3610242,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/09ae63d1-2af8-47d9-8a08-cf51b14c12f6_ChIJ50wI90uX_2.jpg",
      averageRating=4.2, totalRatingsCount=247,
      createdAt="2026-08-30T17:26:40.595005Z", updatedAt="2026-08-31T22:11:26.185448Z",
    ),
    ClubDto(
      id="5dfd6501-60ce-487b-a3b7-5471bd9284bb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Адреналін Сіті", address="вулиця Корсака Івана, 1, Луцьк, 43023 Lutsk, Ukraine",
      city="Lutsk", country="UA",
      latitude=50.7822828, longitude=25.3668169,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4b1a03a3-7264-4a2f-8950-3149cd5ba41a_ChIJL1sxCzCX_0.jpg",
      averageRating=4.1, totalRatingsCount=190,
      createdAt="2026-08-30T17:25:39.797513Z", updatedAt="2026-08-30T20:52:26.388152Z",
    ),
    ClubDto(
      id="c93fa7a3-87ec-48b0-98b1-14b72e83fd11", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Страйк Сіті", address="3-й поверх вулиця Сухомлинського, 1 ТРЦ Порт City, Луцьк, Волинська область, 43000",
      city="Lutsk", country="UA",
      latitude=50.7553314, longitude=25.3557096,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/279e7819-5bd2-40f9-9608-4d7a53fc99ed_photo.png",
      averageRating=3.8, totalRatingsCount=1450,
      createdAt="2026-08-31T15:55:42.506017Z", updatedAt="2026-08-31T15:55:42.506017Z",
    ),
    ClubDto(
      id="f6c1df8b-2b44-4b7b-9650-b665c9771322", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Кенгуру", address="вулиця Корсака Івана, 1, Луцьк, 43023 Lutsk, Ukraine",
      city="Lutsk", country="UA",
      latitude=50.7822917, longitude=25.3671698,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b0f9e61-e682-4aea-abca-416a54a47a0c_ChIJl1QSpDqX_0.jpg",
      averageRating=4.1, totalRatingsCount=21,
      createdAt="2026-08-30T17:26:08.251352Z", updatedAt="2026-08-30T20:52:33.988768Z",
    ),
    ClubDto(
      id="e2c9f272-4170-4d7e-b832-762c3b129816", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="DSU KARTING", address="Рівненська вулиця, 25 б, Луцьк, Волинська область, 43027",
      city="Lutsk", country="UA",
      latitude=50.7433361, longitude=25.3633007,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/42fcc558-109f-4eb2-ab67-e5e0fe845745_photo.jpg",
      averageRating=4.5, totalRatingsCount=16,
      createdAt="2026-08-31T15:56:07.317264Z", updatedAt="2026-08-31T15:56:07.317264Z",
    ),
    ClubDto(
      id="0a954596-cdff-498d-98c1-4ff068325e3d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Фітнес-клуб «CrossBee»", address="проспект Волі, 49а, Луцьк, Волинська область, 43000",
      city="Lutsk", country="UA",
      latitude=50.7439157, longitude=25.3500029,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/41395c12-f6f3-4700-b072-f7269d1a3394_photo.jpg",
      averageRating=4.7, totalRatingsCount=15,
      createdAt="2026-08-31T15:55:35.090173Z", updatedAt="2026-08-31T15:55:35.090173Z",
    ),
    ClubDto(
      id="61532b19-f058-48dd-b9d6-e8e3e7c72b16", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Волинь Карт", address="вулиця Писаревського, 15, Луцьк, Волинська область, 43000",
      city="Lutsk", country="UA",
      latitude=50.7584948, longitude=25.3850705,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5ef04701-e49d-462d-8621-aabd19d6d63b_photo.jpg",
      averageRating=4.3, totalRatingsCount=12,
      createdAt="2026-08-31T15:56:12.311307Z", updatedAt="2026-08-31T15:56:12.311307Z",
    ),
  )),
  CitySeo(slug="kryvyi-rih", name="Kryvyi Rih", country="UA", clubCount=17, sports=listOf(Pair("Football", 4), Pair("Bowling", 2), Pair("Padel", 2), Pair("Billiards", 2), Pair("Tennis", 2), Pair("Volleyball", 2), Pair("Basketball", 1), Pair("Climbing", 1), Pair("Laser Tag", 1)), clubs=listOf(
    ClubDto(
      id="ff575d83-ec29-447b-b8d7-41ccb4fd72ef", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SPORTFIT", address="вулиця Єдності, 6, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9133345, longitude=33.3358006,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b53b2c5-2ea8-4e56-b035-ef18756cff6a_ChIJ8wk3dErf_0.jpg",
      averageRating=4.7, totalRatingsCount=304,
      createdAt="2026-08-30T17:39:07.619386Z", updatedAt="2026-08-30T20:52:22.834359Z",
    ),
    ClubDto(
      id="99593b2b-5a0a-4b63-9f5a-a945beb03812", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Динаміт", address="вулиця Володимира Великого, 34а, Кривий Ріг, 50071 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9418663, longitude=33.4189819,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/210698fa-aadb-46e8-91b8-c66a802e4e0d_ChIJS8bWlXYg_1.jpg",
      averageRating=4.7, totalRatingsCount=321,
      createdAt="2026-08-30T17:39:00.467746Z", updatedAt="2026-08-31T22:11:25.099673Z",
    ),
    ClubDto(
      id="fc21972c-61fc-4638-9a25-5bf928e6962b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="СК \"КБ-75\"", address="вулиця Володимира Великого, 23, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9406608, longitude=33.4127751,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/489cc3a9-21e6-411d-a82a-6e24d48eee38_ChIJu8Iz7Hcg_0.jpg",
      averageRating=4.6, totalRatingsCount=472,
      createdAt="2026-08-30T17:37:51.760058Z", updatedAt="2026-08-30T20:52:45.231639Z",
    ),
    ClubDto(
      id="795f5e50-a078-4f85-8569-98111edec022", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тренувальна База ФК \"Кривбас\"", address="Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9577554, longitude=33.4067839,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/720655d4-9c53-40d3-8bde-a887df0da24d_ChIJH0VPI-zf_0.jpg",
      averageRating=4.6, totalRatingsCount=530,
      createdAt="2026-08-30T17:37:44.627808Z", updatedAt="2026-08-30T20:52:52.535878Z",
    ),
    ClubDto(
      id="7ee8bde8-cfb4-4aee-af94-d678c63a4001", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Золотий кубок", address="вулиця Рилєєва, 4 А, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.89064, longitude=33.3376303,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/90210051-9974-450f-81e8-e56398f08902_ChIJJ2__mKDY_0.jpg",
      averageRating=4.5, totalRatingsCount=264,
      createdAt="2026-08-30T17:39:22.881358Z", updatedAt="2026-08-30T20:52:32.083485Z",
    ),
    ClubDto(
      id="26326578-fdeb-424c-9a6a-30909900f3c5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Розважально-оздоровчий комплекс \"Юніон\"", address="вулиця Героїв АТО, 30Г, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9054859, longitude=33.3971057,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/64fe463b-6474-4cd0-b41c-8492120f57b9_ChIJp571L7kg_0.jpg",
      averageRating=4.5, totalRatingsCount=1427,
      createdAt="2026-08-30T17:38:44.296056Z", updatedAt="2026-08-30T20:52:44.991773Z",
    ),
    ClubDto(
      id="76e4cc69-77c8-4d62-99d0-85f5b39eaad4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="УТБ \"Гірник\"", address="вулиця Світлогірська, 1, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9592033, longitude=33.4087364,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/df33e0a8-0aab-4f54-b916-29763061d030_ChIJpQG_GY7f_0.jpg",
      averageRating=4.5, totalRatingsCount=157,
      createdAt="2026-08-30T17:38:09.836028Z", updatedAt="2026-08-30T20:52:52.658412Z",
    ),
    ClubDto(
      id="52a27666-9210-4423-abb4-4a8910bf4b96", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Форест", address="Ракетна вулиця, 2Б, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9054518, longitude=33.3365437,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/97d81e9c-0377-454a-a059-b6722fdb4765_ChIJ08C6x7PY_1.jpg",
      averageRating=4.5, totalRatingsCount=210,
      createdAt="2026-08-30T17:39:30.997254Z", updatedAt="2026-08-31T22:11:27.922947Z",
    ),
    ClubDto(
      id="ffad19e3-6da1-45bf-9f45-4ba4f6350a79", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Палац спорту", address="вул. Миколи Міхновського, 4А, Кривий Ріг, Дніпропетровська область, 50000",
      city="Kryvyi Rih", country="UA",
      latitude=47.6890661, longitude=33.1616522,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2e12f543-24d9-4a35-9ffa-96765fdc147b_photo.jpg",
      averageRating=4.4, totalRatingsCount=348,
      createdAt="2026-08-31T15:52:59.069481Z", updatedAt="2026-08-31T15:52:59.069481Z",
    ),
    ClubDto(
      id="5fa3f0c0-2247-4e8e-a2cc-b844f1565b31", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Палац спорту \"Молодість\"", address="вулиця Рекордна, 1, Кривий Ріг, Дніпропетровська область, 50000",
      city="Kryvyi Rih", country="UA",
      latitude=48.028161, longitude=33.4792113,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/62fae4a8-08ae-4248-b273-fec3f3fb9f26_photo.jpg",
      averageRating=4.4, totalRatingsCount=662,
      createdAt="2026-08-31T15:52:52.116399Z", updatedAt="2026-08-31T15:52:52.116399Z",
    ),
    ClubDto(
      id="65d92e49-f6d4-4c55-bef1-fb2d4011d247", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SF Spa&Padel", address="Гірничих Інженерів, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9070284, longitude=33.3534224,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/84f060e6-45d2-4f90-b59f-c623d74eeb5e_ChIJ1ZqdeA7f_0.jpg",
      averageRating=4.3, totalRatingsCount=64,
      createdAt="2026-08-30T17:39:15.196122Z", updatedAt="2026-08-30T20:52:22.443946Z",
    ),
    ClubDto(
      id="05c1834b-81eb-4dbc-b539-f9f12b0af6a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Атмосфера", address="вулиця Миколи Світальського, 1Г, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9712589, longitude=33.4461801,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6a761e7e-56ec-4641-abb9-4a1940ade0f5_ChIJ8QhZHQPg_0.jpg",
      averageRating=4.3, totalRatingsCount=999,
      createdAt="2026-08-30T17:38:19.103246Z", updatedAt="2026-08-30T20:52:27.328747Z",
    ),
    ClubDto(
      id="b3250e8b-27fd-4194-a938-ab62f1ccb406", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Золота кулька", address="вулиця Віталія Матусевича, 29, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9039684, longitude=33.4067339,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a1f485cb-f5fd-465f-a8dd-392fd42c83a6_ChIJEQ5zI8Eg_0.jpg",
      averageRating=4.3, totalRatingsCount=163,
      createdAt="2026-08-30T17:38:27.066532Z", updatedAt="2026-08-30T20:52:31.963653Z",
    ),
    ClubDto(
      id="e157e06b-1932-4679-8735-8405fd84910c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FUN PARK", address="вулиця Єсеніна, 16, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.9116104, longitude=33.3977513,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3be939f2-333f-469e-a427-aebc8dc7ec76_ChIJoWLjtLAh_1.jpg",
      averageRating=4.2, totalRatingsCount=2177,
      createdAt="2026-08-30T17:38:35.271130Z", updatedAt="2026-08-31T22:11:16.439144Z",
    ),
    ClubDto(
      id="f4259ba3-c22d-4739-914a-6ef02da0beee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стадіон СШ №10 \"Спарта\"", address="вулиця Чумацька, Кривий Ріг, 50000 Kryvyi Rih, Ukraine",
      city="Kryvyi Rih", country="UA",
      latitude=47.8912191, longitude=33.3317953,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2bf0faa6-ed19-4a0d-aa31-302cdb75438c_ChIJtRsWTaLY_0.jpg",
      averageRating=4.2, totalRatingsCount=219,
      createdAt="2026-08-30T17:38:02.174030Z", updatedAt="2026-08-30T20:52:49.507937Z",
    ),
    ClubDto(
      id="d450ebef-e85e-4e6e-b19c-e74d04b0d549", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MAD HORNETS ( extreme sport paintball)", address="вулиця Свято-Миколаївська, 97Б, Кривий Ріг, Дніпропетровська область, 50000",
      city="Kryvyi Rih", country="UA",
      latitude=47.8979144, longitude=33.3467631,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/97ff8f77-dd6f-4144-a38a-f19d81a39ada_photo.jpg",
      averageRating=4.8, totalRatingsCount=15,
      createdAt="2026-08-31T15:52:46.047312Z", updatedAt="2026-08-31T22:11:18.848010Z",
    ),
    ClubDto(
      id="eebb5ce8-9c32-4f5f-b0ae-ee188bda5ff2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Skalatoria", address="проспект Університетський, 54, Кривий Ріг, Дніпропетровська область, 50000",
      city="Kryvyi Rih", country="UA",
      latitude=47.9081544, longitude=33.4124178,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1bd2ea18-e773-4661-9870-8d8c3baaaac4_photo.jpg",
      averageRating=4.7, totalRatingsCount=11,
      createdAt="2026-08-31T15:53:06.144519Z", updatedAt="2026-08-31T15:53:06.144519Z",
    ),
  )),
  CitySeo(slug="zaporizhzhia", name="Zaporizhzhia", country="UA", clubCount=16, sports=listOf(Pair("Football", 4), Pair("Tennis", 2), Pair("Laser Tag", 2), Pair("Table Tennis", 2), Pair("Padel", 1), Pair("Paintball", 1), Pair("Karting", 1), Pair("Billiards", 1), Pair("Climbing", 1), Pair("Basketball", 1)), clubs=listOf(
    ClubDto(
      id="cf5926a9-3755-4c57-b5d8-cb943d6a7d31", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скеледром \"Energy Wall\"", address="бульвар Вінтера, 16, Запоріжжя, 69096 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.8721842, longitude=35.0757714,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4a839db4-ee9f-408b-9a09-355dd26d7e99_ChIJFV1rRKRm_0.jpg",
      averageRating=4.9, totalRatingsCount=101,
      createdAt="2026-08-30T17:15:10.129466Z", updatedAt="2026-08-30T20:52:46.121582Z",
    ),
    ClubDto(
      id="9e99e69f-3b34-465e-ac5e-3975dabf7fe0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг Клуб \" Бункер\"", address="бульв. Марії Примаченко, 11, Запоріжжя, 69035 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.8393936, longitude=35.1223983,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/64918303-434f-4763-b223-9d527a86bf75_ChIJA6SFoJtn_0.jpg",
      averageRating=4.8, totalRatingsCount=121,
      createdAt="2026-08-30T17:15:39.417049Z", updatedAt="2026-08-30T20:52:37.518602Z",
    ),
    ClubDto(
      id="9b485100-cf7c-432d-98ca-e20314417589", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Клуб \"Блок-Пост\", пейнтбол, лазертаг, тир, аренду бесідок", address="вулиця Горіхова Бухта, 20, Запоріжжя, 69000 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.7976408, longitude=35.167646,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9c6c4bf1-b317-4cb6-aba8-6605826c4882_ChIJh2kMUEFe_0.jpg",
      averageRating=4.7, totalRatingsCount=127,
      createdAt="2026-08-30T17:15:32.098527Z", updatedAt="2026-08-30T20:52:34.239112Z",
    ),
    ClubDto(
      id="16bdb5ba-730f-4ad8-a5cf-3e058fe43e4e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спортивний клуб \"ХОРТ\" Настільний теніс. Тренажерний зал. Фітнес", address="вулиця Сергія Синенка, 63а, Запоріжжя, 69000 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.8641743, longitude=35.0297889,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d33117f3-bb2e-42c5-a23e-2b964da8eb6f_ChIJIXMI82Bj_0.jpg",
      averageRating=4.7, totalRatingsCount=249,
      createdAt="2026-08-30T17:15:55.796618Z", updatedAt="2026-08-30T20:52:48.251174Z",
    ),
    ClubDto(
      id="82ea999b-b9e7-4858-b68c-bae453cacb33", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Монако", address="вулиця Вороніна, 1Б, Запоріжжя, 69120 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.8510122, longitude=35.2379214,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a39874bc-5f3f-47d3-b7ee-27a269d8d56d_ChIJY9yWQ0pn_0.jpg",
      averageRating=4.6, totalRatingsCount=551,
      createdAt="2026-08-30T17:15:17.300397Z", updatedAt="2026-08-30T20:52:39.962050Z",
    ),
    ClubDto(
      id="47188c89-7828-4fea-89eb-5cfb5cef5d0c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="СК \"Мотор Січ\"", address="вулиця Іванова, 24, Запоріжжя, 69000 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.830555, longitude=35.2082869,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d6574eb4-4818-4a38-b3f1-6f046c6dc1ae_ChIJsTudysFd_0.jpg",
      averageRating=4.6, totalRatingsCount=377,
      createdAt="2026-08-30T17:14:46.601477Z", updatedAt="2026-08-30T20:52:45.355765Z",
    ),
    ClubDto(
      id="a9246c84-d556-477e-93b2-1f6ab04e0f9b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Армада", address="вулиця Лермонтова, 24, Запоріжжя, 69000 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.8393507, longitude=35.123992,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8818cec4-1dc0-474a-9cdd-b8fe5b7e0d11_ChIJVfdj5jBn_1.jpg",
      averageRating=4.5, totalRatingsCount=1434,
      createdAt="2026-08-30T17:16:24.940436Z", updatedAt="2026-08-31T22:11:24.655467Z",
    ),
    ClubDto(
      id="c3a88250-ef69-4024-ad96-4de405335d9d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="\"Славутич Арена\"", address="вул. Валерія Лобановського, 21, Запоріжжя, 69000 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.859427, longitude=35.097028,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c2866d35-9a4b-4db4-b6a5-aac11a2afafa_ChIJKVpSOM9m_0.jpg",
      averageRating=4.4, totalRatingsCount=4205,
      createdAt="2026-08-30T17:14:25.137714Z", updatedAt="2026-08-30T20:52:08.068634Z",
    ),
    ClubDto(
      id="49dc4a6a-3546-4cde-8b2e-81e98722b094", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Палац спорту ЗАС", address="Північне шосе, 10, Запоріжжя, 69000 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.8657269, longitude=35.1146469,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39f92e7c-d277-4ecf-9989-1448546549be_ChIJn89qUt1m_0.jpg",
      averageRating=4.4, totalRatingsCount=564,
      createdAt="2026-08-30T17:14:39.428022Z", updatedAt="2026-08-30T20:52:41.642557Z",
    ),
    ClubDto(
      id="2300085a-6009-4f09-a214-47ebc7516fe4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Під Дубом", address="Sadivnitstva Street 13, Zaporizhzhia, Zaporizhzhia, 69017 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.816349, longitude=35.2394474,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/691ce41f-c76c-4df1-85fb-b422914ba0e5_ChIJEwU4NDFc_0.jpg",
      averageRating=4.3, totalRatingsCount=393,
      createdAt="2026-08-30T17:14:53.945226Z", updatedAt="2026-08-30T20:52:44.486650Z",
    ),
    ClubDto(
      id="a7d92927-2a03-4a89-9f25-5c18df4b4d42", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стадіон \"Стріла\"", address="вулиця Іванова, 24, Запоріжжя, 69000 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.8295664, longitude=35.2068603,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/28ae90a4-e129-4c53-bffb-173bd3d5b447_ChIJ3ZoilcFd_0.jpg",
      averageRating=4.3, totalRatingsCount=1421,
      createdAt="2026-08-30T17:14:32.845128Z", updatedAt="2026-08-30T20:52:49.127444Z",
    ),
    ClubDto(
      id="730e74ff-dcc3-4e35-ba1b-f7cb2b228d8c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Дельта", address="13A, Північно-Кільцева вулиця, 13А, Запоріжжя, 69000 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.785912, longitude=35.219316,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/530b6dc0-394c-487c-aa74-a409249c59db_ChIJ6XEWPZVe_1.jpg",
      averageRating=4.2, totalRatingsCount=195,
      createdAt="2026-08-30T17:16:10.703412Z", updatedAt="2026-08-31T22:11:24.987385Z",
    ),
    ClubDto(
      id="47cb9dcc-51ea-4178-9262-c4a793df812b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спортивний фітнес-комплекс", address="Запоріжжя, Запорізька область, 69000",
      city="Zaporizhzhia", country="UA",
      latitude=47.8514864, longitude=35.1037953,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5c013967-3503-4d2f-b075-0dfe7458bfd7_photo.jpg",
      averageRating=4.2, totalRatingsCount=229,
      createdAt="2026-08-31T15:20:09.291109Z", updatedAt="2026-08-31T15:20:09.291109Z",
    ),
    ClubDto(
      id="2c5c6108-53d1-47b6-94df-847e1910f394", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг центр LaserBoom", address="ТРЦ \"Пальміра Plaza, проспект Соборний, 92, 3 поверх, Запоріжжя, 69002 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.8213308, longitude=35.1734601,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c6a4dc09-d661-4370-a79a-6bbce7d86b1f_ChIJ2bK5UJth_0.jpg",
      averageRating=4.6, totalRatingsCount=45,
      createdAt="2026-08-30T17:15:48.168580Z", updatedAt="2026-08-30T20:52:37.907944Z",
    ),
    ClubDto(
      id="f69ffc80-3350-463c-9eb2-a4911b89163b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Суперлига. Клуб настольного тенниса", address="проспект Соборний, 2, Запоріжжя, 69000 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.7959132, longitude=35.1856973,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Table Tennis", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d503e15e-f754-407e-8d87-f378c43ab172_ChIJXXVCs1Vn_0.jpg",
      averageRating=4.6, totalRatingsCount=44,
      createdAt="2026-08-30T17:16:03.054694Z", updatedAt="2026-08-30T20:52:49.889312Z",
    ),
    ClubDto(
      id="57a57308-2459-474b-807b-ced11422203f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісний корт", address="вулиця Іванова, 24, Запоріжжя, 69000 Zaporizhzhia, Ukraine",
      city="Zaporizhzhia", country="UA",
      latitude=47.8293647, longitude=35.2089538,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/494e8358-1bfd-4020-bc41-a8d4f613e242_ChIJr45WpMFd_0.jpg",
      averageRating=4.6, totalRatingsCount=27,
      createdAt="2026-08-30T17:16:39.614728Z", updatedAt="2026-08-30T20:52:52.154191Z",
    ),
  )),
  CitySeo(slug="bergen", name="Bergen", country="NO", clubCount=16, sports=listOf(Pair("Football", 2), Pair("Climbing", 2), Pair("Tennis", 2), Pair("Bowling", 2), Pair("Golf", 2), Pair("Volleyball", 2), Pair("Karting", 1), Pair("Basketball", 1), Pair("Billiards", 1), Pair("Padel", 1)), clubs=listOf(
    ClubDto(
      id="dfd35f8d-9261-4823-9fbf-5f55b6762c0f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Vestveggen Bergen Klatreklubb", address="Åsane Senter 60, 5130 Nyborg",
      city="Bergen", country="NO",
      latitude=60.4697701, longitude=5.3136408,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f8d38f0a-3f42-45ef-af29-e94f7fa36ef1_photo.jpg",
      averageRating=4.8, totalRatingsCount=212,
      createdAt="2026-09-01T00:12:41.395692Z", updatedAt="2026-09-01T00:12:41.395692Z",
    ),
    ClubDto(
      id="7d91112b-ba15-4cd4-93f3-513b856c26e7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bergen Gokartsenter AS", address="Sartorvegen 12, 5353 Straume",
      city="Bergen", country="NO",
      latitude=60.3561429, longitude=5.1277986,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/13370d8f-50b0-40b4-a461-2b1ab05c573f_photo.jpg",
      averageRating=4.6, totalRatingsCount=592,
      createdAt="2026-09-01T00:12:25.361529Z", updatedAt="2026-09-01T00:12:25.361529Z",
    ),
    ClubDto(
      id="db4a0029-b35f-4157-8603-a2c26f542458", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bergen Tennis Arena", address="Vilhelm Bjerknes' vei 20, 5081 Bergen",
      city="Bergen", country="NO",
      latitude=60.3532791, longitude=5.3604736,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/de73b17e-cece-45d4-80e9-55da266fb185_photo.jpg",
      averageRating=4.6, totalRatingsCount=80,
      createdAt="2026-09-01T00:11:44.978148Z", updatedAt="2026-09-01T00:11:44.978148Z",
    ),
    ClubDto(
      id="dc584434-e3e4-4360-b352-8468eaa670ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fana Golfclub", address="Vestre Rå 82, 5239 Rådal",
      city="Bergen", country="NO",
      latitude=60.2894445, longitude=5.309955,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/de57f279-da7d-40f0-988d-9006fe9632b9_photo.jpg",
      averageRating=4.6, totalRatingsCount=207,
      createdAt="2026-09-01T00:12:18.958853Z", updatedAt="2026-09-01T00:12:18.958853Z",
    ),
    ClubDto(
      id="05a1727f-3c79-4f5c-821b-60558a66f576", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bergen Klatreklubb (Bryggeriet)", address="Kalfarveien 82, 5018 Bergen",
      city="Bergen", country="NO",
      latitude=60.3858975, longitude=5.3502959,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/25c526b5-e9f7-4d09-ba0d-cc5bfe37b910_photo.jpg",
      averageRating=4.5, totalRatingsCount=137,
      createdAt="2026-09-01T00:12:46.671762Z", updatedAt="2026-09-01T00:12:46.671762Z",
    ),
    ClubDto(
      id="567f9aa8-1db7-4644-9f6f-d076a1077c07", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Meland Aktiv", address="Fosseskarvegen 4, 5919 Frekhaug",
      city="Bergen", country="NO",
      latitude=60.5233704, longitude=5.2241154,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/780d3059-a589-4bbb-9dbf-40d56ef80a46_photo.jpg",
      averageRating=4.5, totalRatingsCount=168,
      createdAt="2026-09-01T00:12:04.924082Z", updatedAt="2026-09-01T00:12:04.924082Z",
    ),
    ClubDto(
      id="98266c4b-52a9-4004-a2f1-b0044ffcfc42", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kong Oscar", address="Tverrgaten 8, 5017 Bergen",
      city="Bergen", country="NO",
      latitude=60.3921804, longitude=5.3313148,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/04c2a3b4-4d6b-47bb-b188-bce21a75f3b6_photo.jpg",
      averageRating=4.3, totalRatingsCount=536,
      createdAt="2026-09-01T00:12:52.239058Z", updatedAt="2026-09-01T00:12:52.239058Z",
    ),
    ClubDto(
      id="7b8bd677-c016-40dd-852f-0d0a92cf035c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sandslihallen", address="Sandslivegen 100, 5254 Sandsli",
      city="Bergen", country="NO",
      latitude=60.3008224, longitude=5.2851995,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cc590e2e-72cc-4b40-befa-ca1eddc34398_photo.jpg",
      averageRating=4.3, totalRatingsCount=162,
      createdAt="2026-09-01T00:12:09.617134Z", updatedAt="2026-09-01T00:12:09.617134Z",
    ),
    ClubDto(
      id="84e347fd-b586-4441-813a-01e5c8c16b3d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="5aside.com 5 a side football leagues London", address="7 Bell Yard, London WC2A 2JR, UK",
      city="Bergen", country="NO",
      latitude=51.5142633, longitude=-0.1117717,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/485485a7-6cb7-44fd-b422-7e2562646b35_photo.jpg",
      averageRating=4.9, totalRatingsCount=43,
      createdAt="2026-09-01T00:11:30.229121Z", updatedAt="2026-09-01T00:11:30.229121Z",
    ),
    ClubDto(
      id="0510be93-1dc5-4d03-b9e3-ee351825eb3b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fraser Park 5aside", address="100 Marrickville Rd, Marrickville NSW 2204, Australia",
      city="Bergen", country="NO",
      latitude=-33.9150409, longitude=151.1614354,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2868824b-fae9-4615-929e-2c4ae593fcd9_photo.jpg",
      averageRating=4.2, totalRatingsCount=162,
      createdAt="2026-09-01T00:11:25.353397Z", updatedAt="2026-09-01T00:11:25.353397Z",
    ),
    ClubDto(
      id="7e79c298-5169-46ab-a4f4-625caef922c4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bowling 1 Vestkanten", address="Lyderhornsveien 307, 5171 Loddefjord",
      city="Bergen", country="NO",
      latitude=60.3628846, longitude=5.2351002,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0fce6493-28fd-4d51-803e-1660e27fe370_photo.jpg",
      averageRating=4.1, totalRatingsCount=388,
      createdAt="2026-09-01T00:12:35.825379Z", updatedAt="2026-09-01T00:12:35.825379Z",
    ),
    ClubDto(
      id="1427a231-0d78-4ce5-8be0-11c04a9f3b19", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Åsane Bowling & Event Center AS", address="Åsamyrane 86, 5116 Ulset",
      city="Bergen", country="NO",
      latitude=60.4625, longitude=5.3236111,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/23761f64-237e-42e7-91a4-8592410333a0_photo.jpg",
      averageRating=4.1, totalRatingsCount=480,
      createdAt="2026-09-01T00:12:30.722469Z", updatedAt="2026-09-01T00:12:30.722469Z",
    ),
    ClubDto(
      id="3ab26416-7844-4a0a-b825-319b21b0386e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Haukelandshallen", address="St. Olavs vei 50, 5052 Bergen",
      city="Bergen", country="NO",
      latitude=60.3701548, longitude=5.3539144,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d7a2fbf0-7ace-472b-a9de-c94e8af8640e_photo.jpg",
      averageRating=4.0, totalRatingsCount=371,
      createdAt="2026-09-01T00:11:59.667380Z", updatedAt="2026-09-01T00:11:59.667380Z",
    ),
    ClubDto(
      id="8344b106-3bf8-4bbb-af3a-ad8077735b28", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Santapogue Creek Golf Course", address="69 Bergen Ave #1, West Babylon, NY 11704, USA",
      city="Bergen", country="NO",
      latitude=40.6809883, longitude=-73.3421401,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a02b9777-4833-461f-98e3-aa9096ee23b7_photo.jpg",
      averageRating=4.0, totalRatingsCount=352,
      createdAt="2026-09-01T00:12:13.746638Z", updatedAt="2026-09-01T00:12:13.746638Z",
    ),
    ClubDto(
      id="eceed9ba-5625-46f5-ad3c-418aae57bac3", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bergens Tennisklubb", address="Fjellsdalen 9, 5155 Bønes",
      city="Bergen", country="NO",
      latitude=60.3340178, longitude=5.2960785,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2403f4d7-43fd-4d9a-9004-921938bc77c2_photo.jpg",
      averageRating=4.9, totalRatingsCount=25,
      createdAt="2026-09-01T00:11:49.692059Z", updatedAt="2026-09-01T00:11:49.692059Z",
    ),
    ClubDto(
      id="5895c15a-e60b-4250-8b36-dd0931b1fb4c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pro Padel Kokstad", address="Kokstadvegen 25C, 5257 Bergen",
      city="Bergen", country="NO",
      latitude=60.2957505, longitude=5.2677442,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ee9bb78e-189f-4a09-8107-d61442edab6b_photo.jpg",
      averageRating=4.7, totalRatingsCount=26,
      createdAt="2026-09-01T00:11:55.084711Z", updatedAt="2026-09-01T00:11:55.084711Z",
    ),
  )),
  CitySeo(slug="mykolaiv", name="Mykolaiv", country="UA", clubCount=16, sports=listOf(Pair("Football", 3), Pair("Laser Tag", 2), Pair("Billiards", 2), Pair("Tennis", 2), Pair("Paintball", 2), Pair("Basketball", 1), Pair("Padel", 1), Pair("Climbing", 1), Pair("Karting", 1), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="223de958-06a9-40cc-bc04-840a19c20fec", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arena Laser Tag", address="вулиця Василя Порика, 28, Вінниця, Вінницька область, 21001",
      city="Mykolaiv", country="UA",
      latitude=49.2316355, longitude=28.4031318,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e9a85d59-3861-45c7-8ccf-1896c3bad23b_photo.jpg",
      averageRating=4.9, totalRatingsCount=648,
      createdAt="2026-08-31T15:47:12.616739Z", updatedAt="2026-08-31T15:47:12.616739Z",
    ),
    ClubDto(
      id="8664f110-eacd-4bd3-8dd1-e0c30aab455b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбол, лазертаг, страйкбол. Клуб \"Тарантино\"", address="вулиця Врожайна, 29, Миколаїв, 54000 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9869043, longitude=31.936058,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f36bf61b-be2a-4e94-b1ee-63f87c56d114_ChIJQf_jUOXI_0.jpg",
      averageRating=4.9, totalRatingsCount=75,
      createdAt="2026-08-30T17:37:01.491191Z", updatedAt="2026-08-30T20:52:42.749050Z",
    ),
    ClubDto(
      id="1ac29ad4-a37a-441e-90b7-457554ced8c1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Країна тенісу", address="Теннисные корты на Центральном стадионе \"Эвис\" вход с ул. Правды напротив дома 8, Миколаїв, 54000 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9735691, longitude=31.9623029,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0e7560ca-95e0-4fb4-b597-c7fda062f5d2_ChIJU2t4UhHJ_0.jpg",
      averageRating=4.8, totalRatingsCount=56,
      createdAt="2026-08-30T17:37:34.664624Z", updatedAt="2026-08-30T20:52:35.645517Z",
    ),
    ClubDto(
      id="f617ed0d-1358-4d5d-8973-3cb4495a68e8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Дейлі спорт", address="вулиця Спортивна, 2a, Миколаїв, 54000 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9698561, longitude=31.958281,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/baa5c7c8-c9c6-476e-aa7b-b27b2ab1acc6_ChIJv9v2ij3J_0.jpg",
      averageRating=4.7, totalRatingsCount=1877,
      createdAt="2026-08-30T17:37:11.098162Z", updatedAt="2026-08-30T20:52:30.874480Z",
    ),
    ClubDto(
      id="78492843-7ae5-438c-8421-610097851750", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбольний клуб \"HEART OF STEEL\"", address="вулиця Погранична, 29, Миколаїв, 54034 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9585302, longitude=31.9969209,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3a736b13-f209-428c-aabc-31081327b5c1_ChIJP6fTmbvL_0.jpg",
      averageRating=4.6, totalRatingsCount=116,
      createdAt="2026-08-30T17:36:54.519383Z", updatedAt="2026-08-30T20:52:43.015345Z",
    ),
    ClubDto(
      id="7eabe862-dedc-4d98-ab18-c0c4f319e8fd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Діром", address="вулиця Генерала Олекси Алмазова, 12 Б/4, Миколаїв, 54000 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9621276, longitude=31.9495582,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e82fb485-0daa-4997-ae8c-e54fbc24b0be_ChIJcWOJDzrJ_0.jpg",
      averageRating=4.5, totalRatingsCount=237,
      createdAt="2026-08-30T17:36:40.083124Z", updatedAt="2026-08-30T20:52:31.722391Z",
    ),
    ClubDto(
      id="df98b70a-0e91-4993-a6a6-0004e35d17a8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Империя скорости", address="проспект Корабелів, 1/1, Миколаїв, 54000 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.8605558, longitude=32.0014818,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d4819ec-f058-4850-9558-c301e796e33c_ChIJfcrHx0_N_0.jpg",
      averageRating=4.4, totalRatingsCount=278,
      createdAt="2026-08-30T17:36:47.434040Z", updatedAt="2026-08-30T20:52:32.329725Z",
    ),
    ClubDto(
      id="0301dea8-d7fa-4586-b246-04cb5b9f7a4b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісний Корт", address="Миколаїв, 54000 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9789466, longitude=31.9646949,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed118bd4-91a1-484a-ab70-1c4fdcfd4584_ChIJxZ-Ulw_J_0.jpg",
      averageRating=4.4, totalRatingsCount=178,
      createdAt="2026-08-30T17:37:26.175257Z", updatedAt="2026-08-30T20:52:51.420164Z",
    ),
    ClubDto(
      id="61f9c25c-60d0-40ca-bb3a-ed7956c90af0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Центральний міський стадіон", address="вулиця Спортивна, 1/1, Миколаїв, 54015 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9713053, longitude=31.9606829,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c3927b91-5827-4ab6-8d8f-8292cad614bc_ChIJ73p7ZBbJ_0.jpg",
      averageRating=4.4, totalRatingsCount=1775,
      createdAt="2026-08-30T17:35:35.048493Z", updatedAt="2026-08-30T20:52:54.668578Z",
    ),
    ClubDto(
      id="c2ff1df9-8436-4764-bd9d-cc7c303574c6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Надія", address="вулиця Генерала Олекси Алмазова, 44, Миколаїв, 54000 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9681624, longitude=31.9565647,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3bfdbe64-8b40-4d42-a4fd-8c7a1401453c_ChIJoV9Izz3J_0.jpg",
      averageRating=4.3, totalRatingsCount=134,
      createdAt="2026-08-30T17:35:49.073961Z", updatedAt="2026-08-30T20:52:40.208457Z",
    ),
    ClubDto(
      id="73194cfc-0fa0-44ee-b0aa-ba8e48ac6286", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Фортуна", address="Фортуна бильярдный клуб проспект Героїв Сталінграду, 13 ТРЦ Магелан 2-ой этаж, Миколаїв, 54001 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9932126, longitude=31.9989009,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/40f7de2d-a1dc-4325-a6b5-afbd8e8bb7e1_ChIJjemyIJbJ_0.jpg",
      averageRating=4.3, totalRatingsCount=521,
      createdAt="2026-08-30T17:36:11.643884Z", updatedAt="2026-08-30T20:52:53.416277Z",
    ),
    ClubDto(
      id="45d8e9cf-ef24-4a99-9e54-ae101c04e2f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Гавана-мама", address="вулиця Аркасівська, 37, Миколаїв, 54000 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9689218, longitude=31.9817816,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1c2d5413-377a-4af1-9089-60b03dcd0a2a_ChIJ___A3m7J_0.jpg",
      averageRating=4.2, totalRatingsCount=539,
      createdAt="2026-08-30T17:36:03.208992Z", updatedAt="2026-08-30T20:52:29.623713Z",
    ),
    ClubDto(
      id="c5a663c6-6a94-47e7-a287-bdc14a2059b0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Маса", address="вулиця Космонавтів, 90, Миколаїв, 54000 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9470137, longitude=32.0604974,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7b444829-c060-46cd-90be-993e87a0f663_ChIJUb0bxgjL_0.jpg",
      averageRating=4.2, totalRatingsCount=186,
      createdAt="2026-08-30T17:36:26.138394Z", updatedAt="2026-08-30T20:52:39.214744Z",
    ),
    ClubDto(
      id="e9fb7bc8-ced2-4b80-97d3-e72c2e24fe12", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Зоря", address="вулиця Олійника, 36, Миколаїв, 54000 Mykolaiv, Ukraine",
      city="Mykolaiv", country="UA",
      latitude=46.9449787, longitude=32.0407536,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bee30c79-9fd6-49bf-b39c-fa6feba17723_ChIJp2wD96HL_0.jpg",
      averageRating=4.0, totalRatingsCount=323,
      createdAt="2026-08-30T17:35:42.001244Z", updatedAt="2026-08-30T20:52:32.211656Z",
    ),
    ClubDto(
      id="2cbc20e3-7710-4384-ab64-6021f6f49a22", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="«Sky Energy» клуб спортивно-бального танцю\"", address="над кафе ПапаШа, вулиця Маріупольська, 18, 3 поверх, Миколаїв, Миколаївська область, 54000",
      city="Mykolaiv", country="UA",
      latitude=46.970752, longitude=31.9941803,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c624fec9-c792-449b-8e65-5c269f9922b3_photo.jpg",
      averageRating=5.0, totalRatingsCount=33,
      createdAt="2026-08-31T15:46:59.485049Z", updatedAt="2026-08-31T22:11:24.545479Z",
    ),
    ClubDto(
      id="e9a3215d-8728-4cb8-8025-f2259c925d32", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазер клуб Lider+", address="Миколаїв, Миколаївська область, 54000",
      city="Mykolaiv", country="UA",
      latitude=46.9653129, longitude=31.9953186,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/42fc851a-05bd-4716-bd5d-8635da6b0ed7_photo.jpg",
      averageRating=4.7, totalRatingsCount=14,
      createdAt="2026-08-31T15:47:19.706718Z", updatedAt="2026-08-31T22:11:25.538421Z",
    ),
  )),
  CitySeo(slug="poltava", name="Poltava", country="UA", clubCount=16, sports=listOf(Pair("Football", 4), Pair("Tennis", 3), Pair("Volleyball", 2), Pair("Climbing", 2), Pair("Karting", 1), Pair("Basketball", 1), Pair("Laser Tag", 1), Pair("Paintball", 1), Pair("Billiards", 1)), clubs=listOf(
    ClubDto(
      id="2ade6e0a-1a79-4e45-a5b0-eee8f9723627", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг в Полтаві", address="Автобазівська вулиця, 7, Полтава, 36000 Poltava, Ukraine",
      city="Poltava", country="UA",
      latitude=49.5619153, longitude=34.5337671,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/370c0379-8d71-4071-a48c-c404cd3417be_ChIJu9qH3J0v_0.jpg",
      averageRating=4.8, totalRatingsCount=63,
      createdAt="2026-08-30T17:19:28.274874Z", updatedAt="2026-08-30T20:52:37.784998Z",
    ),
    ClubDto(
      id="375b64e2-2aff-4dcd-817c-e080be553ad5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скітенс", address="проспект Віталія Грицаєнка, 24б, Полтава, 36000 Poltava, Ukraine",
      city="Poltava", country="UA",
      latitude=49.5760801, longitude=34.5713079,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/40e459ff-bb52-4133-abbf-761bd07c71b9_ChIJ4dFo8Hov_0.jpg",
      averageRating=4.8, totalRatingsCount=109,
      createdAt="2026-08-30T17:19:36.157102Z", updatedAt="2026-08-30T20:52:47.144522Z",
    ),
    ClubDto(
      id="a8f20b6b-454f-4faf-a759-40e3969944aa", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стадіон Динамо", address="вулиця Антона Грицая, 12, Полтава, 36000 Poltava, Ukraine",
      city="Poltava", country="UA",
      latitude=49.5905182, longitude=34.5463704,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9ca9eb93-4708-47ba-be5b-1bec0ca89051_ChIJZ4AoDVgv_0.jpg",
      averageRating=4.6, totalRatingsCount=765,
      createdAt="2026-08-30T17:18:54.600938Z", updatedAt="2026-08-30T20:52:49.257702Z",
    ),
    ClubDto(
      id="07fb689d-f322-4d84-a479-dab7dd6d551b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Фітнес-клуб \"Space\"", address="бул. Євгена Коновальця, 2, Полтава, Полтавська область, 36000",
      city="Poltava", country="UA",
      latitude=49.5741741, longitude=34.5075272,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/64699fed-5d4d-4e8e-be23-ee0c1fcc6976_photo.jpg",
      averageRating=4.6, totalRatingsCount=260,
      createdAt="2026-08-31T16:01:11.517568Z", updatedAt="2026-08-31T22:11:28.240510Z",
    ),
    ClubDto(
      id="929f5c73-b5c0-4cf4-89e2-3f7746b6d46d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ДЮСШ „Ворскла” ім. І.І. Горпинка", address="майдан Незалежності, 16, Полтава, 36000 Poltava, Ukraine",
      city="Poltava", country="UA",
      latitude=49.5953044, longitude=34.5506291,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/32668546-e776-474f-bd22-de8325cf350d_ChIJkWRgAvol_0.jpg",
      averageRating=4.5, totalRatingsCount=214,
      createdAt="2026-08-30T17:19:09.836737Z", updatedAt="2026-08-30T20:52:30.622211Z",
    ),
    ClubDto(
      id="5295bd21-a29e-4183-84e7-31106542cff2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Класичний", address="вулиця Котляревського, 38, Полтава, Полтавська область, 36000",
      city="Poltava", country="UA",
      latitude=49.5831475, longitude=34.5503138,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ea7771a-21ed-4381-94cd-69138a85b40f_photo.jpg",
      averageRating=4.5, totalRatingsCount=182,
      createdAt="2026-08-31T16:01:05.735180Z", updatedAt="2026-08-31T16:01:05.735180Z",
    ),
    ClubDto(
      id="53153df2-04ef-4a62-83af-2efa169351c5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Теніс у Полтаві", address="вулиця Миру, 12, Полтава, 36022 Poltava, Ukraine",
      city="Poltava", country="UA",
      latitude=49.578495, longitude=34.5869789,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b1932fce-f5ae-4f7f-b49b-857154246c56_ChIJo2AiQIAl_0.jpg",
      averageRating=4.5, totalRatingsCount=93,
      createdAt="2026-08-30T17:19:43.709706Z", updatedAt="2026-08-30T20:52:51.211809Z",
    ),
    ClubDto(
      id="2e83ee63-59a2-4ed8-afb2-c4acfc1cb1b0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Динамо", address="вулиця Дмитра Коряка, 2А, Полтава, 36000 Poltava, Ukraine",
      city="Poltava", country="UA",
      latitude=49.5908095, longitude=34.5437315,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cb93b7ba-6ff0-495b-aaac-62a827c1c205_ChIJG5E-7Vcv_0.jpg",
      averageRating=4.4, totalRatingsCount=275,
      createdAt="2026-08-30T17:19:02.621984Z", updatedAt="2026-08-30T20:52:31.272839Z",
    ),
    ClubDto(
      id="c3640017-3c62-4274-ad57-ab6d2b0c9932", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбольний клуб \"Галактика\"", address="вулиця Ковпака, 26В, Полтава, 36000 Poltava, Ukraine",
      city="Poltava", country="UA",
      latitude=49.5953018, longitude=34.4870281,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6bba288c-6dfa-4b6b-a023-8fe48c089d2d_ChIJX4j4FZYo_0.jpg",
      averageRating=4.4, totalRatingsCount=104,
      createdAt="2026-08-30T17:19:24.514412Z", updatedAt="2026-08-30T20:52:43.251268Z",
    ),
    ClubDto(
      id="ff9741d3-11a0-4110-a121-45a8764c3317", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картодром \"Лтава\"", address="вулиця Комарова, 11, Полтава, 36000 Poltava, Ukraine",
      city="Poltava", country="UA",
      latitude=49.5513982, longitude=34.5039129,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d39522fd-8fc9-43dd-a567-209ee863f0a1_ChIJP382Tdwu_0.jpg",
      averageRating=4.3, totalRatingsCount=1019,
      createdAt="2026-08-30T17:19:17.219558Z", updatedAt="2026-08-30T20:52:33.862263Z",
    ),
    ClubDto(
      id="28249086-f9f6-47ef-bd56-c212489a6a16", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Статус", address="вулиця Михайла Грушевського, 2Д, Полтава, Полтавська область, 36021",
      city="Poltava", country="UA",
      latitude=49.5649833, longitude=34.5192375,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/db035ab6-f964-47b5-87ae-a024555ee882_photo.jpg",
      averageRating=4.3, totalRatingsCount=276,
      createdAt="2026-08-31T16:01:18.877369Z", updatedAt="2026-08-31T22:11:27.159053Z",
    ),
    ClubDto(
      id="f47f8a74-8537-49b5-9c0b-512fb0a8ae4e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Комунальний заклад \"Полтавська дитячо-юнацька спортивна школа \"ПОЛТАВА\"", address="майдан Незалежності, 24А, Полтава, Полтавська область, 36003",
      city="Poltava", country="UA",
      latitude=49.5947451, longitude=34.5462853,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9e1ad650-217c-4e3a-ad49-30bfa60d2f2c_photo.jpg",
      averageRating=4.2, totalRatingsCount=471,
      createdAt="2026-08-31T16:00:36.305651Z", updatedAt="2026-08-31T16:00:36.305651Z",
    ),
    ClubDto(
      id="1dd748e1-6ebf-4e1b-aaa0-4a6071936925", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Плесо", address="вулиця Охтирський Шлях, 73В, Полтава, Полтавська область, 36000",
      city="Poltava", country="UA",
      latitude=49.5932398, longitude=34.5944506,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9e0488f1-b0a9-4c6e-9761-d540482ecd10_photo.jpg",
      averageRating=4.2, totalRatingsCount=967,
      createdAt="2026-08-31T16:00:51.179203Z", updatedAt="2026-08-31T22:11:26.397645Z",
    ),
    ClubDto(
      id="6b37e824-fbd7-4a11-b22a-ba5305fef26b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стадіон \"Ворскла\" імені Олексія Бутовського", address="майдан Незалежності, 16, Полтава, 36000 Poltava, Ukraine",
      city="Poltava", country="UA",
      latitude=49.5947837, longitude=34.5492705,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/50a2d2ec-bffe-4b1c-938b-083960815963_ChIJ1Zey6Pkl_0.jpg",
      averageRating=4.2, totalRatingsCount=2240,
      createdAt="2026-08-30T17:18:46.425245Z", updatedAt="2026-08-30T20:52:48.882305Z",
    ),
    ClubDto(
      id="c291da12-2865-4255-95d5-b7335c4fe640", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PingSpace", address="вулиця Великотирнівська, 9а, Полтава, 36000 Poltava, Ukraine",
      city="Poltava", country="UA",
      latitude=49.5712996, longitude=34.4918862,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8009c092-cc6f-4a7b-9531-e2526e9e7674_ChIJT3VxNPsp_0.jpg",
      averageRating=5.0, totalRatingsCount=21,
      createdAt="2026-08-30T17:19:56.366678Z", updatedAt="2026-08-30T20:52:20.426386Z",
    ),
    ClubDto(
      id="87157e25-8476-408d-9da4-50730b83eb95", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BORA BORA", address="Холодноярський м-н, 46, Полтава, Полтавська область, 36000",
      city="Poltava", country="UA",
      latitude=49.613159, longitude=34.60447,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/be504cc8-0ddc-4178-8fca-5aa309788ba4_photo.jpg",
      averageRating=5.0, totalRatingsCount=8,
      createdAt="2026-08-31T16:00:58.914236Z", updatedAt="2026-08-31T22:11:13.813102Z",
    ),
  )),
  CitySeo(slug="malmo", name="Malmo", country="SE", clubCount=16, sports=listOf(Pair("Football", 4), Pair("Basketball", 2), Pair("Golf", 2), Pair("Padel", 2), Pair("Paintball", 2), Pair("Bowling", 1), Pair("Karting", 1), Pair("Climbing", 1), Pair("Volleyball", 1)), clubs=listOf(
    ClubDto(
      id="b4268ecb-e615-4bad-a881-41962dbf6ec7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Klättercentret Malmo - Climbing for everyone", address="Kopparbergsgatan 8, 214 44 Malmö",
      city="Malmo", country="SE",
      latitude=55.5873497, longitude=13.0251987,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8e2937a3-bd53-4178-8eab-41b560615517_photo.jpg",
      averageRating=4.7, totalRatingsCount=964,
      createdAt="2026-09-01T00:07:31.538486Z", updatedAt="2026-09-01T00:07:31.538486Z",
    ),
    ClubDto(
      id="913e7a82-9384-43bf-97d8-c966fbd1b27c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball course", address="Paintballvägen 1, 246 52 Löddeköpinge",
      city="Malmo", country="SE",
      latitude=55.8184986, longitude=12.9640641,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/74b327fe-91d4-4f4e-97d4-86f955e08f50_photo.jpg",
      averageRating=4.7, totalRatingsCount=328,
      createdAt="2026-09-01T00:07:40.541999Z", updatedAt="2026-09-01T00:07:40.541999Z",
    ),
    ClubDto(
      id="fd78ef10-203a-4a7f-9941-8c3904c9c83d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Eleda Stadion", address="Eric Perssons väg 31, 217 62 Malmö",
      city="Malmo", country="SE",
      latitude=55.5838731, longitude=12.9872887,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cd4f47c4-d06d-433e-b46d-ead7e81a3a8b_photo.jpg",
      averageRating=4.5, totalRatingsCount=3111,
      createdAt="2026-09-01T00:06:03.327112Z", updatedAt="2026-09-01T00:06:03.327112Z",
    ),
    ClubDto(
      id="ba46155d-7653-450e-8fc0-b7748d5b2424", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GoKartCity i Malmö AB", address="Lantmannagatan 59D, 214 48 Malmö",
      city="Malmo", country="SE",
      latitude=55.5814404, longitude=13.0178565,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67858300-5494-4044-8fc9-2490a970fb55_photo.jpg",
      averageRating=4.4, totalRatingsCount=370,
      createdAt="2026-09-01T00:07:13.623401Z", updatedAt="2026-09-01T00:07:13.623401Z",
    ),
    ClubDto(
      id="d1d561ad-d6b5-41d4-8ec6-386a4a3ff481", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hintons Golf Club - Rönnebäck", address="Rönnebäcksvägen 3, 238 41 Oxie",
      city="Malmo", country="SE",
      latitude=55.531263, longitude=13.1018449,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67354d2f-93c1-4376-9ff1-1499ce37cf62_photo.jpg",
      averageRating=4.3, totalRatingsCount=259,
      createdAt="2026-09-01T00:07:07.029870Z", updatedAt="2026-09-01T00:07:07.029870Z",
    ),
    ClubDto(
      id="0a13fe37-a4a5-4fd2-9fed-bc2a04826f73", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hästhagens Idrottsplats", address="Fågelbacksgatan 9, 217 44 Malmö",
      city="Malmo", country="SE",
      latitude=55.5978807, longitude=12.9874601,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6266291b-50a1-4588-8e22-b8996ecbdd9e_photo.jpg",
      averageRating=4.3, totalRatingsCount=147,
      createdAt="2026-09-01T00:06:23.087624Z", updatedAt="2026-09-01T00:06:23.087624Z",
    ),
    ClubDto(
      id="1ad44a98-d047-4af7-81d4-9d04dc39855e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Malmö Arena", address="Hyllie Stationsväg 2, 215 32 Malmö",
      city="Malmo", country="SE",
      latitude=55.5637646, longitude=12.9762167,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8a3bb5ac-b4f2-4b46-a311-d478e33b1618_photo.jpg",
      averageRating=4.3, totalRatingsCount=6167,
      createdAt="2026-09-01T00:06:53.637416Z", updatedAt="2026-09-01T00:06:53.637416Z",
    ),
    ClubDto(
      id="3256da7a-eaf6-4614-9311-3d7e7612feb8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Malmö Idrottsplats", address="Pildammsvägen 10, 211 46 Malmö",
      city="Malmo", country="SE",
      latitude=55.5945341, longitude=12.9969081,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ed7b73d0-69b0-40ae-80d4-a69795a6648f_photo.jpg",
      averageRating=4.3, totalRatingsCount=298,
      createdAt="2026-09-01T00:06:09.878154Z", updatedAt="2026-09-01T00:06:09.878154Z",
    ),
    ClubDto(
      id="fffcb066-b2c4-4a43-976d-3ca73ce27b2d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="VH Padel Malmö", address="Skeppsbyggaregatan 7, 211 11 Malmö",
      city="Malmo", country="SE",
      latitude=55.6073497, longitude=12.9803329,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9d773a68-9514-480a-8e2e-45ee4b5f67fe_photo.jpg",
      averageRating=4.3, totalRatingsCount=141,
      createdAt="2026-09-01T00:06:36.237584Z", updatedAt="2026-09-01T00:06:36.237584Z",
    ),
    ClubDto(
      id="77b8a999-1f54-40b5-8f41-1cd8f2027581", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Malmö Padelcenter", address="Södra Bulltoftavägen 51, 212 22 Malmö",
      city="Malmo", country="SE",
      latitude=55.6065745, longitude=13.0418578,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d371244-e82c-47a1-b70d-3ec74a59f23f_photo.jpg",
      averageRating=4.2, totalRatingsCount=302,
      createdAt="2026-09-01T00:06:29.679339Z", updatedAt="2026-09-01T00:06:29.679339Z",
    ),
    ClubDto(
      id="b1bdee6b-188f-46db-b1d3-5c26b9ef4e82", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Baltiska Hallen", address="Eric Perssons väg 8a, 217 62 Malmö",
      city="Malmo", country="SE",
      latitude=55.5832939, longitude=12.9906359,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f75c6d58-8fc4-49e4-9529-2d564fe25cbb_photo.jpg",
      averageRating=4.1, totalRatingsCount=510,
      createdAt="2026-09-01T00:06:41.546961Z", updatedAt="2026-09-01T00:06:41.546961Z",
    ),
    ClubDto(
      id="b9847a86-9c6c-4c34-aaab-492835c8fbea", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Hyllie IP", address="Hyllie Gårds väg 1-3, 216 23 Malmö",
      city="Malmo", country="SE",
      latitude=55.5649005, longitude=12.9622263,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67856496-f3f4-4c71-8565-66d0f2bb6068_photo.jpg",
      averageRating=4.0, totalRatingsCount=190,
      createdAt="2026-09-01T00:06:16.432353Z", updatedAt="2026-09-01T14:32:00.257009Z",
    ),
    ClubDto(
      id="d6f38d89-ebba-4357-b925-b557f13fe70f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Malmö Burlöv Golfklubb", address="Segesvängen 5, 212 27 Malmö",
      city="Malmo", country="SE",
      latitude=55.6170833, longitude=13.0664521,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/015e090e-90fa-4532-a722-f053c70477dc_photo.jpg",
      averageRating=4.0, totalRatingsCount=606,
      createdAt="2026-09-01T00:07:00.772702Z", updatedAt="2026-09-01T00:07:00.772702Z",
    ),
    ClubDto(
      id="31dc1b46-c77e-46a4-bbfe-4ea0835e7f45", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball South", address="Lilla Bramstorpsvägen 28, 233 91 Svedala",
      city="Malmo", country="SE",
      latitude=55.5577596, longitude=13.3465411,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d5e90188-1d0e-45c1-a759-5d0f21dbb671_photo.jpg",
      averageRating=4.5, totalRatingsCount=44,
      createdAt="2026-09-01T00:07:50.856255Z", updatedAt="2026-09-01T00:07:50.856255Z",
    ),
    ClubDto(
      id="7bbcd06b-5672-4bde-83a8-283d38c16ec6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Big Bowl", address="Östra Förstadsgatan 32, 212 12 Malmö",
      city="Malmo", country="SE",
      latitude=55.6069621, longitude=13.0194128,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e072e0c2-0bd8-462f-a3e1-8fd0e8e67d49_photo.jpg",
      averageRating=3.9, totalRatingsCount=2191,
      createdAt="2026-09-01T00:07:24.306653Z", updatedAt="2026-09-01T00:07:24.306653Z",
    ),
    ClubDto(
      id="866c3183-563b-4476-b5c3-7f6721eeaaf2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Heleneholms Sporthall", address="Ystadvägen, 214 30 Malmö",
      city="Malmo", country="SE",
      latitude=55.5798453, longitude=13.0176254,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7040799a-d1c9-430b-9305-83336bdb65a4_photo.jpg",
      averageRating=3.8, totalRatingsCount=66,
      createdAt="2026-09-01T00:06:47.050682Z", updatedAt="2026-09-01T00:06:47.050682Z",
    ),
  )),
  CitySeo(slug="ivano-frankivsk", name="Ivano-Frankivsk", country="UA", clubCount=15, sports=listOf(Pair("Football", 3), Pair("Basketball", 2), Pair("Laser Tag", 2), Pair("Billiards", 2), Pair("Padel", 1), Pair("Bowling", 1), Pair("Volleyball", 1), Pair("Karting", 1), Pair("Climbing", 1), Pair("Tennis", 1)), clubs=listOf(
    ClubDto(
      id="c18ac5a2-a4af-4fac-97ba-25fae47c72be", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ЛАЗЕРТАГ (лазерні бої) \"Перший Легіон\", ЖК Європейський", address="вул. Європейська, 1, Вовчинець, 76016 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9401813, longitude=24.7486063,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1e73eab8-b031-4db9-9d3a-d06b093d364b_ChIJwSDfYwzB_0.jpg",
      averageRating=4.9, totalRatingsCount=121,
      createdAt="2026-08-30T17:21:11.905759Z", updatedAt="2026-08-30T20:52:36.253747Z",
    ),
    ClubDto(
      id="78b9c1e2-4ec6-46b4-8f8d-77d8daa27744", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг Івано-Франківськ, ВАРТА", address="вулиця Ботанічна, 8, Івано-Франківськ, 76000 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.8932722, longitude=24.710925,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/255fe82f-468a-4be3-84f4-11bf3f0eec92_ChIJWZlOG0PB_0.jpg",
      averageRating=4.8, totalRatingsCount=160,
      createdAt="2026-08-30T17:21:03.733293Z", updatedAt="2026-08-30T20:52:37.159643Z",
    ),
    ClubDto(
      id="ea25856b-e3dc-463d-8a11-c353da831940", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спортивний Комплекс Академії НФК \"УРАГАН\"", address="вулиця Пасічна, 55, Івано-Франківськ, 77450 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9361794, longitude=24.6857231,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d10cc96e-87d1-41ab-8107-a97adedf237e_ChIJkToUrv3A_0.jpg",
      averageRating=4.8, totalRatingsCount=286,
      createdAt="2026-08-30T17:20:19.399642Z", updatedAt="2026-08-30T20:52:47.964741Z",
    ),
    ClubDto(
      id="c413dfdf-44fe-480a-bd4b-09621ae6a1e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Коледж фізичного виховання", address="вулиця Гетьмана Мазепи, 142а, Івано-Франківськ, 76026 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9115546, longitude=24.6897965,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/089136e1-9650-4a75-a6c2-be4e235d2a46_ChIJHXB5BDrB_0.jpg",
      averageRating=4.6, totalRatingsCount=474,
      createdAt="2026-08-30T17:20:11.093614Z", updatedAt="2026-08-30T20:52:34.876107Z",
    ),
    ClubDto(
      id="117e9c0b-6484-431c-99a1-3a9717e64f47", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Легенда", address="вулиця Незалежності, 34А, Івано-Франківськ, 76000 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.918785, longitude=24.714359,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/44043a2d-8070-44fb-82d5-c11d75b17c24_ChIJF9cqz2vB_3.jpg",
      averageRating=4.5, totalRatingsCount=4337,
      createdAt="2026-08-30T17:20:32.492167Z", updatedAt="2026-08-31T22:11:25.855145Z",
    ),
    ClubDto(
      id="7bb151cf-7e57-4d1e-913b-4f1a638fdc70", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ідеал Спорт", address="вулиця Гетьмана Мазепи, 173-2, Івано-Франківськ, 76000 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9072077, longitude=24.6854223,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6dcb3625-d30b-4b7f-8c15-30278355e9a6_ChIJSZaNazHB_0.jpg",
      averageRating=4.4, totalRatingsCount=171,
      createdAt="2026-08-30T17:20:25.011102Z", updatedAt="2026-08-30T20:52:26.026738Z",
    ),
    ClubDto(
      id="5c8db7d5-8936-4793-b025-a9096dc4cc64", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скеледром", address="вулиця Гетьмана Мазепи, 142А, Івано-Франківськ, 76000 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9113487, longitude=24.6902329,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/14b48dca-acaa-4f83-a38c-c1ae739a4487_ChIJC6eaFDrB_0.jpg",
      averageRating=4.4, totalRatingsCount=78,
      createdAt="2026-08-30T17:20:55.851870Z", updatedAt="2026-08-30T20:52:46.005380Z",
    ),
    ClubDto(
      id="1ab82149-0db2-407e-99b1-8f8bf417475f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісний клуб \"Карпати\"", address="вул. Рінь, 45, Микитинці, 76494 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9081002, longitude=24.7475413,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d283ba6b-4579-4fe0-b022-bfb94c2730e5_ChIJmYbLf93D_0.jpg",
      averageRating=4.4, totalRatingsCount=75,
      createdAt="2026-08-30T17:21:33.832472Z", updatedAt="2026-08-30T20:52:51.636403Z",
    ),
    ClubDto(
      id="c307f137-0647-44d5-981d-986455b1bc5b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Панорама плаза", address="Північний бульвар, 2А, Івано-Франківськ, 76000 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9295881, longitude=24.7072146,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a5a7ea9-975d-44d4-ab92-15594b34e2ca_ChIJKzN0bA7B_0.jpg",
      averageRating=4.2, totalRatingsCount=551,
      createdAt="2026-08-30T17:20:40.052837Z", updatedAt="2026-08-30T20:52:41.767593Z",
    ),
    ClubDto(
      id="755ce2e5-48ed-4f13-8451-3f5430b7e56e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Боулінг", address="Північний бульвар, 2А, Івано-Франківськ, 76000 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9296136, longitude=24.7073343,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d1bdfcd7-833e-4f65-87be-0f6e05bf63b7_ChIJvWijbg7B_0.jpg",
      averageRating=4.1, totalRatingsCount=314,
      createdAt="2026-08-30T17:20:48.078729Z", updatedAt="2026-08-30T20:52:27.962737Z",
    ),
    ClubDto(
      id="8a41c707-6c76-4d20-a150-2f5e121154a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Відпочинковий Комплекс \"Villa Laguna\"", address="вулиця Січових Стрільців, 65, Підпечери, Івано-Франківська область, 77441",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9085031, longitude=24.8013615,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/43a24a5c-3231-4964-bcbc-249ad198c186_photo.jpg",
      averageRating=3.8, totalRatingsCount=105,
      createdAt="2026-08-31T15:54:53.076308Z", updatedAt="2026-08-31T22:11:24.882906Z",
    ),
    ClubDto(
      id="4d7ba7e6-5a0d-4d23-a70f-cf6e342181e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ОЛІМП.СПОРТИВНИЙ КЛУБ, ЗАРІЦЬКИЙ ВІТАЛІЙ БОГДАНОВИЧ, ПП", address="вулиця Академіка Сахарова, 38, Івано-Франківськ, Івано-Франківська область, 76000",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.912872, longitude=24.715965,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2a49ce9a-b797-416b-9b15-f650cf78cfa5_photo.jpg",
      averageRating=3.8, totalRatingsCount=273,
      createdAt="2026-08-31T15:54:46.551053Z", updatedAt="2026-08-31T15:54:46.551053Z",
    ),
    ClubDto(
      id="270ebcf1-cc64-4c31-8dbb-9574fefbc875", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MSA - Magic Skills Academy", address="вулиця Богдана Хмельницького, 51А, Івано-Франківськ, 76000 Ivano-Frankivsk, Ukraine",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9339787, longitude=24.7246979,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a9e39101-9989-4988-b79e-becda6b68849_ChIJ2f53cHXB_0.jpg",
      averageRating=4.9, totalRatingsCount=28,
      createdAt="2026-08-30T17:21:27.268287Z", updatedAt="2026-08-30T20:52:18.174533Z",
    ),
    ClubDto(
      id="f1e44814-657e-4520-809e-ea98af4ff419", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ARKAN ARENA", address="вулиця Євгена Коновальця, 229, Івано-Франківськ, Івано-Франківська область, 76000",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.8986452, longitude=24.713833,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a4f735ad-d004-48b7-b5e7-e441f3c13a7b_photo.jpg",
      averageRating=3.9, totalRatingsCount=30,
      createdAt="2026-08-31T15:54:40.271370Z", updatedAt="2026-08-31T15:54:40.271370Z",
    ),
    ClubDto(
      id="36ebe429-2bfe-438a-922f-59f2add08834", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг ІФ", address="вулиця Вовчинецька, 225а, Івано-Франківськ, Івано-Франківська область, 76018",
      city="Ivano-Frankivsk", country="UA",
      latitude=48.9400755, longitude=24.7371907,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9baf8ad6-eaf3-4178-840f-f7109e40bab0_photo.jpg",
      averageRating=4.6, totalRatingsCount=11,
      createdAt="2026-08-31T15:55:00.342840Z", updatedAt="2026-08-31T15:55:00.342840Z",
    ),
  )),
  CitySeo(slug="valladolid", name="Valladolid", country="ES", clubCount=15, sports=listOf(Pair("Football", 5), Pair("Tennis", 4), Pair("Basketball", 3), Pair("Padel", 3)), clubs=listOf(
    ClubDto(
      id="6ca0e1af-24b5-486e-aa42-e966fb0874ff", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ingoal Club", address="C. de Daniel del Olmo González, 8, 47008 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6281219, longitude=-4.7346866,
      type="FOOTBALL",
      types=listOf("FOOTBALL", "TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b24e0109-8206-45a1-ae09-d19ae29088cb_photo.jpg",
      averageRating=4.6, totalRatingsCount=335,
      createdAt="2026-09-01T09:04:11.223126Z", updatedAt="2026-09-01T14:32:02.772988Z",
    ),
    ClubDto(
      id="2e37e3ca-a0ed-444a-9aa7-c418e9f85a91", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sports and Cultural Center Niara", address="Calle Barcelona, 6, 47008 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6201156, longitude=-4.7623469,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3644b202-fc84-4c24-95f8-9816d809d30b_photo.jpg",
      averageRating=4.6, totalRatingsCount=301,
      createdAt="2026-09-01T09:04:59.683539Z", updatedAt="2026-09-01T09:04:59.683539Z",
    ),
    ClubDto(
      id="c1a92541-9086-47f4-839a-26cdd357df7b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pádel Arena Valladolid", address="N-601, 184, 47008 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6001702, longitude=-4.7230366,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5457db18-d9a0-4c47-9a36-f2d170389262_photo.jpg",
      averageRating=4.5, totalRatingsCount=367,
      createdAt="2026-09-01T09:04:36.799176Z", updatedAt="2026-09-01T14:31:59.096981Z",
    ),
    ClubDto(
      id="8fa1180c-8c6c-4498-83a1-2feee837588f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Ciudad Deportiva del Real Valladolid", address="Av. Mundial 82, s/n, 47014 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6440018, longitude=-4.7635596,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bf01f13b-926f-4c7e-9baf-eb885059397a_photo.jpg",
      averageRating=4.4, totalRatingsCount=480,
      createdAt="2026-09-01T09:04:07.600561Z", updatedAt="2026-09-01T09:04:07.600561Z",
    ),
    ClubDto(
      id="6013de1e-5370-4ddd-8113-2231efdb7124", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Raqueta Valladolid", address="C. Padre José Acosta, 2, 47015 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6496928, longitude=-4.7580326,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/697f6978-08ce-4013-92a4-91b99affbd75_photo.jpg",
      averageRating=4.4, totalRatingsCount=431,
      createdAt="2026-09-01T09:04:30.101630Z", updatedAt="2026-09-01T14:31:53.801354Z",
    ),
    ClubDto(
      id="e4efe32a-55d4-4034-8145-aaa64a7fae20", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pabellón Pilar Fernández Valderrama", address="C. Boedo, 7, 47008 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6182022, longitude=-4.7501212,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f50a6db4-1d3e-4480-86f4-78281fcb27bd_photo.jpg",
      averageRating=4.4, totalRatingsCount=654,
      createdAt="2026-09-01T09:04:24.323346Z", updatedAt="2026-09-01T09:04:24.323346Z",
    ),
    ClubDto(
      id="b8b2e860-c141-40a7-a1b5-18b58fd32c9f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="The Players", address="C. Vázquez de Menchaca, 23, 47008 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6181543, longitude=-4.7353613,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/12190370-ba0e-4e4d-ae85-ca7af8fccb79_photo.jpg",
      averageRating=4.3, totalRatingsCount=288,
      createdAt="2026-09-01T09:04:45.276294Z", updatedAt="2026-09-01T09:04:45.276294Z",
    ),
    ClubDto(
      id="f036987d-827d-47cf-a01a-0e9f4dcfa1a0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Complejo Deportivo Luis Minguela", address="P.º Obregón, 6B, 47009 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.66539, longitude=-4.7325868,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b6bb56d0-32cb-427a-8b1d-58d704b4f0fe_photo.jpg",
      averageRating=4.1, totalRatingsCount=333,
      createdAt="2026-09-01T09:04:15.604142Z", updatedAt="2026-09-01T09:04:15.604142Z",
    ),
    ClubDto(
      id="dbfc6fb4-381c-4a9c-9a8e-076365309217", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pabellón Polideportivo Pisuerga", address="Pl. de México, S/N, 47014 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6315346, longitude=-4.7451339,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b79409bd-b6ab-419f-8803-9d544f525e17_photo.jpg",
      averageRating=4.1, totalRatingsCount=2032,
      createdAt="2026-09-01T09:04:53.607433Z", updatedAt="2026-09-01T09:04:53.607433Z",
    ),
    ClubDto(
      id="ca745f2b-c952-4a8d-9899-0987dc16287f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padeld10z", address="Club Padeld10z, C. Industrias, 7, 47195 Arroyo de la Encomienda, Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6239823, longitude=-4.7730469,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/df833fde-96f7-408e-a49f-90f6d8964c36_photo.jpg",
      averageRating=4.1, totalRatingsCount=475,
      createdAt="2026-09-01T09:04:41.292367Z", updatedAt="2026-09-01T09:04:41.292367Z",
    ),
    ClubDto(
      id="04fa2c5b-ac9d-48a7-a295-c4a367d40ade", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Polideportivo Huerta del Rey", address="C. de Joaquín Velasco Martín, 9, 47014 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6478257, longitude=-4.7385843,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9201127b-0c61-4d94-a105-56093946ace9_photo.jpg",
      averageRating=4.1, totalRatingsCount=1528,
      createdAt="2026-09-01T09:03:50.579298Z", updatedAt="2026-09-01T09:03:50.579298Z",
    ),
    ClubDto(
      id="b47559af-9f92-47d6-9d28-336c1721b08a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="polideportivo miriam blasco", address="C. Covadonga, 16, 47011 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6563796, longitude=-4.7130242,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c3d313fb-0c93-45c4-aea2-a597d08507bd_photo.jpg",
      averageRating=4.1, totalRatingsCount=284,
      createdAt="2026-09-01T09:05:05.128040Z", updatedAt="2026-09-01T09:05:05.128040Z",
    ),
    ClubDto(
      id="ca6911a7-7b41-4368-b27d-74156b049882", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CDO Covaresa | Tu club de deporte y ocio en Valladolid", address="C. Felipe Sánchez Román, s/n, 47008 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6127014, longitude=-4.7491893,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e41133a7-171d-4ea0-b600-945f8362a833_photo.jpg",
      averageRating=4.0, totalRatingsCount=2049,
      createdAt="2026-09-01T09:04:20.062014Z", updatedAt="2026-09-01T09:04:20.062014Z",
    ),
    ClubDto(
      id="17486788-5d34-4559-bcfc-d0a67d4939df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Lasa Sport", address="Carr. de Rueda, 187, 47008 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6029253, longitude=-4.7540321,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4be1e74-1441-4d79-aea7-66bba4a3b433_photo.jpg",
      averageRating=4.0, totalRatingsCount=832,
      createdAt="2026-09-01T09:04:00.401289Z", updatedAt="2026-09-01T09:04:00.401289Z",
    ),
    ClubDto(
      id="f41781d4-aaf9-4c3d-87cc-7230b435ce6b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Pádel Las Norias", address="Parque de las Norias de Sta. Victoria, 47008 Valladolid",
      city="Valladolid", country="ES",
      latitude=41.6338571, longitude=-4.733897,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/19e2fa0b-602c-467e-a814-9232aa2be501_photo.jpg",
      averageRating=4.0, totalRatingsCount=224,
      createdAt="2026-09-01T09:04:49.918320Z", updatedAt="2026-09-01T09:04:49.918320Z",
    ),
  )),
  CitySeo(slug="vinnytsia", name="Vinnytsia", country="UA", clubCount=15, sports=listOf(Pair("Football", 4), Pair("Tennis", 3), Pair("Billiards", 2), Pair("Padel", 2), Pair("Karting", 1), Pair("Bowling", 1), Pair("Basketball", 1), Pair("Paintball", 1)), clubs=listOf(
    ClubDto(
      id="d983d911-1c26-43d2-8499-573d9ad316fc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="River Club Vin", address="вулиця Миколи Оводова, 64, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2284638, longitude=28.4699637,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d3bf8a4e-ed35-43cf-bd18-5be5a0d37fe7_ChIJH3wSItZb_0.jpg",
      averageRating=4.9, totalRatingsCount=88,
      createdAt="2026-08-30T17:18:10.895219Z", updatedAt="2026-08-30T20:52:22.152673Z",
    ),
    ClubDto(
      id="21cc8db7-ed41-4cf1-9785-b49ccd320ba0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Hall", address="пров. Василя Стефаника, 6, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2042949, longitude=28.4269555,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5a5260ea-3d0e-4dd1-b078-aebba43818b3_ChIJ35UIi3Fb_0.jpg",
      averageRating=4.8, totalRatingsCount=76,
      createdAt="2026-08-30T17:18:27.359414Z", updatedAt="2026-08-30T20:52:24.528897Z",
    ),
    ClubDto(
      id="acd69e53-89a7-4f9b-8b04-97fe4e5aba57", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спарта", address="вулиця Магістратська, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2368169, longitude=28.4513698,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a1934716-2120-403c-9b6d-8e8306222db6_ChIJhwgPnYRc_2.jpg",
      averageRating=4.7, totalRatingsCount=229,
      createdAt="2026-08-30T17:18:03.703743Z", updatedAt="2026-08-31T22:11:26.616423Z",
    ),
    ClubDto(
      id="71d5d8b3-3cc4-4159-af78-82212e433418", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісний клуб Бомонд", address="вул. Діонісія Міклера, 32 А, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2487258, longitude=28.4584941,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3212c649-f37a-4b43-b37f-ee8c55587e32_ChIJVVUmb6Jc_0.jpg",
      averageRating=4.7, totalRatingsCount=56,
      createdAt="2026-08-30T17:18:34.929910Z", updatedAt="2026-08-30T20:52:51.887536Z",
    ),
    ClubDto(
      id="bc76b76e-09f2-4340-b8ad-9fd1ee390b34", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="City", address="Хмельницьке шосе, 85, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2339464, longitude=28.4178607,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0ac4df23-5fa2-4732-83f6-e9538e55e4a8_ChIJn5rTTF5c_0.jpg",
      averageRating=4.5, totalRatingsCount=662,
      createdAt="2026-08-30T17:17:24.193226Z", updatedAt="2026-08-30T20:52:10.319412Z",
    ),
    ClubDto(
      id="8efc9b5f-b451-4e82-8257-c8ede2078204", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Колос", address="вулиця Генерала Арабея, 3А, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2393963, longitude=28.4396282,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77902cb9-61ec-4bc7-b6b2-3bdaea05da2e_ChIJn3S6a45c_0.jpg",
      averageRating=4.5, totalRatingsCount=167,
      createdAt="2026-08-30T17:16:55.194625Z", updatedAt="2026-08-30T20:52:35.000342Z",
    ),
    ClubDto(
      id="8fd3fc92-7928-41cc-bb18-65ef8866ef37", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пиво та Блюз", address="вулиця 600-річчя, 60, Вінниця, 21027 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2229488, longitude=28.4260569,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6d6d0d8d-8d0b-4b58-b223-ea12820b9149_ChIJ-y92-m9c_0.jpg",
      averageRating=4.5, totalRatingsCount=2146,
      createdAt="2026-08-30T17:17:17.045491Z", updatedAt="2026-08-30T20:52:44.119671Z",
    ),
    ClubDto(
      id="ffb75717-85a5-402a-8b4a-0833e13ae15a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Knockout", address="вулиця Батозька, 2, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2462313, longitude=28.5080543,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/37b504d6-1f72-4554-bdb8-ce2bb5a5bd32_ChIJFzWiBjlb_0.jpg",
      averageRating=4.4, totalRatingsCount=1396,
      createdAt="2026-08-30T17:16:47.090391Z", updatedAt="2026-08-30T20:52:16.302948Z",
    ),
    ClubDto(
      id="db106b00-3069-45c9-93a1-18a0530d99d4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Вінницький міський палац дітей та юнацтва ім. Лялі Ратушної", address="Хмельницьке шосе, 22, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2348322, longitude=28.4406058,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e7699051-db01-44fa-af54-c063c7e37b3d_ChIJmVJYH4Zc_0.jpg",
      averageRating=4.4, totalRatingsCount=115,
      createdAt="2026-08-30T17:17:09.479433Z", updatedAt="2026-08-30T20:52:29.499702Z",
    ),
    ClubDto(
      id="b822a17c-c927-4e8a-968c-23899aca9af8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="SPORT CLUB 493", address="вулиця Пирогова, 71а, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2212448, longitude=28.4454955,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c7f3be82-c00b-4ce9-bae1-d51923cc73e4_ChIJBWeg-jpb_0.jpg",
      averageRating=5.0, totalRatingsCount=42,
      createdAt="2026-08-30T17:18:19.481429Z", updatedAt="2026-08-30T20:52:22.706314Z",
    ),
    ClubDto(
      id="10fde854-c533-4da6-b66a-383187213938", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Люди Fusion Place", address="вулиця 600-річчя, 17, Вінниця, Вінницька область, 21000",
      city="Vinnytsia", country="UA",
      latitude=49.2278093, longitude=28.4273512,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1bbe2be8-6f10-4d3b-a305-b49f9309cbfe_photo.jpg",
      averageRating=4.2, totalRatingsCount=2607,
      createdAt="2026-08-31T15:52:36.983516Z", updatedAt="2026-08-31T15:52:36.983516Z",
    ),
    ClubDto(
      id="76e578bc-2c98-45d8-a0c8-21bf80731155", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Комунальний заклад вищої освіти \"Вінницький гуманітарно-педагогічний коледж\"", address="вулиця Нагірна, 13, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2116952, longitude=28.4551766,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e3941e87-10d5-408c-a5b8-502091bb5ead_ChIJn0nqoZFb_0.jpg",
      averageRating=4.0, totalRatingsCount=148,
      createdAt="2026-08-30T17:17:01.747891Z", updatedAt="2026-08-30T20:52:35.268186Z",
    ),
    ClubDto(
      id="7274184e-37f0-4e27-aab4-a5c587c5a319", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="GT karting club. Epic", address="вулиця Батозька, 1-В, Вінниця, 21001 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2449195, longitude=28.5095268,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3ae593c7-1bb1-4fa5-977f-2b135f4310eb_ChIJA0ii_5Rb_0.jpg",
      averageRating=4.0, totalRatingsCount=36,
      createdAt="2026-08-30T17:17:55.717634Z", updatedAt="2026-08-30T20:52:14.011993Z",
    ),
    ClubDto(
      id="7d8362ad-3b4f-4f84-a7b9-fb8097b6ae62", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Теннисный корт", address="вулиця Академіка Янгеля, 59, Вінниця, 21000 Vinnytsia, Ukraine",
      city="Vinnytsia", country="UA",
      latitude=49.2431192, longitude=28.4835681,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6284bf4e-400a-42f5-be72-f7a91c1bc9ab_ChIJHRDzGV1b_0.jpg",
      averageRating=4.5, totalRatingsCount=32,
      createdAt="2026-08-30T17:18:39.644734Z", updatedAt="2026-08-30T20:52:50.964951Z",
    ),
    ClubDto(
      id="91e1d67a-b03f-4e76-9ad3-3fe0a4ba8f90", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="СК \"INVICTUS\"", address="вулиця Олександра Соловйова, 7, Вінниця, Вінницька область, 21000",
      city="Vinnytsia", country="UA",
      latitude=49.2322179, longitude=28.472609,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fdca00c2-5d9c-4627-8be2-399ff4c1c4d5_photo.png",
      averageRating=5.0, totalRatingsCount=12,
      createdAt="2026-08-31T15:52:25.232538Z", updatedAt="2026-08-31T15:52:25.232538Z",
    ),
  )),
  CitySeo(slug="chernivtsi", name="Chernivtsi", country="UA", clubCount=15, sports=listOf(Pair("Climbing", 2), Pair("Bowling", 2), Pair("Billiards", 2), Pair("Paintball", 2), Pair("Football", 2), Pair("Tennis", 2), Pair("Laser Tag", 1), Pair("Basketball", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="22f38a80-d913-4259-a583-f29387939b82", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Дитяча секція баскетбольний клуб \"STAR BASKET\"", address="вулиця Воробкевича, 19, вулиця Павла Каспрука, 2, Чернівці, Чернівецька область, 58000",
      city="Chernivtsi", country="UA",
      latitude=48.2741824, longitude=25.922372,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/244a6d02-951a-4d1e-aa45-6c5a51af962f_photo.jpg",
      averageRating=5.0, totalRatingsCount=52,
      createdAt="2026-08-31T15:56:41.527766Z", updatedAt="2026-08-31T15:56:41.527766Z",
    ),
    ClubDto(
      id="578e991b-f1a0-4ca8-beb6-11e574d89fd9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісний клуб Cactus", address="вулиця Південно-Кільцева, 45а, Чернівці, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.2562611, longitude=25.9703035,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f63d6870-8419-4303-b5c2-29c1dac1a451_ChIJZ-_B9KYJ_0.jpg",
      averageRating=5.0, totalRatingsCount=75,
      createdAt="2026-08-30T17:23:06.101049Z", updatedAt="2026-08-30T20:52:51.764054Z",
    ),
    ClubDto(
      id="3030512a-5a48-4296-8b55-1f10ed148027", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбол лазертаг Чернівці Warriors", address="вулиця Залозецького, 97 б, Чернівці, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.2837169, longitude=25.9578786,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b4a77577-993a-427d-aed7-8594c6e971d3_ChIJYVVXDOAH_0.jpg",
      averageRating=4.8, totalRatingsCount=153,
      createdAt="2026-08-30T17:22:49.858085Z", updatedAt="2026-08-30T20:52:42.500446Z",
    ),
    ClubDto(
      id="fb42e52e-1742-4ec6-9bd0-bfb551ff6179", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стадіон Олімпія", address="вулиця Воробкевича, 6, Чернівці, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.2552076, longitude=25.9443533,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6c41e1f3-9498-4d82-8997-6b8c5ae85e30_ChIJE9UvKy8P_0.jpg",
      averageRating=4.5, totalRatingsCount=610,
      createdAt="2026-08-30T17:21:41.144144Z", updatedAt="2026-08-30T20:52:49.382101Z",
    ),
    ClubDto(
      id="a6d36cc3-ff77-4513-a6e4-74c9e0ebc735", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="КАРАМБОЛЬ", address="проспект Незалежності, 108, Чернівці, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.2718133, longitude=25.9235531,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f8820c95-189e-478c-8694-9cb24d32485b_ChIJW_SDmrMI_0.jpg",
      averageRating=4.4, totalRatingsCount=77,
      createdAt="2026-08-30T17:22:34.755071Z", updatedAt="2026-08-30T20:52:32.448159Z",
    ),
    ClubDto(
      id="e9a49ec8-5488-41a9-b9d3-e2ef01f868b1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пафос Більярдний Клуб", address="вул. Стасюка, 1А, Чернівці, 58005 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.2715607, longitude=25.9405764,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9227ab84-ec1d-43c6-9eda-776e30f0fd3d_ChIJT3uyG8kI_0.jpg",
      averageRating=4.4, totalRatingsCount=386,
      createdAt="2026-08-30T17:22:11.507519Z", updatedAt="2026-08-30T20:52:41.894290Z",
    ),
    ClubDto(
      id="9f2ba0ad-e367-4dc5-97fc-43d9b44c1292", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Бартка", address="Головна вулиця, 124, Чернівці, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.2710375, longitude=25.9464415,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/50ef18b5-e504-4e8e-b9d4-ed146e49cc3e_ChIJFWfgBM8I_0.jpg",
      averageRating=4.3, totalRatingsCount=3130,
      createdAt="2026-08-30T17:22:26.748608Z", updatedAt="2026-08-30T20:52:27.719334Z",
    ),
    ClubDto(
      id="ad08e604-64fd-4ac6-a6de-1df271ed642e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Більярдний клуб 8", address="вулиця Героїв Майдану, 99А, Чернівці, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.2594724, longitude=25.931755,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cb7c3910-d2bf-46f8-8c77-5b4282b7f433_ChIJhxkMMzEP_0.jpg",
      averageRating=4.3, totalRatingsCount=118,
      createdAt="2026-08-30T17:22:20.301762Z", updatedAt="2026-08-30T20:52:28.746583Z",
    ),
    ClubDto(
      id="3a5ae182-a824-4af3-b825-82d1b3be1628", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг-клуб.Черновцы", address="Татарбунарська вулиця, Чернівці, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.256126, longitude=25.9436742,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2ed939da-bc6d-4a5c-9598-42d2bf0c4b0d_ChIJz8tLk1AP_0.jpg",
      averageRating=4.3, totalRatingsCount=72,
      createdAt="2026-08-30T17:22:42.437964Z", updatedAt="2026-08-30T20:52:33.592749Z",
    ),
    ClubDto(
      id="0a8714d8-c4a0-4dbd-a839-3e4b3377a8f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Штучне футбольне поле (ЗОШ 33)", address="вулиця Героїв Майдану, 152А, Чернівці, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.2737397, longitude=25.9271675,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d6fd5afb-b9ac-4482-8851-bab4e9e53c0d_ChIJG1MvQLEI_0.jpg",
      averageRating=4.3, totalRatingsCount=71,
      createdAt="2026-08-30T17:21:48.919231Z", updatedAt="2026-08-30T20:52:55.054964Z",
    ),
    ClubDto(
      id="d4072772-c980-43ef-a897-9edab00f6cfb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Центр спортивного пейнтболу \"Warriors\"", address="вулиця Хотинська, 43, Чернівці, Чернівецька, ТРЦ\"Панорама, Chernivtsi, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.3224026, longitude=25.9496904,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4b6d483d-765d-412d-814d-1566cf844e6f_ChIJKUdRfN8H_0.jpg",
      averageRating=4.9, totalRatingsCount=41,
      createdAt="2026-08-30T17:22:57.914833Z", updatedAt="2026-08-30T20:52:54.544509Z",
    ),
    ClubDto(
      id="e6a4e6b5-ba99-4f79-a69f-ab249f3ee457", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ТЕНІСНІ КОРТИ ЧЕРНІВ. ОБЛ. ДЮСШ", address="вулиця Ольги Гузар, 2, Чернівці, 58000 Chernivtsi, Ukraine",
      city="Chernivtsi", country="UA",
      latitude=48.275737, longitude=25.939919,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7a5860e7-e23d-4724-8515-5bd66af0a1b4_ChIJCZJN5ccI_0.jpg",
      averageRating=4.2, totalRatingsCount=45,
      createdAt="2026-08-30T17:23:14.170294Z", updatedAt="2026-08-30T20:52:50.188985Z",
    ),
    ClubDto(
      id="f67e9a43-ddc5-41aa-a3f6-f0bee00c8a76", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Арена лазерних боїв «LASERTAG»", address="проспект Степана Бандери, 34В, Київ, 04073",
      city="Chernivtsi", country="UA",
      latitude=50.4863848, longitude=30.5200061,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/65a358ef-2437-41e1-b727-9c67cfe7bd2b_photo.jpg",
      averageRating=5.0, totalRatingsCount=27,
      createdAt="2026-08-31T15:57:06.381253Z", updatedAt="2026-08-31T15:57:06.381253Z",
    ),
    ClubDto(
      id="18519384-7e75-4be6-90fe-767f62a67027", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="King Kong | Воркаут • Акробатика • Повітряна гімнастика", address="Заводська вулиця, 14в, Чернівці, Чернівецька область, 58000",
      city="Chernivtsi", country="UA",
      latitude=48.3192553, longitude=25.9233424,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c0d82569-2efb-4743-a196-dc9127e2059a_photo.jpg",
      averageRating=5.0, totalRatingsCount=19,
      createdAt="2026-08-31T15:56:58.667283Z", updatedAt="2026-08-31T15:56:58.667283Z",
    ),
    ClubDto(
      id="662f6260-ab65-4672-81ce-075d63284eaf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Climbing gym “The SKY”/Скеледром", address="вулиця Лесі Українки, 1, Чернівці, Чернівецька область, 58000",
      city="Chernivtsi", country="UA",
      latitude=48.2890066, longitude=25.9304293,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d70918f2-5197-4c74-9d31-055c79fbb649_photo.jpg",
      averageRating=5.0, totalRatingsCount=6,
      createdAt="2026-08-31T15:56:50.552882Z", updatedAt="2026-08-31T15:56:50.552882Z",
    ),
  )),
  CitySeo(slug="zhytomyr", name="Zhytomyr", country="UA", clubCount=15, sports=listOf(Pair("Football", 4), Pair("Paintball", 2), Pair("Billiards", 2), Pair("Karting", 2), Pair("Bowling", 1), Pair("Tennis", 1), Pair("Climbing", 1), Pair("Basketball", 1), Pair("Padel", 1)), clubs=listOf(
    ClubDto(
      id="fa097164-4769-4d7b-ba7d-c6a0c896c75c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Фітнес зал TRX-club Pantera", address="вулиця Мала Бердичівська, 17, Житомир, 10001 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2523699, longitude=28.6625463,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/5e980488-c038-4307-818c-bad9f78b2ce9_ChIJ11Rjj6Jk_2.jpg",
      averageRating=4.8, totalRatingsCount=127,
      createdAt="2026-08-30T17:33:46.413709Z", updatedAt="2026-08-31T22:11:28.136513Z",
    ),
    ClubDto(
      id="88aed1b3-2394-4b3a-b286-2cd2bb9e9821", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="skGRAD пейнтбол Житомир", address="вул. Кооперативна, 5, Тетерівка, 12420 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2343269, longitude=28.5444783,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ab51f605-c4ea-43d1-a889-1da2a5aac7dc_ChIJRyF_cuZl_0.jpg",
      averageRating=4.7, totalRatingsCount=127,
      createdAt="2026-08-30T17:33:31.563447Z", updatedAt="2026-08-30T20:52:25.795496Z",
    ),
    ClubDto(
      id="12a37d5b-40ed-4c3d-b48c-9895e3fc552a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Центральний міський стадіон «Полісся»", address="вулиця Фещенка-Чопівського, 18, Житомир, 10001 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2460929, longitude=28.6691055,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/89ff523a-1b54-4eb4-8e88-bb10d4990a91_ChIJ0Wp6o4Rk_0.jpg",
      averageRating=4.4, totalRatingsCount=290,
      createdAt="2026-08-30T17:32:23.251685Z", updatedAt="2026-08-30T20:52:54.797671Z",
    ),
    ClubDto(
      id="0c9ca9c4-79a3-47d1-9e0b-9afb7d3b8a80", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Liberty Hall", address="вулиця Київська, 77, Житомир, 10002 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2668668, longitude=28.6851873,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/031d11b4-d0ce-4eb0-9a03-4810a929ec16_ChIJpatgla9k_0.jpg",
      averageRating=4.2, totalRatingsCount=664,
      createdAt="2026-08-30T17:32:59.768006Z", updatedAt="2026-08-30T20:52:17.308155Z",
    ),
    ClubDto(
      id="ee85e3cc-bdc7-493d-b757-6f1b6891a7e1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Епіцентр", address="Київське шосе, 4/2, Житомир, 10001 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2701247, longitude=28.700451,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b2015dca-02e2-48f8-8df1-35b31e7f00e0_ChIJC4gaCIFl_0.jpg",
      averageRating=4.1, totalRatingsCount=2786,
      createdAt="2026-08-30T17:32:09.293533Z", updatedAt="2026-08-30T20:52:31.846702Z",
    ),
    ClubDto(
      id="7dd88dbc-12fd-44e0-a13a-34c855d8c9cb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="СПОРТТОВАРИ, АОЗТ", address="вулиця Михайлівська, 21, Житомир, 10001 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2562556, longitude=28.6641921,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/bbab71fa-c338-4e92-a1c4-3f7b073729d5_ChIJ0ar0kpZk_0.jpg",
      averageRating=4.1, totalRatingsCount=295,
      createdAt="2026-08-30T17:32:16.651114Z", updatedAt="2026-08-30T20:52:45.616818Z",
    ),
    ClubDto(
      id="d8e0b19f-9cc6-4b82-8c47-c03d9802dabc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Megasport", address="ТРЦ Глобал UA, вулиця Київська, 77, 1-й поверх, Житомир, 10001 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2662864, longitude=28.6859482,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/43309516-6c69-4c6f-8ddc-f54425790b85_ChIJBeXilK9k_3.jpg",
      averageRating=4.0, totalRatingsCount=174,
      createdAt="2026-08-30T17:32:30.317058Z", updatedAt="2026-08-31T22:11:18.952962Z",
    ),
    ClubDto(
      id="92e9587b-6e9c-4b6f-8f29-45cd0e737b7f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Більярдний клуб \"Атмосфера\" new format", address="вулиця Михайла Грушевського, 5, Житомир, 10001 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2606596, longitude=28.6601235,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/77b3af30-bee5-41ec-868b-fe0ac6cafd71_ChIJV8KKRY9l_0.jpg",
      averageRating=4.0, totalRatingsCount=102,
      createdAt="2026-08-30T17:32:44.444481Z", updatedAt="2026-08-30T20:52:28.343211Z",
    ),
    ClubDto(
      id="b7a213aa-6bef-45de-860a-150dadac507f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Більярдний клуб «Ріо»", address="вулиця Покровська, 135, 2й поверх, Житомир, 10001 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2831729, longitude=28.6550145,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b88e0eb5-4ab7-4da4-86e9-635ca765c88f_ChIJ6YC_S7ll_2.jpg",
      averageRating=4.7, totalRatingsCount=35,
      createdAt="2026-08-30T17:32:51.948515Z", updatedAt="2026-08-31T22:11:24.770346Z",
    ),
    ClubDto(
      id="697a333a-5605-4a46-abcc-e9a3be3ba923", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг-центр Adrenalinе KART", address="Київське шосе, 44в, Житомир, 10000 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2801959, longitude=28.7217232,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d72822df-e59e-432c-abd1-276529eb67bf_ChIJ6w65B_R9_0.jpg",
      averageRating=4.7, totalRatingsCount=35,
      createdAt="2026-08-30T17:33:15.685534Z", updatedAt="2026-08-30T20:52:33.725452Z",
    ),
    ClubDto(
      id="e2dbb8f5-820d-4ece-9ba0-b444ccbecd43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="КартСіті", address="вулиця Київська, 87, Житомир, 10001 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2679001, longitude=28.6901314,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a3654fff-930d-4e93-82ff-3ab6538a3b9e_ChIJn2apJwBl_0.jpg",
      averageRating=5.0, totalRatingsCount=25,
      createdAt="2026-08-30T17:33:23.024357Z", updatedAt="2026-08-30T20:52:32.569181Z",
    ),
    ClubDto(
      id="7c405703-244c-4517-bd09-48bed2d3f518", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Страйкбольний/пейнтбольний ігровий майданчик \"Едельвейс\"", address="вул. Жуйка, 45 (кінець дороги), Житомир, 10001 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2352878, longitude=28.6814121,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8cf96c4b-f901-4a18-9e26-459998461ee5_ChIJSXdcVXhj_0.jpg",
      averageRating=4.8, totalRatingsCount=26,
      createdAt="2026-08-30T17:33:39.296947Z", updatedAt="2026-08-30T20:52:49.761118Z",
    ),
    ClubDto(
      id="e1207c39-d58e-4e19-9d5d-d533c1ceba99", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Архів", address="Мальованська набережна, Житомир, 10002 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2536605, longitude=28.6502409,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f8b8889d-c167-44b0-90ea-5c608ebe3605_ChIJZ34PtZJk_0.jpg",
      averageRating=4.3, totalRatingsCount=25,
      createdAt="2026-08-30T17:33:07.301430Z", updatedAt="2026-08-30T20:52:27.204419Z",
    ),
    ClubDto(
      id="d18aa6ca-79cf-4ca0-82a5-458774b38deb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="TMS HUB Zhytomyr", address="вулиця Київська, 16а, Житомир, 10001 Zhytomyr, Ukraine",
      city="Zhytomyr", country="UA",
      latitude=50.2555652, longitude=28.66354,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f83da3c7-890e-4245-8131-a6e5e923c09a_ChIJCzZbLqFs_0.jpg",
      averageRating=5.0, totalRatingsCount=20,
      createdAt="2026-08-30T17:33:53.297289Z", updatedAt="2026-08-30T20:52:24.080052Z",
    ),
    ClubDto(
      id="1fcd25f5-c481-4025-99f8-56fc076e6fda", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спортивна школа №1", address="вулиця Домбровського, 11А, Житомир, Житомирська область, 10001",
      city="Zhytomyr", country="UA",
      latitude=50.267623, longitude=28.65368,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6427c7ac-39d1-4b2a-aaf2-b4c089f9469a_photo.jpg",
      averageRating=4.7, totalRatingsCount=9,
      createdAt="2026-08-31T15:53:09.913466Z", updatedAt="2026-08-31T15:53:09.913466Z",
    ),
  )),
  CitySeo(slug="rivne", name="Rivne", country="UA", clubCount=14, sports=listOf(Pair("Basketball", 2), Pair("Volleyball", 2), Pair("Paintball", 2), Pair("Climbing", 2), Pair("Karting", 1), Pair("Billiards", 1), Pair("Tennis", 1), Pair("Football", 1), Pair("Padel", 1), Pair("Bowling", 1)), clubs=listOf(
    ClubDto(
      id="1e4d2a00-62bd-4c3a-ba24-4e91da082012", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="WOD ZONE GYM", address="вулиця Петра Могили, 28, Рівне, Рівненська область, 33000",
      city="Rivne", country="UA",
      latitude=50.6183207, longitude=26.2255944,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/01886203-1366-4483-a8fa-73ff37e12217_photo.jpg",
      averageRating=4.8, totalRatingsCount=158,
      createdAt="2026-08-31T16:01:31.693077Z", updatedAt="2026-08-31T16:01:31.693077Z",
    ),
    ClubDto(
      id="e5c37683-60e6-40eb-a36c-e944ec6a8d16", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Будокан", address="вулиця Академіка Грушевського, 41, Рівне, Рівненська область, 33000",
      city="Rivne", country="UA",
      latitude=50.6218373, longitude=26.2731887,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f69ab274-f105-460a-a44b-dfd42116a297_photo.png",
      averageRating=4.7, totalRatingsCount=91,
      createdAt="2026-08-31T16:01:48.163902Z", updatedAt="2026-08-31T16:01:48.163902Z",
    ),
    ClubDto(
      id="748ed25d-d841-450d-b139-d75d0513648c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скеледром Козак", address="вулиця Соборна, 420, Рівне, 33004 Rivne, Ukraine",
      city="Rivne", country="UA",
      latitude=50.6372518, longitude=26.2083783,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/673445cf-e055-4c8f-a966-5999df376261_ChIJU2ffJp1s_0.jpg",
      averageRating=4.5, totalRatingsCount=137,
      createdAt="2026-08-30T17:27:21.880826Z", updatedAt="2026-08-30T20:52:46.781971Z",
    ),
    ClubDto(
      id="3e18458e-d371-406b-b45b-920b8e163753", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Софія", address="вулиця Дубенська, 4 А, Велика Омеляна, 35360 Rivne, Ukraine",
      city="Rivne", country="UA",
      latitude=50.5905692, longitude=26.152435,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a4ba0ab9-53c5-4f3a-9b61-681364640a39_ChIJjaNQZAxt_0.jpg",
      averageRating=4.5, totalRatingsCount=2993,
      createdAt="2026-08-30T17:28:06.406216Z", updatedAt="2026-08-30T20:52:47.277687Z",
    ),
    ClubDto(
      id="4df0abb3-ae4f-471f-9a7c-48c4ffa2472c", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Фітнес порт", address="вулиця Княгині Ольги, 6, Рівне, 33000 Rivne, Ukraine",
      city="Rivne", country="UA",
      latitude=50.6148228, longitude=26.2634918,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/90e5af31-4415-4715-a725-1542cb968702_ChIJVffE2kQT_0.jpg",
      averageRating=4.4, totalRatingsCount=704,
      createdAt="2026-08-30T17:27:59.151953Z", updatedAt="2026-08-30T20:52:54.060610Z",
    ),
    ClubDto(
      id="26b56830-50b1-41e0-8196-6840a9be1cf2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Козацький Табір \"Гайдамаки\"", address="вулиця Млинівська, 24, Рівне, 33017 Rivne, Ukraine",
      city="Rivne", country="UA",
      latitude=50.6475569, longitude=26.2087909,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8f4a7a56-a120-459b-8f87-7fa5f805314a_ChIJ_2TUwHtr_0.jpg",
      averageRating=4.3, totalRatingsCount=457,
      createdAt="2026-08-30T17:27:43.998418Z", updatedAt="2026-08-30T20:52:34.744207Z",
    ),
    ClubDto(
      id="167a9b4a-25de-407d-82f8-bc3b391187df", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Піраміда", address="вулиця Василя Червонія, 6, Рівне, 33000 Rivne, Ukraine",
      city="Rivne", country="UA",
      latitude=50.6271077, longitude=26.2663003,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6b96590c-30d9-4683-91ce-fcf229bf593c_ChIJL0oO_6gU_0.jpg",
      averageRating=4.3, totalRatingsCount=166,
      createdAt="2026-08-30T17:26:58.753889Z", updatedAt="2026-08-30T20:52:44.743392Z",
    ),
    ClubDto(
      id="5af35db4-bbd6-4bbf-8009-9124f2def5ba", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Хутір", address="вулиця Дубенська, 11б/1, Рівне, 35360 Rivne, Ukraine",
      city="Rivne", country="UA",
      latitude=50.5850462, longitude=26.1443684,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/cd23000e-cfbb-4fda-b97d-d64f82733aaf_ChIJG7nXpeFs_2.jpg",
      averageRating=4.3, totalRatingsCount=2878,
      createdAt="2026-08-30T17:27:14.106826Z", updatedAt="2026-08-31T22:11:28.347888Z",
    ),
    ClubDto(
      id="c95f67f0-1ace-409e-a692-002ac78e3bdb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="RIVNE KARTING CLUB", address="СЬОМОГО СЕРПНЯ, 3, Вересневе, 33004 Rivne, Ukraine",
      city="Rivne", country="UA",
      latitude=50.5782079, longitude=26.1601154,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d449976e-58ed-4f0f-9da2-630c5d5b7bbb_ChIJR6Q8Gh9t_0.jpg",
      averageRating=4.1, totalRatingsCount=269,
      createdAt="2026-08-30T17:27:36.044200Z", updatedAt="2026-08-30T20:52:21.410571Z",
    ),
    ClubDto(
      id="4bb814fe-fc5f-4fa9-ac7f-4869fd7b830a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Стандарт - дитяча футбольна академія Рівне", address="В’ячеслава, вулиця Вячеслава Чорновола, 49а, Рівне, 33003 Rivne, Ukraine",
      city="Rivne", country="UA",
      latitude=50.6089466, longitude=26.2587424,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e68a7263-5cc5-410c-8bf1-dbd311e32aeb_ChIJqcXCc34V_1.jpg",
      averageRating=4.7, totalRatingsCount=41,
      createdAt="2026-08-30T17:26:49.936268Z", updatedAt="2026-08-31T22:11:27.051769Z",
    ),
    ClubDto(
      id="e4689d78-dc48-4bb0-9fba-8c0e81d4ad34", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Отаман", address="вулиця Вячеслава Чорновола, 174, Рівне, 33028 Rivne, Ukraine",
      city="Rivne", country="UA",
      latitude=50.5782491, longitude=26.2615189,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/91c9f778-6b9b-4968-8074-0a5b3d03dbc0_ChIJ3cSMN09t_0.jpg",
      averageRating=4.0, totalRatingsCount=45,
      createdAt="2026-08-30T17:27:51.158264Z", updatedAt="2026-08-30T20:52:41.309507Z",
    ),
    ClubDto(
      id="e5197026-2292-4b4b-9ac8-87fcc20494c2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Скеледром \"Догори дригом\"", address="вулиця Литовська, 53, Рівне, 33017 Rivne, Ukraine",
      city="Rivne", country="UA",
      latitude=50.6255216, longitude=26.2487472,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9868fadd-6ca9-4550-957a-53804fd6ed76_ChIJveGnRKts_0.jpg",
      averageRating=4.8, totalRatingsCount=25,
      createdAt="2026-08-30T17:27:28.344238Z", updatedAt="2026-08-30T20:52:46.512541Z",
    ),
    ClubDto(
      id="9a89da58-6336-436f-a5b9-82c1066dc931", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Баскетбольний клуб \"Рівне\"", address="вулиця Фабрична, 7, Рівне, Рівненська область, 33016",
      city="Rivne", country="UA",
      latitude=50.6382971, longitude=26.2698713,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/22b98e9e-64e3-45cb-826b-aa2e0f8f5710_photo.jpg",
      averageRating=4.8, totalRatingsCount=11,
      createdAt="2026-08-31T16:01:25.951598Z", updatedAt="2026-08-31T16:01:25.951598Z",
    ),
    ClubDto(
      id="0f1dbaf8-4e8c-4ecb-833f-4a36975e82cb", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Спортивний клуб «Воля» кікбоксинг", address="вулиця Степана Дем'янчука, 1А, Рівне, Рівненська область, 33000",
      city="Rivne", country="UA",
      latitude=50.6108181, longitude=26.2851766,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ca212a55-e2fe-429a-9d16-1d4e262de507_photo.jpg",
      averageRating=5.0, totalRatingsCount=6,
      createdAt="2026-08-31T16:01:39.803874Z", updatedAt="2026-08-31T16:01:39.803874Z",
    ),
  )),
  CitySeo(slug="tirana", name="Tirana", country="AL", clubCount=12, sports=listOf(Pair("Football", 3), Pair("Paintball", 2), Pair("Padel", 1), Pair("Bowling", 1), Pair("Billiards", 1), Pair("Volleyball", 1), Pair("Karting", 1), Pair("Climbing", 1), Pair("Tennis", 1)), clubs=listOf(
    ClubDto(
      id="9290694c-9497-4bb2-b8b7-adc1b837e89f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Tirana", address="Rruga Alajdin Frashëri, Çollak",
      city="Tirana", country="AL",
      latitude=41.3257594, longitude=19.8826282,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a85c312c-031d-4242-9610-a7de7b86a374_photo.jpg",
      averageRating=5.0, totalRatingsCount=129,
      createdAt="2026-09-01T09:17:13.798731Z", updatedAt="2026-09-01T09:17:13.798731Z",
    ),
    ClubDto(
      id="bafdf989-137e-453a-bd74-80836b2955bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BO Bowling Tirana", address="QTU Autostrada Tiranë - Durrës, km 6, Tiranë 1000, Tiranë 1000",
      city="Tirana", country="AL",
      latitude=41.3529097, longitude=19.7485948,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/edc3d901-5683-40fc-bf71-4aabd9a917ce_photo.jpg",
      averageRating=4.9, totalRatingsCount=4764,
      createdAt="2026-09-01T09:16:53.339419Z", updatedAt="2026-09-01T09:16:53.339419Z",
    ),
    ClubDto(
      id="abc2df32-f15d-44fa-8538-414a7ece57b7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bilardo Tirona", address="Rruga Abdyl Frashëri, Tiranë 1000",
      city="Tirana", country="AL",
      latitude=41.3187267, longitude=19.8160475,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d7f0953e-8172-42cb-845c-e66d6999c391_photo.jpg",
      averageRating=4.9, totalRatingsCount=67,
      createdAt="2026-09-01T09:17:02.057214Z", updatedAt="2026-09-01T09:17:02.057214Z",
    ),
    ClubDto(
      id="9b3d498d-46ca-403e-99f1-352c0ff40a23", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Paintball Zone Mëzez", address="Rruga 7 Nëntori, Mezez",
      city="Tirana", country="AL",
      latitude=41.340773, longitude=19.763553,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b323aa88-5f37-4629-a729-663ca2b92f89_photo.jpg",
      averageRating=4.9, totalRatingsCount=375,
      createdAt="2026-09-01T09:17:09.314274Z", updatedAt="2026-09-01T09:17:09.314274Z",
    ),
    ClubDto(
      id="0bebba2c-5fc0-462d-9c56-c7dc7c236f9e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Albania Padel Group Shpk", address="DR RURALE 1, STERMAS, Tirane 1001",
      city="Tirana", country="AL",
      latitude=41.2700718, longitude=19.8374862,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/428def7e-c181-46db-abc0-89a400d5acc4_photo.jpg",
      averageRating=4.8, totalRatingsCount=119,
      createdAt="2026-09-01T09:16:40.740590Z", updatedAt="2026-09-01T09:16:40.740590Z",
    ),
    ClubDto(
      id="656e4137-9b36-4e93-a9ce-676b4b0aebe7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Kompleksi Sportiv Arena", address="Rruga Gani Toptani 9, Tiranë",
      city="Tirana", country="AL",
      latitude=41.3353612, longitude=19.7671841,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/33eb0e4e-628e-469c-bfa3-5f61dfaea72a_photo.jpg",
      averageRating=4.8, totalRatingsCount=77,
      createdAt="2026-09-01T09:16:31.852273Z", updatedAt="2026-09-01T09:16:31.852273Z",
    ),
    ClubDto(
      id="260fcbf5-4d62-4647-9d44-b858bfc451e0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Arena Kombëtare", address="Sheshi Italia 1, Tiranë",
      city="Tirana", country="AL",
      latitude=41.3183673, longitude=19.8238974,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d71eb674-4aa1-41d9-a306-4ace202d5a85_photo.jpg",
      averageRating=4.7, totalRatingsCount=2823,
      createdAt="2026-09-01T09:16:23.227460Z", updatedAt="2026-09-01T09:16:23.227460Z",
    ),
    ClubDto(
      id="9292d123-f4e0-4a42-bfaf-3854596cb7bf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="FOOTBALL REPUBLIC by Redi Jupi", address="Barbas",
      city="Tirana", country="AL",
      latitude=41.271194, longitude=19.9072383,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/59229aed-d8a1-4ad9-8850-f0476ff82fc4_photo.jpg",
      averageRating=4.7, totalRatingsCount=108,
      createdAt="2026-09-01T09:16:28.158136Z", updatedAt="2026-09-01T09:16:28.158136Z",
    ),
    ClubDto(
      id="d93fecc1-48c7-4ddd-a5ef-d389557619b5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Rock Tirana Climbing Gym", address="A, Tiranë",
      city="Tirana", country="AL",
      latitude=41.3227093, longitude=19.8297192,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fab644f1-3b7b-45ed-9e72-d5275d6bc06e_photo.jpg",
      averageRating=4.7, totalRatingsCount=116,
      createdAt="2026-09-01T09:16:57.021820Z", updatedAt="2026-09-01T09:16:57.021820Z",
    ),
    ClubDto(
      id="6c39bcd5-bac9-4687-b66f-2b443c8e0b94", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KARTODROM Tirana", address="Vaqarr, Rruga ALBATRANS, Tiranë",
      city="Tirana", country="AL",
      latitude=41.3121393, longitude=19.7502379,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c6430532-2630-4198-aea6-29c2643f60b1_photo.jpg",
      averageRating=4.2, totalRatingsCount=376,
      createdAt="2026-09-01T09:16:48.199374Z", updatedAt="2026-09-01T09:16:48.199374Z",
    ),
    ClubDto(
      id="6bb45388-5c4c-487f-a82d-a1d70453c800", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tenis Tirana", address="8RF8+M26, Rruga Reshit Çollaku, Tiranë",
      city="Tirana", country="AL",
      latitude=41.3241702, longitude=19.8150307,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/614cf223-eefb-4c6f-9166-bf4ab1ac12da_photo.jpg",
      averageRating=4.8, totalRatingsCount=40,
      createdAt="2026-09-01T09:16:35.777861Z", updatedAt="2026-09-01T09:16:35.777861Z",
    ),
    ClubDto(
      id="5f6c9fc6-91ac-4c9e-9802-d9479eb46242", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Club Albania", address="Bulevardi Bajram Curri, Tiranë 1001",
      city="Tirana", country="AL",
      latitude=41.3209495, longitude=19.8048143,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4bda15d9-df8e-4669-a076-ccd271d72fc0_photo.jpg",
      averageRating=4.6, totalRatingsCount=21,
      createdAt="2026-09-01T09:16:43.952586Z", updatedAt="2026-09-01T09:16:43.952586Z",
    ),
  )),
  CitySeo(slug="reykjavik", name="Reykjavik", country="IS", clubCount=12, sports=listOf(Pair("Football", 4), Pair("Golf", 2), Pair("Volleyball", 2), Pair("Karting", 1), Pair("Billiards", 1), Pair("Tennis", 1), Pair("Basketball", 1)), clubs=listOf(
    ClubDto(
      id="960a1b21-b1ac-4574-b83d-a6f002f6456a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Brautarholt Golf Club", address="Brautarholt, 162 Reykjavík",
      city="Reykjavik", country="IS",
      latitude=64.2358725, longitude=-21.8812551,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/864404a8-1824-4281-9615-8d5e50a5c2bb_photo.jpg",
      averageRating=4.8, totalRatingsCount=129,
      createdAt="2026-09-01T09:13:52.694966Z", updatedAt="2026-09-01T09:13:52.694966Z",
    ),
    ClubDto(
      id="9055ff8d-5053-4add-a0a9-3c1cd047fe6f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sundhöllin", address="Barónsstígur 45a, 101 Reykjavík",
      city="Reykjavik", country="IS",
      latitude=64.1418293, longitude=-21.9206518,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7940240a-b7af-4db9-b6db-80e606850faf_photo.jpg",
      averageRating=4.7, totalRatingsCount=1239,
      createdAt="2026-09-01T09:13:40.960753Z", updatedAt="2026-09-01T09:13:40.960753Z",
    ),
    ClubDto(
      id="d5ab92e1-f582-49c4-9b19-fabe1c4712f2", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Árbæjarlaug", address="Fylkisvegur 21, 110 Reykjavík",
      city="Reykjavik", country="IS",
      latitude=64.112203, longitude=-21.794827,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/abeca0be-3a11-436f-a522-c35bfb36bb4f_photo.jpg",
      averageRating=4.7, totalRatingsCount=585,
      createdAt="2026-09-01T09:13:45.402575Z", updatedAt="2026-09-01T09:13:45.402575Z",
    ),
    ClubDto(
      id="61bc17f0-6ec3-4f5f-954b-e2deffb7f059", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laugardalsholl Sport Centre", address="Engjavegur 8, 104 Reykjavík",
      city="Reykjavik", country="IS",
      latitude=64.1405021, longitude=-21.8766456,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/0f65c969-b997-4d91-8b9f-ebcb04ed1c05_photo.jpg",
      averageRating=4.6, totalRatingsCount=188,
      createdAt="2026-09-01T09:13:16.207584Z", updatedAt="2026-09-01T09:13:16.207584Z",
    ),
    ClubDto(
      id="db452b4b-ba53-43e3-9f87-8b8facbaa9f8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Laugardalslaug", address="Sundlaugavegur 105, 105 Reykjavík",
      city="Reykjavik", country="IS",
      latitude=64.1461121, longitude=-21.8800558,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4cf8fa2e-e6ae-422b-9d12-4558b1674933_photo.jpg",
      averageRating=4.6, totalRatingsCount=2232,
      createdAt="2026-09-01T09:13:05.635758Z", updatedAt="2026-09-01T09:13:05.635758Z",
    ),
    ClubDto(
      id="cc76f67d-d41c-444d-85f5-981959ed2c54", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="KR", address="Frostaskjól 2 107, 107 Reykjavík",
      city="Reykjavik", country="IS",
      latitude=64.1459969, longitude=-21.9681842,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/efd7c5dc-f31e-4ac0-b25a-2c66495aca7a_photo.jpg",
      averageRating=4.5, totalRatingsCount=75,
      createdAt="2026-09-01T09:13:21.705371Z", updatedAt="2026-09-01T09:13:21.705371Z",
    ),
    ClubDto(
      id="0b0a4fa9-9d54-463b-91af-3150d380434a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Keilir Golf Club", address="Steinholt 1, 220 Hafnarfjörður",
      city="Reykjavik", country="IS",
      latitude=64.058476, longitude=-21.991246,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3525d496-240a-43f2-b63c-607a1d6dfd9d_photo.jpg",
      averageRating=4.5, totalRatingsCount=87,
      createdAt="2026-09-01T09:13:58.102258Z", updatedAt="2026-09-01T09:13:58.102258Z",
    ),
    ClubDto(
      id="9579d892-bb9f-4a87-b9dd-deb62bf5ff17", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Keiluhöllin", address="Fossaleynir 1, 112 Reykjavík",
      city="Reykjavik", country="IS",
      latitude=64.1465301, longitude=-21.7716598,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/229f7834-59fe-44d8-959d-07d36b53fc09_photo.jpg",
      averageRating=4.4, totalRatingsCount=266,
      createdAt="2026-09-01T09:13:10.440642Z", updatedAt="2026-09-01T09:13:10.440642Z",
    ),
    ClubDto(
      id="563458b5-8101-4f34-9025-0a84bb170edf", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Valur", address="Hlíðarendi, Hlíðarendi 105, 102 Reykjavík",
      city="Reykjavik", country="IS",
      latitude=64.1333618, longitude=-21.9225635,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/faeebed4-e7c3-429e-bf36-8463b95d3fa9_photo.jpg",
      averageRating=4.4, totalRatingsCount=79,
      createdAt="2026-09-01T09:13:36.994978Z", updatedAt="2026-09-01T09:13:36.994978Z",
    ),
    ClubDto(
      id="e7096c1d-a303-45a3-a3b6-03dd8378c3dd", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Snooker & Pool", address="Lágmúli, 108 Reykjavík",
      city="Reykjavik", country="IS",
      latitude=64.138945, longitude=-21.8905405,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/672f7442-7297-4b8a-9f8b-cd16231019df_photo.jpg",
      averageRating=4.1, totalRatingsCount=68,
      createdAt="2026-09-01T09:14:13.259756Z", updatedAt="2026-09-01T09:14:13.259756Z",
    ),
    ClubDto(
      id="7b3f5cbe-801b-412b-88ef-bc1557376f28", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennishöllin", address="Dalsmári 13, 201 Kopavogur",
      city="Reykjavik", country="IS",
      latitude=64.1050297, longitude=-21.8916308,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8ca39c30-fae8-4dc5-bea3-792e8418c6fd_photo.jpg",
      averageRating=4.7, totalRatingsCount=41,
      createdAt="2026-09-01T09:13:29.144179Z", updatedAt="2026-09-01T09:13:29.144179Z",
    ),
    ClubDto(
      id="859a970c-46e4-460e-b4b1-33d3e848f6a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Gt Akademían", address="Faxafen 10 108, 108 Reykjavík",
      city="Reykjavik", country="IS",
      latitude=64.1292587, longitude=-21.8670168,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1adb3b73-63cc-4333-9677-2e7cd26ed384_photo.jpg",
      averageRating=4.8, totalRatingsCount=31,
      createdAt="2026-09-01T09:14:08.788628Z", updatedAt="2026-09-01T09:14:08.788628Z",
    ),
  )),
  CitySeo(slug="kropyvnytskyi", name="Kropyvnytskyi", country="UA", clubCount=12, sports=listOf(Pair("Football", 3), Pair("Billiards", 2), Pair("Padel", 1), Pair("Bowling", 1), Pair("Karting", 1), Pair("Climbing", 1), Pair("Laser Tag", 1), Pair("Paintball", 1), Pair("Tennis", 1)), clubs=listOf(
    ClubDto(
      id="ce74a2e8-18dc-4798-b007-c03b4d2b6c93", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Кіровоградський Обласний Центр Туризму І Краєзнавства Учнівської Молоді", address="Соколівська вулиця, 2, Кропивницький, 25000 Kropyvnytskyi, Ukraine",
      city="Kropyvnytskyi", country="UA",
      latitude=48.4895133, longitude=32.2558555,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/39dab6bc-a861-41bc-9208-7fef307cfd76_ChIJDVPQiCdo_0.jpg",
      averageRating=4.8, totalRatingsCount=140,
      createdAt="2026-08-30T17:34:53.698321Z", updatedAt="2026-08-30T20:52:36.135133Z",
    ),
    ClubDto(
      id="bb402f63-3eae-4d94-b888-79b810862de8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Power", address="провулок Віктора Домонтовича, 3, Кропивницький, 25000 Kropyvnytskyi, Ukraine",
      city="Kropyvnytskyi", country="UA",
      latitude=48.5136929, longitude=32.2800811,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/be1203da-0d3d-441c-9971-ac844d237d45_ChIJGbAqDzBD_0.jpg",
      averageRating=4.5, totalRatingsCount=64,
      createdAt="2026-08-30T17:35:19.171722Z", updatedAt="2026-08-30T20:52:20.550400Z",
    ),
    ClubDto(
      id="9b6b45ea-2ca0-4f40-b794-d179bbec6c95", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Більярдний клуб \"Свояк\"", address="вулиця Юрія Коваленка, 6, Кропивницький, 25031 Kropyvnytskyi, Ukraine",
      city="Kropyvnytskyi", country="UA",
      latitude=48.5012823, longitude=32.2094783,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/52f8fc70-fc37-4712-b8ef-99546bd1d0c1_ChIJ7bGtj6RC_0.jpg",
      averageRating=4.5, totalRatingsCount=137,
      createdAt="2026-08-30T17:34:37.809488Z", updatedAt="2026-08-30T20:52:28.619954Z",
    ),
    ClubDto(
      id="9567ccc0-0de0-4298-bc8d-8cf2cec8abc5", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг клуб ФОРТЕЦЯ", address="Н14, Велика Северинка, Кіровоградська область, 27613",
      city="Kropyvnytskyi", country="UA",
      latitude=48.6148247, longitude=32.2344241,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/559a18f1-0fd2-45cb-b202-552634ff29fb_photo.jpg",
      averageRating=4.5, totalRatingsCount=136,
      createdAt="2026-08-31T15:56:34.218989Z", updatedAt="2026-08-31T22:11:25.645210Z",
    ),
    ClubDto(
      id="7946e3c7-29e7-46fc-8976-123c2bb7fb50", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ДЮСШ №2, СТАДІОН 'Юність'", address="Курганна вулиця, 64, Кропивницький, Кіровоградська, 25000 Kropyvnytskyi, Ukraine",
      city="Kropyvnytskyi", country="UA",
      latitude=48.4888999, longitude=32.2530761,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/8ae85442-1c52-4a78-aea4-bdfb766e336d_ChIJA8GOs5xC_0.jpg",
      averageRating=4.4, totalRatingsCount=196,
      createdAt="2026-08-30T17:34:08.545827Z", updatedAt="2026-08-30T20:52:30.747619Z",
    ),
    ClubDto(
      id="f7583742-024c-4c31-b164-f2bbdc6771f0", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбольний клуб \"Барс\"", address="Кропивницький, 25000 Kropyvnytskyi, Ukraine",
      city="Kropyvnytskyi", country="UA",
      latitude=48.5624883, longitude=32.2560768,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/25e61a61-434d-408a-87b1-0fb0a4a4a2c3_ChIJi2oroPlc_0.jpg",
      averageRating=4.6, totalRatingsCount=47,
      createdAt="2026-08-30T17:35:10.286921Z", updatedAt="2026-08-30T20:52:43.135029Z",
    ),
    ClubDto(
      id="abd6370f-1816-42b2-b8a4-283deadca3f4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ТРК Портал", address="вулиця Соборна, 1а, Кропивницький, 25000 Kropyvnytskyi, Ukraine",
      city="Kropyvnytskyi", country="UA",
      latitude=48.50195, longitude=32.25552,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/d34bda5f-e875-4b26-b638-70744b9f8a95_ChIJJXZ55aJC_2.jpg",
      averageRating=4.3, totalRatingsCount=5215,
      createdAt="2026-08-30T17:34:29.920505Z", updatedAt="2026-08-31T22:11:27.376664Z",
    ),
    ClubDto(
      id="2d023c07-3fad-4092-b8b9-fc725a9c8db6", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тенісні корти АРЗ", address="вулиця Короленка, 80, Кропивницький, 25000 Kropyvnytskyi, Ukraine",
      city="Kropyvnytskyi", country="UA",
      latitude=48.5429848, longitude=32.2593282,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/4660e34f-c8e6-41ae-bf08-4dd40dc8a23f_ChIJZegvcSJd_0.jpg",
      averageRating=4.2, totalRatingsCount=50,
      createdAt="2026-08-30T17:35:27.012456Z", updatedAt="2026-08-30T20:52:52.407597Z",
    ),
    ClubDto(
      id="3f112306-e2b1-4f08-9189-ac64b4c80de1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг клуб \"КАСКАД\"", address="Кропивницький, 25000 Kropyvnytskyi, Ukraine",
      city="Kropyvnytskyi", country="UA",
      latitude=48.5030237, longitude=32.2065671,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1c5ee0fa-125b-4ad6-8665-4a465e414361_ChIJL44FQ_tC_0.jpg",
      averageRating=4.1, totalRatingsCount=107,
      createdAt="2026-08-30T17:35:01.697694Z", updatedAt="2026-08-30T20:52:33.081516Z",
    ),
    ClubDto(
      id="8a7d8b66-1553-44ec-9370-024dae8b5235", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Вельвет", address="вулиця Кавалерійська, 19, Кропивницький, Кіровоградська область, 25002",
      city="Kropyvnytskyi", country="UA",
      latitude=48.5131214, longitude=32.2569329,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/54473ac1-620f-414e-9e34-d4378d3ae3ef_photo.jpg",
      averageRating=3.8, totalRatingsCount=1410,
      createdAt="2026-08-31T15:56:26.336163Z", updatedAt="2026-08-31T15:56:26.336163Z",
    ),
    ClubDto(
      id="1d1c81b5-0d59-4065-a349-b0958a70045a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="ДЮСШ \"Зірочка\"", address="вулиця Кавалерійська, 7, Кропивницький, 25000 Kropyvnytskyi, Ukraine",
      city="Kropyvnytskyi", country="UA",
      latitude=48.5188046, longitude=32.2636954,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f151effc-f8d2-43e3-9834-642245b818ce_ChIJ0aoXp7RC_0.jpg",
      averageRating=4.6, totalRatingsCount=36,
      createdAt="2026-08-30T17:34:16.098859Z", updatedAt="2026-08-30T20:52:30.380622Z",
    ),
    ClubDto(
      id="7ff252fa-b812-4cf0-8ad3-a76d4459f2a7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Центр Традиційного Карате-До", address="вулиця Героїв-рятувальників, 28/5, Кропивницький, 25000 Kropyvnytskyi, Ukraine",
      city="Kropyvnytskyi", country="UA",
      latitude=48.4983206, longitude=32.2278923,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/75f63662-0bf1-493c-8610-d4744fbfd468_ChIJDyALTe1C_0.jpg",
      averageRating=4.6, totalRatingsCount=32,
      createdAt="2026-08-30T17:34:23.556881Z", updatedAt="2026-08-30T20:52:54.428155Z",
    ),
  )),
  CitySeo(slug="podgorica", name="Podgorica", country="ME", clubCount=11, sports=listOf(Pair("Basketball", 2), Pair("Tennis", 2), Pair("Volleyball", 2), Pair("Billiards", 1), Pair("Karting", 1), Pair("Golf", 1), Pair("Padel", 1), Pair("Football", 1)), clubs=listOf(
    ClubDto(
      id="633f2c29-4a83-4642-90b7-3bd2aff392ca", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Karting centar", address="M-2.3 Liješnje bb, 81000",
      city="Podgorica", country="ME",
      latitude=42.3932991, longitude=19.1352558,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99d6f5ce-4c9c-496f-9465-8013f8c550e9_photo.jpg",
      averageRating=4.7, totalRatingsCount=469,
      createdAt="2026-09-01T09:21:40.170658Z", updatedAt="2026-09-01T09:21:40.170658Z",
    ),
    ClubDto(
      id="0f3c9195-1199-4d34-b581-ac1904d6f33a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Eminent Tennis Club", address="F6QJ+3XX, Velje Brdo",
      city="Podgorica", country="ME",
      latitude=42.4877281, longitude=19.232481,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/48384d2d-c80d-489d-ab32-48c4668fd429_photo.jpg",
      averageRating=4.6, totalRatingsCount=73,
      createdAt="2026-09-01T09:21:02.886614Z", updatedAt="2026-09-01T09:21:02.886614Z",
    ),
    ClubDto(
      id="c0e9ec7f-9dab-46ff-9b0b-a114ddc4ff43", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Luštica Bay Golf Course", address="9MV6+2P, Gošići",
      city="Podgorica", country="ME",
      latitude=42.3925949, longitude=18.6617787,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Golf", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/1bf6b564-881c-4a1a-84ec-b3db7f1b6527_photo.jpg",
      averageRating=4.1, totalRatingsCount=47,
      createdAt="2026-09-01T09:21:36.200251Z", updatedAt="2026-09-01T09:21:36.200251Z",
    ),
    ClubDto(
      id="aa7b6a1e-2ce8-489c-9838-1521f87b084a", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Tennis Club As", address="Donji Kokoti, 4, teniski klub as, Kritskog odreda, Podgorica 81000",
      city="Podgorica", country="ME",
      latitude=42.410437, longitude=19.198726,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/934e108f-9ece-4505-9c32-36ffbe194a23_photo.jpg",
      averageRating=4.7, totalRatingsCount=40,
      createdAt="2026-09-01T09:21:07.145276Z", updatedAt="2026-09-01T09:21:07.145276Z",
    ),
    ClubDto(
      id="d7aa1351-cba6-4a94-9229-4e628756b7e8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Sportski Centar Dadex", address="C7VJ+7FX, Crnojevića, Podgorica",
      city="Podgorica", country="ME",
      latitude=42.443241, longitude=19.2812312,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f85ab85e-f1f8-446c-93f7-fe0d4f17fee3_photo.jpg",
      averageRating=4.6, totalRatingsCount=36,
      createdAt="2026-09-01T09:21:16.224889Z", updatedAt="2026-09-01T09:21:16.224889Z",
    ),
    ClubDto(
      id="bc732ccb-40c1-48d7-bf48-005e4c2c7ae7", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Odbojkaški kamp Volleyball Montenegro", address="Hotel Montenegro, Obala bb, Čanj 85357",
      city="Podgorica", country="ME",
      latitude=42.1628923, longitude=18.9986862,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/99653b65-ac62-4339-9f72-f80bed0dc666_photo.jpg",
      averageRating=5.0, totalRatingsCount=30,
      createdAt="2026-09-01T09:21:26.494208Z", updatedAt="2026-09-01T09:21:26.494208Z",
    ),
    ClubDto(
      id="fd338f94-476f-407e-bc8e-060e278c2203", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="All Star-Podgorica", address="Vaka Đurovića, Podgorica 81000",
      city="Podgorica", country="ME",
      latitude=42.4473599, longitude=19.2637003,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a36f9215-d32c-43d5-a046-99d62b16ef45_photo.jpg",
      averageRating=4.9, totalRatingsCount=30,
      createdAt="2026-09-01T09:21:21.501887Z", updatedAt="2026-09-01T09:21:21.501887Z",
    ),
    ClubDto(
      id="55295dcb-0b20-406e-8d83-7089f0565430", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Padel Podgorica", address="C656+VRW, Podgorica",
      city="Podgorica", country="ME",
      latitude=42.409733, longitude=19.2120852,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f148727e-fe95-4d9a-a87c-f1610c9cff3a_photo.jpg",
      averageRating=3.8, totalRatingsCount=36,
      createdAt="2026-09-01T09:21:11.927684Z", updatedAt="2026-09-01T09:21:11.927684Z",
    ),
    ClubDto(
      id="1f131d04-0874-4914-a6e4-adb37ed19453", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Plesni Klub Sonrisa", address="78 Dalmatinska, Podgorica",
      city="Podgorica", country="ME",
      latitude=42.4494408, longitude=19.2433173,
      type="VOLLEYBALL",
      types=listOf("VOLLEYBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/dbce1fff-0604-4a65-8310-7adad88f301d_photo.jpg",
      averageRating=4.3, totalRatingsCount=14,
      createdAt="2026-09-01T09:21:31.492074Z", updatedAt="2026-09-01T09:21:31.492074Z",
    ),
    ClubDto(
      id="dcf5f5d4-00f2-41c4-b06f-99449ab8c986", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Billiard Club Eight", address="br. 15 19. Decembar, Podgorica 81000",
      city="Podgorica", country="ME",
      latitude=42.4439444, longitude=19.2645803,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/941af2b1-7b80-4b0d-802c-d9fb443783a5_photo.jpg",
      averageRating=5.0, totalRatingsCount=12,
      createdAt="2026-09-01T09:21:45.202166Z", updatedAt="2026-09-01T09:21:45.202166Z",
    ),
    ClubDto(
      id="83b74972-9c73-4121-9488-23635f70c0a4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Štampar Sports Centre", address="C6WV+C2M, bb Vijenac Kosovskih Junaka, Podgorica 81000",
      city="Podgorica", country="ME",
      latitude=42.4462427, longitude=19.2424525,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c4ede9d4-1e3a-416e-9d7c-115c6de673ca_photo.jpg",
      averageRating=4.3, totalRatingsCount=10,
      createdAt="2026-09-01T09:20:58.528832Z", updatedAt="2026-09-01T09:20:58.528832Z",
    ),
  )),
  CitySeo(slug="uzhhorod", name="Uzhhorod", country="UA", clubCount=11, sports=listOf(Pair("Football", 3), Pair("Climbing", 2), Pair("Billiards", 2), Pair("Bowling", 1), Pair("Laser Tag", 1), Pair("Tennis", 1), Pair("Basketball", 1)), clubs=listOf(
    ClubDto(
      id="56251c11-3716-4822-aa26-f3acb591c360", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбол Ужгород", address="Unnamed Road, Розівка, Закарпатська область, 89424",
      city="Uzhhorod", country="UA",
      latitude=48.5824754, longitude=22.2598262,
      type="BASKETBALL",
      types=listOf("BASKETBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/defc4054-d05c-414b-983c-b47ed7495927_photo.jpg",
      averageRating=4.9, totalRatingsCount=63,
      createdAt="2026-08-31T16:01:54.639875Z", updatedAt="2026-08-31T22:11:26.290322Z",
    ),
    ClubDto(
      id="a5991c0b-4db9-4d69-8be3-43d25b76cd9f", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Viper Gym", address="вулиця Капушанська, 175а, Ужгород, Закарпатська область, 88000",
      city="Uzhhorod", country="UA",
      latitude=48.610292, longitude=22.2619674,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6bc205da-ff75-4f99-80f6-729cac5318a0_photo.jpg",
      averageRating=4.6, totalRatingsCount=244,
      createdAt="2026-08-31T16:02:08.580960Z", updatedAt="2026-08-31T16:02:08.580960Z",
    ),
    ClubDto(
      id="d85cf58b-3710-498a-bc3b-9dfec42abf17", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="БК Buffalo Ungvár", address="вулиця Заньковецької, 89, Ужгород, 88000 Uzhhorod, Ukraine",
      city="Uzhhorod", country="UA",
      latitude=48.6061451, longitude=22.2639717,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/6067a9b4-969d-41a6-b41b-fcf6a221613a_ChIJEQxX5KIZ_0.jpg",
      averageRating=4.6, totalRatingsCount=115,
      createdAt="2026-08-30T17:30:13.619553Z", updatedAt="2026-08-30T20:52:27.562225Z",
    ),
    ClubDto(
      id="0a9be4ab-96da-4ce5-90e0-2f40cc13af18", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лабда", address="Ужгород, 88000 Uzhhorod, Ukraine",
      city="Uzhhorod", country="UA",
      latitude=48.6225494, longitude=22.2973324,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/2ddd0b3c-6dad-4aa4-afd4-5a1cf3db5f99_ChIJj6ftYLEZ_0.jpg",
      averageRating=4.5, totalRatingsCount=258,
      createdAt="2026-08-30T17:30:06.332148Z", updatedAt="2026-08-30T20:52:36.497453Z",
    ),
    ClubDto(
      id="f6e1dc66-b15d-465f-ade9-fb8422b0ff83", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="MEGASPORT", address="провулок Пасаж, 7, Ужгород, 88000 Uzhhorod, Ukraine",
      city="Uzhhorod", country="UA",
      latitude=48.6223886, longitude=22.2986896,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/f24d3198-4ac1-4e2c-bf8f-9bc5ee0ac4cb_ChIJvbKvarEZ_0.jpg",
      averageRating=4.3, totalRatingsCount=379,
      createdAt="2026-08-30T17:29:51.700249Z", updatedAt="2026-08-30T20:52:17.818149Z",
    ),
    ClubDto(
      id="317adc8f-6935-43b0-a49f-e5bacc77b01e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Лазертаг Арена Ужгород", address="вул. Героїв 128-ї бригади, 43, Ужгород, 88000 Uzhhorod, Ukraine",
      city="Uzhhorod", country="UA",
      latitude=48.6032722, longitude=22.2731845,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7d85bbb3-5059-488a-921f-7d9659209c74_ChIJBcpDCZwZ_0.jpg",
      averageRating=4.4, totalRatingsCount=48,
      createdAt="2026-08-30T17:30:28.868215Z", updatedAt="2026-08-30T20:52:37.401274Z",
    ),
    ClubDto(
      id="6bf42607-d436-4c49-a4ab-5984b7480b61", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Боулінг клуб Прага", address="вулиця Верховинська, 38, Ужгород, 88000 Uzhhorod, Ukraine",
      city="Uzhhorod", country="UA",
      latitude=48.6454429, longitude=22.2747516,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/49c065c0-d84e-4d19-a881-af21246345f0_ChIJeUPJTb8Z_0.jpg",
      averageRating=4.2, totalRatingsCount=73,
      createdAt="2026-08-30T17:30:20.810031Z", updatedAt="2026-08-30T20:52:28.092838Z",
    ),
    ClubDto(
      id="5990792e-ba07-40ab-8f86-db2f923b2a70", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Юність", address="вулиця Заньковецької, 5, Ужгород, 88000 Uzhhorod, Ukraine",
      city="Uzhhorod", country="UA",
      latitude=48.6123701, longitude=22.2900538,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/67eb594f-9bae-4666-87de-0347aba23519_ChIJ0Q6J2KsZ_0.jpg",
      averageRating=4.2, totalRatingsCount=744,
      createdAt="2026-08-30T17:29:38.262545Z", updatedAt="2026-08-30T20:52:55.184251Z",
    ),
    ClubDto(
      id="5f51059b-88a4-4764-a684-f215c13058e9", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Комунальна установа \"Стадіон \"Авангард\" Ужгородської міської ради\"", address="вулиця Івана Франка, 1, Ужгород, 88000 Uzhhorod, Ukraine",
      city="Uzhhorod", country="UA",
      latitude=48.6234901, longitude=22.2762344,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/7e48671b-8c7d-4dd0-b4d5-08722503cc9e_ChIJdc_4DU4Y_0.jpg",
      averageRating=4.0, totalRatingsCount=664,
      createdAt="2026-08-30T17:29:45.457112Z", updatedAt="2026-08-30T20:52:35.131749Z",
    ),
    ClubDto(
      id="293a98bf-018d-4fc2-8c47-ae87a911e461", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="CleverGym", address="вулиця Другетів, 73, Ужгород, Закарпатська область, 88000",
      city="Uzhhorod", country="UA",
      latitude=48.626675, longitude=22.305925,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/eaff5505-5368-46d7-aa2f-0e211b4cab41_photo.jpg",
      averageRating=4.7, totalRatingsCount=40,
      createdAt="2026-08-31T16:02:00.692369Z", updatedAt="2026-08-31T16:02:00.692369Z",
    ),
    ClubDto(
      id="b686b1f8-05c3-4943-8366-ef8adc265fee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Минай", address="вулиця Заньковецької, 58, Ужгород, 88000 Uzhhorod, Ukraine",
      city="Uzhhorod", country="UA",
      latitude=48.609532, longitude=22.2719427,
      type="TENNIS",
      types=listOf("TENNIS"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/661af983-ab57-4245-9c01-9ce65e66e410_ChIJXWm4K6kZ_0.jpg",
      averageRating=4.6, totalRatingsCount=35,
      createdAt="2026-08-30T17:30:37.055537Z", updatedAt="2026-08-30T20:52:39.710735Z",
    ),
  )),
  CitySeo(slug="khmelnytskyi", name="Khmelnytskyi", country="UA", clubCount=9, sports=listOf(Pair("Football", 3), Pair("Paintball", 2), Pair("Billiards", 1), Pair("Laser Tag", 1), Pair("Tennis", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="503b3277-0242-4a7c-8bda-2b609f99a8e4", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбольний Клуб Снайпер", address="Unnamed Road, Хмельницький, 29000 Khmelnytskyi, Ukraine",
      city="Khmelnytskyi", country="UA",
      latitude=49.4041534, longitude=27.0532429,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/9af5c078-ad91-4c30-97d8-196f857adf50_ChIJBaU7lygJ_0.jpg",
      averageRating=4.8, totalRatingsCount=191,
      createdAt="2026-08-30T17:29:14.017452Z", updatedAt="2026-08-30T20:52:42.870401Z",
    ),
    ClubDto(
      id="4ad13e0f-bef3-4d85-9aeb-6638d542560b", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PARUS Business Center", address="провулок Степана Бандери, 1/1, Хмельницький, 29000 Khmelnytskyi, Ukraine",
      city="Khmelnytskyi", country="UA",
      latitude=49.4358121, longitude=26.981876,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/06965ae9-0ffe-437c-b867-7cbab083be17_ChIJl6HH0QIH_3.jpg",
      averageRating=4.7, totalRatingsCount=238,
      createdAt="2026-08-30T17:28:36.504860Z", updatedAt="2026-08-31T22:11:19.274382Z",
    ),
    ClubDto(
      id="32cac790-256f-482a-bb0f-baf3d979c413", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Shooters Club", address="вулиця Проскурівська, 83/1, Хмельницький, 29000 Khmelnytskyi, Ukraine",
      city="Khmelnytskyi", country="UA",
      latitude=49.4203247, longitude=26.9950671,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Laser Tag", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/a3c0fe2d-1979-4b4d-83a0-ba8596c6fd01_ChIJhwSROvIH_0.jpg",
      averageRating=4.7, totalRatingsCount=151,
      createdAt="2026-08-30T17:29:06.540819Z", updatedAt="2026-08-30T20:52:23.327372Z",
    ),
    ClubDto(
      id="8757a22e-079c-4c37-b34f-a2990959e846", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Тамерлан", address="вул. Нижня Берегова, 2/4, Хмельницький, 29000 Khmelnytskyi, Ukraine",
      city="Khmelnytskyi", country="UA",
      latitude=49.4396459, longitude=26.9702326,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b16ded17-8a6e-4bfe-8aaf-975aa8bc2715_ChIJN67WdaYH_0.jpg",
      averageRating=4.6, totalRatingsCount=1313,
      createdAt="2026-08-30T17:28:28.132822Z", updatedAt="2026-08-30T20:52:50.572632Z",
    ),
    ClubDto(
      id="616f0a6a-cb0a-4428-a4c5-703e3d369386", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="X Padel Club", address="Старокостянтинівське шосе, 9, Хмельницький, 29015 Khmelnytskyi, Ukraine",
      city="Khmelnytskyi", country="UA",
      latitude=49.429225, longitude=27.0123092,
      type="TENNIS",
      types=listOf("TENNIS", "PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3c390aa8-4d73-4cbb-b5d2-4f2a46c5df78_ChIJH-fU7nQH_0.jpg",
      averageRating=4.9, totalRatingsCount=46,
      createdAt="2026-08-30T17:29:30.297338Z", updatedAt="2026-09-01T14:31:55.955914Z",
    ),
    ClubDto(
      id="eb9c7aa6-59c1-4b3f-bb97-0dcab018356e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Lybid Plaza", address="вул. Кам'янецька, 21, Хмельницький, 29000 Khmelnytskyi, Ukraine",
      city="Khmelnytskyi", country="UA",
      latitude=49.4262571, longitude=26.9797234,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Billiards", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/b9711377-f191-4e51-9738-1695617d11c1_ChIJhaVF0fsG_0.jpg",
      averageRating=4.2, totalRatingsCount=11592,
      createdAt="2026-08-30T17:28:43.680302Z", updatedAt="2026-08-30T20:52:17.434097Z",
    ),
    ClubDto(
      id="4239f84d-c018-46a3-ad8f-bb99d5dd5bce", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Оздоровчо-розважальний комплекс «СВ-КЛУБ»", address="вулиця Свободи, 1A, Хмельницький, 29017 Khmelnytskyi, Ukraine",
      city="Khmelnytskyi", country="UA",
      latitude=49.4382102, longitude=27.002866,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/05eec4a3-ac22-42dc-8362-f06ff7169e29_ChIJrWLHEKgH_0.jpg",
      averageRating=4.2, totalRatingsCount=1864,
      createdAt="2026-08-30T17:28:22.127900Z", updatedAt="2026-08-30T20:52:40.721714Z",
    ),
    ClubDto(
      id="d3c254ad-c3a6-48a5-8a73-53c6beb4e0dc", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Пейнтбол Хмельницкий (пк \"ПРАЙД\") Лазертаг Хмельницький", address="вулиця Романа Шухевича, 6, Хмельницький, 29000 Khmelnytskyi, Ukraine",
      city="Khmelnytskyi", country="UA",
      latitude=49.4393963, longitude=26.950839,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Paintball", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/fd86916f-ab81-40e4-9331-69fe91ae5e32_ChIJgVSxbSkH_0.jpg",
      averageRating=4.3, totalRatingsCount=42,
      createdAt="2026-08-30T17:29:22.341609Z", updatedAt="2026-08-30T20:52:42.258770Z",
    ),
    ClubDto(
      id="912929a0-6114-494e-85bd-5cb77dd727d1", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Картинг", address="вулиця Паркова, 1, Хмельницький, 29000 Khmelnytskyi, Ukraine",
      city="Khmelnytskyi", country="UA",
      latitude=49.4301929, longitude=26.9686301,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/c3477d9e-3b4e-4410-930e-77db92c2d6ce_ChIJaYLHo-UG_0.jpg",
      averageRating=4.1, totalRatingsCount=32,
      createdAt="2026-08-30T17:28:58.910923Z", updatedAt="2026-08-30T20:52:32.702969Z",
    ),
  )),
  CitySeo(slug="pristina", name="Pristina", country="XK", clubCount=8, sports=listOf(Pair("Football", 3), Pair("Padel", 2), Pair("Bowling", 1), Pair("Climbing", 1), Pair("Karting", 1)), clubs=listOf(
    ClubDto(
      id="b173fd5b-9919-4234-9da7-cf344d2eec85", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Bo Bowling Fushe Kosove", address="Elez Berisha, Prishtina 10000, Fushë-Kosovë 12000",
      city="Pristina", country="XK",
      latitude=42.6407578, longitude=21.112402,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Bowling", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/44fc3c12-5a9a-49c8-a29b-de4847270e72_photo.jpg",
      averageRating=5.0, totalRatingsCount=1469,
      createdAt="2026-09-01T09:22:16.641108Z", updatedAt="2026-09-01T09:22:16.641108Z",
    ),
    ClubDto(
      id="d36f040c-0cd6-4ed2-b5ad-7ba91e1b342d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="PADEL ZONE", address="Lagja Marigona, Prishtina 10000",
      city="Pristina", country="XK",
      latitude=42.5780876, longitude=21.103927,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/ccb507ee-933e-404f-bed3-2826de6aa814_photo.jpg",
      averageRating=4.9, totalRatingsCount=79,
      createdAt="2026-09-01T09:22:01.485974Z", updatedAt="2026-09-01T09:22:01.485974Z",
    ),
    ClubDto(
      id="5d059e5b-d9d7-4572-96c7-d6491d94869d", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="STEP Sport Center", address="J597+XWM, Hajvali, Pristina 10000",
      city="Pristina", country="XK",
      latitude=42.619874, longitude=21.1649826,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/60e08f91-6835-45fe-8c2f-880f1d89b6de_photo.jpg",
      averageRating=4.5, totalRatingsCount=129,
      createdAt="2026-09-01T09:21:48.989382Z", updatedAt="2026-09-01T09:21:48.989382Z",
    ),
    ClubDto(
      id="9ea899dd-e77e-4055-883f-227914207c75", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fitness Gym Prishtina", address="Luan Haradinaj, Prishtinë 10000",
      city="Pristina", country="XK",
      latitude=42.6611084, longitude=21.1566708,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Climbing", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/e524b2fe-e535-4aa6-b2c1-7ff61fd3e58d_photo.jpg",
      averageRating=4.5, totalRatingsCount=48,
      createdAt="2026-09-01T09:22:20.811297Z", updatedAt="2026-09-01T09:22:20.811297Z",
    ),
    ClubDto(
      id="b8172dfb-69a1-4c08-b795-c6a8723e71ee", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Go Kart Prishtina", address="Hajvalia 10510",
      city="Pristina", country="XK",
      latitude=42.6176478, longitude=21.1682007,
      type="OTHER",
      types=listOf("OTHER"),
      customSportName="Karting", mainPhotoUrl="https://images.arenaproplay.com/clubs/images/60491aae-19c4-4106-ac0e-7f3083fade13_photo.jpg",
      averageRating=4.8, totalRatingsCount=43,
      createdAt="2026-09-01T09:22:11.423433Z", updatedAt="2026-09-01T09:22:11.423433Z",
    ),
    ClubDto(
      id="c8059856-9477-4ca3-96db-99afbd2694e8", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="QS. Prishtina", address="Dr.Lec Gradica, Prishtinë 10000",
      city="Pristina", country="XK",
      latitude=42.6615707, longitude=21.1875152,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/727009e2-6fda-4163-b2c6-3671277504d8_photo.jpg",
      averageRating=4.5, totalRatingsCount=37,
      createdAt="2026-09-01T09:21:53.089994Z", updatedAt="2026-09-01T09:21:53.089994Z",
    ),
    ClubDto(
      id="5a70e906-aa66-4204-b6c5-181a4091b20e", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="Fusha Sportive Ylli", address="M4FM+HGQ, Rrugë Qemajl Stafa, Prishtinë 10000",
      city="Pristina", country="XK",
      latitude=42.67397, longitude=21.133864,
      type="FOOTBALL",
      types=listOf("FOOTBALL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/640d4ab1-a16e-4e7c-8866-2619127b8c54_photo.jpg",
      averageRating=3.5, totalRatingsCount=33,
      createdAt="2026-09-01T09:21:57.195034Z", updatedAt="2026-09-01T09:21:57.195034Z",
    ),
    ClubDto(
      id="994e9f3d-ae5c-40f9-964d-d2cbc006a383", ownerId="b3751428-15c1-4f25-b529-8b9caf894d47", name="BE ALL PADEL", address="Magjistralja Prishtine-Ferizaj, Rrethi i Marigones, Prishtinë 10000",
      city="Pristina", country="XK",
      latitude=42.5819457, longitude=21.1286824,
      type="PADEL",
      types=listOf("PADEL"),
      customSportName=null, mainPhotoUrl="https://images.arenaproplay.com/clubs/images/3a9af563-94f0-4db6-a560-bbea66a6888e_photo.jpg",
      averageRating=4.1, totalRatingsCount=11,
      createdAt="2026-09-01T09:22:06.913898Z", updatedAt="2026-09-01T09:22:06.913898Z",
    ),
  )),
)
